/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/kiosk/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 915);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(40)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = lodash;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EC_LOGIN_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APIGEE_API_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OMS_API_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEBUG_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return USE_LOCAL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_MAP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGIN_LINK; });
/* unused harmony export LOGIN_ECLINK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ENTERTAIN_LINK; });
var API_HOST=function(){if(['localhost','127.0.0.1','[::1]'].includes(window.location.hostname)){return'/console';}if(false){// 165
//return 'http://172.104.117.165:8888/console'
// UAT
// return 'https://testwww.uni-prosperity.com.tw/console';
// 正式
return'https://www.uni-prosperity.com.tw/console';//0602測試站
// return 'https://cec.syscom.tw/console'
}else{// OCA
if(window.location.host==='www.uni-prosperity.com.tw:4466')return'https://www.uni-prosperity.com.tw:4466/console';if(window.location.host==='cec.syscom.tw')return'https://cec.syscom.tw/console';if(window.location.host==='www.uni-prosperity.com.tw')return'https://www.uni-prosperity.com.tw/console';if(window.location.host==='testweb.uni-prosperity.com.tw')return'https://testweb.uni-prosperity.com.tw/console';if(window.location.host==='testwww.uni-prosperity.com.tw')return'https://testwww.uni-prosperity.com.tw/console';}}();// 第三方平台代登入
var EC_LOGIN_ENDPOINT=function(){if(false){return'https://ppr-online.uni-prosperity.com.tw:22443/account/eclogin';}else{if(window.location.host==='testwww.uni-prosperity.com.tw'){return'https://qa-online.uni-prosperity.com.tw/zh/account/login/';}else{return'http://online.uni-prosperity.com.tw/zh/account/login/';}}}();// OMS API＿Host
var APIGEE_API_HOST=function(){if(false){return'https://34.117.240.106.nip.io';}else{if(window.location.host==='testwww.uni-prosperity.com.tw'){return'https://34.117.240.106.nip.io';}else{return'https://34.36.14.78.nip.io';}}}();// OMS token
//測試站token
//Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B
//正式站token
//Bearer C0BC18B4-69A6-40D4-9175-EFDC0FFD9249
var OMS_API_TOKEN=function(){if(false){return'Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B';}else{if(window.location.host==='testwww.uni-prosperity.com.tw'){return'Bearer DEF6082C-03A0-4D01-813B-D3170C63FB5B';}else{return'Bearer C0BC18B4-69A6-40D4-9175-EFDC0FFD9249';}}}();var DEBUG_MODE=false;var USE_LOCAL_CONFIG=false;var GOOGLE_MAP_KEY='AIzaSyAGJXA9bPDoLXoidGF0Uq_h3cvIlYc1gXw';var LINK='';if(window.location.host=='cec.syscom.tw'){LINK='https://toaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=b8f848827a0667870c436cca772b66a6&redirect_uri=https://cec.syscom.tw/service/sso/&state=C4&scope=read&device=1';}else LINK='https://oca.uni-prosperity.com.tw/signin';var LOGIN_LINK=LINK;var ECLINK='';if(window.location.host=='cec.syscom.tw'){ECLINK='https://ppr-online.uni-prosperity.com.tw:22443/account/eclogin';}else ECLINK='http://online.uni-prosperity.com.tw/account/eclogin';var LOGIN_ECLINK=ECLINK;var ENTERTAIN_LINK='https://www.uni-prosperity.com.tw/公平待客/';

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_NotificationCenter__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_env__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var whttp=function(){function whttp(){_classCallCheck(this,whttp);this.requestInfos=[];this._handle_auth_denied=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_3__libs_NotificationCenter__["b" /* default */].default.post(__WEBPACK_IMPORTED_MODULE_3__libs_NotificationCenter__["a" /* NotificationName */].AuthDenied);},100);var _store$getState=__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* store */].getState(),_store$getState$auth=_store$getState.auth;_store$getState$auth=_store$getState$auth===undefined?{}:_store$getState$auth;var authorization=_store$getState$auth.authorization;this.authorization=authorization;this.storeStateDidUpdate=this.storeStateDidUpdate.bind(this);// 註冊store update的通知
__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* store */].subscribe(this.storeStateDidUpdate);}_createClass(whttp,[{key:'storeStateDidUpdate',value:function storeStateDidUpdate(){var _store$getState2=__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* store */].getState(),_store$getState2$auth=_store$getState2.auth;_store$getState2$auth=_store$getState2$auth===undefined?{}:_store$getState2$auth;var app_id=_store$getState2$auth.app_id,authorization=_store$getState2$auth.authorization,user_id=_store$getState2$auth.user_id;this.app_id=app_id;this.authorization=authorization;this.user_id=user_id;}},{key:'setCookie',value:function setCookie(key,val,exp){if(exp){document.cookie=key+'='+val+';expires='+exp+';path=/';}else{document.cookie=key+'='+val+';path=/';}}},{key:'getCookie',value:function getCookie(key){var name=key+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i].trim();if(c.indexOf(name)===0)return c.substring(name.length,c.length);}return null;}},{key:'getToken',value:function getToken(){return this.authorization;}},{key:'getHeaders',value:function getHeaders(){var headers={};if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(this.getToken())){headers.Authorization=this.getToken();}return headers;}// send 'get|post|delete' http request
// return cancelToken
},{key:'send',value:function send(method,url,params,data,callback,isOms){var _this=this;// 封裝callback，排除外部發生error造成axios的catch
var cb=function cb(state,res){if(!callback)return;try{callback(state,res);}catch(err){console.error('whttp callback error',err);}};var cancelToken=void 0;__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:method,timeout:600000,headers:isOms?{Authorization:__WEBPACK_IMPORTED_MODULE_4__configs_env__["h" /* OMS_API_TOKEN */]}:this.getHeaders(),withCredentials:false,url:url,params:params,data:data,cancelToken:new __WEBPACK_IMPORTED_MODULE_1_axios__["CancelToken"](function(token){cancelToken=token;})}).then(function(response){var state=true;if(response.status!==200){state=false;}var _response$data=response.data,_response$data$code=_response$data.code,code=_response$data$code===undefined?200:_response$data$code,_response$data$reason=_response$data.reason,reason=_response$data$reason===undefined?'未知錯誤':_response$data$reason,_response$data$data=_response$data.data,data=_response$data$data===undefined?{}:_response$data$data;var res={code:code,reason:reason,data:data};_this._handle_error_code(code);cb(state,res);}).catch(function(error){_this._handle_error_code(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status'));var res={code:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status',400),reason:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.statusText','發生錯誤'),error:error,data:{}};var data=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data');if(data){res.code=data.code;res.reason=data.reason;}cb(false,res);});return cancelToken;}},{key:'get',value:function get(url,query,callback){return this.send('get',url,query,null,callback,false);}},{key:'post',value:function post(url,data,callback){return this.send('post',url,null,data,callback,false);}},{key:'delete',value:function _delete(url,query,callback){return this.send('delete',url,query,null,callback,false);}//呼叫apigeeApi
},{key:'getApigeeApi',value:function getApigeeApi(url,query,callback){return this.send('get',url,query,null,callback,true);}},{key:'postApigeeApi',value:function postApigeeApi(url,data,callback){return this.send('post',url,null,data,callback,true);}// 共用Request，只執行最後一道，但是callback都會被call到
// 減少消耗
},{key:'sharedGet',value:function sharedGet(url,query,callback){var _this2=this;var requestName=url.replace(/(\.)/g,'__');//console.log('sharedGet url:', url)
var requestInfo=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.requestInfos,requestName);var cancelToken=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(requestInfo,'cancelToken');if(cancelToken){cancelToken('sharedGet '+requestName+' By Last Query');}if(!requestInfo){requestInfo={name:requestName,cancelToken:null,callbacks:[]};this.requestInfos[requestName]=requestInfo;}requestInfo.callbacks.push(callback);var callbackWapper=function callbackWapper(state,res){if(res.error instanceof __WEBPACK_IMPORTED_MODULE_1_axios__["Cancel"])return;var callbacks=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(_this2.requestInfos,requestName+'.callbacks',[]);__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(callbacks,function(callback){return callback(state,res);});delete _this2.requestInfos[requestName];};requestInfo.cancelToken=this.send('get',url,query,null,callbackWapper);}},{key:'_handle_error_code',value:function _handle_error_code(code){code=parseInt(code,10);if(code===401){this._handle_auth_denied();}}// 未登入
// access token 過期
}]);return whttp;}();/* harmony default export */ __webpack_exports__["a"] = (new whttp());

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfigConsumer", {
  enumerable: true,
  get: function get() {
    return _context.ConfigConsumer;
  }
});
Object.defineProperty(exports, "ConfigContext", {
  enumerable: true,
  get: function get() {
    return _context.ConfigContext;
  }
});
exports["default"] = exports.configConsumerProps = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcFieldForm = __webpack_require__(157);

var _localeProvider = _interopRequireWildcard(__webpack_require__(952));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _context = __webpack_require__(334);

var _SizeContext = __webpack_require__(72);

var _message = _interopRequireDefault(__webpack_require__(15));

var _notification = _interopRequireDefault(__webpack_require__(33));

// TODO: remove this lint
// SFC has specified a displayName, but not worked.

/* eslint-disable react/display-name */
var configConsumerProps = ['getTargetContainer', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
exports.configConsumerProps = configConsumerProps;

var ConfigProvider = function ConfigProvider(props) {
  React.useEffect(function () {
    if (props.direction) {
      _message["default"].config({
        rtl: props.direction === 'rtl'
      });

      _notification["default"].config({
        rtl: props.direction === 'rtl'
      });
    }
  }, [props.direction]);

  var getPrefixClsWrapper = function getPrefixClsWrapper(context) {
    return function (suffixCls, customizePrefixCls) {
      var prefixCls = props.prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      var mergedPrefixCls = prefixCls || context.getPrefixCls('');
      return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    };
  };

  var renderProvider = function renderProvider(context, legacyLocale) {
    var children = props.children,
        getTargetContainer = props.getTargetContainer,
        getPopupContainer = props.getPopupContainer,
        renderEmpty = props.renderEmpty,
        csp = props.csp,
        autoInsertSpaceInButton = props.autoInsertSpaceInButton,
        form = props.form,
        input = props.input,
        locale = props.locale,
        pageHeader = props.pageHeader,
        componentSize = props.componentSize,
        direction = props.direction,
        space = props.space,
        virtual = props.virtual,
        dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
    var config = (0, _extends2["default"])((0, _extends2["default"])({}, context), {
      getPrefixCls: getPrefixClsWrapper(context),
      csp: csp,
      autoInsertSpaceInButton: autoInsertSpaceInButton,
      locale: locale || legacyLocale,
      direction: direction,
      space: space,
      virtual: virtual,
      dropdownMatchSelectWidth: dropdownMatchSelectWidth
    });

    if (getTargetContainer) {
      config.getTargetContainer = getTargetContainer;
    }

    if (getPopupContainer) {
      config.getPopupContainer = getPopupContainer;
    }

    if (renderEmpty) {
      config.renderEmpty = renderEmpty;
    }

    if (pageHeader) {
      config.pageHeader = pageHeader;
    }

    if (input) {
      config.input = input;
    }

    if (form) {
      config.form = form;
    }

    var childNode = children; // Additional Form provider

    var validateMessages = {};

    if (locale && locale.Form && locale.Form.defaultValidateMessages) {
      validateMessages = locale.Form.defaultValidateMessages;
    }

    if (form && form.validateMessages) {
      validateMessages = (0, _extends2["default"])((0, _extends2["default"])({}, validateMessages), form.validateMessages);
    }

    if (Object.keys(validateMessages).length > 0) {
      childNode = /*#__PURE__*/React.createElement(_rcFieldForm.FormProvider, {
        validateMessages: validateMessages
      }, children);
    }

    var childrenWithLocale = locale === undefined ? childNode : /*#__PURE__*/React.createElement(_localeProvider["default"], {
      locale: locale || legacyLocale,
      _ANT_MARK__: _localeProvider.ANT_MARK
    }, childNode);
    return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
      size: componentSize
    }, /*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
      value: config
    }, childrenWithLocale));
  };

  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
    return /*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
      return renderProvider(context, legacyLocale);
    });
  });
};
/** @private internal usage. do not use in your production */


ConfigProvider.ConfigContext = _context.ConfigContext;
var _default = ConfigProvider;
exports["default"] = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(502);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_badge__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_app__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_stores__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers_user__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfigData__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StoresData__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_NotificationCenter__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libs_wjson__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AppHelper=(_temp=_class=function(){function AppHelper(){_classCallCheck(this,AppHelper);}_createClass(AppHelper,null,[{key:'hasRole',value:function hasRole(roles){var check_roles=Array.isArray(roles)?roles:[roles];var _ref=__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].getState()||{},_ref$user=_ref.user;_ref$user=_ref$user===undefined?{}:_ref$user;var _ref$user$roles=_ref$user.roles,user_roles=_ref$user$roles===undefined?[]:_ref$user$roles;return user_roles.filter(function(x){return check_roles.includes(x);}).length>0;}},{key:'isApp',value:function isApp(){var userAgent=navigator.userAgent||navigator.vendor||window.opera;if(/App\/com.farglory.community/i.test(userAgent)){return true;}}},{key:'isMobile',value:function isMobile(){return this.getMobileOperatingSystem()!=='unknown';}},{key:'isIOS',value:function isIOS(){return this.getMobileOperatingSystem()=='iOS';}},{key:'isAndroid',value:function isAndroid(){return this.getMobileOperatingSystem()=='Android';}},{key:'getMobileOperatingSystem',value:function getMobileOperatingSystem(){// userAgent format: {origin_user_agent} {in_app_custom_agent}
// in_app_custom_agent format:
// "App/com.farglory.community OS/{{ios or android}} version/{{app_version}} build/{{app_bundle_version}} APP-ID/{{APP_ID}}"
// ex: "App/com.farglory.community OS/ios version/\(app_version()) build/\(app_bundle_version()) APP-ID/\(APP_ID)"
var userAgent=navigator.userAgent||navigator.vendor||window.opera;if(/windows phone/i.test(userAgent)){return'Windows Phone';}if(/android/i.test(userAgent)){return'Android';}if(/iPad|iPhone|iPod/.test(userAgent)&&!window.MSStream){return'iOS';}return'unknown';}// 取得URL的QueryParamaters
},{key:'getURLQuery',value:function getURLQuery(){return __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(window,'location.search'));}},{key:'getHashParamaters',value:function getHashParamaters(){return __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(window,'location.hash'));}},{key:'getHashValue',value:function getHashValue(key){var matches=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(window,'location.hash','').match(new RegExp(key+'=([^&]*)'));return matches?matches[1]:null;}},{key:'getLocalStorage',value:function getLocalStorage(key){var str=localStorage.getItem(key);if(str){if(str.substr(0,1)=='{'&&str.substr(-1)=='}')return __WEBPACK_IMPORTED_MODULE_14_libs_wjson__["a" /* default */].decode(localStorage.getItem(key));else return localStorage.getItem(key);}}},{key:'removeLocalStorage',value:function removeLocalStorage(key){return localStorage.removeItem(key);}},{key:'setLocalStorage',value:function setLocalStorage(key,value){return localStorage.setItem(key,value);}/* 使用範例
   * AppHelper.updateConfig( resp => {
   *   const {code=100, reason='發生錯誤', data={} } = resp;
   *   if (code !== 200)
   *   {
   *     return message.warning(reason)
   *   }
   *   this.props.history.replace(to_path)
   * })
   */},{key:'updateConfig',value:function updateConfig(callback){if(__WEBPACK_IMPORTED_MODULE_3__configs_env__["c" /* DEBUG_MODE */]==true){console.debug('updateConfig 開發中直接塞資料',__WEBPACK_IMPORTED_MODULE_11__ConfigData__["a" /* default */]);var options=__WEBPACK_IMPORTED_MODULE_11__ConfigData__["a" /* default */].options,me=__WEBPACK_IMPORTED_MODULE_11__ConfigData__["a" /* default */].me;__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_app__["c" /* updateOptions */])(options));// store.dispatch(updateUserInfo(me))
return;}if(AppHelper.updateConfigCancel)AppHelper.updateConfigCancel('Cancel Last Query');__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders(),cancelToken:new __WEBPACK_IMPORTED_MODULE_1_axios__["CancelToken"](function(cancel){AppHelper.updateConfigCancel=cancel;})}).then(function(response){//console.log('response', response)
var _response$status=response.status,status=_response$status===undefined?100:_response$status,_response$data=response.data;_response$data=_response$data===undefined?{}:_response$data;var _response$data$code=_response$data.code,code=_response$data$code===undefined?100:_response$data$code,_response$data$reason=_response$data.reason,reason=_response$data$reason===undefined?'未知錯誤':_response$data$reason,_response$data$data=_response$data.data,data=_response$data$data===undefined?{}:_response$data$data;var resp={status:status,code:code,reason:reason,data:data};var options=data.options,me=data.me;__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_app__["c" /* updateOptions */])(options));__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_user__["c" /* updateUserInfo */])(me));var confings=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(data);delete confings.me;__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_app__["d" /* updateSystemConfigs */])(data));if(__WEBPACK_IMPORTED_MODULE_3__configs_env__["i" /* USE_LOCAL_CONFIG */]==true){var devOptions=Object.assign({},options,{apis:[].concat(_toConsumableArray(options.apis),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__ConfigData__["a" /* default */].options.apis))// apis:[...options.apis, ...ConfigData.options.apis],
});console.debug('updateConfig 開發中部分塞options資料',devOptions);__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__reducers_app__["c" /* updateOptions */])(devOptions));}if(callback)callback(resp);}).catch(function(error){// console.log('error', error)
var _error$response=error.response;_error$response=_error$response===undefined?{}:_error$response;var _error$response$data=_error$response.data;_error$response$data=_error$response$data===undefined?{}:_error$response$data;var _error$response$data$=_error$response$data.code,code=_error$response$data$===undefined?100:_error$response$data$,_error$response$data$2=_error$response$data.reason,reason=_error$response$data$2===undefined?'未知錯誤':_error$response$data$2,_error$response$data$3=_error$response$data.data,data=_error$response$data$3===undefined?{}:_error$response$data$3;if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=0;reason='canceled';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}},{key:'updateBadge',value:function updateBadge(){__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/v1/admin/shop/badge',null,function(state,res){// if (state === false || res.code !== 200) { return }
var _res$data$shop_in_app=res.data.shop_in_application_badge,shop_in_application_badge=_res$data$shop_in_app===undefined?0:_res$data$shop_in_app;__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_badge__["a" /* updateBadgeInfo */])({shop_in_application:shop_in_application_badge}));});}// check User Auth & Info
},{key:'updateUserInfo',value:function updateUserInfo(callback){console.log(AppHelper.updateUserInfoCancel);//if (AppHelper.updateUserInfoCancel)
//AppHelper.updateUserInfoCancel('Cancel Last Query');
AppHelper.updateUserInfoCancel=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfile',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders()}).then(function(response){var _response$status2=response.status,status=_response$status2===undefined?100:_response$status2,_response$data2=response.data;_response$data2=_response$data2===undefined?{}:_response$data2;var _response$data2$code=_response$data2.code,code=_response$data2$code===undefined?100:_response$data2$code,_response$data2$reaso=_response$data2.reason,reason=_response$data2$reaso===undefined?'未知錯誤':_response$data2$reaso,_response$data2$data=_response$data2.data,data=_response$data2$data===undefined?{}:_response$data2$data;var resp={status:status,code:code,reason:reason,data:data// const { options, me } = data
// let prevPermissions = _.get(store.getState(), 'auth.permissions')
// let prevRoles       = _.get(store.getState(), 'auth.roles')
// let nextPermissions = data.permissions
// let nextRoles       = data.roles
// if (!_.isEqual(prevPermissions, nextPermissions) || !_.isEqual(prevRoles, nextRoles)) {
//     const newAuthInfo = {
//         roles:nextRoles,
//         permissions:nextPermissions,
//     }
//     store.dispatch(updateAuthInfo(newAuthInfo))
//     NotificationCenter.default.post(NotificationName.PermissionsDidChanged, newAuthInfo)
// }
};if(code==401){__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_auth__["a" /* cleanAuthInfo */])());return;}AppHelper.thirdPartyLogin(data.client_id,data.access_token);__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__reducers_user__["c" /* updateUserInfo */])(data));if(callback)callback(resp);}).catch(function(error){var statusCode=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status');var statusText=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.statusText');var code=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.code',statusCode);var reason=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.reason',statusText);var data=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.reason',{});if(statusCode==401){__WEBPACK_IMPORTED_MODULE_13__libs_NotificationCenter__["b" /* default */].default.post(__WEBPACK_IMPORTED_MODULE_13__libs_NotificationCenter__["a" /* NotificationName */].AuthDenied);}if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=499;reason='Client closed request.';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}// 第三方登入
},{key:'thirdPartyLogin',value:function thirdPartyLogin(client_id,token,callback){var ecLoginId='third-party-login';var url=__WEBPACK_IMPORTED_MODULE_3__configs_env__["d" /* EC_LOGIN_ENDPOINT */]+'?src_client_id='+client_id+'&src_token='+token;console.log('EC thirdPartyLogin:'+url);var loginIFrame=document.getElementById(ecLoginId);if(loginIFrame===null){loginIFrame=document.createElement('iframe');loginIFrame.style.display='none';loginIFrame.setAttribute('id',ecLoginId);loginIFrame.src=url;loginIFrame.onload=function(){// loginIFrame.parentNode.removeChild(i);
if(callback)callback();};document.body.appendChild(loginIFrame);}if(loginIFrame.src!==url){loginIFrame.src=url;}console.log('EC thirdPartyLogin iframe',loginIFrame);console.log('EC thirdPartyLogin iframe src: ',loginIFrame.src);}// check User Auth & Info
},{key:'updateUserCardInfo',value:function updateUserCardInfo(callback){console.log(AppHelper.updateUserCardInfoCancel);//if (AppHelper.updateUserCardInfoCancel)
//AppHelper.updateUserCardInfoCancel('Cancel Last Query');
AppHelper.updateUserCardInfoCancel=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/account/getCardProfile',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders()}).then(function(response){var _response$status3=response.status,status=_response$status3===undefined?100:_response$status3,_response$data3=response.data;_response$data3=_response$data3===undefined?{}:_response$data3;var _response$data3$code=_response$data3.code,code=_response$data3$code===undefined?100:_response$data3$code,_response$data3$reaso=_response$data3.reason,reason=_response$data3$reaso===undefined?'未知錯誤':_response$data3$reaso,_response$data3$data=_response$data3.data,data=_response$data3$data===undefined?{}:_response$data3$data;var resp={status:status,code:code,reason:reason,data:data// const { options, me } = data
// let prevPermissions = _.get(store.getState(), 'auth.permissions')
// let prevRoles       = _.get(store.getState(), 'auth.roles')
// let nextPermissions = data.permissions
// let nextRoles       = data.roles
// if (!_.isEqual(prevPermissions, nextPermissions) || !_.isEqual(prevRoles, nextRoles)) {
//     const newAuthInfo = {
//         roles:nextRoles,
//         permissions:nextPermissions,
//     }
//     store.dispatch(updateAuthInfo(newAuthInfo))
//     NotificationCenter.default.post(NotificationName.PermissionsDidChanged, newAuthInfo)
// }
};if(code==401){__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_auth__["a" /* cleanAuthInfo */])());return;}console.error('需確認正常運作? store.dispatch(updateUserCardInfo(data))');// store.dispatch(updateUserCardInfo(data))
if(callback)callback(resp);}).catch(function(error){var statusCode=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status');var statusText=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.statusText');var code=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.code',statusCode);var reason=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.reason',statusText);var data=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.reason',{});if(statusCode==401){__WEBPACK_IMPORTED_MODULE_13__libs_NotificationCenter__["b" /* default */].default.post(__WEBPACK_IMPORTED_MODULE_13__libs_NotificationCenter__["a" /* NotificationName */].AuthDenied);}if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=499;reason='Client closed request.';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}},{key:'getStoreList',value:function getStoreList(params,callback){// if (DEBUG_MODE == true) {
//     console.debug('getStoreList 開發中直接塞資料', StoresData)
//     store.dispatch(updateStoreList(StoresData.listInfo))
//     return
// }
if(AppHelper.getStoreListCancel)AppHelper.getStoreListCancel('Cancel Last Query');console.log('params',params);__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/v1/stores',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders(),cancelToken:new __WEBPACK_IMPORTED_MODULE_1_axios__["CancelToken"](function(cancel){AppHelper.getStoreListCancel=cancel;}),params:Object.assign({},params,{page_size:'all'})}).then(function(response){var _response$status4=response.status,status=_response$status4===undefined?100:_response$status4,_response$data4=response.data;_response$data4=_response$data4===undefined?{}:_response$data4;var _response$data4$code=_response$data4.code,code=_response$data4$code===undefined?100:_response$data4$code,_response$data4$reaso=_response$data4.reason,reason=_response$data4$reaso===undefined?'未知錯誤':_response$data4$reaso,_response$data4$data=_response$data4.data,data=_response$data4$data===undefined?{}:_response$data4$data;var resp={status:status,code:code,reason:reason,data:data};__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_stores__["b" /* updateStoreList */])(data));if(callback)callback(resp);}).catch(function(error){console.log('error',error);var _error$response2=error.response;_error$response2=_error$response2===undefined?{}:_error$response2;var _error$response2$data=_error$response2.data;_error$response2$data=_error$response2$data===undefined?{}:_error$response2$data;var _error$response2$data2=_error$response2$data.code,code=_error$response2$data2===undefined?100:_error$response2$data2,_error$response2$data3=_error$response2$data.reason,reason=_error$response2$data3===undefined?'未知錯誤':_error$response2$data3,_error$response2$data4=_error$response2$data.data,data=_error$response2$data4===undefined?{}:_error$response2$data4;if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=0;reason='canceled';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}},{key:'getStoreInfo',value:function getStoreInfo(params,callback){if(AppHelper.getStoreListCancel)AppHelper.getStoreListCancel('Cancel Last Query');console.log('params',params);__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/v1/stores',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders(),cancelToken:new __WEBPACK_IMPORTED_MODULE_1_axios__["CancelToken"](function(cancel){AppHelper.getStoreListCancel=cancel;}),params:params}).then(function(response){var _response$status5=response.status,status=_response$status5===undefined?100:_response$status5,_response$data5=response.data;_response$data5=_response$data5===undefined?{}:_response$data5;var _response$data5$code=_response$data5.code,code=_response$data5$code===undefined?100:_response$data5$code,_response$data5$reaso=_response$data5.reason,reason=_response$data5$reaso===undefined?'未知錯誤':_response$data5$reaso,_response$data5$data=_response$data5.data,data=_response$data5$data===undefined?{}:_response$data5$data;var resp={status:status,code:code,reason:reason,data:data};__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__reducers_stores__["b" /* updateStoreList */])(data));if(callback)callback(resp);}).catch(function(error){console.log('error',error);var _error$response3=error.response;_error$response3=_error$response3===undefined?{}:_error$response3;var _error$response3$data=_error$response3.data;_error$response3$data=_error$response3$data===undefined?{}:_error$response3$data;var _error$response3$data2=_error$response3$data.code,code=_error$response3$data2===undefined?100:_error$response3$data2,_error$response3$data3=_error$response3$data.reason,reason=_error$response3$data3===undefined?'未知錯誤':_error$response3$data3,_error$response3$data4=_error$response3$data.data,data=_error$response3$data4===undefined?{}:_error$response3$data4;if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=0;reason='canceled';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}},{key:'getBrandList',value:function getBrandList(params,callback){if(AppHelper.getBrandListCancel)AppHelper.getBrandListCancel('Cancel Last Query');__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/v1/brands',{headers:__WEBPACK_IMPORTED_MODULE_4__whttp__["a" /* default */].getHeaders(),cancelToken:new __WEBPACK_IMPORTED_MODULE_1_axios__["CancelToken"](function(cancel){AppHelper.getBrandListCancel=cancel;}),params:params}).then(function(response){var _response$status6=response.status,status=_response$status6===undefined?100:_response$status6,_response$data6=response.data;_response$data6=_response$data6===undefined?{}:_response$data6;var _response$data6$code=_response$data6.code,code=_response$data6$code===undefined?100:_response$data6$code,_response$data6$reaso=_response$data6.reason,reason=_response$data6$reaso===undefined?'未知錯誤':_response$data6$reaso,_response$data6$data=_response$data6.data,data=_response$data6$data===undefined?{}:_response$data6$data;var resp={status:status,code:code,reason:reason,data:data// TODO 看有沒有需要同步
//store.dispatch(updateBrandList(data))
};if(callback)callback(resp);}).catch(function(error){console.log('error',error);var _error$response4=error.response;_error$response4=_error$response4===undefined?{}:_error$response4;var _error$response4$data=_error$response4.data;_error$response4$data=_error$response4$data===undefined?{}:_error$response4$data;var _error$response4$data2=_error$response4$data.code,code=_error$response4$data2===undefined?100:_error$response4$data2,_error$response4$data3=_error$response4$data.reason,reason=_error$response4$data3===undefined?'未知錯誤':_error$response4$data3,_error$response4$data4=_error$response4$data.data,data=_error$response4$data4===undefined?{}:_error$response4$data4;if(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)){code=0;reason='canceled';}if(callback)callback({code:code,reason:reason,data:data,error:error});});}}]);return AppHelper;}(),_class.setDocumentTitle=function(){var title=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;document.title=(' '+title).trim();},_class.updateConfigCancel=null,_class.updateUserInfoCancel=null,_class.updateUserCardInfoCancel=null,_class.getStoreListCancel=null,_class.getStoreInfoCancel=null,_class.getBrandListCancel=null,_class.getNewsLink=function(newsInfo){var action_type=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(newsInfo,'action_type');if(action_type==1){var post_id=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(newsInfo,'post_id');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');return INDEX_URL+'/?p='+post_id;}if(action_type==2){var link=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(newsInfo,'link');console.log('getNewsLink',link,newsInfo);if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(link))return link;}return'#';},_temp);/* harmony default export */ __webpack_exports__["a"] = (AppHelper);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1619);

__webpack_require__(293);

__webpack_require__(139);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Form = _interopRequireWildcard(__webpack_require__(1620));

var _FormItem = _interopRequireDefault(__webpack_require__(1624));

var _ErrorList = _interopRequireDefault(__webpack_require__(708));

var _FormList = _interopRequireDefault(__webpack_require__(1635));

var _context = __webpack_require__(126);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var Form = _Form["default"];
Form.Item = _FormItem["default"];
Form.List = _FormList["default"];
Form.ErrorList = _ErrorList["default"];
Form.useForm = _Form.useForm;
Form.Provider = _context.FormProvider;

Form.create = function () {
  (0, _devWarning["default"])(false, 'Form', 'antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.');
};

var _default = Form;
exports["default"] = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyThenIncreaseKey = getKeyThenIncreaseKey;
exports.attachTypeApi = attachTypeApi;
exports["default"] = exports.getInstance = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcNotification = _interopRequireDefault(__webpack_require__(506));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(257));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(258));

var _InfoCircleFilled = _interopRequireDefault(__webpack_require__(533));

var _useMessage = _interopRequireDefault(__webpack_require__(1030));

var messageInstance;
var defaultDuration = 3;
var defaultTop;
var key = 1;
var localPrefixCls = 'ant-message';
var transitionName = 'move-up';
var getContainer;
var maxCount;
var rtl = false;

function getKeyThenIncreaseKey() {
  return key++;
}

function setMessageConfig(options) {
  if (options.top !== undefined) {
    defaultTop = options.top;
    messageInstance = null; // delete messageInstance for new defaultTop
  }

  if (options.duration !== undefined) {
    defaultDuration = options.duration;
  }

  if (options.prefixCls !== undefined) {
    localPrefixCls = options.prefixCls;
  }

  if (options.getContainer !== undefined) {
    getContainer = options.getContainer;
  }

  if (options.transitionName !== undefined) {
    transitionName = options.transitionName;
    messageInstance = null; // delete messageInstance for new transitionName
  }

  if (options.maxCount !== undefined) {
    maxCount = options.maxCount;
    messageInstance = null;
  }

  if (options.rtl !== undefined) {
    rtl = options.rtl;
  }
}

function getRCNotificationInstance(args, callback) {
  var prefixCls = args.prefixCls || localPrefixCls;

  if (messageInstance) {
    callback({
      prefixCls: prefixCls,
      instance: messageInstance
    });
    return;
  }

  _rcNotification["default"].newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback({
        prefixCls: prefixCls,
        instance: messageInstance
      });
      return;
    }

    messageInstance = instance;
    callback({
      prefixCls: prefixCls,
      instance: instance
    });
  });
}

var typeToIcon = {
  info: _InfoCircleFilled["default"],
  success: _CheckCircleFilled["default"],
  error: _CloseCircleFilled["default"],
  warning: _ExclamationCircleFilled["default"],
  loading: _LoadingOutlined["default"]
};

function getRCNoticeProps(args, prefixCls) {
  var _classNames;

  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var IconComponent = typeToIcon[args.type];
  var messageClass = (0, _classnames["default"])("".concat(prefixCls, "-custom-content"), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(args.type), args.type), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), rtl === true), _classNames));
  return {
    key: args.key,
    duration: duration,
    style: args.style || {},
    className: args.className,
    content: /*#__PURE__*/React.createElement("div", {
      className: messageClass
    }, args.icon || IconComponent && /*#__PURE__*/React.createElement(IconComponent, null), /*#__PURE__*/React.createElement("span", null, args.content)),
    onClose: args.onClose,
    onClick: args.onClick
  };
}

function notice(args) {
  var target = args.key || key++;
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      return resolve(true);
    };

    getRCNotificationInstance(args, function (_ref) {
      var prefixCls = _ref.prefixCls,
          instance = _ref.instance;
      instance.notice(getRCNoticeProps((0, _extends2["default"])((0, _extends2["default"])({}, args), {
        key: target,
        onClose: callback
      }), prefixCls));
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
}

function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}

var api = {
  open: notice,
  config: setMessageConfig,
  destroy: function destroy(messageKey) {
    if (messageInstance) {
      if (messageKey) {
        var _messageInstance = messageInstance,
            removeNotice = _messageInstance.removeNotice;
        removeNotice(messageKey);
      } else {
        var _messageInstance2 = messageInstance,
            destroy = _messageInstance2.destroy;
        destroy();
        messageInstance = null;
      }
    }
  }
};

function attachTypeApi(originalApi, type) {
  originalApi[type] = function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return originalApi.open((0, _extends2["default"])((0, _extends2["default"])({}, content), {
        type: type
      }));
    }

    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return originalApi.open({
      content: content,
      duration: duration,
      type: type,
      onClose: onClose
    });
  };
}

['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
  return attachTypeApi(api, type);
});
api.warn = api.warning;
api.useMessage = (0, _useMessage["default"])(getRCNotificationInstance, getRCNoticeProps);
/** @private test only function. Not work on production */

var getInstance = function getInstance() {
  return  false ? messageInstance : null;
};

exports.getInstance = getInstance;
var _default = api;
exports["default"] = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(526);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1549);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(527));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(526));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(528));
var React = _interopRequireWildcard(__webpack_require__(0));
var _classnames = _interopRequireDefault(__webpack_require__(1));
var _Context = _interopRequireDefault(__webpack_require__(529));
var _IconBase = _interopRequireDefault(__webpack_require__(530));
var _twoTonePrimaryColor = __webpack_require__(1021);
var _utils = __webpack_require__(341);
var _excluded = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Initial setting
// should move it to antd main repo?
(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;
  var className = props.className,
    icon = props.icon,
    spin = props.spin,
    rotate = props.rotate,
    tabIndex = props.tabIndex,
    onClick = props.onClick,
    twoToneColor = props.twoToneColor,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _React$useContext = React.useContext(_Context.default),
    _React$useContext$pre = _React$useContext.prefixCls,
    prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre,
    rootClassName = _React$useContext.rootClassName;
  var classString = (0, _classnames.default)(rootClassName, prefixCls, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;
  var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor),
    _normalizeTwoToneColo2 = (0, _slicedToArray2.default)(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return /*#__PURE__*/React.createElement("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    role: "img",
    "aria-label": icon.name
  }, restProps), {}, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/React.createElement(_IconBase.default, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = wp.i18n;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return genFormItemAtrribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FormHelper=function(){function FormHelper(){_classCallCheck(this,FormHelper);}_createClass(FormHelper,null,[{key:'set',value:function set(object,path,value,callback){__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set(object,path,value);callback(object);}}]);return FormHelper;}();var genFormItemAtrribute=function genFormItemAtrribute(name){var label=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var valuePropName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'value';// label = label || name
return{name:name,label:label,valuePropName:valuePropName};};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(534);
var iterableToArrayLimit = __webpack_require__(1031);
var unsupportedIterableToArray = __webpack_require__(344);
var nonIterableRest = __webpack_require__(536);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1088);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1095);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1096);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1098);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1099);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(355);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1100);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(1102);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(1103);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(1104);
/* unused harmony reexport withRouter */





























/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(285));

var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1121);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcSelect = _interopRequireWildcard(__webpack_require__(1226));

var _configProvider = __webpack_require__(8);

var _iconUtil = _interopRequireDefault(__webpack_require__(1335));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';

var InternalSelect = function InternalSelect(_a, ref) {
  var _classNames2;

  var customizePrefixCls = _a.prefixCls,
      _a$bordered = _a.bordered,
      bordered = _a$bordered === void 0 ? true : _a$bordered,
      className = _a.className,
      getPopupContainer = _a.getPopupContainer,
      dropdownClassName = _a.dropdownClassName,
      _a$listHeight = _a.listHeight,
      listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight,
      _a$listItemHeight = _a.listItemHeight,
      listItemHeight = _a$listItemHeight === void 0 ? 24 : _a$listItemHeight,
      customizeSize = _a.size,
      notFoundContent = _a.notFoundContent,
      _a$transitionName = _a.transitionName,
      transitionName = _a$transitionName === void 0 ? 'slide-up' : _a$transitionName,
      props = __rest(_a, ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "listHeight", "listItemHeight", "size", "notFoundContent", "transitionName"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      renderEmpty = _React$useContext.renderEmpty,
      direction = _React$useContext.direction,
      virtual = _React$useContext.virtual,
      dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;

  var size = React.useContext(_SizeContext["default"]);
  var prefixCls = getPrefixCls('select', customizePrefixCls);
  var mode = React.useMemo(function () {
    var m = props.mode;

    if (m === 'combobox') {
      return undefined;
    }

    if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
      return 'combobox';
    }

    return m;
  }, [props.mode]);
  var isMultiple = mode === 'multiple' || mode === 'tags'; // ===================== Empty =====================

  var mergedNotFound;

  if (notFoundContent !== undefined) {
    mergedNotFound = notFoundContent;
  } else if (mode === 'combobox') {
    mergedNotFound = null;
  } else {
    mergedNotFound = renderEmpty('Select');
  } // ===================== Icons =====================


  var _getIcons = (0, _iconUtil["default"])((0, _extends2["default"])((0, _extends2["default"])({}, props), {
    multiple: isMultiple,
    prefixCls: prefixCls
  })),
      suffixIcon = _getIcons.suffixIcon,
      itemIcon = _getIcons.itemIcon,
      removeIcon = _getIcons.removeIcon,
      clearIcon = _getIcons.clearIcon;

  var selectProps = (0, _omit["default"])(props, ['suffixIcon', 'itemIcon']);
  var rcSelectRtlDropDownClassName = (0, _classnames["default"])(dropdownClassName, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === 'rtl'));
  var mergedSize = customizeSize || size;
  var mergedClassName = (0, _classnames["default"])((_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-lg"), mergedSize === 'large'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-sm"), mergedSize === 'small'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-borderless"), !bordered), _classNames2), className);
  return /*#__PURE__*/React.createElement(_rcSelect["default"], (0, _extends2["default"])({
    ref: ref,
    virtual: virtual,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth
  }, selectProps, {
    transitionName: transitionName,
    listHeight: listHeight,
    listItemHeight: listItemHeight,
    mode: mode,
    prefixCls: prefixCls,
    direction: direction,
    inputIcon: suffixIcon,
    menuItemSelectedIcon: itemIcon,
    removeIcon: removeIcon,
    clearIcon: clearIcon,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: rcSelectRtlDropDownClassName
  }));
};

var SelectRef = /*#__PURE__*/React.forwardRef(InternalSelect);
var Select = SelectRef;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = _rcSelect.Option;
Select.OptGroup = _rcSelect.OptGroup;
var _default = Select;
exports["default"] = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1128);

__webpack_require__(206);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1602);

__webpack_require__(27);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(__webpack_require__(223));

var _Group = _interopRequireDefault(__webpack_require__(1603));

var _Search = _interopRequireDefault(__webpack_require__(697));

var _TextArea = _interopRequireDefault(__webpack_require__(698));

var _Password = _interopRequireDefault(__webpack_require__(1614));

_Input["default"].Group = _Group["default"];
_Input["default"].Search = _Search["default"];
_Input["default"].TextArea = _TextArea["default"];
_Input["default"].Password = _Password["default"];
var _default = _Input["default"];
exports["default"] = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getInstance = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(1052));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcNotification = _interopRequireDefault(__webpack_require__(506));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(345));

var _CloseCircleOutlined = _interopRequireDefault(__webpack_require__(346));

var _ExclamationCircleOutlined = _interopRequireDefault(__webpack_require__(347));

var _InfoCircleOutlined = _interopRequireDefault(__webpack_require__(349));

var _useNotification = _interopRequireDefault(__webpack_require__(1063));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = 24;
var defaultBottom = 24;
var defaultPrefixCls = 'ant-notification';
var defaultPlacement = 'topRight';
var defaultGetContainer;
var defaultCloseIcon;
var rtl = false;

function setNotificationConfig(options) {
  var duration = options.duration,
      placement = options.placement,
      bottom = options.bottom,
      top = options.top,
      getContainer = options.getContainer,
      closeIcon = options.closeIcon,
      prefixCls = options.prefixCls;

  if (prefixCls !== undefined) {
    defaultPrefixCls = prefixCls;
  }

  if (duration !== undefined) {
    defaultDuration = duration;
  }

  if (placement !== undefined) {
    defaultPlacement = placement;
  } else if (options.rtl) {
    defaultPlacement = 'topLeft';
  }

  if (bottom !== undefined) {
    defaultBottom = bottom;
  }

  if (top !== undefined) {
    defaultTop = top;
  }

  if (getContainer !== undefined) {
    defaultGetContainer = getContainer;
  }

  if (closeIcon !== undefined) {
    defaultCloseIcon = closeIcon;
  }

  if (options.rtl !== undefined) {
    rtl = options.rtl;
  }
}

function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
  var style;

  switch (placement) {
    case 'topLeft':
      style = {
        left: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'topRight':
      style = {
        right: 0,
        top: top,
        bottom: 'auto'
      };
      break;

    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom: bottom
      };
      break;

    default:
      style = {
        right: 0,
        top: 'auto',
        bottom: bottom
      };
      break;
  }

  return style;
}

function getNotificationInstance(args, callback) {
  var _args$placement = args.placement,
      placement = _args$placement === void 0 ? defaultPlacement : _args$placement,
      top = args.top,
      bottom = args.bottom,
      _args$getContainer = args.getContainer,
      getContainer = _args$getContainer === void 0 ? defaultGetContainer : _args$getContainer,
      _args$closeIcon = args.closeIcon,
      closeIcon = _args$closeIcon === void 0 ? defaultCloseIcon : _args$closeIcon;
  var outerPrefixCls = args.prefixCls || defaultPrefixCls;
  var prefixCls = "".concat(outerPrefixCls, "-notice");
  var cacheKey = "".concat(outerPrefixCls, "-").concat(placement);
  var cacheInstance = notificationInstance[cacheKey];

  if (cacheInstance) {
    Promise.resolve(cacheInstance).then(function (instance) {
      callback({
        prefixCls: prefixCls,
        instance: instance
      });
    });
    return;
  }

  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
    className: "".concat(outerPrefixCls, "-close-x")
  }, closeIcon || /*#__PURE__*/React.createElement(_CloseOutlined["default"], {
    className: "".concat(outerPrefixCls, "-close-icon")
  }));
  var notificationClass = (0, _classnames["default"])("".concat(outerPrefixCls, "-").concat(placement), (0, _defineProperty2["default"])({}, "".concat(outerPrefixCls, "-rtl"), rtl === true));
  notificationInstance[cacheKey] = new Promise(function (resolve) {
    _rcNotification["default"].newInstance({
      prefixCls: outerPrefixCls,
      className: notificationClass,
      style: getPlacementStyle(placement, top, bottom),
      getContainer: getContainer,
      closeIcon: closeIconToRender
    }, function (notification) {
      resolve(notification);
      callback({
        prefixCls: prefixCls,
        instance: notification
      });
    });
  });
}

var typeToIcon = {
  success: _CheckCircleOutlined["default"],
  info: _InfoCircleOutlined["default"],
  error: _CloseCircleOutlined["default"],
  warning: _ExclamationCircleOutlined["default"]
};

function getRCNoticeProps(args, prefixCls) {
  var duration = args.duration === undefined ? defaultDuration : args.duration;
  var iconNode = null;

  if (args.icon) {
    iconNode = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-icon")
    }, args.icon);
  } else if (args.type) {
    iconNode = /*#__PURE__*/React.createElement(typeToIcon[args.type] || null, {
      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type)
    });
  }

  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-message-single-line-auto-margin")
  }) : null;
  return {
    content: /*#__PURE__*/React.createElement("div", {
      className: iconNode ? "".concat(prefixCls, "-with-icon") : '',
      role: "alert"
    }, iconNode, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message")
    }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-description")
    }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-btn")
    }, args.btn) : null),
    duration: duration,
    closable: true,
    onClose: args.onClose,
    onClick: args.onClick,
    key: args.key,
    style: args.style || {},
    className: args.className
  };
}

function notice(args) {
  getNotificationInstance(args, function (_ref) {
    var prefixCls = _ref.prefixCls,
        instance = _ref.instance;
    instance.notice(getRCNoticeProps(args, prefixCls));
  });
}

var api = {
  open: notice,
  close: function close(key) {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      return Promise.resolve(notificationInstance[cacheKey]).then(function (instance) {
        instance.removeNotice(key);
      });
    });
  },
  config: setNotificationConfig,
  destroy: function destroy() {
    Object.keys(notificationInstance).forEach(function (cacheKey) {
      Promise.resolve(notificationInstance[cacheKey]).then(function (instance) {
        instance.destroy();
      });
      delete notificationInstance[cacheKey]; // lgtm[js/missing-await]
    });
  }
};
['success', 'info', 'warning', 'error'].forEach(function (type) {
  api[type] = function (args) {
    return api.open((0, _extends2["default"])((0, _extends2["default"])({}, args), {
      type: type
    }));
  };
});
api.warn = api.warning;
api.useNotification = (0, _useNotification["default"])(getNotificationInstance, getRCNoticeProps);
/** @private test only function. Not work on production */

var getInstance = function getInstance(cacheKey) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return",  false ? notificationInstance[cacheKey] : null);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.getInstance = getInstance;
var _default = api;
exports["default"] = _default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1761);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlockTree = __webpack_require__(812);
var ContentState = __webpack_require__(427);
var EditorBidiService = __webpack_require__(1942);
var Immutable = __webpack_require__(32);
var SelectionState = __webpack_require__(196);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack;


var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record(defaultRecord);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable) {
    _classCallCheck(this, EditorState);

    this._immutable = immutable;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListConsumer = exports.ListContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _spin = _interopRequireDefault(__webpack_require__(50));

var _useBreakpoint = _interopRequireDefault(__webpack_require__(217));

var _responsiveObserve = __webpack_require__(284);

var _configProvider = __webpack_require__(8);

var _pagination = _interopRequireDefault(__webpack_require__(598));

var _grid = __webpack_require__(294);

var _Item = _interopRequireDefault(__webpack_require__(1537));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ListContext = /*#__PURE__*/React.createContext({});
exports.ListContext = ListContext;
var ListConsumer = ListContext.Consumer;
exports.ListConsumer = ListConsumer;

function List(_a) {
  var _classNames;

  var _a$pagination = _a.pagination,
      pagination = _a$pagination === void 0 ? false : _a$pagination,
      customizePrefixCls = _a.prefixCls,
      _a$bordered = _a.bordered,
      bordered = _a$bordered === void 0 ? false : _a$bordered,
      _a$split = _a.split,
      split = _a$split === void 0 ? true : _a$split,
      className = _a.className,
      children = _a.children,
      itemLayout = _a.itemLayout,
      loadMore = _a.loadMore,
      grid = _a.grid,
      _a$dataSource = _a.dataSource,
      dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
      size = _a.size,
      header = _a.header,
      footer = _a.footer,
      _a$loading = _a.loading,
      loading = _a$loading === void 0 ? false : _a$loading,
      rowKey = _a.rowKey,
      renderItem = _a.renderItem,
      locale = _a.locale,
      rest = __rest(_a, ["pagination", "prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "grid", "dataSource", "size", "header", "footer", "loading", "rowKey", "renderItem", "locale"]);

  var paginationObj = pagination && (0, _typeof2["default"])(pagination) === 'object' ? pagination : {};

  var _React$useState = React.useState(paginationObj.defaultCurrent || 1),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      paginationCurrent = _React$useState2[0],
      setPaginationCurrent = _React$useState2[1];

  var _React$useState3 = React.useState(paginationObj.defaultPageSize || 10),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      paginationSize = _React$useState4[0],
      setPaginationSize = _React$useState4[1];

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      renderEmpty = _React$useContext.renderEmpty,
      direction = _React$useContext.direction;

  var defaultPaginationProps = {
    current: 1,
    total: 0
  };
  var keys = {};

  var triggerPaginationEvent = function triggerPaginationEvent(eventName) {
    return function (page, pageSize) {
      setPaginationCurrent(page);
      setPaginationSize(pageSize);

      if (pagination && pagination[eventName]) {
        pagination[eventName](page, pageSize);
      }
    };
  };

  var onPaginationChange = triggerPaginationEvent('onChange');
  var onPaginationShowSizeChange = triggerPaginationEvent('onShowSizeChange');

  var renderInnerItem = function renderInnerItem(item, index) {
    if (!renderItem) return null;
    var key;

    if (typeof rowKey === 'function') {
      key = rowKey(item);
    } else if (typeof rowKey === 'string') {
      key = item[rowKey];
    } else {
      key = item.key;
    }

    if (!key) {
      key = "list-item-".concat(index);
    }

    keys[index] = key;
    return renderItem(item, index);
  };

  var isSomethingAfterLastItem = function isSomethingAfterLastItem() {
    return !!(loadMore || pagination || footer);
  };

  var renderEmptyFunc = function renderEmptyFunc(prefixCls, renderEmptyHandler) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-empty-text")
    }, locale && locale.emptyText || renderEmptyHandler('List'));
  };

  var prefixCls = getPrefixCls('list', customizePrefixCls);
  var loadingProp = loading;

  if (typeof loadingProp === 'boolean') {
    loadingProp = {
      spinning: loadingProp
    };
  }

  var isLoading = loadingProp && loadingProp.spinning; // large => lg
  // small => sm

  var sizeCls = '';

  switch (size) {
    case 'large':
      sizeCls = 'lg';
      break;

    case 'small':
      sizeCls = 'sm';
      break;

    default:
      break;
  }

  var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-split"), split), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-bordered"), bordered), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-loading"), isLoading), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-grid"), grid), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-something-after-last-item"), isSomethingAfterLastItem()), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  var paginationProps = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, defaultPaginationProps), {
    total: dataSource.length,
    current: paginationCurrent,
    pageSize: paginationSize
  }), pagination || {});
  var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);

  if (paginationProps.current > largestPage) {
    paginationProps.current = largestPage;
  }

  var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-pagination")
  }, /*#__PURE__*/React.createElement(_pagination["default"], (0, _extends2["default"])({}, paginationProps, {
    onChange: onPaginationChange,
    onShowSizeChange: onPaginationShowSizeChange
  }))) : null;
  var splitDataSource = (0, _toConsumableArray2["default"])(dataSource);

  if (pagination) {
    if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
      splitDataSource = (0, _toConsumableArray2["default"])(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
  }

  var screens = (0, _useBreakpoint["default"])();
  var currentBreakpoint = React.useMemo(function () {
    for (var i = 0; i < _responsiveObserve.responsiveArray.length; i += 1) {
      var breakpoint = _responsiveObserve.responsiveArray[i];

      if (screens[breakpoint]) {
        return breakpoint;
      }
    }

    return undefined;
  }, [screens]);
  var colStyle = React.useMemo(function () {
    if (!grid) {
      return undefined;
    }

    var columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;

    if (columnCount) {
      return {
        width: "".concat(100 / columnCount, "%"),
        maxWidth: "".concat(100 / columnCount, "%")
      };
    }
  }, [grid === null || grid === void 0 ? void 0 : grid.column, currentBreakpoint]);
  var childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 53
    }
  });

  if (splitDataSource.length > 0) {
    var items = splitDataSource.map(function (item, index) {
      return renderInnerItem(item, index);
    });
    var childrenList = React.Children.map(items, function (child, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: keys[index],
        style: colStyle
      }, child);
    });
    childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
      gutter: grid.gutter
    }, childrenList) : /*#__PURE__*/React.createElement("ul", {
      className: "".concat(prefixCls, "-items")
    }, items);
  } else if (!children && !isLoading) {
    childrenContent = renderEmptyFunc(prefixCls, renderEmpty);
  }

  var paginationPosition = paginationProps.position || 'bottom';
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: {
      grid: grid,
      itemLayout: itemLayout
    }
  }, /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: classString
  }, rest), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header")
  }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent));
}

List.Item = _Item["default"];
var _default = List;
exports["default"] = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1535);

__webpack_require__(206);

__webpack_require__(48);

__webpack_require__(569);

__webpack_require__(293);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(723);
var objectAssign = __webpack_require__(64);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "resetWarned", {
  enumerable: true,
  get: function get() {
    return _warning.resetWarned;
  }
});
exports["default"] = void 0;

var _warning = _interopRequireWildcard(__webpack_require__(106));

var _default = function _default(valid, component, message) {
  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
};

exports["default"] = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1711);

__webpack_require__(27);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Modal = _interopRequireWildcard(__webpack_require__(412));

var _confirm = _interopRequireWildcard(__webpack_require__(750));

function modalWarn(props) {
  return (0, _confirm["default"])((0, _confirm.withWarn)(props));
}

var Modal = _Modal["default"];

Modal.info = function infoFn(props) {
  return (0, _confirm["default"])((0, _confirm.withInfo)(props));
};

Modal.success = function successFn(props) {
  return (0, _confirm["default"])((0, _confirm.withSuccess)(props));
};

Modal.error = function errorFn(props) {
  return (0, _confirm["default"])((0, _confirm.withError)(props));
};

Modal.warning = modalWarn;
Modal.warn = modalWarn;

Modal.confirm = function confirmFn(props) {
  return (0, _confirm["default"])((0, _confirm.withConfirm)(props));
};

Modal.destroyAll = function destroyAllFn() {
  while (_Modal.destroyFns.length) {
    var close = _Modal.destroyFns.pop();

    if (close) {
      close();
    }
  }
};

Modal.config = _confirm.globalConfig;
var _default = Modal;
exports["default"] = _default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)(module)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1108);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layout = _interopRequireWildcard(__webpack_require__(565));

var _Sider = _interopRequireDefault(__webpack_require__(359));

var Layout = _layout["default"];
Layout.Header = _layout.Header;
Layout.Footer = _layout.Footer;
Layout.Content = _layout.Content;
Layout.Sider = _Sider["default"];
var _default = Layout;
exports["default"] = _default;

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function omit(obj, fields) {
  // eslint-disable-next-line prefer-object-spread
  var shallowCopy = Object.assign({}, obj);

  for (var i = 0; i < fields.length; i += 1) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1126);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(142)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _debounce = _interopRequireDefault(__webpack_require__(596));

var _configProvider = __webpack_require__(8);

var _type = __webpack_require__(118);

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator

var defaultIndicator = null;

function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null

  if (indicator === null) {
    return null;
  }

  if ((0, _reactNode.isValidElement)(indicator)) {
    return (0, _reactNode.cloneElement)(indicator, {
      className: (0, _classnames["default"])(indicator.props.className, dotClassName)
    });
  }

  if ((0, _reactNode.isValidElement)(defaultIndicator)) {
    return (0, _reactNode.cloneElement)(defaultIndicator, {
      className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
    });
  }

  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }), /*#__PURE__*/React.createElement("i", {
    className: "".concat(prefixCls, "-dot-item")
  }));
}

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}

var Spin = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Spin, _React$Component);

  var _super = (0, _createSuper2["default"])(Spin);

  function Spin(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Spin);
    _this = _super.call(this, props);

    _this.debouncifyUpdateSpinning = function (props) {
      var _ref = props || _this.props,
          delay = _ref.delay;

      if (delay) {
        _this.cancelExistingSpin();

        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
      }
    };

    _this.updateSpinning = function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;

      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    };

    _this.renderSpin = function (_ref2) {
      var _classNames;

      var getPrefixCls = _ref2.getPrefixCls,
          direction = _ref2.direction;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          className = _a.className,
          size = _a.size,
          tip = _a.tip,
          wrapperClassName = _a.wrapperClassName,
          style = _a.style,
          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);

      var spinning = _this.state.spinning;
      var prefixCls = getPrefixCls('spin', customizePrefixCls);
      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-spinning"), spinning), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-show-text"), !!tip), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className); // fix https://fb.me/react-unknown-prop

      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
      var spinElement = /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, divProps, {
        style: style,
        className: spinClassName
      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);

      if (_this.isNestedPattern()) {
        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-blur"), spinning));
        return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, divProps, {
          className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning && /*#__PURE__*/React.createElement("div", {
          key: "loading"
        }, spinElement), /*#__PURE__*/React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this.props.children));
      }

      return spinElement;
    };

    var spinning = props.spinning,
        delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;

    _this.debouncifyUpdateSpinning(props);

    return _this;
  }

  (0, _createClass2["default"])(Spin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;

      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && typeof this.props.children !== 'undefined');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);
  return Spin;
}(React.Component);

Spin.defaultProps = {
  spinning: true,
  size: 'default',
  wrapperClassName: ''
};
var _default = Spin;
exports["default"] = _default;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1543);

__webpack_require__(1544);

__webpack_require__(568);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Breadcrumb = _interopRequireDefault(__webpack_require__(1546));

var _default = _Breadcrumb["default"];
exports["default"] = _default;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warning */
/* unused harmony export note */
/* unused harmony export resetWarned */
/* unused harmony export call */
/* unused harmony export warningOnce */
/* harmony export (immutable) */ __webpack_exports__["b"] = noteOnce;
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ __webpack_exports__["a"] = (warningOnce);
/* eslint-enable */

/***/ }),
/* 56 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceElement = replaceElement;
exports.cloneElement = cloneElement;
exports.isValidElement = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var isValidElement = React.isValidElement;
exports.isValidElement = isValidElement;

function replaceElement(element, replacement, props) {
  if (!isValidElement(element)) return replacement;
  return /*#__PURE__*/React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}

function cloneElement(element, props) {
  return replaceElement(element, element, props);
}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

var Errors = function() {
  this.errors = {};
};

Errors.prototype = {
  constructor: Errors,

  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }

    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },

  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }

    return [];
  },

  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }

    return false;
  },

  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function() {
    return this.errors;
  },

  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }

    return false;
  }
};

module.exports = Errors;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* unused harmony export mapAllStateToProps */
/* unused harmony export mapAllDispatchToProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wConnectRedux; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_js__ = __webpack_require__(551);
var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({app:__WEBPACK_IMPORTED_MODULE_2__app_js__["a" /* default */],stores:__WEBPACK_IMPORTED_MODULE_3__stores_js__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_4__auth_js__["b" /* default */],user:__WEBPACK_IMPORTED_MODULE_5__user_js__["b" /* default */]}));var mapAllStateToProps=function mapAllStateToProps(state){return{app:state.app,stores:state.stores,auth:state.auth,user:state.user};};var mapAllDispatchToProps=function mapAllDispatchToProps(dispatch){return{updateAppID:function updateAppID(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__app_js__["b" /* updateAppID */])(id));},updateStoreList:function updateStoreList(listInfo){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__stores_js__["b" /* updateStoreList */])(listInfo));},updateStoreQuery:function updateStoreQuery(query){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__stores_js__["c" /* updateStoreQuery */])(query));},updateAuthInfo:function updateAuthInfo(info){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__auth_js__["c" /* updateAuthInfo */])(info));},cleanAuthInfo:function cleanAuthInfo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__auth_js__["a" /* cleanAuthInfo */])());},updateUserInfo:function updateUserInfo(info){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__user_js__["c" /* updateUserInfo */])(info));},cleanUserInfo:function cleanUserInfo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__user_js__["a" /* cleanUserInfo */])());}};};var wConnectRedux=function wConnectRedux(component){return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapAllStateToProps,mapAllDispatchToProps)(component);};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEEK_DAY_COUNT; });
/* unused harmony export isNullEqual */
/* harmony export (immutable) */ __webpack_exports__["j"] = isSameDecade;
/* harmony export (immutable) */ __webpack_exports__["n"] = isSameYear;
/* harmony export (immutable) */ __webpack_exports__["e"] = getQuarter;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSameQuarter;
/* harmony export (immutable) */ __webpack_exports__["k"] = isSameMonth;
/* harmony export (immutable) */ __webpack_exports__["i"] = isSameDate;
/* unused harmony export isSameTime */
/* harmony export (immutable) */ __webpack_exports__["m"] = isSameWeek;
/* harmony export (immutable) */ __webpack_exports__["g"] = isEqual;
/* harmony export (immutable) */ __webpack_exports__["h"] = isInRange;
/* harmony export (immutable) */ __webpack_exports__["f"] = getWeekStartDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = getClosingViewDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatValue;
/* harmony export (immutable) */ __webpack_exports__["o"] = parseValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCellDateDisabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__panels_DecadePanel_index__ = __webpack_require__(295);

var WEEK_DAY_COUNT = 7;
function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }

  if (!value1 || !value2) {
    return false;
  }

  return undefined;
}
function isSameDecade(generateConfig, decade1, decade2) {
  var equal = isNullEqual(decade1, decade2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
  var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
  return num1 === num2;
}
function isSameYear(generateConfig, year1, year2) {
  var equal = isNullEqual(year1, year2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(year1) === generateConfig.getYear(year2);
}
function getQuarter(generateConfig, date) {
  var quota = Math.floor(generateConfig.getMonth(date) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig, quarter1, quarter2) {
  var equal = isNullEqual(quarter1, quarter2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, quarter1, quarter2) && getQuarter(generateConfig, quarter1) === getQuarter(generateConfig, quarter2);
}
function isSameMonth(generateConfig, month1, month2) {
  var equal = isNullEqual(month1, month2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
}
function isSameDate(generateConfig, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(date1) === generateConfig.getYear(date2) && generateConfig.getMonth(date1) === generateConfig.getMonth(date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
}
function isSameTime(generateConfig, time1, time2) {
  var equal = isNullEqual(time1, time2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
}
function isSameWeek(generateConfig, locale, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
}
function isEqual(generateConfig, value1, value2) {
  return isSameDate(generateConfig, value1, value2) && isSameTime(generateConfig, value1, value2);
}
/** Between in date but not equal of date */

function isInRange(generateConfig, startDate, endDate, current) {
  if (!startDate || !endDate || !current) {
    return false;
  }

  return !isSameDate(generateConfig, startDate, current) && !isSameDate(generateConfig, endDate, current) && generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function getWeekStartDate(locale, generateConfig, value) {
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
  var monthStartDate = generateConfig.setDate(value, 1);
  var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);

  if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig.addDate(alignStartDate, -7);
  }

  return alignStartDate;
}
function getClosingViewDate(viewDate, picker, generateConfig) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  switch (picker) {
    case 'year':
      return generateConfig.addYear(viewDate, offset * 10);

    case 'quarter':
    case 'month':
      return generateConfig.addYear(viewDate, offset);

    default:
      return generateConfig.addMonth(viewDate, offset);
  }
}
function formatValue(value, _ref) {
  var generateConfig = _ref.generateConfig,
      locale = _ref.locale,
      format = _ref.format;
  return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function parseValue(value, _ref2) {
  var generateConfig = _ref2.generateConfig,
      locale = _ref2.locale,
      formatList = _ref2.formatList;

  if (!value || typeof formatList[0] === 'function') {
    return null;
  }

  return generateConfig.locale.parse(locale.locale, value, formatList);
} // eslint-disable-next-line consistent-return

function getCellDateDisabled(_ref3) {
  var cellDate = _ref3.cellDate,
      mode = _ref3.mode,
      disabledDate = _ref3.disabledDate,
      generateConfig = _ref3.generateConfig;
  if (!disabledDate) return false; // Whether cellDate is disabled in range

  var getDisabledFromRange = function getDisabledFromRange(currentMode, start, end) {
    var current = start;

    while (current <= end) {
      var date = void 0;

      switch (currentMode) {
        case 'date':
          {
            date = generateConfig.setDate(cellDate, current);

            if (!disabledDate(date)) {
              return false;
            }

            break;
          }

        case 'month':
          {
            date = generateConfig.setMonth(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'month',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }

        case 'year':
          {
            date = generateConfig.setYear(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'year',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }
      }

      current += 1;
    }

    return true;
  };

  switch (mode) {
    case 'date':
    case 'week':
      {
        return disabledDate(cellDate);
      }

    case 'month':
      {
        var startDate = 1;
        var endDate = generateConfig.getDate(generateConfig.getEndDate(cellDate));
        return getDisabledFromRange('date', startDate, endDate);
      }

    case 'quarter':
      {
        var startMonth = Math.floor(generateConfig.getMonth(cellDate) / 3) * 3;
        var endMonth = startMonth + 2;
        return getDisabledFromRange('month', startMonth, endMonth);
      }

    case 'year':
      {
        return getDisabledFromRange('month', 0, 11);
      }

    case 'decade':
      {
        var year = generateConfig.getYear(cellDate);
        var startYear = Math.floor(year / __WEBPACK_IMPORTED_MODULE_0__panels_DecadePanel_index__["b" /* DECADE_UNIT_DIFF */]) * __WEBPACK_IMPORTED_MODULE_0__panels_DecadePanel_index__["b" /* DECADE_UNIT_DIFF */];
        var endYear = startYear + __WEBPACK_IMPORTED_MODULE_0__panels_DecadePanel_index__["b" /* DECADE_UNIT_DIFF */] - 1;
        return getDisabledFromRange('year', startYear, endYear);
      }
  }
}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1065)();
}


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(502);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(954);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(955);
var isNativeReflectConstruct = __webpack_require__(956);
var possibleConstructorReturn = __webpack_require__(957);
function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return possibleConstructorReturn(this, result);
  };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1120);

__webpack_require__(27);

__webpack_require__(206);

__webpack_require__(116);

__webpack_require__(73);

__webpack_require__(568);

__webpack_require__(48);

__webpack_require__(569);

__webpack_require__(139);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Table = _interopRequireDefault(__webpack_require__(1130));

var _default = _Table["default"];
exports["default"] = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Checkbox = _interopRequireDefault(__webpack_require__(644));

var _Group = _interopRequireDefault(__webpack_require__(648));

var Checkbox = _Checkbox["default"];
Checkbox.Group = _Group["default"];
Checkbox.__ANT_CHECKBOX = true;
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SizeContextProvider = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var SizeContext = /*#__PURE__*/React.createContext(undefined);

var SizeContextProvider = function SizeContextProvider(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(SizeContext.Consumer, null, function (originSize) {
    return /*#__PURE__*/React.createElement(SizeContext.Provider, {
      value: size || originSize
    }, children);
  });
};

exports.SizeContextProvider = SizeContextProvider;
var _default = SizeContext;
exports["default"] = _default;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1124);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_upload_style__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_upload_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_upload_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WUpload_module_scss__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WUpload_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__WUpload_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_configs_env__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//多檔案上傳
var WUpload=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(_ref){var _ref$app=_ref.app,app=_ref$app===undefined?{}:_ref$app,_ref$user=_ref.user,user=_ref$user===undefined?{}:_ref$user,_ref$badges=_ref.badges,badges=_ref$badges===undefined?{}:_ref$badges;return{app:app,user:user,badges:badges};}),_dec(_class=function(_Component){_inherits(WUpload,_Component);function WUpload(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,WUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=WUpload.__proto__||Object.getPrototypeOf(WUpload)).call.apply(_ref2,[this].concat(args))),_this),_this.state={fileList:[//   {
//   uid: '-1',
//   name: 'xxx.png',
//   status: 'done',
//   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
// }
]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WUpload,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var fileList=nextProps.fileList;if(Array.isArray(fileList)){var currentFileList=this.state.fileList;fileList.forEach(function(file,idx){if(!file.uid&&file.id)file.uid=file.id;if(!file.uid)file.uid='uid-'+idx;});if(fileList.length!==currentFileList.length){this.setState({fileList:fileList});return true;}var needUpdate=false;fileList.forEach(function(file,idx){if(file.uid!==fileList[idx].uid){needUpdate=true;}});if(needUpdate===true){this.setState({fileList:fileList});return true;}}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,accept=_props.accept,beforeUpload=_props.beforeUpload,fileList=_props.fileList,listType=_props.listType,multiple=_props.multiple,name=_props.name,showUploadList=_props.showUploadList;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_upload___default.a,{action:__WEBPACK_IMPORTED_MODULE_10_configs_env__["b" /* API_HOST */]+'/api/v1/system/image',accept:accept,name:name,listType:listType,fileList:fileList,showUploadList:showUploadList,multiple:multiple,beforeUpload:beforeUpload,customRequest:function customRequest(options){var data=new FormData();data.append('image',options.file);var config={headers:{'Access-Token':'e48b30e97cb3e6f9138ffb385e28531c83585069c5d5f54813cc1252c8540ccb','content-type':'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'},onUploadProgress:function onUploadProgress(progressEvent){options.onProgress({percent:progressEvent.loaded/progressEvent.total*100},options.file);// Do whatever you want with the native progress event
}};options.onProgress({percent:0},options.file);__WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_10_configs_env__["b" /* API_HOST */]+'/api/v1/system/image',data,config).then(function(res){var _res$data=res.data,_res$data$code=_res$data.code,code=_res$data$code===undefined?100:_res$data$code,_res$data$reason=_res$data.reason,reason=_res$data$reason===undefined?'未知錯誤':_res$data$reason,_res$data$data=_res$data.data,data=_res$data$data===undefined?{}:_res$data$data;if(code!==200){options.onError(new Error());return;}var fileList=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this2,'state.fileList',[]);var file=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(fileList,function(item){return item.uid===options.file.uid;});if(file){file.path=data.path;file.url=data.url;}if(_this2.props.onChange){_this2.props.onChange(fileList);}_this2.setState({fileList:fileList},function(){options.onSuccess(res.data);});}).catch(function(error){var res={code:200,reason:'未知錯誤',error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.data.reason;}options.onError(error);});},onChange:function onChange(_ref3){var file=_ref3.file,fileList=_ref3.fileList,event=_ref3.event;if(_this2.props.onChange){_this2.props.onChange(fileList);}}},this.props.children));}}]);return WUpload;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);// 單張圖片上傳
var AvatarUpload=function(_Component2){_inherits(AvatarUpload,_Component2);function AvatarUpload(){_classCallCheck(this,AvatarUpload);return _possibleConstructorReturn(this,(AvatarUpload.__proto__||Object.getPrototypeOf(AvatarUpload)).apply(this,arguments));}_createClass(AvatarUpload,[{key:'render',value:function render(){var _this4=this;var fileList=this.props.value?[this.props.value]:[];return wp.element.createElement('div',{style:{minHeight:102}},wp.element.createElement(WUpload,{name:this.props.name,listType:'picture-card',className:'avatar-uploader',fileList:fileList,onChange:function onChange(fileList){if(_this4.props.onChange){_this4.props.onChange(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.last(fileList));}}},fileList.length>=1?null:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:'link'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' \u4E0A\u50B3')));}}]);return AvatarUpload;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);// 單檔上傳

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};
/* harmony default export */ __webpack_exports__["a"] = (wrapperRaf);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1109);
var iterableToArray = __webpack_require__(566);
var unsupportedIterableToArray = __webpack_require__(344);
var nonIterableSpread = __webpack_require__(1110);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1636);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcTabs = _interopRequireWildcard(__webpack_require__(1637));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _EllipsisOutlined = _interopRequireDefault(__webpack_require__(653));

var _PlusOutlined = _interopRequireDefault(__webpack_require__(1660));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tabs(_a) {
  var _classNames;

  var type = _a.type,
      className = _a.className,
      size = _a.size,
      _onEdit = _a.onEdit,
      hideAdd = _a.hideAdd,
      centered = _a.centered,
      addIcon = _a.addIcon,
      props = __rest(_a, ["type", "className", "size", "onEdit", "hideAdd", "centered", "addIcon"]);

  var customizePrefixCls = props.prefixCls;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('tabs', customizePrefixCls);
  var editable;

  if (type === 'editable-card') {
    editable = {
      onEdit: function onEdit(editType, _ref) {
        var key = _ref.key,
            event = _ref.event;
        _onEdit === null || _onEdit === void 0 ? void 0 : _onEdit(editType === 'add' ? event : key, editType);
      },
      removeIcon: /*#__PURE__*/React.createElement(_CloseOutlined["default"], null),
      addIcon: addIcon || /*#__PURE__*/React.createElement(_PlusOutlined["default"], null),
      showAdd: hideAdd !== true
    };
  }

  (0, _devWarning["default"])(!('onPrevClick' in props) && !('onNextClick' in props), 'Tabs', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.');
  return /*#__PURE__*/React.createElement(_rcTabs["default"], (0, _extends2["default"])({
    direction: direction
  }, props, {
    moreTransitionName: "slide-up",
    className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(size), size), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-card"), ['card', 'editable-card'].includes(type)), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-editable-card"), type === 'editable-card'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-centered"), centered), _classNames), className),
    editable: editable,
    moreIcon: /*#__PURE__*/React.createElement(_EllipsisOutlined["default"], null),
    prefixCls: prefixCls
  }));
}

Tabs.TabPane = _rcTabs.TabPane;
var _default = Tabs;
exports["default"] = _default;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteConfirmButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_popconfirm_style__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_popconfirm_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_popconfirm_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_popconfirm__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_popconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popconfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_DeleteOutlined__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_DeleteOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_DeleteOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteConfirmButton=function(_React$PureComponent){_inherits(DeleteConfirmButton,_React$PureComponent);function DeleteConfirmButton(){_classCallCheck(this,DeleteConfirmButton);return _possibleConstructorReturn(this,(DeleteConfirmButton.__proto__||Object.getPrototypeOf(DeleteConfirmButton)).apply(this,arguments));}_createClass(DeleteConfirmButton,[{key:'render',value:function render(){var _props=this.props,onConfirm=_props.onConfirm,_props$loading=_props.loading,loading=_props$loading===undefined?false:_props$loading;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popconfirm___default.a,{title:'\u78BA\u8A8D\u8981\u522A\u9664\u55CE\uFF1F',okText:'\u78BA\u8A8D\u522A\u9664',cancelText:'\u53D6\u6D88',okButtonProps:{type:'danger'},onConfirm:onConfirm},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'default',danger:true,size:this.props.size,loading:this.props.loading,icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_DeleteOutlined___default.a,null)},'\u522A\u9664'));}}]);return DeleteConfirmButton;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidatorErrorAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validatorjs_src_errors__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidatorErrorAlert=function(_Component){_inherits(ValidatorErrorAlert,_Component);function ValidatorErrorAlert(){_classCallCheck(this,ValidatorErrorAlert);return _possibleConstructorReturn(this,(ValidatorErrorAlert.__proto__||Object.getPrototypeOf(ValidatorErrorAlert)).apply(this,arguments));}_createClass(ValidatorErrorAlert,[{key:'render',value:function render(){var errors=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'props.errors',new __WEBPACK_IMPORTED_MODULE_5_validatorjs_src_errors___default.a());if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(errors.all()))return null;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_alert___default.a,{className:'formAlert',showIcon:true,type:'warning',message:'\u63D0\u9192',description:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(errors.all()).map(function(key){return wp.element.createElement('div',null,wp.element.createElement('a',{onClick:function onClick(){console.log('key',key);var element=document.querySelector('[name="'+key+'"]');if(!element)return;element.scrollIntoView({behavior:'smooth',block:'center'});}},errors.first(key)));})});}}]);return ValidatorErrorAlert;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(83);
var ContentStateInlineStyle = __webpack_require__(1931);
var DraftFeatureFlags = __webpack_require__(129);
var Immutable = __webpack_require__(32);

var applyEntityToContentState = __webpack_require__(1932);
var getCharacterRemovalRange = __webpack_require__(1934);
var getContentStateFragment = __webpack_require__(305);
var insertFragmentIntoContentState = __webpack_require__(1937);
var insertTextIntoContentState = __webpack_require__(1938);
var invariant = __webpack_require__(34);
var modifyBlockForContentState = __webpack_require__(1939);
var removeEntitiesAtEdges = __webpack_require__(809);
var removeRangeFromContentState = __webpack_require__(1940);
var splitBlockInContentState = __webpack_require__(1941);

var OrderedSet = Immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);

    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });

    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);

    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);

    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};

module.exports = DraftModifier;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(683);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(32),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSMotion__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CSSMotionList__ = __webpack_require__(989);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CSSMotionList", function() { return __WEBPACK_IMPORTED_MODULE_1__CSSMotionList__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__CSSMotion__["a" /* default */]);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var WJSON=function(){function WJSON(){_classCallCheck(this,WJSON);}_createClass(WJSON,[{key:'encode',value:function encode(item){return JSON.stringify(item);}},{key:'decode',value:function decode(str){try{return JSON.parse(str);}catch(err){console.error('WJSON DECODE ERROR',err);return{};}}}]);return WJSON;}();/* harmony default export */ __webpack_exports__["a"] = (new WJSON());

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var PanelContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});
/* harmony default export */ __webpack_exports__["a"] = (PanelContext);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1663);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(714);
var isBuffer = __webpack_require__(1664);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(83);
var Immutable = __webpack_require__(32);

var findRangesImmutable = __webpack_require__(228);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = wp.components;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = wp.compose;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner-catalog.c13f307f.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

exports.default = Barcode;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocaleReceiver = useLocaleReceiver;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _default = _interopRequireDefault(__webpack_require__(960));

var _context = _interopRequireDefault(__webpack_require__(505));

var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LocaleReceiver, _React$Component);

  var _super = (0, _createSuper2["default"])(LocaleReceiver);

  function LocaleReceiver() {
    (0, _classCallCheck2["default"])(this, LocaleReceiver);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || _default["default"][componentName || 'global'];
      var antLocale = this.context;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return (0, _extends2["default"])((0, _extends2["default"])({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default["default"].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context);
    }
  }]);
  return LocaleReceiver;
}(React.Component);

exports["default"] = LocaleReceiver;
LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextType = _context["default"];

function useLocaleReceiver(componentName, defaultLocale) {
  var antLocale = React.useContext(_context["default"]);
  var componentLocale = React.useMemo(function () {
    var locale = defaultLocale || _default["default"][componentName || 'global'];
    var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
    return (0, _extends2["default"])((0, _extends2["default"])({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, antLocale]);
  return [componentLocale];
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateAuthInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanAuthInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_wjson__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var UPDATE_AUTH_INFO="UPDATE_AUTH_INFO";var CLEAN_AUTH_INFO="CLEAN_AUTH_INFO";// dispatch function
var updateAuthInfo=function updateAuthInfo(newState){return{type:UPDATE_AUTH_INFO,newState:newState};};var cleanAuthInfo=function cleanAuthInfo(newState){return{type:CLEAN_AUTH_INFO,newState:newState};};var defaultAuthInfo={authorization:null,roles:[],permissions:{},isLogin:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var auth=__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].decode(localStorage.getItem('wauth'))||defaultAuthInfo;auth=Object.assign({},defaultAuthInfo,auth,state);if(action.type===UPDATE_AUTH_INFO){auth=Object.assign({},auth,action.newState);auth.isLogin=auth.authorization!==null&&typeof auth.authorization==='string'&&auth.authorization.length>0;localStorage.setItem('wauth',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(auth));return auth;}if(action.type===CLEAN_AUTH_INFO){localStorage.setItem('wauth',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(defaultAuthInfo));return defaultAuthInfo;}return Object.assign({},auth);});// 驗證測試用
function processDevPermissions(){var permissionGroup=['user','model','dataset','service','docker-image','page','review'];var actions={view:true,edit:true,delete:false,review:true};var devPermissions={};permissionGroup.forEach(function(groupKey){__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(actions).forEach(function(actionKey){devPermissions[groupKey+':'+actionKey]=actions[actionKey];});});return devPermissions;}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleObserver__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collection__ = __webpack_require__(574);






var INTERNAL_PREFIX_KEY = 'rc-observer-key';
function ResizeObserver(props, ref) {
  var children = props.children;
  var childNodes = typeof children === 'function' ? [children] : Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Children_toArray__["a" /* default */])(children);
  if (false) {
    if (childNodes.length > 1) {
      warning(false, 'Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.');
    } else if (childNodes.length === 0) {
      warning(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
    }
  }
  return childNodes.map(function (child, index) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SingleObserver__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      key: key,
      ref: index === 0 ? ref : undefined
    }), child);
  });
}
var RefResizeObserver = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](ResizeObserver);
if (false) {
  RefResizeObserver.displayName = 'ResizeObserver';
}
RefResizeObserver.Collection = __WEBPACK_IMPORTED_MODULE_5__Collection__["a" /* Collection */];
/* harmony default export */ __webpack_exports__["default"] = (RefResizeObserver);

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _SearchOutlined = _interopRequireDefault(__webpack_require__(1340));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _SearchOutlined.default
  }));
};
SearchOutlined.displayName = 'SearchOutlined';
var _default = /*#__PURE__*/React.forwardRef(SearchOutlined);
exports.default = _default;

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = waitElementReady;
/* harmony export (immutable) */ __webpack_exports__["h"] = scrollTo;
/* harmony export (immutable) */ __webpack_exports__["c"] = createKeyDownHandler;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDefaultFormat;
/* harmony export (immutable) */ __webpack_exports__["f"] = getInputSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalMouseDownEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = getTargetFromEvent;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerModeMap; });
/* harmony export (immutable) */ __webpack_exports__["d"] = elementsContains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_Dom_isVisible__ = __webpack_require__(363);




var scrollIds = new Map();
/** Trigger when element is visible in view */

function waitElementReady(element, callback) {
  var id;

  function tryOrNextFrame() {
    if (Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Dom_isVisible__["a" /* default */])(element)) {
      callback();
    } else {
      id = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */])(function () {
        tryOrNextFrame();
      });
    }
  }

  tryOrNextFrame();
  return function () {
    __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */].cancel(id);
  };
}
/* eslint-disable no-param-reassign */

function scrollTo(element, to, duration) {
  if (scrollIds.get(element)) {
    cancelAnimationFrame(scrollIds.get(element));
  } // jump to target if duration zero


  if (duration <= 0) {
    scrollIds.set(element, requestAnimationFrame(function () {
      element.scrollTop = to;
    }));
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  scrollIds.set(element, requestAnimationFrame(function () {
    element.scrollTop += perTick;

    if (element.scrollTop !== to) {
      scrollTo(element, to, duration - 10);
    }
  }));
}
function createKeyDownHandler(event, _ref) {
  var onLeftRight = _ref.onLeftRight,
      onCtrlLeftRight = _ref.onCtrlLeftRight,
      onUpDown = _ref.onUpDown,
      onPageUpDown = _ref.onPageUpDown,
      onEnter = _ref.onEnter;
  var which = event.which,
      ctrlKey = event.ctrlKey,
      metaKey = event.metaKey;

  switch (which) {
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].LEFT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(-1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].UP:
      if (onUpDown) {
        onUpDown(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].DOWN:
      if (onUpDown) {
        onUpDown(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      if (onPageUpDown) {
        onPageUpDown(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      if (onPageUpDown) {
        onPageUpDown(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].ENTER:
      if (onEnter) {
        onEnter();
        return true;
      }
      /* istanbul ignore next */


      break;
  }

  return false;
} // ===================== Format =====================

function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;

  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;

      case 'week':
        mergedFormat = 'gggg-wo';
        break;

      case 'month':
        mergedFormat = 'YYYY-MM';
        break;

      case 'quarter':
        mergedFormat = 'YYYY-[Q]Q';
        break;

      case 'year':
        mergedFormat = 'YYYY';
        break;

      default:
        mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  }

  return mergedFormat;
}
function getInputSize(picker, format, generateConfig) {
  var defaultSize = picker === 'time' ? 8 : 10;
  var length = typeof format === 'function' ? format(generateConfig.getNow()).length : format.length;
  return Math.max(defaultSize, length) + 2;
}
var globalClickFunc = null;
var clickCallbacks = new Set();
function addGlobalMouseDownEvent(callback) {
  if (!globalClickFunc && typeof window !== 'undefined' && window.addEventListener) {
    globalClickFunc = function globalClickFunc(e) {
      // Clone a new list to avoid repeat trigger events
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(clickCallbacks).forEach(function (queueFunc) {
        queueFunc(e);
      });
    };

    window.addEventListener('mousedown', globalClickFunc);
  }

  clickCallbacks.add(callback);
  return function () {
    clickCallbacks.delete(callback);

    if (clickCallbacks.size === 0) {
      window.removeEventListener('mousedown', globalClickFunc);
      globalClickFunc = null;
    }
  };
}
function getTargetFromEvent(e) {
  var target = e.target; // get target if in shadow dom

  if (e.composed && target.shadowRoot) {
    var _e$composedPath;

    return ((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e)[0]) || target;
  }

  return target;
} // ====================== Mode ======================

var getYearNextMode = function getYearNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'year';
  }

  return next;
};

var getMonthNextMode = function getMonthNextMode(next) {
  if (next === 'date') {
    return 'month';
  }

  return next;
};

var getQuarterNextMode = function getQuarterNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'quarter';
  }

  return next;
};

var getWeekNextMode = function getWeekNextMode(next) {
  if (next === 'date') {
    return 'week';
  }

  return next;
};

var PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
function elementsContains(elements, target) {
  return elements.some(function (ele) {
    return ele && ele.contains(target);
  });
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1686);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcSwitch = _interopRequireDefault(__webpack_require__(1687));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var _wave = _interopRequireDefault(__webpack_require__(387));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Switch = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      customizeSize = _a.size,
      loading = _a.loading,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      disabled = _a.disabled,
      props = __rest(_a, ["prefixCls", "size", "loading", "className", "disabled"]);

  (0, _devWarning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = React.useContext(_SizeContext["default"]);
  var prefixCls = getPrefixCls('switch', customizePrefixCls);
  var loadingIcon = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-handle")
  }, loading && /*#__PURE__*/React.createElement(_LoadingOutlined["default"], {
    className: "".concat(prefixCls, "-loading-icon")
  }));
  var classes = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-small"), (customizeSize || size) === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-loading"), loading), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  return /*#__PURE__*/React.createElement(_wave["default"], {
    insertExtraNode: true
  }, /*#__PURE__*/React.createElement(_rcSwitch["default"], (0, _extends2["default"])({}, props, {
    prefixCls: prefixCls,
    className: classes,
    disabled: disabled || loading,
    ref: ref,
    loadingIcon: loadingIcon
  })));
});
Switch.__ANT_SWITCH = true;
Switch.displayName = 'Switch';
var _default = Switch;
exports["default"] = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1703);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Skeleton = _interopRequireDefault(__webpack_require__(1704));

var _default = _Skeleton["default"];
exports["default"] = _default;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CitySelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_cascader_style__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_cascader_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_cascader_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_cascader__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CitySelect=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref){var _ref$app=_ref.app,app=_ref$app===undefined?{}:_ref$app,_ref$user=_ref.user,user=_ref$user===undefined?{}:_ref$user,_ref$badges=_ref.badges,badges=_ref$badges===undefined?{}:_ref$badges;return{app:app,user:user,badges:badges};}),_dec(_class=function(_Component){_inherits(CitySelect,_Component);function CitySelect(){_classCallCheck(this,CitySelect);return _possibleConstructorReturn(this,(CitySelect.__proto__||Object.getPrototypeOf(CitySelect)).apply(this,arguments));}_createClass(CitySelect,[{key:'render',// triggerChange = changedValue => {
//   if (onChange) {
//     onChange({
//       number,
//       currency,
//       ...value,
//       ...changedValue,
//     });
//   }
// };
value:function render(){var _this2=this;var cityOptions=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'props.app.options.citys',[]);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_cascader___default.a,{expandTrigger:'hover',placeholder:this.props.placeholder,style:this.props.style,value:this.props.value?[__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'props.value.city_id'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'props.value.area_id')]:undefined,options:cityOptions,fieldNames:{label:'name',value:'id',children:'children'},displayRender:function displayRender(labels,selectedOptions){var result=[];labels.forEach(function(label,i){var option=selectedOptions[i];if(i===labels.length-1){result.splice(0,0,wp.element.createElement('span',{className:'text-blue'},' ',option.zip,' '));result.push(wp.element.createElement('span',{key:option.value},label));return;}result.push(wp.element.createElement('span',{key:option.value},label,' / '));});return result;}// onChange={this.props.onChange}
,onChange:function onChange(value,selectedOptions){if(_this2.props.onChange){_this2.props.onChange(Object.assign({},_this2.props.value,{city_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(value,'0'),area_id:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(value,'1')}));}}}));}}]);return CitySelect;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.call = call;
exports.default = void 0;
exports.note = note;
exports.noteOnce = noteOnce;
exports.resetWarned = resetWarned;
exports.warning = warning;
exports.warningOnce = warningOnce;
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}
function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
var _default = warningOnce;
/* eslint-enable */
exports.default = _default;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TableContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var TableContext = /*#__PURE__*/React.createContext(null);
var _default = TableContext;
exports.default = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(597);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _group["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _radioButton["default"];
  }
});
exports["default"] = void 0;

var _radio = _interopRequireDefault(__webpack_require__(392));

var _group = _interopRequireDefault(__webpack_require__(1446));

var _radioButton = _interopRequireDefault(__webpack_require__(1447));

var Radio = _radio["default"];
Radio.Button = _radioButton["default"];
Radio.Group = _group["default"];
var _default = Radio;
exports["default"] = _default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1539);

__webpack_require__(399);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Group", {
  enumerable: true,
  get: function get() {
    return _group["default"];
  }
});
exports["default"] = void 0;

var _avatar = _interopRequireDefault(__webpack_require__(674));

var _group = _interopRequireDefault(__webpack_require__(1541));

var Avatar = _avatar["default"];
Avatar.Group = _group["default"];
var _default = Avatar;
exports["default"] = _default;

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1573);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var UserAgentData = __webpack_require__(1952);
var VersionRange = __webpack_require__(1954);

var mapObject = __webpack_require__(1955);
var memoizeStringOnly = __webpack_require__(1956);

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};

module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(1024));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CloseCircleFilled;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1123);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeRef = composeRef;
exports.fillRef = fillRef;
exports.supportRef = supportRef;
exports.useComposeRef = useComposeRef;
var _typeof2 = _interopRequireDefault(__webpack_require__(586));
var _reactIs = __webpack_require__(248);
var _useMemo = _interopRequireDefault(__webpack_require__(587));
/* eslint-disable no-param-reassign */

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0, _typeof2.default)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}

/**
 * Merge refs into one ref function to support ref passing.
 */
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function (ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return (0, _useMemo.default)(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length === next.length && prev.every(function (ref, i) {
      return ref === next[i];
    });
  });
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}
/* eslint-enable */

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tupleNum = exports.tuple = void 0;

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

exports.tuple = tuple;

var tupleNum = function tupleNum() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args;
};

exports.tupleNum = tupleNum;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcTooltip = _interopRequireDefault(__webpack_require__(660));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _placements = _interopRequireDefault(__webpack_require__(1444));

var _reactNode = __webpack_require__(57);

var _configProvider = __webpack_require__(8);

var _colors = __webpack_require__(661);

var splitObject = function splitObject(obj, keys) {
  var picked = {};
  var omitted = (0, _extends2["default"])({}, obj);
  keys.forEach(function (key) {
    if (obj && key in obj) {
      picked[key] = obj[key];
      delete omitted[key];
    }
  });
  return {
    picked: picked,
    omitted: omitted
  };
};

var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$")); // Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18

function getDisabledCompatibleChildren(element, prefixCls) {
  var elementType = element.type;

  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
    // Pick some layout related style properties up to span
    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
        picked = _splitObject.picked,
        omitted = _splitObject.omitted;

    var spanStyle = (0, _extends2["default"])((0, _extends2["default"])({
      display: 'inline-block'
    }, picked), {
      cursor: 'not-allowed',
      width: element.props.block ? '100%' : null
    });
    var buttonStyle = (0, _extends2["default"])((0, _extends2["default"])({}, omitted), {
      pointerEvents: 'none'
    });
    var child = (0, _reactNode.cloneElement)(element, {
      style: buttonStyle,
      className: null
    });
    return /*#__PURE__*/React.createElement("span", {
      style: spanStyle,
      className: (0, _classnames["default"])(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
    }, child);
  }

  return element;
}

var Tooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames2;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = React.useState(!!props.visible || !!props.defaultVisible),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  React.useEffect(function () {
    if ('visible' in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);

  var isNoTitle = function isNoTitle() {
    var title = props.title,
        overlay = props.overlay;
    return !title && !overlay && title !== 0; // overlay for old version compatibility
  };

  var onVisibleChange = function onVisibleChange(vis) {
    if (!('visible' in props)) {
      setVisible(isNoTitle() ? false : vis);
    }

    if (props.onVisibleChange && !isNoTitle()) {
      props.onVisibleChange(vis);
    }
  };

  var getTooltipPlacements = function getTooltipPlacements() {
    var builtinPlacements = props.builtinPlacements,
        arrowPointAtCenter = props.arrowPointAtCenter,
        autoAdjustOverflow = props.autoAdjustOverflow;
    return builtinPlacements || (0, _placements["default"])({
      arrowPointAtCenter: arrowPointAtCenter,
      autoAdjustOverflow: autoAdjustOverflow
    });
  }; // 动态设置动画点


  var onPopupAlign = function onPopupAlign(domNode, align) {
    var placements = getTooltipPlacements(); // 当前返回的位置

    var placement = Object.keys(placements).filter(function (key) {
      return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
    })[0];

    if (!placement) {
      return;
    } // 根据当前坐标设置动画点


    var rect = domNode.getBoundingClientRect();
    var transformOrigin = {
      top: '50%',
      left: '50%'
    };

    if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
      transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
    } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
      transformOrigin.top = "".concat(-align.offset[1], "px");
    }

    if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
      transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
    } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
      transformOrigin.left = "".concat(-align.offset[0], "px");
    }

    domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
  };

  var getOverlay = function getOverlay() {
    var title = props.title,
        overlay = props.overlay;

    if (title === 0) {
      return title;
    }

    return overlay || title || '';
  };

  var customizePrefixCls = props.prefixCls,
      openClassName = props.openClassName,
      getPopupContainer = props.getPopupContainer,
      getTooltipContainer = props.getTooltipContainer,
      overlayClassName = props.overlayClassName,
      color = props.color,
      overlayInnerStyle = props.overlayInnerStyle,
      children = props.children;
  var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  var tempVisible = visible; // Hide tooltip when there is no title

  if (!('visible' in props) && isNoTitle()) {
    tempVisible = false;
  }

  var child = getDisabledCompatibleChildren((0, _reactNode.isValidElement)(children) ? children : /*#__PURE__*/React.createElement("span", null, children), prefixCls);
  var childProps = child.props;
  var childCls = (0, _classnames["default"])(childProps.className, (0, _defineProperty2["default"])({}, openClassName || "".concat(prefixCls, "-open"), true));
  var customOverlayClassName = (0, _classnames["default"])(overlayClassName, (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-").concat(color), color && PresetColorRegex.test(color)), _classNames2));
  var formattedOverlayInnerStyle = overlayInnerStyle;
  var arrowContentStyle;

  if (color && !PresetColorRegex.test(color)) {
    formattedOverlayInnerStyle = (0, _extends2["default"])((0, _extends2["default"])({}, overlayInnerStyle), {
      background: color
    });
    arrowContentStyle = {
      background: color
    };
  }

  return /*#__PURE__*/React.createElement(_rcTooltip["default"], (0, _extends2["default"])({}, props, {
    prefixCls: prefixCls,
    overlayClassName: customOverlayClassName,
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref: ref,
    builtinPlacements: getTooltipPlacements(),
    overlay: getOverlay(),
    visible: tempVisible,
    onVisibleChange: onVisibleChange,
    onPopupAlign: onPopupAlign,
    overlayInnerStyle: formattedOverlayInnerStyle,
    arrowContent: /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-arrow-content"),
      style: arrowContentStyle
    })
  }), tempVisible ? (0, _reactNode.cloneElement)(child, {
    className: childCls
  }) : child);
});
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big-fast',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  arrowPointAtCenter: false,
  autoAdjustOverflow: true
};
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _FormOutlined = _interopRequireDefault(__webpack_require__(1538));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var FormOutlined = function FormOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _FormOutlined.default
  }));
};
FormOutlined.displayName = 'FormOutlined';
var _default = /*#__PURE__*/React.forwardRef(FormOutlined);
exports.default = _default;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fillRef;
/* harmony export (immutable) */ __webpack_exports__["a"] = composeRef;
/* unused harmony export useComposeRef */
/* harmony export (immutable) */ __webpack_exports__["c"] = supportRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks_useMemo__ = __webpack_require__(254);

/* eslint-disable no-param-reassign */



function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}

/**
 * Merge refs into one ref function to support ref passing.
 */
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function (ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__hooks_useMemo__["a" /* default */])(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length === next.length && prev.every(function (ref, i) {
      return ref === next[i];
    });
  });
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type = Object(__WEBPACK_IMPORTED_MODULE_1_react_is__["isMemo"])(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}
/* eslint-enable */

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CloseOutlined = _interopRequireDefault(__webpack_require__(1054));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CloseOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1550);

__webpack_require__(1551);

__webpack_require__(27);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(__webpack_require__(1553));

var _generatePicker = _interopRequireDefault(__webpack_require__(400));

var DatePicker = (0, _generatePicker["default"])(_moment["default"]);
var _default = DatePicker;
exports["default"] = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItemPrefixContext = exports.FormProvider = exports.FormItemContext = exports.FormContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _rcFieldForm = __webpack_require__(157);

var FormContext = /*#__PURE__*/React.createContext({
  labelAlign: 'right',
  vertical: false,
  itemRef: function itemRef() {}
});
exports.FormContext = FormContext;
var FormItemContext = /*#__PURE__*/React.createContext({
  updateItemErrors: function updateItemErrors() {}
});
exports.FormItemContext = FormItemContext;

var FormProvider = function FormProvider(props) {
  var providerProps = (0, _omit["default"])(props, ['prefixCls']);
  return /*#__PURE__*/React.createElement(_rcFieldForm.FormProvider, providerProps);
};

exports.FormProvider = FormProvider;
var FormItemPrefixContext = /*#__PURE__*/React.createContext({
  prefixCls: ''
});
exports.FormItemPrefixContext = FormItemPrefixContext;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _google_map = __webpack_require__(1881);

var _google_map2 = _interopRequireDefault(_google_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _google_map2.default;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(1930);

module.exports = DraftFeatureFlags;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___262fA","container_1":"container_1___3wMce","container_2":"container_2___2T8pV","hour-24-tag":"hour-24-tag___25vWi"};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(133);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(878);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(247);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);


function toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1_react_is__["isFragment"])(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(503));

var _en_US2 = _interopRequireDefault(__webpack_require__(250));

var _en_US3 = _interopRequireDefault(__webpack_require__(504));

var _en_US4 = _interopRequireDefault(__webpack_require__(959));

/* eslint-disable no-template-curly-in-string */
var typeTemplate = '${label} is not a valid ${type}';
var localeValues = {
  locale: 'en',
  Pagination: _en_US["default"],
  DatePicker: _en_US2["default"],
  TimePicker: _en_US3["default"],
  Calendar: _en_US4["default"],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'No filters',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    selectNone: 'Clear all data',
    selectionAll: 'Select all data',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    triggerDesc: 'Click to sort descending',
    triggerAsc: 'Click to sort ascending',
    cancelSort: 'Click to cancel sorting'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Remove',
    selectCurrent: 'Select current page',
    removeCurrent: 'Remove current page',
    selectAll: 'Select all data',
    removeAll: 'Remove all data',
    selectInvert: 'Invert current page'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No Data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  PageHeader: {
    back: 'Back'
  },
  Form: {
    optional: '(optional)',
    defaultValidateMessages: {
      "default": 'Field validation error for ${label}',
      required: 'Please enter ${label}',
      "enum": '${label} must be one of [${enum}]',
      whitespace: '${label} cannot be a blank character',
      date: {
        format: '${label} date format is invalid',
        parse: '${label} cannot be converted to a date',
        invalid: '${label} is an invalid date'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        "boolean": typeTemplate,
        integer: typeTemplate,
        "float": typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} must be ${len} characters',
        min: '${label} must be at least ${min} characters',
        max: '${label} must be up to ${max} characters',
        range: '${label} must be between ${min}-${max} characters'
      },
      number: {
        len: '${label} must be equal to ${len}',
        min: '${label} must be minimum ${min}',
        max: '${label} must be maximum ${max}',
        range: '${label} must be between ${min}-${max}'
      },
      array: {
        len: 'Must be ${len} ${label}',
        min: 'At least ${min} ${label}',
        max: 'At most ${max} ${label}',
        range: 'The amount of ${label} must be between ${min}-${max}'
      },
      pattern: {
        mismatch: '${label} does not match the pattern ${pattern}'
      }
    }
  },
  Image: {
    preview: 'Preview'
  }
};
var _default = localeValues;
exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(1089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(1092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(205);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1129);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1132);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(140);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(1172);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(143);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;
var _react = _interopRequireDefault(__webpack_require__(0));
var _reactIs = __webpack_require__(248);
function toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  _react.default.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0, _reactIs.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(82);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = leftPad;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tuple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDataOrAriaProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = getValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateValues;
function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  var current = String(str);

  while (current.length < length) {
    current = "".concat(fill).concat(str);
  }

  return current;
}
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
function toArray(val) {
  if (val === null || val === undefined) {
    return [];
  }

  return Array.isArray(val) ? val : [val];
}
function getDataOrAriaProps(props) {
  var retProps = {};
  Object.keys(props).forEach(function (key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role' || key === 'name') && key.substr(0, 7) !== 'data-__') {
      retProps[key] = props[key];
    }
  });
  return retProps;
}
function getValue(values, index) {
  return values ? values[index] : null;
}
function updateValues(values, value, index) {
  var newValues = [getValue(values, 0), getValue(values, 1)];
  newValues[index] = typeof value === 'function' ? value(newValues[index]) : value;

  if (!newValues[0] && !newValues[1]) {
    return null;
  }

  return newValues;
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1643);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _UploadOutlined = _interopRequireDefault(__webpack_require__(1738));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _UploadOutlined.default
  }));
};
UploadOutlined.displayName = 'UploadOutlined';
var _default = /*#__PURE__*/React.forwardRef(UploadOutlined);
exports.default = _default;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1740);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        plain = props.plain,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed", "plain"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var hasChildren = !!children;
    var classString = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-with-text"), hasChildren), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), hasChildren), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-plain"), !!plain), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      className: classString
    }, restProps, {
      role: "separator"
    }), children && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

var _default = Divider;
exports["default"] = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.INIT_COORDS = 'dnd-core/INIT_COORDS';
exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
exports.HOVER = 'dnd-core/HOVER';
exports.DROP = 'dnd-core/DROP';
exports.END_DRAG = 'dnd-core/END_DRAG';


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isFunction(input) {
    return typeof input === 'function';
}
exports.isFunction = isFunction;
function noop() {
    // noop
}
exports.noop = noop;
function isObjectLike(input) {
    return typeof input === 'object' && input !== null;
}
function isPlainObject(input) {
    if (!isObjectLike(input)) {
        return false;
    }
    if (Object.getPrototypeOf(input) === null) {
        return true;
    }
    var proto = input;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(input) === proto;
}
exports.isPlainObject = isPlainObject;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(83);
var Immutable = __webpack_require__(32);

var findRangesImmutable = __webpack_require__(228);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};

var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck(this, ContentBlock);

    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */



var invariant = __webpack_require__(34);

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

module.exports = UnicodeUtils;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___2qOFL","container_1":"container_1___3WshT","container_2":"container_2___3UW3k","credit-card-input-outer":"credit-card-input-outer___3pfuc","credit-card-input-inner":"credit-card-input-inner___1E4Ep","credit-card-input":"credit-card-input___NHQWx","submit-btn":"submit-btn___2S35Y","container":"container___1adIm"};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Field__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useForm__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormContext__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return __WEBPACK_IMPORTED_MODULE_1__Field__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_2__List__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useForm", function() { return __WEBPACK_IMPORTED_MODULE_3__useForm__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormProvider", function() { return __WEBPACK_IMPORTED_MODULE_5__FormContext__["a"]; });






var InternalForm = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */]);
var RefForm = InternalForm;
RefForm.FormProvider = __WEBPACK_IMPORTED_MODULE_5__FormContext__["a" /* FormProvider */];
RefForm.Field = __WEBPACK_IMPORTED_MODULE_1__Field__["a" /* default */];
RefForm.List = __WEBPACK_IMPORTED_MODULE_2__List__["a" /* default */];
RefForm.useForm = __WEBPACK_IMPORTED_MODULE_3__useForm__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (RefForm);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getNamePath;
/* harmony export (immutable) */ __webpack_exports__["e"] = getValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneByNamePathList;
/* harmony export (immutable) */ __webpack_exports__["b"] = containsNamePath;
/* harmony export (immutable) */ __webpack_exports__["j"] = setValues;
/* harmony export (immutable) */ __webpack_exports__["g"] = matchNamePath;
/* harmony export (immutable) */ __webpack_exports__["f"] = isSimilar;
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultGetValueFromEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = move;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_utils_get__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_utils_set__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typeUtil__ = __webpack_require__(489);






/**
 * Convert name to internal supported format.
 * This function should keep since we still thinking if need support like `a.b.c` format.
 * 'a' => ['a']
 * 123 => [123]
 * ['a', 123] => ['a', 123]
 */

function getNamePath(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__typeUtil__["a" /* toArray */])(path);
}
function getValue(store, namePath) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_utils_get__["a" /* default */])(store, namePath);
  return value;
}
function setValue(store, namePath, value) {
  var newStore = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_utils_set__["a" /* default */])(store, namePath, value);
  return newStore;
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function (namePath) {
    var value = getValue(store, namePath);
    newStore = setValue(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  return namePathList && namePathList.some(function (path) {
    return matchNamePath(path, namePath);
  });
}

function isObject(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
/**
 * Copy values into store and return a new values object
 * ({ a: 1, b: { c: 2 } }, { a: 4, b: { d: 5 } }) => { a: 4, b: { c: 2, d: 5 } }
 */


function internalSetValues(store, values) {
  var newStore = Array.isArray(store) ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(store) : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store);

  if (!values) {
    return newStore;
  }

  Object.keys(values).forEach(function (key) {
    var prevValue = newStore[key];
    var value = values[key]; // If both are object (but target is not array), we use recursion to set deep value

    var recursive = isObject(prevValue) && isObject(value);
    newStore[key] = recursive ? internalSetValues(prevValue, value || {}) : value;
  });
  return newStore;
}

function setValues(store) {
  for (var _len = arguments.length, restValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restValues[_key - 1] = arguments[_key];
  }

  return restValues.reduce(function (current, newStore) {
    return internalSetValues(current, newStore);
  }, store);
}
function matchNamePath(namePath, changedNamePath) {
  if (!namePath || !changedNamePath || namePath.length !== changedNamePath.length) {
    return false;
  }

  return namePath.every(function (nameUnit, i) {
    return changedNamePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }

  if (!source && target || source && !target) {
    return false;
  }

  if (!source || !target || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(source) !== 'object' || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(target) !== 'object') {
    return false;
  }

  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys = new Set([].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(sourceKeys), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(targetKeys)));
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(keys).every(function (key) {
    var sourceValue = source[key];
    var targetValue = target[key];

    if (typeof sourceValue === 'function' && typeof targetValue === 'function') {
      return true;
    }

    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? undefined : arguments[1];

  if (event && event.target && valuePropName in event.target) {
    return event.target[valuePropName];
  }

  return event;
}
/**
 * Moves an array item from one position in an array to another.
 *
 * Note: This is a pure function so a new array will be returned, instead
 * of altering the array argument.
 *
 * @param array         Array in which to move an item.         (required)
 * @param moveIndex     The index of the item to move.          (required)
 * @param toIndex       The index to move item at moveIndex to. (required)
 */

function move(array, moveIndex, toIndex) {
  var length = array.length;

  if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) {
    return array;
  }

  var item = array[moveIndex];
  var diff = moveIndex - toIndex;

  if (diff > 0) {
    // move left
    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(0, toIndex)), [item], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(toIndex, moveIndex)), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(moveIndex + 1, length)));
  }

  if (diff < 0) {
    // move right
    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(0, moveIndex)), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(moveIndex + 1, toIndex + 1)), [item], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(array.slice(toIndex + 1, length)));
  }

  return array;
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canUseDom;
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _LoadingOutlined = _interopRequireDefault(__webpack_require__(1003));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _LoadingOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TinyColor; });
/* harmony export (immutable) */ __webpack_exports__["b"] = tinycolor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversion__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_color_names__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_input__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(256);




var TinyColor = /** @class */ (function () {
    function TinyColor(color, opts) {
        if (color === void 0) { color = ''; }
        if (opts === void 0) { opts = {}; }
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) {
            // eslint-disable-next-line no-constructor-return
            return color;
        }
        if (typeof color === 'number') {
            color = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["d" /* numberInputToObject */])(color);
        }
        this.originalInput = color;
        var rgb = Object(__WEBPACK_IMPORTED_MODULE_2__format_input__["a" /* inputToRGB */])(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) {
            this.r = Math.round(this.r);
        }
        if (this.g < 1) {
            this.g = Math.round(this.g);
        }
        if (this.b < 1) {
            this.b = Math.round(this.b);
        }
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function () {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function () {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */
    TinyColor.prototype.getBrightness = function () {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */
    TinyColor.prototype.getLuminance = function () {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) {
            R = RsRGB / 12.92;
        }
        else {
            // eslint-disable-next-line prefer-exponentiation-operator
            R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        }
        if (GsRGB <= 0.03928) {
            G = GsRGB / 12.92;
        }
        else {
            // eslint-disable-next-line prefer-exponentiation-operator
            G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        }
        if (BsRGB <= 0.03928) {
            B = BsRGB / 12.92;
        }
        else {
            // eslint-disable-next-line prefer-exponentiation-operator
            B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */
    TinyColor.prototype.getAlpha = function () {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */
    TinyColor.prototype.setAlpha = function (alpha) {
        this.a = Object(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* boundAlpha */])(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */
    TinyColor.prototype.isMonochrome = function () {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */
    TinyColor.prototype.toHsv = function () {
        var hsv = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["h" /* rgbToHsv */])(this.r, this.g, this.b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */
    TinyColor.prototype.toHsvString = function () {
        var hsv = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["h" /* rgbToHsv */])(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */
    TinyColor.prototype.toHsl = function () {
        var hsl = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["g" /* rgbToHsl */])(this.r, this.g, this.b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */
    TinyColor.prototype.toHslString = function () {
        var hsl = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["g" /* rgbToHsl */])(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */
    TinyColor.prototype.toHex = function (allow3Char) {
        if (allow3Char === void 0) { allow3Char = false; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["f" /* rgbToHex */])(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # appened.
     * @param allow3Char will shorten hex value to 3 char if possible
     */
    TinyColor.prototype.toHexString = function (allow3Char) {
        if (allow3Char === void 0) { allow3Char = false; }
        return '#' + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */
    TinyColor.prototype.toHex8 = function (allow4Char) {
        if (allow4Char === void 0) { allow4Char = false; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["k" /* rgbaToHex */])(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # appened.
     * @param allow4Char will shorten hex value to 4 char if possible
     */
    TinyColor.prototype.toHex8String = function (allow4Char) {
        if (allow4Char === void 0) { allow4Char = false; }
        return '#' + this.toHex8(allow4Char);
    };
    /**
     * Returns the object as a RGBA object.
     */
    TinyColor.prototype.toRgb = function () {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a,
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */
    TinyColor.prototype.toRgbString = function () {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */
    TinyColor.prototype.toPercentageRgb = function () {
        var fmt = function (x) { return "".concat(Math.round(Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* bound01 */])(x, 255) * 100), "%"); };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a,
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */
    TinyColor.prototype.toPercentageRgbString = function () {
        var rnd = function (x) { return Math.round(Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* bound01 */])(x, 255) * 100); };
        return this.a === 1
            ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)")
            : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */
    TinyColor.prototype.toName = function () {
        if (this.a === 0) {
            return 'transparent';
        }
        if (this.a < 1) {
            return false;
        }
        var hex = '#' + Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["f" /* rgbToHex */])(this.r, this.g, this.b, false);
        for (var _i = 0, _a = Object.entries(__WEBPACK_IMPORTED_MODULE_1__css_color_names__["a" /* names */]); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) {
                return key;
            }
        }
        return false;
    };
    TinyColor.prototype.toString = function (format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith('hex') || format === 'name');
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === 'name' && this.a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === 'rgb') {
            formattedString = this.toRgbString();
        }
        if (format === 'prgb') {
            formattedString = this.toPercentageRgbString();
        }
        if (format === 'hex' || format === 'hex6') {
            formattedString = this.toHexString();
        }
        if (format === 'hex3') {
            formattedString = this.toHexString(true);
        }
        if (format === 'hex4') {
            formattedString = this.toHex8String(true);
        }
        if (format === 'hex8') {
            formattedString = this.toHex8String();
        }
        if (format === 'name') {
            formattedString = this.toName();
        }
        if (format === 'hsl') {
            formattedString = this.toHslString();
        }
        if (format === 'hsv') {
            formattedString = this.toHsvString();
        }
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function () {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function () {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.lighten = function (amount) {
        if (amount === void 0) { amount = 10; }
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* clamp01 */])(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.brighten = function (amount) {
        if (amount === void 0) { amount = 10; }
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.darken = function (amount) {
        if (amount === void 0) { amount = 10; }
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* clamp01 */])(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.tint = function (amount) {
        if (amount === void 0) { amount = 10; }
        return this.mix('white', amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.shade = function (amount) {
        if (amount === void 0) { amount = 10; }
        return this.mix('black', amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.desaturate = function (amount) {
        if (amount === void 0) { amount = 10; }
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* clamp01 */])(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */
    TinyColor.prototype.saturate = function (amount) {
        if (amount === void 0) { amount = 10; }
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* clamp01 */])(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */
    TinyColor.prototype.greyscale = function () {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */
    TinyColor.prototype.spin = function (amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */
    TinyColor.prototype.mix = function (color, amount) {
        if (amount === void 0) { amount = 50; }
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a,
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function (results, slices) {
        if (results === void 0) { results = 6; }
        if (slices === void 0) { slices = 30; }
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [this];
        for (hsl.h = (hsl.h - ((part * results) >> 1) + 720) % 360; --results;) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */
    TinyColor.prototype.complement = function () {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function (results) {
        if (results === void 0) { results = 6; }
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while (results--) {
            res.push(new TinyColor({ h: h, s: s, v: v }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function () {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
            new TinyColor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l }),
        ];
    };
    /**
     * Compute how the color would appear on a background
     */
    TinyColor.prototype.onBackground = function (background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        return new TinyColor({
            r: bg.r + (fg.r - bg.r) * fg.a,
            g: bg.g + (fg.g - bg.g) * fg.a,
            b: bg.b + (fg.b - bg.b) * fg.a,
        });
    };
    /**
     * Alias for `polyad(3)`
     */
    TinyColor.prototype.triad = function () {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */
    TinyColor.prototype.tetrad = function () {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */
    TinyColor.prototype.polyad = function (n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [this];
        var increment = 360 / n;
        for (var i = 1; i < n; i++) {
            result.push(new TinyColor({ h: (h + i * increment) % 360, s: hsl.s, l: hsl.l }));
        }
        return result;
    };
    /**
     * compare color vs current color
     */
    TinyColor.prototype.equals = function (color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}());

// kept for backwards compatability with v1
function tinycolor(color, opts) {
    if (color === void 0) { color = ''; }
    if (opts === void 0) { opts = {}; }
    return new TinyColor(color, opts);
}


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(605);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(608);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useLayoutUpdateEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dom_canUseDom__ = __webpack_require__(161);



/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useLayoutEffect = "production" !== 'test' && Object(__WEBPACK_IMPORTED_MODULE_1__Dom_canUseDom__["a" /* default */])() ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/* harmony default export */ __webpack_exports__["a"] = (useLayoutEffect);
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  var firstMountRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](true);
  useLayoutEffect(function () {
    if (!firstMountRef.current) {
      return callback();
    }
  }, deps);

  // We tell react that first mount has passed
  useLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(168);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMergedState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useEvent__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useLayoutEffect__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useState__ = __webpack_require__(204);




/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3__useState__["a" /* default */])(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = Object(__WEBPACK_IMPORTED_MODULE_1__useEvent__["a" /* default */])(onChange);
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3__useState__["a" /* default */])([mergedValue]),
    _useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  Object(__WEBPACK_IMPORTED_MODULE_2__useLayoutEffect__["b" /* useLayoutUpdateEffect */])(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  Object(__WEBPACK_IMPORTED_MODULE_2__useLayoutEffect__["b" /* useLayoutUpdateEffect */])(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = Object(__WEBPACK_IMPORTED_MODULE_1__useEvent__["a" /* default */])(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_contains__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_findDOMNode__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rc_util_es_Dom_addEventListener__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rc_util_es_Portal__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_alignUtil__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Popup__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__context__ = __webpack_require__(1328);





















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }

  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

/**
 * Internal usage. Do not use in your code since this will be removed.
 */
function generateTrigger(PortalComponent) {
  var Trigger = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Trigger, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Trigger);

    // ensure `getContainer` will be called only once
    function Trigger(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Trigger);

      _this = _super.call(this, props);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "popupRef", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createRef"]());

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "triggerRef", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createRef"]());

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "portalContainer", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "attachId", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "clickOutsideHandler", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "touchOutsideHandler", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "contextMenuOutsideHandler1", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "contextMenuOutsideHandler2", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "mouseDownTimeout", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "focusTime", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "preClickTime", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "preTouchTime", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "delayTimer", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "hasPopupMouseDown", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onMouseEnter", function (e) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;

        _this.fireEvents('onMouseEnter', e);

        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onMouseMove", function (e) {
        _this.fireEvents('onMouseMove', e);

        _this.setPoint(e);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onMouseLeave", function (e) {
        _this.fireEvents('onMouseLeave', e);

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onPopupMouseEnter", function () {
        _this.clearDelayTimer();
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onPopupMouseLeave", function (e) {
        var _this$popupRef$curren;

        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_contains__["a" /* default */])((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) {
          return;
        }

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onFocus", function (e) {
        _this.fireEvents('onFocus', e); // incase focusin and focusout


        _this.clearDelayTimer();

        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();

          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onMouseDown", function (e) {
        _this.fireEvents('onMouseDown', e);

        _this.preClickTime = Date.now();
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onTouchStart", function (e) {
        _this.fireEvents('onTouchStart', e);

        _this.preTouchTime = Date.now();
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onBlur", function (e) {
        _this.fireEvents('onBlur', e);

        _this.clearDelayTimer();

        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onContextMenu", function (e) {
        e.preventDefault();

        _this.fireEvents('onContextMenu', e);

        _this.setPopupVisible(true, e);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onContextMenuClose", function () {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onClick", function (event) {
        _this.fireEvents('onClick', event); // focus will trigger click


        if (_this.focusTime) {
          var preTime;

          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }

          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }

          _this.focusTime = 0;
        }

        _this.preClickTime = 0;
        _this.preTouchTime = 0; // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291

        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }

        var nextVisible = !_this.state.popupVisible;

        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onPopupMouseDown", function () {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function () {
          _this.hasPopupMouseDown = false;
        }, 0);

        if (_this.context) {
          var _this$context;

          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "onDocumentClick", function (event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }

        var target = event.target;

        var root = _this.getRootDomNode();

        var popupNode = _this.getPopupDomNode();

        if ( // mousedown on the target should also close popup when action is contextMenu.
        // https://github.com/ant-design/ant-design/issues/29853
        (!Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_contains__["a" /* default */])(root, target) || _this.isContextMenuOnly()) && !Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target) && !_this.hasPopupMouseDown) {
          _this.close();
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getRootDomNode", function () {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }

        try {
          var domNode = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_findDOMNode__["a" /* default */])(_this.triggerRef.current);

          if (domNode) {
            return domNode;
          }
        } catch (err) {// Do nothing
        }

        return __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getPopupClassNameFromAlign", function (align) {
        var className = [];
        var _this$props = _this.props,
            popupPlacement = _this$props.popupPlacement,
            builtinPlacements = _this$props.builtinPlacements,
            prefixCls = _this$props.prefixCls,
            alignPoint = _this$props.alignPoint,
            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

        if (popupPlacement && builtinPlacements) {
          className.push(Object(__WEBPACK_IMPORTED_MODULE_17__utils_alignUtil__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
        }

        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }

        return className.join(' ');
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getComponent", function () {
        var _this$props2 = _this.props,
            prefixCls = _this$props2.prefixCls,
            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
            popupClassName = _this$props2.popupClassName,
            onPopupAlign = _this$props2.onPopupAlign,
            popupMotion = _this$props2.popupMotion,
            popupAnimation = _this$props2.popupAnimation,
            popupTransitionName = _this$props2.popupTransitionName,
            popupStyle = _this$props2.popupStyle,
            mask = _this$props2.mask,
            maskAnimation = _this$props2.maskAnimation,
            maskTransitionName = _this$props2.maskTransitionName,
            maskMotion = _this$props2.maskMotion,
            zIndex = _this$props2.zIndex,
            popup = _this$props2.popup,
            stretch = _this$props2.stretch,
            alignPoint = _this$props2.alignPoint,
            mobile = _this$props2.mobile,
            forceRender = _this$props2.forceRender,
            onPopupClick = _this$props2.onPopupClick;
        var _this$state = _this.state,
            popupVisible = _this$state.popupVisible,
            point = _this$state.point;

        var align = _this.getPopupAlign();

        var mouseProps = {};

        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }

        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }

        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Popup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          prefixCls: prefixCls,
          destroyPopupOnHide: destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint && point,
          className: popupClassName,
          align: align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch: stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask: mask,
          zIndex: zIndex,
          transitionName: popupTransitionName,
          maskAnimation: maskAnimation,
          maskTransitionName: maskTransitionName,
          maskMotion: maskMotion,
          ref: _this.popupRef,
          motion: popupMotion,
          mobile: mobile,
          forceRender: forceRender,
          onClick: onPopupClick
        }), typeof popup === 'function' ? popup() : popup);
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "attachParent", function (popupContainer) {
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_raf__["a" /* default */].cancel(_this.attachId);
        var _this$props3 = _this.props,
            getPopupContainer = _this$props3.getPopupContainer,
            getDocument = _this$props3.getDocument;

        var domNode = _this.getRootDomNode();

        var mountNode;

        if (!getPopupContainer) {
          mountNode = getDocument(_this.getRootDomNode()).body;
        } else if (domNode || getPopupContainer.length === 0) {
          // Compatible for legacy getPopupContainer with domNode argument.
          // If no need `domNode` argument, will call directly.
          // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
          mountNode = getPopupContainer(domNode);
        }

        if (mountNode) {
          mountNode.appendChild(popupContainer);
        } else {
          // Retry after frame render in case parent not ready
          _this.attachId = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_raf__["a" /* default */])(function () {
            _this.attachParent(popupContainer);
          });
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getContainer", function () {
        if (!_this.portalContainer) {
          // In React.StrictMode component will call render multiple time in first mount.
          // When you want to refactor with FC, useRef will also init multiple time and
          // point to different useRef instance which will create multiple element
          // (This multiple render will not trigger effect so you can not clean up this
          // in effect). But this is safe with class component since it always point to same class instance.
          var getDocument = _this.props.getDocument;
          var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
          // https://github.com/react-component/trigger/issues/41

          popupContainer.style.position = 'absolute';
          popupContainer.style.top = '0';
          popupContainer.style.left = '0';
          popupContainer.style.width = '100%';
          _this.portalContainer = popupContainer;
        }

        _this.attachParent(_this.portalContainer);

        return _this.portalContainer;
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setPoint", function (point) {
        var alignPoint = _this.props.alignPoint;
        if (!alignPoint || !point) return;

        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handlePortalUpdate", function () {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "triggerContextValue", {
        onPopupMouseDown: _this.onPopupMouseDown
      });

      var _popupVisible;

      if ('popupVisible' in props) {
        _popupVisible = !!props.popupVisible;
      } else {
        _popupVisible = !!props.defaultPopupVisible;
      }

      _this.state = {
        prevPopupVisible: _popupVisible,
        popupVisible: _popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this["fire".concat(h)] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Trigger, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50

        if (state.popupVisible) {
          var currentDocument;

          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument(this.getRootDomNode());
            this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_14_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
          } // always hide on mobile


          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_14_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_14_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
          } // close popup when trigger type contains 'onContextMenu' and window is blur.


          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_14_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
          }

          return;
        }

        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_raf__["a" /* default */].cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        var _this$popupRef$curren2;

        // for test
        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement,
            popupAlign = props.popupAlign,
            builtinPlacements = props.builtinPlacements;

        if (popupPlacement && builtinPlacements) {
          return Object(__WEBPACK_IMPORTED_MODULE_17__utils_alignUtil__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
        }

        return popupAlign;
      }
    }, {
      key: "setPopupVisible",
      value:
      /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */
      function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();

        if (prevPopupVisible !== popupVisible) {
          if (!('popupVisible' in this.props)) {
            this.setState({
              popupVisible: popupVisible,
              prevPopupVisible: prevPopupVisible
            });
          }

          this.props.onPopupVisibleChange(popupVisible);
        } // Always record the point position since mouseEnterDelay will delay the show


        if (alignPoint && event && popupVisible) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;

        var delay = delayS * 1000;
        this.clearDelayTimer();

        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function () {
            _this2.setPopupVisible(visible, point);

            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }

        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }

        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }

        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;

        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }

        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props4 = this.props,
            action = _this$props4.action,
            showAction = _this$props4.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function isContextMenuOnly() {
        var action = this.props.action;
        return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props5 = this.props,
            action = _this$props5.action,
            showAction = _this$props5.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props6 = this.props,
            action = _this$props6.action,
            hideAction = _this$props6.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props7 = this.props,
            action = _this$props7.action,
            showAction = _this$props7.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props8 = this.props,
            action = _this$props8.action,
            hideAction = _this$props8.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props9 = this.props,
            action = _this$props9.action,
            showAction = _this$props9.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props10 = this.props,
            action = _this$props10.action,
            hideAction = _this$props10.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible) {
          var _this$popupRef$curren3;

          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];

        if (childCallback) {
          childCallback(e);
        }

        var callback = this.props[type];

        if (callback) {
          callback(e);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props11 = this.props,
            children = _this$props11.children,
            forceRender = _this$props11.forceRender,
            alignPoint = _this$props11.alignPoint,
            className = _this$props11.className,
            autoDestroy = _this$props11.autoDestroy;
        var child = __WEBPACK_IMPORTED_MODULE_8_react__["Children"].only(children);
        var newChildProps = {
          key: 'trigger'
        }; // ============================== Visible Handlers ==============================
        // >>> ContextMenu

        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        } // >>> Click


        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains('onClick');
          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        } // >>> Hover(enter)


        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter; // Point align

          if (alignPoint) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        } // >>> Hover(leave)


        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        } // >>> Focus


        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains('onFocus');
          newChildProps.onBlur = this.createTwoChains('onBlur');
        } // =================================== Render ===================================


        var childrenClassName = __WEBPACK_IMPORTED_MODULE_16_classnames___default()(child && child.props && child.props.className, className);

        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }

        var cloneProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, newChildProps);

        if (Object(__WEBPACK_IMPORTED_MODULE_13_rc_util_es_ref__["c" /* supportRef */])(child)) {
          cloneProps.ref = Object(__WEBPACK_IMPORTED_MODULE_13_rc_util_es_ref__["a" /* composeRef */])(this.triggerRef, child.ref);
        }

        var trigger = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"](child, cloneProps);
        var portal; // prevent unmounting after it's rendered

        if (popupVisible || this.popupRef.current || forceRender) {
          portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }

        if (!popupVisible && autoDestroy) {
          portal = null;
        }

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__context__["a" /* default */].Provider, {
          value: this.triggerContextValue
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};

        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }

        return newState;
      }
    }]);

    return Trigger;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Trigger, "contextType", __WEBPACK_IMPORTED_MODULE_19__context__["a" /* default */]);

  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Trigger, "defaultProps", {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  });

  return Trigger;
}
/* harmony default export */ __webpack_exports__["a"] = (generateTrigger(__WEBPACK_IMPORTED_MODULE_15_rc_util_es_Portal__["a" /* default */]));

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(628);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);

      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      });

      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};
var _default = wrapperRaf;
exports.default = _default;

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(287);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(654);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1408);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1411);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["e"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return menuAllProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isMobile__ = __webpack_require__(1416);



function noop() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || "".concat(prefix, "item_").concat(index);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(children, function (c) {
    index += 1;

    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(c.props.children, function (c2) {
        index += 1;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(children, function (c) {
    if (c) {
      var construct = c.type;

      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        // eslint-disable-next-line no-param-reassign
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    if (includeMargin) {
      var _getComputedStyle = getComputedStyle(elem),
          marginLeft = _getComputedStyle.marginLeft,
          marginRight = _getComputedStyle.marginRight;

      width += +marginLeft.replace('px', '') + +marginRight.replace('px', '');
    }

    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(elem.style) === 'object') {
    // eslint-disable-next-line no-param-reassign
    elem.style[styleProperty] = value;
  }
};
var isMobileDevice = function isMobileDevice() {
  return __WEBPACK_IMPORTED_MODULE_2__utils_isMobile__["a" /* default */].any;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1470),
    getValue = __webpack_require__(1473);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useForceUpdate;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

function useForceUpdate() {
  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = (0, _slicedToArray2["default"])(_React$useReducer, 2),
      forceUpdate = _React$useReducer2[1];

  return forceUpdate;
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelContext__ = __webpack_require__(86);


var HIDDEN_STYLE = {
  visibility: 'hidden'
};

function Header(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$prevIcon = _ref.prevIcon,
      prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon,
      _ref$nextIcon = _ref.nextIcon,
      nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon,
      _ref$superPrevIcon = _ref.superPrevIcon,
      superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon,
      _ref$superNextIcon = _ref.superNextIcon,
      superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon,
      onSuperPrev = _ref.onSuperPrev,
      onSuperNext = _ref.onSuperNext,
      onPrev = _ref.onPrev,
      onNext = _ref.onNext,
      children = _ref.children;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__PanelContext__["a" /* default */]),
      hideNextBtn = _React$useContext.hideNextBtn,
      hidePrevBtn = _React$useContext.hidePrevBtn;

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: prefixCls
  }, onSuperPrev && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", {
    type: "button",
    onClick: onSuperPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {}
  }, superPrevIcon), onPrev && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", {
    type: "button",
    onClick: onPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {}
  }, prevIcon), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-view")
  }, children), onNext && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", {
    type: "button",
    onClick: onNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {}
  }, nextIcon), onSuperNext && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", {
    type: "button",
    onClick: onSuperNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {}
  }, superNextIcon));
}

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var RangeContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});
/* harmony default export */ __webpack_exports__["a"] = (RangeContext);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1639);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1741);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcInputNumber = _interopRequireDefault(__webpack_require__(1742));

var _UpOutlined = _interopRequireDefault(__webpack_require__(1758));

var _DownOutlined = _interopRequireDefault(__webpack_require__(216));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InputNumber = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = React.useContext(_SizeContext["default"]);

  var className = props.className,
      customizeSize = props.size,
      customizePrefixCls = props.prefixCls,
      readOnly = props.readOnly,
      others = __rest(props, ["className", "size", "prefixCls", "readOnly"]);

  var prefixCls = getPrefixCls('input-number', customizePrefixCls);
  var upIcon = /*#__PURE__*/React.createElement(_UpOutlined["default"], {
    className: "".concat(prefixCls, "-handler-up-inner")
  });
  var downIcon = /*#__PURE__*/React.createElement(_DownOutlined["default"], {
    className: "".concat(prefixCls, "-handler-down-inner")
  });
  var mergeSize = customizeSize || size;
  var inputNumberClass = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), mergeSize === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), mergeSize === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-readonly"), readOnly), _classNames), className);
  return /*#__PURE__*/React.createElement(_rcInputNumber["default"], (0, _extends2["default"])({
    ref: ref,
    className: inputNumberClass,
    upHandler: upIcon,
    downHandler: downIcon,
    prefixCls: prefixCls,
    readOnly: readOnly
  }, others));
});
InputNumber.defaultProps = {
  step: 1
};
var _default = InputNumber;
exports["default"] = _default;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DragDropContext_1 = __webpack_require__(301);
exports.DragDropContext = DragDropContext_1.DragDropContext;
exports.DragDropContextProvider = DragDropContext_1.DragDropContextProvider;
exports.DragDropContextConsumer = DragDropContext_1.Consumer;
var DragLayer_1 = __webpack_require__(1783);
exports.DragLayer = DragLayer_1.default;
var DragSource_1 = __webpack_require__(1784);
exports.DragSource = DragSource_1.default;
var DropTarget_1 = __webpack_require__(1792);
exports.DropTarget = DropTarget_1.default;
var DragPreviewImage_1 = __webpack_require__(1794);
exports.DragPreviewImage = DragPreviewImage_1.default;
var hooks_1 = __webpack_require__(1795);
exports.useDrag = hooks_1.useDrag;
exports.useDragLayer = hooks_1.useDragLayer;
exports.useDrop = hooks_1.useDrop;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */
function get(obj, path, defaultValue) {
    return path
        .split('.')
        .reduce(function (a, c) { return (a && a[c] ? a[c] : defaultValue || null); }, obj);
}
exports.get = get;
/**
 * drop-in replacement for _.without
 */
function without(items, item) {
    return items.filter(function (i) { return i !== item; });
}
exports.without = without;
/**
 * drop-in replacement for _.isString
 * @param input
 */
function isString(input) {
    return typeof input === 'string';
}
exports.isString = isString;
/**
 * drop-in replacement for _.isString
 * @param input
 */
function isObject(input) {
    return typeof input === 'object';
}
exports.isObject = isObject;
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */
function xor(itemsA, itemsB) {
    var map = new Map();
    var insertItem = function (item) {
        return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    map.forEach(function (count, key) {
        if (count === 1) {
            result.push(key);
        }
    });
    return result;
}
exports.xor = xor;
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */
function intersection(itemsA, itemsB) {
    return itemsA.filter(function (t) { return itemsB.indexOf(t) > -1; });
}
exports.intersection = intersection;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HTML5Backend_1 = __webpack_require__(1801);
var getEmptyImage_1 = __webpack_require__(1809);
exports.getEmptyImage = getEmptyImage_1.default;
var NativeTypes = __webpack_require__(420);
exports.NativeTypes = NativeTypes;
function createHTML5Backend(manager) {
    return new HTML5Backend_1.default(manager);
}
exports.default = createHTML5Backend;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 * @format
 * 
 */



var AtomicBlockUtils = __webpack_require__(1929);
var BlockMapBuilder = __webpack_require__(227);
var CharacterMetadata = __webpack_require__(83);
var CompositeDraftDecorator = __webpack_require__(1945);
var ContentBlock = __webpack_require__(154);
var ContentState = __webpack_require__(427);
var DefaultDraftBlockRenderMap = __webpack_require__(430);
var DefaultDraftInlineStyle = __webpack_require__(815);
var DraftEditor = __webpack_require__(1946);
var DraftEditorBlock = __webpack_require__(817);
var DraftEntity = __webpack_require__(306);
var DraftModifier = __webpack_require__(81);
var DraftEntityInstance = __webpack_require__(813);
var EditorState = __webpack_require__(36);
var KeyBindingUtil = __webpack_require__(437);
var RichTextEditorUtil = __webpack_require__(832);
var SelectionState = __webpack_require__(196);

var convertFromDraftStateToRaw = __webpack_require__(2007);
var convertFromHTMLToContentBlocks = __webpack_require__(830);
var convertFromRawToDraftState = __webpack_require__(2010);
var generateRandomKey = __webpack_require__(121);
var getDefaultKeyBinding = __webpack_require__(833);
var getVisibleSelectionRect = __webpack_require__(2015);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,

  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,

  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  SelectionState: SelectionState,

  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};

module.exports = DraftPublic;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(32);

var Record = Immutable.Record;


var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = function (_SelectionStateRecord) {
  _inherits(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck(this, SelectionState);

    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2050)


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(316);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___30nLR","container_1":"container_1___34kqs","container_2":"container_2___11RRz","mask-wrapper":"mask-wrapper___2yPmp","mask-content-wrapper":"mask-content-wrapper___2tyAA","close-btn":"close-btn___1TMbB","play-btn":"play-btn___24k6k","catalog-content-wrapper":"catalog-content-wrapper___36dfq","carousel-image":"carousel-image___1uQLH"};

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(927);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSafeState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](false);
  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](defaultValue),
    _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1122);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollBarSize;
/* unused harmony export getTargetScrollBarSize */
/* eslint-disable no-param-reassign */

var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = '0';
    outerStyle.left = '0';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function ensureSize(str) {
  var match = str.match(/^(.*)px$/);
  var value = Number(match === null || match === void 0 ? void 0 : match[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  var _getComputedStyle = getComputedStyle(target, '::-webkit-scrollbar'),
    width = _getComputedStyle.width,
    height = _getComputedStyle.height;
  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getPathValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = getColumnsKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeObject;
/* harmony export (immutable) */ __webpack_exports__["d"] = validateValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(165);

var INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';

function toArray(arr) {
  if (arr === undefined || arr === null) {
    return [];
  }

  return Array.isArray(arr) ? arr : [arr];
}

function getPathValue(record, path) {
  // Skip if path is empty
  if (!path && typeof path !== 'number') {
    return record;
  }

  var pathList = toArray(path);
  var current = record;

  for (var i = 0; i < pathList.length; i += 1) {
    if (!current) {
      return null;
    }

    var prop = pathList[i];
    current = current[prop];
  }

  return current;
}
function getColumnsKey(columns) {
  var columnKeys = [];
  var keys = {};
  columns.forEach(function (column) {
    var _ref = column || {},
        key = _ref.key,
        dataIndex = _ref.dataIndex;

    var mergedKey = key || toArray(dataIndex).join('-') || INTERNAL_KEY_PREFIX;

    while (keys[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }

    keys[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}
function mergeObject() {
  var merged = {};
  /* eslint-disable no-param-reassign */

  function fillProps(obj, clone) {
    if (clone) {
      Object.keys(clone).forEach(function (key) {
        var value = clone[key];

        if (value && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object') {
          obj[key] = obj[key] || {};
          fillProps(obj[key], value);
        } else {
          obj[key] = value;
        }
      });
    }
  }
  /* eslint-enable */


  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  objects.forEach(function (clone) {
    fillProps(merged, clone);
  });
  return merged;
}
function validateValue(val) {
  return val !== null && val !== undefined;
}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathValue = getPathValue;
exports.getColumnsKey = getColumnsKey;
exports.mergeObject = mergeObject;
exports.validateValue = validateValue;

var _typeof2 = _interopRequireDefault(__webpack_require__(142));

var INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';

function toArray(arr) {
  if (arr === undefined || arr === null) {
    return [];
  }

  return Array.isArray(arr) ? arr : [arr];
}

function getPathValue(record, path) {
  // Skip if path is empty
  if (!path && typeof path !== 'number') {
    return record;
  }

  var pathList = toArray(path);
  var current = record;

  for (var i = 0; i < pathList.length; i += 1) {
    if (!current) {
      return null;
    }

    var prop = pathList[i];
    current = current[prop];
  }

  return current;
}

function getColumnsKey(columns) {
  var columnKeys = [];
  var keys = {};
  columns.forEach(function (column) {
    var _ref = column || {},
        key = _ref.key,
        dataIndex = _ref.dataIndex;

    var mergedKey = key || toArray(dataIndex).join('-') || INTERNAL_KEY_PREFIX;

    while (keys[mergedKey]) {
      mergedKey = "".concat(mergedKey, "_next");
    }

    keys[mergedKey] = true;
    columnKeys.push(mergedKey);
  });
  return columnKeys;
}

function mergeObject() {
  var merged = {};
  /* eslint-disable no-param-reassign */

  function fillProps(obj, clone) {
    if (clone) {
      Object.keys(clone).forEach(function (key) {
        var value = clone[key];

        if (value && (0, _typeof2.default)(value) === 'object') {
          obj[key] = obj[key] || {};
          fillProps(obj[key], value);
        } else {
          obj[key] = value;
        }
      });
    }
  }
  /* eslint-enable */


  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  objects.forEach(function (clone) {
    fillProps(merged, clone);
  });
  return merged;
}

function validateValue(val) {
  return val !== null && val !== undefined;
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(370),
    getRawTag = __webpack_require__(1203),
    objectToString = __webpack_require__(1204);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DownOutlined = _interopRequireDefault(__webpack_require__(1336));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DownOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _react = __webpack_require__(0);

var _responsiveObserve = _interopRequireDefault(__webpack_require__(284));

function useBreakpoint() {
  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      screens = _useState2[0],
      setScreens = _useState2[1];

  (0, _react.useEffect)(function () {
    var token = _responsiveObserve["default"].subscribe(function (supportScreens) {
      setScreens(supportScreens);
    });

    return function () {
      return _responsiveObserve["default"].unsubscribe(token);
    };
  }, []);
  return screens;
}

var _default = useBreakpoint;
exports["default"] = _default;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _ShopOutlined = _interopRequireDefault(__webpack_require__(1542));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ShopOutlined = function ShopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _ShopOutlined.default
  }));
};
ShopOutlined.displayName = 'ShopOutlined';
var _default = /*#__PURE__*/React.forwardRef(ShopOutlined);
exports.default = _default;

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PanelBody;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_timeUtil__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dateUtil__ = __webpack_require__(61);







function PanelBody(_ref) {
  var prefixCls = _ref.prefixCls,
      disabledDate = _ref.disabledDate,
      onSelect = _ref.onSelect,
      picker = _ref.picker,
      rowNum = _ref.rowNum,
      colNum = _ref.colNum,
      prefixColumn = _ref.prefixColumn,
      rowClassName = _ref.rowClassName,
      baseDate = _ref.baseDate,
      getCellClassName = _ref.getCellClassName,
      getCellText = _ref.getCellText,
      getCellNode = _ref.getCellNode,
      getCellDate = _ref.getCellDate,
      generateConfig = _ref.generateConfig,
      titleCell = _ref.titleCell,
      headerCells = _ref.headerCells;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__PanelContext__["a" /* default */]),
      onDateMouseEnter = _React$useContext.onDateMouseEnter,
      onDateMouseLeave = _React$useContext.onDateMouseLeave,
      mode = _React$useContext.mode;

  var cellPrefixCls = "".concat(prefixCls, "-cell"); // =============================== Body ===============================

  var rows = [];

  for (var i = 0; i < rowNum; i += 1) {
    var row = [];
    var rowStartDate = void 0;

    var _loop = function _loop(j) {
      var _objectSpread2;

      var offset = i * colNum + j;
      var currentDate = getCellDate(baseDate, offset);
      var disabled = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dateUtil__["c" /* getCellDateDisabled */])({
        cellDate: currentDate,
        mode: mode,
        disabledDate: disabledDate,
        generateConfig: generateConfig
      });

      if (j === 0) {
        rowStartDate = currentDate;

        if (prefixColumn) {
          row.push(prefixColumn(rowStartDate));
        }
      }

      var title = titleCell && titleCell(currentDate);
      row.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("td", {
        key: j,
        title: title,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(cellPrefixCls, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])((_objectSpread2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_objectSpread2, "".concat(cellPrefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_objectSpread2, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === 'year' && Number(title) % 10 === 0), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_objectSpread2, "".concat(cellPrefixCls, "-end"), title === Object(__WEBPACK_IMPORTED_MODULE_5__utils_timeUtil__["a" /* getLastDay */])(generateConfig, currentDate) || picker === 'year' && Number(title) % 10 === 9), _objectSpread2), getCellClassName(currentDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled && onDateMouseEnter) {
            onDateMouseEnter(currentDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled && onDateMouseLeave) {
            onDateMouseLeave(currentDate);
          }
        }
      }, getCellNode ? getCellNode(currentDate) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
        className: "".concat(cellPrefixCls, "-inner")
      }, getCellText(currentDate))));
    };

    for (var j = 0; j < colNum; j += 1) {
      _loop(j);
    }

    rows.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("tr", {
      key: i,
      className: rowClassName && rowClassName(rowStartDate)
    }, row));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-body")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("table", {
    className: "".concat(prefixCls, "-content")
  }, headerCells && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("thead", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("tr", null, headerCells)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("tbody", null, rows)));
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixControlledValue = fixControlledValue;
exports.resolveOnChange = resolveOnChange;
exports.getInputClassName = getInputClassName;
exports.triggerFocus = triggerFocus;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(696));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

function resolveOnChange(target, e, onChange) {
  if (onChange) {
    var event = e;

    if (e.type === 'click') {
      // click clear icon
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input

      target.value = '';
      onChange(event); // reset target ref value

      target.value = originalInputValue;
      return;
    }

    onChange(event);
  }
}

function getInputClassName(prefixCls, bordered, size, disabled, direction) {
  var _classNames;

  return (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames));
}

function triggerFocus(element, option) {
  if (!element) return;
  element.focus(option); // Selection content

  var _ref = option || {},
      cursor = _ref.cursor;

  if (cursor) {
    var len = element.value.length;

    switch (cursor) {
      case 'start':
        element.setSelectionRange(0, 0);
        break;

      case 'end':
        element.setSelectionRange(len, len);
        break;

      default:
        element.setSelectionRange(0, len);
    }
  }
}

var Input = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Input, _React$Component);

  var _super = (0, _createSuper2["default"])(Input);

  function Input(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Input);
    _this = _super.call(this, props);
    _this.direction = 'ltr';

    _this.focus = function (option) {
      triggerFocus(_this.input, option);
    };

    _this.saveClearableInput = function (input) {
      _this.clearableInput = input;
    };

    _this.saveInput = function (input) {
      _this.input = input;
    };

    _this.onFocus = function (e) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      }, _this.clearPasswordValueAttribute);

      if (onFocus) {
        onFocus(e);
      }
    };

    _this.onBlur = function (e) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      }, _this.clearPasswordValueAttribute);

      if (onBlur) {
        onBlur(e);
      }
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.focus();
      });

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.renderInput = function (prefixCls, size, bordered) {
      var input = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _this$props = _this.props,
          className = _this$props.className,
          addonBefore = _this$props.addonBefore,
          addonAfter = _this$props.addonAfter,
          customizeSize = _this$props.size,
          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      'defaultValue', 'size', 'inputType', 'bordered']);
      return /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({
        autoComplete: input.autoComplete
      }, otherProps, {
        onChange: _this.handleChange,
        onFocus: _this.onFocus,
        onBlur: _this.onBlur,
        onKeyDown: _this.handleKeyDown,
        className: (0, _classnames["default"])(getInputClassName(prefixCls, bordered, customizeSize || size, disabled, _this.direction), (0, _defineProperty2["default"])({}, className, className && !addonBefore && !addonAfter)),
        ref: _this.saveInput
      }));
    };

    _this.clearPasswordValueAttribute = function () {
      // https://github.com/ant-design/ant-design/issues/20541
      _this.removePasswordTimeout = setTimeout(function () {
        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
          _this.input.removeAttribute('value');
        }
      });
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onPressEnter = _this$props2.onPressEnter,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.renderComponent = function (_ref2) {
      var getPrefixCls = _ref2.getPrefixCls,
          direction = _ref2.direction,
          input = _ref2.input;
      var _this$state = _this.state,
          value = _this$state.value,
          focused = _this$state.focused;
      var _this$props3 = _this.props,
          customizePrefixCls = _this$props3.prefixCls,
          _this$props3$bordered = _this$props3.bordered,
          bordered = _this$props3$bordered === void 0 ? true : _this$props3$bordered;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      _this.direction = direction;
      return /*#__PURE__*/React.createElement(_SizeContext["default"].Consumer, null, function (size) {
        return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], (0, _extends2["default"])({
          size: size
        }, _this.props, {
          prefixCls: prefixCls,
          inputType: "input",
          value: fixControlledValue(value),
          element: _this.renderInput(prefixCls, size, bordered, input),
          handleReset: _this.handleReset,
          ref: _this.saveClearableInput,
          direction: direction,
          focused: focused,
          triggerFocus: _this.focus,
          bordered: bordered
        }));
      });
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value,
      focused: false,
      // eslint-disable-next-line react/no-unused-state
      prevValue: props.value
    };
    return _this;
  }

  (0, _createClass2["default"])(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.clearPasswordValueAttribute();
    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
    // We keep an empty function here.

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
        (0, _devWarning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.removePasswordTimeout) {
        clearTimeout(this.removePasswordTimeout);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "setSelectionRange",
    value: function setSelectionRange(start, end, direction) {
      this.input.setSelectionRange(start, end, direction);
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "setValue",
    value: function setValue(value, callback) {
      if (this.props.value === undefined) {
        this.setState({
          value: value
        }, callback);
      } else {
        callback === null || callback === void 0 ? void 0 : callback();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref3) {
      var prevValue = _ref3.prevValue;
      var newState = {
        prevValue: nextProps.value
      };

      if (nextProps.value !== undefined || prevValue !== nextProps.value) {
        newState.value = nextProps.value;
      }

      return newState;
    }
  }]);
  return Input;
}(React.Component);

Input.defaultProps = {
  type: 'text'
};
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _EyeOutlined = _interopRequireDefault(__webpack_require__(1615));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _EyeOutlined.default
  }));
};
EyeOutlined.displayName = 'EyeOutlined';
var _default = /*#__PURE__*/React.forwardRef(EyeOutlined);
exports.default = _default;

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationCenter; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// 2019-10-24 
// aleiku
// NotificationCenter v2.0
var subscriberUid=-1;var NotificationName={'AuthDenied':'NotificationNameAuthDenied','PermissionsDidChanged':'NotificationNamePermissionsDidChanged','PageLayoutDidChanged':'NotificationNamePageLayoutDidChanged','PageNeedCheckDataItems':'NotificationNamePageNeedCheckDataItems','PageCleanCache':'NotificationNamePageCleanCache','PageOnSubmit':'NotificationNamePageOnSubmit','PageUseSampleImage':'NotificationNamePageUseSampleImage','PageRequestImageDidChange':'NotificationNamePageRequestImageDidChange'// const default = new NotificationCenter()
};var notificationCenterDefault=null;var NotificationCenter=function(){_createClass(NotificationCenter,null,[{key:'default',// TODO: 這樣寫會報錯，應該是ES6的關係之後再修正
// static default = NotificationCenter.default == null ? new NotificationCenter() : this.default;
get:function get(){if(notificationCenterDefault==null){notificationCenterDefault=new NotificationCenter();}return notificationCenterDefault;}}]);function NotificationCenter(){_classCallCheck(this,NotificationCenter);this.observers=[];}_createClass(NotificationCenter,[{key:'addObserver',value:function addObserver(observer,callback){var eventName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var object=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var token=(++subscriberUid).toString();this.observers.push({token:token,observer:observer,callback:callback,eventName:eventName,object:object});return token;}},{key:'removeObserver',value:function removeObserver(observer){var eventName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;this.observers=this.observers.filter(function(observerInfo){if(observerInfo.observer===observer){// 不指定eventName remove all
if(eventName===undefined)return false;if(eventName===observerInfo.eventName)return false;}return true;});}},{key:'post',value:function post(eventName,object){this.observers.filter(function(item){return item.eventName===null||item.eventName===eventName;}).forEach(function(item){if(item.callback instanceof Function){item.callback({eventName:eventName,object:object,observer:item.observer,observerObject:item.object});}});}}]);return NotificationCenter;}();

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var invariant = __webpack_require__(25);
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), 'update(): You provided an invalid spec to update(). The spec may ' +
                'not contain an array except as the value of $set, $push, $unshift, ' +
                '$splice or any custom command allowing an array value.');
        }
        invariant(typeof spec === 'object' && spec !== null, 'update(): You provided an invalid spec to update(). The spec and ' +
            'every included key path must be plain objects containing one of the ' +
            'following commands: %s.', Object.keys(this.commands).join(', '));
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), 'update(): expected target of %s to be an array; got %s.', command, value);
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), 'update(): expected spec of %s to be an array; got %s. ' +
        'Did you forget to wrap your parameter in an array?', command, spec);
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), 'Expected $splice target to be an array; got %s', value);
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), 'update(): expected spec of $splice to be an array of arrays; got %s. ' +
        'Did you forget to wrap your parameters in an array?', value);
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', 'update(): expected spec of $apply to be a function; got %s.', fn);
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, 'Cannot have more than one key in an object with $set');
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', 'update(): $merge expects a spec of type \'object\'; got %s', specValue);
    invariant(target && typeof target === 'object', 'update(): $merge expects a target of type \'object\'; got %s', target);
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', 'update(): %s expects a target of type Set or Map; got %s', command, typeOfTarget);
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * @format
 * 
 */



var Immutable = __webpack_require__(32);

var OrderedMap = Immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

module.exports = BlockMapBuilder;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */



/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = exports.SET_A = 0;
var SET_B = exports.SET_B = 1;
var SET_C = exports.SET_C = 2;

// Special characters
var SHIFT = exports.SHIFT = 98;
var START_A = exports.START_A = 103;
var START_B = exports.START_B = 104;
var START_C = exports.START_C = 105;
var MODULO = exports.MODULO = 103;
var STOP = exports.STOP = 106;
var FNC1 = exports.FNC1 = 207;

// Get set by start code
var SET_BY_CODE = exports.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
var SWAP = exports.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

var A_START_CHAR = exports.A_START_CHAR = String.fromCharCode(208); // START_A + 105
var B_START_CHAR = exports.B_START_CHAR = String.fromCharCode(209); // START_B + 105
var C_START_CHAR = exports.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
var A_CHARS = exports.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
var B_CHARS = exports.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
var C_CHARS = exports.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
var BARS = exports.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Standard start end and middle bits
var SIDE_BIN = exports.SIDE_BIN = '101';
var MIDDLE_BIN = exports.MIDDLE_BIN = '01010';

var BINARIES = exports.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
var EAN2_STRUCTURE = exports.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
var EAN5_STRUCTURE = exports.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
var EAN13_STRUCTURE = exports.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__(232);

// Encode data string
var encode = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

exports.default = encode;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck(this, MSI);

		return _possibleConstructorReturn(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

exports.default = MSI;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(853);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(2092);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(2093);
var isNativeReflectConstruct = __webpack_require__(2094);
var possibleConstructorReturn = __webpack_require__(2095);
function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return possibleConstructorReturn(this, result);
  };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clamp = clamp;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _react = _interopRequireDefault(__webpack_require__(0));

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return (// eslint-disable-next-line no-prototype-builtins
    keysArray.reduce(function (value, key) {
      return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec)
  );
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1lf0E","container_1":"container_1___3Wafd","container_2":"container_2___2l-d3"};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___vEOoh","container_1":"container_1___3ade0","container_2":"container_2___1rnRa"};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(878);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(2149);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(2151);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___2M209","container_1":"container_1___18WNb","container_2":"container_2___1hnXf"};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(484);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(934);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOOK_MARK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_warning__ = __webpack_require__(55);


var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var warningFunc = function warningFunc() {
  Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_warning__["a" /* default */])(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};

var Context = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      setCallbacks: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc
    };
  }
});
/* harmony default export */ __webpack_exports__["b"] = (Context);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _en_US = _interopRequireDefault(__webpack_require__(958));

var _en_US2 = _interopRequireDefault(__webpack_require__(504));

// Merge into a locale object
var locale = {
  lang: (0, _extends2["default"])({
    placeholder: 'Select date',
    yearPlaceholder: 'Select year',
    quarterPlaceholder: 'Select quarter',
    monthPlaceholder: 'Select month',
    weekPlaceholder: 'Select week',
    rangePlaceholder: ['Start date', 'End date'],
    rangeYearPlaceholder: ['Start year', 'End year'],
    rangeMonthPlaceholder: ['Start month', 'End month'],
    rangeWeekPlaceholder: ['Start week', 'End week']
  }, _en_US["default"]),
  timePickerLocale: (0, _extends2["default"])({}, _en_US2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(514);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(251);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }
  if (node instanceof __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component) {
    return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(node);
  }
  return null;
}

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMemo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = rgbToRgb;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgbToHsl;
/* harmony export (immutable) */ __webpack_exports__["b"] = hslToRgb;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbToHsv;
/* harmony export (immutable) */ __webpack_exports__["c"] = hsvToRgb;
/* harmony export (immutable) */ __webpack_exports__["f"] = rgbToHex;
/* harmony export (immutable) */ __webpack_exports__["k"] = rgbaToHex;
/* harmony export (immutable) */ __webpack_exports__["j"] = rgbaToArgbHex;
/* unused harmony export convertDecimalToHex */
/* harmony export (immutable) */ __webpack_exports__["a"] = convertHexToDecimal;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseIntFromHex;
/* harmony export (immutable) */ __webpack_exports__["d"] = numberInputToObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(256);

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */
function rgbToRgb(r, g, b) {
    return {
        r: Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(r, 255) * 255,
        g: Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(g, 255) * 255,
        b: Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(b, 255) * 255,
    };
}
/**
 * Converts an RGB color value to HSL.
 * *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
 * *Returns:* { h, s, l } in [0,1]
 */
function rgbToHsl(r, g, b) {
    r = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(r, 255);
    g = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(g, 255);
    b = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, l: l };
}
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    if (t > 1) {
        t -= 1;
    }
    if (t < 1 / 6) {
        return p + (q - p) * (6 * t);
    }
    if (t < 1 / 2) {
        return q;
    }
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hslToRgb(h, s, l) {
    var r;
    var g;
    var b;
    h = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(h, 360);
    s = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(s, 100);
    l = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */
function rgbToHsv(r, g, b) {
    r = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(r, 255);
    g = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(g, 255);
    b = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hsvToRgb(h, s, v) {
    h = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(h, 360) * 6;
    s = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(s, 100);
    v = Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bound01 */])(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [v, q, p, p, t, v][mod];
    var g = [t, v, v, q, p, p][mod];
    var b = [p, p, t, v, v, q][mod];
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */
function rgbToHex(r, g, b, allow3Char) {
    var hex = [
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(r).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(g).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(b).toString(16)),
    ];
    // Return a 3 character hex if possible
    if (allow3Char &&
        hex[0].startsWith(hex[0].charAt(1)) &&
        hex[1].startsWith(hex[1].charAt(1)) &&
        hex[2].startsWith(hex[2].charAt(1))) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join('');
}
/**
 * Converts an RGBA color plus alpha transparency to hex
 *
 * Assumes r, g, b are contained in the set [0, 255] and
 * a in [0, 1]. Returns a 4 or 8 character rgba hex
 */
// eslint-disable-next-line max-params
function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(r).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(g).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(b).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(convertDecimalToHex(a)),
    ];
    // Return a 4 character hex if possible
    if (allow4Char &&
        hex[0].startsWith(hex[0].charAt(1)) &&
        hex[1].startsWith(hex[1].charAt(1)) &&
        hex[2].startsWith(hex[2].charAt(1)) &&
        hex[3].startsWith(hex[3].charAt(1))) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join('');
}
/**
 * Converts an RGBA color to an ARGB Hex8 string
 * Rarely used, but required for "toFilter()"
 */
function rgbaToArgbHex(r, g, b, a) {
    var hex = [
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(convertDecimalToHex(a)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(r).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(g).toString(16)),
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* pad2 */])(Math.round(b).toString(16)),
    ];
    return hex.join('');
}
/** Converts a decimal to a hex value */
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
/** Converts a hex value to a decimal */
function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */
function parseIntFromHex(val) {
    return parseInt(val, 16);
}
function numberInputToObject(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff,
    };
}


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bound01;
/* harmony export (immutable) */ __webpack_exports__["c"] = clamp01;
/* unused harmony export isOnePointZero */
/* unused harmony export isPercentage */
/* harmony export (immutable) */ __webpack_exports__["b"] = boundAlpha;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertToPercentage;
/* harmony export (immutable) */ __webpack_exports__["e"] = pad2;
/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */
function bound01(n, max) {
    if (isOnePointZero(n)) {
        n = '100%';
    }
    var isPercent = isPercentage(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) {
        n = parseInt(String(n * max), 10) / 100;
    }
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
        return 1;
    }
    // Convert into [0, 1] range if it isn't already
    if (max === 360) {
        // If n is a hue given in degrees,
        // wrap around out-of-range values into [0, 360] range
        // then convert into [0, 1].
        n = (n < 0 ? (n % max) + max : n % max) / parseFloat(String(max));
    }
    else {
        // If n not a hue given in degrees
        // Convert into [0, 1] range if it isn't already.
        n = (n % max) / parseFloat(String(max));
    }
    return n;
}
/**
 * Force a number between 0 and 1
 * @hidden
 */
function clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */
function isOnePointZero(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */
function isPercentage(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */
function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }
    return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */
function convertToPercentage(n) {
    if (n <= 1) {
        return "".concat(Number(n) * 100, "%");
    }
    return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */
function pad2(c) {
    return c.length === 1 ? '0' + c : String(c);
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(1022));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _ExclamationCircleFilled;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(1026));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CheckCircleFilled;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1071);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1069);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(205);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _RightOutlined = _interopRequireDefault(__webpack_require__(1114));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _RightOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1139);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1157);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_valueUtil__ = __webpack_require__(208);









function isRenderCell(data) {
  return data && Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(data) === 'object' && !Array.isArray(data) && ! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](data);
}

function isRefComponent(component) {
  // String tag component also support ref
  if (typeof component === 'string') {
    return true;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_ref__["c" /* supportRef */])(component);
}

function Cell(_ref, ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      record = _ref.record,
      index = _ref.index,
      dataIndex = _ref.dataIndex,
      render = _ref.render,
      children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'td' : _ref$component,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan,
      fixLeft = _ref.fixLeft,
      fixRight = _ref.fixRight,
      firstFixLeft = _ref.firstFixLeft,
      lastFixLeft = _ref.lastFixLeft,
      firstFixRight = _ref.firstFixRight,
      lastFixRight = _ref.lastFixRight,
      appendNode = _ref.appendNode,
      _ref$additionalProps = _ref.additionalProps,
      additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps,
      ellipsis = _ref.ellipsis,
      align = _ref.align,
      rowType = _ref.rowType,
      isSticky = _ref.isSticky;
  var cellPrefixCls = "".concat(prefixCls, "-cell"); // ==================== Child Node ====================

  var cellProps;
  var childNode;

  if (children) {
    childNode = children;
  } else {
    var value = Object(__WEBPACK_IMPORTED_MODULE_7__utils_valueUtil__["b" /* getPathValue */])(record, dataIndex); // Customize render node

    childNode = value;

    if (render) {
      var renderData = render(value, record, index);

      if (isRenderCell(renderData)) {
        childNode = renderData.children;
        cellProps = renderData.props;
      } else {
        childNode = renderData;
      }
    }
  } // Not crash if final `childNode` is not validate ReactNode


  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(childNode) === 'object' && !Array.isArray(childNode) && ! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](childNode)) {
    childNode = null;
  }

  if (ellipsis && (lastFixLeft || firstFixRight)) {
    childNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      className: "".concat(cellPrefixCls, "-content")
    }, childNode);
  }

  var _ref2 = cellProps || {},
      cellColSpan = _ref2.colSpan,
      cellRowSpan = _ref2.rowSpan,
      cellStyle = _ref2.style,
      cellClassName = _ref2.className,
      restCellProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["colSpan", "rowSpan", "style", "className"]);

  var mergedColSpan = cellColSpan !== undefined ? cellColSpan : colSpan;
  var mergedRowSpan = cellRowSpan !== undefined ? cellRowSpan : rowSpan;

  if (mergedColSpan === 0 || mergedRowSpan === 0) {
    return null;
  } // ====================== Fixed =======================


  var fixedStyle = {};
  var isFixLeft = typeof fixLeft === 'number';
  var isFixRight = typeof fixRight === 'number';

  if (isFixLeft) {
    fixedStyle.position = 'sticky';
    fixedStyle.left = fixLeft;
  }

  if (isFixRight) {
    fixedStyle.position = 'sticky';
    fixedStyle.right = fixRight;
  } // ====================== Align =======================


  var alignStyle = {};

  if (align) {
    alignStyle.textAlign = align;
  } // ====================== Render ======================


  var title;
  var ellipsisConfig = ellipsis === true ? {
    showTitle: true
  } : ellipsis;

  if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
    if (typeof childNode === 'string' || typeof childNode === 'number') {
      title = childNode.toString();
    } else if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](childNode) && typeof childNode.props.children === 'string') {
      title = childNode.props.children;
    }
  }

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    title: title
  }, restCellProps), additionalProps), {}, {
    colSpan: mergedColSpan && mergedColSpan !== 1 ? mergedColSpan : null,
    rowSpan: mergedRowSpan && mergedRowSpan !== 1 ? mergedRowSpan : null,
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(cellPrefixCls, className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky), _classNames), additionalProps.className, cellClassName),
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
    ref: isRefComponent(Component) ? ref : null
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Component, componentProps, appendNode, childNode);
}

var RefCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](Cell);
RefCell.displayName = 'Cell';
var MemoCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["memo"](RefCell, function (prev, next) {
  if (next.shouldCellUpdate) {
    return !next.shouldCellUpdate(next.record, prev.record);
  }

  return false;
});
/* harmony default export */ __webpack_exports__["a"] = (MemoCell);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTERNAL_COL_DEFINE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getExpandableProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAndAriaProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__ = __webpack_require__(55);



var INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';
function getExpandableProps(props) {
  var expandable = props.expandable,
      legacyExpandableConfig = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["expandable"]);

  if ('expandable' in props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, legacyExpandableConfig), expandable);
  }

  if (false) {
    warning(false, 'expanded related props have been moved into `expandable`.');
  }

  return legacyExpandableConfig;
}
/**
 * Returns only data- and aria- key/value pairs
 * @param {object} props
 */

function getDataAndAriaProps(props) {
  /* eslint-disable no-param-reassign */
  return Object.keys(props).reduce(function (memo, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      memo[key] = props[key];
    }

    return memo;
  }, {});
  /* eslint-enable */
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1177);
var iterableToArrayLimit = __webpack_require__(1178);
var unsupportedIterableToArray = __webpack_require__(585);
var nonIterableRest = __webpack_require__(1179);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1184);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(586)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(274));

var _typeof2 = _interopRequireDefault(__webpack_require__(142));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _ref3 = __webpack_require__(117);

var _valueUtil = __webpack_require__(210);

function isRenderCell(data) {
  return data && (0, _typeof2.default)(data) === 'object' && !Array.isArray(data) && ! /*#__PURE__*/React.isValidElement(data);
}

function isRefComponent(component) {
  // String tag component also support ref
  if (typeof component === 'string') {
    return true;
  }

  return (0, _ref3.supportRef)(component);
}

function Cell(_ref, ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      record = _ref.record,
      index = _ref.index,
      dataIndex = _ref.dataIndex,
      render = _ref.render,
      children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'td' : _ref$component,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan,
      fixLeft = _ref.fixLeft,
      fixRight = _ref.fixRight,
      firstFixLeft = _ref.firstFixLeft,
      lastFixLeft = _ref.lastFixLeft,
      firstFixRight = _ref.firstFixRight,
      lastFixRight = _ref.lastFixRight,
      appendNode = _ref.appendNode,
      _ref$additionalProps = _ref.additionalProps,
      additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps,
      ellipsis = _ref.ellipsis,
      align = _ref.align,
      rowType = _ref.rowType,
      isSticky = _ref.isSticky;
  var cellPrefixCls = "".concat(prefixCls, "-cell"); // ==================== Child Node ====================

  var cellProps;
  var childNode;

  if (children) {
    childNode = children;
  } else {
    var value = (0, _valueUtil.getPathValue)(record, dataIndex); // Customize render node

    childNode = value;

    if (render) {
      var renderData = render(value, record, index);

      if (isRenderCell(renderData)) {
        childNode = renderData.children;
        cellProps = renderData.props;
      } else {
        childNode = renderData;
      }
    }
  } // Not crash if final `childNode` is not validate ReactNode


  if ((0, _typeof2.default)(childNode) === 'object' && !Array.isArray(childNode) && ! /*#__PURE__*/React.isValidElement(childNode)) {
    childNode = null;
  }

  if (ellipsis && (lastFixLeft || firstFixRight)) {
    childNode = /*#__PURE__*/React.createElement("span", {
      className: "".concat(cellPrefixCls, "-content")
    }, childNode);
  }

  var _ref2 = cellProps || {},
      cellColSpan = _ref2.colSpan,
      cellRowSpan = _ref2.rowSpan,
      cellStyle = _ref2.style,
      cellClassName = _ref2.className,
      restCellProps = (0, _objectWithoutProperties2.default)(_ref2, ["colSpan", "rowSpan", "style", "className"]);

  var mergedColSpan = cellColSpan !== undefined ? cellColSpan : colSpan;
  var mergedRowSpan = cellRowSpan !== undefined ? cellRowSpan : rowSpan;

  if (mergedColSpan === 0 || mergedRowSpan === 0) {
    return null;
  } // ====================== Fixed =======================


  var fixedStyle = {};
  var isFixLeft = typeof fixLeft === 'number';
  var isFixRight = typeof fixRight === 'number';

  if (isFixLeft) {
    fixedStyle.position = 'sticky';
    fixedStyle.left = fixLeft;
  }

  if (isFixRight) {
    fixedStyle.position = 'sticky';
    fixedStyle.right = fixRight;
  } // ====================== Align =======================


  var alignStyle = {};

  if (align) {
    alignStyle.textAlign = align;
  } // ====================== Render ======================


  var title;
  var ellipsisConfig = ellipsis === true ? {
    showTitle: true
  } : ellipsis;

  if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
    if (typeof childNode === 'string' || typeof childNode === 'number') {
      title = childNode.toString();
    } else if ( /*#__PURE__*/React.isValidElement(childNode) && typeof childNode.props.children === 'string') {
      title = childNode.props.children;
    }
  }

  var componentProps = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({
    title: title
  }, restCellProps), additionalProps), {}, {
    colSpan: mergedColSpan && mergedColSpan !== 1 ? mergedColSpan : null,
    rowSpan: mergedRowSpan && mergedRowSpan !== 1 ? mergedRowSpan : null,
    className: (0, _classnames.default)(cellPrefixCls, className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), (0, _defineProperty2.default)(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky), _classNames), additionalProps.className, cellClassName),
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
    ref: isRefComponent(Component) ? ref : null
  });
  return /*#__PURE__*/React.createElement(Component, componentProps, appendNode, childNode);
}

var RefCell = /*#__PURE__*/React.forwardRef(Cell);
RefCell.displayName = 'Cell';
var MemoCell = /*#__PURE__*/React.memo(RefCell, function (prev, next) {
  if (next.shouldCellUpdate) {
    return !next.shouldCellUpdate(next.record, prev.record);
  }

  return false;
});
var _default = MemoCell;
exports.default = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1239);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pickAttrs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(330);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(610);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["e"] = toInnerValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = toOuterValues;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeLastEnabledValue;
/* unused harmony export isClient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isBrowserClient; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getUUID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(376);

function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }

  return value !== undefined ? [value] : [];
}
/**
 * Convert outer props value into internal value
 */

function toInnerValue(value, _ref) {
  var labelInValue = _ref.labelInValue,
      combobox = _ref.combobox;

  if (value === undefined || value === '' && combobox) {
    return [];
  }

  var values = Array.isArray(value) ? value : [value];

  if (labelInValue) {
    return values.map(function (_ref2) {
      var key = _ref2.key,
          val = _ref2.value;
      return val !== undefined ? val : key;
    });
  }

  return values;
}
/**
 * Convert internal value into out event value
 */

function toOuterValues(valueList, _ref3) {
  var optionLabelProp = _ref3.optionLabelProp,
      labelInValue = _ref3.labelInValue,
      prevValue = _ref3.prevValue,
      options = _ref3.options,
      getLabeledValue = _ref3.getLabeledValue;
  var values = valueList;

  if (labelInValue) {
    values = values.map(function (val) {
      return getLabeledValue(val, {
        options: options,
        prevValue: prevValue,
        labelInValue: labelInValue,
        optionLabelProp: optionLabelProp
      });
    });
  }

  return values;
}
function removeLastEnabledValue(measureValues, values) {
  var newValues = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(values);

  var removeIndex;

  for (removeIndex = measureValues.length - 1; removeIndex >= 0; removeIndex -= 1) {
    if (!measureValues[removeIndex].disabled) {
      break;
    }
  }

  var removedValue = null;

  if (removeIndex !== -1) {
    removedValue = newValues[removeIndex];
    newValues.splice(removeIndex, 1);
  }

  return {
    values: newValues,
    removedValue: removedValue
  };
}
var isClient = typeof window !== 'undefined' && window.document && window.document.documentElement;
/** Is client side and not jsdom */

var isBrowserClient = "production" !== 'test' && isClient;
var uuid = 0;
/** Get unique id for accessibility usage */

function getUUID() {
  var retId; // Test never reach

  /* istanbul ignore if */

  if (isBrowserClient) {
    retId = uuid;
    uuid += 1;
  } else {
    retId = 'TEST_OR_SSR';
  }

  return retId;
}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1306);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
exports.responsiveArray = responsiveArray;
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
exports.responsiveMap = responsiveMap;
var subscribers = new Map();
var subUid = -1;
var screens = {};
var responsiveObserve = {
  matchHandlers: {},
  dispatch: function dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach(function (func) {
      return func(screens);
    });
    return subscribers.size >= 1;
  },
  subscribe: function subscribe(func) {
    if (!subscribers.size) this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers["delete"](token);
    if (!subscribers.size) this.unregister();
  },
  unregister: function unregister() {
    var _this = this;

    Object.keys(responsiveMap).forEach(function (screen) {
      var matchMediaQuery = responsiveMap[screen];
      var handler = _this.matchHandlers[matchMediaQuery];
      handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register: function register() {
    var _this2 = this;

    Object.keys(responsiveMap).forEach(function (screen) {
      var matchMediaQuery = responsiveMap[screen];

      var listener = function listener(_ref) {
        var matches = _ref.matches;

        _this2.dispatch((0, _extends3["default"])((0, _extends3["default"])({}, screens), (0, _defineProperty2["default"])({}, screen, matches)));
      };

      var mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      _this2.matchHandlers[matchMediaQuery] = {
        mql: mql,
        listener: listener
      };
      listener(mql);
    });
  }
};
var _default = responsiveObserve;
exports["default"] = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertLegacyProps = convertLegacyProps;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _buttonGroup = _interopRequireDefault(__webpack_require__(1402));

var _configProvider = __webpack_require__(8);

var _wave = _interopRequireDefault(__webpack_require__(387));

var _type = __webpack_require__(118);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _LoadingIcon = _interopRequireDefault(__webpack_require__(1405));

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/button-has-type */


var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

function isString(str) {
  return typeof str === 'string';
}

function isUnborderedButtonType(type) {
  return type === 'text' || type === 'link';
} // Insert one space between two chinese characters automatically.


function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }

  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return (0, _reactNode.cloneElement)(child, {
      children: child.props.children.split('').join(SPACE)
    });
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }

    return /*#__PURE__*/React.createElement("span", null, child);
  }

  return child;
}

function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = (0, _typeof2["default"])(child);
    var isCurrentChildPure = type === 'string' || type === 'number';

    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }

    isPrevChildPure = isCurrentChildPure;
  }); // Pass to React.Children.map to auto fill key

  return React.Children.map(childList, function (child) {
    return insertSpace(child, needInserted);
  });
}

var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'link', 'text');
var ButtonShapes = (0, _type.tuple)('circle', 'round');
var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');

function convertLegacyProps(type) {
  if (type === 'danger') {
    return {
      danger: true
    };
  }

  return {
    type: type
  };
}

var InternalButton = function InternalButton(props, ref) {
  var _classNames;

  var _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      customizePrefixCls = props.prefixCls,
      type = props.type,
      danger = props.danger,
      shape = props.shape,
      customizeSize = props.size,
      className = props.className,
      children = props.children,
      icon = props.icon,
      _props$ghost = props.ghost,
      ghost = _props$ghost === void 0 ? false : _props$ghost,
      _props$block = props.block,
      block = _props$block === void 0 ? false : _props$block,
      _props$htmlType = props.htmlType,
      htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType,
      rest = __rest(props, ["loading", "prefixCls", "type", "danger", "shape", "size", "className", "children", "icon", "ghost", "block", "htmlType"]);

  var size = React.useContext(_SizeContext["default"]);

  var _React$useState = React.useState(!!loading),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      innerLoading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      hasTwoCNChar = _React$useState4[0],
      setHasTwoCNChar = _React$useState4[1];

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton,
      direction = _React$useContext.direction;

  var buttonRef = ref || /*#__PURE__*/React.createRef();
  var delayTimeoutRef = React.useRef();

  var isNeedInserted = function isNeedInserted() {
    return React.Children.count(children) === 1 && !icon && !isUnborderedButtonType(type);
  };

  var fixTwoCNChar = function fixTwoCNChar() {
    // Fix for HOC usage like <FormatMessage />
    if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) {
      return;
    }

    var buttonText = buttonRef.current.textContent;

    if (isNeedInserted() && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  }; // =============== Update Loading ===============


  var loadingOrDelay;

  if ((0, _typeof2["default"])(loading) === 'object' && loading.delay) {
    loadingOrDelay = loading.delay || true;
  } else {
    loadingOrDelay = !!loading;
  }

  React.useEffect(function () {
    clearTimeout(delayTimeoutRef.current);

    if (typeof loadingOrDelay === 'number') {
      delayTimeoutRef.current = window.setTimeout(function () {
        setLoading(loadingOrDelay);
      }, loadingOrDelay);
    } else {
      setLoading(loadingOrDelay);
    }
  }, [loadingOrDelay]);
  React.useEffect(fixTwoCNChar, [buttonRef]);

  var handleClick = function handleClick(e) {
    var onClick = props.onClick;

    if (innerLoading) {
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  (0, _devWarning["default"])(!(typeof icon === 'string' && icon.length > 2), 'Button', "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(icon, "` at https://ant.design/components/icon"));
  (0, _devWarning["default"])(!(ghost && isUnborderedButtonType(type)), 'Button', "`link` or `text` button can't be a `ghost` button.");
  var prefixCls = getPrefixCls('btn', customizePrefixCls);
  var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
  // small => sm

  var sizeCls = '';

  switch (customizeSize || size) {
    case 'large':
      sizeCls = 'lg';
      break;

    case 'small':
      sizeCls = 'sm';
      break;

    default:
      break;
  }

  var iconType = innerLoading ? 'loading' : icon;
  var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(type), type), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(shape), shape), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-background-ghost"), ghost && !isUnborderedButtonType(type)), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-loading"), innerLoading), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-block"), block), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-dangerous"), !!danger), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  var iconNode = icon && !innerLoading ? icon : /*#__PURE__*/React.createElement(_LoadingIcon["default"], {
    existIcon: !!icon,
    prefixCls: prefixCls,
    loading: !!innerLoading
  });
  var kids = children || children === 0 ? spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
  var linkButtonRestProps = (0, _omit["default"])(rest, ['navigate']);

  if (linkButtonRestProps.href !== undefined) {
    return /*#__PURE__*/React.createElement("a", (0, _extends2["default"])({}, linkButtonRestProps, {
      className: classes,
      onClick: handleClick,
      ref: buttonRef
    }), iconNode, kids);
  }

  var buttonNode = /*#__PURE__*/React.createElement("button", (0, _extends2["default"])({}, rest, {
    type: htmlType,
    className: classes,
    onClick: handleClick,
    ref: buttonRef
  }), iconNode, kids);

  if (isUnborderedButtonType(type)) {
    return buttonNode;
  }

  return /*#__PURE__*/React.createElement(_wave["default"], null, buttonNode);
};

var Button = /*#__PURE__*/React.forwardRef(InternalButton);
Button.displayName = 'Button';
Button.Group = _buttonGroup["default"];
Button.__ANT_BUTTON = true;
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(1432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(654);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Provider__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Provider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connect__ = __webpack_require__(1412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__connect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create__ = __webpack_require__(1414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__create__["a"]; });





/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1460),
    listCacheDelete = __webpack_require__(1461),
    listCacheGet = __webpack_require__(1462),
    listCacheHas = __webpack_require__(1463),
    listCacheSet = __webpack_require__(1464);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(664);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1482);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1536);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});
exports["default"] = void 0;

var _row = _interopRequireDefault(__webpack_require__(672));

var _col = _interopRequireDefault(__webpack_require__(398));

var _useBreakpoint = _interopRequireDefault(__webpack_require__(217));

var _default = {
  useBreakpoint: _useBreakpoint["default"]
};
exports["default"] = _default;

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DECADE_UNIT_DIFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DECADE_DISTANCE_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DecadeHeader__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DecadeBody__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__ = __webpack_require__(99);





var DECADE_UNIT_DIFF = 10;
var DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10;

function DecadePanel(props) {
  var prefixCls = props.prefixCls,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      operationRef = props.operationRef,
      onSelect = props.onSelect,
      onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-decade-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__["c" /* createKeyDownHandler */])(event, {
        onLeftRight: function onLeftRight(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT), 'key');
        },
        onUpDown: function onUpDown(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF * __WEBPACK_IMPORTED_MODULE_3__DecadeBody__["a" /* DECADE_COL_COUNT */]), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange('year', viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onDecadesChange = function onDecadesChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  var onInternalSelect = function onInternalSelect(date) {
    onSelect(date, 'mouse');
    onPanelChange('year', date);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DecadeHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onPrevDecades: function onPrevDecades() {
      onDecadesChange(-1);
    },
    onNextDecades: function onNextDecades() {
      onDecadesChange(1);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__DecadeBody__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onSelect: onInternalSelect
  })));
}

/* harmony default export */ __webpack_exports__["c"] = (DecadePanel);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = setDateTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLowerBoundTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLastDay;
function setTime(generateConfig, date, hour, minute, second) {
  var nextTime = generateConfig.setHour(date, hour);
  nextTime = generateConfig.setMinute(nextTime, minute);
  nextTime = generateConfig.setSecond(nextTime, second);
  return nextTime;
}
function setDateTime(generateConfig, date, defaultDate) {
  if (!defaultDate) {
    return date;
  }

  var newDate = date;
  newDate = generateConfig.setHour(newDate, generateConfig.getHour(defaultDate));
  newDate = generateConfig.setMinute(newDate, generateConfig.getMinute(defaultDate));
  newDate = generateConfig.setSecond(newDate, generateConfig.getSecond(defaultDate));
  return newDate;
}
function getLowerBoundTime(hour, minute, second, hourStep, minuteStep, secondStep) {
  var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;

  if (lowerBoundHour < hour) {
    return [lowerBoundHour, 60 - minuteStep, 60 - secondStep];
  }

  var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;

  if (lowerBoundMinute < minute) {
    return [lowerBoundHour, lowerBoundMinute, 60 - secondStep];
  }

  var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
  return [lowerBoundHour, lowerBoundMinute, lowerBoundSecond];
}
function getLastDay(generateConfig, date) {
  var year = generateConfig.getYear(date);
  var month = generateConfig.getMonth(date) + 1;
  var endDate = generateConfig.getEndDate(generateConfig.getFixedDate("".concat(year, "-").concat(month, "-01")));
  var lastDay = generateConfig.getDate(endDate);
  var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
  return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCellClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__ = __webpack_require__(147);



function useCellClassName(_ref) {
  var cellPrefixCls = _ref.cellPrefixCls,
      generateConfig = _ref.generateConfig,
      rangedValue = _ref.rangedValue,
      hoverRangedValue = _ref.hoverRangedValue,
      isInView = _ref.isInView,
      isSameCell = _ref.isSameCell,
      offsetCell = _ref.offsetCell,
      today = _ref.today,
      value = _ref.value;

  function getClassName(currentDate) {
    var _ref2;

    var prevDate = offsetCell(currentDate, -1);
    var nextDate = offsetCell(currentDate, 1);
    var rangeStart = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(rangedValue, 0);
    var rangeEnd = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(rangedValue, 1);
    var hoverStart = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(hoverRangedValue, 0);
    var hoverEnd = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(hoverRangedValue, 1);
    var isRangeHovered = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateUtil__["h" /* isInRange */])(generateConfig, hoverStart, hoverEnd, currentDate);

    function isRangeStart(date) {
      return isSameCell(rangeStart, date);
    }

    function isRangeEnd(date) {
      return isSameCell(rangeEnd, date);
    }

    var isHoverStart = isSameCell(hoverStart, currentDate);
    var isHoverEnd = isSameCell(hoverEnd, currentDate);
    var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
    var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
    return _ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-in-range"), Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateUtil__["h" /* isInRange */])(generateConfig, rangeStart, rangeEnd, currentDate)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateUtil__["h" /* isInRange */])(generateConfig, hoverStart, hoverEnd, prevDate))), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateUtil__["h" /* isInRange */])(generateConfig, hoverStart, hoverEnd, nextDate))), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
  }

  return getClassName;
}

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(189);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var Element = function Element(props) {
  var _classNames, _classNames2;

  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      size = props.size,
      shape = props.shape;
  var sizeCls = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
  var shapeCls = (0, _classnames["default"])((_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-round"), shape === 'round'), _classNames2));
  var sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px")
  } : {};
  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(prefixCls, sizeCls, shapeCls, className),
    style: (0, _extends2["default"])((0, _extends2["default"])({}, sizeStyle), style)
  });
};

var _default = Element;
exports["default"] = _default;

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dnd_core_1 = __webpack_require__(1762);
var checkDecoratorArguments_1 = __webpack_require__(304);
var isRefable_1 = __webpack_require__(417);
var invariant = __webpack_require__(25);
var hoistStatics = __webpack_require__(418);
/**
 * Create the React Context
 */
exports.context = React.createContext({
    dragDropManager: undefined,
});
exports.Consumer = exports.context.Consumer, exports.Provider = exports.context.Provider;
/**
 * Creates the context object we're providing
 * @param backend
 * @param context
 */
function createChildContext(backend, context, debugMode) {
    return {
        dragDropManager: dnd_core_1.createDragDropManager(backend, context, debugMode),
    };
}
exports.createChildContext = createChildContext;
/**
 * A React component that provides the React-DnD context
 */
exports.DragDropContextProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var contextValue = 'manager' in props
        ? { dragDropManager: props.manager }
        : createChildContext(props.backend, props.context, props.debugMode);
    return React.createElement(exports.Provider, { value: contextValue }, children);
};
/**
 * Wrap the root component of your application with DragDropContext decorator to set up React DnD.
 * This lets you specify the backend, and sets up the shared DnD state behind the scenes.
 * @param backendFactory The DnD backend factory
 * @param backendContext The backend context
 */
function DragDropContext(backendFactory, backendContext, debugMode) {
    checkDecoratorArguments_1.default('DragDropContext', 'backend', backendFactory);
    var childContext = createChildContext(backendFactory, backendContext, debugMode);
    return function decorateContext(DecoratedComponent) {
        var Decorated = DecoratedComponent;
        var displayName = Decorated.displayName || Decorated.name || 'Component';
        var DragDropContextContainer = /** @class */ (function (_super) {
            __extends(DragDropContextContainer, _super);
            function DragDropContextContainer() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.ref = React.createRef();
                _this.getManager = function () { return childContext.dragDropManager; };
                return _this;
            }
            DragDropContextContainer.prototype.getDecoratedComponentInstance = function () {
                invariant(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
                return this.ref.current;
            };
            DragDropContextContainer.prototype.render = function () {
                return (React.createElement(exports.Provider, { value: childContext },
                    React.createElement(Decorated, __assign({}, this.props, { ref: isRefable_1.isRefable(Decorated) ? this.ref : null }))));
            };
            DragDropContextContainer.DecoratedComponent = DecoratedComponent;
            DragDropContextContainer.displayName = "DragDropContext(" + displayName + ")";
            return DragDropContextContainer;
        }(React.Component));
        return hoistStatics(DragDropContextContainer, DecoratedComponent);
    };
}
exports.DragDropContext = DragDropContext;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var beginDrag_1 = __webpack_require__(1767);
var publishDragSource_1 = __webpack_require__(1769);
var hover_1 = __webpack_require__(1770);
var drop_1 = __webpack_require__(1771);
var endDrag_1 = __webpack_require__(1772);
__export(__webpack_require__(152));
function createDragDropActions(manager) {
    return {
        beginDrag: beginDrag_1.default(manager),
        publishDragSource: publishDragSource_1.default(manager),
        hover: hover_1.default(manager),
        drop: drop_1.default(manager),
        endDrag: endDrag_1.default(manager),
    };
}
exports.default = createDragDropActions;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: exports.ADD_SOURCE,
        payload: {
            sourceId: sourceId,
        },
    };
}
exports.addSource = addSource;
function addTarget(targetId) {
    return {
        type: exports.ADD_TARGET,
        payload: {
            targetId: targetId,
        },
    };
}
exports.addTarget = addTarget;
function removeSource(sourceId) {
    return {
        type: exports.REMOVE_SOURCE,
        payload: {
            sourceId: sourceId,
        },
    };
}
exports.removeSource = removeSource;
function removeTarget(targetId) {
    return {
        type: exports.REMOVE_TARGET,
        payload: {
            targetId: targetId,
        },
    };
}
exports.removeTarget = removeTarget;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function checkDecoratorArguments(functionName, signature) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (false) {
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var arg = args_1[_a];
            if (arg && arg.prototype && arg.prototype.render) {
                // eslint-disable-next-line no-console
                console.error('You seem to be applying the arguments in the wrong order. ' +
                    ("It should be " + functionName + "(" + signature + ")(Component), not the other way around. ") +
                    'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
                return;
            }
        }
    }
}
exports.default = checkDecoratorArguments;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(808);
var removeEntitiesAtEdges = __webpack_require__(809);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */

var DraftEntityInstance = __webpack_require__(813);
var Immutable = __webpack_require__(32);

var invariant = __webpack_require__(34);

var Map = Immutable.Map;


var instances = Map();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

module.exports = DraftEntity;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2019);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }

  return r1.offset - r2.offset;
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitReactElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom_server__);


 // see http://w3c.github.io/html/syntax.html#writing-html-documents-elements

var VOID_TAGS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
function splitReactElement(element) {
  if (VOID_TAGS.indexOf(element.type) !== -1) {
    return __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default.a.renderToStaticMarkup(element);
  }

  var tags = __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default.a.renderToStaticMarkup(__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {}, '\r')).split('\r');
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(tags.length > 1, "convertToHTML: Element of type ".concat(element.type, " must render children"));
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(tags.length < 3, "convertToHTML: Element of type ".concat(element.type, " cannot use carriage return character"));
  return {
    start: tags[0],
    end: tags[1]
  };
}

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrandList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandListEditor", function() { return BrandListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_module_scss__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,"VC_CONFIG.PLUGIN_ASSETS_URL");var INDEX_URL=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,"VC_CONFIG.INDEX_URL");var Locale=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,"VC_CONFIG.Locale");var FormItem=__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item;var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.split(text,"\n"),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],{key:idx},line,wp.element.createElement("br",null));});};// 前端頁面
var BrandList=function(_Component){_inherits(BrandList,_Component);function BrandList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrandList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrandList.__proto__||Object.getPrototypeOf(BrandList)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:"info",query:{cid:null,keyword:null},brandInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},vip:0},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_12_jquery___default()(document).on("click","#brand div a",function(){var $text=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).attr("alt");dataLayer.push({event:"brand_click",item:$text});});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_16__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_15__configs_env__["b" /* API_HOST */]+"/api/v1/system/configs",{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?"發生錯誤":_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:"發生錯誤"});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_16__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_15__configs_env__["b" /* API_HOST */]+"/api/v1/brands",{page_size:"all",keyword:query.keyword},function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?"發生錯誤":_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log("loadData",code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning(reason);_this.props.history.replace("/brands");return;}_this.setState({brandInfo:data.rows});});},_this.loadBanner=function(){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_16__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_15__configs_env__["b" /* API_HOST */]+"/api/v1/news?",{"category_ids[]":110},function(state,res){_this.setState({isFetchData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?"發生錯誤":_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;console.log("loadBanner",code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning(reason);_this.props.history.replace("/brands");return;}_this.setState({listInfo:data.rows});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_12_jquery___default()(".selectpicker").selectpicker("refresh");},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,"state.query",{});__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.set(query,key,value);_this.setState({query:query});window.location.href=_this.getSearchPath(query);},_this.getSearchPath=function(query){if(Locale=="en_US")return window.VC_CONFIG.INDEX_URL+"/brands-en/#"+__WEBPACK_IMPORTED_MODULE_11_query_string___default.a.stringify(query,{skipNull:true});return window.VC_CONFIG.INDEX_URL+"/brands/#"+__WEBPACK_IMPORTED_MODULE_11_query_string___default.a.stringify(query,{skipNull:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrandList,[{key:"componentDidMount",value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__["a" /* default */].getHashParamaters();this.loadConfig();this.loadData(query);this.loadBanner();this.setState({query:query});this.GTM();}},{key:"render",value:function render(){var _this2=this;var tabType=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.tabType",{});var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.options",{});var query=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.query",{});var vip=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.vip");var brandInfo=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.brandInfo",{});var listInfo=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,"state.listInfo");var categoryOptions=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(options,"food_categories",[]).concat(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(options,"brand_categories",[])).filter(function(categoryInfo){return!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(categoryInfo.items);});var Local=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,"VC_CONFIG.Locale");var brand_categorys=categoryOptions;var keyword_ids=[];var keyword_cate=[];var vip_cate=[];if(query.cid){brand_categorys=brand_categorys.filter(function(categoryInfo){return categoryInfo.id==query.cid;});}if(query.keyword){__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(brandInfo,function(info){keyword_ids.push(info.id);});__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(brand_categorys,function(categoryInfo){__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(categoryInfo,"items",[]),function(Info){if(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(keyword_ids,function(id){return Info.id==id;})&&!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(keyword_cate,function(id){return categoryInfo.id==id;})){keyword_cate.push(categoryInfo.id);}});});brand_categorys=brand_categorys.filter(function(categoryInfo){return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(keyword_cate,function(id){return categoryInfo.id==id;});});}if(vip==1){__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(brand_categorys,function(categoryInfo){__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(categoryInfo,"items",[]),function(Info){if(Info.is_vip==vip&&!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(vip_cate,function(id){return categoryInfo.id==id;})){vip_cate.push(categoryInfo.id);}});});brand_categorys=brand_categorys.filter(function(categoryInfo){return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(vip_cate,function(id){return categoryInfo.id==id;});});}this.refreshPicker();return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement("div",{"class":"bg-light"},wp.element.createElement("div",{"class":"container"},wp.element.createElement("div",{"class":"breadcrumb-wrap py-4 m-0"},wp.element.createElement("nav",{"aria-label":"breadcrumb"},wp.element.createElement("ol",{"class":"breadcrumb"},wp.element.createElement("li",{"class":"breadcrumb-item"},wp.element.createElement("a",{href:""+window.VC_CONFIG.INDEX_URL+(Local=="en_US"?"/en":"")},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])("首頁","cec-plugin-stores"))),wp.element.createElement("li",{"class":"breadcrumb-item"},wp.element.createElement("a",{href:window.VC_CONFIG.INDEX_URL+"/shopping-mall"+(Local=="en_US"?"-en":"")},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])("購物中心","cec-plugin-stores"))),wp.element.createElement("li",{"class":"breadcrumb-item"},wp.element.createElement("a",{href:window.VC_CONFIG.INDEX_URL+"/brands"+(Local=="en_US"?"-en":"")},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])("合作品牌","cec-plugin-stores")))))))),wp.element.createElement("div",{"class":"banner-location"},wp.element.createElement("div",{"class":"banner-image"},listInfo&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.head(listInfo),"images.0.url")&&wp.element.createElement("img",{src:""+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.head(listInfo),"images.0.url"),alt:""}),(!listInfo||!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.head(listInfo),"images.0.url"))&&wp.element.createElement("img",{src:PLUGIN_ASSETS_URL+"img/banner/store/banner-brand.png",alt:""}))),wp.element.createElement("main",{"class":"bg-light"},wp.element.createElement("div",{"class":"container"},wp.element.createElement("div",{"class":"map-filter-bar outer"},wp.element.createElement("div",{"class":"row justify-content-center no-gutters mx-n2 pt-4"},wp.element.createElement("div",{"class":"col-md-3 px-2"},wp.element.createElement("div",{className:"form-group"},wp.element.createElement("select",{className:"form-select selectpicker",name:"category_id",value:query.cid,onChange:function onChange(e){return _this2.handleQueryUpdate("cid",e.target.value);}},wp.element.createElement("option",{value:undefined,disabled:true},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])("請選擇類別","cec-plugin-stores")),wp.element.createElement("option",{value:""},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])("所有類別","cec-plugin-stores")," "),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(categoryOptions,function(item){return wp.element.createElement("option",{key:item.id,value:item.id},item.name);})))),wp.element.createElement("div",{"class":"col-md-3 px-2"},wp.element.createElement("div",{className:"form-group"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:"\u641C\u5C0B\u540D\u7A31",size:"large",style:{height:"50px"},value:query.keyword,onChange:function onChange(e){return _this2.handleQueryUpdate("keyword",e.target.value);}}))),wp.element.createElement("div",{"class":"col-md-auto px-2"},wp.element.createElement("a",{role:"button",className:"btn btn-primary btn-search",onClick:function onClick(){_this2.loadData(query);}},wp.element.createElement("i",{className:"icon-search mr-3 mr-md-0 ",style:{color:"#FFFFFF"}})))))),wp.element.createElement("div",{className:"container"},wp.element.createElement("div",{className:"d-flex align-items-md-center justify-content-between pt-4"},wp.element.createElement("div",{"class":"ml-auto",style:{padding:"20px"}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default.a,{checkedChildren:"vip\u7279\u7D04\u5546\u5E97",unCheckedChildren:"vip\u7279\u7D04\u5546\u5E97",onChange:function onChange(value){var val=0;if(value===true)val=1;else val=0;_this2.setState({vip:val});}})))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(brand_categorys,function(categoryInfo){return wp.element.createElement("div",{"class":"container",key:categoryInfo.id},wp.element.createElement("h4",{"class":"heading-title justify-content-center"},categoryInfo.name),wp.element.createElement("hr",{"class":"border-top border-navy mt-0 mb-4"}),wp.element.createElement("div",{"class":"mb-5"},wp.element.createElement("div",{id:"brand","class":"row"},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(categoryInfo,"items",[]),function(Info){if(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(brandInfo,function(brandInfo){return brandInfo.id==Info.id;})&&(vip==0||vip==1&&Info.is_vip&&Info.is_vip==vip)){return wp.element.createElement("div",{"class":"col-4 col-md-3 col-lg-2 my-4"},wp.element.createElement("a",{alt:Info.name,role:"button","class":"store-brand-logo-link",href:INDEX_URL+"/brand-info"+(Locale=="en_US"?"-en":"")+"/?brand="+Info.name},wp.element.createElement("img",{src:Info.image,alt:Info.name})));}}))));})));}}]);return BrandList;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var BrandListEditor=function(_Component2){_inherits(BrandListEditor,_Component2);function BrandListEditor(){_classCallCheck(this,BrandListEditor);return _possibleConstructorReturn(this,(BrandListEditor.__proto__||Object.getPrototypeOf(BrandListEditor)).apply(this,arguments));}_createClass(BrandListEditor,[{key:"render",value:function render(){return wp.element.createElement("div",{className:"vu-blocks-editor"},"\u7DE8\u8F2F\u5668");}}]);return BrandListEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _constants = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants.BARS[index] ? _constants.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3.default);

exports.default = CODE128;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mod10 = mod10;
exports.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (old, replaceObj) {
  return _extends({}, old, replaceObj);
};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(853);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"code":"","name":"客服建議","items":[{"code":"ec66bd66-1428-40bf-be14-b6243bda0e26","name":"建議查詢  Inquiry","id":"1","items":[{"name":"線上購物Online Shopping","id":65,"items":[]},{"name":"產品查詢 / 建議Product Inquiry/ Suggestion","id":"15","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"27"},{"name":"生鮮商品Fresh","id":"28"},{"name":"家用百貨/五金類商品Bazzar","id":"29"},{"name":"家電商品Appliance","id":"30"},{"name":"紡織/鞋子商品Textile","id":"31"}]},{"name":"欲成為合作廠商來信Supplier Inquiry","id":"16","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"32"},{"name":"生鮮商品Fresh","id":"33"},{"name":"家用百貨/五金類商品Bazzar","id":"34"},{"name":"家電商品Appliance","id":"35"},{"name":"紡織/鞋子商品Textile","id":"36"}]},{"name":"詐騙電話Telefraud","id":"17","items":[]},{"name":"其他Others","id":"18","items":[]},{"name":"會員卡相關問題 Member Card","id":"35","items":[]}]},{"code":"7ee77de0-6698-4a15-86d8-61f9ddd53435","name":"問題反映 Complaint","id":"2","items":[{"name":"線上購物Online Shopping","id":71,"items":[]},{"name":"服務品質Service Quality","id":"30","items":[]},{"name":"產品品質/價格相關問題Product Quality","id":"31","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"name":"安全檢查/停車相關問題Security&Parking","id":"32","items":[]},{"name":"會員卡相關問題 Member Card","id":"33","items":[]},{"name":"其他Others","id":"34","items":[]}]},{"code":"7fc29946-b0a3-452b-9e80-a0b1b3b38822","name":"感謝函 Praise","id":"3","items":[{"name":"感謝函 Praise","id":"55","items":[]}]}]},{"id":2,"code":"","name":"新品推薦","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":3,"code":"","name":"缺貨回報","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":4,"code":"","name":"買貴回報","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":5,"code":"","name":"服務建議","items":[{"name":"服務品質Service Quality","id":"30","items":[]},{"name":"產品品質/價格相關問題Product Quality","id":"31","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"name":"安全檢查/停車相關問題Security&Parking","id":"32","items":[]},{"name":"會員卡相關問題 Member Card","id":"33","items":[]},{"name":"其他Others","id":"34","items":[]}]}]

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = [{"code":"39026e1a-02c5-4119-b7c9-68975fd4a806","name":"線上購物 On line shopping","Sort":13,"UnitCode":"Online shopping","id":"27","items":null,"ShowStoreMenu":false},{"code":"39026e1a-02c5-4119-b7c9-68975fd4a807","name":"通路門市Store","Sort":14,"UnitCode":"Store","id":"28","items":null,"ShowStoreMenu":false},{"code":"697883d7-0daa-4ced-be27-959b248c4979","name":"會員卡相關問題Loyalty card","Sort":0,"UnitCode":"CARD","id":"1","items":null,"ShowStoreMenu":false},{"code":"deacbd20-503d-44bb-8b9c-2d3c13171eba","name":"網站相關問題Website","Sort":3,"UnitCode":"WEBSITE","id":"4","items":null,"ShowStoreMenu":false},{"code":"277760a3-c037-4695-8b8d-5601396b5f74","name":"自有品牌商品PLB product","Sort":2,"UnitCode":"PLB","id":"3","items":null,"ShowStoreMenu":false},{"code":"fb862c6e-c554-4394-94c5-f0707966ad7c","name":"美食街/商店街相關問題 Shopping Mall","Sort":4,"UnitCode":"SHOPPINGMALL","id":"5","items":null,"ShowStoreMenu":false},{"code":"b93940e3-bb11-4f11-91ae-9c0d2c92c23d","name":"總公司Head office","Sort":1,"UnitCode":"HO","id":"2","items":null,"ShowStoreMenu":false}]

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"code":"","name":"客服建議","en_name":"Customer service suggestions"},{"id":2,"code":"","name":"新品推薦","en_name":"New Product"},{"id":3,"code":"","name":"缺貨回報","en_name":"Out of Stock Return"},{"id":4,"code":"","name":"買貴回報","en_name":"Buy expensive returns"},{"id":5,"code":"","name":"服務建議","en_name":"Service suggestion"}]

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = [{"type":0,"id":"hyper","name":"大型量販","items":[{"id":"Uniprosperity ","name":" Uniprosperity","ch_name":"Uniprosperity","en_name":"","type":0},{"id":"RT-Mart 大潤發","name":"大潤發 RT-Mart","ch_name":"RT-Mart","en_name":"大潤發","type":0},{"id":"Save & Safe 大買家","name":"大買家 Save & Safe","ch_name":"Save & Safe","en_name":"大買家","type":0},{"id":"Tuntex Mart 東帝士","name":"東帝士 Tuntex Mart","ch_name":"Tuntex Mart","en_name":"東帝士","type":0},{"id":"Amart 愛買","name":"愛買 Amart","ch_name":"Amart","en_name":"愛買","type":0},{"id":"Buying 全買","name":"全買 Buying","ch_name":"Buying","en_name":"全買","type":0},{"id":"Shi-Hu-Huei 喜互惠量販","name":"喜互惠量販 Shi-Hu-Huei","ch_name":"Shi-Hu-Huei","en_name":"喜互惠量販","type":0},{"id":"Taisuco 台糖","name":"台糖 Taisuco","ch_name":"Taisuco","en_name":"台糖","type":0},{"id":"Dollars 大樂","name":"大樂 Dollars","ch_name":"Dollars","en_name":"大樂","type":0},{"id":"Costco 好市多","name":"好市多 Costco","ch_name":"Costco","en_name":"好市多","type":0}]},{"type":1,"id":"super","name":"連鎖超市","items":[{"id":"Convenient-Buy 便利購","name":"便利購 Convenient-Buy","ch_name":"Convenient-Buy","en_name":"便利購","type":1},{"id":"PX Mart (Total) 全聯福利中心 (全部)","name":"全聯福利中心 (全部) PX Mart (Total)","ch_name":"PX Mart (Total)","en_name":"全聯福利中心 (全部)","type":1},{"id":"Wellcome 頂好超市","name":"頂好超市 Wellcome","ch_name":"Wellcome","en_name":"頂好超市","type":1},{"id":"Simple Mart 美廉社","name":"美廉社 Simple Mart","ch_name":"Simple Mart","en_name":"美廉社","type":1},{"id":"Farmers’ Association 縣市農會","name":"縣市農會 Farmers’ Association","ch_name":"Farmers’ Association","en_name":"縣市農會","type":1},{"id":"Matsusei (Sung-Ching) 松青","name":"松青 Matsusei (Sung-Ching)","ch_name":"Matsusei (Sung-Ching)","en_name":"松青","type":1},{"id":"Freedom Alliance 自由聯盟","name":"自由聯盟 Freedom Alliance","ch_name":"Freedom Alliance","en_name":"自由聯盟","type":1},{"id":"Small North 小北百貨","name":"小北百貨 Small North","ch_name":"Small North","en_name":"小北百貨","type":1},{"id":"Sinon 台灣楓康","name":"台灣楓康 Sinon","ch_name":"Sinon","en_name":"台灣楓康","type":1},{"id":"Shi Mei 喜美","name":"喜美 Shi Mei","ch_name":"Shi Mei","en_name":"喜美","type":1},{"id":"D-Mart 主婦省錢","name":"主婦省錢 D-Mart","ch_name":"D-Mart","en_name":"主婦省錢","type":1},{"id":"Tong-Gwan 統冠","name":"統冠 Tong-Gwan","ch_name":"Tong-Gwan","en_name":"統冠","type":1},{"id":"Jasons market Jasons","name":"Jasons Jasons market","ch_name":"Jasons market","en_name":"Jasons","type":1},{"id":"SKM supermarket 新光三越超市","name":"新光三越超市 SKM supermarket","ch_name":"SKM supermarket","en_name":"新光三越超市","type":1}]},{"type":2,"id":"cvs","name":"便利商店","items":[{"id":"7-Eleven 統一超商","name":"統一超商 7-Eleven","ch_name":"7-Eleven","en_name":"統一超商","type":2},{"id":"Family Mart 全家便利","name":"全家便利 Family Mart","ch_name":"Family Mart","en_name":"全家便利","type":2},{"id":"Hi-Life 萊爾富","name":"萊爾富 Hi-Life","ch_name":"Hi-Life","en_name":"萊爾富","type":2},{"id":"Circle K OK","name":"OK Circle K","ch_name":"Circle K","en_name":"OK","type":2}]},{"type":3,"id":"pharmacy","name":"美容藥妝","items":[{"id":"Watson's 屈臣氏","name":"屈臣氏 Watson's","ch_name":"Watson's","en_name":"屈臣氏","type":3},{"id":"Ever Green    長青連鎖藥局","name":"長青連鎖藥局 Ever Green   ","ch_name":"Ever Green   ","en_name":"長青連鎖藥局","type":3},{"id":"Cosmed 康是美","name":"康是美 Cosmed","ch_name":"Cosmed","en_name":"康是美","type":3},{"id":"Wei Kong 維康","name":"維康 Wei Kong","ch_name":"Wei Kong","en_name":"維康","type":3},{"id":"Health  Trend 2001    中美連鎖藥局","name":"中美連鎖藥局 Health  Trend 2001   ","ch_name":"Health  Trend 2001   ","en_name":"中美連鎖藥局","type":3},{"id":"MedFirst Healthcare 杏一","name":"杏一 MedFirst Healthcare","ch_name":"MedFirst Healthcare","en_name":"杏一","type":3},{"id":"Yes Chain 躍獅連鎖藥局","name":"躍獅連鎖藥局 Yes Chain","ch_name":"Yes Chain","en_name":"躍獅連鎖藥局","type":3},{"id":"The Medicine Shoppe 博登藥局","name":"博登藥局 The Medicine Shoppe","ch_name":"The Medicine Shoppe","en_name":"博登藥局","type":3},{"id":"Tin Tin 丁丁藥局","name":"丁丁藥局 Tin Tin","ch_name":"Tin Tin","en_name":"丁丁藥局","type":3},{"id":"Who 華特健康廣場","name":"華特健康廣場 Who","ch_name":"Who","en_name":"華特健康廣場","type":3},{"id":"Long Shin 健康人生藥局","name":"健康人生藥局 Long Shin","ch_name":"Long Shin","en_name":"健康人生藥局","type":3},{"id":"Poya  寶雅","name":"寶雅 Poya ","ch_name":"Poya ","en_name":"寶雅","type":3},{"id":"Ming  Chia  Mei 名佳美","name":"名佳美 Ming  Chia  Mei","ch_name":"Ming  Chia  Mei","en_name":"名佳美","type":3},{"id":"Meei   Hwa   Tai 美華泰","name":"美華泰 Meei   Hwa   Tai","ch_name":"Meei   Hwa   Tai","en_name":"美華泰","type":3},{"id":"Momo momo 藥妝","name":"momo 藥妝 Momo","ch_name":"Momo","en_name":"momo 藥妝","type":3},{"id":"J-Mart 佳瑪生活廣場","name":"佳瑪生活廣場 J-Mart","ch_name":"J-Mart","en_name":"佳瑪生活廣場","type":3},{"id":"ACE top1 A+1百貨","name":"A+1百貨 ACE top1","ch_name":"ACE top1","en_name":"A+1百貨","type":3}]},{"type":4,"id":"bazaar","name":"文具家居","items":[{"id":"I House 特力屋","name":"特力屋 I House","ch_name":"I House","en_name":"特力屋","type":4},{"id":"Home Box  好博家","name":"好博家 Home Box ","ch_name":"Home Box ","en_name":"好博家","type":4},{"id":"Hola  和樂家居館","name":"和樂家居館 Hola ","ch_name":"Hola ","en_name":"和樂家居館","type":4},{"id":"Nitori 宜得利傢俱","name":"宜得利傢俱 Nitori","ch_name":"Nitori","en_name":"宜得利傢俱","type":4},{"id":"Ikea 宜家家居","name":"宜家家居 Ikea","ch_name":"Ikea","en_name":"宜家家居","type":4},{"id":"Working House  生活工場","name":"生活工場 Working House ","ch_name":"Working House ","en_name":"生活工場","type":4},{"id":"Daiso 大創","name":"大創 Daiso","ch_name":"Daiso","en_name":"大創","type":4},{"id":"Muji 無印良品","name":"無印良品 Muji","ch_name":"Muji","en_name":"無印良品","type":4},{"id":"Toys' Rus 玩具反斗城","name":"玩具反斗城 Toys' Rus","ch_name":"Toys' Rus","en_name":"玩具反斗城","type":4},{"id":"Kingstone 金石堂","name":"金石堂 Kingstone","ch_name":"Kingstone","en_name":"金石堂","type":4},{"id":"Jin Yu Tang  金玉堂文具","name":"金玉堂文具 Jin Yu Tang ","ch_name":"Jin Yu Tang ","en_name":"金玉堂文具","type":4},{"id":"Eslite 誠品","name":"誠品 Eslite","ch_name":"Eslite","en_name":"誠品","type":4},{"id":"Nobel Book 諾貝爾書店","name":"諾貝爾書店 Nobel Book","ch_name":"Nobel Book","en_name":"諾貝爾書店","type":4},{"id":"Stepping Stone 墊腳石文化廣場","name":"墊腳石文化廣場 Stepping Stone","ch_name":"Stepping Stone","en_name":"墊腳石文化廣場","type":4},{"id":"Kong Nan 光南","name":"光南 Kong Nan","ch_name":"Kong Nan","en_name":"光南","type":4},{"id":"9 x 9 9乘9","name":"9乘9 9 x 9","ch_name":"9 x 9","en_name":"9乘9","type":4},{"id":"Decathlon 迪卡儂","name":"迪卡儂 Decathlon","ch_name":"Decathlon","en_name":"迪卡儂","type":4},{"id":"Richahaus 麗車坊","name":"麗車坊 Richahaus","ch_name":"Richahaus","en_name":"麗車坊","type":4},{"id":"9 to 9 耐途耐","name":"耐途耐 9 to 9","ch_name":"9 to 9","en_name":"耐途耐","type":4},{"id":"Car quality 車麗屋","name":"車麗屋 Car quality","ch_name":"Car quality","en_name":"車麗屋","type":4}]},{"type":5,"id":"appliance","name":"連鎖家電","items":[{"id":"Tsann Kuen (3C) 燦坤 (3C)","name":"燦坤 (3C) Tsann Kuen (3C)","ch_name":"Tsann Kuen (3C)","en_name":"燦坤 (3C)","type":5},{"id":"Onking (app. + digital) 全國電子","name":"全國電子 Onking (app. + digital)","ch_name":"Onking (app. + digital)","en_name":"全國電子","type":5},{"id":"Tatung 3C 大同3C","name":"大同3C Tatung 3C","ch_name":"Tatung 3C","en_name":"大同3C","type":5},{"id":"Shun Fa 3C 順發3C","name":"順發3C Shun Fa 3C","ch_name":"Shun Fa 3C","en_name":"順發3C","type":5}]},{"type":6,"id":"online","name":"線上購物","items":[{"id":"ibon mart  ibon mart ","name":"ibon mart  ibon mart ","ch_name":"ibon mart ","en_name":"ibon mart ","type":6},{"id":"A.Mart online shopping 愛買網路商店","name":"愛買網路商店 A.Mart online shopping","ch_name":"A.Mart online shopping","en_name":"愛買網路商店","type":6},{"id":"ASAP ASAP 閃電購物網","name":"ASAP 閃電購物網 ASAP","ch_name":"ASAP","en_name":"ASAP 閃電購物網","type":6},{"id":"Books 博客來","name":"博客來 Books","ch_name":"Books","en_name":"博客來","type":6},{"id":"online shopping 網路商店","name":"網路商店 online shopping","ch_name":"online shopping","en_name":"網路商店","type":6},{"id":"Costco online shopping 好市多網路商店","name":"好市多網路商店 Costco online shopping","ch_name":"Costco online shopping","en_name":"好市多網路商店","type":6},{"id":"ET Mall 東森購物","name":"東森購物 ET Mall","ch_name":"ET Mall","en_name":"東森購物","type":6},{"id":"Friday FriDay","name":"FriDay Friday","ch_name":"Friday","en_name":"FriDay","type":6},{"id":"Go Happy Go Happy 快樂購物網","name":"Go Happy 快樂購物網 Go Happy","ch_name":"Go Happy","en_name":"Go Happy 快樂購物網","type":6},{"id":"Momo Momo","name":"Momo Momo","ch_name":"Momo","en_name":"Momo","type":6},{"id":"Myfone shopping Myfone 購物","name":"Myfone 購物 Myfone shopping","ch_name":"Myfone shopping","en_name":"Myfone 購物","type":6},{"id":"Pay Easy Pay Easy 女性購物","name":"Pay Easy 女性購物 Pay Easy","ch_name":"Pay Easy","en_name":"Pay Easy 女性購物","type":6},{"id":"Pchome shopping Pchome 購物","name":"Pchome 購物 Pchome shopping","ch_name":"Pchome shopping","en_name":"Pchome 購物","type":6},{"id":"RT-Mart online shopping 大潤發網路商店","name":"大潤發網路商店 RT-Mart online shopping","ch_name":"RT-Mart online shopping","en_name":"大潤發網路商店","type":6},{"id":"Ruten auction 露天拍賣","name":"露天拍賣 Ruten auction","ch_name":"Ruten auction","en_name":"露天拍賣","type":6},{"id":"Save & Safe online shopping 大買家網路商店","name":"大買家網路商店 Save & Safe online shopping","ch_name":"Save & Safe online shopping","en_name":"大買家網路商店","type":6},{"id":"Taobao 淘寶","name":"淘寶 Taobao","ch_name":"Taobao","en_name":"淘寶","type":6},{"id":"Tsann Kuen 3C online shopping 燦坤3C 快3網路商城","name":"燦坤3C 快3網路商城 Tsann Kuen 3C online shopping","ch_name":"Tsann Kuen 3C online shopping","en_name":"燦坤3C 快3網路商城","type":6},{"id":"UDN shopping UDN買東西","name":"UDN買東西 UDN shopping","ch_name":"UDN shopping","en_name":"UDN買東西","type":6},{"id":"U-Mall 森森購物","name":"森森購物 U-Mall","ch_name":"U-Mall","en_name":"森森購物","type":6},{"id":"Yahoo auction 雅虎 Yahoo! 拍賣","name":"雅虎 Yahoo! 拍賣 Yahoo auction","ch_name":"Yahoo auction","en_name":"雅虎 Yahoo! 拍賣","type":6},{"id":"Yahoo shopping 雅虎 Yahoo! 購物中心","name":"雅虎 Yahoo! 購物中心 Yahoo shopping","ch_name":"Yahoo shopping","en_name":"雅虎 Yahoo! 購物中心","type":6}]}]

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBlockTypeByName", function() { return getBlockTypeByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBlockMountIdByName", function() { return getBlockMountIdByName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_wjson__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/**
 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
 * @param {Object} props Props.
 * @returns {Mixed} JSX Component.
 */__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mixin({pascalCase:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flow(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.upperFirst)});function pascalCase(str){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.startCase(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.camelCase(str)).replace(/ /g,'');}var _wp$blocks=wp.blocks,registerBlockType=_wp$blocks.registerBlockType,getCategories=_wp$blocks.getCategories,setCategories=_wp$blocks.setCategories;var categorySlug='cec-blocks';var blockCategories=getCategories();if(!blockCategories.find(function(c){return c.slug===categorySlug;})){blockCategories.push({slug:categorySlug,name:'模組',icon:null});setCategories(blockCategories);}/**
 *
 * @param [] settings
 */var getBlockTypeByName=function getBlockTypeByName(name){return'cec-vulcan-block/'+name;};var getBlockMountIdByName=function getBlockMountIdByName(name){return'cec-vulcan-block-'+name;};var registerVulcanBlockType=function registerVulcanBlockType(){var settings=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];settings.forEach(function(item){//console.log('registerVulcanBlockType', item)
var save=null;try{var saveFilePath='./'+item.module+'/'+item.name+'-save';save=!(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()).default;}catch(ex){// console.error(ex);
}var edit=null;try{var editFilePath='./'+item.module+'/'+item.name+'-edit';edit=!(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()).default;}catch(ex){// console.error(ex);
}try{var Editor=item.editor?Object(__WEBPACK_IMPORTED_MODULE_1_reducers__["b" /* wConnectRedux */])(item.editor):Object(__WEBPACK_IMPORTED_MODULE_1_reducers__["b" /* wConnectRedux */])(__webpack_require__(861)("./"+item.module+'/'+item.name)[pascalCase(item.name+'_editor')]);registerBlockType(getBlockTypeByName(item.name),{title:item.title,icon:item.icon,category:categorySlug,keywords:item.keywords,edit:edit?edit:function(props){return wp.element.createElement(Editor,_extends({},props,{store:__WEBPACK_IMPORTED_MODULE_1_reducers__["a" /* store */]}));},save:save?save:function(props){return wp.element.createElement('div',{id:getBlockMountIdByName(item.name),'vu-attributes':__WEBPACK_IMPORTED_MODULE_2__libs_wjson__["a" /* default */].encode(props.attributes)});},attributes:item.attributes});}catch(ex){// console.error('ex', ex);
}});};/* harmony default export */ __webpack_exports__["default"] = (registerVulcanBlockType);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___uXr0k","container_1":"container_1___2HTNk","container_2":"container_2___3HvPO","wp-block-cgb-block-cec-blocks":"wp-block-cgb-block-cec-blocks___2L5x-"};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(923);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(331);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(492);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(494);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _default = _interopRequireDefault(__webpack_require__(136));

var runtimeLocale = (0, _extends2["default"])({}, _default["default"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = (0, _extends2["default"])((0, _extends2["default"])({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = (0, _extends2["default"])({}, _default["default"].Modal);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withConfigConsumer = withConfigConsumer;
exports.ConfigConsumer = exports.ConfigContext = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _renderEmpty = _interopRequireDefault(__webpack_require__(961));

var ConfigContext = /*#__PURE__*/React.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : 'ant';
  },
  renderEmpty: _renderEmpty["default"]
});
exports.ConfigContext = ConfigContext;
var ConfigConsumer = ConfigContext.Consumer;
/** @deprecated Use hooks instead. This is a legacy function */

exports.ConfigConsumer = ConfigConsumer;

function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return /*#__PURE__*/React.createElement(Component, (0, _extends2["default"])({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };

    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || 'Component';
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _empty = _interopRequireDefault(__webpack_require__(962));

var _simple = _interopRequireDefault(__webpack_require__(963));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);

var Empty = function Empty(_a) {
  var className = _a.className,
      customizePrefixCls = _a.prefixCls,
      _a$image = _a.image,
      image = _a$image === void 0 ? defaultEmptyImg : _a$image,
      description = _a.description,
      children = _a.children,
      imageStyle = _a.imageStyle,
      restProps = __rest(_a, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Empty"
  }, function (locale) {
    var _classNames;

    var prefixCls = getPrefixCls('empty', customizePrefixCls);
    var des = typeof description !== 'undefined' ? description : locale.description;
    var alt = typeof des === 'string' ? des : 'empty';
    var imageNode = null;

    if (typeof image === 'string') {
      imageNode = /*#__PURE__*/React.createElement("img", {
        alt: alt,
        src: image
      });
    } else {
      imageNode = image;
    }

    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      className: (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className)
    }, restProps), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-image"),
      style: imageStyle
    }, imageNode), des && /*#__PURE__*/React.createElement("p", {
      className: "".concat(prefixCls, "-description")
    }, des), children && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, children));
  });
};

Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(979);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transitionEndName; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransitionName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_Dom_canUseDom__ = __webpack_require__(161);



// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_Dom_canUseDom__["a" /* default */])(), typeof window !== 'undefined' ? window : {});
var style = {};

if (Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_Dom_canUseDom__["a" /* default */])()) {
  var _document$createEleme = document.createElement('div');

  style = _document$createEleme.style;
}

var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;

    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];

      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return "".concat(transitionName, "-").concat(transitionType);
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_APPEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_LEAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STEP_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STEP_PREPARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STEP_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STEP_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STEP_ACTIVATED; });
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof3 = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate = generate;
exports.getSecondaryColor = getSecondaryColor;
exports.iconStyles = void 0;
exports.isIconDefinition = isIconDefinition;
exports.normalizeAttrs = normalizeAttrs;
exports.normalizeTwoToneColors = normalizeTwoToneColors;
exports.useInsertStyles = exports.svgBaseProps = void 0;
exports.warning = warning;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var _typeof2 = _interopRequireDefault(__webpack_require__(13));
var _colors = __webpack_require__(1013);
var _react = _interopRequireWildcard(__webpack_require__(0));
var _warning = _interopRequireDefault(__webpack_require__(106));
var _dynamicCSS = __webpack_require__(1019);
var _Context = _interopRequireDefault(__webpack_require__(529));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function warning(valid, message) {
  (0, _warning.default)(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return (0, _typeof2.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, _typeof2.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];
    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;
      default:
        acc[key] = val;
    }
    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/_react.default.createElement(node.tag, (0, _objectSpread2.default)({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }
  return /*#__PURE__*/_react.default.createElement(node.tag, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return (0, _colors.generate)(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
exports.svgBaseProps = svgBaseProps;
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
exports.iconStyles = iconStyles;
var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;
  var _useContext = (0, _react.useContext)(_Context.default),
    csp = _useContext.csp;
  (0, _react.useEffect)(function () {
    (0, _dynamicCSS.updateCSS)(styleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp
    });
  }, []);
};
exports.useInsertStyles = useInsertStyles;

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return names; });
// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */
var names = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = canUseDom;
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(535);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(1056));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CheckCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CloseCircleOutlined = _interopRequireDefault(__webpack_require__(1058));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CloseCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ExclamationCircleOutlined = _interopRequireDefault(__webpack_require__(348));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _ExclamationCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _ExclamationCircleOutlined = _interopRequireDefault(__webpack_require__(1060));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _ExclamationCircleOutlined.default
  }));
};
ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(ExclamationCircleOutlined);
exports.default = _default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _InfoCircleOutlined = _interopRequireDefault(__webpack_require__(1061));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _InfoCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(1074);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(265);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(266);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRouterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_SystemInfo_ErrorPage__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_SystemInfo_InfoPage__ = __webpack_require__(1119);
/*
 * 負責控制該專案的path to View Compoment 設定
 */// import { LayoutType } from '../layouts/Layout/LayoutFactory';
var LayoutType={};// 要綁定wConnectRedux，
// 所以只用一次的compoment就直接用require('{module_path}').default
// 重複使用的compoment才用import
var StoreList=Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(361).default));// 此處先看wp_slug
// news
// mall
// stores
// repair
var routerData=[// 此處對應init.php:生成wordpress的側邊目錄
// web.js對應要掛載的Component
{wp_slug:'news',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(724).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'stores',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(361).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'brands',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(726).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'category',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(728).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'catalogues',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(730).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'recipes',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(732).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'vendors',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(734).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'cibc',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(736).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'privileges',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(738).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'static',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(740).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:'hotkeywords',path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(741).default)),layout:LayoutType.Full,roles:null,exact:true},// { wp_slug: 'news'  , path: '/', component: ErrorPage, layout: LayoutType.Full, roles: null, exact: true },
// { wp_slug: 'repair', path: '/', component: ErrorPage, layout: LayoutType.Full, roles: null, exact: true },
// 最新消息管理
{wp_slug:null,path:'/news',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(724).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/news/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(1702).default)),layout:LayoutType.Full,roles:null,exact:true},// 分店管理
{wp_slug:null,path:'/stores',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(361).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/stores/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(1872).default)),layout:LayoutType.Full,roles:null,exact:true},// 品牌管理
{wp_slug:null,path:'/brands',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(726).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/brands/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(1925).default)),layout:LayoutType.Full,roles:null,exact:true},// 品牌類別管理
{wp_slug:null,path:'/category',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(728).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/category/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2039).default)),layout:LayoutType.Full,roles:null,exact:true},// 促銷目錄
{wp_slug:null,path:'/catalogues',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(730).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/catalogues/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2040).default)),layout:LayoutType.Full,roles:null,exact:true},// 食譜管理
{wp_slug:null,path:'/recipes',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(732).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/recipes/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2042).default)),layout:LayoutType.Full,roles:null,exact:true},// 第三方平台管理
{wp_slug:null,path:'/vendors',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(734).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/vendors/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2044).default)),layout:LayoutType.Full,roles:null,exact:true},// 權限管理
{wp_slug:null,path:'/privileges',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(738).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/privileges/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2045).default)),layout:LayoutType.Full,roles:null,exact:true},// 保經管理
{wp_slug:null,path:'/cibc',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(736).default)),layout:LayoutType.Full,roles:null,exact:true},{wp_slug:null,path:'/cibc/view/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(2046).default)),layout:LayoutType.Full,roles:null,exact:true},// 靜態頁面
{wp_slug:null,path:'/static',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(740).default)),layout:LayoutType.Full,roles:null,exact:true},// 熱門關鍵字頁面
{wp_slug:null,path:'/hotkeywords',component:Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__reducers__["b" /* wConnectRedux */])(__webpack_require__(741).default)),layout:LayoutType.Full,roles:null,exact:true},// 系統訊息
{path:'/system/info/:message',component:__WEBPACK_IMPORTED_MODULE_4__views_SystemInfo_InfoPage__["a" /* default */],layout:LayoutType.Full},{path:'/error',component:__WEBPACK_IMPORTED_MODULE_3__views_SystemInfo_ErrorPage__["a" /* default */],layout:LayoutType.Full}];var getRouterData=function getRouterData(){var hasPermissions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNil(hasPermissions)){var userPermissions=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* store */].getState(),'auth.permissions',{});hasPermissions=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(userPermissions).filter(function(k){return userPermissions[k]===true;});}return routerData.filter(function(item){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNil(item.permissions)||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(item.permissions))return true;item.permissions=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(item.permissions)?item.permissions:[item.permissions];return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.intersection(item.permissions,hasPermissions).length>0;});};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SiderContext = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _BarsOutlined = _interopRequireDefault(__webpack_require__(1111));

var _RightOutlined = _interopRequireDefault(__webpack_require__(267));

var _LeftOutlined = _interopRequireDefault(__webpack_require__(360));

var _layout = __webpack_require__(565);

var _configProvider = __webpack_require__(8);

var _isNumeric = _interopRequireDefault(__webpack_require__(1118));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var dimensionMaxMap = {
  xs: '479.98px',
  sm: '575.98px',
  md: '767.98px',
  lg: '991.98px',
  xl: '1199.98px',
  xxl: '1599.98px'
};
var SiderContext = /*#__PURE__*/React.createContext({});
exports.SiderContext = SiderContext;

var generateId = function () {
  var i = 0;
  return function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    i += 1;
    return "".concat(prefix).concat(i);
  };
}();

var Sider = function Sider(_a) {
  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      trigger = _a.trigger,
      children = _a.children,
      _a$defaultCollapsed = _a.defaultCollapsed,
      defaultCollapsed = _a$defaultCollapsed === void 0 ? false : _a$defaultCollapsed,
      _a$theme = _a.theme,
      theme = _a$theme === void 0 ? 'dark' : _a$theme,
      _a$style = _a.style,
      style = _a$style === void 0 ? {} : _a$style,
      _a$collapsible = _a.collapsible,
      collapsible = _a$collapsible === void 0 ? false : _a$collapsible,
      _a$reverseArrow = _a.reverseArrow,
      reverseArrow = _a$reverseArrow === void 0 ? false : _a$reverseArrow,
      _a$width = _a.width,
      width = _a$width === void 0 ? 200 : _a$width,
      _a$collapsedWidth = _a.collapsedWidth,
      collapsedWidth = _a$collapsedWidth === void 0 ? 80 : _a$collapsedWidth,
      zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
      breakpoint = _a.breakpoint,
      onCollapse = _a.onCollapse,
      onBreakpoint = _a.onBreakpoint,
      props = __rest(_a, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]);

  var _useContext = (0, React.useContext)(_layout.LayoutContext),
      siderHook = _useContext.siderHook;

  var _useState = (0, React.useState)('collapsed' in props ? props.collapsed : defaultCollapsed),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var _useState3 = (0, React.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      below = _useState4[0],
      setBelow = _useState4[1];

  (0, React.useEffect)(function () {
    if ('collapsed' in props) {
      setCollapsed(props.collapsed);
    }
  }, [props.collapsed]);

  var handleSetCollapsed = function handleSetCollapsed(value, type) {
    if (!('collapsed' in props)) {
      setCollapsed(value);
    }

    if (onCollapse) {
      onCollapse(value, type);
    }
  }; // ========================= Responsive =========================


  var responsiveHandlerRef = (0, React.useRef)();

  responsiveHandlerRef.current = function (mql) {
    setBelow(mql.matches);

    if (onBreakpoint) {
      onBreakpoint(mql.matches);
    }

    if (collapsed !== mql.matches) {
      handleSetCollapsed(mql.matches, 'responsive');
    }
  };

  (0, React.useEffect)(function () {
    function responsiveHandler(mql) {
      return responsiveHandlerRef.current(mql);
    }

    var mql;

    if (typeof window !== 'undefined') {
      var _window = window,
          matchMedia = _window.matchMedia;

      if (matchMedia && breakpoint && breakpoint in dimensionMaxMap) {
        mql = matchMedia("(max-width: ".concat(dimensionMaxMap[breakpoint], ")"));

        try {
          mql.addEventListener('change', responsiveHandler);
        } catch (error) {
          mql.addListener(responsiveHandler);
        }

        responsiveHandler(mql);
      }
    }

    return function () {
      try {
        mql === null || mql === void 0 ? void 0 : mql.removeEventListener('change', responsiveHandler);
      } catch (error) {
        mql === null || mql === void 0 ? void 0 : mql.removeListener(responsiveHandler);
      }
    };
  }, []);
  (0, React.useEffect)(function () {
    var uniqueId = generateId('ant-sider-');
    siderHook.addSider(uniqueId);
    return function () {
      return siderHook.removeSider(uniqueId);
    };
  }, []);

  var toggle = function toggle() {
    handleSetCollapsed(!collapsed, 'clickTrigger');
  };

  var _useContext2 = (0, React.useContext)(_configProvider.ConfigContext),
      getPrefixCls = _useContext2.getPrefixCls;

  var renderSider = function renderSider() {
    var _classNames;

    var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    var divProps = (0, _omit["default"])(props, ['collapsed']);
    var rawWidth = collapsed ? collapsedWidth : width; // use "px" as fallback unit for width

    var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0

    var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
      onClick: toggle,
      className: (0, _classnames["default"])("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left')),
      style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/React.createElement(_BarsOutlined["default"], null)) : null;
    var iconObj = {
      expanded: reverseArrow ? /*#__PURE__*/React.createElement(_RightOutlined["default"], null) : /*#__PURE__*/React.createElement(_LeftOutlined["default"], null),
      collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_LeftOutlined["default"], null) : /*#__PURE__*/React.createElement(_RightOutlined["default"], null)
    };
    var status = collapsed ? 'collapsed' : 'expanded';
    var defaultTrigger = iconObj[status];
    var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-trigger"),
      onClick: toggle,
      style: {
        width: siderWidth
      }
    }, trigger || defaultTrigger) : null;
    var divStyle = (0, _extends2["default"])((0, _extends2["default"])({}, style), {
      flex: "0 0 ".concat(siderWidth),
      maxWidth: siderWidth,
      minWidth: siderWidth,
      width: siderWidth
    });
    var siderCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-collapsed"), !!collapsed), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-below"), !!below), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames), className);
    return /*#__PURE__*/React.createElement("aside", (0, _extends2["default"])({
      className: siderCls
    }, divProps, {
      style: divStyle
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-children")
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
  };

  return /*#__PURE__*/React.createElement(SiderContext.Provider, {
    value: {
      siderCollapsed: collapsed,
      collapsedWidth: collapsedWidth
    }
  }, renderSider());
};

var _default = Sider;
exports["default"] = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _LeftOutlined = _interopRequireDefault(__webpack_require__(1116));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _LeftOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_module_scss__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_libs_AppHelper__ = __webpack_require__(10);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabPane=__WEBPACK_IMPORTED_MODULE_26_antd_lib_tabs___default.a.TabPane;var FormItem=__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item;var Search=__WEBPACK_IMPORTED_MODULE_22_antd_lib_input___default.a.Search;var Option=__WEBPACK_IMPORTED_MODULE_20_antd_lib_select___default.a.Option;var RangePicker=__WEBPACK_IMPORTED_MODULE_18_antd_lib_date_picker___default.a.RangePicker;var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_27_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},table_query:{keyword:null,roles:[],status:[],citys:[],fields:[],group:null,area:null,store_type:null},ui_state:{isLoading:false},message:"",keyword:"",permission:"all"},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var tableQuery=_this.formRef.current.getFieldValue();var page=opt.page,page_size=opt.page_size;//分店管理列表加入分店管理帳號顯示過濾 by Sam 2022/03/18
var current_user=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(window,"VC_CONFIG.WP_CURRENT_USER","");var user_id=current_user.ID;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+"/api/mgt/v1/stores",{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableQuery,"keyword"),group:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableQuery,"store_group_id"),area:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableQuery,"store_area_id"),store_type:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableQuery,"store_type_id"),user_id:user_id},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?"發生錯誤":_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:"發生錯誤"});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.exportData=function(){var table_query=_this.state.table_query;_this.setState({isExportData:true});__WEBPACK_IMPORTED_MODULE_33_axios___default()({url:__WEBPACK_IMPORTED_MODULE_34_axios_lib_helpers_buildURL___default()(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+"/api/mgt/v1/stores/export",{keyword:table_query.keyword,email:"user@gmail.com",format:"xlsx"}),method:"GET",responseType:"blob",// important
headers:__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].getHeaders()}).then(function(response){_this.setState({isExportData:false});var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement("a");link.href=url;link.setAttribute("download","export.xlsx");document.body.appendChild(link);link.click();}).catch(function(error){_this.setState({isExportData:false});var res={code:200,reason:"未知錯誤",error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.statusText;}__WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning("無法匯出:"+error.message);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+("/api/mgt/v1/stores/"+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?"發生錯誤":_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error("發生錯誤");}if(code!==200){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("刪除成功");_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+("/api/mgt/v1/stores/"+item.id+"/clone"),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?"發生錯誤":_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error("發生錯誤");}if(code!==200){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.success("複製成功");if(!__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(data.id))_this.props.history.push("/stores/view/"+data.id);});},_this.submitUserStatusData=function(status,user_id){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(result){};_this.setState({isSubmitUserStatusData:true});__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+("/api/v1/user/status/"+user_id),{status:status},function(state,res){_this.setState({isSubmitUserStatusData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?"發生錯誤":_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){callback(false);return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning("發生錯誤");}if(code!==200){callback(false);return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning(reason);}callback(true);});},_this.submitBranchTime=function(){__WEBPACK_IMPORTED_MODULE_32__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+"/api/mgt/v1/stores/updateBranchTime",function(state,res){console.log(res);var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?"發生錯誤":_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning("發生錯誤");}if(code!==200){return __WEBPACK_IMPORTED_MODULE_16_antd_lib_message___default.a.warning(reason);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_37_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
// 匯出
//變更使用者狀態
//更新時間
},{key:"render",value:function render(){var _this2=this;var _state=this.state,_state$table_query=_state.table_query,table_query=_state$table_query===undefined?{}:_state$table_query,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.props,"auth.permissions",{});var options=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this,"props.app.options",{});var privileges=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(window,"VC_CONFIG.privileges");return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{to:"/stores"},"\u5206\u5E97\u7BA1\u7406"))),wp.element.createElement("h2",null,"\u5206\u5E97\u7BA1\u7406",wp.element.createElement("span",null)),wp.element.createElement("div",{className:"block search"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a,{ref:this.formRef,onValuesChange:function onValuesChange(changedFields,allFields){return console.log("onValuesChange",changedFields);}},wp.element.createElement("div",{className:"flexBox col_12"},wp.element.createElement(FormItem,_extends({},Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])("keyword","名稱"),{label:"\u540D\u7A31"}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_input___default.a,{placeholder:"\u641C\u5C0B\u540D\u7A31\u3001\u4EE3\u865F\u3001\u4EE3\u78BC"}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])("store_area_id","分店所在地區"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select___default.a,{placeholder:"\u8ACB\u9078\u64C7\u5206\u5E97\u6240\u5728\u5730\u5340"},wp.element.createElement("option",{value:null},"\u8ACB\u9078\u64C7\u5206\u5E97\u6240\u5728\u5730\u5340"),__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(options,"store_areas",[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])("store_group_id","分店群組"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select___default.a,{placeholder:"\u8ACB\u9078\u64C7\u5206\u5E97\u7FA4\u7D44"},wp.element.createElement("option",{value:null},"\u8ACB\u9078\u64C7\u5206\u5E97\u7FA4\u7D44"),__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(options,"store_groups",[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])("store_type_id","分店型態"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_select___default.a,{placeholder:"\u8ACB\u9078\u64C7\u5206\u5E97\u578B\u614B"},wp.element.createElement("option",{value:null},"\u8ACB\u9078\u64C7\u5206\u5E97\u578B\u614B"),__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(options,"store_types",[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item,{style:{textAlign:"right"}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},"\u53D6\u6D88"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:"primary",style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},"\u641C\u5C0B")))),wp.element.createElement("div",{className:"toolbar"},wp.element.createElement("h3",null,"\u5206\u5E97\u5217\u8868",wp.element.createElement("span",null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a,{layout:"inline"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form___default.a.Item,null,wp.element.createElement("div",{className:"flexBox"},__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(privileges,"stores.create",false)===true&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{to:"/stores/view"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:"primary",onClick:function onClick(){_this2.props.history.push("/kiosk"+"/experience-center/service/info/");}},"\u65B0\u589E")))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,"current",[]),total:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,"total",0),pageSize:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,"page_size",0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:"id",title:"ID"},{dataIndex:["images","0"],title:"樓層圖",render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar___default.a,{shape:"square",icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined___default.a,null),src:image});}},{dataIndex:"name",title:"名稱"},{dataIndex:"code",title:"代號"},{dataIndex:"sn",title:"代碼"},{dataIndex:"store_area_name",title:"地區"},{dataIndex:"store_group_name",title:"地區"},{dataIndex:"store_type_name",title:"類型"},{dataIndex:"sort",title:"排序"},{dataIndex:"status_name",title:"狀態"},{dataIndex:"updated_at",title:"更新時間"},{dataIndex:["modified_user","name"],title:"異動者"},{title:"Action",key:"tools",render:function render(text,record){var privileges=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(window,"VC_CONFIG.privileges",{});var storesModify=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(privileges,"stores.modify",[]);var canCreate=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(privileges,"stores.create",false);var canEdit=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.indexOf(storesModify,"all")!==-1||__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.indexOf(storesModify,record.id)!==-1;var dataSource=[];if(canCreate)dataSource.push(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:"small",onConfirm:function onConfirm(){return _this2.deleteData(record);}}));if(canCreate||canEdit)dataSource.push(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{role:"button",to:"/stores/view/"+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:"default",size:"small",icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},"\u7DE8\u8F2F")));if(dataSource.length===0)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react__["Fragment"],null);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:dataSource,renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_27_react__["Component"]);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1136);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (element) {
  if (!element) {
    return false;
  }
  if (element instanceof HTMLElement && element.offsetParent) {
    return true;
  }
  if (element instanceof SVGGraphicsElement && element.getBBox) {
    var _element$getBBox = element.getBBox(),
      width = _element$getBBox.width,
      height = _element$getBBox.height;
    if (width || height) {
      return true;
    }
  }
  if (element instanceof HTMLElement && element.getBoundingClientRect) {
    var _element$getBoundingC = element.getBoundingClientRect(),
      _width = _element$getBoundingC.width,
      _height = _element$getBoundingC.height;
    if (_width || _height) {
      return true;
    }
  }
  return false;
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var BodyContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
/* harmony default export */ __webpack_exports__["a"] = (BodyContext);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1174);
var iterableToArray = __webpack_require__(1175);
var unsupportedIterableToArray = __webpack_require__(585);
var nonIterableSpread = __webpack_require__(1176);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollBarSize;
exports.getTargetScrollBarSize = getTargetScrollBarSize;
/* eslint-disable no-param-reassign */

var cached;
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = '0';
    outerStyle.left = '0';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function ensureSize(str) {
  var match = str.match(/^(.*)px$/);
  var value = Number(match === null || match === void 0 ? void 0 : match[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  var _getComputedStyle = getComputedStyle(target, '::-webkit-scrollbar'),
    width = _getComputedStyle.width,
    height = _getComputedStyle.height;
  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpandableProps = getExpandableProps;
exports.getDataAndAriaProps = getDataAndAriaProps;
exports.INTERNAL_COL_DEFINE = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(274));

var _warning = _interopRequireDefault(__webpack_require__(106));

var INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';
exports.INTERNAL_COL_DEFINE = INTERNAL_COL_DEFINE;

function getExpandableProps(props) {
  var expandable = props.expandable,
      legacyExpandableConfig = (0, _objectWithoutProperties2.default)(props, ["expandable"]);

  if ('expandable' in props) {
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, legacyExpandableConfig), expandable);
  }

  if (false) {
    (0, _warning.default)(false, 'expanded related props have been moved into `expandable`.');
  }

  return legacyExpandableConfig;
}
/**
 * Returns only data- and aria- key/value pairs
 * @param {object} props
 */


function getDataAndAriaProps(props) {
  /* eslint-disable no-param-reassign */
  return Object.keys(props).reduce(function (memo, key) {
    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
      memo[key] = props[key];
    }

    return memo;
  }, {});
  /* eslint-enable */
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var BodyContext = /*#__PURE__*/React.createContext(null);
var _default = BodyContext;
exports.default = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(109);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(599);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(607);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1248);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var TransBtn = function TransBtn(_ref) {
  var className = _ref.className,
      customizeIcon = _ref.customizeIcon,
      customizeIconProps = _ref.customizeIconProps,
      _onMouseDown = _ref.onMouseDown,
      onClick = _ref.onClick,
      children = _ref.children;
  var icon;

  if (typeof customizeIcon === 'function') {
    icon = customizeIcon(customizeIconProps);
  } else {
    icon = customizeIcon;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: className,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();

      if (_onMouseDown) {
        _onMouseDown(event);
      }
    },
    style: {
      userSelect: 'none',
      WebkitUserSelect: 'none'
    },
    unselectable: "on",
    onClick: onClick,
    "aria-hidden": true
  }, icon !== undefined ? icon : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className.split(/\s+/).map(function (cls) {
      return "".concat(cls, "-icon");
    }))
  }, children));
};

/* harmony default export */ __webpack_exports__["a"] = (TransBtn);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1272);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1286);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  if (!root) {
    return false;
  }

  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }

  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(641);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1350);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(218);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrDel = arrDel;
exports.arrAdd = arrAdd;
exports.posToArr = posToArr;
exports.getPosition = getPosition;
exports.isTreeNode = isTreeNode;
exports.getDragChildrenKeys = getDragChildrenKeys;
exports.isLastChild = isLastChild;
exports.isFirstChild = isFirstChild;
exports.calcDropPosition = calcDropPosition;
exports.calcSelectedKeys = calcSelectedKeys;
exports.convertDataToTree = convertDataToTree;
exports.parseCheckedKeys = parseCheckedKeys;
exports.conductExpandParent = conductExpandParent;
exports.getDataAndAria = getDataAndAria;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(638));

var _typeof2 = _interopRequireDefault(__webpack_require__(175));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(381));

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(106));

var _TreeNode = _interopRequireDefault(__webpack_require__(1351));

/* eslint-disable no-lonely-if */

/**
 * Legacy code. Should avoid to use if you are new to import these code.
 */
function arrDel(list, value) {
  var clone = list.slice();
  var index = clone.indexOf(value);

  if (index >= 0) {
    clone.splice(index, 1);
  }

  return clone;
}

function arrAdd(list, value) {
  var clone = list.slice();

  if (clone.indexOf(value) === -1) {
    clone.push(value);
  }

  return clone;
}

function posToArr(pos) {
  return pos.split('-');
}

function getPosition(level, index) {
  return "".concat(level, "-").concat(index);
}

function isTreeNode(node) {
  return node && node.type && node.type.isTreeNode;
}

function getDragChildrenKeys(dragNodeKey, keyEntities) {
  // not contains self
  // self for left or right drag
  var dragChildrenKeys = [];
  var entity = keyEntities[dragNodeKey];

  function dig() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    list.forEach(function (_ref) {
      var key = _ref.key,
          children = _ref.children;
      dragChildrenKeys.push(key);
      dig(children);
    });
  }

  dig(entity.children);
  return dragChildrenKeys;
}

function isLastChild(treeNodeEntity) {
  if (treeNodeEntity.parent) {
    var posArr = posToArr(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
  }

  return false;
}

function isFirstChild(treeNodeEntity) {
  var posArr = posToArr(treeNodeEntity.pos);
  return Number(posArr[posArr.length - 1]) === 0;
} // Only used when drag, not affect SSR.


function calcDropPosition(event, dragNode, targetNode, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
  var _abstractDropNodeEnti;

  var clientX = event.clientX,
      clientY = event.clientY;

  var _event$target$getBoun = event.target.getBoundingClientRect(),
      top = _event$target$getBoun.top,
      height = _event$target$getBoun.height; // optional chain for testing


  var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
  var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent; // find abstract drop node by horizontal offset

  var abstractDropNodeEntity = keyEntities[targetNode.props.eventKey];

  if (clientY < top + height / 2) {
    // first half, set abstract drop node to previous node
    var nodeIndex = flattenedNodes.findIndex(function (flattenedNode) {
      return flattenedNode.data.key === abstractDropNodeEntity.key;
    });
    var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
    var prevNodeKey = flattenedNodes[prevNodeIndex].data.key;
    abstractDropNodeEntity = keyEntities[prevNodeKey];
  }

  var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
  var abstractDragOverEntity = abstractDropNodeEntity;
  var dragOverNodeKey = abstractDropNodeEntity.key;
  var dropPosition = 0;
  var dropLevelOffset = 0; // Only allow cross level drop when dragging on a non-expanded node

  if (!expandKeys.includes(initialAbstractDropNodeKey)) {
    for (var i = 0; i < rawDropLevelOffset; i += 1) {
      if (isLastChild(abstractDropNodeEntity)) {
        abstractDropNodeEntity = abstractDropNodeEntity.parent;
        dropLevelOffset += 1;
      } else {
        break;
      }
    }
  }

  var abstractDropDataNode = abstractDropNodeEntity.node;
  var dropAllowed = true;

  if (isFirstChild(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
    dropNode: abstractDropDataNode,
    dropPosition: -1
  }) && abstractDropNodeEntity.key === targetNode.props.eventKey) {
    // first half of first node in first level
    dropPosition = -1;
  } else if ((abstractDragOverEntity.children || []).length && expandKeys.includes(dragOverNodeKey)) {
    // drop on expanded node
    // only allow drop inside
    if (allowDrop({
      dropNode: abstractDropDataNode,
      dropPosition: 0
    })) {
      dropPosition = 0;
    } else {
      dropAllowed = false;
    }
  } else if (dropLevelOffset === 0) {
    if (rawDropLevelOffset > -1.5) {
      // | Node     | <- abstractDropNode
      // | -^-===== | <- mousePosition
      // 1. try drop after
      // 2. do not allow drop
      if (allowDrop({
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    } else {
      // | Node     | <- abstractDropNode
      // | ---==^== | <- mousePosition
      // whether it has children or doesn't has children
      // always
      // 1. try drop inside
      // 2. try drop after
      // 3. do not allow drop
      if (allowDrop({
        dropNode: abstractDropDataNode,
        dropPosition: 0
      })) {
        dropPosition = 0;
      } else if (allowDrop({
        dropNode: abstractDropDataNode,
        dropPosition: 1
      })) {
        dropPosition = 1;
      } else {
        dropAllowed = false;
      }
    }
  } else {
    // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
      dropNode: abstractDropDataNode,
      dropPosition: 1
    })) {
      dropPosition = 1;
    } else {
      dropAllowed = false;
    }
  }

  return {
    dropPosition: dropPosition,
    dropLevelOffset: dropLevelOffset,
    dropTargetKey: abstractDropNodeEntity.key,
    dropTargetPos: abstractDropNodeEntity.pos,
    dragOverNodeKey: dragOverNodeKey,
    dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
    dropAllowed: dropAllowed
  };
}
/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */


function calcSelectedKeys(selectedKeys, props) {
  if (!selectedKeys) return undefined;
  var multiple = props.multiple;

  if (multiple) {
    return selectedKeys.slice();
  }

  if (selectedKeys.length) {
    return [selectedKeys[0]];
  }

  return selectedKeys;
}

var internalProcessProps = function internalProcessProps(props) {
  return props;
};

function convertDataToTree(treeData, processor) {
  if (!treeData) return [];

  var _ref2 = processor || {},
      _ref2$processProps = _ref2.processProps,
      processProps = _ref2$processProps === void 0 ? internalProcessProps : _ref2$processProps;

  var list = Array.isArray(treeData) ? treeData : [treeData];
  return list.map(function (_ref3) {
    var children = _ref3.children,
        props = (0, _objectWithoutProperties2.default)(_ref3, ["children"]);
    var childrenNodes = convertDataToTree(children, processor);
    return /*#__PURE__*/_react.default.createElement(_TreeNode.default, processProps(props), childrenNodes);
  });
}
/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */


function parseCheckedKeys(keys) {
  if (!keys) {
    return null;
  } // Convert keys to object format


  var keyProps;

  if (Array.isArray(keys)) {
    // [Legacy] Follow the api doc
    keyProps = {
      checkedKeys: keys,
      halfCheckedKeys: undefined
    };
  } else if ((0, _typeof2.default)(keys) === 'object') {
    keyProps = {
      checkedKeys: keys.checked || undefined,
      halfCheckedKeys: keys.halfChecked || undefined
    };
  } else {
    (0, _warning.default)(false, '`checkedKeys` is not an array or an object');
    return null;
  }

  return keyProps;
}
/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */


function conductExpandParent(keyList, keyEntities) {
  var expandedKeys = new Set();

  function conductUp(key) {
    if (expandedKeys.has(key)) return;
    var entity = keyEntities[key];
    if (!entity) return;
    expandedKeys.add(key);
    var parent = entity.parent,
        node = entity.node;
    if (node.disabled) return;

    if (parent) {
      conductUp(parent.key);
    }
  }

  (keyList || []).forEach(function (key) {
    conductUp(key);
  });
  return (0, _toConsumableArray2.default)(expandedKeys);
}
/**
 * Returns only the data- and aria- key/value pairs
 */


function getDataAndAria(props) {
  var omitProps = {};
  Object.keys(props).forEach(function (key) {
    if (key.startsWith('data-') || key.startsWith('aria-')) {
      omitProps[key] = props[key];
    }
  });
  return omitProps;
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(175)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMergedState;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(643));
var _useEvent = _interopRequireDefault(__webpack_require__(1369));
var _useLayoutEffect = __webpack_require__(1370);
var _useState5 = _interopRequireDefault(__webpack_require__(1371));
/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}

/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;

  // ======================= Init =======================
  var _useState = (0, _useState5.default)(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;

  // ====================== Change ======================
  var onChangeFn = (0, _useEvent.default)(onChange);
  var _useState3 = (0, _useState5.default)([mergedValue]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  (0, _useLayoutEffect.useLayoutUpdateEffect)(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);

  // Sync value back to `undefined` when it from control to un-control
  (0, _useLayoutEffect.useLayoutUpdateEffect)(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);

  // ====================== Update ======================
  var triggerChange = (0, _useEvent.default)(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDropdown = _interopRequireDefault(__webpack_require__(650));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _RightOutlined = _interopRequireDefault(__webpack_require__(267));

var _dropdownButton = _interopRequireDefault(__webpack_require__(1399));

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _type = __webpack_require__(118);

var _reactNode = __webpack_require__(57);

var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');

var Dropdown = function Dropdown(props) {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var getTransitionName = function getTransitionName() {
    var _props$placement = props.placement,
        placement = _props$placement === void 0 ? '' : _props$placement,
        transitionName = props.transitionName;

    if (transitionName !== undefined) {
      return transitionName;
    }

    if (placement.indexOf('top') >= 0) {
      return 'slide-down';
    }

    return 'slide-up';
  };

  var renderOverlay = function renderOverlay(prefixCls) {
    // rc-dropdown already can process the function of overlay, but we have check logic here.
    // So we need render the element to check and pass back to rc-dropdown.
    var overlay = props.overlay;
    var overlayNode;

    if (typeof overlay === 'function') {
      overlayNode = overlay();
    } else {
      overlayNode = overlay;
    }

    overlayNode = React.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/React.createElement("span", null, overlayNode) : overlayNode);
    var overlayProps = overlayNode.props; // Warning if use other mode

    (0, _devWarning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
    // menu should be focusable in dropdown defaultly

    var _overlayProps$selecta = overlayProps.selectable,
        selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
        _overlayProps$focusab = overlayProps.focusable,
        focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
    var expandIcon = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-menu-submenu-arrow")
    }, /*#__PURE__*/React.createElement(_RightOutlined["default"], {
      className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
    }));
    var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlayNode : (0, _reactNode.cloneElement)(overlayNode, {
      mode: 'vertical',
      selectable: selectable,
      focusable: focusable,
      expandIcon: expandIcon
    });
    return fixedModeOverlay;
  };

  var getPlacement = function getPlacement() {
    var placement = props.placement;

    if (placement !== undefined) {
      return placement;
    }

    return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  };

  var arrow = props.arrow,
      customizePrefixCls = props.prefixCls,
      children = props.children,
      trigger = props.trigger,
      disabled = props.disabled,
      getPopupContainer = props.getPopupContainer,
      overlayClassName = props.overlayClassName;
  var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
  var child = React.Children.only(children);
  var dropdownTrigger = (0, _reactNode.cloneElement)(child, {
    className: (0, _classnames["default"])("".concat(prefixCls, "-trigger"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), child.props.className),
    disabled: disabled
  });
  var overlayClassNameCustomized = (0, _classnames["default"])(overlayClassName, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
  var triggerActions = disabled ? [] : trigger;
  var alignPoint;

  if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
    alignPoint = true;
  }

  return /*#__PURE__*/React.createElement(_rcDropdown["default"], (0, _extends2["default"])({
    arrow: arrow,
    alignPoint: alignPoint
  }, props, {
    overlayClassName: overlayClassNameCustomized,
    prefixCls: prefixCls,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    transitionName: getTransitionName(),
    trigger: triggerActions,
    overlay: function overlay() {
      return renderOverlay(prefixCls);
    },
    placement: getPlacement()
  }), dropdownTrigger);
};

Dropdown.Button = _dropdownButton["default"];
Dropdown.defaultProps = {
  mouseEnterDelay: 0.15,
  mouseLeaveDelay: 0.1
};
var _default = Dropdown;
exports["default"] = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(203));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ref2 = __webpack_require__(117);

var _raf = _interopRequireDefault(__webpack_require__(1404));

var _configProvider = __webpack_require__(8);

var _reactNode = __webpack_require__(57);

var styleForPseudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {
    return false;
  }

  return !element || element.offsetParent === null || element.hidden;
}

function isNotGrey(color) {
  // eslint-disable-next-line no-useless-escape
  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);

  if (match && match[1] && match[2] && match[3]) {
    return !(match[1] === match[2] && match[2] === match[3]);
  }

  return true;
}

var Wave = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Wave, _React$Component);

  var _super = (0, _createSuper2["default"])(Wave);

  function Wave() {
    var _this;

    (0, _classCallCheck2["default"])(this, Wave);
    _this = _super.apply(this, arguments);
    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.animationStart = false;
    _this.destroyed = false;

    _this.onClick = function (node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = _this.props.insertExtraNode;
      _this.extraNode = document.createElement('div');

      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          extraNode = _assertThisInitialize.extraNode;

      var getPrefixCls = _this.context.getPrefixCls;
      extraNode.className = "".concat(getPrefixCls(''), "-click-animating-node");

      var attributeName = _this.getAttributeName();

      node.setAttribute(attributeName, 'true'); // Not white or transparent or grey

      styleForPseudo = styleForPseudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        // Add nonce if CSP exist
        if (_this.csp && _this.csp.nonce) {
          styleForPseudo.nonce = _this.csp.nonce;
        }

        extraNode.style.borderColor = waveColor;
        styleForPseudo.innerHTML = "\n      [".concat(getPrefixCls(''), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(''), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }");

        if (!document.body.contains(styleForPseudo)) {
          document.body.appendChild(styleForPseudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      ['transition', 'animation'].forEach(function (name) {
        node.addEventListener("".concat(name, "start"), _this.onTransitionStart);
        node.addEventListener("".concat(name, "end"), _this.onTransitionEnd);
      });
    };

    _this.onTransitionStart = function (e) {
      if (_this.destroyed) {
        return;
      }

      var node = _this.containerRef.current;

      if (!e || e.target !== node || _this.animationStart) {
        return;
      }

      _this.resetEffect(node);
    };

    _this.onTransitionEnd = function (e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      _this.resetEffect(e.target);
    };

    _this.bindAnimationEvent = function (node) {
      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this.clickWaveTimeoutId = window.setTimeout(function () {
          return _this.onClick(node, waveColor);
        }, 0);

        _raf["default"].cancel(_this.animationStartId);

        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this.animationStartId = (0, _raf["default"])(function () {
          _this.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    };

    _this.renderWave = function (_ref) {
      var csp = _ref.csp;
      var children = _this.props.children;
      _this.csp = csp;
      if (! /*#__PURE__*/React.isValidElement(children)) return children;
      var ref = _this.containerRef;

      if ((0, _ref2.supportRef)(children)) {
        ref = (0, _ref2.composeRef)(children.ref, _this.containerRef);
      }

      return (0, _reactNode.cloneElement)(children, {
        ref: ref
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(Wave, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = this.containerRef.current;

      if (!node || node.nodeType !== 1) {
        return;
      }

      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }

      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }

      this.destroyed = true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var getPrefixCls = this.context.getPrefixCls;
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? "".concat(getPrefixCls(''), "-click-animating") : "".concat(getPrefixCls(''), "-click-animating-without-extra-node");
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      var _this2 = this;

      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

      if (styleForPseudo) {
        styleForPseudo.innerHTML = '';
      }

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      ['transition', 'animation'].forEach(function (name) {
        node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
        node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
    }
  }]);
  return Wave;
}(React.Component);

exports["default"] = Wave;
Wave.contextType = _configProvider.ConfigContext;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = _interopRequireWildcard(__webpack_require__(286));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _SubMenu = _interopRequireDefault(__webpack_require__(1433));

var _MenuItem = _interopRequireDefault(__webpack_require__(1434));

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _Sider = __webpack_require__(359);

var _motion = _interopRequireDefault(__webpack_require__(662));

var _reactNode = __webpack_require__(57);

var _MenuContext = _interopRequireDefault(__webpack_require__(390));

var InternalMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(InternalMenu, _React$Component);

  var _super = (0, _createSuper2["default"])(InternalMenu);

  function InternalMenu(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, InternalMenu);
    _this = _super.call(this, props);

    _this.renderMenu = function (_ref) {
      var getPopupContainer = _ref.getPopupContainer,
          getPrefixCls = _ref.getPrefixCls,
          direction = _ref.direction;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          className = _this$props.className,
          theme = _this$props.theme,
          expandIcon = _this$props.expandIcon;
      var defaultMotions = {
        horizontal: {
          motionName: 'slide-up'
        },
        inline: _motion["default"],
        other: {
          motionName: 'zoom-big'
        }
      };
      var prefixCls = getPrefixCls('menu', customizePrefixCls);
      var menuClassName = (0, _classnames["default"])("".concat(prefixCls, "-").concat(theme), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()), className);
      return /*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
        value: {
          inlineCollapsed: _this.getInlineCollapsed() || false,
          antdMenuTheme: theme,
          direction: direction
        }
      }, /*#__PURE__*/React.createElement(_rcMenu["default"], (0, _extends2["default"])({
        getPopupContainer: getPopupContainer
      }, _this.props, {
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: (0, _reactNode.cloneElement)(expandIcon, {
          className: "".concat(prefixCls, "-submenu-expand-icon")
        })
      })));
    };

    (0, _devWarning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
    (0, _devWarning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
    return _this;
  }

  (0, _createClass2["default"])(InternalMenu, [{
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var _this$props2 = this.props,
          inlineCollapsed = _this$props2.inlineCollapsed,
          siderCollapsed = _this$props2.siderCollapsed;

      if (siderCollapsed !== undefined) {
        return siderCollapsed;
      }

      return inlineCollapsed;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu);
    }
  }]);
  return InternalMenu;
}(React.Component);

InternalMenu.defaultProps = {
  className: '',
  theme: 'light',
  focusable: false
}; // We should keep this as ref-able

var Menu = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2["default"])(Menu, _React$Component2);

  var _super2 = (0, _createSuper2["default"])(Menu);

  function Menu() {
    (0, _classCallCheck2["default"])(this, Menu);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(Menu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
        return /*#__PURE__*/React.createElement(InternalMenu, (0, _extends2["default"])({}, _this2.props, context));
      });
    }
  }]);
  return Menu;
}(React.Component);

exports["default"] = Menu;
Menu.Divider = _rcMenu.Divider;
Menu.Item = _MenuItem["default"];
Menu.SubMenu = _SubMenu["default"];
Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = omit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(330);

function omit(obj, fields) {
  var clone = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }
  return clone;
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var MenuContext = /*#__PURE__*/(0, _react.createContext)({
  inlineCollapsed: false
});
var _default = MenuContext;
exports["default"] = _default;

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(645));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _ref = __webpack_require__(117);

var _configProvider = __webpack_require__(8);

var _context = _interopRequireDefault(__webpack_require__(393));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalRadio = function InternalRadio(props, ref) {
  var _classNames;

  var context = React.useContext(_context["default"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var innerRef = React.useRef();
  var mergedRef = (0, _ref.composeRef)(ref, innerRef);
  React.useEffect(function () {
    (0, _devWarning["default"])(!('optionType' in props), 'Radio', '`optionType` is only support in Radio.Group.');
  }, []);

  var onChange = function onChange(e) {
    if (props.onChange) {
      props.onChange(e);
    }

    if (context === null || context === void 0 ? void 0 : context.onChange) {
      context.onChange(e);
    }
  };

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      style = props.style,
      restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

  var prefixCls = getPrefixCls('radio', customizePrefixCls);
  var radioProps = (0, _extends2["default"])({}, restProps);

  if (context) {
    radioProps.name = context.name;
    radioProps.onChange = onChange;
    radioProps.checked = props.value === context.value;
    radioProps.disabled = props.disabled || context.disabled;
  }

  var wrapperClassString = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), _classNames), className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    React.createElement("label", {
      className: wrapperClassString,
      style: style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], (0, _extends2["default"])({}, radioProps, {
      prefixCls: prefixCls,
      ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
  );
};

var Radio = /*#__PURE__*/React.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
Radio.defaultProps = {
  type: 'radio'
};
var _default = Radio;
exports["default"] = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioGroupContextProvider = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var RadioGroupContext = /*#__PURE__*/React.createContext(null);
var RadioGroupContextProvider = RadioGroupContext.Provider;
exports.RadioGroupContextProvider = RadioGroupContextProvider;
var _default = RadioGroupContext;
exports["default"] = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnKey = getColumnKey;
exports.getColumnPos = getColumnPos;
exports.renderColumnTitle = renderColumnTitle;

function getColumnKey(column, defaultKey) {
  if ('key' in column && column.key !== undefined && column.key !== null) {
    return column.key;
  }

  if (column.dataIndex) {
    return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
  }

  return defaultKey;
}

function getColumnPos(index, pos) {
  return pos ? "".concat(pos, "-").concat(index) : "".concat(index);
}

function renderColumnTitle(title, props) {
  if (typeof title === 'function') {
    return title(props);
  }

  return title;
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184),
    root = __webpack_require__(109);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _RowContext = _interopRequireDefault(__webpack_require__(673));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function parseFlex(flex) {
  if (typeof flex === 'number') {
    return "".concat(flex, " ").concat(flex, " auto");
  }

  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return "0 0 ".concat(flex);
  }

  return flex;
}

var sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
var Col = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useContext2 = React.useContext(_RowContext["default"]),
      gutter = _React$useContext2.gutter,
      wrap = _React$useContext2.wrap;

  var customizePrefixCls = props.prefixCls,
      span = props.span,
      order = props.order,
      offset = props.offset,
      push = props.push,
      pull = props.pull,
      className = props.className,
      children = props.children,
      flex = props.flex,
      style = props.style,
      others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);

  var prefixCls = getPrefixCls('col', customizePrefixCls);
  var sizeClassObj = {};
  sizes.forEach(function (size) {
    var _extends2;

    var sizeProps = {};
    var propSize = props[size];

    if (typeof propSize === 'number') {
      sizeProps.span = propSize;
    } else if ((0, _typeof2["default"])(propSize) === 'object') {
      sizeProps = propSize || {};
    }

    delete others[size];
    sizeClassObj = (0, _extends3["default"])((0, _extends3["default"])({}, sizeClassObj), (_extends2 = {}, (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), (0, _defineProperty2["default"])(_extends2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _extends2));
  });
  var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-order-").concat(order), order), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-push-").concat(push), push), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
  var mergedStyle = (0, _extends3["default"])({}, style);

  if (gutter) {
    mergedStyle = (0, _extends3["default"])((0, _extends3["default"])((0, _extends3["default"])({}, gutter[0] > 0 ? {
      paddingLeft: gutter[0] / 2,
      paddingRight: gutter[0] / 2
    } : {}), gutter[1] > 0 ? {
      paddingTop: gutter[1] / 2,
      paddingBottom: gutter[1] / 2
    } : {}), mergedStyle);
  }

  if (flex) {
    mergedStyle.flex = parseFlex(flex); // Hack for Firefox to avoid size issue
    // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553

    if (flex === 'auto' && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }

  return /*#__PURE__*/React.createElement("div", (0, _extends3["default"])({}, others, {
    style: mergedStyle,
    className: classes,
    ref: ref
  }), children);
});
Col.displayName = 'Col';
var _default = Col;
exports["default"] = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1540);

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeProps = getTimeProps;
exports["default"] = exports.Components = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _PickerButton = _interopRequireDefault(__webpack_require__(1555));

var _PickerTag = _interopRequireDefault(__webpack_require__(1556));

var _generateSinglePicker2 = _interopRequireDefault(__webpack_require__(1559));

var _generateRangePicker = _interopRequireDefault(__webpack_require__(1598));

var Components = {
  button: _PickerButton["default"],
  rangeItem: _PickerTag["default"]
};
exports.Components = Components;

function toArray(list) {
  if (!list) {
    return [];
  }

  return Array.isArray(list) ? list : [list];
}

function getTimeProps(props) {
  var format = props.format,
      picker = props.picker,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      use12Hours = props.use12Hours;
  var firstFormat = toArray(format)[0];
  var showTimeObj = (0, _extends2["default"])({}, props);

  if (firstFormat && typeof firstFormat === 'string') {
    if (!firstFormat.includes('s') && showSecond === undefined) {
      showTimeObj.showSecond = false;
    }

    if (!firstFormat.includes('m') && showMinute === undefined) {
      showTimeObj.showMinute = false;
    }

    if (!firstFormat.includes('H') && !firstFormat.includes('h') && showHour === undefined) {
      showTimeObj.showHour = false;
    }

    if ((firstFormat.includes('a') || firstFormat.includes('A')) && use12Hours === undefined) {
      showTimeObj.use12Hours = true;
    }
  }

  if (picker === 'time') {
    return showTimeObj;
  }

  if (typeof firstFormat === 'function') {
    // format of showTime should use default when format is custom format function
    delete showTimeObj.format;
  }

  return {
    showTime: showTimeObj
  };
}

function generatePicker(generateConfig) {
  // =========================== Picker ===========================
  var _generateSinglePicker = (0, _generateSinglePicker2["default"])(generateConfig),
      DatePicker = _generateSinglePicker.DatePicker,
      WeekPicker = _generateSinglePicker.WeekPicker,
      MonthPicker = _generateSinglePicker.MonthPicker,
      YearPicker = _generateSinglePicker.YearPicker,
      TimePicker = _generateSinglePicker.TimePicker,
      QuarterPicker = _generateSinglePicker.QuarterPicker; // ======================== Range Picker ========================


  var RangePicker = (0, _generateRangePicker["default"])(generateConfig);
  var MergedDatePicker = DatePicker;
  MergedDatePicker.WeekPicker = WeekPicker;
  MergedDatePicker.MonthPicker = MonthPicker;
  MergedDatePicker.YearPicker = YearPicker;
  MergedDatePicker.RangePicker = RangePicker;
  MergedDatePicker.TimePicker = TimePicker;
  MergedDatePicker.QuarterPicker = QuarterPicker;
  return MergedDatePicker;
}

var _default = generatePicker;
exports["default"] = _default;

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__panels_TimePanel__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__panels_DatetimePanel__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__panels_DatePanel__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__panels_WeekPanel__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__panels_MonthPanel__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__panels_QuarterPanel__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__panels_YearPanel__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__panels_DecadePanel__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_uiUtil__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_getExtraFooter__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_getRanges__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__ = __webpack_require__(296);






/**
 * Logic:
 *  When `mode` === `picker`,
 *  click will trigger `onSelect` (if value changed trigger `onChange` also).
 *  Panel change will not trigger `onSelect` but trigger `onPanelChange`
 */





















function PickerPanel(props) {
  var _classNames;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      className = props.className,
      style = props.style,
      locale = props.locale,
      generateConfig = props.generateConfig,
      value = props.value,
      defaultValue = props.defaultValue,
      pickerValue = props.pickerValue,
      defaultPickerValue = props.defaultPickerValue,
      disabledDate = props.disabledDate,
      mode = props.mode,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      showNow = props.showNow,
      showTime = props.showTime,
      showToday = props.showToday,
      renderExtraFooter = props.renderExtraFooter,
      hideHeader = props.hideHeader,
      onSelect = props.onSelect,
      onChange = props.onChange,
      onPanelChange = props.onPanelChange,
      onMouseDown = props.onMouseDown,
      onPickerValueChange = props.onPickerValueChange,
      _onOk = props.onOk,
      components = props.components,
      direction = props.direction,
      _props$hourStep = props.hourStep,
      hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep,
      _props$minuteStep = props.minuteStep,
      minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep,
      _props$secondStep = props.secondStep,
      secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep;
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
  var isHourStepValid = 24 % hourStep === 0;
  var isMinuteStepValid = 60 % minuteStep === 0;
  var isSecondStepValid = 60 % secondStep === 0;

  if (false) {
    warning(!value || generateConfig.isValidate(value), 'Invalidate date pass to `value`.');
    warning(!value || generateConfig.isValidate(value), 'Invalidate date pass to `defaultValue`.');
    warning(isHourStepValid, "`hourStep` ".concat(hourStep, " is invalid. It should be a factor of 24."));
    warning(isMinuteStepValid, "`minuteStep` ".concat(minuteStep, " is invalid. It should be a factor of 60."));
    warning(isSecondStepValid, "`secondStep` ".concat(secondStep, " is invalid. It should be a factor of 60."));
  } // ============================ State =============================


  var panelContext = __WEBPACK_IMPORTED_MODULE_5_react__["useContext"](__WEBPACK_IMPORTED_MODULE_19__PanelContext__["a" /* default */]);
  var operationRef = panelContext.operationRef,
      panelDivRef = panelContext.panelRef,
      onContextSelect = panelContext.onSelect,
      hideRanges = panelContext.hideRanges,
      defaultOpenValue = panelContext.defaultOpenValue;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_5_react__["useContext"](__WEBPACK_IMPORTED_MODULE_21__RangeContext__["a" /* default */]),
      inRange = _React$useContext.inRange,
      panelPosition = _React$useContext.panelPosition,
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var panelRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"]({}); // Handle init logic

  var initRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](true); // Value

  var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_hooks_useMergedState__["a" /* default */])(null, {
    value: value,
    defaultValue: defaultValue,
    postState: function postState(val) {
      if (!val && defaultOpenValue && picker === 'time') {
        return defaultOpenValue;
      }

      return val;
    }
  }),
      _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setInnerValue = _useMergedState2[1]; // View date control


  var _useMergedState3 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_hooks_useMergedState__["a" /* default */])(null, {
    value: pickerValue,
    defaultValue: defaultPickerValue || mergedValue,
    postState: function postState(date) {
      var now = generateConfig.getNow();
      if (!date) return now; // When value is null and set showTime

      // When value is null and set showTime
      if (!mergedValue && showTime) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(showTime) === 'object') {
          return Object(__WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__["c" /* setDateTime */])(generateConfig, Array.isArray(date) ? date[0] : date, showTime.defaultValue || now);
        }

        if (defaultValue) {
          return Object(__WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__["c" /* setDateTime */])(generateConfig, Array.isArray(date) ? date[0] : date, defaultValue);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__["c" /* setDateTime */])(generateConfig, Array.isArray(date) ? date[0] : date, now);
      }

      return date;
    }
  }),
      _useMergedState4 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState3, 2),
      viewDate = _useMergedState4[0],
      setInnerViewDate = _useMergedState4[1];

  var setViewDate = function setViewDate(date) {
    setInnerViewDate(date);

    if (onPickerValueChange) {
      onPickerValueChange(date);
    }
  }; // Panel control


  var getInternalNextMode = function getInternalNextMode(nextMode) {
    var getNextMode = __WEBPACK_IMPORTED_MODULE_20__utils_uiUtil__["a" /* PickerModeMap */][picker];

    if (getNextMode) {
      return getNextMode(nextMode);
    }

    return nextMode;
  }; // Save panel is changed from which panel


  var _useMergedState5 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_hooks_useMergedState__["a" /* default */])(function () {
    if (picker === 'time') {
      return 'time';
    }

    return getInternalNextMode('date');
  }, {
    value: mode
  }),
      _useMergedState6 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState5, 2),
      mergedMode = _useMergedState6[0],
      setInnerMode = _useMergedState6[1];

  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    setInnerMode(picker);
  }, [picker]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](function () {
    return mergedMode;
  }),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      sourceMode = _React$useState2[0],
      setSourceMode = _React$useState2[1];

  var onInternalPanelChange = function onInternalPanelChange(newMode, viewValue) {
    var nextMode = getInternalNextMode(newMode || mergedMode);
    setSourceMode(mergedMode);
    setInnerMode(nextMode);

    if (onPanelChange && (mergedMode !== nextMode || Object(__WEBPACK_IMPORTED_MODULE_18__utils_dateUtil__["g" /* isEqual */])(generateConfig, viewDate, viewDate))) {
      onPanelChange(viewValue, nextMode);
    }
  };

  var triggerSelect = function triggerSelect(date, type) {
    var forceTriggerSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (mergedMode === picker || forceTriggerSelect) {
      setInnerValue(date);

      if (onSelect) {
        onSelect(date);
      }

      if (onContextSelect) {
        onContextSelect(date, type);
      }

      if (onChange && !Object(__WEBPACK_IMPORTED_MODULE_18__utils_dateUtil__["g" /* isEqual */])(generateConfig, date, mergedValue) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date))) {
        onChange(date);
      }
    }
  }; // ========================= Interactive ==========================


  var onInternalKeyDown = function onInternalKeyDown(e) {
    if (panelRef.current && panelRef.current.onKeyDown) {
      if ([__WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].LEFT, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].RIGHT, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].UP, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_UP, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER].includes(e.which)) {
        e.preventDefault();
      }

      return panelRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_warning__["a" /* default */])(false, 'Panel not correct handle keyDown event. Please help to fire issue about this.');
      return false;
    }
    /* eslint-enable no-lone-blocks */
  };

  var onInternalBlur = function onInternalBlur(e) {
    if (panelRef.current && panelRef.current.onBlur) {
      panelRef.current.onBlur(e);
    }
  };

  if (operationRef && panelPosition !== 'right') {
    operationRef.current = {
      onKeyDown: onInternalKeyDown,
      onClose: function onClose() {
        if (panelRef.current && panelRef.current.onClose) {
          panelRef.current.onClose();
        }
      }
    };
  } // ============================ Effect ============================


  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (value && !initRef.current) {
      setInnerViewDate(value);
    }
  }, [value]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    initRef.current = false;
  }, []); // ============================ Panels ============================

  var panelNode;

  var pickerProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
    operationRef: panelRef,
    prefixCls: prefixCls,
    viewDate: viewDate,
    value: mergedValue,
    onViewDateChange: setViewDate,
    sourceMode: sourceMode,
    onPanelChange: onInternalPanelChange,
    disabledDate: disabledDate
  });

  delete pickerProps.onChange;
  delete pickerProps.onSelect;

  switch (mergedMode) {
    case 'decade':
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__panels_DecadePanel__["c" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'year':
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__panels_YearPanel__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'month':
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__panels_MonthPanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'quarter':
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__panels_QuarterPanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'week':
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__panels_WeekPanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'time':
      delete pickerProps.showTime;
      panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__panels_TimePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(showTime) === 'object' ? showTime : null, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    default:
      if (showTime) {
        panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__panels_DatetimePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
          onSelect: function onSelect(date, type) {
            setViewDate(date);
            triggerSelect(date, type);
          }
        }));
      } else {
        panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__panels_DatePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pickerProps, {
          onSelect: function onSelect(date, type) {
            setViewDate(date);
            triggerSelect(date, type);
          }
        }));
      }

  } // ============================ Footer ============================


  var extraFooter;
  var rangesNode;

  var onNow = function onNow() {
    var now = generateConfig.getNow();
    var lowerBoundTime = Object(__WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__["b" /* getLowerBoundTime */])(generateConfig.getHour(now), generateConfig.getMinute(now), generateConfig.getSecond(now), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
    var adjustedNow = Object(__WEBPACK_IMPORTED_MODULE_24__utils_timeUtil__["d" /* setTime */])(generateConfig, now, lowerBoundTime[0], // hour
    lowerBoundTime[1], // minute
    lowerBoundTime[2]);
    triggerSelect(adjustedNow, 'submit');
  };

  if (!hideRanges) {
    extraFooter = Object(__WEBPACK_IMPORTED_MODULE_22__utils_getExtraFooter__["a" /* default */])(prefixCls, mergedMode, renderExtraFooter);
    rangesNode = Object(__WEBPACK_IMPORTED_MODULE_23__utils_getRanges__["a" /* default */])({
      prefixCls: prefixCls,
      components: components,
      needConfirmButton: needConfirmButton,
      okDisabled: !mergedValue || disabledDate && disabledDate(mergedValue),
      locale: locale,
      showNow: showNow,
      onNow: needConfirmButton && onNow,
      onOk: function onOk() {
        if (mergedValue) {
          triggerSelect(mergedValue, 'submit', true);

          if (_onOk) {
            _onOk(mergedValue);
          }
        }
      }
    });
  }

  var todayNode;

  if (showToday && mergedMode === 'date' && picker === 'date' && !showTime) {
    var now = generateConfig.getNow();
    var todayCls = "".concat(prefixCls, "-today-btn");
    var disabled = disabledDate && disabledDate(now);
    todayNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("a", {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(todayCls, disabled && "".concat(todayCls, "-disabled")),
      "aria-disabled": disabled,
      onClick: function onClick() {
        if (!disabled) {
          triggerSelect(now, 'mouse', true);
        }
      }
    }, locale.today);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__PanelContext__["a" /* default */].Provider, {
    value: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, panelContext), {}, {
      mode: mergedMode,
      hideHeader: 'hideHeader' in props ? hideHeader : panelContext.hideHeader,
      hidePrevBtn: inRange && panelPosition === 'right',
      hideNextBtn: inRange && panelPosition === 'left'
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    tabIndex: tabIndex,
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-panel"), className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-panel-has-range"), rangedValue && rangedValue[0] && rangedValue[1]), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1]), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-panel-rtl"), direction === 'rtl'), _classNames)),
    style: style,
    onKeyDown: onInternalKeyDown,
    onBlur: onInternalBlur,
    onMouseDown: onMouseDown,
    ref: panelDivRef
  }, panelNode, extraFooter || rangesNode || todayNode ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-footer")
  }, extraFooter, rangesNode, todayNode) : null));
}

/* harmony default export */ __webpack_exports__["a"] = (PickerPanel);
/* eslint-enable */

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateBody__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateHeader__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_uiUtil__ = __webpack_require__(99);









var DATE_ROW_COUNT = 6;

function DatePanel(props) {
  var prefixCls = props.prefixCls,
      _props$panelName = props.panelName,
      panelName = _props$panelName === void 0 ? 'date' : _props$panelName,
      keyboardConfig = props.keyboardConfig,
      active = props.active,
      operationRef = props.operationRef,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onViewDateChange = props.onViewDateChange,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__utils_uiUtil__["c" /* createKeyDownHandler */])(event, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff * __WEBPACK_IMPORTED_MODULE_7__utils_dateUtil__["a" /* WEEK_DAY_COUNT */]), 'key');
        },
        onPageUpDown: function onPageUpDown(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
        }
      }, keyboardConfig));
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  var onMonthChange = function onMonthChange(diff) {
    var newDate = generateConfig.addMonth(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(panelPrefixCls, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(panelPrefixCls, "-active"), active))
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__DateHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate // View Operation
    ,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onPrevMonth: function onPrevMonth() {
      onMonthChange(-1);
    },
    onNextMonth: function onNextMonth() {
      onMonthChange(1);
    },
    onMonthClick: function onMonthClick() {
      onPanelChange('month', viewDate);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DateBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    onSelect: function onSelect(date) {
      return _onSelect(date, 'mouse');
    },
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate,
    rowCount: DATE_ROW_COUNT
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (DatePanel);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YEAR_DECADE_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YearHeader__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YearBody__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__ = __webpack_require__(99);





var YEAR_DECADE_COUNT = 10;

function YearPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      sourceMode = props.sourceMode,
      _onSelect = props.onSelect,
      onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__["c" /* createKeyDownHandler */])(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * YEAR_DECADE_COUNT), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * __WEBPACK_IMPORTED_MODULE_3__YearBody__["a" /* YEAR_COL_COUNT */]), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange(sourceMode === 'date' ? 'date' : 'month', value || viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onDecadeChange = function onDecadeChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff * 10);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__YearHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onPrevDecade: function onPrevDecade() {
      onDecadeChange(-1);
    },
    onNextDecade: function onNextDecade() {
      onDecadeChange(1);
    },
    onDecadeClick: function onDecadeClick() {
      onPanelChange('decade', viewDate);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__YearBody__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      onPanelChange(sourceMode === 'date' ? 'date' : 'month', date);

      _onSelect(date, 'mouse');
    }
  })));
}

/* harmony default export */ __webpack_exports__["b"] = (YearPanel);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useValueTexts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shallowequal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_hooks_useMemo__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__ = __webpack_require__(61);



function useValueTexts(value, _ref) {
  var formatList = _ref.formatList,
      generateConfig = _ref.generateConfig,
      locale = _ref.locale;
  return Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_hooks_useMemo__["a" /* default */])(function () {
    if (!value) {
      return [[''], ''];
    } // We will convert data format back to first format


    var firstValueText = '';
    var fullValueTexts = [];

    for (var i = 0; i < formatList.length; i += 1) {
      var format = formatList[i];
      var formatStr = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(value, {
        generateConfig: generateConfig,
        locale: locale,
        format: format
      });
      fullValueTexts.push(formatStr);

      if (i === 0) {
        firstValueText = formatStr;
      }
    }

    return [fullValueTexts, firstValueText];
  }, [value, formatList], function (prev, next) {
    return prev[0] !== next[0] || !__WEBPACK_IMPORTED_MODULE_0_shallowequal___default()(prev[1], next[1]);
  });
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _QuestionCircleOutlined = _interopRequireDefault(__webpack_require__(1630));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _QuestionCircleOutlined.default
  }));
};
QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(QuestionCircleOutlined);
exports.default = _default;

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null));

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1FE9G","container_1":"container_1___1bywV","container_2":"container_2___1mkP5"};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(88);
var normalizeHeaderName = __webpack_require__(1666);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(715);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(715);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(329)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CopyOutlined = _interopRequireDefault(__webpack_require__(1685));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CopyOutlined = function CopyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CopyOutlined.default
  }));
};
CopyOutlined.displayName = 'CopyOutlined';
var _default = /*#__PURE__*/React.forwardRef(CopyOutlined);
exports.default = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.destroyFns = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDialog = _interopRequireDefault(__webpack_require__(1712));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _useModal = _interopRequireDefault(__webpack_require__(1734));

var _locale = __webpack_require__(333);

var _button = _interopRequireDefault(__webpack_require__(26));

var _button2 = __webpack_require__(285);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var mousePosition;
var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795

exports.destroyFns = destroyFns;

var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  }; // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开

  setTimeout(function () {
    mousePosition = null;
  }, 100);
}; // 只有点击事件支持从鼠标位置动画展开


if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
  document.documentElement.addEventListener('click', getClickPosition, true);
}

var Modal = function Modal(props) {
  var _classNames;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var handleCancel = function handleCancel(e) {
    var onCancel = props.onCancel;

    if (onCancel) {
      onCancel(e);
    }
  };

  var handleOk = function handleOk(e) {
    var onOk = props.onOk;

    if (onOk) {
      onOk(e);
    }
  };

  var renderFooter = function renderFooter(locale) {
    var okText = props.okText,
        okType = props.okType,
        cancelText = props.cancelText,
        confirmLoading = props.confirmLoading;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({
      onClick: handleCancel
    }, props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({}, (0, _button2.convertLegacyProps)(okType), {
      loading: confirmLoading,
      onClick: handleOk
    }, props.okButtonProps), okText || locale.okText));
  };

  var customizePrefixCls = props.prefixCls,
      footer = props.footer,
      visible = props.visible,
      wrapClassName = props.wrapClassName,
      centered = props.centered,
      getContainer = props.getContainer,
      closeIcon = props.closeIcon,
      _props$focusTriggerAf = props.focusTriggerAfterClose,
      focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
      restProps = __rest(props, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose"]);

  var prefixCls = getPrefixCls('modal', customizePrefixCls);
  var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Modal",
    defaultLocale: (0, _locale.getConfirmLocale)()
  }, renderFooter);
  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-close-x")
  }, closeIcon || /*#__PURE__*/React.createElement(_CloseOutlined["default"], {
    className: "".concat(prefixCls, "-close-icon")
  }));
  var wrapClassNameExtended = (0, _classnames["default"])(wrapClassName, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-centered"), !!centered), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrap-rtl"), direction === 'rtl'), _classNames));
  return /*#__PURE__*/React.createElement(_rcDialog["default"], (0, _extends2["default"])({}, restProps, {
    getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
    prefixCls: prefixCls,
    wrapClassName: wrapClassNameExtended,
    footer: footer === undefined ? defaultFooter : footer,
    visible: visible,
    mousePosition: mousePosition,
    onClose: handleCancel,
    closeIcon: closeIconToRender,
    focusTriggerAfterClose: focusTriggerAfterClose
  }));
};

Modal.useModal = _useModal["default"];
Modal.defaultProps = {
  width: 520,
  transitionName: 'zoom',
  maskTransitionName: 'fade',
  confirmLoading: false,
  visible: false,
  okType: 'primary'
};
var _default = Modal;
exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1718);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */
function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!style) {
    return {};
  }
  var _options$element = options.element,
    element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style);

  // IE browser compatible
  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}
/* harmony default export */ __webpack_exports__["a"] = (setStyle);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1728);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isClassComponent(Component) {
    return (Component &&
        Component.prototype &&
        typeof Component.prototype.render === 'function');
}
function isRefForwardingComponent(C) {
    return (C && C.$$typeof && C.$$typeof.toString() === 'Symbol(react.forward_ref)');
}
exports.isRefForwardingComponent = isRefForwardingComponent;
function isRefable(C) {
    return isClassComponent(C) || isRefForwardingComponent(C);
}
exports.isRefable = isRefable;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(262);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var DragDropContext_1 = __webpack_require__(301);
var invariant = __webpack_require__(25);
/**
 * A hook to retrieve the DragDropManager from Context
 */
function useDragDropManager() {
    var dragDropManager = react_1.useContext(DragDropContext_1.context).dragDropManager;
    invariant(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}
exports.useDragDropManager = useDragDropManager;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE = '__NATIVE_FILE__';
exports.URL = '__NATIVE_URL__';
exports.TEXT = '__NATIVE_TEXT__';


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validProgress = validProgress;
exports.getSuccessPercent = getSuccessPercent;

var _devWarning = _interopRequireDefault(__webpack_require__(41));

function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}

function getSuccessPercent(_ref) {
  var success = _ref.success,
      successPercent = _ref.successPercent;
  var percent = successPercent;
  /** @deprecated Use `percent` instead */

  if (success && 'progress' in success) {
    (0, _devWarning["default"])(false, 'Progress', '`success.progress` is deprecated. Please use `success.percent` instead.');
    percent = success.progress;
  }

  if (success && 'percent' in success) {
    percent = success.percent;
  }

  return percent;
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(345));

var _ExclamationCircleOutlined = _interopRequireDefault(__webpack_require__(347));

var _InfoCircleOutlined = _interopRequireDefault(__webpack_require__(349));

var _CloseCircleOutlined = _interopRequireDefault(__webpack_require__(346));

var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(258));

var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(257));

var _InfoCircleFilled = _interopRequireDefault(__webpack_require__(533));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _rcMotion = _interopRequireDefault(__webpack_require__(84));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(1869));

var _ErrorBoundary = _interopRequireDefault(__webpack_require__(1870));

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var iconMapFilled = {
  success: _CheckCircleFilled["default"],
  info: _InfoCircleFilled["default"],
  error: _CloseCircleFilled["default"],
  warning: _ExclamationCircleFilled["default"]
};
var iconMapOutlined = {
  success: _CheckCircleOutlined["default"],
  info: _InfoCircleOutlined["default"],
  error: _CloseCircleOutlined["default"],
  warning: _ExclamationCircleOutlined["default"]
};

var Alert = function Alert(_a) {
  var _classNames2;

  var description = _a.description,
      customizePrefixCls = _a.prefixCls,
      message = _a.message,
      banner = _a.banner,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      style = _a.style,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      onClick = _a.onClick,
      afterClose = _a.afterClose,
      showIcon = _a.showIcon,
      closable = _a.closable,
      closeText = _a.closeText,
      action = _a.action,
      props = __rest(_a, ["description", "prefixCls", "message", "banner", "className", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "action"]);

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      closed = _React$useState2[0],
      setClosed = _React$useState2[1];

  var ref = React.useRef();

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('alert', customizePrefixCls);

  var handleClose = function handleClose(e) {
    var _a;

    setClosed(true);
    (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, e);
  };

  var getType = function getType() {
    var type = props.type;

    if (type !== undefined) {
      return type;
    } // banner 模式默认为警告


    return banner ? 'warning' : 'info';
  }; // closeable when closeText is assigned


  var isClosable = closeText ? true : closable;
  var type = getType();

  var renderIconNode = function renderIconNode() {
    var icon = props.icon; // use outline icon in alert with description

    var iconType = (description ? iconMapOutlined : iconMapFilled)[type] || null;

    if (icon) {
      return (0, _reactNode.replaceElement)(icon, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }, icon), function () {
        return {
          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), (0, _defineProperty2["default"])({}, icon.props.className, icon.props.className))
        };
      });
    }

    return /*#__PURE__*/React.createElement(iconType, {
      className: "".concat(prefixCls, "-icon")
    });
  };

  var renderCloseIcon = function renderCloseIcon() {
    return isClosable ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: handleClose,
      className: "".concat(prefixCls, "-close-icon"),
      tabIndex: 0
    }, closeText ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-close-text")
    }, closeText) : /*#__PURE__*/React.createElement(_CloseOutlined["default"], null)) : null;
  }; // banner 模式默认有 Icon


  var isShowIcon = banner && showIcon === undefined ? true : showIcon;
  var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-with-description"), !!description), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-no-icon"), !isShowIcon), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-banner"), !!banner), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2), className);
  var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);
  return /*#__PURE__*/React.createElement(_rcMotion["default"], {
    visible: !closed,
    motionName: "".concat(prefixCls, "-motion"),
    motionAppear: false,
    motionEnter: false,
    onLeaveStart: function onLeaveStart(node) {
      return {
        maxHeight: node.offsetHeight
      };
    },
    onLeaveEnd: afterClose
  }, function (_ref) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      ref: ref,
      "data-show": !closed,
      className: (0, _classnames["default"])(alertCls, motionClassName),
      style: (0, _extends2["default"])((0, _extends2["default"])({}, style), motionStyle),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      role: "alert"
    }, dataOrAriaProps), isShowIcon ? renderIconNode() : null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message")
    }, message), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-description")
    }, description)), action ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-action")
    }, action) : null, renderCloseIcon());
  });
};

Alert.ErrorBoundary = _ErrorBoundary["default"];
var _default = Alert;
exports["default"] = _default;

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.arrayTreeFilter = factory());
}(this, (function () { 'use strict';

function arrayTreeFilter(data, filterFn, options) {
    options = options || {};
    options.childrenKeyName = options.childrenKeyName || "children";
    var children = data || [];
    var result = [];
    var level = 0;
    do {
        var foundItem = children.filter(function (item) {
            return filterFn(item, level);
        })[0];
        if (!foundItem) {
            break;
        }
        result.push(foundItem);
        children = foundItem[options.childrenKeyName] || [];
        level += 1;
    } while (children.length > 0);
    return result;
}

return arrayTreeFilter;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(807), __webpack_require__(195), __webpack_require__(32), __webpack_require__(836), __webpack_require__(52), __webpack_require__(2038), __webpack_require__(835));
	else if(typeof define === 'function' && define.amd)
		define(["react", "braft-utils", "draft-js", "immutable", "braft-convert", "react-dom", "braft-finder", "draftjs-utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("braft-utils"), require("draft-js"), require("immutable"), require("braft-convert"), require("react-dom"), require("braft-finder"), require("draftjs-utils")) : factory(root["react"], root["braft-utils"], root["draft-js"], root["immutable"], root["braft-convert"], root["react-dom"], root["braft-finder"], root["draftjs-utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__23__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(2);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(15);

var assertThisInitialized = __webpack_require__(1);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(26);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(27);

var iterableToArray = __webpack_require__(28);

var nonIterableSpread = __webpack_require__(29);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Immutable = __webpack_require__(13);

var KEY_SEPARATOR = '-';

function MultiDecorator(decorators) {
    this.decorators = Immutable.List(decorators);
}

/**
    Return list of decoration IDs per character

    @param {ContentBlock}
    @return {List<String>}
*/
MultiDecorator.prototype.getDecorations = function(block) {
    var decorations = Array(block.getText().length).fill(null);

    this.decorators.forEach(function(decorator, i) {
        var _decorations = decorator.getDecorations(block);

        _decorations.forEach(function(key, offset) {
            if (!key) {
                return;
            }

            key = i + KEY_SEPARATOR + key;

            decorations[offset] = key;
        });
    });

    return Immutable.List(decorations);
};

/**
    Return component to render a decoration

    @param {String}
    @return {Function}
*/
MultiDecorator.prototype.getComponentForKey = function(key) {
    var decorator = this.getDecoratorForKey(key);
    return decorator.getComponentForKey(
        this.getInnerKey(key)
    );
};

/**
    Return props to render a decoration

    @param {String}
    @return {Object}
*/
MultiDecorator.prototype.getPropsForKey = function(key) {
    var decorator = this.getDecoratorForKey(key);
    return decorator.getPropsForKey(
        this.getInnerKey(key)
    );
};

/**
    Return a decorator for a specific key

    @param {String}
    @return {Decorator}
*/
MultiDecorator.prototype.getDecoratorForKey = function(key) {
    var parts = key.split(KEY_SEPARATOR);
    var index = Number(parts[0]);

    return this.decorators.get(index);
};

/**
    Return inner key for a decorator

    @param {String}
    @return {String}
*/
MultiDecorator.prototype.getInnerKey = function(key) {
    var parts = key.split(KEY_SEPARATOR);
    return parts.slice(1).join(KEY_SEPARATOR);
};

module.exports = MultiDecorator;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(13),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(25);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(30);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__23__;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(36);

var iterableToArrayLimit = __webpack_require__(37);

var nonIterableRest = __webpack_require__(38);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(31);
var removeEntitiesAtEdges = __webpack_require__(34);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(32);
var Immutable = __webpack_require__(13);

var generateRandomKey = __webpack_require__(33);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(19);
var Immutable = __webpack_require__(13);

var findRangesImmutable = __webpack_require__(20);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(19);

var findRangesImmutable = __webpack_require__(20);
var invariant = __webpack_require__(35);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? undefined : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(15);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/objectSpread.js
var objectSpread = __webpack_require__(5);
var objectSpread_default = /*#__PURE__*/__webpack_require__.n(objectSpread);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(21);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(7);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(9);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(1);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/inherits.js
var inherits = __webpack_require__(10);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(12);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ../node_modules/draft-js/dist/Draft.css
var Draft = __webpack_require__(40);

// EXTERNAL MODULE: ./assets/scss/_base.scss
var _base = __webpack_require__(42);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./languages/en.js
/* harmony default export */ var en = ({
  base: {
    remove: 'Remove',
    cancel: 'Cancel',
    confirm: 'Confirm',
    inert: 'Insert',
    width: 'Width',
    height: 'Height'
  },
  controls: {
    clear: 'Clear',
    undo: 'Undo',
    redo: 'Redo',
    fontSize: 'Font Size',
    color: 'Color',
    textColor: 'Text',
    tempColors: 'Temp Colors',
    backgroundColor: 'Background',
    bold: 'Bold',
    lineHeight: 'Line Height',
    letterSpacing: 'Letter Spacing',
    textIndent: 'Text Indent',
    increaseIndent: 'Increase Indent',
    decreaseIndent: 'Decrease Indent',
    italic: 'Italic',
    underline: 'Underline',
    strikeThrough: 'Strike Through',
    fontFamily: 'Font Family',
    textAlign: 'Text Alignment',
    alignLeft: 'Left Alignment',
    alignCenter: 'Center Alignment',
    alignRight: 'Right Alignment',
    alignJustify: 'Justify Alignment',
    floatLeft: 'Left Float',
    floatRight: 'Right Float',
    superScript: 'Super Script',
    subScript: 'Sub Script',
    removeStyles: 'Remove Styles',
    headings: 'Headings',
    header: 'Header',
    normal: 'Normal',
    orderedList: 'Ordered List',
    unorderedList: 'Unordered List',
    blockQuote: 'Quote',
    code: 'Code',
    link: 'Link',
    unlink: 'Unlink',
    hr: 'Horizontal Line',
    media: 'Media',
    mediaLibirary: 'Media Library',
    emoji: 'Emoji',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen'
  },
  linkEditor: {
    textInputPlaceHolder: 'Input link text',
    linkInputPlaceHolder: 'Input link URL',
    inputWithEnterPlaceHolder: 'Input link URL and press Enter',
    openInNewWindow: 'Open in new window',
    removeLink: 'Remove Link'
  },
  audioPlayer: {
    title: 'Play Audio'
  },
  videoPlayer: {
    title: 'Play Video',
    embedTitle: 'Embed Media'
  },
  media: {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    embed: 'Embed'
  }
});
// CONCATENATED MODULE: ./languages/zh.js
/* harmony default export */ var zh = ({
  base: {
    remove: '删除',
    cancel: '取消',
    confirm: '确定',
    inert: '插入',
    width: '宽度',
    height: '高度'
  },
  controls: {
    clear: '清除内容',
    undo: '撤销',
    redo: '重做',
    fontSize: '字号',
    lineHeight: '行高',
    letterSpacing: '字间距',
    textIndent: '段落缩进',
    increaseIndent: '增加缩进',
    decreaseIndent: '减少缩进',
    border: '边框',
    color: '颜色',
    textColor: '文字颜色',
    backgroundColor: '背景颜色',
    tempColors: '临时颜色',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    strikeThrough: '删除线',
    fontFamily: '字体',
    textAlign: '文本对齐',
    alignLeft: '居左',
    alignCenter: '居中',
    alignRight: '居右',
    alignJustify: '两端',
    floatLeft: '左浮动',
    floatRight: '右浮动',
    superScript: '上标',
    subScript: '下标',
    removeStyles: '清除样式',
    headings: '标题',
    header: '标题',
    normal: '常规',
    orderedList: '有序列表',
    unorderedList: '无序列表',
    blockQuote: '引用',
    code: '代码',
    link: '链接',
    unlink: '清除链接',
    hr: '水平线',
    media: '媒体',
    mediaLibirary: '媒体库',
    emoji: '小表情',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏'
  },
  linkEditor: {
    textInputPlaceHolder: '输入链接文字',
    linkInputPlaceHolder: '输入链接地址',
    inputWithEnterPlaceHolder: '输入链接地址并回车',
    openInNewWindow: '在新窗口打开',
    removeLink: '移除链接'
  },
  audioPlayer: {
    title: '播放音频文件'
  },
  videoPlayer: {
    title: '播放视频文件',
    embedTitle: '嵌入式媒体'
  },
  media: {
    image: '图像',
    video: '视频',
    audio: '音频',
    embed: '嵌入式媒体'
  }
});
// CONCATENATED MODULE: ./languages/zh-hant.js
/* harmony default export */ var zh_hant = ({
  base: {
    remove: '刪除',
    cancel: '取消',
    confirm: '確定',
    inert: '插入',
    width: '寬度',
    height: '高度'
  },
  controls: {
    clear: '清除内容',
    undo: '復原',
    redo: '取消復原',
    fontSize: '字型大小',
    color: '顏色',
    textColor: '文字顏色',
    backgroundColor: '背景顏色',
    tempColors: '臨時顏色',
    bold: '粗體',
    lineHeight: '行高',
    letterSpacing: '字間距',
    textIndent: '段落縮進',
    increaseIndent: '增加縮進',
    decreaseIndent: '减少縮進',
    border: '邊框',
    italic: '斜體',
    underline: '底線',
    strikeThrough: '刪除線',
    fontFamily: '字體',
    textAlign: '文字對齊',
    alignLeft: '置左',
    alignCenter: '置中',
    alignRight: '置右',
    alignJustify: '左右對齊',
    floatLeft: '左浮動',
    floatRight: '右浮動',
    superScript: '上標',
    subScript: '下標',
    removeStyles: '清除樣式',
    headings: '標題',
    header: '標題',
    normal: '常規',
    orderedList: '有序列表',
    unorderedList: '無序列表',
    blockQuote: '引用',
    code: '程式碼',
    link: '連結',
    unlink: '清除連結',
    hr: '水平線',
    media: '媒體',
    mediaLibirary: '媒體庫',
    emoji: '表情符號',
    fullscreen: '全螢幕',
    exitFullscreen: '退出全螢幕'
  },
  linkEditor: {
    textInputPlaceHolder: '輸入連結文字',
    linkInputPlaceHolder: '輸入連結地址',
    inputWithEnterPlaceHolder: '輸入連結地址並換行',
    openInNewWindow: '在新視窗打開',
    removeLink: '移除連結'
  },
  audioPlayer: {
    title: '播放音檔'
  },
  videoPlayer: {
    title: '播放影片',
    embedTitle: '嵌入式媒體'
  },
  media: {
    image: '圖片',
    video: '影片',
    audio: '音檔',
    embed: '嵌入式媒體'
  }
});
// CONCATENATED MODULE: ./languages/pl.js
/* harmony default export */ var pl = ({
  base: {
    remove: 'Usuń',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    inert: 'Wstaw',
    width: 'Szerokość',
    height: 'Wysokość'
  },
  controls: {
    clear: 'Wyczyść',
    undo: 'Cofnij',
    redo: 'Przywróć',
    fontSize: 'Wielkość',
    color: 'Kolor',
    textColor: 'Kolor tekstu',
    tempColors: 'Kolory',
    backgroundColor: 'Tło',
    bold: 'Pogrubienie',
    lineHeight: 'Wysokość linii',
    letterSpacing: 'Odstęp znaków',
    textIndent: 'Wcięcie tekstu',
    increaseIndent: 'Zwiększ wcięcie',
    decreaseIndent: 'Zmniejsz wcięcie',
    italic: 'Italiki',
    underline: 'Podkreślenie',
    strikeThrough: 'Przekreślenie',
    fontFamily: 'Czcionka',
    textAlign: 'Wyrównanie tekstu',
    alignLeft: 'Do lewej',
    alignCenter: 'Wycentruj',
    alignRight: 'Do prawej',
    alignJustify: 'Wyjustuj',
    floatLeft: 'Do lewej',
    floatRight: 'Do prawej',
    superScript: 'Superskrypt',
    subScript: 'Subskrypt',
    removeStyles: 'Usuń stylowanie',
    headings: 'Nagłówki',
    header: 'Nagłówek',
    normal: 'Normalny',
    orderedList: 'Lista uporządkowana',
    unorderedList: 'Lista nieuporządkowana',
    blockQuote: 'Cytat',
    code: 'Kod',
    link: 'Link',
    unlink: 'Usuń link',
    hr: 'Linia pozioma',
    media: 'Media',
    mediaLibirary: 'Biblioteka mediów',
    emoji: 'Emoji'
  },
  linkEditor: {
    textInputPlaceHolder: 'Wpisz tekst linku',
    linkInputPlaceHolder: 'Wpisz Adres URL',
    inputWithEnterPlaceHolder: 'Wpisz adres URL i naciśnij Enter',
    openInNewWindow: 'Otwórz w nowym oknie',
    removeLink: 'Usuń link'
  },
  audioPlayer: {
    title: 'Odtwórz audio'
  },
  videoPlayer: {
    title: 'Odtwórz wideo',
    embedTitle: 'Tytuł'
  },
  media: {
    image: 'Obraz',
    video: 'Wideo',
    audio: 'Audio',
    embed: 'Obiekt osadzony'
  }
});
// CONCATENATED MODULE: ./languages/kr.js
/* harmony default export */ var kr = ({
  base: {
    remove: '삭제',
    cancel: '취소',
    confirm: '결정',
    inert: '삽입',
    width: '너비',
    height: '높이'
  },
  controls: {
    clear: '콘텐츠지우기',
    undo: '취소',
    redo: '다시하기',
    fontSize: '글자크기',
    lineHeight: '행높이',
    letterSpacing: '단어간격',
    textIndent: '단락들여쓰기',
    increaseIndent: '들여쓰기늘리기',
    decreaseIndent: '들여쓰기줄이기',
    border: '국경',
    color: '색상',
    textColor: '텍스트색상',
    backgroundColor: '배경색상',
    tempColors: '임시색',
    bold: '굵게',
    italic: '기울임꼴',
    underline: '밑줄',
    strikeThrough: '취소선',
    fontFamily: '글꼴',
    textAlign: '텍스트정렬',
    alignLeft: '왼쪽',
    alignCenter: '중심',
    alignRight: '오른쪽',
    alignJustify: '양쪽끝',
    floatLeft: '떠다니기',
    floatRight: '오른쪽부동',
    superScript: '위첨자',
    subScript: '첨자',
    removeStyles: '스타일지우기',
    headings: '제목',
    header: '제목',
    normal: '재래식',
    orderedList: '순서가지정된목록',
    unorderedList: '정렬되지않은목록',
    blockQuote: '참고문헌',
    code: '코드',
    link: '링크',
    unlink: '링크삭제',
    hr: '수평선',
    media: '미디어',
    mediaLibirary: '미디어라이브러리',
    emoji: '작은표현',
    fullscreen: '전체화면',
    exitFullscreen: '전체화면종료'
  },
  linkEditor: {
    textInputPlaceHolder: '링크텍스트입력',
    linkInputPlaceHolder: '링크주소입력',
    inputWithEnterPlaceHolder: '링크주소입력.',
    openInNewWindow: '새창열기',
    removeLink: '링크삭제'
  },
  audioPlayer: {
    title: '오디오파일재생'
  },
  videoPlayer: {
    title: '비디오파일재생',
    embedTitle: '임베디드미디어'
  },
  media: {
    image: '이미지',
    video: '비디오',
    audio: '오디오',
    embed: '임베디드미디어'
  }
});
// CONCATENATED MODULE: ./languages/tr.js
/* harmony default export */ var tr = ({
  base: {
    remove: 'Kaldır',
    cancel: 'İptal',
    confirm: 'Onayla',
    inert: 'Ekle',
    width: 'Genişlik',
    height: 'Yükseklik'
  },
  controls: {
    clear: 'Temizle',
    undo: 'Geri al',
    redo: 'İleri al',
    fontSize: 'Yazı boyutu',
    color: 'Renk',
    textColor: 'Yazı rengi',
    tempColors: 'Geçici renkler',
    backgroundColor: 'Arkaplan',
    bold: 'Kalın',
    lineHeight: 'Satır yüksekliği',
    letterSpacing: 'Harf aralığı',
    textIndent: 'Çentik aralığı',
    increaseIndent: 'Çentiği genişlet',
    decreaseIndent: 'Çentiği daralt',
    italic: 'Eğik',
    underline: 'Altı çizili',
    strikeThrough: 'Üstü çizili',
    fontFamily: 'Yazı tipi',
    textAlign: 'Metin Hizalama',
    alignLeft: 'Sola hizala',
    alignCenter: 'Ortaya hizala',
    alignRight: 'Sağa hizala',
    alignJustify: 'Her iki tarafa hizala',
    floatLeft: 'Sola yatır',
    floatRight: 'Sağa yatır',
    superScript: 'Ana kod',
    subScript: 'Alt kod',
    removeStyles: 'Stilleri kaldır',
    headings: 'Başlıklar',
    header: 'Başlık',
    normal: 'Normal',
    orderedList: 'Sıralı liste',
    unorderedList: 'Sırasız liste',
    blockQuote: 'Alıntı',
    code: 'Kod',
    link: 'Bağlantı',
    unlink: 'Bağlantıyı kaldır',
    hr: 'Yatay çizgi',
    media: 'Medya',
    mediaLibirary: 'Kütüphane',
    emoji: 'İfade',
    fullscreen: 'Tam ekran',
    exitFullscreen: 'Tam ekrandan çık'
  },
  linkEditor: {
    textInputPlaceHolder: 'Bağlantı metnini girin',
    linkInputPlaceHolder: 'Bağlantı URL\' si girin',
    inputWithEnterPlaceHolder: 'Bağlantı URL\'si girin ve Enter\' a basın',
    openInNewWindow: 'Yeni pencerede aç',
    removeLink: 'Bağlantıyı kaldır'
  },
  audioPlayer: {
    title: 'Ses çal'
  },
  videoPlayer: {
    title: 'Görüntü oynat',
    embedTitle: 'Görüntüyü göm'
  },
  media: {
    image: 'Resim',
    video: 'Görüntü',
    audio: 'Ses',
    embed: 'Gömülü nesne'
  }
});
// CONCATENATED MODULE: ./languages/jpn.js
/* harmony default export */ var jpn = ({
  base: {
    remove: '削除',
    cancel: 'キャンセル',
    confirm: '決定',
    inert: '挿入',
    width: '幅',
    height: '高さ'
  },
  controls: {
    clear: 'クリアコンテンツ',
    undo: 'キャンセル',
    redo: 'キャンセル',
    fontSize: 'フォントサイズ',
    lineHeight: 'フォントサイズ',
    letterSpacing: 'ワード間隔',
    textIndent: '段落のインデント',
    increaseIndent: 'インデントを増やす',
    decreaseIndent: 'インデントを減らす',
    border: '国境',
    color: '色',
    textColor: 'テキストの色',
    backgroundColor: '背景色',
    tempColors: '仮色',
    bold: '太字',
    italic: 'イタリック体',
    underline: '下線',
    strikeThrough: '取り消し線',
    fontFamily: 'フォント',
    textAlign: 'テキストの配置',
    alignLeft: '左',
    alignCenter: '中央揃え',
    alignRight: '右に立つ',
    alignJustify: '両端',
    floatLeft: '左フローティング',
    floatRight: '右フローティング',
    superScript: '上付き',
    subScript: '下付き文字',
    removeStyles: 'クリアスタイル',
    headings: '役職',
    header: '役職',
    normal: '従来の',
    orderedList: '順序付きリスト',
    unorderedList: '番号なしリスト',
    blockQuote: '参照',
    code: 'コード',
    link: 'リンク',
    unlink: 'リンクを解除',
    hr: '横線',
    media: 'メディア',
    mediaLibirary: 'メディアライブラリー',
    emoji: '小さな表現',
    fullscreen: '全画面',
    exitFullscreen: '全画面を退く'
  },
  linkEditor: {
    textInputPlaceHolder: 'リンクテキストを入力',
    linkInputPlaceHolder: 'リンクアドレスを入力',
    inputWithEnterPlaceHolder: 'リンクアドレスを入力して戻ります',
    openInNewWindow: '新しいウィンドウで開く',
    removeLink: '新しいウィンドウで開く'
  },
  audioPlayer: {
    title: 'オーディオファイルを再生する'
  },
  videoPlayer: {
    title: 'ビデオファイルを再生する',
    embedTitle: '埋め込みメディア'
  },
  media: {
    image: '画像',
    video: 'ビデオ',
    audio: '音声',
    embed: '埋め込みメディア'
  }
});
// CONCATENATED MODULE: ./languages/ru.js
/* harmony default export */ var ru = ({
  base: {
    remove: 'Удалить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    insert: 'Вставить',
    width: 'Ширина',
    height: 'Высота'
  },
  controls: {
    clear: 'Очистить',
    undo: 'Отменить',
    redo: 'Повторить',
    fontSize: 'Размер шрифта',
    color: 'Цвет',
    textColor: 'Цвет текста',
    tempColors: 'Temp Colors',
    backgroundColor: 'Цвет фона',
    bold: 'Жирный',
    lineHeight: 'Межстрочный интервал',
    letterSpacing: 'Межбуквенный интервал',
    textIndent: 'Отступ',
    increaseIndent: 'Увеличить отступ',
    decreaseIndent: 'Уменьшить отступ',
    italic: 'Курсив',
    underline: 'Подчеркнутый',
    strikeThrough: 'Перечеркнутый',
    fontFamily: 'Шрифт',
    textAlign: 'Расположение текста',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    alignJustify: 'По ширине',
    floatLeft: 'Обтекание слева',
    floatRight: 'Обтекание справа',
    superScript: 'Надстрочный индекс',
    subScript: 'Подстрочный индекс',
    removeStyles: 'Убрать стили',
    headings: 'Заголовки',
    header: 'Заголовок',
    normal: 'Обычный',
    orderedList: 'Упорядоченный список',
    unorderedList: 'Неупорядоченный список',
    blockQuote: 'Цитата',
    code: 'Код',
    link: 'Вставить ссылку',
    unlink: 'Убрать ссылку',
    hr: 'Горизонтальная линия',
    media: 'Медиа',
    mediaLibirary: 'Медиа библиотека',
    emoji: 'Emoji',
    fullscreen: 'Полноэкранный режим',
    exitFullscreen: 'Выйти из полноэкранного режима'
  },
  linkEditor: {
    textInputPlaceHolder: 'Введите текст ссылки',
    linkInputPlaceHolder: 'Вставить ссылку',
    inputWithEnterPlaceHolder: 'Вставить ссылку и нажать Enter',
    openInNewWindow: 'Открыть в новом окне',
    removeLink: 'Убрать ссылку'
  },
  audioPlayer: {
    title: 'Воспроизвести аудиофайл'
  },
  videoPlayer: {
    title: 'Воспроизвести видеофайл',
    embedTitle: 'Embed Media'
  },
  media: {
    image: 'Картинка',
    video: 'Видео',
    audio: 'Аудио',
    embed: 'Встроенное'
  }
});
// CONCATENATED MODULE: ./languages/fr.js
/* harmony default export */ var fr = ({
  base: {
    remove: 'Supprimer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    inert: 'Insérer',
    width: 'Largeur',
    height: 'Hauteur'
  },
  controls: {
    clear: 'Effacer',
    undo: 'Annuler',
    redo: 'Refaire',
    fontSize: 'Taille de police',
    color: 'Couleur',
    textColor: 'Texte',
    tempColors: 'Couleurs temporaire',
    backgroundColor: 'Couleur d\'arrière plan',
    bold: 'Gras',
    lineHeight: 'Hauteur de ligne',
    letterSpacing: 'Espacement des lettres',
    textIndent: 'Indentation du texte',
    increaseIndent: 'Augmenter l\'indentation',
    decreaseIndent: 'Réduire l\'indentation',
    italic: 'Italique',
    underline: 'Souligner',
    strikeThrough: 'Barrer',
    fontFamily: 'Police d\'écriture',
    textAlign: 'Alignement du texte',
    alignLeft: 'Aligner à gauche',
    alignCenter: 'Aligner au centre',
    alignRight: 'Aligner à droite',
    alignJustify: 'Justifier',
    floatLeft: 'Déplacer à gauche',
    floatRight: 'Déplacer à droite',
    superScript: 'Super-script',
    subScript: 'Sous-script',
    removeStyles: 'Supprimer les styles',
    headings: 'Titres',
    header: 'Entêtes',
    normal: 'Normal',
    orderedList: 'Liste ordonnée',
    unorderedList: 'Liste non-ordonnée',
    blockQuote: 'Citation',
    code: 'Code',
    link: 'Insérer un lien',
    unlink: 'Supprimer le lien',
    hr: 'Ligne horizontale',
    media: 'Média',
    mediaLibirary: 'Bibliothêque',
    emoji: 'Emoji',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran'
  },
  linkEditor: {
    textInputPlaceHolder: 'Insérer le texte à afficher',
    linkInputPlaceHolder: 'Insérer le lien URL',
    inputWithEnterPlaceHolder: 'Insérer le lien URL puis appuyer sur Entrée',
    openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
    removeLink: 'Supprimer le lien'
  },
  audioPlayer: {
    title: 'Lancer le son audio'
  },
  videoPlayer: {
    title: 'Lancer la video',
    embedTitle: 'Intégrer média'
  },
  media: {
    image: 'Image',
    video: 'Vidéo',
    audio: 'Audio',
    embed: 'Intégré'
  }
});
// CONCATENATED MODULE: ./languages/pt-br.js
/* harmony default export */ var pt_br = ({
  base: {
    remove: 'Remover',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    inert: 'Inserir',
    width: 'Largura',
    height: 'Altura'
  },
  controls: {
    clear: 'Limpar',
    undo: 'Desfazer',
    redo: 'Refazer',
    fontSize: 'Tamanho da Fonte',
    color: 'Cor',
    textColor: 'Texto',
    tempColors: 'Temp Colors',
    backgroundColor: 'Cor de Fundo',
    bold: 'Negrito',
    lineHeight: 'Altura da LinhaLine Height',
    letterSpacing: 'Espaçamento entre Letras',
    textIndent: 'Identação de Texto',
    increaseIndent: 'Aumentar Identação',
    decreaseIndent: 'Diminuir Identção',
    italic: 'Itálico',
    underline: 'Sublinhado',
    strikeThrough: 'Riscado',
    fontFamily: 'Família da Fonte',
    textAlign: 'Alinhamento de Texto',
    alignLeft: 'Alinhamento à Esquerda',
    alignCenter: 'Alinhamento Centralizado',
    alignRight: 'Alinhamento à Direita',
    alignJustify: 'Alinhamento Justificado',
    floatLeft: 'Flutuação à Esquerda',
    floatRight: 'Flutuação à Direita',
    superScript: 'Sobrescrito',
    subScript: 'Subscrito',
    removeStyles: 'Remover Estilos',
    headings: 'Cabeçalhos',
    header: 'Cabeçalho',
    normal: 'Normal',
    orderedList: 'Lista Ordenada',
    unorderedList: 'Lista Não Ordenada',
    blockQuote: 'Citação',
    code: 'Código',
    link: 'Link',
    unlink: 'Remover Link',
    hr: 'Linha Horizontal',
    media: 'Mídia',
    mediaLibirary: 'Biblioteca de Mídia',
    emoji: 'Emoji',
    fullscreen: 'Tela Cheia',
    exitFullscreen: 'Sair de Tela Cheia'
  },
  linkEditor: {
    textInputPlaceHolder: 'Insira o texto do link',
    linkInputPlaceHolder: 'Insira a URL do link',
    inputWithEnterPlaceHolder: 'Insira a URL do link e aperte Enter',
    openInNewWindow: 'Abrir em nova janela',
    removeLink: 'Remover Link'
  },
  audioPlayer: {
    title: 'Tocar Áudio'
  },
  videoPlayer: {
    title: 'Tocar Vídeo',
    embedTitle: 'Mídia Embutida'
  },
  media: {
    image: 'Imagem',
    video: 'Vídeo',
    audio: 'Áudio',
    embed: 'Embutido'
  }
});
// CONCATENATED MODULE: ./languages/vi-vn.js
/* harmony default export */ var vi_vn = ({
  base: {
    remove: 'Xóa bỏ',
    cancel: 'Hủy bỏ',
    confirm: 'Xác nhận',
    inert: 'Chèn vào',
    width: 'Độ rộng',
    height: 'Độ cao'
  },
  controls: {
    clear: 'Xóa toàn bộ nội dung',
    undo: 'Hủy bỏ',
    redo: 'Làm lại',
    fontSize: 'Size chữ',
    lineHeight: 'Độ cao hàng',
    letterSpacing: 'Khoảng cách chữ',
    textIndent: 'Khoảng cách đoạn văn',
    increaseIndent: 'Tăng khoảng cách',
    decreaseIndent: 'Giảm khoảng cách',
    border: 'Đường viền',
    color: 'Màu sắc',
    textColor: 'Màu chữ',
    backgroundColor: 'Màu nền',
    tempColors: 'Màu tạm thời',
    bold: 'Tô đậm',
    italic: 'In nghiêng',
    underline: 'Gạch dưới',
    strikeThrough: 'Xóa gạch dưới',
    fontFamily: 'Font chữ',
    textAlign: 'Căn chỉnh văn bản',
    alignLeft: 'Căn trái',
    alignCenter: 'Căn giữa',
    alignRight: 'Căn phải',
    alignJustify: 'Hai lề',
    floatLeft: 'Float left',
    floatRight: 'Float right',
    superScript: 'Chỉ số trên',
    subScript: 'Chỉ số dưới',
    removeStyles: 'Xóa style',
    headings: 'Tiêu đề',
    header: 'Tiêu đề',
    normal: 'Quy tắc thông thường',
    orderedList: 'Kiểu sắp xếp',
    unorderedList: 'Kiểu không sắp xếp',
    blockQuote: 'Trích dẫn',
    code: 'Code',
    link: 'Liên kết',
    unlink: 'Gỡ liên kết',
    hr: 'Horizontal line',
    media: 'Media',
    mediaLibirary: 'Kho media',
    emoji: 'Biểu tượng cảm xúc',
    fullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát khỏi chế độ toàn màn hình'
  },
  linkEditor: {
    textInputPlaceHolder: 'Nhập văn bản liên kết',
    linkInputPlaceHolder: 'Nhập địa chỉ liên kết',
    inputWithEnterPlaceHolder: 'Nhập địa chỉ liên kết và Enter',
    openInNewWindow: 'Mở trong tab mới',
    removeLink: 'Gỡ liên kết'
  },
  audioPlayer: {
    title: 'Phát tệp âm thanh'
  },
  videoPlayer: {
    title: 'Phát tệp video',
    embedTitle: 'Media nhúng'
  },
  media: {
    image: 'Hình ảnh',
    video: 'Video',
    audio: 'Âm thanh',
    embed: 'Media nhúng'
  }
});
// CONCATENATED MODULE: ./languages/index.js











/* harmony default export */ var languages = ({
  'en': en,
  'zh': zh,
  'zh-hant': zh_hant,
  'pl': pl,
  'kr': kr,
  'tr': tr,
  'jpn': jpn,
  'ru': ru,
  'fr': fr,
  'pt-br': pt_br,
  'vi-vn': vi_vn
});
// EXTERNAL MODULE: external "braft-finder"
var external_braft_finder_ = __webpack_require__(17);
var external_braft_finder_default = /*#__PURE__*/__webpack_require__.n(external_braft_finder_);

// EXTERNAL MODULE: external "braft-utils"
var external_braft_utils_ = __webpack_require__(3);

// EXTERNAL MODULE: external "draft-js"
var external_draft_js_ = __webpack_require__(6);

// EXTERNAL MODULE: external "immutable"
var external_immutable_ = __webpack_require__(13);
var external_immutable_default = /*#__PURE__*/__webpack_require__.n(external_immutable_);

// CONCATENATED MODULE: ./configs/keybindings.js
 // TODO
// Allow custom shortcut settings

/* harmony default export */ var keybindings = (function (customKeyBindingFn) {
  return function (event) {
    if (event.keyCode === 83 && (external_draft_js_["KeyBindingUtil"].hasCommandModifier(event) || external_draft_js_["KeyBindingUtil"].isCtrlKeyCommand(event))) {
      return 'braft-save';
    }

    if (customKeyBindingFn) {
      return customKeyBindingFn(event) || Object(external_draft_js_["getDefaultKeyBinding"])(event);
    }

    return Object(external_draft_js_["getDefaultKeyBinding"])(event);
  };
});
// CONCATENATED MODULE: ./configs/props.js
/* harmony default export */ var configs_props = ({
  language: 'zh',
  controls: ['undo', 'redo', 'separator', 'font-size', 'line-height', 'letter-spacing', 'separator', 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator', 'superscript', 'subscript', 'remove-styles', 'emoji', 'separator', 'text-indent', 'text-align', 'separator', 'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator', 'media', 'link', 'table', 'split', 'hr', 'separator', 'clear', 'separator', 'fullscreen'],
  excludeControls: [],
  extendControls: [],
  extendAtomics: [],
  componentBelowControlBar: null,
  media: {
    pasteImage: true,
    imagePasteLimit: 5,
    image: true,
    video: true,
    audio: true,
    uploadFn: null,
    validateFn: null,
    onBeforeDeselect: null,
    onDeselect: null,
    onBeforeSelect: null,
    onSelect: null,
    onBeforeRemove: null,
    onRemove: null,
    onCancel: null,
    onFileSelect: null,
    onBeforeInsert: null,
    onInsert: null,
    onChange: null,
    accepts: {
      image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
      video: 'video/mp4',
      audio: 'audio/mp3'
    },
    externals: {
      audio: true,
      video: true,
      image: true,
      embed: true
    }
  },
  imageControls: ['float-left', 'float-right', 'align-left', 'align-center', 'align-right', 'link', 'size', 'remove'],
  imageResizable: true,
  imageEqualRatio: true,
  colors: ['#000000', '#333333', '#666666', '#999999', '#cccccc', '#ffffff', '#61a951', '#16a085', '#07a9fe', '#003ba5', '#8e44ad', '#f32784', '#c0392b', '#d35400', '#f39c12', '#fdda00'],
  colorPicker: null,
  colorPickerTheme: 'dark',
  colorPickerAutoHide: true,
  codeTabIndents: 2,
  headings: ['header-one', 'header-two', 'header-three', 'header-four', 'header-five', 'header-six', 'unstyled'],
  textAligns: ['left', 'center', 'right', 'justify'],
  textBackgroundColor: true,
  allowInsertLinkText: false,
  defaultLinkTarget: '',
  letterSpacings: [0, 1, 2, 3, 4, 5, 6],
  lineHeights: [1, 1.2, 1.5, 1.75, 2, 2.5, 3, 4],
  fontSizes: [12, 14, 16, 18, 20, 24, 28, 30, 32, 36, 40, 48, 56, 64, 72, 96, 120, 144],
  fontFamilies: [{
    name: 'Araial',
    family: 'Arial, Helvetica, sans-serif'
  }, {
    name: 'Georgia',
    family: 'Georgia, serif'
  }, {
    name: 'Impact',
    family: 'Impact, serif'
  }, {
    name: 'Monospace',
    family: '"Courier New", Courier, monospace'
  }, {
    name: 'Tahoma',
    family: 'tahoma, arial, "Hiragino Sans GB", 宋体, sans-serif'
  }],
  converts: {
    unitExportFn: function unitExportFn(value, type) {
      return type === 'line-height' ? value : "".concat(value, "px");
    }
  },
  emojis: ['🤣', '🙌', '💚', '💛', '👏', '😉', '💯', '💕', '💞', '💘', '💙', '💝', '🖤', '💜', '❤️', '😍', '😻', '💓', '💗', '😋', '😇', '😂', '😹', '😘', '💖', '😁', '😀', '🤞', '😲', '😄', '😊', '👍', '😌', '😃', '😅', '✌️', '🤗', '💋', '😗', '😽', '😚', '🤠', '😙', '😺', '👄', '😸', '😏', '😼', '👌', '😎', '😆', '😛', '🙏', '🤝', '🙂', '🤑', '😝', '😐', '😑', '🤤', '😤', '🙃', '🤡', '😶', '😪', '😴', '😵', '😓', '👊', '😦', '😷', '🤐', '😜', '🤓', '👻', '😥', '🙄', '🤔', '🤒', '🙁', '😔', '😯', '☹️', '☠️', '😰', '😩', '😖', '😕', '😒', '😣', '😢', '😮', '😿', '🤧', '😫', '🤥', '😞', '😬', '👎', '💀', '😳', '😨', '🤕', '🤢', '😱', '😭', '😠', '😈', '😧', '💔', '😟', '🙀', '💩', '👿', '😡', '😾', '🖕'],
  stripPastedStyles: false,
  triggerChangeOnMount: true,
  className: '',
  style: {},
  controlBarClassName: '',
  controlBarStyle: {},
  contentClassName: '',
  contentStyle: {},
  draftProps: {},
  hooks: {},
  onChange: null,
  onFocus: null,
  onBlur: null,
  onTab: null,
  onDelete: null,
  onSave: null,
  fixPlaceholder: false
});
// EXTERNAL MODULE: ../node_modules/draft-js/lib/getFragmentFromSelection.js
var getFragmentFromSelection = __webpack_require__(22);
var getFragmentFromSelection_default = /*#__PURE__*/__webpack_require__.n(getFragmentFromSelection);

// EXTERNAL MODULE: external "draftjs-utils"
var external_draftjs_utils_ = __webpack_require__(23);

// CONCATENATED MODULE: ./configs/handlers.js






var handlers_keyCommandHandlers = function keyCommandHandlers(command, editorState, editor) {
  if (editor.editorProps.handleKeyCommand && editor.editorProps.handleKeyCommand(command, editorState, editor) === 'handled') {
    return 'handled';
  }

  if (command === 'braft-save') {
    editor.editorProps.onSave && editor.editorProps.onSave(editorState);
    return 'handled';
  }

  var _editor$editorProps = editor.editorProps,
      controls = _editor$editorProps.controls,
      excludeControls = _editor$editorProps.excludeControls;
  var allowIndent = (controls.indexOf('text-indent') !== 0 || controls.find(function (item) {
    return item.key === 'text-indent';
  })) && excludeControls.indexOf('text-indent') === -1;
  var cursorStart = editorState.getSelection().getStartOffset();
  var cursorEnd = editorState.getSelection().getEndOffset();
  var cursorIsAtFirst = cursorStart === 0 && cursorEnd === 0;

  if (command === 'backspace') {
    if (editor.editorProps.onDelete && editor.editorProps.onDelete(editorState) === false) {
      return 'handled';
    }

    var blockType = external_braft_utils_["ContentUtils"].getSelectionBlockType(editorState);

    if (allowIndent && cursorIsAtFirst && blockType !== 'code-block') {
      editor.setValue(external_braft_utils_["ContentUtils"].decreaseSelectionIndent(editorState));
    }
  }

  if (command === 'tab') {
    var _blockType = external_braft_utils_["ContentUtils"].getSelectionBlockType(editorState);

    if (_blockType === 'code-block') {
      editor.setValue(external_braft_utils_["ContentUtils"].insertText(editorState, ' '.repeat(editor.editorProps.codeTabIndents)));
      return 'handled';
    } else if (_blockType === 'ordered-list-item' || _blockType === 'unordered-list-item') {
      var newEditorState = external_draft_js_["RichUtils"].onTab(event, editorState, 4);

      if (newEditorState !== editorState) {
        editor.setValue(newEditorState);
      }

      return 'handled';
    } else if (_blockType !== 'atomic' && allowIndent && cursorIsAtFirst) {
      editor.setValue(external_braft_utils_["ContentUtils"].increaseSelectionIndent(editorState));
      return 'handled';
    }
  }

  var nextEditorState = external_braft_utils_["ContentUtils"].handleKeyCommand(editorState, command);

  if (nextEditorState) {
    editor.setValue(nextEditorState);
    return 'handled';
  }

  return 'not-handled';
};
var handlers_returnHandlers = function returnHandlers(event, editorState, editor) {
  if (editor.editorProps.handleReturn && editor.editorProps.handleReturn(event, editorState, editor) === 'handled') {
    return 'handled';
  }

  var currentBlock = external_braft_utils_["ContentUtils"].getSelectionBlock(editorState);
  var currentBlockType = currentBlock.getType();

  if (currentBlockType === 'unordered-list-item' || currentBlockType === 'ordered-list-item') {
    if (currentBlock.getLength() === 0) {
      editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionBlockType(editorState, 'unstyled'));
      return 'handled';
    }

    return 'not-handled';
  } else if (currentBlockType === 'code-block') {
    if (event.which === 13 && (event.getModifierState('Shift') || event.getModifierState('Alt') || event.getModifierState('Control'))) {
      editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionBlockType(editorState, 'unstyled'));
      return 'handled';
    }

    return 'not-handled';
  } else if (currentBlockType === 'blockquote') {
    if (event.which === 13) {
      if (event.getModifierState('Shift') || event.getModifierState('Alt') || event.getModifierState('Control')) {
        event.which = 0;
      } else {
        editor.setValue(external_draft_js_["RichUtils"].insertSoftNewline(editorState));
        return 'handled';
      }
    }
  }

  var nextEditorState = Object(external_draftjs_utils_["handleNewLine"])(editorState, event);

  if (nextEditorState) {
    editor.setValue(nextEditorState);
    return 'handled';
  }

  return 'not-handled';
};
var beforeInputHandlers = function beforeInputHandlers(chars, editorState, editor) {
  if (editor.editorProps.handleBeforeInput && editor.editorProps.handleBeforeInput(chars, editorState, editor) === 'handled') {
    return 'handled';
  }

  return 'not-handled';
};
var handlers_compositionStartHandler = function compositionStartHandler(_, editor) {
  var editorState = editor.state.editorState;
  var selectedBlocks = external_braft_utils_["ContentUtils"].getSelectedBlocks(editorState);

  if (selectedBlocks && selectedBlocks.length > 1) {
    var nextEditorState = external_draft_js_["EditorState"].push(editorState, external_draft_js_["Modifier"].removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'backward'), 'remove-range');
    editor.setValue(nextEditorState);
  }
};
var handlers_dropHandlers = function dropHandlers(selectionState, dataTransfer, editor) {
  if (editor.editorProps.readOnly || editor.editorProps.disabled) {
    return 'handled';
  }

  if (window && window.__BRAFT_DRAGING__IMAGE__) {
    var nextEditorState = external_draft_js_["EditorState"].forceSelection(editor.state.editorState, selectionState);
    nextEditorState = external_braft_utils_["ContentUtils"].insertMedias(nextEditorState, [window.__BRAFT_DRAGING__IMAGE__.mediaData]);
    nextEditorState = external_braft_utils_["ContentUtils"].removeBlock(nextEditorState, window.__BRAFT_DRAGING__IMAGE__.block, nextEditorState.getSelection());
    window.__BRAFT_DRAGING__IMAGE__ = null;
    editor.lockOrUnlockEditor(true);
    editor.setValue(nextEditorState);
    return 'handled';
  } else if (!dataTransfer || !dataTransfer.getText()) {
    return 'handled';
  }

  return 'not-handled';
};
var handlers_handleFiles = function handleFiles(files, editor) {
  var _editor$constructor$d = objectSpread_default()({}, editor.constructor.defaultProps.media, editor.editorProps.media),
      pasteImage = _editor$constructor$d.pasteImage,
      validateFn = _editor$constructor$d.validateFn,
      imagePasteLimit = _editor$constructor$d.imagePasteLimit;

  pasteImage && files.slice(0, imagePasteLimit).forEach(function (file) {
    if (file && file.type.indexOf('image') > -1 && editor.braftFinder) {
      var validateResult = validateFn ? validateFn(file) : true;

      if (validateResult instanceof Promise) {
        validateResult.then(function () {
          editor.braftFinder.uploadImage(file, function (image) {
            editor.isLiving && editor.setValue(external_braft_utils_["ContentUtils"].insertMedias(editor.state.editorState, [image]));
          });
        });
      } else if (validateResult) {
        editor.braftFinder.uploadImage(file, function (image) {
          editor.isLiving && editor.setValue(external_braft_utils_["ContentUtils"].insertMedias(editor.state.editorState, [image]));
        });
      }
    }
  });

  if (files[0] && files[0].type.indexOf('image') > -1 && pasteImage) {
    return 'handled';
  }

  return 'not-handled';
};
var droppedFilesHandlers = function droppedFilesHandlers(selectionState, files, editor) {
  if (editor.editorProps.handleDroppedFiles && editor.editorProps.handleDroppedFiles(selectionState, files, editor) === 'handled') {
    return 'handled';
  }

  return handlers_handleFiles(files, editor);
};
var pastedFilesHandlers = function pastedFilesHandlers(files, editor) {
  if (editor.editorProps.handlePastedFiles && editor.editorProps.handlePastedFiles(files, editor) === 'handled') {
    return 'handled';
  }

  return handlers_handleFiles(files, editor);
};
var handlers_copyHandlers = function copyHandlers(event, editor) {
  var blockMap = getFragmentFromSelection_default()(editor.state.editorState);

  if (blockMap && blockMap.toArray) {
    try {
      var tempContentState = external_draft_js_["ContentState"].createFromBlockArray(blockMap.toArray());
      var tempEditorState = external_draft_js_["EditorState"].createWithContent(tempContentState);
      var clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
      tempEditorState.setConvertOptions(editor.state.editorState.convertOptions);
      clipboardData.setData('text/html', tempEditorState.toHTML());
      clipboardData.setData('text/plain', tempEditorState.toText());
      event.preventDefault();
    } catch (error) {
      console.warn(error);
    }
  }
};
var handlers_pastedTextHandlers = function pastedTextHandlers(text, html, editorState, editor) {
  if (editor.editorProps.handlePastedText && editor.editorProps.handlePastedText(text, html, editorState, editor) === 'handled') {
    return 'handled';
  }

  if (!html || editor.editorProps.stripPastedStyles) {
    return false;
  }

  var tempColors = external_braft_utils_["ColorUtils"].detectColorsFromHTMLString(html);
  editor.setState({
    tempColors: [].concat(toConsumableArray_default()(editor.state.tempColors), toConsumableArray_default()(tempColors)).filter(function (item) {
      return editor.editorProps.colors.indexOf(item) === -1;
    }).filter(function (item, index, array) {
      return array.indexOf(item) === index;
    })
  }, function () {
    editor.setValue(external_braft_utils_["ContentUtils"].insertHTML(editorState, html, 'paste'));
  });
  return 'handled';
};
// CONCATENATED MODULE: ./helpers/extension.js

// TODO
//-extended support for block-style and atomic types

var extension_extensionControls = [];
var extension_extensionDecorators = [];
var extension_propInterceptors = [];
var extension_extensionBlockRenderMaps = [];
var extension_extensionBlockRendererFns = [];
var extensionInlineStyleMaps = [];
var extension_extensionInlineStyleFns = [];
var extensionEntities = [];
var inlineStyleImporters = [];
var inlineStyleExporters = [];
var blockImporters = [];
var blockExporters = [];

var filterByEditorId = function filterByEditorId(items, editorId) {
  if (!editorId) {
    return items.filter(function (item) {
      return !item.includeEditors;
    }).map(function (item) {
      return item.data;
    });
  }

  return items.map(function (item) {
    if (!item.includeEditors && !item.excludeEditors) {
      return item.data;
    }

    if (item.includeEditors) {
      return item.includeEditors.indexOf(editorId) !== -1 ? item.data : false;
    }

    if (item.excludeEditors) {
      return item.excludeEditors.indexOf(editorId) !== -1 ? false : item.data;
    }

    return false;
  }).filter(function (item) {
    return item;
  });
};

var getPropInterceptors = function getPropInterceptors(editorId) {
  return filterByEditorId(extension_propInterceptors, editorId);
};
var getExtensionControls = function getExtensionControls(editorId) {
  return filterByEditorId(extension_extensionControls, editorId);
};
var getExtensionDecorators = function getExtensionDecorators(editorId) {
  return filterByEditorId(extension_extensionDecorators, editorId, 'decorators');
};
var getExtensionBlockRenderMaps = function getExtensionBlockRenderMaps(editorId) {
  return filterByEditorId(extension_extensionBlockRenderMaps, editorId);
};
var getExtensionBlockRendererFns = function getExtensionBlockRendererFns(editorId) {
  return filterByEditorId(extension_extensionBlockRendererFns, editorId);
};
var getExtensionInlineStyleMap = function getExtensionInlineStyleMap(editorId) {
  var inlineStyleMap = {};
  filterByEditorId(extensionInlineStyleMaps, editorId).forEach(function (item) {
    inlineStyleMap[item.inlineStyleName] = item.styleMap;
  });
  return inlineStyleMap;
};
var getExtensionInlineStyleFns = function getExtensionInlineStyleFns(editorId) {
  return filterByEditorId(extension_extensionInlineStyleFns, editorId);
};
var compositeStyleImportFn = function compositeStyleImportFn(styleImportFn, editorId) {
  return function (nodeName, node, style) {
    filterByEditorId(inlineStyleImporters, editorId).forEach(function (styleImporter) {
      if (styleImporter.importer && styleImporter.importer(nodeName, node)) {
        style = style.add(styleImporter.inlineStyleName);
      }
    });
    return styleImportFn ? styleImportFn(nodeName, node, style) : style;
  };
};
var compositeStyleExportFn = function compositeStyleExportFn(styleExportFn, editorId) {
  return function (style) {
    style = style.toUpperCase();
    var result = styleExportFn ? styleExportFn(style) : undefined;

    if (result) {
      return result;
    }

    filterByEditorId(inlineStyleExporters, editorId).find(function (item) {
      if (item.inlineStyleName === style) {
        result = item.exporter;
        return true;
      }
    });
    return result;
  };
};
var compositeEntityImportFn = function compositeEntityImportFn(entityImportFn, editorId) {
  return function (nodeName, node, createEntity, source) {
    var result = entityImportFn ? entityImportFn(nodeName, node, createEntity, source) : null;

    if (result) {
      return result;
    }

    filterByEditorId(extensionEntities, editorId).find(function (entityItem) {
      var matched = entityItem.importer ? entityItem.importer(nodeName, node, source) : null;
      matched && (result = createEntity(entityItem.entityType, matched.mutability || 'MUTABLE', matched.data || {}));
      return !!matched;
    });
    return result;
  };
};
var compositeEntityExportFn = function compositeEntityExportFn(entityExportFn, editorId) {
  return function (entity, originalText) {
    var result = entityExportFn ? entityExportFn(entity, originalText) : undefined;

    if (result) {
      return result;
    }

    var entityType = entity.type.toUpperCase();
    filterByEditorId(extensionEntities, editorId).find(function (entityItem) {
      if (entityItem.entityType === entityType) {
        result = entityItem.exporter ? entityItem.exporter(entity, originalText) : undefined;
        return true;
      }
    });
    return result;
  };
};
var compositeBlockImportFn = function compositeBlockImportFn(blockImportFn, editorId) {
  return function (nodeName, node, source) {
    var result = blockImportFn ? blockImportFn(nodeName, node, source) : null;

    if (result) {
      return result;
    }

    filterByEditorId(blockImporters, editorId).find(function (blockImporter) {
      var matched = blockImporter.importer ? blockImporter.importer(nodeName, node, source) : undefined;
      matched && (result = matched);
      return !!matched;
    });
    return result;
  };
};
var compositeBlockExportFn = function compositeBlockExportFn(blockExportFn, editorId) {
  return function (contentState, block) {
    var result = blockExportFn ? blockExportFn(contentState, block) : null;

    if (result) {
      return result;
    }

    filterByEditorId(blockExporters, editorId).find(function (blockExporter) {
      var matched = blockExporter.exporter ? blockExporter.exporter(contentState, block) : undefined;
      matched && (result = matched);
      return !!matched;
    });
    return result;
  };
};

var extension_useExtension = function useExtension(extension) {
  if (extension instanceof Array) {
    extension.forEach(useExtension);
    return false;
  }

  if (!extension || !extension.type || typeof extension.type !== 'string') {
    return false;
  }

  var includeEditors = extension.includeEditors,
      excludeEditors = extension.excludeEditors;

  if (extension.type === 'control') {
    extension_extensionControls.push({
      includeEditors: includeEditors,
      excludeEditors: excludeEditors,
      data: extension.control
    });
  } else if (extension.type === 'inline-style') {
    var inlineStyleName = extension.name.toUpperCase();

    if (extension.control) {
      extension_extensionControls.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: objectSpread_default()({
          key: inlineStyleName,
          type: 'inline-style',
          command: inlineStyleName
        }, extension.control)
      });
    }

    if (extension.style) {
      extensionInlineStyleMaps.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          inlineStyleName: inlineStyleName,
          styleMap: extension.style
        }
      });
    }

    if (extension.styleFn) {
      extension_extensionInlineStyleFns.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          inlineStyleName: inlineStyleName,
          styleFn: extension.styleFn
        }
      });
    }

    if (extension.importer) {
      inlineStyleImporters.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          inlineStyleName: inlineStyleName,
          importer: extension.importer
        }
      });
    }

    inlineStyleExporters.push({
      includeEditors: includeEditors,
      excludeEditors: excludeEditors,
      data: {
        inlineStyleName: inlineStyleName,
        exporter: extension.exporter ? extension.exporter(extension) : external_react_default.a.createElement("span", {
          style: extension.style
        })
      }
    });
  } else if (extension.type === 'block-style') {// TODO
  } else if (extension.type === 'entity') {
    var entityType = extension.name.toUpperCase();

    if (extension.control) {
      extension_extensionControls.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: typeof extension.control === 'function' ? extension.control : objectSpread_default()({
          key: entityType,
          type: 'entity',
          command: entityType,
          data: {
            mutability: extension.mutability || 'MUTABLE',
            data: extension.data || {}
          }
        }, extension.control)
      });
    }

    extensionEntities.push({
      includeEditors: includeEditors,
      excludeEditors: excludeEditors,
      data: {
        entityType: entityType,
        importer: extension.importer,
        exporter: extension.exporter
      }
    });
    extension_extensionDecorators.push({
      includeEditors: includeEditors,
      excludeEditors: excludeEditors,
      data: {
        type: 'entity',
        decorator: {
          key: entityType,
          component: extension.component
        }
      }
    });
  } else if (extension.type === 'block') {
    var blockType = extension.name;

    if (extension.renderMap) {
      extension_extensionBlockRenderMaps.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          blockType: blockType,
          renderMap: extension.renderMap
        }
      });
    }

    if (extension.rendererFn) {
      extension_extensionBlockRendererFns.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          blockType: blockType,
          rendererFn: extension.rendererFn
        }
      });
    }

    if (extension.importer) {
      blockImporters.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          blockType: blockType,
          importer: extension.importer
        }
      });
    }

    if (extension.exporter) {
      blockExporters.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          blockType: blockType,
          exporter: extension.exporter
        }
      });
    }
  } else if (extension.type === 'atomic') {// TODO
  } else if (extension.type === 'decorator') {
    var decorator = extension.decorator;

    if (decorator && decorator.strategy && decorator.component) {
      extension_extensionDecorators.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          type: 'strategy',
          decorator: decorator
        }
      });
    } else if (decorator && decorator.getDecorations) {
      extension_extensionDecorators.push({
        includeEditors: includeEditors,
        excludeEditors: excludeEditors,
        data: {
          type: 'class',
          decorator: decorator
        }
      });
    }
  } else if (extension.type === 'prop-interception') {
    extension_propInterceptors.push({
      includeEditors: includeEditors,
      excludeEditors: excludeEditors,
      data: extension.interceptor
    });
  }
};

var createExtensibleEditor = function createExtensibleEditor(BraftEditor) {
  BraftEditor.use = extension_useExtension;
  return BraftEditor;
};
// CONCATENATED MODULE: ./renderers/block/blockRenderMap.js




/* harmony default export */ var block_blockRenderMap = (function (props, blockRenderMap) {
  var customBlockRenderMap = Object(external_immutable_["Map"])({
    'atomic': {
      element: ''
    },
    'code-block': {
      element: 'code',
      wrapper: external_react_default.a.createElement("pre", {
        className: "braft-code-block"
      })
    }
  });

  try {
    var extensionBlockRenderMaps = getExtensionBlockRenderMaps(props.editorId);
    customBlockRenderMap = extensionBlockRenderMaps.reduce(function (customBlockRenderMap, item) {
      return customBlockRenderMap.merge(typeof item.renderMap === 'function' ? item.renderMap(props) : item.renderMap);
    }, customBlockRenderMap);

    if (blockRenderMap) {
      if (typeof blockRenderMap === 'function') {
        customBlockRenderMap = customBlockRenderMap.merge(blockRenderMap(props));
      } else {
        customBlockRenderMap = customBlockRenderMap.merge(blockRenderMap);
      }
    }

    customBlockRenderMap = external_draft_js_["DefaultDraftBlockRenderMap"].merge(customBlockRenderMap);
  } catch (error) {
    console.warn(error);
  }

  return customBlockRenderMap;
});
// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/extends.js
var helpers_extends = __webpack_require__(11);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__(24);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./renderers/atomics/Image/style.scss
var Image_style = __webpack_require__(45);

// EXTERNAL MODULE: ./components/common/Switch/style.scss
var Switch_style = __webpack_require__(46);

// CONCATENATED MODULE: ./components/common/Switch/index.jsx


/* harmony default export */ var Switch = (function (props) {
  var active = props.active,
      _onClick = props.onClick,
      className = props.className;
  return external_react_default.a.createElement("div", {
    onClick: function onClick() {
      return _onClick();
    },
    className: 'bf-switch ' + className + (active ? ' active' : '')
  });
});
// CONCATENATED MODULE: ./configs/controls.js

/* harmony default export */ var configs_controls = (function (lang, editor) {
  return [{
    key: 'undo',
    title: lang.controls.undo,
    text: external_react_default.a.createElement("i", {
      className: "bfi-undo"
    }),
    type: 'editor-method',
    command: 'undo'
  }, {
    key: 'redo',
    title: lang.controls.redo,
    text: external_react_default.a.createElement("i", {
      className: "bfi-redo"
    }),
    type: 'editor-method',
    command: 'redo'
  }, {
    key: 'remove-styles',
    title: lang.controls.removeStyles,
    text: external_react_default.a.createElement("i", {
      className: "bfi-format_clear"
    }),
    type: 'editor-method',
    command: 'removeSelectionInlineStyles'
  }, {
    key: 'hr',
    title: lang.controls.hr,
    text: external_react_default.a.createElement("i", {
      className: "bfi-hr"
    }),
    type: 'editor-method',
    command: 'insertHorizontalLine'
  }, {
    key: 'bold',
    title: lang.controls.bold,
    text: external_react_default.a.createElement("i", {
      className: "bfi-bold"
    }),
    type: 'inline-style',
    command: 'bold'
  }, {
    key: 'italic',
    title: lang.controls.italic,
    text: external_react_default.a.createElement("i", {
      className: "bfi-italic"
    }),
    type: 'inline-style',
    command: 'italic'
  }, {
    key: 'underline',
    title: lang.controls.underline,
    text: external_react_default.a.createElement("i", {
      className: "bfi-underlined"
    }),
    type: 'inline-style',
    command: 'underline'
  }, {
    key: 'strike-through',
    title: lang.controls.strikeThrough,
    text: external_react_default.a.createElement("i", {
      className: "bfi-strikethrough"
    }),
    type: 'inline-style',
    command: 'strikethrough'
  }, {
    key: 'superscript',
    title: lang.controls.superScript,
    text: external_react_default.a.createElement("i", {
      className: "bfi-superscript"
    }),
    type: 'inline-style',
    command: 'superscript'
  }, {
    key: 'subscript',
    title: lang.controls.subScript,
    text: external_react_default.a.createElement("i", {
      className: "bfi-subscript"
    }),
    type: 'inline-style',
    command: 'subscript'
  }, {
    key: 'headings',
    title: lang.controls.headings,
    type: 'headings'
  }, {
    key: 'blockquote',
    title: lang.controls.blockQuote,
    text: external_react_default.a.createElement("i", {
      className: "bfi-quote"
    }),
    type: 'block-type',
    command: 'blockquote'
  }, {
    key: 'code',
    title: lang.controls.code,
    text: external_react_default.a.createElement("i", {
      className: "bfi-code"
    }),
    type: 'block-type',
    command: 'code-block'
  }, {
    key: 'list-ul',
    title: lang.controls.unorderedList,
    text: external_react_default.a.createElement("i", {
      className: "bfi-list"
    }),
    type: 'block-type',
    command: 'unordered-list-item'
  }, {
    key: 'list-ol',
    title: lang.controls.orderedList,
    text: external_react_default.a.createElement("i", {
      className: "bfi-list-numbered"
    }),
    type: 'block-type',
    command: 'ordered-list-item'
  }, {
    key: 'link',
    title: lang.controls.link,
    type: 'link'
  }, {
    key: 'text-color',
    title: lang.controls.color,
    type: 'text-color'
  }, {
    key: 'line-height',
    title: lang.controls.lineHeight,
    type: 'line-height'
  }, {
    key: 'letter-spacing',
    title: lang.controls.letterSpacing,
    type: 'letter-spacing'
  }, {
    key: 'text-indent',
    title: lang.controls.textIndent,
    type: 'text-indent'
  }, {
    key: 'font-size',
    title: lang.controls.fontSize,
    type: 'font-size'
  }, {
    key: 'font-family',
    title: lang.controls.fontFamily,
    type: 'font-family'
  }, {
    key: 'text-align',
    title: lang.controls.textAlign,
    type: 'text-align'
  }, {
    key: 'media',
    title: lang.controls.media,
    text: external_react_default.a.createElement("i", {
      className: "bfi-media"
    }),
    type: 'media'
  }, {
    key: 'emoji',
    title: lang.controls.emoji,
    text: external_react_default.a.createElement("i", {
      className: "bfi-emoji"
    }),
    type: 'emoji'
  }, {
    key: 'clear',
    title: lang.controls.clear,
    text: external_react_default.a.createElement("i", {
      className: "bfi-clear_all"
    }),
    type: 'editor-method',
    command: 'clearEditorContent'
  }, {
    key: 'fullscreen',
    title: editor.state.isFullscreen ? lang.controls.exitFullscreen : lang.controls.fullscreen,
    text: external_react_default.a.createElement("i", {
      className: editor.state.isFullscreen ? 'bfi-fullscreen-exit' : 'bfi-fullscreen'
    }),
    type: 'editor-method',
    command: 'toggleFullscreen'
  }, {
    key: 'modal',
    type: 'modal'
  }, {
    key: 'button',
    type: 'button'
  }, {
    key: 'dropdown',
    type: 'dropdown'
  }, {
    key: 'component',
    type: 'component'
  }];
});
var imageControlItems = {
  'float-left': {
    text: external_react_default.a.createElement("span", {
      "data-float": "left"
    }, "\uE91E"),
    command: 'setImageFloat|left'
  },
  'float-right': {
    text: external_react_default.a.createElement("span", {
      "data-float": "right"
    }, "\uE914"),
    command: 'setImageFloat|right'
  },
  'align-left': {
    text: external_react_default.a.createElement("span", {
      "data-align": "left"
    }, "\uE027"),
    command: 'setImageAlignment|left'
  },
  'align-center': {
    text: external_react_default.a.createElement("span", {
      "data-align": "center"
    }, "\uE028"),
    command: 'setImageAlignment|center'
  },
  'align-right': {
    text: external_react_default.a.createElement("span", {
      "data-align": "right"
    }, "\uE029"),
    command: 'setImageAlignment|right'
  },
  'size': {
    text: external_react_default.a.createElement("span", null, "\uE3C2"),
    command: 'toggleSizeEditor'
  },
  'link': {
    text: external_react_default.a.createElement("span", null, "\uE91A"),
    command: 'toggleLinkEditor'
  },
  'remove': {
    text: external_react_default.a.createElement("span", null, "\uE9AC"),
    command: 'removeImage'
  }
};
// CONCATENATED MODULE: ./renderers/atomics/Image/index.jsx
















var Image_Image =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Image, _React$Component);

  function Image() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, Image);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(Image)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      toolbarVisible: false,
      toolbarOffset: 0,
      linkEditorVisible: false,
      sizeEditorVisible: false,
      tempLink: null,
      tempWidth: null,
      tempHeight: null
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "initialLeft", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "initialTop", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "initialWidth", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "initialHeight", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "reSizeType", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "zoom", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "changeSize", function (e) {
      var type = _this.reSizeType;

      if (!_this.initialLeft) {
        _this.initialLeft = e.screenX;
        _this.initialTop = e.screenY;
      }

      if (type === 'rightbottom') {
        _this.initialHeight += e.screenY - _this.initialTop;
        _this.initialWidth += e.screenX - _this.initialLeft;
      }

      if (type === 'leftbottom') {
        _this.initialHeight += e.screenY - _this.initialTop;
        _this.initialWidth += -e.screenX + _this.initialLeft;
      }

      _this.initialLeft = e.screenX;
      _this.initialTop = e.screenY;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "moveImage", function (e) {
      _this.changeSize(e);

      _this.setState({
        tempWidth: Math.abs(_this.initialWidth),
        tempHeight: Math.abs(_this.initialHeight)
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "upImage", function () {
      var imageEqualRatio = _this.props.imageEqualRatio;

      if (imageEqualRatio) {
        _this.confirmImageSizeEqualRatio();
      } else {
        _this.confirmImageSize();
      }

      document.removeEventListener('mousemove', _this.moveImage);
      document.removeEventListener('mouseup', _this.upImage);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "repareChangeSize", function (type) {
      return function (e) {
        _this.reSizeType = type;

        var imageRect = _this.imageElement.getBoundingClientRect();

        _this.initialLeft = _this.initialTop = 0;
        _this.initialWidth = imageRect.width;
        _this.initialHeight = imageRect.height;
        _this.zoom = imageRect.width / imageRect.height;
        e.preventDefault();
        document.addEventListener('mousemove', _this.moveImage);
        document.addEventListener('mouseup', _this.upImage);
      };
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "preventDragEvent", function (event) {
      event.stopPropagation();
      event.preventDefault();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleDragStart", function () {
      if (_this.props.editor.editorProps.readOnly || _this.props.editor.editorProps.disabled) {
        return false;
      }

      window.__BRAFT_DRAGING__IMAGE__ = {
        block: _this.props.block,
        mediaData: objectSpread_default()({
          type: 'IMAGE'
        }, _this.props.mediaData)
      };

      _this.setState({
        toolbarVisible: false
      }, function () {
        _this.unlockEditor();
      });

      return true;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleDragEnd", function () {
      window.__BRAFT_DRAGING__IMAGE__ = null;
      return false;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "executeCommand", function (command) {
      if (typeof command === 'string') {
        var _command$split = command.split('|'),
            _command$split2 = slicedToArray_default()(_command$split, 2),
            method = _command$split2[0],
            param = _command$split2[1];

        _this[method] && _this[method](param);
      } else if (typeof command === 'function') {
        command(_this.props.block, _this.props.mediaData, _this.props.editor.getValue());
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "removeImage", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].removeBlock(_this.props.editor.getValue(), _this.props.block));

      _this.unlockEditor();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "toggleLinkEditor", function () {
      _this.setState({
        linkEditorVisible: !_this.state.linkEditorVisible,
        sizeEditorVisible: false
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "toggleSizeEditor", function () {
      _this.setState({
        linkEditorVisible: false,
        sizeEditorVisible: !_this.state.sizeEditorVisible
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleLinkInputKeyDown", function (e) {
      if (e.keyCode === 13) {
        _this.confirmImageLink();
      } else {
        return;
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setImageLink", function (e) {
      _this.setState({
        tempLink: e.currentTarget.value
      });

      return;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "confirmImageLink", function () {
      var link = _this.state.tempLink;

      var hookReturns = _this.props.hooks('set-image-link', link)(link);

      if (hookReturns === false) {
        return false;
      }

      if (typeof hookReturns === 'string') {
        link = hookReturns;
      }

      if (link !== null) {
        _this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaData(_this.props.editor.getValue(), _this.props.entityKey, {
          link: link
        }));

        window.setImmediate(_this.props.editor.forceRender);
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleSizeInputKeyDown", function (e) {
      if (e.keyCode === 13) {
        _this.confirmImageSize();
      } else {
        return;
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setImageWidth", function (_ref) {
      var currentTarget = _ref.currentTarget;
      var value = currentTarget.value;
      value && !isNaN(value) && (value = value + 'px');

      _this.setState({
        tempWidth: value
      });

      return;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setImageHeight", function (_ref2) {
      var currentTarget = _ref2.currentTarget;
      var value = currentTarget.value;
      value && !isNaN(value) && (value = value + 'px');

      _this.setState({
        tempHeight: value
      });

      return;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "confirmImageSize", function () {
      var _this$state = _this.state,
          width = _this$state.tempWidth,
          height = _this$state.tempHeight;
      var newImageSize = {};
      width !== null && (newImageSize.width = width);
      height !== null && (newImageSize.height = height);

      var hookReturns = _this.props.hooks('set-image-size', newImageSize)(newImageSize);

      if (hookReturns === false) {
        return false;
      }

      if (hookReturns && (hookReturns.width || hookReturns.height)) {
        newImageSize = hookReturns;
      }

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaData(_this.props.editor.getValue(), _this.props.entityKey, newImageSize));

      window.setImmediate(_this.props.editor.forceRender);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "confirmImageSizeEqualRatio", function () {
      var _this$state2 = _this.state,
          width = _this$state2.tempWidth,
          height = _this$state2.tempHeight;
      var equalWidth;
      var equalHeight;
      var newImageSize = {}; // 宽度过大 图片等比缩放

      if (width / height > _this.zoom) {
        equalWidth = Math.floor(height * _this.zoom);

        _this.setState({
          tempWidth: equalWidth
        });

        equalHeight = height;
      } else if (width / height < _this.zoom) {
        equalHeight = Math.floor(width / _this.zoom);

        _this.setState({
          tempHeight: equalHeight
        });

        equalWidth = width;
      }

      equalWidth !== null && (newImageSize.width = equalWidth);
      equalHeight !== null && (newImageSize.height = equalHeight);

      var hookReturns = _this.props.hooks('set-image-size', newImageSize)(newImageSize);

      if (hookReturns === false) {
        return false;
      }

      if (hookReturns && (hookReturns.width || hookReturns.height)) {
        newImageSize = hookReturns;
      }

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaData(_this.props.editor.getValue(), _this.props.entityKey, newImageSize));

      window.setImmediate(_this.props.editor.forceRender);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setImageFloat", function (float) {
      var hookReturns = _this.props.hooks('set-image-float', float)(float);

      if (hookReturns === false) {
        return false;
      }

      if (typeof hookReturns === 'string') {
        float = hookReturns;
      }

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaPosition(_this.props.editor.getValue(), _this.props.block, {
        float: float
      }));

      _this.unlockEditor();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setImageAlignment", function (alignment) {
      var hookReturns = _this.props.hooks('set-image-alignment', alignment)(alignment);

      if (hookReturns === false) {
        return false;
      }

      if (typeof hookReturns === 'string') {
        alignment = hookReturns;
      }

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaPosition(_this.props.editor.getValue(), _this.props.block, {
        alignment: alignment
      }));

      _this.unlockEditor();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "showToolbar", function (event) {
      if (_this.props.editor.editorProps.readOnly || _this.props.editor.editorProps.disabled) {
        return false;
      }

      event.preventDefault();

      if (!_this.state.toolbarVisible) {
        _this.setState({
          toolbarVisible: true
        }, function () {
          _this.lockEditor();

          _this.setState({
            toolbarOffset: _this.calcToolbarOffset()
          });
        });
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "hideToolbar", function (event) {
      event.preventDefault();

      _this.setState({
        toolbarVisible: false
      }, function () {
        _this.unlockEditor(); // this.props.editor.requestFocus()

      });
    });

    return _this;
  }

  createClass_default()(Image, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          mediaData = _this$props.mediaData,
          language = _this$props.language,
          imageControls = _this$props.imageControls,
          imageResizable = _this$props.imageResizable;
      var _this$state3 = this.state,
          toolbarVisible = _this$state3.toolbarVisible,
          toolbarOffset = _this$state3.toolbarOffset,
          linkEditorVisible = _this$state3.linkEditorVisible,
          sizeEditorVisible = _this$state3.sizeEditorVisible,
          tempWidth = _this$state3.tempWidth,
          tempHeight = _this$state3.tempHeight;
      var blockData = this.props.block.getData();
      var float = blockData.get('float');
      var alignment = blockData.get('alignment');
      var url = mediaData.url,
          link = mediaData.link,
          link_target = mediaData.link_target,
          width = mediaData.width,
          height = mediaData.height,
          meta = mediaData.meta;
      var imageStyles = {};
      var clearFix = false;

      if (float) {
        alignment = null;
      } else if (alignment === 'left') {
        imageStyles.float = 'left';
        clearFix = true;
      } else if (alignment === 'right') {
        imageStyles.float = 'right';
        clearFix = true;
      } else if (alignment === 'center') {
        imageStyles.textAlign = 'center';
      } else {
        imageStyles.float = 'left';
        clearFix = true;
      }

      var renderedControlItems = imageControls.map(function (item, index) {
        if (typeof item === 'string' && imageControlItems[item]) {
          return external_react_default.a.createElement("a", {
            className: item === 'link' && link ? 'active' : '',
            key: index,
            onClick: function onClick() {
              return _this2.executeCommand(imageControlItems[item].command);
            }
          }, imageControlItems[item].text);
        } else if (item && (item.render || item.text)) {
          return item.render ? item.render(mediaData, _this2.props.block) : external_react_default.a.createElement("a", {
            key: index,
            onClick: function onClick() {
              return item.onClick && _this2.executeCommand(item.onClick);
            }
          }, item.text);
        } else {
          return null;
        }
      });
      return external_react_default.a.createElement("div", {
        className: "bf-media"
      }, external_react_default.a.createElement("div", {
        style: imageStyles,
        draggable: true,
        onMouseEnter: this.showToolbar,
        onMouseMove: this.showToolbar,
        onMouseLeave: this.hideToolbar,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd,
        ref: function ref(instance) {
          return _this2.mediaEmbederInstance = instance;
        },
        className: "bf-image"
      }, toolbarVisible ? external_react_default.a.createElement("div", {
        style: {
          marginLeft: toolbarOffset
        },
        ref: function ref(instance) {
          return _this2.toolbarElement = instance;
        },
        "data-float": float,
        "data-align": alignment,
        className: "bf-media-toolbar"
      }, linkEditorVisible ? external_react_default.a.createElement("div", {
        className: "bf-image-link-editor"
      }, external_react_default.a.createElement("div", {
        className: "editor-input-group"
      }, external_react_default.a.createElement("input", {
        type: "text",
        placeholder: language.linkEditor.inputWithEnterPlaceHolder,
        onKeyDown: this.handleLinkInputKeyDown,
        onChange: this.setImageLink,
        defaultValue: link
      }), external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.confirmImageLink
      }, language.base.confirm)), external_react_default.a.createElement("div", {
        className: "switch-group"
      }, external_react_default.a.createElement(Switch, {
        active: link_target === '_blank',
        onClick: function onClick() {
          return _this2.setImageLinkTarget(link_target);
        }
      }), external_react_default.a.createElement("label", null, language.linkEditor.openInNewWindow))) : null, sizeEditorVisible ? external_react_default.a.createElement("div", {
        className: "bf-image-size-editor"
      }, external_react_default.a.createElement("div", {
        className: "editor-input-group"
      }, external_react_default.a.createElement("input", {
        type: "text",
        placeholder: language.base.width,
        onKeyDown: this.handleSizeInputKeyDown,
        onChange: this.setImageWidth,
        defaultValue: width
      }), external_react_default.a.createElement("input", {
        type: "text",
        placeholder: language.base.height,
        onKeyDown: this.handleSizeInputKeyDown,
        onChange: this.setImageHeight,
        defaultValue: height
      }), external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.confirmImageSize
      }, language.base.confirm))) : null, renderedControlItems, external_react_default.a.createElement("i", {
        style: {
          marginLeft: toolbarOffset * -1
        },
        className: "bf-media-toolbar-arrow"
      })) : null, external_react_default.a.createElement("div", {
        style: {
          position: 'relative',
          width: "".concat(width, "px"),
          height: "".concat(height, "px"),
          display: 'inline-block'
        }
      }, external_react_default.a.createElement("img", extends_default()({
        ref: function ref(instance) {
          return _this2.imageElement = instance;
        },
        src: url,
        width: width,
        height: height
      }, meta)), toolbarVisible && imageResizable ? external_react_default.a.createElement("div", {
        className: "bf-csize-icon right-bottom",
        onMouseDown: this.repareChangeSize('rightbottom')
      }) : null, toolbarVisible && imageResizable ? external_react_default.a.createElement("div", {
        className: "bf-csize-icon left-bottom",
        onMouseDown: this.repareChangeSize('leftbottom')
      }) : null, external_react_default.a.createElement("div", {
        className: "bf-pre-csize ".concat(this.reSizeType),
        style: {
          width: "".concat(tempWidth, "px"),
          height: "".concat(tempHeight, "px")
        }
      }))), clearFix && external_react_default.a.createElement("div", {
        className: "clearfix",
        style: {
          clear: 'both',
          height: 0,
          lineHeight: 0,
          float: 'none'
        }
      }));
    }
  }, {
    key: "lockEditor",
    value: function lockEditor() {
      this.props.editor.lockOrUnlockEditor(true);
    }
  }, {
    key: "unlockEditor",
    value: function unlockEditor() {
      this.props.editor.lockOrUnlockEditor(false);
    }
  }, {
    key: "calcToolbarOffset",
    value: function calcToolbarOffset() {
      var _this$props2 = this.props,
          getContainerNode = _this$props2.getContainerNode,
          containerNode = _this$props2.containerNode;
      var container = getContainerNode ? getContainerNode() : containerNode;

      if (!container) {
        return 0;
      }

      var viewRect = container.querySelector('.bf-content').getBoundingClientRect();
      var toolbarRect = this.toolbarElement.getBoundingClientRect();
      var imageRect = this.imageElement.getBoundingClientRect();
      var right = viewRect.right - (imageRect.right - imageRect.width / 2 + toolbarRect.width / 2);
      var left = imageRect.left + imageRect.width / 2 - toolbarRect.width / 2 - viewRect.left;

      if (right < 10) {
        return right - 10;
      } else if (left < 10) {
        return left * -1 + 10;
      } else {
        return 0;
      }
    }
  }, {
    key: "setImageLinkTarget",
    value: function setImageLinkTarget(link_target) {
      var hookReturns = this.props.hooks('set-image-link-target', link_target)(link_target);

      if (hookReturns === false) {
        return false;
      }

      if (typeof hookReturns === 'string') {
        link_target = hookReturns;
      }

      link_target = link_target === '_blank' ? '' : '_blank';
      this.props.editor.setValue(external_braft_utils_["ContentUtils"].setMediaData(this.props.editor.getValue(), this.props.entityKey, {
        link_target: link_target
      }));
      window.setImmediate(this.props.editor.forceRender);
    }
  }]);

  return Image;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./renderers/atomics/Video/style.scss
var Video_style = __webpack_require__(47);

// EXTERNAL MODULE: ./components/common/Modal/style.scss
var Modal_style = __webpack_require__(48);

// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(16);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);

// CONCATENATED MODULE: ./components/common/Modal/index.jsx














var Modal_Modal =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Modal, _React$Component);

  function Modal(props) {
    var _this;

    classCallCheck_default()(this, Modal);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(Modal).call(this, props));

    defineProperty_default()(assertThisInitialized_default()(_this), "handleTransitionEnd", function () {
      if (!_this.rootElement || !_this.rootElement.classList) {
        return false;
      }

      if (!_this.rootElement.classList.contains('active')) {
        external_react_dom_default.a.unmountComponentAtNode(_this.rootElement) && _this.rootElement.parentNode.removeChild(_this.rootElement);
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleMouseDown", function (event) {
      var tagName = event.target.tagName.toLowerCase();

      if (tagName === 'input' || tagName === 'textarea') {
        return false;
      }

      event.preventDefault();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleCancel", function () {
      _this.props.closeOnCancel && _this.close();
      _this.props.onCancel && _this.props.onCancel();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleConfirm", function () {
      _this.props.closeOnConfirm && _this.close();
      _this.props.onConfirm && _this.props.onConfirm();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleMaskClick", function () {
      _this.props.closeOnBlur && _this.close();
      _this.props.onBlue && _this.props.onBlue();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "close", function () {
      _this.unrenderComponent();

      _this.props.onClose && _this.props.onClose();
    });

    _this.active = false;
    _this.componentId = 'BRAFT-MODAL-' + external_braft_utils_["BaseUtils"].UniqueIndex();
    return _this;
  }

  createClass_default()(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible) {
        this.active = true;
        this.renderComponent(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      if (this.props.visible && !next.visible) {
        this.unrenderComponent();
      } else if (this.props.visible || next.visible) {
        this.active = true;
        this.renderComponent(next);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "unrenderComponent",
    value: function unrenderComponent() {
      this.active = false;
      this.activeId && window.clearImmediate(this.activeId);

      if (this.rootElement && this.rootElement.classList) {
        this.rootElement.classList.remove('active');
      }
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(props) {
      var _this2 = this;

      if (!this.active) {
        return false;
      }

      var title = props.title,
          className = props.className,
          width = props.width,
          height = props.height,
          children = props.children,
          component = props.component,
          confirmable = props.confirmable,
          showFooter = props.showFooter,
          showCancel = props.showCancel,
          showConfirm = props.showConfirm,
          showClose = props.showClose,
          cancelText = props.cancelText,
          confirmText = props.confirmText,
          bottomText = props.bottomText,
          language = props.language;
      typeof showCancel === 'undefined' && (showCancel = true);
      typeof showClose === 'undefined' && (showClose = true);
      typeof showConfirm === 'undefined' && (showConfirm = true);
      typeof showFooter === 'undefined' && (showFooter = true);
      var childComponent = external_react_default.a.createElement("div", {
        onMouseDown: this.handleMouseDown,
        className: 'bf-modal ' + (className || '')
      }, external_react_default.a.createElement("div", {
        className: "bf-modal-mask",
        onClick: this.handleMaskClick
      }), external_react_default.a.createElement("div", {
        onTransitionEnd: this.handleTransitionEnd,
        style: {
          width: width,
          height: height
        },
        className: "bf-modal-content"
      }, external_react_default.a.createElement("div", {
        className: "bf-modal-header"
      }, external_react_default.a.createElement("h3", {
        className: "bf-modal-caption"
      }, title), showClose && external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.close,
        className: "bf-modal-close-button"
      }, external_react_default.a.createElement("i", {
        className: "bfi-close"
      }))), external_react_default.a.createElement("div", {
        className: "bf-modal-body"
      }, children || component), showFooter ? external_react_default.a.createElement("div", {
        className: "bf-modal-footer"
      }, external_react_default.a.createElement("div", {
        className: "bf-modal-addon-text"
      }, bottomText), external_react_default.a.createElement("div", {
        className: "bf-modal-buttons"
      }, showCancel && external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.handleCancel,
        className: "bf-modal-cancel"
      }, cancelText || language.base.cancel), showConfirm && external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.handleConfirm,
        className: 'bf-modal-confirm ' + (!confirmable ? 'disabled' : '')
      }, confirmText || language.base.confirm))) : null));
      this.rootElement = document.querySelector('#' + this.componentId);

      if (!this.rootElement) {
        this.rootElement = document.createElement('div');
        this.rootElement.id = this.componentId;
        this.rootElement.className = 'bf-modal-root';
        document.body.appendChild(this.rootElement);
      }

      external_react_dom_default.a.render(childComponent, this.rootElement);
      this.activeId = window.setImmediate(function () {
        _this2.rootElement.classList.add('active');
      });
    }
  }]);

  return Modal;
}(external_react_default.a.Component);

defineProperty_default()(Modal_Modal, "defaultProps", {
  showFooter: true,
  closeOnBlur: true
});


var Modal_showModal = function showModal(props) {
  var hostNode = document.createElement('div');
  hostNode.style.display = 'none';
  document.body.appendChild(hostNode);
  props = objectSpread_default()({
    visible: true,
    closeOnConfirm: true,
    closeOnCancel: true
  }, props);

  var close = function close() {
    external_react_dom_default.a.unmountComponentAtNode(hostNode) && hostNode.parentNode.removeChild(hostNode);
  };

  var onConfirm = function onConfirm() {
    props.onConfirm && props.onConfirm();
  };

  var onCancel = function onCancel() {
    props.onCancel && props.onCancel();
  };

  var onClose = function onClose() {
    close();
    props.onClose && props.onClose();
  };

  var modalInstance = external_react_dom_default.a.render(external_react_default.a.createElement(Modal_Modal, extends_default()({}, props, {
    onConfirm: onConfirm,
    onCancel: onCancel,
    onClose: onClose
  })), hostNode);
  modalInstance.destroy = close;
  modalInstance.update = modalInstance.renderComponent;
  return modalInstance;
};
// EXTERNAL MODULE: ./components/business/PlayerModal/style.scss
var PlayerModal_style = __webpack_require__(49);

// CONCATENATED MODULE: ./components/business/PlayerModal/index.jsx




var PlayerModal_playViaModal = function playViaModal(title, component, language) {
  return Modal_showModal({
    title: title,
    component: component,
    language: language,
    showFooter: false
  });
};

var typeIconsMap = {
  'video': 'bfi-film',
  'audio': 'bfi-music',
  'embed': 'bfi-code'
};
/* harmony default export */ var PlayerModal = (function (_ref) {
  var title = _ref.title,
      type = _ref.type,
      language = _ref.language,
      name = _ref.name,
      url = _ref.url,
      poster = _ref.poster,
      children = _ref.children,
      onRemove = _ref.onRemove;
  return external_react_default.a.createElement("div", {
    className: "bf-player-holder ".concat(type)
  }, external_react_default.a.createElement("div", {
    className: "icon-badge"
  }, external_react_default.a.createElement("i", {
    className: typeIconsMap[type]
  }), external_react_default.a.createElement("span", {
    className: "text"
  }, language.media[type])), external_react_default.a.createElement("button", {
    onMouseDown: onRemove,
    className: "button-remove"
  }, external_react_default.a.createElement("i", {
    className: "bfi-close"
  })), external_react_default.a.createElement("button", {
    onMouseDown: function onMouseDown() {
      return PlayerModal_playViaModal(name ? "".concat(title, ":").concat(name) : title, children, language);
    },
    className: "button-play"
  }, external_react_default.a.createElement("i", {
    className: "bfi-play_arrow"
  })), name ? external_react_default.a.createElement("h5", {
    className: "bf-name"
  }, name) : null, external_react_default.a.createElement("h6", {
    className: "bf-url"
  }, url), poster ? external_react_default.a.createElement("div", {
    className: "bf-poster",
    style: {
      backgroundImage: "url(".concat(poster, ")")
    }
  }) : null);
});
// CONCATENATED MODULE: ./renderers/atomics/Video/index.jsx












var Video_Video =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Video, _React$Component);

  function Video() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, Video);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(Video)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "removeVideo", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].removeBlock(_this.props.editorState, _this.props.block));
    });

    return _this;
  }

  createClass_default()(Video, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mediaData = _this$props.mediaData,
          language = _this$props.language;
      var url = mediaData.url,
          name = mediaData.name,
          meta = mediaData.meta;
      return external_react_default.a.createElement("div", {
        className: "bf-video-wrap"
      }, external_react_default.a.createElement(PlayerModal, {
        type: "video",
        onRemove: this.removeVideo,
        poster: meta ? meta.poster || '' : '',
        language: language,
        url: url,
        name: name,
        title: language.videoPlayer.title
      }, external_react_default.a.createElement("div", {
        className: "bf-video-player"
      }, external_react_default.a.createElement("video", {
        controls: true,
        poster: meta ? meta.poster || '' : ''
      }, external_react_default.a.createElement("source", {
        src: url
      })))));
    }
  }]);

  return Video;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./renderers/atomics/Audio/style.scss
var Audio_style = __webpack_require__(50);

// CONCATENATED MODULE: ./renderers/atomics/Audio/index.jsx












var Audio_Audio =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Audio, _React$Component);

  function Audio() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, Audio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(Audio)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "removeAudio", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].removeBlock(_this.props.editorState, _this.props.block));
    });

    return _this;
  }

  createClass_default()(Audio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mediaData = _this$props.mediaData,
          language = _this$props.language;
      var url = mediaData.url,
          name = mediaData.name,
          meta = mediaData.meta;
      return external_react_default.a.createElement("div", {
        className: "bf-audio-wrap"
      }, external_react_default.a.createElement(PlayerModal, {
        type: "audio",
        onRemove: this.removeAudio,
        poster: meta ? meta.poster || '' : '',
        language: language,
        url: url,
        name: name,
        title: language.audioPlayer.title
      }, external_react_default.a.createElement("div", {
        className: "bf-audio-player"
      }, external_react_default.a.createElement("audio", {
        controls: true,
        src: url
      }))));
    }
  }]);

  return Audio;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./renderers/atomics/Embed/style.scss
var Embed_style = __webpack_require__(51);

// CONCATENATED MODULE: ./renderers/atomics/Embed/index.jsx












var Embed_Embed =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(Embed, _React$Component);

  function Embed() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, Embed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(Embed)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "removeEmbed", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].removeBlock(_this.props.editorState, _this.props.block));
    });

    return _this;
  }

  createClass_default()(Embed, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mediaData = _this$props.mediaData,
          language = _this$props.language;
      var name = mediaData.name,
          url = mediaData.url,
          meta = mediaData.meta;
      return external_react_default.a.createElement("div", {
        className: "bf-embed-wrap"
      }, external_react_default.a.createElement(PlayerModal, {
        type: "embed",
        onRemove: this.removeEmbed,
        poster: meta ? meta.poster || '' : '',
        language: language,
        url: url,
        name: name,
        title: language.videoPlayer.embedTitle
      }, external_react_default.a.createElement("div", {
        className: "bf-embed-player",
        dangerouslySetInnerHTML: {
          __html: url
        }
      })));
    }
  }]);

  return Embed;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./renderers/atomics/HorizontalLine/style.scss
var HorizontalLine_style = __webpack_require__(52);

// CONCATENATED MODULE: ./renderers/atomics/HorizontalLine/index.jsx











var HorizontalLine_HorizontalLine =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(HorizontalLine, _React$Component);

  function HorizontalLine() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, HorizontalLine);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(HorizontalLine)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "removeHorizontalLine", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].removeBlock(_this.props.editorState, _this.props.block));
    });

    return _this;
  }

  createClass_default()(HorizontalLine, [{
    key: "render",
    value: function render() {
      return external_react_default.a.createElement("div", {
        className: "bf-hr"
      }, external_react_default.a.createElement("div", {
        className: "bf-media-toolbar"
      }, external_react_default.a.createElement("a", {
        onClick: this.removeHorizontalLine
      }, "\uE9AC")));
    }
  }]);

  return HorizontalLine;
}(external_react_default.a.Component);


// CONCATENATED MODULE: ./renderers/block/blockRendererFn.js











var blockRendererFn_BlockRenderFnContext = function BlockRenderFnContext() {
  var _this = this;

  classCallCheck_default()(this, BlockRenderFnContext);

  defineProperty_default()(this, "superProps", void 0);

  defineProperty_default()(this, "customBlockRendererFn", void 0);

  defineProperty_default()(this, "getRenderFn", function (superProps, customBlockRendererFn) {
    _this.superProps = superProps;
    _this.customBlockRendererFn = customBlockRendererFn;
    return _this.blockRendererFn;
  });

  defineProperty_default()(this, "renderAtomicBlock", function (props) {
    var superProps = _this.superProps;
    var entityKey = props.block.getEntityAt(0);

    if (!entityKey) {
      return null;
    }

    var entity = props.contentState.getEntity(entityKey);
    var mediaData = entity.getData();
    var mediaType = entity.getType();

    var mediaProps = objectSpread_default()({}, superProps, {
      block: props.block,
      mediaData: mediaData,
      entityKey: entityKey
    });

    if (mediaType === 'IMAGE') {
      return external_react_default.a.createElement(Image_Image, mediaProps);
    } else if (mediaType === 'AUDIO') {
      return external_react_default.a.createElement(Audio_Audio, mediaProps);
    } else if (mediaType === 'VIDEO') {
      return external_react_default.a.createElement(Video_Video, mediaProps);
    } else if (mediaType === 'EMBED') {
      return external_react_default.a.createElement(Embed_Embed, mediaProps);
    } else if (mediaType === 'HR') {
      return external_react_default.a.createElement(HorizontalLine_HorizontalLine, mediaProps);
    }

    if (superProps.extendAtomics) {
      var atomics = superProps.extendAtomics;

      for (var i = 0; i < atomics.length; i++) {
        if (mediaType === atomics[i].type) {
          var Component = atomics[i].component;
          return external_react_default.a.createElement(Component, mediaProps);
        }
      }
    }

    return null;
  });

  defineProperty_default()(this, "blockRendererFn", function (block) {
    var customBlockRendererFn = _this.customBlockRendererFn,
        superProps = _this.superProps;
    var blockType = block.getType();
    var blockRenderer = null;

    if (customBlockRendererFn) {
      blockRenderer = customBlockRendererFn(block, superProps) || null;
    }

    if (blockRenderer) {
      return blockRenderer;
    }

    var extensionBlockRendererFns = getExtensionBlockRendererFns(superProps.editorId);
    extensionBlockRendererFns.find(function (item) {
      if (item.blockType === blockType || item.blockType instanceof RegExp && item.blockType.test(blockType)) {
        blockRenderer = item.rendererFn ? item.rendererFn(superProps) : null;
        return true;
      }
    });

    if (blockRenderer) {
      return blockRenderer;
    }

    if (blockType === 'atomic') {
      blockRenderer = {
        component: _this.renderAtomicBlock,
        editable: false
      };
    }

    return blockRenderer;
  });
};

var blockRenderFnContext = new blockRendererFn_BlockRenderFnContext();
/* harmony default export */ var block_blockRendererFn = (blockRenderFnContext.getRenderFn);
// CONCATENATED MODULE: ./renderers/block/blockStyleFn.js
/* harmony default export */ var block_blockStyleFn = (function (customBlockStyleFn) {
  return function (block) {
    var blockAlignment = block.getData() && block.getData().get('textAlign');
    var blockIndent = block.getData() && block.getData().get('textIndent');
    var blockFloat = block.getData() && block.getData().get('float');
    var result = '';

    if (blockAlignment) {
      result = "bfa-".concat(blockAlignment);
    }

    if (blockIndent && blockIndent !== 0) {
      result += " bftd-".concat(blockIndent);
    }

    if (blockFloat) {
      result += " bff-".concat(blockFloat);
    }

    if (customBlockStyleFn) {
      result += customBlockStyleFn(block) || '';
    }

    return result;
  };
});
// CONCATENATED MODULE: ./renderers/inline/inlineStyleMap.js


/* harmony default export */ var inlineStyleMap = (function (props) {
  var customStyleMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var extensionInlineStyleMap = getExtensionInlineStyleMap(props.editorId);
  return objectSpread_default()({
    'SUPERSCRIPT': {
      position: 'relative',
      top: '-8px',
      fontSize: '11px'
    },
    'SUBSCRIPT': {
      position: 'relative',
      bottom: '-8px',
      fontSize: '11px'
    }
  }, extensionInlineStyleMap, customStyleMap);
});
// CONCATENATED MODULE: ./renderers/inline/inlineStyleFn.js


var getStyleValue = function getStyleValue(style) {
  return style.split('-')[1];
};

/* harmony default export */ var inlineStyleFn = (function (props, options) {
  return function (styles, block) {
    var output = {};
    var fontFamilies = options.fontFamilies,
        unitExportFn = options.unitExportFn,
        customStyleFn = options.customStyleFn;
    var extensionInlineStyleFns = getExtensionInlineStyleFns(props.editorId);
    extensionInlineStyleFns.forEach(function (item) {
      output = item.styleFn ? item.styleFn(styles, block, output) : output;
    });
    output = customStyleFn ? customStyleFn(styles, block, output) : {};
    styles.forEach(function (style) {
      if (style.indexOf('COLOR-') === 0) {
        output.color = '#' + getStyleValue(style);
      } else if (style.indexOf('BGCOLOR-') === 0) {
        output.backgroundColor = '#' + getStyleValue(style);
      } else if (style.indexOf('FONTSIZE-') === 0) {
        output.fontSize = unitExportFn(getStyleValue(style), 'font-size', 'editor');
      } else if (style.indexOf('LINEHEIGHT-') === 0) {
        output.lineHeight = unitExportFn(getStyleValue(style), 'line-height', 'editor');
      } else if (style.indexOf('LETTERSPACING-') === 0) {
        output.letterSpacing = unitExportFn(getStyleValue(style), 'letter-spacing', 'editor');
      } else if (style.indexOf('TEXTINDENT-') === 0) {
        output.textIndent = unitExportFn(getStyleValue(style), 'text-indent', 'editor');
      } else if (style.indexOf('FONTFAMILY-') === 0) {
        output.fontFamily = (fontFamilies.find(function (item) {
          return item.name.toUpperCase() === getStyleValue(style);
        }) || {}).family || '';
      }
    });
    return output;
  };
});
// EXTERNAL MODULE: ../node_modules/draft-js-multidecorators/index.js
var draft_js_multidecorators = __webpack_require__(18);
var draft_js_multidecorators_default = /*#__PURE__*/__webpack_require__.n(draft_js_multidecorators);

// CONCATENATED MODULE: ./renderers/decorators/Link/index.jsx

/* harmony default export */ var Link = (function (props) {
  var children = props.children,
      entityKey = props.entityKey,
      contentState = props.contentState;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      href = _contentState$getEnti.href,
      target = _contentState$getEnti.target;

  return external_react_default.a.createElement("span", {
    className: "bf-link-wrap"
  }, external_react_default.a.createElement("a", {
    onClick: function onClick(event) {
      return viewLink(event, href);
    },
    className: "bf-link",
    href: href,
    target: target
  }, children));
});

var viewLink = function viewLink(event, link) {
  // When pressing the Ctrl / command key, click to open the url in the link text
  if (event.getModifierState('Control') || event.getModifierState('Meta')) {
    var tempLink = document.createElement('a');
    tempLink.href = link;
    tempLink.target = event.currentTarget.target;
    tempLink.click();
  }
};
// CONCATENATED MODULE: ./renderers/decorators/index.js






var KEY_SEPARATOR = '-';

draft_js_multidecorators_default.a.prototype.getDecorations = function (block, contentState) {
  var decorations = Array(block.getText().length).fill(null);
  this.decorators.forEach(function (decorator, i) {
    decorator.getDecorations(block, contentState).forEach(function (key, offset) {
      if (!key) {
        return;
      }

      key = i + KEY_SEPARATOR + key;
      decorations[offset] = key;
    });
  });
  return external_immutable_default.a.List(decorations);
};

var builtinDecorators = [{
  type: 'entity',
  decorator: {
    key: 'LINK',
    component: Link
  }
}];

var createStrategy = function createStrategy(type) {
  return function (block, callback, contentState) {
    block.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === type;
    }, callback);
  };
};

/* harmony default export */ var decorators = (function (editorId) {
  var extensionDecorators = getExtensionDecorators(editorId);
  var entityDecorators = [].concat(builtinDecorators, toConsumableArray_default()(extensionDecorators.filter(function (item) {
    return item.type === 'entity';
  })));
  var strategyDecorators = extensionDecorators.filter(function (item) {
    return item.type === 'strategy';
  });
  var classDecorators = extensionDecorators.filter(function (item) {
    return item.type === 'class';
  });
  return new draft_js_multidecorators_default.a([].concat(toConsumableArray_default()(classDecorators.map(function (item) {
    return item.decorator;
  })), [// combine decorators created with strategy
  new external_draft_js_["CompositeDecorator"](strategyDecorators.map(function (item) {
    return item.decorator;
  })), // combine decorators for entities
  new external_draft_js_["CompositeDecorator"](entityDecorators.map(function (item) {
    return {
      strategy: createStrategy(item.decorator.key),
      component: item.decorator.component
    };
  }))]));
});
// CONCATENATED MODULE: ./renderers/index.js






var getBlockRenderMap = block_blockRenderMap;
var getBlockRendererFn = block_blockRendererFn;
var getBlockStyleFn = block_blockStyleFn;
var getCustomStyleMap = inlineStyleMap;
var getCustomStyleFn = inlineStyleFn;
var getDecorators = decorators;
// EXTERNAL MODULE: ./components/business/ControlBar/style.scss
var ControlBar_style = __webpack_require__(53);

// EXTERNAL MODULE: ./components/business/LinkEditor/style.scss
var LinkEditor_style = __webpack_require__(54);

// EXTERNAL MODULE: ./components/common/DropDown/style.scss
var DropDown_style = __webpack_require__(55);

// CONCATENATED MODULE: ./helpers/responsive.js


var resizeEventHandlers = [];
var responsiveHelperInited = false;
var debouce = false;
/* harmony default export */ var responsive = ({
  resolve: function resolve(eventHandler) {
    var id = external_braft_utils_["BaseUtils"].UniqueIndex();
    resizeEventHandlers.push({
      id: id,
      eventHandler: eventHandler
    });
    return id;
  },
  unresolve: function unresolve(id) {
    resizeEventHandlers = resizeEventHandlers.filter(function (item) {
      return item.id !== id;
    });
  }
});

if (!responsiveHelperInited && (typeof window === "undefined" ? "undefined" : typeof_default()(window)) === 'object') {
  window.addEventListener('resize', function (event) {
    clearTimeout(debouce);
    debouce = setTimeout(function () {
      resizeEventHandlers.map(function (item) {
        typeof item.eventHandler === 'function' && item.eventHandler(event);
      });
      debouce = false;
    }, 100);
  });
  responsiveHelperInited = true;
}
// CONCATENATED MODULE: ./components/common/DropDown/index.jsx











var DropDown_DropDown =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(DropDown, _React$Component);

  function DropDown() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(DropDown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "responsiveResolveId", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "dropDownHandlerElement", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "dropDownContentElement", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      active: false,
      offset: 0
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "fixDropDownPosition", function () {
      var viewRect = _this.props.getContainerNode().getBoundingClientRect();

      var handlerRect = _this.dropDownHandlerElement.getBoundingClientRect();

      var contentRect = _this.dropDownContentElement.getBoundingClientRect();

      var offset = 0;
      var right = handlerRect.right - handlerRect.width / 2 + contentRect.width / 2;
      var left = handlerRect.left + handlerRect.width / 2 - contentRect.width / 2;
      right = viewRect.right - right;
      left = left - viewRect.left;

      if (right < 10) {
        offset = right - 10;
      } else if (left < 10) {
        offset = left * -1 + 10;
      }

      if (offset !== _this.state.offset) {
        _this.setState({
          offset: offset
        });
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "registerClickEvent", function (event) {
      var autoHide = _this.props.autoHide;
      var active = _this.state.active;

      if (_this.dropDownContentElement.contains(event.target) || _this.dropDownHandlerElement.contains(event.target)) {
        return false;
      }

      autoHide && active && _this.hide();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "toggle", function () {
      _this.setState({
        active: !_this.state.active
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "show", function () {
      _this.setState({
        active: true
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "hide", function () {
      _this.setState({
        active: false
      });
    });

    return _this;
  }

  createClass_default()(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document) {
        document.body.addEventListener('click', this.registerClickEvent);
        this.responsiveResolveId = responsive.resolve(this.fixDropDownPosition);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      if (!this.props.disabled && next.disabled) {
        this.hide();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevState) {
      if (!prevState.active && this.state.active) {
        this.fixDropDownPosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (document) {
        document.body.removeEventListener('click', this.registerClickEvent);
        responsive.unresolve(this.responsiveResolveId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          active = _this$state.active,
          offset = _this$state.offset;
      var _this$props = this.props,
          caption = _this$props.caption,
          htmlCaption = _this$props.htmlCaption,
          title = _this$props.title,
          disabled = _this$props.disabled,
          showArrow = _this$props.showArrow,
          arrowActive = _this$props.arrowActive,
          className = _this$props.className,
          children = _this$props.children,
          theme = _this$props.theme;
      disabled && (active = false);
      theme === 'light' && (className = ' light-theme ' + className);
      return external_react_default.a.createElement("div", {
        className: 'bf-dropdown ' + (active ? 'active ' : '') + (disabled ? 'disabled ' : '') + className
      }, htmlCaption ? external_react_default.a.createElement("button", {
        type: "button",
        className: "dropdown-handler",
        "data-title": title,
        onClick: this.toggle,
        dangerouslySetInnerHTML: htmlCaption ? {
          __html: htmlCaption
        } : null,
        ref: function ref(instance) {
          return _this2.dropDownHandlerElement = instance;
        }
      }) : external_react_default.a.createElement("button", {
        type: "button",
        className: "dropdown-handler",
        "data-title": title,
        onClick: this.toggle,
        ref: function ref(instance) {
          return _this2.dropDownHandlerElement = instance;
        }
      }, external_react_default.a.createElement("span", null, caption), showArrow !== false ? external_react_default.a.createElement("i", {
        className: "bfi-drop-down"
      }) : null), external_react_default.a.createElement("div", {
        className: "dropdown-content",
        style: {
          marginLeft: offset
        },
        ref: function ref(instance) {
          return _this2.dropDownContentElement = instance;
        }
      }, external_react_default.a.createElement("i", {
        style: {
          marginLeft: offset * -1
        },
        className: 'dropdown-arrow' + (arrowActive ? ' active' : '')
      }), external_react_default.a.createElement("div", {
        className: "dropdown-content-inner"
      }, children)));
    }
  }]);

  return DropDown;
}(external_react_default.a.Component);


// CONCATENATED MODULE: ./components/business/ControlGroup/index.jsx

/* harmony default export */ var ControlGroup = (function (props) {
  if (external_react_default.a.Fragment) {
    return external_react_default.a.createElement(external_react_default.a.Fragment, null, props.children);
  } else {
    return external_react_default.a.createElement("div", {
      className: "control-item-group"
    }, props.children);
  }
});
// CONCATENATED MODULE: ./components/business/LinkEditor/index.jsx














var LinkEditor_LinkEditor =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(LinkEditor, _React$Component);

  function LinkEditor(props) {
    var _this;

    classCallCheck_default()(this, LinkEditor);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(LinkEditor).call(this, props));

    defineProperty_default()(assertThisInitialized_default()(_this), "dropDownInstance", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "handeKeyDown", function (e) {
      if (e.keyCode === 13) {
        _this.handleConfirm();

        e.preventDefault();
        return false;
      }
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleTnputText", function (e) {
      _this.setState({
        text: e.currentTarget.value
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleInputLink", function (e) {
      _this.setState({
        href: e.currentTarget.value
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setTarget", function () {
      _this.setState({
        target: _this.state.target === '_blank' ? '' : '_blank'
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleCancel", function () {
      _this.dropDownInstance.hide();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleUnlink", function () {
      _this.dropDownInstance.hide();

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionLink(_this.props.editorState, false));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleConfirm", function () {
      var _this$state = _this.state,
          text = _this$state.text,
          href = _this$state.href,
          target = _this$state.target,
          textSelected = _this$state.textSelected;

      var hookReturns = _this.props.hooks('toggle-link', {
        href: href,
        target: target
      })({
        href: href,
        target: target
      });

      _this.dropDownInstance.hide();

      _this.props.editor.requestFocus();

      if (hookReturns === false) {
        return false;
      }

      if (hookReturns) {
        typeof hookReturns.href === 'string' && (href = hookReturns.href);
        typeof hookReturns.target === 'string' && (target = hookReturns.target);
      }

      if (textSelected) {
        if (href) {
          _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionLink(_this.props.editorState, href, target));
        } else {
          _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionLink(_this.props.editorState, false));
        }
      } else {
        _this.props.editor.setValue(external_braft_utils_["ContentUtils"].insertText(_this.props.editorState, text || href, null, {
          type: 'LINK',
          data: {
            href: href,
            target: target
          }
        }));
      }
    });

    _this.state = {
      text: '',
      href: '',
      target: props.defaultLinkTarget || '',
      textSelected: false
    };
    return _this;
  }

  createClass_default()(LinkEditor, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _ContentUtils$getSele = external_braft_utils_["ContentUtils"].getSelectionEntityData(nextProps.editorState, 'LINK'),
          href = _ContentUtils$getSele.href,
          target = _ContentUtils$getSele.target;

      var textSelected = !external_braft_utils_["ContentUtils"].isSelectionCollapsed(this.props.editorState) && external_braft_utils_["ContentUtils"].getSelectionBlockType(this.props.editorState) !== 'atomic';
      var selectedText = '';

      if (textSelected) {
        selectedText = external_braft_utils_["ContentUtils"].getSelectionText(this.props.editorState);
      }

      this.setState({
        textSelected: textSelected,
        text: selectedText,
        href: href || '',
        target: typeof target === 'undefined' ? nextProps.defaultLinkTarget || '' : target || ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var allowInsertLinkText = this.props.allowInsertLinkText;
      var _this$state2 = this.state,
          text = _this$state2.text,
          href = _this$state2.href,
          target = _this$state2.target,
          textSelected = _this$state2.textSelected;
      var caption = external_react_default.a.createElement("i", {
        className: "bfi-link"
      });
      return external_react_default.a.createElement(ControlGroup, null, external_react_default.a.createElement(DropDown_DropDown, {
        key: 0,
        caption: caption,
        title: this.props.language.controls.link,
        autoHide: true,
        getContainerNode: this.props.getContainerNode,
        showArrow: false,
        ref: function ref(instance) {
          return _this2.dropDownInstance = instance;
        },
        className: 'control-item dropdown link-editor-dropdown'
      }, external_react_default.a.createElement("div", {
        className: "bf-link-editor"
      }, allowInsertLinkText ? external_react_default.a.createElement("div", {
        className: "input-group"
      }, external_react_default.a.createElement("input", {
        type: "text",
        value: text,
        spellCheck: false,
        disabled: textSelected,
        placeholder: this.props.language.linkEditor.textInputPlaceHolder,
        onKeyDown: this.handeKeyDown,
        onChange: this.handleTnputText
      })) : null, external_react_default.a.createElement("div", {
        className: "input-group"
      }, external_react_default.a.createElement("input", {
        type: "text",
        value: href,
        spellCheck: false,
        placeholder: this.props.language.linkEditor.linkInputPlaceHolder,
        onKeyDown: this.handeKeyDown,
        onChange: this.handleInputLink
      })), external_react_default.a.createElement("div", {
        className: "switch-group"
      }, external_react_default.a.createElement(Switch, {
        active: target === '_blank',
        onClick: this.setTarget
      }), external_react_default.a.createElement("label", null, this.props.language.linkEditor.openInNewWindow)), external_react_default.a.createElement("div", {
        className: "buttons"
      }, external_react_default.a.createElement("a", {
        onClick: this.handleUnlink,
        className: "primary button-remove-link pull-left"
      }, external_react_default.a.createElement("i", {
        className: "bfi-close"
      }), external_react_default.a.createElement("span", null, this.props.language.linkEditor.removeLink)), external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.handleConfirm,
        className: "primary pull-right"
      }, this.props.language.base.confirm), external_react_default.a.createElement("button", {
        type: "button",
        onClick: this.handleCancel,
        className: "default pull-right"
      }, this.props.language.base.cancel)))), external_react_default.a.createElement("button", {
        key: 1,
        type: "button",
        "data-title": this.props.language.controls.unlink,
        className: "control-item button",
        onClick: this.handleUnlink,
        disabled: !textSelected || !href
      }, external_react_default.a.createElement("i", {
        className: "bfi-link-off"
      })));
    }
  }]);

  return LinkEditor;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./components/business/Headings/style.scss
var Headings_style = __webpack_require__(56);

// CONCATENATED MODULE: ./configs/maps.js

var maps_getHeadings = function getHeadings(lang) {
  return [{
    key: 'header-one',
    title: lang.controls.header + ' 1',
    text: external_react_default.a.createElement("h1", null, lang.controls.header, " 1"),
    type: 'block-type',
    command: 'header-one'
  }, {
    key: 'header-two',
    title: lang.controls.header + ' 2',
    text: external_react_default.a.createElement("h2", null, lang.controls.header, " 2"),
    type: 'block-type',
    command: 'header-two'
  }, {
    key: 'header-three',
    title: lang.controls.header + ' 3',
    text: external_react_default.a.createElement("h3", null, lang.controls.header, " 3"),
    type: 'block-type',
    command: 'header-three'
  }, {
    key: 'header-four',
    title: lang.controls.header + ' 4',
    text: external_react_default.a.createElement("h4", null, lang.controls.header, " 4"),
    type: 'block-type',
    command: 'header-four'
  }, {
    key: 'header-five',
    title: lang.controls.header + ' 5',
    text: external_react_default.a.createElement("h5", null, lang.controls.header, " 5"),
    type: 'block-type',
    command: 'header-five'
  }, {
    key: 'header-six',
    title: lang.controls.header + ' 6',
    text: external_react_default.a.createElement("h6", null, lang.controls.header, " 6"),
    type: 'block-type',
    command: 'header-six'
  }, {
    key: 'unstyled',
    title: lang.controls.normal,
    text: lang.controls.normal,
    type: 'block-type',
    command: 'unstyled'
  }];
};
var blocks = {
  'header-one': 'h1',
  'header-two': 'h2',
  'header-three': 'h3',
  'header-four': 'h4',
  'header-fiv': 'h5',
  'header-six': 'h6',
  'unstyled': 'p',
  'blockquote': 'blockquote'
};
// CONCATENATED MODULE: ./components/business/Headings/index.jsx




/* harmony default export */ var Headings = (function (props) {
  var dropDownInstance = null;
  var headings = maps_getHeadings(props.language).filter(function (item) {
    return props.headings.indexOf(item.key) !== -1;
  });
  var currentHeadingIndex = headings.findIndex(function (item) {
    return item.command === props.current;
  });
  var caption = headings[currentHeadingIndex] ? headings[currentHeadingIndex].title : props.language.controls.normal;
  return external_react_default.a.createElement(DropDown_DropDown, {
    caption: caption,
    autoHide: true,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.headings,
    arrowActive: currentHeadingIndex === 0,
    ref: function ref(instance) {
      return dropDownInstance = instance;
    },
    className: 'control-item dropdown headings-dropdown'
  }, external_react_default.a.createElement("ul", {
    className: "menu"
  }, headings.map(function (item, index) {
    var isActive = props.current === item.command;
    return external_react_default.a.createElement("li", {
      key: index,
      className: 'menu-item' + (isActive ? ' active' : ''),
      onClick: function onClick() {
        props.onChange(item.command, item.type), dropDownInstance.hide();
      }
    }, item.text);
  })));
});
// EXTERNAL MODULE: ./components/business/TextColor/style.scss
var TextColor_style = __webpack_require__(57);

// EXTERNAL MODULE: ./components/common/ColorPicker/style.scss
var ColorPicker_style = __webpack_require__(58);

// CONCATENATED MODULE: ./components/common/ColorPicker/index.jsx


/* harmony default export */ var common_ColorPicker = (function (props) {
  return external_react_default.a.createElement("div", {
    className: "bf-colors-wrap"
  }, external_react_default.a.createElement("ul", {
    className: "bf-colors"
  }, props.presetColors.map(function (item, index) {
    var className = props.color && item.toLowerCase() === props.color.toLowerCase() ? 'color-item active' : 'color-item';
    return external_react_default.a.createElement("li", {
      key: index,
      title: item,
      className: className,
      style: {
        color: item
      },
      "data-color": item.replace('#', ''),
      onClick: function onClick(e) {
        props.onChange(e.currentTarget.dataset.color, true);
      }
    });
  })));
});
// CONCATENATED MODULE: ./components/business/TextColor/index.jsx













var TextColor_TextColor =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(TextColor, _React$Component);

  function TextColor() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, TextColor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(TextColor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      colorType: 'color'
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "switchColorType", function (_ref) {
      var currentTarget = _ref.currentTarget;

      _this.setState({
        colorType: currentTarget.dataset.type
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "toggleColor", function (color, closePicker) {
      if (color) {
        var hookReturns = _this.props.hooks("toggle-text-".concat(_this.state.colorType), color)(color);

        if (hookReturns === false) {
          return false;
        }

        if (typeof hookReturns === 'string') {
          color = hookReturns;
        }

        if (_this.state.colorType === 'color') {
          _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionColor(_this.props.editorState, color));
        } else {
          _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionBackgroundColor(_this.props.editorState, color));
        }
      }

      if (closePicker) {
        _this.dropDownInstance.hide();

        _this.props.editor.requestFocus();
      }
    });

    return _this;
  }

  createClass_default()(TextColor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var captionStyle = {};
      var currentColor = null;
      var colorType = this.state.colorType;
      var selectionStyles = this.props.editorState.getCurrentInlineStyle().toJS();
      selectionStyles.forEach(function (style) {
        if (style.indexOf('COLOR-') === 0) {
          captionStyle.color = '#' + style.split('-')[1];
          colorType === 'color' && (currentColor = captionStyle.color);
        }

        if (style.indexOf('BGCOLOR-') === 0) {
          captionStyle.backgroundColor = '#' + style.split('-')[1];
          colorType === 'background-color' && (currentColor = captionStyle.backgroundColor);
        }
      });
      var caption = external_react_default.a.createElement("i", {
        style: captionStyle,
        className: "bfi-text-color"
      }, external_react_default.a.createElement("span", {
        className: "path1"
      }), external_react_default.a.createElement("span", {
        className: "path2"
      }));
      var ColorPicker = this.props.colorPicker || common_ColorPicker;
      return external_react_default.a.createElement(DropDown_DropDown, {
        caption: caption,
        title: this.props.language.controls.color,
        showArrow: false,
        autoHide: this.props.autoHide,
        theme: this.props.theme,
        getContainerNode: this.props.getContainerNode,
        ref: function ref(instance) {
          return _this2.dropDownInstance = instance;
        },
        className: 'control-item dropdown text-color-dropdown'
      }, external_react_default.a.createElement("div", {
        className: "bf-text-color-picker-wrap"
      }, external_react_default.a.createElement("div", {
        className: "bf-color-switch-buttons",
        style: this.props.enableBackgroundColor ? {} : {
          display: 'none'
        }
      }, external_react_default.a.createElement("button", {
        type: "button",
        "data-type": "color",
        className: colorType === 'color' ? 'active' : '',
        onClick: this.switchColorType
      }, this.props.language.controls.textColor), external_react_default.a.createElement("button", {
        type: "button",
        "data-type": "background-color",
        className: colorType === 'background-color' ? 'active' : '',
        onClick: this.switchColorType
      }, this.props.language.controls.backgroundColor)), external_react_default.a.createElement(ColorPicker, {
        width: 200,
        color: currentColor,
        disableAlpha: true,
        presetColors: this.props.colors,
        onChange: this.toggleColor
      })));
    }
  }]);

  return TextColor;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./components/business/FontSize/style.scss
var FontSize_style = __webpack_require__(59);

// CONCATENATED MODULE: ./components/business/FontSize/index.jsx





var FontSize_toggleFontSize = function toggleFontSize(event, props) {
  var fontSize = event.currentTarget.dataset.size;
  var hookReturns = props.hooks('toggle-font-size', fontSize)(fontSize);

  if (hookReturns === false) {
    return false;
  }

  if (!isNaN(fontSize)) {
    fontSize = hookReturns;
  }

  props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionFontSize(props.editorState, fontSize));
  props.editor.requestFocus();
};

/* harmony default export */ var FontSize = (function (props) {
  var caption = null;
  var currentFontSize = null;
  var dropDownInstance = null;
  props.fontSizes.find(function (item) {
    if (external_braft_utils_["ContentUtils"].selectionHasInlineStyle(props.editorState, 'FONTSIZE-' + item)) {
      caption = item;
      currentFontSize = item;
      return true;
    }

    return false;
  });
  return external_react_default.a.createElement(DropDown_DropDown, {
    autoHide: true,
    caption: caption || props.defaultCaption,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.fontSize,
    ref: function ref(instance) {
      return dropDownInstance = instance;
    },
    className: 'control-item dropdown bf-font-size-dropdown'
  }, external_react_default.a.createElement("ul", {
    className: "bf-font-sizes"
  }, props.fontSizes.map(function (item, index) {
    return external_react_default.a.createElement("li", {
      key: index,
      className: item === currentFontSize ? 'active' : null,
      "data-size": item,
      onClick: function onClick(event) {
        FontSize_toggleFontSize(event, props), dropDownInstance.hide();
      }
    }, item);
  })));
});
// EXTERNAL MODULE: ./components/business/LineHeight/style.scss
var LineHeight_style = __webpack_require__(60);

// CONCATENATED MODULE: ./components/business/LineHeight/index.jsx





var LineHeight_toggleLineHeight = function toggleLineHeight(event, props) {
  var lineHeight = event.currentTarget.dataset.size;
  var hookReturns = props.hooks('toggle-line-height', lineHeight)(lineHeight);

  if (hookReturns === false) {
    return false;
  }

  if (!isNaN(hookReturns)) {
    lineHeight = hookReturns;
  }

  props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionLineHeight(props.editorState, lineHeight));
  props.editor.requestFocus();
};

/* harmony default export */ var LineHeight = (function (props) {
  var caption = null;
  var currentLineHeight = null;
  var dropDownInstance = null;
  props.lineHeights.find(function (item) {
    if (external_braft_utils_["ContentUtils"].selectionHasInlineStyle(props.editorState, 'LINEHEIGHT-' + item)) {
      caption = item;
      currentLineHeight = item;
      return true;
    }

    return false;
  });
  return external_react_default.a.createElement(DropDown_DropDown, {
    autoHide: true,
    caption: caption || props.defaultCaption,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.lineHeight,
    ref: function ref(instance) {
      return dropDownInstance = instance;
    },
    className: 'control-item dropdown bf-line-height-dropdown'
  }, external_react_default.a.createElement("ul", {
    className: "bf-line-heights"
  }, props.lineHeights.map(function (item, index) {
    return external_react_default.a.createElement("li", {
      key: index,
      className: item === currentLineHeight ? 'active' : null,
      "data-size": item,
      onClick: function onClick(event) {
        LineHeight_toggleLineHeight(event, props), dropDownInstance.hide();
      }
    }, item);
  })));
});
// EXTERNAL MODULE: ./components/business/FontFamily/style.scss
var FontFamily_style = __webpack_require__(61);

// CONCATENATED MODULE: ./components/business/FontFamily/index.jsx





var FontFamily_toggleFontFamily = function toggleFontFamily(event, props) {
  var fontFamilyName = event.currentTarget.dataset.name;
  var hookReturns = props.hooks('toggle-font-family', fontFamilyName)(fontFamilyName, props.fontFamilies);

  if (hookReturns === false) {
    return false;
  }

  if (typeof hookReturns === 'string') {
    fontFamilyName = hookReturns;
  }

  props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionFontFamily(props.editorState, fontFamilyName));
  props.editor.requestFocus();
};

/* harmony default export */ var FontFamily = (function (props) {
  var caption = null;
  var currentIndex = null;
  var dropDownInstance = null;
  props.fontFamilies.find(function (item, index) {
    if (external_braft_utils_["ContentUtils"].selectionHasInlineStyle(props.editorState, 'FONTFAMILY-' + item.name)) {
      caption = item.name;
      currentIndex = index;
      return true;
    }

    return false;
  });
  return external_react_default.a.createElement(DropDown_DropDown, {
    caption: caption || props.defaultCaption,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.fontFamily,
    autoHide: true,
    arrowActive: currentIndex === 0,
    ref: function ref(instance) {
      return dropDownInstance = instance;
    },
    className: 'control-item dropdown font-family-dropdown'
  }, external_react_default.a.createElement("ul", {
    className: "menu"
  }, props.fontFamilies.map(function (item, index) {
    return external_react_default.a.createElement("li", {
      key: index,
      className: 'menu-item ' + (index === currentIndex ? 'active' : ''),
      "data-name": item.name,
      onClick: function onClick(event) {
        FontFamily_toggleFontFamily(event, props), dropDownInstance.hide();
      }
    }, external_react_default.a.createElement("span", {
      style: {
        fontFamily: item.family
      }
    }, item.name));
  })));
});
// CONCATENATED MODULE: ./components/business/TextAlign/index.jsx











var TextAlign_TextAlign =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(TextAlign, _React$Component);

  function TextAlign() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, TextAlign);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(TextAlign)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      currentAlignment: undefined
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setAlignment", function (event) {
      var alignment = event.currentTarget.dataset.alignment;

      var hookReturns = _this.props.hooks('toggle-text-alignment', alignment)(alignment);

      if (_this.props.textAligns.indexOf(hookReturns) > -1) {
        alignment = hookReturns;
      }

      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionAlignment(_this.props.editorState, alignment));

      _this.props.editor.requestFocus();
    });

    return _this;
  }

  createClass_default()(TextAlign, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      this.setState({
        currentAlignment: external_braft_utils_["ContentUtils"].getSelectionBlockData(next.editorState, 'textAlign')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var textAlignmentTitles = [this.props.language.controls.alignLeft, this.props.language.controls.alignCenter, this.props.language.controls.alignRight, this.props.language.controls.alignJustify];
      return external_react_default.a.createElement(ControlGroup, null, this.props.textAligns.map(function (item, index) {
        return external_react_default.a.createElement("button", {
          type: "button",
          key: index,
          "data-title": textAlignmentTitles[index],
          "data-alignment": item,
          className: 'control-item button ' + (item === _this2.state.currentAlignment ? 'active' : null),
          onClick: _this2.setAlignment
        }, external_react_default.a.createElement("i", {
          className: 'bfi-align-' + item
        }));
      }));
    }
  }]);

  return TextAlign;
}(external_react_default.a.Component);


// EXTERNAL MODULE: ./components/business/EmojiPicker/style.scss
var EmojiPicker_style = __webpack_require__(62);

// CONCATENATED MODULE: ./components/business/EmojiPicker/index.jsx





var EmojiPicker_insertEmoji = function insertEmoji(event, props) {
  var emoji = event.currentTarget.dataset.emoji;
  var hookReturns = props.hooks('insert-emoji', emoji)(emoji);

  if (hookReturns === false) {
    return false;
  }

  if (typeof hookReturns === 'string') {
    emoji = hookReturns;
  }

  props.editor.setValue(external_braft_utils_["ContentUtils"].insertText(props.editorState, emoji));
  props.editor.requestFocus();
};

/* harmony default export */ var EmojiPicker = (function (props) {
  return external_react_default.a.createElement(DropDown_DropDown, {
    caption: props.defaultCaption,
    autoHide: true,
    showArrow: false,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.emoji,
    className: 'control-item dropdown bf-emoji-dropdown'
  }, external_react_default.a.createElement("div", {
    className: "bf-emojis-wrap"
  }, external_react_default.a.createElement("ul", {
    className: "bf-emojis"
  }, props.emojis.map(function (item, index) {
    return external_react_default.a.createElement("li", {
      key: index,
      "data-emoji": item,
      onClick: function onClick(event) {
        return EmojiPicker_insertEmoji(event, props);
      }
    }, item);
  }))));
});
// EXTERNAL MODULE: ./components/business/LetterSpacing/style.scss
var LetterSpacing_style = __webpack_require__(63);

// CONCATENATED MODULE: ./components/business/LetterSpacing/index.jsx





var LetterSpacing_toggleLetterSpacing = function toggleLetterSpacing(event, props) {
  var letterSpacing = event.currentTarget.dataset.size;
  var hookReturns = props.hooks('toggle-letter-spacing', letterSpacing)(letterSpacing);

  if (hookReturns === false) {
    return false;
  }

  if (!isNaN(hookReturns)) {
    letterSpacing = hookReturns;
  }

  props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionLetterSpacing(props.editorState, letterSpacing));
  props.editor.requestFocus();
};

/* harmony default export */ var LetterSpacing = (function (props) {
  var caption = null;
  var currentLetterSpacing = null;
  var dropDownInstance = null;
  props.letterSpacings.find(function (item) {
    if (external_braft_utils_["ContentUtils"].selectionHasInlineStyle(props.editorState, 'LETTERSPACING-' + item)) {
      caption = item;
      currentLetterSpacing = item;
      return true;
    }

    return false;
  });
  return external_react_default.a.createElement(DropDown_DropDown, {
    autoHide: true,
    caption: caption || props.defaultCaption,
    getContainerNode: props.getContainerNode,
    title: props.language.controls.letterSpacing,
    ref: function ref(instance) {
      return dropDownInstance = instance;
    },
    className: 'control-item dropdown bf-letter-spacing-dropdown'
  }, external_react_default.a.createElement("ul", {
    className: "bf-letter-spacings"
  }, props.letterSpacings.map(function (item, index) {
    return external_react_default.a.createElement("li", {
      key: index,
      className: item === currentLetterSpacing ? 'active' : null,
      "data-size": item,
      onClick: function onClick(event) {
        LetterSpacing_toggleLetterSpacing(event, props), dropDownInstance.hide();
      }
    }, item);
  })));
});
// CONCATENATED MODULE: ./components/business/TextIndent/index.jsx











var TextIndent_TextAlign =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(TextAlign, _React$Component);

  function TextAlign() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, TextAlign);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(TextAlign)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "state", {
      currentIndent: 0
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "increaseIndent", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].increaseSelectionIndent(_this.props.editorState));

      _this.props.editor.requestFocus();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "decreaseIndent", function () {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].decreaseSelectionIndent(_this.props.editorState));

      _this.props.editor.requestFocus();
    });

    return _this;
  }

  createClass_default()(TextAlign, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        currentIndent: external_braft_utils_["ContentUtils"].getSelectionBlockData(nextProps.editorState, 'textIndent') || 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var currentIndent = this.state.currentIndent;
      var language = this.props.language;
      return external_react_default.a.createElement(ControlGroup, null, external_react_default.a.createElement("button", {
        key: 0,
        type: "button",
        "data-title": language.controls.increaseIndent,
        disabled: currentIndent >= 6,
        className: "control-item button button-indent-increase".concat(currentIndent > 0 && currentIndent < 6 ? ' active' : ''),
        onClick: this.increaseIndent
      }, external_react_default.a.createElement("i", {
        className: 'bfi-indent-increase'
      })), external_react_default.a.createElement("button", {
        key: 1,
        type: "button",
        "data-title": language.controls.decreaseIndent,
        disabled: currentIndent <= 0,
        className: "control-item button button-indent-decrease",
        onClick: this.decreaseIndent
      }, external_react_default.a.createElement("i", {
        className: 'bfi-indent-decrease'
      })));
    }
  }]);

  return TextAlign;
}(external_react_default.a.Component);


// CONCATENATED MODULE: ./components/business/ControlBar/index.jsx


























var commandHookMap = {
  'inline-style': 'toggle-inline-style',
  'block-type': 'change-block-type',
  'editor-method': 'exec-editor-command'
};
var exclusiveInlineStyles = {
  'superscript': 'subscript',
  'subscript': 'superscript'
};

var mergeControls = function mergeControls(commonProps, builtControls, extensionControls, extendControls) {
  extensionControls = extensionControls.map(function (item) {
    return typeof item === 'function' ? item(commonProps) : item;
  });
  extendControls = extendControls.map(function (item) {
    return typeof item === 'function' ? item(commonProps) : item;
  });

  if (extensionControls.length === 0 && extendControls.length === 0) {
    return builtControls;
  }

  return builtControls.map(function (item) {
    return extendControls.find(function (subItem) {
      return subItem.replace === (item.key || item);
    }) || extensionControls.find(function (subItem) {
      return subItem.replace === (item.key || item);
    }) || item;
  }).concat(extensionControls.length ? 'separator' : '').concat(extensionControls.filter(function (item) {
    return !item.replace;
  })).concat(extendControls.filter(function (item) {
    return typeof item === 'string' || !item.replace;
  }));
};

var ControlBar_ControlBar =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(ControlBar, _React$Component);

  function ControlBar() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_default()(this, ControlBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn_default()(this, (_getPrototypeOf2 = getPrototypeOf_default()(ControlBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_default()(assertThisInitialized_default()(_this), "allControls", []);

    defineProperty_default()(assertThisInitialized_default()(_this), "mediaLibiraryModal", null);

    defineProperty_default()(assertThisInitialized_default()(_this), "extendedModals", {});

    defineProperty_default()(assertThisInitialized_default()(_this), "openBraftFinder", function () {
      if (!_this.props.braftFinder || !_this.props.braftFinder.ReactComponent) {
        return false;
      }

      if (_this.props.hooks('open-braft-finder')() === false) {
        return false;
      }

      var mediaProps = _this.props.media;
      var MediaLibrary = _this.props.braftFinder.ReactComponent;
      _this.mediaLibiraryModal = Modal_showModal({
        title: _this.props.language.controls.mediaLibirary,
        language: _this.props.language,
        width: 640,
        showFooter: false,
        className: mediaProps.modalClassName,
        component: external_react_default.a.createElement(MediaLibrary, {
          accepts: mediaProps.accepts,
          onCancel: _this.closeBraftFinder,
          onInsert: _this.insertMedias,
          onChange: mediaProps.onChange,
          externals: mediaProps.externals,
          onBeforeSelect: _this.bindBraftFinderHook('select-medias'),
          onBeforeDeselect: _this.bindBraftFinderHook('deselect-medias'),
          onBeforeRemove: _this.bindBraftFinderHook('remove-medias'),
          onBeforeInsert: _this.bindBraftFinderHook('insert-medias'),
          onFileSelect: _this.bindBraftFinderHook('select-files')
        })
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "bindBraftFinderHook", function (hookName) {
      return function () {
        return _this.props.hooks(hookName, arguments.length <= 0 ? undefined : arguments[0]).apply(void 0, arguments);
      };
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "insertMedias", function (medias) {
      _this.props.editor.setValue(external_braft_utils_["ContentUtils"].insertMedias(_this.props.editorState, medias));

      _this.props.editor.requestFocus();

      _this.props.media.onInsert && _this.props.media.onInsert(medias);

      _this.closeBraftFinder();
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "closeBraftFinder", function () {
      _this.props.media.onCancel && _this.props.media.onCancel();
      _this.mediaLibiraryModal && _this.mediaLibiraryModal.close();
    });

    return _this;
  }

  createClass_default()(ControlBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var language = this.props.language;
      this.allControls.forEach(function (item) {
        if (item.type === 'modal') {
          if (item.modal && item.modal.id && _this2.extendedModals[item.modal.id]) {
            _this2.extendedModals[item.modal.id].update(objectSpread_default()({}, item.modal, {
              language: language
            }));
          }
        }
      });
    }
  }, {
    key: "getControlItemClassName",
    value: function getControlItemClassName(data) {
      var className = 'control-item button';
      var type = data.type,
          command = data.command;

      if (type === 'inline-style' && external_braft_utils_["ContentUtils"].selectionHasInlineStyle(this.props.editorState, command)) {
        className += ' active';
      } else if (type === 'block-type' && external_braft_utils_["ContentUtils"].getSelectionBlockType(this.props.editorState) === command) {
        className += ' active';
      } else if (type === 'entity' && external_braft_utils_["ContentUtils"].getSelectionEntityType(this.props.editorState) === command) {
        className += ' active';
      }

      return className;
    }
  }, {
    key: "applyControl",
    value: function applyControl(command, type) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var hookReturns = this.props.hooks(commandHookMap[type] || type, command)(command);
      var editorState = this.props.editorState;

      if (hookReturns === false) {
        return false;
      }

      if (typeof hookReturns === 'string') {
        command = hookReturns;
      }

      if (type === 'inline-style') {
        var exclusiveInlineStyle = exclusiveInlineStyles[command];

        if (exclusiveInlineStyle && external_braft_utils_["ContentUtils"].selectionHasInlineStyle(editorState, exclusiveInlineStyle)) {
          editorState = external_braft_utils_["ContentUtils"].toggleSelectionInlineStyle(editorState, exclusiveInlineStyle);
        }

        this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionInlineStyle(editorState, command));
      } else if (type === 'block-type') {
        this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionBlockType(editorState, command));
      } else if (type === 'entity') {
        this.props.editor.setValue(external_braft_utils_["ContentUtils"].toggleSelectionEntity(editorState, {
          type: command,
          mutability: data.mutability || 'MUTABLE',
          data: data.data || {}
        }));
      } else if (type === 'editor-method') {
        this.props.editor[command] && this.props.editor[command]();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          editor = _this$props.editor,
          editorId = _this$props.editorId,
          editorState = _this$props.editorState,
          className = _this$props.className,
          style = _this$props.style,
          controls = _this$props.controls,
          media = _this$props.media,
          extendControls = _this$props.extendControls,
          language = _this$props.language,
          hooks = _this$props.hooks,
          colors = _this$props.colors,
          colorPicker = _this$props.colorPicker,
          colorPickerTheme = _this$props.colorPickerTheme,
          colorPickerAutoHide = _this$props.colorPickerAutoHide,
          headings = _this$props.headings,
          fontSizes = _this$props.fontSizes,
          fontFamilies = _this$props.fontFamilies,
          emojis = _this$props.emojis,
          getContainerNode = _this$props.getContainerNode,
          lineHeights = _this$props.lineHeights,
          letterSpacings = _this$props.letterSpacings,
          textAligns = _this$props.textAligns,
          textBackgroundColor = _this$props.textBackgroundColor,
          allowInsertLinkText = _this$props.allowInsertLinkText,
          defaultLinkTarget = _this$props.defaultLinkTarget;
      var currentBlockType = external_braft_utils_["ContentUtils"].getSelectionBlockType(editorState);
      var commonProps = {
        editor: editor,
        editorId: editorId,
        editorState: editorState,
        language: language,
        getContainerNode: getContainerNode,
        hooks: hooks
      };
      var renderedControls = [];
      var editorControls = configs_controls(language, editor);
      var extensionControls = getExtensionControls(editorId);
      var allControls = mergeControls(commonProps, controls, extensionControls, extendControls);
      this.allControls = allControls;
      return external_react_default.a.createElement("div", {
        className: "bf-controlbar ".concat(className || ''),
        style: style,
        onMouseDown: this.preventDefault
      }, allControls.map(function (item, index) {
        var itemKey = typeof item === 'string' ? item : item.key;

        if (typeof itemKey !== 'string') {
          return null;
        }

        if (renderedControls.indexOf(itemKey) > -1) {
          return null;
        }

        if (itemKey.toLowerCase() === 'separator') {
          return external_react_default.a.createElement("span", {
            key: index,
            className: "separator-line"
          });
        }

        var controlItem = editorControls.find(function (subItem) {
          return subItem.key.toLowerCase() === itemKey.toLowerCase();
        });

        if (typeof item !== 'string') {
          controlItem = objectSpread_default()({}, controlItem, item);
        }

        if (!controlItem) {
          return null;
        }

        renderedControls.push(itemKey);

        if (controlItem.type === 'headings') {
          return external_react_default.a.createElement(Headings, extends_default()({
            key: index,
            headings: headings,
            current: currentBlockType,
            onChange: function onChange(command) {
              return _this3.applyControl(command, 'block-type');
            }
          }, commonProps));
        } else if (controlItem.type === 'text-color') {
          return external_react_default.a.createElement(TextColor_TextColor, extends_default()({
            key: index,
            colors: colors,
            colorPicker: colorPicker,
            theme: colorPickerTheme,
            autoHide: colorPickerAutoHide,
            enableBackgroundColor: textBackgroundColor
          }, commonProps));
        } else if (controlItem.type === 'font-size') {
          return external_react_default.a.createElement(FontSize, extends_default()({
            key: index,
            fontSizes: fontSizes,
            defaultCaption: controlItem.title
          }, commonProps));
        } else if (controlItem.type === 'line-height') {
          return external_react_default.a.createElement(LineHeight, extends_default()({
            key: index,
            lineHeights: lineHeights,
            defaultCaption: controlItem.title
          }, commonProps));
        } else if (controlItem.type === 'letter-spacing') {
          return external_react_default.a.createElement(LetterSpacing, extends_default()({
            key: index,
            letterSpacings: letterSpacings,
            defaultCaption: controlItem.title
          }, commonProps));
        } else if (controlItem.type === 'text-indent') {
          return external_react_default.a.createElement(TextIndent_TextAlign, extends_default()({
            key: index,
            defaultCaption: controlItem.title
          }, commonProps));
        } else if (controlItem.type === 'font-family') {
          return external_react_default.a.createElement(FontFamily, extends_default()({
            key: index,
            fontFamilies: fontFamilies,
            defaultCaption: controlItem.title
          }, commonProps));
        } else if (controlItem.type === 'emoji') {
          return external_react_default.a.createElement(EmojiPicker, extends_default()({
            key: index,
            emojis: emojis,
            defaultCaption: controlItem.text
          }, commonProps));
        } else if (controlItem.type === 'link') {
          return external_react_default.a.createElement(LinkEditor_LinkEditor, extends_default()({
            key: index,
            defaultLinkTarget: defaultLinkTarget,
            allowInsertLinkText: allowInsertLinkText
          }, commonProps));
        } else if (controlItem.type === 'text-align') {
          return external_react_default.a.createElement(TextAlign_TextAlign, extends_default()({
            key: index,
            textAligns: textAligns
          }, commonProps));
        } else if (controlItem.type === 'media') {
          if (!media.image && !media.video && !media.audio) {
            return null;
          }

          return external_react_default.a.createElement("button", {
            type: "button",
            key: index,
            "data-title": controlItem.title,
            disabled: controlItem.disabled,
            className: "control-item media button",
            onClick: _this3.openBraftFinder
          }, controlItem.text);
        } else if (controlItem.type === 'dropdown') {
          return external_react_default.a.createElement(DropDown_DropDown, extends_default()({
            key: index,
            className: "control-item extend-control-item dropdown ".concat(controlItem.className || ''),
            caption: controlItem.text,
            htmlCaption: controlItem.html,
            showArrow: controlItem.showArrow,
            title: controlItem.title,
            arrowActive: controlItem.arrowActive,
            theme: controlItem.theme,
            autoHide: controlItem.autoHide,
            disabled: controlItem.disabled,
            ref: controlItem.ref
          }, commonProps), controlItem.component);
        } else if (controlItem.type === 'modal') {
          return external_react_default.a.createElement("button", {
            type: "button",
            key: index,
            "data-title": controlItem.title,
            disabled: controlItem.disabled,
            className: "control-item extend-control-item button ".concat(controlItem.className || ''),
            dangerouslySetInnerHTML: controlItem.html ? {
              __html: controlItem.html
            } : null,
            onClick: function onClick(event) {
              if (controlItem.modal && controlItem.modal.id) {
                if (_this3.extendedModals[controlItem.modal.id]) {
                  _this3.extendedModals[controlItem.modal.id].active = true;

                  _this3.extendedModals[controlItem.modal.id].update(objectSpread_default()({}, controlItem.modal, {
                    language: language
                  }));
                } else {
                  _this3.extendedModals[controlItem.modal.id] = Modal_showModal(objectSpread_default()({}, controlItem.modal, {
                    language: language
                  }));
                  controlItem.modal.onCreate && controlItem.modal.onCreate(_this3.extendedModals[controlItem.modal.id]);
                }
              }

              controlItem.onClick && controlItem.onClick(event);
            }
          }, !controlItem.html ? controlItem.text : null);
        } else if (controlItem.type === 'component') {
          return external_react_default.a.createElement("div", {
            key: index,
            className: "component-wrapper ".concat(controlItem.className || '')
          }, controlItem.component);
        } else if (controlItem.type === 'button') {
          return external_react_default.a.createElement("button", {
            type: "button",
            key: index,
            "data-title": controlItem.title,
            disabled: controlItem.disabled,
            className: "control-item button ".concat(controlItem.className || ''),
            dangerouslySetInnerHTML: controlItem.html ? {
              __html: controlItem.html
            } : null,
            onClick: function onClick(event) {
              return controlItem.onClick && controlItem.onClick(event);
            }
          }, !controlItem.html ? controlItem.text : null);
        } else if (controlItem) {
          var disabled = false;

          if (controlItem.command === 'undo') {
            disabled = editorState.getUndoStack().size === 0;
          } else if (controlItem.command === 'redo') {
            disabled = editorState.getRedoStack().size === 0;
          }

          return external_react_default.a.createElement("button", {
            type: "button",
            key: index,
            disabled: disabled,
            "data-title": controlItem.title,
            className: _this3.getControlItemClassName({
              type: controlItem.type,
              command: controlItem.command
            }),
            onClick: function onClick() {
              return _this3.applyControl(controlItem.command, controlItem.type, controlItem.data);
            }
          }, controlItem.text);
        }
      }));
    }
  }, {
    key: "preventDefault",
    value: function preventDefault(event) {
      var tagName = event.target.tagName.toLowerCase();

      if (tagName === 'input' || tagName === 'label') {// ...
      } else {
        event.preventDefault();
      }
    }
  }]);

  return ControlBar;
}(external_react_default.a.Component);


// CONCATENATED MODULE: ./editor/index.jsx

























var buildHooks = function buildHooks(hooks) {
  return function (hookName) {
    var defaultReturns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return hooks[hookName] || function () {
      return defaultReturns;
    };
  };
};

var filterColors = function filterColors(colors, colors2) {
  return colors.filter(function (item) {
    return !colors2.find(function (color) {
      return color.toLowerCase() === item.toLowerCase();
    });
  }).filter(function (item, index, array) {
    return array.indexOf(item) === index;
  });
};

var editor_isControlEnabled = function isControlEnabled(props, controlName) {
  return [].concat(toConsumableArray_default()(props.controls), toConsumableArray_default()(props.extendControls)).find(function (item) {
    return item === controlName || item.key === controlName;
  }) && props.excludeControls.indexOf(controlName) === -1;
};

var editor_getConvertOptions = function getConvertOptions(props) {
  var editorId = props.editorId || props.id;

  var convertOptions = objectSpread_default()({}, configs_props.converts, props.converts, {
    fontFamilies: props.fontFamilies
  });

  convertOptions.styleImportFn = compositeStyleImportFn(convertOptions.styleImportFn, editorId);
  convertOptions.styleExportFn = compositeStyleExportFn(convertOptions.styleExportFn, editorId);
  convertOptions.entityImportFn = compositeEntityImportFn(convertOptions.entityImportFn, editorId);
  convertOptions.entityExportFn = compositeEntityExportFn(convertOptions.entityExportFn, editorId);
  convertOptions.blockImportFn = compositeBlockImportFn(convertOptions.blockImportFn, editorId);
  convertOptions.blockExportFn = compositeBlockExportFn(convertOptions.blockExportFn, editorId);
  return convertOptions;
};

var editor_BraftEditor =
/*#__PURE__*/
function (_React$Component) {
  inherits_default()(BraftEditor, _React$Component);

  function BraftEditor(props) {
    var _this;

    classCallCheck_default()(this, BraftEditor);

    _this = possibleConstructorReturn_default()(this, getPrototypeOf_default()(BraftEditor).call(this, props));

    defineProperty_default()(assertThisInitialized_default()(_this), "onChange", function (editorState, callback) {
      if (!(editorState instanceof external_draft_js_["EditorState"])) {
        editorState = external_draft_js_["EditorState"].set(editorState, {
          decorator: _this.editorDecorators
        });
      }

      if (!editorState.convertOptions) {
        editorState.setConvertOptions(editor_getConvertOptions(_this.editorProps));
      }

      _this.setState({
        editorState: editorState
      }, function () {
        _this.props.onChange && _this.props.onChange(editorState);
        callback && callback(editorState);
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "getDraftInstance", function () {
      return _this.draftInstance;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "getFinderInstance", function () {
      return _this.braftFinder;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "getValue", function () {
      return _this.state.editorState;
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setValue", function (editorState, callback) {
      return _this.onChange(editorState, callback);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "forceRender", function () {
      var selectionState = _this.state.editorState.getSelection();

      _this.setValue(external_draft_js_["EditorState"].set(_this.state.editorState, {
        decorator: _this.editorDecorators
      }), function () {
        _this.setValue(external_draft_js_["EditorState"].forceSelection(_this.state.editorState, selectionState));
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "onTab", function (event) {
      if (handlers_keyCommandHandlers('tab', _this.state.editorState, assertThisInitialized_default()(_this)) === 'handled') {
        event.preventDefault();
      }

      _this.editorProps.onTab && _this.editorProps.onTab(event);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "onFocus", function () {
      _this.isFocused = true;
      _this.editorProps.onFocus && _this.editorProps.onFocus(_this.state.editorState);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "onBlur", function () {
      _this.isFocused = false;
      _this.editorProps.onBlur && _this.editorProps.onBlur(_this.state.editorState);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "requestFocus", function () {
      setTimeout(function () {
        return _this.draftInstance.focus();
      }, 0);
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleKeyCommand", function (command, editorState) {
      return handlers_keyCommandHandlers(command, editorState, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleReturn", function (event, editorState) {
      return handlers_returnHandlers(event, editorState, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleBeforeInput", function (chars, editorState) {
      return beforeInputHandlers(chars, editorState, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleDrop", function (selectionState, dataTransfer) {
      return handlers_dropHandlers(selectionState, dataTransfer, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleDroppedFiles", function (selectionState, files) {
      return droppedFilesHandlers(selectionState, files, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handlePastedFiles", function (files) {
      return pastedFilesHandlers(files, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleCopyContent", function (event) {
      return handlers_copyHandlers(event, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handlePastedText", function (text, html, editorState) {
      return handlers_pastedTextHandlers(text, html, editorState, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "handleCompositionStart", function (event) {
      return handlers_compositionStartHandler(event, assertThisInitialized_default()(_this));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "undo", function () {
      _this.setValue(external_braft_utils_["ContentUtils"].undo(_this.state.editorState));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "redo", function () {
      _this.setValue(external_braft_utils_["ContentUtils"].redo(_this.state.editorState));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "removeSelectionInlineStyles", function () {
      _this.setValue(external_braft_utils_["ContentUtils"].removeSelectionInlineStyles(_this.state.editorState));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "insertHorizontalLine", function () {
      _this.setValue(external_braft_utils_["ContentUtils"].insertHorizontalLine(_this.state.editorState));
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "clearEditorContent", function () {
      _this.setValue(external_braft_utils_["ContentUtils"].clear(_this.state.editorState), function (editorState) {
        _this.setValue(external_braft_utils_["ContentUtils"].toggleSelectionIndent(editorState, 0));
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "toggleFullscreen", function (fullscreen) {
      _this.setState({
        isFullscreen: typeof fullscreen !== 'undefined' ? fullscreen : !_this.state.isFullscreen
      }, function () {
        _this.editorProps.onFullscreen && _this.editorProps.onFullscreen(_this.state.isFullscreen);
      });
    });

    defineProperty_default()(assertThisInitialized_default()(_this), "setEditorContainerNode", function (containerNode) {
      _this.containerNode = containerNode;
    });

    _this.editorProps = _this.getEditorProps(props);
    _this.editorDecorators = getDecorators(_this.editorProps.editorId || _this.editorProps.id);
    _this.isFocused = false;
    _this.isLiving = false;
    _this.braftFinder = null;
    _this.valueInitialized = !!(_this.props.defaultValue || _this.props.value);
    var defaultEditorState = (_this.props.defaultValue || _this.props.value) instanceof external_draft_js_["EditorState"] ? _this.props.defaultValue || _this.props.value : external_draft_js_["EditorState"].createEmpty(_this.editorDecorators);
    defaultEditorState.setConvertOptions(editor_getConvertOptions(_this.editorProps));
    var tempColors = [];

    if (external_braft_utils_["ContentUtils"].isEditorState(defaultEditorState)) {
      var colors = external_braft_utils_["ColorUtils"].detectColorsFromDraftState(defaultEditorState.toRAW(true));
      defaultEditorState.setConvertOptions(editor_getConvertOptions(_this.editorProps));
      tempColors = filterColors(colors, _this.editorProps.colors);
    }

    _this.state = {
      tempColors: tempColors,
      editorState: defaultEditorState,
      isFullscreen: false,
      draftProps: {}
    };
    _this.containerNode = null;
    return _this;
  }

  createClass_default()(BraftEditor, [{
    key: "getEditorProps",
    value: function getEditorProps(props) {
      var _this2 = this;

      props = props || this.props;

      var _props = props,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          restProps = objectWithoutProperties_default()(_props, ["value", "defaultValue", "onChange"]); // eslint-disable-line no-unused-vars


      var propInterceptors = getPropInterceptors(restProps.editorId || restProps.id);

      if (propInterceptors.length === 0) {
        return restProps;
      }

      var porpsMap = Object(external_immutable_["Map"])(restProps);
      propInterceptors.forEach(function (interceptor) {
        porpsMap = porpsMap.merge(Object(external_immutable_["Map"])(interceptor(porpsMap.toJS(), _this2) || {}));
      });
      return porpsMap.toJS();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (editor_isControlEnabled(this.editorProps, 'media')) {
        var _this$editorProps = this.editorProps,
            language = _this$editorProps.language,
            media = _this$editorProps.media;

        var _defaultProps$media$m = objectSpread_default()({}, configs_props.media, media),
            uploadFn = _defaultProps$media$m.uploadFn,
            validateFn = _defaultProps$media$m.validateFn,
            items = _defaultProps$media$m.items;

        this.braftFinder = new external_braft_finder_default.a({
          items: items,
          language: language,
          uploader: uploadFn,
          validator: validateFn
        });
        this.forceUpdate();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isLiving = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (prevState.editorState !== this.state.editorState) {
        this.state.editorState.setConvertOptions(editor_getConvertOptions(this.editorProps));
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var _this3 = this;

      this.editorProps = this.getEditorProps(props);
      var editorState = props.value;
      var _this$editorProps2 = this.editorProps,
          media = _this$editorProps2.media,
          language = _this$editorProps2.language;
      var currentProps = this.getEditorProps();

      if (!editor_isControlEnabled(currentProps, 'media') && editor_isControlEnabled(this.editorProps, 'media') && !this.braftFinder) {
        var _defaultProps$media$m2 = objectSpread_default()({}, configs_props.media, media),
            uploadFn = _defaultProps$media$m2.uploadFn,
            validateFn = _defaultProps$media$m2.validateFn,
            items = _defaultProps$media$m2.items;

        this.braftFinder = new external_braft_finder_default.a({
          items: items,
          language: language,
          uploader: uploadFn,
          validator: validateFn
        });
        this.forceUpdate();
      }

      if (media && media.items && this.braftFinder) {
        this.braftFinder.setItems(media.items);
      }

      var nextEditorState;

      if (!this.valueInitialized && typeof this.props.defaultValue === 'undefined' && external_braft_utils_["ContentUtils"].isEditorState(props.defaultValue)) {
        nextEditorState = props.defaultValue;
      } else if (external_braft_utils_["ContentUtils"].isEditorState(editorState)) {
        nextEditorState = editorState;
      }

      if (nextEditorState) {
        if (nextEditorState && nextEditorState !== this.state.editorState) {
          var tempColors = external_braft_utils_["ColorUtils"].detectColorsFromDraftState(nextEditorState.toRAW(true));
          nextEditorState.setConvertOptions(editor_getConvertOptions(this.editorProps));
          this.setState({
            tempColors: filterColors([].concat(toConsumableArray_default()(this.state.tempColors), toConsumableArray_default()(tempColors)), currentProps.colors),
            editorState: nextEditorState
          }, function () {
            _this3.props.onChange && _this3.props.onChange(nextEditorState);
          });
        } else {
          this.setState({
            editorState: nextEditorState
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isLiving = false;
      this.controlBarInstance && this.controlBarInstance.closeBraftFinder();
    }
  }, {
    key: "lockOrUnlockEditor",
    value: function lockOrUnlockEditor(editorLocked) {
      this.setState({
        editorLocked: editorLocked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$editorProps3 = this.editorProps,
          id = _this$editorProps3.id,
          editorId = _this$editorProps3.editorId,
          controls = _this$editorProps3.controls,
          excludeControls = _this$editorProps3.excludeControls,
          extendControls = _this$editorProps3.extendControls,
          readOnly = _this$editorProps3.readOnly,
          disabled = _this$editorProps3.disabled,
          media = _this$editorProps3.media,
          language = _this$editorProps3.language,
          colors = _this$editorProps3.colors,
          colorPicker = _this$editorProps3.colorPicker,
          colorPickerTheme = _this$editorProps3.colorPickerTheme,
          colorPickerAutoHide = _this$editorProps3.colorPickerAutoHide,
          hooks = _this$editorProps3.hooks,
          fontSizes = _this$editorProps3.fontSizes,
          fontFamilies = _this$editorProps3.fontFamilies,
          emojis = _this$editorProps3.emojis,
          placeholder = _this$editorProps3.placeholder,
          fixPlaceholder = _this$editorProps3.fixPlaceholder,
          headings = _this$editorProps3.headings,
          imageControls = _this$editorProps3.imageControls,
          imageResizable = _this$editorProps3.imageResizable,
          imageEqualRatio = _this$editorProps3.imageEqualRatio,
          lineHeights = _this$editorProps3.lineHeights,
          letterSpacings = _this$editorProps3.letterSpacings,
          textAligns = _this$editorProps3.textAligns,
          textBackgroundColor = _this$editorProps3.textBackgroundColor,
          allowInsertLinkText = _this$editorProps3.allowInsertLinkText,
          defaultLinkTarget = _this$editorProps3.defaultLinkTarget,
          extendAtomics = _this$editorProps3.extendAtomics,
          className = _this$editorProps3.className,
          style = _this$editorProps3.style,
          controlBarClassName = _this$editorProps3.controlBarClassName,
          controlBarStyle = _this$editorProps3.controlBarStyle,
          contentClassName = _this$editorProps3.contentClassName,
          contentStyle = _this$editorProps3.contentStyle,
          stripPastedStyles = _this$editorProps3.stripPastedStyles,
          componentBelowControlBar = _this$editorProps3.componentBelowControlBar;
      var _this$state = this.state,
          isFullscreen = _this$state.isFullscreen,
          editorState = _this$state.editorState;
      editorId = editorId || id;
      hooks = buildHooks(hooks);
      controls = controls.filter(function (item) {
        return excludeControls.indexOf(item) === -1;
      });
      language = (typeof language === 'function' ? language(languages, 'braft-editor') : languages[language]) || languages[configs_props.language];
      var externalMedias = media && media.externals ? objectSpread_default()({}, configs_props.media.externals, media.externals) : configs_props.media.externals;
      var accepts = media && media.accepts ? objectSpread_default()({}, configs_props.media.accepts, media.accepts) : configs_props.media.accepts;
      media = objectSpread_default()({}, configs_props.media, media, {
        externalMedias: externalMedias,
        accepts: accepts
      });

      if (!media.uploadFn) {
        media.video = false;
        media.audio = false;
      }

      var controlBarProps = {
        editor: this,
        editorState: editorState,
        braftFinder: this.braftFinder,
        ref: function ref(instance) {
          return _this4.controlBarInstance = instance;
        },
        getContainerNode: function getContainerNode() {
          return _this4.containerNode;
        },
        className: controlBarClassName,
        style: controlBarStyle,
        colors: [].concat(toConsumableArray_default()(colors), toConsumableArray_default()(this.state.tempColors)),
        colorPicker: colorPicker,
        colorPickerTheme: colorPickerTheme,
        colorPickerAutoHide: colorPickerAutoHide,
        hooks: hooks,
        editorId: editorId,
        media: media,
        controls: controls,
        language: language,
        extendControls: extendControls,
        headings: headings,
        fontSizes: fontSizes,
        fontFamilies: fontFamilies,
        emojis: emojis,
        lineHeights: lineHeights,
        letterSpacings: letterSpacings,
        textAligns: textAligns,
        textBackgroundColor: textBackgroundColor,
        allowInsertLinkText: allowInsertLinkText,
        defaultLinkTarget: defaultLinkTarget
      };
      var unitExportFn = editorState.convertOptions.unitExportFn;
      var commonProps = {
        editor: this,
        editorId: editorId,
        hooks: hooks,
        editorState: editorState,
        containerNode: this.containerNode,
        imageControls: imageControls,
        imageResizable: imageResizable,
        language: language,
        extendAtomics: extendAtomics,
        imageEqualRatio: imageEqualRatio
      };
      var blockRendererFn = getBlockRendererFn(commonProps, this.editorProps.blockRendererFn);
      var blockRenderMap = getBlockRenderMap(commonProps, this.editorProps.blockRenderMap);
      var blockStyleFn = getBlockStyleFn(this.editorProps.blockStyleFn);
      var customStyleMap = getCustomStyleMap(commonProps, this.editorProps.customStyleMap);
      var customStyleFn = getCustomStyleFn(commonProps, {
        fontFamilies: fontFamilies,
        unitExportFn: unitExportFn,
        customStyleFn: this.editorProps.customStyleFn
      });
      var keyBindingFn = keybindings(this.editorProps.keyBindingFn);
      var mixedProps = {};

      if (this.state.editorLocked || this.editorProps.disabled || this.editorProps.readOnly || this.editorProps.draftProps.readOnly) {
        mixedProps.readOnly = true;
      }

      if (placeholder && fixPlaceholder && editorState.isEmpty() && editorState.getCurrentContent().getFirstBlock().getType() !== 'unstyled') {
        placeholder = '';
      }

      var draftProps = objectSpread_default()({
        ref: function ref(instance) {
          _this4.draftInstance = instance;
        },
        editorState: editorState,
        handleKeyCommand: this.handleKeyCommand,
        handleReturn: this.handleReturn,
        handleBeforeInput: this.handleBeforeInput,
        handleDrop: this.handleDrop,
        handleDroppedFiles: this.handleDroppedFiles,
        handlePastedText: this.handlePastedText,
        handlePastedFiles: this.handlePastedFiles,
        onChange: this.onChange,
        onTab: this.onTab,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        blockRenderMap: blockRenderMap,
        blockRendererFn: blockRendererFn,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        keyBindingFn: keyBindingFn,
        placeholder: placeholder,
        stripPastedStyles: stripPastedStyles
      }, this.editorProps.draftProps, mixedProps);

      return external_react_default.a.createElement("div", {
        style: style,
        ref: this.setEditorContainerNode,
        className: "bf-container ".concat(className).concat(disabled ? ' disabled' : '').concat(readOnly ? ' read-only' : '').concat(isFullscreen ? ' fullscreen' : '')
      }, external_react_default.a.createElement(ControlBar_ControlBar, controlBarProps), componentBelowControlBar, external_react_default.a.createElement("div", {
        onCompositionStart: this.handleCompositionStart,
        className: "bf-content ".concat(contentClassName),
        onCopy: this.handleCopyContent,
        style: contentStyle
      }, external_react_default.a.createElement(external_draft_js_["Editor"], draftProps)));
    }
  }]);

  return BraftEditor;
}(external_react_default.a.Component);

defineProperty_default()(editor_BraftEditor, "defaultProps", configs_props);



// EXTERNAL MODULE: external "braft-convert"
var external_braft_convert_ = __webpack_require__(14);

// CONCATENATED MODULE: ./index.jsx
/* concated harmony reexport EditorState */__webpack_require__.d(__webpack_exports__, "EditorState", function() { return external_draft_js_["EditorState"]; });
/* concated harmony reexport getDecorators */__webpack_require__.d(__webpack_exports__, "getDecorators", function() { return getDecorators; });







external_draft_js_["EditorState"].prototype.setConvertOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.convertOptions = options;
};

external_draft_js_["EditorState"].prototype.toHTML = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var convertOptions = this.convertOptions || {};
  return Object(external_braft_convert_["convertEditorStateToHTML"])(this, objectSpread_default()({}, convertOptions, options));
};

external_draft_js_["EditorState"].prototype.toRAW = function (noStringify) {
  return noStringify ? Object(external_braft_convert_["convertEditorStateToRaw"])(this) : JSON.stringify(Object(external_braft_convert_["convertEditorStateToRaw"])(this));
};

external_draft_js_["EditorState"].prototype.toText = function () {
  return this.getCurrentContent().getPlainText();
};

external_draft_js_["EditorState"].prototype.isEmpty = function () {
  return !this.getCurrentContent().hasText();
};

editor_BraftEditor.createEditorState = external_draft_js_["EditorState"].createFrom = function (content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.unitExportFn = options.unitExportFn || editor_BraftEditor.defaultProps.converts.unitExportFn;
  options.styleImportFn = compositeStyleImportFn(options.styleImportFn, options.editorId);
  options.entityImportFn = compositeEntityImportFn(options.entityImportFn, options.editorId);
  options.blockImportFn = compositeBlockImportFn(options.blockImportFn, options.editorId);
  var editorState = null;

  if (content instanceof external_draft_js_["EditorState"]) {
    editorState = content;
  } else if (typeof_default()(content) === 'object' && content && content.blocks && content.entityMap) {
    editorState = Object(external_braft_convert_["convertRawToEditorState"])(content, getDecorators(options.editorId));
  } else if (typeof content === 'string') {
    try {
      if (/^(-)?\d+$/.test(content)) {
        editorState = Object(external_braft_convert_["convertHTMLToEditorState"])(content, getDecorators(options.editorId), options, 'create');
      } else {
        editorState = external_draft_js_["EditorState"].createFrom(JSON.parse(content), options);
      }
    } catch (error) {
      editorState = Object(external_braft_convert_["convertHTMLToEditorState"])(content, getDecorators(options.editorId), options, 'create');
    }
  } else if (typeof content === 'number') {
    editorState = Object(external_braft_convert_["convertHTMLToEditorState"])(content.toLocaleString().replace(/,/g, ''), getDecorators(options.editorId), options, 'create');
  } else {
    editorState = external_draft_js_["EditorState"].createEmpty(getDecorators(options.editorId));
  }

  options.styleExportFn = compositeStyleExportFn(options.styleExportFn, options.editorId);
  options.entityExportFn = compositeEntityExportFn(options.entityExportFn, options.editorId);
  options.blockExportFn = compositeBlockExportFn(options.blockExportFn, options.editorId);
  editorState.setConvertOptions(options);
  return editorState;
};

/* harmony default export */ var index_0 = __webpack_exports__["default"] = (createExtensibleEditor(editor_BraftEditor));
 // 2.1 version development plan
// [] Optimizing the selection of multiple lines of text is an error when inserting a link
// [] Add a new image delete hook in the editor
// 2.2 development plan
// [] table function
// [] Beautify the UI, including icons and interface style
// version 2.3 development plan
// [] Primary md shortcut input support
// [] simple editing functions such as picture cropping
// [] allows custom shortcuts

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(227);
var CharacterMetadata = __webpack_require__(83);
var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var DraftEntity = __webpack_require__(306);
var DraftFeatureFlags = __webpack_require__(129);
var Immutable = __webpack_require__(32);
var SelectionState = __webpack_require__(196);

var generateRandomKey = __webpack_require__(121);
var sanitizeDraftText = __webpack_require__(428);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var ContentStateRecord = Record(defaultRecord);

var ContentState = function (_ContentStateRecord) {
  _inherits(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */



var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var invariant = __webpack_require__(34);

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

module.exports = UnicodeBidiDirection;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * @format
 * 
 */



var _require = __webpack_require__(32),
    Map = _require.Map;

var React = __webpack_require__(0);

var cx = __webpack_require__(197);

var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */



/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1959);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getStyleProperty = __webpack_require__(1961);

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

module.exports = Style;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var getDocumentScrollElement = __webpack_require__(1966);
var getUnboundedScrollPosition = __webpack_require__(1967);

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @format
 * 
 */



var getSelectionOffsetKeyForNode = __webpack_require__(822);

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @format
 * 
 */



var UserAgent = __webpack_require__(114);

var isOSX = UserAgent.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

module.exports = KeyBindingUtil;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__ = __webpack_require__(2024);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(2043);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(138);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])({}));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreListEditor", function() { return StoreListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_hash__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_wjson__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(window,'VC_CONFIG.Locale');var STORE_TYPE_IMAGE_URL_MAP={1:PLUGIN_ASSETS_URL+'/img/store/storeImage_a.png',2:PLUGIN_ASSETS_URL+'/img/store/storeImage_s.png'};var getStoreImageUrl=function getStoreImageUrl(store){var storeTypeId=Number(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(store,'store_type_id'));return STORE_TYPE_IMAGE_URL_MAP[storeTypeId]||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(store,'images.0','');};// 前端頁面
var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],// 分頁
listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},query:{a:null,t:null,id:null,service_ids:[],is24h:null},hotKey:[13,86,29]},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click','#store div a',function(){var $text=__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('alt');dataLayer.push({event:'store_click',item:$text});});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cacheQuery=__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[],is24h:null};query.a=cacheQuery.a;query.t=cacheQuery.t;localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].encode(query));__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getStoreList({store_type_id:query.t,store_area_id:query.a,id:query.id,service_ids:query.service_ids,is24h:query.is24h?1:''},function(){_this.handleInfiniteOnLoad();});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(){var query=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.selectpicker[name=id]').selectpicker('val',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(query,'id'));__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(query,key,value);if(key==='a'||key==='t'||key==='service_ids'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(query,'id',null);__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.selectpicker[name=id]').selectpicker('val',null);}localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].encode(query));_this.loadData(query);_this.setState({query:query},function(){_this.refreshPicker();});},_this.getSearchPath=function(query){return window.VC_CONFIG.INDEX_URL+'/stores/#'+__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query,{skipNull:true});},_this.handleInfiniteOnLoad=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(page){console.log('handleInfiniteOnLoad');var listInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this,'props.stores.listInfo');_this.setState({loading:true});var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(listInfo,'rows'),0,data.length+3);console.log('kkk',newData);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getHashParamaters();var cacheQuery=__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[]};if(!query.a&&cacheQuery.a){query.a=1;}localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].encode(query));this.loadData(query);this.loadConfig();this.GTM();}},{key:'render',value:function render(){// const {listInfo={} } = this.state;
var listInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'props.stores.listInfo');var data=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'state.data');var query=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'state.query',{});var options=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'state.options',{});var hotKey=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'state.hotKey');var categoryOptions=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(options,'service_categories',[]).filter(function(categoryInfo){return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(categoryInfo.items);});var service_categorys=categoryOptions;this.refreshPicker();return wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-md-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement('div',{id:'store',className:'row'},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data,function(item){return wp.element.createElement('div',{className:'col-md-6 col-lg-4 d-flex align-items-stretch'},wp.element.createElement('div',{className:'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('a',{alt:item.name,className:'card-body',role:'button',href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+item.name+'#tab=info'},wp.element.createElement('div',{className:'img-2-1 mb-4',style:{backgroundImage:'url('+getStoreImageUrl(item)+')'}}),wp.element.createElement('h5',{className:'h4 text-center mb-4'},(Locale=='zh_TW'||Locale=='en_US'&&!item.en_name)&&item.name,Locale=='en_US'&&item.en_name&&item.en_name,item.is24h&&wp.element.createElement('span',{className:'hour-24-tag'},'24h')),wp.element.createElement('ul',{className:'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{className:'icon-store_map'}),wp.element.createElement('span',null,(Locale=='zh_TW'||Locale=='en_US'&&!item.en_street)&&item.address,Locale=='en_US'&&item.en_street&&item.en_street,wp.element.createElement('a',{className:'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{className:'ml-3',src:PLUGIN_ASSETS_URL+'/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{className:'icon-store_phone'}),wp.element.createElement('span',null,wp.element.createElement('a',{href:'tel:+886-'+item.contact_tel},item.contact_tel)))))));}))))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var nextListInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(props,'stores.listInfo');var prevListInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(state,'listInfo');console.log('getDerivedStateFromProps',__WEBPACK_IMPORTED_MODULE_3_object_hash___default()(nextListInfo)!==__WEBPACK_IMPORTED_MODULE_3_object_hash___default()(prevListInfo));if(__WEBPACK_IMPORTED_MODULE_3_object_hash___default()(nextListInfo)!==__WEBPACK_IMPORTED_MODULE_3_object_hash___default()(prevListInfo)){return{data:[],listInfo:nextListInfo};}// Return null to indicate no change to state.
return null;}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// 編輯器
var StoreListEditor=function(_Component2){_inherits(StoreListEditor,_Component2);function StoreListEditor(){_classCallCheck(this,StoreListEditor);return _possibleConstructorReturn(this,(StoreListEditor.__proto__||Object.getPrototypeOf(StoreListEditor)).apply(this,arguments));}_createClass(StoreListEditor,[{key:'render',value:function render(){return wp.element.createElement('div',null,'\u5546\u5E97\u5217\u8868');}}]);return StoreListEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreMapEditor", function() { return StoreMapEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_wjson__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var Option=__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option;// 前端頁面
var StoreMap=function(_Component){_inherits(StoreMap,_Component);function StoreMap(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreMap);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreMap.__proto__||Object.getPrototypeOf(StoreMap)).call.apply(_ref,[this].concat(args))),_this),_this.state={query:{a:null,t:null,id:null,service_ids:[]}},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cacheQuery=__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[]};query.service_ids=cacheQuery.service_ids;__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getStoreList({store_type_id:query.t,store_area_id:query.a,service_ids:query.service_ids,id:query.id,page_size:'all'},function(){return _this.reloadMaps();});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker').selectpicker('refresh');});});},_this.getGPS=function(){console.log('geolocation','geolocation'in navigator,navigator.geolocation);if('geolocation'in navigator===false){return;}navigator.geolocation.getCurrentPosition(function(position){console.log('geolocation getCurrentPosition',position.coords.latitude,position.coords.longitude);});},_this.reloadMaps=function(){var _this$state=_this.state,map=_this$state.map,maps=_this$state.maps;console.log('reloadMaps',map,maps);if(!maps||!map)return;var stores=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this,'props.stores.listInfo.rows',[]);if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isArray(stores)||stores.length===0)return;if(Array.isArray(_this.state.markers)){_this.state.markers.forEach(function(marker){return marker.setMap(null);});}// zoom預設為能呈現出地形等高線的大小
// 所以改成呈現最新的裝置位置
var bounds=new maps.LatLngBounds();var markers=stores.map(function(store,idx){var icon='';if(store.store_type_id==2)icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-m-loc.png';else icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-loc.png';var marker=new maps.Marker({map:map,position:{lat:store.latitude,lng:store.longitude},store:store,icon:icon});var infowindow=new maps.InfoWindow({content:'<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">'+store.name+'</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">'+store.address+'</div> </div> </div>'});marker.addListener('click',function(){infowindow.open(map,marker);});// marker.addListener('mouseover', function () {
//   infowindow.open(map, marker);
// });
// marker.addListener('mouseout', function () {
//   infowindow.close();
// });
if(idx==0){bounds.extend(marker.getPosition());}return marker;});map.fitBounds(bounds);map.setZoom(16);_this.setState({markers:markers});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function(){var query=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker[name=id]').selectpicker('val',__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(query,'id'));__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){console.log('handleQueryUpdate',key,value);var query=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this,'state.query',{});console.log('query',query);var cacheQuery=__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[]};query.service_ids=cacheQuery.service_ids;console.log('cacheQuery',cacheQuery);console.log('query111',query);__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(query,key,value);if(key==='a'||key==='t'||key==='service_ids'){__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(query,'id',null);// delete query.id
console.log('handleQueryUpdate',__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker[name=id]'));__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker[name=id]').selectpicker('val',null);}console.log('handleQueryUpdate555',query);localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].encode(query));console.log('handleQueryUpdate',key,value,query);_this.loadData(query);_this.setState({query:query},function(){_this.refreshPicker();});},_this.getSearchPath=function(query){var Local=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(window,'VC_CONFIG.Locale');if(Local=='en_US')return window.VC_CONFIG.INDEX_URL+'/stores-en/#'+__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(query,{skipNull:true});return window.VC_CONFIG.INDEX_URL+'/stores/#'+__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(query,{skipNull:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreMap,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getHashParamaters();var cacheQuery=__WEBPACK_IMPORTED_MODULE_11_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[]};if(!query.a&&cacheQuery.a){query.a=1;}if(!query.service_ids&&cacheQuery.service_ids){query.service_ids=cacheQuery.service_ids;}console.log('componentDidMount',query,cacheQuery);this.setState({query:query});this.loadConfig();this.loadData(query);}},{key:'render',value:function render(){var _this2=this;var listInfo=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'props.stores.listInfo',[]);// const options = _.get(this, 'props.app.options', {})
var options=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.query',{});this.refreshPicker();return wp.element.createElement('div',{className:'banner-location'},wp.element.createElement('div',{id:'map'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_google_map_react___default.a,{bootstrapURLKeys:{key:__WEBPACK_IMPORTED_MODULE_9__configs_env__["f" /* GOOGLE_MAP_KEY */]},defaultCenter:[25.1243218,121.4971524],defaultZoom:13,options:{mapTypeControl:false,styles:[{elementType:'all'}]},yesIWantToUseGoogleMapApiInternals:true,onGoogleApiLoaded:function onGoogleApiLoaded(_ref2){var map=_ref2.map,maps=_ref2.maps;return _this2.setState({map:map,maps:maps},function(){return _this2.reloadMaps();});}})),wp.element.createElement('div',{className:'map-filter-bar'},wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row justify-content-center no-gutters mx-n2'},wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'store_area_id',value:query.a,'data-none-selected-text':'\u8ACB\u9078\u64C7\u57CE\u5E02\u5340\u57DF',onChange:function onChange(e){return _this2.handleQueryUpdate('a',!isNaN(parseInt(e.target.value,10))?parseInt(e.target.value,10):null);}},wp.element.createElement('option',{value:null,disabled:true},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('請選擇城市區域','cec-plugin-stores')),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(options,'store_areas',[]),function(item){return wp.element.createElement('option',{key:item.id,value:item.id},item.name);})))),wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'store_type_id',value:query.t,'data-none-selected-text':Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('請選擇分店型態','cec-plugin-stores'),onChange:function onChange(e){return _this2.handleQueryUpdate('t',!isNaN(parseInt(e.target.value,10))?parseInt(e.target.value,10):null);}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('請選擇分店型態','cec-plugin-stores'),' '),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(options,'store_types',[]),function(item){return wp.element.createElement('option',{key:item.id,value:item.id},item.name);})))),wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'id','data-none-selected-text':'\u8ACB\u9078\u64C7\u5206\u5E97',value:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(query,'id',null),onChange:function onChange(e){return _this2.handleQueryUpdate('id',!isNaN(parseInt(e.target.value,10))?parseInt(e.target.value,10):null);}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('請選擇分店','cec-plugin-stores'),' '),__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(listInfo,'rows',[]),function(item){return wp.element.createElement('option',{key:item.id,value:item.id},item.name);})))),wp.element.createElement('div',{className:'col-md-auto px-2'},wp.element.createElement('a',{className:'btn btn-primary btn-search',href:this.getSearchPath(query),onClick:function onClick(){return _this2.loadData(query);}},wp.element.createElement('i',{className:'icon-search mr-3 mr-md-0'}),wp.element.createElement('span',{className:'h6 mb-0 d-md-none'},'\u641C\u5C0B\u5206\u5E97')))))));}}]);return StoreMap;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 後台編輯器
var StoreMapEditor=function(_Component2){_inherits(StoreMapEditor,_Component2);function StoreMapEditor(){_classCallCheck(this,StoreMapEditor);return _possibleConstructorReturn(this,(StoreMapEditor.__proto__||Object.getPrototypeOf(StoreMapEditor)).apply(this,arguments));}_createClass(StoreMapEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{style:{height:'50vh',width:'100%'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_google_map_react___default.a,{bootstrapURLKeys:{key:__WEBPACK_IMPORTED_MODULE_9__configs_env__["f" /* GOOGLE_MAP_KEY */]},defaultCenter:[25.1243218,121.4971524],defaultZoom:13,options:{mapTypeControl:false}}));}}]);return StoreMapEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___36yRi","container_1":"container_1___XxTYd","container_2":"container_2___whRTE"};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserLoginEditor", function() { return UserLoginEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG',{});var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};// 前端頁面
var UserLogin=function(_Component){_inherits(UserLogin,_Component);function UserLogin(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserLogin);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserLogin.__proto__||Object.getPrototypeOf(UserLogin)).call.apply(_ref,[this].concat(args))),_this),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo),To:null,ContactData:{}},_this.getCampaigns=function(){__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_13__configs_env__["b" /* API_HOST */]+'/api/campaigns/config',{},function(state,res){console.log(state,res);var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入失敗，請稍候在試','cec-plugin-stores'),onClose:function onClose(){//window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入失敗','cec-plugin-stores'),description:reason,onClose:function onClose(){//window.location.href = VC_CONFIG.INDEX_URL;
}});return;}var campaignCode=_this.getParameterByName('state');//
if(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.has(res,'data.'+campaignCode)){var auth_url=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(res,'data.'+campaignCode+'.auth_url');var targetUrl=auth_url+'?'+__WEBPACK_IMPORTED_MODULE_10_query_string___default.a.stringify({code:_this.getParameterByName('code'),spcode:_this.getParameterByName('spcode')});window.location.href=targetUrl;}});},_this.exchangeToken=function(code,spcode){_this.props.cleanAuthInfo();if(code==null||spcode==null){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入失敗，請稍候在試','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_13__configs_env__["b" /* API_HOST */]+('/api/account/getAccessToken?code='+code+'&spcode='+spcode),{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入失敗，請稍候在試','cec-plugin-stores'),onClose:function onClose(){//window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入失敗','cec-plugin-stores'),description:reason,onClose:function onClose(){//window.location.href = VC_CONFIG.INDEX_URL;
}});return;}console.log('store',__WEBPACK_IMPORTED_MODULE_20__reducers_auth__["c" /* updateAuthInfo */]);_this.props.updateAuthInfo({authorization:data.token});__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateUserInfo(function(){var link=VC_CONFIG.INDEX_URL;__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['success']({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入成功','cec-plugin-stores'),duration:1,onClose:function onClose(){if(_this.state.To){link=link+_this.state.To;if(_this.state.ContactData){link=link+'?data='+encodeURIComponent(JSON.stringify(_this.state.ContactData));}}else{link=VC_CONFIG.INDEX_URL+'/profile';}console.log('sso網頁轉至: ',link);window.location.href=link;}});});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserLogin,[{key:'getParameterByName',value:function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\]]/g,'\\$&');var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)'),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var To=__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].getLocalStorage('to-href');var ContactData=__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].getLocalStorage('contact-data');if(this.getParameterByName('state')!=='C4'){this.getCampaigns();return;}if(To){this.setState({To:To},function(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');});if(ContactData)this.setState({ContactData:ContactData},function(){_this2.exchangeToken(_this2.getParameterByName('code'),_this2.getParameterByName('spcode'));__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');});console.log('sso',To,ContactData);}else this.exchangeToken(this.getParameterByName('code'),this.getParameterByName('spcode'));// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){return wp.element.createElement('div',{style:{height:'350px'},className:'jumbotron d-flex align-items-center'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{className:'mt-4',size:'large',tip:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('登入中...','cec-plugin-stores')})));}}]);return UserLogin;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器
var UserLoginEditor=function(_Component2){_inherits(UserLoginEditor,_Component2);function UserLoginEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,UserLoginEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=UserLoginEditor.__proto__||Object.getPrototypeOf(UserLoginEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(UserLoginEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'OCA-\u6703\u54E1 SSO \u767B\u5165\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserLoginEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserCCLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserLoginCCEditor", function() { return UserLoginCCEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG',{});var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]// 前端頁面
};var UserCCLogin=function(_Component){_inherits(UserCCLogin,_Component);function UserCCLogin(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserCCLogin);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserCCLogin.__proto__||Object.getPrototypeOf(UserCCLogin)).call.apply(_ref,[this].concat(args))),_this),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo),To:null,contactData:{}},_this.saveAccessToken=function(token){_this.props.cleanAuthInfo();console.log('access token',token);if(token==null){// return notification['error']({
//   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}_this.setState({isSubmitData:false});_this.props.updateAuthInfo({authorization:token});_this.fetchUserInfo();},_this.exchangeToken=function(accessToken){_this.props.cleanAuthInfo();if(accessToken==null){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+('/api/account/getAccessTokenCC?access_token='+accessToken),{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'登入失敗，請稍候再試。',content:reason});}if(code!==200){if(code==901){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('須將帳號改為手機','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==902){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('更新帳號資訊。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==903){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行解除綁定後補資料流程','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==999){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('解除綁定不完全，請與客服中心聯繫。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'提示',content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}_this.props.updateAuthInfo({authorization:data.token});console.log('exchangeToken',data.token);_this.fetchUserInfo();});},_this.fetchUserInfo=function(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateUserInfo(function(resp){console.log('updateUserInfo userInfo:',resp);var link=VC_CONFIG.INDEX_URL;var fromBigPlatform=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('from-big-platform');__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['success']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入成功','cec-plugin-stores'),duration:1,onClose:function onClose(){// 檢查是否從大平台載具歸戶流程進入
if(fromBigPlatform==='true'){// 導向載具綁定頁面
link=VC_CONFIG.INDEX_URL+'/carrier-binding';console.log('從大平台流程，導向載具綁定頁面:',link);}else if(_this.state.To){link=link+_this.state.To;if(_this.state.contactData){link=link+'?data='+encodeURIComponent(JSON.stringify(_this.state.contactData));}}else{link=VC_CONFIG.INDEX_URL+'/profile';}console.log('sso網頁轉至: ',link);window.location.replace(link);}});});},_this.subLogin=function(src_token,src_client_id){_this.props.cleanAuthInfo();if(src_token==null||src_client_id==null){// return notification['error']({
//   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+'/api/account/getSubLogInCC',{src_token:src_token,src_client_id:src_client_id},function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){// return notification['error']({
//   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//   description: reason,
//   onClose:() => {
//     //window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){// window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code==300){//顯示錯誤訊息並返回首頁
// return notification['error']({
//         message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//         description: reason,
//         onClose:() => {
//           window.location.href = VC_CONFIG.INDEX_URL;
//         }
//       });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}else if(code!==200&&code!==300){// return notification['error']({
//   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//   description: reason,
//   onClose:() => {
//     //window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){// window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code==200){_this.props.updateAuthInfo({authorization:data.token});console.log('subLogin',data,data.token);__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateUserInfo(function(){var link=VC_CONFIG.INDEX_URL;__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['success']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入成功','cec-plugin-stores'),duration:1,onClose:function onClose(){if(_this.state.To){link=link+_this.state.To;if(_this.state.contactData){link=link+'?data='+encodeURIComponent(JSON.stringify(_this.state.contactData));}}else{link=VC_CONFIG.INDEX_URL+'/profile';}console.log('sso網頁轉至: ',link);window.location.href=link;}});});}});},_this.Logout=function(){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['warning']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已成功登出','cec-plugin-stores'),duration:1,onClose:function onClose(){//AppHelper.removeLocalStorage('contact-data')
//AppHelper.removeLocalStorage('to-href')
//this.props.cleanUserInfo();
//this.props.cleanAuthInfo();
window.location.href=VC_CONFIG.INDEX_URL;}});},_this.thirdBinding=function(redirectFlag){var showMessage='您已完成綁定第三方帳號';switch(redirectFlag){case'1':showMessage='您已完成綁定第三方帳號(Facebook)關聯';break;case'2':showMessage='您已完成解除第三方帳號(Facebook)關聯';break;case'3':showMessage='您已完成綁定第三方帳號(G+)關聯';break;case'4':showMessage='您已完成解除第三方帳號(G+)關聯';break;case'5':showMessage='您已完成綁定第三方帳號(Line)關聯';break;case'6':showMessage='您已完成解除第三方帳號(Line)關聯';break;default:return;}// return notification['success']({
//   message: __(showMessage,'cec-plugin-stores'),
//   duration: 3,
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL+"/profile";
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.success({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])(showMessage,'cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL+'/profile';}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserCCLogin,[{key:'getParameterByName',value:function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\]]/g,'\\$&');var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)'),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var To=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('to-href');var contactData=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('contact-data');var fromBigPlatform=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('from-big-platform');if(To){this.setState({To:To},function(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');});if(contactData)this.setState({contactData:contactData},function(){// this.saveAccessToken(this.getParameterByName('access_token'))
// 2023/05/17 ALVIN 依舊需要exchangeToken
_this2.exchangeToken(_this2.getParameterByName('access_token'));__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');});console.log('sso',To,contactData,fromBigPlatform);}var token=this.getParameterByName('access_token');console.log('access_token:',token);if(this.getParameterByName('src_token')&&this.getParameterByName('src_client_id')){return this.subLogin(this.getParameterByName('src_token'),this.getParameterByName('src_client_id'));}if(this.getParameterByName('redirectFlag')){return this.thirdBinding(this.getParameterByName('redirectFlag'));}if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(token)){// return this.saveAccessToken(token)
return this.exchangeToken(token);}// 判斷是否有user
var authorization=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this.props,'auth.authorization');if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(authorization)){return this.fetchUserInfo();}window.location.href='/';}//測試： https://www.uni-prosperity.com.tw/sso?src_token=123&src_client_id=123
//第三方綁定
},{key:'render',value:function render(){return wp.element.createElement('div',{style:{height:'350px'},className:'jumbotron d-flex align-items-center'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{className:'mt-4',size:'large',tip:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入中...','cec-plugin-stores')})));}}]);return UserCCLogin;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var UserLoginCCEditor=function(_Component2){_inherits(UserLoginCCEditor,_Component2);function UserLoginCCEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,UserLoginCCEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=UserLoginCCEditor.__proto__||Object.getPrototypeOf(UserLoginCCEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(UserLoginCCEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'CC-\u6703\u54E1 SSO \u767B\u5165\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserLoginCCEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserProfileEditor", function() { return UserProfileEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_jsbarcode__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_jsbarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_jsbarcode__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var Local=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_17_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,isLoading:false},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_23_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_23_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_23_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_23_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_23_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_23_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_23_jquery___default()('.highlight').addClass('current_page_item');});},_this.fillData=function(data){if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.isNil(data.addresses)||!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.isArray(data.addresses)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(data.addresses[0],'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(data.addresses[0],'area_id')};data.street=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(data.addresses[0],'street');}if(data.birthday){data.birthday=__WEBPACK_IMPORTED_MODULE_21_moment___default()(data.birthday);}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};info.addresses=[{city_id:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'address.city_id'),area_id:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'address.area_id'),street:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'street')}];console.log(info);info.birthday=__WEBPACK_IMPORTED_MODULE_21_moment___default()(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'birthday')).format('YYYY-MM-DD');info.flag=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'flag')?1:0;info.agree_receive_sms=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'agree_receive_sms')?1:0;info.sync_to_cls=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'sync_to_cls')?1:0;delete info['address'];console.log('info',info);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+'/api/account/updProfile',info,function(state,res){console.log(state,res,info);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_13_antd_lib_notification___default.a['success']({message:'修改成功'});window.location.href=window.VC_CONFIG.INDEX_URL+'/profile';});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfile,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__["a" /* default */].updateConfig();this.setState({isFetchData:true,isLoading:true,info:this.props.user});__WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__["a" /* default */].updateUserInfo(function(){_this2.setState({isFetchData:false,isLoading:false},function(){_this2.reloadTab();});_this2.fillData(_this2.props.user);});// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_27_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this,'props.app.options',{});var info=this.state.info;return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link ',href:window.VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link ',href:window.VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{'class':'card border-0 shadow-0 mb-4'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},wp.element.createElement('div',{'class':'col-md-6 mx-auto'},wp.element.createElement('p',{className:'h6 text-navy mb-4'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('我的帳號','cec-plugin-stores'),'\uFF1A',info&&info.email),wp.element.createElement('p',{className:'h6 text-navy mb-4'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('連結好康卡','cec-plugin-stores'),'\uFF1A',info&&info.cardInfo&&info.cardInfo.cardnumber&&wp.element.createElement('svg',{'class':'barcode img-fluid mb-5','jsbarcode-value':info.cardInfo.cardnumber,'jsbarcode-width':'4','jsbarcode-height':'50'})),wp.element.createElement('p',{className:'note text-success mb-0'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('一個網站帳號僅能連結一張好康卡(或聯名卡)， 無論您選擇哪一張卡片進行連結，所有卡片消費時皆可累積點數，會員資料、紅利點數皆為同一會員帳戶所有。','cec-plugin-stores')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this3.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){console.log('onValuesChange:',changedFields,allFields);}// onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
// onFieldsChange={(changedFields, allFields) => {
//     const storeInfo = _.reduce(allFields,(obj,item) => {
//         _.set(obj, item.name.join('.'), item.value)
//         return obj
//       }, {})
//       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
//       return true
//     }}
},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('帳號資料','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:this.state.isSubmitData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},info&&info.spcode==='C4'&&wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('帳號','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement('input',{className:'form-control',type:'text',disabled:'disabled',readonly:'',value:info&&info.email,id:''}))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('中文姓名','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請輸入中文姓名','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('cn_name')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('英文姓名','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請輸入英文姓名','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_name')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('生日','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請選擇生日','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('birthday',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_date_picker___default.a,{placeholder:'\u8ACB\u9078\u64C7\u751F\u65E5',className:'form-control',format:'YYYY-MM-DD'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('地址','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{label:''},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a.Group,{compact:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{name:'address',noStyle:true,className:'form-control',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請選擇縣市區域','cec-plugin-stores')}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_components_CitySelect_CitySelect__["a" /* default */],{placeholder:'\u8ACB\u9078\u64C7\u7E23\u5E02',style:{width:'30%'}})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{name:'street',noStyle:true,className:'form-control',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請輸入地址','cec-plugin-stores')}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{style:{width:'70%'},placeholder:'\u8F38\u5165\u5730\u5740'})))))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('手機','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({rules:[{required:true,pattern:new RegExp('^[0-9]{10}$'),message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請輸入正確手機號碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('mobile')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('居住電話','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('home_phone'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('公司電話','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('work_phone'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('電子信箱','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('請輸入信箱','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('email')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{className:'form-control'})))))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('訂閱相關活動訊息','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:this.state.isSubmitData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('flag',null,'checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{value:true},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('我授權給使用我的資料，將網路促銷活動、店內促銷活動、會員最新消息、遊戲及及其他公司集團品牌新聞，發送至我的信箱。','cec-plugin-stores'))))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('agree_receive_sms',null,'checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{value:true},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('我想要收到寄給我的手機簡訊 (※以上功能僅針對官網會員，好康卡會員若要取消簡訊寄送服務，請撥打客服專線：0809-001-365，客服人員會代為協助處理，謝謝！)','cec-plugin-stores'))))))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('資料同步','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:this.state.isSubmitData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('sync_to_cls',null,'checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_checkbox___default.a,{value:true},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('同步網站會員資料至好康卡會員資料','cec-plugin-stores')))),wp.element.createElement('p',{className:' text-dark fw-300'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('※若您勾選此項目，系統將自動同步網站會員資料至好康卡會員資料，但姓名及生日無法同步修改，如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:' text-dark fw-300'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('※由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores'))))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('若您同時擁有好康卡及聯名卡，兩張卡片可擇一輸入。無論選擇哪一張卡片，所有卡片消費時皆可累積點數，會員資料、紅利點數皆為同一個帳戶所有。一個網站帳號僅能連結一個好康卡(或聯名卡)。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('※ 身份證字號英文字母需大寫，若是您沒有身分證字號，請輸入您的居留證號碼或是護照號碼進行綁定。 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('※ 請輸入完整好康卡或聯名卡號，請勿有空格或符號。 好康卡範例：1465121897610145 ；聯名卡範例：5252558843433636')))))),wp.element.createElement('div',{className:'text-center mt-5'},wp.element.createElement('a',{className:'h6 btn btn-outline-primary rounded-pill px-5 py-4',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this3.formRef.current.submit();}},Object(__WEBPACK_IMPORTED_MODULE_37__wordpress_i18n__["__"])('確定修改','cec-plugin-stores')))))));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserProfileEditor=function(_Component2){_inherits(UserProfileEditor,_Component2);function UserProfileEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserProfileEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserProfileEditor.__proto__||Object.getPrototypeOf(UserProfileEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserProfileEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u8CC7\u8A0A\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserProfileEditor;}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfileCC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserProfileCCEditor", function() { return UserProfileCCEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};function isMobileDevice(){var mobileDevices=['Android','iPhone','iPad'];var isMobileDevice=0;for(var i=0;i<mobileDevices.length;i++){if(navigator.userAgent.match(mobileDevices[i])){isMobileDevice=1;}}return isMobileDevice;}// 前端頁面
var UserProfileCC=function(_Component){_inherits(UserProfileCC,_Component);function UserProfileCC(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfileCC);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfileCC.__proto__||Object.getPrototypeOf(UserProfileCC)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this.logoutTimer=null,_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,isLoading:false,ccUrl:null,memberVip:0,memberOpen:0,memberType:0,// 0: 一般會員; 1: VIP; 2: 一般會員 OP會員; 3: VIP OP會員
memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,openPoint:0,openPointDiscount:0,iframeHeight:900,logoutModal:false,iframeLoaded:false,isLoadingLogout:false},_this.LoadCC=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/cc/ccUri?type=profile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'發生錯誤'});}if(code===401){// Modal.error({
//   title: '登入資訊已過期',
//   onOk: () => {
//     window.location.replace(VC_CONFIG.INDEX_URL);
//   }
// });
console.log('登入資訊過期');}else if(code!==200){// notification['error']({
//   message: '資料讀取失敗',
//   description: reason,
// });
__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({ccUrl:data.uri},function(){_this.getIframeHeight();_this.logoutTimer=setTimeout(function(){_this.setState({logoutModal:true});},120000);});});},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get($magicLine,0)){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.highlight').addClass('current_page_item');});},_this.getProfile=function(){_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){// return message.error('發生錯誤');
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'發生錯誤'});}if(code===401){// Modal.error({
//   title: '登入資訊已過期',
//   onOk: () => {
//     window.location.replace(VC_CONFIG.INDEX_URL);
//   }
// });
console.log('登入資訊過期');}else if(code!==200){// notification['error']({
//   message: '資料讀取失敗',
//   description: reason,
// });
__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({info:data});// AppHelper.thirdPartyLogin(data.client_id, data.access_token)
});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfiles',{},function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({memberVip:data.member_profile_isvip,memberOpen:data.member_profile_isopen,memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10),openPoint:data.member_open_value,openPointDiscount:parseInt(data.member_open_value,10),memberType:data.member_profile_isvip==0&&data.member_profile_isopen==0?0:data.member_profile_isvip==1&&data.member_profile_isopen==0?1:data.member_profile_isvip==0&&data.member_profile_isopen==1?2:data.member_profile_isvip==1&&data.member_profile_isopen==1?3:0});});},_this.getIframeHeight=function(){var url=_this.state.ccUrl;var frame=document.getElementById('iframe-profile');var message={parentOrigin:window.origin,msg:'收到請回覆'};frame.addEventListener('load',function(){var frameContent=frame.contentWindow;frameContent.postMessage(JSON.stringify(message),url);_this.setState({iframeLoaded:true});});},_this.ccLogout=function(){_this.setState({isLoadingLogout:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/cc/ccUri?type=logout',{},function(state,res){var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}_this.ccLogoutProcess(data.uri);});},_this.ccLogoutProcess=function(uri){__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(uri,{},function(state,res){var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!=='200'){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');_this.props.cleanUserInfo();_this.props.cleanAuthInfo();__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['warning']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('已成功登出','cec-plugin-stores'),duration:1,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});});},_this.logout=function(){_this.setState({isLoadingLogout:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/ocaUri?type=logout',{},function(state,res){var _res$code6=res.code,code=_res$code6===undefined?100:_res$code6,_res$reason6=res.reason,reason=_res$reason6===undefined?Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason6,_res$data6=res.data,data=_res$data6===undefined?{}:_res$data6;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');_this.props.cleanUserInfo();_this.props.cleanAuthInfo();window.location.href=data.uri;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfileCC,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.LoadCC();__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].updateConfig();this.getMemberProfile();this.getProfile();this.setState({info:this.props.user},function(){_this2.reloadTab();});// 獲取 iframe 高度
window.addEventListener('message',function(event){console.log('event.data',event.data);if(typeof event.data==='number'){clearTimeout(_this2.logoutTimer);var iframeHeight=event.data+20;__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#iframe-profile').css({visibility:'visible'});_this2.setState({iframeHeight:iframeHeight});}});}},{key:'render',value:function render(){var _this3=this;var ccUrl=this.state.ccUrl;var ProfileInfo=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.info');var MemberVip=this.state.memberVip;var MemberOpen=this.state.memberOpen;// 新增用戶類型
var MemberType=this.state.memberType;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;var OpenPoint=this.state.openPoint;var OpenPointDiscount=this.state.openPointDiscount;var iframeHeight=this.state.iframeHeight;var isMobile=isMobileDevice();var memberCardImages={0:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-2025.png',// 一般會員
1:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png',// VIP
2:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-openpoint-2025.png',// 一般會員 OP會員
3:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png'// VIP OP會員
};return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:' container',style:{'max-width':'1300px'}},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),wp.element.createElement('b',{className:'fw-700'},ProfileInfo&&ProfileInfo.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}})))),wp.element.createElement('div',{'class':'col-lg-8 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',' ',MemberVip==0?wp.element.createElement('span',{style:{color:'#1E5BC6'}},'\u4E00\u822C\u6703\u54E1'):wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-vvip-2025.png',alt:'VIP',style:{width:'60px',height:'17px'}}),MemberOpen==1&&wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-openpoint-2025.png',alt:'uniopen',style:{width:'60px',height:'17px'}}))),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/cec-point-2025.png',alt:'\u7D05\u5229\u9EDE\u6578\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,' \u5143')))),wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/open-point-2025.svg',alt:'OPENPOINT\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'OPENPOINT\uFF1A',OpenPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',OpenPointDiscount,' \u5143'))))),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{align:'center',style:{backgroundColor:'#F5F4F2',height:iframeHeight+'px',position:'relative'}},ccUrl&&wp.element.createElement('iframe',{id:'iframe-profile',title:'iframe-profile',style:{visibility:'hidden',height:'100%'},src:ccUrl,width:isMobile?'100%':'80%',border:'0',frameborder:'no',scrolling:'no'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{size:'large',style:{position:'absolute',top:'50%',left:'50%'},spinning:!this.state.iframeLoaded}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,{visible:this.state.logoutModal,title:'Oops !',closable:false,okText:'\u78BA\u5B9A',confirmLoading:this.state.isLoadingLogout,cancelButtonProps:{style:{display:'none'}},onOk:function onOk(){// 改CC Logout
// this.logout()
_this3.ccLogout();}},wp.element.createElement('div',null,'\u6703\u54E1\u5E33\u865F\u767B\u5165\u6642\u9593\u5DF2\u904E\u671F\uFF0C\u8ACB\u91CD\u65B0\u767B\u5165\u3002')));}}]);return UserProfileCC;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserProfileCCEditor=function(_Component2){_inherits(UserProfileCCEditor,_Component2);function UserProfileCCEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserProfileCCEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserProfileCCEditor.__proto__||Object.getPrototypeOf(UserProfileCCEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserProfileCCEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'CC-\u6703\u54E1\u8CC7\u8A0A\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserProfileCCEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPasswordEditor", function() { return UserPasswordEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_11_antd_lib_tabs___default.a.TabPane;var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(window,'VC_CONFIG');// 前端頁面
var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_17_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_17_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.highlight').addClass('current_page_item');});},_this.fillData=function(data){if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(data,'area_id')};}console.log(data);_this.formRef.current.setFieldsValue(data);_this.setState({isLoading:false},function(){_this.reloadTab();});},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log('submitData',info);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/changePwd',info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.success('修改成功');});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfile,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].updateConfig();this.setState({isFetchData:true,info:this.props.user});__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].updateUserInfo(function(){_this2.setState({isFetchData:false},function(){_this2.reloadTab();});_this2.fillData(_this2.props.user);});// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'props.app.options',{});var info=this.state.info;var Local=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(window,'VC_CONFIG.Locale');return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('會員資料','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,{spinning:this.state.isSubmitData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this3.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){console.log('onValuesChange:',changedFields,allFields);}// onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
// onFieldsChange={(changedFields, allFields) => {
//     const storeInfo = _.reduce(allFields,(obj,item) => {
//         _.set(obj, item.name.join('.'), item.value)
//         return obj
//       }, {})
//       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
//       return true
//     }}
},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'form-group mb-4 row align--items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('舊密碼','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('請輸入密碼!','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_24_libs_FormHelper__["a" /* genFormItemAtrribute */])('opw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a.Password,null)))),wp.element.createElement('div',{className:'form-group mb-4 row align--items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('新密碼','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('請輸入新密碼!','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_24_libs_FormHelper__["a" /* genFormItemAtrribute */])('npw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a.Password,null)))),wp.element.createElement('div',{className:'form-group mb-4 row align--items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('再次輸入','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_24_libs_FormHelper__["a" /* genFormItemAtrribute */])('npw_chk'),{dependencies:['npw'],rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('請輸入確認密碼!','cec-plugin-stores')},function(_ref2){var getFieldValue=_ref2.getFieldValue;return{validator:function validator(rule,value){if(!value||getFieldValue('npw')===value){return Promise.resolve();}return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('再次輸入密碼不同!','cec-plugin-stores'));}};}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a.Password,null)))))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確 性。客服中心：市話 0809-001-365 / 手機(02)8006-9999 ※ 由於促銷目錄為提前印製，故於 網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！ ※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores')))))),wp.element.createElement('div',{className:'text-center mt-5'},wp.element.createElement('a',{className:'h6 btn btn-outline-primary rounded-pill px-5 py-4',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this3.formRef.current.submit();}},Object(__WEBPACK_IMPORTED_MODULE_31__wordpress_i18n__["__"])('確定修改','cec-plugin-stores')))))));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPasswordEditor=function(_Component2){_inherits(UserPasswordEditor,_Component2);function UserPasswordEditor(){var _ref3;var _temp2,_this4,_ret2;_classCallCheck(this,UserPasswordEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref3=UserPasswordEditor.__proto__||Object.getPrototypeOf(UserPasswordEditor)).call.apply(_ref3,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserPasswordEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u8B8A\u66F4\u5BC6\u78BC\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPasswordEditor;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfileCC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPasswordCCEditor", function() { return UserPasswordCCEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Local=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'VC_CONFIG');// 前端頁面
var UserProfileCC=function(_Component){_inherits(UserProfileCC,_Component);function UserProfileCC(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfileCC);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfileCC.__proto__||Object.getPrototypeOf(UserProfileCC)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,memberVip:0,memberOpen:0,memberType:0,// 0: 一般會員; 1: VIP; 2: 一般會員 OP會員; 3: VIP OP會員
memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,openPoint:0,openPointDiscount:0,isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_14_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get($magicLine,0)){//console.log('kkk c', $magicLine)
__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_14_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this);//console.log('basic-tabs-label', $el)
leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_14_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_14_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.highlight').addClass('current_page_item');});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_17__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_16__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfiles',{},function(state,res){console.log('getProfiles','/api/account/cc/getProfiles',res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}console.log('getProfiles',data);_this.setState({memberVip:data.member_profile_isvip,memberOpen:data.member_profile_isopen,memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10),openPoint:data.member_open_value,openPointDiscount:parseInt(data.member_open_value,10),memberType:data.member_profile_isvip==0&&data.member_profile_isopen==0?0:data.member_profile_isvip==1&&data.member_profile_isopen==0?1:data.member_profile_isvip==0&&data.member_profile_isopen==1?2:data.member_profile_isvip==1&&data.member_profile_isopen==1?3:0});});},_this.LoadCC=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_17__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_16__configs_env__["b" /* API_HOST */]+'/api/account/cc/ccUri?type=changepwd',{},function(state,res){//console.log(state, res, info)
_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a['error']({message:'資料讀取失敗',description:reason});return _this.setState({messages:data.messages||{}});}//console.log(data)
_this.setState({ccUrl:data.uri});});},_this.getProfile=function(){_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_17__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_16__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a['error']({message:'資料讀取失敗',description:reason});return _this.setState({messages:data.messages||{}});}_this.setState({info:data});//console.log('getProfile',data)
});},_this.getIframeHeight=function(){var f=document.getElementById('iframe-pwd');f.style.height=f.contentWindow.document.body.scrollHeight+40+'px';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfileCC,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.LoadCC();__WEBPACK_IMPORTED_MODULE_15_libs_AppHelper__["a" /* default */].updateConfig();this.getMemberProfile();this.getProfile();//this.setState({ isFetchData: true},() => {this.reloadTab()})
this.setState({info:this.props.user},function(){_this2.reloadTab();});}},{key:'render',value:function render(){var _this3=this;var ccUrl=this.state.ccUrl;var ProfileInfo=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.info');var MemberVip=this.state.memberVip;var MemberOpen=this.state.memberOpen;// 新增用戶類型
var MemberType=this.state.memberType;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;var OpenPoint=this.state.openPoint;var OpenPointDiscount=this.state.openPointDiscount;var iframeHeight=this.state.iframeHeight;var memberCardImages={0:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-2025.png',// 一般會員
1:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png',// VIP
2:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-openpoint-2025.png',// 一般會員 OP會員
3:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png'// VIP OP會員
};return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),wp.element.createElement('b',{className:'fw-700'},ProfileInfo&&ProfileInfo.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}})))),wp.element.createElement('div',{'class':'col-lg-8 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',' ',MemberVip==0?wp.element.createElement('span',{style:{color:'#1E5BC6'}},'\u4E00\u822C\u6703\u54E1'):wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-vvip-2025.png',alt:'VIP',style:{width:'60px',height:'17px'}}),MemberOpen==1&&wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-openpoint-2025.png',alt:'uniopen',style:{width:'60px',height:'17px'}}))),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/cec-point-2025.png',alt:'\u7D05\u5229\u9EDE\u6578\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,' \u5143')))),wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/open-point-2025.svg',alt:'OPENPOINT\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'OPENPOINT\uFF1A',OpenPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',OpenPointDiscount,' \u5143'))))),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item  current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item  current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_18__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{align:'center'},ccUrl&&wp.element.createElement('iframe',{id:'iframe-pwd',title:'iframe-pwd'//src="https://ppr-online.uni-prosperity.com.tw/testaccount/member/profile?client_id=c4fhcruwmgh6vz7n0l&amp;nonce_str=%21QAZxdr5×tamp=1595570823&amp;sign=7f9868830fe95472bc4e0d8bc37e926c5bba1b8272fdde1911bb78b60ba7f2c8&amp;access_token=9c1956af-9451-422d-8845-b63393b91776&amp;redirect_uri=https%3A%2F%2Fcec.syscom.tw%2Fservice%2Fsso%2F&amp;lang=zh_TW"
,src:ccUrl,width:'75%',height:'600',scrolling:'no',frameborder:'no',onload:function onload(){return _this3.getIframeHeight();}}))));}}]);return UserProfileCC;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPasswordCCEditor=function(_Component2){_inherits(UserPasswordCCEditor,_Component2);function UserPasswordCCEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserPasswordCCEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserPasswordCCEditor.__proto__||Object.getPrototypeOf(UserPasswordCCEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserPasswordCCEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_15_libs_AppHelper__["a" /* default */].updateConfig();//console.log('kkk', this.props.attributes)
this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'props.app.options',{});//console.log('editor', this.props)
return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'CC\u66F4\u6539\u5BC6\u78BC'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPasswordCCEditor;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPaymentEditor", function() { return UserPaymentEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserPayment=function(_Component){_inherits(UserPayment,_Component);function UserPayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserPayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserPayment.__proto__||Object.getPrototypeOf(UserPayment)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this.state={query:{},listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],tableData_Detail:[],selectmonth:__WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true},_this.control=function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).on('show.bs.collapse','.tbody .order-detail-info',function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.order-detail-info').removeClass('show');//$(this).addClass('show');
});});},_this.clickgetdetail=function(){var ID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';console.log('555555555555555555',ID);_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/account/purchaseDetail',{pur_id:ID},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData_Detail:data.purchaseDetail,isLoading:false},function(){_this.refreshPicker();});});},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_9_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log('loadData',query);//const { query } = this.state;
var _page$page_size={page:1,page_size:'all'},page=_page$page_size.page,page_size=_page$page_size.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/account/purchaseList',{start_dt:query.start_dt,end_dt:query.end_dt},function(state,res){_this.setState({isLoadingData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}console.log(code,reason,data,res);_this.setState({tableData:data.purchases},function(){_this.refreshPicker();});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'area_id')};}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);_this.setState({isLoading:false},function(){_this.reloadTab();});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserPayment,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(lastDay).format('YYYY-MM-DD')// AppHelper.updateConfig()
};this.setState({query:query});this.setState({info:this.props.user},function(){_this2.reloadTab();});this.loadData(query);this.control();}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_13_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,query=_state.query,info=_state.info,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?[]:_state$tableData,_state$tableData_Deta=_state.tableData_Detail,tableData_Detail=_state$tableData_Deta===undefined?[]:_state$tableData_Deta;var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var tmpStr_area='',tmpResult_area='<option value="'+__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).format('YYYY年MM月')+'</option>';for(var i=0;i<5;i++){tmpStr_area='<option value="'+__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).subtract(1,'months').format('YYYY年MM月')+'</option>';tmpResult_area=tmpResult_area+tmpStr_area;firstDay=__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD');lastDay=__WEBPACK_IMPORTED_MODULE_7_moment___default()(lastDay).subtract(1,'months').format('YYYY-MM-DD');}__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#SelectMonth').html(tmpResult_area);this.refreshPicker();var tttttt=[{items:[{sku_amount:20,sku_id:381179,sku_name:'安心茶葉蛋',sku_price:null,sku_quantity:2}],payments:[{amount:20,payment_id:'24'}],pur_amount:20,pur_dt:'2020-05-13 17:56:00',pur_id:1302780146,pur_pos_amt:1035,pur_pos_pts:310718,pur_redeem_pts:0,pur_reward_pts:40,pur_store:'北投店',pur_type:'00'},{items:[{sku_amount:55,sku_id:7335249,sku_name:'1/4核桃吐司',sku_price:null,sku_quantity:1},{sku_amount:25,sku_id:500921,sku_name:'每朝健康綠無糖',sku_price:null,sku_quantity:1},{sku_amount:28,sku_id:6996733,sku_name:'1/4芝麻吐司',sku_price:null,sku_quantity:1}],payments:[{amount:108,payment_id:'24'}],pur_amount:108,pur_dt:'2020-05-12 16:19:00',pur_id:1302465840,pur_pos_amt:1035,pur_pos_pts:310502,pur_redeem_pts:0,pur_reward_pts:216,pur_store:'北投店',pur_type:'00'},{items:[{sku_amount:20,sku_id:381179,sku_name:'安心茶葉蛋',sku_price:null,sku_quantity:2}],payments:[{amount:20,payment_id:'24'}],pur_amount:20,pur_dt:'2020-05-13 17:56:00',pur_id:1302780155,pur_pos_amt:1035,pur_pos_pts:310718,pur_redeem_pts:0,pur_reward_pts:40,pur_store:'北投店',pur_type:'00'}];return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores')))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row justify-content-center'},wp.element.createElement('div',{className:'col-6 col-lg-9'},wp.element.createElement('h5',{className:'h4 text-navy text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('查詢月份','cec-plugin-stores'))))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-sm-4'},wp.element.createElement('select',{className:'form-select selectpicker',name:'SelectMonth',id:'SelectMonth',value:this.state.selectmonth,onChange:function onChange(e){query.start_dt=e.target.value;query.end_dt=__WEBPACK_IMPORTED_MODULE_7_moment___default()(e.target.value).endOf('month').format('YYYY-MM-DD');_this3.loadData(query);_this3.setState({selectmonth:e.target.value});}})),wp.element.createElement('div',{className:'col-sm-8'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-12 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5 p-lg-0'},wp.element.createElement('div',{className:'flex-table','data-theme':'success'},wp.element.createElement('div',{className:'thead'},wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('消費日期','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('分店名稱','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('交易型態','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('消費金額','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('紅利折抵','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('獲得點數','cec-plugin-stores')))),tableData.length==0&&wp.element.createElement('div',{className:'tbody'},wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('尚無任何消費記錄','cec-plugin-stores')))),tableData.map(function(v,idx){return wp.element.createElement('div',{className:'tbody'},wp.element.createElement('ul',{'class':'table-row order-detail-item','data-toggle':'collapse',href:'#order-detail-'+v.pur_id,role:'button','aria-expanded':'false','aria-controls':'#order-detail-'+v.pur_id,id:v.pur_id,onClick:function onClick(){return _this3.clickgetdetail(String(v.pur_id));}},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},v.pur_dt),wp.element.createElement('li',{'data-title':'\u5206\u5E97\u540D\u7A31'},v.pur_store&&v.pur_store,!v.pur_store&&Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('店外消費','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u4EA4\u6613\u578B\u614B'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('消費','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u91D1\u984D'},Local=='en_US'&&v.pur_amount&&'$'+v.pur_amount,Local=='zh_TW'&&v.pur_amount&&v.pur_amount+'\u5143'),wp.element.createElement('li',{'data-title':'\u6298\u62B5'},v.pur_redeem_pts&&v.pur_redeem_pts,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('點','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u7D2F\u7A4D\u9EDE\u6578'},v.pur_reward_pts&&v.pur_reward_pts,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('點','cec-plugin-stores'))),wp.element.createElement('div',{'class':'order-detail-info collapse',id:'order-detail-'+v.pur_id},wp.element.createElement('div',{'class':'card'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'card points-list'},wp.element.createElement('h5',{'class':'card-header'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('點數明細','cec-plugin-stores')),wp.element.createElement('div',{'class':'card-body py-0'},wp.element.createElement('ul',{'class':'list-unstyled'},wp.element.createElement('li',{'class':'d-flex align-items-center justify-content-between text-navy my-4'},wp.element.createElement('p',{'class':'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('本次交易扣除點數','cec-plugin-stores')),wp.element.createElement('p',{'class':'p text-right mb-0'},tableData_Detail.pur_redeem_pts&&tableData_Detail.pur_redeem_pts,' ','\u9EDE')),wp.element.createElement('li',{'class':'d-flex align-items-center justify-content-between text-navy my-4'},wp.element.createElement('p',{'class':'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('紅利點數可用餘額','cec-plugin-stores')),wp.element.createElement('p',{'class':'p text-right mb-0'},tableData_Detail.pur_pos_pts&&tableData_Detail.pur_pos_pts,' ','\u9EDE')),wp.element.createElement('li',{'class':'d-flex align-items-center justify-content-between text-navy my-4'},wp.element.createElement('p',{'class':'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('換算可折抵金額','cec-plugin-stores')),wp.element.createElement('p',{'class':'p text-right mb-0'},tableData_Detail.pur_pos_amt&&tableData_Detail.pur_pos_amt,' ','\u9EDE')),wp.element.createElement('li',{'class':'d-flex align-items-center justify-content-between text-navy my-4'},wp.element.createElement('p',{'class':'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('本次回饋點數總計','cec-plugin-stores')),wp.element.createElement('p',{'class':'p text-right mb-0'},tableData_Detail.pur_reward_pts&&tableData_Detail.pur_reward_pts,' ','\u9EDE'))))),wp.element.createElement('div',{'class':'card order-list'},wp.element.createElement('h5',{'class':'card-header'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('交易明細','cec-plugin-stores')),wp.element.createElement('div',{'class':'card-body p-0'},wp.element.createElement('div',{'class':'flex-table','data-theme':'light'},wp.element.createElement('div',{'class':'thead'},wp.element.createElement('ul',{'class':'table-row'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('品名','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('數量','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('金額','cec-plugin-stores')))),wp.element.createElement('div',{'class':'thead tbody'},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(tableData_Detail.items,function(item,idx){return wp.element.createElement('ul',{'class':'table-row'},wp.element.createElement('li',{'class':'text-lg-left','data-title':'\u54C1\u540D'},item.sku_name&&item.sku_name),wp.element.createElement('li',{'data-title':'\u6578\u91CF'},item.sku_quantity&&item.sku_quantity),wp.element.createElement('li',{'class':'text-lg-right','data-title':'\u91D1\u984D'},'$',item.sku_amount&&item.sku_amount));}),__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(tableData_Detail.payments,function(pay,idx){return wp.element.createElement('ul',{'class':'table-row'},wp.element.createElement('li',{'class':'text-lg-left d-none d-lg-block'},' '),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('小計','cec-plugin-stores')),wp.element.createElement('li',{'class':'text-lg-right','data-title':'\u91D1\u984D'},'$',pay.amount&&pay.amount));}),wp.element.createElement('ul',{'class':'table-row'},wp.element.createElement('li',{'class':'text-lg-left'},'\xA0'),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('實付','cec-plugin-stores')),wp.element.createElement('li',{'class':'text-lg-right'},'$',tableData_Detail.pur_amount&&tableData_Detail.pur_amount))))))))));})))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))))));}}]);return UserPayment;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPaymentEditor=function(_Component2){_inherits(UserPaymentEditor,_Component2);function UserPaymentEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserPaymentEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserPaymentEditor.__proto__||Object.getPrototypeOf(UserPaymentEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserPaymentEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u6D88\u8CBB\u8A18\u9304\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPaymentEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPointEditor", function() { return UserPointEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_9_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_7_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserPayment=function(_Component){_inherits(UserPayment,_Component);function UserPayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserPayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserPayment.__proto__||Object.getPrototypeOf(UserPayment)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef(),_this.state={query:{},listInfo:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],selectmonth:__WEBPACK_IMPORTED_MODULE_11_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_13_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_13_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log('loadData',query);//const { query } = this.state;
var _page$page_size={page:1,page_size:'all'},page=_page$page_size.page,page_size=_page$page_size.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_16__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_15__configs_env__["b" /* API_HOST */]+'/api/account/pointsDetail',{start_dt:query.start_dt,end_dt:query.end_dt},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}console.log(code,reason,data,res);_this.setState({tableData:data.pointsdetail},function(){_this.refreshPicker();});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(data,'area_id')};}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);_this.setState({isLoading:false},function(){_this.reloadTab();});},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_16__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_15__configs_env__["b" /* API_HOST */]+'/api/account/changePwd',info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.success('修改成功');});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_13_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.TransType=function(item){if(item=='BLC')return'點數結餘';else if(item=='ADJ')return'點數調整';else if(item=='RDM')return'紅利折抵';else if(item=='PUR')return'消費';else return'消費';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserPayment,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_11_moment___default()(lastDay).format('YYYY-MM-DD')// AppHelper.updateConfig()
};this.setState({query:query});this.setState({info:this.props.user},function(){_this2.reloadTab();});this.loadData(query);// AppHelper.updateUserInfo(() => {
//   this.setState({ isFetchData: false })
//   this.fillData(this.props.user)
// });
// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_17_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,query=_state.query,info=_state.info,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?[]:_state$tableData;var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var tmpStr_area='',tmpResult_area='<option value="'+__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).format('YYYY年MM月')+'</option>';for(var i=0;i<5;i++){tmpStr_area='<option value="'+__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).subtract(1,'months').format('YYYY年MM月')+'</option>';tmpResult_area=tmpResult_area+tmpStr_area;firstDay=__WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD');lastDay=__WEBPACK_IMPORTED_MODULE_11_moment___default()(lastDay).subtract(1,'months').format('YYYY-MM-DD');}console.log('option',tmpResult_area);__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#SelectMonth').html(tmpResult_area);this.refreshPicker();console.log('tableData',tableData);return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row justify-content-center'},wp.element.createElement('div',{className:'col-6 col-lg-9'},wp.element.createElement('h5',{className:'h4 text-navy text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('查詢月份','cec-plugin-stores'))))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-sm-4'},wp.element.createElement('select',{className:'form-select selectpicker',name:'SelectMonth',id:'SelectMonth',value:this.state.selectmonth,onChange:function onChange(e){query.start_dt=e.target.value;query.end_dt=__WEBPACK_IMPORTED_MODULE_11_moment___default()(e.target.value).endOf('month').format('YYYY-MM-DD');_this3.loadData(query);_this3.setState({selectmonth:e.target.value});console.log('1111',_this3.state.selectmonth);}})),wp.element.createElement('div',{className:'col-sm-8'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('網站僅提供六個月內點數記錄查詢, 若您對您的點數記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-12 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5 p-lg-0'},wp.element.createElement('div',{className:'flex-table','data-theme':'success'},wp.element.createElement('div',{className:'thead'},wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('消費日期','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('消費地點','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('交易型態','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('消費金額','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('紅利點數','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數折抵','cec-plugin-stores')))),wp.element.createElement('div',{className:'tbody'},tableData.length==0&&wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('尚無任何點數記錄','cec-plugin-stores'))),tableData.map(function(v){return wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},v.awd_dt&&v.awd_dt),wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u5730\u9EDE'},v.store_name&&v.store_name,!v.store_name&&Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('店外消費','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u4EA4\u6613\u578B\u614B'},v.trans_type&&_this3.TransType(v.trans_type)),wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u91D1\u984D'},Local=='en_US'&&v.trans_amt&&'$'+v.trans_amt,Local=='zh_TW'&&v.trans_amt&&v.trans_amt+'\u5143'),wp.element.createElement('li',{'data-title':'\u7D05\u5229\u9EDE\u6578'},v.earned_points&&v.earned_points,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u9EDE\u6578\u6298\u62B5'},v.burned_points&&v.burned_points,Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點','cec-plugin-stores')));}))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))))));}}]);return UserPayment;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPointEditor=function(_Component2){_inherits(UserPointEditor,_Component2);function UserPointEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserPointEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserPointEditor.__proto__||Object.getPrototypeOf(UserPointEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserPointEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u9EDE\u6578\u7D00\u9304\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPointEditor;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserInvoiceEditor", function() { return UserInvoiceEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var VC_CONFIG=window.VC_CONFIG;var Local=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_5_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserPoint=function(_Component){_inherits(UserPoint,_Component);function UserPoint(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserPoint);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserPoint.__proto__||Object.getPrototypeOf(UserPoint)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this.state={query:{},listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],selectmonth:__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log('loadData',query);//const { query } = this.state;
var _page$page_size={page:1,page_size:'all'},page=_page$page_size.page,page_size=_page$page_size.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_13__configs_env__["b" /* API_HOST */]+'/api/account/eInvoiceList',{start_dt:query.start_dt,end_dt:query.end_dt},function(state,res){_this.setState({isLoadingData:false});console.log('333333333333333333333333');var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);console.log('1111111111111111111',state);if(state===false){return console.log('55555555555555555555');}//this.setState({ message: '發生錯誤' }); }
if(code!==200){return console.log('66666666666666666666');}//this.setState({ message: reason }); }
console.log('eInvoiceList_data',data);_this.setState({tableData:data.einvoices},function(){_this.refreshPicker();});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(data,'area_id')};}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);_this.setState({isLoading:false},function(){_this.reloadTab();});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.wincode=function(num){var codeA='特別獎 1000萬';var codeB='千元獎 2000元';var codeC='百萬獎 100萬';var code=['特　獎 200萬','頭　獎 20萬','二　獎 <br> 4萬','三　獎 <br> 1萬','四　獎 4,000元','五　獎 1,000元','六　獎 200元'];if(num==='A'){return codeA||'??';}else if(num==='B'){return codeB||'??';}else if(num==='C'){return codeC||'??';}else{num=parseInt(num,10);return code[num]||'??';}},_this.nonwincode=function(date){if(date){var getDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()(date);var currDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()();if(__WEBPACK_IMPORTED_MODULE_9_moment___default()(getDate).isBefore(currDate)){var getDateMonth=getDate.format('M');var currDateMonth=currDate.format('M');var currDateDay=currDate.format('D');var diffMonth=Math.abs(currDateMonth-getDateMonth);if(currDateMonth>=7){//7-12月
if(diffMonth>2){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth>1){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}else{if(diffMonth>2&&diffMonth<10){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth<=1){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserPoint,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_9_moment___default()(lastDay).format('YYYY-MM-DD')// AppHelper.updateConfig()
};this.setState({query:query});this.setState({info:this.props.user},function(){_this2.reloadTab();});this.loadData(query);// AppHelper.updateUserInfo(() => {
//   this.setState({ isFetchData: false })
//   this.fillData(this.props.user)
// });
// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_15_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,query=_state.query,info=_state.info,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?[]:_state$tableData;var tmpstatus='';var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var tmpStr_area='',tmpResult_area='<option value="'+__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY年MM月')+'</option>';for(var i=0;i<5;i++){tmpStr_area='<option value="'+__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY年MM月')+'</option>';tmpResult_area=tmpResult_area+tmpStr_area;firstDay=__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD');lastDay=__WEBPACK_IMPORTED_MODULE_9_moment___default()(lastDay).subtract(1,'months').format('YYYY-MM-DD');}console.log('option',tmpResult_area);__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#SelectMonth').html(tmpResult_area);this.refreshPicker();return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票紀錄','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票紀錄','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row justify-content-center'},wp.element.createElement('div',{className:'col-6 col-lg-9'},wp.element.createElement('h5',{className:'h4 text-navy text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('查詢月份','cec-plugin-stores'))))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-sm-4'},wp.element.createElement('select',{className:'form-select selectpicker',name:'SelectMonth',id:'SelectMonth',value:this.state.selectmonth,onChange:function onChange(e){query.start_dt=e.target.value;query.end_dt=__WEBPACK_IMPORTED_MODULE_9_moment___default()(e.target.value).endOf('month').format('YYYY-MM-DD');_this3.loadData(query);_this3.setState({selectmonth:e.target.value});console.log('1111',_this3.state.selectmonth);}})),wp.element.createElement('div',{className:'col-sm-8'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-12 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5 p-lg-0'},wp.element.createElement('div',{className:'flex-table','data-theme':'success'},wp.element.createElement('div',{className:'thead'},wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('消費日期','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('發票號碼','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('是否列印發票','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('發票捐贈','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('是否中獎','cec-plugin-stores')))),wp.element.createElement('div',{className:'tbody'},tableData.length==0&&wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('尚無任何消費記錄','cec-plugin-stores'))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(tableData,function(v){return wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},v.inv_date),wp.element.createElement('li',{'data-title':'\u767C\u7968\u865F\u78BC'},v.inv_code),wp.element.createElement('li',{'data-title':'\u662F\u5426\u5217\u5370\u767C\u7968'},v.inv_type=='電子發票(有列印)'?Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('非歸戶發票','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票(無列印)','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u767C\u7968\u6350\u8D08'},v.don_fl==1?Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('捐贈','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('無','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u662F\u5426\u4E2D\u734E'},v.inv_win_flag==1&&v.inv_type==Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票(無列印)','cec-plugin-stores')&&_this3.wincode(v.inv_win_code),v.inv_win_flag==0&&v.inv_type==Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票(無列印)','cec-plugin-stores')&&_this3.nonwincode(v.inv_date),v.inv_type==Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票(有列印)','cec-plugin-stores')&&Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('非歸戶發票自行兌獎','cec-plugin-stores')));}))))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-6 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('h5',{'class':'h3 text-navy text-center mb-4'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('電子發票歸戶','cec-plugin-stores')),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-8 col-md-6 mx-auto'},wp.element.createElement('a',{'class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(e){__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.error({title:'Oops! 發票歸戶功能維修中',content:'即日至10/27，將暫停設定會員發票歸戶功能，造成不便敬請見諒。'});}},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('開始歸戶','cec-plugin-stores'))))))),wp.element.createElement('div',{'class':'col-lg-6 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 text-navy text-justify mb-0'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('由於財政部電子發票服務平台建議使用IE8.0以上的瀏覽 器來進行歸戶，因此建議您不要使用平板電腦來進行好 康卡及聯名卡的歸戶作業，感謝您的配合，謝謝！','cec-plugin-stores')))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))))));}}]);return UserPoint;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserInvoiceEditor=function(_Component2){_inherits(UserInvoiceEditor,_Component2);function UserInvoiceEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserInvoiceEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserInvoiceEditor.__proto__||Object.getPrototypeOf(UserInvoiceEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserInvoiceEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-users-invoice-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u9EDE\u6578\u8A18\u9304\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserInvoiceEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserInvoiceCarrierConsolidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserInvoiceCarrierConsolidationEditor", function() { return UserInvoiceCarrierConsolidationEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=window.VC_CONFIG;var Local=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a.Option;// 前端頁面
var UserInvoiceCarrierConsolidation=function(_Component){_inherits(UserInvoiceCarrierConsolidation,_Component);function UserInvoiceCarrierConsolidation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserInvoiceCarrierConsolidation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserInvoiceCarrierConsolidation.__proto__||Object.getPrototypeOf(UserInvoiceCarrierConsolidation)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef(),_this.state={selectedCard:'',card_type:null,cardOptions:[],query:{},listInfo:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.cloneDeep(defaultListInfo),memberVip:0,memberOpen:0,memberType:0,// 0: 一般會員; 1: VIP; 2: 一般會員 OP會員; 3: VIP OP會員
memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,openPoint:0,openPointDiscount:0,tableData:[],selectmonth:__WEBPACK_IMPORTED_MODULE_15_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true,cardNumbersList:Array(4).fill('')},_this.focusCreditCardInput=function(e){if(/^\d*$/.test(e.target.value)){var currentInput=e.target.value;var maxLength=4;var newArray=[].concat(_toConsumableArray(_this.state.cardNumbersList));switch(e.target.id){case'credit-card-input-1':currentInput.length===maxLength&&document.querySelector('#credit-card-input-2').focus();_this.setState({cardNumbersList:newArray.fill(currentInput,0,1)});break;case'credit-card-input-2':currentInput.length===maxLength&&document.querySelector('#credit-card-input-3').focus();_this.setState({cardNumbersList:newArray.fill(currentInput,1,2)});break;case'credit-card-input-3':currentInput.length===maxLength&&document.querySelector('#credit-card-input-4').focus();_this.setState({cardNumbersList:newArray.fill(currentInput,2,3)});break;case'credit-card-input-4':_this.setState({cardNumbersList:newArray.fill(currentInput,3,4)});break;default:break;}}},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_17_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_17_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadHKCards=function(){var _page$page_size={page:1,page_size:'all'},page=_page$page_size.page,page_size=_page$page_size.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/oca/getCCEInvoiceCarrierList',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false){return console.log('55555555555555555555');}//this.setState({ message: '發生錯誤' }); }
if(code!==200){return console.log('66666666666666666666');}//this.setState({ message: reason }); }
console.log('getEInvoiceCarrierList',data);_this.setState({cardOptions:data});});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfiles',{},function(state,res){console.log('getProfiles','/api/account/cc/getProfiles',res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}console.log('getProfiles',data);_this.setState({memberVip:data.member_profile_isvip,memberOpen:data.member_profile_isopen,memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10),openPoint:data.member_open_value,openPointDiscount:parseInt(data.member_open_value,10),memberType:data.member_profile_isvip==0&&data.member_profile_isopen==0?0:data.member_profile_isvip==1&&data.member_profile_isopen==0?1:data.member_profile_isvip==0&&data.member_profile_isopen==1?2:data.member_profile_isvip==1&&data.member_profile_isopen==1?3:0});});},_this.submitData=function(){var cardNumbersList=_this.state.cardNumbersList;_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/oca/getEInvoiceCarrierConsolidationData',{card:_this.state.selectedCard==='null'?cardNumbersList[0]+cardNumbersList[1]+cardNumbersList[2]+cardNumbersList[3]:_this.state.selectedCard,type:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(_this,'state.card_type')},function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_9_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_notification___default.a['error']({message:'發生錯誤',description:reason});return _this.setState({messages:data.messages||{}});}// 發送post給財政部
__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.destroyAll();__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal___default.a.confirm({title:'即將離開本網站，前往財政部電子發票歸戶平台',cancelText:'取消',okText:'離開本網站，並進行發票歸戶',onCancel:null,onOk:function onOk(){var form=document.createElement('form');form.setAttribute('method','post');form.setAttribute('action',__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(data,'url'));form.setAttribute('target','view');__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.forEach(data,function(v,k){console.log(k+'='+v);var input=document.createElement('input');input.type='hidden';input.name=k;input.value=v;form.appendChild(input);});document.body.appendChild(form);window.open('','view');form.submit();}});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_17_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.wincode=function(num){var codeA='特別獎 1000萬';var codeB='千元獎 2000元';var codeC='百萬獎 100萬';var code=['特　獎 200萬','頭　獎 20萬','二　獎 <br> 4萬','三　獎 <br> 1萬','四　獎 4,000元','五　獎 1,000元','六　獎 200元'];if(num==='A'){return codeA||'??';}else if(num==='B'){return codeB||'??';}else if(num==='C'){return codeC||'??';}else{num=parseInt(num,10);return code[num]||'??';}},_this.nonwincode=function(date){if(date){var getDate=__WEBPACK_IMPORTED_MODULE_15_moment___default()(date);var currDate=__WEBPACK_IMPORTED_MODULE_15_moment___default()();if(__WEBPACK_IMPORTED_MODULE_15_moment___default()(getDate).isBefore(currDate)){var getDateMonth=getDate.format('M');var currDateMonth=currDate.format('M');var currDateDay=currDate.format('D');var diffMonth=Math.abs(currDateMonth-getDateMonth);if(currDateMonth>=7){//7-12月
if(diffMonth>2){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth>1){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}else{if(diffMonth>2&&diffMonth<10){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth<=1){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'未中獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserInvoiceCarrierConsolidation,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.getMemberProfile();this.loadHKCards();this.setState({info:this.props.user},function(){_this2.reloadTab();});}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_21_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,cardOptions=_state.cardOptions,_state$info=_state.info,info=_state$info===undefined?[]:_state$info,cardNumbersList=_state.cardNumbersList,selectedCard=_state.selectedCard;var MemberVip=this.state.memberVip;var MemberOpen=this.state.memberOpen;// 新增用戶類型
var MemberType=this.state.memberType;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;var OpenPoint=this.state.openPoint;var OpenPointDiscount=this.state.openPointDiscount;var memberCardImages={0:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-2025.png',// 一般會員
1:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png',// VIP
2:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-openpoint-2025.png',// 一般會員 OP會員
3:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png'// VIP OP會員
};var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var tmpStr_area='',tmpResult_area='<option value="'+__WEBPACK_IMPORTED_MODULE_15_moment___default()(firstDay).format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_15_moment___default()(firstDay).format('YYYY年MM月')+'</option>';for(var i=0;i<5;i++){tmpStr_area='<option value="'+__WEBPACK_IMPORTED_MODULE_15_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD')+'">'+__WEBPACK_IMPORTED_MODULE_15_moment___default()(firstDay).subtract(1,'months').format('YYYY年MM月')+'</option>';tmpResult_area=tmpResult_area+tmpStr_area;firstDay=__WEBPACK_IMPORTED_MODULE_15_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD');lastDay=__WEBPACK_IMPORTED_MODULE_15_moment___default()(lastDay).subtract(1,'months').format('YYYY-MM-DD');}__WEBPACK_IMPORTED_MODULE_17_jquery___default()('#SelectMonth').html(tmpResult_area);this.refreshPicker();var currentCard=cardOptions.find(function(item){return String(item.id)===_this3.state.selectedCard;})||{};var selectedTypeName=currentCard.typeName;return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('電子發票紀錄','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('電子發票紀錄','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}})))),wp.element.createElement('div',{'class':'col-lg-8 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',' ',MemberVip==0?wp.element.createElement('span',{style:{color:'#1E5BC6'}},'\u4E00\u822C\u6703\u54E1'):wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-vvip-2025.png',alt:'VIP',style:{width:'60px',height:'17px'}}),MemberOpen==1&&wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/tag-openpoint-2025.png',alt:'uniopen',style:{width:'60px',height:'17px'}}))),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/cec-point-2025.png',alt:'\u7D05\u5229\u9EDE\u6578\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,' \u5143')))),wp.element.createElement('div',{'class':'col-md-6 my-2'},wp.element.createElement('div',{'class':'card border-0 shadow-sm',style:{background:'#EBEBEB'}},wp.element.createElement('div',{'class':'card-body text-center'},wp.element.createElement('div',{div:true,className:'mb-3 d-flex justify-content-center'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/open-point-2025.svg',alt:'OPENPOINT\u5716\u793A',style:{width:'24px',height:'24px'}})),wp.element.createElement('p',{'class':'h4 text-navy'},'OPENPOINT\uFF1A',OpenPoint,' \u9EDE'),wp.element.createElement('p',{'class':'h6 text-success'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',OpenPointDiscount,' \u5143'))))),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link ',href:'#'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link ',href:'#'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'shadow-0 rounded-10 mb-4'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('h4',{className:'heading-title align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('會員卡歸戶','cec-plugin-stores')),wp.element.createElement('hr',{className:'border-top border-gray mt-0 mb-5'}),wp.element.createElement('div',{className:'row align-items-center justify-content-center'},wp.element.createElement('div',{className:'col-md-6 mb-5 mb-md-0'},wp.element.createElement('div',{className:'row mb-4'},wp.element.createElement('div',{className:'col-7 mx-auto'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/credit_card2.svg',alt:''})))),wp.element.createElement('div',{className:'col-md-6'},wp.element.createElement('div',{className:'row mb-4'},wp.element.createElement('div',{className:'col-9 col-md-8 mx-auto'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_22_libs_FormHelper__["a" /* genFormItemAtrribute */])('card'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select___default.a,{placeholder:'\u9078\u64C7\u6703\u54E1\u5361',onChange:function onChange(card){var temCard=card.split('_');_this3.setState({selectedCard:temCard[0],card_type:temCard[1],cardNumbersList:Array(4).fill('')});}},__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.map(cardOptions,function(item){return wp.element.createElement(Option,{value:item.id+'_'+item.type},item.id.slice(0,7)+'******'+item.id.slice(13));}))),selectedTypeName==='聯名卡'&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input-outer']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input-inner']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{id:'credit-card-input-1',className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input'],maxLength:4,value:cardNumbersList[0],onChange:this.focusCreditCardInput}),'-',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{id:'credit-card-input-2',className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input'],maxLength:4,value:cardNumbersList[1],onChange:this.focusCreditCardInput}),'-',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{id:'credit-card-input-3',className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input'],maxLength:4,value:cardNumbersList[2],onChange:this.focusCreditCardInput}),'-',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{id:'credit-card-input-4',className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['credit-card-input'],maxLength:4,value:cardNumbersList[3],onChange:this.focusCreditCardInput})))))),wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-9 col-md-8 mx-auto'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{className:__WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default.a['submit-btn'],disabled:selectedCard==='null'&&cardNumbersList.join('').length!==16,onClick:function onClick(e){// Modal.warning({
//   title: '發票歸戶功能維修中',
//   content:
//     '目前電子發票作業系統維護中，歸戶功能暫停使用，我們將會儘快修復，造成不便盼您諒解。',
// });
e.preventDefault();_this3.submitData();}},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('開始歸戶','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},'\u6CE8\u610F\u4E8B\u9805')))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy mb-4'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('．自2025年9月16日起，會員名下之會員卡(包括實體好康卡及數位好康卡)，將統一整合至會員名下之GID開頭會員卡號, 當會員持名下任一會員卡號消費, 使用電子發票存於會員載具時, 會員載具皆會存於GID開頭之會員卡號。會員需重新選擇此組GID會員卡號進行歸戶。 此外，查詢電子發票交易時，需依據已歸戶的GID會員卡進行查詢。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy mb-4'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('．如您已於APP進行升級認證為uniopen會員，您的GID會員卡號將會整合為uniopen會員卡號。請您務必重新選擇此組GID會員卡號進行歸戶。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('．若進行歸戶作業將會使您離開網站，前往財政部電子發票平台，所有財政部電子發票平台，提供之網站及其內容（包括客戶隱私權及資訊安全）不屬於網站控制及責任範圍之內。','cec-plugin-stores'))))))))));}}]);return UserInvoiceCarrierConsolidation;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserInvoiceCarrierConsolidationEditor=function(_Component2){_inherits(UserInvoiceCarrierConsolidationEditor,_Component2);function UserInvoiceCarrierConsolidationEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserInvoiceCarrierConsolidationEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserInvoiceCarrierConsolidationEditor.__proto__||Object.getPrototypeOf(UserInvoiceCarrierConsolidationEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserInvoiceCarrierConsolidationEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-users-invoice-editor'},wp.element.createElement('h2',null,'OCA\u767C\u7968\u6B78\u6236'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserInvoiceCarrierConsolidationEditor;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserConnectEditor", function() { return UserConnectEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_google_login__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_google_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_google_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__ = __webpack_require__(21);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FB=window.FB;var gapi=window.gapi;var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserPoint=function(_Component){_inherits(UserPoint,_Component);function UserPoint(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserPoint);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserPoint.__proto__||Object.getPrototypeOf(UserPoint)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_18_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],visible:false,confirmLoading:false,pw:null,openid:null,sp_code:null,isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadAccountGroup=function(){var callback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var query=__WEBPACK_IMPORTED_MODULE_25_libs_AppHelper__["a" /* default */].getHashParamaters();_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_26__configs_env__["b" /* API_HOST */]+'/api/account/getAccountGroup',{},function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warning(reason);//this.props.history.replace("/brands")
return;}console.log('getAccountGroup',data);_this.setState({tableData:data},function(){if(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isFunction(callback))callback();});});},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_26__configs_env__["b" /* API_HOST */]+'/api/account/eInvoiceList',{start_dt:__WEBPACK_IMPORTED_MODULE_19_moment___default()().subtract(1,'months').format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_19_moment___default()().format('YYYY-MM-DD')},function(state,res){_this.setState({isLoadingData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(data,'area_id')};}console.log(data);_this.formRef.current.setFieldsValue(data);_this.setState({isLoading:false},function(){_this.reloadTab();});},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};info.spcode='C4';console.log('submitData',info);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_26__configs_env__["b" /* API_HOST */]+'/api/account/accountGroup',info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['error']({message:'連結失敗',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.success('連結成功');});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserPoint,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_25_libs_AppHelper__["a" /* default */].updateConfig();this.setState({isFetchData:true,info:this.props.user},function(){_this2.reloadTab();});//AppHelper.getAccountGroup(() => {
//  this.setState({ isFetchData: false })
//this.fillData(this.props.user)
//});
this.loadAccountGroup(connect);this.setState({info:this.props.user});//this.loadData();
// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_28_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,info=_state.info,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?[]:_state$tableData;var account=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'state.tableData.accounts',[]);var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var test_account=[{login:'kktry.iie98g@g2.nctu.edu.tw',sp_code:'C4'},/*{
        "openid": "1234",
        "sp_code": "GG"
    },
    {
        "openid": "123",
        "sp_code": "LI"
    },*/{openid:'123',sp_code:'FB'}];this.refreshPicker();return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{'class':'pt-0'},wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/loyaltyprofile-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{id:'container','class':'container'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('第三方驗證登入更快速，您可以在此將您的帳號與其他社群登入帳號做連結，設定完成後即可以用Facebook/Google/LINE帳號登入會員帳號囉。')),wp.element.createElement('div',{className:'justify-content-center'},!tableData.gid&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a,{id:'spin'},wp.element.createElement('div',{'class':'row justify-content-center',style:{minHeight:200}}))),tableData.gid&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-md-6 col-lg-3 px-3 mb-4'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'},__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='C4';})&&__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.filter(account,function(item){return item.sp_code=='C4';}).map(function(item){return wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/logo/logo-icon.svg',alt:'\u5E33\u865F'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('帳號','cec-plugin-stores')),wp.element.createElement('p',{id:'C4-connected','class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已綁定','cec-plugin-stores'))),wp.element.createElement('p',{'class':'h6 text-primary text-center btn btn-block rounded-pill py-4'},item.login),wp.element.createElement('a',{'class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('修改密碼','cec-plugin-stores')));}),!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='C4';})&&wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/logo/logo-icon.svg',alt:'\u5E33\u865F'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('帳號','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('尚未綁定','cec-plugin-stores'))),wp.element.createElement('a',{id:'C4_connect','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行連結','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,id:'C4_Form',name:'basic',style:{display:'none'},layout:'vertical',onFinish:function onFinish(values){return _this3.submitData(values);}//onValuesChange={(changedFields, allFields) => {
//  console.log('onValuesChange:', changedFields, allFields)
//}}
},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入您的帳號','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('login')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{placeholder:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入您的帳號','cec-plugin-stores'),className:'form-control'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('pw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.Password,{placeholder:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores'),className:'form-control'})),wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this3.formRef.current.submit();}},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('確認','cec-plugin-stores')))))),wp.element.createElement('div',{'class':'col-md-6 col-lg-3 px-3 mb-4'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'},__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='FB';})&&__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.filter(account,function(item){return item.sp_code=='FB';}).map(function(item){return wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'icon-facebook'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('Facebook 登入','cec-plugin-stores')),wp.element.createElement('p',{id:'FB-connected','class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已綁定','cec-plugin-stores'))),wp.element.createElement('p',{'class':'h6 text-primary text-center btn btn-block rounded-pill py-4'},item.openid));}),!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='FB';})&&wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'icon-facebook'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('Facebook 登入','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('尚未綁定','cec-plugin-stores'))),wp.element.createElement('a',{id:'FB_connect','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行連結','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,id:'FB_Form',name:'basic',style:{display:'none'},layout:'vertical'//onFinish={values => console.log(values.FBpw) }
},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('因連結外部帳號，請您再次輸入您的密碼!','cec-plugin-stores'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({id:'FBpwForm',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('FBpw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.Password,{name:'FBpwd',placeholder:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores'),className:'form-control'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{id:'FBgetBind',type:'primary',htmlType:'submit','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('確認','cec-plugin-stores'))))))),wp.element.createElement('div',{'class':'col-md-6 col-lg-3 px-3 mb-4'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'},__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='GG';})&&__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.filter(account,function(item){return item.sp_code=='GG';}).map(function(item){return wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'fab fa-google-plus-g'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('Google+ 登入','cec-plugin-stores')),wp.element.createElement('p',{id:'GG-connected','class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已綁定','cec-plugin-stores'))),wp.element.createElement('p',{'class':'h6 text-primary text-center btn btn-block rounded-pill py-4'},item.openid));}),!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='GG';})&&wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'fab fa-google-plus-g'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('Google+ 登入','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('尚未綁定','cec-plugin-stores'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_react_google_login__["GoogleLogin"],{clientId:'260812646328-b62s7lbkc6s51qve5kd7f0krf3pjf4rb.apps.googleusercontent.com',render:function render(renderProps){return wp.element.createElement('button',{id:'GG_connect',disabled:renderProps.disabled,'class':'h6 btn btn-block btn-outline-primary rounded-pill py-4'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行連結','cec-plugin-stores'));},buttonText:'Login',onSuccess:function onSuccess(response){console.log(response);},onFailure:function onFailure(response){console.log(response);},cookiePolicy:'single_host_origin'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,id:'GG_Form',name:'basic',style:{display:'none'},layout:'vertical'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('因連結外部帳號，請您再次輸入您的密碼!','cec-plugin-stores'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({id:'GGpwForm',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('GGpw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.Password,{name:'GGpwd',placeholder:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores'),className:'form-control'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{id:'GGgetBind',type:'primary',htmlType:'submit','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('確認','cec-plugin-stores'))))))),wp.element.createElement('div',{'class':'col-md-6 col-lg-3 px-3 mb-4'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 h-100 rounded-20'},__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='LI';})&&__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.filter(account,function(item){return item.sp_code=='LI';}).map(function(item){return wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'icon-line'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('LINE 登入','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已綁定','cec-plugin-stores'))),wp.element.createElement('p',{'class':'h6 text-primary text-center btn btn-block rounded-pill py-4'},item.openid));}),!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(account,function(o){return o.sp_code=='LI';})&&wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'icon-circle-block mx-auto mb-3'},wp.element.createElement('i',{'class':'icon-line'})),wp.element.createElement('h5',{'class':'h5 text-navy text-center mb-2'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('LINE 登入','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-font text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('尚未綁定','cec-plugin-stores'))),wp.element.createElement('a',{id:'LI_connect','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行連結','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,id:'LI_Form',name:'basic',style:{display:'none'},layout:'vertical'//onFinish={values => console.log(values.LIpw) }
},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('因連結外部帳號，請您再次輸入您的密碼!','cec-plugin-stores'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({id:'LIpwForm',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('LIpw')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.Password,{name:'LIpwd',placeholder:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('請輸入密碼','cec-plugin-stores'),className:'form-control'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{id:'LIgetBind',type:'primary',htmlType:'submit','class':'h6 btn btn-block btn-outline-primary rounded-pill py-4'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('確認','cec-plugin-stores')))))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))))));}}]);return UserPoint;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserConnectEditor=function(_Component2){_inherits(UserConnectEditor,_Component2);function UserConnectEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserConnectEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserConnectEditor.__proto__||Object.getPrototypeOf(UserConnectEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_18_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserConnectEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_25_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-users-connect-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u95DC\u806F\u5E33\u865F\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserConnectEditor;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);var connect=function connect(){console.log('Container-Bind');var getUrlString=window.location.href;var url=new URL(getUrlString);if(url.searchParams.get('code')&&url.searchParams.get('state')=='LI'){// 轉換編碼
var parseJwt=function parseJwt(token){var base64Url=token.split('.')[1];var base64=base64Url.replace('-','+').replace('_','/');return JSON.parse(window.atob(base64));};var data={grant_typ:'authorization_code',code:url.searchParams.get('code'),//redirect_uri: 'http://localhost:8080/cec/connect',
//client_id: '1654222822',
//client_secret: '0bc2d82037c9794636215114c0263033'
redirect_uri:'https://cec.syscom.tw/connect',client_id:'1630186793',client_secret:'e08bc2fa98afdab36927fcf9d3898c05'};var postData='grant_type='+data.grant_typ+'&code='+data.code+'&redirect_uri='+data.redirect_uri+'&client_id='+data.client_id+'&client_secret='+data.client_secret;console.log('LINE-qs.data',postData);var config={headers:{'Content-Type':'application/x-www-form-urlencoded'}};__WEBPACK_IMPORTED_MODULE_24_axios___default.a.post('https://api.line.me/oauth2/v2.1/token',postData,config).then(function(result){var tmpIdToken=result.data.id_token;console.log('LINE-result',tmpIdToken);var tmpSub=parseJwt(tmpIdToken).sub;console.log('LINE-result111111',tmpSub);bindAccount('LI',tmpSub);}).catch(function(err){console.log('LINE-ERROR',err);});}//bindAccount
function bindAccount(spcode,openid){console.log('bindAccount',spcode,openid);var C4Account=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#C4-connected').html();var tmppwd=null;console.log('bindAccount-C4Account',C4Account);if(C4Account){console.log('bindAccount-C4AccountC4Account');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'_connect').attr('style','display:none');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'_Form').show();__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'getBind').click(function(){if(spcode=='FB'){tmppwd=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'_Form').find('input[name="FBpwd"]').val();}else if(spcode=='GG'){tmppwd=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'_Form').find('input[name="GGpwd"]').val();}else if(spcode=='LI'){tmppwd=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#'+spcode+'_Form').find('input[name="LIpwd"]').val();}//結果
console.log('bindAccount',spcode,openid,tmppwd);console.log('bindAccount1111111111111111111',__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#C4-connected').html());__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_26__configs_env__["b" /* API_HOST */]+'/api/account/accountGroup',{spcode:spcode,openid:openid,pw:tmppwd},function(state,res){console.log(state,res);var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'));}if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('連結失敗','cec-plugin-stores'),description:reason});return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('連結失敗','cec-plugin-stores'));}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.success({title:'Good job！',content:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('恭喜您成功連結帳號，之後您亦可用已連結的帳號登入。','cec-plugin-stores')});window.location.href=VC_CONFIG.INDEX_URL+'/connect';});});}else{console.log('bindAccount-else');__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_26__configs_env__["b" /* API_HOST */]+'/api/account/accountGroup',{spcode:spcode,openid:openid},function(state,res){console.log(state,res);var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'));}if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('連結失敗','cec-plugin-stores'),description:reason});return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error(Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('連結失敗','cec-plugin-stores'));}__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.success({title:'Good job！',content:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('恭喜您成功連結帳號，之後您亦可用已連結的帳號登入。','cec-plugin-stores')});window.location.href=VC_CONFIG.INDEX_URL+'/connect';});}}//C4
__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).on('click','#C4_connect',function(){console.log('jQuery',__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this));__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this).attr('style','display:none');console.log('jQuery',__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#C4_Form'));__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#C4_Form').show();})//Facebook
;(function(d,s,id){console.log('Facebookfunctionfunction');var js,fjs=d.getElementsByTagName(s)[0];if(d.getElementById(id)){return;}js=d.createElement(s);js.id=id;js.src='https://connect.facebook.net/zh_TW/sdk.js';js.integrity="sha384-tGX9ELjlGPfAjLclS6ecSCLOYvJv8fPBjbWdPdsWANwE4VxBwBPmhPqBnqFsuT0Y";js.crossOrigin='anonymous';js.onerror=function(e){console.error('FB SDK 載入失敗（可能 SRI/CORS）',e);};fjs.parentNode.insertBefore(js,fjs);})(document,'script','facebook-jssdk');__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).on('click','#FB_connect',function(){console.log('jQuery-FB_click');window.fbAsyncInit=function(){console.log('fbAsyncInit');FB.init({appId:'826182204185577',cookie:true,xfbml:true,version:'v7.0'});FB.AppEvents.logPageView();};FB.init({appId:'826182204185577',cookie:true,xfbml:true,version:'v7.0'});FB.AppEvents.logPageView();FB.logout(function(response){// Person is now logged out
console.log('jQuery-FB_logout111',response);});FB.login(function(response){//檢查臉書登入狀態
console.log('jQuery-FB_55555');//如果已經有授權過應用程式
if(response.status==='connected'){console.log('jQuery-FB11',response);var userId=response.authResponse.userID;console.log('jQuery-FB-userId',userId);bindAccount('FB',userId);//這邊就可以判斷取得資料跟網站使用者資料是否一致
}else{//沒授權過應用程式
//呼叫FB.login()請求使用者授權
FB.login(function(response){if(response.status==='connected'){var userId=response.authResponse.userID;bindAccount('FB',userId);}else{__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.error({title:'Facebook尚未登入成功！'});}});}FB.logout(function(response){// Person is now logged out
console.log('jQuery-FB_logout2222',response);});});});//Google
__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).on('click','#GG_connect',function(){console.log('jQuery-GG_click');var script=document.createElement('script');script.src='https://apis.google.com/js/api.js';document.body.appendChild(script);var Google_appId='260812646328-b62s7lbkc6s51qve5kd7f0krf3pjf4rb.apps.googleusercontent.com';script.onload=function(){console.log('jQuery-GG_click22');gapi.load('client:auth2',{callback:function callback(){// Initialize client & auth libraries
console.log('jQuery-GG_click33');gapi.client.init({clientId:Google_appId//scope: 'https://www.googleapis.com/auth/userinfo.profile'
}).then(function(success){// Google Libraries are initialized successfully
// You can now make API calls
console.log('Google Libraries are initialized successfully');gapi.auth2.getAuthInstance().signIn().then(function(success){// Login API call is successful
var profile=success.getId();console.log('GG',success.Ca);console.log('GG',success);bindAccount('GG',profile);},function(error){// Error occurred
// console.log(error) to find the reason
console.log(error);});},function(error){// Error occurred
console.log(error);// to find the reason
});},onerror:function onerror(){// Failed to load libraries
console.log('Failed to load libraries');}});};});//LINE
__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).on('click','#LI_connect',function(){var URL='https://access.line.me/oauth2/v2.1/authorize?';URL+='response_type=code';//URL += '&client_id=1654222822';
URL+='&client_id=1630186793';//URL += '&redirect_uri=http://localhost:8080/cec/connect';
URL+='&redirect_uri=https://cec.syscom.tw/connect';URL+='&state=LI';URL+='&scope=openid%20profile';window.location.href=URL;});};

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserBigPlatformProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserBigPlatformProcessEditor", function() { return UserBigPlatformProcessEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(window,'VC_CONFIG',{});/**
 * 大平台載具歸戶 - 處理頁面 (Process)
 * 
 * 此頁面接收 PHP (init.php) 驗證後的 redirect，處理後續流程：
 * - 成功: ?token=xxx&ban=xxx&verified=1 → 保存 token → 檢查登入 → 導向
 * - 失敗: ?error=xxx → 顯示錯誤訊息
 */var UserBigPlatformProcess=function(_Component){_inherits(UserBigPlatformProcess,_Component);function UserBigPlatformProcess(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserBigPlatformProcess);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserBigPlatformProcess.__proto__||Object.getPrototypeOf(UserBigPlatformProcess)).call.apply(_ref,[this].concat(args))),_this),_this.state={isProcessing:false,errorMessage:null},_this.getParameterByName=function(name,url){if(!url)url=window.location.href;name=name.replace(/[\[\]]/g,'\\$&');var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)');var results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));},_this.handleVerifiedCallback=function(token,ban){console.log('處理驗證成功回調:',{token:token,ban:ban});// 保存 token 到 localStorage
__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].setLocalStorage('big-platform-token',token);__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].setLocalStorage('big-platform-ban',ban);console.log('Token 已保存至 storage');// 檢查用戶登入狀態
_this.checkLoginStatus();},_this.checkLoginStatus=function(){var authorization=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(_this.props,'auth.authorization');var isLogin=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(_this.props,'auth.isLogin',false);console.log('檢查登入狀態:',{isLogin:isLogin,hasAuth:!!authorization});if(!isLogin||!authorization){// 未登入，保存目標頁面並導向登入
_this.redirectToLogin();}else{// 已登入，直接導向載具綁定頁
_this.redirectToCarrierBinding();}},_this.redirectToLogin=function(){// 保存目標頁面路徑，登入後會導回來
__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].setLocalStorage('to-href','/carrier-binding');__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].setLocalStorage('from-big-platform','true');__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a.info({message:Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('請先登入','cec-plugin-stores'),description:Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('載具歸戶需要登入會員帳號','cec-plugin-stores'),duration:2});// 延遲導向，讓用戶看到提示訊息
setTimeout(function(){// 取得 CC 登入 URL
_this.getCCLoginUri();},1500);},_this.getCCLoginUri=function(){__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/account/cc/login',{},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){return _this.showErrorAndRedirect(Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'));}console.log('導向 CC 登入頁:',data.uri);window.location.href=data.uri;});},_this.redirectToCarrierBinding=function(){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a.success({message:Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('驗證成功','cec-plugin-stores'),description:Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('即將前往載具綁定頁面','cec-plugin-stores'),duration:1});setTimeout(function(){window.location.href=VC_CONFIG.INDEX_URL+'/carrier-binding';},1000);},_this.showErrorAndRedirect=function(message){_this.setState({isProcessing:false});__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('載具歸戶失敗','cec-plugin-stores'),content:message,onOk:function onOk(){// 清除相關 storage
__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-token');__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-ban');__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].removeLocalStorage('from-big-platform');window.location.href=VC_CONFIG.INDEX_URL;}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserBigPlatformProcess,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// 檢查是否有錯誤參數
var error=this.getParameterByName('error');if(error){return this.showErrorAndRedirect(decodeURIComponent(error));}// 檢查驗證成功參數
var verified=this.getParameterByName('verified');var token=this.getParameterByName('token');var ban=this.getParameterByName('ban');if(verified==='1'&&token&&ban){this.setState({isProcessing:true},function(){_this2.handleVerifiedCallback(token,ban);});}else{// 無效的訪問
this.showErrorAndRedirect(Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('無效的頁面訪問，請從正確管道進行載具歸戶。','cec-plugin-stores'));}}/**
   * 從 URL 取得參數
   *//**
   * 處理驗證成功的回調
   * PHP 已完成 API 驗證，這裡只需保存 token 並檢查登入狀態
   *//**
   * 檢查用戶登入狀態
   *//**
   * 導向登入頁面
   *//**
   * 取得 CC 登入 URL
   *//**
   * 導向載具綁定頁面
   *//**
   * 顯示錯誤訊息並導回首頁
   */},{key:'render',value:function render(){var isProcessing=this.state.isProcessing;return wp.element.createElement('div',{style:{height:'350px'},className:'jumbotron d-flex align-items-center'},wp.element.createElement('div',{className:'container text-center'},isProcessing?wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,{size:'large'}),wp.element.createElement('h4',{className:'mt-4'},Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('正在處理載具歸戶請求...','cec-plugin-stores')),wp.element.createElement('p',{className:'text-muted'},Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('請稍候，不要關閉此頁面','cec-plugin-stores'))):wp.element.createElement('div',null,wp.element.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('處理中...','cec-plugin-stores')))));}}]);return UserBigPlatformProcess;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器組件
var UserBigPlatformProcessEditor=function(_Component2){_inherits(UserBigPlatformProcessEditor,_Component2);function UserBigPlatformProcessEditor(){_classCallCheck(this,UserBigPlatformProcessEditor);return _possibleConstructorReturn(this,(UserBigPlatformProcessEditor.__proto__||Object.getPrototypeOf(UserBigPlatformProcessEditor)).apply(this,arguments));}_createClass(UserBigPlatformProcessEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u5927\u5E73\u53F0\u8F09\u5177\u6B78\u6236 - \u8655\u7406\u9801\u9762'),wp.element.createElement('p',null,'\u63A5\u6536 PHP \u9A57\u8B49\u5F8C\u7684 redirect\uFF0C\u8655\u7406 token \u4FDD\u5B58\u8207\u767B\u5165\u6AA2\u67E5'));}}]);return UserBigPlatformProcessEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserCarrierBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserCarrierBindingEditor", function() { return UserCarrierBindingEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_alert_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_module_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.get(window,'VC_CONFIG',{});var Option=__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option;/**
 * 大平台載具綁定頁面
 * 用戶登入後選擇會員卡進行載具綁定
 */var UserCarrierBinding=function(_Component){_inherits(UserCarrierBinding,_Component);function UserCarrierBinding(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserCarrierBinding);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserCarrierBinding.__proto__||Object.getPrototypeOf(UserCarrierBinding)).call.apply(_ref,[this].concat(args))),_this),_this.state={isLoading:true,isSubmitting:false,cardOptions:[],selectedCard:'',cardType:null,memberInfo:null,bigPlatformToken:null,bigPlatformBan:null},_this.loadMemberInfo=function(){__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfiles',{},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){console.error('載入會員資料失敗:',reason);return;}console.log('會員資料:',data);_this.setState({memberInfo:data});});},_this.loadCards=function(){_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/oca/getCCEInvoiceCarrierList',{},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log('會員卡清單:',{state:state,code:code,data:data});_this.setState({isLoading:false});if(state===false||code!==200){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('載入失敗','cec-plugin-stores'),content:reason});}_this.setState({cardOptions:data||[]});});},_this.submitBinding=function(){var _this$state=_this.state,selectedCard=_this$state.selectedCard,cardType=_this$state.cardType,bigPlatformToken=_this$state.bigPlatformToken,bigPlatformBan=_this$state.bigPlatformBan;if(!selectedCard){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a.warning({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('請選擇會員卡','cec-plugin-stores')});}__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確認載具綁定','cec-plugin-stores'),content:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確定要將此會員卡綁定至財政部電子發票平台嗎?','cec-plugin-stores'),okText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確定綁定','cec-plugin-stores'),cancelText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('取消','cec-plugin-stores'),onOk:function onOk(){_this.performBinding();}});},_this.performBinding=function(){var _this$state2=_this.state,selectedCard=_this$state2.selectedCard,cardType=_this$state2.cardType,bigPlatformToken=_this$state2.bigPlatformToken;_this.setState({isSubmitting:true});// 呼叫後端 API 取得大平台表單資料
__WEBPACK_IMPORTED_MODULE_20__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_19__configs_env__["b" /* API_HOST */]+'/api/account/cc/getBigPlatformCarrierFormData',{card:selectedCard,type:cardType,token:bigPlatformToken},function(state,res){_this.setState({isSubmitting:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;console.log('取得大平台表單資料:',{state:state,code:code,reason:reason,data:data});if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('綁定失敗','cec-plugin-stores'),content:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('無法連接伺服器，請稍後再試','cec-plugin-stores')});}if(code!==200){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('綁定失敗','cec-plugin-stores'),content:reason});}// 取得表單資料後，發送 POST 給財政部
_this.submitToBigPlatform(data);});},_this.submitToBigPlatform=function(formData){var url=formData.url,card_ban=formData.card_ban,card_no1=formData.card_no1,card_no2=formData.card_no2,card_type=formData.card_type,token=formData.token,signature=formData.signature;if(!url){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('綁定失敗','cec-plugin-stores'),content:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('無法取得財政部平台網址','cec-plugin-stores')});}console.log('準備提交至財政部大平台:',formData);// 清除 storage 中的大平台相關資料
__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-token');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-ban');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('from-big-platform');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');// 顯示確認彈窗
__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('即將前往財政部電子發票平台','cec-plugin-stores'),content:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('您將離開本網站，前往財政部電子發票平台完成載具綁定','cec-plugin-stores'),cancelText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('取消','cec-plugin-stores'),okText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('前往財政部平台','cec-plugin-stores'),onCancel:null,onOk:function onOk(){// 建立表單並提交
var form=document.createElement('form');form.setAttribute('method','post');form.setAttribute('action',url);form.setAttribute('target','_self');// 加入表單參數
var params={card_ban:card_ban,card_no1:card_no1,card_no2:card_no2,card_type:card_type,token:token,signature:signature};__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.forEach(params,function(value,key){if(value!==undefined&&value!==null){console.log('\u8868\u55AE\u53C3\u6578: '+key+'='+value);var input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;form.appendChild(input);}});document.body.appendChild(form);form.submit();}});},_this.handleBindingSuccess=function(data){// 此方法已不再使用，因為綁定流程改為直接導向財政部平台
// 保留此方法以防未來需要
console.log('綁定成功（舊流程）:',data);},_this.showErrorAndRedirect=function(message){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('錯誤','cec-plugin-stores'),content:message,onOk:function onOk(){// 清除相關 storage
__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-token');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-ban');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('from-big-platform');window.location.href=VC_CONFIG.INDEX_URL;}});},_this.cancelBinding=function(){__WEBPACK_IMPORTED_MODULE_13_antd_lib_modal___default.a.confirm({title:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確認取消','cec-plugin-stores'),content:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確定要取消載具綁定流程嗎?','cec-plugin-stores'),okText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確定取消','cec-plugin-stores'),cancelText:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('繼續綁定','cec-plugin-stores'),onOk:function onOk(){// 清除相關 storage
__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-token');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('big-platform-ban');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('from-big-platform');__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a.info({message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('已取消綁定','cec-plugin-stores'),duration:1});setTimeout(function(){window.location.href=VC_CONFIG.INDEX_URL+'/profile';},1000);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserCarrierBinding,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// 檢查是否從大平台流程進入
var token=__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].getLocalStorage('big-platform-token');var ban=__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].getLocalStorage('big-platform-ban');// 進入頁面後即清除導向標記，避免下次登入重複導向
__WEBPACK_IMPORTED_MODULE_18_libs_AppHelper__["a" /* default */].removeLocalStorage('from-big-platform');console.log('載具綁定頁面初始化:',{token:token,ban:ban});if(!token||!ban){return this.showErrorAndRedirect(Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('無效的載具歸戶請求','cec-plugin-stores'));}this.setState({bigPlatformToken:token,bigPlatformBan:ban},function(){// 載入會員資料和卡片清單
_this2.loadMemberInfo();_this2.loadCards();});}/**
   * 載入會員資料
   *//**
   * 載入會員卡清單
   *//**
   * 提交載具綁定
   *//**
   * 執行綁定操作
   *//**
   * 提交表單至財政部大平台
   *//**
   * 處理綁定成功
   *//**
   * 顯示錯誤並導向首頁
   *//**
   * 取消綁定流程
   */},{key:'render',value:function render(){var _this3=this;var _state=this.state,isLoading=_state.isLoading,isSubmitting=_state.isSubmitting,cardOptions=_state.cardOptions,selectedCard=_state.selectedCard,memberInfo=_state.memberInfo;if(isLoading){return wp.element.createElement('div',{style:{height:'350px'},className:'jumbotron d-flex align-items-center'},wp.element.createElement('div',{className:'container text-center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a,{size:'large'}),wp.element.createElement('h4',{className:'mt-4'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('載入中...','cec-plugin-stores'))));}return wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-5 pb-5'},wp.element.createElement('div',{className:'breadcrumb-wrap mb-4'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('載具綁定','cec-plugin-stores'))))),wp.element.createElement('h3',{className:'h4 text-navy mb-4'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('財政部電子發票平台 - 載具綁定','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_alert___default.a,{message:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('請選擇要綁定的會員卡','cec-plugin-stores'),description:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('選擇會員卡後，您的電子發票將會自動歸戶至財政部電子發票平台','cec-plugin-stores'),type:'info',showIcon:true,className:'mb-4'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{className:'shadow-sm'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-md-8 mx-auto'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{layout:'vertical'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('選擇會員卡','cec-plugin-stores'),required:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{size:'large',placeholder:Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('請選擇要綁定的會員卡','cec-plugin-stores'),value:selectedCard||undefined,onChange:function onChange(value){var _value$split=value.split('_'),_value$split2=_slicedToArray(_value$split,2),cardId=_value$split2[0],cardType=_value$split2[1];_this3.setState({selectedCard:cardId,cardType:cardType});}},__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.map(cardOptions,function(item){return wp.element.createElement(Option,{key:item.id,value:item.id+'_'+item.type},item.id,' ',item.typeName?'('+item.typeName+')':'');}))),memberInfo&&wp.element.createElement('div',{className:'mb-4 p-3 bg-light rounded'},wp.element.createElement('h6',{className:'text-navy mb-2'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('會員資訊','cec-plugin-stores')),wp.element.createElement('p',{className:'mb-1'},wp.element.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('會員卡號：','cec-plugin-stores')),memberInfo.member_profile_linkcode),wp.element.createElement('p',{className:'mb-0'},wp.element.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('會員等級：','cec-plugin-stores')),memberInfo.member_profile_isvip==1?'VIP':Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('一般會員','cec-plugin-stores'),memberInfo.member_profile_isopen==1&&' + OPENPOINT')),wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{size:'large',block:true,onClick:this.cancelBinding,disabled:isSubmitting},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('取消','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',size:'large',block:true,onClick:this.submitBinding,loading:isSubmitting,disabled:!selectedCard},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('確認綁定','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'mt-4'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_card___default.a,{className:'shadow-sm'},wp.element.createElement('h6',{className:'text-navy mb-3'},Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('注意事項','cec-plugin-stores')),wp.element.createElement('ul',{className:'text-muted mb-0'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('綁定後，您在的消費電子發票將自動歸戶至財政部電子發票平台','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('請確認選擇的會員卡號正確，綁定後如需變更請聯繫客服','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_21__wordpress_i18n__["__"])('若您已在小平台完成歸戶，此次綁定將會更新您的歸戶資訊','cec-plugin-stores'))))))));}}]);return UserCarrierBinding;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);// 編輯器組件
var UserCarrierBindingEditor=function(_Component2){_inherits(UserCarrierBindingEditor,_Component2);function UserCarrierBindingEditor(){_classCallCheck(this,UserCarrierBindingEditor);return _possibleConstructorReturn(this,(UserCarrierBindingEditor.__proto__||Object.getPrototypeOf(UserCarrierBindingEditor)).apply(this,arguments));}_createClass(UserCarrierBindingEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u8F09\u5177\u7D81\u5B9A\u9801\u9762'),wp.element.createElement('p',null,'\u7528\u6236\u9078\u64C7\u6703\u54E1\u5361\u9032\u884C\u5927\u5E73\u53F0\u8F09\u5177\u7D81\u5B9A'));}}]);return UserCarrierBindingEditor;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogueListEditor", function() { return CatalogueListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_carousel_style__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_carousel_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_carousel_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_carousel__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_player_youtube__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_player_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_player_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_NavTab_NavTab__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configs_env__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INDEX_URL=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:'all',//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var CatalogMode={Default:1,// 預設列表
Slider:2// 首頁橫向滑動
};// 前端頁面
var CatalogueList=function(_Component){_inherits(CatalogueList,_Component);function CatalogueList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueList.__proto__||Object.getPrototypeOf(CatalogueList)).call.apply(_ref,[this].concat(args))),_this),_this.hasVideo=false,_this.mouseInfo={clientX:null,clientY:null},_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo),selectedCategoryId:null,isModalVisible:false,videoList:[]},_this.lodavideoList=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:'5'};var page=opt.page,page_size=opt.page_size;__WEBPACK_IMPORTED_MODULE_15_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/v1/news?',{page:page,page_size:page_size,'category_ids[]':122},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;var videoList=data.rows.map(function(item){return{videoURL:item.youtube,imageURL:item.images_previews.length?item.images_previews[0].url||item.images[0].url:null};});var hasVideo=videoList.length>0;_this.setState({videoList:videoList});_this.hasVideo=hasVideo;});},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:'all'};var page=opt.page,page_size=opt.page_size;__WEBPACK_IMPORTED_MODULE_15_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/v1/catalogues',{page:page,page_size:page_size},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;_this.setState({listInfo:data},function(){_this.reloadSwiper();});});},_this.reloadSwiper=function(){var Swiper=window.Swiper;if(!Swiper)return;window.swiperCatalog=new Swiper('.catalog-swiper',{slidesPerView:_this.hasVideo?3:5,spaceBetween:30,loop:true,navigation:{nextEl:'.catalog-swiper-button-next',prevEl:'.catalog-swiper-button-prev'},breakpoints:{992:{slidesPerView:3,centeredSlides:true},767:{slidesPerView:3,spaceBetween:0,centeredSlides:true,watchSlidesProgress:true,watchSlidesVisibility:true}}});},_this.handleClosePlayerModal=function(){_this.setState({isModalVisible:false});},_this.handleMouseDownCarousel=function(e){e.persist();_this.mouseInfo={clientX:e.clientX,clientY:e.clientY};},_this.handleMouseUpCarousel=function(e,videoURL){e.persist();var _this$mouseInfo=_this.mouseInfo,clientX=_this$mouseInfo.clientX,clientY=_this$mouseInfo.clientY;var isDragX=Math.abs(clientX-e.clientX)>10;var isDragY=Math.abs(clientY-e.clientY)>10;if(isDragX||isDragY){return;}_this.setState({isModalVisible:true,videoURL:videoURL});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueList,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var isFromThemePage=window.location.hash.includes('theme');var isFromWellcomePage=window.location.hash.includes('wellcome');var isFromLeafletPage=window.location.hash.includes('leaflet');var isFromMarketPage=window.location.hash.includes('market');var isFromNewOpeningPage=window.location.hash.includes('new-opening');this.loadData();this.lodavideoList();__WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__["a" /* default */].updateConfig(function(resp){// 選第一頁
var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this2,'props.app.options',{});var category_ids=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this2.props,'category_ids',[]);var catalogue_categories=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(options,'catalogue_categories',[]),function(category){return category_ids.indexOf(category.id)!==-1;});_this2.setState({selectedCategoryId:isFromThemePage// 主題企劃
?35:isFromWellcomePage// 頂好促銷
?36:isFromLeafletPage// 報紙廣告
?37:isFromMarketPage// 超市促銷
?38:isFromNewOpeningPage// 新店開幕
?39:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(catalogue_categories,'0.id')});});}},{key:'render',value:function render(){var _this3=this;var catalogues=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.listInfo.rows',[]);// const catalogues = Array(5).fill({
//   ...this.state.listInfo.rows[0],
// });
var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});var category_ids=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this.props,'category_ids',[]);var catalogue_categories=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(options,'catalogue_categories',[]).sort(function(a,b){return a.id-b.id;}),function(category){return category_ids.indexOf(category.id)!==-1;});var selectedCategoryId=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.selectedCategoryId',__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(catalogue_categories,'0.id'));var mode=this.props.mode||CatalogMode.Default;var urlQuery=__WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__["a" /* default */].getURLQuery();var isKiosk=urlQuery.view;var Locale=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var NavTavCate=[];if(Locale==='en_US'){catalogue_categories.forEach(function(category){catalogues.find(function(item){return item.category_id==category.id&&item.category_id!=40&&item.category_id!=41;})&&NavTavCate.push({id:category.id,name:category.name_en?category.name_en:category.name});});}else{catalogue_categories.forEach(function(category){catalogues.find(function(item){return item.category_id==category.id&&item.category_id!=40&&item.category_id!=41;})&&NavTavCate.push({id:category.id,name:category.name});//category
});}if(mode===CatalogMode.Default){return wp.element.createElement('main',{'class':'bg-light'},NavTavCate.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_components_NavTab_NavTab__["a" /* default */],{value:selectedCategoryId,tabs:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(NavTavCate,function(category){return{value:category.id,name:category.name};}),onChange:function onChange(value,tabInfo){window.location.hash='';_this3.setState({selectedCategoryId:value});}}),wp.element.createElement('div',{'class':'tab-content',id:'pills-tabContent'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row'},catalogues.filter(function(catalogues){return catalogues.category_id===_this3.state.selectedCategoryId;}).map(function(catalogue){var catalogueName=catalogue.en_name?catalogue.en_name:catalogue.name;var imgURL=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.split(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.first(catalogue.images),' ').join(encodeURIComponent(' '));if(imgURL){imgURL=imgURL.replace('(','%28');imgURL=imgURL.replace(')','%29');}return wp.element.createElement('div',{'class':'col-6 col-md-4 column-lg-5 mb-4 wow fadeInUp','data-wow-delay':'0.1s'},wp.element.createElement('a',{'class':'catalog-item mb-3',role:'button',href:Locale=='en_US'?INDEX_URL+'/catalogue-view-en?catalogue='+catalogueName+(isKiosk?'&view=kiosk':''):INDEX_URL+'/catalogue-view?catalogue='+catalogueName+(isKiosk?'&view=kiosk':'')},wp.element.createElement('span',{'class':'cover img-catalog mb-2',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.split(catalogue.cover_url,' ').join(encodeURIComponent(' ')).replace('(','%28').replace(')','%29')+')'}},wp.element.createElement('span',{'class':'more'},wp.element.createElement('i',{'class':'fas fa-eye'}))),wp.element.createElement('h6',{'class':'note align-self-start text-navy fw-700 mb-1'},(Locale=='zh_TW'||Locale=='en_US'&&!catalogue.en_name)&&catalogue.name,Locale=='en_US'&&catalogue.en_name),wp.element.createElement('div',{'class':'d-flex flex-lg-row flex-column justify-content-between aling-items-center w-100'},wp.element.createElement('p',{'class':'note mb-lg-0 mb-2 text-dark'},catalogue.promotion_start_date,'-',catalogue.promotion_end_date))));})))));}if(mode===CatalogMode.Slider){return wp.element.createElement('article',{'class':'catalog-section'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row fadeInUp'},this.hasVideo&&wp.element.createElement('div',{'class':'col-md-12 col-lg-5 order-lg-0 order-1'},wp.element.createElement('div',{'class':'card card-primary border-0'},wp.element.createElement('div',{'class':'card-header d-flex justify-content-between align-items-center'},wp.element.createElement('strong',{'class':'h6 mb-0'},Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('活動影片','cec-plugin-stores'))),wp.element.createElement('div',{className:'card-body p-3 carousel-wrapper'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_carousel___default.a,{className:'video',swipeToSlide:true,draggable:true,autoplay:true,autoplaySpeed:5000},this.state.videoList.map(function(video){return wp.element.createElement('div',{className:'carousel-video'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a['carousel-image'],style:{backgroundImage:'url('+video.imageURL+')'},onMouseDown:_this3.handleMouseDownCarousel,onMouseUp:function onMouseUp(e){return _this3.handleMouseUpCarousel(e,video.videoURL);}},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a['play-btn']},wp.element.createElement('img',{src:window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/youtube-icon-dark.png',width:64,height:45,alt:''}))));})),this.state.isModalVisible&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a['mask-wrapper'],onClick:this.handleClosePlayerModal},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a['close-btn']},wp.element.createElement('img',{src:window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/close-btn.svg',width:40,height:40,alt:''})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a['mask-content-wrapper']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_react_player_youtube___default.a,{width:window.innerWidth>=1200?'1024px':'100%',height:'576px',url:this.state.videoURL,playing:true,controls:true})))))),wp.element.createElement('div',{'class':''+(this.hasVideo?'col-md-12 col-lg-7 order-lg-1 order-0  mb-lg-0 mb-5':'col-lg-12')},wp.element.createElement('div',{'class':'card card-primary border-0',style:{height:'100%'}},wp.element.createElement('div',{'class':'card-header d-flex justify-content-between align-items-center'},wp.element.createElement('strong',{'class':'h6 mb-0'},Object(__WEBPACK_IMPORTED_MODULE_11__wordpress_i18n__["__"])('促銷目錄','cec-plugin-stores')),wp.element.createElement('a',{'class':'h6 text-white mb-0',role:'button',href:INDEX_URL+'/catalogues'+(Locale=='en_US'?'-en':''),'data-toggle':'tooltip','data-placement':'right',title:'\u770B\u66F4\u591A'},wp.element.createElement('i',{'class':'icon-plus'}))),wp.element.createElement('div',{'class':'card-body p-3',style:{}},wp.element.createElement('div',{'class':'catalog-swiper-wrap',style:{padding:'0 6rem'}},wp.element.createElement('div',{'class':'swiper-container catalog-swiper'},wp.element.createElement('div',{'class':'swiper-wrapper'},catalogues.filter(function(catalogue){return category_ids.indexOf(catalogue.category_id)!==-1&&catalogue.cover_url!==null;}).map(function(catalogue,idx){var catalogueName=catalogue.en_name?catalogue.en_name:catalogue.name;return wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('a',{'class':'catalog-item',role:'button',href:INDEX_URL+'/catalogue-view'+(Locale=='en_US'?'-en':'')+'?catalogue='+catalogueName+(isKiosk?'&view=kiosk':'')},wp.element.createElement('span',{'class':'cover img-catalog',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.split(catalogue.cover_url,' ').join(encodeURIComponent(' ')).replace('(','%28').replace(')','%29')+')'}},wp.element.createElement('span',{'class':'more'},wp.element.createElement('i',{'class':'fas fa-eye'}))),wp.element.createElement('strong',null,Locale=='en_US'&&catalogue.en_name?catalogue.en_name:catalogue.name)));}))),wp.element.createElement('div',{'class':'control'},wp.element.createElement('div',{'class':'catalog-swiper-button catalog-swiper-button-prev'},wp.element.createElement('i',{'class':'icon-chevron-left'})),wp.element.createElement('div',{'class':'catalog-swiper-button catalog-swiper-button-next'},wp.element.createElement('i',{'class':'icon-chevron-right'}))))))))));}return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null);}}]);return CatalogueList;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueListEditor=function(_Component2){_inherits(CatalogueListEditor,_Component2);function CatalogueListEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,CatalogueListEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=CatalogueListEditor.__proto__||Object.getPrototypeOf(CatalogueListEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(CatalogueListEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_14_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this5=this;var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{alt:'f538','class':'dashicons dashicons-layout'})),'\u4FC3\u92B7\u76EE\u9304\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'// layout="vertical"
// onFinish={values => this.submitData(values)}
,onValuesChange:function onValuesChange(changedFields,allFields){return _this5.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_ids','目錄類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(options,'catalogue_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{value:item.id},item.name));}})))));}}]);return CatalogueListEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isMediaStream = isMediaStream;
exports.isBlobUrl = isBlobUrl;
exports.supportsWebKitPresentationMode = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(__webpack_require__(2121));

var _deepmerge = _interopRequireDefault(__webpack_require__(857));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video');
  // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function
  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavTab=function(_Component){_inherits(NavTab,_Component);function NavTab(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavTab);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavTab.__proto__||Object.getPrototypeOf(NavTab)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:undefined},_this.reloadTab=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function(){var $el,leftPos,newWidth;var tabsUl=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.basic-tabs-label ul'));if(!tabsUl)return;var $magicLine=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(tabsUl).find('#magic-line'));if(!$magicLine){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}$magicLine=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(tabsUl).find('#magic-line'));if(!$magicLine)return;$magicLine=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.current_page_item').width());// $current_page_item = $(".current_page_item a")
if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isFunction(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.current_page_item a').position)){$magicLine.css('left',__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.current_page_item a').position(),'left',0));}$magicLine.data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on({mouseenter:function mouseenter(){$el=__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},mouseleave:function mouseleave(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});}},'.basic-tabs-label ul li a');__WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on({mouseenter:function mouseenter(){if(!__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.highlight').removeClass('current_page_item');}},mouseleave:function mouseleave(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.highlight').addClass('current_page_item');}},'#pills-tab .nav-item');},10),_this.componentDidMount=function(){_this.reloadTab();},_this.componentDidUpdate=function(prevProps,prevState,snapshot){// console.log('componentDidUpdate', prevProps, prevState, this.state)
if(prevState.value!==_this.state.value){_this.reloadTab();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavTab,[{key:'render',value:function render(){var _this2=this;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('div',{'class':'mt-4'},wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this,'props.tabs',[]),function(item){return wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-item',item.value===_this2.state.value?'current_page_item highlight':null),key:item.type},wp.element.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-link'),href:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(item,'link'),onClick:function onClick(e){e.preventDefault();_this2.setState({value:item.value},function(){_this2.reloadTab();if(_this2.props.onChange){_this2.props.onChange(item.value,item);}});_this2.reloadTab();}},item.name));}),wp.element.createElement('li',{id:'magic-line'})))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){if(props.value!==state.value)return{value:props.value};}}]);return NavTab;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Recruit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecruitEditor", function() { return RecruitEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_module_scss__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_classnames__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(window,'VC_CONFIG',{});var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var Recruit=function(_Component){_inherits(Recruit,_Component);function Recruit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Recruit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Recruit.__proto__||Object.getPrototypeOf(Recruit)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef(),_this.state={query:{},storeInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},store:[],area:null,branch:[],loading:false},_this.fillData=function(){_this.formRef.current.setFieldsValue({phone:'123456',name:'KK',licence:['壽險','產險','外幣'],area:'北區',store:'新店店',city:'台北市',email:'test@gamil.xxx',desc:'123test'});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(query){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+'/api/v1/stores',query,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/cecservice');return;}_this.setState({listInfo:data});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_18_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};info.type=2;/*
        type:
        1:聯絡我們
        2:人才招募
    */console.log('submitData',info);_this.setState({isSubmitData:true,messages:{}});_this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+'/api/v1/cibc/mail',info,function(state,res){console.log(state,res);_this.setState({loading:false});_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['error']({message:'發生錯誤',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['success']({message:'成功'});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Recruit,[{key:'componentDidMount',value:function componentDidMount(){var query={page_size:'all',iscibc:1};this.loadConfig();this.loadData(query);this.setState({query:query});}},{key:'render',value:function render(){var _this2=this;var storeInfo=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.listInfo.rows',{});var options=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.query',{});var branchCity=new Set();storeInfo.forEach(function(item){if(item.city_name){if(!branchCity.has(item.city_name)){branchCity.add(item.city_name);}}});this.refreshPicker();return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/cibc'},'\u5EB7\u9054\u76DB\u901A\u4FDD\u96AA\u7D93\u7D00\u4EBA',' ')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u4EBA\u624D\u62DB\u52DF')))),wp.element.createElement('section',{'class':'pt-5 pb-0'},wp.element.createElement('div',{'class':'basic-tabs-border mb-5'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc'},'\u9996\u9801')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-about'},'\u5EB7\u9054\u76DB\u901A\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:__WEBPACK_IMPORTED_MODULE_22__configs_env__["e" /* ENTERTAIN_LINK */]},'\u516C\u5E73\u5F85\u5BA2')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-service'},'\u670D\u52D9\u9805\u76EE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-partner'},'\u5408\u4F5C\u5925\u4F34')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-activity'},'\u6D3B\u52D5\u526A\u5F71')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-servicepoint'},'\u670D\u52D9\u64DA\u9EDE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link active',href:VC_CONFIG.INDEX_URL+'/cibc-recruit'},'\u4EBA\u624D\u62DB\u52DF'))))),wp.element.createElement('img',{'class':'img-cover',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/recruit/cibc_banner.png',alt:''}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,{spinning:this.state.loading,tip:'Sending...',size:'large'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){//console.log('onValuesChange', changedFields.area),
//console.log('onValuesChange-this.state', this.state.area)
if(changedFields.area){_this2.formRef.current.setFields([{name:['store'],value:null,touched:true,validating:false,errors:[]}]);//console.log('onValuesChange-if', changedFields)
}}},wp.element.createElement('section',{'class':'pt-md-5'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u6211\u8981\u61C9\u5FB5'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-5'},'\u8ACB\u5C07\u5C65\u6B77\u5BC4\u5230\uFF1ATW_CIBC@uni-prosperity.com.tw \u6216\u586B\u5BEB\u4EE5\u4E0B\u8868\u683C\uFF0C\u5C07\u6709\u5C08\u4EBA\u8207\u60A8\u9023\u7D61'),wp.element.createElement('fieldset',{'class':'bg-white p-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u59D3\u540D*')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('name'),{rules:[{required:true,message:'請輸入姓名'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-left','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u5730\u5340')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({name:'area'},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('area'),{rules:[{required:true,message:'請輸入地區'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5730\u5340',onChange:function onChange(changedFields,allFields){_this2.store=storeInfo.filter(function(item){return item.store_group_name==changedFields;});_this2.setState({store:_this2.store,area:changedFields,branch:_this2.store[0].name});}},__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.map(options.store_groups,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option,{value:item.name},item.name);})))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block'},'\u8B49\u7167(\u53EF\u8907\u9078)')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('licence'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:'\u58FD\u96AA'},'\u58FD\u96AA'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:'\u7522\u96AA'},'\u7522\u96AA'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:'\u5916\u5E63'},'\u5916\u5E63'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:'\u6295\u8CC7'},'\u6295\u8CC7'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:'\u5176\u4ED6'},'\u5176\u4ED6')))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-left','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u5206\u5E97')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('store'),{rules:[{required:true,message:'請選擇分店'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5206\u5E97',notFoundContent:'\u8ACB\u5148\u9078\u64C7\u5730\u5340',value:__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this,'state.branch',null),onChange:function onChange(changedFields){_this2.setState({branch:changedFields});}},__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.map(this.state.store,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option,{key:item.name},item.name);})))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u5C45\u4F4F\u5730')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('city'),{rules:[{required:true,message:'請輸入居住地'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5C45\u4F4F\u5730'},__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.map(options.citys,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option,{value:item.name},item.name);})))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-left','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u624B\u6A5F*')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('phone'),{rules:[{required:true,message:'請輸入手機'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'Email')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('email'),{rules:[{required:true,message:'請輸入email'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u81EA\u50B3',' ')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc'),{rules:[{required:true,message:'請輸入自傳'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_input___default.a.TextArea,{rows:5}))))))),wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-6 col-lg-3 mt-5'},wp.element.createElement('a',{'class':'h6 btn btn-block bg-white text-navy rounded-pill px-5 py-4',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this2.formRef.current.submit();}},'\u78BA\u5B9A\u9001\u51FA')))))),wp.element.createElement('section',{'class':'pt-md-0'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u806F\u7D61\u6211\u5011'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 d-flex align-items-stretch'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-8 mx-auto'},wp.element.createElement('h5',{'class':'h4 text-center mb-4'},'\u53F0\u5317\u8FA6\u516C\u5BA4'),wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_map'}),wp.element.createElement('span',null,'11268 \u53F0\u5317\u5E02\u5317\u6295\u5340\u5927\u696D\u8DEF136\u865F5\u6A13',wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://goo.gl/maps/7kb51Fb1uwHAxZMGA',target:'_blank',rel:'noopener noreferrer'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_phone'}),wp.element.createElement('span',null,'02-2898-1999')))))))),wp.element.createElement('div',{'class':'col-md-6 d-flex align-items-stretch'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-8 mx-auto'},wp.element.createElement('h5',{'class':'h4 text-center mb-4'},'\u53F0\u5357\u8FA6\u516C\u5BA4'),wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_map'}),wp.element.createElement('span',null,'71079 \u53F0\u5357\u5E02\u6C38\u5EB7\u5340\u4E2D\u83EF\u4E8C\u8DEF350\u865F2\u6A13',wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://goo.gl/maps/bu9i4ugrnLHyKswL9',target:'_blank',rel:'noopener noreferrer'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_phone'}),wp.element.createElement('span',null,'06-208-3119'))))))))),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 rounded-20 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row justify-content-center align-items-center'},wp.element.createElement('div',{'class':'col-md-4'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/recruit/hiring_cyhs.svg',alt:''})),wp.element.createElement('div',{'class':'col-md-5'},wp.element.createElement('div',{'class':'text-center'},wp.element.createElement('h5',{'class':'h3 text-navy my-4 fw-700'},'\u6B61\u8FCE\u6295\u905E\u76F8\u95DC\u8077\u4F4D'),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-sm-6 mx-auto my-3'},wp.element.createElement('a',{'class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'https://www.104.com.tw/job/5doh8',target:'_blank',rel:'noopener noreferrer'},'\u6295\u905E\u5C65\u6B77')))))))))))));}}]);return Recruit;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);// 編輯器
var RecruitEditor=function(_Component2){_inherits(RecruitEditor,_Component2);function RecruitEditor(){_classCallCheck(this,RecruitEditor);return _possibleConstructorReturn(this,(RecruitEditor.__proto__||Object.getPrototypeOf(RecruitEditor)).apply(this,arguments));}_createClass(RecruitEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return RecruitEditor;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FAQUs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAQUsEditor", function() { return FAQUsEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_device_detect__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_module_scss__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_configs_env__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');// 前端頁面
var FAQUs=function(_Component){_inherits(FAQUs,_Component);function FAQUs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FAQUs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FAQUs.__proto__||Object.getPrototypeOf(FAQUs)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:'info',query:{c:null,i:null},serviceInfo:undefined,listInfo:{current:1,//目前頁數
page_size:200,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]}},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_10_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11_configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(){var query=__WEBPACK_IMPORTED_MODULE_9_libs_AppHelper__["a" /* default */].getHashParamaters();_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_10_libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_11_configs_env__["b" /* API_HOST */]+'/api/v1/questions?page_size=all',null,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/faq');return;}_this.setState({listInfo:data});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.getSearchPath=function(query){return VC_CONFIG.INDEX_URL+'/stores/#'+__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(query,{skipNull:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FAQUs,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_9_libs_AppHelper__["a" /* default */].getHashParamaters();this.loadConfig();this.loadData(query);this.setState({query:query});}},{key:'render',value:function render(){var faqInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.listInfo',{});var faq=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(faqInfo,'rows',[]);var options=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.query',{});var faqCategories=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(options,'question_categories',[]);var highlight=query.c||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.first(faqCategories),'id');var highlightItem=query.i;this.refreshPicker();return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_5__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:'#'},Object(__WEBPACK_IMPORTED_MODULE_5__wordpress_i18n__["__"])('客服中心','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_5__wordpress_i18n__["__"])('常見問題','cec-plugin-stores'))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 faq-tab-accrodion'},wp.element.createElement('div',{'class':'col-md-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-0'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(faqCategories,function(categoryInfo){return wp.element.createElement('div',{'class':'list-group'},wp.element.createElement('a',{id:categoryInfo.id,'class':categoryInfo.id===highlight?'list-group-item list-group-item-action active':'list-group-item list-group-item-action',href:'#c='+categoryInfo.id},(Local=='zh_TW'||Local=='en_US'&&!categoryInfo.name_en)&&categoryInfo.name&&categoryInfo.name,Local=='en_US'&&categoryInfo.name_en&&categoryInfo.name_en),__WEBPACK_IMPORTED_MODULE_7_react_device_detect__["isMobileOnly"]&&wp.element.createElement('div',{id:'bbbb-'+categoryInfo.id,style:{display:categoryInfo.id===highlight?'':'none'}},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-0'},wp.element.createElement('div',{'class':'accordion',id:'accordionFAQ'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(faq.filter(function(Info){return Info.question_category_id==categoryInfo.id;}),function(Info){return wp.element.createElement('div',{id:'aaa-'+Info.id,'class':'card shadow-0'},wp.element.createElement('div',{'class':'card-header',id:'heading-'+Info.id},wp.element.createElement('h5',{'class':'mb-0'},wp.element.createElement('button',{'class':'btn btn-link',type:'button','data-toggle':'collapse','data-target':'#collapse-'+Info.id,'aria-controls':'collapse-'+Info.id,href:'#kkk='+Info.id},(Local=='zh_TW'||Local=='en_US'&&!Info.title_en)&&Info.title,Local=='en_US'&&Info.title_en&&Info.title_en))),wp.element.createElement('div',{'class':'collapse',id:'collapse-'+Info.id,'aria-labelledby':'heading-'+Info.id,'data-parent':'#accordionFAQ'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('p',{'class':'p text-dark text-justify'},(Local=='zh_TW'||Local=='en_US'&&!Info.content_en)&&wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:Info.content.replace(/\\n/g,'<br/>')}}),Local=='en_US'&&Info.content_en&&wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:Info.content_en.replace(/\\n/g,'<br/>')}})))));}))))));})))),!__WEBPACK_IMPORTED_MODULE_7_react_device_detect__["isMobileOnly"]&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(faqCategories,function(categoryInfo){return wp.element.createElement('div',{id:'bbbb-'+categoryInfo.id,'class':'col-md-8 px-3',style:{display:categoryInfo.id==highlight?'':'none'}},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body p-0'},wp.element.createElement('div',{'class':'accordion',id:'accordionFAQ'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(faq.filter(function(Info){return Info.question_category_id==categoryInfo.id;}),function(Info){return wp.element.createElement('div',{id:'aaa-'+Info.id,'class':'card shadow-0'},wp.element.createElement('div',{'class':'card-header',id:'heading-'+Info.id},wp.element.createElement('h5',{'class':'mb-0'},wp.element.createElement('button',{'class':'btn btn-link',type:'button','data-toggle':'collapse','data-target':'#collapse-'+Info.id,'aria-controls':'collapse-'+Info.id,href:'#kkk='+Info.id},(Local=='zh_TW'||Local=='en_US'&&!Info.title_en)&&Info.title,Local=='en_US'&&Info.title_en&&Info.title_en))),wp.element.createElement('div',{'class':'collapse',id:'collapse-'+Info.id,'aria-labelledby':'heading-'+Info.id,'data-parent':'#accordionFAQ'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('p',{'class':'p text-dark text-justify'},(Local=='zh_TW'||Local=='en_US'&&!Info.content_en)&&wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:Info.content.replace(/\\n/g,'<br/>')}}),Local=='en_US'&&Info.content_en&&wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:Info.content_en.replace(/\\n/g,'<br/>')}})))));})))));})))));}}]);return FAQUs;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);__WEBPACK_IMPORTED_MODULE_6_jquery___default()(function(){// accordion 展開時觸發
__WEBPACK_IMPORTED_MODULE_6_jquery___default()(document).on('show.bs.collapse','#accordionFAQ .card',function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.accordion > .card').removeClass('active');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.accordion .card > .collapse').removeClass('show');__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).addClass('active');});// accordion 收合時觸發
__WEBPACK_IMPORTED_MODULE_6_jquery___default()(document).on('hide.bs.collapse','#accordionFAQ .card',function(){if(__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).hasClass('active')){__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).removeClass('active');}});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(document).on('click','.card-body .list-group a',function(){var listGroupEl=__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).parent();var accordionItemEl=__WEBPACK_IMPORTED_MODULE_7_react_device_detect__["isMobileOnly"]?__WEBPACK_IMPORTED_MODULE_6_jquery___default()(listGroupEl).find('[id^="aaa-"]'):__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#bbbb-'+this.id).find('[id^="aaa-"]');// const accordionFirstItemEl = accordionItemEl.first();
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.card-body .list-group a').removeClass('active');__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).addClass('active');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("[id^='bbbb-']").attr('style','display:none');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#bbbb-'+__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this)[0].id).show();__WEBPACK_IMPORTED_MODULE_6_jquery___default()("[id^='aaa-']").removeClass('active');// accordionFirstItemEl.addClass('active');
__WEBPACK_IMPORTED_MODULE_6_jquery___default()("[id^='aaa-'] .collapse").removeClass('show');// accordionFirstItemEl.children('.collapse').addClass('show');
if(__WEBPACK_IMPORTED_MODULE_7_react_device_detect__["isMobileOnly"]){var navbarHeight=__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.navbar').height();window.scrollTo({top:window.scrollY+this.getBoundingClientRect().top-navbarHeight});// 為 mobile, tablet 吃不到 .active 的 style 而設定
__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.card-body .list-group a').css({color:'#0E3368'});__WEBPACK_IMPORTED_MODULE_6_jquery___default()(this).css({color:'#fff'});}});});// 編輯器
var FAQUsEditor=function(_Component2){_inherits(FAQUsEditor,_Component2);function FAQUsEditor(){_classCallCheck(this,FAQUsEditor);return _possibleConstructorReturn(this,(FAQUsEditor.__proto__||Object.getPrototypeOf(FAQUsEditor)).apply(this,arguments));}_createClass(FAQUsEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return FAQUsEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CIBCInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIBCInfoEditor", function() { return CIBCInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_scss__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__libs_whttp__ = __webpack_require__(7);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'VC_CONFIG',{});var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var CIBCInfo=function(_Component){_inherits(CIBCInfo,_Component);function CIBCInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CIBCInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CIBCInfo.__proto__||Object.getPrototypeOf(CIBCInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createRef(),_this.state={query:{},storeInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},store:[],area:null,branch:[],loading:false},_this.fillData=function(){_this.formRef.current.setFieldsValue({phone:'123456',name:'KK',licence:['壽險','產險','外幣'],area:'北區',store:'新店店',city:'台北市',email:'test@gamil.xxx',desc:'123test'});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_19__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_18__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(query){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_19__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_18__configs_env__["b" /* API_HOST */]+'/api/v1/stores',query,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/cecservice');return;}_this.setState({listInfo:data});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_14_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};info.type=1;/*
        type:
        1:聯絡我們
        2:人才招募
    */console.log('submitData',info);_this.setState({isSubmitData:true,messages:{}});_this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_19__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_18__configs_env__["b" /* API_HOST */]+'/api/v1/cibc/mail',info,function(state,res){console.log(state,res);_this.setState({loading:false});_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_9_antd_lib_notification___default.a['error']({message:'發生錯誤',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_9_antd_lib_notification___default.a['success']({message:'成功'});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CIBCInfo,[{key:'componentDidMount',value:function componentDidMount(){var query={page_size:'all'//iscibc:1
};this.loadConfig();this.loadData(query);this.setState({query:query});}},{key:'render',value:function render(){var _this2=this;var storeInfo=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.listInfo.rows',{});var options=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.query',{});var branchCity=new Set();storeInfo.forEach(function(item){if(item.city_name){if(!branchCity.has(item.city_name)){branchCity.add(item.city_name);}}});this.refreshPicker();return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/cibc'},'\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u4EBA\u624D\u62DB\u52DF')))),wp.element.createElement('section',{'class':'pt-5 pb-0'},wp.element.createElement('div',{'class':'basic-tabs-border mb-5'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc'},'\u9996\u9801')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-about'},'\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-service'},'\u670D\u52D9\u9805\u76EE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-product'},'\u5546\u54C1\u8CC7\u8A0A')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-partner'},'\u5408\u4F5C\u5925\u4F34')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-activity'},'\u6D3B\u52D5\u526A\u5F71')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-servicepoint'},'\u670D\u52D9\u64DA\u9EDE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-recruit'},'\u4EBA\u624D\u62DB\u52DF'))))),wp.element.createElement('img',{'class':'img-cover',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/contact-us/cibc_banner.jpg',alt:''}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,{spinning:this.state.loading,tip:'Sending...',size:'large'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){//console.log('onValuesChange', changedFields.area),
//console.log('onValuesChange-this.state', this.state.area)
if(changedFields.area){_this2.formRef.current.setFields([{name:['store'],value:null,touched:true,validating:false,errors:[]}]);//console.log('onValuesChange-if', changedFields)
}}},wp.element.createElement('section',{'class':'pt-md-5'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u806F\u7D61\u6211\u5011'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-5'},'\u5982\u6709\u4EFB\u4F55\u9700\u6C42\u6216\u554F\u984C\uFF0C\u8ACB\u5BC4\u4FE1\u5230\uFF1ATW_CIBC@uni-prosperity.com.tw \u6216\u586B\u5BEB\u4EE5\u4E0B\u8868\u683C\uFF0C\u5C07\u6709\u5C08\u4EBA\u8207\u60A8\u9023\u7D61',wp.element.createElement('p',null),'\u3010\u6B64\u9801\u9762\u50C5\u53D7\u7406\u4FDD\u96AA\u76F8\u95DC\u8A62\u554F\uFF0C\u82E5\u60A8\u6709\u5206\u5E97\u8CFC\u7269\u76F8\u95DC\u554F\u984C\uFF0C\u8ACB\u6539\u81F3\u4EE5\u4E0B\u7DB2\u5740\u7559\u8A00',wp.element.createElement('a',{href:'https://www.uni-prosperity.com.tw/contact-us/'},'https://www.uni-prosperity.com.tw/contact-us/'),'\u3011'),wp.element.createElement('fieldset',{'class':'bg-white p-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u59D3\u540D*')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('name'),{rules:[{required:true,message:'請輸入姓名'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-left','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u6240\u5728\u5340\u57DF')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({name:'area'},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('area'),{rules:[{required:true,message:'請輸入區域'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5340\u57DF',onChange:function onChange(changedFields,allFields){_this2.store=storeInfo.filter(function(item){return item.store_area_name==changedFields;});_this2.setState({store:_this2.store,area:changedFields,branch:_this2.store[0].name});}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{value:null,disabled:true},'\u8ACB\u9078\u64C7\u5340\u57DF'),__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.map(options.store_areas,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{value:item.name},item.name);})))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u624B\u6A5F*')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('phone'),{rules:[{required:true,message:'請輸入手機'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-left','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u81E8\u8FD1\u5206\u5E97')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('store'),{rules:[{required:true,message:'請選擇分店'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5206\u5E97',notFoundContent:'\u8ACB\u5148\u9078\u64C7\u5730\u5340',value:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.branch',null),onChange:function onChange(changedFields){_this2.setState({branch:changedFields});}},__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.map(this.state.store,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a.Option,{key:item.name},item.name);})))))),wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'Email')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('email'),{rules:[{required:true,message:'請輸入email'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'}))))),wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-auto col-form-label h6 text-navy text-md-right','for':''},wp.element.createElement('span',{'class':'d-block',style:{width:'70px'}},'\u4FE1\u4EF6\u5167\u5BB9',' ')),wp.element.createElement('div',{'class':'col-sm'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_17_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc'),{rules:[{required:true,message:'請輸入信件內容'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.TextArea,{rows:5}))))))),wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-6 col-lg-3 mt-5'},wp.element.createElement('a',{'class':'h6 btn btn-block bg-white text-navy rounded-pill px-5 py-4',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this2.formRef.current.submit();}},'\u78BA\u5B9A\u9001\u51FA')))))),wp.element.createElement('section',{'class':'pt-md-0'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u6211\u5011\u7684\u99D0\u9EDE'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 d-flex align-items-stretch'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-8 mx-auto'},wp.element.createElement('h5',{'class':'h4 text-center mb-4'},'\u53F0\u5317\u8FA6\u516C\u5BA4'),wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_map'}),wp.element.createElement('span',null,'11268 \u53F0\u5317\u5E02\u5317\u6295\u5340\u5927\u696D\u8DEF136\u865F5\u6A13',wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://goo.gl/maps/7kb51Fb1uwHAxZMGA',target:'_blank',rel:'noopener noreferrer'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_phone'}),wp.element.createElement('span',null,'02-2898-1999')))))))),wp.element.createElement('div',{'class':'col-md-6 d-flex align-items-stretch'},wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-8 mx-auto'},wp.element.createElement('h5',{'class':'h4 text-center mb-4'},'\u53F0\u5357\u8FA6\u516C\u5BA4'),wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_map'}),wp.element.createElement('span',null,'71079 \u53F0\u5357\u5E02\u6C38\u5EB7\u5340\u4E2D\u83EF\u4E8C\u8DEF350\u865F2\u6A13',wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://goo.gl/maps/bu9i4ugrnLHyKswL9',target:'_blank',rel:'noopener noreferrer'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_phone'}),wp.element.createElement('span',null,'06-208-3119'))))))))))));}}]);return CIBCInfo;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);// 編輯器
var CIBCInfoEditor=function(_Component2){_inherits(CIBCInfoEditor,_Component2);function CIBCInfoEditor(){_classCallCheck(this,CIBCInfoEditor);return _possibleConstructorReturn(this,(CIBCInfoEditor.__proto__||Object.getPrototypeOf(CIBCInfoEditor)).apply(this,arguments));}_createClass(CIBCInfoEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return CIBCInfoEditor;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CIBCServicePoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIBCServicePointEditor", function() { return CIBCServicePointEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_popover_style__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_popover_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_popover_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_popover__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(window,'VC_CONFIG',{});var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var CIBCServicePoint=function(_Component){_inherits(CIBCServicePoint,_Component);function CIBCServicePoint(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CIBCServicePoint);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CIBCServicePoint.__proto__||Object.getPrototypeOf(CIBCServicePoint)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef(),_this.state={query:{},storeInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},store:[],area:null,branch:[],loading:false,content:null},_this.fillData=function(){_this.formRef.current.setFieldsValue({phone:'123456',name:'KK',licence:['壽險','產險','外幣'],area:'北區',store:'新店店',city:'台北市',email:'test@gamil.xxx',desc:'123test'});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_9__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(query){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_9__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_8__configs_env__["b" /* API_HOST */]+'/api/v1/stores',query,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/cecservice');return;}_this.setState({listInfo:data});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.loadCIBC=function(id){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_9__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8__configs_env__["b" /* API_HOST */]+('/api/v1/cibcs/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.warning(reason);return;}_this.setState({CIBCInfo:data});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CIBCServicePoint,[{key:'componentDidMount',value:function componentDidMount(){var query={page_size:'all',iscibc:1};this.loadConfig();this.loadData(query);this.setState({query:query});}},{key:'render',value:function render(){var _this2=this;var storeInfo=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.listInfo.rows',{});var options=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.query',{});var branchCity=new Set();storeInfo.forEach(function(item){if(item.city_name){if(!branchCity.has(item.city_name)){branchCity.add(item.city_name);}}});this.refreshPicker();var CIBCInfo=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.CIBCInfo');//console.log("CIBCInfo",CIBCInfo)
var content=wp.element.createElement('p',null,'\u7121');if(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.CIBCInfo.users.length')>0){var CIBCInfo_users=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this,'state.CIBCInfo.users')[0];//console.log("CIBCInfo_users",CIBCInfo_users)
content=wp.element.createElement('div',null,wp.element.createElement('div',{'class':'card-cibcMan'},wp.element.createElement('img',{'class':'img-1-2 mb-3',style:{height:270,width:200},src:CIBCInfo_users&&CIBCInfo_users.image[0].url,alt:''}),wp.element.createElement('p',{'class':'p text-primary my-2'},'\u670D\u52D9\u4EBA\u54E1\uFF1A',CIBCInfo_users&&CIBCInfo_users.name),wp.element.createElement('p',{'class':'p text-primary my-2'},'\u670D\u52D9\u5E74\u8CC7\uFF1A',CIBCInfo_users&&CIBCInfo_users.seniority,'\u5E74'),wp.element.createElement('p',{'class':'p text-primary my-2'},'\u99D0\u9EDE\u6642\u9593\uFF1A',CIBCInfo_users&&CIBCInfo_users.open_at+' - '+CIBCInfo_users.close_at),wp.element.createElement('p',{'class':'p text-primary my-2'},'\u6301\u6709\u8B49\u7167\uFF1A',CIBCInfo_users&&CIBCInfo_users.licenses)));}return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u5EB7\u9054\u76DB\u901A\u4FDD\u96AA\u7D93\u7D00\u4EBA ')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u670D\u52D9\u64DA\u9EDE')))),wp.element.createElement('section',{'class':'pt-5 pb-0'},wp.element.createElement('div',{'class':'basic-tabs-border mb-5'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc'},'\u9996\u9801')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-about'},'\u5EB7\u9054\u76DB\u901A\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:__WEBPACK_IMPORTED_MODULE_8__configs_env__["e" /* ENTERTAIN_LINK */]},'\u516C\u5E73\u5F85\u5BA2')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-service'},'\u670D\u52D9\u9805\u76EE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-partner'},'\u5408\u4F5C\u5925\u4F34')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-activity'},'\u6D3B\u52D5\u526A\u5F71')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link active',href:VC_CONFIG.INDEX_URL+'/cibc-servicepoint'},'\u670D\u52D9\u64DA\u9EDE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-recruit'},'\u4EBA\u624D\u62DB\u52DF'))))),wp.element.createElement('img',{'class':'img-cover',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/servicePoint/cibc_banner.png',alt:''}),wp.element.createElement('section',null,wp.element.createElement('h4',{'class':'heading-title align-items-center'},'\u8ACB\u9EDE\u9078\u5730\u5716\u4E0A\u7684\u5340\u57DF\uFF0C\u67E5\u770B\u5404\u5730\u5206\u5E97'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('svg',{version:'1.1',id:'map-SVG',xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 500 950',style:{enableBackground:'new 0 0 500 950'},xmlSpace:'preserve'},wp.element.createElement('a',{href:' javascript:void(0)'},wp.element.createElement('g',{'class':'area active',id:'north','data-toggle':'tooltip','data-placement':'top',title:'\u5317\u5340'},wp.element.createElement('path',{d:'M433.1,53.2l-0.3,11.3l0.2,2.9l3.5,3.7l-0.4,2.4l-2.4,1.7l-3.8,1.4l-4.9-0.6L415,71.8            l-2.9-2.1l-3.5-3.2l-2.7-3.3l-1.6-3.3l-2.8-3.5l-0.6-2.8l3-2.1l6.8-2.9l4.2-2.8l1.3,0.9l2.3,2.6l3.7,1.3L433.1,53.2L433.1,53.2z'}),wp.element.createElement('path',{d:'M397.5,99l-4,1.6l-5.5-0.1l-4.6-1l-3.5-3.1l-3.6-4.1l-5.5-4.4l-3.7-6.4l1.4-7l-1.1-6l-5.4-5.2            l-3.6-4l1.5-2.8l1.7-2.3l2-4.4l3.4-3.8l10.4-6.1l2.8-2.4l3.8-1.9l3.6,1.1l2,2.1l-0.5,3.4l0.4,3.3l3,6.5l2.4,9.5l3.7,3.3l1.5,4.2            l-1.5,6.3l0.1,4.9l4.4,2.5l3.6,3l-1.9,4.1L397.5,99L397.5,99z'}),wp.element.createElement('path',{d:'M232.9,171.1l-0.2,0.2l-4.4,1l-4.2-1.6l-2.6-3.6l-4.1-2.5l-6.6-2.6l1.1-3.9l5.2-10.8l2.1-2.9            l0.7-1.4v-1.6l-0.7-1.8l-1-2.1l1.4-2.9l1.7-1.7l7.9,3.4l14.4,4.6l5.1,2.7l3.6,3.7l1.8,3.5l-1,3.4l-2.3,1.3l-4.9,0.9l-5.6,2.3            l-3.2,4.1l-2.2,5.4L232.9,171.1z'}),wp.element.createElement('path',{d:'M345.9,204l-2.2,6.2l-1.3,4.5l0.6,4.2l-3.6,5.5L326,237.9l-4.1,10l-2.7-0.8l-10.1,1l-0.8,0.6            l-0.6-4.7l-4.4-7.4l-3.1-3.1l-1.2-4.2l-4.8-3.8l-11.9,3l-4.6-0.5l-6.5,0.5l-7.3,2l-3.9-1l0.9-4.9l1.2-4.4l-1-3.8l-1-2.8l1-2.9            l0.8-3.3l0.3-3.7l-0.7-4.9l-3.7-3.2l-11.5-5.4l-5.7-4.3l-3.7-4.2l-4.2-10.6l2.3-2.9l2.2-5.3l3.2-4.1l5.6-2.3l4.9-0.9l2.3-1.3l1-3.4            l-1.8-3.5l-3.6-3.7l-5.1-2.7l-14.4-4.6l-7.9-3.4l1.4-2.2l0.6-3.7l0.9-2.8l1.9-2.8l2.6-2l2.4-0.9l-0.2-1.1l0.7-2.8l2.1-5.8l2-3.2            l2.9,1l13-1l4.4,2.9l3.8,8.3l4.8,1.9l4.1,1.1l3.9,1.9l6.5,2.1l3.4,4l-1,5.5l3.3,3.5l6.2,2l4,2.9l2.9,2.9l3.6,0.7l3.7-0.3l3.2,3.3            l2.5,4.3l4.1,2.1l3.2,2.5l0.4,4.8l1.5,6.9l-1.8,7.4L314,183l0.5,4.1l4.9,3.7l5.9,3.6l5.2,0.9l3.8,2.8l6.9,3.9L345.9,204L345.9,204z            '}),wp.element.createElement('path',{d:'M415.1,45.8l-4.2,2.8l-6.8,2.9l-3,2.1l0.6,2.8l2.8,3.5l1.6,3.3l2.7,3.3l3.5,3.2l2.9,2.1            l10.1,4.2l4.9,0.6l3.8-1.4l2.4-1.7l0.4-2.4l-3.5-3.7l-0.2-2.9l0.3-11.3l32.9,8l3,1.9l-1.5,3.5l-0.4,2.8l0.7,4.9l2.3,8.3l2.5,3.9            l2.1,0.9l6.7-1l3.4,0.4l4,1l3.5,1.8l1.9,2.4l-8.3,4.1l-0.8-1l-3.1-1.8l-5.6,1.2l-8,4.2l-3.5,2.4l-10.7,2.2l-1.3,2.8l2.4,3.4            l-1.5,3.6l-4.4,2.8l-3.3,1.1l-3.5,1.9l-3.1,3.9l-2.9,4.7l-4.8,3.4l-5.9,1.8l-12.8,7.7l-12.4,5l-3.6,2.2l-4.5,3.8l-1.9,4.7l0.2,4            l1,3l0.4,1.9l-3.7,2.7l-6.3,3l-4.8,3.3l-3.6,3.1l-4.7,1.7l-5.4,1.5l-2.4-5.1l-8.5-8.1l-1.3-5.3l-0.8-4.9l2.9-3.5l1.4-5l-8.1-11.7            l-4.8-1.9l-7,0.4l-4.9-2.8l1.2-6.4l-1-4.9l-5.1-4.9l-1-4.9l1-5.5l-0.2-5.9l3.5-3.8l12.5-3.7l3.1-3.2l1-4l-0.5-3.9l-4.9-7.1l-4-2.1            l-3.9-1l-3-2.7l-4.5-2.9l-6-2.8l-4-4.4l10.7-2l4.6-1.7l5.8-4.9l1.8-0.9l2.1-0.4h2.9l3.3,1l1.8,2.6l1.1,2.6l1.4,1.5l3.3-1.3            l-3.4-5.4l-5.5-5.6l-2.9-1.8l0.9-2.6l1.7-1.4l1.8-0.9l0.8-1l2-4.9l3-5.6l6.3-5.6l9.1-4.7l10.5-2.4l10.3,1.1l4.3,3.2l9.5,13.5l3.4,7            l1.1-0.5l2.6-0.7l2.9-0.4l2.1,0.6l-0.1,0.9l-1,1.2l-1,1.7l0.1,2.1l1,1.1L415.1,45.8L415.1,45.8z M397.5,99l7.2-9.1l1.9-4.1l-3.6-3            l-4.4-2.5l-0.1-4.9l1.5-6.3l-1.5-4.2l-3.7-3.3l-2.4-9.5l-3-6.5l-0.4-3.3l0.5-3.4l-2-2.1l-3.6-1.1l-3.8,1.9l-2.8,2.4L367,46.1            l-3.4,3.8l-2,4.4l-1.7,2.3l-1.5,2.9l3.6,4l5.4,5.2l1.1,6l-1.4,7l3.7,6.4l5.5,4.4l3.6,4.1l3.5,3.1l4.6,1l5.5,0.1L397.5,99L397.5,99z            '}),wp.element.createElement('path',{d:'M363.7,180.5l-2.9,0.9l-5.1,3.7l2.9,11.8l-2.1,3.6l-3.2,1.2l-3.1-0.6l-3.7,1.5l-0.5,1.4            l-4.6-2.1l-6.9-3.9l-3.8-2.8l-5.2-0.9l-5.9-3.6l-4.9-3.7L314,183l4.4-6.2l1.8-7.4l-1.5-6.9l-0.4-4.8l-3.2-2.5l-4.1-2.1l-2.5-4.3            l-3.2-3.3l-3.7,0.3l-3.6-0.7l-3-2.9l-4-2.9l-6.2-2l-3.3-3.5l1-5.5l-3.4-4l-6.5-2.1l-3.9-1.9l-4.1-1.1l-4.8-1.9l-3.8-8.3l-4.4-2.9            l-13,1l-2.9-1l8.5-13.5l6.6-7.9l6.8-5.8l17.5-5.8l4.1-2.6l3.5-3l4.3-2.4l8.6-3l19.1-3.4l4,4.4l6,2.9l4.5,2.9l3,2.7l3.9,1l4,2.1            l4.9,7.1l0.5,3.9l-1,4l-3.1,3.2l-12.5,3.7l-3.5,3.8l0.2,5.9l-1,5.5l1,4.9l5.1,4.9l1,4.9l-1.2,6.4l4.9,2.8l7-0.4l4.8,1.9l8.1,11.7            l-1.4,5l-2.9,3.5l0.8,4.9l1.3,5.3l8.5,8.1L363.7,180.5L363.7,180.5z'}),wp.element.createElement('path',{d:'M433.7,278.2h-1l-10.6-1.6L404.5,266l-3.6,0.9l-2.3,5.7l-4.7,4.3h-6.2l-7.9-3l-14.3-3.6            l-6.2-2.9l-2.4-2l-5.6-4.5h-4.7l-4.5,2.2l-3.8,0.6l-3.5-2.4l-4.2-2.5l-4.7-1l-1.3-3.6l0.6-5.2l-3.4-1l4.1-10l13.3-13.5l3.6-5.5            l-0.6-4.2l1.3-4.5l2.2-6.2l0.5-1.4l3.7-1.5l3.1,0.6l3.2-1.2l2.1-3.6l-2.9-11.8l5.1-3.7l2.9-0.9l5.4-1.5l4.7-1.7l3.6-3.1l4.8-3.3            l6.3-3l3.7-2.7l-0.4-1.9l-1-3l-0.2-4l1.9-4.7l4.5-3.8l3.6-2.2l12.4-5l12.8-7.7l5.9-1.8l4.8-3.4l2.9-4.8l3.1-3.9l3.5-1.9l3.3-1.1            l4.4-2.8l1.5-3.6l-2.4-3.4l1.3-2.8l10.7-2.2l3.5-2.4l8-4.2l5.6-1.2l3.1,1.8l0.8,1l-11.4,5.7l-5.2,4.5l-17.8,21.7l-2.8,4.6l-2.2,6.5            l-1.5,7.3l-0.5,7.2l0.3,7l3.1,14.7l-0.2,3.8l-1.4,3.7l0.2,7.7l3.3,6l6.2,3.8l7.2,1.3v1.7l-3-0.3l-2.9,0.3l-2.5,0.8l-1.8,1.3            l2.6,4.8l1.2,6.2l-0.8,5.3l-5.7,3.2l-0.4,2.4l0.7,2.9l1.6,2.6l0.6,2.7l-2.4,2.3l-5.9,3.4l-6.7,7.6l-0.3,3l0.5,6.7l-1.1,2.5            l-1.2,2.2l-0.8,3l-0.5,6.1l-0.6,1.5l-1,1.2l-0.5,1.3L433.7,278.2z'}),wp.element.createElement('path',{d:'M433.7,278.1l0.6,0.8l1.5,2.8l0.2,1l-1.3,2.3l-5.5,5.4l-5.9,8.2l-4.5,3.5l-1.3,1.9l0.7,2            l-0.9,1.4l-6.3,4.9l-2.4,2.3l-2.7,5.7l-2.8,11.6l-7,10.4l-1.4,4.2l0.2,4.5l1.7,4.9l1.4,2.2l1.2,1l0.8,1.3l0.1,3l-1,3.4l-3.5,5.5            l-0.7,3.3l-0.4,6.1l-3,15.5l-6.1,16.2l-7.6,38.1l-4.6,9.3l-10.5,61l-3.3-1l-10.3,4.9l-3.7,5.1l1.6,6.6l0.6,6.6l-3.4,6.6l-3.2,4.9            l-2.6,6.3l-2.3,8l-3.5,7.3l-4.6,12.6l-2.9,5.8l0.1,6.4l-0.9,5.9l-6.2,3.5l-7.8-1l-11.2-9.2l-8.8-15.2l-5.4-1.4l-6-0.9l-4.8-4.6            l-5.8-2.8l-7.4-2.7l-4.8-7.7l-1.1-7l-0.3-2.4l-2.7-7.2l-6-4.9l-5.3-3.4l-1-3.8l1.3-3l5.3-2.3l2.9-4.8l-1.8-5.5l5.7-3.3l2.9-2.7            l-1.6-5.9l1.4-2.6l1.4-3.8l4.9-3.7l7-1.5l7-0.3l5-4.5l1.2-8.1l3.8-4.9l7.2-2.7l4.3-2.9l1.5-4.9l3-12l1.1-8l-0.9-6.8l-1.1-5.1            l-3-3.9l-2-3.8l5.4-8.9l0.2-3.5l2.4-6.7l3.7-8.1l2.9-8.4l1.5-9.4l0.6-7.2l-1.7-4.3l-1.9-3.1l2.2-7.2l4.9-10.2l7.6-9.9l0.3-3.7            l-1.4-4.3l-4.9-3.2l-2.8-2.9l-0.2-9.4l3.5-2.8l6.3-2.1l4.9-2.3l-0.2-3.5l-1.3-5.9l2.7-1.9l1.1-2l3.2-1.6l2.9-3.6l1.2-4.9l2.9-4.8            l7.1-4.5l2.3-5.9l0.4-4l4.5-4.7l2.4,2l6.2,2.9l14.3,3.6l7.9,3h6.2l4.7-4.3l2.3-5.7l3.6-0.9l17.6,10.6l10.6,1.6L433.7,278.1z'}))),wp.element.createElement('a',{href:' javascript:void(0)'},wp.element.createElement('g',{'class':'area',id:'south','data-toggle':'tooltip','data-placement':'bottom',title:'\u5357\u5340'},wp.element.createElement('path',{d:'M247.6,521.5l1.8,5.5l-2.9,4.8l-5.3,2.3l-1.3,3l1,3.8l5.3,3.4l6,4.9l2.7,7.2l0.3,2.4            l-14.8,3.6l-6.1,3.9l-3.8,3.7l-7.4,4.9l-0.9,5.4l2.2,5.7l-2.6,4.7l-7,3.8l-0.8,6.6l2,9.4l-2.9,12.6l-0.1,10.7l-4.1,5.6l-8.1,6.8            l-2.2,9.3l1.2,7.7l2.9,4.4l5.9,6.1l1.1,4.7l-3.7,0.5l-4.9-0.9l-4.1,0.2l-8.1,6.4l-5.6-5.2l-7.2-8.5l-6.8,1.7l-6.3,5.6l-12.5-6.3            l-8.9,4.3l-6.1,6.8l-7.6,2.7l-16.9-1l-1.6,4.7l-1.2,6.8l-2.5,7.5l0.5,6.7l-0.1,9l-5.4,20.2l-0.1,6.8l2.6,7.1l0.4,7.8l-7.7,19.5            l-2.5-1l-1.5,0.1l-1.7,0.7h-2.1l-12.4-9.7L64,754.3L76.1,769l-1.4-7l-3.6-6.8l-5-5.7l-8.6-8l-3.3-4l-1.5-4.6l2.1-4.4l1-3.9            l-1.4-5.5l-2.6-5.3l-4.7-7.3l-4.4-9.7l-1-4.3l0.1-2.9l1.4-3.4l0.3-2.3l-0.5-1.1l-2.6-2.2l-0.5-2.2l-2.8-4.7l-0.7-1.9l-2-12.9            l5.8-3.5l0.2,0.5l3.7,8.2l4.6,2.4l14.9,2.1l7.8-0.9l8,1l4-1.4l3.3-2.5l6.2-2.5l6-4.2l2.3-5.2l2.9-4.9l5-6.8l5.8-6.1l6.2-5.1l7-6.8            l6.2-8l9.5-16.2l9.9-14.4l2.2-6.3l-1-6.4l-1.3-4.3l0.1-4.8l3.4-3.3l6.6,0.7l5.5-0.6l11.7-6.9l4.3-5.1l7.5-5.8l7.3-4.1l4-4.8            l3.4-6.5l8.1-6.5l17.6-8.9l4.1,1l5.5,2.1l4,5.6L247.6,521.5L247.6,521.5z'}),wp.element.createElement('path',{d:'M206.1,678.8l3.3,6.3l0.7,4.7l5.1,1.2l5.2,3.4l-2.7,13.1l-0.1,4.9l-1.9,4.8l-9.3,3.9l-4.6,2.6            l-7.2,1.5l-5.1,4.3l-2.3,6.3l-3.5,6.3l-2.9,7.1l-0.8,14l1.1,6.2l1.9,5.8l1,6.8v5.1l2.5,4.8l4.4,5.3l-2.4,3.6l-5,3l-2,3.7l-0.5,4.3            l2.6,3.7l3.2,1.6l2.9,4.2l-0.1,5.4l0.6,5.8l3,5.6l4.4,4.7l9.7,4.5l4.3-0.3l0.9,49.1l-1.5,6.9l-2.4,5.7l-3.2,2.4l-3.8,3.5l0.1,7.9            l1.4,8.8l-0.4,5.6l-4.3-6.5l-6.5-4.9l-7.4-3.3l-7.6-1.8l-0.3,6.3l-2.2,2.2l-3.2-0.8l-3.5-2.9l-0.2-2.3l1.2-6.7l-5.2-8.8l-0.5-2.3            l0.1-2l0.4-3v-10.3l0.5-2.9l2.4-3.4l0.5-2.9L148,831.5l-1.5-2.8l-5.2-6.5l-4.2-9.4l-1.9-2.7l-7.8-6.2l-5.1-2.9l-0.9-3.5l-0.7-1.2            l-4.2-2.8L107,789l-4.3-2.9l-4.6-4l-2.5-1.5l7.7-19.5l-0.4-7.8l-2.6-7.1l0.1-6.8l5.4-20.2l0.1-9l-0.5-6.7l2.5-7.5l1.2-6.8l1.6-4.7            l16.9,1l7.6-2.7l6.1-6.8l8.9-4.3l12.5,6.3l6.3-5.6l6.8-1.7l7.2,8.5l5.6,5.2l8.1-6.4l4.1-0.2L206.1,678.8z'}),wp.element.createElement('path',{d:'M156.1,578.2l-2.2,6.3l-9.9,14.4l-9.5,16.2l-6.2,8l-7,6.8l-6.2,5.1l-5.8,6.1l-5,6.8l-2.9,4.9            l-2.3,5.2l-6,4.2l-6.2,2.5l-3.3,2.5l-4,1.4l-8-1l-7.8,0.9l-14.9-2.1l-4.6-2.4l-3.7-8.2l-0.2-0.5l-5.8,3.5l-1-6l-1.7-3.4l-3.7-3.7            l4.5-3.2l2.6-5.8l-1-4.9l-6-0.9l-1.1,1.7l-1,3.2l-1.7,2.6l-3.1-0.1l-1.2-2.2l0.5-6.7l-0.8-2.3l-3.9-1.7l-2.2,2l-1.7,2.8l-2.7,0.7            l-2.8-2.4l-0.7-3.3l0.7-3.2l1-2.2l2.9-1.5l3.5-0.5l2.9-1l1-2.9l-1.3-1.4l-8.9-2.3v-1.8l7.5-0.1l-0.8-2.5l-4.1-3.5l-2.7-3l0.7-3.8            l2.4-1.4l2.6-0.9l1.3-2.4l-0.8-3.7l-1.3-3l0.9-2.9l1.3-3.5l2.2-2.5l-0.5-2.2l0.5-2.2l3.1-8.6l1.5-1.6l2.5-0.6l-3.5-2.4l1.5-3.9            l4.9,1.9l8.5,1.2l6.8,1.7l5.9-2.7l2.4-4.7l5.5-3.4l6.3-4.9l4.5-4.6l5.8-4.4l7.4-3.3l14.5-2.7l8.1-0.5l6.8,2.3l3.8,2.3l2,4l1.6,4.9            l9.4,9.6l0.9,7.1l-1.7,13.5l1.5,4.4l4.3,3.3h3.6l5-2.3l4.8-0.6l3.5,1L156.1,578.2z'}),wp.element.createElement('path',{d:'M211.8,847l-4.3,0.3l-9.7-4.5l-4.4-4.7l-3-5.6l-0.6-5.8l0.1-5.4l-2.9-4.2l-3.2-1.6l-2.6-3.7            l0.5-4.3l2-3.7l5-3l2.4-3.6l-4.4-5.3l-2.5-4.8v-5.1l-1-6.8l-1.9-5.8l-1.1-6.2l0.8-14l2.9-7.1l3.5-6.3l2.3-6.3l5.1-4.3l7.2-1.5            l4.6-2.6l9.3-3.9l1.9-4.8l0.1-4.9l2.7-13.1l-5.2-3.4l-5.1-1.2l-0.7-4.7l-3.3-6.3l3.7-0.5l-1.1-4.7l-5.9-6.1l-2.9-4.4l-1.2-7.7            l2.2-9.3l8.1-6.8l4.1-5.6l0.1-10.7l2.9-12.6l-2-9.4l0.8-6.6l7-3.8l2.6-4.7l-2.2-5.7l0.9-5.4l7.4-4.9l3.8-3.7l6.1-3.9l14.8-3.6            l1.1,7l4.8,7.7l7.4,2.7l5.8,2.8l4.8,4.6l6,0.9l5.4,1.4l8.8,15.2l11.1,9.2l7.8,1l6.2-3.5l0.9-5.9l-0.1-6.4l2.9-5.8l4.6-12.6l3.5-7.3            l2.3-8l2.6-6.3l3.2-4.9l3.4-6.6l-0.6-6.6l-1.6-6.6l3.7-5.1l10.3-4.9l3.3,1l-4.4,25.1l-2.1,4.7l-6.8,8.9l-2.5,4.7l-2,5.8l-1.4,10.8            l0.2,9.7l-1,9.2l-4.7,9.4l-2,2l-4.5,3.3l-2.1,2.1l-1,2.2l-1.6,5.5l-4.6,8l-2.8,12.5l-2,5.6l-9.8,14.1l-1.2,2.6l-13.2,11.2l-3.1,3.6            l-0.4,2.6l0.6,5.9l-0.2,2.7l-1.1,3l-2.1,3.3l-4.5,5.8l-4.5,4.3l-15.3,10.2L252.6,732l-2.6,1.3l-2,2.6l-4.9,12.8l-2.5,4.8L233,763            l-3.1,5.7l-1.8,11.7l-4.6,16l-9,15.9l-1.3,5.4l-1.6,15.3L211.8,847z'}))),wp.element.createElement('a',{href:' javascript:void(0)'},wp.element.createElement('g',{'class':'area',id:'west','data-toggle':'tooltip','data-placement':'right',title:'\u4E2D\u5340'},wp.element.createElement('path',{d:'M159.5,361.9l0.1,3.4l-4.1,1.5l-1.1,2.8l0.5,3.8l-1.9,4.4l-1.5,5.1l-0.1,5.4l-1.1,6.3            l-0.9,12.7l2,6l3.4,3.1l3.7,1.3l5.3,2.8l-1,3.3l-3.6,1.4l-2.4,2.2l-2.3,1.5l-1,0.7l-11.4-2.3l-5.5,0.1l-11.6-5.7l-18.7-2.2l-11-4.2            l-6.3-1.7l-7.2-0.4l-20.9,2.5l-7.2-4.2l0.8-1.3l1.5-6.8l1.1-2.9l6.8-6.5l1.9-2.7l2.6-7.4l4-7.3l5.4-15.3l2.6-4.5l2.9-2.9l2.4-1.6            l2.1-1l1.5-1.3l0.6-2.9l1.1-2.7l4.9-3.8l1.1-2.9l0.6-9.6l0.9-2.7l2.6-2.5l10.7-12.6l5.5,1.8l3.8,3.3l2.6,6l1,7.2l4.3,5.1l11.3,3.3            l4.1,3.4l3,4.8l1.9,3.8l0.1,3.8l1.1,3.1l4.1,0.8l5.1,3.3L159.5,361.9L159.5,361.9z'}),wp.element.createElement('path',{d:'M328.7,303l1.3,5.9l0.2,3.5l-4.9,2.3l-6.3,2.1l-3.5,2.8l0.2,9.4l2.8,2.9l4.9,3.2l1.4,4.3            l-0.3,3.7l-7.6,9.9l-4.9,10.2l-2.2,7.2l1.9,3.1l1.7,4.3l-0.6,7.2l-1.5,9.4l-2.9,8.4l-3.7,8.1l-2.4,6.7l-0.2,3.5l-5.4,8.9l2,3.8            l3,3.9l1.1,5.1l0.9,6.8l-1.1,8l-3,12l-1.5,4.9l-4.3,2.9l-7.2,2.7l-3.8,4.9l-1.2,8.1l-5,4.5l-7,0.3l-7,1.5l-4.9,3.7l-1.4,3.8            l-1.4,2.6l1.6,5.9l-2.9,2.7l-5.7,3.3l-0.7-1.9l-4-5.6l-5.5-2.1l-4.1-1l-0.9-0.2l-24.4-0.2l-7.2-1.3l-1-3.6l-0.4-5.6l-2.6-6.2            l-1.1-4.6l2.9-4.9l0.3-5l-4.9-2.7l-3.9-1.1l-6.5-2.5l-5.8-0.7l-2.5-3.3l-7.8,0.9l-6.5,1.9l-5.5-2.4l-3.8-4.5l0.9-5.4l1.8-4.9            l-1-7.3l1-6.8l1.9-4.5l-1.8-6.8l2.3-1.5l2.4-2.2l3.6-1.4l1-3.3l-5.3-2.8l-3.7-1.3l-3.4-3.1l-2-6l0.9-12.7l1.1-6.3l0.1-5.4l1.5-5.1            l1.9-4.4l-0.5-3.8l1.1-2.8l4.1-1.5l-0.1-3.4l4.1,0.2l17,2.4l4-0.6l4.8-4.6l7.2-13.7l3.5-8.1l6.1-2.9l9.6,1.3l5.7-0.2l5.5-7.3            l2.9-1.8l8.5,6.4l3.3-0.9l2.5-5.2l4.5-3.7l6.3,0.1l4.8-1.8l7.5-7.2l4.9-2.8l4.2-0.8l8.4-4.5l5.9-0.2l6-1l10.6-4.2l4.4-0.3l4.5,1            L328.7,303L328.7,303z'}),wp.element.createElement('path',{d:'M308.4,248.7l0.8-0.6l10.1-1l2.7,0.8l3.4,1l-0.6,5.2l1.3,3.6l4.7,1l4.2,2.5l3.5,2.4l3.8-0.6            l4.5-2.2h4.7l5.6,4.5l-4.5,4.7l-0.4,4l-2.3,5.9l-7.1,4.5l-2.9,4.8l-1.2,4.9l-2.9,3.6l-3.2,1.6l-1.1,2l-2.7,1.9l-12.7-1.2l-4.5-1            l-4.4,0.3l-10.6,4.2l-6,1l-5.9,0.2l-8.4,4.5l-4.2,0.8l-4.9,2.8l-7.5,7.2l-4.8,1.8l-6.3-0.1l-4.5,3.7l-2.5,5.2l-3.3,0.9l-8.5-6.4            l-2.9,1.8l-5.5,7.3l-5.7,0.2l-9.6-1.3l-6.1,2.9l-3.5,8.1l-7.2,13.7l-4.8,4.6l-4,0.6l-17-2.4l-4.1-0.2v-1.3l-5.1-3.3l-4.1-0.8            l-1.1-3.1l-0.1-3.8l-1.9-3.8l-3-4.8l-4.1-3.4l-11.3-3.3l-4.3-5.1l-1-7.2l-2.6-6l-3.8-3.3l-5.5-1.8l0.6-0.8l0.8-3.1l3.1-2.6l2.1-6.2            l2.6-11.7l8.8-15.3l2.7-9.4l3.2-5.2l12.7-14.1l8.8,13.6l4.5,4.8l6,5.2l14.4,10.6l6.9,3.4l6.3,1.1l11,6.4l11.5-0.7l4.9-2.7l0.9-7            l5.2-3.1l9.4,0.8l5.7,2.3l4.8,5.3l5.1,2l8.5-4.5l6.5-2.8l11-8.8l5.6-3l4.4-4.2l4-2.9l5,0.1l4.7-1.9l1.7-5.3L308.4,248.7            L308.4,248.7z'}),wp.element.createElement('path',{d:'M154.6,429.1l1.8,6.8l-1.9,4.5l-1,6.8l1,7.3l-1.8,4.9l-0.9,5.4l3.8,4.5l5.5,2.4l6.5-1.9            l7.8-0.9l2.5,3.3h-0.5l-0.3,4.8v3.2l-3.8,1.2l-11.1,2.3l-6,0.6l-2.3-3.7l-4.5-3.2l-7.9,2.3l-3.5,0.5l-12-4.4l-4.8-5.6l-5-4.4            l-6.6,0.4l-12,2.2l-6.8,1.9l-15.5,8.9l-3.6,3.6l-4.2,2.3l-6.7,5.4l-5,0.8l-2,2.9l-1.6,4.7l-3.7,3l-5.8-0.1l-7.9-4.5l-11,1.3            l4.4-4.9L28,478.2l0.7-11.7l2.7-9.3l4.1-7.3l1.2-9.5l2.2-8.4l1.2-2.9l5.8-7.7l1-2.7l0.7-1.4l5.3-4.1l0.8-1.5l7.2,4.2l20.9-2.5            l7.2,0.4l6.3,1.7l11,4.2l18.7,2.2l11.6,5.7l5.5-0.1l11.4,2.3L154.6,429.1L154.6,429.1z'}),wp.element.createElement('path',{d:'M232.9,171.1l4.2,10.6l3.7,4.2l5.7,4.3l11.5,5.4l3.7,3.2l0.7,4.9l-0.3,3.7l-0.8,3.3l-1,2.9            l1,2.8l1,3.8l-1.2,4.4l-0.9,4.9l3.9,1l7.3-2l6.5-0.5l4.6,0.5l11.9-3l4.8,3.8l1.2,4.2l3.1,3.1l4.4,7.4l0.6,4.7l-3.5,2.5l-1.7,5.3            l-4.7,1.9l-5-0.1l-4,2.9l-4.4,4.2l-5.6,3l-11,8.8l-6.5,2.8l-8.5,4.5l-5.1-2l-4.8-5.3l-5.7-2.3l-9.4-0.8l-5.2,3.1l-0.9,7l-4.9,2.7            l-11.5,0.7l-11-6.4l-6.3-1.1l-6.9-3.4L167.3,266l-6-5.2l-4.5-4.8l-8.8-13.6l6.8-7.7l1.8-3.8l0.9-6.3l2.1-5.3l5.6-9.9l1.5-6l1.4-2.6            l6.5-1.9l1.8-2l1-2.5l1.3-2.4l4-4.1l4.4-3.2l5.3-1.4l6.8,1.2l-0.9-5.1l2.6-3.5l3.5-3.6l1.8-5.4l0.8-1.8l3.4-1.7l0.3-1.2l6.6,2.6            l4.1,2.5l2.6,3.6l4.2,1.6l4.4-1L232.9,171.1L232.9,171.1z'}),wp.element.createElement('path',{d:'M177.9,472.4l5.8,0.7l6.5,2.5l3.9,1.1l4.9,2.7l-0.3,5l-2.9,4.9l1.1,4.6l2.6,6.2l0.4,5.6l1,3.6            l7.2,1.3l24.4,0.2l0.9,0.2l-17.6,8.9l-8.1,6.5l-3.4,6.5l-4,4.8l-7.3,4.1l-7.5,5.8l-4.3,5.1l-11.7,6.9l-5.5,0.6l-6.6-0.7l-3.4,3.3            l-0.1,4.8l1.3,4.3l1,6.4l-8-1l-3.5-1l-4.8,0.6l-5,2.3h-3.6l-4.3-3.3l-1.5-4.4l1.7-13.5l-1-7.1l-9.4-9.6l-1.6-4.9l-2-4l-3.8-2.3            l-6.8-2.3l-8.1,0.5l-14.5,2.7l-7.4,3.3l-5.8,4.4l-4.5,4.6l-6.3,4.9l-5.5,3.4l-2.4,4.7l-5.9,2.7l-6.8-1.7l-8.5-1.2l-4.9-1.9l3.6-0.3            l3.1-1.3l1.3,0.5l-0.9-3l-2.1,1.5l-1.7-0.5l-2.4-0.1v-3.1l2.3-5.3l3.5-0.3l5.1,0.1l-3.5-10l-3.9-7.6l1.8-3.5V519l-2.9-1.4l0.4-1.7            l1.7-1.9l0.9-2.5l3.8-4.9L24,507l-0.2-8.3l11-1.3l7.9,4.5l5.8,0.1l3.7-3l1.6-4.7l2-2.9l5-0.8l6.7-5.4l4.2-2.3l3.6-3.6l15.5-8.9            l6.8-1.9l12-2.2l6.6-0.4l5,4.4l4.8,5.6l12,4.4l3.5-0.5l7.9-2.3l4.5,3.2l2.3,3.7l6-0.6l11.1-2.3l3.8-1.2v-3.2l0.3-4.8L177.9,472.4z'}))),wp.element.createElement('a',{href:' javascript:void(0)'},wp.element.createElement('g',{'class':'area',id:'east','data-toggle':'tooltip','data-placement':'left',title:'\u6771\u5340'})))),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(options.store_groups,function(item){if(item.name=='北北區'){return wp.element.createElement('div',{'class':'col-lg-9 ',id:'north_stores'},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-primary d-none d-lg-block'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},'\u5317\u5340')))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(storeInfo.filter(function(item){return item.store_group_name=='北北區'||item.store_group_name=='北南區';}),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popover___default.a,{mouseEnterDelay:'0.5',placement:'left',id:'item.id',content:content,title:'\u670D\u52D9\u4EBA\u54E1\u8CC7\u8A0A'},wp.element.createElement('div',{onMouseEnter:function onMouseEnter(){_this2.loadCIBC(item.id);}},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-white d-block text-decoration-none'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.cibc_address,wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.cibc_address,target:'_blank'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'})));}));}else if(item.name=='中區'){return wp.element.createElement('div',{'class':'col-lg-9 ',style:{display:'none'},id:'west_stores'},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-primary d-none d-lg-block'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},'\u4E2D\u5340')))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(storeInfo.filter(function(item){return item.store_group_name=='中區';}),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popover___default.a,{placement:'rightTop',id:'item.id',content:content,title:'\u670D\u52D9\u4EBA\u54E1\u8CC7\u8A0A'},wp.element.createElement('div',{onMouseEnter:function onMouseEnter(){_this2.loadCIBC(item.id);}},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-white d-block text-decoration-none'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.address,wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'})));}));}else if(item.name=='南區'){return wp.element.createElement('div',{'class':'col-lg-9 ',style:{display:'none'},id:'south_stores'},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-primary d-none d-lg-block'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},'\u5357\u5340')))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(storeInfo.filter(function(item){return item.store_group_name=='南區';}),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popover___default.a,{placement:'rightTop',id:'item.id',content:content,title:'\u670D\u52D9\u4EBA\u54E1\u8CC7\u8A0A'},wp.element.createElement('div',{onMouseEnter:function onMouseEnter(){_this2.loadCIBC(item.id);}},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-white d-block text-decoration-none'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.address,wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'})));}));}else{return wp.element.createElement('div',{'class':'col-lg-9 ',style:{display:'none'},id:'east_stores'},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-primary d-none d-lg-block'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},'\u6771\u5340')))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(storeInfo.filter(function(item){return item.store_group_name=='東區';}),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_popover___default.a,{placement:'rightTop',id:'item.id',content:content,title:'\u670D\u52D9\u4EBA\u54E1\u8CC7\u8A0A'},wp.element.createElement('div',{onMouseEnter:function onMouseEnter(){_this2.loadCIBC(item.id);}},wp.element.createElement('div',{'class':'p-4 px-md-5 bg-white d-block text-decoration-none'},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-lg-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.address,wp.element.createElement('a',{'class':'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{'class':'ml-3',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/google_map.svg',alt:''})))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'})));}));}})))));}}]);return CIBCServicePoint;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);// 編輯器
var CIBCServicePointEditor=function(_Component2){_inherits(CIBCServicePointEditor,_Component2);function CIBCServicePointEditor(){_classCallCheck(this,CIBCServicePointEditor);return _possibleConstructorReturn(this,(CIBCServicePointEditor.__proto__||Object.getPrototypeOf(CIBCServicePointEditor)).apply(this,arguments));}_createClass(CIBCServicePointEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return CIBCServicePointEditor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);window.onload=function(){var tab_li=document.getElementsByTagName('g');for(var i=0;i<tab_li.length;i++){tab_li[i].index=i;tab_li[i].onclick=function(){//var content = document.getElementById(this.id + "_stores");
var content_remove;for(var j=0;j<tab_li.length;j++){content_remove=document.getElementById(tab_li[j].id+'_stores');tab_li[j].classList.remove('active');__WEBPACK_IMPORTED_MODULE_6_jquery___default()("[id$='_stores']").attr('style','display:none');}this.setAttribute('class',' area active');__WEBPACK_IMPORTED_MODULE_6_jquery___default()('#'+this.id+'_stores').show();};}};

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FeedBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FeedBackEditor", function() { return FeedBackEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_ExclamationCircleOutlined__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_ExclamationCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_ExclamationCircleOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_module_scss__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_NavTab_NavTab__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__queryOptions_json__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__queryOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__queryOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__queryOptionsDev_json__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__queryOptionsDev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__queryOptionsDev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__queryTargetOptions_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__queryTargetOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__queryTargetOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__querySubjectOptions_json__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__querySubjectOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__querySubjectOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__retailChannelOptions_json__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__retailChannelOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__retailChannelOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_libs_wjson__ = __webpack_require__(85);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(window,'VC_CONFIG',{});var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var FeedBack=function(_Component){_inherits(FeedBack,_Component);function FeedBack(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FeedBack);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FeedBack.__proto__||Object.getPrototypeOf(FeedBack)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_13_react___default.a.createRef(),_this.state={value1:null,value2:null,value3:null,URLQuery:{},isSubmitData:false},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var SerialID=__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(_this,'state.URLQuery.sid');var Var_Number=__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(_this,'state.URLQuery.nid');console.log('submitData-3',SerialID,Var_Number);if(!SerialID||!Var_Number){__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal___default.a.error({title:'序號遺失，請與客服中心聯絡'});}else{info.SerialID=SerialID;info.Var_Number=Var_Number;console.log('submitData-2',info);///feedback?nid=Web2018011000999&sid=CCFS2018011000814
_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_19__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_18__configs_env__["b" /* API_HOST */]+'/api/contactus/custFeedBack',info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal___default.a.error({content:'送出失敗，請稍後再試'});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal___default.a.success({content:'送出成功，感謝您填寫資料',onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FeedBack,[{key:'componentDidMount',value:function componentDidMount(){var Query=__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].getURLQuery();this.setState({URLQuery:Query});console.log('test',__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].getURLQuery());}},{key:'render',value:function render(){var _this2=this;var options=[{label:'非常滿意',value:1},{label:'滿意',value:2},{label:'普通',value:3},{label:'不滿意',value:4},{label:'非常不滿意',value:5}];var _state=this.state,value1=_state.value1,value2=_state.value2,value3=_state.value3;var antIcon=wp.element.createElement('img',{id:'loadingImg',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/logo/loading.gif',alt:''});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light',id:'feedbackmain'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,{style:{width:'100%',height:'100%'},spinning:this.state.isSubmitData,size:'large',indicator:antIcon},wp.element.createElement('div',{'class':'container',id:'feedback'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u63D0\u4F9B\u610F\u898B')))),wp.element.createElement('h4',{'class':'heading-title align-items-center'},'\u63D0\u4F9B\u610F\u898B'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){_this2.submitData(values);}//onFieldsChange={(changedFields, allFields) => {
//     console.log('onFieldsChange', _.reduce(allFields, (r, i) => {
//       r[i.name.join('.')] = i.value
//       return r
//    }, {}),changedFields, allFields)
//  }
// }
},wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{'class':'h4 text-navy text-center'},'\u56DE\u8986\u6EFF\u610F\u5EA6 *')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Whole'),{rules:[{required:true,message:'請選擇回覆滿意度'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,{options:options,onChange:function onChange(e){_this2.setState({value1:e.target.value},function(){console.log('value 1 :',_this2.state.value1);});},value:value1})))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{'class':'h4 text-navy text-center'},'\u56DE\u8986\u901F\u5EA6 *')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Reply'),{rules:[{required:true,message:'請選擇回覆速度滿意度'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,{options:options,onChange:function onChange(e){_this2.setState({value2:e.target.value},function(){console.log('value 2 :',_this2.state.value2);});},value:value2})))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{'class':'h4 text-navy text-center'},'\u670D\u52D9\u6C34\u6E96 *')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Service'),{rules:[{required:true,message:'請選擇服務水準滿意度'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_radio___default.a.Group,{options:options,onChange:function onChange(e){_this2.setState({value3:e.target.value},function(){console.log('value 3 :',_this2.state.value3);});},value:value3})))))),wp.element.createElement('div',{'class':'row justify-content-center',id:'feedbackbotton'},wp.element.createElement('div',{'class':'col-sm-2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',size:'large',onClick:function onClick(e){__WEBPACK_IMPORTED_MODULE_12_antd_lib_modal___default.a.confirm({icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_ExclamationCircleOutlined___default.a,null),title:'注意',content:wp.element.createElement('div',null,wp.element.createElement('p',null,'\u60A8\u6240\u586B\u5BEB\u7684\u8CC7\u6599\u5C07\u4E0D\u5132\u5B58'),wp.element.createElement('p',null,'\u60A8\u78BA\u5B9A\u96E2\u958B\u6B64\u9801\u9762\u55CE\uFF1F')),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}},'\u3000\u53D6\u6D88\u3000')),wp.element.createElement('div',{'class':'col-sm-1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',size:'large',onClick:function onClick(e){e.preventDefault();_this2.formRef.current.submit();}},'\u78BA\u8A8D\u9001\u51FA'))))))));}}]);return FeedBack;}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);// 編輯器
var FeedBackEditor=function(_Component2){_inherits(FeedBackEditor,_Component2);function FeedBackEditor(){_classCallCheck(this,FeedBackEditor);return _possibleConstructorReturn(this,(FeedBackEditor.__proto__||Object.getPrototypeOf(FeedBackEditor)).apply(this,arguments));}_createClass(FeedBackEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return FeedBackEditor;}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"code":"","name":"客服建議","items":[{"code":"ec66bd66-1428-40bf-be14-b6243bda0e26","name":"建議查詢  Inquiry","id":"1","items":[{"name":"產品查詢 / 建議Product Inquiry/ Suggestion","id":1,"items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"27"},{"name":"生鮮商品Fresh","id":"28"},{"name":"家用百貨/五金類商品Bazzar","id":"29"},{"name":"家電商品Appliance","id":"30"},{"name":"紡織/鞋子商品Textile","id":"31"}]},{"id":2,"name":"服務品質 Service Quality","items":[]},{"id":3,"name":"安全作業 Security Process","items":[]},{"id":4,"name":"網站類別Website","items":[]},{"id":5,"name":"廠商來信Supplier Inquiry","items":[]},{"id":6,"name":"詐騙電話Telefraud","items":[]},{"id":7,"name":"新店訊息New Store Information","items":[]},{"id":8,"name":"鼓勵員工 Thanks for our staff","items":[]},{"id":10,"name":"人力資源 HR","items":[]},{"id":11,"name":"贊助需求 Sponsor request","items":[]},{"id":12,"name":"好康卡 Loyalty","items":[]},{"id":13,"name":"聯邦銀行 UB","items":[]},{"id":14,"name":"其他 Others","items":[]},{"id":15,"name":"產品查詢 / 建議Product Inquiry/ Suggestion","items":[]},{"name":"欲成為合作廠商來信Supplier Inquiry","id":"16","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"32"},{"name":"生鮮商品Fresh","id":"33"},{"name":"家用百貨/五金類商品Bazzar","id":"34"},{"name":"家電商品Appliance","id":"35"},{"name":"紡織/鞋子商品Textile","id":"36"}]},{"id":17,"name":"詐騙電話Telefraud","items":[]},{"id":18,"name":"其他 Others","items":[]},{"id":35,"name":"會員卡相關問題 Member Card","items":[]},{"id":36,"name":"電信相關問題telecom","items":[]},{"id":38,"name":"大陸來信Letter From China","items":[]},{"id":41,"name":"玉山銀行 E_Sun Bank","items":[]},{"id":44,"name":"購物中心 Shopping Mall","items":[]},{"id":46,"name":"電子商務 App","items":[]},{"id":48,"name":"電子發票 E Invoice","items":[]},{"id":50,"name":"活動企劃 Campaign","items":[]},{"id":51,"name":"財務相關 Finance","items":[]},{"id":59,"name":"價格相關 Price issue","items":[]},{"id":60,"name":"環保相關 Environmental concerns","items":[]},{"id":61,"name":"賣場營運建議 Operation suggestion","items":[]},{"id":63,"name":"營業時間 / 分店確認 Business hour / store","items":[]},{"id":65,"name":"線上購物Online shopping test","items":[]},{"id":68,"name":"購物商城 Market place","items":[]}]},{"code":"7ee77de0-6698-4a15-86d8-61f9ddd53435","name":"問題反映 Suggestion/Complaint","id":"2","items":[{"name":"線上購物Online Shopping","id":70,"items":[]},{"name":"服務品質Service Quality","id":"30","items":[]},{"name":"產品品質/價格相關問題Product Quality","id":"31","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"name":"安全檢查/停車相關問題Security&Parking","id":"32","items":[]},{"name":"會員卡相關問題 Member Card","id":"33","items":[]},{"name":"其他Others","id":"34","items":[]}]},{"code":"7fc29946-b0a3-452b-9e80-a0b1b3b38822","name":"感謝函 Praise","id":"3","items":[{"name":"鼓勵員工 Thanks for our staff","id":55,"items":[]}]}]},{"id":2,"code":"","name":"新品推薦","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":3,"code":"","name":"缺貨回報","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":4,"code":"","name":"買貴回報","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"id":5,"code":"","name":"服務建議","items":[{"name":"服務品質Service Quality","id":"30","items":[]},{"name":"產品品質/價格相關問題Product Quality","id":"31","items":[{"name":"日常生活用品/雜貨類商品Grocery","id":"84"},{"name":"生鮮商品Fresh","id":"85"},{"name":"家用百貨/五金類商品Bazzar","id":"86"},{"name":"家電商品Appliance","id":"87"},{"name":"紡織/鞋子商品Textile","id":"88"}]},{"name":"安全檢查/停車相關問題Security&Parking","id":"32","items":[]},{"name":"會員卡相關問題 Member Card","id":"33","items":[]},{"name":"其他Others","id":"34","items":[]}]}]

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StockList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockListEditor", function() { return StockListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_module_scss__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INDEX_URL=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var StockList=function(_Component){_inherits(StockList,_Component);function StockList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StockList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StockList.__proto__||Object.getPrototypeOf(StockList)).call.apply(_ref,[this].concat(args))),_this),_this.state={storeStockList:[],showPopUp:false},_this.getProductStock=function(params){__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].postApigeeApi(__WEBPACK_IMPORTED_MODULE_10__configs_env__["a" /* APIGEE_API_HOST */]+'/api/v1/oms/cec/website/stock/query',params,function(state,res){if(state===false){return console.log('發生錯誤');}if(res.code!=='200'){return console.log('ErrorReason',res.reason);}var stockInfo=res.data.stockInfo;var configOptions=_this.props.app.options||{};var storeListAll=configOptions.stores||[];var matchedData=stockInfo.map(function(info){var matchingStore=storeListAll.find(function(store){return store.sn===info.storeCode&&store.status===true;});if(matchingStore){return Object.assign({},info,{storeName:matchingStore.name,storeType:matchingStore.store_type_name==='量販'?1:2});}return null;}).filter(function(item){return item!==null;}).slice().sort(function(a,b){return a.storeType-b.storeType;});_this.setState({storeStockList:matchedData,showPopUp:true});});},_this.handleClickClosePopup=function(){_this.setState({showPopUp:false});},_this.handleClickShowPopup=function(){var productId=_this.props.productId||'';var StoreListInfo=_this.props.stores.listInfo||{};var StoreCode=StoreListInfo.rows.map(function(obj){return obj.sn;});_this.getProductStock({storeCode:StoreCode,productKey:productId});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StockList,[{key:'render',value:function render(){var _this2=this;var productName=this.props.productName||'';return wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{onClick:function onClick(){return _this2.handleClickShowPopup();},type:'primary'},'\u67E5\u8A62\u5206\u5E97\u5EAB\u5B58'),this.state.showPopUp&&wp.element.createElement('div',null,wp.element.createElement('div',{onClick:function onClick(){return _this2.handleClickClosePopup();},className:__WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default.a['mask']}),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default.a['container']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default.a['product-title']},'\u5546\u54C1\u540D\u7A31\uFF1A'+productName),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default.a['stock-list-wrapper']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{dataSource:this.state.storeStockList,renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,wp.element.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_13__styles_module_scss___default.a['stock-list'],href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+item.storeName+'#tab=info'},wp.element.createElement('div',null,item.storeName+'\uFF1A'+item.productStock+'\u500B')));}})))));}}]);return StockList;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var StockListEditor=function(_Component2){_inherits(StockListEditor,_Component2);function StockListEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,StockListEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=StockListEditor.__proto__||Object.getPrototypeOf(StockListEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this3.handleInput=function(e){var value=e.target.value;var numericValue=value.replace(/[^0-9]/g,'');e.target.value=numericValue;},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(StockListEditor,[{key:'componentDidMount',value:function componentDidMount(){this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this4=this;return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-megaphone'})),'\u5546\u54C1\u4EE3\u78BC\u8A2D\u5B9A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onValuesChange:function onValuesChange(changedFields,allFields){return _this4.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_12_libs_FormHelper__["a" /* genFormItemAtrribute */])('productId','商品代碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:'\u8ACB\u8F38\u5165\u5546\u54C1\u5341\u4E00\u78BC',onInput:this.handleInput,maxLength:11})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_12_libs_FormHelper__["a" /* genFormItemAtrribute */])('productName','商品名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:'\u8ACB\u8F38\u5165\u5546\u54C1\u540D\u7A31'}))));}}]);return StockListEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mask":"mask___V4LVT","container":"container___Y-CSa","product-title":"product-title___3NYen","stock-list-wrapper":"stock-list-wrapper___3TH4_","stock-list":"stock-list___37vE8","stock-message":"stock-message___3zoJF"};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StockAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockAllEditor", function() { return StockAllEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StockAll=function(_Component){_inherits(StockAll,_Component);function StockAll(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StockAll);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StockAll.__proto__||Object.getPrototypeOf(StockAll)).call.apply(_ref,[this].concat(args))),_this),_this.state={stockTotal:0},_this.getProductStock=function(params){__WEBPACK_IMPORTED_MODULE_7__libs_whttp__["a" /* default */].postApigeeApi(__WEBPACK_IMPORTED_MODULE_6__configs_env__["a" /* APIGEE_API_HOST */]+'/api/v1/oms/cec/website/stock/query',params,function(state,res){if(state===false){return console.log('發生錯誤');}if(res.code!=='200'){return console.log('ErrorReason',res.reason);}console.log('res',res);_this.setState({stockTotal:res.data.stockTotal});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StockAll,[{key:'componentDidMount',value:function componentDidMount(){var productId=this.props.productId||'';if(productId){this.getProductStock({queryAll:true,productKey:productId});}}},{key:'render',value:function render(){var stockTotal=this.state.stockTotal;return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default.a['stock-message']},wp.element.createElement('p',null,'\u5168\u53F0\u9650\u91CF\u5EAB\u5B58\uFF1A\u5C1A\u6709 '+stockTotal+' \u7D44'));}}]);return StockAll;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);// 編輯器
var StockAllEditor=function(_Component2){_inherits(StockAllEditor,_Component2);function StockAllEditor(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,StockAllEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=StockAllEditor.__proto__||Object.getPrototypeOf(StockAllEditor)).call.apply(_ref2,[this].concat(args))),_this2),_this2.formRef=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef(),_this2.handleInput=function(e){var value=e.target.value;var numericValue=value.replace(/[^0-9]/g,'');e.target.value=numericValue;},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(StockAllEditor,[{key:'componentDidMount',value:function componentDidMount(){this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this3=this;return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-megaphone'})),'\u5168\u53F0\u7E3D\u5EAB\u5B58\u91CF'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onValuesChange:function onValuesChange(changedFields,allFields){return _this3.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_8_libs_FormHelper__["a" /* genFormItemAtrribute */])('productId','商品代碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:'\u8ACB\u8F38\u5165\u5546\u54C1\u5341\u4E00\u78BC',onInput:this.handleInput,maxLength:11}))));}}]);return StockAllEditor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(2153);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(2157);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(209);












var Handle = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(Handle, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Handle);

  function Handle() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Handle);

    _this = _super.apply(this, arguments);
    _this.state = {
      clickFocused: false
    };

    _this.setHandleRef = function (node) {
      _this.handle = node;
    };

    _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    };

    _this.handleMouseDown = function (e) {
      // avoid selecting text during drag
      // https://github.com/ant-design/ant-design/issues/25010
      e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324

      _this.focus();
    };

    _this.handleBlur = function () {
      _this.setClickFocus(false);
    };

    _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Handle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: "setClickFocus",
    value: function setClickFocus(focused) {
      this.setState({
        clickFocused: focused
      });
    }
  }, {
    key: "clickFocus",
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _ref, _ref2;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          vertical = _this$props.vertical,
          reverse = _this$props.reverse,
          offset = _this$props.offset,
          style = _this$props.style,
          disabled = _this$props.disabled,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          tabIndex = _this$props.tabIndex,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy,
          ariaValueTextFormatter = _this$props.ariaValueTextFormatter,
          restProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);

      var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(this.props.className, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
      var positionStyle = vertical ? (_ref = {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'bottom' : 'top', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'left' : 'right', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);

      var elStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), positionStyle);

      var mergedTabIndex = tabIndex || 0;

      if (disabled || tabIndex === null) {
        mergedTabIndex = null;
      }

      var ariaValueText;

      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: this.setHandleRef,
        tabIndex: mergedTabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown // aria attribute
        ,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": !!disabled,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);



/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* unused harmony export calculateNextValue */
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(60);



function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
    });
  } catch (error) {
    return false;
  }
}
function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;
  return value < min || value > max;
}
function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;
  var points = Object.keys(marks).map(parseFloat);

  if (step !== null) {
    var baseNum = Math.pow(10, getPrecision(step));
    var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }

  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;

  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }

  return precision;
}
function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}
function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }

  if (val >= max) {
    return max;
  }

  return val;
}
function ensureValuePrecision(val, props) {
  var step = props.step;
  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line

  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}
function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };
  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  }

  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }

  return value;
}
function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;

  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP:
      method = vertical && reverse ? decrease : increase;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      method = !vertical && reverse ? decrease : increase;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN:
      method = vertical && reverse ? increase : decrease;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].LEFT:
      method = !vertical && reverse ? increase : decrease;
      break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }

  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueInfoPos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogueInfoPosEditor", function() { return CatalogueInfoPosEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_affix_style__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_affix_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_affix_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_affix__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_ArrowLeftOutlined__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_ArrowLeftOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_ArrowLeftOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_scss__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[{name:'品牌 #1'// "logo_url": "http://cec.syscom.tw:8880/uploads/48859859abcf9248f23d4f6202efcf5f.jpg",
},{name:'品牌 #2'// "logo_url": "http://cec.syscom.tw:8880/uploads/251b9bce1f9a454ae691944ea9396e31.jpg",
},{name:'品牌 #3'// "logo_url": "http://cec.syscom.tw:8880/uploads/f63176e067072961ddd5a17e7ecb61fe.jpg"
},{name:'品牌 #4'// "logo_url": "http://cec.syscom.tw:8880/uploads/252716bd6a210aa82c3a09c2a62833e9.jpg",
}]};var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'VC_CONFIG');// 前端頁面
var CatalogueInfoPos=function(_Component){_inherits(CatalogueInfoPos,_Component);function CatalogueInfoPos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueInfoPos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueInfoPos.__proto__||Object.getPrototypeOf(CatalogueInfoPos)).call.apply(_ref,[this].concat(args))),_this),_this.state={catalogueInfo:{images:[]},data:[],loading:false,hasMore:true},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_14_jquery___default()(document).on('click','#pdf',function(){var $text=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).attr('alt');dataLayer.push({event:'catalogue_pdf',item:$text});});},_this.loadData=function(){var search=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_19_query_string___default.a.parse(search);var id=queryParams.id;console.log('bb',queryParams);if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+('/api/v1/catalogues/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/catalogues');return;}_this.setState({catalogueInfo:data});_this.handleInfiniteOnLoad();});},_this.handleInfiniteOnLoad=function(page){var catalogueInfo=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(_this.state,'catalogueInfo');_this.setState({loading:true});setTimeout(function(){var data=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(catalogueInfo,'images'),0,data.length+1);console.log('handleInfiniteOnLoad',page,data,newData);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueInfoPos,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();this.GTM();}// 抓取頁面資訊
},{key:'render',value:function render(){var _state$catalogueInfo=this.state.catalogueInfo,catalogueInfo=_state$catalogueInfo===undefined?{}:_state$catalogueInfo;var catalogues=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.listInfo.rows',[]);var options=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'props.app.options',{});var category_ids=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this.props,'category_ids',[]);var catalogue_categories=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(options,'catalogue_categories',[]),function(category){return category_ids.indexOf(category.id)!==-1;});var selectedCategoryId=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'state.selectedCategoryId',__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(catalogue_categories,'0.id'));var pdf=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(catalogueInfo,'pdfs.0');var urlQuery=__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].getURLQuery();var isKiosk=urlQuery.view;return wp.element.createElement('main',{'class':'bg-light'},isKiosk&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_affix___default.a,{offsetTop:30},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_button___default.a,{style:{display:'inline-flex',fontSize:'30px',color:'white',borderRadius:'20px',backgroundColor:'#08c',height:'60px',width:'140px',top:'20px',left:'40px'},onClick:function onClick(){return window.history.back();}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_ArrowLeftOutlined___default.a,{style:{fontSize:'40px',color:'white',width:'70px'}}),'\u8FD4\u56DE')),wp.element.createElement('div',{'class':'container'},!isKiosk&&wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:'#',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('促銷目錄','cec-plugin-stores'))),catalogueInfo.category_id==40&&wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues-corrections'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('目錄更正公告','cec-plugin-stores'))),catalogueInfo.category_id==41&&wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues-preorderitemrules'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('預購目錄應記載事項','cec-plugin-stores'))),catalogueInfo.category_id!=(40||41)&&wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues'},Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('全部促銷目錄','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page',id:'name'},catalogueInfo.name)))),wp.element.createElement('section',{'class':'pt-md-5'},!isKiosk&&pdf&&wp.element.createElement('a',{id:'pdf',alt:catalogueInfo.name,href:pdf,target:'_blank'},' ',Object(__WEBPACK_IMPORTED_MODULE_25__wordpress_i18n__["__"])('PDF下載','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement('div',{align:'center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a,{grid:{gutter:16,xs:1,sm:1,md:1,lg:1,xl:1,xxl:1},dataSource:this.state.data,renderItem:function renderItem(image,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a.Item,{key:idx},wp.element.createElement('img',{align:'center',src:image.replace('mppuni-prosperity','wwwuni-prosperity'),alt:'\u76EE\u9304',style:{width:'100%'}}));}},this.state.loading&&this.state.hasMore&&wp.element.createElement('div',{className:'demo-loading-container'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,null))))))));}}]);return CatalogueInfoPos;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueInfoPosEditor=function(_Component2){_inherits(CatalogueInfoPosEditor,_Component2);function CatalogueInfoPosEditor(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,CatalogueInfoPosEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=CatalogueInfoPosEditor.__proto__||Object.getPrototypeOf(CatalogueInfoPosEditor)).call.apply(_ref2,[this].concat(args))),_this2),_this2.formRef=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createRef(),_this2.state={listInfo:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(defaultListInfo)},_this2.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(_this2,'props.match.params.id');if(!id)return;_this2.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+('/api/v1/catalogues/'+id),null,function(state,res){_this2.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_10_antd_lib_message___default.a.warning(reason);_this2.props.history.replace('/catalogues');return;}_this2.fillData(data);});},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(CatalogueInfoPosEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].updateConfig();}// 抓取頁面資訊
},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u5167\u5BB9'));}}]);return CatalogueInfoPosEditor;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pageBufferSize=2;// 顯示前後兩頁
var Pagination=function(_Component){_inherits(Pagination,_Component);function Pagination(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Pagination);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Pagination.__proto__||Object.getPrototypeOf(Pagination)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(e,page){e.preventDefault();_this.props.onChange&&_this.props.onChange(page,__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(_this,'props.pageSize',10));},_this.getLargestPage=function(){var pageSize=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(_this,'props.pageSize',10);var total=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(_this,'props.total');return Math.ceil(total/pageSize);},_this.getPageRange=function(page){var pageRange=[];var largestPage=_this.getLargestPage();var i=page+pageBufferSize<largestPage?page:page-pageBufferSize;i=i-pageBufferSize>0?i-pageBufferSize:1;while(pageRange.length<1+2*pageBufferSize&&i<=largestPage){pageRange.push(i++);}if(pageRange.length===0&&page){pageRange.push(page);}return pageRange;},_temp),_possibleConstructorReturn(_this,_ret);}// 要出現的ITEM
_createClass(Pagination,[{key:'hasPrevEllipsis',value:function hasPrevEllipsis(page){return page-(pageBufferSize+1)>0;}},{key:'hasNextEllipsis',value:function hasNextEllipsis(page){return page+(pageBufferSize+1)<this.getLargestPage();}},{key:'render',value:function render(){var _this2=this;var current=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this,'props.current');var pageSize=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this,'props.pageSize',10);var total=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this,'props.total',0);var largestPage=Math.ceil(total/pageSize);if(current>largestPage)current=largestPage;if(!total||total===0)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,wp.element.createElement('nav',{'class':'mt-5','aria-label':'Page navigation'},wp.element.createElement('ul',{'class':'pagination justify-content-center'},wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-item',current<=1&&'disabled')},wp.element.createElement('a',{'class':'page-link',tabindex:'-1','aria-disabled':'true',onClick:function onClick(e){return _this2.onClick(e,current-1);}},wp.element.createElement('div',{'class':'fas fa-caret-left d-md-none'}),wp.element.createElement('span',{'class':'d-none d-md-inline'},Object(__WEBPACK_IMPORTED_MODULE_3__wordpress_i18n__["__"])('上一頁','cec-plugin-stores')))),this.hasPrevEllipsis(current)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-item',current===1&&'active')},wp.element.createElement('a',{'class':'page-link',href:'#',onClick:function onClick(e){return _this2.onClick(e,1);}},'1')),wp.element.createElement('li',{className:'page-item'},wp.element.createElement('span',null,'\u2022\u2022\u2022'))),__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.getPageRange(current),function(page,idx){return wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-item',current===page&&'active')},wp.element.createElement('a',{'class':'page-link',href:'#',onClick:function onClick(e){return _this2.onClick(e,page);}},page));}),this.hasNextEllipsis(current)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,wp.element.createElement('li',{className:'page-item'},wp.element.createElement('span',null,'\u2022\u2022\u2022')),wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-item',current===largestPage&&'active')},wp.element.createElement('a',{'class':'page-link',href:'#',onClick:function onClick(e){return _this2.onClick(e,largestPage);}},largestPage))),wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('page-item',current>=largestPage&&'disabled')},wp.element.createElement('a',{'class':'page-link',href:'#',onClick:function onClick(e){return _this2.onClick(e,current+1);}},wp.element.createElement('div',{'class':'fas fa-caret-right d-md-none'}),wp.element.createElement('span',{'class':'d-none d-md-inline'},Object(__WEBPACK_IMPORTED_MODULE_3__wordpress_i18n__["__"])('下一頁','cec-plugin-stores')))))));}}]);return Pagination;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___2M48R","container_1":"container_1___1w3CO","container_2":"container_2___nkBwX","wp-block-cgb-block-cec-blocks":"wp-block-cgb-block-cec-blocks___1h36P"};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(481);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldContext__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_typeUtil__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_validateUtil__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__ = __webpack_require__(158);


















function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
  if (typeof shouldUpdate === 'function') {
    return shouldUpdate(prev, next, 'source' in info ? {
      source: info.source
    } : {});
  }

  return prevValue !== nextValue;
} // We use Class instead of Hooks here since it will cost much code by using Hooks.


var Field = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Field, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Field);

  // ============================== Subscriptions ==============================
  function Field(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Field);

    _this = _super.call(this, props);
    _this.state = {
      resetCount: 0
    };
    _this.cancelRegisterFunc = null;
    _this.mounted = false;
    /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */

    _this.touched = false;
    /** Mark when touched & validated. Currently only used for `dependencies` */

    _this.dirty = false;
    _this.validatePromise = null;
    _this.errors = [];

    _this.cancelRegister = function () {
      var _this$props = _this.props,
          preserve = _this$props.preserve,
          isListField = _this$props.isListField;

      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve);
      }

      _this.cancelRegisterFunc = null;
    }; // ================================== Utils ==================================


    _this.getNamePath = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName,
          prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== undefined ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(prefixName), Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(name)) : [];
    };

    _this.getRules = function () {
      var _this$props3 = _this.props,
          _this$props3$rules = _this$props3.rules,
          rules = _this$props3$rules === void 0 ? [] : _this$props3$rules,
          fieldContext = _this$props3.fieldContext;
      return rules.map(function (rule) {
        if (typeof rule === 'function') {
          return rule(fieldContext);
        }

        return rule;
      });
    };

    _this.refresh = function () {
      if (!_this.mounted) return;
      /**
       * Clean up current node.
       */

      _this.setState(function (_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    }; // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component


    _this.onStoreChange = function (prevStore, namePathList, info) {
      var _this$props4 = _this.props,
          shouldUpdate = _this$props4.shouldUpdate,
          _this$props4$dependen = _this$props4.dependencies,
          dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen,
          onReset = _this$props4.onReset;
      var store = info.store;

      var namePath = _this.getNamePath();

      var prevValue = _this.getValue(prevStore);

      var curValue = _this.getValue(store);

      var namePathMatch = namePathList && Object(__WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["b" /* containsNamePath */])(namePathList, namePath); // `setFieldsValue` is a quick access to update related status

      if (info.type === 'valueUpdate' && info.source === 'external' && prevValue !== curValue) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = [];
      }

      switch (info.type) {
        case 'reset':
          if (!namePathList || namePathMatch) {
            // Clean up state
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = null;
            _this.errors = [];

            if (onReset) {
              onReset();
            }

            _this.refresh();

            return;
          }

          break;

        case 'setField':
          {
            if (namePathMatch) {
              var data = info.data;

              if ('touched' in data) {
                _this.touched = data.touched;
              }

              if ('validating' in data && !('originRCField' in data)) {
                _this.validatePromise = data.validating ? Promise.resolve([]) : null;
              }

              if ('errors' in data) {
                _this.errors = data.errors || [];
              }

              _this.dirty = true;

              _this.reRender();

              return;
            } // Handle update by `setField` with `shouldUpdate`


            if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
              _this.reRender();

              return;
            }

            break;
          }

        case 'dependenciesUpdate':
          {
            /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */
            var dependencyList = dependencies.map(__WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["d" /* getNamePath */]); // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
            // emitted earlier and they will work there
            // If set it may cause unnecessary twice rerendering

            if (dependencyList.some(function (dependency) {
              return Object(__WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["b" /* containsNamePath */])(info.relatedFields, dependency);
            })) {
              _this.reRender();

              return;
            }

            break;
          }

        default:
          // 1. If `namePath` exists in `namePathList`, means it's related value and should update
          //      For example <List name="list"><Field name={['list', 0]}></List>
          //      If `namePathList` is [['list']] (List value update), Field should be updated
          //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
          // 2.
          //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
          //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
          //       is not provided
          //   2.2 If `shouldUpdate` provided, use customize logic to update the field
          //       else to check if value changed
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();

            return;
          }

          break;
      }

      if (shouldUpdate === true) {
        _this.reRender();
      }
    };

    _this.validateRules = function (options) {
      // We should fixed namePath & value to avoid developer change then by form function
      var namePath = _this.getNamePath();

      var currentValue = _this.getValue(); // Force change to async to avoid rule OOD under renderProps field


      var rootPromise = Promise.resolve().then(function () {
        if (!_this.mounted) {
          return [];
        }

        var _this$props5 = _this.props,
            _this$props5$validate = _this$props5.validateFirst,
            validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate,
            messageVariables = _this$props5.messageVariables;

        var _ref2 = options || {},
            triggerName = _ref2.triggerName;

        var filteredRules = _this.getRules();

        if (triggerName) {
          filteredRules = filteredRules.filter(function (rule) {
            var validateTrigger = rule.validateTrigger;

            if (!validateTrigger) {
              return true;
            }

            var triggerList = Object(__WEBPACK_IMPORTED_MODULE_14__utils_typeUtil__["a" /* toArray */])(validateTrigger);
            return triggerList.includes(triggerName);
          });
        }

        var promise = Object(__WEBPACK_IMPORTED_MODULE_15__utils_validateUtil__["a" /* validateRules */])(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
        promise.catch(function (e) {
          return e;
        }).then(function () {
          var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          if (_this.validatePromise === rootPromise) {
            _this.validatePromise = null;
            _this.errors = errors;

            _this.reRender();
          }
        });
        return promise;
      });
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = []; // Force trigger re-render since we need sync renderProps with new meta

      _this.reRender();

      return rootPromise;
    };

    _this.isFieldValidating = function () {
      return !!_this.validatePromise;
    };

    _this.isFieldTouched = function () {
      return _this.touched;
    };

    _this.isFieldDirty = function () {
      return _this.dirty;
    };

    _this.getErrors = function () {
      return _this.errors;
    };

    _this.isListField = function () {
      return _this.props.isListField;
    };

    _this.isList = function () {
      return _this.props.isList;
    }; // ============================= Child Component =============================


    _this.getMeta = function () {
      // Make error & validating in cache to save perf
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        name: _this.getNamePath()
      };
      return meta;
    }; // Only return validate child node. If invalidate, will do nothing about field.


    _this.getOnlyChild = function (children) {
      // Support render props
      if (typeof children === 'function') {
        var meta = _this.getMeta();

        return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.getOnlyChild(children(_this.getControlled(), meta, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      } // Filed element only


      var childList = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Children_toArray__["a" /* default */])(children);

      if (childList.length !== 1 || ! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react__["isValidElement"](childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }

      return {
        child: childList[0],
        isFunction: false
      };
    }; // ============================== Field Control ==============================


    _this.getValue = function (store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;

      var namePath = _this.getNamePath();

      return Object(__WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["e" /* getValue */])(store || getFieldsValue(true), namePath);
    };

    _this.getControlled = function () {
      var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          validateTrigger = _this$props6.validateTrigger,
          getValueFromEvent = _this$props6.getValueFromEvent,
          normalize = _this$props6.normalize,
          valuePropName = _this$props6.valuePropName,
          getValueProps = _this$props6.getValueProps,
          fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;

      var namePath = _this.getNamePath();

      var getInternalHooks = fieldContext.getInternalHooks,
          getFieldsValue = fieldContext.getFieldsValue;

      var _getInternalHooks = getInternalHooks(__WEBPACK_IMPORTED_MODULE_13__FieldContext__["a" /* HOOK_MARK */]),
          dispatch = _getInternalHooks.dispatch;

      var value = _this.getValue();

      var mergedGetValueProps = getValueProps || function (val) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, valuePropName, val);
      }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


      var originTriggerFunc = childProps[trigger];

      var control = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, childProps), mergedGetValueProps(value)); // Add trigger


      control[trigger] = function () {
        // Mark as touched
        _this.touched = true;
        _this.dirty = true;
        var newValue;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = __WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["c" /* defaultGetValueFromEvent */].apply(void 0, [valuePropName].concat(args));
        }

        if (normalize) {
          newValue = normalize(newValue, value, getFieldsValue(true));
        }

        dispatch({
          type: 'updateValue',
          namePath: namePath,
          value: newValue
        });

        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      }; // Add validateTrigger


      var validateTriggerList = Object(__WEBPACK_IMPORTED_MODULE_14__utils_typeUtil__["a" /* toArray */])(mergedValidateTrigger || []);
      validateTriggerList.forEach(function (triggerName) {
        // Wrap additional function of component, so that we can get latest value from store
        var originTrigger = control[triggerName];

        control[triggerName] = function () {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          } // Always use latest rules


          var rules = _this.props.rules;

          if (rules && rules.length) {
            // We dispatch validate to root,
            // since it will update related data with other field with same name
            dispatch({
              type: 'validateField',
              namePath: namePath,
              triggerName: triggerName
            });
          }
        };
      });
      return control;
    }; // Register on init


    if (props.fieldContext) {
      var getInternalHooks = props.fieldContext.getInternalHooks;

      var _getInternalHooks2 = getInternalHooks(__WEBPACK_IMPORTED_MODULE_13__FieldContext__["a" /* HOOK_MARK */]),
          initEntityValue = _getInternalHooks2.initEntityValue;

      initEntityValue(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(Field, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          shouldUpdate = _this$props7.shouldUpdate,
          fieldContext = _this$props7.fieldContext;
      this.mounted = true; // Register on init

      if (fieldContext) {
        var getInternalHooks = fieldContext.getInternalHooks;

        var _getInternalHooks3 = getInternalHooks(__WEBPACK_IMPORTED_MODULE_13__FieldContext__["a" /* HOOK_MARK */]),
            registerField = _getInternalHooks3.registerField;

        this.cancelRegisterFunc = registerField(this);
      } // One more render for component in case fields not ready


      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted) return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;

      var _this$getOnlyChild = this.getOnlyChild(children),
          child = _this$getOnlyChild.child,
          isFunction = _this$getOnlyChild.isFunction; // Not need to `cloneElement` since user can handle this in render function self


      var returnChildNode;

      if (isFunction) {
        returnChildNode = child;
      } else if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react__["isValidElement"](child)) {
        returnChildNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react__["cloneElement"](child, this.getControlled(child.props));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__["a" /* default */])(!child, '`children` of Field is not validate ReactElement.');
        returnChildNode = child;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"], {
        key: resetCount
      }, returnChildNode);
    }
  }]);

  return Field;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

Field.contextType = __WEBPACK_IMPORTED_MODULE_13__FieldContext__["b" /* default */];
Field.defaultProps = {
  trigger: 'onChange',
  valuePropName: 'value'
};

function WrapperField(_ref4) {
  var name = _ref4.name,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref4, ["name"]);

  var fieldContext = __WEBPACK_IMPORTED_MODULE_12_react__["useContext"](__WEBPACK_IMPORTED_MODULE_13__FieldContext__["b" /* default */]);
  var namePath = name !== undefined ? Object(__WEBPACK_IMPORTED_MODULE_16__utils_valueUtil__["d" /* getNamePath */])(name) : undefined;
  var key = 'keep';

  if (!restProps.isListField) {
    key = "_".concat((namePath || []).join('_'));
  }

  if (false) {
    warning(restProps.preserve !== false || !restProps.isListField, '`preserve` should not apply on Form.List fields.');
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react__["createElement"](Field, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    key: key,
    name: namePath
  }, restProps, {
    fieldContext: fieldContext
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (WrapperField);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(924);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(485);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(484);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
function toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
function get(entity, path) {
  var current = entity;
  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }
    current = current[path[i]];
  }
  return current;
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(941);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(943);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultValidateMessages; });
var typeTemplate = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldContext__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_asyncUtil__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_messages__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__ = __webpack_require__(158);












var FormStore = function FormStore(forceRootUpdate) {
  var _this = this;

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, FormStore);

  this.formHooked = false;
  this.subscribable = true;
  this.store = {};
  this.fieldEntities = [];
  this.initialValues = {};
  this.callbacks = {};
  this.validateMessages = null;
  this.preserve = null;
  this.lastValidatePromise = null;

  this.getForm = function () {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      getInternalHooks: _this.getInternalHooks
    };
  }; // ======================== Internal Hooks ========================


  this.getInternalHooks = function (key) {
    if (key === __WEBPACK_IMPORTED_MODULE_7__FieldContext__["a" /* HOOK_MARK */]) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve
      };
    }

    Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__["a" /* default */])(false, '`getInternalHooks` is internal usage. Should not call directly.');
    return null;
  };

  this.useSubscribe = function (subscribable) {
    _this.subscribable = subscribable;
  };
  /**
   * First time `setInitialValues` should update store with initial value
   */


  this.setInitialValues = function (initialValues, init) {
    _this.initialValues = initialValues || {};

    if (init) {
      _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["j" /* setValues */])({}, initialValues, _this.store);
    }
  };

  this.getInitialValue = function (namePath) {
    return Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["e" /* getValue */])(_this.initialValues, namePath);
  };

  this.setCallbacks = function (callbacks) {
    _this.callbacks = callbacks;
  };

  this.setValidateMessages = function (validateMessages) {
    _this.validateMessages = validateMessages;
  };

  this.setPreserve = function (preserve) {
    _this.preserve = preserve;
  }; // ========================== Dev Warning =========================


  this.timeoutId = null;

  this.warningUnhooked = function () {
    if (false) {
      _this.timeoutId = window.setTimeout(function () {
        _this.timeoutId = null;

        if (!_this.formHooked) {
          warning(false, 'Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?');
        }
      });
    }
  }; // ============================ Fields ============================

  /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */


  this.getFieldEntities = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!pure) {
      return _this.fieldEntities;
    }

    return _this.fieldEntities.filter(function (field) {
      return field.getNamePath().length;
    });
  };

  this.getFieldsMap = function () {
    var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cache = new __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__["a" /* default */]();

    _this.getFieldEntities(pure).forEach(function (field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });

    return cache;
  };

  this.getFieldEntitiesForNamePathList = function (nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }

    var cache = _this.getFieldsMap(true);

    return nameList.map(function (name) {
      var namePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name)
      };
    });
  };

  this.getFieldsValue = function (nameList, filterFunc) {
    _this.warningUnhooked();

    if (nameList === true && !filterFunc) {
      return _this.store;
    }

    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(nameList) ? nameList : null);

    var filteredNameList = [];
    fieldEntities.forEach(function (entity) {
      var _entity$isListField;

      var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath(); // Ignore when it's a list item and not specific the namePath,
      // since parent field is already take in count

      if (!nameList && ((_entity$isListField = entity.isListField) === null || _entity$isListField === void 0 ? void 0 : _entity$isListField.call(entity))) {
        return;
      }

      if (!filterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = 'getMeta' in entity ? entity.getMeta() : null;

        if (filterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["a" /* cloneByNamePathList */])(_this.store, filteredNameList.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]));
  };

  this.getFieldValue = function (name) {
    _this.warningUnhooked();

    var namePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name);
    return Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["e" /* getValue */])(_this.store, namePath);
  };

  this.getFieldsError = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);

    return fieldEntities.map(function (entity, index) {
      if (entity && !('INVALIDATE_NAME_PATH' in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors()
        };
      }

      return {
        name: Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(nameList[index]),
        errors: []
      };
    });
  };

  this.getFieldError = function (name) {
    _this.warningUnhooked();

    var namePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name);

    var fieldError = _this.getFieldsError([namePath])[0];

    return fieldError.errors;
  };

  this.isFieldsTouched = function () {
    _this.warningUnhooked();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var arg0 = args[0],
        arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;

    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]);
      isAllFieldsTouched = arg1;
    }

    var fieldEntities = _this.getFieldEntities(true);

    var isFieldTouched = function isFieldTouched(field) {
      return field.isFieldTouched();
    }; // ===== Will get fully compare when not config namePathList =====


    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
    } // Generate a nest tree for validate


    var map = new __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__["a" /* default */]();
    namePathList.forEach(function (shortNamePath) {
      map.set(shortNamePath, []);
    });
    fieldEntities.forEach(function (field) {
      var fieldNamePath = field.getNamePath(); // Find matched entity and put into list

      namePathList.forEach(function (shortNamePath) {
        if (shortNamePath.every(function (nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map.update(shortNamePath, function (list) {
            return [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(list), [field]);
          });
        }
      });
    }); // Check if NameMap value is touched

    var isNamePathListTouched = function isNamePathListTouched(entities) {
      return entities.some(isFieldTouched);
    };

    var namePathListEntities = map.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  };

  this.isFieldTouched = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsTouched([name]);
  };

  this.isFieldsValidating = function (nameList) {
    _this.warningUnhooked();

    var fieldEntities = _this.getFieldEntities();

    if (!nameList) {
      return fieldEntities.some(function (testField) {
        return testField.isFieldValidating();
      });
    }

    var namePathList = nameList.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]);
    return fieldEntities.some(function (testField) {
      var fieldNamePath = testField.getNamePath();
      return Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["b" /* containsNamePath */])(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  };

  this.isFieldValidating = function (name) {
    _this.warningUnhooked();

    return _this.isFieldsValidating([name]);
  };
  /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */


  this.resetWithFieldInitialValue = function () {
    var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create cache
    var cache = new __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__["a" /* default */]();

    var fieldEntities = _this.getFieldEntities(true);

    fieldEntities.forEach(function (field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath(); // Record only if has `initialValue`

      if (initialValue !== undefined) {
        var records = cache.get(namePath) || new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    }); // Reset

    var resetWithFields = function resetWithFields(entities) {
      entities.forEach(function (field) {
        var initialValue = field.props.initialValue;

        if (initialValue !== undefined) {
          var namePath = field.getNamePath();

          var formInitialValue = _this.getInitialValue(namePath);

          if (formInitialValue !== undefined) {
            // Warning if conflict with form initialValues and do not modify value
            Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__["a" /* default */])(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);

            if (records && records.size > 1) {
              // Warning if multiple field set `initialValue`and do not modify value
              Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__["a" /* default */])(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath); // Set `initialValue`


              if (!info.skipExist || originValue === undefined) {
                _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records)[0].value);
              }
            }
          }
        }
      });
    };

    var requiredFieldEntities;

    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function (namePath) {
        var records = cache.get(namePath);

        if (records) {
          var _requiredFieldEntitie;

          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records).map(function (r) {
            return r.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }

    resetWithFields(requiredFieldEntities);
  };

  this.resetFields = function (nameList) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (!nameList) {
      _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["j" /* setValues */])({}, _this.initialValues);

      _this.resetWithFieldInitialValue();

      _this.notifyObservers(prevStore, null, {
        type: 'reset'
      });

      return;
    } // Reset by `nameList`


    var namePathList = nameList.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]);
    namePathList.forEach(function (namePath) {
      var initialValue = _this.getInitialValue(namePath);

      _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, initialValue);
    });

    _this.resetWithFieldInitialValue({
      namePathList: namePathList
    });

    _this.notifyObservers(prevStore, namePathList, {
      type: 'reset'
    });
  };

  this.setFields = function (fields) {
    _this.warningUnhooked();

    var prevStore = _this.store;
    fields.forEach(function (fieldData) {
      var name = fieldData.name,
          errors = fieldData.errors,
          data = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(fieldData, ["name", "errors"]);

      var namePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name); // Value

      if ('value' in data) {
        _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, data.value);
      }

      _this.notifyObservers(prevStore, [namePath], {
        type: 'setField',
        data: fieldData
      });
    });
  };

  this.getFields = function () {
    var entities = _this.getFieldEntities(true);

    var fields = entities.map(function (field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();

      var fieldData = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });

      Object.defineProperty(fieldData, 'originRCField', {
        value: true
      });
      return fieldData;
    });
    return fields;
  }; // =========================== Observer ===========================

  /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */


  this.initEntityValue = function (entity) {
    var initialValue = entity.props.initialValue;

    if (initialValue !== undefined) {
      var namePath = entity.getNamePath();
      var prevValue = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["e" /* getValue */])(_this.store, namePath);

      if (prevValue === undefined) {
        _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, initialValue);
      }
    }
  };

  this.registerField = function (entity) {
    _this.fieldEntities.push(entity); // Set initial values


    if (entity.props.initialValue !== undefined) {
      var prevStore = _this.store;

      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });

      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: 'valueUpdate',
        source: 'internal'
      });
    } // un-register field callback


    return function (isListField, preserve) {
      _this.fieldEntities = _this.fieldEntities.filter(function (item) {
        return item !== entity;
      }); // Clean up store value if preserve

      var mergedPreserve = preserve !== undefined ? preserve : _this.preserve;

      if (mergedPreserve === false && !isListField) {
        var namePath = entity.getNamePath();

        if (namePath.length && _this.getFieldValue(namePath) !== undefined) {
          _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, undefined);
        }
      }
    };
  };

  this.dispatch = function (action) {
    switch (action.type) {
      case 'updateValue':
        {
          var namePath = action.namePath,
              value = action.value;

          _this.updateValue(namePath, value);

          break;
        }

      case 'validateField':
        {
          var _namePath = action.namePath,
              triggerName = action.triggerName;

          _this.validateFields([_namePath], {
            triggerName: triggerName
          });

          break;
        }

      default: // Currently we don't have other action. Do nothing.

    }
  };

  this.notifyObservers = function (prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, info), {}, {
        store: _this.getFieldsValue(true)
      });

      _this.getFieldEntities().forEach(function (_ref2) {
        var onStoreChange = _ref2.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  };

  this.updateValue = function (name, value) {
    var namePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(name);
    var prevStore = _this.store;
    _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["i" /* setValue */])(_this.store, namePath, value);

    _this.notifyObservers(prevStore, [namePath], {
      type: 'valueUpdate',
      source: 'internal'
    }); // Notify dependencies children with parent update
    // We need delay to trigger validate in case Field is under render props


    var childrenFields = _this.getDependencyChildrenFields(namePath);

    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }

    _this.notifyObservers(prevStore, childrenFields, {
      type: 'dependenciesUpdate',
      relatedFields: [namePath].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(childrenFields))
    }); // trigger callback function


    var onValuesChange = _this.callbacks.onValuesChange;

    if (onValuesChange) {
      var changedValues = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["a" /* cloneByNamePathList */])(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }

    _this.triggerOnFieldsChange([namePath].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(childrenFields)));
  }; // Let all child Field get update.


  this.setFieldsValue = function (store) {
    _this.warningUnhooked();

    var prevStore = _this.store;

    if (store) {
      _this.store = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["j" /* setValues */])(_this.store, store);
    }

    _this.notifyObservers(prevStore, null, {
      type: 'valueUpdate',
      source: 'external'
    });
  };

  this.getDependencyChildrenFields = function (rootNamePath) {
    var children = new Set();
    var childrenFields = [];
    var dependencies2fields = new __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__["a" /* default */]();
    /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */

    _this.getFieldEntities().forEach(function (field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function (dependency) {
        var dependencyNamePath = Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */])(dependency);
        dependencies2fields.update(dependencyNamePath, function () {
          var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
          fields.add(field);
          return fields;
        });
      });
    });

    var fillChildren = function fillChildren(namePath) {
      var fields = dependencies2fields.get(namePath) || new Set();
      fields.forEach(function (field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();

          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren(fieldNamePath);
          }
        }
      });
    };

    fillChildren(rootNamePath);
    return childrenFields;
  };

  this.triggerOnFieldsChange = function (namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;

    if (onFieldsChange) {
      var fields = _this.getFields();
      /**
       * Fill errors since `fields` may be replaced by controlled fields
       */


      if (filedErrors) {
        var cache = new __WEBPACK_IMPORTED_MODULE_9__utils_NameMap__["a" /* default */]();
        filedErrors.forEach(function (_ref3) {
          var name = _ref3.name,
              errors = _ref3.errors;
          cache.set(name, errors);
        });
        fields.forEach(function (field) {
          // eslint-disable-next-line no-param-reassign
          field.errors = cache.get(field.name) || field.errors;
        });
      }

      var changedFields = fields.filter(function (_ref4) {
        var fieldName = _ref4.name;
        return Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["b" /* containsNamePath */])(namePathList, fieldName);
      });
      onFieldsChange(changedFields, fields);
    }
  }; // =========================== Validate ===========================


  this.validateFields = function (nameList, options) {
    _this.warningUnhooked();

    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["d" /* getNamePath */]) : []; // Collect result in promise list

    var promiseList = [];

    _this.getFieldEntities(true).forEach(function (field) {
      // Add field if not provide `nameList`
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      /**
       * Recursive validate if configured.
       * TODO: perf improvement @zombieJ
       */


      if ((options === null || options === void 0 ? void 0 : options.recursive) && provideNameList) {
        var namePath = field.getNamePath();

        if ( // nameList[i] === undefined 说明是以 nameList 开头的
        // ['name'] -> ['name','list']
        namePath.every(function (nameUnit, i) {
          return nameList[i] === nameUnit || nameList[i] === undefined;
        })) {
          namePathList.push(namePath);
        }
      } // Skip if without rule


      if (!field.props.rules || !field.props.rules.length) {
        return;
      }

      var fieldNamePath = field.getNamePath(); // Add field validate rule in to promise list

      if (!provideNameList || Object(__WEBPACK_IMPORTED_MODULE_11__utils_valueUtil__["b" /* containsNamePath */])(namePathList, fieldNamePath)) {
        var promise = field.validateRules(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          validateMessages: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_10__utils_messages__["a" /* defaultValidateMessages */]), _this.validateMessages)
        }, options)); // Wrap promise with field

        promiseList.push(promise.then(function () {
          return {
            name: fieldNamePath,
            errors: []
          };
        }).catch(function (errors) {
          return Promise.reject({
            name: fieldNamePath,
            errors: errors
          });
        }));
      }
    });

    var summaryPromise = Object(__WEBPACK_IMPORTED_MODULE_8__utils_asyncUtil__["a" /* allPromiseFinish */])(promiseList);
    _this.lastValidatePromise = summaryPromise; // Notify fields with rule that validate has finished and need update

    summaryPromise.catch(function (results) {
      return results;
    }).then(function (results) {
      var resultNamePathList = results.map(function (_ref5) {
        var name = _ref5.name;
        return name;
      });

      _this.notifyObservers(_this.store, resultNamePathList, {
        type: 'validateFinish'
      });

      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function () {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }

      return Promise.reject([]);
    }).catch(function (results) {
      var errorList = results.filter(function (result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    }); // Do not throw in console

    returnPromise.catch(function (e) {
      return e;
    });
    return returnPromise;
  }; // ============================ Submit ============================


  this.submit = function () {
    _this.warningUnhooked();

    _this.validateFields().then(function (values) {
      var onFinish = _this.callbacks.onFinish;

      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          // Should print error if user `onFinish` callback failed
          console.error(err);
        }
      }
    }).catch(function (e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;

      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  };

  this.forceRootUpdate = forceRootUpdate;
};

function useForm(form) {
  var formRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"]({}),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      forceUpdate = _React$useState2[1];

  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      // Create a new FormStore if not provided
      var forceReRender = function forceReRender() {
        forceUpdate({});
      };

      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }

  return [formRef.current];
}

/* harmony default export */ __webpack_exports__["a"] = (useForm);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(948);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var FormContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createContext"]({
  triggerFormChange: function triggerFormChange() {},
  triggerFormFinish: function triggerFormFinish() {},
  registerForm: function registerForm() {},
  unregisterForm: function unregisterForm() {}
});

var FormProvider = function FormProvider(_ref) {
  var validateMessages = _ref.validateMessages,
      onFormChange = _ref.onFormChange,
      onFormFinish = _ref.onFormFinish,
      children = _ref.children;
  var formContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](FormContext);
  var formsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({});
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](FormContext.Provider, {
    value: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formContext), {}, {
      validateMessages: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields: changedFields,
            forms: formsRef.current
          });
        }

        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values: values,
            forms: formsRef.current
          });
        }

        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm(name, form) {
        if (name) {
          formsRef.current = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formsRef.current), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, name, form));
        }

        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm(name) {
        var newForms = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formsRef.current);

        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};


/* harmony default export */ __webpack_exports__["b"] = (FormContext);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(40)["default"];
var toPrimitive = __webpack_require__(953);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: 'Page',
  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages',
  page_size: 'Page Size'
};
exports.default = _default;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var LocaleContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var _default = LocaleContext;
exports["default"] = _default;

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(964);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(508);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(968);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(508);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(969);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(972);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_findDOMNode__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_motion__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__interface__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks_useStatus__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DomWrapper__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useStepQueue__ = __webpack_require__(516);





/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */











/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;

  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function (props, ref) {
    var _props$visible = props.visible,
        visible = _props$visible === void 0 ? true : _props$visible,
        _props$removeOnLeave = props.removeOnLeave,
        removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
        forceRender = props.forceRender,
        children = props.children,
        motionName = props.motionName,
        leavedClassName = props.leavedClassName,
        eventProps = props.eventProps;
    var supportMotion = isSupportTransition(props); // Ref to the react node, it may be a HTMLElement

    var nodeRef = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(); // Ref to the dom wrapper in case ref can not pass to HTMLElement

    var wrapperNodeRef = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_findDOMNode__["a" /* default */])(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }

    var _useStatus = Object(__WEBPACK_IMPORTED_MODULE_10__hooks_useStatus__["a" /* default */])(supportMotion, visible, getDomElement, props),
        _useStatus2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useStatus, 4),
        status = _useStatus2[0],
        statusStep = _useStatus2[1],
        statusStyle = _useStatus2[2],
        mergedVisible = _useStatus2[3]; // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`


    var renderedRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](mergedVisible);

    if (mergedVisible) {
      renderedRef.current = true;
    } // ====================== Refs ======================


    var setNodeRef = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (node) {
      nodeRef.current = node;
      Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_ref__["b" /* fillRef */])(ref, node);
    }, [ref]); // ===================== Render =====================

    var motionChildren;

    var mergedProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, eventProps), {}, {
      visible: visible
    });

    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === __WEBPACK_IMPORTED_MODULE_9__interface__["d" /* STATUS_NONE */] || !isSupportTransition(props)) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;

      // In motion
      var statusSuffix;

      if (statusStep === __WEBPACK_IMPORTED_MODULE_9__interface__["h" /* STEP_PREPARE */]) {
        statusSuffix = 'prepare';
      } else if (Object(__WEBPACK_IMPORTED_MODULE_12__hooks_useStepQueue__["d" /* isActive */])(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === __WEBPACK_IMPORTED_MODULE_9__interface__["i" /* STEP_START */]) {
        statusSuffix = 'start';
      }

      motionChildren = children(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedProps), {}, {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_8__util_motion__["b" /* getTransitionName */])(motionName, status), (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, Object(__WEBPACK_IMPORTED_MODULE_8__util_motion__["b" /* getTransitionName */])(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
        style: statusStyle
      }), setNodeRef);
    } // Auto inject ref if child node not have `ref` props


    if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](motionChildren) && Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_ref__["c" /* supportRef */])(motionChildren)) {
      var _ref = motionChildren,
          originNodeRef = _ref.ref;

      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"](motionChildren, {
          ref: setNodeRef
        });
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__DomWrapper__["a" /* default */], {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_8__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(974);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(497);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SkipStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DoStep; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_hooks_useState__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interface__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useNextFrame__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useIsomorphicLayoutEffect__ = __webpack_require__(517);






var STEP_QUEUE = [__WEBPACK_IMPORTED_MODULE_3__interface__["h" /* STEP_PREPARE */], __WEBPACK_IMPORTED_MODULE_3__interface__["i" /* STEP_START */], __WEBPACK_IMPORTED_MODULE_3__interface__["f" /* STEP_ACTIVE */], __WEBPACK_IMPORTED_MODULE_3__interface__["e" /* STEP_ACTIVATED */]];
/** Skip current step */

var SkipStep = false;
/** Current step should be update in */

var DoStep = true;
function isActive(step) {
  return step === __WEBPACK_IMPORTED_MODULE_3__interface__["f" /* STEP_ACTIVE */] || step === __WEBPACK_IMPORTED_MODULE_3__interface__["e" /* STEP_ACTIVATED */];
}
/* harmony default export */ __webpack_exports__["c"] = (function (status, callback) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_hooks_useState__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__interface__["g" /* STEP_NONE */]),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useNextFrame = Object(__WEBPACK_IMPORTED_MODULE_4__useNextFrame__["a" /* default */])(),
      _useNextFrame2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useNextFrame, 2),
      nextFrame = _useNextFrame2[0],
      cancelNextFrame = _useNextFrame2[1];

  function startQueue() {
    setStep(__WEBPACK_IMPORTED_MODULE_3__interface__["h" /* STEP_PREPARE */], true);
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__useIsomorphicLayoutEffect__["a" /* default */])(function () {
    if (step !== __WEBPACK_IMPORTED_MODULE_3__interface__["g" /* STEP_NONE */] && step !== __WEBPACK_IMPORTED_MODULE_3__interface__["e" /* STEP_ACTIVATED */]) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);

      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }

          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_Dom_canUseDom__ = __webpack_require__(161);

 // It's safe to use `useLayoutEffect` but the warning is annoying

var useIsomorphicLayoutEffect = Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_Dom_canUseDom__["a" /* default */])() ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/* harmony default export */ __webpack_exports__["a"] = (useIsomorphicLayoutEffect);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(514);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(985);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(988);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);











var Notice = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Notice, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Notice);

  function Notice() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Notice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.closeTimer = null;

    _this.close = function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.clearCloseTimer();

      var _this$props = _this.props,
          onClose = _this$props.onClose,
          noticeKey = _this$props.noticeKey;

      if (onClose) {
        onClose(noticeKey);
      }
    };

    _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = window.setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    };

    _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Notice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
      this.props.visible !== prevProps.visible && this.props.visible) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          closable = _this$props2.closable,
          closeIcon = _this$props2.closeIcon,
          style = _this$props2.style,
          onClick = _this$props2.onClick,
          children = _this$props2.children,
          holder = _this$props2.holder;
      var componentClass = "".concat(prefixCls, "-notice");
      var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function (acc, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          acc[key] = _this2.props[key];
        }

        return acc;
      }, {});
      var node = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(componentClass, className, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(componentClass, "-closable"), closable)),
        style: style,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer,
        onClick: onClick
      }, dataOrAriaAttributeProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "".concat(componentClass, "-content")
      }, children), closable ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("a", {
        tabIndex: 0,
        onClick: this.close,
        className: "".concat(componentClass, "-close")
      }, closeIcon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        className: "".concat(componentClass, "-close-x")
      })) : null);

      if (holder) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.createPortal(node, holder);
      }

      return node;
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Notice.defaultProps = {
  onClose: function onClose() {},
  duration: 1.5
};


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(524);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(1004);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1007);
var iterableToArrayLimit = __webpack_require__(1008);
var unsupportedIterableToArray = __webpack_require__(1009);
var nonIterableRest = __webpack_require__(1011);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1012);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = __webpack_require__(0);
var IconContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = IconContext;
exports.default = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(528));
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var _utils = __webpack_require__(341);
var _excluded = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return (0, _objectSpread2.default)({}, twoToneColorPalette);
}
var IconBase = function IconBase(props) {
  var icon = props.icon,
    className = props.className,
    onClick = props.onClick,
    style = props.style,
    primaryColor = props.primaryColor,
    secondaryColor = props.secondaryColor,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
    };
  }
  (0, _utils.useInsertStyles)();
  (0, _utils.warning)((0, _utils.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!(0, _utils.isIconDefinition)(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === 'function') {
    target = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return (0, _utils.generate)(target.icon, "svg-".concat(target.name), (0, _objectSpread2.default)({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};
IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var _default = IconBase;
exports.default = _default;

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(163);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_color_names__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__readability__ = __webpack_require__(1014);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__to_ms_filter__ = __webpack_require__(1015);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__from_ratio__ = __webpack_require__(1016);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format_input__ = __webpack_require__(532);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__format_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__random__ = __webpack_require__(1017);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interfaces__ = __webpack_require__(1018);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__conversion__ = __webpack_require__(255);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__conversion__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__conversion__["h"]; });










// kept for backwards compatability with v1
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__index__["b" /* tinycolor */]);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inputToRGB;
/* unused harmony export stringInputToObject */
/* unused harmony export isValidCSSUnit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversion__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_color_names__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(256);
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */



/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */
function inputToRGB(color) {
    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') {
        color = stringInputToObject(color);
    }
    if (typeof color === 'object') {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["i" /* rgbToRgb */])(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* convertToPercentage */])(color.s);
            v = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* convertToPercentage */])(color.v);
            rgb = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["c" /* hsvToRgb */])(color.h, s, v);
            ok = true;
            format = 'hsv';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* convertToPercentage */])(color.s);
            l = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* convertToPercentage */])(color.l);
            rgb = Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["b" /* hslToRgb */])(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) {
            a = color.a;
        }
    }
    a = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* boundAlpha */])(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a,
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */
function stringInputToObject(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) {
        return false;
    }
    var named = false;
    if (__WEBPACK_IMPORTED_MODULE_1__css_color_names__["a" /* names */][color]) {
        color = __WEBPACK_IMPORTED_MODULE_1__css_color_names__["a" /* names */][color];
        named = true;
    }
    else if (color === 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
    }
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = matchers.rgb.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    match = matchers.rgba.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    match = matchers.hsl.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    match = matchers.hsla.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    match = matchers.hsv.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    match = matchers.hsva.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    match = matchers.hex8.exec(color);
    if (match) {
        return {
            r: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[1]),
            g: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[2]),
            b: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[3]),
            a: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["a" /* convertHexToDecimal */])(match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex6.exec(color);
    if (match) {
        return {
            r: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[1]),
            g: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[2]),
            b: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    match = matchers.hex4.exec(color);
    if (match) {
        return {
            r: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[1] + match[1]),
            g: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[2] + match[2]),
            b: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[3] + match[3]),
            a: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["a" /* convertHexToDecimal */])(match[4] + match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex3.exec(color);
    if (match) {
        return {
            r: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[1] + match[1]),
            g: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[2] + match[2]),
            b: Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["e" /* parseIntFromHex */])(match[3] + match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */
function isValidCSSUnit(color) {
    return Boolean(matchers.CSS_UNIT.exec(String(color)));
}


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _InfoCircleFilled = _interopRequireDefault(__webpack_require__(1028));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _InfoCircleFilled;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 535 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(538);

var _interopRequireDefault = __webpack_require__(539);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useNotification;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1032));

var _extends2 = _interopRequireDefault(__webpack_require__(542));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1036));

var React = _interopRequireWildcard(__webpack_require__(0));

var _Notice = _interopRequireDefault(__webpack_require__(1040));

function useNotification(notificationInstance) {
  var createdRef = React.useRef({});

  var _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      elements = _React$useState2[0],
      setElements = _React$useState2[1];

  function notify(noticeProps) {
    var firstMount = true;
    notificationInstance.add(noticeProps, function (div, props) {
      var key = props.key;

      if (div && (!createdRef.current[key] || firstMount)) {
        var noticeEle = /*#__PURE__*/React.createElement(_Notice.default, (0, _extends2.default)({}, props, {
          holder: div
        }));
        createdRef.current[key] = noticeEle;
        setElements(function (originElements) {
          var index = originElements.findIndex(function (ele) {
            return ele.key === props.key;
          });

          if (index === -1) {
            return [].concat((0, _toConsumableArray2.default)(originElements), [noticeEle]);
          }

          var cloneList = (0, _toConsumableArray2.default)(originElements);
          cloneList[index] = noticeEle;
          return cloneList;
        });
      }

      firstMount = false;
    });
  }

  return [notify, /*#__PURE__*/React.createElement(React.Fragment, null, elements)];
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(259)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(540);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 542 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(259)["default"];
var toPrimitive = __webpack_require__(1042);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(545);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(548);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(350);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAppID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateSystemConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateOptions; });
/* unused harmony export updateOptionsByClass */
/* unused harmony export cleanOptions */
/* unused harmony export selectFieldID */
/* unused harmony export updateFilterDate */
var UPDATE_APP_ID='UPDATE_APP_ID';var UPDATE_SYSTEM_CONFIGS='UPDATE_SYSTEM_CONFIGS';var UPDATE_OPTIONS='UPDATE_OPTIONS';var UPDATE_OPTIONS_BY_CLASS='UPDATE_OPTIONS_BY_CLASS';var CLEAN_OPTIONS='CLEAN_OPTIONS';var SELECT_FIELD='SELECT_FIELD';var UPDATE_FILTER_DATE='UPDATE_FILTER_DATE';var updateAppID=function updateAppID(app_id){return{type:UPDATE_APP_ID,app_id:app_id};};var updateSystemConfigs=function updateSystemConfigs(configs){return{type:UPDATE_SYSTEM_CONFIGS,configs:configs};};var updateOptions=function updateOptions(options){return{type:UPDATE_OPTIONS,options:options};};var updateOptionsByClass=function updateOptionsByClass(options_class,options){return{type:UPDATE_OPTIONS_BY_CLASS,options_class:options_class,options:options};};var cleanOptions=function cleanOptions(){return{type:CLEAN_OPTIONS};};var selectFieldID=function selectFieldID(id){return{type:SELECT_FIELD,id:id};};var updateFilterDate=function updateFilterDate(start_date,end_date){return{type:UPDATE_FILTER_DATE,start_date:start_date,end_date:end_date};};var initState={id:null,selectedFieldID:null,filter_start_date:null,filter_end_date:null,configs:{},options:{}};var app=function app(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initState;var input=arguments[1];var type=input.type;if(type===UPDATE_APP_ID)return Object.assign({},state,{id:input.app_id});if(type===UPDATE_SYSTEM_CONFIGS)return Object.assign({},state,{configs:input.configs});if(type===UPDATE_OPTIONS)return Object.assign({},state,{options:input.options});if(type===UPDATE_OPTIONS_BY_CLASS){var _state$options=state.options,options=_state$options===undefined?{}:_state$options;options[input.options_class]=input.options;return Object.assign({},state,{options:options});}if(type===CLEAN_OPTIONS){return Object.assign({},state,{options:{}});}if(type===SELECT_FIELD){return Object.assign({},state,{selectedFieldID:input.id});}if(type===UPDATE_FILTER_DATE){return Object.assign({},state,{filter_start_date:input.start_date,filter_end_date:input.end_date});}return state;};/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateStoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateStoreQuery; });
var defaultState={query:{keyword:undefined,city_id:undefined},listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]}// action types
};var UPDATE_STORE_LIST='UPDATE_STORE_LIST';var UPDATE_STORE_QUERY='UPDATE_STORE_QUERY';// actions
var updateStoreList=function updateStoreList(listInfo){return{type:UPDATE_STORE_LIST,listInfo:listInfo};};var updateStoreQuery=function updateStoreQuery(query){return{type:UPDATE_STORE_QUERY,query:query};};// reducers
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];var type=action.type;if(type===UPDATE_STORE_LIST)return Object.assign({},state,{listInfo:action.listInfo});if(type===UPDATE_STORE_QUERY)return Object.assign({},state,{query:action.query});return state;});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_wjson__ = __webpack_require__(85);
var UPDATE_USER_INFO="UPDATE_USER_INFO";var CLEAN_USER_INFO="CLEAN_USER_INFO";// dispatch function
var updateUserInfo=function updateUserInfo(newState){return{type:UPDATE_USER_INFO,newState:newState};};var cleanUserInfo=function cleanUserInfo(newState){return{type:CLEAN_USER_INFO,newState:newState};};var defaultUserInfo={addresses:null,agree_receive_sms:null,amt_balance:null,birthday:null,checkSum:null,cn_name:null,email:null,employee_flag:null,en_name:null,flag:null,gender:null,gid:null,home_phone:null,mobile:null,point_balance:null,reg_dt:null,twid:null,vip_flag:null,work_phone:null// reducer
};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var user=__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].decode(localStorage.getItem('wuser'))||defaultUserInfo;user=Object.assign({},defaultUserInfo,user,state);if(action.type===UPDATE_USER_INFO){user=Object.assign({},user,action.newState);//console.log("user", user)
// user.isLogin = (user.access_token !== null && (typeof user.access_token === 'string') && user.access_token.length > 0)
localStorage.setItem('wuser',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(user));return user;}if(action.type===CLEAN_USER_INFO){localStorage.setItem('wuser',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(defaultUserInfo));return defaultUserInfo;}return user;});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _zh_TW = _interopRequireDefault(__webpack_require__(1085));

var _zh_TW2 = _interopRequireDefault(__webpack_require__(553));

// 统一合并为完整的 Locale
var locale = {
  lang: (0, _extends2["default"])({
    placeholder: '請選擇日期',
    yearPlaceholder: '請選擇年份',
    quarterPlaceholder: '請選擇季度',
    monthPlaceholder: '請選擇月份',
    weekPlaceholder: '請選擇周',
    rangePlaceholder: ['開始日期', '結束日期'],
    rangeYearPlaceholder: ['開始年份', '結束年份'],
    rangeMonthPlaceholder: ['開始月份', '結束月份'],
    rangeWeekPlaceholder: ['開始周', '結束周']
  }, _zh_TW["default"]),
  timePickerLocale: (0, _extends2["default"])({}, _zh_TW2["default"])
};
locale.lang.ok = '確 定'; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: '請選擇時間'
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(138);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(265);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(356);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1097)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(357);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(265);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(266);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(356);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Content = exports.Footer = exports.Header = exports.LayoutContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var LayoutContext = /*#__PURE__*/React.createContext({
  siderHook: {
    addSider: function addSider() {
      return null;
    },
    removeSider: function removeSider() {
      return null;
    }
  }
});
exports.LayoutContext = LayoutContext;

function generator(_ref) {
  var suffixCls = _ref.suffixCls,
      tagName = _ref.tagName,
      displayName = _ref.displayName;
  return function (BasicComponent) {
    var Adapter = function Adapter(props) {
      var _React$useContext = React.useContext(_configProvider.ConfigContext),
          getPrefixCls = _React$useContext.getPrefixCls;

      var customizePrefixCls = props.prefixCls;
      var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
      return /*#__PURE__*/React.createElement(BasicComponent, (0, _extends2["default"])({
        prefixCls: prefixCls,
        tagName: tagName
      }, props));
    };

    Adapter.displayName = displayName;
    return Adapter;
  };
}

var Basic = function Basic(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      tagName = props.tagName,
      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);

  var classString = (0, _classnames["default"])(prefixCls, className);
  return /*#__PURE__*/React.createElement(tagName, (0, _extends2["default"])({
    className: classString
  }, others), children);
};

var BasicLayout = function BasicLayout(props) {
  var _classNames;

  var _React$useContext2 = React.useContext(_configProvider.ConfigContext),
      direction = _React$useContext2.direction;

  var _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      siders = _React$useState2[0],
      setSiders = _React$useState2[1];

  var prefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      hasSider = props.hasSider,
      Tag = props.tagName,
      others = __rest(props, ["prefixCls", "className", "children", "hasSider", "tagName"]);

  var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : siders.length > 0), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
    value: {
      siderHook: {
        addSider: function addSider(id) {
          setSiders(function (prev) {
            return [].concat((0, _toConsumableArray2["default"])(prev), [id]);
          });
        },
        removeSider: function removeSider(id) {
          setSiders(function (prev) {
            return prev.filter(function (currentId) {
              return currentId !== id;
            });
          });
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Tag, (0, _extends2["default"])({
    className: classString
  }, others), children));
};

var Layout = generator({
  suffixCls: 'layout',
  tagName: 'section',
  displayName: 'Layout'
})(BasicLayout);
var Header = generator({
  suffixCls: 'layout-header',
  tagName: 'header',
  displayName: 'Header'
})(Basic);
exports.Header = Header;
var Footer = generator({
  suffixCls: 'layout-footer',
  tagName: 'footer',
  displayName: 'Footer'
})(Basic);
exports.Footer = Footer;
var Content = generator({
  suffixCls: 'layout-content',
  tagName: 'main',
  displayName: 'Content'
})(Basic);
exports.Content = Content;
var _default = Layout;
exports["default"] = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content_404":"content_404___2Vifq","page404":"page404___scWPH"};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1125);

__webpack_require__(27);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1127);

__webpack_require__(29);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sugar_Column__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sugar_ColumnGroup__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Summary", function() { return __WEBPACK_IMPORTED_MODULE_1__Footer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_2__sugar_Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__sugar_ColumnGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "INTERNAL_COL_DEFINE", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_legacyUtil__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */]);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(571);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1144);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CollectionContext; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Collection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CollectionContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
/**
 * Collect all the resize event from children ResizeObserver
 */
function Collection(_ref) {
  var children = _ref.children,
    onBatchResize = _ref.onBatchResize;
  var resizeIdRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](0);
  var resizeInfosRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]([]);
  var onCollectionResize = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](CollectionContext);
  var onResize = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size: size,
      element: element,
      data: data
    });
    Promise.resolve().then(function () {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 ? void 0 : onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });
    // Continue bubbling if parent exist
    onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CollectionContext.Provider, {
    value: onResize
  }, children);
}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ColumnGroup(_) {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_) {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderRow__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_TableContext__ = __webpack_require__(107);




function parseHeaderRows(rootColumns) {
  var rows = [];

  function fillRowCells(columns, colIndex) {
    var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // Init rows
    rows[rowIndex] = rows[rowIndex] || [];
    var currentColIndex = colIndex;
    var colSpans = columns.filter(Boolean).map(function (column) {
      var cell = {
        key: column.key,
        className: column.className || '',
        children: column.title,
        column: column,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column.children;

      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function (total, count) {
          return total + count;
        }, 0);
        cell.hasSubColumns = true;
      }

      if ('colSpan' in column) {
        colSpan = column.colSpan;
      }

      if ('rowSpan' in column) {
        cell.rowSpan = column.rowSpan;
      }

      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  } // Generate `rows` cell data


  fillRowCells(rootColumns, 0); // Handle `rowSpan`

  var rowCount = rows.length;

  var _loop = function _loop(rowIndex) {
    rows[rowIndex].forEach(function (cell) {
      if (!('rowSpan' in cell) && !cell.hasSubColumns) {
        // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
      }
    });
  };

  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }

  return rows;
}

function Header(_ref) {
  var stickyOffsets = _ref.stickyOffsets,
      columns = _ref.columns,
      flattenColumns = _ref.flattenColumns,
      onHeaderRow = _ref.onHeaderRow;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      getComponent = _React$useContext.getComponent;

  var rows = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return parseHeaderRows(columns);
  }, [columns]);
  var WrapperComponent = getComponent(['header', 'wrapper'], 'thead');
  var trComponent = getComponent(['header', 'row'], 'tr');
  var thComponent = getComponent(['header', 'cell'], 'th');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrapperComponent, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function (row, rowIndex) {
    var rowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__HeaderRow__["a" /* default */], {
      key: rowIndex,
      flattenColumns: flattenColumns,
      cells: row,
      stickyOffsets: stickyOffsets,
      rowComponent: trComponent,
      cellComponent: thComponent,
      onHeaderRow: onHeaderRow,
      index: rowIndex
    });
    return rowNode;
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCellFixedInfo;
function getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
  var startColumn = columns[colStart] || {};
  var endColumn = columns[colEnd] || {};
  var fixLeft;
  var fixRight;

  if (startColumn.fixed === 'left') {
    fixLeft = stickyOffsets.left[colStart];
  } else if (endColumn.fixed === 'right') {
    fixRight = stickyOffsets.right[colEnd];
  }

  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns[colEnd + 1];
  var prevColumn = columns[colStart - 1];

  if (direction === 'rtl') {
    if (fixLeft !== undefined) {
      var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
      firstFixLeft = !prevFixLeft;
    } else if (fixRight !== undefined) {
      var nextFixRight = nextColumn && nextColumn.fixed === 'right';
      lastFixRight = !nextFixRight;
    }
  } else if (fixLeft !== undefined) {
    var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
    lastFixLeft = !nextFixLeft;
  } else if (fixRight !== undefined) {
    var prevFixRight = prevColumn && prevColumn.fixed === 'right';
    firstFixRight = !prevFixRight;
  }

  return {
    fixLeft: fixLeft,
    fixRight: fixRight,
    lastFixLeft: lastFixLeft,
    firstFixRight: firstFixRight,
    lastFixRight: lastFixRight,
    firstFixLeft: firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_legacyUtil__ = __webpack_require__(272);




function ColGroup(_ref) {
  var colWidths = _ref.colWidths,
      columns = _ref.columns,
      columCount = _ref.columCount;
  var cols = [];
  var len = columCount || columns.length; // Only insert col with width & additional props
  // Skip if rest col do not have any useful info

  var mustInsert = false;

  for (var i = len - 1; i >= 0; i -= 1) {
    var width = colWidths[i];
    var column = columns && columns[i];
    var additionalProps = column && column[__WEBPACK_IMPORTED_MODULE_2__utils_legacyUtil__["a" /* INTERNAL_COL_DEFINE */]];

    if (width || additionalProps || mustInsert) {
      cols.unshift( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("col", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        key: i,
        style: {
          width: width,
          minWidth: width
        }
      }, additionalProps)));
      mustInsert = true;
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("colgroup", null, cols);
}

/* harmony default export */ __webpack_exports__["a"] = (ColGroup);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_TableContext__ = __webpack_require__(107);




function ExpandedRow(_ref) {
  var prefixCls = _ref.prefixCls,
      children = _ref.children,
      Component = _ref.component,
      cellComponent = _ref.cellComponent,
      fixHeader = _ref.fixHeader,
      fixColumn = _ref.fixColumn,
      horizonScroll = _ref.horizonScroll,
      className = _ref.className,
      expanded = _ref.expanded,
      componentWidth = _ref.componentWidth,
      colSpan = _ref.colSpan;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__context_TableContext__["a" /* default */]),
      scrollbarSize = _React$useContext.scrollbarSize; // Cache render node


  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    var contentNode = children;

    if (fixColumn) {
      contentNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        style: {
          width: componentWidth - (fixHeader ? scrollbarSize : 0),
          position: 'sticky',
          left: 0,
          overflow: 'hidden'
        },
        className: "".concat(prefixCls, "-expanded-row-fixed")
      }, contentNode);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, {
      className: className,
      style: {
        display: expanded ? null : 'none'
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* default */], {
      component: cellComponent,
      prefixCls: prefixCls,
      colSpan: colSpan
    }, contentNode));
  }, [children, Component, fixHeader, horizonScroll, className, expanded, componentWidth, colSpan, scrollbarSize]);
}

/* harmony default export */ __webpack_exports__["a"] = (ExpandedRow);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ResizeContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
/* harmony default export */ __webpack_exports__["a"] = (ResizeContext);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useLayoutState;
/* harmony export (immutable) */ __webpack_exports__["b"] = useTimeoutLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Execute code before next frame but async
 */

function useLayoutState(defaultState) {
  var stateRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(defaultState);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      forceUpdate = _useState2[1];

  var lastPromiseRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var updateBatchRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);

  function setFrameState(updater) {
    updateBatchRef.current.push(updater);
    var promise = Promise.resolve();
    lastPromiseRef.current = promise;
    promise.then(function () {
      if (lastPromiseRef.current === promise) {
        var prevBatch = updateBatchRef.current;
        var prevState = stateRef.current;
        updateBatchRef.current = [];
        prevBatch.forEach(function (batchUpdater) {
          stateRef.current = batchUpdater(stateRef.current);
        });
        lastPromiseRef.current = null;

        if (prevState !== stateRef.current) {
          forceUpdate({});
        }
      }
    });
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return function () {
      lastPromiseRef.current = null;
    };
  }, []);
  return [stateRef.current, setFrameState];
}
/** Lock frame, when frame pass reset the lock. */

function useTimeoutLock(defaultState) {
  var frameRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(defaultState || null);
  var timeoutRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();

  function cleanUp() {
    window.clearTimeout(timeoutRef.current);
  }

  function setState(newState) {
    frameRef.current = newState;
    cleanUp();
    timeoutRef.current = window.setTimeout(function () {
      frameRef.current = null;
      timeoutRef.current = undefined;
    }, 100);
  }

  function getState() {
    return frameRef.current;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return cleanUp;
  }, []);
  return [setState, getState];
}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cell__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Row__ = __webpack_require__(1166);





function Footer(_ref) {
  var children = _ref.children;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls;

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tfoot", {
    className: "".concat(prefixCls, "-summary")
  }, children);
}

/* harmony default export */ __webpack_exports__["b"] = (Footer);
var FooterComponents = {
  Cell: __WEBPACK_IMPORTED_MODULE_2__Cell__["a" /* default */],
  Row: __WEBPACK_IMPORTED_MODULE_3__Row__["a" /* default */]
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(584);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(275).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMemo;
var React = _interopRequireWildcard(__webpack_require__(0));
function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = React.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _HeaderRow = _interopRequireDefault(__webpack_require__(1185));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

function parseHeaderRows(rootColumns) {
  var rows = [];

  function fillRowCells(columns, colIndex) {
    var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // Init rows
    rows[rowIndex] = rows[rowIndex] || [];
    var currentColIndex = colIndex;
    var colSpans = columns.filter(Boolean).map(function (column) {
      var cell = {
        key: column.key,
        className: column.className || '',
        children: column.title,
        column: column,
        colStart: currentColIndex
      };
      var colSpan = 1;
      var subColumns = column.children;

      if (subColumns && subColumns.length > 0) {
        colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function (total, count) {
          return total + count;
        }, 0);
        cell.hasSubColumns = true;
      }

      if ('colSpan' in column) {
        colSpan = column.colSpan;
      }

      if ('rowSpan' in column) {
        cell.rowSpan = column.rowSpan;
      }

      cell.colSpan = colSpan;
      cell.colEnd = cell.colStart + colSpan - 1;
      rows[rowIndex].push(cell);
      currentColIndex += colSpan;
      return colSpan;
    });
    return colSpans;
  } // Generate `rows` cell data


  fillRowCells(rootColumns, 0); // Handle `rowSpan`

  var rowCount = rows.length;

  var _loop = function _loop(rowIndex) {
    rows[rowIndex].forEach(function (cell) {
      if (!('rowSpan' in cell) && !cell.hasSubColumns) {
        // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
      }
    });
  };

  for (var rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
    _loop(rowIndex);
  }

  return rows;
}

function Header(_ref) {
  var stickyOffsets = _ref.stickyOffsets,
      columns = _ref.columns,
      flattenColumns = _ref.flattenColumns,
      onHeaderRow = _ref.onHeaderRow;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls,
      getComponent = _React$useContext.getComponent;

  var rows = React.useMemo(function () {
    return parseHeaderRows(columns);
  }, [columns]);
  var WrapperComponent = getComponent(['header', 'wrapper'], 'thead');
  var trComponent = getComponent(['header', 'row'], 'tr');
  var thComponent = getComponent(['header', 'cell'], 'th');
  return /*#__PURE__*/React.createElement(WrapperComponent, {
    className: "".concat(prefixCls, "-thead")
  }, rows.map(function (row, rowIndex) {
    var rowNode = /*#__PURE__*/React.createElement(_HeaderRow.default, {
      key: rowIndex,
      flattenColumns: flattenColumns,
      cells: row,
      stickyOffsets: stickyOffsets,
      rowComponent: trComponent,
      cellComponent: thComponent,
      onHeaderRow: onHeaderRow,
      index: rowIndex
    });
    return rowNode;
  }));
}

var _default = Header;
exports.default = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCellFixedInfo = getCellFixedInfo;

function getCellFixedInfo(colStart, colEnd, columns, stickyOffsets, direction) {
  var startColumn = columns[colStart] || {};
  var endColumn = columns[colEnd] || {};
  var fixLeft;
  var fixRight;

  if (startColumn.fixed === 'left') {
    fixLeft = stickyOffsets.left[colStart];
  } else if (endColumn.fixed === 'right') {
    fixRight = stickyOffsets.right[colEnd];
  }

  var lastFixLeft = false;
  var firstFixRight = false;
  var lastFixRight = false;
  var firstFixLeft = false;
  var nextColumn = columns[colEnd + 1];
  var prevColumn = columns[colStart - 1];

  if (direction === 'rtl') {
    if (fixLeft !== undefined) {
      var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
      firstFixLeft = !prevFixLeft;
    } else if (fixRight !== undefined) {
      var nextFixRight = nextColumn && nextColumn.fixed === 'right';
      lastFixRight = !nextFixRight;
    }
  } else if (fixLeft !== undefined) {
    var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
    lastFixLeft = !nextFixLeft;
  } else if (fixRight !== undefined) {
    var prevFixRight = prevColumn && prevColumn.fixed === 'right';
    firstFixRight = !prevFixRight;
  }

  return {
    fixLeft: fixLeft,
    fixRight: fixRight,
    lastFixLeft: lastFixLeft,
    firstFixRight: firstFixRight,
    lastFixRight: lastFixRight,
    firstFixLeft: firstFixLeft,
    isSticky: stickyOffsets.isSticky
  };
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var React = _interopRequireWildcard(__webpack_require__(0));

var _legacyUtil = __webpack_require__(368);

function ColGroup(_ref) {
  var colWidths = _ref.colWidths,
      columns = _ref.columns,
      columCount = _ref.columCount;
  var cols = [];
  var len = columCount || columns.length; // Only insert col with width & additional props
  // Skip if rest col do not have any useful info

  var mustInsert = false;

  for (var i = len - 1; i >= 0; i -= 1) {
    var width = colWidths[i];
    var column = columns && columns[i];
    var additionalProps = column && column[_legacyUtil.INTERNAL_COL_DEFINE];

    if (width || additionalProps || mustInsert) {
      cols.unshift( /*#__PURE__*/React.createElement("col", (0, _extends2.default)({
        key: i,
        style: {
          width: width,
          minWidth: width
        }
      }, additionalProps)));
      mustInsert = true;
    }
  }

  return /*#__PURE__*/React.createElement("colgroup", null, cols);
}

var _default = ColGroup;
exports.default = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _Cell = _interopRequireDefault(__webpack_require__(276));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

function ExpandedRow(_ref) {
  var prefixCls = _ref.prefixCls,
      children = _ref.children,
      Component = _ref.component,
      cellComponent = _ref.cellComponent,
      fixHeader = _ref.fixHeader,
      fixColumn = _ref.fixColumn,
      horizonScroll = _ref.horizonScroll,
      className = _ref.className,
      expanded = _ref.expanded,
      componentWidth = _ref.componentWidth,
      colSpan = _ref.colSpan;

  var _React$useContext = React.useContext(_TableContext.default),
      scrollbarSize = _React$useContext.scrollbarSize; // Cache render node


  return React.useMemo(function () {
    var contentNode = children;

    if (fixColumn) {
      contentNode = /*#__PURE__*/React.createElement("div", {
        style: {
          width: componentWidth - (fixHeader ? scrollbarSize : 0),
          position: 'sticky',
          left: 0,
          overflow: 'hidden'
        },
        className: "".concat(prefixCls, "-expanded-row-fixed")
      }, contentNode);
    }

    return /*#__PURE__*/React.createElement(Component, {
      className: className,
      style: {
        display: expanded ? null : 'none'
      }
    }, /*#__PURE__*/React.createElement(_Cell.default, {
      component: cellComponent,
      prefixCls: prefixCls,
      colSpan: colSpan
    }, contentNode));
  }, [children, Component, fixHeader, horizonScroll, className, expanded, componentWidth, colSpan, scrollbarSize]);
}

var _default = ExpandedRow;
exports.default = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ResizeContext = /*#__PURE__*/React.createContext(null);
var _default = ResizeContext;
exports.default = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertChildrenToColumns = convertChildrenToColumns;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(366));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(274));

var React = _interopRequireWildcard(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(106));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _legacyUtil = __webpack_require__(368);

function convertChildrenToColumns(children) {
  return (0, _toArray.default)(children).filter(function (node) {
    return /*#__PURE__*/React.isValidElement(node);
  }).map(function (_ref) {
    var key = _ref.key,
        props = _ref.props;
    var nodeChildren = props.children,
        restProps = (0, _objectWithoutProperties2.default)(props, ["children"]);
    var column = (0, _objectSpread2.default)({
      key: key
    }, restProps);

    if (nodeChildren) {
      column.children = convertChildrenToColumns(nodeChildren);
    }

    return column;
  });
}

function flatColumns(columns) {
  return columns.reduce(function (list, column) {
    var fixed = column.fixed; // Convert `fixed='true'` to `fixed='left'` instead

    var parsedFixed = fixed === true ? 'left' : fixed;
    var subColumns = column.children;

    if (subColumns && subColumns.length > 0) {
      return [].concat((0, _toConsumableArray2.default)(list), (0, _toConsumableArray2.default)(flatColumns(subColumns).map(function (subColum) {
        return (0, _objectSpread2.default)({
          fixed: parsedFixed
        }, subColum);
      })));
    }

    return [].concat((0, _toConsumableArray2.default)(list), [(0, _objectSpread2.default)((0, _objectSpread2.default)({}, column), {}, {
      fixed: parsedFixed
    })]);
  }, []);
}

function warningFixed(flattenColumns) {
  var allFixLeft = true;

  for (var i = 0; i < flattenColumns.length; i += 1) {
    var col = flattenColumns[i];

    if (allFixLeft && col.fixed !== 'left') {
      allFixLeft = false;
    } else if (!allFixLeft && col.fixed === 'left') {
      (0, _warning.default)(false, "Index ".concat(i - 1, " of `columns` missing `fixed='left'` prop."));
      break;
    }
  }

  var allFixRight = true;

  for (var _i = flattenColumns.length - 1; _i >= 0; _i -= 1) {
    var _col = flattenColumns[_i];

    if (allFixRight && _col.fixed !== 'right') {
      allFixRight = false;
    } else if (!allFixRight && _col.fixed === 'right') {
      (0, _warning.default)(false, "Index ".concat(_i + 1, " of `columns` missing `fixed='right'` prop."));
      break;
    }
  }
}

function revertForRtl(columns) {
  return columns.map(function (column) {
    var fixed = column.fixed,
        restProps = (0, _objectWithoutProperties2.default)(column, ["fixed"]); // Convert `fixed='left'` to `fixed='right'` instead

    var parsedFixed = fixed;

    if (fixed === 'left') {
      parsedFixed = 'right';
    } else if (fixed === 'right') {
      parsedFixed = 'left';
    }

    return (0, _objectSpread2.default)({
      fixed: parsedFixed
    }, restProps);
  });
}
/**
 * Parse `columns` & `children` into `columns`.
 */


function useColumns(_ref2, transformColumns) {
  var prefixCls = _ref2.prefixCls,
      columns = _ref2.columns,
      children = _ref2.children,
      expandable = _ref2.expandable,
      expandedKeys = _ref2.expandedKeys,
      getRowKey = _ref2.getRowKey,
      onTriggerExpand = _ref2.onTriggerExpand,
      expandIcon = _ref2.expandIcon,
      rowExpandable = _ref2.rowExpandable,
      expandIconColumnIndex = _ref2.expandIconColumnIndex,
      direction = _ref2.direction,
      expandRowByClick = _ref2.expandRowByClick,
      columnWidth = _ref2.columnWidth;
  var baseColumns = React.useMemo(function () {
    return columns || convertChildrenToColumns(children);
  }, [columns, children]); // Add expand column

  var withExpandColumns = React.useMemo(function () {
    if (expandable) {
      var _expandColumn;

      var expandColIndex = expandIconColumnIndex || 0;
      var prevColumn = baseColumns[expandColIndex];
      var expandColumn = (_expandColumn = {}, (0, _defineProperty2.default)(_expandColumn, _legacyUtil.INTERNAL_COL_DEFINE, {
        className: "".concat(prefixCls, "-expand-icon-col")
      }), (0, _defineProperty2.default)(_expandColumn, "title", ''), (0, _defineProperty2.default)(_expandColumn, "fixed", prevColumn ? prevColumn.fixed : null), (0, _defineProperty2.default)(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), (0, _defineProperty2.default)(_expandColumn, "width", columnWidth), (0, _defineProperty2.default)(_expandColumn, "render", function render(_, record, index) {
        var rowKey = getRowKey(record, index);
        var expanded = expandedKeys.has(rowKey);
        var recordExpandable = rowExpandable ? rowExpandable(record) : true;
        var icon = expandIcon({
          prefixCls: prefixCls,
          expanded: expanded,
          expandable: recordExpandable,
          record: record,
          onExpand: onTriggerExpand
        });

        if (expandRowByClick) {
          return /*#__PURE__*/React.createElement("span", {
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, icon);
        }

        return icon;
      }), _expandColumn); // Insert expand column in the target position

      var cloneColumns = baseColumns.slice();

      if (expandColIndex >= 0) {
        cloneColumns.splice(expandColIndex, 0, expandColumn);
      }

      return cloneColumns;
    }

    return baseColumns;
  }, [expandable, baseColumns, getRowKey, expandedKeys, expandIcon, direction]);
  var mergedColumns = React.useMemo(function () {
    var finalColumns = withExpandColumns;

    if (transformColumns) {
      finalColumns = transformColumns(finalColumns);
    } // Always provides at least one column for table display


    if (!finalColumns.length) {
      finalColumns = [{
        render: function render() {
          return null;
        }
      }];
    }

    return finalColumns;
  }, [transformColumns, withExpandColumns, direction]);
  var flattenColumns = React.useMemo(function () {
    if (direction === 'rtl') {
      return revertForRtl(flatColumns(mergedColumns));
    }

    return flatColumns(mergedColumns);
  }, [mergedColumns, direction]); // Only check out of production since it's waste for each render

  if (false) {
    warningFixed(flattenColumns);
  }

  return [mergedColumns, flattenColumns];
}

var _default = useColumns;
exports.default = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayoutState = useLayoutState;
exports.useTimeoutLock = useTimeoutLock;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(273));

var _react = __webpack_require__(0);

/**
 * Execute code before next frame but async
 */
function useLayoutState(defaultState) {
  var stateRef = (0, _react.useRef)(defaultState);

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      forceUpdate = _useState2[1];

  var lastPromiseRef = (0, _react.useRef)(null);
  var updateBatchRef = (0, _react.useRef)([]);

  function setFrameState(updater) {
    updateBatchRef.current.push(updater);
    var promise = Promise.resolve();
    lastPromiseRef.current = promise;
    promise.then(function () {
      if (lastPromiseRef.current === promise) {
        var prevBatch = updateBatchRef.current;
        var prevState = stateRef.current;
        updateBatchRef.current = [];
        prevBatch.forEach(function (batchUpdater) {
          stateRef.current = batchUpdater(stateRef.current);
        });
        lastPromiseRef.current = null;

        if (prevState !== stateRef.current) {
          forceUpdate({});
        }
      }
    });
  }

  (0, _react.useEffect)(function () {
    return function () {
      lastPromiseRef.current = null;
    };
  }, []);
  return [stateRef.current, setFrameState];
}
/** Lock frame, when frame pass reset the lock. */


function useTimeoutLock(defaultState) {
  var frameRef = (0, _react.useRef)(defaultState || null);
  var timeoutRef = (0, _react.useRef)();

  function cleanUp() {
    window.clearTimeout(timeoutRef.current);
  }

  function setState(newState) {
    frameRef.current = newState;
    cleanUp();
    timeoutRef.current = window.setTimeout(function () {
      frameRef.current = null;
      timeoutRef.current = undefined;
    }, 100);
  }

  function getState() {
    return frameRef.current;
  }

  (0, _react.useEffect)(function () {
    return cleanUp;
  }, []);
  return [setState, getState];
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;
var _reactDom = _interopRequireDefault(__webpack_require__(52));
function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(277),
    now = __webpack_require__(1198),
    toNumber = __webpack_require__(1199);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pagination = _interopRequireDefault(__webpack_require__(1205));

var _default = _Pagination["default"];
exports["default"] = _default;

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1209);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(599);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1211);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1214);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1230);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1243);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(280);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(610);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function (isScrollAtTop, isScrollAtBottom) {
  // Do lock for a wheel when scrolling
  var lockRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var lockTimeoutRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function () {
      lockRef.current = false;
    }, 50);
  }
  // Pass to ref since global add is in closure
  var scrollPingRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
    top: isScrollAtTop,
    bottom: isScrollAtBottom
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  return function (deltaY) {
    var smoothOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var originScroll =
    // Pass origin wheel when on the top
    deltaY < 0 && scrollPingRef.current.top ||
    // Pass origin wheel when on the bottom
    deltaY > 0 && scrollPingRef.current.bottom;
    if (smoothOffset && originScroll) {
      // No need lock anymore when it's smooth offset from touchMove interval
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** This is a placeholder, not real render in dom */
var Option = function Option() {
  return null;
};

Option.isSelectOption = true;
/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** This is a placeholder, not real render in dom */
var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
/* harmony default export */ __webpack_exports__["a"] = (OptGroup);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertChildrenToData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_toArray__ = __webpack_require__(135);





function convertNodeToOption(node) {
  var key = node.key,
      _node$props = node.props,
      children = _node$props.children,
      value = _node$props.value,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_node$props, ["children", "value"]);

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    key: key,
    value: value !== undefined ? value : key,
    children: children
  }, restProps);
}

function convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_toArray__["a" /* default */])(nodes).map(function (node, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](node) || !node.type) {
      return null;
    }

    var isSelectOptGroup = node.type.isSelectOptGroup,
        key = node.key,
        _node$props2 = node.props,
        children = _node$props2.children,
        restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_node$props2, ["children"]);

    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
      label: key
    }, restProps), {}, {
      options: convertChildrenToData(children)
    });
  }).filter(function (data) {
    return data;
  });
}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = flattenOptions;
/* harmony export (immutable) */ __webpack_exports__["c"] = findValueOption;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLabeledValue; });
/* harmony export (immutable) */ __webpack_exports__["b"] = filterOptions;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSeparatedContent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isValueDisabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = fillOptionsWithMissingValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonUtil__ = __webpack_require__(281);








function getKey(data, index) {
  var key = data.key;
  var value;

  if ('value' in data) {
    value = data.value;
  }

  if (key !== null && key !== undefined) {
    return key;
  }

  if (value !== undefined) {
    return value;
  }

  return "rc-index-key-".concat(index);
}
/**
 * Flat options into flatten list.
 * We use `optionOnly` here is aim to avoid user use nested option group.
 * Here is simply set `key` to the index if not provided.
 */


function flattenOptions(options) {
  var flattenList = [];

  function dig(list, isGroupOption) {
    list.forEach(function (data) {
      if (isGroupOption || !('options' in data)) {
        // Option
        flattenList.push({
          key: getKey(data, flattenList.length),
          groupOption: isGroupOption,
          data: data
        });
      } else {
        // Option Group
        flattenList.push({
          key: getKey(data, flattenList.length),
          group: true,
          data: data
        });
        dig(data.options, true);
      }
    });
  }

  dig(options, false);
  return flattenList;
}
/**
 * Inject `props` into `option` for legacy usage
 */

function injectPropsWithOption(option) {
  var newOption = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, option);

  if (!('props' in newOption)) {
    Object.defineProperty(newOption, 'props', {
      get: function get() {
        Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__["a" /* default */])(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
        return newOption;
      }
    });
  }

  return newOption;
}

function findValueOption(values, options) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$prevValueOptions = _ref.prevValueOptions,
      prevValueOptions = _ref$prevValueOptions === void 0 ? [] : _ref$prevValueOptions;

  var optionMap = new Map();
  options.forEach(function (flattenItem) {
    if (!flattenItem.group) {
      var data = flattenItem.data; // Check if match

      optionMap.set(data.value, data);
    }
  });
  return values.map(function (val) {
    var option = optionMap.get(val); // Fallback to try to find prev options

    if (!option) {
      option = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, prevValueOptions.find(function (opt) {
        return opt._INTERNAL_OPTION_VALUE_ === val;
      }));
    }

    return injectPropsWithOption(option);
  });
}
var getLabeledValue = function getLabeledValue(value, _ref2) {
  var options = _ref2.options,
      prevValue = _ref2.prevValue,
      labelInValue = _ref2.labelInValue,
      optionLabelProp = _ref2.optionLabelProp;
  var item = findValueOption([value], options)[0];
  var result = {
    value: value
  };
  var prevValItem;
  var prevValues = Object(__WEBPACK_IMPORTED_MODULE_6__commonUtil__["d" /* toArray */])(prevValue);

  if (labelInValue) {
    prevValItem = prevValues.find(function (prevItem) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(prevItem) === 'object' && 'value' in prevItem) {
        return prevItem.value === value;
      } // [Legacy] Support `key` as `value`


      return prevItem.key === value;
    });
  }

  if (prevValItem && Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(prevValItem) === 'object' && 'label' in prevValItem) {
    result.label = prevValItem.label;

    if (item && typeof prevValItem.label === 'string' && typeof item[optionLabelProp] === 'string' && prevValItem.label.trim() !== item[optionLabelProp].trim()) {
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__["a" /* default */])(false, '`label` of `value` is not same as `label` in Select options.');
    }
  } else if (item && optionLabelProp in item) {
    result.label = item[optionLabelProp];
  } else {
    result.label = value;
    result.isCacheable = true;
  } // Used for motion control


  result.key = result.value;
  return result;
};

function toRawString(content) {
  return Object(__WEBPACK_IMPORTED_MODULE_6__commonUtil__["d" /* toArray */])(content).join('');
}
/** Filter single option if match the search text */


function getFilterFunction(optionFilterProp) {
  return function (searchValue, option) {
    var lowerSearchText = searchValue.toLowerCase(); // Group label search

    if ('options' in option) {
      return toRawString(option.label).toLowerCase().includes(lowerSearchText);
    } // Option value search


    var rawValue = option[optionFilterProp];
    var value = toRawString(rawValue).toLowerCase();
    return value.includes(lowerSearchText);
  };
}
/** Filter options and return a new options by the search text */


function filterOptions(searchValue, options, _ref3) {
  var optionFilterProp = _ref3.optionFilterProp,
      filterOption = _ref3.filterOption;
  var filteredOptions = [];
  var filterFunc;

  if (filterOption === false) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(options);
  }

  if (typeof filterOption === 'function') {
    filterFunc = filterOption;
  } else {
    filterFunc = getFilterFunction(optionFilterProp);
  }

  options.forEach(function (item) {
    // Group should check child options
    if ('options' in item) {
      // Check group first
      var matchGroup = filterFunc(searchValue, item);

      if (matchGroup) {
        filteredOptions.push(item);
      } else {
        // Check option
        var subOptions = item.options.filter(function (subItem) {
          return filterFunc(searchValue, subItem);
        });

        if (subOptions.length) {
          filteredOptions.push(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, item), {}, {
            options: subOptions
          }));
        }
      }

      return;
    }

    if (filterFunc(searchValue, injectPropsWithOption(item))) {
      filteredOptions.push(item);
    }
  });
  return filteredOptions;
}
function getSeparatedContent(text, tokens) {
  if (!tokens || !tokens.length) {
    return null;
  }

  var match = false;

  function separate(str, _ref4) {
    var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_ref4),
        token = _ref5[0],
        restTokens = _ref5.slice(1);

    if (!token) {
      return [str];
    }

    var list = str.split(token);
    match = match || list.length > 1;
    return list.reduce(function (prevList, unitStr) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(prevList), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(separate(unitStr, restTokens)));
    }, []).filter(function (unit) {
      return unit;
    });
  }

  var list = separate(text, tokens);
  return match ? list : null;
}
function isValueDisabled(value, options) {
  var option = findValueOption([value], options)[0];
  return option.disabled;
}
/**
 * `tags` mode should fill un-list item into the option list
 */

function fillOptionsWithMissingValue(options, value, optionLabelProp, labelInValue) {
  var values = Object(__WEBPACK_IMPORTED_MODULE_6__commonUtil__["d" /* toArray */])(value).slice().sort();

  var cloneOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(options); // Convert options value to set


  var optionValues = new Set();
  options.forEach(function (opt) {
    if (opt.options) {
      opt.options.forEach(function (subOpt) {
        optionValues.add(subOpt.value);
      });
    } else {
      optionValues.add(opt.value);
    }
  }); // Fill missing value

  values.forEach(function (item) {
    var val = labelInValue ? item.value : item;

    if (!optionValues.has(val)) {
      var _ref6;

      cloneOptions.push(labelInValue ? (_ref6 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref6, optionLabelProp, item.label), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref6, "value", val), _ref6) : {
        value: val
      });
    }
  });
  return cloneOptions;
}

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverflowContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_resize_observer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_hooks_useLayoutEffect__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Item__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useBatchFrameState__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RawItem__ = __webpack_require__(1288);




var _excluded = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];








var OverflowContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createContext"](null);
var RESPONSIVE = 'responsive';
var INVALIDATE = 'invalidate';

function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}

function Overflow(props, ref) {
  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      renderItem = props.renderItem,
      renderRawItem = props.renderRawItem,
      itemKey = props.itemKey,
      _props$itemWidth = props.itemWidth,
      itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth,
      ssr = props.ssr,
      style = props.style,
      className = props.className,
      maxCount = props.maxCount,
      renderRest = props.renderRest,
      renderRawRest = props.renderRawRest,
      suffix = props.suffix,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      itemComponent = props.itemComponent,
      onVisibleChange = props.onVisibleChange,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

  var createUseState = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useBatchFrameState__["a" /* useBatchFrameState */])();
  var fullySSR = ssr === 'full';

  var _createUseState = createUseState(null),
      _createUseState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_createUseState, 2),
      containerWidth = _createUseState2[0],
      setContainerWidth = _createUseState2[1];

  var mergedContainerWidth = containerWidth || 0;

  var _createUseState3 = createUseState(new Map()),
      _createUseState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_createUseState3, 2),
      itemWidths = _createUseState4[0],
      setItemWidths = _createUseState4[1];

  var _createUseState5 = createUseState(0),
      _createUseState6 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_createUseState5, 2),
      prevRestWidth = _createUseState6[0],
      setPrevRestWidth = _createUseState6[1];

  var _createUseState7 = createUseState(0),
      _createUseState8 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_createUseState7, 2),
      restWidth = _createUseState8[0],
      setRestWidth = _createUseState8[1];

  var _createUseState9 = createUseState(0),
      _createUseState10 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_createUseState9, 2),
      suffixWidth = _createUseState10[0],
      setSuffixWidth = _createUseState10[1];

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(null),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      suffixFixedStart = _useState2[0],
      setSuffixFixedStart = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(null),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      displayCount = _useState4[0],
      setDisplayCount = _useState4[1];

  var mergedDisplayCount = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }

    return displayCount || 0;
  }, [displayCount, containerWidth]);

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      restReady = _useState6[0],
      setRestReady = _useState6[1];

  var itemPrefixCls = "".concat(prefixCls, "-item"); // Always use the max width to avoid blink

  var mergedRestWidth = Math.max(prevRestWidth, restWidth); // ================================= Data =================================

  var isResponsive = maxCount === RESPONSIVE;
  var shouldResponsive = data.length && isResponsive;
  var invalidate = maxCount === INVALIDATE;
  /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */

  var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
  var mergedData = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
    var items = data;

    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data;
      } else {
        items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount === 'number') {
      items = data.slice(0, maxCount);
    }

    return items;
  }, [data, itemWidth, containerWidth, maxCount, shouldResponsive]);
  var omittedItems = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
    if (shouldResponsive) {
      return data.slice(mergedDisplayCount + 1);
    }

    return data.slice(mergedData.length);
  }, [data, mergedData, shouldResponsive, mergedDisplayCount]); // ================================= Item =================================

  var getKey = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useCallback"])(function (item, index) {
    var _ref;

    if (typeof itemKey === 'function') {
      return itemKey(item);
    }

    return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
  }, [itemKey]);
  var mergedRenderItem = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useCallback"])(renderItem || function (item) {
    return item;
  }, [renderItem]);

  function updateDisplayCount(count, suffixFixedStartVal, notReady) {
    // React 18 will sync render even when the value is same in some case.
    // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
    // ref: https://github.com/ant-design/ant-design/issues/36559
    if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) {
      return;
    }

    setDisplayCount(count);

    if (!notReady) {
      setRestReady(count < data.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(count);
    }

    if (suffixFixedStartVal !== undefined) {
      setSuffixFixedStart(suffixFixedStartVal);
    }
  } // ================================= Size =================================


  function onOverflowResize(_, element) {
    setContainerWidth(element.clientWidth);
  }

  function registerSize(key, width) {
    setItemWidths(function (origin) {
      var clone = new Map(origin);

      if (width === null) {
        clone.delete(key);
      } else {
        clone.set(key, width);
      }

      return clone;
    });
  }

  function registerOverflowSize(_, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }

  function registerSuffixSize(_, width) {
    setSuffixWidth(width);
  } // ================================ Effect ================================


  function getItemWidth(index) {
    return itemWidths.get(getKey(mergedData[index], index));
  }

  Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    if (mergedContainerWidth && mergedRestWidth && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1; // When data count change to 0, reset this since not loop will reach

      if (!len) {
        updateDisplayCount(0, null);
        return;
      }

      for (var i = 0; i < len; i += 1) {
        var currentItemWidth = getItemWidth(i); // Fully will always render

        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        } // Break since data not ready


        if (currentItemWidth === undefined) {
          updateDisplayCount(i - 1, undefined, true);
          break;
        } // Find best match


        totalWidth += currentItemWidth;

        if ( // Only one means `totalWidth` is the final width
        lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
        i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
          // Additional check if match the end
          updateDisplayCount(lastIndex, null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          // Can not hold all the content to show rest
          updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }

      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey, mergedData]); // ================================ Render ================================

  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};

  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: 'absolute',
      left: suffixFixedStart,
      top: 0
    };
  }

  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate: invalidate
  }; // >>>>> Choice render fun by `renderRawItem`

  var internalRenderItemNode = renderRawItem ? function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](OverflowContext.Provider, {
      key: key,
      value: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, itemSharedProps), {}, {
        order: index,
        item: item,
        itemKey: key,
        registerSize: registerSize,
        display: index <= mergedDisplayCount
      })
    }, renderRawItem(item, index));
  } : function (item, index) {
    var key = getKey(item, index);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Item__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, itemSharedProps, {
      order: index,
      key: key,
      item: item,
      renderItem: mergedRenderItem,
      itemKey: key,
      registerSize: registerSize,
      display: index <= mergedDisplayCount
    }));
  }; // >>>>> Rest node

  var restNode;
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };

  if (!renderRawRest) {
    var mergedRenderRest = renderRest || defaultRenderRest;
    restNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Item__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
  } else if (renderRawRest) {
    restNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](OverflowContext.Provider, {
      value: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
  }

  var overflowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(!invalidate && prefixCls, className),
    style: style,
    ref: ref
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Item__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));

  if (isResponsive) {
    overflowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_rc_resize_observer__["default"], {
      onResize: onOverflowResize,
      disabled: !shouldResponsive
    }, overflowNode);
  }

  return overflowNode;
}

var ForwardOverflow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](Overflow);
ForwardOverflow.displayName = 'Overflow';
ForwardOverflow.Item = __WEBPACK_IMPORTED_MODULE_10__RawItem__["a" /* default */];
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE; // Convert to generic type

/* harmony default export */ __webpack_exports__["b"] = (ForwardOverflow);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1278);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1285);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_resize_observer__ = __webpack_require__(97);



var _excluded = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];


 // Use shared variable to save bundle size

var UNDEFINED = undefined;

function InternalItem(props, ref) {
  var prefixCls = props.prefixCls,
      invalidate = props.invalidate,
      item = props.item,
      renderItem = props.renderItem,
      responsive = props.responsive,
      responsiveDisabled = props.responsiveDisabled,
      registerSize = props.registerSize,
      itemKey = props.itemKey,
      className = props.className,
      style = props.style,
      children = props.children,
      display = props.display,
      order = props.order,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

  var mergedHidden = responsive && !display; // ================================ Effect ================================

  function internalRegisterSize(width) {
    registerSize(itemKey, width);
  }

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      internalRegisterSize(null);
    };
  }, []); // ================================ Render ================================

  var childNode = renderItem && item !== UNDEFINED ? renderItem(item) : children;
  var overflowStyle;

  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? 'hidden' : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? 'none' : UNDEFINED,
      position: mergedHidden ? 'absolute' : UNDEFINED
    };
  }

  var overflowProps = {};

  if (mergedHidden) {
    overflowProps['aria-hidden'] = true;
  }

  var itemNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(!invalidate && prefixCls, className),
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, overflowStyle), style)
  }, overflowProps, restProps, {
    ref: ref
  }), childNode);

  if (responsive) {
    itemNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_resize_observer__["default"], {
      onResize: function onResize(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }

  return itemNode;
}

var Item = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](InternalItem);
Item.displayName = 'Item';
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_ref__ = __webpack_require__(122);




var Input = function Input(_ref, ref) {
  var prefixCls = _ref.prefixCls,
      id = _ref.id,
      inputElement = _ref.inputElement,
      disabled = _ref.disabled,
      tabIndex = _ref.tabIndex,
      autoFocus = _ref.autoFocus,
      autoComplete = _ref.autoComplete,
      editable = _ref.editable,
      accessibilityIndex = _ref.accessibilityIndex,
      value = _ref.value,
      maxLength = _ref.maxLength,
      _onKeyDown = _ref.onKeyDown,
      _onMouseDown = _ref.onMouseDown,
      _onChange = _ref.onChange,
      onPaste = _ref.onPaste,
      _onCompositionStart = _ref.onCompositionStart,
      _onCompositionEnd = _ref.onCompositionEnd,
      open = _ref.open,
      attrs = _ref.attrs;
  var inputNode = inputElement || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", null);
  var _inputNode = inputNode,
      originRef = _inputNode.ref,
      _inputNode$props = _inputNode.props,
      onOriginKeyDown = _inputNode$props.onKeyDown,
      onOriginChange = _inputNode$props.onChange,
      onOriginMouseDown = _inputNode$props.onMouseDown,
      onOriginCompositionStart = _inputNode$props.onCompositionStart,
      onOriginCompositionEnd = _inputNode$props.onCompositionEnd,
      style = _inputNode$props.style;
  inputNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](inputNode, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    id: id,
    ref: Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_ref__["a" /* composeRef */])(ref, originRef),
    disabled: disabled,
    tabIndex: tabIndex,
    autoComplete: autoComplete || 'off',
    type: 'search',
    autoFocus: autoFocus,
    className: "".concat(prefixCls, "-selection-search-input"),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), {}, {
      opacity: editable ? null : 0
    }),
    role: 'combobox',
    'aria-expanded': open,
    'aria-haspopup': 'listbox',
    'aria-owns': "".concat(id, "_list"),
    'aria-autocomplete': 'list',
    'aria-controls': "".concat(id, "_list"),
    'aria-activedescendant': "".concat(id, "_list_").concat(accessibilityIndex)
  }, attrs), {}, {
    value: editable ? value : '',
    maxLength: maxLength,
    readOnly: !editable,
    unselectable: !editable ? 'on' : null,
    onKeyDown: function onKeyDown(event) {
      _onKeyDown(event);

      if (onOriginKeyDown) {
        onOriginKeyDown(event);
      }
    },
    onMouseDown: function onMouseDown(event) {
      _onMouseDown(event);

      if (onOriginMouseDown) {
        onOriginMouseDown(event);
      }
    },
    onChange: function onChange(event) {
      _onChange(event);

      if (onOriginChange) {
        onOriginChange(event);
      }
    },
    onCompositionStart: function onCompositionStart(event) {
      _onCompositionStart(event);

      if (onOriginCompositionStart) {
        onOriginCompositionStart(event);
      }
    },
    onCompositionEnd: function onCompositionEnd(event) {
      _onCompositionEnd(event);

      if (onOriginCompositionEnd) {
        onOriginCompositionEnd(event);
      }
    },
    onPaste: onPaste
  }));
  return inputNode;
};

var RefInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](Input);
RefInput.displayName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (RefInput);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useLayoutEffect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_commonUtil__ = __webpack_require__(281);
/* eslint-disable react-hooks/rules-of-hooks */


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */

function useLayoutEffect(effect, deps) {
  // Never happen in test env
  if (__WEBPACK_IMPORTED_MODULE_1__utils_commonUtil__["b" /* isBrowserClient */]) {
    /* istanbul ignore next */
    __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"](effect, deps);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](effect, deps);
  }
}
/* eslint-enable */

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Locker return cached mark.
 * If set to `true`, will return `true` in a short time even if set `false`.
 * If set to `false` and then set to `true`, will change to `true`.
 * And after time duration, it will back to `null` automatically.
 */

function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  var lockRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var timeoutRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null); // Clean up

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);

  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }

    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function () {
      lockRef.current = null;
    }, duration);
  }

  return [function () {
    return lockRef.current;
  }, doLock];
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(629);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1291);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dom_canUseDom__ = __webpack_require__(161);



var Portal = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
  var didUpdate = props.didUpdate,
    getContainer = props.getContainer,
    children = props.children;
  var parentRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  // Ref return nothing, only for wrapper check exist
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () {
    return {};
  });

  // Create container in client side with sync to avoid useEffect not get ref
  var initRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  if (!initRef.current && Object(__WEBPACK_IMPORTED_MODULE_2__Dom_canUseDom__["a" /* default */])()) {
    containerRef.current = getContainer();
    parentRef.current = containerRef.current.parentNode;
    initRef.current = true;
  }

  // [Legacy] Used by `rc-trigger`
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
  });
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    // Restore container to original place
    // React 18 StrictMode will unmount first and mount back for effect test:
    // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
    if (containerRef.current.parentNode === null && parentRef.current !== null) {
      parentRef.current.appendChild(containerRef.current);
    }
    return function () {
      var _containerRef$current, _containerRef$current2;
      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
      // Since some component use `Portal` directly, we have to keep the logic here.
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(children, containerRef.current) : null;
});
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotion;
function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      animation = _ref.animation,
      transitionName = _ref.transitionName;

  if (motion) {
    return motion;
  }

  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }

  if (transitionName) {
    return {
      motionName: transitionName
    };
  }

  return null;
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1317);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CheckOutlined = _interopRequireDefault(__webpack_require__(1338));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CheckOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SearchOutlined = _interopRequireDefault(__webpack_require__(98));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _SearchOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(218);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKey = getKey;
exports.warningWithoutKey = warningWithoutKey;
exports.convertTreeToData = convertTreeToData;
exports.flattenTreeData = flattenTreeData;
exports.traverseDataNodes = traverseDataNodes;
exports.convertDataToEntities = convertDataToEntities;
exports.getTreeNodeProps = getTreeNodeProps;
exports.convertNodePropsToEventData = convertNodePropsToEventData;

var _typeof2 = _interopRequireDefault(__webpack_require__(175));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(638));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(640));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(381));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _warning = _interopRequireDefault(__webpack_require__(106));

var _util = __webpack_require__(382);

function getKey(key, pos) {
  if (key !== null && key !== undefined) {
    return key;
  }

  return pos;
}
/**
 * Warning if TreeNode do not provides key
 */


function warningWithoutKey() {
  var treeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keys = new Map();

  function dig(list) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (list || []).forEach(function (treeNode) {
      var key = treeNode.key,
          children = treeNode.children;
      (0, _warning.default)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
      var recordKey = String(key);
      (0, _warning.default)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
      keys.set(recordKey, true);
      dig(children, "".concat(path).concat(recordKey, " > "));
    });
  }

  dig(treeData);
}
/**
 * Convert `children` of Tree into `treeData` structure.
 */


function convertTreeToData(rootNodes) {
  function dig(node) {
    var treeNodes = (0, _toArray.default)(node);
    return treeNodes.map(function (treeNode) {
      // Filter invalidate node
      if (!(0, _util.isTreeNode)(treeNode)) {
        (0, _warning.default)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
        return null;
      }

      var key = treeNode.key;
      var _treeNode$props = treeNode.props,
          children = _treeNode$props.children,
          rest = (0, _objectWithoutProperties2.default)(_treeNode$props, ["children"]);
      var dataNode = (0, _objectSpread2.default)({
        key: key
      }, rest);
      var parsedChildren = dig(children);

      if (parsedChildren.length) {
        dataNode.children = parsedChildren;
      }

      return dataNode;
    }).filter(function (dataNode) {
      return dataNode;
    });
  }

  return dig(rootNodes);
}
/**
 * Flat nest tree data into flatten list. This is used for virtual list render.
 * @param treeNodeList Origin data node list
 * @param expandedKeys
 * need expanded keys, provides `true` means all expanded (used in `rc-tree-select`).
 */


function flattenTreeData() {
  var treeNodeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var expandedKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
  var flattenList = [];

  function dig(list) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return list.map(function (treeNode, index) {
      var pos = (0, _util.getPosition)(parent ? parent.pos : '0', index);
      var mergedKey = getKey(treeNode.key, pos); // Add FlattenDataNode into list

      var flattenNode = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, treeNode), {}, {
        parent: parent,
        pos: pos,
        children: null,
        data: treeNode,
        isStart: [].concat((0, _toConsumableArray2.default)(parent ? parent.isStart : []), [index === 0]),
        isEnd: [].concat((0, _toConsumableArray2.default)(parent ? parent.isEnd : []), [index === list.length - 1])
      });
      flattenList.push(flattenNode); // Loop treeNode children

      if (expandedKeys === true || expandedKeySet.has(mergedKey)) {
        flattenNode.children = dig(treeNode.children || [], flattenNode);
      } else {
        flattenNode.children = [];
      }

      return flattenNode;
    });
  }

  dig(treeNodeList);
  return flattenList;
}
/**
 * Traverse all the data by `treeData`.
 * Please not use it out of the `rc-tree` since we may refactor this code.
 */


function traverseDataNodes(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
  // Init config
  var externalGetKey = null;
  var childrenPropName;
  var configType = (0, _typeof2.default)(config);

  if (configType === 'function' || configType === 'string') {
    // Legacy getKey param
    externalGetKey = config;
  } else if (config && configType === 'object') {
    childrenPropName = config.childrenPropName;
    externalGetKey = config.externalGetKey;
  }

  childrenPropName = childrenPropName || 'children'; // Get keys

  var syntheticGetKey;

  if (externalGetKey) {
    if (typeof externalGetKey === 'string') {
      syntheticGetKey = function syntheticGetKey(node) {
        return node[externalGetKey];
      };
    } else if (typeof externalGetKey === 'function') {
      syntheticGetKey = function syntheticGetKey(node) {
        return externalGetKey(node);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey(node, pos) {
      return getKey(node.key, pos);
    };
  } // Process


  function processNode(node, index, parent) {
    var children = node ? node[childrenPropName] : dataNodes;
    var pos = node ? (0, _util.getPosition)(parent.pos, index) : '0'; // Process node if is not root

    if (node) {
      var key = syntheticGetKey(node, pos);
      var data = {
        node: node,
        index: index,
        pos: pos,
        key: key,
        parentPos: parent.node ? parent.pos : null,
        level: parent.level + 1
      };
      callback(data);
    } // Process children node


    if (children) {
      children.forEach(function (subNode, subIndex) {
        processNode(subNode, subIndex, {
          node: node,
          pos: pos,
          level: parent ? parent.level + 1 : -1
        });
      });
    }
  }

  processNode(null);
}
/**
 * Convert `treeData` into entity records.
 */


function convertDataToEntities(dataNodes) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      initWrapper = _ref.initWrapper,
      processEntity = _ref.processEntity,
      onProcessFinished = _ref.onProcessFinished,
      externalGetKey = _ref.externalGetKey,
      childrenPropName = _ref.childrenPropName;

  var
  /** @deprecated Use `config.externalGetKey` instead */
  legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
  // Init config
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities: posEntities,
    keyEntities: keyEntities
  };

  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }

  traverseDataNodes(dataNodes, function (item) {
    var node = item.node,
        index = item.index,
        pos = item.pos,
        key = item.key,
        parentPos = item.parentPos,
        level = item.level;
    var entity = {
      node: node,
      index: index,
      key: key,
      pos: pos,
      level: level
    };
    var mergedKey = getKey(key, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity; // Fill children

    entity.parent = posEntities[parentPos];

    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }

    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName: childrenPropName
  });

  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }

  return wrapper;
}
/**
 * Get TreeNode props with Tree props.
 */


function getTreeNodeProps(key, _ref2) {
  var expandedKeys = _ref2.expandedKeys,
      selectedKeys = _ref2.selectedKeys,
      loadedKeys = _ref2.loadedKeys,
      loadingKeys = _ref2.loadingKeys,
      checkedKeys = _ref2.checkedKeys,
      halfCheckedKeys = _ref2.halfCheckedKeys,
      dragOverNodeKey = _ref2.dragOverNodeKey,
      dropPosition = _ref2.dropPosition,
      keyEntities = _ref2.keyEntities;
  var entity = keyEntities[key];
  var treeNodeProps = {
    eventKey: key,
    expanded: expandedKeys.indexOf(key) !== -1,
    selected: selectedKeys.indexOf(key) !== -1,
    loaded: loadedKeys.indexOf(key) !== -1,
    loading: loadingKeys.indexOf(key) !== -1,
    checked: checkedKeys.indexOf(key) !== -1,
    halfChecked: halfCheckedKeys.indexOf(key) !== -1,
    pos: String(entity ? entity.pos : ''),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: dragOverNodeKey === key && dropPosition === 0,
    dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
    dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
  };
  return treeNodeProps;
}

function convertNodePropsToEventData(props) {
  var data = props.data,
      expanded = props.expanded,
      selected = props.selected,
      checked = props.checked,
      loaded = props.loaded,
      loading = props.loading,
      halfChecked = props.halfChecked,
      dragOver = props.dragOver,
      dragOverGapTop = props.dragOverGapTop,
      dragOverGapBottom = props.dragOverGapBottom,
      pos = props.pos,
      active = props.active;
  var eventData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
    expanded: expanded,
    selected: selected,
    checked: checked,
    loaded: loaded,
    loading: loading,
    halfChecked: halfChecked,
    dragOver: dragOver,
    dragOverGapTop: dragOverGapTop,
    dragOverGapBottom: dragOverGapBottom,
    pos: pos,
    active: active
  });

  if (!('props' in eventData)) {
    Object.defineProperty(eventData, 'props', {
      get: function get() {
        (0, _warning.default)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
        return props;
      }
    });
  }

  return eventData;
}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1345);
var iterableToArray = __webpack_require__(1346);
var unsupportedIterableToArray = __webpack_require__(1347);
var nonIterableSpread = __webpack_require__(1348);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(380);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(175)["default"];
var toPrimitive = __webpack_require__(1349);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1364);
var iterableToArrayLimit = __webpack_require__(1365);
var unsupportedIterableToArray = __webpack_require__(1366);
var nonIterableRest = __webpack_require__(1368);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcCheckbox = _interopRequireDefault(__webpack_require__(645));

var _Group = __webpack_require__(648);

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalCheckbox = function InternalCheckbox(_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      children = _a.children,
      _a$indeterminate = _a.indeterminate,
      indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate,
      style = _a.style,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      _a$skipGroup = _a.skipGroup,
      skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup,
      restProps = __rest(_a, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var checkboxGroup = React.useContext(_Group.GroupContext);
  var prevValue = React.useRef(restProps.value);
  React.useEffect(function () {
    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    (0, _devWarning["default"])('checked' in restProps || !!checkboxGroup || !('value' in restProps), 'Checkbox', '`value` is not a valid prop, do you mean `checked`?');
  }, []);
  React.useEffect(function () {
    if (skipGroup) {
      return;
    }

    if (restProps.value !== prevValue.current) {
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }

    return function () {
      return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
    };
  }, [restProps.value]);
  var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
  var checkboxProps = (0, _extends2["default"])({}, restProps);

  if (checkboxGroup && !skipGroup) {
    checkboxProps.onChange = function () {
      if (restProps.onChange) {
        restProps.onChange.apply(restProps, arguments);
      }

      if (checkboxGroup.toggleOption) {
        checkboxGroup.toggleOption({
          label: children,
          value: restProps.value
        });
      }
    };

    checkboxProps.name = checkboxGroup.name;
    checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
    checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
  }

  var classString = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames), className);
  var checkboxClass = (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    React.createElement("label", {
      className: classString,
      style: style,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], (0, _extends2["default"])({}, checkboxProps, {
      prefixCls: prefixCls,
      className: checkboxClass,
      ref: ref
    })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
  );
};

var Checkbox = /*#__PURE__*/React.forwardRef(InternalCheckbox);
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);








// eslint-disable-next-line import/no-extraneous-dependencies



var Checkbox = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(Checkbox, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Checkbox);

  function Checkbox(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Checkbox);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }

      if (onChange) {
        onChange({
          target: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.props), {}, {
            checked: e.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          },
          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var checked = 'checked' in props ? props.checked : props.defaultChecked;
    _this.state = {
      checked: checked
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Checkbox, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          style = _this$props2.style,
          name = _this$props2.name,
          id = _this$props2.id,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          tabIndex = _this$props2.tabIndex,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          onKeyDown = _this$props2.onKeyDown,
          onKeyPress = _this$props2.onKeyPress,
          onKeyUp = _this$props2.onKeyUp,
          autoFocus = _this$props2.autoFocus,
          value = _this$props2.value,
          required = _this$props2.required,
          others = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["prefixCls", "className", "style", "name", "id", "type", "disabled", "readOnly", "tabIndex", "onClick", "onFocus", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "autoFocus", "value", "required"]);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          // eslint-disable-next-line no-param-reassign
          prev[key] = others[key];
        }

        return prev;
      }, {});
      var checked = this.state.checked;
      var classString = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-checked"), checked), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", {
        className: classString,
        style: style
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        name: name,
        id: id,
        type: type,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: "".concat(prefixCls, "-input"),
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('checked' in props) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
          checked: props.checked
        });
      }

      return null;
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {}
};
/* harmony default export */ __webpack_exports__["default"] = (Checkbox);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(647);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1373);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupContext = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _Checkbox = _interopRequireDefault(__webpack_require__(644));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var GroupContext = /*#__PURE__*/React.createContext(null);
exports.GroupContext = GroupContext;

var CheckboxGroup = function CheckboxGroup(_a) {
  var defaultValue = _a.defaultValue,
      children = _a.children,
      _a$options = _a.options,
      options = _a$options === void 0 ? [] : _a$options,
      customizePrefixCls = _a.prefixCls,
      className = _a.className,
      style = _a.style,
      onChange = _a.onChange,
      restProps = __rest(_a, ["defaultValue", "children", "options", "prefixCls", "className", "style", "onChange"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = React.useState(restProps.value || defaultValue || []),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      registeredValues = _React$useState4[0],
      setRegisteredValues = _React$useState4[1];

  React.useEffect(function () {
    if ('value' in restProps) {
      setValue(restProps.value || []);
    }
  }, [restProps.value]);

  var getOptions = function getOptions() {
    return options.map(function (option) {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option
        };
      }

      return option;
    });
  };

  var cancelValue = function cancelValue(val) {
    setRegisteredValues(function (prevValues) {
      return prevValues.filter(function (v) {
        return v !== val;
      });
    });
  };

  var registerValue = function registerValue(val) {
    setRegisteredValues(function (prevValues) {
      return [].concat((0, _toConsumableArray2["default"])(prevValues), [val]);
    });
  };

  var toggleOption = function toggleOption(option) {
    var optionIndex = value.indexOf(option.value);
    var newValue = (0, _toConsumableArray2["default"])(value);

    if (optionIndex === -1) {
      newValue.push(option.value);
    } else {
      newValue.splice(optionIndex, 1);
    }

    if (!('value' in restProps)) {
      setValue(newValue);
    }

    if (onChange) {
      var opts = getOptions();
      onChange(newValue.filter(function (val) {
        return registeredValues.indexOf(val) !== -1;
      }).sort(function (a, b) {
        var indexA = opts.findIndex(function (opt) {
          return opt.value === a;
        });
        var indexB = opts.findIndex(function (opt) {
          return opt.value === b;
        });
        return indexA - indexB;
      }));
    }
  };

  var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
  var groupPrefixCls = "".concat(prefixCls, "-group");
  var domProps = (0, _omit["default"])(restProps, ['value', 'disabled']);

  if (options && options.length > 0) {
    children = getOptions().map(function (option) {
      return /*#__PURE__*/React.createElement(_Checkbox["default"], {
        prefixCls: prefixCls,
        key: option.value.toString(),
        disabled: 'disabled' in option ? option.disabled : restProps.disabled,
        value: option.value,
        checked: value.indexOf(option.value) !== -1,
        onChange: option.onChange,
        className: "".concat(groupPrefixCls, "-item"),
        style: option.style
      }, option.label);
    });
  }

  var context = {
    toggleOption: toggleOption,
    value: value,
    disabled: restProps.disabled,
    name: restProps.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: registerValue,
    cancelValue: cancelValue
  };
  var classString = (0, _classnames["default"])(groupPrefixCls, (0, _defineProperty2["default"])({}, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: classString,
    style: style
  }, domProps), /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: context
  }, children));
};

var _default = /*#__PURE__*/React.memo(CheckboxGroup);

exports["default"] = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dropdown = _interopRequireDefault(__webpack_require__(386));

var _default = _dropdown["default"];
exports["default"] = _default;

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1386);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dropdown__["a" /* default */]);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1387);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _EllipsisOutlined = _interopRequireDefault(__webpack_require__(1400));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _EllipsisOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1407);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniStoreContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MiniStoreContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Provider.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MiniStoreContext.Provider, { value: this.props.store }, this.props.children));
    };
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shallowequal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DOMWrap__ = __webpack_require__(1421);


















function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state.activeKey), {}, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found;
    Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (c && c.props && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_15__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_15__util__["e" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_15__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
function saveRef(c) {
  if (!c) {
    return;
  }
  /* eslint-disable @typescript-eslint/no-invalid-this */


  var index = this.instanceArray.indexOf(c);

  if (index !== -1) {
    // update component if it's already inside instanceArray
    this.instanceArray[index] = c;
  } else {
    // add component if it's not in instanceArray yet;
    this.instanceArray.push(c);
  }
  /* eslint-enable @typescript-eslint/no-invalid-this */

}
var SubPopupMenu = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(SubPopupMenu, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(SubPopupMenu);

  function SubPopupMenu(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, SubPopupMenu);

    _this = _super.call(this, props);
    /**
     * all keyboard events callbacks run from here at first
     *
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e, callback) {
      var keyCode = e.keyCode;
      var handled;

      _this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        activeItem = _this.step(keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    };

    _this.onItemHover = function (e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
    };

    _this.onDeselect = function (selectInfo) {
      _this.props.onDeselect(selectInfo);
    };

    _this.onSelect = function (selectInfo) {
      _this.props.onSelect(selectInfo);
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onDestroy = function (key) {
      /* istanbul ignore next */
      _this.props.onDestroy(key);
    };

    _this.getFlatInstanceArray = function () {
      return _this.instanceArray;
    };

    _this.step = function (direction) {
      var children = _this.getFlatInstanceArray();

      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];

      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.props.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    };

    _this.renderCommonMenuItem = function (child, i, extraProps) {
      var state = _this.props.store.getState();

      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize.props;

      var key = Object(__WEBPACK_IMPORTED_MODULE_15__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055

      if (!childProps || typeof child.type === 'string') {
        return child;
      }

      var isActive = key === state.activeKey;

      var newChildProps = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        mode: childProps.mode || props.mode,
        level: props.level,
        inlineIndent: props.inlineIndent,
        renderMenuItem: _this.renderMenuItem,
        rootPrefixCls: props.prefixCls,
        index: i,
        parentMenu: props.parentMenu,
        // customized ref function, need to be invoked manually in child's componentDidMount
        manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this))),
        eventKey: key,
        active: !childProps.disabled && isActive,
        multiple: props.multiple,
        onClick: function onClick(e) {
          (childProps.onClick || __WEBPACK_IMPORTED_MODULE_15__util__["h" /* noop */])(e);

          _this.onClick(e);
        },
        onItemHover: _this.onItemHover,
        motion: props.motion,
        subMenuOpenDelay: props.subMenuOpenDelay,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        onOpenChange: _this.onOpenChange,
        onDeselect: _this.onDeselect,
        onSelect: _this.onSelect,
        builtinPlacements: props.builtinPlacements,
        itemIcon: childProps.itemIcon || _this.props.itemIcon,
        expandIcon: childProps.expandIcon || _this.props.expandIcon
      }, extraProps), {}, {
        direction: props.direction
      }); // ref: https://github.com/ant-design/ant-design/issues/13943


      if (props.mode === 'inline' || Object(__WEBPACK_IMPORTED_MODULE_15__util__["d" /* isMobileDevice */])()) {
        newChildProps.triggerSubMenuAction = 'click';
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"](child, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, newChildProps), {}, {
        key: key || i
      }));
    };

    _this.renderMenuItem = function (c, i, subMenuKey) {
      /* istanbul ignore if */
      if (!c) {
        return null;
      }

      var state = _this.props.store.getState();

      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this.props.triggerSubMenuAction,
        subMenuKey: subMenuKey
      };
      return _this.renderCommonMenuItem(c, i, extraProps);
    };

    props.store.setState({
      activeKey: Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props.store.getState().activeKey), {}, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this.instanceArray = [];
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(SubPopupMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !__WEBPACK_IMPORTED_MODULE_13_shallowequal___default()(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);

      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ('activeKey' in prevProps) {
        // If prev activeKey is not same as current activeKey,
        // we should set it.
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props);

      this.instanceArray = [];
      var className = __WEBPACK_IMPORTED_MODULE_14_classnames___default()(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className: className,
        // role could be 'select' and by default set to menu
        role: props.role || 'menu'
      };

      if (props.id) {
        domProps.id = props.id;
      }

      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }

      var prefixCls = props.prefixCls,
          eventKey = props.eventKey,
          visible = props.visible,
          level = props.level,
          mode = props.mode,
          overflowedIndicator = props.overflowedIndicator,
          theme = props.theme;
      __WEBPACK_IMPORTED_MODULE_15__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Otherwise, the propagated click event will trigger another onClick

      delete props.onClick;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__DOMWrap__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        prefixCls: prefixCls,
        mode: mode,
        tag: "ul",
        level: level,
        theme: theme,
        visible: visible,
        overflowedIndicator: overflowedIndicator
      }, domProps), Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Children_toArray__["a" /* default */])(props.children).map(function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      }));
    }
  }]);

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_15__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_9_mini_store__["b" /* connect */])()(SubPopupMenu);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(658);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_trigger__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mini_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SubPopupMenu__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__placements__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util__ = __webpack_require__(183);



















var guid = 0;
var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = Object(__WEBPACK_IMPORTED_MODULE_18__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state.defaultActiveFirst), {}, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, menuId, defaultActiveFirst))
  });
};

var SubMenu = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(SubMenu, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(SubMenu);

  function SubMenu(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, SubMenu);

    _this = _super.call(this, props);

    _this.onDestroy = function (key) {
      _this.props.onDestroy(key);
    };
    /**
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */


    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      var menu = _this.menuInstance;
      var store = _this.props.store;

      var visible = _this.getVisible();

      if (keyCode === __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onTitleClick(e);

        updateDefaultActiveFirst(store, _this.props.eventKey, true);
        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
        if (visible) {
          menu.onKeyDown(e);
        } else {
          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value


          updateDefaultActiveFirst(store, _this.props.eventKey, true);
        }

        return true;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__["a" /* default */].LEFT) {
        var handled;

        if (visible) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          _this.triggerOpenChange(false);

          handled = true;
        }

        return handled;
      }

      if (visible && (keyCode === __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_12_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onPopupVisibleChange = function (visible) {
      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };

    _this.onMouseEnter = function (e) {
      var _this$props = _this.props,
          key = _this$props.eventKey,
          onMouseEnter = _this$props.onMouseEnter,
          store = _this$props.store;
      updateDefaultActiveFirst(store, _this.props.eventKey, false);
      onMouseEnter({
        key: key,
        domEvent: e
      });
    };

    _this.onMouseLeave = function (e) {
      var _this$props2 = _this.props,
          parentMenu = _this$props2.parentMenu,
          eventKey = _this$props2.eventKey,
          onMouseLeave = _this$props2.onMouseLeave;
      parentMenu.subMenuInstance = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleMouseEnter = function (domEvent) {
      var _this$props3 = _this.props,
          key = _this$props3.eventKey,
          onItemHover = _this$props3.onItemHover,
          onTitleMouseEnter = _this$props3.onTitleMouseEnter;
      onItemHover({
        key: key,
        hover: true
      });
      onTitleMouseEnter({
        key: key,
        domEvent: domEvent
      });
    };

    _this.onTitleMouseLeave = function (e) {
      var _this$props4 = _this.props,
          parentMenu = _this$props4.parentMenu,
          eventKey = _this$props4.eventKey,
          onItemHover = _this$props4.onItemHover,
          onTitleMouseLeave = _this$props4.onTitleMouseLeave;
      parentMenu.subMenuInstance = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
      onItemHover({
        key: eventKey,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleClick = function (e) {
      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize.props;

      props.onTitleClick({
        key: props.eventKey,
        domEvent: e
      });

      if (props.triggerSubMenuAction === 'hover') {
        return;
      }

      _this.triggerOpenChange(!_this.getVisible(), 'click');

      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
    };

    _this.onSubMenuClick = function (info) {
      // in the case of overflowed submenu
      // onClick is not copied over
      if (typeof _this.props.onClick === 'function') {
        _this.props.onClick(_this.addKeyPath(info));
      }
    };

    _this.onSelect = function (info) {
      _this.props.onSelect(info);
    };

    _this.onDeselect = function (info) {
      _this.props.onDeselect(info);
    };

    _this.getPrefixCls = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu");
    };

    _this.getActiveClassName = function () {
      return "".concat(_this.getPrefixCls(), "-active");
    };

    _this.getDisabledClassName = function () {
      return "".concat(_this.getPrefixCls(), "-disabled");
    };

    _this.getSelectedClassName = function () {
      return "".concat(_this.getPrefixCls(), "-selected");
    };

    _this.getOpenClassName = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
    };

    _this.getVisible = function () {
      return _this.state.isOpen;
    };

    _this.getMode = function () {
      return _this.state.mode;
    };

    _this.saveMenuInstance = function (c) {
      // children menu instance
      _this.menuInstance = c;
    };

    _this.addKeyPath = function (info) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, info), {}, {
        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
      });
    };

    _this.triggerOpenChange = function (open, type) {
      var key = _this.props.eventKey;

      var openChange = function openChange() {
        _this.onOpenChange({
          key: key,
          item: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          trigger: type,
          open: open
        });
      };

      if (type === 'mouseenter') {
        // make sure mouseenter happen after other menu item's mouseleave
        _this.mouseenterTimeout = setTimeout(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };

    _this.isChildrenSelected = function () {
      var ret = {
        find: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_18__util__["f" /* loopMenuItemRecursively */])(_this.props.children, _this.props.selectedKeys, ret);
      return ret.find;
    };

    _this.isInlineMode = function () {
      return _this.getMode() === 'inline';
    };

    _this.adjustWidth = function () {
      /* istanbul ignore if */
      if (!_this.subMenuTitle || !_this.menuInstance) {
        return;
      }

      var popupMenu = __WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"](_this.menuInstance);

      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */


      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
    };

    _this.saveSubMenuTitle = function (subMenuTitle) {
      _this.subMenuTitle = subMenuTitle;
    };

    _this.getBaseProps = function () {
      var _assertThisInitialize2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize2.props;

      var mergedMode = _this.getMode();

      return {
        mode: mergedMode === 'horizontal' ? 'vertical' : mergedMode,
        visible: _this.getVisible(),
        level: props.level + 1,
        inlineIndent: props.inlineIndent,
        focusable: false,
        onClick: _this.onSubMenuClick,
        onSelect: _this.onSelect,
        onDeselect: _this.onDeselect,
        onDestroy: _this.onDestroy,
        selectedKeys: props.selectedKeys,
        eventKey: "".concat(props.eventKey, "-menu-"),
        openKeys: props.openKeys,
        motion: props.motion,
        onOpenChange: _this.onOpenChange,
        subMenuOpenDelay: props.subMenuOpenDelay,
        parentMenu: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        triggerSubMenuAction: props.triggerSubMenuAction,
        builtinPlacements: props.builtinPlacements,
        defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_18__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
        multiple: props.multiple,
        prefixCls: props.rootPrefixCls,
        id: _this.internalMenuId,
        manualRef: _this.saveMenuInstance,
        itemIcon: props.itemIcon,
        expandIcon: props.expandIcon,
        direction: props.direction
      };
    };

    _this.getMotion = function (mode, visible) {
      var _assertThisInitialize3 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          haveRendered = _assertThisInitialize3.haveRendered;

      var _this$props5 = _this.props,
          motion = _this$props5.motion,
          rootPrefixCls = _this$props5.rootPrefixCls; // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode

      var mergedMotion = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motion), {}, {
        leavedClassName: "".concat(rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !visible || mode !== 'inline'
      });

      return mergedMotion;
    };

    var store = props.store,
        eventKey = props.eventKey;

    var _store$getState = store.getState(),
        defaultActiveFirst = _store$getState.defaultActiveFirst;

    _this.isRootMenu = false;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    _this.state = {
      mode: props.mode,
      isOpen: props.isOpen
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(SubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props6 = this.props,
          mode = _this$props6.mode,
          parentMenu = _this$props6.parentMenu,
          manualRef = _this$props6.manualRef,
          isOpen = _this$props6.isOpen;

      var updateState = function updateState() {
        _this2.setState({
          mode: mode,
          isOpen: isOpen
        });
      }; // Delay sync when mode changed in case openKeys change not sync


      var isOpenChanged = isOpen !== this.state.isOpen;
      var isModeChanged = mode !== this.state.mode;

      if (isModeChanged || isOpenChanged) {
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_raf__["a" /* default */].cancel(this.updateStateRaf);

        if (isModeChanged) {
          this.updateStateRaf = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_raf__["a" /* default */])(updateState);
        } else {
          updateState();
        }
      } // invoke customized ref to expose component to mixin


      if (manualRef) {
        manualRef(this);
      }

      if (mode !== 'horizontal' || !(parentMenu === null || parentMenu === void 0 ? void 0 : parentMenu.isRootMenu) || !isOpen) {
        return;
      }

      this.minWidthTimeout = setTimeout(function () {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props,
          onDestroy = _this$props7.onDestroy,
          eventKey = _this$props7.eventKey;

      if (onDestroy) {
        onDestroy(eventKey);
      }
      /* istanbul ignore if */


      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      /* istanbul ignore if */


      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }

      __WEBPACK_IMPORTED_MODULE_11_rc_util_es_raf__["a" /* default */].cancel(this.updateStateRaf);
    }
  }, {
    key: "renderPopupMenu",
    value: function renderPopupMenu(className, style) {
      var baseProps = this.getBaseProps();
      /**
       * zombiej: Why SubPopupMenu here?
       * Seems whatever popup or inline mode both will render SubPopupMenu.
       * It's controlled by Trigger for popup or not.
       */

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__SubPopupMenu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseProps, {
        id: this.internalMenuId,
        className: className,
        style: style
      }), this.props.children);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var baseProps = this.getBaseProps();
      var mode = baseProps.mode,
          visible = baseProps.visible,
          forceSubMenuRender = baseProps.forceSubMenuRender,
          direction = baseProps.direction; // [Legacy] getMotion must be called before `haveRendered`

      var mergedMotion = this.getMotion(mode, visible);
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || visible || forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", null);
      }

      var sharedClassName = __WEBPACK_IMPORTED_MODULE_14_classnames___default()("".concat(baseProps.prefixCls, "-sub"), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(baseProps.prefixCls, "-rtl"), direction === 'rtl'));

      if (!this.isInlineMode()) {
        return this.renderPopupMenu(sharedClassName);
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_rc_motion__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        visible: baseProps.visible,
        forceRender: forceSubMenuRender
      }, mergedMotion), function (_ref) {
        var className = _ref.className,
            style = _ref.style;
        var mergedClassName = __WEBPACK_IMPORTED_MODULE_14_classnames___default()(sharedClassName, className);
        return _this3.renderPopupMenu(mergedClassName, style);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2, _props$parentMenu, _classNames3;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.props);

      var visible = this.getVisible();
      var prefixCls = this.getPrefixCls();
      var inline = this.isInlineMode();
      var mergedMode = this.getMode();
      var className = __WEBPACK_IMPORTED_MODULE_14_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(mergedMode), (_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, props.className, !!props.className), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, this.getOpenClassName(), visible), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, this.getActiveClassName(), props.active || visible && !inline), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, this.getDisabledClassName(), props.disabled), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, this.getSelectedClassName(), this.isChildrenSelected()), _classNames2));

      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }

      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};

      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        }; // only works in title, not outer li

        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }

      var style = {};
      var direction = props.direction;
      var isRTL = direction === 'rtl';

      if (inline) {
        if (isRTL) {
          style.paddingRight = props.inlineIndent * props.level;
        } else {
          style.paddingLeft = props.inlineIndent * props.level;
        }
      }

      var ariaOwns = {}; // only set aria-owns when menu is open
      // otherwise it would be an invalid aria-owns value
      // since corresponding node cannot be found

      if (this.getVisible()) {
        ariaOwns = {
          'aria-owns': this.internalMenuId
        };
      } // expand custom icon should NOT be displayed in menu with horizontal mode.


      var icon = null;

      if (mergedMode !== 'horizontal') {
        icon = this.props.expandIcon; // ReactNode

        if (typeof this.props.expandIcon === 'function') {
          icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](this.props.expandIcon, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.props));
        }
      }

      var title = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: this.saveSubMenuTitle,
        style: style,
        className: "".concat(prefixCls, "-title"),
        role: "button"
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": visible
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === 'string' ? props.title : undefined
      }), props.title, icon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren();
      var getPopupContainer = ((_props$parentMenu = props.parentMenu) === null || _props$parentMenu === void 0 ? void 0 : _props$parentMenu.isRootMenu) ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[mergedMode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = __WEBPACK_IMPORTED_MODULE_14_classnames___default()((_classNames3 = {}, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames3, props.popupClassName, props.popupClassName && !inline), Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames3, "".concat(prefixCls, "-rtl"), isRTL), _classNames3));
      var disabled = props.disabled,
          triggerSubMenuAction = props.triggerSubMenuAction,
          subMenuOpenDelay = props.subMenuOpenDelay,
          forceSubMenuRender = props.forceSubMenuRender,
          subMenuCloseDelay = props.subMenuCloseDelay,
          builtinPlacements = props.builtinPlacements;
      __WEBPACK_IMPORTED_MODULE_18__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      var placement = isRTL ? Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_17__placements__["b" /* placementsRtl */]), builtinPlacements) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_17__placements__["a" /* placements */]), builtinPlacements);
      delete props.direction; // [Legacy] It's a fast fix,
      // but we should check if we can refactor this to make code more easy to understand

      var baseProps = this.getBaseProps();
      var mergedMotion = inline ? null : this.getMotion(baseProps.mode, baseProps.visible);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, mouseEvents, {
        className: className,
        role: "menuitem"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_rc_trigger__["a" /* default */], {
        prefixCls: prefixCls,
        popupClassName: __WEBPACK_IMPORTED_MODULE_14_classnames___default()("".concat(prefixCls, "-popup"), popupClassName),
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: inline ? false : visible,
        popupAlign: popupAlign,
        popup: inline ? null : children,
        action: disabled || inline ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion
      }, title), inline ? children : null);
    }
  }]);

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_18__util__["h" /* noop */],
  mode: 'vertical',
  title: ''
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_15_mini_store__["b" /* connect */])(function (_ref2, _ref3) {
  var openKeys = _ref2.openKeys,
      activeKey = _ref2.activeKey,
      selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey,
      subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);
connected.isSubMenu = true;
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1435);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColorTypes = exports.PresetStatusColorTypes = void 0;

var _type = __webpack_require__(118);

var PresetStatusColorTypes = (0, _type.tuple)('success', 'processing', 'error', 'default', 'warning'); // eslint-disable-next-line import/prefer-default-export

exports.PresetStatusColorTypes = PresetStatusColorTypes;
var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
exports.PresetColorTypes = PresetColorTypes;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// ================== Collapse Motion ==================
var getCollapsedHeight = function getCollapsedHeight() {
  return {
    height: 0,
    opacity: 0
  };
};

var getRealHeight = function getRealHeight(node) {
  return {
    height: node.scrollHeight,
    opacity: 1
  };
};

var getCurrentHeight = function getCurrentHeight(node) {
  return {
    height: node.offsetHeight
  };
};

var skipOpacityTransition = function skipOpacityTransition(_, event) {
  return event.propertyName === 'height';
};

var collapseMotion = {
  motionName: 'ant-motion-collapse',
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
};
var _default = collapseMotion;
exports["default"] = _default;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1457);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 664 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(211),
    isObject = __webpack_require__(277);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1474),
    mapCacheDelete = __webpack_require__(1481),
    mapCacheGet = __webpack_require__(1483),
    mapCacheHas = __webpack_require__(1484),
    mapCacheSet = __webpack_require__(1485);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1486),
    arraySome = __webpack_require__(1489),
    cacheHas = __webpack_require__(1490);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(109),
    stubFalse = __webpack_require__(1507);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)(module)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1509),
    baseUnary = __webpack_require__(1510),
    nodeUtil = __webpack_require__(1511);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var _RowContext = _interopRequireDefault(__webpack_require__(673));

var _type = __webpack_require__(118);

var _responsiveObserve = _interopRequireWildcard(__webpack_require__(284));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
var Row = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var customizePrefixCls = props.prefixCls,
      justify = props.justify,
      align = props.align,
      className = props.className,
      style = props.style,
      children = props.children,
      _props$gutter = props.gutter,
      gutter = _props$gutter === void 0 ? 0 : _props$gutter,
      wrap = props.wrap,
      others = __rest(props, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = React.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      screens = _React$useState2[0],
      setScreens = _React$useState2[1];

  var gutterRef = React.useRef(gutter);
  React.useEffect(function () {
    var token = _responsiveObserve["default"].subscribe(function (screen) {
      var currentGutter = gutterRef.current || 0;

      if (!Array.isArray(currentGutter) && (0, _typeof2["default"])(currentGutter) === 'object' || Array.isArray(currentGutter) && ((0, _typeof2["default"])(currentGutter[0]) === 'object' || (0, _typeof2["default"])(currentGutter[1]) === 'object')) {
        setScreens(screen);
      }
    });

    return function () {
      return _responsiveObserve["default"].unsubscribe(token);
    };
  }, []);

  var getGutter = function getGutter() {
    var results = [0, 0];
    var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach(function (g, index) {
      if ((0, _typeof2["default"])(g) === 'object') {
        for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
          var breakpoint = _responsiveObserve.responsiveArray[i];

          if (screens[breakpoint] && g[breakpoint] !== undefined) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };

  var prefixCls = getPrefixCls('row', customizePrefixCls);
  var gutters = getGutter();
  var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-no-wrap"), wrap === false), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(justify), justify), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(align), align), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  var rowStyle = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] > 0 ? {
    marginTop: gutters[1] / -2,
    marginBottom: gutters[1] / 2
  } : {}), style);
  return /*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
    value: {
      gutter: gutters,
      wrap: wrap
    }
  }, /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, others, {
    className: classes,
    style: rowStyle,
    ref: ref
  }), children));
});
Row.displayName = 'Row';
var _default = Row;
exports["default"] = _default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var RowContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = RowContext;
exports["default"] = _default;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(97));

var _ref = __webpack_require__(117);

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _responsiveObserve = __webpack_require__(284);

var _useBreakpoint = _interopRequireDefault(__webpack_require__(217));

var _SizeContext = _interopRequireDefault(__webpack_require__(675));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalAvatar = function InternalAvatar(props, ref) {
  var _classNames, _classNames2;

  var groupSize = React.useContext(_SizeContext["default"]);

  var _React$useState = React.useState(1),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      scale = _React$useState2[0],
      setScale = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      mounted = _React$useState4[0],
      setMounted = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      isImgExist = _React$useState6[0],
      setIsImgExist = _React$useState6[1];

  var avatarNodeRef = React.useRef();
  var avatarChildrenRef = React.useRef();
  var avatarNodeMergeRef = (0, _ref.composeRef)(ref, avatarNodeRef);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var setScaleParam = function setScaleParam() {
    if (!avatarChildrenRef.current || !avatarNodeRef.current) {
      return;
    }

    var childrenWidth = avatarChildrenRef.current.offsetWidth; // offsetWidth avoid affecting be transform scale

    var nodeWidth = avatarNodeRef.current.offsetWidth; // denominator is 0 is no meaning

    if (childrenWidth !== 0 && nodeWidth !== 0) {
      var _props$gap = props.gap,
          gap = _props$gap === void 0 ? 4 : _props$gap;

      if (gap * 2 < nodeWidth) {
        setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
      }
    }
  };

  React.useEffect(function () {
    setMounted(true);
  }, []);
  React.useEffect(function () {
    setIsImgExist(true);
    setScale(1);
  }, [props.src]);
  React.useEffect(function () {
    setScaleParam();
  }, [props.gap]);

  var handleImgLoadError = function handleImgLoadError() {
    var onError = props.onError;
    var errorFlag = onError ? onError() : undefined;

    if (errorFlag !== false) {
      setIsImgExist(false);
    }
  };

  var customizePrefixCls = props.prefixCls,
      shape = props.shape,
      customSize = props.size,
      src = props.src,
      srcSet = props.srcSet,
      icon = props.icon,
      className = props.className,
      alt = props.alt,
      draggable = props.draggable,
      children = props.children,
      others = __rest(props, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt", "draggable", "children"]);

  var size = customSize === 'default' ? groupSize : customSize;
  var screens = (0, _useBreakpoint["default"])();
  var responsiveSizeStyle = React.useMemo(function () {
    if ((0, _typeof2["default"])(size) !== 'object') {
      return {};
    }

    var currentBreakpoint = _responsiveObserve.responsiveArray.find(function (screen) {
      return screens[screen];
    });

    var currentSize = size[currentBreakpoint];
    return currentSize ? {
      width: currentSize,
      height: currentSize,
      lineHeight: "".concat(currentSize, "px"),
      fontSize: icon ? currentSize / 2 : 18
    } : {};
  }, [screens, size]);
  (0, _devWarning["default"])(!(typeof icon === 'string' && icon.length > 2), 'Avatar', "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(icon, "` at https://ant.design/components/icon"));
  var prefixCls = getPrefixCls('avatar', customizePrefixCls);
  var sizeCls = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
  var hasImageElement = /*#__PURE__*/React.isValidElement(src);
  var classString = (0, _classnames["default"])(prefixCls, sizeCls, (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-").concat(shape), shape), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-image"), hasImageElement || src && isImgExist), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-icon"), icon), _classNames2), className);
  var sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px"),
    fontSize: icon ? size / 2 : 18
  } : {};
  var childrenToRender;

  if (typeof src === 'string' && isImgExist) {
    childrenToRender = /*#__PURE__*/React.createElement("img", {
      src: src,
      draggable: draggable,
      srcSet: srcSet,
      onError: handleImgLoadError,
      alt: alt
    });
  } else if (hasImageElement) {
    childrenToRender = src;
  } else if (icon) {
    childrenToRender = icon;
  } else if (mounted || scale !== 1) {
    var transformString = "scale(".concat(scale, ") translateX(-50%)");
    var childrenStyle = {
      msTransform: transformString,
      WebkitTransform: transformString,
      transform: transformString
    };
    var sizeChildrenStyle = typeof size === 'number' ? {
      lineHeight: "".concat(size, "px")
    } : {};
    childrenToRender = /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
      onResize: setScaleParam
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      },
      style: (0, _extends2["default"])((0, _extends2["default"])({}, sizeChildrenStyle), childrenStyle)
    }, children));
  } else {
    childrenToRender = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      style: {
        opacity: 0
      },
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      }
    }, children);
  } // The event is triggered twice from bubbling up the DOM tree.
  // see https://codesandbox.io/s/kind-snow-9lidz


  delete others.onError;
  delete others.gap;
  return /*#__PURE__*/React.createElement("span", (0, _extends2["default"])({}, others, {
    style: (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, sizeStyle), responsiveSizeStyle), others.style),
    className: classString,
    ref: avatarNodeMergeRef
  }), childrenToRender);
};

var Avatar = /*#__PURE__*/React.forwardRef(InternalAvatar);
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  shape: 'circle',
  size: 'default'
};
var _default = Avatar;
exports["default"] = _default;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SizeContextProvider = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var SizeContext = /*#__PURE__*/React.createContext('default');

var SizeContextProvider = function SizeContextProvider(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(SizeContext.Consumer, null, function (originSize) {
    return /*#__PURE__*/React.createElement(SizeContext.Provider, {
      value: size || originSize
    }, children);
  });
};

exports.SizeContextProvider = SizeContextProvider;
var _default = SizeContext;
exports["default"] = _default;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var _configProvider = __webpack_require__(8);

var _getRenderPropValue = __webpack_require__(677);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Popover = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var customizePrefixCls = _a.prefixCls,
      title = _a.title,
      content = _a.content,
      otherProps = __rest(_a, ["prefixCls", "title", "content"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var getOverlay = function getOverlay(prefixCls) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, (0, _getRenderPropValue.getRenderPropValue)(title)), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-inner-content")
    }, (0, _getRenderPropValue.getRenderPropValue)(content)));
  };

  var prefixCls = getPrefixCls('popover', customizePrefixCls);
  return /*#__PURE__*/React.createElement(_tooltip["default"], (0, _extends2["default"])({}, otherProps, {
    prefixCls: prefixCls,
    ref: ref,
    overlay: getOverlay(prefixCls)
  }));
});
Popover.displayName = 'Popover';
Popover.defaultProps = {
  placement: 'top',
  transitionName: 'zoom-big',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
};
var _default = Popover;
exports["default"] = _default;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRenderPropValue = void 0;

var getRenderPropValue = function getRenderPropValue(propValue) {
  if (!propValue) {
    return null;
  }

  var isRenderFunction = typeof propValue === 'function';

  if (isRenderFunction) {
    return propValue();
  }

  return propValue;
};

exports.getRenderPropValue = getRenderPropValue;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CalendarOutlined = _interopRequireDefault(__webpack_require__(1560));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CalendarOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ClockCircleOutlined = _interopRequireDefault(__webpack_require__(1562));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _ClockCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Picker__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PickerPanel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RangePicker__ = __webpack_require__(1595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerPanel", function() { return __WEBPACK_IMPORTED_MODULE_1__PickerPanel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RangePicker", function() { return __WEBPACK_IMPORTED_MODULE_2__RangePicker__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Picker__["a" /* default */]);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(683);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1565);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1566);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1569);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(687);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimeHeader__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeBody__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_uiUtil__ = __webpack_require__(99);









var countBoolean = function countBoolean(boolList) {
  return boolList.filter(function (bool) {
    return bool !== false;
  }).length;
};

function TimePanel(props) {
  var generateConfig = props.generateConfig,
      _props$format = props.format,
      format = _props$format === void 0 ? 'HH:mm:ss' : _props$format,
      prefixCls = props.prefixCls,
      active = props.active,
      operationRef = props.operationRef,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      _props$use12Hours = props.use12Hours,
      use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours,
      onSelect = props.onSelect,
      value = props.value;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var bodyOperationRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](); // ======================= Keyboard =======================

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](-1),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      activeColumnIndex = _React$useState2[0],
      setActiveColumnIndex = _React$useState2[1];

  var columnsCount = countBoolean([showHour, showMinute, showSecond, use12Hours]);
  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_uiUtil__["c" /* createKeyDownHandler */])(event, {
        onLeftRight: function onLeftRight(diff) {
          setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
        },
        onUpDown: function onUpDown(diff) {
          if (activeColumnIndex === -1) {
            setActiveColumnIndex(0);
          } else if (bodyOperationRef.current) {
            bodyOperationRef.current.onUpDown(diff);
          }
        },
        onEnter: function onEnter() {
          onSelect(value || generateConfig.getNow(), 'key');
          setActiveColumnIndex(-1);
        }
      });
    },
    onBlur: function onBlur() {
      setActiveColumnIndex(-1);
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(panelPrefixCls, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(panelPrefixCls, "-active"), active))
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TimeHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    format: format,
    prefixCls: prefixCls
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TimeBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    activeColumnIndex: activeColumnIndex,
    operationRef: bodyOperationRef
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (TimePanel);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtraFooter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function getExtraFooter(prefixCls, mode, renderExtraFooter) {
  if (!renderExtraFooter) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-footer-extra")
  }, renderExtraFooter(mode));
}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function getRanges(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$rangeList = _ref.rangeList,
      rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components,
      needConfirmButton = _ref.needConfirmButton,
      onNow = _ref.onNow,
      onOk = _ref.onOk,
      okDisabled = _ref.okDisabled,
      showNow = _ref.showNow,
      locale = _ref.locale;
  var presetNode;
  var okNode;

  if (rangeList.length) {
    var Item = components.rangeItem || 'span';
    presetNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, rangeList.map(function (_ref2) {
      var label = _ref2.label,
          onClick = _ref2.onClick,
          onMouseEnter = _ref2.onMouseEnter,
          onMouseLeave = _ref2.onMouseLeave;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
        key: label,
        className: "".concat(prefixCls, "-preset")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item, {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, label));
    }));
  }

  if (needConfirmButton) {
    var Button = components.button || 'button';

    if (onNow && !presetNode && showNow !== false) {
      presetNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
        className: "".concat(prefixCls, "-now")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", {
        className: "".concat(prefixCls, "-now-btn"),
        onClick: onNow
      }, locale.now));
    }

    okNode = needConfirmButton && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
      className: "".concat(prefixCls, "-ok")
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button, {
      disabled: okDisabled,
      onClick: onOk
    }, locale.ok));
  }

  if (!presetNode && !okNode) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, okNode);
}

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_trigger__ = __webpack_require__(173);




var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

function PickerTrigger(_ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      popupElement = _ref.popupElement,
      popupStyle = _ref.popupStyle,
      visible = _ref.visible,
      dropdownClassName = _ref.dropdownClassName,
      dropdownAlign = _ref.dropdownAlign,
      transitionName = _ref.transitionName,
      getPopupContainer = _ref.getPopupContainer,
      children = _ref.children,
      range = _ref.range,
      popupPlacement = _ref.popupPlacement,
      direction = _ref.direction;
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");

  var getPopupPlacement = function getPopupPlacement() {
    if (popupPlacement !== undefined) {
      return popupPlacement;
    }

    return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_trigger__["a" /* default */], {
    showAction: [],
    hideAction: [],
    popupPlacement: getPopupPlacement(),
    builtinPlacements: BUILT_IN_PLACEMENTS,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: transitionName,
    popup: popupElement,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    popupClassName: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(dropdownClassName, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(dropdownPrefixCls, "-range"), range), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl'), _classNames)),
    popupStyle: popupStyle,
    getPopupContainer: getPopupContainer
  }, children);
}

/* harmony default export */ __webpack_exports__["a"] = (PickerTrigger);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usePickerInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__ = __webpack_require__(99);




function usePickerInput(_ref) {
  var open = _ref.open,
      value = _ref.value,
      isClickOutside = _ref.isClickOutside,
      triggerOpen = _ref.triggerOpen,
      forwardKeyDown = _ref.forwardKeyDown,
      _onKeyDown = _ref.onKeyDown,
      blurToCancel = _ref.blurToCancel,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      typing = _useState2[0],
      setTyping = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];
  /**
   * We will prevent blur to handle open event when user click outside,
   * since this will repeat trigger `onOpenChange` event.
   */


  var preventBlurRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var valueChangedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var preventDefaultRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var inputProps = {
    onMouseDown: function onMouseDown() {
      setTyping(true);
      triggerOpen(true);
    },
    onKeyDown: function onKeyDown(e) {
      var preventDefault = function preventDefault() {
        preventDefaultRef.current = true;
      };

      _onKeyDown(e, preventDefault);

      if (preventDefaultRef.current) return;

      switch (e.which) {
        case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ENTER:
          {
            if (!open) {
              triggerOpen(true);
            } else if (onSubmit() !== false) {
              setTyping(true);
            }

            e.preventDefault();
            return;
          }

        case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].TAB:
          {
            if (typing && open && !e.shiftKey) {
              setTyping(false);
              e.preventDefault();
            } else if (!typing && open) {
              if (!forwardKeyDown(e) && e.shiftKey) {
                setTyping(true);
                e.preventDefault();
              }
            }

            return;
          }

        case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ESC:
          {
            setTyping(true);
            onCancel();
            return;
          }
      }

      if (!open && ![__WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].SHIFT].includes(e.which)) {
        triggerOpen(true);
      } else if (!typing) {
        // Let popup panel handle keyboard
        forwardKeyDown(e);
      }
    },
    onFocus: function onFocus(e) {
      setTyping(true);
      setFocused(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      if (preventBlurRef.current || !isClickOutside(document.activeElement)) {
        preventBlurRef.current = false;
        return;
      }

      if (blurToCancel) {
        setTimeout(function () {
          var _document = document,
              activeElement = _document.activeElement;

          while (activeElement && activeElement.shadowRoot) {
            activeElement = activeElement.shadowRoot.activeElement;
          }

          if (isClickOutside(activeElement)) {
            onCancel();
          }
        }, 0);
      } else if (open) {
        triggerOpen(false);

        if (valueChangedRef.current) {
          onSubmit();
        }
      }

      setFocused(false);

      if (_onBlur) {
        _onBlur(e);
      }
    }
  }; // check if value changed

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    valueChangedRef.current = false;
  }, [open]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    valueChangedRef.current = true;
  }, [value]); // Global click handler

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__["b" /* addGlobalMouseDownEvent */])(function (e) {
      var target = Object(__WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__["g" /* getTargetFromEvent */])(e);

      if (open) {
        var clickedOutside = isClickOutside(target);

        if (!clickedOutside) {
          preventBlurRef.current = true; // Always set back in case `onBlur` prevented by user

          requestAnimationFrame(function () {
            preventBlurRef.current = false;
          });
        } else if (!focused || clickedOutside) {
          triggerOpen(false);
        }
      }
    });
  });
  return [inputProps, {
    focused: focused,
    typing: typing
  }];
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTextValueMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function useTextValueMapping(_ref) {
  var valueTexts = _ref.valueTexts,
      onTextChange = _ref.onTextChange;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](''),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      text = _React$useState2[0],
      setInnerText = _React$useState2[1];

  var valueTextsRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"]([]);
  valueTextsRef.current = valueTexts;

  function triggerTextChange(value) {
    setInnerText(value);
    onTextChange(value);
  }

  function resetText() {
    setInnerText(valueTextsRef.current[0]);
  }

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    if (valueTexts.every(function (valText) {
      return valText !== text;
    })) {
      resetText();
    }
  }, [valueTexts.join('||')]);
  return [text, triggerTextChange, resetText];
}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useHoverValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useValueTexts__ = __webpack_require__(404);



function useHoverValue(valueText, _ref) {
  var formatList = _ref.formatList,
      generateConfig = _ref.generateConfig,
      locale = _ref.locale;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      value = _useState2[0],
      internalSetValue = _useState2[1];

  var raf = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);

  function setValue(val) {
    var immediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    cancelAnimationFrame(raf.current);

    if (immediately) {
      internalSetValue(val);
      return;
    }

    raf.current = requestAnimationFrame(function () {
      internalSetValue(val);
    });
  }

  var _useValueTexts = Object(__WEBPACK_IMPORTED_MODULE_2__useValueTexts__["a" /* default */])(value, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useValueTexts2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useValueTexts, 2),
      firstText = _useValueTexts2[1];

  function onEnter(date) {
    setValue(date);
  }

  function onLeave() {
    var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setValue(null, immediately);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    onLeave(true);
  }, [valueText]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return function () {
      return cancelAnimationFrame(raf.current);
    };
  }, []);
  return [firstText, onEnter, onLeave];
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaceholder = getPlaceholder;
exports.getRangePlaceholder = getRangePlaceholder;

function getPlaceholder(picker, locale, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }

  if (picker === 'year' && locale.lang.yearPlaceholder) {
    return locale.lang.yearPlaceholder;
  }

  if (picker === 'quarter' && locale.lang.quarterPlaceholder) {
    return locale.lang.quarterPlaceholder;
  }

  if (picker === 'month' && locale.lang.monthPlaceholder) {
    return locale.lang.monthPlaceholder;
  }

  if (picker === 'week' && locale.lang.weekPlaceholder) {
    return locale.lang.weekPlaceholder;
  }

  if (picker === 'time' && locale.timePickerLocale.placeholder) {
    return locale.timePickerLocale.placeholder;
  }

  return locale.lang.placeholder;
}

function getRangePlaceholder(picker, locale, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }

  if (picker === 'year' && locale.lang.yearPlaceholder) {
    return locale.lang.rangeYearPlaceholder;
  }

  if (picker === 'month' && locale.lang.monthPlaceholder) {
    return locale.lang.rangeMonthPlaceholder;
  }

  if (picker === 'week' && locale.lang.weekPlaceholder) {
    return locale.lang.rangeWeekPlaceholder;
  }

  if (picker === 'time' && locale.timePickerLocale.placeholder) {
    return locale.timePickerLocale.rangePlaceholder;
  }

  return locale.lang.rangePlaceholder;
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPrefixSuffix = hasPrefixSuffix;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _type = __webpack_require__(118);

var _Input = __webpack_require__(223);

var _reactNode = __webpack_require__(57);

var ClearableInputType = (0, _type.tuple)('text', 'input');

function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}

var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ClearableLabeledInput, _React$Component);

  var _super = (0, _createSuper2["default"])(ClearableLabeledInput);

  function ClearableLabeledInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, ClearableLabeledInput);
    _this = _super.apply(this, arguments);
    /** @private Do not use out of this class. We do not promise this is always keep. */

    _this.containerRef = /*#__PURE__*/React.createRef();

    _this.onInputMouseUp = function (e) {
      var _a;

      if ((_a = _this.containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
        var triggerFocus = _this.props.triggerFocus;
        triggerFocus === null || triggerFocus === void 0 ? void 0 : triggerFocus();
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(ClearableLabeledInput, [{
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var _this$props = this.props,
          allowClear = _this$props.allowClear,
          value = _this$props.value,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          handleReset = _this$props.handleReset;

      if (!allowClear) {
        return null;
      }

      var needClear = !disabled && !readOnly && value;
      var className = "".concat(prefixCls, "-clear-icon");
      return /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], {
        onClick: handleReset,
        className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(className, "-hidden"), !needClear), className),
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props2 = this.props,
          suffix = _this$props2.suffix,
          allowClear = _this$props2.allowClear;

      if (suffix || allowClear) {
        return /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }

      return null;
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, element) {
      var _classNames2;

      var _this$props3 = this.props,
          focused = _this$props3.focused,
          value = _this$props3.value,
          prefix = _this$props3.prefix,
          className = _this$props3.className,
          size = _this$props3.size,
          suffix = _this$props3.suffix,
          disabled = _this$props3.disabled,
          allowClear = _this$props3.allowClear,
          direction = _this$props3.direction,
          style = _this$props3.style,
          readOnly = _this$props3.readOnly,
          bordered = _this$props3.bordered;
      var suffixNode = this.renderSuffix(prefixCls);

      if (!hasPrefixSuffix(this.props)) {
        return (0, _reactNode.cloneElement)(element, {
          value: value
        });
      }

      var prefixNode = prefix ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, prefix) : null;
      var affixWrapperCls = (0, _classnames["default"])("".concat(prefixCls, "-affix-wrapper"), (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-focused"), focused), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-disabled"), disabled), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-sm"), size === 'small'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), suffix && allowClear && value), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-readonly"), readOnly), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, _defineProperty2["default"])(_classNames2, "".concat(className), !hasAddon(this.props) && className), _classNames2));
      return /*#__PURE__*/React.createElement("span", {
        ref: this.containerRef,
        className: affixWrapperCls,
        style: style,
        onMouseUp: this.onInputMouseUp
      }, prefixNode, (0, _reactNode.cloneElement)(element, {
        style: null,
        value: value,
        className: (0, _Input.getInputClassName)(prefixCls, bordered, size, disabled)
      }), suffixNode);
    }
  }, {
    key: "renderInputWithLabel",
    value: function renderInputWithLabel(prefixCls, labeledElement) {
      var _classNames4;

      var _this$props4 = this.props,
          addonBefore = _this$props4.addonBefore,
          addonAfter = _this$props4.addonAfter,
          style = _this$props4.style,
          size = _this$props4.size,
          className = _this$props4.className,
          direction = _this$props4.direction; // Not wrap when there is not addons

      if (!hasAddon(this.props)) {
        return labeledElement;
      }

      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonAfter) : null;
      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), wrapperClassName, (0, _defineProperty2["default"])({}, "".concat(wrapperClassName, "-rtl"), direction === 'rtl'));
      var mergedGroupClassName = (0, _classnames["default"])("".concat(prefixCls, "-group-wrapper"), (_classNames4 = {}, (0, _defineProperty2["default"])(_classNames4, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), (0, _defineProperty2["default"])(_classNames4, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), (0, _defineProperty2["default"])(_classNames4, "".concat(prefixCls, "-group-wrapper-rtl"), direction === 'rtl'), _classNames4), className); // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper

      return /*#__PURE__*/React.createElement("span", {
        className: mergedGroupClassName,
        style: style
      }, /*#__PURE__*/React.createElement("span", {
        className: mergedWrapperClassName
      }, addonBeforeNode, (0, _reactNode.cloneElement)(labeledElement, {
        style: null
      }), addonAfterNode));
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function renderTextAreaWithClearIcon(prefixCls, element) {
      var _classNames5;

      var _this$props5 = this.props,
          value = _this$props5.value,
          allowClear = _this$props5.allowClear,
          className = _this$props5.className,
          style = _this$props5.style,
          direction = _this$props5.direction,
          bordered = _this$props5.bordered;

      if (!allowClear) {
        return (0, _reactNode.cloneElement)(element, {
          value: value
        });
      }

      var affixWrapperCls = (0, _classnames["default"])("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (_classNames5 = {}, (0, _defineProperty2["default"])(_classNames5, "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames5, "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, _defineProperty2["default"])(_classNames5, "".concat(className), !hasAddon(this.props) && className), _classNames5));
      return /*#__PURE__*/React.createElement("span", {
        className: affixWrapperCls,
        style: style
      }, (0, _reactNode.cloneElement)(element, {
        style: null,
        value: value
      }), this.renderClearIcon(prefixCls));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          inputType = _this$props6.inputType,
          element = _this$props6.element;

      if (inputType === ClearableInputType[0]) {
        return this.renderTextAreaWithClearIcon(prefixCls, element);
      }

      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    }
  }]);
  return ClearableLabeledInput;
}(React.Component);

var _default = ClearableLabeledInput;
exports["default"] = _default;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _ref = __webpack_require__(117);

var _SearchOutlined = _interopRequireDefault(__webpack_require__(636));

var _Input = _interopRequireDefault(__webpack_require__(223));

var _button = _interopRequireDefault(__webpack_require__(26));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _configProvider = __webpack_require__(8);

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var customizePrefixCls = props.prefixCls,
      customizeInputPrefixCls = props.inputPrefixCls,
      className = props.className,
      customizeSize = props.size,
      suffix = props.suffix,
      _props$enterButton = props.enterButton,
      enterButton = _props$enterButton === void 0 ? false : _props$enterButton,
      addonAfter = props.addonAfter,
      loading = props.loading,
      disabled = props.disabled,
      customOnSearch = props.onSearch,
      customOnChange = props.onChange,
      restProps = __rest(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var contextSize = React.useContext(_SizeContext["default"]);
  var size = customizeSize || contextSize;
  var inputRef = React.useRef(null);

  var onChange = function onChange(e) {
    if (e && e.target && e.type === 'click' && customOnSearch) {
      customOnSearch(e.target.value, e);
    }

    if (customOnChange) {
      customOnChange(e);
    }
  };

  var onMouseDown = function onMouseDown(e) {
    var _a;

    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e.preventDefault();
    }
  };

  var onSearch = function onSearch(e) {
    var _a;

    if (customOnSearch) {
      customOnSearch((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input.value, e);
    }
  };

  var prefixCls = getPrefixCls('input-search', customizePrefixCls);
  var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  var searchIcon = typeof enterButton === 'boolean' || typeof enterButton === 'undefined' ? /*#__PURE__*/React.createElement(_SearchOutlined["default"], null) : null;
  var btnClassName = "".concat(prefixCls, "-button");
  var button;
  var enterButtonAsElement = enterButton || {};
  var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;

  if (isAntdButton || enterButtonAsElement.type === 'button') {
    button = (0, _reactNode.cloneElement)(enterButtonAsElement, (0, _extends2["default"])({
      onMouseDown: onMouseDown,
      onClick: onSearch,
      key: 'enterButton'
    }, isAntdButton ? {
      className: btnClassName,
      size: size
    } : {}));
  } else {
    button = /*#__PURE__*/React.createElement(_button["default"], {
      className: btnClassName,
      type: enterButton ? 'primary' : undefined,
      size: size,
      disabled: disabled,
      key: "enterButton",
      onMouseDown: onMouseDown,
      onClick: onSearch,
      loading: loading,
      icon: searchIcon
    }, enterButton);
  }

  if (addonAfter) {
    button = [button, (0, _reactNode.cloneElement)(addonAfter, {
      key: 'addonAfter'
    })];
  }

  var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(size), !!size), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-with-button"), !!enterButton), _classNames), className);
  return /*#__PURE__*/React.createElement(_Input["default"], (0, _extends2["default"])({
    ref: (0, _ref.composeRef)(inputRef, ref),
    onPressEnter: onSearch
  }, restProps, {
    size: size,
    prefixCls: inputPrefixCls,
    addonAfter: button,
    suffix: suffix,
    onChange: onChange,
    className: cls,
    disabled: disabled
  }));
});
Search.displayName = 'Search';
var _default = Search;
exports["default"] = _default;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcTextarea = _interopRequireDefault(__webpack_require__(1604));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _useMergedState3 = _interopRequireDefault(__webpack_require__(384));

var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(696));

var _configProvider = __webpack_require__(8);

var _Input = __webpack_require__(223);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var TextArea = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      _a$bordered = _a.bordered,
      bordered = _a$bordered === void 0 ? true : _a$bordered,
      _a$showCount = _a.showCount,
      showCount = _a$showCount === void 0 ? false : _a$showCount,
      maxLength = _a.maxLength,
      className = _a.className,
      style = _a.style,
      customizeSize = _a.size,
      props = __rest(_a, ["prefixCls", "bordered", "showCount", "maxLength", "className", "style", "size"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = React.useContext(_SizeContext["default"]);
  var innerRef = React.useRef();
  var clearableInputRef = React.useRef(null);

  var _useMergedState = (0, _useMergedState3["default"])(props.defaultValue, {
    value: props.value
  }),
      _useMergedState2 = (0, _slicedToArray2["default"])(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  var prevValue = React.useRef(props.value);
  React.useEffect(function () {
    if (props.value !== undefined || prevValue.current !== props.value) {
      setValue(props.value);
      prevValue.current = props.value;
    }
  }, [props.value, prevValue.current]);

  var handleSetValue = function handleSetValue(val, callback) {
    if (props.value === undefined) {
      setValue(val);
      callback === null || callback === void 0 ? void 0 : callback();
    }
  };

  var handleChange = function handleChange(e) {
    handleSetValue(e.target.value);
    (0, _Input.resolveOnChange)(innerRef.current, e, props.onChange);
  };

  var handleReset = function handleReset(e) {
    handleSetValue('', function () {
      var _a;

      (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    (0, _Input.resolveOnChange)(innerRef.current, e, props.onChange);
  };

  var prefixCls = getPrefixCls('input', customizePrefixCls);
  React.useImperativeHandle(ref, function () {
    var _a;

    return {
      resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
      focus: function focus(option) {
        var _a, _b;

        (0, _Input.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
      },
      blur: function blur() {
        var _a;

        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  });
  var textArea = /*#__PURE__*/React.createElement(_rcTextarea["default"], (0, _extends2["default"])({}, (0, _omit["default"])(props, ['allowClear']), {
    maxLength: maxLength,
    className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-borderless"), !bordered), (0, _defineProperty2["default"])(_classNames, className, className && !showCount), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === 'small' || customizeSize === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === 'large' || customizeSize === 'large'), _classNames)),
    style: showCount ? null : style,
    prefixCls: prefixCls,
    onChange: handleChange,
    ref: innerRef
  }));
  var val = (0, _Input.fixControlledValue)(value); // Max length value

  var hasMaxLength = Number(maxLength) > 0; // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题

  val = hasMaxLength ? (0, _toConsumableArray2["default"])(val).slice(0, maxLength).join('') : val; // TextArea

  var textareaNode = /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], (0, _extends2["default"])({}, props, {
    prefixCls: prefixCls,
    direction: direction,
    inputType: "text",
    value: val,
    element: textArea,
    handleReset: handleReset,
    ref: clearableInputRef,
    bordered: bordered
  })); // Only show text area wrapper when needed

  if (showCount) {
    var valueLength = (0, _toConsumableArray2["default"])(val).length;
    var dataCount = '';

    if ((0, _typeof2["default"])(showCount) === 'object') {
      dataCount = showCount.formatter({
        count: valueLength,
        maxLength: maxLength
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
    }

    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-textarea"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-textarea-rtl"), direction === 'rtl'), "".concat(prefixCls, "-textarea-show-count"), className),
      style: style,
      "data-count": dataCount
    }, textareaNode);
  }

  return textareaNode;
});
var _default = TextArea;
exports["default"] = _default;

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(702);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1605);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1606);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1609);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(702);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _EyeOutlined = _interopRequireDefault(__webpack_require__(224));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _EyeOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
exports.getFieldId = getFieldId;

function toArray(candidate) {
  if (candidate === undefined || candidate === false) return [];
  return Array.isArray(candidate) ? candidate : [candidate];
}

function getFieldId(namePath, formName) {
  if (!namePath.length) return undefined;
  var mergedId = namePath.join('_');
  return formName ? "".concat(formName, "_").concat(mergedId) : mergedId;
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ErrorList;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcMotion = _interopRequireDefault(__webpack_require__(84));

var _useMemo = _interopRequireDefault(__webpack_require__(587));

var _useCacheErrors3 = _interopRequireDefault(__webpack_require__(1632));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

var _context = __webpack_require__(126);

var EMPTY_LIST = [];

function ErrorList(_ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? EMPTY_LIST : _ref$errors,
      help = _ref.help,
      onDomErrorVisibleChange = _ref.onDomErrorVisibleChange;
  var forceUpdate = (0, _useForceUpdate["default"])();

  var _React$useContext = React.useContext(_context.FormItemPrefixContext),
      prefixCls = _React$useContext.prefixCls,
      status = _React$useContext.status;

  var _useCacheErrors = (0, _useCacheErrors3["default"])(errors, function (changedVisible) {
    if (changedVisible) {
      /**
       * We trigger in sync to avoid dom shaking but this get warning in react 16.13.
       *
       * So use Promise to keep in micro async to handle this.
       * https://github.com/ant-design/ant-design/issues/21698#issuecomment-593743485
       */
      Promise.resolve().then(function () {
        onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(true);
      });
    }

    forceUpdate();
  }, !!help),
      _useCacheErrors2 = (0, _slicedToArray2["default"])(_useCacheErrors, 2),
      visible = _useCacheErrors2[0],
      cacheErrors = _useCacheErrors2[1];

  var memoErrors = (0, _useMemo["default"])(function () {
    return cacheErrors;
  }, visible, function (_, nextVisible) {
    return nextVisible;
  }); // Memo status in same visible

  var _React$useState = React.useState(status),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      innerStatus = _React$useState2[0],
      setInnerStatus = _React$useState2[1];

  React.useEffect(function () {
    if (visible && status) {
      setInnerStatus(status);
    }
  }, [visible, status]);
  var baseClassName = "".concat(prefixCls, "-item-explain");
  return /*#__PURE__*/React.createElement(_rcMotion["default"], {
    motionDeadline: 500,
    visible: visible,
    motionName: "show-help",
    onLeaveEnd: function onLeaveEnd() {
      onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(false);
    },
    motionAppear: true,
    removeOnLeave: true
  }, function (_ref2) {
    var motionClassName = _ref2.className;
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])(baseClassName, (0, _defineProperty2["default"])({}, "".concat(baseClassName, "-").concat(innerStatus), innerStatus), motionClassName),
      key: "help"
    }, memoErrors.map(function (error, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", {
          key: index,
          role: "alert"
        }, error)
      );
    }));
  });
}

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(711);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function AddButton(_ref, ref) {
  var prefixCls = _ref.prefixCls,
      editable = _ref.editable,
      locale = _ref.locale,
      style = _ref.style;

  if (!editable || editable.showAdd === false) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", {
    ref: ref,
    type: "button",
    className: "".concat(prefixCls, "-nav-add"),
    style: style,
    "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab',
    onClick: function onClick(event) {
      editable.onEdit('add', {
        event: event
      });
    }
  }, editable.addIcon || '+');
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](AddButton));

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TabPane;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);




function TabPane(_ref) {
  var prefixCls = _ref.prefixCls,
      forceRender = _ref.forceRender,
      className = _ref.className,
      style = _ref.style,
      id = _ref.id,
      active = _ref.active,
      animated = _ref.animated,
      destroyInactiveTabPane = _ref.destroyInactiveTabPane,
      tabKey = _ref.tabKey,
      children = _ref.children;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](forceRender),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      visited = _React$useState2[0],
      setVisited = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (active) {
      setVisited(true);
    } else if (destroyInactiveTabPane) {
      setVisited(false);
    }
  }, [active, destroyInactiveTabPane]);
  var mergedStyle = {};

  if (!active) {
    if (animated) {
      mergedStyle.visibility = 'hidden';
      mergedStyle.height = 0;
      mergedStyle.overflowY = 'hidden';
    } else {
      mergedStyle.display = 'none';
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    id: id && "".concat(id, "-panel-").concat(tabKey),
    role: "tabpanel",
    tabIndex: active ? 0 : -1,
    "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
    "aria-hidden": !active,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, mergedStyle), style),
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-tabpane"), active && "".concat(prefixCls, "-tabpane-active"), className)
  }, (active || visited || forceRender) && children);
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);
var settle = __webpack_require__(1667);
var buildURL = __webpack_require__(127);
var parseHeaders = __webpack_require__(1669);
var isURLSameOrigin = __webpack_require__(1670);
var createError = __webpack_require__(716);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1671);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1672);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1668);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(399);

__webpack_require__(27);

__webpack_require__(1680);

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(257));

var _KeyCode = _interopRequireDefault(__webpack_require__(721));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var _button = _interopRequireDefault(__webpack_require__(26));

var _button2 = __webpack_require__(285);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _configProvider = __webpack_require__(8);

var _getRenderPropValue = __webpack_require__(677);

var _reactNode = __webpack_require__(57);

var _this = void 0;

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Popconfirm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useState = React.useState(props.visible),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  React.useEffect(function () {
    if ('visible' in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);
  React.useEffect(function () {
    if ('defaultVisible' in props) {
      setVisible(props.defaultVisible);
    }
  }, [props.defaultVisible]);

  var settingVisible = function settingVisible(value, e) {
    if (!('visible' in props)) {
      setVisible(value);
    }

    if (props.onVisibleChange) {
      props.onVisibleChange(value, e);
    }
  };

  var onConfirm = function onConfirm(e) {
    settingVisible(false, e);

    if (props.onConfirm) {
      props.onConfirm.call(_this, e);
    }
  };

  var onCancel = function onCancel(e) {
    settingVisible(false, e);

    if (props.onCancel) {
      props.onCancel.call(_this, e);
    }
  };

  var _onKeyDown = function onKeyDown(e) {
    if (e.keyCode === _KeyCode["default"].ESC && visible) {
      settingVisible(false, e);
    }
  };

  var onVisibleChange = function onVisibleChange(value) {
    var disabled = props.disabled;

    if (disabled) {
      return;
    }

    settingVisible(value);
  };

  var renderOverlay = function renderOverlay(prefixCls, popconfirmLocale) {
    var okButtonProps = props.okButtonProps,
        cancelButtonProps = props.cancelButtonProps,
        title = props.title,
        cancelText = props.cancelText,
        okText = props.okText,
        okType = props.okType,
        icon = props.icon;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-inner-content")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message")
    }, icon, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message-title")
    }, (0, _getRenderPropValue.getRenderPropValue)(title))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-buttons")
    }, /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({
      onClick: onCancel,
      size: "small"
    }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({
      onClick: onConfirm
    }, (0, _button2.convertLegacyProps)(okType), {
      size: "small"
    }, okButtonProps), okText || popconfirmLocale.okText)));
  };

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var customizePrefixCls = props.prefixCls,
      placement = props.placement,
      children = props.children,
      overlayClassName = props.overlayClassName,
      restProps = __rest(props, ["prefixCls", "placement", "children", "overlayClassName"]);

  var prefixCls = getPrefixCls('popover', customizePrefixCls);
  var prefixClsConfirm = getPrefixCls('popconfirm', customizePrefixCls);
  var overlayClassNames = (0, _classnames["default"])(prefixClsConfirm, overlayClassName);
  var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Popconfirm",
    defaultLocale: _default2["default"].Popconfirm
  }, function (popconfirmLocale) {
    return renderOverlay(prefixCls, popconfirmLocale);
  });
  return /*#__PURE__*/React.createElement(_tooltip["default"], (0, _extends2["default"])({}, restProps, {
    prefixCls: prefixCls,
    placement: placement,
    onVisibleChange: onVisibleChange,
    visible: visible,
    overlay: overlay,
    overlayClassName: overlayClassNames,
    ref: ref
  }), (0, _reactNode.cloneElement)(children, {
    onKeyDown: function onKeyDown(e) {
      var _a, _b;

      if ( /*#__PURE__*/React.isValidElement(children)) {
        (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      }

      _onKeyDown(e);
    }
  }));
});
Popconfirm.defaultProps = {
  transitionName: 'zoom-big',
  placement: 'top',
  trigger: 'click',
  okType: 'primary',
  icon: /*#__PURE__*/React.createElement(_ExclamationCircleFilled["default"], null),
  disabled: false
};
var _default = Popconfirm;
exports["default"] = _default;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var _default = KeyCode;
exports.default = _default;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _DeleteOutlined = _interopRequireDefault(__webpack_require__(1681));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _DeleteOutlined.default
  }));
};
DeleteOutlined.displayName = 'DeleteOutlined';
var _default = /*#__PURE__*/React.forwardRef(DeleteOutlined);
exports.default = _default;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_icons_CopyOutlined__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_icons_CopyOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_icons_CopyOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__styles_module_scss__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item;var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var NewsList=function(_Component){_inherits(NewsList,_Component);function NewsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsList.__proto__||Object.getPrototypeOf(NewsList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_27_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},tableQuery:{keyword:null,category_ids:[]},message:'',keyword:'',sort:'',is_middle_banner:null,promotion_status:1,brandList:[],showBrandList:false},_this.fetchBrands=function(){__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_30_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/brands',{per_page:10000},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({brandList:data.rows});});},_this.loadData=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.debounce(function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var tableQuery=_this.formRef.current.getFieldValue();console.log('tableQuery',tableQuery);_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_30_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/news',{page:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(opt,'page',1),page_size:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(opt,'page_size',10),keyword:tableQuery.keyword,sort:_this.state.sort,category_ids:tableQuery.category_ids,is_middle_banner:_this.state.is_middle_banner,promotion_status:_this.state.promotion_status,brand_id:tableQuery.brand_id},function(state,res){_this.setState({isLoadingData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},200),_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_30_configs_env__["b" /* API_HOST */]+('/api/mgt/v1/news/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_30_configs_env__["b" /* API_HOST */]+('/api/mgt/v1/news/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.isNil(data.id))_this.props.history.push('/news/view/'+data.id);});},_this.sortChange=function(pagination,filters,sorter){var sort='';if(!sorter)sort='';else{var string=[];if(sorter.order){string=sorter.order.split('end');sort=sorter.field+' '+string[0];}else{sort='';}console.log('pagination: ',pagination,'filters: ',filters,'sorter: ',sorter);console.log('sort = ',sort);}_this.setState({sort:sort},function(){return _this.loadData();});},_this.onCheckboxChange=function(e){if(e.target.checked)_this.setState({is_middle_banner:1});else _this.setState({is_middle_banner:0});},_this.onStatusChange=function(e){_this.setState({promotion_status:e.target.value},function(){return _this.loadData();});},_this.loadCategoryData=function(){if(window.location.href.indexOf('?category_id')!==-1){var category_id=__WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__["a" /* default */].getHashValue('category_id');category_id=category_id.split(',');for(var i=0;i<category_id.length;i++){category_id[i]=parseInt(category_id[i],10);}_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:['category_ids'],value:category_id}]);}},_this.handleChangeCategory=function(checkedValue){console.log('checkedValue',checkedValue);var showBrandList=false;var resetBrandList=true;checkedValue.forEach(function(id){if([129,130].includes(id)){showBrandList=true;resetBrandList=false;}});_this.formRef.current.setFieldsValue({brand_id:resetBrandList?null:_this.formRef.current.getFieldValue('brand_id')});_this.setState({showBrandList:showBrandList});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__["a" /* default */].updateConfig();this.loadCategoryData();this.loadData();this.fetchBrands();}//從網址判斷有沒有 category_id，再讓 checkbox 勾選帶回的參數
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData,brandList=_state.brandList,showBrandList=_state.showBrandList;var options=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this,'props.app.options',{});var newsCategories=options.news_categories||[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{to:'/news'},'\u6D88\u606F\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u6D88\u606F\u7BA1\u7406',wp.element.createElement('span',null)),wp.element.createElement('div',{className:'block search'},wp.element.createElement('h3',null,'\u641C\u5C0B',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',initialValues:{promotion_status:this.state.promotion_status,brand_id:null},onFinish:function onFinish(values){_this2.setState({tableQuery:values});_this2.loadData(values);var category_ids=values.category_ids;localStorage.setItem('category_ids',category_ids);}},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,Object(__WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,{name:'category_ids',label:'\u6D88\u606F\u985E\u5225'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox___default.a.Group,{onChange:this.handleChangeCategory},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a,{grid:listGrid,dataSource:newsCategories,renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox___default.a,{value:item.id},item.name));}}))),showBrandList&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,{name:'brand_id',label:'\u5C08\u5C6C\u54C1\u724C'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toUpperCase().includes(input.toUpperCase());}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option,{key:'all',value:null},'\u5168\u90E8'),brandList.map(function(brand){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select___default.a.Option,{key:brand.id,value:brand.id},brand.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,{name:'others',label:'\u5176\u4ED6'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox___default.a,{onChange:this.onCheckboxChange},'\u4E2D\u7248\u4F4D Banner \u662F\u5426\u555F\u7528')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__["a" /* genFormItemAtrribute */])('promotion_status','消息狀態'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Group,{onChange:this.onStatusChange},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:1},'\u5168\u90E8'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:2},'\u4E0A\u67B6\u4E2D'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:3},'\u6E96\u5099\u4E2D'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:4},'\u5DF2\u4E0B\u67B6'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});__WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__["a" /* default */].removeLocalStorage('category_ids');_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default.a,null),htmlType:'submit'},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u6D88\u606F\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{to:'/news/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(tableData,'page_size',0),onChange:__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.debounce(function(page,page_size){_this2.loadData({page:page,page_size:page_size});},100)},onChange:this.sortChange,columns:[{dataIndex:'id',title:'ID',sorter:function sorter(a,b){return a.id-b.id;}},{dataIndex:['images','0','url'],title:'圖片',render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default.a,{shape:'square',src:image,component:wp.element.createElement('div',{'class':'wp-menu-image dashicons-before dashicons-megaphone'},wp.element.createElement('br',null))});}},{dataIndex:'name',key:'id',title:'名稱',sorter:function sorter(a,b){return a.name.length-b.name.length;}},{dataIndex:'category_name',title:'分類'},{dataIndex:'status_name',title:'狀態'},{dataIndex:'modified_at',title:'更新時間',sorter:function sorter(a,b){return a.modified_at-b.modified_at;}},{dataIndex:['modified_user','name'],title:'異動者'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_34_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5__ant_design_icons_lib_icons_CopyOutlined___default.a,null),loading:record.isCloneData===true,onClick:function onClick(){return _this2.cloneData(record);}},'\u8907\u88FD'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_react_router_dom__["b" /* Link */],{role:'button',to:'/news/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return NewsList;}(__WEBPACK_IMPORTED_MODULE_27_react__["Component"]);

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___3_ObF","container_1":"container_1___1vJlP","container_2":"container_2___3omxQ"};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_ShopOutlined__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_ShopOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_ShopOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_module_scss__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_libs_AppHelper__ = __webpack_require__(10);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item;var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_26_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},table_query:{keyword:null},message:'',keyword:''},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var tableQuery=_this.formRef.current.getFieldValue();var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_31__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_30__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/brands',{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'keyword'),type:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'type'),category_id:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'type')==1?__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'brand_categories'):__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'food_categories'),delivery_id:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableQuery,'delivery_id')},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.exportData=function(){var table_query=_this.state.table_query;_this.setState({isExportData:true});__WEBPACK_IMPORTED_MODULE_32_axios___default()({url:__WEBPACK_IMPORTED_MODULE_33_axios_lib_helpers_buildURL___default()(__WEBPACK_IMPORTED_MODULE_30__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/brands/export',{keyword:table_query.keyword,email:'user@gmail.com',format:'xlsx'}),method:'GET',responseType:'blob',// important
headers:__WEBPACK_IMPORTED_MODULE_31__libs_whttp__["a" /* default */].getHeaders()}).then(function(response){_this.setState({isExportData:false});var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download','export.xlsx');document.body.appendChild(link);link.click();}).catch(function(error){_this.setState({isExportData:false});var res={code:200,reason:'未知錯誤',error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.statusText;}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.warning('無法匯出:'+error.message);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_31__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_30__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/brands/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_31__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_30__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/brands/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isNil(data.id))_this.props.history.push('/brands/view/'+data.id);});},_this.submitUserStatusData=function(status,user_id){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(result){};_this.setState({isSubmitUserStatusData:true});__WEBPACK_IMPORTED_MODULE_31__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_30__configs_env__["b" /* API_HOST */]+('/api/v1/user/status/'+user_id),{status:status},function(state,res){_this.setState({isSubmitUserStatusData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){callback(false);return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.warning('發生錯誤');}if(code!==200){callback(false);return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.warning(reason);}callback(true);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_36_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
// 匯出
//變更使用者狀態
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$table_query=_state.table_query,table_query=_state$table_query===undefined?{}:_state$table_query,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this,'props.app.options',{});var privileges=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(window,'VC_CONFIG.privileges');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */],{to:'/brands'},'\u54C1\u724C\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u54C1\u724C\u7BA1\u7406',wp.element.createElement('span',null)),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a,{ref:this.formRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,_extends({label:'\u540D\u7A31'},Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','名稱')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input___default.a,{placeholder:'\u641C\u5C0B\u540D\u7A31'}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('type','品牌類型'),{rules:[{required:false,message:'請選擇點擊動作'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a,{value:1},'\u4E00\u822C\u5C08\u6AC3'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio___default.a,{value:2},'\u7F8E\u98DF\u9910\u5EF3'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,{shouldUpdate:true,noStyle:true},function(){if(!_this2.formRef.current)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null);var action_type=_this2.formRef.current.getFieldValue('type');if(action_type==1){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('brand_categories','品牌分類'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u54C1\u724C\u5206\u985E'},wp.element.createElement('option',{value:null},'\u8ACB\u9078\u64C7\u54C1\u724C\u5206\u985E'),__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(options,'brand_categories',[]),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:item.id,value:item.id},item.name);})));}if(action_type==2){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('food_categories','品牌分類'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u54C1\u724C\u5206\u985E'},wp.element.createElement('option',{value:null},'\u8ACB\u9078\u64C7\u54C1\u724C\u5206\u985E'),__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(options,'food_categories',[]),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:item.id,value:item.id},item.name);})));}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('delivery_id','外送平台'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5916\u9001\u5E73\u53F0'},wp.element.createElement('option',{value:null},'\u8ACB\u9078\u64C7\u5916\u9001\u5E73\u53F0'),__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(options,'vendors',[]),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_select___default.a.Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u54C1\u724C\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(privileges,'brands.create',false)===true&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */],{to:'/brands/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'logo_url',title:'品牌圖',render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_avatar___default.a,{shape:'square',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_ShopOutlined___default.a,null),src:image});}},{dataIndex:'name',title:'名稱'},{dataIndex:'status_name',title:'狀態'},{dataIndex:'sort',title:'排序'},{dataIndex:'modified_at',title:'更新時間'},{dataIndex:['modified_user','name'],title:'異動者'},{title:'Action',key:'tools',width:250,render:function render(text,record){var privileges=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(window,'VC_CONFIG.privileges',{});var canCreate=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(privileges,'brands.create',false);var canEdit=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(privileges,'brands.modify',false);var dataSource=[];if(canCreate){dataSource.push(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_34_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}));dataSource.push(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined___default.a,null),loading:record.isCloneData===true,onClick:function onClick(){return _this2.cloneData(record);}},'\u8907\u88FD'));}if(canCreate||canEdit)dataSource.push(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */],{role:'button',to:'/brands/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F')));if(dataSource.length===0)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:dataSource// dataSource={[
//   <DeleteConfirmButton
//     loading={record.isDeleteData === true}
//     size="small"
//     onConfirm={() => this.deleteData(record)}
//   />,
//   <Button type="default" size="small" icon={<CopyOutlined />} loading={record.isCloneData === true} onClick={() => this.cloneData(record)}>複製</Button>,
//   <Link role="button" to={`/brands/view/${record.id}`} ><Button type="default" size="small" icon={<FormOutlined />}>編輯</Button></Link>
// ]}
,renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_26_react__["Component"]);

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___IXJ-U","container_1":"container_1___170TK","container_2":"container_2___NjvSh"};

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CategoryList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_libs_AppHelper__ = __webpack_require__(10);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item;var CategoryList=function(_Component){_inherits(CategoryList,_Component);function CategoryList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CategoryList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CategoryList.__proto__||Object.getPrototypeOf(CategoryList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_21_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},table_query:{keyword:null,type:null},message:'',keyword:''},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});var tableQuery=_this.formRef.current.getFieldValue();__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/categories',{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableQuery,'keyword'),type:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableQuery,'type')},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.exportData=function(){var table_query=_this.state.table_query;_this.setState({isExportData:true});__WEBPACK_IMPORTED_MODULE_27_axios___default()({url:__WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL___default()(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/categories/export',{keyword:table_query.keyword,email:'user@gmail.com',format:'xlsx'}),method:'GET',responseType:'blob',// important
headers:__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].getHeaders()}).then(function(response){_this.setState({isExportData:false});var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download','export.xlsx');document.body.appendChild(link);link.click();}).catch(function(error){_this.setState({isExportData:false});var res={code:200,reason:'未知錯誤',error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.statusText;}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning('無法匯出:'+error.message);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/categories/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/categories/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(data.id))_this.props.history.push('/category/view/'+data.id);});},_this.submitUserStatusData=function(status,user_id){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(result){};_this.setState({isSubmitUserStatusData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/v1/user/status/'+user_id),{status:status},function(state,res){_this.setState({isSubmitUserStatusData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){callback(false);return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning('發生錯誤');}if(code!==200){callback(false);return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning(reason);}callback(true);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CategoryList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_31_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
// 匯出
//變更使用者狀態
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$table_query=_state.table_query,table_query=_state$table_query===undefined?{}:_state$table_query,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(this.props,'auth.permissions',{});var CategoryDate=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'rows');var options=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{to:'/category'},'\u985E\u5225\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u985E\u5225\u7BA1\u7406',wp.element.createElement('span',null)),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a,{ref:this.formRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','名稱'),{label:'\u540D\u7A31'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default.a,{placeholder:'\u641C\u5C0B\u540D\u7A31'}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('type','類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u641C\u5C0B\u985E\u5225'},wp.element.createElement('option',{value:null},'\u8ACB\u9078\u64C7\u641C\u5C0B\u985E\u5225'),__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(options,'category_types',[]),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_select___default.a.Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u985E\u5225\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{to:'/category/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'type_name',title:'類別'},{dataIndex:'name',title:'名稱'},{dataIndex:'status_name',title:'狀態'},{dataIndex:'sort',title:'排序'},{dataIndex:'updated_at',title:'更新時間'},//{ dataIndex: ['modified_user','name'] , title: '異動者'},
{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_CopyOutlined___default.a,null),loading:record.isCloneData===true,onClick:function onClick(){return _this2.cloneData(record);}},'\u8907\u88FD'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{role:'button',to:'/category/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return CategoryList;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1_bLi","container_1":"container_1___2dXbA","container_2":"container_2___37Fdr"};

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_module_scss__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueList=function(_Component){_inherits(CatalogueList,_Component);function CatalogueList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueList.__proto__||Object.getPrototypeOf(CatalogueList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_25_react___default.a.createRef(),_this.state={tableInfo:{current:0,page_size:10,total:0,rows:[]},message:'',categoryCheckboxList:[],isLoadingData:false},_this.getCatalogueList=function(values){var opt=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{page:1,page_size:10};var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_30_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_29_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/catalogues',{keyword:values.keyword,category_ids:values.category_ids,promotion_status:values.promotion_status,page:page,page_size:page_size},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableInfo:data});});},_this.handleSearch=function(values){console.log('search values',values);_this.getCatalogueList(values);},_this.handleReset=function(){_this.formRef.current.resetFields();_this.getCatalogueList(_this.formRef.current.getFieldsValue());},_this.getCategoryCheckboxList=function(){__WEBPACK_IMPORTED_MODULE_30_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_29_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/categories',{type:4},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({categoryCheckboxList:data.rows});});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_30_libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_29_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/catalogues/'+item.id,{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_24_antd_lib_message___default.a.success('刪除成功');_this.getCatalogueList(_this.formRef.current.getFieldsValue());});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueList,[{key:'componentDidMount',value:function componentDidMount(){this.getCatalogueList(this.formRef.current.getFieldsValue());this.getCategoryCheckboxList();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tableInfo=_state.tableInfo,categoryCheckboxList=_state.categoryCheckboxList;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react_router_dom__["b" /* Link */],{to:'/catalogues'},'\u4FC3\u92B7\u76EE\u9304\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u7BA1\u7406'),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a,{ref:this.formRef,className:'basicForm',initialValues:{keyword:'',category_ids:[],promotion_status:1},layout:'vertical',autoComplete:'off',onFinish:this.handleSearch},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item,{name:'keyword',label:'\u540D\u7A31'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input___default.a,{placeholder:'\u641C\u5C0B\u540D\u7A31'}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item,{name:'category_ids',label:'\u76EE\u9304\u985E\u5225'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_list___default.a,{grid:listGrid,dataSource:categoryCheckboxList,renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox___default.a,{value:item.id},item.name));}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item,{name:'promotion_status',label:'\u76EE\u9304\u72C0\u614B'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:1},'\u5168\u90E8'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:2},'\u4E0A\u67B6\u4E2D'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:3},'\u6E96\u5099\u4E2D'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_radio___default.a.Button,{value:4},'\u5DF2\u4E0B\u67B6'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item,{style:{marginTop:'50px'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{onClick:this.handleReset},'\u91CD\u7F6E'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default.a,null),htmlType:'submit'},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u4FC3\u92B7\u76EE\u9304\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react_router_dom__["b" /* Link */],{to:'/catalogues/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableInfo.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(tableInfo,'current',[]),total:__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(tableInfo,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(tableInfo,'page_size',0),onChange:function onChange(page,page_size){_this2.getCatalogueList(_this2.formRef.current.getFieldsValue(),{page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:['images','0','url'],title:'封面',render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar___default.a,{shape:'square',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined___default.a,null),src:image});}},{dataIndex:'name',title:'名稱'},{dataIndex:'category_name',title:'分類'},{dataIndex:'status_name',title:'狀態'},{dataIndex:'sort',title:'排序'},{dataIndex:'modified_at',title:'更新時間'},{dataIndex:['modified_user','name'],title:'異動者'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react_router_dom__["b" /* Link */],{role:'button',to:'/catalogues/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return CatalogueList;}(__WEBPACK_IMPORTED_MODULE_25_react__["Component"]);

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___gxKi5","container_1":"container_1___2Eqnu","container_2":"container_2___2UeQ_"};

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecipeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_module_scss__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_libs_AppHelper__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a.Item;var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var RecipeList=function(_Component){_inherits(RecipeList,_Component);function RecipeList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecipeList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipeList.__proto__||Object.getPrototypeOf(RecipeList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_23_react___default.a.createRef(),_this.state={tableData:{"current":0,//目前頁數
"page_size":10,//一頁幾筆
"total":0,//以此query條件，總共幾筆資料
"rows":[]},tableQuery:{keyword:null,category_ids:[]},message:'',keyword:''},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var tableQuery=_this.formRef.current.getFieldValue();//const { tableQuery } = this.state;
var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_28__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_27__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/recipes',{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(tableQuery,'keyword'),category_ids:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(tableQuery,'recipe_ids')},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.exportData=function(){var tableQuery=_this.state.tableQuery;_this.setState({isExportData:true});__WEBPACK_IMPORTED_MODULE_29_axios___default()({url:__WEBPACK_IMPORTED_MODULE_30_axios_lib_helpers_buildURL___default()(__WEBPACK_IMPORTED_MODULE_27__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/recipes/export',{keyword:tableQuery.keyword,email:'user@gmail.com',format:'xlsx'}),method:'GET',responseType:'blob',// important
headers:__WEBPACK_IMPORTED_MODULE_28__libs_whttp__["a" /* default */].getHeaders()}).then(function(response){_this.setState({isExportData:false});var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download','export.xlsx');document.body.appendChild(link);link.click();}).catch(function(error){_this.setState({isExportData:false});var res={code:200,reason:'未知錯誤',error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.statusText;}__WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.warning('無法匯出:'+error.message);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_28__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_27__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/recipes/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_28__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_27__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/recipes/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isNil(data.id))_this.props.history.push('/recipes/view/'+data.id);});},_this.submitUserStatusData=function(status,user_id){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(result){};_this.setState({isSubmitUserStatusData:true});__WEBPACK_IMPORTED_MODULE_28__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_27__configs_env__["b" /* API_HOST */]+('/api/v1/user/status/'+user_id),{status:status},function(state,res){_this.setState({isSubmitUserStatusData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){callback(false);return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.warning('發生錯誤');}if(code!==200){callback(false);return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.warning(reason);}callback(true);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipeList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_33_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
// 匯出
//變更使用者狀態
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$tableQuery=_state.tableQuery,tableQuery=_state$tableQuery===undefined?{}:_state$tableQuery,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["b" /* Link */],{to:'/recipes'},'\u98DF\u8B5C\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u98DF\u8B5C\u7BA1\u7406'),wp.element.createElement('p',null),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a,{ref:this.formRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,Object(__WEBPACK_IMPORTED_MODULE_32_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_32_libs_FormHelper__["a" /* genFormItemAtrribute */])('recipe_ids','食譜類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(options,'recipe_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_checkbox___default.a,{value:item.id},item.name));}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u98DF\u8B5C\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["b" /* Link */],{to:'/recipes/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:['images','0','url'],title:'封面',render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar___default.a,{shape:'square',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_ShopOutlined___default.a,null),src:image});}},{dataIndex:'name',title:'名稱'},{dataIndex:'category_name',title:'分類'},{dataIndex:'status_name',title:'狀態'},{dataIndex:'sort',title:'排序'},{dataIndex:'modified_at',title:'更新時間'},{dataIndex:['modified_user','name'],title:'異動者'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}),// <Button type="default" size="small" icon={<CopyOutlined />} loading={record.isCloneData === true} onClick={() => this.cloneData(record)}>複製</Button>,
wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["b" /* Link */],{role:'button',to:'/recipes/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return RecipeList;}(__WEBPACK_IMPORTED_MODULE_23_react__["Component"]);

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___34rxN","container_1":"container_1___3efNM","container_2":"container_2___3R2s1"};

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VendorList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item;var VendorList=function(_Component){_inherits(VendorList,_Component);function VendorList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VendorList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VendorList.__proto__||Object.getPrototypeOf(VendorList)).call.apply(_ref,[this].concat(args))),_this),_this.state={tableData:{"current":0,//目前頁數
"page_size":10,//一頁幾筆
"total":0,//以此query條件，總共幾筆資料
"rows":[]},tableQuery:{keyword:null},message:'',keyword:''},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var tableQuery=_this.state.tableQuery;var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/vendors',{page:page,page_size:page_size,keyword:tableQuery.keyword},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.exportData=function(){var tableQuery=_this.state.tableQuery;_this.setState({isExportData:true});__WEBPACK_IMPORTED_MODULE_27_axios___default()({url:__WEBPACK_IMPORTED_MODULE_28_axios_lib_helpers_buildURL___default()(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/vendors/export',{keyword:tableQuery.keyword,email:'user@gmail.com',format:'xlsx'}),method:'GET',responseType:'blob',// important
headers:__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].getHeaders()}).then(function(response){_this.setState({isExportData:false});var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download','export.xlsx');document.body.appendChild(link);link.click();}).catch(function(error){_this.setState({isExportData:false});var res={code:200,reason:'未知錯誤',error:error,data:{}};if(error.response){res.code=error.response.status;res.reason=error.response.statusText;}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning('無法匯出:'+error.message);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/vendors/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/vendors/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isNil(data.id))_this.props.history.push('/vendors/view/'+data.id);});},_this.submitUserStatusData=function(status,user_id){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(result){};_this.setState({isSubmitUserStatusData:true});__WEBPACK_IMPORTED_MODULE_26__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_25__configs_env__["b" /* API_HOST */]+('/api/v1/user/status/'+user_id),{status:status},function(state,res){_this.setState({isSubmitUserStatusData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){callback(false);return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning('發生錯誤');}if(code!==200){callback(false);return __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning(reason);}callback(true);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VendorList,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}// 拉Table資料
// 匯出
//變更使用者狀態
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$tableQuery=_state.tableQuery,tableQuery=_state$tableQuery===undefined?{}:_state$tableQuery,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(this.props,'auth.permissions',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{to:'/vendors'},'\u7B2C\u4E09\u65B9\u5E73\u53F0\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u7B2C\u4E09\u65B9\u5E73\u53F0\u7BA1\u7406'),wp.element.createElement('p',null),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a,null,wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,{label:'\u540D\u7A31'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input___default.a,{placeholder:'\u641C\u5C0B\u540D\u7A31',value:tableQuery.keyword,onChange:function onChange(event){tableQuery.keyword=event.target.value;_this2.setState({tableQuery:tableQuery});}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{onClick:function onClick(event){_this2.setState({tableQuery:{keyword:null,roles:[],status:[],citys:[],fields:[]}},function(){return _this2.loadData();});}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u98DF\u8B5C\u5217\u8868',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a,{layout:'inline'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{to:'/vendors/view'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:'primary'},'\u65B0\u589E')))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'image_url',title:'封面',render:function render(image){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_avatar___default.a,{shape:'square',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_ShopOutlined___default.a,null),src:image});}},{dataIndex:'name',title:'名稱'},{dataIndex:'type_name',title:'分類'},// { dataIndex: 'status_name'   , title: '狀態' },
// { dataIndex: 'sort'          , title: '排序' },
// { dataIndex: 'modified_at'   , title: '更新時間'},
// { dataIndex: ['modified_user','name'] , title: '異動者'},
{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){return _this2.deleteData(record);}}),// <Button type="default" size="small" icon={<CopyOutlined />} loading={record.isCloneData === true} onClick={() => this.cloneData(record)}>複製</Button>,
wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_react_router_dom__["b" /* Link */],{role:'button',to:'/vendors/view/'+record.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return VendorList;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1Smrs","container_1":"container_1___3pSkD","container_2":"container_2___Zc4Ll"};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CategoryList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_module_scss__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_libs_AppHelper__ = __webpack_require__(10);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item;var CategoryList=function(_Component){_inherits(CategoryList,_Component);function CategoryList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CategoryList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CategoryList.__proto__||Object.getPrototypeOf(CategoryList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_16_react___default.a.createRef(),_this.state={tableData:{"current":0,//目前頁數
"page_size":10,//一頁幾筆
"total":0,//以此query條件，總共幾筆資料
"rows":[]},table_query:{keyword:null,groupid:null},message:'',keyword:''},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});var tableQuery=_this.formRef.current.getFieldValue();__WEBPACK_IMPORTED_MODULE_21__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_20__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/cibcs',{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableQuery,'keyword'),groupid:__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableQuery,'groupid')},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}//console.log('data',data)
_this.setState({tableData:data});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CategoryList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_26_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
},{key:'render',// 匯出
// exportData = () => {
//   const { table_query } = this.state;
//   this.setState({ isExportData:true } )
//   axios({
//     url: buildURL(API_HOST + '/api/mgt/v1/categories/export', {
//           keyword  : table_query.keyword,
//           email    : 'user@gmail.com',
//           format   :'xlsx',
//         }),
//     method: 'GET',
//     responseType: 'blob', // important
//     headers: whttp.getHeaders(),
//   }).then((response) => {
//     this.setState({ isExportData:false } )
//     const url = window.URL.createObjectURL(new Blob([response.data]));
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'export.xlsx');
//     document.body.appendChild(link);
//     link.click();
//   })
//   .catch( error => {
//     this.setState({ isExportData:false } )
//     let res = { code: 200, reason:'未知錯誤', error: error, data:{}};
//     if (error.response)
//     {
//         res.code = error.response.status
//         res.reason    = error.response.statusText
//     }
//     message.warning('無法匯出:' + error.message)
//   });
// }
// deleteData = (item) => {
//   if (_.isNil(item.id)) return
//   item.isDeleteData = true
//   this.setState({ isDeleteData: true })
//   whttp.delete(API_HOST + `/api/mgt/v1/categories/${item.id}`, {
//   }, (state, res) => {
//     item.isDeleteData = false
//     this.setState({ isDeleteData: false })
//     const { code = 100, reason = '發生錯誤', data = {} } = res;
//     if (state === false) { return message.error('發生錯誤'); }
//     if (code !== 200) { return message.error(reason); }
//     message.success('刪除成功')
//     this.loadData()
//   });
// }
// cloneData = (item) => {
//   if (_.isNil(item.id)) return
//   item.isCloneData = true
//   this.setState({ isCloneData: true})
//   whttp.post(API_HOST + `/api/mgt/v1/categories/${item.id}/clone`, {
//   }, (state, res) => {
//     item.isCloneData = false
//     this.setState({ isCloneData: false })
//     const { code = 100, reason = '發生錯誤', data = {} } = res;
//     if (state === false) { return message.error('發生錯誤'); }
//     if (code !== 200) { return message.error(reason); }
//     message.success('複製成功')
//     if (!_.isNil(data.id))
//       this.props.history.push(`/category/view/${data.id}`)
//   });
// }
//變更使用者狀態
// submitUserStatusData = (status, user_id, callback = (result)=>{}) => {
//   this.setState({isSubmitUserStatusData:true})
//   whttp.post(API_HOST + `/api/v1/user/status/${user_id}` , {
//     status : status
//   },
//   (state, res) => 
//   {
//     this.setState({isSubmitUserStatusData:false})
//     const {code=100, reason='發生錯誤', data={} } = res;
//     if (state === false) { 
//       callback(false)
//       return message.warning('發生錯誤'); 
//     }
//     if (code !== 200)
//     { 
//       callback(false)
//       return message.warning(reason); 
//     }
//     callback(true)
//   })
// }
value:function render(){var _this2=this;var _state=this.state,_state$table_query=_state.table_query,table_query=_state$table_query===undefined?{}:_state$table_query,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(this.props,'auth.permissions',{});var cibcInfo=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableData,'rows');//.filter(info=>{return info.iscibc == 1})
var options=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["b" /* Link */],{to:'/cibc'},'\u4FDD\u7D93\u64DA\u9EDE\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u4FDD\u7D93\u64DA\u9EDE\u7BA1\u7406',wp.element.createElement('span',null)),wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{ref:this.formRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,_extends({},Object(__WEBPACK_IMPORTED_MODULE_25_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','關鍵字'),{label:'\u95DC\u9375\u5B57'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,{placeholder:'\u641C\u5C0B\u95DC\u9375\u5B57'}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u4FDD\u7D93\u64DA\u9EDE\u5217\u8868',wp.element.createElement('span',null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:cibcInfo,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'name',title:'服務分店'},{dataIndex:'iscibc_name',title:'保經據點'},{dataIndex:'address',title:'地址'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[// <DeleteConfirmButton
//   loading={record.isDeleteData === true}
//   size="small"
//   onConfirm={() => this.deleteData(record)}
// />,
// <Button type="default" size="small" icon={<CopyOutlined />} loading={record.isCloneData === true} onClick={() => this.cloneData(record)}>複製</Button>,
wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["b" /* Link */],{role:'button',to:'/cibc/view/'+text.id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return CategoryList;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___iTbmw","container_1":"container_1___sl-Nj","container_2":"container_2___1i6g9"};

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_module_scss__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_libs_FormHelper__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item;var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var NewsList=function(_Component){_inherits(NewsList,_Component);function NewsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsList.__proto__||Object.getPrototypeOf(NewsList)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_18_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},tableQuery:{keyword:null,category_ids:[]},message:'',keyword:'',sort:'',is_middle_banner:null},_this.loadData=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var tableQuery=_this.formRef.current.getFieldValue();console.log('tableQuery',tableQuery);_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/privileges',{page:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(opt,'page',1),page_size:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(opt,'page_size',10),keyword:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(tableQuery,'keyword'),sort:_this.state.sort//category_ids : _.get(tableQuery, 'category_ids'),
//is_middle_banner : this.state.is_middle_banner,
},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},300),_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/news/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_23__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_22__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/news/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_15_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isNil(data.id))_this.props.history.push('/news/view/'+data.id);});},_this.sortChange=function(pagination,filters,sorter){var sort='';if(!sorter)sort='';else{var string=[];if(sorter.order){string=sorter.order.split('end');sort=sorter.field+' '+string[0];}else{sort='';}console.log('pagination: ',pagination,'filters: ',filters,'sorter: ',sorter);console.log('sort = ',sort);}_this.setState({sort:sort},function(){return _this.loadData();});},_this.onCheckboxChange=function(e){if(e.target.checked)_this.setState({is_middle_banner:1});else _this.setState({is_middle_banner:0});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_24_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$tableQuery=_state.tableQuery,tableQuery=_state$tableQuery===undefined?{}:_state$tableQuery,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react_router_dom__["b" /* Link */],{to:'/privileges'},'\u6B0A\u9650\u7BA1\u7406'))),wp.element.createElement('h2',null,'\u6B0A\u9650\u7BA1\u7406',wp.element.createElement('span',null)),wp.element.createElement('div',{className:'block search'},wp.element.createElement('h3',null,'\u641C\u5C0B',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onValuesChange:function onValuesChange(changedFields,allFields){return console.log('onValuesChange',changedFields);},onFinish:function onFinish(values){_this2.setState({tableQuery:values});_this2.loadData(values);}},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,Object(__WEBPACK_IMPORTED_MODULE_25_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7__ant_design_icons_lib_icons_SearchOutlined___default.a,null),htmlType:'submit'},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,wp.element.createElement('span',null,'\u4F7F\u7528\u8005\u5217\u8868'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_table___default.a,{dataSource:tableData.rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(tableData,'page_size',0),onChange:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(function(page,page_size){_this2.loadData({page:page,page_size:page_size});},100)},onChange:this.sortChange,columns:[// { dataIndex: 'id'            , title: '#', sorter: (a, b) => a.id - b.id},
// { dataIndex: ['images', '0', 'url'], title: '圖片',
//   render: image => <Avatar shape="square" src={image} component={<div class="wp-menu-image dashicons-before dashicons-megaphone"><br/></div>} />,
// },
{dataIndex:'user_id',title:'username'},// { dataIndex: 'category_name' , title: '分類' },
// { dataIndex: 'status_name'   , title: '狀態' },
// { dataIndex: 'sort'          , title: '排序' },
{dataIndex:'created_at',title:'建立時間'},{dataIndex:'updated_at',title:'更新時間'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[// <DeleteConfirmButton
//   loading={record.isDeleteData === true}
//   size="small"
//   onConfirm={() => this.deleteData(record)}
// />,
wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react_router_dom__["b" /* Link */],{role:'button',to:'/privileges/view/'+record.user_id},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6__ant_design_icons_lib_icons_FormOutlined___default.a,null)},'\u7DE8\u8F2F'))],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,item);}});}}]}));}}]);return NewsList;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1iE8o","container_1":"container_1___YxCYU","container_2":"container_2___2HTeG"};

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
var Static=function Static(){var onFinish=function onFinish(values){__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_15_configs_env__["b" /* API_HOST */]+'/api/mgt/v1/system',{path:values.path},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_11_antd_lib_message___default.a.success('新增成功');});};var onFinishFailed=function onFinishFailed(errorInfo){console.log('Failed:',errorInfo);};return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */],{to:'/static'},'\u975C\u614B\u9801\u9762\u8F49\u63DB'))),wp.element.createElement('h2',null,'\u975C\u614B\u9801\u9762\u8F49\u63DB',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{style:{display:'flex'},name:'basic',onFinish:onFinish,onFinishFailed:onFinishFailed,autoComplete:'off'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{style:{marginRight:'20px'},label:'\u7DB2\u5740',name:'path',rules:[{required:true,message:'請輸入網址'}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{style:{width:400}})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,{type:'primary',htmlType:'submit'},'\u5132\u5B58'))),wp.element.createElement('p',null,'\u7BC4\u4F8B\uFF1A\u7DB2\u9801\u540D\u7A31/'),wp.element.createElement('p',{style:{color:'red'}},'\uFF0A\uFF0A\uFF0A\uFF0A\u5982\u6709\u5DF2\u5B58\u5728\u7DB2\u9801\u6703\u76F4\u63A5\u8986\u84CB\uFF0C\u82E5\u7DB2\u9801\u4E0D\u5B58\u5728\u6703\u76F4\u63A5\u8F49\u6210\u9996\u9801'));};/* harmony default export */ __webpack_exports__["default"] = (Static);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HotKeywords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PlusCircleOutlined__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PlusCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PlusCircleOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_SearchOutlined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_SearchOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_SearchOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_module_scss__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios_lib_helpers_buildURL__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios_lib_helpers_buildURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios_lib_helpers_buildURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__ = __webpack_require__(10);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item;var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var HotKeywords=function(_Component){_inherits(HotKeywords,_Component);function HotKeywords(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HotKeywords);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HotKeywords.__proto__||Object.getPrototypeOf(HotKeywords)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this.manualFormRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this.manualTableFormRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this.state={tableData:{"current":0,//目前頁數
"page_size":10,//一頁幾筆
"total":0,//以此query條件，總共幾筆資料
"rows":[]},tableQuery:{keyword:null,category_ids:[]},message:'',keyword:'',formListAddMethod:null},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var tableQuery=_this.formRef.current.getFieldValue();//const { tableQuery } = this.state;
var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_25__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_24__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/hot-keywords',{page:page,page_size:page_size,keyword:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(tableQuery,'keyword')},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});_this.fillData(data);});},_this.submitAddHotKeyword=function(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(_this.state.formListAddMethod!=null){var formFields=_this.manualTableFormRef.current.getFieldValue();if(formFields.manual_rows.find(function(row){return row.keyword===item.keyword;})!=null){return __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('已存在於手動清單中');}_this.state.formListAddMethod({keyword:item.keyword,sort:999});}return;},_this.submitManualData=function(){var formFields=_this.manualTableFormRef.current.getFieldValue();var manualSet=_this.manualFormRef.current.getFieldValue();var manual_rows=formFields.manual_rows;var is_manual=manualSet.is_manual;console.log('is manual',is_manual);var payload=manual_rows.map(function(row,idx){return{id:row.id,keyword:row.keyword,sort:row.sort};});__WEBPACK_IMPORTED_MODULE_25__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_24__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/hot-keywords',{keywords:payload,is_manual:is_manual},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('儲存成功');_this.setState({tableData:data});_this.fillData(data);});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.manualTableFormRef.current)return;_this.manualTableFormRef.current.setFieldsValue(data);if(!_this.manualFormRef.current)return;_this.manualFormRef.current.setFieldsValue(data);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HotKeywords,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}// 拉Table資料
// 手動新增熱門關鍵字
// 保存資料
},{key:'render',value:function render(){var _this2=this;var _state=this.state,_state$tableQuery=_state.tableQuery,tableQuery=_state$tableQuery===undefined?{}:_state$tableQuery,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var _props$app$options$fi=this.props.app.options.fields,optionFields=_props$app$options$fi===undefined?[]:_props$app$options$fi;var permissions=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_react_router_dom__["b" /* Link */],{to:'/hotkeywords'},'\u71B1\u9580\u95DC\u9375\u5B57'))),wp.element.createElement('h2',null,'\u71B1\u9580\u95DC\u9375\u5B57'),wp.element.createElement('p',null),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{className:'auto-block col_12'},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a,{ref:this.formRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(FormItem,Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('keyword','關鍵字查詢'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{onClick:function onClick(event){_this2.formRef.current.resetFields();_this2.setState({tableQuery:{}});_this2.loadData();}},'\u53D6\u6D88'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_SearchOutlined___default.a,null),onClick:function onClick(event){return _this2.loadData();}},'\u641C\u5C0B')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u71B1\u9580\u95DC\u9375\u5B57\u5217\u8868(\u81EA\u52D5)',wp.element.createElement('span',null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a,{dataSource:tableData.auto_rows,loading:this.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'keyword',title:'名稱'},{dataIndex:'sort',title:'排序'},{dataIndex:'total',title:'查詢次數'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a,{dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PlusCircleOutlined___default.a,null),loading:record.isAddManual===true,onClick:function onClick(){_this2.submitAddHotKeyword(record);}},'\u52A0\u5165\u624B\u52D5\u6E05\u55AE')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item,null,item);}});}}]})),wp.element.createElement('div',{className:'manual-block col_12'},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a,{ref:this.manualFormRef},wp.element.createElement('div',{className:'flexBox col_12'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])('is_manual','熱門關鍵字狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_switch___default.a,{checkedChildren:'\u624B\u52D5',unCheckedChildren:'\u81EA\u52D5'}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,{style:{textAlign:'right'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},onClick:function onClick(){return _this2.submitManualData();}},'\u5132\u5B58')))),wp.element.createElement('div',{className:'toolbar'},wp.element.createElement('h3',null,'\u71B1\u9580\u95DC\u9375\u5B57\u5217\u8868(\u624B\u52D5)',wp.element.createElement('span',null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a,{ref:this.manualTableFormRef},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.List,{name:'manual_rows'},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;setTimeout(function(){_this2.setState({formListAddMethod:add});},1000);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return idx+1;}},{dataIndex:'keyword',title:'名稱',render:function render(page,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'keyword']),{rules:[{required:true,message:'必填'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,null));}},{dataIndex:'sort',title:'排序',render:function render(indexName,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_29_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'sort']),{rules:[{required:true,message:'必填'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,null));}},{dataIndex:'action',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{htmlType:'button',onClick:function onClick(){return add();}},'\u65B0\u589E')));})))));}}]);return HotKeywords;}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOpenCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_typeof__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Portal__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dom_canUseDom__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__switchScrollingEffect__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__setStyle__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Dom_scrollLocker__ = __webpack_require__(1726);







/* eslint-disable no-underscore-dangle,react/require-default-props */







var openCount = 0;
var supportDom = Object(__WEBPACK_IMPORTED_MODULE_10__Dom_canUseDom__["a" /* default */])();

/** @private Test usage only */
function getOpenCount() {
  return  false ? openCount : 0;
}

// https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332
var cacheOverflow = {};
var getParent = function getParent(getContainer) {
  if (!supportDom) {
    return null;
  }
  if (getContainer) {
    if (typeof getContainer === 'string') {
      return document.querySelectorAll(getContainer)[0];
    }
    if (typeof getContainer === 'function') {
      return getContainer();
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_typeof__["a" /* default */])(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
      return getContainer;
    }
  }
  return document.body;
};
var PortalWrapper = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(PortalWrapper, _React$Component);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(PortalWrapper);
  function PortalWrapper(props) {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PortalWrapper);
    _this = _super.call(this, props);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "container", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "componentRef", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createRef"]());
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "rafId", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "scrollLocker", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "renderComponent", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateScrollLocker", function (prevProps) {
      var _ref = prevProps || {},
        prevVisible = _ref.visible;
      var _this$props = _this.props,
        getContainer = _this$props.getContainer,
        visible = _this$props.visible;
      if (visible && visible !== prevVisible && supportDom && getParent(getContainer) !== _this.scrollLocker.getContainer()) {
        _this.scrollLocker.reLock({
          container: getParent(getContainer)
        });
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "updateOpenCount", function (prevProps) {
      var _ref2 = prevProps || {},
        prevVisible = _ref2.visible,
        prevGetContainer = _ref2.getContainer;
      var _this$props2 = _this.props,
        visible = _this$props2.visible,
        getContainer = _this$props2.getContainer;

      // Update count
      if (visible !== prevVisible && supportDom && getParent(getContainer) === document.body) {
        if (visible && !prevVisible) {
          openCount += 1;
        } else if (prevProps) {
          openCount -= 1;
        }
      }

      // Clean up container if needed
      var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';
      if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
        _this.removeCurrentContainer();
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "attachToParent", function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (force || _this.container && !_this.container.parentNode) {
        var parent = getParent(_this.props.getContainer);
        if (parent) {
          parent.appendChild(_this.container);
          return true;
        }
        return false;
      }
      return true;
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "getContainer", function () {
      if (!supportDom) {
        return null;
      }
      if (!_this.container) {
        _this.container = document.createElement('div');
        _this.attachToParent(true);
      }
      _this.setWrapperClassName();
      return _this.container;
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "setWrapperClassName", function () {
      var wrapperClassName = _this.props.wrapperClassName;
      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "removeCurrentContainer", function () {
      var _this$container, _this$container$paren;
      // Portal will remove from `parentNode`.
      // Let's handle this again to avoid refactor issue.
      (_this$container = _this.container) === null || _this$container === void 0 ? void 0 : (_this$container$paren = _this$container.parentNode) === null || _this$container$paren === void 0 ? void 0 : _this$container$paren.removeChild(_this.container);
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "switchScrollingEffect", function () {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        Object(__WEBPACK_IMPORTED_MODULE_11__switchScrollingEffect__["a" /* default */])();
        // Must be set after switchScrollingEffect
        cacheOverflow = Object(__WEBPACK_IMPORTED_MODULE_12__setStyle__["a" /* default */])({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!openCount) {
        Object(__WEBPACK_IMPORTED_MODULE_12__setStyle__["a" /* default */])(cacheOverflow);
        cacheOverflow = {};
        Object(__WEBPACK_IMPORTED_MODULE_11__switchScrollingEffect__["a" /* default */])(true);
      }
    });
    _this.scrollLocker = new __WEBPACK_IMPORTED_MODULE_13__Dom_scrollLocker__["a" /* default */]({
      container: getParent(props.getContainer)
    });
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(PortalWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.updateOpenCount();
      if (!this.attachToParent()) {
        this.rafId = Object(__WEBPACK_IMPORTED_MODULE_8__raf__["a" /* default */])(function () {
          _this2.forceUpdate();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateOpenCount(prevProps);
      this.updateScrollLocker(prevProps);
      this.setWrapperClassName();
      this.attachToParent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        visible = _this$props3.visible,
        getContainer = _this$props3.getContainer;
      if (supportDom && getParent(getContainer) === document.body) {
        // 离开时不会 render， 导到离开时数值不变，改用 func 。。
        openCount = visible && openCount ? openCount - 1 : openCount;
      }
      this.removeCurrentContainer();
      __WEBPACK_IMPORTED_MODULE_8__raf__["a" /* default */].cancel(this.rafId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        forceRender = _this$props4.forceRender,
        visible = _this$props4.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect,
        scrollLocker: this.scrollLocker
      };
      if (forceRender || visible || this.componentRef.current) {
        portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Portal__["a" /* default */], {
          getContainer: this.getContainer,
          ref: this.componentRef
        }, children(childProps));
      }
      return portal;
    }
  }]);
  return PortalWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (PortalWrapper);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(492);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotionName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUUID;
/* harmony export (immutable) */ __webpack_exports__["c"] = offset;
// =============================== Motion ===============================
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;

  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }

  return motionName;
} // ================================ UUID ================================

var uuid = -1;
function getUUID() {
  uuid += 1;
  return uuid;
} // =============================== Offset ===============================

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }

  return ret;
}

function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Modal = _interopRequireDefault(__webpack_require__(412));

var _ActionButton = _interopRequireDefault(__webpack_require__(1737));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _configProvider = _interopRequireDefault(__webpack_require__(8));

var ConfirmDialog = function ConfirmDialog(props) {
  var icon = props.icon,
      onCancel = props.onCancel,
      onOk = props.onOk,
      close = props.close,
      zIndex = props.zIndex,
      afterClose = props.afterClose,
      visible = props.visible,
      keyboard = props.keyboard,
      centered = props.centered,
      getContainer = props.getContainer,
      maskStyle = props.maskStyle,
      okText = props.okText,
      okButtonProps = props.okButtonProps,
      cancelText = props.cancelText,
      cancelButtonProps = props.cancelButtonProps,
      direction = props.direction,
      prefixCls = props.prefixCls,
      rootPrefixCls = props.rootPrefixCls,
      bodyStyle = props.bodyStyle,
      _props$closable = props.closable,
      closable = _props$closable === void 0 ? false : _props$closable,
      closeIcon = props.closeIcon,
      modalRender = props.modalRender,
      focusTriggerAfterClose = props.focusTriggerAfterClose;
  (0, _devWarning["default"])(!(typeof icon === 'string' && icon.length > 2), 'Modal', "`icon` is using ReactNode instead of string naming in v4. Please check `".concat(icon, "` at https://ant.design/components/icon")); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon

  var okType = props.okType || 'primary';
  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

  var okCancel = 'okCancel' in props ? props.okCancel : true;
  var width = props.width || 416;
  var style = props.style || {};
  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为

  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
  var transitionName = props.transitionName || 'zoom';
  var maskTransitionName = props.maskTransitionName || 'fade';
  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), (0, _defineProperty2["default"])({}, "".concat(contentPrefixCls, "-rtl"), direction === 'rtl'), props.className);
  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
    actionFn: onCancel,
    closeModal: close,
    autoFocus: autoFocusButton === 'cancel',
    buttonProps: cancelButtonProps,
    prefixCls: "".concat(rootPrefixCls, "-btn")
  }, cancelText);
  return /*#__PURE__*/React.createElement(_Modal["default"], {
    prefixCls: prefixCls,
    className: classString,
    wrapClassName: (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
    onCancel: function onCancel() {
      return close({
        triggerCancel: true
      });
    },
    visible: visible,
    title: "",
    transitionName: transitionName,
    footer: "",
    maskTransitionName: maskTransitionName,
    mask: mask,
    maskClosable: maskClosable,
    maskStyle: maskStyle,
    style: style,
    width: width,
    zIndex: zIndex,
    afterClose: afterClose,
    keyboard: keyboard,
    centered: centered,
    getContainer: getContainer,
    closable: closable,
    closeIcon: closeIcon,
    modalRender: modalRender,
    focusTriggerAfterClose: focusTriggerAfterClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body-wrapper")
  }, /*#__PURE__*/React.createElement(_configProvider["default"], {
    prefixCls: rootPrefixCls
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-body"),
    style: bodyStyle
  }, icon, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
    className: "".concat(contentPrefixCls, "-title")
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-content")
  }, props.content))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(contentPrefixCls, "-btns")
  }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
    type: okType,
    actionFn: onOk,
    closeModal: close,
    autoFocus: autoFocusButton === 'ok',
    buttonProps: okButtonProps,
    prefixCls: "".concat(rootPrefixCls, "-btn")
  }, okText))));
};

var _default = ConfirmDialog;
exports["default"] = _default;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = confirm;
exports.withWarn = withWarn;
exports.withInfo = withInfo;
exports.withSuccess = withSuccess;
exports.withError = withError;
exports.withConfirm = withConfirm;
exports.globalConfig = globalConfig;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(52));

var _InfoCircleOutlined = _interopRequireDefault(__webpack_require__(349));

var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(345));

var _CloseCircleOutlined = _interopRequireDefault(__webpack_require__(346));

var _ExclamationCircleOutlined = _interopRequireDefault(__webpack_require__(347));

var _locale = __webpack_require__(333);

var _Modal = __webpack_require__(412);

var _ConfirmDialog = _interopRequireDefault(__webpack_require__(749));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var defaultRootPrefixCls = 'ant';

function getRootPrefixCls() {
  return defaultRootPrefixCls;
}

function confirm(config) {
  var div = document.createElement('div');
  document.body.appendChild(div); // eslint-disable-next-line @typescript-eslint/no-use-before-define

  var currentConfig = (0, _extends2["default"])((0, _extends2["default"])({}, config), {
    close: close,
    visible: true
  });

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < _Modal.destroyFns.length; i++) {
      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line @typescript-eslint/no-use-before-define

      if (fn === close) {
        _Modal.destroyFns.splice(i, 1);

        break;
      }
    }
  }

  function render(_a) {
    var okText = _a.okText,
        cancelText = _a.cancelText,
        prefixCls = _a.prefixCls,
        props = __rest(_a, ["okText", "cancelText", "prefixCls"]);
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */


    setTimeout(function () {
      var runtimeLocale = (0, _locale.getConfirmLocale)();
      ReactDOM.render( /*#__PURE__*/React.createElement(_ConfirmDialog["default"], (0, _extends2["default"])({}, props, {
        prefixCls: prefixCls || "".concat(getRootPrefixCls(), "-modal"),
        rootPrefixCls: getRootPrefixCls(),
        okText: okText || (props.okCancel ? runtimeLocale.okText : runtimeLocale.justOkText),
        cancelText: cancelText || runtimeLocale.cancelText
      })), div);
    });
  }

  function close() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    currentConfig = (0, _extends2["default"])((0, _extends2["default"])({}, currentConfig), {
      visible: false,
      afterClose: function afterClose() {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }

        destroy.apply(_this, args);
      }
    });
    render(currentConfig);
  }

  function update(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = (0, _extends2["default"])((0, _extends2["default"])({}, currentConfig), configUpdate);
    }

    render(currentConfig);
  }

  render(currentConfig);

  _Modal.destroyFns.push(close);

  return {
    destroy: close,
    update: update
  };
}

function withWarn(props) {
  return (0, _extends2["default"])({
    type: 'warning',
    icon: /*#__PURE__*/React.createElement(_ExclamationCircleOutlined["default"], null),
    okCancel: false
  }, props);
}

function withInfo(props) {
  return (0, _extends2["default"])({
    type: 'info',
    icon: /*#__PURE__*/React.createElement(_InfoCircleOutlined["default"], null),
    okCancel: false
  }, props);
}

function withSuccess(props) {
  return (0, _extends2["default"])({
    type: 'success',
    icon: /*#__PURE__*/React.createElement(_CheckCircleOutlined["default"], null),
    okCancel: false
  }, props);
}

function withError(props) {
  return (0, _extends2["default"])({
    type: 'error',
    icon: /*#__PURE__*/React.createElement(_CloseCircleOutlined["default"], null),
    okCancel: false
  }, props);
}

function withConfirm(props) {
  return (0, _extends2["default"])({
    type: 'confirm',
    icon: /*#__PURE__*/React.createElement(_ExclamationCircleOutlined["default"], null),
    okCancel: true
  }, props);
}

function globalConfig(_ref) {
  var rootPrefixCls = _ref.rootPrefixCls;

  if (rootPrefixCls) {
    defaultRootPrefixCls = rootPrefixCls;
  }
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _PictureOutlined = _interopRequireDefault(__webpack_require__(1739));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PictureOutlined = function PictureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _PictureOutlined.default
  }));
};
PictureOutlined.displayName = 'PictureOutlined';
var _default = /*#__PURE__*/React.forwardRef(PictureOutlined);
exports.default = _default;

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(753);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1745);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HandlerRole;
(function (HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole = exports.HandlerRole || (exports.HandlerRole = {}));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) {
        return targetType === null;
    }
    return Array.isArray(targetType)
        ? targetType.some(function (t) { return t === draggedItemType; })
        : targetType === draggedItemType;
}
exports.default = matchesType;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.strictEquality = function (a, b) { return a === b; };
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */
function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) {
        return true;
    }
    else if (!offsetA || !offsetB) {
        return false;
    }
    else {
        return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
    }
}
exports.areCoordsEqual = areCoordsEqual;
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */
function areArraysEqual(a, b, isEqual) {
    if (isEqual === void 0) { isEqual = exports.strictEquality; }
    if (a.length !== b.length) {
        return false;
    }
    for (var i = 0; i < a.length; ++i) {
        if (!isEqual(a[i], b[i])) {
            return false;
        }
    }
    return true;
}
exports.areArraysEqual = areArraysEqual;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discount_lodash_1 = __webpack_require__(193);
exports.NONE = [];
exports.ALL = [];
exports.NONE.__IS_NONE__ = true;
exports.ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */
function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === exports.NONE) {
        return false;
    }
    if (dirtyIds === exports.ALL || typeof handlerIds === 'undefined') {
        return true;
    }
    var commonIds = discount_lodash_1.intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}
exports.areDirty = areDirty;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var DragDropContext_1 = __webpack_require__(301);
var disposables_1 = __webpack_require__(1785);
var isRefable_1 = __webpack_require__(417);
var discount_lodash_1 = __webpack_require__(153);
var invariant = __webpack_require__(25);
var hoistStatics = __webpack_require__(418);
var shallowEqual = __webpack_require__(96);
function decorateHandler(_a) {
    var DecoratedComponent = _a.DecoratedComponent, createHandler = _a.createHandler, createMonitor = _a.createMonitor, createConnector = _a.createConnector, registerHandler = _a.registerHandler, containerDisplayName = _a.containerDisplayName, getType = _a.getType, collect = _a.collect, options = _a.options;
    var _b = options.arePropsEqual, arePropsEqual = _b === void 0 ? shallowEqual : _b;
    var Decorated = DecoratedComponent;
    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
    var DragDropContainer = /** @class */ (function (_super) {
        __extends(DragDropContainer, _super);
        function DragDropContainer(props) {
            var _this = _super.call(this, props) || this;
            _this.decoratedRef = React.createRef();
            _this.handleChange = function () {
                var nextState = _this.getCurrentState();
                if (!shallowEqual(nextState, _this.state)) {
                    _this.setState(nextState);
                }
            };
            _this.disposable = new disposables_1.SerialDisposable();
            _this.receiveProps(props);
            _this.dispose();
            return _this;
        }
        DragDropContainer.prototype.getHandlerId = function () {
            return this.handlerId;
        };
        DragDropContainer.prototype.getDecoratedComponentInstance = function () {
            invariant(this.decoratedRef.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
            return this.decoratedRef.current;
        };
        DragDropContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
            return (!arePropsEqual(nextProps, this.props) ||
                !shallowEqual(nextState, this.state));
        };
        DragDropContainer.prototype.componentDidMount = function () {
            this.disposable = new disposables_1.SerialDisposable();
            this.currentType = undefined;
            this.receiveProps(this.props);
            this.handleChange();
        };
        DragDropContainer.prototype.componentDidUpdate = function (prevProps) {
            if (!arePropsEqual(this.props, prevProps)) {
                this.receiveProps(this.props);
                this.handleChange();
            }
        };
        DragDropContainer.prototype.componentWillUnmount = function () {
            this.dispose();
        };
        DragDropContainer.prototype.receiveProps = function (props) {
            if (!this.handler) {
                return;
            }
            this.handler.receiveProps(props);
            this.receiveType(getType(props));
        };
        DragDropContainer.prototype.receiveType = function (type) {
            if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
                return;
            }
            if (type === this.currentType) {
                return;
            }
            this.currentType = type;
            var _a = registerHandler(type, this.handler, this.manager), handlerId = _a[0], unregister = _a[1];
            this.handlerId = handlerId;
            this.handlerMonitor.receiveHandlerId(handlerId);
            this.handlerConnector.receiveHandlerId(handlerId);
            var globalMonitor = this.manager.getMonitor();
            var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
            this.disposable.setDisposable(new disposables_1.CompositeDisposable(new disposables_1.Disposable(unsubscribe), new disposables_1.Disposable(unregister)));
        };
        DragDropContainer.prototype.dispose = function () {
            this.disposable.dispose();
            if (this.handlerConnector) {
                this.handlerConnector.receiveHandlerId(null);
            }
        };
        DragDropContainer.prototype.getCurrentState = function () {
            if (!this.handlerConnector) {
                return {};
            }
            var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);
            if (false) {
                invariant(discount_lodash_1.isPlainObject(nextState), 'Expected `collect` specified as the second argument to ' +
                    '%s for %s to return a plain object of props to inject. ' +
                    'Instead, received %s.', containerDisplayName, displayName, nextState);
            }
            return nextState;
        };
        DragDropContainer.prototype.render = function () {
            var _this = this;
            return (React.createElement(DragDropContext_1.Consumer, null, function (_a) {
                var dragDropManager = _a.dragDropManager;
                _this.receiveDragDropManager(dragDropManager);
                if (typeof requestAnimationFrame !== 'undefined') {
                    requestAnimationFrame(function () { return _this.handlerConnector.reconnect(); });
                }
                return (React.createElement(Decorated, __assign({}, _this.props, _this.getCurrentState(), { 
                    // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
                    ref: isRefable_1.isRefable(Decorated) ? _this.decoratedRef : null })));
            }));
        };
        DragDropContainer.prototype.receiveDragDropManager = function (dragDropManager) {
            if (this.manager !== undefined) {
                return;
            }
            invariant(dragDropManager !== undefined, 'Could not find the drag and drop manager in the context of %s. ' +
                'Make sure to wrap the top-level component of your app with DragDropContext. ' +
                'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
            if (dragDropManager === undefined) {
                return;
            }
            this.manager = dragDropManager;
            this.handlerMonitor = createMonitor(dragDropManager);
            this.handlerConnector = createConnector(dragDropManager.getBackend());
            this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
        };
        DragDropContainer.DecoratedComponent = DecoratedComponent;
        DragDropContainer.displayName = containerDisplayName + "(" + displayName + ")";
        return DragDropContainer;
    }(React.Component));
    return hoistStatics(DragDropContainer, DecoratedComponent);
}
exports.default = decorateHandler;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    return [sourceId, function () { return registry.removeSource(sourceId); }];
}
exports.default = registerSource;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getDecoratedComponent(instanceRef) {
    var currentRef = instanceRef.current;
    if (currentRef == null) {
        return null;
    }
    else if (currentRef.decoratedRef) {
        // go through the private field in decorateHandler to avoid the invariant hit
        return currentRef.decoratedRef.current;
    }
    else {
        return currentRef;
    }
}
exports.getDecoratedComponent = getDecoratedComponent;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var invariant = __webpack_require__(25);
var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl = /** @class */ (function () {
    function DragSourceMonitorImpl(manager) {
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
    DragSourceMonitorImpl.prototype.receiveHandlerId = function (sourceId) {
        this.sourceId = sourceId;
    };
    DragSourceMonitorImpl.prototype.getHandlerId = function () {
        return this.sourceId;
    };
    DragSourceMonitorImpl.prototype.canDrag = function () {
        invariant(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        }
        finally {
            isCallingCanDrag = false;
        }
    };
    DragSourceMonitorImpl.prototype.isDragging = function () {
        if (!this.sourceId) {
            return false;
        }
        invariant(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
        try {
            isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        }
        finally {
            isCallingIsDragging = false;
        }
    };
    DragSourceMonitorImpl.prototype.subscribeToStateChange = function (listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    };
    DragSourceMonitorImpl.prototype.isDraggingSource = function (sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    };
    DragSourceMonitorImpl.prototype.isOverTarget = function (targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    };
    DragSourceMonitorImpl.prototype.getTargetIds = function () {
        return this.internalMonitor.getTargetIds();
    };
    DragSourceMonitorImpl.prototype.isSourcePublic = function () {
        return this.internalMonitor.isSourcePublic();
    };
    DragSourceMonitorImpl.prototype.getSourceId = function () {
        return this.internalMonitor.getSourceId();
    };
    DragSourceMonitorImpl.prototype.subscribeToOffsetChange = function (listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    };
    DragSourceMonitorImpl.prototype.canDragSource = function (sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    };
    DragSourceMonitorImpl.prototype.canDropOnTarget = function (targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    };
    DragSourceMonitorImpl.prototype.getItemType = function () {
        return this.internalMonitor.getItemType();
    };
    DragSourceMonitorImpl.prototype.getItem = function () {
        return this.internalMonitor.getItem();
    };
    DragSourceMonitorImpl.prototype.getDropResult = function () {
        return this.internalMonitor.getDropResult();
    };
    DragSourceMonitorImpl.prototype.didDrop = function () {
        return this.internalMonitor.didDrop();
    };
    DragSourceMonitorImpl.prototype.getInitialClientOffset = function () {
        return this.internalMonitor.getInitialClientOffset();
    };
    DragSourceMonitorImpl.prototype.getInitialSourceClientOffset = function () {
        return this.internalMonitor.getInitialSourceClientOffset();
    };
    DragSourceMonitorImpl.prototype.getSourceClientOffset = function () {
        return this.internalMonitor.getSourceClientOffset();
    };
    DragSourceMonitorImpl.prototype.getClientOffset = function () {
        return this.internalMonitor.getClientOffset();
    };
    DragSourceMonitorImpl.prototype.getDifferenceFromInitialOffset = function () {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    };
    return DragSourceMonitorImpl;
}());
exports.default = DragSourceMonitorImpl;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var wrapConnectorHooks_1 = __webpack_require__(763);
var isRef_1 = __webpack_require__(764);
var shallowEqual = __webpack_require__(96);
var SourceConnector = /** @class */ (function () {
    function SourceConnector(backend) {
        var _this = this;
        this.backend = backend;
        this.hooks = wrapConnectorHooks_1.default({
            dragSource: function (node, options) {
                _this.dragSourceOptions = options || null;
                if (isRef_1.isRef(node)) {
                    _this.dragSourceRef = node;
                }
                else {
                    _this.dragSourceNode = node;
                }
                _this.reconnectDragSource();
            },
            dragPreview: function (node, options) {
                _this.dragPreviewOptions = options || null;
                if (isRef_1.isRef(node)) {
                    _this.dragPreviewRef = node;
                }
                else {
                    _this.dragPreviewNode = node;
                }
                _this.reconnectDragPreview();
            },
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
    }
    SourceConnector.prototype.receiveHandlerId = function (newHandlerId) {
        if (this.handlerId === newHandlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    };
    Object.defineProperty(SourceConnector.prototype, "connectTarget", {
        get: function () {
            return this.dragSource;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceConnector.prototype, "dragSourceOptions", {
        get: function () {
            return this.dragSourceOptionsInternal;
        },
        set: function (options) {
            this.dragSourceOptionsInternal = options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceConnector.prototype, "dragPreviewOptions", {
        get: function () {
            return this.dragPreviewOptionsInternal;
        },
        set: function (options) {
            this.dragPreviewOptionsInternal = options;
        },
        enumerable: true,
        configurable: true
    });
    SourceConnector.prototype.reconnect = function () {
        this.reconnectDragSource();
        this.reconnectDragPreview();
    };
    SourceConnector.prototype.reconnectDragSource = function () {
        // if nothing has changed then don't resubscribe
        var didChange = this.didHandlerIdChange() ||
            this.didConnectedDragSourceChange() ||
            this.didDragSourceOptionsChange();
        if (didChange) {
            this.disconnectDragSource();
        }
        var dragSource = this.dragSource;
        if (!this.handlerId) {
            return;
        }
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
    };
    SourceConnector.prototype.reconnectDragPreview = function () {
        // if nothing has changed then don't resubscribe
        var didChange = this.didHandlerIdChange() ||
            this.didConnectedDragPreviewChange() ||
            this.didDragPreviewOptionsChange();
        if (didChange) {
            this.disconnectDragPreview();
        }
        var dragPreview = this.dragPreview;
        if (!this.handlerId || !dragPreview) {
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    };
    SourceConnector.prototype.didHandlerIdChange = function () {
        return this.lastConnectedHandlerId !== this.handlerId;
    };
    SourceConnector.prototype.didConnectedDragSourceChange = function () {
        return this.lastConnectedDragSource !== this.dragSource;
    };
    SourceConnector.prototype.didConnectedDragPreviewChange = function () {
        return this.lastConnectedDragPreview !== this.dragPreview;
    };
    SourceConnector.prototype.didDragSourceOptionsChange = function () {
        return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    };
    SourceConnector.prototype.didDragPreviewOptionsChange = function () {
        return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    };
    SourceConnector.prototype.disconnectDragSource = function () {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    };
    SourceConnector.prototype.disconnectDragPreview = function () {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    };
    Object.defineProperty(SourceConnector.prototype, "dragSource", {
        get: function () {
            return (this.dragSourceNode || (this.dragSourceRef && this.dragSourceRef.current));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceConnector.prototype, "dragPreview", {
        get: function () {
            return (this.dragPreviewNode ||
                (this.dragPreviewRef && this.dragPreviewRef.current));
        },
        enumerable: true,
        configurable: true
    });
    return SourceConnector;
}());
exports.default = SourceConnector;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var cloneWithRef_1 = __webpack_require__(1790);
__webpack_require__(1791);
function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') {
        return;
    }
    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' +
        ("You can either wrap " + displayName + " into a <div>, or turn it into a ") +
        'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return function (elementOrNode, options) {
        if (elementOrNode === void 0) { elementOrNode = null; }
        if (options === void 0) { options = null; }
        // When passed a node, call the hook straight away.
        if (!react_1.isValidElement(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        var ref = options ? function (node) { return hook(node, options); } : hook;
        return cloneWithRef_1.default(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function (key) {
        var hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) {
            wrappedHooks[key] = hooks[key];
        }
        else {
            var wrappedHook_1 = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = function () { return wrappedHook_1; };
        }
    });
    return wrappedHooks;
}
exports.default = wrapConnectorHooks;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isRef(obj) {
    return (obj !== null && typeof obj === 'object' && obj.hasOwnProperty('current'));
}
exports.isRef = isRef;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isValidType(type, allowArray) {
    return (typeof type === 'string' ||
        typeof type === 'symbol' ||
        (!!allowArray &&
            Array.isArray(type) &&
            type.every(function (t) { return isValidType(t, false); })));
}
exports.default = isValidType;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function registerTarget(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    return [targetId, function () { return registry.removeTarget(targetId); }];
}
exports.default = registerTarget;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var invariant = __webpack_require__(25);
var isCallingCanDrop = false;
var DropTargetMonitorImpl = /** @class */ (function () {
    function DropTargetMonitorImpl(manager) {
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
    DropTargetMonitorImpl.prototype.receiveHandlerId = function (targetId) {
        this.targetId = targetId;
    };
    DropTargetMonitorImpl.prototype.getHandlerId = function () {
        return this.targetId;
    };
    DropTargetMonitorImpl.prototype.subscribeToStateChange = function (listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    };
    DropTargetMonitorImpl.prototype.canDrop = function () {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) {
            return false;
        }
        invariant(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');
        try {
            isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        }
        finally {
            isCallingCanDrop = false;
        }
    };
    DropTargetMonitorImpl.prototype.isOver = function (options) {
        if (!this.targetId) {
            return false;
        }
        return this.internalMonitor.isOverTarget(this.targetId, options);
    };
    DropTargetMonitorImpl.prototype.getItemType = function () {
        return this.internalMonitor.getItemType();
    };
    DropTargetMonitorImpl.prototype.getItem = function () {
        return this.internalMonitor.getItem();
    };
    DropTargetMonitorImpl.prototype.getDropResult = function () {
        return this.internalMonitor.getDropResult();
    };
    DropTargetMonitorImpl.prototype.didDrop = function () {
        return this.internalMonitor.didDrop();
    };
    DropTargetMonitorImpl.prototype.getInitialClientOffset = function () {
        return this.internalMonitor.getInitialClientOffset();
    };
    DropTargetMonitorImpl.prototype.getInitialSourceClientOffset = function () {
        return this.internalMonitor.getInitialSourceClientOffset();
    };
    DropTargetMonitorImpl.prototype.getSourceClientOffset = function () {
        return this.internalMonitor.getSourceClientOffset();
    };
    DropTargetMonitorImpl.prototype.getClientOffset = function () {
        return this.internalMonitor.getClientOffset();
    };
    DropTargetMonitorImpl.prototype.getDifferenceFromInitialOffset = function () {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    };
    return DropTargetMonitorImpl;
}());
exports.default = DropTargetMonitorImpl;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var wrapConnectorHooks_1 = __webpack_require__(763);
var isRef_1 = __webpack_require__(764);
var shallowEqual = __webpack_require__(96);
var TargetConnector = /** @class */ (function () {
    function TargetConnector(backend) {
        var _this = this;
        this.backend = backend;
        this.hooks = wrapConnectorHooks_1.default({
            dropTarget: function (node, options) {
                _this.dropTargetOptions = options;
                if (isRef_1.isRef(node)) {
                    _this.dropTargetRef = node;
                }
                else {
                    _this.dropTargetNode = node;
                }
                _this.reconnect();
            },
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
    }
    Object.defineProperty(TargetConnector.prototype, "connectTarget", {
        get: function () {
            return this.dropTarget;
        },
        enumerable: true,
        configurable: true
    });
    TargetConnector.prototype.reconnect = function () {
        // if nothing has changed then don't resubscribe
        var didChange = this.didHandlerIdChange() ||
            this.didDropTargetChange() ||
            this.didOptionsChange();
        if (didChange) {
            this.disconnectDropTarget();
        }
        var dropTarget = this.dropTarget;
        if (!this.handlerId) {
            return;
        }
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    };
    TargetConnector.prototype.receiveHandlerId = function (newHandlerId) {
        if (newHandlerId === this.handlerId) {
            return;
        }
        this.handlerId = newHandlerId;
        this.reconnect();
    };
    Object.defineProperty(TargetConnector.prototype, "dropTargetOptions", {
        get: function () {
            return this.dropTargetOptionsInternal;
        },
        set: function (options) {
            this.dropTargetOptionsInternal = options;
        },
        enumerable: true,
        configurable: true
    });
    TargetConnector.prototype.didHandlerIdChange = function () {
        return this.lastConnectedHandlerId !== this.handlerId;
    };
    TargetConnector.prototype.didDropTargetChange = function () {
        return this.lastConnectedDropTarget !== this.dropTarget;
    };
    TargetConnector.prototype.didOptionsChange = function () {
        return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    };
    TargetConnector.prototype.disconnectDropTarget = function () {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    };
    Object.defineProperty(TargetConnector.prototype, "dropTarget", {
        get: function () {
            return (this.dropTargetNode || (this.dropTargetRef && this.dropTargetRef.current));
        },
        enumerable: true,
        configurable: true
    });
    return TargetConnector;
}());
exports.default = TargetConnector;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var useCollector_1 = __webpack_require__(770);
function useMonitorOutput(monitor, collect, onCollect) {
    var _a = useCollector_1.useCollector(monitor, collect, onCollect), collected = _a[0], updateCollected = _a[1];
    react_1.useEffect(function subscribeToMonitorStateChange() {
        var handlerId = monitor.getHandlerId();
        if (handlerId == null) {
            return undefined;
        }
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [handlerId],
        });
    }, [monitor, updateCollected]);
    return collected;
}
exports.useMonitorOutput = useMonitorOutput;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shallowEqual = __webpack_require__(96);
var react_1 = __webpack_require__(0);
/**
 *
 * @param monitor The monitor to colelct state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */
function useCollector(monitor, collect, onUpdate) {
    var _a = react_1.useState(function () { return collect(monitor); }), collected = _a[0], setCollected = _a[1];
    var updateCollected = react_1.useCallback(function () {
        var nextValue = collect(monitor);
        if (!shallowEqual(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) {
                onUpdate();
            }
        }
    }, [collected, monitor, onUpdate]);
    return [collected, updateCollected];
}
exports.useCollector = useCollector;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function memoize(fn) {
    var result = null;
    var memoized = function () {
        if (result == null) {
            result = fn();
        }
        return result;
    };
    return memoized;
}
exports.memoize = memoize;
/**
 * drop-in replacement for _.without
 */
function without(items, item) {
    return items.filter(function (i) { return i !== item; });
}
exports.without = without;
function union(itemsA, itemsB) {
    var set = new Set();
    var insertItem = function (item) { return set.add(item); };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    set.forEach(function (key) { return result.push(key); });
    return result;
}
exports.union = union;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discount_lodash_1 = __webpack_require__(771);
exports.isFirefox = discount_lodash_1.memoize(function () {
    return /firefox/i.test(navigator.userAgent);
});
exports.isSafari = discount_lodash_1.memoize(function () { return Boolean(window.safari); });


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcUpload = _interopRequireDefault(__webpack_require__(1815));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Dragger = _interopRequireDefault(__webpack_require__(780));

var _UploadList = _interopRequireDefault(__webpack_require__(1837));

var _utils = __webpack_require__(781);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

var _useFreshState3 = _interopRequireDefault(__webpack_require__(1866));

var InternalUpload = function InternalUpload(props, ref) {
  var _classNames2;

  var fileListProp = props.fileList,
      defaultFileList = props.defaultFileList,
      onRemove = props.onRemove,
      showUploadList = props.showUploadList,
      listType = props.listType,
      onPreview = props.onPreview,
      onDownload = props.onDownload,
      onChange = props.onChange,
      previewFile = props.previewFile,
      disabled = props.disabled,
      propLocale = props.locale,
      iconRender = props.iconRender,
      isImageUrl = props.isImageUrl,
      progress = props.progress,
      customizePrefixCls = props.prefixCls,
      className = props.className,
      type = props.type,
      children = props.children,
      style = props.style,
      itemRender = props.itemRender,
      maxCount = props.maxCount;

  var _React$useState = React.useState('drop'),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      dragState = _React$useState2[0],
      setDragState = _React$useState2[1];

  var forceUpdate = (0, _useForceUpdate["default"])(); // Refresh always use fresh data

  var _useFreshState = (0, _useFreshState3["default"])(fileListProp || defaultFileList || [], fileListProp),
      _useFreshState2 = (0, _slicedToArray2["default"])(_useFreshState, 2),
      getFileList = _useFreshState2[0],
      setFileList = _useFreshState2[1];

  var upload = React.useRef();
  React.useEffect(function () {
    (0, _devWarning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not a valid prop, do you mean `fileList`?');
    (0, _devWarning["default"])(!('transformFile' in props), 'Upload', '`transformFile` is deprecated. Please use `beforeUpload` directly.');
  }, []);

  var onInternalChange = function onInternalChange(info) {
    var cloneList = (0, _toConsumableArray2["default"])(info.fileList); // Cut to match count

    if (maxCount === 1) {
      cloneList = cloneList.slice(-1);
    } else if (maxCount) {
      cloneList = cloneList.slice(0, maxCount);
    }

    setFileList(cloneList);
    onChange === null || onChange === void 0 ? void 0 : onChange((0, _extends2["default"])((0, _extends2["default"])({}, info), {
      fileList: cloneList
    }));
  };

  var onStart = function onStart(file) {
    var targetItem = (0, _utils.fileToObject)(file);
    targetItem.status = 'uploading';
    var nextFileList = getFileList().concat();
    var fileIndex = nextFileList.findIndex(function (_ref) {
      var uid = _ref.uid;
      return uid === targetItem.uid;
    });

    if (fileIndex === -1) {
      nextFileList.push(targetItem);
    } else {
      nextFileList[fileIndex] = targetItem;
    }

    onInternalChange({
      file: targetItem,
      fileList: nextFileList
    });
  };

  var onSuccess = function onSuccess(response, file, xhr) {
    try {
      if (typeof response === 'string') {
        response = JSON.parse(response);
      }
    } catch (e) {
      /* do nothing */
    }

    var targetItem = (0, _utils.getFileItem)(file, getFileList()); // removed

    if (!targetItem) {
      return;
    }

    targetItem.status = 'done';
    targetItem.response = response;
    targetItem.xhr = xhr;
    onInternalChange({
      file: (0, _extends2["default"])({}, targetItem),
      fileList: getFileList().concat()
    });
  };

  var onProgress = function onProgress(e, file) {
    var targetItem = (0, _utils.getFileItem)(file, getFileList()); // removed

    if (!targetItem) {
      return;
    }

    targetItem.percent = e.percent;
    onInternalChange({
      event: e,
      file: (0, _extends2["default"])({}, targetItem),
      fileList: getFileList().concat()
    });
  };

  var onError = function onError(error, response, file) {
    var targetItem = (0, _utils.getFileItem)(file, getFileList()); // removed

    if (!targetItem) {
      return;
    }

    targetItem.error = error;
    targetItem.response = response;
    targetItem.status = 'error';
    onInternalChange({
      file: (0, _extends2["default"])({}, targetItem),
      fileList: getFileList().concat()
    });
  };

  var handleRemove = function handleRemove(file) {
    var currentFile;
    Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
      // Prevent removing file
      if (ret === false) {
        return;
      }

      var fileList = getFileList();
      var removedFileList = (0, _utils.removeFileItem)(file, fileList);

      if (removedFileList) {
        currentFile = (0, _extends2["default"])((0, _extends2["default"])({}, file), {
          status: 'removed'
        });
        fileList === null || fileList === void 0 ? void 0 : fileList.some(function (item) {
          var matchKey = currentFile.uid !== undefined ? 'uid' : 'name';

          if (item[matchKey] === currentFile[matchKey]) {
            item.status = 'removed';
            return true;
          }

          return false;
        });

        if (upload.current) {
          upload.current.abort(currentFile);
        }

        onInternalChange({
          file: currentFile,
          fileList: removedFileList
        });
      }
    });
  };

  var onFileDrop = function onFileDrop(e) {
    setDragState(e.type);
  };

  var beforeUpload = function beforeUpload(file, fileListArgs) {
    var beforeUploadProp = props.beforeUpload;

    if (!beforeUploadProp) {
      return true;
    }

    var result = beforeUploadProp(file, fileListArgs);

    if (result === false) {
      // Get unique file list
      var uniqueList = [];
      getFileList().concat(fileListArgs.map(_utils.fileToObject)).forEach(function (f) {
        if (uniqueList.every(function (uf) {
          return uf.uid !== f.uid;
        })) {
          uniqueList.push(f);
        }
      });
      onInternalChange({
        file: file,
        fileList: uniqueList
      });
      return false;
    }

    if (result && result.then) {
      return result;
    }

    return true;
  }; // Test needs


  React.useImperativeHandle(ref, function () {
    return {
      onStart: onStart,
      onSuccess: onSuccess,
      onProgress: onProgress,
      onError: onError,
      fileList: getFileList(),
      upload: upload.current,
      forceUpdate: forceUpdate
    };
  });

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('upload', customizePrefixCls);
  var rcUploadProps = (0, _extends2["default"])((0, _extends2["default"])({
    onStart: onStart,
    onError: onError,
    onProgress: onProgress,
    onSuccess: onSuccess
  }, props), {
    prefixCls: prefixCls,
    beforeUpload: beforeUpload,
    onChange: undefined
  });
  delete rcUploadProps.className;
  delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
  // !children: https://github.com/ant-design/ant-design/issues/14298
  // disabled: https://github.com/ant-design/ant-design/issues/16478
  //           https://github.com/ant-design/ant-design/issues/24197

  if (!children || disabled) {
    delete rcUploadProps.id;
  }

  var renderUploadList = function renderUploadList(button) {
    return showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
      componentName: "Upload",
      defaultLocale: _default2["default"].Upload
    }, function (locale) {
      var _ref2 = typeof showUploadList === 'boolean' ? {} : showUploadList,
          showRemoveIcon = _ref2.showRemoveIcon,
          showPreviewIcon = _ref2.showPreviewIcon,
          showDownloadIcon = _ref2.showDownloadIcon,
          removeIcon = _ref2.removeIcon,
          downloadIcon = _ref2.downloadIcon;

      return /*#__PURE__*/React.createElement(_UploadList["default"], {
        listType: listType,
        items: getFileList(true),
        previewFile: previewFile,
        onPreview: onPreview,
        onDownload: onDownload,
        onRemove: handleRemove,
        showRemoveIcon: !disabled && showRemoveIcon,
        showPreviewIcon: showPreviewIcon,
        showDownloadIcon: showDownloadIcon,
        removeIcon: removeIcon,
        downloadIcon: downloadIcon,
        iconRender: iconRender,
        locale: (0, _extends2["default"])((0, _extends2["default"])({}, locale), propLocale),
        isImageUrl: isImageUrl,
        progress: progress,
        appendAction: button,
        itemRender: itemRender
      });
    }) : button;
  };

  if (type === 'drag') {
    var _classNames;

    var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-drag"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-drag-uploading"), getFileList().some(function (file) {
      return file.status === 'uploading';
    })), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
      className: dragCls,
      onDrop: onFileDrop,
      onDragOver: onFileDrop,
      onDragLeave: onFileDrop,
      style: style
    }, /*#__PURE__*/React.createElement(_rcUpload["default"], (0, _extends2["default"])({}, rcUploadProps, {
      ref: upload,
      className: "".concat(prefixCls, "-btn")
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-drag-container")
    }, children))), renderUploadList());
  }

  var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-select"), true), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2));
  var uploadButton = /*#__PURE__*/React.createElement("div", {
    className: uploadButtonCls,
    style: children ? undefined : {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement(_rcUpload["default"], (0, _extends2["default"])({}, rcUploadProps, {
    ref: upload
  })));

  if (listType === 'picture-card') {
    return /*#__PURE__*/React.createElement("span", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-picture-card-wrapper"), className)
    }, renderUploadList(uploadButton));
  }

  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, uploadButton, renderUploadList());
};

var Upload = /*#__PURE__*/React.forwardRef(InternalUpload);
Upload.Dragger = _Dragger["default"];
Upload.displayName = 'Upload';
Upload.defaultProps = {
  type: 'select',
  multiple: false,
  action: '',
  data: {},
  accept: '',
  beforeUpload: _utils.T,
  showUploadList: true,
  listType: 'text',
  className: '',
  disabled: false,
  supportServerRender: true
};
var _default = Upload;
exports["default"] = _default;

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(777);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1817);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1818);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1821);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _Upload = _interopRequireDefault(__webpack_require__(773));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalDragger = function InternalDragger(_a, ref) {
  var style = _a.style,
      height = _a.height,
      restProps = __rest(_a, ["style", "height"]);

  return /*#__PURE__*/React.createElement(_Upload["default"], (0, _extends2["default"])({
    ref: ref
  }, restProps, {
    type: "drag",
    style: (0, _extends2["default"])((0, _extends2["default"])({}, style), {
      height: height
    })
  }));
};

var Dragger = /*#__PURE__*/React.forwardRef(InternalDragger);
Dragger.displayName = 'Dragger';
var _default = Dragger;
exports["default"] = _default;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T = T;
exports.fileToObject = fileToObject;
exports.getFileItem = getFileItem;
exports.removeFileItem = removeFileItem;
exports.previewImage = previewImage;
exports.isImageUrl = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object


function fileToObject(file) {
  return (0, _extends2["default"])((0, _extends2["default"])({}, file), {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}

function getFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(function (item) {
    return item[matchKey] === file[matchKey];
  })[0];
}

function removeFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  var removed = fileList.filter(function (item) {
    return item[matchKey] !== file[matchKey];
  });

  if (removed.length === fileList.length) {
    return null;
  }

  return removed;
} // ==================== Default Image Preview ====================


var extname = function extname() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};

var isImageFileType = function isImageFileType(type) {
  return type.indexOf('image/') === 0;
};

var isImageUrl = function isImageUrl(file) {
  if (file.type && !file.thumbUrl) {
    return isImageFileType(file.type);
  }

  var url = file.thumbUrl || file.url;
  var extension = extname(url);

  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }

  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }

  if (extension) {
    // other file types which have extension
    return false;
  }

  return true;
};

exports.isImageUrl = isImageUrl;
var MEASURE_SIZE = 200;

function previewImage(file) {
  return new Promise(function (resolve) {
    if (!file.type || !isImageFileType(file.type)) {
      resolve('');
      return;
    }

    var canvas = document.createElement('canvas');
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var img = new Image();

    img.onload = function () {
      var width = img.width,
          height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;

      if (width > height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };

    img.src = window.URL.createObjectURL(file);
  });
}

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "geekblue", function() { return geekblue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generate", function() { return generate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gold", function() { return gold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "magenta", function() { return magenta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetDarkPalettes", function() { return presetDarkPalettes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetPalettes", function() { return presetPalettes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetPrimaryColors", function() { return presetPrimaryColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volcano", function() { return volcano; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__ = __webpack_require__(531);


var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = new __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["a" /* TinyColor */](color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = pColor.toHsv();
    var colorString = new __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["a" /* TinyColor */]({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }).toHexString();
    patterns.push(colorString);
  }

  patterns.push(pColor.toHexString());

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = pColor.toHsv();

    var _colorString = new __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["a" /* TinyColor */]({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }).toHexString();

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref) {
      var index = _ref.index,
          opacity = _ref.opacity;
      var darkColorString = new __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["a" /* TinyColor */](opts.backgroundColor || '#141414').mix(patterns[index], opacity * 100).toHexString();
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
var red = presetPalettes.red;
var volcano = presetPalettes.volcano;
var gold = presetPalettes.gold;
var orange = presetPalettes.orange;
var yellow = presetPalettes.yellow;
var lime = presetPalettes.lime;
var green = presetPalettes.green;
var cyan = presetPalettes.cyan;
var blue = presetPalettes.blue;
var geekblue = presetPalettes.geekblue;
var purple = presetPalettes.purple;
var magenta = presetPalettes.magenta;
var grey = presetPalettes.grey;




/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1862);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1863);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useTransitionDuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};
var useTransitionDuration = function useTransitionDuration(percentList) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var paths = percentList.map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  });
  var prevTimeStamp = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var now = Date.now();
    var updated = false;
    Object.keys(paths).forEach(function (key) {
      var path = paths[key].current;

      if (!path) {
        return;
      }

      updated = true;
      var pathStyle = path.style;
      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';

      if (prevTimeStamp.current && now - prevTimeStamp.current < 100) {
        pathStyle.transitionDuration = '0s, 0s';
      }
    });

    if (updated) {
      prevTimeStamp.current = Date.now();
    }
  });
  return [paths];
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1868);

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1873);

__webpack_require__(77);

__webpack_require__(1874);

__webpack_require__(1875);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _Grid = _interopRequireDefault(__webpack_require__(1876));

var _Meta = _interopRequireDefault(__webpack_require__(1877));

var _tabs = _interopRequireDefault(__webpack_require__(78));

var _row = _interopRequireDefault(__webpack_require__(1878));

var _col = _interopRequireDefault(__webpack_require__(1879));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function getAction(actions) {
  var actionList = actions.map(function (action, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        style: {
          width: "".concat(100 / actions.length, "%")
        },
        key: "action-".concat(index)
      }, /*#__PURE__*/React.createElement("span", null, action))
    );
  });
  return actionList;
}

var Card = function Card(props) {
  var _extends2, _classNames;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = React.useContext(_SizeContext["default"]);

  var onTabChange = function onTabChange(key) {
    if (props.onTabChange) {
      props.onTabChange(key);
    }
  };

  var isContainGrid = function isContainGrid() {
    var containGrid;
    React.Children.forEach(props.children, function (element) {
      if (element && element.type && element.type === _Grid["default"]) {
        containGrid = true;
      }
    });
    return containGrid;
  };

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      extra = props.extra,
      _props$headStyle = props.headStyle,
      headStyle = _props$headStyle === void 0 ? {} : _props$headStyle,
      _props$bodyStyle = props.bodyStyle,
      bodyStyle = _props$bodyStyle === void 0 ? {} : _props$bodyStyle,
      title = props.title,
      loading = props.loading,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      customizeSize = props.size,
      type = props.type,
      cover = props.cover,
      actions = props.actions,
      tabList = props.tabList,
      children = props.children,
      activeTabKey = props.activeTabKey,
      defaultActiveTabKey = props.defaultActiveTabKey,
      tabBarExtraContent = props.tabBarExtraContent,
      hoverable = props.hoverable,
      _props$tabProps = props.tabProps,
      tabProps = _props$tabProps === void 0 ? {} : _props$tabProps,
      others = __rest(props, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps"]);

  var prefixCls = getPrefixCls('card', customizePrefixCls);
  var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
    padding: 24
  } : undefined;
  var block = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-loading-block")
  });
  var loadingBlock = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-loading-content"),
    style: loadingBlockStyle
  }, /*#__PURE__*/React.createElement(_row["default"], {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_col["default"], {
    span: 22
  }, block)), /*#__PURE__*/React.createElement(_row["default"], {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_col["default"], {
    span: 8
  }, block), /*#__PURE__*/React.createElement(_col["default"], {
    span: 15
  }, block)), /*#__PURE__*/React.createElement(_row["default"], {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_col["default"], {
    span: 6
  }, block), /*#__PURE__*/React.createElement(_col["default"], {
    span: 18
  }, block)), /*#__PURE__*/React.createElement(_row["default"], {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_col["default"], {
    span: 13
  }, block), /*#__PURE__*/React.createElement(_col["default"], {
    span: 9
  }, block)), /*#__PURE__*/React.createElement(_row["default"], {
    gutter: 8
  }, /*#__PURE__*/React.createElement(_col["default"], {
    span: 4
  }, block), /*#__PURE__*/React.createElement(_col["default"], {
    span: 3
  }, block), /*#__PURE__*/React.createElement(_col["default"], {
    span: 16
  }, block)));
  var hasActiveTabKey = activeTabKey !== undefined;
  var extraProps = (0, _extends3["default"])((0, _extends3["default"])({}, tabProps), (_extends2 = {}, (0, _defineProperty2["default"])(_extends2, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), (0, _defineProperty2["default"])(_extends2, "tabBarExtraContent", tabBarExtraContent), _extends2));
  var head;
  var tabs = tabList && tabList.length ? /*#__PURE__*/React.createElement(_tabs["default"], (0, _extends3["default"])({
    size: "large"
  }, extraProps, {
    className: "".concat(prefixCls, "-head-tabs"),
    onChange: onTabChange
  }), tabList.map(function (item) {
    return /*#__PURE__*/React.createElement(_tabs["default"].TabPane, {
      tab: item.tab,
      disabled: item.disabled,
      key: item.key
    });
  })) : null;

  if (title || extra || tabs) {
    head = /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head"),
      style: headStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head-wrapper")
    }, title && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-head-title")
    }, title), extra && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-extra")
    }, extra)), tabs);
  }

  var coverDom = cover ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-cover")
  }, cover) : null;
  var body = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, loading ? loadingBlock : children);
  var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-actions")
  }, getAction(actions)) : null;
  var divProps = (0, _omit["default"])(others, ['onTabChange']);
  var mergedSize = customizeSize || size;
  var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-loading"), loading), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-bordered"), bordered), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-hoverable"), hoverable), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-contain-grid"), isContainGrid()), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
  return /*#__PURE__*/React.createElement("div", (0, _extends3["default"])({}, divProps, {
    className: classString
  }), head, coverDom, body, actionDom);
};

Card.Grid = _Grid["default"];
Card.Meta = _Meta["default"];
var _default = Card;
exports["default"] = _default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1880);

__webpack_require__(124);

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _datePicker = _interopRequireDefault(__webpack_require__(125));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalTimePicker = _datePicker["default"].TimePicker,
    InternalRangePicker = _datePicker["default"].RangePicker;
var RangePicker = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InternalRangePicker, (0, _extends2["default"])({}, props, {
    picker: "time",
    mode: undefined,
    ref: ref
  }));
});
var TimePicker = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var addon = _a.addon,
      renderExtraFooter = _a.renderExtraFooter,
      popupClassName = _a.popupClassName,
      restProps = __rest(_a, ["addon", "renderExtraFooter", "popupClassName"]);

  var internalRenderExtraFooter = React.useMemo(function () {
    if (renderExtraFooter) {
      return renderExtraFooter;
    }

    if (addon) {
      (0, _devWarning["default"])(false, 'TimePicker', '`addon` is deprecated. Please use `renderExtraFooter` instead.');
      return addon;
    }

    return undefined;
  }, [addon, renderExtraFooter]);
  return /*#__PURE__*/React.createElement(InternalTimePicker, (0, _extends2["default"])({}, restProps, {
    dropdownClassName: popupClassName,
    mode: undefined,
    ref: ref,
    renderExtraFooter: internalRenderExtraFooter
  }));
});
TimePicker.displayName = 'TimePicker';
TimePicker.RangePicker = RangePicker;
var _default = TimePicker;
exports["default"] = _default;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(63);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(793);

var _omit2 = _interopRequireDefault(_omit);

var _shallowEqual = __webpack_require__(794);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// utils


var mainStyle = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var style = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  backgroundColor: 'transparent',
  position: 'absolute'
};

var GoogleMapMarkers = function (_Component) {
  _inherits(GoogleMapMarkers, _Component);

  /* eslint-disable react/forbid-prop-types */
  function GoogleMapMarkers(props) {
    _classCallCheck(this, GoogleMapMarkers);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getState = function () {
      return {
        children: _this.props.dispatcher.getChildren(),
        updateCounter: _this.props.dispatcher.getUpdateCounter()
      };
    };

    _this._onChangeHandler = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var prevChildCount = (_this.state.children || []).length;
      var state = _this._getState();

      _this.setState(state, function () {
        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
      });
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // click works only on hovered item
          _this.props.onChildClick(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseDown = function () {
      if (_this.props.onChildMouseDown) {
        if (_this.hoverChildProps_) {
          var hoverKey = _this.hoverKey_;
          var childProps = _this.hoverChildProps_;
          // works only on hovered item
          _this.props.onChildMouseDown(hoverKey, childProps);
        }
      }
    };

    _this._onChildMouseEnter = function (hoverKey, childProps) {
      if (!_this.dimensionsCache_) {
        return;
      }

      if (_this.props.onChildMouseEnter) {
        _this.props.onChildMouseEnter(hoverKey, childProps);
      }

      _this.hoverChildProps_ = childProps;
      _this.hoverKey_ = hoverKey;
      _this.setState({ hoverKey: hoverKey });
    };

    _this._onChildMouseLeave = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var hoverKey = _this.hoverKey_;
      var childProps = _this.hoverChildProps_;

      if (hoverKey !== undefined && hoverKey !== null) {
        if (_this.props.onChildMouseLeave) {
          _this.props.onChildMouseLeave(hoverKey, childProps);
        }

        _this.hoverKey_ = null;
        _this.hoverChildProps_ = null;
        _this.setState({ hoverKey: null });
      }
    };

    _this._onMouseAllow = function (value) {
      if (!value) {
        _this._onChildMouseLeave();
      }

      _this.allowMouse_ = value;
    };

    _this._onMouseChangeHandler = function () {
      if (_this.allowMouse_) {
        _this._onMouseChangeHandlerRaf();
      }
    };

    _this._onMouseChangeHandlerRaf = function () {
      if (!_this.dimensionsCache_) {
        return;
      }

      var mp = _this.props.dispatcher.getMousePosition();

      if (mp) {
        var distances = [];
        var hoverDistance = _this.props.getHoverDistance();

        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
          if (!child) return;
          // layers
          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
            return;
          }

          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
          var dist = _this.props.distanceToMouse(_this.dimensionsCache_[childKey], mp, child.props);
          if (dist < hoverDistance) {
            distances.push({
              key: childKey,
              dist: dist,
              props: child.props
            });
          }
        });

        if (distances.length) {
          distances.sort(function (a, b) {
            return a.dist - b.dist;
          });
          var hoverKey = distances[0].key;
          var childProps = distances[0].props;

          if (_this.hoverKey_ !== hoverKey) {
            _this._onChildMouseLeave();

            _this._onChildMouseEnter(hoverKey, childProps);
          }
        } else {
          _this._onChildMouseLeave();
        }
      } else {
        _this._onChildMouseLeave();
      }
    };

    _this._getDimensions = function (key) {
      var childKey = key;
      return _this.dimensionsCache_[childKey];
    };

    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);

    _this.dimensionsCache_ = {};
    _this.hoverKey_ = null;
    _this.hoverChildProps_ = null;
    _this.allowMouse_ = true;

    _this.state = _extends({}, _this._getState(), { hoverKey: null });
    return _this;
  }
  /* eslint-enable react/forbid-prop-types */

  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.experimental === true) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
    }

    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);

    this.dimensionsCache_ = null;
  };

  GoogleMapMarkers.prototype.render = function render() {
    var _this2 = this;

    var mainElementStyle = this.props.style || mainStyle;
    this.dimensionsCache_ = {};

    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
      if (!child) return undefined;
      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
        return _react2.default.cloneElement(child, {
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        });
      }

      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };

      var pt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(latLng) : _this2.props.geoService.fromLatLngToCenterPixel(latLng);

      var stylePtPos = {
        left: pt.x,
        top: pt.y
      };

      // If the component has a southeast corner defined (either as a LatLng, or a separate
      // lat and lng pair), set the width and height based on the distance between the northwest
      // and the southeast corner to lock the overlay to the correct geographic bounds.
      if (child.props.seLatLng !== undefined || child.props.seLat !== undefined && child.props.seLng !== undefined) {
        var seLatLng = child.props.seLatLng !== undefined ? child.props.seLatLng : { lat: child.props.seLat, lng: child.props.seLng };

        var sePt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(seLatLng) : _this2.props.geoService.fromLatLngToCenterPixel(seLatLng);

        stylePtPos.width = sePt.x - pt.x;
        stylePtPos.height = sePt.y - pt.y;
      }

      var containerPt = _this2.props.geoService.fromLatLngToContainerPixel(latLng);

      // to prevent rerender on child element i need to pass
      // const params $getDimensions and $dimensionKey instead of dimension object
      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;

      _this2.dimensionsCache_[childKey] = _extends({
        x: containerPt.x,
        y: containerPt.y
      }, latLng);

      return _react2.default.createElement(
        'div',
        {
          key: childKey,
          style: _extends({}, style, stylePtPos),
          className: child.props.$markerHolderClassName
        },
        _react2.default.cloneElement(child, {
          $hover: childKey === _this2.state.hoverKey,
          $getDimensions: _this2._getDimensions,
          $dimensionKey: childKey,
          $geoService: _this2.props.geoService,
          $onMouseAllow: _this2._onMouseAllow,
          $prerender: _this2.props.prerender
        })
      );
    });

    return _react2.default.createElement(
      'div',
      { style: mainElementStyle },
      markers
    );
  };

  return GoogleMapMarkers;
}(_react.Component);

GoogleMapMarkers.propTypes = {
  geoService: _propTypes2.default.any,
  style: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  dispatcher: _propTypes2.default.any,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  getHoverDistance: _propTypes2.default.func,
  insideMapPanes: _propTypes2.default.bool,
  prerender: _propTypes2.default.bool
};
GoogleMapMarkers.defaultProps = {
  insideMapPanes: false,
  prerender: false
};
exports.default = GoogleMapMarkers;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
var omit = function omit(obj, keys) {
  var rest = _objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key in rest) {
      delete rest[key];
    }
  }
  return rest;
};

exports.default = omit;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  // eslint-disable-next-line no-self-compare
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;
/* src: https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js */

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _wrap2 = __webpack_require__(797);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = function () {
  function LatLng(lat, lng) {
    _classCallCheck(this, LatLng);

    if (isNaN(lat) || isNaN(lng)) {
      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
    }
    this.lat = +lat;
    this.lng = +lng;
  }

  LatLng.prototype.wrap = function wrap() {
    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
  };

  return LatLng;
}();

LatLng.convert = function (a) {
  if (a instanceof LatLng) {
    return a;
  }

  if (Array.isArray(a)) {
    return new LatLng(a[0], a[1]);
  }

  if ('lng' in a && 'lat' in a) {
    return new LatLng(a.lat, a.lng);
  }

  return a;
};

exports.default = LatLng;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addPassiveEventListener;
// feature detection for passive support
// see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
function hasPassiveSupport() {
  var passiveSupported = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
}

function addPassiveEventListener(element, eventName, func, capture) {
  element.addEventListener(eventName, func, hasPassiveSupport() ? {
    capture: capture,
    passive: true
  } : capture);
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1900);

__webpack_require__(206);

__webpack_require__(30);

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(203));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcCascader = _interopRequireDefault(__webpack_require__(1901));

var _arrayTreeFilter = _interopRequireDefault(__webpack_require__(425));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _KeyCode = _interopRequireDefault(__webpack_require__(721));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _DownOutlined = _interopRequireDefault(__webpack_require__(216));

var _RightOutlined = _interopRequireDefault(__webpack_require__(267));

var _RedoOutlined = _interopRequireDefault(__webpack_require__(1921));

var _LeftOutlined = _interopRequireDefault(__webpack_require__(360));

var _input = _interopRequireDefault(__webpack_require__(31));

var _configProvider = __webpack_require__(8);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// We limit the filtered item count by default
var defaultLimit = 50; // keep value when filtering

var keepFilteredValueField = '__KEEP_FILTERED_OPTION_VALUE';

function highlightKeyword(str, keyword, prefixCls) {
  return str.split(keyword).map(function (node, index) {
    return index === 0 ? node : [/*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-menu-item-keyword"),
      key: "seperator"
    }, keyword), node];
  });
}

function defaultFilterOption(inputValue, path, names) {
  return path.some(function (option) {
    return option[names.label].indexOf(inputValue) > -1;
  });
}

function defaultRenderFilteredOption(inputValue, path, prefixCls, names) {
  return path.map(function (option, index) {
    var label = option[names.label];
    var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
    return index === 0 ? node : [' / ', node];
  });
}

function defaultSortFilteredOption(a, b, inputValue, names) {
  function callback(elem) {
    return elem[names.label].indexOf(inputValue) > -1;
  }

  return a.findIndex(callback) - b.findIndex(callback);
}

function getFieldNames(_ref) {
  var fieldNames = _ref.fieldNames;
  return fieldNames;
}

function getFilledFieldNames(props) {
  var fieldNames = getFieldNames(props) || {};
  var names = {
    children: fieldNames.children || 'children',
    label: fieldNames.label || 'label',
    value: fieldNames.value || 'value'
  };
  return names;
}

function flattenTree(options, props) {
  var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var names = getFilledFieldNames(props);
  var flattenOptions = [];
  var childrenName = names.children;
  options.forEach(function (option) {
    var path = ancestor.concat(option);

    if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
      flattenOptions.push(path);
    }

    if (option[childrenName]) {
      flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
    }
  });
  return flattenOptions;
}

var defaultDisplayRender = function defaultDisplayRender(label) {
  return label.join(' / ');
};

function warningValueNotExist(list) {
  var fieldNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (list || []).forEach(function (item) {
    var valueFieldName = fieldNames.value || 'value';
    (0, _devWarning["default"])(valueFieldName in item, 'Cascader', 'Not found `value` in `options`.');
    warningValueNotExist(item[fieldNames.children || 'children'], fieldNames);
  });
}

function getEmptyNode(renderEmpty, names, notFoundContent) {
  var _ref2;

  return _ref2 = {}, (0, _defineProperty2["default"])(_ref2, names.value, 'ANT_CASCADER_NOT_FOUND'), (0, _defineProperty2["default"])(_ref2, names.label, notFoundContent || renderEmpty('Cascader')), (0, _defineProperty2["default"])(_ref2, "disabled", true), (0, _defineProperty2["default"])(_ref2, "isEmptyNode", true), _ref2;
}

var Cascader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Cascader, _React$Component);

  var _super = (0, _createSuper2["default"])(Cascader);

  function Cascader(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Cascader);
    _this = _super.call(this, props);
    _this.cachedOptions = [];

    _this.setValue = function (value) {
      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value, selectedOptions);
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.handleChange = function (value, selectedOptions) {
      _this.setState({
        inputValue: ''
      });

      if (selectedOptions[0].__IS_FILTERED_OPTION) {
        var unwrappedValue = selectedOptions[0][keepFilteredValueField] === undefined ? value[0] : selectedOptions[0][keepFilteredValueField];
        var unwrappedSelectedOptions = selectedOptions[0].path;

        _this.setValue(unwrappedValue, unwrappedSelectedOptions);

        return;
      }

      _this.setValue(value, selectedOptions);
    };

    _this.handlePopupVisibleChange = function (popupVisible) {
      if (!('popupVisible' in _this.props)) {
        _this.setState(function (state) {
          return {
            popupVisible: popupVisible,
            inputFocused: popupVisible,
            inputValue: popupVisible ? state.inputValue : ''
          };
        });
      }

      var onPopupVisibleChange = _this.props.onPopupVisibleChange;

      if (onPopupVisibleChange) {
        onPopupVisibleChange(popupVisible);
      }
    };

    _this.handleInputBlur = function () {
      _this.setState({
        inputFocused: false
      });
    };

    _this.handleInputClick = function (e) {
      var _this$state = _this.state,
          inputFocused = _this$state.inputFocused,
          popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.

      if (inputFocused || popupVisible) {
        e.stopPropagation();
      }
    };

    _this.handleKeyDown = function (e) {
      // SPACE => https://github.com/ant-design/ant-design/issues/16871
      if (e.keyCode === _KeyCode["default"].BACKSPACE || e.keyCode === _KeyCode["default"].SPACE) {
        e.stopPropagation();
      }
    };

    _this.handleInputChange = function (e) {
      var popupVisible = _this.state.popupVisible;
      var inputValue = e.target.value;

      if (!popupVisible) {
        _this.handlePopupVisibleChange(true);
      }

      _this.setState({
        inputValue: inputValue
      });
    };

    _this.clearSelection = function (e) {
      var inputValue = _this.state.inputValue;
      e.preventDefault();
      e.stopPropagation();

      if (!inputValue) {
        _this.handlePopupVisibleChange(false);

        _this.clearSelectionTimeout = setTimeout(function () {
          _this.setValue([]);
        }, 200);
      } else {
        _this.setState({
          inputValue: ''
        });
      }
    };

    _this.renderCascader = function (_ref3, locale) {
      var getContextPopupContainer = _ref3.getPopupContainer,
          getPrefixCls = _ref3.getPrefixCls,
          renderEmpty = _ref3.renderEmpty,
          direction = _ref3.direction;
      return /*#__PURE__*/React.createElement(_SizeContext["default"].Consumer, null, function (size) {
        var _classNames, _classNames2, _classNames3, _classNames5;

        var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
            props = _assertThisInitialize.props,
            state = _assertThisInitialize.state;

        var customizePrefixCls = props.prefixCls,
            customizeInputPrefixCls = props.inputPrefixCls,
            children = props.children,
            _props$placeholder = props.placeholder,
            placeholder = _props$placeholder === void 0 ? locale.placeholder || 'Please select' : _props$placeholder,
            customizeSize = props.size,
            disabled = props.disabled,
            className = props.className,
            style = props.style,
            allowClear = props.allowClear,
            _props$showSearch = props.showSearch,
            showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
            suffixIcon = props.suffixIcon,
            expandIcon = props.expandIcon,
            notFoundContent = props.notFoundContent,
            popupClassName = props.popupClassName,
            bordered = props.bordered,
            dropdownRender = props.dropdownRender,
            otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch", "suffixIcon", "expandIcon", "notFoundContent", "popupClassName", "bordered", "dropdownRender"]);

        var mergedSize = customizeSize || size;
        var value = state.value,
            inputFocused = state.inputFocused;
        var isRtlLayout = direction === 'rtl';
        var prefixCls = getPrefixCls('cascader', customizePrefixCls);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var sizeCls = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(inputPrefixCls, "-lg"), mergedSize === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(inputPrefixCls, "-sm"), mergedSize === 'small'), _classNames));
        var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], {
          className: "".concat(prefixCls, "-picker-clear"),
          onClick: _this.clearSelection
        }) : null;
        var arrowCls = (0, _classnames["default"])((_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-picker-arrow"), true), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-picker-arrow-expand"), state.popupVisible), _classNames2));
        var pickerCls = (0, _classnames["default"])("".concat(prefixCls, "-picker"), (_classNames3 = {}, (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-rtl"), isRtlLayout), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-with-value"), state.inputValue), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-disabled"), disabled), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-").concat(mergedSize), !!mergedSize), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-show-search"), !!showSearch), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-focused"), inputFocused), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-picker-borderless"), !bordered), _classNames3), className); // Fix bug of https://github.com/facebook/react/pull/5004
        // and https://fb.me/react-unknown-prop

        var inputProps = (0, _omit["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent', 'fieldNames', 'bordered']);
        var options = props.options;
        var names = getFilledFieldNames(_this.props);

        if (options && options.length > 0) {
          if (state.inputValue) {
            options = _this.generateFilteredOptions(prefixCls, renderEmpty);
          }
        } else {
          options = [getEmptyNode(renderEmpty, names, notFoundContent)];
        } // Dropdown menu should keep previous status until it is fully closed.


        if (!state.popupVisible) {
          options = _this.cachedOptions;
        } else {
          _this.cachedOptions = options;
        }

        var dropdownMenuColumnStyle = {};
        var isNotFound = (options || []).length === 1 && options[0].isEmptyNode;

        if (isNotFound) {
          dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
        } // The default value of `matchInputWidth` is `true`


        var resultListMatchInputWidth = showSearch.matchInputWidth !== false;

        if (resultListMatchInputWidth && (state.inputValue || isNotFound) && _this.input) {
          dropdownMenuColumnStyle.width = _this.input.input.offsetWidth;
        }

        var inputIcon;

        if (suffixIcon) {
          inputIcon = (0, _reactNode.replaceElement)(suffixIcon, /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-picker-arrow")
          }, suffixIcon), function () {
            var _classNames4;

            return {
              className: (0, _classnames["default"])((_classNames4 = {}, (0, _defineProperty2["default"])(_classNames4, suffixIcon.props.className, suffixIcon.props.className), (0, _defineProperty2["default"])(_classNames4, "".concat(prefixCls, "-picker-arrow"), true), _classNames4))
            };
          });
        } else {
          inputIcon = /*#__PURE__*/React.createElement(_DownOutlined["default"], {
            className: arrowCls
          });
        }

        var input = children || /*#__PURE__*/React.createElement("span", {
          style: style,
          className: pickerCls
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-picker-label")
        }, _this.getLabel()), /*#__PURE__*/React.createElement(_input["default"], (0, _extends2["default"])({}, inputProps, {
          tabIndex: "-1",
          ref: _this.saveInput,
          prefixCls: inputPrefixCls,
          placeholder: value && value.length > 0 ? undefined : placeholder,
          className: "".concat(prefixCls, "-input ").concat(sizeCls),
          value: state.inputValue,
          disabled: disabled,
          readOnly: !showSearch,
          autoComplete: inputProps.autoComplete || 'off',
          onClick: showSearch ? _this.handleInputClick : undefined,
          onBlur: showSearch ? _this.handleInputBlur : undefined,
          onKeyDown: _this.handleKeyDown,
          onChange: showSearch ? _this.handleInputChange : undefined
        })), clearIcon, inputIcon);
        var expandIconNode;

        if (expandIcon) {
          expandIconNode = expandIcon;
        } else {
          expandIconNode = isRtlLayout ? /*#__PURE__*/React.createElement(_LeftOutlined["default"], null) : /*#__PURE__*/React.createElement(_RightOutlined["default"], null);
        }

        var loadingIcon = /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-menu-item-loading-icon")
        }, /*#__PURE__*/React.createElement(_RedoOutlined["default"], {
          spin: true
        }));
        var getPopupContainer = props.getPopupContainer || getContextPopupContainer;
        var rest = (0, _omit["default"])(props, ['inputIcon', 'expandIcon', 'loadingIcon', 'bordered', 'className']);
        var rcCascaderPopupClassName = (0, _classnames["default"])(popupClassName, (_classNames5 = {}, (0, _defineProperty2["default"])(_classNames5, "".concat(prefixCls, "-menu-").concat(direction), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames5, "".concat(prefixCls, "-menu-empty"), options.length === 1 && options[0].value === 'ANT_CASCADER_NOT_FOUND'), _classNames5));
        return /*#__PURE__*/React.createElement(_rcCascader["default"], (0, _extends2["default"])({}, rest, {
          prefixCls: prefixCls,
          getPopupContainer: getPopupContainer,
          options: options,
          value: value,
          popupVisible: state.popupVisible,
          onPopupVisibleChange: _this.handlePopupVisibleChange,
          onChange: _this.handleChange,
          dropdownMenuColumnStyle: dropdownMenuColumnStyle,
          expandIcon: expandIconNode,
          loadingIcon: loadingIcon,
          popupClassName: rcCascaderPopupClassName,
          popupPlacement: _this.getPopupPlacement(direction),
          dropdownRender: dropdownRender
        }), input);
      });
    };

    _this.state = {
      value: props.value || props.defaultValue || [],
      inputValue: '',
      inputFocused: false,
      popupVisible: props.popupVisible,
      flattenOptions: props.showSearch ? flattenTree(props.options, props) : undefined,
      prevProps: props
    };
    return _this;
  }

  (0, _createClass2["default"])(Cascader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.clearSelectionTimeout) {
        clearTimeout(this.clearSelectionTimeout);
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var _this$props = this.props,
          options = _this$props.options,
          _this$props$displayRe = _this$props.displayRender,
          displayRender = _this$props$displayRe === void 0 ? defaultDisplayRender : _this$props$displayRe;
      var names = getFilledFieldNames(this.props);
      var value = this.state.value;
      var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
      var selectedOptions = (0, _arrayTreeFilter["default"])(options, function (o, level) {
        return o[names.value] === unwrappedValue[level];
      }, {
        childrenKeyName: names.children
      });
      var label = selectedOptions.length ? selectedOptions.map(function (o) {
        return o[names.label];
      }) : value;
      return displayRender(label, selectedOptions);
    }
  }, {
    key: "generateFilteredOptions",
    value: function generateFilteredOptions(prefixCls, renderEmpty) {
      var _this2 = this;

      var _this$props2 = this.props,
          showSearch = _this$props2.showSearch,
          notFoundContent = _this$props2.notFoundContent;
      var names = getFilledFieldNames(this.props);
      var _showSearch$filter = showSearch.filter,
          filter = _showSearch$filter === void 0 ? defaultFilterOption : _showSearch$filter,
          _showSearch$render = showSearch.render,
          render = _showSearch$render === void 0 ? defaultRenderFilteredOption : _showSearch$render,
          _showSearch$sort = showSearch.sort,
          sort = _showSearch$sort === void 0 ? defaultSortFilteredOption : _showSearch$sort,
          _showSearch$limit = showSearch.limit,
          limit = _showSearch$limit === void 0 ? defaultLimit : _showSearch$limit;
      var _this$state2 = this.state,
          _this$state2$flattenO = _this$state2.flattenOptions,
          flattenOptions = _this$state2$flattenO === void 0 ? [] : _this$state2$flattenO,
          inputValue = _this$state2.inputValue; // Limit the filter if needed

      var filtered;

      if (limit > 0) {
        filtered = [];
        var matchCount = 0; // Perf optimization to filter items only below the limit

        flattenOptions.some(function (path) {
          var match = filter(_this2.state.inputValue, path, names);

          if (match) {
            filtered.push(path);
            matchCount += 1;
          }

          return matchCount >= limit;
        });
      } else {
        (0, _devWarning["default"])(typeof limit !== 'number', 'Cascader', "'limit' of showSearch should be positive number or false.");
        filtered = flattenOptions.filter(function (path) {
          return filter(_this2.state.inputValue, path, names);
        });
      }

      filtered = filtered.sort(function (a, b) {
        return sort(a, b, inputValue, names);
      });

      if (filtered.length > 0) {
        // Fix issue: https://github.com/ant-design/ant-design/issues/26554
        var field = names.value === names.label ? keepFilteredValueField : names.value;
        return filtered.map(function (path) {
          var _ref4;

          return _ref4 = {
            __IS_FILTERED_OPTION: true,
            path: path
          }, (0, _defineProperty2["default"])(_ref4, field, path.map(function (o) {
            return o[names.value];
          })), (0, _defineProperty2["default"])(_ref4, names.label, render(inputValue, path, prefixCls, names)), (0, _defineProperty2["default"])(_ref4, "disabled", path.some(function (o) {
            return !!o.disabled;
          })), (0, _defineProperty2["default"])(_ref4, "isEmptyNode", true), _ref4;
        });
      }

      return [getEmptyNode(renderEmpty, names, notFoundContent)];
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "getPopupPlacement",
    value: function getPopupPlacement() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ltr';
      var popupPlacement = this.props.popupPlacement;

      if (popupPlacement !== undefined) {
        return popupPlacement;
      }

      return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (configArgument) {
        return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (locale) {
          return _this3.renderCascader(configArgument, locale);
        });
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref5) {
      var prevProps = _ref5.prevProps;
      var newState = {
        prevProps: nextProps
      };

      if ('value' in nextProps) {
        newState.value = nextProps.value || [];
      }

      if ('popupVisible' in nextProps) {
        newState.popupVisible = nextProps.popupVisible;
      }

      if (nextProps.showSearch && prevProps.options !== nextProps.options) {
        newState.flattenOptions = flattenTree(nextProps.options, nextProps);
      }

      if (false) {
        warningValueNotExist(nextProps.options, getFieldNames(nextProps));
      }

      return newState;
    }
  }]);
  return Cascader;
}(React.Component);

Cascader.defaultProps = {
  transitionName: 'slide-up',
  options: [],
  disabled: false,
  allowClear: true,
  bordered: true
};
var _default = Cascader;
exports["default"] = _default;

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1910);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1912);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1915);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorUtils = exports.BaseUtils = exports.ContentUtils = undefined;

var _content = __webpack_require__(1928);

var _ContentUtils = _interopRequireWildcard(_content);

var _base = __webpack_require__(2036);

var _BaseUtils = _interopRequireWildcard(_base);

var _color = __webpack_require__(2037);

var _ColorUtils = _interopRequireWildcard(_color);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentUtils = exports.ContentUtils = _ContentUtils;
var BaseUtils = exports.BaseUtils = _BaseUtils;
var ColorUtils = exports.ColorUtils = _ColorUtils;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(89);
var Immutable = __webpack_require__(32);

var generateRandomKey = __webpack_require__(121);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(83);

var findRangesImmutable = __webpack_require__(228);
var invariant = __webpack_require__(34);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */



/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var ContentBlockNode = __webpack_require__(89);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * @format
 * 
 */



var Immutable = __webpack_require__(32);

var emptyFunction = __webpack_require__(261);
var findRangesImmutable = __webpack_require__(228);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;


var returnTrue = emptyFunction.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * @legacyServerCallableInstance
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(32);

var Record = Immutable.Record;


var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck(this, DraftEntityInstance);

    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var UnicodeBidiDirection = __webpack_require__(429);

var invariant = __webpack_require__(34);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }
  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

module.exports = UnicodeBidi;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */



module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */



function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorLeaf = __webpack_require__(1950);
var DraftOffsetKey = __webpack_require__(307);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(52);
var Scroll = __webpack_require__(820);
var Style = __webpack_require__(434);
var UnicodeBidi = __webpack_require__(814);
var UnicodeBidiDirection = __webpack_require__(429);

var cx = __webpack_require__(197);
var getElementPosition = __webpack_require__(1964);
var getScrollPosition = __webpack_require__(435);
var getViewportDimensions = __webpack_require__(1968);
var invariant = __webpack_require__(34);
var nullthrows = __webpack_require__(105);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck(this, DraftEditorBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);

      return React.createElement(
        DecoratorComponent,
        _extends({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 818 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

module.exports = Scroll;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var PhotosMimeType = __webpack_require__(1971);

var createArrayFromMixed = __webpack_require__(1972);
var emptyFunction = __webpack_require__(261);

var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */



/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * @format
 * 
 */



var invariant = __webpack_require__(34);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * @format
 * 
 */



var DraftOffsetKey = __webpack_require__(307);

var nullthrows = __webpack_require__(105);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());
  if (false) {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */
      return selection;
    }
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(305);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @format
 * 
 */



var UserAgent = __webpack_require__(114);

var invariant = __webpack_require__(34);

var isChrome = UserAgent.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

module.exports = getRangeClientRects;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @format
 * 
 */



var findAncestorOffsetKey = __webpack_require__(436);
var getSelectionOffsetKeyForNode = __webpack_require__(822);
var getUpdatedSelectionState = __webpack_require__(824);
var invariant = __webpack_require__(34);
var nullthrows = __webpack_require__(105);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @format
 * 
 */



var TokenizeUtil = __webpack_require__(1990);

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

module.exports = DraftRemovableWord;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

module.exports = moveSelectionForward;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @format
 * 
 */



var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl,
    _assign = __webpack_require__(64);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(83);
var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var DefaultDraftBlockRenderMap = __webpack_require__(430);
var DraftEntity = __webpack_require__(306);
var DraftFeatureFlags = __webpack_require__(129);
var Immutable = __webpack_require__(32);

var _require = __webpack_require__(32),
    Set = _require.Set;

var URI = __webpack_require__(2001);

var cx = __webpack_require__(197);
var generateRandomKey = __webpack_require__(121);
var getSafeBodyFromHTML = __webpack_require__(831);
var invariant = __webpack_require__(34);
var sanitizeDraftText = __webpack_require__(428);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    OrderedSet = Immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey();

        var textNode = new ContentBlockNode({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * @format
 * 
 */



var UserAgent = __webpack_require__(114);

var invariant = __webpack_require__(34);

var isOldIE = UserAgent.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var SelectionState = __webpack_require__(196);

var adjustBlockDepthForContentState = __webpack_require__(2002);
var nullthrows = __webpack_require__(105);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

module.exports = RichTextEditorUtil;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @format
 * 
 */



var KeyBindingUtil = __webpack_require__(437);
var Keys = __webpack_require__(431);
var UserAgent = __webpack_require__(114);

var isOSX = UserAgent.isPlatform('Mac OS X');
var isWindows = UserAgent.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */



var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

module.exports = DraftStringKey;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(195),__webpack_require__(32)):"function"==typeof define&&define.amd?define(["draft-js","immutable"],t):"object"==typeof exports?exports.draftjsUtils=t(require("draft-js"),require("immutable")):e.draftjsUtils=t(e["draft-js"],e.immutable)}("undefined"!=typeof self?self:this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){var t=e.getSelection(),n=e.getCurrentContent(),r=t.getStartKey(),o=t.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(e,t){return t===r}).takeUntil(function(e,t){return t===o}).concat([[o,i.get(o)]])}function o(e){return r(e).toList()}function i(e){if(e)return o(e).get(0)}function l(e){if(e){var t=i(e),n=e.getCurrentContent(),r=n.getBlockMap().toSeq().toList(),o=0;if(r.forEach(function(e,n){e.get("key")===t.get("key")&&(o=n-1)}),o>-1)return r.get(o)}}function c(e){return e?e.getCurrentContent().getBlockMap().toList():new v.List}function a(e){var t=o(e);if(!t.some(function(e){return e.type!==t.get(0).type}))return t.get(0).type}function f(e){var t=p.RichUtils.tryToRemoveBlockStyle(e);return t?p.EditorState.push(e,t,"change-block-type"):e}function u(e){var t="",n=e.getSelection(),r=n.getAnchorOffset(),i=n.getFocusOffset(),l=o(e);if(l.size>0){if(n.getIsBackward()){var c=r;r=i,i=c}for(var a=0;a<l.size;a+=1){var f=0===a?r:0,u=a===l.size-1?i:l.get(a).getText().length;t+=l.get(a).getText().slice(f,u)}}return t}function s(e){var t=e.getCurrentContent(),n=e.getSelection(),r=p.Modifier.removeRange(t,n,"forward"),o=r.getSelectionAfter(),i=r.getBlockForKey(o.getStartKey());return r=p.Modifier.insertText(r,o,"\n",i.getInlineStyleAt(o.getStartOffset()),null),p.EditorState.push(e,r,"insert-fragment")}function g(e){var t=p.Modifier.splitBlock(e.getCurrentContent(),e.getSelection());return f(p.EditorState.push(e,t,"split-block"))}function d(e){var t=e.getCurrentContent().getBlockMap().toList(),n=e.getSelection().merge({anchorKey:t.first().get("key"),anchorOffset:0,focusKey:t.last().get("key"),focusOffset:t.last().getLength()}),r=p.Modifier.removeRange(e.getCurrentContent(),n,"forward");return p.EditorState.push(e,r,"remove-range")}function S(e,t){var n=p.Modifier.setBlockData(e.getCurrentContent(),e.getSelection(),t);return p.EditorState.push(e,n,"change-block-data")}function y(e){var t=new v.Map({}),n=o(e);if(n&&n.size>0)for(var r=0;r<n.size;r+=1){var i=function(e){var r=n.get(e).getData();if(!r||0===r.size)return t=t.clear(),"break";if(0===e)t=r;else if(t.forEach(function(e,n){r.get(n)&&r.get(n)===e||(t=t.delete(n))}),0===t.size)return t=t.clear(),"break"}(r);if("break"===i)break}return t}Object.defineProperty(t,"__esModule",{value:!0}),t.blockRenderMap=void 0,t.getSelectedBlocksMap=r,t.getSelectedBlocksList=o,t.getSelectedBlock=i,t.getBlockBeforeSelectedBlock=l,t.getAllBlocks=c,t.getSelectedBlocksType=a,t.removeSelectedBlocksStyle=f,t.getSelectionText=u,t.addLineBreakRemovingSelection=s,t.insertNewUnstyledBlock=g,t.clearEditorContent=d,t.setBlockData=S,t.getSelectedBlocksMetadata=y;var p=n(0),v=n(6),k=(0,v.Map)({code:{element:"pre"}});t.blockRenderMap=p.DefaultDraftBlockRenderMap.merge(k)},function(e,t,n){"use strict";function r(e){if(e){var t=e.getType();return"unordered-list-item"===t||"ordered-list-item"===t}return!1}function o(e,t,n){var r=e.getSelection(),o=e.getCurrentContent(),i=o.getBlockMap(),l=(0,c.getSelectedBlocksMap)(e).map(function(e){var r=e.getDepth()+t;return r=Math.max(0,Math.min(r,n)),e.set("depth",r)});return i=i.merge(l),o.merge({blockMap:i,selectionBefore:r,selectionAfter:r})}function i(e,t,n){var r=e.getSelection(),i=void 0;i=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var c=e.getCurrentContent(),a=c.getBlockForKey(i),f=a.getType();if("unordered-list-item"!==f&&"ordered-list-item"!==f)return e;var u=c.getBlockBefore(i);if(!u)return e;if(u.getType()!==f)return e;var s=a.getDepth();if(1===t&&s===n)return e;var g=Math.min(u.getDepth()+1,n),d=o(e,t,g);return l.EditorState.push(e,d,"adjust-depth")}Object.defineProperty(t,"__esModule",{value:!0}),t.isListBlock=r,t.changeDepth=i;var l=n(0),c=n(1)},function(e,t,n){e.exports=n(4)},function(e,t,n){"use strict";var r=n(5),o=n(1),i=n(7),l=function(e){return e&&e.__esModule?e:{default:e}}(i),c=n(2);e.exports={getSelectedBlocksMap:o.getSelectedBlocksMap,getSelectedBlocksList:o.getSelectedBlocksList,getSelectedBlock:o.getSelectedBlock,getBlockBeforeSelectedBlock:o.getBlockBeforeSelectedBlock,getAllBlocks:o.getAllBlocks,getSelectedBlocksType:o.getSelectedBlocksType,removeSelectedBlocksStyle:o.removeSelectedBlocksStyle,getSelectionText:o.getSelectionText,addLineBreakRemovingSelection:o.addLineBreakRemovingSelection,insertNewUnstyledBlock:o.insertNewUnstyledBlock,clearEditorContent:o.clearEditorContent,setBlockData:o.setBlockData,getSelectedBlocksMetadata:o.getSelectedBlocksMetadata,blockRenderMap:o.blockRenderMap,getEntityRange:r.getEntityRange,getCustomStyleMap:r.getCustomStyleMap,toggleCustomInlineStyle:r.toggleCustomInlineStyle,getSelectionEntity:r.getSelectionEntity,extractInlineStyle:r.extractInlineStyle,removeAllInlineStyles:r.removeAllInlineStyles,getSelectionInlineStyle:r.getSelectionInlineStyle,getSelectionCustomInlineStyle:r.getSelectionCustomInlineStyle,handleNewLine:l.default,isListBlock:c.isListBlock,changeDepth:c.changeDepth}},function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e){var t=e.getSelection();if(t.isCollapsed()){var n={},r=e.getCurrentInlineStyle().toList().toJS();if(r)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(e){n[e]=r.indexOf(e)>=0}),n}var o=t.getStartOffset(),i=t.getEndOffset(),l=(0,p.getSelectedBlocksList)(e);if(l.size>0){var c=function(){for(var e={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},t=0;t<l.size;t+=1){var n=0===t?o:0,r=t===l.size-1?i:l.get(t).getText().length;n===r&&0===n?(n=1,r=2):n===r&&(n-=1);for(var c=n;c<r;c+=1)!function(n){var r=l.get(t).getInlineStyleAt(n);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){e[t]=e[t]&&r.get(t)===t})}(c)}return{v:e}}();if("object"===(void 0===c?"undefined":S(c)))return c.v}return{}}function i(e){var t=void 0,n=e.getSelection(),r=n.getStartOffset(),o=n.getEndOffset();r===o&&0===r?o=1:r===o&&(r-=1);for(var i=(0,p.getSelectedBlock)(e),l=r;l<o;l+=1){var c=i.getEntityAt(l);if(!c){t=void 0;break}if(l===r)t=c;else if(t!==c){t=void 0;break}}return t}function l(e,t){var n=(0,p.getSelectedBlock)(e),r=void 0;return n.findEntityRanges(function(e){return e.get("entity")===t},function(e,t){r={start:e,end:t,text:n.get("text").slice(e,t)}}),r}function c(e,t,n){var r=e.getSelection(),o=Object.keys(v[t]).reduce(function(e,t){return y.Modifier.removeInlineStyle(e,r,t)},e.getCurrentContent()),i=y.EditorState.push(e,o,"changeinline-style"),l=e.getCurrentInlineStyle();if(r.isCollapsed()&&(i=l.reduce(function(e,t){return y.RichUtils.toggleInlineStyle(e,t)},i)),"SUPERSCRIPT"===t||"SUBSCRIPT"==t)l.has(n)||(i=y.RichUtils.toggleInlineStyle(i,n));else{var c="bgcolor"===t?"backgroundColor":t;l.has(c+"-"+n)||(i=y.RichUtils.toggleInlineStyle(i,t.toLowerCase()+"-"+n),k(t,c,n))}return i}function a(e){if(e){e.getCurrentContent().getBlockMap().map(function(e){return e.get("characterList")}).toList().flatten().forEach(function(e){e&&0===e.indexOf("color-")?k("color","color",e.substr(6)):e&&0===e.indexOf("bgcolor-")?k("bgcolor","backgroundColor",e.substr(8)):e&&0===e.indexOf("fontsize-")?k("fontSize","fontSize",+e.substr(9)):e&&0===e.indexOf("fontfamily-")&&k("fontFamily","fontFamily",e.substr(11))})}}function f(e,t,n){var r=e.getInlineStyleAt(n).toList(),o=r.filter(function(e){return e.startsWith(t.toLowerCase())});if(o&&o.size>0)return o.get(0)}function u(e,t){var n=e.getCurrentInlineStyle().toList(),r=n.filter(function(e){return e.startsWith(t.toLowerCase())});if(r&&r.size>0)return r.get(0)}function s(e,t){if(e&&t&&t.length>0){var n=function(){var n=e.getSelection(),r={};if(n.isCollapsed())return t.forEach(function(t){r[t]=u(e,t)}),{v:r};var o=n.getStartOffset(),i=n.getEndOffset(),l=(0,p.getSelectedBlocksList)(e);if(l.size>0){for(var c=0;c<l.size;c+=1)!function(e){var n=0===e?o:0,c=e===l.size-1?i:l.get(e).getText().length;n===c&&0===n?(n=1,c=2):n===c&&(n-=1);for(var a=n;a<c;a+=1)!function(o){o===n?t.forEach(function(t){r[t]=f(l.get(e),t,o)}):t.forEach(function(t){r[t]&&r[t]!==f(l.get(e),t,o)&&(r[t]=void 0)})}(a)}(c);return{v:r}}}();if("object"===(void 0===n?"undefined":S(n)))return n.v}return{}}function g(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=y.Modifier.removeInlineStyle(n,e.getSelection(),t)}),y.EditorState.push(e,n,"change-inline-style")}Object.defineProperty(t,"__esModule",{value:!0}),t.getCustomStyleMap=void 0;var d=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.getSelectionInlineStyle=o,t.getSelectionEntity=i,t.getEntityRange=l,t.toggleCustomInlineStyle=c,t.extractInlineStyle=a,t.getSelectionCustomInlineStyle=s,t.removeAllInlineStyles=g;var y=n(0),p=n(1),v={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}},k=function(e,t,n){v[e][e.toLowerCase()+"-"+n]=r({},""+t,n)};t.getCustomStyleMap=function(){return d({},v.color,v.bgcolor,v.fontSize,v.fontFamily,{CODE:v.CODE,SUPERSCRIPT:v.SUPERSCRIPT,SUBSCRIPT:v.SUBSCRIPT})}},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=e.getSelection();if(t.isCollapsed()){var n=e.getCurrentContent(),r=t.getStartKey(),o=n.getBlockForKey(r);if(!(0,a.isListBlock)(o)&&"unstyled"!==o.getType()&&o.getLength()===t.getStartOffset())return(0,c.insertNewUnstyledBlock)(e);if((0,a.isListBlock)(o)&&0===o.getLength()){var i=o.getDepth();if(0===i)return(0,c.removeSelectedBlocksStyle)(e);if(i>0)return(0,a.changeDepth)(e,-1,i)}}}function o(e){return 13===e.which&&(e.getModifierState("Shift")||e.getModifierState("Alt")||e.getModifierState("Control"))}function i(e,t){if(o(t)){return e.getSelection().isCollapsed()?l.RichUtils.insertSoftNewline(e):(0,c.addLineBreakRemovingSelection)(e)}return r(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=i;var l=n(0),c=n(1),a=n(2)}])});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertRawToEditorState = exports.convertEditorStateToRaw = exports.convertHTMLToEditorState = exports.convertEditorStateToHTML = exports.convertHTMLToRaw = exports.convertRawToHTML = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _draftConvert = __webpack_require__(2017);

var _configs = __webpack_require__(2035);

var _draftJs = __webpack_require__(195);

var defaultConvertOptions = {
  fontFamilies: _configs.defaultFontFamilies
};

var convertRawToHTML = exports.convertRawToHTML = function convertRawToHTML(rawContent, options) {

  options = _extends({}, defaultConvertOptions, options);

  try {
    var contentState = (0, _draftJs.convertFromRaw)(rawContent);
    options.contentState = contentState;
    return (0, _draftConvert.convertToHTML)((0, _configs.getToHTMLConfig)(options))(contentState);
  } catch (error) {
    console.warn(error);
    return '';
  }
};

var convertHTMLToRaw = exports.convertHTMLToRaw = function convertHTMLToRaw(HTMLString, options, source) {

  options = _extends({}, defaultConvertOptions, options);

  try {
    var contentState = (0, _draftConvert.convertFromHTML)((0, _configs.getFromHTMLConfig)(options, source))(HTMLString);
    return (0, _draftJs.convertToRaw)(contentState);
  } catch (error) {
    console.warn(error);
    return {};
  }
};

var convertEditorStateToHTML = exports.convertEditorStateToHTML = function convertEditorStateToHTML(editorState, options) {

  options = _extends({}, defaultConvertOptions, options);

  try {
    var contentState = editorState.getCurrentContent();
    options.contentState = contentState;
    return (0, _draftConvert.convertToHTML)((0, _configs.getToHTMLConfig)(options))(contentState);
  } catch (error) {
    console.warn(error);
    return '';
  }
};

var convertHTMLToEditorState = exports.convertHTMLToEditorState = function convertHTMLToEditorState(HTMLString, editorDecorators, options, source) {

  options = _extends({}, defaultConvertOptions, options);

  try {
    return _draftJs.EditorState.createWithContent((0, _draftConvert.convertFromHTML)((0, _configs.getFromHTMLConfig)(options, source))(HTMLString), editorDecorators);
  } catch (error) {
    console.warn(error);
    return _draftJs.EditorState.createEmpty(editorDecorators);
  }
};

var convertEditorStateToRaw = exports.convertEditorStateToRaw = function convertEditorStateToRaw(editorState) {
  return (0, _draftJs.convertToRaw)(editorState.getCurrentContent());
};

var convertRawToEditorState = exports.convertRawToEditorState = function convertRawToEditorState(rawContent, editorDecorators) {

  try {
    return _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(rawContent), editorDecorators);
  } catch (error) {
    console.warn(error);
    return _draftJs.EditorState.createEmpty(editorDecorators);
  }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateMutation;
function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength, suffixLength) {
  // three cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed,
  // mutations that completely contain the new one where we can adjust
  // the length, and mutations that occur partially within the new one.
  var lengthDiff = newLength - originalLength;
  var mutationAfterChange = originalOffset + originalLength <= mutation.offset;

  if (mutationAfterChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }

  var mutationContainsChange = originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length;

  if (mutationContainsChange) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }

  var mutationWithinPrefixChange = mutation.offset >= originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && prefixLength > 0;

  if (mutationWithinPrefixChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength
    });
  }

  var mutationContainsPrefix = mutation.offset < originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && mutation.offset + mutation.length > originalOffset && prefixLength > 0;

  if (mutationContainsPrefix) {
    return [Object.assign({}, mutation, {
      length: originalOffset - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + prefixLength,
      length: mutation.offset - originalOffset + mutation.length
    })];
  }

  var mutationContainsSuffix = mutation.offset >= originalOffset && mutation.offset + mutation.length > originalOffset + originalLength && originalOffset + originalLength > mutation.offset && suffixLength > 0;

  if (mutationContainsSuffix) {
    return [Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength,
      length: originalOffset + originalLength - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + originalLength + prefixLength + suffixLength,
      length: mutation.offset + mutation.length - (originalOffset + originalLength)
    })];
  }

  return mutation;
}

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getElementHTML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__splitReactElement__ = __webpack_require__(310);






function hasChildren(element) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(element) && __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(element.props.children) > 0;
}

function getElementHTML(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (element === undefined || element === null) {
    return element;
  }

  if (typeof element === 'string') {
    return element;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(element)) {
    if (hasChildren(element)) {
      return __WEBPACK_IMPORTED_MODULE_3_react_dom_server___default.a.renderToStaticMarkup(element);
    }

    var tags = Object(__WEBPACK_IMPORTED_MODULE_4__splitReactElement__["a" /* default */])(element);

    if (text !== null && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(tags) === 'object') {
      var start = tags.start,
          end = tags.end;
      return start + text + end;
    }

    return tags;
  }

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');

  if (text !== null) {
    var _start = element.start,
        _end = element.end;
    return _start + text + _end;
  }

  return element;
}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(void 0, arguments);

    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(void 0, arguments);
  };
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseHTML;
var fallback = function fallback(html) {
  var doc = document.implementation.createHTMLDocument('');
  doc.documentElement.innerHTML = html;
  return doc;
};

function parseHTML(html) {
  var doc;

  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');

    if (doc === null || doc.body === null) {
      doc = fallback(html);
    }
  } else {
    doc = fallback(html);
  }

  return doc.body;
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _BookOutlined = _interopRequireDefault(__webpack_require__(2041));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var BookOutlined = function BookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _BookOutlined.default
  }));
};
BookOutlined.displayName = 'BookOutlined';
var _default = /*#__PURE__*/React.forwardRef(BookOutlined);
exports.default = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define(e);else{var t;"undefined"!=typeof window?t=window:"undefined"!=typeof global?t=global:"undefined"!=typeof self&&(t=self),t.objectHash=e()}}(function(){return function o(i,u,a){function s(n,e){if(!u[n]){if(!i[n]){var t="function"==typeof require&&require;if(!e&&t)return require(n,!0);if(f)return f(n,!0);throw new Error("Cannot find module '"+n+"'")}var r=u[n]={exports:{}};i[n][0].call(r.exports,function(e){var t=i[n][1][e];return s(t||e)},r,r.exports,o,i,u,a)}return u[n].exports}for(var f="function"==typeof require&&require,e=0;e<a.length;e++)s(a[e]);return s}({1:[function(w,b,m){(function(e,t,f,n,r,o,i,u,a){"use strict";var s=w("crypto");function c(e,t){return function(e,t){var n;n="passthrough"!==t.algorithm?s.createHash(t.algorithm):new y;void 0===n.write&&(n.write=n.update,n.end=n.update);g(t,n).dispatch(e),n.update||n.end("");if(n.digest)return n.digest("buffer"===t.encoding?void 0:t.encoding);var r=n.read();return"buffer"!==t.encoding?r.toString(t.encoding):r}(e,t=h(e,t))}(m=b.exports=c).sha1=function(e){return c(e)},m.keys=function(e){return c(e,{excludeValues:!0,algorithm:"sha1",encoding:"hex"})},m.MD5=function(e){return c(e,{algorithm:"md5",encoding:"hex"})},m.keysMD5=function(e){return c(e,{algorithm:"md5",encoding:"hex",excludeValues:!0})};var l=s.getHashes?s.getHashes().slice():["sha1","md5"];l.push("passthrough");var d=["buffer","hex","binary","base64"];function h(e,t){t=t||{};var n={};if(n.algorithm=t.algorithm||"sha1",n.encoding=t.encoding||"hex",n.excludeValues=!!t.excludeValues,n.algorithm=n.algorithm.toLowerCase(),n.encoding=n.encoding.toLowerCase(),n.ignoreUnknown=!0===t.ignoreUnknown,n.respectType=!1!==t.respectType,n.respectFunctionNames=!1!==t.respectFunctionNames,n.respectFunctionProperties=!1!==t.respectFunctionProperties,n.unorderedArrays=!0===t.unorderedArrays,n.unorderedSets=!1!==t.unorderedSets,n.unorderedObjects=!1!==t.unorderedObjects,n.replacer=t.replacer||void 0,n.excludeKeys=t.excludeKeys||void 0,void 0===e)throw new Error("Object argument required.");for(var r=0;r<l.length;++r)l[r].toLowerCase()===n.algorithm.toLowerCase()&&(n.algorithm=l[r]);if(-1===l.indexOf(n.algorithm))throw new Error('Algorithm "'+n.algorithm+'"  not supported. supported values: '+l.join(", "));if(-1===d.indexOf(n.encoding)&&"passthrough"!==n.algorithm)throw new Error('Encoding "'+n.encoding+'"  not supported. supported values: '+d.join(", "));return n}function p(e){if("function"==typeof e){return null!=/^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e))}}function g(u,t,a){a=a||[];function s(e){return t.update?t.update(e,"utf8"):t.write(e,"utf8")}return{dispatch:function(e){u.replacer&&(e=u.replacer(e));var t=typeof e;return null===e&&(t="null"),this["_"+t](e)},_object:function(t){var e=Object.prototype.toString.call(t),n=/\[object (.*)\]/i.exec(e);n=(n=n?n[1]:"unknown:["+e+"]").toLowerCase();var r;if(0<=(r=a.indexOf(t)))return this.dispatch("[CIRCULAR:"+r+"]");if(a.push(t),void 0!==f&&f.isBuffer&&f.isBuffer(t))return s("buffer:"),s(t);if("object"===n||"function"===n||"asyncfunction"===n){var o=Object.keys(t);u.unorderedObjects&&(o=o.sort()),!1===u.respectType||p(t)||o.splice(0,0,"prototype","__proto__","constructor"),u.excludeKeys&&(o=o.filter(function(e){return!u.excludeKeys(e)})),s("object:"+o.length+":");var i=this;return o.forEach(function(e){i.dispatch(e),s(":"),u.excludeValues||i.dispatch(t[e]),s(",")})}if(!this["_"+n]){if(u.ignoreUnknown)return s("["+n+"]");throw new Error('Unknown object type "'+n+'"')}this["_"+n](t)},_array:function(e,t){t=void 0!==t?t:!1!==u.unorderedArrays;var n=this;if(s("array:"+e.length+":"),!t||e.length<=1)return e.forEach(function(e){return n.dispatch(e)});var r=[],o=e.map(function(e){var t=new y,n=a.slice();return g(u,t,n).dispatch(e),r=r.concat(n.slice(a.length)),t.read().toString()});return a=a.concat(r),o.sort(),this._array(o,!1)},_date:function(e){return s("date:"+e.toJSON())},_symbol:function(e){return s("symbol:"+e.toString())},_error:function(e){return s("error:"+e.toString())},_boolean:function(e){return s("bool:"+e.toString())},_string:function(e){s("string:"+e.length+":"),s(e.toString())},_function:function(e){s("fn:"),p(e)?this.dispatch("[native]"):this.dispatch(e.toString()),!1!==u.respectFunctionNames&&this.dispatch("function-name:"+String(e.name)),u.respectFunctionProperties&&this._object(e)},_number:function(e){return s("number:"+e.toString())},_xml:function(e){return s("xml:"+e.toString())},_null:function(){return s("Null")},_undefined:function(){return s("Undefined")},_regexp:function(e){return s("regex:"+e.toString())},_uint8array:function(e){return s("uint8array:"),this.dispatch(Array.prototype.slice.call(e))},_uint8clampedarray:function(e){return s("uint8clampedarray:"),this.dispatch(Array.prototype.slice.call(e))},_int8array:function(e){return s("uint8array:"),this.dispatch(Array.prototype.slice.call(e))},_uint16array:function(e){return s("uint16array:"),this.dispatch(Array.prototype.slice.call(e))},_int16array:function(e){return s("uint16array:"),this.dispatch(Array.prototype.slice.call(e))},_uint32array:function(e){return s("uint32array:"),this.dispatch(Array.prototype.slice.call(e))},_int32array:function(e){return s("uint32array:"),this.dispatch(Array.prototype.slice.call(e))},_float32array:function(e){return s("float32array:"),this.dispatch(Array.prototype.slice.call(e))},_float64array:function(e){return s("float64array:"),this.dispatch(Array.prototype.slice.call(e))},_arraybuffer:function(e){return s("arraybuffer:"),this.dispatch(new Uint8Array(e))},_url:function(e){return s("url:"+e.toString())},_map:function(e){s("map:");var t=Array.from(e);return this._array(t,!1!==u.unorderedSets)},_set:function(e){s("set:");var t=Array.from(e);return this._array(t,!1!==u.unorderedSets)},_blob:function(){if(u.ignoreUnknown)return s("[blob]");throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n')},_domwindow:function(){return s("domwindow")},_process:function(){return s("process")},_timer:function(){return s("timer")},_pipe:function(){return s("pipe")},_tcp:function(){return s("tcp")},_udp:function(){return s("udp")},_tty:function(){return s("tty")},_statwatcher:function(){return s("statwatcher")},_securecontext:function(){return s("securecontext")},_connection:function(){return s("connection")},_zlib:function(){return s("zlib")},_context:function(){return s("context")},_nodescript:function(){return s("nodescript")},_httpparser:function(){return s("httpparser")},_dataview:function(){return s("dataview")},_signal:function(){return s("signal")},_fsevent:function(){return s("fsevent")},_tlswrap:function(){return s("tlswrap")}}}function y(){return{buf:"",write:function(e){this.buf+=e},end:function(e){this.buf+=e},read:function(){return this.buf}}}m.writeToStream=function(e,t,n){return void 0===n&&(n=t,t={}),g(t=h(e,t),n).dispatch(e)}}).call(this,w("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},w("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_794fcf4d.js","/")},{buffer:3,crypto:5,lYpoI2:10}],2:[function(e,t,f){(function(e,t,n,r,o,i,u,a,s){!function(e){"use strict";var f="undefined"!=typeof Uint8Array?Uint8Array:Array,n="+".charCodeAt(0),r="/".charCodeAt(0),o="0".charCodeAt(0),i="a".charCodeAt(0),u="A".charCodeAt(0),a="-".charCodeAt(0),s="_".charCodeAt(0);function c(e){var t=e.charCodeAt(0);return t===n||t===a?62:t===r||t===s?63:t<o?-1:t<o+10?t-o+26+26:t<u+26?t-u:t<i+26?t-i+26:void 0}e.toByteArray=function(e){var t,n,r,o,i;if(0<e.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var u=e.length;o="="===e.charAt(u-2)?2:"="===e.charAt(u-1)?1:0,i=new f(3*e.length/4-o),n=0<o?e.length-4:e.length;var a=0;function s(e){i[a++]=e}for(t=0;t<n;t+=4,0)s((16711680&(r=c(e.charAt(t))<<18|c(e.charAt(t+1))<<12|c(e.charAt(t+2))<<6|c(e.charAt(t+3))))>>16),s((65280&r)>>8),s(255&r);return 2==o?s(255&(r=c(e.charAt(t))<<2|c(e.charAt(t+1))>>4)):1==o&&(s((r=c(e.charAt(t))<<10|c(e.charAt(t+1))<<4|c(e.charAt(t+2))>>2)>>8&255),s(255&r)),i},e.fromByteArray=function(e){var t,n,r,o,i=e.length%3,u="";function a(e){return"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e)}for(t=0,r=e.length-i;t<r;t+=3)n=(e[t]<<16)+(e[t+1]<<8)+e[t+2],u+=a((o=n)>>18&63)+a(o>>12&63)+a(o>>6&63)+a(63&o);switch(i){case 1:u+=a((n=e[e.length-1])>>2),u+=a(n<<4&63),u+="==";break;case 2:u+=a((n=(e[e.length-2]<<8)+e[e.length-1])>>10),u+=a(n>>4&63),u+=a(n<<2&63),u+="="}return u}}(void 0===f?this.base64js={}:f)}).call(this,e("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js","/node_modules/gulp-browserify/node_modules/base64-js/lib")},{buffer:3,lYpoI2:10}],3:[function(O,e,H){(function(e,t,h,n,r,o,i,u,a){var s=O("base64-js"),f=O("ieee754");function h(e,t,n){if(!(this instanceof h))return new h(e,t,n);var r,o,i,u,a,s=typeof e;if("base64"===t&&"string"==s)for(e=(r=e).trim?r.trim():r.replace(/^\s+|\s+$/g,"");e.length%4!=0;)e+="=";if("number"==s)o=x(e);else if("string"==s)o=h.byteLength(e,t);else{if("object"!=s)throw new Error("First argument needs to be a number, array or string.");o=x(e.length)}if(h._useTypedArrays?i=h._augment(new Uint8Array(o)):((i=this).length=o,i._isBuffer=!0),h._useTypedArrays&&"number"==typeof e.byteLength)i._set(e);else if(S(a=e)||h.isBuffer(a)||a&&"object"==typeof a&&"number"==typeof a.length)for(u=0;u<o;u++)h.isBuffer(e)?i[u]=e.readUInt8(u):i[u]=e[u];else if("string"==s)i.write(e,0,t);else if("number"==s&&!h._useTypedArrays&&!n)for(u=0;u<o;u++)i[u]=0;return i}function p(e,t,n,r){return h._charsWritten=T(function(e){for(var t=[],n=0;n<e.length;n++)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function g(e,t,n,r){return h._charsWritten=T(function(e){for(var t,n,r,o=[],i=0;i<e.length;i++)t=e.charCodeAt(i),n=t>>8,r=t%256,o.push(r),o.push(n);return o}(t),e,n,r)}function c(e,t,n){var r="";n=Math.min(e.length,n);for(var o=t;o<n;o++)r+=String.fromCharCode(e[o]);return r}function l(e,t,n,r){r||(D("boolean"==typeof n,"missing or invalid endian"),D(null!=t,"missing offset"),D(t+1<e.length,"Trying to read beyond buffer length"));var o,i=e.length;if(!(i<=t))return n?(o=e[t],t+1<i&&(o|=e[t+1]<<8)):(o=e[t]<<8,t+1<i&&(o|=e[t+1])),o}function d(e,t,n,r){r||(D("boolean"==typeof n,"missing or invalid endian"),D(null!=t,"missing offset"),D(t+3<e.length,"Trying to read beyond buffer length"));var o,i=e.length;if(!(i<=t))return n?(t+2<i&&(o=e[t+2]<<16),t+1<i&&(o|=e[t+1]<<8),o|=e[t],t+3<i&&(o+=e[t+3]<<24>>>0)):(t+1<i&&(o=e[t+1]<<16),t+2<i&&(o|=e[t+2]<<8),t+3<i&&(o|=e[t+3]),o+=e[t]<<24>>>0),o}function y(e,t,n,r){if(r||(D("boolean"==typeof n,"missing or invalid endian"),D(null!=t,"missing offset"),D(t+1<e.length,"Trying to read beyond buffer length")),!(e.length<=t)){var o=l(e,t,n,!0);return 32768&o?-1*(65535-o+1):o}}function w(e,t,n,r){if(r||(D("boolean"==typeof n,"missing or invalid endian"),D(null!=t,"missing offset"),D(t+3<e.length,"Trying to read beyond buffer length")),!(e.length<=t)){var o=d(e,t,n,!0);return 2147483648&o?-1*(4294967295-o+1):o}}function b(e,t,n,r){return r||(D("boolean"==typeof n,"missing or invalid endian"),D(t+3<e.length,"Trying to read beyond buffer length")),f.read(e,t,n,23,4)}function m(e,t,n,r){return r||(D("boolean"==typeof n,"missing or invalid endian"),D(t+7<e.length,"Trying to read beyond buffer length")),f.read(e,t,n,52,8)}function v(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+1<e.length,"trying to write beyond buffer length"),N(t,65535));var i=e.length;if(!(i<=n))for(var u=0,a=Math.min(i-n,2);u<a;u++)e[n+u]=(t&255<<8*(r?u:1-u))>>>8*(r?u:1-u)}function _(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+3<e.length,"trying to write beyond buffer length"),N(t,4294967295));var i=e.length;if(!(i<=n))for(var u=0,a=Math.min(i-n,4);u<a;u++)e[n+u]=t>>>8*(r?u:3-u)&255}function E(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+1<e.length,"Trying to write beyond buffer length"),Y(t,32767,-32768)),e.length<=n||v(e,0<=t?t:65535+t+1,n,r,o)}function I(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+3<e.length,"Trying to write beyond buffer length"),Y(t,2147483647,-2147483648)),e.length<=n||_(e,0<=t?t:4294967295+t+1,n,r,o)}function A(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+3<e.length,"Trying to write beyond buffer length"),F(t,34028234663852886e22,-34028234663852886e22)),e.length<=n||f.write(e,t,n,r,23,4)}function B(e,t,n,r,o){o||(D(null!=t,"missing value"),D("boolean"==typeof r,"missing or invalid endian"),D(null!=n,"missing offset"),D(n+7<e.length,"Trying to write beyond buffer length"),F(t,17976931348623157e292,-17976931348623157e292)),e.length<=n||f.write(e,t,n,r,52,8)}H.Buffer=h,H.SlowBuffer=h,H.INSPECT_MAX_BYTES=50,h.poolSize=8192,h._useTypedArrays=function(){try{var e=new ArrayBuffer(0),t=new Uint8Array(e);return t.foo=function(){return 42},42===t.foo()&&"function"==typeof t.subarray}catch(e){return!1}}(),h.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"raw":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},h.isBuffer=function(e){return!(null==e||!e._isBuffer)},h.byteLength=function(e,t){var n;switch(e+="",t||"utf8"){case"hex":n=e.length/2;break;case"utf8":case"utf-8":n=C(e).length;break;case"ascii":case"binary":case"raw":n=e.length;break;case"base64":n=k(e).length;break;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":n=2*e.length;break;default:throw new Error("Unknown encoding")}return n},h.concat=function(e,t){if(D(S(e),"Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."),0===e.length)return new h(0);if(1===e.length)return e[0];var n;if("number"!=typeof t)for(n=t=0;n<e.length;n++)t+=e[n].length;var r=new h(t),o=0;for(n=0;n<e.length;n++){var i=e[n];i.copy(r,o),o+=i.length}return r},h.prototype.write=function(e,t,n,r){if(isFinite(t))isFinite(n)||(r=n,n=void 0);else{var o=r;r=t,t=n,n=o}t=Number(t)||0;var i,u,a,s,f,c,l,d=this.length-t;switch((!n||d<(n=Number(n)))&&(n=d),r=String(r||"utf8").toLowerCase()){case"hex":i=function(e,t,n,r){n=Number(n)||0;var o=e.length-n;(!r||o<(r=Number(r)))&&(r=o);var i=t.length;D(i%2==0,"Invalid hex string"),i/2<r&&(r=i/2);for(var u=0;u<r;u++){var a=parseInt(t.substr(2*u,2),16);D(!isNaN(a),"Invalid hex string"),e[n+u]=a}return h._charsWritten=2*u,u}(this,e,t,n);break;case"utf8":case"utf-8":f=this,c=t,l=n,i=h._charsWritten=T(C(e),f,c,l);break;case"ascii":i=p(this,e,t,n);break;case"binary":i=p(this,e,t,n);break;case"base64":u=this,a=t,s=n,i=h._charsWritten=T(k(e),u,a,s);break;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":i=g(this,e,t,n);break;default:throw new Error("Unknown encoding")}return i},h.prototype.toString=function(e,t,n){var r,o,i,u,a=this;if(e=String(e||"utf8").toLowerCase(),t=Number(t)||0,(n=void 0!==n?Number(n):n=a.length)===t)return"";switch(e){case"hex":r=function(e,t,n){var r=e.length;(!t||t<0)&&(t=0);(!n||n<0||r<n)&&(n=r);for(var o="",i=t;i<n;i++)o+=j(e[i]);return o}(a,t,n);break;case"utf8":case"utf-8":r=function(e,t,n){var r="",o="";n=Math.min(e.length,n);for(var i=t;i<n;i++)e[i]<=127?(r+=M(o)+String.fromCharCode(e[i]),o=""):o+="%"+e[i].toString(16);return r+M(o)}(a,t,n);break;case"ascii":r=c(a,t,n);break;case"binary":r=c(a,t,n);break;case"base64":o=a,u=n,r=0===(i=t)&&u===o.length?s.fromByteArray(o):s.fromByteArray(o.slice(i,u));break;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":r=function(e,t,n){for(var r=e.slice(t,n),o="",i=0;i<r.length;i+=2)o+=String.fromCharCode(r[i]+256*r[i+1]);return o}(a,t,n);break;default:throw new Error("Unknown encoding")}return r},h.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}},h.prototype.copy=function(e,t,n,r){if(n=n||0,r||0===r||(r=this.length),t=t||0,r!==n&&0!==e.length&&0!==this.length){D(n<=r,"sourceEnd < sourceStart"),D(0<=t&&t<e.length,"targetStart out of bounds"),D(0<=n&&n<this.length,"sourceStart out of bounds"),D(0<=r&&r<=this.length,"sourceEnd out of bounds"),r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var o=r-n;if(o<100||!h._useTypedArrays)for(var i=0;i<o;i++)e[i+t]=this[i+n];else e._set(this.subarray(n,n+o),t)}},h.prototype.slice=function(e,t){var n=this.length;if(e=U(e,n,0),t=U(t,n,n),h._useTypedArrays)return h._augment(this.subarray(e,t));for(var r=t-e,o=new h(r,void 0,!0),i=0;i<r;i++)o[i]=this[i+e];return o},h.prototype.get=function(e){return console.log(".get() is deprecated. Access using array indexes instead."),this.readUInt8(e)},h.prototype.set=function(e,t){return console.log(".set() is deprecated. Access using array indexes instead."),this.writeUInt8(e,t)},h.prototype.readUInt8=function(e,t){if(t||(D(null!=e,"missing offset"),D(e<this.length,"Trying to read beyond buffer length")),!(e>=this.length))return this[e]},h.prototype.readUInt16LE=function(e,t){return l(this,e,!0,t)},h.prototype.readUInt16BE=function(e,t){return l(this,e,!1,t)},h.prototype.readUInt32LE=function(e,t){return d(this,e,!0,t)},h.prototype.readUInt32BE=function(e,t){return d(this,e,!1,t)},h.prototype.readInt8=function(e,t){if(t||(D(null!=e,"missing offset"),D(e<this.length,"Trying to read beyond buffer length")),!(e>=this.length))return 128&this[e]?-1*(255-this[e]+1):this[e]},h.prototype.readInt16LE=function(e,t){return y(this,e,!0,t)},h.prototype.readInt16BE=function(e,t){return y(this,e,!1,t)},h.prototype.readInt32LE=function(e,t){return w(this,e,!0,t)},h.prototype.readInt32BE=function(e,t){return w(this,e,!1,t)},h.prototype.readFloatLE=function(e,t){return b(this,e,!0,t)},h.prototype.readFloatBE=function(e,t){return b(this,e,!1,t)},h.prototype.readDoubleLE=function(e,t){return m(this,e,!0,t)},h.prototype.readDoubleBE=function(e,t){return m(this,e,!1,t)},h.prototype.writeUInt8=function(e,t,n){n||(D(null!=e,"missing value"),D(null!=t,"missing offset"),D(t<this.length,"trying to write beyond buffer length"),N(e,255)),t>=this.length||(this[t]=e)},h.prototype.writeUInt16LE=function(e,t,n){v(this,e,t,!0,n)},h.prototype.writeUInt16BE=function(e,t,n){v(this,e,t,!1,n)},h.prototype.writeUInt32LE=function(e,t,n){_(this,e,t,!0,n)},h.prototype.writeUInt32BE=function(e,t,n){_(this,e,t,!1,n)},h.prototype.writeInt8=function(e,t,n){n||(D(null!=e,"missing value"),D(null!=t,"missing offset"),D(t<this.length,"Trying to write beyond buffer length"),Y(e,127,-128)),t>=this.length||(0<=e?this.writeUInt8(e,t,n):this.writeUInt8(255+e+1,t,n))},h.prototype.writeInt16LE=function(e,t,n){E(this,e,t,!0,n)},h.prototype.writeInt16BE=function(e,t,n){E(this,e,t,!1,n)},h.prototype.writeInt32LE=function(e,t,n){I(this,e,t,!0,n)},h.prototype.writeInt32BE=function(e,t,n){I(this,e,t,!1,n)},h.prototype.writeFloatLE=function(e,t,n){A(this,e,t,!0,n)},h.prototype.writeFloatBE=function(e,t,n){A(this,e,t,!1,n)},h.prototype.writeDoubleLE=function(e,t,n){B(this,e,t,!0,n)},h.prototype.writeDoubleBE=function(e,t,n){B(this,e,t,!1,n)},h.prototype.fill=function(e,t,n){if(e=e||0,t=t||0,n=n||this.length,"string"==typeof e&&(e=e.charCodeAt(0)),D("number"==typeof e&&!isNaN(e),"value is not a number"),D(t<=n,"end < start"),n!==t&&0!==this.length){D(0<=t&&t<this.length,"start out of bounds"),D(0<=n&&n<=this.length,"end out of bounds");for(var r=t;r<n;r++)this[r]=e}},h.prototype.inspect=function(){for(var e=[],t=this.length,n=0;n<t;n++)if(e[n]=j(this[n]),n===H.INSPECT_MAX_BYTES){e[n+1]="...";break}return"<Buffer "+e.join(" ")+">"},h.prototype.toArrayBuffer=function(){if("undefined"==typeof Uint8Array)throw new Error("Buffer.toArrayBuffer not supported in this browser");if(h._useTypedArrays)return new h(this).buffer;for(var e=new Uint8Array(this.length),t=0,n=e.length;t<n;t+=1)e[t]=this[t];return e.buffer};var L=h.prototype;function U(e,t,n){return"number"!=typeof e?n:t<=(e=~~e)?t:0<=e||0<=(e+=t)?e:0}function x(e){return(e=~~Math.ceil(+e))<0?0:e}function S(e){return(Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)})(e)}function j(e){return e<16?"0"+e.toString(16):e.toString(16)}function C(e){for(var t=[],n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<=127)t.push(e.charCodeAt(n));else{var o=n;55296<=r&&r<=57343&&n++;for(var i=encodeURIComponent(e.slice(o,n+1)).substr(1).split("%"),u=0;u<i.length;u++)t.push(parseInt(i[u],16))}}return t}function k(e){return s.toByteArray(e)}function T(e,t,n,r){for(var o=0;o<r&&!(o+n>=t.length||o>=e.length);o++)t[o+n]=e[o];return o}function M(e){try{return decodeURIComponent(e)}catch(e){return String.fromCharCode(65533)}}function N(e,t){D("number"==typeof e,"cannot write a non-number as a number"),D(0<=e,"specified a negative value for writing an unsigned value"),D(e<=t,"value is larger than maximum value for type"),D(Math.floor(e)===e,"value has a fractional component")}function Y(e,t,n){D("number"==typeof e,"cannot write a non-number as a number"),D(e<=t,"value larger than maximum allowed value"),D(n<=e,"value smaller than minimum allowed value"),D(Math.floor(e)===e,"value has a fractional component")}function F(e,t,n){D("number"==typeof e,"cannot write a non-number as a number"),D(e<=t,"value larger than maximum allowed value"),D(n<=e,"value smaller than minimum allowed value")}function D(e,t){if(!e)throw new Error(t||"Failed assertion")}h._augment=function(e){return e._isBuffer=!0,e._get=e.get,e._set=e.set,e.get=L.get,e.set=L.set,e.write=L.write,e.toString=L.toString,e.toLocaleString=L.toString,e.toJSON=L.toJSON,e.copy=L.copy,e.slice=L.slice,e.readUInt8=L.readUInt8,e.readUInt16LE=L.readUInt16LE,e.readUInt16BE=L.readUInt16BE,e.readUInt32LE=L.readUInt32LE,e.readUInt32BE=L.readUInt32BE,e.readInt8=L.readInt8,e.readInt16LE=L.readInt16LE,e.readInt16BE=L.readInt16BE,e.readInt32LE=L.readInt32LE,e.readInt32BE=L.readInt32BE,e.readFloatLE=L.readFloatLE,e.readFloatBE=L.readFloatBE,e.readDoubleLE=L.readDoubleLE,e.readDoubleBE=L.readDoubleBE,e.writeUInt8=L.writeUInt8,e.writeUInt16LE=L.writeUInt16LE,e.writeUInt16BE=L.writeUInt16BE,e.writeUInt32LE=L.writeUInt32LE,e.writeUInt32BE=L.writeUInt32BE,e.writeInt8=L.writeInt8,e.writeInt16LE=L.writeInt16LE,e.writeInt16BE=L.writeInt16BE,e.writeInt32LE=L.writeInt32LE,e.writeInt32BE=L.writeInt32BE,e.writeFloatLE=L.writeFloatLE,e.writeFloatBE=L.writeFloatBE,e.writeDoubleLE=L.writeDoubleLE,e.writeDoubleBE=L.writeDoubleBE,e.fill=L.fill,e.inspect=L.inspect,e.toArrayBuffer=L.toArrayBuffer,e}}).call(this,O("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},O("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/buffer/index.js","/node_modules/gulp-browserify/node_modules/buffer")},{"base64-js":2,buffer:3,ieee754:11,lYpoI2:10}],4:[function(l,d,e){(function(e,t,u,n,r,o,i,a,s){u=l("buffer").Buffer;var f=4,c=new u(f);c.fill(0);d.exports={hash:function(e,t,n,r){return u.isBuffer(e)||(e=new u(e)),function(e,t,n){for(var r=new u(t),o=n?r.writeInt32BE:r.writeInt32LE,i=0;i<e.length;i++)o.call(r,e[i],4*i,!0);return r}(t(function(e,t){if(e.length%f!=0){var n=e.length+(f-e.length%f);e=u.concat([e,c],n)}for(var r=[],o=t?e.readInt32BE:e.readInt32LE,i=0;i<e.length;i+=f)r.push(o.call(e,i));return r}(e,r),8*e.length),n,r)}}}).call(this,l("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},l("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{buffer:3,lYpoI2:10}],5:[function(w,e,b){(function(e,t,a,n,r,o,i,u,s){a=w("buffer").Buffer;var f=w("./sha"),c=w("./sha256"),l=w("./rng"),d={sha1:f,sha256:c,md5:w("./md5")},h=64,p=new a(h);function g(e,r){var o=d[e=e||"sha1"],i=[];return o||y("algorithm:",e,"is not yet supported"),{update:function(e){return a.isBuffer(e)||(e=new a(e)),i.push(e),e.length,this},digest:function(e){var t=a.concat(i),n=r?function(e,t,n){a.isBuffer(t)||(t=new a(t)),a.isBuffer(n)||(n=new a(n)),t.length>h?t=e(t):t.length<h&&(t=a.concat([t,p],h));for(var r=new a(h),o=new a(h),i=0;i<h;i++)r[i]=54^t[i],o[i]=92^t[i];var u=e(a.concat([r,n]));return e(a.concat([o,u]))}(o,r,t):o(t);return i=null,e?n.toString(e):n}}}function y(){var e=[].slice.call(arguments).join(" ");throw new Error([e,"we accept pull requests","http://github.com/dominictarr/crypto-browserify"].join("\n"))}p.fill(0),b.createHash=function(e){return g(e)},b.createHmac=function(e,t){return g(e,t)},b.randomBytes=function(e,t){if(!t||!t.call)return new a(l(e));try{t.call(this,void 0,new a(l(e)))}catch(e){t(e)}},function(e,t){for(var n in e)t(e[n],n)}(["createCredentials","createCipher","createCipheriv","createDecipher","createDecipheriv","createSign","createVerify","createDiffieHellman","pbkdf2"],function(e){b[e]=function(){y("sorry,",e,"is not implemented yet")}})}).call(this,w("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},w("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{"./md5":6,"./rng":7,"./sha":8,"./sha256":9,buffer:3,lYpoI2:10}],6:[function(w,b,e){(function(e,t,n,r,o,i,u,a,s){var f=w("./helpers");function c(e,t){e[t>>5]|=128<<t%32,e[14+(t+64>>>9<<4)]=t;for(var n=1732584193,r=-271733879,o=-1732584194,i=271733878,u=0;u<e.length;u+=16){var a=n,s=r,f=o,c=i;n=d(n,r,o,i,e[u+0],7,-680876936),i=d(i,n,r,o,e[u+1],12,-389564586),o=d(o,i,n,r,e[u+2],17,606105819),r=d(r,o,i,n,e[u+3],22,-1044525330),n=d(n,r,o,i,e[u+4],7,-176418897),i=d(i,n,r,o,e[u+5],12,1200080426),o=d(o,i,n,r,e[u+6],17,-1473231341),r=d(r,o,i,n,e[u+7],22,-45705983),n=d(n,r,o,i,e[u+8],7,1770035416),i=d(i,n,r,o,e[u+9],12,-1958414417),o=d(o,i,n,r,e[u+10],17,-42063),r=d(r,o,i,n,e[u+11],22,-1990404162),n=d(n,r,o,i,e[u+12],7,1804603682),i=d(i,n,r,o,e[u+13],12,-40341101),o=d(o,i,n,r,e[u+14],17,-1502002290),n=h(n,r=d(r,o,i,n,e[u+15],22,1236535329),o,i,e[u+1],5,-165796510),i=h(i,n,r,o,e[u+6],9,-1069501632),o=h(o,i,n,r,e[u+11],14,643717713),r=h(r,o,i,n,e[u+0],20,-373897302),n=h(n,r,o,i,e[u+5],5,-701558691),i=h(i,n,r,o,e[u+10],9,38016083),o=h(o,i,n,r,e[u+15],14,-660478335),r=h(r,o,i,n,e[u+4],20,-405537848),n=h(n,r,o,i,e[u+9],5,568446438),i=h(i,n,r,o,e[u+14],9,-1019803690),o=h(o,i,n,r,e[u+3],14,-187363961),r=h(r,o,i,n,e[u+8],20,1163531501),n=h(n,r,o,i,e[u+13],5,-1444681467),i=h(i,n,r,o,e[u+2],9,-51403784),o=h(o,i,n,r,e[u+7],14,1735328473),n=p(n,r=h(r,o,i,n,e[u+12],20,-1926607734),o,i,e[u+5],4,-378558),i=p(i,n,r,o,e[u+8],11,-2022574463),o=p(o,i,n,r,e[u+11],16,1839030562),r=p(r,o,i,n,e[u+14],23,-35309556),n=p(n,r,o,i,e[u+1],4,-1530992060),i=p(i,n,r,o,e[u+4],11,1272893353),o=p(o,i,n,r,e[u+7],16,-155497632),r=p(r,o,i,n,e[u+10],23,-1094730640),n=p(n,r,o,i,e[u+13],4,681279174),i=p(i,n,r,o,e[u+0],11,-358537222),o=p(o,i,n,r,e[u+3],16,-722521979),r=p(r,o,i,n,e[u+6],23,76029189),n=p(n,r,o,i,e[u+9],4,-640364487),i=p(i,n,r,o,e[u+12],11,-421815835),o=p(o,i,n,r,e[u+15],16,530742520),n=g(n,r=p(r,o,i,n,e[u+2],23,-995338651),o,i,e[u+0],6,-198630844),i=g(i,n,r,o,e[u+7],10,1126891415),o=g(o,i,n,r,e[u+14],15,-1416354905),r=g(r,o,i,n,e[u+5],21,-57434055),n=g(n,r,o,i,e[u+12],6,1700485571),i=g(i,n,r,o,e[u+3],10,-1894986606),o=g(o,i,n,r,e[u+10],15,-1051523),r=g(r,o,i,n,e[u+1],21,-2054922799),n=g(n,r,o,i,e[u+8],6,1873313359),i=g(i,n,r,o,e[u+15],10,-30611744),o=g(o,i,n,r,e[u+6],15,-1560198380),r=g(r,o,i,n,e[u+13],21,1309151649),n=g(n,r,o,i,e[u+4],6,-145523070),i=g(i,n,r,o,e[u+11],10,-1120210379),o=g(o,i,n,r,e[u+2],15,718787259),r=g(r,o,i,n,e[u+9],21,-343485551),n=y(n,a),r=y(r,s),o=y(o,f),i=y(i,c)}return Array(n,r,o,i)}function l(e,t,n,r,o,i){return y((u=y(y(t,e),y(r,i)))<<(a=o)|u>>>32-a,n);var u,a}function d(e,t,n,r,o,i,u){return l(t&n|~t&r,e,t,o,i,u)}function h(e,t,n,r,o,i,u){return l(t&r|n&~r,e,t,o,i,u)}function p(e,t,n,r,o,i,u){return l(t^n^r,e,t,o,i,u)}function g(e,t,n,r,o,i,u){return l(n^(t|~r),e,t,o,i,u)}function y(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}b.exports=function(e){return f.hash(e,c,16)}}).call(this,w("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},w("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{"./helpers":4,buffer:3,lYpoI2:10}],7:[function(e,l,t){(function(e,t,n,r,o,i,u,a,s){var f,c;f=function(e){for(var t,n=new Array(e),r=0;r<e;r++)0==(3&r)&&(t=4294967296*Math.random()),n[r]=t>>>((3&r)<<3)&255;return n},l.exports=c||f}).call(this,e("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{buffer:3,lYpoI2:10}],8:[function(l,d,e){(function(e,t,n,r,o,i,u,a,s){var f=l("./helpers");function c(e,t){e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;for(var n,r=Array(80),o=1732584193,i=-271733879,u=-1732584194,a=271733878,s=-1009589776,f=0;f<e.length;f+=16){for(var c=o,l=i,d=u,h=a,p=s,g=0;g<80;g++){r[g]=g<16?e[f+g]:m(r[g-3]^r[g-8]^r[g-14]^r[g-16],1);var y=b(b(m(o,5),w(g,i,u,a)),b(b(s,r[g]),(n=g)<20?1518500249:n<40?1859775393:n<60?-1894007588:-899497514));s=a,a=u,u=m(i,30),i=o,o=y}o=b(o,c),i=b(i,l),u=b(u,d),a=b(a,h),s=b(s,p)}return Array(o,i,u,a,s)}function w(e,t,n,r){return e<20?t&n|~t&r:!(e<40)&&e<60?t&n|t&r|n&r:t^n^r}function b(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function m(e,t){return e<<t|e>>>32-t}d.exports=function(e){return f.hash(e,c,20,!0)}}).call(this,l("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},l("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{"./helpers":4,buffer:3,lYpoI2:10}],9:[function(l,d,e){(function(e,t,n,r,o,i,u,a,s){function B(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function L(e,t){return e>>>t|e<<32-t}function U(e,t){return e>>>t}function f(e,t){var n,r,o,i,u,a,s,f,c,l,d,h,p,g,y,w,b,m,v=new Array(1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298),_=new Array(1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225),E=new Array(64);e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;for(var I=0;I<e.length;I+=16){n=_[0],r=_[1],o=_[2],i=_[3],u=_[4],a=_[5],s=_[6],f=_[7];for(var A=0;A<64;A++)E[A]=A<16?e[A+I]:B(B(B((m=E[A-2],L(m,17)^L(m,19)^U(m,10)),E[A-7]),(b=E[A-15],L(b,7)^L(b,18)^U(b,3))),E[A-16]),c=B(B(B(B(f,L(w=u,6)^L(w,11)^L(w,25)),(y=u)&a^~y&s),v[A]),E[A]),l=B(L(g=n,2)^L(g,13)^L(g,22),(d=n)&(h=r)^d&(p=o)^h&p),f=s,s=a,a=u,u=B(i,c),i=o,o=r,r=n,n=B(c,l);_[0]=B(n,_[0]),_[1]=B(r,_[1]),_[2]=B(o,_[2]),_[3]=B(i,_[3]),_[4]=B(u,_[4]),_[5]=B(a,_[5]),_[6]=B(s,_[6]),_[7]=B(f,_[7])}return _}var c=l("./helpers");d.exports=function(e){return c.hash(e,f,32,!0)}}).call(this,l("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},l("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js","/node_modules/gulp-browserify/node_modules/crypto-browserify")},{"./helpers":4,buffer:3,lYpoI2:10}],10:[function(e,c,t){(function(e,t,n,r,o,i,u,a,s){function f(){}(e=c.exports={}).nextTick=function(){var e="undefined"!=typeof window&&window.setImmediate,t="undefined"!=typeof window&&window.postMessage&&window.addEventListener;if(e)return function(e){return window.setImmediate(e)};if(t){var n=[];return window.addEventListener("message",function(e){var t=e.source;t!==window&&null!==t||"process-tick"!==e.data||(e.stopPropagation(),0<n.length&&n.shift()())},!0),function(e){n.push(e),window.postMessage("process-tick","*")}}return function(e){setTimeout(e,0)}}(),e.title="browser",e.browser=!0,e.env={},e.argv=[],e.on=f,e.addListener=f,e.once=f,e.off=f,e.removeListener=f,e.removeAllListeners=f,e.emit=f,e.binding=function(e){throw new Error("process.binding is not supported")},e.cwd=function(){return"/"},e.chdir=function(e){throw new Error("process.chdir is not supported")}}).call(this,e("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/gulp-browserify/node_modules/process/browser.js","/node_modules/gulp-browserify/node_modules/process")},{buffer:3,lYpoI2:10}],11:[function(e,t,f){(function(e,t,n,r,o,i,u,a,s){f.read=function(e,t,n,r,o){var i,u,a=8*o-r-1,s=(1<<a)-1,f=s>>1,c=-7,l=n?o-1:0,d=n?-1:1,h=e[t+l];for(l+=d,i=h&(1<<-c)-1,h>>=-c,c+=a;0<c;i=256*i+e[t+l],l+=d,c-=8);for(u=i&(1<<-c)-1,i>>=-c,c+=r;0<c;u=256*u+e[t+l],l+=d,c-=8);if(0===i)i=1-f;else{if(i===s)return u?NaN:1/0*(h?-1:1);u+=Math.pow(2,r),i-=f}return(h?-1:1)*u*Math.pow(2,i-r)},f.write=function(e,t,n,r,o,i){var u,a,s,f=8*i-o-1,c=(1<<f)-1,l=c>>1,d=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,h=r?0:i-1,p=r?1:-1,g=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,u=c):(u=Math.floor(Math.log(t)/Math.LN2),t*(s=Math.pow(2,-u))<1&&(u--,s*=2),2<=(t+=1<=u+l?d/s:d*Math.pow(2,1-l))*s&&(u++,s/=2),c<=u+l?(a=0,u=c):1<=u+l?(a=(t*s-1)*Math.pow(2,o),u+=l):(a=t*Math.pow(2,l-1)*Math.pow(2,o),u=0));8<=o;e[n+h]=255&a,h+=p,a/=256,o-=8);for(u=u<<o|a,f+=o;0<f;e[n+h]=255&u,h+=p,u/=256,f-=8);e[n+h-p]|=128*g}}).call(this,e("lYpoI2"),"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/node_modules/ieee754/index.js","/node_modules/ieee754")},{buffer:3,lYpoI2:10}]},{},[1])(1)});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _barcodes = __webpack_require__(2051);

var _barcodes2 = _interopRequireDefault(_barcodes);

var _merge = __webpack_require__(314);

var _merge2 = _interopRequireDefault(_merge);

var _linearizeEncodings = __webpack_require__(2076);

var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);

var _fixOptions = __webpack_require__(2077);

var _fixOptions2 = _interopRequireDefault(_fixOptions);

var _getRenderProperties = __webpack_require__(2078);

var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);

var _optionsFromStrings = __webpack_require__(849);

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _ErrorHandler = __webpack_require__(2084);

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _exceptions = __webpack_require__(852);

var _defaults = __webpack_require__(850);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
module.exports = JsBarcode;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(232);

var _encoder = __webpack_require__(233);

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3.default);

exports.default = EAN;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checksum = checksum;

var _encoder = __webpack_require__(233);

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum(data);
		}

		var _this = _possibleConstructorReturn(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

exports.default = UPC;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(2066);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits(ITF, _Barcode);

	function ITF() {
		_classCallCheck(this, ITF);

		return _possibleConstructorReturn(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants.START_BIN + encoded + _constants.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants.BINARIES[pair[1]];

			return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3.default);

exports.default = ITF;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var defaults = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

exports.default = defaults;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTotalWidthOfEncodings = exports.calculateEncodingAttributes = exports.getBarcodePadding = exports.getEncodingHeight = exports.getMaximumHeightOfEncodings = undefined;

var _merge = __webpack_require__(314);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var size = ctx.measureText(string).width;

	return size;
}

exports.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
exports.getEncodingHeight = getEncodingHeight;
exports.getBarcodePadding = getBarcodePadding;
exports.calculateEncodingAttributes = calculateEncodingAttributes;
exports.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exports.InvalidInputException = InvalidInputException;
exports.InvalidElementException = InvalidElementException;
exports.NoElementException = NoElementException;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(317)["default"];
var toPrimitive = __webpack_require__(2091);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(2102);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(855);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 858 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2118));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;

var noop = function noop() {};

var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: 'div',
  previewTabIndex: 0,
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      }
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: '0.14.16',
      dashVersion: '3.1.3',
      flvVersion: '1.5.0'
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};
exports.defaultProps = defaultProps;

/***/ }),
/* 860 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 860;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": 323,
	"./banner/banner-breadcrumb": 862,
	"./banner/banner-breadcrumb.js": 862,
	"./banner/styles.module.scss": 863,
	"./brands/brand-info": 864,
	"./brands/brand-info.js": 864,
	"./brands/brand-list": 311,
	"./brands/brand-list.js": 311,
	"./brands/brand-list.js.bak": 2127,
	"./brands/styles.module.scss": 445,
	"./brands/vip-gift.module.scss": 865,
	"./catalogues/catalogue-info": 866,
	"./catalogues/catalogue-info-pos": 477,
	"./catalogues/catalogue-info-pos.js": 477,
	"./catalogues/catalogue-info.js": 866,
	"./catalogues/catalogue-info.module.scss": 883,
	"./catalogues/catalogue-list": 459,
	"./catalogues/catalogue-list.js": 459,
	"./catalogues/catalogue-pos": 884,
	"./catalogues/catalogue-pos.js": 884,
	"./catalogues/styles.module.scss": 200,
	"./cibc/cibc-calculation": 885,
	"./cibc/cibc-calculation.js": 885,
	"./cibc/cibc-contact-us": 464,
	"./cibc/cibc-contact-us.js": 464,
	"./cibc/cibc-recruit": 462,
	"./cibc/cibc-recruit.js": 462,
	"./cibc/cibc-servicepoint": 465,
	"./cibc/cibc-servicepoint.js": 465,
	"./cibc/cibc.css": 886,
	"./cibc/styles.module.scss": 240,
	"./customer-service/contact-us": 887,
	"./customer-service/contact-us.js": 887,
	"./customer-service/contact-us.module.scss": 888,
	"./customer-service/faq-us": 463,
	"./customer-service/faq-us.js": 463,
	"./customer-service/feedback": 466,
	"./customer-service/feedback.js": 466,
	"./customer-service/queryOptions": 319,
	"./customer-service/queryOptions.json": 319,
	"./customer-service/queryOptionsDev": 467,
	"./customer-service/queryOptionsDev.json": 467,
	"./customer-service/querySubjectOptions": 321,
	"./customer-service/querySubjectOptions.json": 321,
	"./customer-service/queryTargetOptions": 320,
	"./customer-service/queryTargetOptions copy": 889,
	"./customer-service/queryTargetOptions copy.json": 889,
	"./customer-service/queryTargetOptions.json": 320,
	"./customer-service/retailChannelOptions": 322,
	"./customer-service/retailChannelOptions.json": 322,
	"./customer-service/service-us": 890,
	"./customer-service/service-us.js": 890,
	"./customer-service/styles.module.scss": 241,
	"./editor.scss": 2175,
	"./index": 323,
	"./index.js": 323,
	"./member/member-cobrandedcard": 891,
	"./member/member-cobrandedcard.js": 891,
	"./member/member-hkcard": 892,
	"./member/member-hkcard.js": 892,
	"./news/news-info": 893,
	"./news/news-info.js": 893,
	"./news/news-list": 894,
	"./news/news-list-preview": 895,
	"./news/news-list-preview.js": 895,
	"./news/news-list.js": 894,
	"./news/styles.module.scss": 326,
	"./recipes/recipe-info": 896,
	"./recipes/recipe-info.js": 896,
	"./recipes/recipe-list": 897,
	"./recipes/recipe-list.js": 897,
	"./recipes/styles.module.scss": 479,
	"./repair/repair-info": 898,
	"./repair/repair-info.js": 898,
	"./repair/styles.module.scss": 899,
	"./stock/stock-all": 470,
	"./stock/stock-all.js": 470,
	"./stock/stock-list": 468,
	"./stock/stock-list.js": 468,
	"./stock/stock-store": 900,
	"./stock/stock-store.js": 900,
	"./stock/styles.module.scss": 469,
	"./stores/store-info": 902,
	"./stores/store-info.js": 902,
	"./stores/store-list": 903,
	"./stores/store-list-v2": 443,
	"./stores/store-list-v2.js": 443,
	"./stores/store-list.js": 903,
	"./stores/store-list.js.bak": 904,
	"./stores/store-list.js.bak.mjs": 904,
	"./stores/store-map": 444,
	"./stores/store-map.js": 444,
	"./stores/store-vendor": 905,
	"./stores/store-vendor.js": 905,
	"./stores/styles.module.scss": 130,
	"./style.scss": 2179,
	"./users/styles.module.scss": 156,
	"./users/user-big-platform-process": 457,
	"./users/user-big-platform-process.js": 457,
	"./users/user-carrier-binding": 458,
	"./users/user-carrier-binding.js": 458,
	"./users/user-connect": 456,
	"./users/user-connect.js": 456,
	"./users/user-invoice": 454,
	"./users/user-invoice-carrier-consolidation": 455,
	"./users/user-invoice-carrier-consolidation.js": 455,
	"./users/user-invoice.js": 454,
	"./users/user-loyaltyprofile": 906,
	"./users/user-loyaltyprofile.js": 906,
	"./users/user-password": 450,
	"./users/user-password-cc": 451,
	"./users/user-password-cc.js": 451,
	"./users/user-password-oca": 907,
	"./users/user-password-oca.js": 907,
	"./users/user-password.js": 450,
	"./users/user-payment": 452,
	"./users/user-payment-oca": 908,
	"./users/user-payment-oca.js": 908,
	"./users/user-payment.js": 452,
	"./users/user-point": 453,
	"./users/user-point.js": 453,
	"./users/user-profile": 448,
	"./users/user-profile-cc": 449,
	"./users/user-profile-cc.js": 449,
	"./users/user-profile-oca": 909,
	"./users/user-profile-oca.js": 909,
	"./users/user-profile.js": 448,
	"./users/user-sso-login": 446,
	"./users/user-sso-login-cc": 447,
	"./users/user-sso-login-cc.js": 447,
	"./users/user-sso-login-oca": 910,
	"./users/user-sso-login-oca.js": 910,
	"./users/user-sso-login.js": 446,
	"./widget/styles.module.scss": 246,
	"./widget/widget-facebook": 911,
	"./widget/widget-facebook-mall": 912,
	"./widget/widget-facebook-mall.js": 912,
	"./widget/widget-facebook.js": 911,
	"./widget/widget-weather": 913,
	"./widget/widget-weather.js": 913,
	"./widget/widget-wine": 914,
	"./widget/widget-wine.js": 914
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogueListEditor", function() { return CatalogueListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultListInfo={"current":1,//目前頁數
"page_size":10,//一頁幾筆
"total":1,//以此query條件，總共幾筆資料
"rows":[]// 前端頁面
};var CatalogueList=function(_Component){_inherits(CatalogueList,_Component);function CatalogueList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueList.__proto__||Object.getPrototypeOf(CatalogueList)).call.apply(_ref,[this].concat(args))),_this),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueList,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){return wp.element.createElement('div',{'class':'banner banner-breadcrumb'},wp.element.createElement('div',{'class':'banner-img'},wp.element.createElement('img',{src:'assets/img/banner/banner-catalog.png',alt:'\u4FC3\u92B7\u76EE\u9304'})),wp.element.createElement('div',{'class':'breadcrumb-inner'},wp.element.createElement('h3',null,'\u4FC3\u92B7\u76EE\u9304'),wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'}))));}}]);return CatalogueList;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueListEditor=function(_Component2){_inherits(CatalogueListEditor,_Component2);function CatalogueListEditor(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,CatalogueListEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=CatalogueListEditor.__proto__||Object.getPrototypeOf(CatalogueListEditor)).call.apply(_ref2,[this].concat(args))),_this2),_this2.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this2.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(CatalogueListEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this3=this;var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'// layout="vertical"
// onFinish={values => this.submitData(values)}
,onValuesChange:function onValuesChange(changedFields,allFields){return _this3.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__["a" /* genFormItemAtrribute */])('show_category_title','目錄標題','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_switch___default.a,{checkedChildren:'\u986F\u793A',unCheckedChildren:'\u96B1\u85CF'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_ids','目錄類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(options,'catalogue_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:item.id},item.name));}})))));}}]);return CatalogueListEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1ZS2e","container_1":"container_1___GUSat","container_2":"container_2___3ymFK"};

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrandInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandInfoEditor", function() { return BrandInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_img_icon_google_map_svg__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_img_icon_google_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_assets_img_icon_google_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_brands_brand_list__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_braft_editor__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_braft_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_braft_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,"VC_CONFIG.PLUGIN_ASSETS_URL");var INDEX_URL=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,"VC_CONFIG.INDEX_URL");var Locale=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,"VC_CONFIG.Locale");var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.split(text,"\n"),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],{key:idx},line,wp.element.createElement("br",null));});};var default_image=PLUGIN_ASSETS_URL+"img/banner/store/banner-info.png";var swiper129=null;var swiper130=null;function isMobileDevice(){var mobileDevices=["Android","iPhone","iPad"];var isMobileDevice=false;for(var i=0;i<mobileDevices.length;i++){if(navigator.userAgent.match(mobileDevices[i])){isMobileDevice=true;}}return isMobileDevice;}// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
var BrandInfo=function(_Component){_inherits(BrandInfo,_Component);function BrandInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrandInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrandInfo.__proto__||Object.getPrototypeOf(BrandInfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:"info",brandInfo:undefined,categoryList:[],category129:[],category130:[]},_this.loadData=function(){var urlQuery=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getURLQuery();var brand=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(urlQuery,"brand");if(!brand)return _this.props.history.replace("/brands");_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+("/api/v1/brands/"+brand),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?"發生錯誤":_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning(reason);_this.props.history.replace("/brands");return;}_this.setState({brandInfo:data});_this.loadHTMLdesc(data);});},_this.loadHTMLdesc=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(Locale=="en_US"&&info.en_desc){document.getElementById("output-desc-content").innerHTML=info.en_desc;}else{document.getElementById("output-desc-content").innerHTML=info.desc;}},_this.reloadSwiper129=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function(){if(_this.state.category129.length>0){var Swiper=window.Swiper;if(!Swiper||swiper129)return;console.log("1");swiper129=new Swiper(".swiper-container-129",{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:"auto",autoplay:{delay:5000},pagination:{el:".swiper-container-129 .swiper-pagination",clickable:true}});}},500),_this.reloadSwiper130=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function(){if(_this.state.category130.length>0){var Swiper=window.Swiper;if(!Swiper||swiper130)return;console.log("2");swiper130=new Swiper(".swiper-container-130",{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:"auto",autoplay:{delay:5000},pagination:{el:".swiper-container-130 .swiper-pagination",clickable:true}});}},500),_this.fetchCategoryList=function(){var brandInfo=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this,"state.brandInfo",{});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+"/api/v1/news",{page:1,page_size:"all"},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?"發生錯誤":_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false||code!==200)return;_this.setState({categoryList:data.rows},function(){var categoryList=_this.state.categoryList;var category129=categoryList.filter(function(c){return c.category_id===129;});//品牌活動快訊
var category130=categoryList.filter(function(c){return c.category_id===130;});//產品介紹
_this.reloadSwiper129();_this.reloadSwiper130();_this.setState({category129:category129,category130:category130});});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrandInfo,[{key:"componentDidMount",value:function componentDidMount(){this.setState({tabType:__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getHashValue("tab")||"info"});this.loadData();this.fetchCategoryList();}},{key:"render",value:function render(){var _state=this.state,category129=_state.category129,category130=_state.category130;var brandInfo=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,"state.brandInfo",{});var news=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,"state.brandInfo.news",[]);var Local=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,"VC_CONFIG.Locale");console.log("bbbbbb",category129,category130);category129=category129.filter(function(c){return c.brands.includes(brandInfo.id);});category130=category130.filter(function(c){return c.brands.includes(brandInfo.id);});var isMobile=isMobileDevice();console.log("sssss",category129,category130);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,wp.element.createElement("div",{"class":"bg-light"},wp.element.createElement("div",{"class":"container"},wp.element.createElement("div",{"class":"breadcrumb-wrap py-4 m-0"},wp.element.createElement("nav",{"aria-label":"breadcrumb"},wp.element.createElement("ol",{"class":"breadcrumb"},wp.element.createElement("li",{"class":"breadcrumb-item"},wp.element.createElement("a",{href:""+window.VC_CONFIG.INDEX_URL+(Local=="en_US"?"/en":"")},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])("首頁","cec-plugin-stores"))),wp.element.createElement("li",{"class":"breadcrumb-item"},wp.element.createElement("a",{href:window.VC_CONFIG.INDEX_URL+"/shopping-mall"+(Local=="en_US"?"-en":"")},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])("購物中心","cec-plugin-stores"))),wp.element.createElement("li",{"class":"breadcrumb-item active","aria-current":"page",id:"name"},Locale=="en_US"&&brandInfo.en_name&&brandInfo.en_name,(Locale=="zh_TW"||Locale=="en_US"&&!brandInfo.en_name)&&brandInfo.name)))))),wp.element.createElement("div",{"class":"banner"},wp.element.createElement("div",{"class":"banner-image brand-image",style:{height:isMobile?200:400}},wp.element.createElement("img",{src:brandInfo.image_url||default_image,alt:""}),wp.element.createElement("h3",{"class":"title"},"")),wp.element.createElement("div",{"class":"store-brand-logo-wrapper",style:{width:1200,margin:"0 auto"}},wp.element.createElement("div",{"class":"store-brand-logo-link",role:"button",style:{width:isMobile?144:255,height:isMobile?144:255,marginLeft:isMobile?15:0,left:"5%",borderRadius:8,position:"absolute",top:"50%",transform:"translateY(-50%)",zIndex:1}},wp.element.createElement("img",{src:brandInfo.logo_url,alt:""})))),wp.element.createElement("main",{"class":"bg-light"},wp.element.createElement("div",{"class":"container"},wp.element.createElement("div",{"class":"brand-info mb-4",style:{marginTop:0}},wp.element.createElement("div",{"class":"row align-items-end"},wp.element.createElement("div",{"class":"col-12"},wp.element.createElement("div",{"class":"brand-info-text mt-5"},wp.element.createElement("h4",{"class":"h3 text-navy"},Locale=="zh_TW"||Locale=="en_US"&&!brandInfo.en_name&&brandInfo.name,Locale=="en_US"&&brandInfo.en_name&&brandInfo.en_name),wp.element.createElement("p",{id:"output-desc-content","class":"p text-navy text-justify mt-3 mt-lg-5 mb-0"}))))),wp.element.createElement("div",{"class":"row"},category129.length>0&&wp.element.createElement("div",{"class":"col-12 col-md-6"},wp.element.createElement("h4",{"class":"heading-title text-center"},"\u6D3B\u52D5\u5FEB\u8A0A"),wp.element.createElement("hr",{"class":"border-top border-gray mt-0 mb-4"}),wp.element.createElement("div",{"class":"swiper-container-129",style:{overflow:"hidden"}},wp.element.createElement("div",{"class":"swiper-wrapper"},category129.map(function(item,idx){return wp.element.createElement("div",{key:idx,"class":"swiper-slide"},wp.element.createElement("a",{"class":"card text-decoration-none border-0 shadow-0 p-0",role:"button",href:__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getNewsLink(item),onClick:function onClick(e){if(__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getNewsLink(item)==="#"){e.preventDefault();}}},wp.element.createElement("div",{"class":"img-2-1",style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(item,"images.0.url")+")"}}),wp.element.createElement("div",{"class":"card-body p-3"},wp.element.createElement("h5",{"class":"text-navy limit-line-1 mb-2 h6"},item.name))));})),wp.element.createElement("div",{"class":"swiper-pagination"}))),category130.length>0&&wp.element.createElement("div",{"class":"col-12 col-md-6"},wp.element.createElement("h4",{"class":"heading-title text-center"},"\u7522\u54C1\u4ECB\u7D39"),wp.element.createElement("hr",{"class":"border-top border-gray mt-0 mb-4"}),wp.element.createElement("div",{"class":"swiper-container-130",style:{overflow:"hidden"}},wp.element.createElement("div",{"class":"swiper-wrapper"},category130.map(function(item,idx){return wp.element.createElement("div",{key:idx,"class":"swiper-slide"},wp.element.createElement("a",{"class":"card text-decoration-none border-0 shadow-0 p-0",role:"button",href:__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getNewsLink(item),onClick:function onClick(e){if(__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getNewsLink(item)==="#"){e.preventDefault();}}},wp.element.createElement("div",{"class":"img-2-1",style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(item,"images.0.url")+")"}}),wp.element.createElement("div",{"class":"card-body p-3"},wp.element.createElement("h5",{"class":"text-navy limit-line-1 mb-2 h6"},item.name))));})),wp.element.createElement("div",{"class":"swiper-pagination"})))),wp.element.createElement("div",{"class":"container"},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.groupBy(brandInfo.deliveries,function(vendor){return vendor.vendor_id;}),function(vendors,idx){var vendorHasIcon=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(vendors,function(vendor){return vendor.image!==null;});return wp.element.createElement("a",{role:"button",key:idx,"class":"my-lg-5 my-3",onClick:function onClick(e){__WEBPACK_IMPORTED_MODULE_3_antd_lib_modal___default.a.info({title:"請選擇品牌所在分店",okText:"取消",content:wp.element.createElement("div",{"class":"row no-gutters mx-n2",id:"item"},vendors.map(function(vendor,idx){return wp.element.createElement("div",{key:idx,"class":"col-auto px-2"},wp.element.createElement("a",{href:vendor.url},wp.element.createElement("span",{"class":"p btn btn-outline-primary px-3 rounded-pill my-2 service-badge",role:"button"},vendor.store_name)));}))});}},wp.element.createElement("img",{"class":"img-cover",src:vendorHasIcon.image,alt:vendorHasIcon.vendor_name}));})),wp.element.createElement("h4",{"class":"heading-title justify-content-start"},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])("所在分店","cec-plugin-stores")," "),wp.element.createElement("hr",{"class":"border-top border-gray mt-0 mb-4"}),wp.element.createElement("div",{"class":"section pt-md-5"},wp.element.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(brandInfo,"stores",[]),function(storeInfo,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,wp.element.createElement("div",{"class":"col-md-6 col-lg-4"},wp.element.createElement("div",{"class":"card card-storeInfo brand-theme shadow-0 card-border-width-1 type-1"},wp.element.createElement("a",{className:"card-body",style:{cursor:"pointer"},onClick:function onClick(e){e.persist();if(e.target.className.includes("vip")||e.target.className.includes("gift")||e.target.id.includes("gMap-link"))return;window.location.href=INDEX_URL+"/store-info"+(Locale=="en_US"?"-en":"")+"/?store="+storeInfo.name+"#tab=info";}},wp.element.createElement("div",{"class":"ml-3",style:{display:"flex"}},wp.element.createElement("h5",{"class":"h4 pl-4 mb-4"},Locale=="en_US"&&storeInfo.en_name&&storeInfo.en_name,(Locale=="zh_TW"||Locale=="en_US"&&!storeInfo.en_name)&&storeInfo.name),storeInfo.BrandVoucher.is_vip===1&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default.a,{title:"\u4EABVIP\u512A\u60E0"},wp.element.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.vip,style:{cursor:"default"}},wp.element.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.vip1},"VIP"))),storeInfo.BrandVoucher.is_gift===1&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default.a,{title:"\u53EF\u4F7F\u7528\u79AE\u5238"},wp.element.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.gift,style:{cursor:"default"}},wp.element.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.gift1},"\u79AE\u5238"))),storeInfo.BrandVoucher.is_gift===1&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_tooltip___default.a,{title:"\u53EF\u4F7F\u7528\u79AE\u7269\u5361"},wp.element.createElement("div",{style:{width:"55px",cursor:"default"},className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.gift},wp.element.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_19__vip_gift_module_scss___default.a.gift1,style:{whiteSpace:"nowrap",width:"45px"}},"\u79AE\u7269\u5361")))),wp.element.createElement("ul",{"class":"traffic-info-list"},wp.element.createElement("li",null,wp.element.createElement("i",{"class":"icon-store_map"}),wp.element.createElement("span",null,Locale=="en_US"&&storeInfo.en_street&&storeInfo.en_street,(Locale=="zh_TW"||Locale=="en_US"&&!storeInfo.en_street)&&storeInfo.address&&storeInfo.address,wp.element.createElement("a",{"class":"gMap-link",role:"button",href:"https://www.google.com.tw/maps/place/"+storeInfo.address,target:"_blank"},wp.element.createElement("img",{id:"gMap-link","class":"ml-3",src:PLUGIN_ASSETS_URL+"img/icon/google_map.svg",alt:""})))))))));}))))));}}]);return BrandInfo;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器
var BrandInfoEditor=function(_Component2){_inherits(BrandInfoEditor,_Component2);function BrandInfoEditor(){_classCallCheck(this,BrandInfoEditor);return _possibleConstructorReturn(this,(BrandInfoEditor.__proto__||Object.getPrototypeOf(BrandInfoEditor)).apply(this,arguments));}_createClass(BrandInfoEditor,[{key:"render",value:function render(){return wp.element.createElement("div",{className:"vu-blocks-editor"},wp.element.createElement("div",{"class":"components-placeholder__label"},wp.element.createElement("span",{"class":"block-editor-block-icon"},wp.element.createElement("div",{"class":"dashicons dashicons-layout"})),"\u54C1\u724C\u8CC7\u8A0A"));}}]);return BrandInfoEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"vip1":"vip1___1Mk0U","vip":"vip___3Q8DT","gift":"gift___YBq5n","gift1":"gift1___38QP0"};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogueInfoEditor", function() { return CatalogueInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_empty_style__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_empty_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_empty_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_empty__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_drawer_style__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_drawer_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_drawer_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tooltip_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_affix_style__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_affix_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_affix_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_affix__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_ArrowLeftOutlined__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_ArrowLeftOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_ArrowLeftOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_slider_style__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_slider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_slider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_slider__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_draggable__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react_draggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_device_detect__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_module_scss__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_configs_env__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG');var PLUGIN_ASSETS_URL=VC_CONFIG.PLUGIN_ASSETS_URL;var isDoublePageMode=function isDoublePageMode(width){return width>992;};var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[{name:'品牌 #1'// "logo_url": "http://cec.syscom.tw:8880/uploads/48859859abcf9248f23d4f6202efcf5f.jpg",
},{name:'品牌 #2'// "logo_url": "http://cec.syscom.tw:8880/uploads/251b9bce1f9a454ae691944ea9396e31.jpg",
},{name:'品牌 #3'// "logo_url": "http://cec.syscom.tw:8880/uploads/f63176e067072961ddd5a17e7ecb61fe.jpg"
},{name:'品牌 #4'// "logo_url": "http://cec.syscom.tw:8880/uploads/252716bd6a210aa82c3a09c2a62833e9.jpg",
}]};var InfoDetail=function InfoDetail(){return wp.element.createElement('div',{className:''+__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['info-card']},wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-3'},'\u4FC3\u92B7\u76EE\u9304\u8AAA\u660E'),wp.element.createElement('p',{'class':'p mb-0 text-primary text-justify'},'\u672C\u4FC3\u92B7\u76EE\u9304\u4E4B\u50F9\u683C\u3001\u5716\u7247\u53CA\u8D08\u54C1\u82E5\u6709\u8AA4\uFF0C\u4EE5\u8CE3\u5834\u5BE6\u969B\u6A19\u793A\u70BA\u6E96\u3002',wp.element.createElement('br',null),'\u4FC3\u92B7\u76EE\u9304\u4E4B\u5546\u54C1\uFF0C\u56E0\u5404\u8CE3\u5834\u898F\u6A21\u4E0D\u540C\uFF0C\u90E8\u4EFD\u5206\u5E97\u672A\u8CA9\u552E\u6216\u50C5\u8CA9\u552E\u90E8\u4EFD\u5546\u54C1\uFF0C\u8A72\u5E97\u8CA9\u552E\u54C1\u9805\uFF0C\u8ACB\u4F9D\u8CE3\u5834\u9673\u5217\u70BA\u6E96\u3002',' ',wp.element.createElement('br',null),'\u70BA\u97FF\u61C9\u74B0\u4FDD\uFF0C\u5982\u679C\u60A8\u6B32\u53D6\u6D88\u7D19\u672C\u4FC3\u92B7\u76EE\u9304\u90F5\u5BC4\uFF0C\u8ACB\u806F\u7D61\u5BA2\u670D\u4E2D\u5FC3\u514D\u4ED8\u8CBB\u5C08\u7DDA\uFF1A0809-001-365 (\u670D\u52D9\u6642\u9593\uFF1A\u4E0A\u53489\u9EDE~\u665A\u95939\u9EDE)'));};var CatalogueInfo=function(_Component){_inherits(CatalogueInfo,_Component);function CatalogueInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueInfo.__proto__||Object.getPrototypeOf(CatalogueInfo)).call.apply(_ref,[this].concat(args))),_this),_this.previewHeight=null,_this.previewHeightSet=true,_this.state={catalogueInfo:{images:[],images_previews:[],imagesPreviewsDoublePage:[]},data:[],loading:false,hasMore:true,currentSlideIdx:0,query:{},isModalVisible:true,isModalVisibleInfo:false,zoomPreviewImg:1,zoomModalImg:1,deviceWidth:window.innerWidth,modalImageList:[],modalImagePosition:{x:0,y:0},categoryIdxDrawer:false,categoryIdxDrawerModal:false},_this.receiveMessage=function(event){if(event.origin!=='https://edm.cec-taiwan.com.tw'){return false;}var height=event.data;document.getElementById('edm-iframe').setAttribute('height',height);},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).on('click','#pdf',function(){var $text=__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this).attr('alt');dataLayer.push({event:'catalogue_pdf',item:$text});});},_this.loadData=function(){var search=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_22_query_string___default.a.parse(search);var catalogue=queryParams.catalogue;var deviceWidth=_this.state.deviceWidth;if(!catalogue)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_32_configs_env__["b" /* API_HOST */]+('/api/v1/catalogues/'+catalogue),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/catalogues');return;}// 改原圖片
// const imagesPreviewsDoublePage = data.images_previews
//   .map((img, idx) => {
//     if (idx === 0 || idx === data.images_previews.length - 1) {
//       return [img]
//     }
//     if (idx % 2 !== 0) {
//       return [img, data.images_previews[idx + 1]]
//     }
//     return null
//   })
//   .filter(Boolean)
var imagesPreviewsDoublePage=data.images.map(function(img,idx){if(idx===0||idx===data.images.length-1){return[img];}if(idx%2!==0){return[img,data.images[idx+1]];}return null;}).filter(Boolean);_this.setState({catalogueInfo:Object.assign({},data,{imagesPreviewsDoublePage:imagesPreviewsDoublePage})});// 改原圖片
// this.setCurrentSlideIdx(data.images_previews, imagesPreviewsDoublePage)
_this.setCurrentSlideIdx(data.images,imagesPreviewsDoublePage);_this.handleInfiniteOnLoad();_this.reloadSwiper();_this.reloadSwiperModal();});},_this.setCurrentSlideIdx=function(singlePageList,doublePageList){var deviceWidth=_this.state.deviceWidth;var _qs$parse=__WEBPACK_IMPORTED_MODULE_22_query_string___default.a.parse(window.location.hash),page=_qs$parse.page;var queryPage=Number(page);var imgIdx=Number.isNaN(queryPage)||queryPage<=0||queryPage>singlePageList.length?0:queryPage-1;var imgURL=singlePageList[imgIdx];if(isDoublePageMode(deviceWidth)){imgIdx=doublePageList.findIndex(function(a){return a.includes(imgURL);});}else{imgIdx=singlePageList.findIndex(function(a){return a===imgURL;});}_this.setState({currentSlideIdx:imgIdx});},_this.getDeviceType=function(){return{isDesktop:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"]&&window.orientation===0,isTabletPortrait:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isTablet"]&&window.orientation===0,isTabletLandscape:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isTablet"]&&[-90,90].includes(window.orientation),isMobilePortrait:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobileOnly"]&&window.orientation===0,isMobileLandscape:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobileOnly"]&&[-90,90].includes(window.orientation)};},_this.setBackToTopAnchor=function(){var backToTopAnchor=document.querySelector('.back_to_top');backToTopAnchor.style.display='none';window.addEventListener('scroll',__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.throttle(function(e){if(window.scrollY>400){backToTopAnchor.style.display='block';}else{backToTopAnchor.style.display='none';}}),500);},_this.handleInfiniteOnLoad=function(page){var catalogueInfo=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.state,'catalogueInfo');_this.setState({loading:true});setTimeout(function(){var data=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'images'),0,data.length+1);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100);},_this.reloadSwiper=function(){var Swiper=window.Swiper;if(!Swiper)return;window.swiperCatalog=new Swiper('.catalogs-slide .swiper-container',{initialSlide:_this.state.currentSlideIdx,slidesPerView:1,loop:false,navigation:{nextEl:'.next-btn',prevEl:'.previous-btn'},preloadImages:false,lazy:{loadPrevNext:true},watchSlidesVisibility:true,threshold:5});window.swiperCatalog.on('slideChange',function(){_this.setState({currentSlideIdx:window.swiperCatalog.activeIndex});});window.swiperCatalog.on('lazyImageReady',function(swiper,slideEl,imageEl){slideEl.style.visibility='visible';});},_this.reloadSwiperModal=function(){var Swiper=window.Swiper;if(!Swiper)return;window.swiperCatalogModal=new Swiper('.swiper-container-modal',{initialSlide:_this.state.currentSlideIdx,slidesPerView:1,loop:false,navigation:{nextEl:'.swiper-container-modal .next-btn',prevEl:'.swiper-container-modal .previous-btn'},preloadImages:false,lazy:{loadPrevNext:true},watchSlidesVisibility:true,threshold:5,spaceBetween:(window.innerWidth-window.innerWidth*0.95)/2,centeredSlides:true});window.swiperCatalogModal.on('slideChange',function(){_this.setState({currentSlideIdx:window.swiperCatalogModal.activeIndex},function(){window.swiperCatalog.slideTo(_this.state.currentSlideIdx);});});window.swiperCatalogModal.on('lazyImageReady',function(swiper,slideEl,imageEl){slideEl.style.visibility='visible';});},_this.handleChangeSlider=function(e){if(_this.state.zoomPreviewImg===1){window.swiperCatalog.slideTo(e-1);}_this.setState({currentSlideIdx:e-1,zoomPreviewImg:1});},_this.handleOpenModal=function(){_this.setState({isModalVisible:true,zoomModalImg:1,modalImagePosition:{x:0,y:0}},function(){_this.reloadSwiperModal();// this.setModalImgMouseWheel();
});},_this.handleCloseModal=function(e){var cxName=e.target.className;e.persist();if(typeof cxName!=='string')return;if(cxName.includes('modal-content-wrapper')||cxName.includes('mask-wrapper')||cxName.includes('swiper-slide')||cxName.includes('catalogs-page-image')||cxName.includes('close-btn')){_this.setState({isModalVisible:false,isModalVisibleInfo:false});}},_this.handleZoomOut=function(name){var zoom=_this.state[name];if(zoom<=1)return;_this.setState(_defineProperty({},name,zoom-0.25),function(){if(_this.state[name]===1){_this.reloadSwiper();return;}});},_this.handleZoomIn=function(name){var zoom=_this.state[name];if(zoom>=2)return;_this.setState(_defineProperty({},name,zoom+0.25));},_this.handleClickInfoIcon=function(){if(!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"]){_this.setState({isModalVisibleInfo:true});}},_this.getSliderTipFormat=function(value){var _this$state=_this.state,catalogueInfo=_this$state.catalogueInfo,deviceWidth=_this$state.deviceWidth;var AddZero=function AddZero(num){return String(num).length<2?'0'+num:''+num;};if(!isDoublePageMode(deviceWidth)){// const totalPage = catalogueInfo.images_previews.length
// 改原圖片
var totalPage=catalogueInfo.images.length;return AddZero(value)+'/'+AddZero(totalPage);}if(isDoublePageMode(deviceWidth)){var _totalPage=catalogueInfo.imagesPreviewsDoublePage.length;var countArray=[];for(var i=2;i<=_totalPage;i++){countArray.push(i);}var idx=countArray.findIndex(function(i){return i===value;});if(value===1){return'01';}if(value===_totalPage){return''+AddZero(value+idx);}return AddZero(value+idx)+'/'+AddZero(value+idx+1);}},_this.renderSlider=function(){var _this$state2=_this.state,catalogueInfo=_this$state2.catalogueInfo,currentSlideIdx=_this$state2.currentSlideIdx,deviceWidth=_this$state2.deviceWidth;// const max = isDoublePageMode(deviceWidth)
//   ? catalogueInfo.imagesPreviewsDoublePage.length
//   : catalogueInfo.images_previews.length
// 改原圖片
var max=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage.length:catalogueInfo.images.length;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_slider___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider'],trackStyle:{backgroundColor:'#0870e6'},handleStyle:{border:'3px solid #0870E6'},min:1,max:max,tipFormatter:window.innerWidth>=1024?_this.getSliderTipFormat:null,value:currentSlideIdx+1,onChange:_this.handleChangeSlider});},_this.renderPreviewPrevNextBtn=function(){var _this$state3=_this.state,currentSlideIdx=_this$state3.currentSlideIdx,deviceWidth=_this$state3.deviceWidth,catalogueInfo=_this$state3.catalogueInfo,zoomPreviewImg=_this$state3.zoomPreviewImg;var currentPage=currentSlideIdx+1;// const totalPage = isDoublePageMode(deviceWidth)
//   ? catalogueInfo.imagesPreviewsDoublePage.length
//   : catalogueInfo.images_previews.length
// 改原圖片
var totalPage=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage.length:catalogueInfo.images.length;var handleNext=function handleNext(){if(zoomPreviewImg===1)return;_this.setState(function(prevState,props){return{currentSlideIdx:prevState.currentSlideIdx+1,zoomPreviewImg:1};},function(){_this.reloadSwiper();});};var handlePrev=function handlePrev(){if(zoomPreviewImg===1)return;_this.setState(function(prevState,props){return{currentSlideIdx:prevState.currentSlideIdx-1,zoomPreviewImg:1};},function(){_this.reloadSwiper();});};return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['next-btn-wrapper']},wp.element.createElement('div',{'class':'next-btn',style:{visibility:currentPage!==totalPage?'visible':'hidden'},onClick:handleNext})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['prev-btn-wrapper']},wp.element.createElement('div',{'class':'previous-btn',style:{visibility:currentPage!==1?'visible':'hidden'},onClick:handlePrev})));},_this.handleClickModalArrowBtn=function(mode){var currentSlideIdx=_this.state.currentSlideIdx;var activeIndex=window.swiperCatalog.activeIndex;var isNext=mode==='next';window.swiperCatalog.slideTo(isNext?activeIndex+1:activeIndex-1);_this.setState({currentPage:isNext?currentSlideIdx+1:currentSlideIdx-1,modalImagePosition:{x:0,y:0},zoomModalImg:1});},_this.getPageInfo=function(currentSlide){var products=[];if(!currentSlide)return products;if(Array.isArray(currentSlide)){currentSlide.forEach(function(url){var imgUrl=url.split('_preview').join('');var info=_this.state.catalogueInfo.page_info.find(function(obj){return obj.image===imgUrl;});if(!info||!info.products)return products;products=[].concat(_toConsumableArray(products),_toConsumableArray(info.products));});}else{var imgUrl=currentSlide.split('_preview').join('');var info=_this.state.catalogueInfo.page_info.find(function(obj){return obj.image===imgUrl;});if(!info||!info.products)return products;products=[].concat(_toConsumableArray(products),_toConsumableArray(info.products));}return products;},_this.setModalImage=function(imgURL){var _this$state4=_this.state,modalImageList=_this$state4.modalImageList,zoomModalImg=_this$state4.zoomModalImg;var _this$getDeviceType=_this.getDeviceType(),isMobileLandscape=_this$getDeviceType.isMobileLandscape;var image=modalImageList.find(function(m){return m.url===imgURL;});if(!image){var img=new Image();img.src=imgURL;img.addEventListener('load',function(e){var image=e.path?e.path[0]:e.target;var imgHeight=null;var imgWidth=null;if(window.innerWidth>window.innerHeight){imgHeight=Math.round((window.innerHeight-100)*0.9);imgWidth=Math.round(imgHeight*(image.width/image.height));}if(window.innerHeight>window.innerWidth){imgWidth=Math.round(window.innerWidth*0.95);imgHeight=Math.round(imgWidth*(image.height/image.width));}if(isMobileLandscape){imgWidth=Math.round(window.innerWidth*0.95);imgHeight=Math.round(imgWidth*(image.height/image.width));}_this.setState({modalImageList:[].concat(_toConsumableArray(modalImageList),[{url:imgURL,width:imgWidth,height:imgHeight}])});});}},_this.getModalImage=function(imgURL){var _this$state5=_this.state,modalImageList=_this$state5.modalImageList,zoomModalImg=_this$state5.zoomModalImg;var img=modalImageList.find(function(m){return m.url===imgURL;})||{};return Object.assign({},img,{width:img.width*zoomModalImg,height:img.height*zoomModalImg});},_this.handleStopModalImage=function(e,data){_this.setState({modalImagePosition:{x:data.x,y:data.y}});},_this.renderCategoryIdxBtn=function(){var _cx;var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _this$state6=_this.state,categoryIdxDrawer=_this$state6.categoryIdxDrawer,categoryIdxDrawerModal=_this$state6.categoryIdxDrawerModal;var btnStyle=categoryIdxDrawer&&type===''||categoryIdxDrawerModal&&type==='modal';var btnCx=__WEBPACK_IMPORTED_MODULE_26_classnames___default()((_cx={},_defineProperty(_cx,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['category-idx-btn'],true),_defineProperty(_cx,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['opened'],btnStyle),_cx));var btnIconSrc=PLUGIN_ASSETS_URL+'img/catalog/index-'+(btnStyle?'open':'close')+'.svg';var handleClickCategoryIndex=function handleClickCategoryIndex(){var scrollY=window.scrollY;if(type==='modal'){_this.setState({categoryIdxDrawerModal:!categoryIdxDrawerModal});}else{_this.setState({categoryIdxDrawer:!categoryIdxDrawer},function(){window.scroll(0,scrollY);});}};return wp.element.createElement('div',{className:btnCx,onClick:handleClickCategoryIndex},'\u76EE\u9304\u7D22\u5F15',wp.element.createElement('img',{'class':'ml-2',src:btnIconSrc,alt:''}));},_this.handleCloseDrawer=function(){_this.setState({categoryIdxDrawer:false,categoryIdxDrawerModal:false});},_this.handleClickCategory=function(page){var _this$state7=_this.state,catalogueInfo=_this$state7.catalogueInfo,deviceWidth=_this$state7.deviceWidth,zoomPreviewImg=_this$state7.zoomPreviewImg,categoryIdxDrawer=_this$state7.categoryIdxDrawer,categoryIdxDrawerModal=_this$state7.categoryIdxDrawerModal,isModalVisible=_this$state7.isModalVisible;// const imgList = isDoublePageMode(deviceWidth)
//   ? catalogueInfo.imagesPreviewsDoublePage.flat()
//   : catalogueInfo.images_previews
// 改原圖片
var imgList=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage.flat():catalogueInfo.images;var url=imgList[page-1]?imgList[page-1]:imgList[0];var slideIdx=null;if(page>imgList.length){// slideIdx = isDoublePageMode(deviceWidth)
//   ? catalogueInfo.imagesPreviewsDoublePage.length - 1
//   : catalogueInfo.images_previews.length - 1
// 改原圖片
slideIdx=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage.length-1:catalogueInfo.images.length-1;}else if(isDoublePageMode(deviceWidth)){catalogueInfo.imagesPreviewsDoublePage.forEach(function(ary,idx){if(ary.includes(url)){slideIdx=idx;return;}});}else{slideIdx=page-1;}if(zoomPreviewImg===1){window.swiperCatalog.slideTo(slideIdx);}if(!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"]&&categoryIdxDrawerModal){window.swiperCatalogModal.slideTo(slideIdx);}_this.setState({currentSlideIdx:slideIdx,zoomPreviewImg:1,categoryIdxDrawer:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"]&&categoryIdxDrawer&&!isModalVisible?false:categoryIdxDrawer},function(){if(zoomPreviewImg!==1){_this.reloadSwiper();}});},_this.renderDrawerList=function(){var catalogueInfo=_this.state.catalogueInfo;var categoryIndexesList=catalogueInfo.category_indexes||[];var nameTransform=function nameTransform(name){return name.match(/.{1,8}/g).map(function(n){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,n,wp.element.createElement('br',null));});};return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer-category-list']},categoryIndexesList.map(function(c){var page=c.page;return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer-category'],onClick:function onClick(){return _this.handleClickCategory(page);}},wp.element.createElement('div',null,nameTransform(c.index_name)),wp.element.createElement('div',null,String(c.page).length===1?'0'+c.page:c.page));}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueInfo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var query=__WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__["a" /* default */].getHashParamaters();this.setState({query:query});this.loadData();this.GTM();this.setBackToTopAnchor();// this.setModalImgMouseWheel();
window.addEventListener('resize',function(e){var _state=_this2.state,deviceWidth=_state.deviceWidth,currentSlideIdx=_state.currentSlideIdx;var previousWidth=deviceWidth;var currentWidth=e.target.innerWidth;if(!isDoublePageMode(previousWidth)&&!isDoublePageMode(currentWidth)||isDoublePageMode(previousWidth)&&isDoublePageMode(currentWidth)){_this2.setState({deviceWidth:currentWidth});return;}_this2.setState({deviceWidth:currentWidth,modalImageList:[],currentSlideIdx:isDoublePageMode(currentWidth)?Math.ceil(currentSlideIdx/2):currentSlideIdx*2-1},function(){_this2.reloadSwiper();_this2.reloadSwiperModal();});});// post message, iframe receive message listener
window.addEventListener('message',this.receiveMessage,false);}},{key:'render',value:function render(){var _this3=this;var _getDeviceType=this.getDeviceType(),isTabletPortrait=_getDeviceType.isTabletPortrait,isTabletLandscape=_getDeviceType.isTabletLandscape,isMobilePortrait=_getDeviceType.isMobilePortrait,isMobileLandscape=_getDeviceType.isMobileLandscape;var _state2=this.state,_state2$catalogueInfo=_state2.catalogueInfo,catalogueInfo=_state2$catalogueInfo===undefined?{}:_state2$catalogueInfo,currentSlideIdx=_state2.currentSlideIdx,zoomPreviewImg=_state2.zoomPreviewImg,zoomModalImg=_state2.zoomModalImg,isModalVisible=_state2.isModalVisible,isModalVisibleInfo=_state2.isModalVisibleInfo,deviceWidth=_state2.deviceWidth,modalImageList=_state2.modalImageList,modalImagePosition=_state2.modalImagePosition;var showCategoryIdxBtn=catalogueInfo.category_indexes&&catalogueInfo.category_indexes.length>0;var catalogsSlideEl=document.querySelector('.catalogs-slide');if(this.previewHeightSet&&catalogsSlideEl){if(catalogsSlideEl.getBoundingClientRect().height>this.previewHeight){this.previewHeight=catalogsSlideEl.getBoundingClientRect().height;}}var swiper=window.swiperCatalog||{};var swiperModal=window.swiperCatalogModal||{};var currentPage=currentSlideIdx+1;var pdf=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'pdfs.0')||'';var urlQuery=__WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__["a" /* default */].getURLQuery();var isKiosk=urlQuery.view;var Local=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG.Locale');// const totalPage = isDoublePageMode(deviceWidth)
//   ? catalogueInfo.imagesPreviewsDoublePage.length
//   : catalogueInfo.images_previews.length
// const imgList = isDoublePageMode(deviceWidth)
// ? catalogueInfo.imagesPreviewsDoublePage
// : catalogueInfo.images_previews
// 改原圖片
var totalPage=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage.length:catalogueInfo.images.length;var imgList=isDoublePageMode(deviceWidth)?catalogueInfo.imagesPreviewsDoublePage:catalogueInfo.images;var havePageinfo=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'page_info',[]).length?__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'page_info',[]):null;var hasDoublePage=imgList.every(function(i){return Array.isArray(i);});var currentSlide=imgList[currentSlideIdx];var isDoublePage=Array.isArray(currentSlide)&&currentSlide.length>1;// 是否為iframe頁面
var iFrameUrl=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'iframe_url',null);// 判斷 pageinfo 為 0 = 最後一頁
var products=[];if(currentPage===totalPage){var info=catalogueInfo.page_info.find(function(obj){return obj.page===0;});if(info){products=[].concat(_toConsumableArray(products),_toConsumableArray(info.products));}}else{products=this.getPageInfo(currentSlide);}var enName=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'en_name',[])?__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(catalogueInfo,'en_name',[]):'';if(swiper){swiper.allowTouchMove=zoomPreviewImg===1;}if(swiperModal){swiperModal.allowTouchMove=zoomPreviewImg===1;}var zoomOutBtnCx=function zoomOutBtnCx(name){var _cx2;return __WEBPACK_IMPORTED_MODULE_26_classnames___default()((_cx2={},_defineProperty(_cx2,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['zoom-out-btn'],true),_defineProperty(_cx2,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['disabled'],_this3.state[name]===1),_cx2));};var zoomInBtnCx=function zoomInBtnCx(name){var _cx3;return __WEBPACK_IMPORTED_MODULE_26_classnames___default()((_cx3={},_defineProperty(_cx3,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['zoom-in-btn'],true),_defineProperty(_cx3,__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['disabled'],_this3.state[name]===2),_cx3));};// 設定 Modal Image 長寬
if(currentSlide&&hasDoublePage){currentSlide.forEach(function(c){_this3.setModalImage(c);});}if(currentSlide&&!hasDoublePage){this.setModalImage(currentSlide);}return wp.element.createElement('main',{'class':'bg-light'},isKiosk&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_affix___default.a,{offsetTop:30},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_button___default.a,{style:{display:'inline-flex',fontSize:'30px',color:'white',borderRadius:'20px',backgroundColor:'#08c',height:'60px',width:'140px',top:'20px',left:'40px'},onClick:function onClick(){return window.history.back();}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_ArrowLeftOutlined___default.a,{style:{fontSize:'40px',color:'white',width:'70px'}}),'\u8FD4\u56DE')),!isKiosk&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{className:'breadcrumb '+__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['breadcrumb']},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues'},Object(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__["__"])('促銷目錄','cec-plugin-stores'))),catalogueInfo.category_id==40&&wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues-corrections'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__["__"])('目錄更正公告','cec-plugin-stores'))),catalogueInfo.category_id==41&&wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/catalogues-preorderitemrules'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__["__"])('預購目錄應記載事項','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page',id:'name'},catalogueInfo.name))))),havePageinfo&&iFrameUrl===null&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{'class':'container',style:{maxWidth:'1435px'}},wp.element.createElement('section',{'class':'p-0'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-9 d-flex flex-column'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['operation-wrapper']},showCategoryIdxBtn&&wp.element.createElement('div',{style:{marginRight:'auto'}},this.renderCategoryIdxBtn()),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['fake-space']}),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider-wrapper']},wp.element.createElement('div',{className:''+__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['index-wrapper']},this.getSliderTipFormat(currentPage)),(__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isTablet"]||__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"])&&this.renderSlider()),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['function-wrapper']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tooltip___default.a,{overlayClassName:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['info-tooltip'],title:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-3'},'\u4FC3\u92B7\u76EE\u9304\u8AAA\u660E'),wp.element.createElement('p',{'class':'p mb-0 text-primary text-justify'},'\u672C\u4FC3\u92B7\u76EE\u9304\u4E4B\u50F9\u683C\u3001\u5716\u7247\u53CA\u8D08\u54C1\u82E5\u6709\u8AA4\uFF0C\u4EE5\u8CE3\u5834\u5BE6\u969B\u6A19\u793A\u70BA\u6E96\u3002',wp.element.createElement('br',null),'\u4FC3\u92B7\u76EE\u9304\u4E4B\u5546\u54C1\uFF0C\u56E0\u5404\u8CE3\u5834\u898F\u6A21\u4E0D\u540C\uFF0C\u90E8\u4EFD\u5206\u5E97\u672A\u8CA9\u552E\u6216\u50C5\u8CA9\u552E\u90E8\u4EFD\u5546\u54C1\uFF0C\u8A72\u5E97\u8CA9\u552E\u54C1\u9805\uFF0C\u8ACB\u4F9D\u8CE3\u5834\u9673\u5217\u70BA\u6E96\u3002',' ',wp.element.createElement('br',null),'\u70BA\u97FF\u61C9\u74B0\u4FDD\uFF0C\u5982\u679C\u60A8\u6B32\u53D6\u6D88\u7D19\u672C\u4FC3\u92B7\u76EE\u9304\u90F5\u5BC4\uFF0C\u8ACB\u806F\u7D61\u5BA2\u670D\u4E2D\u5FC3\u514D\u4ED8\u8CBB\u5C08\u7DDA\uFF1A0809-001-365 (\u670D\u52D9\u6642\u9593\uFF1A\u4E0A\u53489\u9EDE~\u665A\u95939\u9EDE)')),placement:'bottom'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['info-btn'],onClick:this.handleClickInfoIcon})),pdf&&wp.element.createElement('a',{href:pdf&&pdf.replace('mppuni-prosperity','wwwuni-prosperity'),target:'_blank'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['download-btn']})),!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobileOnly"]&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['fullscreen-btn'],onClick:this.handleOpenModal})),wp.element.createElement('div',{className:zoomOutBtnCx('zoomPreviewImg'),onClick:function onClick(){return _this3.handleZoomOut('zoomPreviewImg');}}),wp.element.createElement('div',{className:zoomInBtnCx('zoomPreviewImg'),onClick:function onClick(){return _this3.handleZoomIn('zoomPreviewImg');}})),zoomPreviewImg!==1&&!isDoublePage&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-wrapper'],style:{height:this.previewHeight}},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-scale-wrapper']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-scale-inner-wrapper'],style:{transform:'scale('+zoomPreviewImg+')'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_react_draggable___default.a,null,wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-image'],style:{backgroundImage:'url('+currentSlide+')'}}))),this.renderPreviewPrevNextBtn(),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],width:'22%',placement:'left',visible:this.state.categoryIdxDrawer,getContainer:false,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList())),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider-wrapper']},this.renderSlider())),zoomPreviewImg!==1&&isDoublePage&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-wrapper'],style:{height:this.previewHeight}},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-scale-wrapper']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-scale-inner-wrapper'],style:{transform:'scale('+zoomPreviewImg+')'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_react_draggable___default.a,null,wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-image-wrapper']},currentSlide.map(function(imgURL,idx){return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['preview-image'],style:{backgroundImage:'url('+imgURL+')',flexBasis:'50%',backgroundPosition:idx===0?'right':'left'}});})))),this.renderPreviewPrevNextBtn(),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],width:'22%',placement:'left',visible:this.state.categoryIdxDrawer,getContainer:false,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList())),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider-wrapper']},this.renderSlider())),zoomPreviewImg===1&&!isDoublePageMode(deviceWidth)&&wp.element.createElement('div',{'class':'catalogs-slide pb-0 d-flex flex-column',style:{paddingTop:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"]?'0px':'inherit',height:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isTablet"]?'426px':'auto'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container w-100',style:{height:isMobileLandscape?'253px':'auto'}},wp.element.createElement('div',{'class':'swiper-wrapper h-100',style:{alignItems:'center'}},catalogueInfo.images.map(function(imgURL){return wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('div',{'class':'catalogs-page-image w-100 h-100'},wp.element.createElement('img',{'data-src':imgURL,alt:'','class':'swiper-lazy',style:{visibility:'hidden'}}),wp.element.createElement('div',{'class':'swiper-lazy-preloader'})));})),this.renderPreviewPrevNextBtn(),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],width:'22%',placement:'left',visible:this.state.categoryIdxDrawer,getContainer:false,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList())),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider-wrapper']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['index-wrapper']},this.getSliderTipFormat(currentPage)),this.renderSlider(),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['fullscreen-icon'],onClick:this.handleOpenModal})))),zoomPreviewImg===1&&isDoublePageMode(deviceWidth)&&wp.element.createElement('div',{'class':'catalogs-slide pb-0 d-flex flex-column',style:{height:'auto',overflow:'hidden'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container w-100',style:{height:__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"]?'90%':'100%'}},wp.element.createElement('div',{'class':'swiper-wrapper h-100'},catalogueInfo.imagesPreviewsDoublePage.map(function(imgArray){return wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('div',{'class':'catalogs-page-image h-100'},imgArray.map(function(url,idx){return wp.element.createElement('img',{'data-src':url,alt:'','class':'swiper-lazy',style:{visibility:'hidden',width:'50%',objectPosition:imgArray.length===1?'center':idx%2===0?'right':'left'}});}),wp.element.createElement('div',{'class':'swiper-lazy-preloader'})));})),this.renderPreviewPrevNextBtn(),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],width:'22%',placement:'left',visible:this.state.categoryIdxDrawer,getContainer:false,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList())),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slider-wrapper']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['index-wrapper']},this.getSliderTipFormat(currentPage)),this.renderSlider(),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['fullscreen-icon'],onClick:this.handleOpenModal}))))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slide-product-wrapper']+' col-lg-3 col-sm-12'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['slide-product-column']+' overflow-lg-hidden position-absolute h-lg-100 p-0 d-flex flex-column'},wp.element.createElement('div',{'class':'bg-sea p-4 mb-4',style:{borderRadius:'10px'}},wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},'\u5546\u54C1\u50F9\u683C\u5982\u6709\u66F4\u52D5\uFF0C\u4EE5\u8CE3\u5834\u8207\u7DDA\u4E0A\u8CFC\u7269\u7DB2\u7AD9\u6A19\u793A\u70BA\u6E96')),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['product-list-wrapper']+' px-lg-4 px-sm-2 py-2 overflow-auto '},(products.length===0||products.every(function(product){return!product.IsOnSale;}))&&wp.element.createElement('div',{'class':'d-flex justify-content-center h-100'},wp.element.createElement('div',{'class':'col-lg-12 col-md-9'},wp.element.createElement('div',{'class':'d-flex flex-column justify-content-center h-100'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['product-list-empty-img']},wp.element.createElement('img',{src:PLUGIN_ASSETS_URL+'img/catalogue/logo.png',alt:'\u66F4\u591A\u6D3B\u52D5\u8CC7\u8A0A\u8ACB\u81F3\u5BE6\u9AD4\u8CE3\u5834\u6216\u7DDA\u4E0A\u8CFC\u7269'})),wp.element.createElement('p',{'class':'w-100 p text-font text-center mb-5'},'\u66F4\u591A\u6D3B\u52D5\u8CC7\u8A0A\u8ACB\u81F3\u5BE6\u9AD4\u8CE3\u5834\u6216\u7DDA\u4E0A\u8CFC\u7269'))))),__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.map(products,function(item,idx){if(item.IsOnSale){return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['card-wrapper']+' card border-0 rounded-10'},wp.element.createElement('a',{href:item.uri+'?utm_campaign='+enName+'&utm_medium=dm&utm_source=web',target:'_blank',rel:'noopener noreferrer'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-4 d-flex align-items-center'},wp.element.createElement('div',{'class':'img-1-1',style:{backgroundImage:'url('+encodeURI(item.item_img[0])+')'}})),wp.element.createElement('div',{'class':'col-8'},wp.element.createElement('div',{'class':'d-flex flex-column'},wp.element.createElement('h6',{'class':'h6 mb-0'},item.product_name),wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-end mt-3'},wp.element.createElement('p',{'class':'h5 text-primary mb-0'},'$',' ',item.special_price!==''&&item.special_price,item.special_price===''&&item.price),wp.element.createElement('p',{'class':'p text-font mb-0'},'/',item.pack,'\u5165'))))))));}}))))))),isModalVisible&&!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"]&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-wrapper'],onClick:this.handleCloseModal},currentPage!==totalPage&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-right-icon'],onClick:function onClick(){return _this3.handleClickModalArrowBtn('next');}}),currentPage!==1&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-left-icon'],onClick:function onClick(){return _this3.handleClickModalArrowBtn('prev');}}),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['close-btn']}),wp.element.createElement('div',{id:'modal-content-wrapper',className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['modal-content-wrapper']},!hasDoublePage&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_react_draggable___default.a,{disabled:!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"]},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['modal-image'],style:{width:this.getModalImage(currentSlide).width,height:this.getModalImage(currentSlide).height,flexBasis:'100%',backgroundImage:'url('+currentSlide+')',backgroundPosition:'center'}})),hasDoublePage&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_react_draggable___default.a,{disabled:!__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isDesktop"],position:{x:modalImagePosition.x,y:modalImagePosition.y},onStop:this.handleStopModalImage},wp.element.createElement('div',{'class':'d-flex'},currentSlide.map(function(imgURL,idx){var width=_this3.getModalImage(imgURL).width;var height=_this3.getModalImage(imgURL).height;return wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['modal-image'],style:{width:width,height:height,flexBasis:isDoublePage?'50%':'100%',backgroundImage:'url('+imgURL+')',backgroundPosition:isDoublePage?null:'center'}});})))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['operation-section']},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['operation-bar-wrapper']},wp.element.createElement('div',{className:'text-white mr-lg-5'},this.getSliderTipFormat(currentPage)),wp.element.createElement('div',{className:zoomOutBtnCx('zoomModalImg'),onClick:function onClick(){return _this3.handleZoomOut('zoomModalImg');}}),wp.element.createElement('div',{className:zoomInBtnCx('zoomModalImg'),onClick:function onClick(){return _this3.handleZoomIn('zoomModalImg');}}),showCategoryIdxBtn&&wp.element.createElement('div',{style:{marginLeft:'16px'}},this.renderCategoryIdxBtn('modal'))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer-wrapper']},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_26_classnames___default()(__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['popup-mode']),placement:'bottom',visible:this.state.categoryIdxDrawerModal,getContainer:false,height:150,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList())))),isModalVisible&&__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"]&&!isTabletLandscape&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-wrapper'],onClick:this.handleCloseModal},showCategoryIdxBtn&&!this.state.categoryIdxDrawerModal&&wp.element.createElement('div',{style:{position:'absolute',bottom:'10%',left:'5%',zIndex:1100}},this.renderCategoryIdxBtn('modal')),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['close-btn']}),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['modal-content-wrapper'],style:{width:'100%',height:'100%',display:'flex',alignItems:'center'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container-modal',style:{width:'100%',height:isMobilePortrait||isTabletPortrait?'auto':'100%'}},wp.element.createElement('div',{'class':'swiper-wrapper h-100',style:{alignItems:'center'}},catalogueInfo.images.map(function(imgURL){return wp.element.createElement('div',{'class':'swiper-slide',style:{display:isTabletPortrait||isMobileLandscape?'flex':'inherit',justifyContent:isMobileLandscape?'center':'inherit'}},wp.element.createElement('div',{'class':'catalogs-page-image',style:{display:'flex',alignItems:'center',justifyContent:'center',width:isTabletPortrait?'auto':isMobilePortrait?'100%':'auto',height:isTabletPortrait?'auto':isMobilePortrait?'auto':'100%'}},wp.element.createElement('img',{'data-src':imgURL,alt:'','class':'swiper-lazy',style:{visibility:'hidden',width:isTabletPortrait?'85%':isMobilePortrait?'95%':'auto',height:isTabletPortrait?'auto':isMobilePortrait?'auto':'95%'}}),wp.element.createElement('div',{'class':'swiper-lazy-preloader'})));})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['next-btn-wrapper'],style:{visibility:currentPage!==totalPage?'visible':'hidden'}},wp.element.createElement('div',{'class':'next-btn'})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['prev-btn-wrapper'],style:{visibility:currentPage!==1?'visible':'hidden'}},wp.element.createElement('div',{'class':'previous-btn'}))))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['operation-bar-wrapper']},wp.element.createElement('div',{className:'text-white mr-lg-5'},this.getSliderTipFormat(currentPage))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer-wrapper'],style:{zIndex:1500}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_drawer___default.a,{className:__WEBPACK_IMPORTED_MODULE_26_classnames___default()(__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['drawer'],__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['popup-mode']),placement:'bottom',visible:this.state.categoryIdxDrawerModal,getContainer:false,bodyStyle:{background:'#0870e6'},onClose:this.handleCloseDrawer},this.renderDrawerList()))),isModalVisible&&__WEBPACK_IMPORTED_MODULE_27_react_device_detect__["isMobile"]&&isTabletLandscape&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-wrapper'],onClick:this.handleCloseModal},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['close-btn']}),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['modal-content-wrapper'],style:{width:'100%',height:isTabletLandscape?'auto':'100%',display:'flex',alignItems:'center'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container-modal',style:{width:'100%',height:isMobilePortrait?'auto':'100%'}},wp.element.createElement('div',{'class':'swiper-wrapper h-100',style:{alignItems:'center'}},catalogueInfo.imagesPreviewsDoublePage.map(function(imgArray){return wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('div',{'class':'catalogs-page-image h-100',style:{width:'90%',margin:'0 auto'}},imgArray.map(function(url,idx){return wp.element.createElement('img',{'data-src':url,alt:'','class':'swiper-lazy',style:{visibility:'hidden',width:'50%',objectPosition:imgArray.length===1?'center':idx%2===0?'right':'left'}});}),wp.element.createElement('div',{'class':'swiper-lazy-preloader'})));})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['next-btn-wrapper'],style:{visibility:currentPage!==totalPage?'visible':'hidden'}},wp.element.createElement('div',{'class':'next-btn'})),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['prev-btn-wrapper'],style:{visibility:currentPage!==1?'visible':'hidden'}},wp.element.createElement('div',{'class':'previous-btn'}))))),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['operation-bar-wrapper']},wp.element.createElement('div',{className:'text-white mr-lg-5'},this.getSliderTipFormat(currentPage)))),isModalVisibleInfo&&wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['mask-wrapper'],onClick:this.handleCloseModal},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_29__catalogue_info_module_scss___default.a['close-btn']}),wp.element.createElement(InfoDetail,null))),iFrameUrl!==null&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('section',{'class':'pt-md-5'},wp.element.createElement('div',{align:'center'},wp.element.createElement('iframe',{title:'edm-iframe',name:'edm-iframe',id:'edm-iframe',src:iFrameUrl,style:{minWidth:'100%',minHeight:'100%'},height:'auto',scrolling:'yes',frameborder:'no'})))),!havePageinfo&&iFrameUrl===null&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('section',{'class':'pt-md-5'},!isKiosk&&pdf&&wp.element.createElement('a',{id:'pdf',alt:catalogueInfo.name,href:pdf&&pdf.replace('mppuni-prosperity','wwwuni-prosperity'),target:'_blank',rel:'noopener noreferrer'},' ',Object(__WEBPACK_IMPORTED_MODULE_24__wordpress_i18n__["__"])('PDF下載','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement('div',{align:'center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{grid:{gutter:16,xs:1,sm:1,md:1,lg:1,xl:1,xxl:1},dataSource:this.state.data,renderItem:function renderItem(image,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,{key:idx},wp.element.createElement('img',{align:'center',src:image,alt:'\u76EE\u9304',style:{width:'100%'}}));},locale:{emptyText:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_empty___default.a,{image:__WEBPACK_IMPORTED_MODULE_3_antd_lib_empty___default.a.PRESENTED_IMAGE_SIMPLE,description:'\u8CC7\u6599\u8F09\u5165\u4E2D...'})}},this.state.loading&&this.state.hasMore&&wp.element.createElement('div',{className:'demo-loading-container'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,null))))))));}}]);return CatalogueInfo;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueInfoEditor=function(_Component2){_inherits(CatalogueInfoEditor,_Component2);function CatalogueInfoEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,CatalogueInfoEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=CatalogueInfoEditor.__proto__||Object.getPrototypeOf(CatalogueInfoEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_19_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(defaultListInfo)},_this4.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this4,'props.match.params.id');if(!id)return;_this4.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_31_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_32_configs_env__["b" /* API_HOST */]+('/api/v1/catalogues/'+id),null,function(state,res){_this4.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_message___default.a.warning(reason);_this4.props.history.replace('/catalogues');return;}_this4.fillData(data);});},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(CatalogueInfoEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_30_libs_AppHelper__["a" /* default */].updateConfig();}// 抓取頁面資訊
},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u5167\u5BB9'));}}]);return CatalogueInfoEditor;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(2133);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(870);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(2134);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(2135);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(873);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2139);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(97));

var _configProvider = __webpack_require__(8);

var _throttleByAnimationFrame = __webpack_require__(2140);

var _utils = __webpack_require__(2141);

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof2["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

function getDefaultTarget() {
  return typeof window !== 'undefined' ? window : null;
}

var AffixStatus;

(function (AffixStatus) {
  AffixStatus[AffixStatus["None"] = 0] = "None";
  AffixStatus[AffixStatus["Prepare"] = 1] = "Prepare";
})(AffixStatus || (AffixStatus = {}));

var Affix = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Affix, _React$Component);

  var _super = (0, _createSuper2["default"])(Affix);

  function Affix() {
    var _this;

    (0, _classCallCheck2["default"])(this, Affix);
    _this = _super.apply(this, arguments);
    _this.state = {
      status: AffixStatus.None,
      lastAffix: false,
      prevTarget: null
    };

    _this.getOffsetTop = function () {
      var offsetBottom = _this.props.offsetBottom;
      var offsetTop = _this.props.offsetTop;

      if (offsetBottom === undefined && offsetTop === undefined) {
        offsetTop = 0;
      }

      return offsetTop;
    };

    _this.getOffsetBottom = function () {
      return _this.props.offsetBottom;
    };

    _this.savePlaceholderNode = function (node) {
      _this.placeholderNode = node;
    };

    _this.saveFixedNode = function (node) {
      _this.fixedNode = node;
    }; // =================== Measure ===================


    _this.measure = function () {
      var _this$state = _this.state,
          status = _this$state.status,
          lastAffix = _this$state.lastAffix;
      var onChange = _this.props.onChange;

      var targetFunc = _this.getTargetFunc();

      if (status !== AffixStatus.Prepare || !_this.fixedNode || !_this.placeholderNode || !targetFunc) {
        return;
      }

      var offsetTop = _this.getOffsetTop();

      var offsetBottom = _this.getOffsetBottom();

      var targetNode = targetFunc();

      if (!targetNode) {
        return;
      }

      var newState = {
        status: AffixStatus.None
      };
      var targetRect = (0, _utils.getTargetRect)(targetNode);
      var placeholderReact = (0, _utils.getTargetRect)(_this.placeholderNode);
      var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
      var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);

      if (fixedTop !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          top: fixedTop,
          width: placeholderReact.width,
          height: placeholderReact.height
        };
        newState.placeholderStyle = {
          width: placeholderReact.width,
          height: placeholderReact.height
        };
      } else if (fixedBottom !== undefined) {
        newState.affixStyle = {
          position: 'fixed',
          bottom: fixedBottom,
          width: placeholderReact.width,
          height: placeholderReact.height
        };
        newState.placeholderStyle = {
          width: placeholderReact.width,
          height: placeholderReact.height
        };
      }

      newState.lastAffix = !!newState.affixStyle;

      if (onChange && lastAffix !== newState.lastAffix) {
        onChange(newState.lastAffix);
      }

      _this.setState(newState);
    }; // @ts-ignore TS6133


    _this.prepareMeasure = function () {
      // event param is used before. Keep compatible ts define here.
      _this.setState({
        status: AffixStatus.Prepare,
        affixStyle: undefined,
        placeholderStyle: undefined
      }); // Test if `updatePosition` called


      if (false) {
        var onTestUpdatePosition = _this.props.onTestUpdatePosition;

        if (onTestUpdatePosition) {
          onTestUpdatePosition();
        }
      }
    }; // =================== Render ===================


    _this.render = function () {
      var getPrefixCls = _this.context.getPrefixCls;
      var _this$state2 = _this.state,
          affixStyle = _this$state2.affixStyle,
          placeholderStyle = _this$state2.placeholderStyle;
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          children = _this$props.children;
      var className = (0, _classnames["default"])((0, _defineProperty2["default"])({}, getPrefixCls('affix', prefixCls), affixStyle));
      var props = (0, _omit["default"])(_this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']); // Omit this since `onTestUpdatePosition` only works on test.

      if (false) {
        props = (0, _omit["default"])(props, ['onTestUpdatePosition']);
      }

      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
        onResize: function onResize() {
          _this.updatePosition();
        }
      }, /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, props, {
        ref: _this.savePlaceholderNode
      }), affixStyle && /*#__PURE__*/React.createElement("div", {
        style: placeholderStyle,
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: _this.saveFixedNode,
        style: affixStyle
      }, /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
        onResize: function onResize() {
          _this.updatePosition();
        }
      }, children))));
    };

    return _this;
  }

  (0, _createClass2["default"])(Affix, [{
    key: "getTargetFunc",
    value: function getTargetFunc() {
      var getTargetContainer = this.context.getTargetContainer;
      var target = this.props.target;

      if (target !== undefined) {
        return target;
      }

      return getTargetContainer || getDefaultTarget;
    } // Event handler

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var targetFunc = this.getTargetFunc();

      if (targetFunc) {
        // [Legacy] Wait for parent component ref has its value.
        // We should use target as directly element instead of function which makes element check hard.
        this.timeout = setTimeout(function () {
          (0, _utils.addObserveTarget)(targetFunc(), _this2); // Mock Event object.

          _this2.updatePosition();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevTarget = this.state.prevTarget;
      var targetFunc = this.getTargetFunc();
      var newTarget = null;

      if (targetFunc) {
        newTarget = targetFunc() || null;
      }

      if (prevTarget !== newTarget) {
        (0, _utils.removeObserveTarget)(this);

        if (newTarget) {
          (0, _utils.addObserveTarget)(newTarget, this); // Mock Event object.

          this.updatePosition();
        } // eslint-disable-next-line react/no-did-update-set-state


        this.setState({
          prevTarget: newTarget
        });
      }

      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
        this.updatePosition();
      }

      this.measure();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      (0, _utils.removeObserveTarget)(this);
      this.updatePosition.cancel(); // https://github.com/ant-design/ant-design/issues/22683

      this.lazyUpdatePosition.cancel();
    } // Handle realign logic

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      this.prepareMeasure();
    }
  }, {
    key: "lazyUpdatePosition",
    value: function lazyUpdatePosition() {
      var targetFunc = this.getTargetFunc();
      var affixStyle = this.state.affixStyle; // Check position change before measure to make Safari smooth

      if (targetFunc && affixStyle) {
        var offsetTop = this.getOffsetTop();
        var offsetBottom = this.getOffsetBottom();
        var targetNode = targetFunc();

        if (targetNode && this.placeholderNode) {
          var targetRect = (0, _utils.getTargetRect)(targetNode);
          var placeholderReact = (0, _utils.getTargetRect)(this.placeholderNode);
          var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
          var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);

          if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
            return;
          }
        }
      } // Directly call prepare measure since it's already throttled.


      this.prepareMeasure();
    }
  }]);
  return Affix;
}(React.Component);

Affix.contextType = _configProvider.ConfigContext;

__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);

__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "lazyUpdatePosition", null);

var _default = Affix;
exports["default"] = _default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _ArrowLeftOutlined = _interopRequireDefault(__webpack_require__(2142));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _ArrowLeftOutlined.default
  }));
};
ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
var _default = /*#__PURE__*/React.forwardRef(ArrowLeftOutlined);
exports.default = _default;

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(2148);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      style = props.style;
  var length = props.length,
      offset = props.offset,
      reverse = props.reverse;

  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset = 100 - offset;
  }

  var positonStyle = vertical ? (_ref = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, reverse ? 'bottom' : 'top', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, reverse ? 'left' : 'right', 'auto'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, "width", "".concat(length, "%")), _ref2);

  var elStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), positonStyle);

  return included ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: className,
    style: elStyle
  }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_get__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_inherits__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Steps__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Marks__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Handle__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(476);



















/* eslint-disable @typescript-eslint/no-explicit-any */

function noop() {}

function createSlider(Component) {
  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  return _a = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_inherits__["a" /* default */])(ComponentEnhancer, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ComponentEnhancer);

    function ComponentEnhancer(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ComponentEnhancer);

      _this = _super.call(this, props);

      _this.onDown = function (e, position) {
        var p = position;
        var _this$props = _this.props,
            draggableTrack = _this$props.draggableTrack,
            isVertical = _this$props.vertical;
        var bounds = _this.state.bounds;
        var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
        var inPoint = __WEBPACK_IMPORTED_MODULE_18__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs);
        _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function (n, i) {
          var v = !i ? n >= bounds[i] : true;
          return i === value.length - 1 ? n <= bounds[i] : v;
        }).some(function (c) {
          return !c;
        });

        if (_this.dragTrack) {
          _this.dragOffset = p;
          _this.startBounds = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(bounds);
        } else {
          if (!inPoint) {
            _this.dragOffset = 0;
          } else {
            var handlePosition = __WEBPACK_IMPORTED_MODULE_18__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
            _this.dragOffset = p - handlePosition;
            p = handlePosition;
          }

          _this.onStart(p);
        }
      };

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        _this.removeDocumentEvents();

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_18__utils__["e" /* getMousePosition */](isVertical, e);

        _this.onDown(e, position);

        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_18__utils__["h" /* isNotTouchEvent */](e)) return;
        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_18__utils__["f" /* getTouchPosition */](isVertical, e);

        _this.onDown(e, position);

        _this.addDocumentTouchEvents();

        __WEBPACK_IMPORTED_MODULE_18__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props2 = _this.props,
            onFocus = _this$props2.onFocus,
            vertical = _this$props2.vertical;

        if (__WEBPACK_IMPORTED_MODULE_18__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs) && !_this.dragTrack) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_18__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;

          _this.onStart(handlePosition);

          __WEBPACK_IMPORTED_MODULE_18__utils__["j" /* pauseEvent */](e);

          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        if (!_this.dragTrack) {
          _this.onEnd();
        }

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_18__utils__["e" /* getMousePosition */](_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_18__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_18__utils__["f" /* getTouchPosition */](_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_18__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();

        _this.onChange({
          value: value
        }); // eslint-disable-next-line react/no-unused-state


        _this.setState({
          value: value
        }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;
      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line

      Object(__WEBPACK_IMPORTED_MODULE_14_rc_util_es_warning__["a" /* default */])(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
      _this.handlesRefs = {};
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(ComponentEnhancer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
        var _this$props3 = this.props,
            autoFocus = _this$props3.autoFocus,
            disabled = _this$props3.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "componentWillUnmount", this)) Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _this$props4 = this.props,
            vertical = _this$props4.vertical,
            reverse = _this$props4.reverse;
        var rect = slider.getBoundingClientRect();

        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }

        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider = this.sliderRef;

        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        /* eslint-disable @typescript-eslint/no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: "focus",
      value: function focus() {
        var _this$handlesRefs$;

        if (this.props.disabled) {
          return;
        }

        (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 ? void 0 : _this$handlesRefs$.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this2 = this;

        if (this.props.disabled) {
          return;
        }

        Object.keys(this.handlesRefs).forEach(function (key) {
          var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;

          (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 ? void 0 : (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 ? void 0 : _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
        });
      }
    }, {
      key: "calcValue",
      value: function calcValue(offset) {
        var _this$props5 = this.props,
            vertical = _this$props5.vertical,
            min = _this$props5.min,
            max = _this$props5.max;
        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value) {
        var _this$props6 = this.props,
            min = _this$props6.min,
            max = _this$props6.max;
        var ratio = (value - min) / (max - min);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var _this$props7 = this.props,
            prefixCls = _this$props7.prefixCls,
            className = _this$props7.className,
            marks = _this$props7.marks,
            dots = _this$props7.dots,
            step = _this$props7.step,
            included = _this$props7.included,
            disabled = _this$props7.disabled,
            vertical = _this$props7.vertical,
            reverse = _this$props7.reverse,
            min = _this$props7.min,
            max = _this$props7.max,
            children = _this$props7.children,
            maximumTrackStyle = _this$props7.maximumTrackStyle,
            style = _this$props7.style,
            railStyle = _this$props7.railStyle,
            dotStyle = _this$props7.dotStyle,
            activeDotStyle = _this$props7.activeDotStyle;

        var _get$call = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ComponentEnhancer.prototype), "render", this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_13_classnames___default()(prefixCls, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-vertical"), vertical), Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, className, className), _classNames));
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onMouseUp: disabled ? noop : this.onMouseUp,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, maximumTrackStyle), railStyle)
        }), tracks, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Steps__["a" /* default */], {
          prefixCls: prefixCls,
          vertical: vertical,
          reverse: reverse,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }), handles, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Marks__["a" /* default */], {
          className: "".concat(prefixCls, "-mark"),
          onClickLabel: disabled ? noop : this.onClickMarkLabel,
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          reverse: reverse
        }), children);
      }
    }]);

    return ComponentEnhancer;
  }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Component.defaultProps), {}, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(props) {
      var index = props.index,
          restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["index"]);

      delete restProps.dragging;

      if (restProps.value === null) {
        return null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Handle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, restProps, {
        key: index
      }));
    },
    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _a;
}

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_tooltip__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__ = __webpack_require__(75);





var SliderTooltip = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (props, ref) {
  var visible = props.visible,
      overlay = props.overlay;
  var innerRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](null);
  var tooltipRef = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_ref__["a" /* composeRef */])(ref, innerRef);
  var rafRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](null);

  function cancelKeepAlign() {
    __WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__["a" /* default */].cancel(rafRef.current);
  }

  function keepAlign() {
    rafRef.current = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__["a" /* default */])(function () {
      var _innerRef$current;

      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.forcePopupAlign();
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }

    return cancelKeepAlign;
  }, [visible, overlay]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_tooltip__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: tooltipRef
  }, props));
});
/* harmony default export */ __webpack_exports__["a"] = (SliderTooltip);

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"category-idx-btn":"category-idx-btn___2c-Vh","opened":"opened___jaiqL","info-tooltip":"info-tooltip___uHT_B","operation-wrapper":"operation-wrapper___3JPKs","fake-space":"fake-space___28msu","slider-wrapper":"slider-wrapper___qJwtX","index-wrapper":"index-wrapper___34p62","slider":"slider___1aY3a","function-wrapper":"function-wrapper___35-2o","info-btn":"info-btn___36G1p","info-card":"info-card___2-X8r","download-btn":"download-btn___2QuLl","fullscreen-btn":"fullscreen-btn___3Z_3_","zoom-out-btn":"zoom-out-btn___1swZI","disabled":"disabled___1wFmH","zoom-in-btn":"zoom-in-btn___14anf","fullscreen-icon":"fullscreen-icon___2o5C3","next-btn-wrapper":"next-btn-wrapper___ef6bU","prev-btn-wrapper":"prev-btn-wrapper___3tKGq","mask-wrapper":"mask-wrapper___b2w3y","mask-right-icon":"mask-right-icon___24qmH","mask-left-icon":"mask-left-icon___2_fPD","close-btn":"close-btn___3VkDh","modal-content-wrapper":"modal-content-wrapper___2AZat","modal-image":"modal-image___3tcJx","operation-section":"operation-section___RG6go","operation-bar-wrapper":"operation-bar-wrapper___2QUHw","drawer-wrapper":"drawer-wrapper___21PwR","swiper-wrapper":"swiper-wrapper___2L3sz","slide-product-wrapper":"slide-product-wrapper___2FCyC","slide-product-column":"slide-product-column___JHCSw","product-list-wrapper":"product-list-wrapper___1b5Ys","card-wrapper":"card-wrapper___sXzHK","product-list-img":"product-list-img___3sMq_","product-list-empty-img":"product-list-empty-img___EcuMb","preview-image-wrapper":"preview-image-wrapper___112C3","preview-image":"preview-image___2zbhD","preview-wrapper":"preview-wrapper___3aN5R","preview-scale-wrapper":"preview-scale-wrapper___3zOlL","preview-scale-inner-wrapper":"preview-scale-inner-wrapper___11gh3","breadcrumb":"breadcrumb___TABuN","drawer":"drawer___3usWZ","drawer-category-list":"drawer-category-list___nzcpn","drawer-category":"drawer-category___3Vnsp","popup-mode":"popup-mode___1yRd6"};

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CataloguePos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CataloguePosEditor", function() { return CataloguePosEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__catalogue_info_pos__ = __webpack_require__(477);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INDEX_URL=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var defaultListInfo={"current":1,//目前頁數
"page_size":10,//一頁幾筆
"total":1,//以此query條件，總共幾筆資料
"rows":[]};var CataloguMode={Default:1,// 預設列表
Slider:2// 首頁橫向滑動
// 前端頁面
};var CataloguePos=function(_Component){_inherits(CataloguePos,_Component);function CataloguePos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CataloguePos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CataloguePos.__proto__||Object.getPrototypeOf(CataloguePos)).call.apply(_ref,[this].concat(args))),_this),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo)},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:'all'};var tableQuery=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this,'state.tableQuery',{});var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_13__configs_env__["b" /* API_HOST */]+'/api/v1/catalogues',{page:page,page_size:page_size},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({listInfo:data},function(){_this.reloadSwiper();});});},_this.reloadSwiper=function(){var Swiper=window.Swiper;if(!Swiper)return;window.swiperCatalog=new Swiper('.catalog-swiper',{slidesPerView:5,spaceBetween:30,loop:true,navigation:{nextEl:'.catalog-swiper-button-next',prevEl:'.catalog-swiper-button-prev'},breakpoints:{992:{slidesPerView:3},767:{slidesPerView:3,spaceBetween:0,centeredSlides:true,watchSlidesProgress:true,watchSlidesVisibility:true}}});},_this.genInfoLink=function(id){var location=window.location;return location.protocol+'//'+location.host+location.pathname+'?view=kiosk&id='+id;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CataloguePos,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();}},{key:'render',value:function render(){var _this2=this;var _state$listInfo=this.state.listInfo,listInfo=_state$listInfo===undefined?{}:_state$listInfo;var catalogues=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'state.listInfo.rows',[]);var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});var category_ids=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props,'category_ids',[]);var catalogue_categories=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(options,'catalogue_categories',[]).sort(function(a,b){return a.id-b.id;});var selectedCategoryId=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'state.selectedCategoryId',__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(catalogue_categories,'0.id'));var mode=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.mode',CataloguMode.Default);var urlQuery=__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].getURLQuery();var isKiosk=urlQuery.view;var Local=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG.Locale');var NavTavCate=[];catalogue_categories.forEach(function(category){catalogues.find(function(item){return item.category_id===category.id;})&&NavTavCate.push(category);});var catalogueID=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(urlQuery,'id');if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEmpty(catalogueID)){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19__catalogue_info_pos__["default"],null);}return wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'tab-content',id:'pills-tabContent'},__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(NavTavCate,function(category,idx){return wp.element.createElement('div',{className:'container',key:idx},wp.element.createElement('section',{className:'py-lg-5'},wp.element.createElement('h2',{className:'card-title'},category.name),wp.element.createElement('div',{className:'row'},catalogues.filter(function(catalogues){return catalogues.category_id===category.id;}).map(function(catalogue,idx){//const imageurl =  reactStringReplace(_.first(catalogue.images), 'mpp', 'www') 
//console.log('imageurl',imageurl)
return wp.element.createElement('div',{key:idx,className:'col-6 col-md-4 column-lg-5 mb-4 wow fadeInUp','data-wow-delay':'0.1s'},wp.element.createElement('a',{className:'catalog-item mb-3',role:'button',href:_this2.genInfoLink(catalogue.id)},wp.element.createElement('span',{className:'cover img-catalog mb-2',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.first(catalogue.images).replace('mppuni-prosperity','wwwuni-prosperity')+')'}},wp.element.createElement('span',{className:'more'},wp.element.createElement('i',{className:'fas fa-eye'}))),wp.element.createElement('h6',{className:'note align-self-start text-navy fw-700 mb-1'},Local=="zh_TW"&&catalogue.name,Local=="en_US"&&catalogue.en_name),wp.element.createElement('div',{className:'d-flex flex-lg-row flex-column justify-content-between aling-items-center w-100'},wp.element.createElement('p',{className:'note mb-lg-0 mb-2 text-dark'},catalogue.promotion_start_date,'-',catalogue.promotion_end_date))));}))));})));}}]);return CataloguePos;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CataloguePosEditor=function(_Component2){_inherits(CataloguePosEditor,_Component2);function CataloguePosEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,CataloguePosEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=CataloguePosEditor.__proto__||Object.getPrototypeOf(CataloguePosEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(CataloguePosEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this4=this;var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{className:'components-placeholder__label'},wp.element.createElement('span',{className:'block-editor-block-icon'},wp.element.createElement('div',{alt:'f538',className:'dashicons dashicons-layout'})),'\u4FC3\u92B7\u76EE\u9304\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'// layout="vertical"
// onFinish={values => this.submitData(values)}
,onValuesChange:function onValuesChange(changedFields,allFields){return _this4.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_ids','目錄類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(options,'catalogue_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_checkbox___default.a,{value:item.id},item.name));}})))));}}]);return CataloguePosEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CibcCalculation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CibcCalculationEditor", function() { return CibcCalculationEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_module_scss__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cibc_css__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cibc_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cibc_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG');var CibcCalculation=function(_Component){_inherits(CibcCalculation,_Component);function CibcCalculation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CibcCalculation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CibcCalculation.__proto__||Object.getPrototypeOf(CibcCalculation)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef(),_this.state={query:{},storeInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},store:[],area:null,branch:[],loading:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CibcCalculation,[{key:'componentDidMount',value:function componentDidMount(){cibcCalculationDidMount();}},{key:'render',value:function render(){return wp.element.createElement('main',{'class':'bg-light',id:'calculation'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0 '},wp.element.createElement('nav',{'aria-label':'breadcrumb',style:{textAlign:'left'}},wp.element.createElement('ol',{'class':'breadcrumb '},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/cibc'},'\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u4FDD\u96AA\u8A66\u7B97\u8868')))),wp.element.createElement('section',{'class':'pt-5 pb-0'},wp.element.createElement('div',{'class':'basic-tabs-border mb-5'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc'},'\u9996\u9801')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-about'},'\u4FDD\u96AA\u7D93\u7D00\u4EBA')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-service'},'\u670D\u52D9\u9805\u76EE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-product'},'\u5546\u54C1\u8CC7\u8A0A')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-partner'},'\u5408\u4F5C\u5925\u4F34')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-activity'},'\u6D3B\u52D5\u526A\u5F71')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-servicepoint'},'\u670D\u52D9\u64DA\u9EDE')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/cibc-recruit'},'\u4EBA\u624D\u62DB\u52DF'))))),wp.element.createElement('div',{'class':'wrapper cibc-menu cibc-cal'},wp.element.createElement('div',null,wp.element.createElement('div',{'class':'contentbox'},wp.element.createElement('div',{'class':'blocktitle'},wp.element.createElement('span',null,'\u4FDD\u969C\u8A66\u7B97')),wp.element.createElement('div',{'class':'infoblock'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u500B\u4EBA\u8CC7\u6599')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('div',{'class':'inputbox'},wp.element.createElement('ul',null,wp.element.createElement('li',{'class':'fullwidth'},wp.element.createElement('div',{'class':'text',style:{paddingLeft:'0'}},wp.element.createElement('span',null,'\u59D3\u540D')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'name'}))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text',style:{paddingLeft:'0'}},wp.element.createElement('span',null,'\u751F\u65E5')),wp.element.createElement('div',{'class':'input',id:'datepickerbox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_date_picker___default.a,{id:'datepicker',onChange:DateonChange,style:{width:'100%'}}))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text',style:{paddingLeft:'0'}},wp.element.createElement('span',null,'\u6027\u5225')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('select',{name:'gender'},wp.element.createElement('option',{value:''},'\u8ACB\u9078\u64C7\u6027\u5225'),wp.element.createElement('option',{value:'\u7537'},'\u7537'),wp.element.createElement('option',{value:'\u5973'},'\u5973')))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',null,'\u60A8\u7684\u4FDD\u96AA\u5E74\u9F61'),wp.element.createElement('span',{'class':'resultstr age'},'0'),wp.element.createElement('span',null,'\u6B72,\u96E2\u52DE\u4FDD\u9000\u4F11\u5E74\u9F61'),wp.element.createElement('span',{'class':'resultstr year'},'0'),wp.element.createElement('span',null,'\u5E74')))),wp.element.createElement('div',{'class':'incomeblock'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u6536\u5165\u72C0\u6CC1')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('div',{'class':'inputbox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u6BCF\u6708\u56FA\u5B9A\u6536\u5165')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'stableincome',id:'stableincome',onkeyup:'value=value.replace(/[^\\d]/g,\'\').replace(/0*(\\d*)/,\'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5143'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u6BCF\u6708\u5176\u4ED6\u6536\u5165')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'otherincome',id:'otherincome',onkeyup:'value=value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5143'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',null,'\u6536\u5165\u5C0F\u8A08'),wp.element.createElement('span',{'class':'resultstr incomemoney'},'0'),wp.element.createElement('span',null,'\u5143/\u6708')))),wp.element.createElement('div',{'class':'expenditureblock'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u652F\u51FA\u72C0\u6CC1')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('div',{'class':'inputbox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u623F\u8CB8/\u623F\u79DF\u652F\u51FA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'mortgageprice',onkeyup:'value=value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'mortgageyear',onkeyup:'value=value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5E74'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u8ECA\u8CB8\u652F\u51FA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'carloanprice',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'carloanyear',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5E74'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u5176\u4ED6\u8CB8\u6B3E')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'otherloansprice',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'otherloansyear',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5E74'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u6559\u80B2\u8CBB\u7528\u652F\u51FA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'eduprice',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'eduyear',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5E74'))),wp.element.createElement('li',{'class':'lastaverage'},wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u96E2\u9000\u4F11\u751F\u6D3B\u5E73\u5747\u6708\u652F\u51FA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'averageprice',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u6708\uFF0C\u96E2\u52DE\u4FDD\u9000\u4F11\u5E74\u9F61'),wp.element.createElement('span',{id:'averageyear'},'0'),wp.element.createElement('span',null,'\u5E74'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',null,'\u652F\u51FA\u5C0F\u8A08'),wp.element.createElement('span',{'class':'resultstr money'},'0'),wp.element.createElement('span',null,'\u5143/\u6708')),wp.element.createElement('div',{'class':'demandbox none'},wp.element.createElement('div',{'class':'titlebox'},wp.element.createElement('span',null,'\u60A8\u7684\u4FDD\u969C\u9700\u6C42')),wp.element.createElement('div',{'class':'noticebox'},wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u4E0D\u542B\u6708\u751F\u6D3B\u652F\u51FA')),wp.element.createElement('div',{'class':'price'},wp.element.createElement('span',{id:'excludeprice','class':'priceText'},'0')),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u5143/\u5E74\uFF0C\u542B\u6708\u751F\u6D3B\u652F\u51FA')),wp.element.createElement('div',{'class':'price'},wp.element.createElement('span',{id:'includeprice','class':'priceText'},'0')),wp.element.createElement('div',{'class':'last'},wp.element.createElement('span',null,'\u5143/\u5E74'))),wp.element.createElement('div',{'class':'colorbox'},wp.element.createElement('ul',{'class':'colorlist'},wp.element.createElement('li',{'class':'first'},wp.element.createElement('i',{'class':'one'}),wp.element.createElement('span',null,'\u623F\u8CB8/\u623F\u79DF\u652F\u51FA')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'two'}),wp.element.createElement('span',null,'\u8ECA\u8CB8\u652F\u51FA')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'three'}),wp.element.createElement('span',null,'\u5176\u4ED6\u8CB8\u6B3E')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'four'}),wp.element.createElement('span',null,'\u9000\u4F11\u751F\u6D3B\u652F\u51FA')),wp.element.createElement('li',{'class':'last'},wp.element.createElement('i',{'class':'five'}),wp.element.createElement('span',null,'\u6559\u80B2\u8CBB\u7528\u652F\u51FA')))),wp.element.createElement('div',{'class':'chartbox'}),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('ul',{'class':'resultlist'},wp.element.createElement('li',{'class':'result'},wp.element.createElement('span',{'class':'text'},'\u58FD\u96AA\u4FDD\u969C\u9700\u6C42'),wp.element.createElement('span',{id:'lifeinsuranceprice','class':'price'},'0'),wp.element.createElement('span',{'class':'unit'},'\u5143')),wp.element.createElement('li',{'class':'result'},wp.element.createElement('span',{'class':'text'},'\u6BCF\u500B\u6708\u6536\u5165-\u652F\u51FA\u9918\u984D'),wp.element.createElement('span',{id:'inandoutcomeprice','class':'price sp'},'0'),wp.element.createElement('span',{'class':'unit'},'\u5143'))))))),wp.element.createElement('div',{'class':'hospitalizebox'},wp.element.createElement('div',{'class':'shadowbox'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u4F4F\u9662\u65E5\u984D')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('ul',null,wp.element.createElement('li',{'class':'first'},wp.element.createElement('div',{'class':'title'},wp.element.createElement('span',null,'\u5DF2\u6295\u4FDD\u4F4F\u9662\u65E5\u984D')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'hospitalprice',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u5143/\u65E5'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'title'},wp.element.createElement('span',null,'\u9078\u64C7\u5C45\u4F4F\u5730\u4E3B\u8981\u91AB\u9662')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'hospital',placeholder:'\u8ACB\u53C3\u8003\u4E3B\u8981\u91AB\u9662\u75C5\u623F\u8CBB',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u5143/\u65E5'))),wp.element.createElement('div',{'class':'text'},wp.element.createElement('a',{href:'#',id:'choosehospital'},'\u67E5\u8A62\u4E3B\u8981\u91AB\u9662\u75C5\u623F\u8CBB'))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u5C1A\u9700\u88DC\u5F37'),wp.element.createElement('span',{'class':'price hospital'},'0'),wp.element.createElement('span',{'class':'unit'},'\u5143/\u65E5'))))),wp.element.createElement('div',{'class':'longtermcarebox'},wp.element.createElement('div',{'class':'shadowbox'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u9577\u7167&\u5931\u80FD\u9700\u6C42')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('ul',null,wp.element.createElement('li',{'class':'first'},wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u9810\u4F30\u9577\u7167\u6216\u5931\u80FD\u6708\u652F\u51FA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'incapacitation',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5143/\u6708'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u793E\u6703\u88DC\u52A9')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'allowance',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5143/\u6708'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u81EA\u8CFC\u5546\u696D\u4FDD\u96AA')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'selfinsurance',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5143/\u6708')))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u5C1A\u9700\u88DC\u5F37'),wp.element.createElement('span',{'class':'price allow'},'0'),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708'))))),wp.element.createElement('div',{'class':'retirebox'},wp.element.createElement('div',{'class':'row-title'},wp.element.createElement('strong',null,'\u9000\u4F11\u751F\u6D3B')),wp.element.createElement('div',{'class':'row-comment'},wp.element.createElement('div',{'class':'inputbox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('div',{'class':'text'},wp.element.createElement('span',null,'\u9810\u4F30\u9000\u4F11\u5E74\u9F61')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'estimated',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'middle'},wp.element.createElement('span',null,'\u6B72\uFF0C\u9810\u4F30\u9000\u4F11\u5F8C\u9918\u547D')),wp.element.createElement('div',{'class':'input'},wp.element.createElement('input',{type:'text',name:'survival'})),wp.element.createElement('div',{'class':'unit'},wp.element.createElement('span',null,'\u5E74')),wp.element.createElement('div',{'class':'openimage'},wp.element.createElement('span',null,'\u9810\u4F30\u53C3\u8003\u503C'))))),wp.element.createElement('div',{'class':'noticebox'},wp.element.createElement('span',null,'\u4F9D\u64DA\u5167\u653F\u90E8106\u5E74\u7D71\u8A08\u751F\u5E73\u5747\u58FD\u547D',wp.element.createElement('br',null),'\u7537\u6027:77\u6B72\uFF0C\u5973\u602783\u6B72')),wp.element.createElement('div',{'class':'inputbox bottom'},wp.element.createElement('ul',null,wp.element.createElement('li',{'class':'allred'},wp.element.createElement('div',{'class':'subtext'},wp.element.createElement('span',null,'\u9810\u4F30\u9000\u4F11\u5F8C\u6708\u652F\u51FA')),wp.element.createElement('div',{'class':'subinput'},wp.element.createElement('input',{type:'text',name:'retireoutlay',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'subunit'},wp.element.createElement('span',null,'\u5143'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'subtext'},wp.element.createElement('span',null,'\u52DE\u4FDD\u6BCF\u6708\u7D66\u4ED8')),wp.element.createElement('div',{'class':'subinput'},wp.element.createElement('input',{type:'text',name:'retirebilingual',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'subunit'},wp.element.createElement('span',null,'\u5143'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'subtext'},wp.element.createElement('span',null,'\u5546\u696D\u4FDD\u96AA\u6BCF\u6708\u7D66\u4ED8')),wp.element.createElement('div',{'class':'subinput'},wp.element.createElement('input',{type:'text',name:'retireinsurance',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'subunit'},wp.element.createElement('span',null,'\u5143'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'subtext'},wp.element.createElement('span',null,'\u5176\u4ED6\u6BCF\u6708\u7D66\u4ED8')),wp.element.createElement('div',{'class':'subinput'},wp.element.createElement('input',{type:'text',name:'retireother',onkeyup:'value = value.replace(/[^\\d]/g, \'\').replace(/0*(\\d*)/, \'$1\') '})),wp.element.createElement('div',{'class':'subunit'},wp.element.createElement('span',null,'\u5143'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u9000\u4F11\u5F8C\u6BCF\u6708\u5C1A\u5DEE'),wp.element.createElement('span',{'class':'resultstr retiremoney'},'0'),wp.element.createElement('span',null,'\u5143')))),wp.element.createElement('div',{'class':'btnbox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('a',{href:'#',id:'html2pdfBtn'},'\u532F\u51FAPDF\u6A94')),wp.element.createElement('li',null,wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/cibc-contact-us'},'\u806F\u7D61\u6211\u5011')))))))),wp.element.createElement('div',{id:'printcibxblock',style:{fontVariant:'normal',display:'none'}},wp.element.createElement('div',{'class':'borderbox',style:{textAlign:'left'}},wp.element.createElement('div',{'class':'topbox'},wp.element.createElement('div',{'class':'contentbox'},wp.element.createElement('span',null,'\u4FDD\u969C\u8A66\u7B97\u7D50\u679C'),wp.element.createElement('span',null,'Insurance cost trial'),wp.element.createElement('div',{'class':'infobox'},wp.element.createElement('p',{'class':'red'},'\u4F9D\u64DA\u60A8\u8F38\u5165\u7684\u8CC7\u6599\uFF0C\u4FDD\u7D93\u8A66\u7B97\u51FA\u60A8\u7684\u4FDD\u969C\u9700\u6C42\u5206\u6790\u7E3D\u8868\u5982\u4E0B\uFF1A'),wp.element.createElement('p',{'class':'blue'},'\u53EF\u6301\u672C\u5206\u6790\u8868\u5C31\u8FD1\u81F3\u91CF\u8CA9\u5E97\u8207\u4FDD\u96AA\u5C08\u54E1\u505A\u8AEE\u8A62\u8207\u898F\u5283\u670D\u52D9'))),wp.element.createElement('div',{'class':'logobox'},wp.element.createElement('img',{alt:'','class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/pdf/logo.png'}))),wp.element.createElement('div',{'class':'middlebox'},wp.element.createElement('div',{'class':'sectionbox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u500B\u4EBA\u8CC7\u6599')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('span',{'class':'lefttitle'},'\u59D3\u540D'),wp.element.createElement('span',{'class':'rightcontent infoname'})),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'lefttitle'},'\u751F\u65E5'),wp.element.createElement('span',{'class':'rightcontent infobirth'})),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'lefttitle'},'\u6027\u5225'),wp.element.createElement('span',{'class':'rightcontent infogender'}))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u60A8\u7684\u4FDD\u96AA\u5E74\u9F61'),wp.element.createElement('span',{'class':'number inage'}),wp.element.createElement('span',{'class':'text'},'\u6B72\uFF0C\u96E2\u52DE\u4FDD\u9000\u4F11\u5E74\u9F61'),wp.element.createElement('span',{'class':'number reage'}),wp.element.createElement('span',{'class':'text'},'\u5E74'))),wp.element.createElement('div',{'class':'incomebox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u6536\u5165\u72C0\u6CC1')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('span',{'class':'lefttitle'},'\u6BCF\u6708\u56FA\u5B9A\u6536\u5165'),wp.element.createElement('span',{'class':'rightcontent incomeone'})),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'lefttitle'},'\u6BCF\u6708\u5176\u4ED6\u6536\u5165'),wp.element.createElement('span',{'class':'rightcontent incometwo'}))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u5C0F\u8A08'),wp.element.createElement('span',{'class':'number totalincome'}),wp.element.createElement('span',{'class':'text'},'\u5143'))),wp.element.createElement('div',{'class':'expenditurebox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u652F\u51FA\u72C0\u6CC1')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('div',{'class':'info'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text one'},'\u623F\u8CB8/\u623F\u79DF\u652F\u51FA'),wp.element.createElement('span',{'class':'number one','data-id':'1'}),wp.element.createElement('span',{'class':'text two'},'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6'),wp.element.createElement('span',{'class':'number two','data-id':'1'}),wp.element.createElement('span',{'class':'text three'},'\u5E74')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text one'},'\u8ECA\u8CB8\u652F\u51FA'),wp.element.createElement('span',{'class':'number one','data-id':'2'}),wp.element.createElement('span',{'class':'text two'},'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6'),wp.element.createElement('span',{'class':'number two','data-id':'2'}),wp.element.createElement('span',{'class':'text three'},'\u5E74')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text one'},'\u5176\u4ED6\u8CB8\u6B3E'),wp.element.createElement('span',{'class':'number one','data-id':'3'}),wp.element.createElement('span',{'class':'text two'},'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6'),wp.element.createElement('span',{'class':'number two','data-id':'3'}),wp.element.createElement('span',{'class':'text three'},'\u5E74')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text one'},'\u96E2\u9000\u4F11\u751F\u6D3B\u5E73\u5747\u6708\u652F\u51FA'),wp.element.createElement('span',{'class':'number one','data-id':'4'}),wp.element.createElement('span',{'class':'text two'},'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6'),wp.element.createElement('span',{'class':'number two','data-id':'4'}),wp.element.createElement('span',{'class':'text three'},'\u5E74')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text one'},'\u6559\u80B2\u8CBB\u7528\u652F\u51FA'),wp.element.createElement('span',{'class':'number one','data-id':'5'}),wp.element.createElement('span',{'class':'text two'},'\u5143/\u6708\uFF0C\u5269\u9918\u5E74\u5EA6'),wp.element.createElement('span',{'class':'number two','data-id':'5'}),wp.element.createElement('span',{'class':'text three'},'\u5E74')))),wp.element.createElement('div',{'class':'chartbox'},wp.element.createElement('div',{'class':'expendituretitle'},wp.element.createElement('span',null,'\u60A8\u7684\u4FDD\u969C\u9700\u6C42')),wp.element.createElement('div',{'class':'chartleft'},wp.element.createElement('div',{'class':'totalpricebox'},wp.element.createElement('ul',null,wp.element.createElement('li',{'class':'text'},wp.element.createElement('span',null,'\u4E0D\u542B\u6708\u751F\u6D3B\u652F\u51FA'),wp.element.createElement('span',{'class':'price excludeprice'})),wp.element.createElement('li',{'class':'unittext'},wp.element.createElement('span',{'class':'unit'},'\u5143/\u5E74')),wp.element.createElement('li',{'class':'text'},wp.element.createElement('span',null,'\u542B\u6708\u751F\u6D3B\u652F\u51FA'),wp.element.createElement('span',{'class':'price includeprice'})),wp.element.createElement('li',{'class':'unittext'},wp.element.createElement('span',{'class':'unit'},'\u5143/\u5E74')))),wp.element.createElement('div',{'class':'colorbox'},wp.element.createElement('ul',{'class':'colorlist'},wp.element.createElement('li',{'class':'first'},wp.element.createElement('i',{'class':'one'}),wp.element.createElement('span',null,'\u623F\u8CB8/\u623F\u79DF\u652F\u51FA')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'two'}),wp.element.createElement('span',null,'\u8ECA\u8CB8\u652F\u51FA')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'three'}),wp.element.createElement('span',null,'\u5176\u4ED6\u8CB8\u6B3E')),wp.element.createElement('li',null,wp.element.createElement('i',{'class':'four'}),wp.element.createElement('span',null,'\u9000\u4F11\u751F\u6D3B\u652F\u51FA')),wp.element.createElement('li',{'class':'last'},wp.element.createElement('i',{'class':'five'}),wp.element.createElement('span',null,'\u6559\u80B2\u8CBB\u7528\u652F\u51FA')))),wp.element.createElement('div',{'class':'totalinfobox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text'},'\u58FD\u96AA\u4FDD\u969C\u9700\u6C42'),wp.element.createElement('span',{'class':'price life'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u5E74')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'text'},'\u6BCF\u500B\u6708\u6536\u5165 - \u652F\u51FA\u9918\u984D'),wp.element.createElement('span',{'class':'price inandout'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708'))))),wp.element.createElement('div',{'class':'chartright'},wp.element.createElement('canvas',{id:'pdfcanvas'})))))),wp.element.createElement('div',{'class':'hospitalizebox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u4F4F\u9662\u65E5\u984D')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u5DF2\u6295\u4FDD\u4F4F\u9662\u65E5\u984D'),wp.element.createElement('span',{'class':'price one'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u65E5')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u9078\u64C7\u5C45\u4F4F\u7B2C\u4E3B\u8981\u91AB\u9662 '),wp.element.createElement('span',{'class':'price two'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u65E5'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u5C1A\u9700\u88DC\u5F37'),wp.element.createElement('span',{'class':'number'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u65E5'))),wp.element.createElement('div',{'class':'longtermcarebox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u9577\u7167&\u5931\u80FD\u9700\u6C42')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('ul',{'class':'longtermcaretop'},wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u9810\u4F30\u9577\u7167\u6216\u5931\u80FD\u6708\u652F\u51FA'),wp.element.createElement('span',{'class':'price'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708'))),wp.element.createElement('ul',{'class':'longtermcarebottom'},wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u793E\u6703\u88DC\u52A9'),wp.element.createElement('span',{'class':'price one'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u81EA\u8CFC\u5546\u696D\u4FDD\u96AA'),wp.element.createElement('span',{'class':'price two'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u5C1A\u9700\u88DC\u5F37'),wp.element.createElement('span',{'class':'number'}),wp.element.createElement('span',{'class':'unit'},'\u5143/\u6708'))),wp.element.createElement('div',{'class':'retirebox'},wp.element.createElement('div',{'class':'calbox'},wp.element.createElement('div',{'class':'left'},wp.element.createElement('span',null,'\u9000\u4F11\u751F\u6D3B')),wp.element.createElement('div',{'class':'right'},wp.element.createElement('div',{'class':'retiretop'},wp.element.createElement('span',{'class':'text'},'\u9810\u4F30\u9000\u4F11\u5E74\u9F61'),wp.element.createElement('span',{'class':'price one'}),wp.element.createElement('span',{'class':'text'},'\u6B72\uFF0C\u9810\u4F30\u9000\u4F11\u5F8C\u9918\u547D'),wp.element.createElement('span',{'class':'price two'}),wp.element.createElement('span',{'class':'text'},'\u5E74')),wp.element.createElement('ul',{'class':'retiremiddle'},wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u9810\u4F30\u9000\u4F11\u5F8C\u6708\u652F\u51FA'),wp.element.createElement('span',{'class':'price one'}),wp.element.createElement('span',{'class':'unit'},'\u5143')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u52DE\u4FDD\u6BCF\u6708\u7D66\u4ED8'),wp.element.createElement('span',{'class':'price two'}),wp.element.createElement('span',{'class':'unit'},'\u5143'))),wp.element.createElement('ul',{'class':'retirebottom'},wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u5546\u696D\u4FDD\u96AA\u6BCF\u6708\u7D66\u4ED8'),wp.element.createElement('span',{'class':'price one'}),wp.element.createElement('span',{'class':'unit'},'\u5143')),wp.element.createElement('li',null,wp.element.createElement('span',{'class':'title'},'\u5176\u4ED6\u6BCF\u6708\u6536\u5165'),wp.element.createElement('span',{'class':'price two'}),wp.element.createElement('span',{'class':'unit'},'\u5143'))))),wp.element.createElement('div',{'class':'resultbox'},wp.element.createElement('span',{'class':'text'},'\u9000\u4F11\u5F8C\u6BCF\u6708\u5C1A\u5DEE'),wp.element.createElement('span',{'class':'number'}),wp.element.createElement('span',{'class':'unit'},'\u5143')))),wp.element.createElement('div',{'class':'bottombox'},wp.element.createElement('ul',null,wp.element.createElement('li',null,wp.element.createElement('div',{'class':'title'},wp.element.createElement('span',null,'\u53F0\u5317\u8FA6\u516C\u5BA4')),wp.element.createElement('div',{'class':'address'},wp.element.createElement('span',{'class':'text'},'\u5730\u5740\uFF1A'),wp.element.createElement('span',{'class':'content'},'11268\u53F0\u5317\u5E02\u5317\u6295\u5340\u5927\u696D\u8DEF136\u865F5\u6A13')),wp.element.createElement('div',{'class':'phone'},wp.element.createElement('span',{'class':'text'},'\u96FB\u8A71\uFF1A'),wp.element.createElement('span',{'class':'content'},'02-2898-1999'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'title'},wp.element.createElement('span',null,'\u53F0\u5357\u8FA6\u516C\u5BA4')),wp.element.createElement('div',{'class':'address'},wp.element.createElement('span',{'class':'text'},'\u5730\u5740\uFF1A'),wp.element.createElement('span',{'class':'content'},'71079 \u53F0\u5357\u5E02\u6C38\u5EB7\u5340\u4E2D\u83EF\u4E8C\u8DEF350\u865F2\u6A13')),wp.element.createElement('div',{'class':'phone'},wp.element.createElement('span',{'class':'text'},'\u96FB\u8A71\uFF1A'),wp.element.createElement('span',{'class':'content'},'06-208-3119'))),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'fbblock'},wp.element.createElement('div',{'class':'blockleft'},wp.element.createElement('div',{'class':'top'},wp.element.createElement('div',{'class':'imgbox'},wp.element.createElement('img',{alt:'',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/pdf/icon.png'})),wp.element.createElement('span',null,'\u52A0\u5165\u597D\u53CB')),wp.element.createElement('div',{'class':'bottom'},wp.element.createElement('span',null,'\u82E5\u6709\u4EFB\u4F55\u7591\u554F\uFF0C\u6B61\u8FCE\u6383\u63CF\u4E0A\u65B9QRCODE\uFF0C\u53EF\u7ACB\u5373\u8207\u6211\u5011\u806F\u7D61\u5537\uFF01'))),wp.element.createElement('div',{'class':'blockright'},wp.element.createElement('img',{alt:'',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/cibc/pdf/qrcodeicon.png'})))))),wp.element.createElement('div',{'class':'mark'},wp.element.createElement('span',null,'\u4FDD\u96AA\u7D93\u7D00\u4EBA E-mail : TW_CIBC@uni-prosperity.com.tw')))));}}]);return CibcCalculation;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var CibcCalculationEditor=function(_Component2){_inherits(CibcCalculationEditor,_Component2);function CibcCalculationEditor(){_classCallCheck(this,CibcCalculationEditor);return _possibleConstructorReturn(this,(CibcCalculationEditor.__proto__||Object.getPrototypeOf(CibcCalculationEditor)).apply(this,arguments));}_createClass(CibcCalculationEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{alt:'f538','class':'dashicons dashicons-layout'})),'\u4FDD\u969C\u8A66\u7B97'));}}]);return CibcCalculationEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);function DateonChange(date,dateString){var tmpYear,tmpSelectYear,tmpSelectMonth,tmpSelectDay,tmpDifference;var tmpNowYear=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY');var tmpNowMonth=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('MM');var tmpNowDay=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('DD');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="averageprice"]').attr('disabled',false);tmpSelectYear=__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('YYYY');tmpSelectMonth=__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('MM');tmpSelectDay=__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD');if(tmpNowYear==tmpSelectYear){tmpDifference=parseInt(tmpNowMonth,10)-parseInt(tmpSelectMonth,10);if(Math.abs(tmpDifference)<6){tmpYear=0;}else{tmpYear=1;}}else if(tmpNowYear>tmpSelectYear){if(tmpNowMonth>6&&tmpSelectMonth<=6){tmpDifference=parseInt(tmpNowMonth,10)-parseInt(tmpSelectMonth,10);if(Math.abs(tmpDifference)<=6){tmpYear=tmpNowYear-tmpSelectYear;}else{tmpYear=tmpNowYear-tmpSelectYear+1;}}else if(tmpNowMonth>6&&tmpSelectMonth>6){tmpDifference=parseInt(tmpNowMonth,10)-parseInt(tmpSelectMonth,10);if(Math.abs(tmpDifference)<=6){tmpYear=tmpNowYear-tmpSelectYear;}else{tmpYear=tmpNowYear-tmpSelectYear+1;}}else if(tmpNowMonth<=6&&tmpSelectMonth<=6){tmpDifference=parseInt(tmpNowMonth,10)-parseInt(tmpSelectMonth,10);if(Math.abs(tmpDifference)<=6){tmpYear=tmpNowYear-tmpSelectYear;}else{tmpYear=tmpNowYear-tmpSelectYear+1;}}else if(tmpNowMonth<=6&&tmpSelectMonth>6){tmpDifference=parseInt(tmpNowMonth,10)+12-parseInt(tmpSelectMonth,10);if(Math.abs(tmpDifference)<=6){tmpYear=tmpNowYear-tmpSelectYear-1;}else{tmpYear=tmpNowYear-tmpSelectYear;}}else{tmpYear=tmpNowYear-tmpSelectYear;}}else{tmpYear=0;}var tmpDiff=null;if(tmpYear>65){tmpDiff=0;}else{tmpDiff=65-tmpYear;}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').html(tmpYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year').html(tmpDiff);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#averageyear').text(tmpDiff);}//////////////////////////////////////////////
var cibcCalculationDidMount=function cibcCalculationDidMount(){window.onload=function(){var tab_li=document.getElementsByTagName('g');for(var i=0;i<tab_li.length;i++){tab_li[i].index=i;tab_li[i].onclick=function(){//var content = document.getElementById(this.id + "_stores");
var content_remove;for(var j=0;j<tab_li.length;j++){content_remove=document.getElementById(tab_li[j].id+'_stores');tab_li[j].classList.remove('active');__WEBPACK_IMPORTED_MODULE_4_jquery___default()("[id$='_stores']").attr('style','display:none');}this.setAttribute('class',' area active');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#'+this.id+'_stores').show();};}};__WEBPACK_IMPORTED_MODULE_4_jquery___default()(document).ready(function(){//$(function () {
equalHeight();//});
});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).resize(function(){equalHeight();});function equalHeight(){var tmpTitle=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .blocktitle');var tmpTitleHeight=tmpTitle.find('span').height();tmpTitle.find('.hr').css({height:tmpTitleHeight});var tmpArray=[];var tmpArraytwo=[];if(window.innerWidth>1024){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li').css({height:'auto'});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li').css({height:'auto'});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li').each(function(index){var tmpHeight=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find('.input').height();tmpArray.push(tmpHeight);});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li').css({height:Math.max.apply(null,tmpArray)-2+'px'});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li').each(function(index){var tmpHeight=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find('.input').height();tmpArraytwo.push(tmpHeight);});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li').css({height:Math.max.apply(null,tmpArraytwo)-2+'px'});}}// 在Array指定位置塞值
Array.prototype.insert=function(index,item){this.splice(index,0,item);};function getChart(mortgageprice,mortgageyear,carloanprice,carloanyear,otherloansprice,otherloansyear,averageprice,averageyear,eduprice,eduyear){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').removeClass('none').find('.chartbox').html('<canvas id="canvas"></canvas>');var tmpAge=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').text();var tmpArrayTotal=[];var tmpArrayTotalLinePrice=[];var tmpArrayTotalLineYear=[];var tmpArrayone=[];var tmpArraytwo=[];var tmpArraythree=[];var tmpArrayfour=[];var tmpArrayfive=[];var tmpJson=[];var tmpArrayYear=[];var tmpNewArrayYear=[];var tmpNewArrayCalYear=[];var tmpMortgageOneYear=parseInt(mortgageprice,10)*12;var tmpMortgageTotal=0;var tmpCarloanOneYear=parseInt(carloanprice,10)*12;var tmpCarloanTotal=0;var tmpOtherloansOneYear=parseInt(otherloansprice,10)*12;var tmpOtherloansTotal=0;var tmpAverageOneYear=parseInt(averageprice,10)*12;var tmpAverageTotal=0;var tmpEduOneYear=parseInt(eduprice,10)*12;var tmpEduTotal=0;if(parseInt(mortgageprice,10)>0){tmpJson.push({type:'mortgage',price:parseInt(mortgageprice,10),year:parseInt(mortgageyear,10)});}if(parseInt(carloanprice,10)>0){tmpJson.push({type:'carloan',price:parseInt(carloanprice,10),year:parseInt(carloanyear,10)});}if(parseInt(otherloansprice,10)>0){tmpJson.push({type:'otherloans',price:parseInt(otherloansprice,10),year:parseInt(otherloansyear,10)});}if(parseInt(averageprice,10)>0){tmpJson.push({type:'average',price:parseInt(averageprice,10),year:parseInt(averageyear,10)});}if(parseInt(eduprice,10)>0){tmpJson.push({type:'edu',price:parseInt(eduprice,10),year:parseInt(eduyear,10)});}tmpJson=tmpJson.sort(function(a,b){return a.year>b.year?1:-1;});// x 軸標籤
__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.each(tmpJson,function(key,value){// 總共線(藍) Begin
if(value.price!=0&&value.year!=0){tmpArrayTotalLinePrice.push(value.price);tmpArrayTotalLineYear.push(value.year);}// 總共線(藍) End
tmpArrayYear.push(value.year);});tmpArrayYear.sort(sortNumberOther);for(var i=0;i<tmpArrayYear.length;i++){tmpNewArrayYear.push(parseInt(tmpAge,10)+parseInt(tmpJson[i].year,10)+'歲');tmpNewArrayCalYear.push(parseInt(tmpAge,10)+parseInt(tmpJson[i].year,10));}tmpNewArrayYear.insert(0,parseInt(tmpAge,10)+'歲');tmpNewArrayYear=tmpNewArrayYear.filter(function(el,i,arr){return arr.indexOf(el)===i;});tmpNewArrayCalYear=tmpNewArrayCalYear.filter(function(el,i,arr){return arr.indexOf(el)===i;});tmpArrayYear.insert(0,0);tmpNewArrayCalYear.insert(0,0);// 判斷在ArrayYear的第幾個
tmpAge=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').text():0;var mortgageIndex=tmpNewArrayCalYear.indexOf(parseInt(mortgageyear,10)+parseInt(tmpAge,10));var carloanIndex=tmpNewArrayCalYear.indexOf(parseInt(carloanyear,10)+parseInt(tmpAge,10));var otherloansIndex=tmpNewArrayCalYear.indexOf(parseInt(otherloansyear,10)+parseInt(tmpAge,10));var averageIndex=tmpNewArrayCalYear.indexOf(parseInt(averageyear,10)+parseInt(tmpAge,10));var eduIndex=tmpNewArrayCalYear.indexOf(parseInt(eduyear,10)+parseInt(tmpAge,10));// 房貸區塊
if(mortgageIndex>0&&mortgageprice&&mortgageyear){var mortgageTotal=parseInt(tmpMortgageOneYear,10)*parseInt(mortgageyear,10);tmpArrayone.push(mortgageTotal);for(var _i=0;_i<mortgageIndex;_i++){var j=_i+1;var mortgageMount=mortgageTotal-parseInt(tmpMortgageOneYear,10)*(tmpNewArrayCalYear[j]-parseInt(tmpAge,10));tmpArrayone.push(mortgageMount);}tmpArrayone.sort(sortNumber);if(mortgageIndex==1){for(var _i2=0;_i2<4;_i2++){tmpArrayone.push(0);}}else if(mortgageIndex==2){for(var _i3=0;_i3<3;_i3++){tmpArrayone.push(0);}}else if(mortgageIndex==3){for(var _i4=0;_i4<2;_i4++){tmpArrayone.push(0);}}else if(mortgageIndex==4){for(var _i5=0;_i5<1;_i5++){tmpArrayone.push(0);}}}// 車貸區塊
if(carloanIndex>0&&carloanprice&&carloanyear){var carloanTotal=parseInt(tmpCarloanOneYear,10)*parseInt(carloanyear,10);tmpArraytwo.push(carloanTotal);for(var _i6=0;_i6<carloanIndex;_i6++){var _j=_i6+1;var carloanMount=carloanTotal-parseInt(tmpCarloanOneYear,10)*(tmpNewArrayCalYear[_j]-parseInt(tmpAge,10));tmpArraytwo.push(carloanMount);}tmpArraytwo.sort(sortNumber);if(carloanIndex==1){for(var _i7=0;_i7<4;_i7++){tmpArraytwo.push(0);}}else if(carloanIndex==2){for(var _i8=0;_i8<3;_i8++){tmpArraytwo.push(0);}}else if(carloanIndex==3){for(var _i9=0;_i9<2;_i9++){tmpArraytwo.push(0);}}else if(carloanIndex==4){for(var _i10=0;_i10<1;_i10++){tmpArraytwo.push(0);}}}// 其他貸款區塊
if(otherloansIndex>0&&otherloansprice&&otherloansyear){var otherloansTotal=parseInt(tmpOtherloansOneYear,10)*parseInt(otherloansyear,10);tmpArraythree.push(otherloansTotal);for(var _i11=0;_i11<otherloansIndex;_i11++){var _j2=_i11+1;var otherloansMount=otherloansTotal-parseInt(tmpOtherloansOneYear,10)*(tmpNewArrayCalYear[_j2]-parseInt(tmpAge,10));tmpArraythree.push(otherloansMount);}tmpArraythree.sort(sortNumber);if(otherloansIndex==1){for(var _i12=0;_i12<4;_i12++){tmpArraythree.push(0);}}else if(otherloansIndex==2){for(var _i13=0;_i13<3;_i13++){tmpArraythree.push(0);}}else if(otherloansIndex==3){for(var _i14=0;_i14<2;_i14++){tmpArraythree.push(0);}}else if(otherloansIndex==4){for(var _i15=0;_i15<1;_i15++){tmpArraythree.push(0);}}}// 平均支出區塊
if(averageIndex>0&&averageprice&&averageyear){var averageTotal=parseInt(tmpAverageOneYear,10)*parseInt(averageyear,10);tmpArrayfour.push(averageTotal);for(var _i16=0;_i16<averageIndex;_i16++){var _j3=_i16+1;var averageMount=averageTotal-parseInt(tmpAverageOneYear,10)*(tmpNewArrayCalYear[_j3]-parseInt(tmpAge,10));tmpArrayfour.push(averageMount);}tmpArrayfour.sort(sortNumber);if(averageIndex==1){for(var _i17=0;_i17<4;_i17++){tmpArrayfour.push(0);}}else if(averageIndex==2){for(var _i18=0;_i18<3;_i18++){tmpArrayfour.push(0);}}else if(averageIndex==3){for(var _i19=0;_i19<2;_i19++){tmpArrayfour.push(0);}}else if(averageIndex==4){for(var _i20=0;_i20<1;_i20++){tmpArrayfour.push(0);}}}// 教育費用區塊
if(eduIndex>0&&eduprice&&eduyear){var eduTotal=parseInt(tmpEduOneYear,10)*parseInt(eduyear,10);tmpArrayfive.push(eduTotal);for(var _i21=0;_i21<eduIndex;_i21++){var _j4=_i21+1;var eduMount=eduTotal-parseInt(tmpEduOneYear,10)*(tmpNewArrayCalYear[_j4]-parseInt(tmpAge,10));tmpArrayfive.push(eduMount);}tmpArrayfive.sort(sortNumber);if(eduIndex==1){for(var _i22=0;_i22<4;_i22++){tmpArrayfive.push(0);}}else if(eduIndex==2){for(var _i23=0;_i23<3;_i23++){tmpArrayfive.push(0);}}else if(eduIndex==3){for(var _i24=0;_i24<2;_i24++){tmpArrayfive.push(0);}}else if(eduIndex==4){for(var _i25=0;_i25<1;_i25++){tmpArrayfive.push(0);}}}for(var _i26=0;_i26<tmpNewArrayCalYear.length;_i26++){var tmpTotalOne=tmpArrayone[_i26]?tmpArrayone[_i26]:0;var tmpTotalTwo=tmpArraytwo[_i26]?tmpArraytwo[_i26]:0;var tmpTotalThree=tmpArraythree[_i26]?tmpArraythree[_i26]:0;var tmpTotalFour=tmpArrayfour[_i26]?tmpArrayfour[_i26]:0;var tmpTotalFive=tmpArrayfive[_i26]?tmpArrayfive[_i26]:0;var tmpTotal=tmpTotalOne+tmpTotalTwo+tmpTotalThree+tmpTotalFour+tmpTotalFive;tmpArrayTotal.push(tmpTotal);}if(tmpArrayTotal.length>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#lifeinsuranceprice').text(addCommas(tmpArrayTotal[0]));}var chartData={labels:tmpNewArrayYear,datasets:[{type:'line',label:'總和',borderColor:'#0071bc',borderWidth:2,fill:false,data:tmpArrayTotal},{type:'bar',label:'房貸/房租支出',backgroundColor:'#419ef2',data:tmpArrayone},{type:'bar',label:'車貸支出',backgroundColor:'#de4740',data:tmpArraytwo},{type:'bar',label:'其他貸款',backgroundColor:'#fcaf38',data:tmpArraythree},{type:'bar',label:'退休生活支出',backgroundColor:'#87d6d8',data:tmpArrayfour},{type:'bar',label:'教育費用支出',backgroundColor:'#f978a0',data:tmpArrayfive}]};var ctx=document.getElementById('canvas').getContext('2d');var ctxpdf=document.getElementById('pdfcanvas').getContext('2d');// window.myBar = new Chart(ctx, {
//   type: 'bar',
//   data: chartData,
//   options: {
//     legend: {
//       display: false,
//     },
//     title: {
//       display: false,
//     },
//     tooltips: {
//       mode: 'index',
//       intersect: false,
//       enabled: true,
//       callbacks: {
//         label: function(tooltipItem, data) {
//           var tmpLabel = data.datasets[tooltipItem.datasetIndex].label;
//           var tooltipValue =
//             data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
//           return tmpLabel + ':' + parseInt(tooltipValue).toLocaleString();
//         },
//       },
//     },
//     responsive: true,
//     scales: {
//       xAxes: [
//         {
//           scaleLabel: {
//             display: true,
//             labelString: '歲',
//             fontStyle: 'bold',
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//           stacked: true,
//           barPercentage: 0.35,
//           ticks: {
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//         },
//       ],
//       yAxes: [
//         {
//           scaleLabel: {
//             display: true,
//             labelString: '支出',
//             fontStyle: 'bold',
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//           stacked: true,
//           ticks: {
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//             callback: function(value, index, values) {
//               if (parseInt(value) >= 1000) {
//                 return value
//                   .toString()
//                   .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//               } else {
//                 return value;
//               }
//             },
//           },
//         },
//       ],
//     },
//   },
// });
// $('#printcibxblock').removeClass('none');
// window.myBar = new Chart(ctxpdf, {
//   type: 'bar',
//   data: chartData,
//   options: {
//     legend: {
//       display: false,
//     },
//     title: {
//       display: false,
//     },
//     tooltips: {
//       mode: 'index',
//       intersect: false,
//       enabled: true,
//       callbacks: {
//         label: function(tooltipItem, data) {
//           var value = data.datasets[0].data[tooltipItem.index];
//           if (parseInt(value) >= 1000) {
//             return (
//               '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//             );
//           } else {
//             return '$' + value;
//           }
//         },
//       },
//     },
//     responsive: true,
//     scales: {
//       xAxes: [
//         {
//           scaleLabel: {
//             display: false,
//             labelString: '歲',
//             fontStyle: 'bold',
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//           stacked: true,
//           barPercentage: 0.35,
//           ticks: {
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//         },
//       ],
//       yAxes: [
//         {
//           scaleLabel: {
//             display: false,
//             labelString: '支出',
//             fontStyle: 'bold',
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//           },
//           stacked: true,
//           ticks: {
//             fontColor: '#251b1b',
//             fontSize: 16,
//             fontFamily: "'cwTeXYen', sans-serif",
//             callback: function(value, index, values) {
//               if (parseInt(value) >= 1000) {
//                 return value
//                   .toString()
//                   .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//               } else {
//                 return value;
//               }
//             },
//           },
//         },
//       ],
//     },
//   },
// });
// $('#printcibxblock').addClass('none');
}function drawChart(dataMortgagePrice,dataMortgageYear,dataCarloanPrice,dataCarloanYear,dataOtherloansPrice,dataOtherloansYear,dataAveragePrice,dataAverageYear,dataEduPrice,dataEduYear){var tmpStableIncome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="stableincome"]').val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="stableincome"]').val()):0;var tmpOtherIncome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherincome"]').val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherincome"]').val()):0;var tmpMortgagePriceVal=dataMortgagePrice.val()?clearCommas(dataMortgagePrice.val()):0;var tmpMortgageYearVal=dataMortgageYear.val()?dataMortgageYear.val():0;var tmpCarloanPriceVal=dataCarloanPrice.val()?clearCommas(dataCarloanPrice.val()):0;var tmpCarloanYearVal=dataCarloanYear.val()?dataCarloanYear.val():0;var tmpOtherloansPriceVal=dataOtherloansPrice.val()?clearCommas(dataOtherloansPrice.val()):0;var tmpOtherloansYearVal=dataOtherloansYear.val()?dataOtherloansYear.val():0;var tmpAveragePriceVal=null;if(dataAveragePrice){tmpAveragePriceVal=dataAveragePrice.val()?clearCommas(dataAveragePrice.val()):0;}else{tmpAveragePriceVal=0;}var tmpAverageYearVal=dataAverageYear.text()?dataAverageYear.text():0;var tmpEduPriceVal=dataEduPrice.val()?clearCommas(dataEduPrice.val()):0;var tmpEduYearVal=dataEduYear.val()?dataEduYear.val():0;var tmpTotalPrice=parseInt(tmpMortgagePriceVal,10)+parseInt(tmpCarloanPriceVal,10)+parseInt(tmpOtherloansPriceVal,10)+parseInt(tmpAveragePriceVal,10)+parseInt(tmpEduPriceVal,10);var tmpInAndOutcomePrice=parseInt(tmpStableIncome,10)+parseInt(tmpOtherIncome,10)-parseInt(tmpTotalPrice,10);if(tmpMortgagePriceVal==0&&tmpMortgageYearVal==0&&tmpCarloanPriceVal==0&&tmpCarloanYearVal==0&&tmpOtherloansPriceVal==0&&tmpOtherloansYearVal==0&&tmpAveragePriceVal==0&&tmpAverageYearVal==0&&tmpEduPriceVal==0&&tmpEduYearVal==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}else{getChart(tmpMortgagePriceVal,tmpMortgageYearVal,tmpCarloanPriceVal,tmpCarloanYearVal,tmpOtherloansPriceVal,tmpOtherloansYearVal,tmpAveragePriceVal,tmpAverageYearVal,tmpEduPriceVal,tmpEduYearVal);}if(tmpInAndOutcomePrice<0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).addClass('red');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).removeClass('red');}}// 倒排序
function sortNumber(a,b){return b-a;}// 正排序
function sortNumberOther(a,b){return a-b;}// 加價錢的逗號
function addCommas(num){var aIntNum=num.toString().split('.');var iIntPart=aIntNum[0];var iFlootPart=aIntNum.length>1?'.'+aIntNum[1]:'';var rgx=/(\d+)(\d{3})/;if(iIntPart.length>=4){while(rgx.test(iIntPart)){iIntPart=iIntPart.replace(rgx,'$1,$2');}}return iIntPart+iFlootPart;}// 去除逗號
function clearCommas(str){if(str){str=str.replace(/,/g,'');return str;}else{return 0;}}var tmpStableIncome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="stableincome"]');var tmpOtherIncome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherincome"]');var tmpMortgagePrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageprice"]');var tmpMortgageYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageyear"]');var tmpCarloanPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanprice"]');var tmpCarloanYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanyear"]');var tmpOtherloansPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansprice"]');var tmpOtherloansYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansyear"]');var tmpAveragePrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="averageprice"]');var tmpAverageYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#averageyear');var tmpEduPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduprice"]');var tmpEduYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduyear"]');tmpStableIncome.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpStableIncomeValue=tmpStableIncome.val()?clearCommas(tmpStableIncome.val()):0;var tmpOtherIncomeValue=tmpOtherIncome.val()?clearCommas(tmpOtherIncome.val()):0;var tmpValue=parseInt(tmpStableIncomeValue,10)+parseInt(tmpOtherIncomeValue,10);var tmpMortgagePriceVal=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpCarloanPriceVal=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpOtherloansPriceVal=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpAveragePriceVal=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpEduPriceVal=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpTotalPrice=parseInt(tmpMortgagePriceVal,10)+parseInt(tmpCarloanPriceVal,10)+parseInt(tmpOtherloansPriceVal,10)+parseInt(tmpAveragePriceVal,10)+parseInt(tmpEduPriceVal,10);var tmpInAndOutcomePrice=tmpValue-parseInt(tmpTotalPrice,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.incomeblock .row-comment .resultbox .resultstr.incomemoney').html(addCommas(tmpValue));if(tmpInAndOutcomePrice<0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).addClass('red');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).removeClass('red');}});tmpOtherIncome.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpStableIncomeValue=tmpStableIncome.val()?clearCommas(tmpStableIncome.val()):0;var tmpOtherIncomeValue=tmpOtherIncome.val()?clearCommas(tmpOtherIncome.val()):0;var tmpValue=parseInt(tmpStableIncomeValue,10)+parseInt(tmpOtherIncomeValue,10);var tmpMortgagePriceVal=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpCarloanPriceVal=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpOtherloansPriceVal=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpAveragePriceVal=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpEduPriceVal=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpTotalPrice=parseInt(tmpMortgagePriceVal,10)+parseInt(tmpCarloanPriceVal,10)+parseInt(tmpOtherloansPriceVal,10)+parseInt(tmpAveragePriceVal,10)+parseInt(tmpEduPriceVal,10);var tmpInAndOutcomePrice=tmpValue-parseInt(tmpTotalPrice,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.incomeblock .row-comment .resultbox .resultstr.incomemoney').html(addCommas(tmpValue));if(tmpInAndOutcomePrice<0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).addClass('red');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text(addCommas(tmpInAndOutcomePrice)).removeClass('red');}});tmpMortgagePrice.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpMortgagePrice.val();var tmpThisYearVal=tmpMortgageYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpMortgageYear.keyup(function(){var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpMortgagePrice.val();var tmpThisYearVal=tmpMortgageYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpCarloanPrice.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpCarloanPrice.val();var tmpThisYearVal=tmpCarloanYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpCarloanYear.keyup(function(){var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpCarloanPrice.val();var tmpThisYearVal=tmpCarloanYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpOtherloansPrice.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpOtherloansPrice.val();var tmpThisYearVal=tmpOtherloansYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpOtherloansYear.keyup(function(){var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpOtherloansPrice.val();var tmpThisYearVal=tmpOtherloansYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpAveragePrice.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpAveragePrice.val();var tmpThisYearVal=tmpAverageYear.text();if(tmpThisPriceVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}else{drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,'',tmpAverageYear,tmpEduPrice,tmpEduYear);}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpEduPrice.keyup(function(){var tmpThisValue=clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val());__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpThisValue));var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpEduPrice.val();var tmpThisYearVal=tmpEduYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});tmpEduYear.keyup(function(){var tmpMortgagePriceText=tmpMortgagePrice.val()?clearCommas(tmpMortgagePrice.val()):0;var tmpMortgageYearText=tmpMortgageYear.val()?tmpMortgageYear.val():0;var tmpCarloanPriceText=tmpCarloanPrice.val()?clearCommas(tmpCarloanPrice.val()):0;var tmpCarloanYearText=tmpCarloanYear.val()?tmpCarloanYear.val():0;var tmpOtherloansPriceText=tmpOtherloansPrice.val()?clearCommas(tmpOtherloansPrice.val()):0;var tmpOtherloansYearText=tmpOtherloansYear.val()?tmpOtherloansYear.val():0;var tmpAveragePriceText=tmpAveragePrice.val()?clearCommas(tmpAveragePrice.val()):0;var tmpAverageYearText=tmpAverageYear.text()?tmpAverageYear.text():0;var tmpEduPriceText=tmpEduPrice.val()?clearCommas(tmpEduPrice.val()):0;var tmpEduYearText=tmpEduYear.val()?tmpEduYear.val():0;var tmpTotalPriceText=parseInt(tmpMortgagePriceText,10)+parseInt(tmpCarloanPriceText,10)+parseInt(tmpOtherloansPriceText,10)+parseInt(tmpAveragePriceText,10)+parseInt(tmpEduPriceText,10);var tmpTotalInclude=parseInt(tmpMortgagePriceText,10)*12*parseInt(tmpMortgageYearText,10)+parseInt(tmpCarloanPriceText,10)*12*parseInt(tmpCarloanYearText,10)+parseInt(tmpOtherloansPriceText,10)*12*parseInt(tmpOtherloansYearText,10)+parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10)+parseInt(tmpEduPriceText,10)*12*parseInt(tmpEduYearText,10);var tmpTotalExclude=parseInt(tmpTotalInclude,10)-parseInt(tmpAveragePriceText,10)*12*parseInt(tmpAverageYearText,10);var tmpThisPriceVal=tmpEduPrice.val();var tmpThisYearVal=tmpEduYear.val();if(tmpThisPriceVal&&tmpThisYearVal){drawChart(tmpMortgagePrice,tmpMortgageYear,tmpCarloanPrice,tmpCarloanYear,tmpOtherloansPrice,tmpOtherloansYear,tmpAveragePrice,tmpAverageYear,tmpEduPrice,tmpEduYear);}else if(tmpMortgagePriceText==0&&tmpCarloanPriceText==0&&tmpOtherloansPriceText==0&&tmpAveragePriceText==0&&tmpEduPriceText==0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox').addClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').html(addCommas(tmpTotalInclude));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').html(addCommas(tmpTotalExclude));if(tmpTotalInclude<=0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(0);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money').text(addCommas(tmpTotalPriceText));}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospitalprice"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpHosVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospital"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospital"]').val():0;var tmpPrice=parseInt(clearCommas(tmpVal),10)-parseInt(clearCommas(tmpHosVal),10);if(tmpPrice>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').html(addCommas(tmpPrice)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').html(addCommas(tmpPrice)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospital"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpHosVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospitalprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospitalprice"]').val():0;var tmpPrice=parseInt(clearCommas(tmpHosVal),10)-parseInt(clearCommas(tmpVal),10);if(tmpPrice>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').html(addCommas(tmpPrice)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').html(addCommas(tmpPrice)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpAllow=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val():0;var tmpSelf=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val():0;var tmpTotal=parseInt(clearCommas(tmpAllow),10)+parseInt(clearCommas(tmpSelf),10)-parseInt(clearCommas(tmpVal),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpIncapa=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val():0;var tmpSelf=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val():0;var tmpTotal=parseInt(clearCommas(tmpVal),10)+parseInt(clearCommas(tmpSelf),10)-parseInt(clearCommas(tmpIncapa),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpAllow=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val():0;var tmpIncapa=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val():0;var tmpTotal=parseInt(clearCommas(tmpAllow),10)+parseInt(clearCommas(tmpVal),10)-parseInt(clearCommas(tmpIncapa),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpOut=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val():0;var tmpBi=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val():0;var tmpIns=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val():0;var tmpOther=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val():0;var tmpTotal=parseInt(clearCommas(tmpBi),10)+parseInt(clearCommas(tmpIns),10)+parseInt(clearCommas(tmpOther),10)-parseInt(clearCommas(tmpOut),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpOut=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val():0;var tmpBi=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val():0;var tmpIns=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val():0;var tmpOther=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val():0;var tmpTotal=parseInt(clearCommas(tmpBi),10)+parseInt(clearCommas(tmpIns),10)+parseInt(clearCommas(tmpOther),10)-parseInt(clearCommas(tmpOut),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpOut=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val():0;var tmpBi=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val():0;var tmpIns=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val():0;var tmpOther=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val():0;var tmpTotal=parseInt(clearCommas(tmpBi),10)+parseInt(clearCommas(tmpIns),10)+parseInt(clearCommas(tmpOther),10)-parseInt(clearCommas(tmpOut),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').keyup(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()?clearCommas(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val()):0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val(addCommas(tmpVal));var tmpOut=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val():0;var tmpBi=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val():0;var tmpIns=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val():0;var tmpOther=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val():0;var tmpTotal=parseInt(clearCommas(tmpBi,10),10)+parseInt(clearCommas(tmpIns,10),10)+parseInt(clearCommas(tmpOther,10),10)-parseInt(clearCommas(tmpOut,10),10);if(tmpTotal>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).addClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').html(addCommas(tmpTotal)).removeClass('abs');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text').removeClass('none');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="averageprice"]').click(function(){var tmpThis=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this);var tmpDatepicker=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#datepickerbox input').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#datepickerbox input').val():'';if(!tmpDatepicker){// swal({
//   title: '',
//   type: 'info',
//   html: '請選擇生日',
//   confirmButtonText: '我知道了',
// }).then(function() {
//   tmpThis.val('').attr('disabled', true);
// });
}else{tmpThis.attr('disabled',false);}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').change(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val();var tmpEstimatedVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').val():0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').attr('disabled',false);if(tmpVal=='男'){if(tmpEstimatedVal>=77){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val('');}else{var tmpTotalEs=77-parseInt(tmpEstimatedVal,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val(tmpTotalEs);}}else if(tmpVal=='女'){if(tmpEstimatedVal>=84){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val('');}else{var _tmpTotalEs=84-parseInt(tmpEstimatedVal,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val(_tmpTotalEs);}}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val('');}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').click(function(){var tmpThis=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this);var tmpGender=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val():'';if(!tmpGender){// swal({
//   title: '',
//   type: 'info',
//   html: '請選擇性別',
//   confirmButtonText: '我知道了',
// }).then(function() {
//   tmpThis.val('');
//   tmpThis.attr('disabled', true);
// });
}});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').keyup(function(){var tmpThis=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this);var tmpEstimatedVal=tmpThis.val()?tmpThis.val():0;var tmpSurvival=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val():0;var tmpGender=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val():'';if(tmpGender=='男'){if(tmpEstimatedVal>=77){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val('');}else{var tmpTotalEs=77-parseInt(tmpEstimatedVal,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val(tmpTotalEs);}}else if(tmpGender=='女'){if(tmpEstimatedVal>=84){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val('');}else{var _tmpTotalEs2=84-parseInt(tmpEstimatedVal,10);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val(_tmpTotalEs2);}}});// 病房費計算
__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#choosehospital').click(function(){var tmpHtml='<div class="cibchospitalbox">'+'<ul>'+'<li><span>區域</span><div class="box"><select id="area"><option value="">請選擇區域</option><option value="北區">北區</option><option value="中區">中區</option><option value="南區">南區</option><option value="宜花東">宜花東</option></select></div></li>'+'<li><span>醫院名稱</span><div class="box"><select id="name"><option value="">請選擇醫院名稱</option></select></div></li>'+'<li><span>選擇房型</span><div class="box"><select id="roomtype"><option value="">請選擇房型</option></select></div></li>'+'</ul>'+'</div>';// swal({
//   title: '請選擇醫院病房費',
//   html: tmpHtml,
//   confirmButtonText: '確定',
//   confirmButtonColor: '#3085d6',
//   showCancelButton: true,
//   cancelButtonText: '取消',
//   cancelButtonColor: '#d33',
// }).then(
//   function() {
//     var tmpRoomType = $('#roomtype').val() ? $('#roomtype').val() : '';
//     $('[name="hospital"]').val(addCommas(tmpRoomType));
//     var tmpHospitalPriceVal = $('[name="hospitalprice"]').val()
//       ? $('[name="hospitalprice"]').val()
//       : 0;
//     var tmpHospitalVal = tmpRoomType ? tmpRoomType : 0;
//     var tmpPrice =
//       parseInt(clearCommas(tmpHospitalPriceVal)) -
//       parseInt(clearCommas(tmpHospitalVal));
//     if (tmpPrice > 0) {
//       $(
//         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
//       )
//         .html(addCommas(tmpPrice))
//         .addClass('abs');
//       $(
//         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
//       ).addClass('none');
//     } else {
//       $(
//         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
//       )
//         .html(addCommas(tmpPrice))
//         .removeClass('abs');
//       $(
//         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
//       ).removeClass('none');
//     }
//   },
//   function(dismiss) {
//     if (dismiss == 'cancel') {
//     }
//   }
// );
dialogChange();});function dialogChange(){var hospitalName={北區:['台北醫學院','國泰醫院','新光醫院','馬偕醫院','亞東醫院','恩主公醫院','敏盛醫院'],中區:['中國醫藥學院','台中榮總','澄清醫院','埔里基督教','彰化基督教'],南區:['嘉義基督教','嘉義長庚','成大醫院','奇美醫院','高雄榮總','高雄長庚','高雄醫學院','屏東基督教'],宜花東:['羅東博愛','門諾醫院','花蓮慈濟','台東馬偕']};var hospitalMoney={台北醫學院:[4000,2000],國泰醫院:[4560,2060],新光醫院:[4550,2200],馬偕醫院:[4500,2500],亞東醫院:[3000,2000],恩主公醫院:[3450,1200],敏盛醫院:[4500,1800],中國醫藥學院:[3980,1980],台中榮總:[3380,1800],澄清醫院:[3400,2400],埔里基督教:[2500,1200],彰化基督教:[2800,1600],嘉義基督教:[2500,1500],嘉義長庚:[2500,1200],成大醫院:[2900,1580],奇美醫院:[2500,1680],高雄榮總:[3000,1500],高雄長庚:[3000,1500],高雄醫學院:[2300,1400],屏東基督教:[2500,1200],羅東博愛:[2000,1000],門諾醫院:[2000,1000],花蓮慈濟:[2000,1000],台東馬偕:[2000,1000]};__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#name').attr('disabled',true);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#roomtype').attr('disabled',true);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#area').change(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val();var tmpStr='',tmpResult='';for(var i=0;i<hospitalName[tmpVal].length;i++){tmpStr='<option value="'+hospitalName[tmpVal][i]+'">'+hospitalName[tmpVal][i]+'</option>';tmpResult=tmpResult+tmpStr;}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#name').html('<option value="">請選擇醫院名稱</option>'+tmpResult).attr('disabled',false);});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#name').change(function(){var tmpVal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).val();var tmpStr='',tmpResult='';for(var i=0;i<hospitalMoney[tmpVal].length;i++){if(i==0){tmpStr='<option value="'+hospitalMoney[tmpVal][i]+'">普通單人房</option>';}else if(i==1){tmpStr='<option value="'+hospitalMoney[tmpVal][i]+'">普通雙人房</option>';}tmpResult=tmpResult+tmpStr;}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#roomtype').html(tmpResult).attr('disabled',false);});}// Html to PDF
__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#html2pdfBtn').click(function(){var tmpName=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="name"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="name"]').val():'';var tmpBirth=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#datepickerbox input').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#datepickerbox input').val():'';var tmpGender=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="gender"]').val():'';var tmpAge=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age').text():'';var tmpYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year').text():'';var tmpStableincome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="stableincome"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="stableincome"]').val():'';var tmpOtherincome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherincome"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherincome"]').val():'';var tmpTotalIncome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .incomeblock .row-comment .resultbox .resultstr.incomemoney').text();var tmpMortgagePrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageprice"]').val():'';var tmpMortgageYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageyear"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="mortgageyear"]').val():'';var tmpCarloanPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanprice"]').val():'';var tmpCarloanYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanyear"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="carloanyear"]').val():'';var tmpOtherloansPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansprice"]').val():'';var tmpOtherloansYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansyear"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="otherloansyear"]').val():'';var tmpAveragePrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="averageprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="averageprice"]').val():'';var tmpAverageYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#averageyear').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#averageyear').text():'';var tmpEduPrice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduprice"]').val():'';var tmpEduYear=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduyear"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="eduyear"]').val():'';var tmpExcludeprice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#excludeprice').text():'';var tmpIncludeprice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#includeprice').text():'';var tmpLifeinsurance=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#lifeinsuranceprice').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#lifeinsuranceprice').text():'';var tmpInandoutcome=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#inandoutcomeprice').text():'';var tmpHospitalprice=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospitalprice"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospitalprice"]').val():'';var tmpHospital=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospital"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="hospital"]').val():'';var tmpHospitalTotal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital').text():'';var tmpIncapacitation=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="incapacitation"]').val():'';var tmpAllowance=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="allowance"]').val():'';var tmpSelfinsurance=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="selfinsurance"]').val():'';var tmpAllowTotal=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow').text():'';var tmpEstimated=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="estimated"]').val():'';var tmpSurival=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="survival"]').val():'';var tmpRetireoutlay=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireoutlay"]').val():'';var tmpRetirebilingual=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retirebilingual"]').val():'';var tmpRetireinsurance=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireinsurance"]').val():'';var tmpRetireother=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('[name="retireother"]').val():'';var tmpRetiremoney=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').text()?__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney').text():'';__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infoname').text(tmpName);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infobirth').text(tmpBirth);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infogender').text(tmpGender);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .sectionbox .resultbox .number.inage').text(tmpAge);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .sectionbox .resultbox .number.reage').text(tmpYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .incomebox .calbox .right ul li .rightcontent.incomeone').text(addCommas(tmpStableincome)+' 元');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .incomebox .calbox .right ul li .rightcontent.incometwo').text(addCommas(tmpOtherincome)+' 元');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .incomebox .resultbox .number.totalincome').text(tmpTotalIncome);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="1"]').text(addCommas(tmpMortgagePrice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="1"]').text(tmpMortgageYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="2"]').text(addCommas(tmpCarloanPrice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="2"]').text(tmpCarloanYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="3"]').text(addCommas(tmpOtherloansPrice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="3"]').text(tmpOtherloansYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="4"]').text(addCommas(tmpAveragePrice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="4"]').text(tmpAverageYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="5"]').text(addCommas(tmpEduPrice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="5"]').text(tmpEduYear);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalpricebox ul li .price.excludeprice').text(tmpExcludeprice);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalpricebox ul li .price.includeprice').text(tmpIncludeprice);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalinfobox ul li .price.life').text(tmpLifeinsurance);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalinfobox ul li .price.inandout').text(addCommas(tmpInandoutcome));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .hospitalizebox .calbox .right ul li .price.one').text(addCommas(tmpHospitalprice));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .hospitalizebox .calbox .right ul li .price.two').text(addCommas(tmpHospital));if(parseInt(tmpHospitalTotal,10)>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .hospitalizebox .resultbox .number').text(tmpHospitalTotal).css('color','#005aaa').parent().find('.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .hospitalizebox .resultbox .number').text(tmpHospitalTotal).css('color','#ff0000').parent().find('.text').removeClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcaretop li span.price').text(addCommas(tmpIncapacitation));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcarebottom li .price.one').text(addCommas(tmpAllowance));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcarebottom li .price.two').text(addCommas(tmpSelfinsurance));if(parseInt(tmpAllowTotal,10)>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .longtermcarebox .resultbox .number').text(tmpAllowTotal).css('color','#005aaa').parent().find('.text').addClass('none');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .longtermcarebox .resultbox .number').text(tmpAllowTotal).css('color','#ff0000').parent().find('.text').removeClass('none');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right .retiretop span.one').text(tmpEstimated);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right .retiretop span.two').text(tmpSurival);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right ul.retiremiddle li .price.one').text(addCommas(tmpRetireoutlay));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right ul.retiremiddle li .price.two').text(addCommas(tmpRetirebilingual));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right ul.retirebottom li .price.one').text(addCommas(tmpRetireinsurance));__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .calbox .right ul.retirebottom li .price.two').text(addCommas(tmpRetireother));if(parseInt(tmpRetiremoney,10)>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .resultbox .number').text(tmpRetiremoney).css('color','#005aaa').parent().find('.text').html('退休後每月餘額');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock .middlebox .retirebox .resultbox .number').text(tmpRetiremoney).css('color','#ff0000').parent().find('.text').html('退休後每月尚差');}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#printcibxblock').removeClass('none');__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.LoadingOverlay('show',{// image: "https://pc4appcdn.azureedge.net/assets/plugins/jquery-lodingoverlay/src/loading.gif",
});// html2canvas($('#printcibxblock').get(0), {
//   scale: 4,
//   onrendered: function(canvas) {
//     var ctx = canvas.getContext('2d');
//     ctx.scale(2, 2);
//     ctx.fillStyle = '#ffffff';
//     var pageData = canvas.toDataURL('image/png', 1.0);
//     var pdf = new jsPDF('', 'pt', 'a4');
//     pdf.internal.scaleFactor = 2;
//     pdf.addImage(
//       pageData,
//       'PNG',
//       0,
//       0,
//       595.28,
//       (592.28 / canvas.width) * canvas.height
//     );
//     pdf.save('保障試算結果.pdf');
//     $('#printcibxblock').addClass('none');
//     $.LoadingOverlay('hide');
//   },
// });
});};

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ContactUs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactUsEditor", function() { return ContactUsEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader_style__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_cascader_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_auto_complete_style__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_auto_complete_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_auto_complete_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_auto_complete__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_auto_complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_auto_complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_module_scss__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_NavTab_NavTab__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__queryOptions_json__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__queryOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__queryOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__queryTargetOptions_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__queryTargetOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__queryTargetOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__retailChannelOptions_json__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__retailChannelOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__retailChannelOptions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_assets_img_contact_1_person_svg__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_assets_img_contact_1_person_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_assets_img_contact_1_person_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_assets_img_contact_2_info_svg__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_assets_img_contact_2_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_assets_img_contact_2_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_assets_img_contact_3_message_svg__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_assets_img_contact_3_message_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_assets_img_contact_3_message_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_assets_img_contact_4_place_svg__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_assets_img_contact_4_place_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_assets_img_contact_4_place_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_assets_img_contact_6_file_svg__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_assets_img_contact_6_file_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_assets_img_contact_6_file_svg__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryOptions=__WEBPACK_IMPORTED_MODULE_32__queryOptions_json___default.a;var fileType='.png,.jpg,.jpeg,.bmp,.avi,.mp4,.mp3,.mkv,.3gp,.mov,image/png,image/jpeg,image/bmp,image/x-windows-bmp,application/x-troff-msvideo,video/avi,video/msvideo,video/x-msvideo,audio/mpeg3,audio/x-mpeg-3,video/mpeg,video/x-mpeg,video/quicktime,video/mp4,video/mkv';var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window,'VC_CONFIG',{});var ONLINE_SHOPPING_CODES=['online_shopping',65,70,71];var SubjectID={CustomerService:1,//客服建議
NewProduct:2,//新品推薦
OutOfStock:3,//缺貨回報
Expensive:4,//買貴回報
Service:5//服務建議
};var ContactUs=function(_Component){_inherits(ContactUs,_Component);function ContactUs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContactUs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContactUs.__proto__||Object.getPrototypeOf(ContactUs)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_21_react___default.a.createRef(),_this.state={tabType:'info',info:{},option:[],files:[],query:{OrderId:null,Name:null,Tel:null,Email:null,ProductId:null,Type:null},orderOptions:[],isSubmitData:false,visible:false,confirmLoading:false,data:{},isShowChannelStoresField:false,configs:{},allStores:[],isFileUploading:false,agreePersonalInfo:false,personalInfoScrolledToBottom:false// 新增狀態
},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.formRef.current.setFieldsValue({Var_QueryPeo:null,// queryTargets.0
Var_QueryStore:null,Var_ChannelStore:null,Var_Place:null,Var_QueryType:null,Var_Type:null,Var_Product:null,Var_Name:null,Var_Subject:null,Var_Email:null,Var_Tel:null,Txt_Memo:null,Var_Source:1,Var_OrderId:undefined,Var_ProductId:null,Var_Files:[],querySubject:1,queryTypes:[],queryTargets:[]});},_this.fetchConfigs=function(){__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',null,function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({configs:data.options});});},_this.fetchStores=function(){__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/v1/stores',{page_size:'all'},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({allStores:data.rows});});},_this.loadOrderList=function(){var isLogin=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(_this,'props.auth.isLogin');if(!isLogin)return;_this.setState({isLoadOrderList:true});__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/account/getOrderList',{},function(state,res){_this.setState({isLoadOrderList:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}var orderOptions=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.map(data,function(item){return{code:item.code,order_date:item.order_date,store_name:item.store_name};});_this.setState({orderOptions:orderOptions});});},_this.selectStoreCode=function(storeCode){__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.forEach(__WEBPACK_IMPORTED_MODULE_33__queryTargetOptions_json___default.a,function(target){__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.forEach(target.items,function(targetSubItem){if(targetSubItem.UnitCode===storeCode){_this.formRef.current.setFields([{name:['queryTargets'],value:[target.id,targetSubItem.id],touched:true,validating:false,errors:[]}]);}});});},_this.copyString=function(text){var input=document.createElement('textarea');input.setAttribute('type','text');input.value=text;document.getElementsByTagName('body')[0].appendChild(input);input.select();document.execCommand('copy');input.remove();},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var queryTypes=[info.queryTypes_lv1,info.queryTypes_lv2,info.queryTypes_lv3];var subject1st=parseInt(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'querySubject'),10);var type1st=parseInt(queryTypes[0],10);var type2nd=parseInt(queryTypes[1],10);var type3rd=parseInt(queryTypes[2],10);var target1st=parseInt(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'queryTargets.0'),10);var target2nd=parseInt(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'queryTargets.1'),10);var target3rd=parseInt(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'queryTargets.2'),10);var channel1st='';var channel2nd='';var channel3rd='';var channel4th='';var files=[];_this.formRef.current.getFieldValue('Var_Files').forEach(function(file){if(file.path){files.push(file.path);}});info.Var_Files=files;info.Var_Subject=''+info.Var_Subject;info.Var_QueryType=type1st;info.Var_Type=type2nd;info.Var_QueryPeo=target1st;info.Var_QueryStore=!isNaN(target2nd)?target2nd:'';info.Var_Channel_Store_Type=channel1st;info.Var_Channel_City=channel2nd;info.Var_Channel_Area=channel3rd;info.Var_Channel_Store_Name=channel4th;if(target1st===28){var _channel1st=info['channelStores'][0];var _channel2nd=info['channelStores'][1];var _channel3rd=info['channelStores'][2];var _channel4th=info['channelStores'][3];var allStores=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(_this.state,'allStores');var scs_number=allStores.filter(function(item){return item.name===_channel4th;}).map(function(scs){return scs.scs_number;}).toString();var scs_number_id=allStores.filter(function(item){return item.name===_channel4th;}).map(function(scs){return scs.scs_number_id;}).toString();info.Var_Channel_Store_Type=_channel1st;info.Var_Channel_City=_channel2nd;info.Var_Channel_Area=_channel3rd;info.Var_Channel_Store_Name=_channel4th;info.Var_QueryPeo=scs_number_id;info.Var_QueryStore=scs_number;}if(info.Var_OrderId&&!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.isEmpty(info.Var_OrderId)){info.Txt_Memo+='\n\u8A02\u55AE\u7DE8\u865F\uFF1A'+info.Var_OrderId;}// 客服建議、服務建議
if([SubjectID.CustomerService,SubjectID.Service].includes(subject1st)){if(subject1st===SubjectID.CustomerService&&// 客服建議
[15,16,31].includes(type2nd)// 產品查詢/建議Product Inquiry/Suggestion、欲成為合作廠商來信Supplier Inquiry、產品品質/價格相關問題Product Quality
){info.Var_Product=type3rd;}if(subject1st===SubjectID.Service&&[31].includes(type1st)){// 服務建議
info.Var_Product=type2nd;}if(subject1st===SubjectID.Service){info.Var_QueryType=2;}}// 新品推薦、缺貨回報、買貴回報
else{info.Var_QueryPeo=target1st;info.Var_QueryStore='';info.Var_Product=type3rd;info.Var_Type=type2nd;info.Var_QueryType='';}// 新品推薦
if(subject1st===SubjectID.NewProduct){//固定為總公司回覆
info.Var_QueryPeo=2;info.Var_QueryStore='';info.Var_QueryType=1;info.Var_Type=15;info.Var_Subject='\u65B0\u54C1\u63A8\u85A6 : '+info.product_name;info.Txt_Memo=['[ 新品推薦 ]','\u8CC7\u8A0A\u4F86\u6E90 : ['+info.data_source+']','\u5546\u54C1\u689D\u78BC : '+info.product_barcode,'\u901A\u8DEF\u552E\u50F9 : '+info.product_price,'\u4F9B\u61C9\u5546 : '+info.supplier,'\u63A8\u85A6\u5546\u54C1\u8CC7\u8A0A : '+info.product_info].join('\n');delete info.product_name;delete info.data_source;delete info.product_barcode;delete info.product_price;delete info.supplier;delete info.product_info;}// 缺貨回報
if(subject1st===SubjectID.OutOfStock){//固定為總公司回覆
info.Var_QueryPeo=2;info.Var_Type=31;info.Var_QueryType=2;info.Txt_Memo='[ 缺貨回報 ] '+info.Txt_Memo;}// 買貴回報
if(subject1st===SubjectID.Expensive){//固定為總公司回覆
info.Var_QueryPeo=2;info.Var_QueryType=2;info.Var_Type=31;info.Var_Subject='\u8CB7\u8CB4\u56DE\u5831 : '+info.product_name;info.Txt_Memo=['[ 買貴回報 ]','\u662F\u5426\u70BA\u4FC3\u92B7\uFF1A['+info.onsale+']','\u901A\u8DEF\u985E\u578B : '+__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'retailChannel.0'),'\u6BD4\u50F9\u901A\u8DEF : '+__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(info,'retailChannel.1'),'\u6BD4\u50F9\u901A\u8DEF\u552E\u50F9 : '+info.product_price,'\u7559\u8A00\u5167\u5BB9\uFF1A'+info.desc].join('\n');}delete info.querySubject;delete info.queryTargets;delete info.channelStores;delete info.queryTypes_lv1;delete info.queryTypes_lv2;delete info.queryTypes_lv3;setTimeout(function(){__WEBPACK_IMPORTED_MODULE_27_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_27_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');var xml=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.map(info,function(v,k){return'<'+k+'>'+v+'</'+k+'>';}).join('\n');_this.copyString(xml);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/contactus/custAdvice',info,function(state,res){_this.setState({isSubmitData:false,confirmLoading:false,visible:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:'發生錯誤',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.success({content:'送出成功!',onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});});},1000);},_this.checkSending=function(){_this.setState({visible:true});},_this.GetCCUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/account/cc/login',{},function(state,res){console.log(state,res);var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){_this.setState({isSubmitData:false});return __WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);// 改為前往CC登入頁面
// this.GoCCLoginPage(data.uri)
_this.setState({isSubmitData:false});_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GoCCLoginPage=function(ccApiUrl){__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(ccApiUrl,{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code6=res.code,code=_res$code6===undefined?100:_res$code6,_res$reason6=res.reason,reason=_res$reason6===undefined?Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason6,_res$data6=res.data,data=_res$data6===undefined?{}:_res$data6;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GetOcaUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/account/oca/login',{},function(state,res){_this.setState({isSubmitData:false});var _res$code7=res.code,code=_res$code7===undefined?100:_res$code7,_res$reason7=res.reason,reason=_res$reason7===undefined?Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason7,_res$data7=res.data,data=_res$data7===undefined?{}:_res$data7;if(state===false){return __WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.showInfo=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.debounce(function(info){__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.destroyAll();__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.info(info);},300),_this.handleFormSubmit=function(e){e.preventDefault();_this.formRef.current.submit();_this.UIlog();},_this.handleQueryTargetsChange=function(value,selectedOptions){var optionNameSelected=selectedOptions.length>0?selectedOptions[0].name:'';if(optionNameSelected==='通路門市Store'){_this.setState({isShowChannelStoresField:true});}else{_this.setState({isShowChannelStoresField:false});}},_this.handleorderlist=function(){var orderOptions=_this.state.orderOptions;var Var_OrderId=_this.getFieldValue('Var_OrderId');var orderStoreName=orderOptions.filter(function(item){return item.code===Var_OrderId;}).map(function(item){return item.store_name;}).toString();_this.formRef.current.setFieldsValue({Var_Place:orderStoreName});var allStores=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(_this.state,'allStores');var storeList=allStores.filter(function(store){return store['name']===orderStoreName;}).map(function(item){return{name:item.name,type:item.store_type_name,city:item.city_name,area:item.area_name};});switch(orderStoreName){case'楊梅發貨中心':_this.formRef.current.setFieldsValue({queryTargets:['43']});_this.setState({isShowChannelStoresField:false});break;case'':_this.formRef.current.setFieldsValue({queryTargets:[]});_this.setState({isShowChannelStoresField:false});break;default:_this.formRef.current.setFieldsValue({queryTargets:['28']});_this.formRef.current.setFieldsValue({channelStores:[storeList[0].type,storeList[0].city,storeList[0].area,storeList[0].name]});_this.setState({isShowChannelStoresField:true});break;}},_this.UIlog=function(){var browser=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window,'browser');var os=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window.navigator,'userAgent');var querySubject=_this.getFieldValue('querySubject');var queryTypes=_this.getFieldValue('queryTypes',[]);var type=['84','85','86','87','88'].includes(queryTypes[0]);if(querySubject===4&!type){__WEBPACK_IMPORTED_MODULE_29__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+'/api/v1/contactuslog',{os:os,browser:browser},function(state,res){_this.setState({isSubmitData:false});var _res$code8=res.code,code=_res$code8===undefined?100:_res$code8,_res$reason8=res.reason,reason=_res$reason8===undefined?'發生錯誤':_res$reason8,_res$data8=res.data,data=_res$data8===undefined?{}:_res$data8;if(state===false){return __WEBPACK_IMPORTED_MODULE_20_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_18_antd_lib_notification___default.a['error']({message:'發生錯誤',description:reason});return _this.setState({messages:data.messages||{}});}});}},_this.getFileExtension=function(filename){return filename.slice((filename.lastIndexOf('.')-1>>>0)+2);},_this.handlePersonalInfoAgreeChange=function(e){_this.setState({agreePersonalInfo:e.target.checked});},_this.handlePersonalInfoScroll=function(e){var _e$target=e.target,scrollTop=_e$target.scrollTop,scrollHeight=_e$target.scrollHeight,clientHeight=_e$target.clientHeight;if(scrollTop+clientHeight>=scrollHeight-2){// 容許2px誤差
if(!_this.state.personalInfoScrolledToBottom){_this.setState({personalInfoScrolledToBottom:true});}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContactUs,[{key:'componentDidMount',value:function componentDidMount(){this.setState({tabType:__WEBPACK_IMPORTED_MODULE_27_libs_AppHelper__["a" /* default */].getHashValue('tab')||'info'});this.fetchConfigs();this.fetchStores();this.fillData();if(window.location.href.indexOf('?data')!=-1){var filldata=JSON.parse(__WEBPACK_IMPORTED_MODULE_27_libs_AppHelper__["a" /* default */].getURLQuery().data);this.formRef.current.setFieldsValue(filldata);}this.loadOrderList();}// ALVIN 2023/05/05 調整為CC登入
// 2023/05/05 取得並前往 CC Login Url
},{key:'render',value:function render(){var _this2=this;var _state=this.state,configs=_state.configs,allStores=_state.allStores,personalInfoScrolledToBottom=_state.personalInfoScrolledToBottom;// 根據 state 動態產生 aria-live 訊息
var personalInfoA11yMsg=personalInfoScrolledToBottom?'您已閱讀完個人資料聲明，現在可以勾選同意。':'請閱讀至最下方以啟用同意勾選。';var isLogin=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this,'props.auth.isLogin',false);var orderOptions=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state,'orderOptions');var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window,'VC_CONFIG');var PLUGIN_ASSETS_URL=VC_CONFIG.PLUGIN_ASSETS_URL;var selectedSubject=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json___default.a,function(item){return item.id==_this2.getFieldValue('querySubject');});var subjectTitle=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(selectedSubject,'name','客服建議');var selectedSubjectId=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(selectedSubject,'id');var pathname=window.location.pathname;if(pathname[0]=='/'){pathname=pathname.substr(1);}var isKiosk=pathname==='kiosk/contact_us.html'||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_24_query_string___default.a.parse(window.location.search),'view')==='kiosk';var Locale=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(window,'VC_CONFIG.Locale');var alldata={};var storeTypes=configs['contact_store_type']||[];var channelStoresList=storeTypes.map(function(type){var cities=configs['citys'].map(function(city){var areas=city.children.map(function(area){var storeList=allStores.filter(function(store){return store['store_type_name']===type.name&&store['city_name']===city.name&&store['area_name']===area.name;}).map(function(item){return{id:item.id,name:item.name,scs_number:item.scs_number,item:null,ShowStoreMenu:false};});return{id:area.id,name:area.name,items:storeList,ShowStoreMenu:true,disabled:storeList.length===0};});return{id:city.id,name:city.name,items:areas,ShowStoreMenu:true};});return{id:type.id,name:type.name,items:cities,ShowStoreMenu:true};});var submitBtnCx='h6 btn btn-block bg-white text-navy rounded-pill px-5 py-4';var submitBtnDisabledCx='h6 btn btn-block bg-secondary text-navy rounded-pill px-5 py-4 disabled';// 訊息類別下拉選單
var selectedQueryOption=queryOptions.find(function(o){return o.id===selectedSubjectId;});var queryTypesList_lv1=selectedQueryOption?selectedQueryOption.items:[];var selectedQueryTypesLv1=queryTypesList_lv1.find(function(o){return o.id===_this2.formRef.current.getFieldValue('queryTypes_lv1');});var queryTypesList_lv2=selectedQueryTypesLv1?selectedQueryTypesLv1.items:[];var selectedQueryTypesLv2=queryTypesList_lv2.find(function(o){return o.id===_this2.formRef.current.getFieldValue('queryTypes_lv2');});var queryTypesList_lv3=selectedQueryTypesLv2?selectedQueryTypesLv2.items:[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',className:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['basic'],layout:'vertical',autoComplete:'off',onFinish:function onFinish(values){_this2.checkSending(values);_this2.setState({info:values});},onFieldsChange:function onFieldsChange(changedFields,allFields){alldata=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.reduce(allFields,function(r,i){r[i.name.join('.')]=i.value;return r;},{});_this2.setState({data:JSON.stringify(alldata)});localStorage.setItem('to-href','/contact-us');localStorage.setItem('contact-data',_this2.state.data);}},wp.element.createElement('section',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({noStyle:true},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('querySubject'),{rules:[{required:true,message:'請選擇詢問主題'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_components_NavTab_NavTab__["a" /* default */],{value:this.getFieldValue('querySubject'),tabs:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json___default.a.filter(function(item){return item.id!==5;}),function(item){return{value:item.id,name:Locale=='en_US'?item.en_name:item.name};}),onChange:function onChange(value,tabInfo){_this2.option=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(queryOptions,function(o){return o.id==value;}),'items');_this2.formRef.current.setFields([{name:['queryTypes'],value:[],touched:true,validating:false,errors:[]}]);_this2.setState(_this2.option);}})),wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_37_assets_img_contact_1_person_svg___default.a,alt:'\u5BA2\u670D\u5EFA\u8B70'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Locale=='en_US'?Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json___default.a,function(item){return item.id==_this2.getFieldValue('querySubject');}),'en_name','客服建議'),'cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_34__querySubjectOptions_json___default.a,function(item){return item.id==_this2.getFieldValue('querySubject');}),'name','客服建議'),'cec-plugin-stores'))))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('親愛的顧客您好：','cec-plugin-stores'),wp.element.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('若您對康達盛通有任何的建議或指教，我們非常歡迎您能來信指教，若您有急需反映之事項，請您致電 客服中心：0809-001-365、線上將有專人為您提供服務。 客服中心服務時間為早上9:00-晚上9:00，或您可透過語音直接轉由分店協助處理。感謝您。','cec-plugin-stores')),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['icon-call-wrapper'],style:{display:'flex',flexWrap:'wrap',alignItems:'flex-start'}},wp.element.createElement('a',{role:'button',target:'_blank',href:'https://uni-prosperity.tototalk.com.tw/web-contact-us',rel:'noopener noreferrer'},wp.element.createElement('img',{style:{maxWidth:136},alt:' ',src:PLUGIN_ASSETS_URL+'img/contact/ICON-WB.png'}),wp.element.createElement('img',{alt:' ',style:{maxWidth:150},src:PLUGIN_ASSETS_URL+'img/contact/web-contact-us.png'})),wp.element.createElement('div',{'aria-live':'polite','aria-atomic':'true',style:{position:'absolute',left:'-9999px',height:'1px',width:'1px',overflow:'hidden'}},personalInfoA11yMsg),wp.element.createElement('div',{style:{display:'flex',flexDirection:'column',alignItems:'center'}},wp.element.createElement('div',{className:'d-block d-md-none',style:{width:'100%',marginTop:16}},wp.element.createElement('div',{id:'personalInfoStatement',style:{border:'1px solid #ccc',borderRadius:6,padding:12,height:120,overflowY:'scroll',fontSize:14,background:'#fff',marginBottom:12,whiteSpace:'pre-line'},onScroll:this.handlePersonalInfoScroll,ref:function ref(el){return _this2.personalInfoBoxMobile=el;},tabIndex:0,'aria-label':'\u500B\u4EBA\u8CC7\u6599\u8490\u96C6\u544A\u77E5\u53CA\u8072\u660E\u5167\u5BB9'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('聯絡我們之《個人資料蒐集告知及聲明》\n\n就台端於「客服建議」、「新品推薦」、「缺貨回報」或「買貴回報」各表單所提出之申請，康達盛通生活事業股份有限公司(以下簡稱本公司)為處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內蒐集台端於所填表單所提供之各類個人資料（包括姓名、電話、地址、電子信箱、購物時間地點與識別類、特徵類、家庭情形、生活格調、社會情形、教育、受僱情形及其他所填表單所載個資類別等暨消費資訊及相關個人資料）。本公司得將個人資料於處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內，提供予本公司（含受本公司委託處理事務之機關）處理人員或該申請相關之廠商蒐集、處理或利用，使之協助處理台端之申請，並限於本公司所營業務存續期間(法律另有規定者則不在此限)，在中華民國境內及境外(包含但不限於日本)或「個人資料利用之對象」其國內及國外所在地以電子郵件、電話、簡訊、以自動化機器或其他非自動化之利用方式利用。\n\n台端得至www.uni-prosperity.com.tw網站留言或來電客服中心(電話：0809-001365，服務時間為每日上午9點至下午9點)主張個人資料保護法第三條規定之權利，請求查詢、閱覽、製給複製本、補充或更正、停止蒐集處理或利用、或刪除原提供之個人資料。另台端如請求查詢、閱覽個人資料或製給複製本時，將酌收必要成本費用。惟依法本公司因執行業務所必須者，本公司得不依台端請求為之。\n\n台端可自由選擇是否提供其個人資料，惟若拒絕提供相關個人資料，本公司將無法進行必要之處理作業，致無法完整提供相關服務。','cec-plugin-stores')),!this.state.personalInfoScrolledToBottom&&wp.element.createElement('div',{style:{display:'flex',justifyContent:'center',margin:'16px 0 20px 0'}},wp.element.createElement('button',{type:'button',style:{fontSize:16,background:'#005BAC',color:'#fff',border:'none',borderRadius:6,padding:'10px 32px',cursor:'pointer',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',outline:'none',transition:'box-shadow 0.2s, outline 0.2s'},onClick:function onClick(){// 完成後 scroll 到最下方
if(_this2.personalInfoBoxMobile){_this2.personalInfoBoxMobile.scrollTop=_this2.personalInfoBoxMobile.scrollHeight;}_this2.setState({personalInfoScrolledToBottom:true});},'aria-label':'\u6211\u5DF2\u95B1\u8B80\u5B8C\u7562',onFocus:function onFocus(e){return e.target.style.boxShadow='0 0 0 3px #90caf9';},onBlur:function onBlur(e){return e.target.style.boxShadow='0 2px 8px rgba(0,0,0,0.06)';},onMouseOver:function onMouseOver(e){return e.target.style.background='#003e7e';},onMouseOut:function onMouseOut(e){return e.target.style.background='#005BAC';}},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我已閱讀完畢','cec-plugin-stores'))),wp.element.createElement('label',{id:'personalInfoCheckboxLabel',style:{display:'flex',alignItems:'center',fontSize:14}},wp.element.createElement('input',{type:'checkbox',checked:this.state.agreePersonalInfo,onChange:this.handlePersonalInfoAgreeChange,style:{marginRight:8},disabled:!this.state.personalInfoScrolledToBottom,'aria-checked':this.state.agreePersonalInfo?'true':'false','aria-disabled':!this.state.personalInfoScrolledToBottom?'true':'false','aria-labelledby':'personalInfoCheckboxLabel personalInfoStatement'}),Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我已閱讀並同意 聯絡我們之《個人資料蒐集告知及聲明》','cec-plugin-stores'),!this.state.personalInfoScrolledToBottom&&wp.element.createElement('span',{style:{color:'#888',marginLeft:8,fontSize:12}},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('請閱讀至最下方以啟用勾選','cec-plugin-stores'))))),wp.element.createElement('div',{className:'d-none d-md-flex',style:{flex:1,marginLeft:24,minWidth:260,maxWidth:400,display:'flex',flexDirection:'column',alignItems:'stretch'}},wp.element.createElement('div',{id:'personalInfoStatement',style:{border:'1px solid #ccc',borderRadius:6,padding:12,height:120,overflowY:'scroll',fontSize:14,background:'#fff',marginBottom:12,whiteSpace:'pre-line'},onScroll:this.handlePersonalInfoScroll,ref:function ref(el){return _this2.personalInfoBox=el;},tabIndex:0,'aria-label':'\u500B\u4EBA\u8CC7\u6599\u8490\u96C6\u544A\u77E5\u53CA\u8072\u660E\u5167\u5BB9'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('聯絡我們之《個人資料蒐集告知及聲明》\n\n就台端於「客服建議」、「新品推薦」、「缺貨回報」或「買貴回報」各表單所提出之申請，康達盛通生活事業股份有限公司(以下簡稱本公司)為處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內蒐集台端於所填表單所提供之各類個人資料（包括姓名、電話、地址、電子信箱、購物時間地點與識別類、特徵類、家庭情形、生活格調、社會情形、教育、受僱情形及其他所填表單所載個資類別等暨消費資訊及相關個人資料）。本公司得將個人資料於處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內，提供予本公司（含受本公司委託處理事務之機關）處理人員或該申請相關之廠商蒐集、處理或利用，使之協助處理台端之申請，並限於本公司所營業務存續期間(法律另有規定者則不在此限)，在中華民國境內及境外(包含但不限於日本)或「個人資料利用之對象」其國內及國外所在地以電子郵件、電話、簡訊、以自動化機器或其他非自動化之利用方式利用。\n\n台端得至www.uni-prosperity.com.tw網站留言或來電客服中心(電話：0809-001365，服務時間為每日上午9點至下午9點)主張個人資料保護法第三條規定之權利，請求查詢、閱覽、製給複製本、補充或更正、停止蒐集處理或利用、或刪除原提供之個人資料。另台端如請求查詢、閱覽個人資料或製給複製本時，將酌收必要成本費用。惟依法本公司因執行業務所必須者，本公司得不依台端請求為之。\n\n台端可自由選擇是否提供其個人資料，惟若拒絕提供相關個人資料，本公司將無法進行必要之處理作業，致無法完整提供相關服務。','cec-plugin-stores')),!this.state.personalInfoScrolledToBottom&&wp.element.createElement('div',{style:{display:'flex',justifyContent:'center',margin:'16px 0 20px 0'}},wp.element.createElement('button',{type:'button',style:{fontSize:16,background:'#005BAC',color:'#fff',border:'none',borderRadius:6,padding:'10px 32px',cursor:'pointer',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',outline:'none',transition:'box-shadow 0.2s, outline 0.2s'},onClick:function onClick(){// 完成後 scroll 到最下方
if(_this2.personalInfoBox){_this2.personalInfoBox.scrollTop=_this2.personalInfoBox.scrollHeight;}_this2.setState({personalInfoScrolledToBottom:true});},'aria-label':'\u6211\u5DF2\u95B1\u8B80\u5B8C\u7562',onFocus:function onFocus(e){return e.target.style.boxShadow='0 0 0 3px #90caf9';},onBlur:function onBlur(e){return e.target.style.boxShadow='0 2px 8px rgba(0,0,0,0.06)';},onMouseOver:function onMouseOver(e){return e.target.style.background='#003e7e';},onMouseOut:function onMouseOut(e){return e.target.style.background='#005BAC';}},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我已閱讀完畢','cec-plugin-stores'))),wp.element.createElement('label',{id:'personalInfoCheckboxLabel',style:{display:'flex',alignItems:'center',fontSize:14}},wp.element.createElement('input',{type:'checkbox',checked:this.state.agreePersonalInfo,onChange:this.handlePersonalInfoAgreeChange,style:{marginRight:8},disabled:!this.state.personalInfoScrolledToBottom,'aria-checked':this.state.agreePersonalInfo?'true':'false','aria-disabled':!this.state.personalInfoScrolledToBottom?'true':'false','aria-labelledby':'personalInfoCheckboxLabel personalInfoStatement'}),Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('我已閱讀並同意 聯絡我們之《個人資料蒐集告知及聲明》','cec-plugin-stores'),!this.state.personalInfoScrolledToBottom&&wp.element.createElement('span',{style:{color:'#888',marginLeft:8,fontSize:12}},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('請閱讀至最下方以啟用勾選','cec-plugin-stores'))))))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_38_assets_img_contact_2_info_svg___default.a,alt:'\u806F\u7D61\u8CC7\u8A0A'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('聯絡資訊','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group row align-items-center'},wp.element.createElement('label',{'class':'col-sm-4 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('姓名','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-8'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Name'),{className:'mb-0',rules:[{type:'string',required:true,whitespace:true,message:'請輸入姓名和內容不為空'},{type:'string',min:0,max:40,message:'超過字數限制(最多為40個字)'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'}))))),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'form-group row align-items-center'},wp.element.createElement('label',{'class':'col-sm-4 col-form-label h6 text-navy text-md-right','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('電話','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-8'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Tel'),{className:'mb-0',rules:[{type:'string',required:true,whitespace:true,message:'請輸入電話和內容不能為空白'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))))),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group row align-items-center mb-0'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('信箱','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Email'),{className:'mb-0',rules:[{type:'email',required:true,message:'請輸入信箱和內容不能為空白'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))))))))),__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf([SubjectID.CustomerService,SubjectID.Service],selectedSubjectId)!==-1&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_39_assets_img_contact_3_message_svg___default.a,alt:'\u8A0A\u606F\u985E\u578B'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('訊息類型','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5 w-100'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('訊息類別','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['query-types-select-wrapper']+' col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('queryTypes_lv1'),{rules:[{required:queryTypesList_lv1.length>0,message:'請選擇類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a,{dropdownClassName:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['select-wrapper'],placeholder:'Please Select',onChange:function onChange(val){_this2.formRef.current.setFields([{name:'queryTypes_lv2',value:undefined,errors:[]},{name:'queryTypes_lv3',value:undefined,errors:[]}]);}},queryTypesList_lv1.map(function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a.Option,{key:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('queryTypes_lv2'),{rules:[{required:queryTypesList_lv2.length>0,message:'請選擇類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a,{dropdownClassName:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['select-wrapper'],placeholder:'Please Select',disabled:queryTypesList_lv2.length===0,onChange:function onChange(val){_this2.formRef.current.setFields([{name:'queryTypes_lv3',value:undefined,errors:[]}]);}},queryTypesList_lv2.map(function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a.Option,{key:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('queryTypes_lv3'),{rules:[{required:queryTypesList_lv3.length>0,message:'請選擇類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a,{dropdownClassName:__WEBPACK_IMPORTED_MODULE_26__contact_us_module_scss___default.a['select-wrapper'],placeholder:'Please Select',disabled:queryTypesList_lv3.length===0},queryTypesList_lv3.map(function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select___default.a.Option,{key:item.id},item.name);}))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,{noStyle:true,shouldUpdate:true},function(){var isOnlineShopping=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf(ONLINE_SHOPPING_CODES,__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.last(_this2.getFieldValue('queryTypes',[])))!==-1;if(!isOnlineShopping)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group row align-items-center mb-0'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('訂單號碼','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_OrderId'),{extra:wp.element.createElement('div',null,wp.element.createElement('a',{style:{color:'red'}},'\u5982\u679C\u8A02\u55AE\u5DF2\u6210\u7ACB\uFF0C\u8ACB\u9EDE\u9078\u3010',wp.element.createElement('h7',{style:{color:'#24A0F7'},target:'_blank',rel:'noopener noreferrer',onClick:function onClick(selectoderlist){if(isLogin===false){__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.confirm({title:'線上購物問題，請先登入會員',cancelText:'知道了',okText:'立即登入',onOk:function onOk(){// ALVIN 2023/05/05 調整CC login remark
// this.GetOcaUri()
_this2.GetCCUri();if(_this2.state.LoginUrl)window.location.replace(_this2.state.LoginUrl);},onCancel:function onCancel(){}});}else{window.open('https://qa-online.uni-prosperity.com.tw/');}}},'\u67E5\u8A62\u8A02\u55AE\u865F\u78BC'),'\u3011\u5148\u767B\u5165\u6703\u54E1','>','\u8A02\u55AE\u67E5\u8A62\uFF0C\u63D0\u4F9B\u8A02\u55AE\u865F\u78BC\uFF0C \u4EE5\u5229\u52A0\u5FEB\u8655\u7406\u901F\u5EA6\u3002\u82E5\u8A02\u55AE\u5C1A\u672A\u6210\u7ACB\u7121\u9808\u586B\u5BEB\u3002'))}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_antd_lib_auto_complete___default.a,{autoFocus:true,defaultOpen:true,options:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.map(orderOptions,function(item){return{value:item.code};}),filterOption:function filterOption(inputValue,option){return option.value.toUpperCase().indexOf(inputValue.toUpperCase())!==-1;},onChange:_this2.handleorderlist})))))));}),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('詢問對象','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('queryTargets'),{className:'mb-0',rules:[{required:true,message:'請選擇詢問對象'}],extra:this.state.isLoadOrderDetails&&'搜尋訂單分店...'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader___default.a,{expandTrigger:'hover',fieldNames:{value:'id',label:'name',children:'items'},options:__WEBPACK_IMPORTED_MODULE_33__queryTargetOptions_json___default.a,onChange:this.handleQueryTargetsChange})))),this.state.isShowChannelStoresField&&wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('通路門市','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('channelStores'),{className:'mb-0',rules:[{required:true,message:'請選擇通路門市'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader___default.a,{expandTrigger:'hover',fieldNames:{value:'name',label:'name',children:'items'},options:channelStoresList})))))))),__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf([SubjectID.NewProduct,SubjectID.OutOfStock,SubjectID.Expensive],selectedSubjectId)!==-1&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_39_assets_img_contact_3_message_svg___default.a,alt:'\u5546\u54C1\u985E\u5225'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('商品類別','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('商品類別','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('queryTypes_lv3'),{rules:[{required:true,message:'請選擇商品類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader___default.a,{expandTrigger:'hover',fieldNames:{value:'id',label:'name',children:'items'},options:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(queryOptions,function(o){return o.id==selectedSubjectId;}),'items'),onChange:function onChange(value,selectedOptions){var isOnlineShopping=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf(ONLINE_SHOPPING_CODES,__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.last(value))!==-1;if(isLogin===false&&isOnlineShopping){__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.confirm({title:'線上購物問題，請先登入會員',cancelText:'知道了',okText:'立即登入',onOk:function onOk(){window.location.replace(__WEBPACK_IMPORTED_MODULE_28__configs_env__["g" /* LOGIN_LINK */]);},onCancel:function onCancel(){_this2.formRef.current.setFields([{name:['queryTypes'],value:[],touched:true,validating:false,errors:[]}]);}});}}})))))))),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_40_assets_img_contact_4_place_svg___default.a,alt:'\u8CFC\u7269\u5730\u9EDE'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('購物地點','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'form-group row align-items-center mb-0'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('購物地點','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Place'),{className:'mb-0',rules:[{type:'string',required:true,whitespace:true,message:'請輸入購物地點和內容不能為空白'},{type:'string',min:0,max:100,message:'超過字數限制(最多為100個字)'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input',maxLength:101})))))))))),isKiosk!==true&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_42_assets_img_contact_6_file_svg___default.a,alt:'\u9644\u52A0\u6A94\u6848'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('附加檔案','cec-plugin-stores'))))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('您最多可以上傳四個檔案，所有檔案大小加總不得超過4MB 可接受的格式為 png、jpg、jpeg、bmp、avi、mp4、mp3、mkv、3gp、mov','cec-plugin-stores')),wp.element.createElement('div',{'class':'row mt-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Files'),{valuePropName:'fileList'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_36_components_WUpload_WUpload__["b" /* default */],{accept:fileType,listType:'picture-card',beforeUpload:function beforeUpload(file,fileList){var fileExt=null;if(file.name){fileExt=_this2.getFileExtension(file.name);}if((!file.type||!fileType.includes(file.type))&&!fileType.includes(fileExt)){_this2.showInfo({title:'檔案格式錯誤'});return Promise.reject('檔案格式錯誤');}var fileSize=file.size/1024/1024;var currentFilesSize=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.reduce(_this2.getFieldValue('Var_Files'),function(sum,file){return sum+file.size;},0)/1024/1024;if(fileList.length>4){_this2.showInfo({title:'您最多可以上傳四個檔案'});return Promise.reject('您最多可以上傳四個檔案');}if(currentFilesSize+fileSize>4){_this2.showInfo({title:'所有檔案大小加總不得超過4MB'});return Promise.reject('所有檔案大小加總不得超過4MB');}return Promise.resolve();},onChange:function onChange(fileList){if(!fileList)return;_this2.setState({isFileUploading:fileList.some(function(file){return file.status==='uploading';})});}},this.getFieldValue('Var_Files',[]).length<4&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' ',Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('上傳','cec-plugin-stores'),' ')))))))),__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf([SubjectID.CustomerService,SubjectID.Service],selectedSubjectId)!==-1&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg___default.a,alt:'\u56DE\u994B\u8A0A\u606F'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('回饋訊息','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},'\u63D0\u9192\u60A8\uFF1A\u70BA\u52A0\u901F\u8655\u7406\u60A8\u63D0\u554F\u7684\u554F\u984C\uFF0C\u8ACB\u63D0\u4F9B\u5177\u9AD4\u5167\u5BB9\uFF0C\u82E5\u8CC7\u8A0A\u4E0D\u660E\u78BA\uFF0C\u5C07\u7121\u6CD5\u9032\u4E00\u6B65\u8655\u7406\u53CA\u56DE\u5FA9\uFF0C\u656C\u8ACB\u898B\u8AD2'),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('訊息標題*','cec-plugin-stores')),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Subject'),{className:'mb-0',rules:[{type:'string',required:true,whitespace:true,message:'請輸入訊息標題和內容不能為空白'},{type:'string',min:0,max:100,message:'超過字數限制(最多為100個字)'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('留言內容','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Txt_Memo'),{rules:[{type:'string',required:true,whitespace:true,message:'請輸入留言內容和內容不能為空白'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a.TextArea,{className:'form-control feedback-content-input',rows:8})))))))),selectedSubjectId===SubjectID.NewProduct&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg___default.a,alt:'\u63A8\u85A6\u5546\u54C1\u8CC7\u8A0A'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('推薦商品資訊','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},'\u63D0\u9192\u60A8\uFF1A\u70BA\u52A0\u901F\u8655\u7406\u60A8\u63D0\u554F\u7684\u554F\u984C\uFF0C\u8ACB\u63D0\u4F9B\u5177\u9AD4\u5167\u5BB9\uFF0C\u82E5\u8CC7\u8A0A\u4E0D\u660E\u78BA\uFF0C\u5C07\u7121\u6CD5\u9032\u4E00\u6B65\u8655\u7406\u53CA\u56DE\u5FA9\uFF0C\u656C\u8ACB\u898B\u8AD2'),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u5546\u54C1\u540D\u7A31*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_name'),{rules:[{required:true,message:'請輸入商品名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u8CC7\u8A0A\u4F86\u6E90*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('data_source'),{rules:[{required:true,message:'請輸入資訊來源'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Group,{value:'large'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:'\u5BE6\u9AD4'},'\u5BE6\u9AD4'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:'\u7DB2\u8DEF'},'\u7DB2\u8DEF'))))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u5546\u54C1\u689D\u78BC'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_barcode'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u552E\u50F9'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_price'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u4F9B\u61C9\u5546'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('supplier'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('推薦商品資訊','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_info'),{rules:[{required:true,message:'推薦商品資訊'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a.TextArea,{className:'form-control feedback-content-input',rows:8})))))))),selectedSubjectId===SubjectID.OutOfStock&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg___default.a,alt:'\u56DE\u5831\u8A0A\u606F'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('回報訊息','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},'\u63D0\u9192\u60A8\uFF1A\u70BA\u52A0\u901F\u8655\u7406\u60A8\u63D0\u554F\u7684\u554F\u984C\uFF0C\u8ACB\u63D0\u4F9B\u5177\u9AD4\u5167\u5BB9\uFF0C\u82E5\u8CC7\u8A0A\u4E0D\u660E\u78BA\uFF0C\u5C07\u7121\u6CD5\u9032\u4E00\u6B65\u8655\u7406\u53CA\u56DE\u5FA9\uFF0C\u656C\u8ACB\u898B\u8AD2'),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},'\u5546\u54C1\u540D\u7A31*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Var_Subject'),{rules:[{required:true,message:'請輸入商品名稱'},{type:'string',min:0,max:100,message:'超過字數限制(最多為100個字)'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('缺貨說明','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('Txt_Memo'),{rules:[{required:true,message:'請輸入缺貨說明'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a.TextArea,{className:'form-control feedback-content-input',rows:8})))))))),selectedSubjectId===SubjectID.Expensive&&wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4 stre'},wp.element.createElement('div',{'class':'col-lg-3 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'row mb-4'},wp.element.createElement('div',{'class':'col-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:__WEBPACK_IMPORTED_MODULE_41_assets_img_contact_5_reply_svg___default.a,alt:'\u56DE\u5831\u8CC7\u8A0A'}))),wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('回報資訊','cec-plugin-stores')),wp.element.createElement('p',{'class':'note text-primary text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('必填資料','cec-plugin-stores'),'*')))),wp.element.createElement('div',{'class':'col-lg-9 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'},wp.element.createElement('div',{'class':'card-body p-5'},wp.element.createElement('p',{'class':'h6 mb-0 text-navy'},'\u63D0\u9192\u60A8\uFF1A\u70BA\u52A0\u901F\u8655\u7406\u60A8\u63D0\u554F\u7684\u554F\u984C\uFF0C\u8ACB\u63D0\u4F9B\u5177\u9AD4\u5167\u5BB9\uFF0C\u82E5\u8CC7\u8A0A\u4E0D\u660E\u78BA\uFF0C\u5C07\u7121\u6CD5\u9032\u4E00\u6B65\u8655\u7406\u53CA\u56DE\u5FA9\uFF0C\u656C\u8ACB\u898B\u8AD2'),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('商品名稱','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_name'),{rules:[{required:true,message:'請輸入商品名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('是否為促銷','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('onsale'),{rules:[{required:true,message:'請選擇是否為促銷'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Group,{value:'large',onChange:function onChange(e){var value=e.target.value;_this2.option=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.find(queryOptions,function(o){return o.id===value;}),'items');_this2.setState(_this2.option);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:'\u662F'},'\u662F'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_radio___default.a.Button,{value:'\u975E'},'\u5426'))))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('比價通路','cec-plugin-stores'),'*'),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('retailChannel'),{rules:[{required:true,message:'請選擇比價通路'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_cascader___default.a,{expandTrigger:'hover',fieldNames:{value:'name',label:'name',children:'items'},options:__WEBPACK_IMPORTED_MODULE_35__retailChannelOptions_json___default.a,onChange:function onChange(value,selectedOptions){var isOnlineShopping=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.indexOf(ONLINE_SHOPPING_CODES,__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.last(value))!==-1;if(isLogin===false&&isOnlineShopping){__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a.confirm({title:'線上購物問題，請先登入會員',cancelText:'知道了',okText:'立即登入',onOk:function onOk(){window.location.replace(__WEBPACK_IMPORTED_MODULE_28__configs_env__["g" /* LOGIN_LINK */]);},onCancel:function onCancel(){_this2.formRef.current.setFields([{name:['queryTypes'],value:[],touched:true,validating:false,errors:[]}]);}});}}})))),wp.element.createElement('div',{'class':'form-group mb-4 row align-items-center'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('比價通路價格','cec-plugin-stores')),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('product_price'),{rules:[{required:true,message:'請輸入比價通路價格'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a,{className:'form-control feedback-content-input'})))),wp.element.createElement('div',{'class':'form-group mb-4 row'},wp.element.createElement('label',{'class':'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('留言內容','cec-plugin-stores')),wp.element.createElement('div',{'class':'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_30_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input___default.a.TextArea,{className:'form-control feedback-content-input',rows:8})))))))),wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-6 col-lg-3 mt-5'},wp.element.createElement('a',{'class':this.state.isFileUploading||!this.state.agreePersonalInfo?submitBtnDisabledCx:submitBtnCx,role:'button',href:'#',onClick:!this.state.agreePersonalInfo?function(e){return e.preventDefault();}:this.handleFormSubmit},Object(__WEBPACK_IMPORTED_MODULE_23__wordpress_i18n__["__"])('確定送出','cec-plugin-stores')))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_modal___default.a,{title:'\u78BA\u5B9A\u9001\u51FA',visible:this.state.visible,onOk:function onOk(){_this2.submitData(_this2.state.info);_this2.setState({confirmLoading:true});},confirmLoading:this.state.confirmLoading,onCancel:function onCancel(){_this2.setState({visible:false});}},'\u8ACB\u518D\u6B21\u78BA\u8A8D\u662F\u5426\u9001\u51FA'))))));}}]);return ContactUs;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 編輯器
var ContactUsEditor=function(_Component2){_inherits(ContactUsEditor,_Component2);function ContactUsEditor(){_classCallCheck(this,ContactUsEditor);return _possibleConstructorReturn(this,(ContactUsEditor.__proto__||Object.getPrototypeOf(ContactUsEditor)).apply(this,arguments));}_createClass(ContactUsEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-format-status'})),'\u806F\u7D61\u6211\u5011\u6A21\u7D44'));}}]);return ContactUsEditor;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"basic":"basic___iGI8O","query-types-select-wrapper":"query-types-select-wrapper___ZbDi3","select-wrapper":"select-wrapper___2VWSp","icon-call-wrapper":"icon-call-wrapper___2prM-"};

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = [{"code":"697883d7-0daa-4ced-be27-959b248c4979","name":"會員卡相關問題Loyalty card","Sort":0,"UnitCode":"CARD","id":"1","items":null,"ShowStoreMenu":false},{"code":"b93940e3-bb11-4f11-91ae-9c0d2c92c23d","name":"總公司Head Office","Sort":1,"UnitCode":"HO","id":"2","items":null,"ShowStoreMenu":false},{"code":"277760a3-c037-4695-8b8d-5601396b5f74","name":"商品PLB product","Sort":2,"UnitCode":"PLB","id":"3","items":null,"ShowStoreMenu":false},{"code":"deacbd20-503d-44bb-8b9c-2d3c13171eba","name":"網站相關問題Website","Sort":3,"UnitCode":"WEBSITE","id":"4","items":null,"ShowStoreMenu":false},{"code":"fb862c6e-c554-4394-94c5-f0707966ad7c","name":"美食街/商店街相關問題 Shopping Mall","Sort":4,"UnitCode":"SHOPPINGMALL","id":"5","items":null,"ShowStoreMenu":false},{"code":"c938ac55-8665-42aa-96f6-e6dadd3fcafb","name":"電信相關問題 Telecommunications Corporation","Sort":5,"UnitCode":"Telecommunications","id":"6","items":null,"ShowStoreMenu":false},{"code":"2c4b7325-c099-4a16-a346-7867e9f00ef7","name":"台北地區Taipei Area","Sort":6,"UnitCode":"Taipei","id":"7","items":[{"name":"天母店 Tien Mou Store","Enable":true,"id":"2","UnitCode":"TM"},{"name":"大直店 Ta Zhi Store","Enable":true,"id":"3","UnitCode":"TZ"},{"name":"內湖店 Nei Hu Store","Enable":true,"id":"5","UnitCode":"NH"},{"name":"重慶店 Chong Qing Store","Enable":true,"id":"6","UnitCode":"CQ"},{"name":"南港店 Nan Kang Store","Enable":true,"id":"7","UnitCode":"NK"},{"name":"三民店 San Ming Store","Enable":true,"id":"8","UnitCode":"SM"},{"name":"東興店 Dong Hsing Store","Enable":true,"id":"9","UnitCode":"DH"},{"name":"桂林店 Kwei Ling Store","Enable":true,"id":"10","UnitCode":"KL"},{"name":"重新店 Chung Xin Store","Enable":true,"id":"11","UnitCode":"CX"},{"name":"板橋店 Pan Chiao Store","Enable":true,"id":"12","UnitCode":"PC"},{"name":"中和店 Jong Ho Store","Enable":true,"id":"13","UnitCode":"JH"},{"name":"新店店 Hsin Tien Store","Enable":true,"id":"14","UnitCode":"HT"},{"name":"土城店 Tu Chen Store","Enable":true,"id":"15","UnitCode":"TC"},{"name":"樹林店 Shu Lin Store","Enable":true,"id":"16","UnitCode":"SL"},{"name":"林口店 Lin Kou Store","Enable":true,"id":"25","UnitCode":"LK"},{"name":"蘆洲店 Lu Jhou Store","Enable":true,"id":"113","UnitCode":"LJ"},{"name":"北投店 Bei Tou Store","Enable":true,"id":"117","UnitCode":"BE"},{"name":"北大店 Bei Dai Store","Enable":true,"id":"121","UnitCode":"BD"},{"name":"中平店 Zhong Ping Store","Enable":true,"id":"123","UnitCode":"ZP"},{"name":"淡新店 Tan Xin Store","Enable":true,"id":"133","UnitCode":"TX"},{"name":"汐科店 Xi Ke Store","Enable":true,"id":"155","UnitCode":"XK"}],"ShowStoreMenu":true},{"code":"c6952c9c-f18c-4d2b-b704-f04faa335626","name":"桃竹苗地區Tao-Chu-Miao Area","Sort":7,"UnitCode":"Tao-Chu-Miao","id":"8","items":[{"name":"桃園店 Tao Yuan Store","Enable":true,"id":"17","UnitCode":"TY"},{"name":"經國店 Ching Kuo Store","Enable":true,"id":"18","UnitCode":"CK"},{"name":"中壢店 Chung Li Store","Enable":true,"id":"19","UnitCode":"CL"},{"name":"中原店 Zhong Yuan Store","Enable":true,"id":"21","UnitCode":"ZY"},{"name":"內壢店 Nei Li Store","Enable":true,"id":"22","UnitCode":"NL"},{"name":"竹北店 Chu Pei Store","Enable":true,"id":"23","UnitCode":"CP"},{"name":"苗栗店 Miao Li Store","Enable":true,"id":"24","UnitCode":"ML"},{"name":"平鎮店Ping Jhen Store","Enable":true,"id":"186","UnitCode":"PJ"},{"name":"八德店Ba De Store","Enable":true,"id":"200","UnitCode":"BA"}],"ShowStoreMenu":true},{"code":"1f201944-9efc-41f0-9b61-9eda5f0ef0e8","name":"中彰投地區Chung-Zhang-Tou Area","Sort":8,"UnitCode":null,"id":"9","items":[{"name":"中清店 Chung Shing Store","Enable":true,"id":"26","UnitCode":"CS"},{"name":"青海店 Ching Hai Store","Enable":true,"id":"27","UnitCode":"CA"},{"name":"文心店 Wen Sin Store","Enable":true,"id":"28","UnitCode":"WS"},{"name":"大墩店 Ta Tun Store","Enable":true,"id":"29","UnitCode":"TT"},{"name":"崇德店 Chung Teh Store","Enable":true,"id":"30","UnitCode":"CT"},{"name":"德安店 De An Store","Enable":true,"id":"31","UnitCode":"DA"},{"name":"彰化店 Zhang Hua Store","Enable":true,"id":"32","UnitCode":"ZH"},{"name":"南投店 Nan Tou Store","Enable":true,"id":"33","UnitCode":"NT"},{"name":"太平店 Tai Ping Store","Enable":true,"id":"51","UnitCode":"TP"},{"name":"豐原店 Fong Yuan Store","Enable":true,"id":"104","UnitCode":"FY"},{"name":"沙鹿店 Xa Lu Store","Enable":true,"id":"131","UnitCode":"XL"},{"name":"埔里店Pu Li Store","Enable":true,"id":"143","UnitCode":"PL"},{"name":"西屯店 Xi Tun store","Enable":true,"id":"292","UnitCode":"XT"}],"ShowStoreMenu":true},{"code":"d835d133-57d0-42eb-8aa5-c2b377be64b7","name":"雲嘉南地區Yun-Chia-Nan Area","Sort":9,"UnitCode":"Yun-Chia-Nan","id":"10","items":[{"name":"嘉義店 Chia Yi Store","Enable":true,"id":"34","UnitCode":"CY"},{"name":"新營店 Hsin Ying Store","Enable":true,"id":"35","UnitCode":"HY"},{"name":"中正店 Chung Cheng Store","Enable":true,"id":"36","UnitCode":"CC"},{"name":"中華店 Chung Hua Store","Enable":true,"id":"37","UnitCode":"CH"},{"name":"安平店 An Ping Store","Enable":true,"id":"38","UnitCode":"AP"},{"name":"仁德店 Jen Te Store","Enable":true,"id":"39","UnitCode":"JT"},{"name":"北門店 Bei Men Store","Enable":true,"id":"105","UnitCode":"BM"},{"name":"斗六店 Dou Liu Store","Enable":true,"id":"115","UnitCode":"DL"},{"name":"虎尾店 Hu Wei Store","Enable":true,"id":"153","UnitCode":"HW"},{"name":"北港店Bei Kang Store","Enable":true,"id":"296","UnitCode":"BK"},{"name":"新仁店Xin Jen Store","Enable":true,"id":"300","UnitCode":"XJ"}],"ShowStoreMenu":true},{"code":"b480caef-37df-4e4f-99f6-e6e1cef658a8","name":"高屏地區Kao-Ping Area","Sort":10,"UnitCode":"Kao-Ping","id":"11","items":[{"name":"鼎山店 Ding Shan Store","Enable":true,"id":"40","UnitCode":"DS"},{"name":"愛河店 Love River Store","Enable":true,"id":"42","UnitCode":"LR"},{"name":"鳳山店 Fong Shan Store","Enable":true,"id":"44","UnitCode":"FS"},{"name":"成功店 Zheng Kong Store","Enable":true,"id":"45","UnitCode":"ZK"},{"name":"五甲店 Wu Ghia Store","Enable":true,"id":"46","UnitCode":"WG"},{"name":"屏東店 Ping Tung Store","Enable":true,"id":"47","UnitCode":"PT"},{"name":"澄清店 Cheng Ching Store","Enable":true,"id":"49","UnitCode":"CG"},{"name":"光華店 Kwang Hwa Store","Enable":true,"id":"50","UnitCode":"KH"},{"name":"楠梓店 Nan Zhi Store","Enable":true,"id":"125","UnitCode":"NZ"},{"name":"新屏店 Xin Ping Store","Enable":true,"id":"294","UnitCode":"XP"},{"name":"新楠店Xin Nan Store","Enable":true,"id":"298","UnitCode":"XN"}],"ShowStoreMenu":true},{"code":"1175d23b-a013-4242-9c5b-8b7ef6afc54c","name":"宜花東地區Yi-Hua-Dong Area","Sort":11,"UnitCode":"Yi-Hua-Dong","id":"12","items":[{"name":"花蓮店 Hua Lien Store","Enable":true,"id":"48","UnitCode":"HL"},{"name":"宜蘭店 I Lan Store","Enable":true,"id":"103","UnitCode":"IL"},{"name":"台東店 Tai Tung Store","Enable":true,"id":"106","UnitCode":"TA"}],"ShowStoreMenu":true},{"code":"8f86ebb6-9b02-4749-a662-1a89fe2877a4","name":"金門地區KinMen Area","Sort":12,"UnitCode":"KinMen","id":"40","items":[{"name":"金門店KinMen Store","Enable":true,"id":"260","UnitCode":"KM"}],"ShowStoreMenu":true},{"code":"345eef35-6c93-4e36-83d0-5748cb46241f","name":"超市 Market","Sort":12,"UnitCode":"Market","id":"26","items":[{"name":"超市府中店 Fu Zhong Store","Enable":true,"id":"119","UnitCode":"FZ"},{"name":"超市永安店 Yonghe Yongan Store","Enable":true,"id":"127","UnitCode":"YY"},{"name":"超市福益店 Tuchen Fuyi Store","Enable":true,"id":"129","UnitCode":"TF"},{"name":"超市南竹店 Nan Chu Store","Enable":true,"id":"135","UnitCode":"NC"},{"name":"超市景安店 Jing An Store","Enable":true,"id":"137","UnitCode":"JA"},{"name":"超市豐南店 Fong Nan Store","Enable":true,"id":"139","UnitCode":"FN"},{"name":"超市民族店 Min Zu Store","Enable":true,"id":"145","UnitCode":"MZ"},{"name":"超市中北店 Zhong North Store","Enable":true,"id":"147","UnitCode":"ZN"},{"name":"超市莊敬店 Zhuang Jing Store","Enable":true,"id":"149","UnitCode":"ZJ"},{"name":"超市昌平店 Chang Ping Store","Enable":true,"id":"151","UnitCode":"CI"},{"name":"超市草屯店 Cao Tun Store","Enable":true,"id":"157","UnitCode":"CZ"},{"name":"超市左營自由店 Zouying Ziyou Store","Enable":true,"id":"159","UnitCode":"ZZ"},{"name":"超市新莊丹鳳店 Xinzhuang DanFeng Store","Enable":true,"id":"161","UnitCode":"DF"},{"name":"超市永康二王店 YongKang ErWang Store","Enable":true,"id":"166","UnitCode":"YE"},{"name":"超市太平環中店 Taiping Huan Zhong Store","Enable":true,"id":"172","UnitCode":"HZ"},{"name":"超市高雄岡山店 Kaohsiung GangShan Store","Enable":true,"id":"174","UnitCode":"KG"},{"name":"超市台中漢口店 Taichung Han Kou Store","Enable":true,"id":"176","UnitCode":"HK"},{"name":"超市高雄小港店 Kaohsiung Xiaogang Store","Enable":true,"id":"178","UnitCode":"KX"},{"name":"超市台中南屯店 Taichung Nan Tun Store","Enable":true,"id":"180","UnitCode":"TN"},{"name":"超市楠梓益群店 Nanzi Yiqun Store","Enable":true,"id":"184","UnitCode":"NY"},{"name":"超市桃園南平店TaoYuan NanPing Store","Enable":true,"id":"188","UnitCode":"NP"},{"name":"超市員林大同店Yuanlin DaTung Store","Enable":true,"id":"190","UnitCode":"YD"},{"name":"超市左營自由二店Zouing Ziyou 2","Enable":true,"id":"192","UnitCode":"ZU"},{"name":"超市高雄鼎金店Kaohsiung Ding Jing Store","Enable":true,"id":"194","UnitCode":"DJ"},{"name":"超市板橋中正店Panchiao ZhongZheng Store","Enable":true,"id":"196","UnitCode":"PO"},{"name":"超市三民建工店Sanmin JianGong Store","Enable":true,"id":"198","UnitCode":"SJ"},{"name":"超市中壢中北店Chungli ZhongBei Store","Enable":true,"id":"202","UnitCode":"ZE"},{"name":"超市左營南屏店 Zouying NanPing Store","Enable":true,"id":"210","UnitCode":"NA"},{"name":"超市台中興安店 Taichung XinAn Store","Enable":true,"id":"212","UnitCode":"XA"},{"name":"超市屏東自由店 Pingtung ZiYou Store","Enable":true,"id":"214","UnitCode":"PU"},{"name":"超市內湖東湖店 Neihu DongHu Store","Enable":true,"id":"218","UnitCode":"ND"},{"name":"超市桃園龍安店 Taoyuan Longan Store","Enable":true,"id":"220","UnitCode":"TL"},{"name":"超市大甲蔣公店 Da Jia Jiang Gong Store","Enable":true,"id":"222","UnitCode":"JG"},{"name":"超市新竹南大店 Hsin Chu NanDa Store","Enable":true,"id":"224","UnitCode":"HN"},{"name":"超市台南裕農店 TaiNan YuNong Store","Enable":true,"id":"226","UnitCode":"YN"},{"name":"超市蘆洲光華店 LuZhou KuangHua Store","Enable":true,"id":"228","UnitCode":"GH"},{"name":"超市台北濟南店 Taipei JiNan Store","Enable":true,"id":"230","UnitCode":"JN"},{"name":"超市士林忠誠店 ShiLin ZhongZheng Store","Enable":true,"id":"232","UnitCode":"SG"},{"name":"超市台北內湖1店 Taipei Neihu Yi Store","Enable":true,"id":"234","UnitCode":"N1"},{"name":"超市台中進化店 Taichung Jin Hua Store","Enable":true,"id":"236","UnitCode":"TJ"},{"name":"超市板橋文化店 PanChiao Wen Hua Store","Enable":true,"id":"238","UnitCode":"PW"},{"name":"超市台中大墩11店 Taichung Ta Tun 11 Store","Enable":true,"id":"240","UnitCode":"T1"},{"name":"超市新莊中港店 Xin Zhuang Zhong Gang Store","Enable":true,"id":"242","UnitCode":"XZ"},{"name":"超市桃園大興店 Taoyuan DaXing Store","Enable":true,"id":"244","UnitCode":"DX"},{"name":"超市桃園中正店Taoyuan Zhong Zheng Store","Enable":true,"id":"246","UnitCode":"ZG"},{"name":"超市左營重和店 Zuoying ChongHe Store","Enable":true,"id":"204","UnitCode":"ZC"},{"name":"超市台南開元店 Tainan KaiYuan Store","Enable":true,"id":"206","UnitCode":"KY"},{"name":"超市台南北安店 Tainan BeiAn Store","Enable":true,"id":"208","UnitCode":"BN"},{"name":"超市台中中清2店 Taichuang Zhong Shing 2 Store","Enable":true,"id":"248","UnitCode":"ZS"},{"name":"超市台南文賢店 Tainan WenXian Store","Enable":true,"id":"250","UnitCode":"WX"},{"name":"超市台北錦州店 Taipei JinZhou Store","Enable":true,"id":"252","UnitCode":"JZ"},{"name":"超市台南中華西店 TaiNan ChungHuaWest Store","Enable":true,"id":"254","UnitCode":"CW"},{"name":"超市台中進化2店 Taichung JinHua 2 Store","Enable":true,"id":"256","UnitCode":"J2"},{"name":"超市大里中興店 Dali Zhongxing Store","Enable":true,"id":"258","UnitCode":"DZ"},{"name":"超市土城日月光店 Tu Cheng We Mall Store","Enable":true,"id":"262","UnitCode":"WM"},{"name":"超市內湖成功店 Neihu Cheng Gong Store","Enable":true,"id":"264","UnitCode":"NU"},{"name":"超市左營崇德店Zuoying Chungde Store","Enable":true,"id":"266","UnitCode":"ZD"},{"name":"超市北投明德店Bei Tou Ming De store","Enable":true,"id":"268","UnitCode":"MI"},{"name":"超市內湖江南店 Nei Hu Jiang Nan","Enable":true,"id":"270","UnitCode":"NJ"},{"name":"超市高雄天祥店KaoHsiung TianXiang store","Enable":true,"id":"272","UnitCode":"KT"},{"name":"超市中壢成章1店Zhong Li Cheng Zhang 1 store","Enable":true,"id":"274","UnitCode":"Z1"},{"name":"超市桃園桃中店 Taoyuan Tao Zhong store","Enable":true,"id":"276","UnitCode":"S1"},{"name":"超市台中復興店 Taichung Fu Xing Store","Enable":true,"id":"278","UnitCode":"FX"},{"name":"超市三重新北大道店 San Chong Xin Bei Blvd Store","Enable":true,"id":"280","UnitCode":"SX"},{"name":"超市小港漢民店 XiaoGang HanMin Store","Enable":true,"id":"282","UnitCode":"XH"},{"name":"超市台中水湳店Taichung ShuiNan Store","Enable":true,"id":"284","UnitCode":"SN"},{"name":"超市鳳山甲一店 FongShan Ghia 1 Store","Enable":true,"id":"286","UnitCode":"FG"},{"name":"超市大安臨江店 Da an Linjiang Store","Enable":true,"id":"288","UnitCode":"DG"},{"name":"超市土城中央店 Tu Cheng Zhong Yang Store","Enable":true,"id":"290","UnitCode":"TU"},{"name":"超市高雄九如一店Kaohsiung JiuRu Store","Enable":true,"id":"302","UnitCode":"KJ"},{"name":"超市土城廣明店Tu Cheng Guang Ming Store","Enable":true,"id":"304","UnitCode":"GM"},{"name":"超市八里商港店BaLi ShanGang Store","Enable":true,"id":"306","UnitCode":"BL"}],"ShowStoreMenu":true},{"code":"39026e1a-02c5-4119-b7c9-68975fd4a806","name":"線上購物 On line shopping","Sort":13,"UnitCode":"Online shopping","id":"27","items":null,"ShowStoreMenu":false}]

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ServiceUs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServiceUsEditor", function() { return ServiceUsEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(window,'VC_CONFIG',{});var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var ServiceUs=function(_Component){_inherits(ServiceUs,_Component);function ServiceUs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ServiceUs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ServiceUs.__proto__||Object.getPrototypeOf(ServiceUs)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:'info',query:{},serviceInfo:undefined,listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]}},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(){var query=__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getHashParamaters();_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/v1/brands',{category_id:query.cids},function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/cecservice');return;}_this.setState({listInfo:data});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(query,key,value);_this.setState({query:query});window.location.href=_this.getSearchPath(query);},_this.getSearchPath=function(query){console.log('getSearchPath',__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query,{skipNull:true}),query);return window.location.origin+'/brands/#'+__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query,{skipNull:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ServiceUs,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getHashParamaters();this.loadConfig();this.loadData(query);this.setState({query:query,tabType:__WEBPACK_IMPORTED_MODULE_8_libs_AppHelper__["a" /* default */].getHashValue('tab')||'info'});}},{key:'render',value:function render(){var serviceInfo=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.serviceInfo',{});var tabType=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.tabType',{});var options=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.query',{});var listInfo=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'props.brands.listInfo',[]);var categoryOptions=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(options,'service_categories',[]).filter(function(categoryInfo){return!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(categoryInfo.items);});var service_categorys=categoryOptions;if(query.cid){service_categorys=service_categorys.filter(function(categoryInfo){return categoryInfo.id==query.cid;});}this.refreshPicker();return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(service_categorys,function(categoryInfo){return wp.element.createElement('div',{'class':'container pt-0',key:categoryInfo.id},wp.element.createElement('h4',{'class':'heading-title align-items-center'},categoryInfo.name),wp.element.createElement('div',{style:{textAlign:'center',fontSize:'18px'}},Object(__WEBPACK_IMPORTED_MODULE_12__wordpress_i18n__["__"])('您可於賣場找到下列服務(服務項目因各店實際狀況而有所不同, 詳情請洽詢各店服務台)','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(categoryInfo,'items',[]),function(serviceInfo){return wp.element.createElement('div',{'class':'col-6 col-sm-4 col-md-3 col-lg-auto icon_service-wrap px-3'},wp.element.createElement('a',{'class':'icon_service-block mb-4',role:'button',href:'#','data-toggle':'modal','data-target':'#icon-service-modal-'+serviceInfo.id,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('div',{'class':'inner'},wp.element.createElement('img',{src:serviceInfo.image,alt:serviceInfo.name}),wp.element.createElement('span',{'class':'name'},Object(__WEBPACK_IMPORTED_MODULE_12__wordpress_i18n__["__"])(serviceInfo.name,'cec-plugin-stores')))),wp.element.createElement('div',{'class':'modal fade',id:'icon-service-modal-'+serviceInfo.id,tabindex:'-1',role:'dialog','aria-labelledby':'icon-service-modalTitle','aria-hidden':'true'},wp.element.createElement('div',{'class':'modal-dialog modal-dialog-centered',role:'document'},wp.element.createElement('div',{'class':'modal-content'},wp.element.createElement('div',{'class':'modal-header border-0'},wp.element.createElement('button',{'class':'text-navy close',type:'button','data-dismiss':'modal','aria-label':'Close'},wp.element.createElement('span',{'class':'text-navy','aria-hidden':'true'},'\xD7'))),wp.element.createElement('div',{'class':'modal-body px-5 pb-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-3'},wp.element.createElement('img',{style:{width:'100%'},src:serviceInfo.image,alt:serviceInfo.name,id:'service-image'})),wp.element.createElement('div',{'class':'col-9'},wp.element.createElement('h6',{'class':'h4 text-navy mb-4',id:'service-name'},serviceInfo.name),wp.element.createElement('p',{'class':'h6 fw-300 text-font text-justify',id:'service-desc'},serviceInfo.desc))))))));})));})));}}]);return ServiceUs;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var ServiceUsEditor=function(_Component2){_inherits(ServiceUsEditor,_Component2);function ServiceUsEditor(){_classCallCheck(this,ServiceUsEditor);return _possibleConstructorReturn(this,(ServiceUsEditor.__proto__||Object.getPrototypeOf(ServiceUsEditor)).apply(this,arguments));}_createClass(ServiceUsEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return ServiceUsEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MemberCobrandedcard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG.Locale');var isLogin=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.auth.isLogin');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane;// 前端頁面
var MemberCobrandedcard=function(_Component){_inherits(MemberCobrandedcard,_Component);function MemberCobrandedcard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MemberCobrandedcard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MemberCobrandedcard.__proto__||Object.getPrototypeOf(MemberCobrandedcard)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this.state={query:{},listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],tableData_Detail:[],selectmonth:__WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true// ALVIN 2023/05/05 調整為CC登入
},_this.GetCCUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/cc/login',{},function(state,res){console.log(state,res);var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){_this.setState({isSubmitData:false});return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);// 改為前往CC登入頁面
// this.GoCCLoginPage(data.uri)
_this.setState({isSubmitData:false});_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GoCCLoginPage=function(ccApiUrl){__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(ccApiUrl,{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GetOcaUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/login',{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_10__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.control=function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).on('show.bs.collapse','.tbody .order-detail-info',function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.order-detail-info').removeClass('show');//$(this).addClass('show');
});});},_this.clickgetdetail=function(){var ID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';console.log('555555555555555555',ID);_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/purchaseDetail',{pur_id:ID},function(state,res){var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData_Detail:data.purchaseDetail,isLoading:false},function(){_this.refreshPicker();});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'area_id')};}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_temp),_possibleConstructorReturn(_this,_ret);}// 2023/05/05 取得並前往 CC Login Url
_createClass(MemberCobrandedcard,[{key:'componentDidMount',value:function componentDidMount(){var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(lastDay).format('YYYY-MM-DD')// AppHelper.updateConfig()
};this.setState({query:query});this.control();// var swiper = new Swiper('.swiper-memberCard', {
//   spaceBetween: 10,
//   loop: true,
//   slidesPerView: 'auto',
//   centeredSlides: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   pagination: { el: '.swiper-pagination' },
//   breakpoints: { 767: { spaceBetween: 0 } },
// });
}},{key:'render',value:function render(){var _this2=this;var isLogin=this.props.auth.isLogin;var $query=void 0;if(isLogin){$query=wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:VC_CONFIG.INDEX_URL+'/payment'},'\u7ACB\u5373\u67E5\u8A62');}else{$query=wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(){// ALVIN 2023/05/05 調整為CC Login
// this.GetOcaUri();
_this2.GetCCUri();}},'\u7ACB\u5373\u67E5\u8A62');}return wp.element.createElement('div',null,wp.element.createElement('p',null),wp.element.createElement('p',null),wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:'[index]'},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:'#'},'\u6703\u54E1\u6B0A\u76CA')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u95DC\u65BC\u806F\u540D\u5361')))),wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u5361\u53CB\u512A\u60E0\u8AAA\u660E'))),wp.element.createElement('div',{'class':'basic-tabs-label mb-5'},wp.element.createElement('ul',{id:'pills-tab','class':'nav nav-pills'},wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:'[index]/member-hkcard'},'\u95DC\u65BC\u597D\u5EB7\u5361')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:'[index]/member-vip'},'\u95DC\u65BC VIP')),wp.element.createElement('li',{'class':'nav-item current_page_item highlight'},wp.element.createElement('a',{'class':'nav-link',href:'[index]/member-cobrandedcard'},'\u95DC\u65BC\u806F\u540D\u5361')))),wp.element.createElement('div',{className:'container'},wp.element.createElement('section',null,wp.element.createElement('div',{className:'row align-items-center justify-content-center'},wp.element.createElement('div',{className:'col-md-6 col-lg-5 mx-auto'},wp.element.createElement('div',{className:'swiper-container swiper-memberCard'},wp.element.createElement('div',{className:'swiper-wrapper'},wp.element.createElement('div',{className:'swiper-slide'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/card.png',alt:''})),wp.element.createElement('div',{className:'swiper-slide'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/card2.png',alt:''}))),wp.element.createElement('div',{className:'swiper-pagination'}))),wp.element.createElement('div',{className:'col-lg-5 my-lg-0 my-5'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement('h4',{className:'h4 title-theme-1 text-navy mb-4'},'\u7389\u5C71\u60A0\u904A\u806F\u540D\u5361'),wp.element.createElement('h5',{className:'h6 text-danger my-5'},'\u5929\u5929\u90FD\u512A\u60E0 \u597D\u5EB7\u591A\u66F4\u591A',wp.element.createElement('br',null),'\u5E74\u5E74\u6709\u6D88\u8CBB \u5E74\u5E74\u514D\u5E74\u8CBB',wp.element.createElement('br',null),'\u60A0\u904A\u5361/icash\u5361\u8D85\u65B9\u4FBF \u611F\u61C9\u5237\u5361\u514D\u7C3D\u540D'),wp.element.createElement('p',{className:'note text-navy mb-0'},'\u7ACB\u5373\u7DDA\u4E0A\u7533\u8FA6'),wp.element.createElement('div',{className:'row justify-content-center mt-3'},wp.element.createElement('div',{className:'col-8 col-md-5'},wp.element.createElement('a',{className:'h6 mb-0 btn btn-lg btn-block btn-outline-primary rounded-pill mb-md-0 mb-3',role:'button',href:'https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0024&param=APYCRD0024,,,,F000000000,,HO,,,,e#b',target:'_blank',rel:'noopener noreferrer'},'\u60A0\u904A\u806F\u540D\u5361')),wp.element.createElement('div',{className:'col-8 col-md-5'},wp.element.createElement('a',{className:'h6 mb-0 btn btn-lg btn-block btn-outline-primary rounded-pill mb-md-0 mb-3',role:'button',href:'https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0041&param=APYCRD0041,,,,F000000000,,HO,,,,e#b',target:'_blank',rel:'noopener noreferrer'},'icash\u806F\u540D\u5361'))))))),wp.element.createElement('section',{className:'pb-0'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement('h4',{className:'heading-title align-items-center'},'\u6D88\u8CBB\u7686\u53EF\u7D2F\u7A4D\u300C\u9EDE\u6578\u300D\u7D05\u5229\u7121\u9650\u5927'),wp.element.createElement('hr',{className:'border-top border-gray mt-0 mb-4'}),wp.element.createElement('p',{className:'h6 text-font'},'\u6301\u806F\u540D\u5361\u65BC\u5E97\u5167\u6D88\u8CBB\uFF1A\u4E00\u5143\u73FE\u63DB2\u9EDE\u7D05\u5229\u9EDE\u6578\uFF0C\u5E97\u5916\u6D88\u8CBB\uFF1A\u4E00\u5143\u73FE\u63DB1\u9EDE\u7D05\u5229\u9EDE\u6578\uFF0C\u8F15\u9B06\u7D2F\u7A4D\uFF5E',wp.element.createElement('br',null),'\u4F7F\u7528CarrfourPay \u7D81\u5B9A\u7389\u5C71\u806F\u540D\u5361\u652F\u4ED8\uFF0C\u5728\u8CE3\u5834\u5167\u6D88\u8CBB\uFF0C\u4E00\u5143\u73FE\u63DB3\u9EDE\u7D05\u5229\u9EDE\u6578\uFF0C\u4E09\u500D\u597D\u5EB7\u9001\u7D66\u60A8\uFF01'),wp.element.createElement('p',{className:'h6 text-font',style:{color:'red !important'}},'\u203B\u4E0A\u8FF0\u7A4D\u9EDE\u6D3B\u52D5\u9700\u5237\u7389\u5C71\u60A0\u904A\u806F\u540D\u5361\uFF0C\u8A73\u7D30\u6D3B\u52D5\u5167\u5BB9\u8ACB\u898B\u5E97\u5167\u516C\u544A\uFF1B\u56DE\u994B\u9EDE\u6578\u5C0F\u6578\u9EDE\u4EE5\u4E0B\u4E0D\u5217\u5165\u7D2F\u8A08\uFF0C\u7121\u7389\u5C71\u9280\u884C\u7D05\u5229\u9EDE\u6578')),wp.element.createElement('div',{className:'row align-items-center justify-content-center'},wp.element.createElement('div',{className:'col-lg-6 my-5'},wp.element.createElement('div',{className:'row justify-content-center'},wp.element.createElement('div',{className:'col-auto col-lg-5'},wp.element.createElement('div',{className:'whiteSky-block'},wp.element.createElement('h5',{className:'h4 text-primary mb-4'},'\u5E97\u5167\u6D88\u8CBB'),wp.element.createElement('h6',{className:'h4 text-center text-navy m-0 fw-700'},wp.element.createElement('strong',{className:'fw-700 px-1 text-danger'},'1'),'\u5143',wp.element.createElement('strong',{className:'fw-700 px-1 text-danger'},'2'),'\u9EDE'),wp.element.createElement('p',{className:'note text-font mt-4 mb-0'},'\u7D040.66%\u73FE\u91D1\u56DE\u994B'))),wp.element.createElement('div',{className:'col-auto col-lg-5'},wp.element.createElement('div',{className:'whiteSky-block'},wp.element.createElement('h5',{className:'h4 text-primary mb-4'},'\u5E97\u5916\u6D88\u8CBB'),wp.element.createElement('h6',{className:'h4 text-center text-navy m-0 fw-700'},wp.element.createElement('strong',{className:'fw-700 px-1 text-danger'},'1'),'\u5143',wp.element.createElement('strong',{className:'fw-700 px-1 text-danger'},'1'),'\u9EDE'),wp.element.createElement('p',{className:'note text-font mt-4 mb-0'},'\u7D040.33%\u73FE\u91D1\u56DE\u994B'))))))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'row no-gutters mx-n2'},wp.element.createElement('div',{className:'col-sm-6 col-md-4 col-lg px-2 my-3'},wp.element.createElement('div',{className:'row align-items-start my-5 no-gutters mx-n2'},wp.element.createElement('div',{className:'col-3 col-md-4 mx-auto px-2'},wp.element.createElement('div',{className:'px-3'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/icon01.png',alt:''}))),wp.element.createElement('div',{className:'col-9 col-md-8 px-2'},wp.element.createElement('h5',{className:'h5 text-navy mb-3 fw-700'},'\u9EDE\u6578\u8B8A\u73FE\u91D1',wp.element.createElement('br',null),'\u8CFC\u7269\u7701\u6700\u591A'),wp.element.createElement('p',{className:'p fw-300 text-dark mb-4'},'300\u9EDE\u9EDE\u6578\u53EF\u6263\u62B51\u5143\uFF0C\u7279\u9078\u76EE\u9304/\u5E97\u5167\u5546\u54C1\uFF0C\u53EF\u4EAB\u984D\u5916\u9EDE\u6578/\u6703\u54E1\u50F9')))),wp.element.createElement('div',{className:'col-sm-6 col-md-4 col-lg px-2 my-3'},wp.element.createElement('div',{className:'row align-items-start my-5 no-gutters mx-n2'},wp.element.createElement('div',{className:'col-3 col-md-4 mx-auto px-2'},wp.element.createElement('div',{className:'px-3'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/icon02.png',alt:''}))),wp.element.createElement('div',{className:'col-9 col-md-8 px-2'},wp.element.createElement('h5',{className:'h5 text-navy mb-3 fw-700'},'\u5361\u53CB\u7368\u4EAB',wp.element.createElement('br',null),'\u5206\u671F0\u5229\u7387'),wp.element.createElement('p',{className:'p fw-300 text-dark mb-4'},'\u5168\u570B\u8CE3\u5834\u5167\u6D88\u8CBB\u6EFF\u984D\u4EAB3~12\u671F\u5206\u671F\u4ED8\u6B3E0\u5229\u7387\uFF0C\u7279\u5B9A\u5546\u54C1\u53EF\u4EAB24\u621630\u671F\u5206\u671F\u4ED8\u6B3E0\u5229\u7387'),wp.element.createElement('p',{className:'p fw-300 text-dark mb-4',style:{color:'red !important'}},'\u203B\u5E97\u5167\u5206\u671F\u6D88\u8CBB\u4ECD\u53EF\u7D2F\u7A4D\u7D05\u5229\u9EDE\u6578',wp.element.createElement('br',null),'\u203B\u6D3B\u52D5\u8A73\u60C5\u53CA\u6CE8\u610F\u4E8B\u9805\u8ACB\u6D3D\u5168\u570B\u9580\u5E02')))),wp.element.createElement('div',{className:'col-sm-6 col-md-4 col-lg px-2 my-3'},wp.element.createElement('div',{className:'row align-items-start my-5 no-gutters mx-n2'},wp.element.createElement('div',{className:'col-3 col-md-4 mx-auto px-2'},wp.element.createElement('div',{className:'px-3'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/icon03.png',alt:''}))),wp.element.createElement('div',{className:'col-9 col-md-8 px-2'},wp.element.createElement('h5',{className:'h5 text-navy mb-3 fw-700'},'eTag\u81EA\u52D5\u5132\u503C',wp.element.createElement('br',null),'\u570B\u9053\u901A\u884C\u771F\u9806\u66A2'),wp.element.createElement('p',{className:'p fw-300 text-dark mb-4'},'\u9023\u7D50eTag\u9810\u5132\u5E33\u6236\uFF0C\u9918\u984D\u4F4E\u65BC120\u5143\u81EA\u52D5\u5132\u503C400\u5143( \u6216\u5176\u500D\u6578 )\u514D\u624B\u7E8C\u8CBB\u3001\u514D\u7169\u60F1\u3001\u570B\u9053\u901A\u884C\u4E00\u8DEF\u9806\u66A2')))),wp.element.createElement('div',{className:'col-sm-6 col-md-4 col-lg px-2 my-3'},wp.element.createElement('div',{className:'row align-items-start my-5 no-gutters mx-n2'},wp.element.createElement('div',{className:'col-3 col-md-4 mx-auto px-2'},wp.element.createElement('div',{className:'px-3'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/coBrand/icon04.png',alt:''}))),wp.element.createElement('div',{className:'col-9 col-md-8 px-2'},wp.element.createElement('h5',{className:'h5 text-navy mb-3 fw-700'},'\u60A0\u904A\u5361\u8D85\u65B9\u4FBF',wp.element.createElement('br',null),'\u611F\u61C9\u5237\u5361\u514D\u7C3D\u540D'),wp.element.createElement('p',{className:'p fw-300 text-dark mb-4'},'\u8D85\u904E\u842C\u5BB6\u60A0\u904A\u5361\u5C0F\u984D\u652F\u4ED8\u7279\u5E97\uFF0C\u514D\u5E36\u96F6\u9322\u8F15\u9B06\u4ED8\u6B3E\u611F\u61C9\u5F0F\u4EA4\u6613\uFF0C\u514D\u5237\u5361\u3001\u514D\u7C3D\u540D\u3001\u4FBF\u5229\u53C8\u5FEB\u901F')))))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('h4',{className:'heading-title align-items-center'},'\u7389\u5C71\u60A0\u904ADebit\u5361'),wp.element.createElement('hr',{className:'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{className:'row align-items-center justify-content-center'},wp.element.createElement('div',{className:'col-lg-6'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-md-6 col-lg-10 mx-auto'},wp.element.createElement('img',{className:'img-fluid',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-coBrand2.png',alt:''})))),wp.element.createElement('div',{className:'col-lg-5 my-lg-0 my-5'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement('h4',{className:'h4 title-theme-1 text-navy mb-4'},'\u4E00\u5F35\u5E6B\u6211\u8CFA\u9322\u7684\u5361'),wp.element.createElement('h5',{className:'h6 text-primary mb-4'},'1.\u7C3D\u5E33\u6D88\u8CBB\uFF1A\u570B\u5167\u5916\u90FD\u80FD\u5237\u3001\u66F4\u6709\u6548\u7BA1\u7406\u5E33\u6236',wp.element.createElement('br',null),'2.\u91D1\u878D\u5361\u63D0\u6B3E\u3001\u5B58\u6B3E\u8207\u8F49\u5E33\uFF1A\u63D0\u6B3E\u3001\u8F49\u5E33\u771F\u4FBF\u5229'),wp.element.createElement('p',{className:'note text-dark mb-3'},'\u9996\u5237\u55AE\u7B46\u6EFF\u984D\u8D08\u300C\u7D05\u5229\u9EDE\u65783\u842C\u9EDE\u300D',wp.element.createElement('br',null),'\uFF08\u9996\u6B21\u7533\u8FA6\u7389\u5C71\u60A0\u904ADebit\u5361\uFF0C\u4E14\u7559email\uFF0C\u6838\u5361\u5F8C45\u5929\u5167\u65BC\u5E97\u5167\uFF0C\u55AE\u7B46\u5237\u6EFF599\u5143(\u542B)\u4EE5\u4E0A\uFF0C\u8D08\u300C\u7D05\u5229\u9EDE\u65783\u842C\u9EDE\u300D\u3002')),wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-sm-6 mx-auto my-3'},wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'https://www.esunbank.com.tw/bank/personal/credit-card/intro/debit-card/c4-debit-card',target:'_blank',rel:'noopener noreferrer'},'\u6700\u65B0Debit\u5361\u512A\u60E0\u6D3B\u52D5')))))),wp.element.createElement('h4',{className:'heading-title justify-content-center'},'\u7389\u5C71\u806F\u540D\u5361 / Debit\u5361\u5361\u53CB\u512A\u60E0'),wp.element.createElement('hr',{className:'border-top border-gray mt-0 mb-5'}),wp.element.createElement('div',{className:'embed-responsive embed-responsive-16by9 mb-5'},wp.element.createElement('iframe',{className:'embed-responsive-item',title:'embed-responsive-item',src:'https://www.youtube.com/embed/6tbR9uhR35U',frameborder:'0',allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:''})),wp.element.createElement('div',{className:'row align-items-center'},wp.element.createElement('div',{className:'col-lg-12 mb-5'},wp.element.createElement('img',{className:'img-contain',src:'https://testwww.uni-prosperity.com.tw/wp-content/uploads/2020/11/2020DM3_\u5361\u53CB\u8AAA\u660E1401any-4.jpg',alt:''}),wp.element.createElement('button',{style:{backgroundColor:'transparent',width:'12%',height:'2%',position:'absolute',right:'8.5%',bottom:'31%',border:'none',outline:'none',cursor:'pointer'}}))),wp.element.createElement('div',{className:'row my-3 justify-content-center'},wp.element.createElement('div',{className:'col-md-12'},wp.element.createElement('h6',{className:'h5 text-navy text-center mb-4'},'\u6700\u65B0\u512A\u60E0\u6D3B\u52D5')),wp.element.createElement('div',{className:'col-sm-3'},wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'https://www.esunbank.com.tw/bank/personal/credit-card/intro/co-branded-card/c4-card',target:'_blank',rel:'noopener noreferrer'},'\u6700\u65B0\u60A0\u904A\u806F\u540D\u5361\u512A\u60E0\u6D3B\u52D5')),wp.element.createElement('div',{className:'col-sm-3'},wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'https://www.esunbank.com.tw/bank/personal/credit-card/intro/co-branded-card/c4-icash-card',target:'_blank',rel:'noopener noreferrer'},'\u6700\u65B0icash\u806F\u540D\u5361\u512A\u60E0\u6D3B\u52D5'))),wp.element.createElement('section',null,wp.element.createElement('h4',{className:'heading-title align-items-center'},'\u7533\u8FA6\u806F\u540D\u5361\u6703\u54E1'),wp.element.createElement('hr',{className:'border-top border-gray mt-0 mb-5'}),wp.element.createElement('div',{className:'row justify-content-center mb-5'},wp.element.createElement('div',{className:'col-lg-8'},wp.element.createElement('div',{className:'memberCard-step-wrap'},wp.element.createElement('div',{className:'memberCard-step-item'},wp.element.createElement('div',{className:'info'},wp.element.createElement('h6',{className:'h6 text-primary text-center mb-4'},'\u7ACB\u5373\u7DDA\u4E0A\u7533\u8FA6'),wp.element.createElement('div',{className:'px-md-5 px-3'},wp.element.createElement('div',{className:'row justify-content-center mb-4'},wp.element.createElement('div',{className:'col-md-5'},wp.element.createElement('a',{className:'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3',role:'button',href:'https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0024&param=APYCRD0024,,,,F000000000,,HO,,,,e#b',target:'_blank',rel:'noopener noreferrer'},'\u7389\u5C71\u60A0\u904A\u806F\u540D\u5361')),wp.element.createElement('div',{className:'col-md-5'},wp.element.createElement('a',{className:'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3',role:'button',href:'https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0041&param=APYCRD0041,,,,F000000000,,HO,,,,e#b',target:'_blank',rel:'noopener noreferrer'},'\u7389\u5C71icash\u806F\u540D\u5361'))),wp.element.createElement('p',{className:'h6 text-navy text-center mb-0'},'\u63D0\u9192\u60A8\uFF1A\u9EDE\u9078\u5F8C\u5C07\u9032\u5165\u7389\u5C71\u9280\u884C\u4FE1\u7528\u5361\u7DB2\u7AD9')))),wp.element.createElement('div',{className:'memberCard-step-item'},wp.element.createElement('div',{className:'info'},wp.element.createElement('h6',{className:'h6 text-primary text-center mb-4'},'\u5206\u5E97\u81E8\u6AC3\u7533\u8FA6'),wp.element.createElement('div',{className:'px-md-5 px-3'},wp.element.createElement('p',{className:'h6 text-navy mb-4'},'\u651C\u5E36\u500B\u4EBA\u8B49\u4EF6\u3001\u8CA1\u529B\u8B49\u660E\u8207\u8868\u683C\u81F3\u9130\u8FD1\u7684',wp.element.createElement('br',null),'*\u8CA1\u529B\u8B49\u660E\uFF1A\u85AA\u8CC7\u55AE(\u6700\u8FD13\u500B\u6708\u5F71\u672C)\u3001\u5B58\u647A(\u5E33\u865F\u6236\u540D\u5C01\u9762\u53CA\u8FD1\u4E09\u500B\u6708\u5167\u9801\u660E\u7D30)\u7B49\u3002',wp.element.createElement('br',null),'*\u7389\u5C71\u9280\u884C\u4FDD\u7559\u806F\u540D\u5361\u7533\u8ACB\u6838\u51C6\u8207\u5426\u4E4B\u6B0A\u5229\u3002'),wp.element.createElement('p',{className:'h6 text-navy mb-4'},'\u9001\u4EF6\u5F8C\uFF0C\u8CC7\u6599\u9F4A\u5168\u7D04\u4E8C\u81F3\u4E09\u9031\u5373\u6703\u5BC4\u9001\u806F\u540D\u5361\u81F3\u767B\u8A18\u5730\u5740',wp.element.createElement('br',null),'*\u5E97\u5167\u7533\u8FA6\u99AC\u4E0A\u9818\u53D6\u597D\u5EB7\u5361\uFF0C\u8B93\u60A8\u5728\u806F\u540D\u5361\u5BE9\u6838\u671F\u9593\uFF0C\u4E0D\u932F\u5931\u96C6\u9EDE\u6A5F\u6703\uFF01\u99AC\u4E0A\u7A4D\u9EDE\uFF0C\u9EDE\u6578\u8B8A\u73FE\u91D1\uFF01'),wp.element.createElement('p',null,wp.element.createElement('a',{className:'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill',role:'button',href:VC_CONFIG.INDEX_URL+'/stores'},'\u67E5\u8A62\u5206\u5E97\u4F4D\u7F6E')))))))),wp.element.createElement('div',{className:'card card-storeInfo shadow-0 card-border-width-1 rounded-20 h-100'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'row align-items-center justify-content-center'},wp.element.createElement('div',{className:'col-8 col-md-3 mx-md-0 mx-auto'},wp.element.createElement('img',{className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/credit_card2.svg',alt:''})),wp.element.createElement('div',{className:'col-md-auto'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement('h5',{className:'h4 text-navy my-4 fw-700'},'\u67E5\u8A62\u6703\u54E1\u5361\u9EDE\u6578'),wp.element.createElement('p',{className:'p text-font mb-5'},'\u5DF2\u7D93\u662F\u6703\u54E1\u4E86\u55CE\uFF1F \u7ACB\u5373\u7D81\u5B9A\u5361\u7247\uFF0C\u67E5\u8A62\u9EDE\u6578\u597D\u8F15\u9B06\uFF01'),wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-md-9 col-6 mx-auto'},$query))))))))),wp.element.createElement('p',null)),wp.element.createElement('p',null),wp.element.createElement('p',null));}}]);return MemberCobrandedcard;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MemberCobrandedcard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG.Locale');var isLogin=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.auth.isLogin');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_5_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_3_antd_lib_tabs___default.a.TabPane;// 前端頁面
var MemberCobrandedcard=function(_Component){_inherits(MemberCobrandedcard,_Component);function MemberCobrandedcard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MemberCobrandedcard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MemberCobrandedcard.__proto__||Object.getPrototypeOf(MemberCobrandedcard)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this.state={query:{},listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo),tableData:[],tableData_Detail:[],selectmonth:__WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('month').format('YYYY-MM-DD'),isLoading:true// ALVIN 2023/05/05 調整為CC登入
},_this.GetCCUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/account/cc/login',{},function(state,res){console.log(state,res);var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){_this.setState({isSubmitData:false});return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.GoCCLoginPage(data.uri);});},_this.GoCCLoginPage=function(ccApiUrl){__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(ccApiUrl,{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.control=function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(document).on('show.bs.collapse','.tbody .order-detail-info',function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.order-detail-info').removeClass('show');//$(this).addClass('show');
});});},_this.clickgetdetail=function(){var ID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';console.log('555555555555555555',ID);_this.setState({isLoading:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/account/purchaseDetail',{pur_id:ID},function(state,res){var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData_Detail:data.purchaseDetail,isLoading:false},function(){_this.refreshPicker();});});},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(data,'area_id')};}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_temp),_possibleConstructorReturn(_this,_ret);}// 2023/05/05 取得並前往 CC Login Url
_createClass(MemberCobrandedcard,[{key:'GetOcaUri',value:function GetOcaUri(){var _this2=this;this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/account/oca/login',{},function(state,res){console.log(state,res);_this2.setState({isSubmitData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this2.setState({LoginUrl:data.uri});window.location.href=data.uri;});}},{key:'componentDidMount',value:function componentDidMount(){var date=new Date(),y=date.getFullYear(),m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_7_moment___default()(lastDay).format('YYYY-MM-DD')// AppHelper.updateConfig()
};this.setState({query:query});this.control();// var swiper = new Swiper('.swiper-memberCard', {
//   spaceBetween: 10,
//   loop: true,
//   slidesPerView: 'auto',
//   centeredSlides: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   pagination: { el: '.swiper-pagination' },
//   breakpoints: { 767: { spaceBetween: 0 } },
// });
}},{key:'render',value:function render(){var _this3=this;var isLogin=this.props.auth.isLogin;var $query=void 0;if(isLogin){$query=wp.element.createElement('a',{'class':'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:VC_CONFIG.INDEX_URL+'/payment'},'\u7ACB\u5373\u67E5\u8A62');}else{$query=wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#',onClick:function onClick(){// ALVIN 2023/05/05 調整CC Login
// this.GetOcaUri()
_this3.GetCCUri();}},'\u7ACB\u5373\u67E5\u8A62');}return wp.element.createElement('div',null,wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL},'\u9996\u9801')),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:'#'},'\u6703\u54E1\u6B0A\u76CA')),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},'\u95DC\u65BC\u597D\u5EB7\u5361')))),wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u5361\u53CB\u512A\u60E0\u8AAA\u660E'))),wp.element.createElement('div',{'class':'basic-tabs-label mb-5'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':'nav-item current_page_item highlight'},wp.element.createElement('a',{'class':'nav-link active',href:VC_CONFIG.INDEX_URL+'/member-hkcard'},'\u95DC\u65BC\u597D\u5EB7\u5361')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/member-VIP'},'\u95DC\u65BC VIP')),wp.element.createElement('li',{'class':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:VC_CONFIG.INDEX_URL+'/member-cobrandedcard'},'\u95DC\u65BC\u806F\u540D\u5361')))),wp.element.createElement('div',{'class':'container'},wp.element.createElement('section',null,wp.element.createElement('div',{'class':'row align-items-center justify-content-center'},wp.element.createElement('div',{'class':'col-lg-6'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-6 col-lg-10 mx-auto'},wp.element.createElement('div',{'class':'swiper-container swiper-memberCard'},wp.element.createElement('div',{'class':'swiper-wrapper'},wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-discount.png',alt:'\u597D\u5EB7\u5361'})),wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-discount.png',alt:'\u597D\u5EB7\u5361'})),wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/card-discount.png',alt:'\u597D\u5EB7\u5361'}))),wp.element.createElement('div',{'class':'swiper-pagination'}))))),wp.element.createElement('div',{'class':'col-lg-4 my-lg-0 my-5'},wp.element.createElement('div',{'class':'text-center'},wp.element.createElement('h4',{'class':'h4 title-theme-1 text-navy mb-4'},'\u4E00\u5F35\u5E6B\u6211\u8CFA\u9322\u7684\u5361'),wp.element.createElement('h5',{'class':'h6 text-danger mb-3'},'\u4E00\u51431\u9EDE\uFF0C\u7D05\u5229\u7121\u9650\u5927'),wp.element.createElement('p',{'class':'note text-font mb-3'},'\u514D\u8CBB\u7533\u8ACB\u597D\u5EB7\u5361\uFF0C\u7ACB\u5373\u7533\u8FA6\u7ACB\u5373\u7D2F\u7A4D\u7D05\u5229\u9EDE\u6578\uFF0C \u6B21\u65E5\u8CFC\u7269\u51FA\u793A\u6703\u54E1\u5361\u53EF\u4EAB\u9EDE\u6578\u6298\u62B5\u6D88\u8CBB\u91D1\u984D\uFF0C\u8CFC\u7269\u7701\u6700\u591A\uFF01',wp.element.createElement('span',{'class':'text-navy d-block mt-4 fw-500'},'\u514D\u8CBB\u7533\u8ACB\uFF0C\u7ACB\u5373\u767C\u5361\uFF1B\u99AC\u4E0A\u7A4D\u9EDE\uFF0C\u9EDE\u6578\u8B8A\u73FE\u91D1')))))),wp.element.createElement('h4',{'class':'heading-title justify-content-center'},'\u597D\u5EB7\u5361\u5C08\u5C6C\u798F\u5229'),wp.element.createElement('hr',{'class':'border-top border-gray m-0'}),wp.element.createElement('section',{'class':'pt-5'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon01.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u514D\u8CBB\u7533\u8FA6\u6703\u54E1\u5361'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u5E74\u6EFF16\u6B72\u5373\u53EF\u99AC\u4E0A\u7533\u8FA6'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon02.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u751F\u65E5\u9EDE\u6578\u98C6\u8CFA',wp.element.createElement('strong',{'class':'fw-700 px-1 text-danger'},'20'),'\u500D'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u751F\u65E5\u7576\u5929\u4EE5\u6700\u9AD8\u7D50\u5E33\u91D1\u984D\u8D0820\u500D (\u5DF2\u542B\u539F\u672C1\u500D)\uFF0C\u6700\u9AD8\u8D08100\u842C\u9EDE **\u9EDE\u6578\u65BC48\u5C0F\u6642\u5F8C\u81EA\u52D5\u5165\u5E33'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon03.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},wp.element.createElement('strong',{'class':'fw-700 px-1 text-danger'},'1'),'\u5143\u7D2F\u7A4D',wp.element.createElement('strong',{'class':'fw-700 px-1 text-danger'},'1'),'\u9EDE'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u6D88\u8CBB\u6BCF1\u5143\u90FD\u80FD\u7D2F\u7A4D\u7D05\u5229\u9EDE\u6578'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon04.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},wp.element.createElement('strong',{'class':'fw-700 px-1 text-danger'},'100%'),'\u9EDE\u6578\u8B8A\u73FE\u91D1'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u6191\u5361\u53EF\u4EE5300\u9EDE\u62981\u5143\uFF0C\u6298\u62B5\u7121\u4E0A\u9650'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon05.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u9EDE\u6578\u7D42\u751F\u6709\u6548'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u6BCF\u5E74\u6301\u5361\u6D88\u8CBB1\u6B21\uFF0C\u9EDE\u6578\u7D42\u751F\u6709\u6548'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon06.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u7279\u5B9A\u5546\u54C1\u98C6\u9EDE\u6578'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u8CFC\u8CB7\u6307\u5B9A\u5546\u54C1\u518D\u591A\u8CFA\u9EDE\u6578'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon07.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u96FB\u5B50\u767C\u7968\u4E2D\u734E\u901A\u77E5'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u4E2D\u734E\u767C\u7968\uFF0C\u4E3B\u52D5\u901A\u77E5\u60A8'))),wp.element.createElement('div',{'class':'col-sm-4 col-md-3 px-2 my-3'},wp.element.createElement('div',{'class':'d-flex flex-column px-md-4'},wp.element.createElement('div',{'class':'row my-5'},wp.element.createElement('div',{'class':'col-3 col-md-5 col-lg-4 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/discount/icon08.png',alt:''}))),wp.element.createElement('h5',{'class':'h5 text-center text-navy my-4 fw-700'},'\u9A5A\u7206\u6703\u54E1\u50F9\u5546\u54C1'),wp.element.createElement('p',{'class':'note fw-300 text-dark text-center mb-0'},'\u591A\u6A23\u7A2E\u985E\u5546\u54C1\u8CB7\u5230\u8D85\u5212\u7B97'))))),wp.element.createElement('section',{'class':'pt-0'},wp.element.createElement('div',{'class':'banner-with-text'},wp.element.createElement('div',{'class':'img-4-1 d-flex align-items-center bg-sea rounded-20'},wp.element.createElement('div',{'class':'row align-items-center px-lg-5 p-4'},wp.element.createElement('div',{'class':'col-lg-4 d-flex justify-content-center d-lg-block'},wp.element.createElement('img',{'class':'img-fluid',src:'/wp-content/themes/cec/assets/img/membercard/successful_purchase.svg',alt:''})),wp.element.createElement('div',{'class':'col-lg-8'},wp.element.createElement('div',{'class':'bg-white p-lg-5 py-4 px-5 rounded text-block-inner'},wp.element.createElement('h6',{'class':'h5 text-navy mb-4'},'\u6703\u54E1\u8CFC\u7269\u7701\u66F4\u591A'),wp.element.createElement('p',{'class':'p text-dark'},'\u6301\u6703\u54E1\u5361\u65BC\u5E97\u5167\u6D88\u8CBB1\u5143\u53EF\u4EAB1\u9EDE\u7D05\u5229\u9EDE\u6578\u57FA\u672C\u56DE\u994B\uFF0C\u66F4\u53EF\u4EAB\u6709\u5C08\u5C6C\u6703\u54E1\u50F9\u5546\u54C1\u3001\u6307\u5B9A\u5546\u54C1\u591A\u8CFA\u9EDE\u6578\uFF0C\u4E0D\u5B9A\u671F\u5E97\u5167\u6703\u54E1\u5C08\u5C6C\u6D3B\u52D5(\u5982\u62BD\u734E\u3001\u597D\u5EB7\u512A\u60E0\u5238\u7B49\u7B49)\uFF0C\u8B93\u60A8\u6BCF1\u584A\u9322\u90FD\u82B1\u5F97\u7269\u8D85\u6240\u503C\uFF01'))))))),wp.element.createElement('h4',{'class':'heading-title align-items-center'},'\u7ACB\u5373\u52A0\u5165'),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-3'}),wp.element.createElement('p',{'class':'p text-font text-center mb-5'},'\u5C08\u5C6C\u6703\u54E1\u50F9\uFF0C\u9EDE\u6578\u8B8A\u73FE\u91D1'),wp.element.createElement('section',{'class':'pt-0'},wp.element.createElement('div',{'class':'row justify-content-center mb-5'},wp.element.createElement('div',{'class':'col-lg-8'},wp.element.createElement('div',{'class':'memberCard-step-wrap'},wp.element.createElement('div',{'class':'memberCard-step-item'},' ',wp.element.createElement('span',{'class':'num'},' ',wp.element.createElement('b',null,'1')),wp.element.createElement('div',{'class':'info'},wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-4'},'\u8A73\u95B1\u7533\u8ACB\u689D\u6B3E\u53CA\u7D30\u5247'),wp.element.createElement('div',{'class':'px-md-5 pl-5 pr-0'},wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-md-4'},wp.element.createElement('a',{'class':'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3',role:'button',href:VC_CONFIG.INDEX_URL+'/member-clause'},'\u689D\u6B3E\u8207\u7D30\u5247')),wp.element.createElement('div',{'class':'col-md-4'},wp.element.createElement('a',{'class':'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3',role:'button',href:VC_CONFIG.INDEX_URL+'/membercard-partnerslist'},'\u7279\u7D04\u5408\u4F5C\u5EE0\u5546\u540D\u55AE')))))),wp.element.createElement('div',{'class':'memberCard-step-item'},' ',wp.element.createElement('span',{'class':'num'},' ',wp.element.createElement('b',null,'2')),wp.element.createElement('div',{'class':'info'},wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-4'},'\u958B\u59CB\u7533\u8FA6\u597D\u5EB7\u5361'),wp.element.createElement('div',{'class':'px-md-5 pl-5 pr-0'},wp.element.createElement('div',{'class':'row justify-content-between mb-4'},wp.element.createElement('div',{'class':'col-auto'},wp.element.createElement('p',{'class':'h6 text-navy mb-md-0 mb-3'},'\u651C\u5E36\u500B\u4EBA\u8B49\u4EF6\u81F3\u9130\u8FD1\u7684')),wp.element.createElement('div',{'class':'col-md-4'},wp.element.createElement('a',{'class':'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill',role:'button',href:VC_CONFIG.INDEX_URL+'/stores'},'\u67E5\u8A62\u5206\u5E97\u4F4D\u7F6E'))),wp.element.createElement('div',{'class':'row justify-content-between'},wp.element.createElement('div',{'class':'col-auto'},wp.element.createElement('p',{'class':'h6 text-navy mb-md-0 mb-3'},'\u7DDA\u4E0A\u7533\u8ACB\u597D\u5EB7\u5361')),wp.element.createElement('div',{'class':'col-md-4'},wp.element.createElement('a',{'class':'h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill',role:'button',href:VC_CONFIG.INDEX_URL+'/membercard-application'},'\u7ACB\u5373\u7533\u8ACB')))))),wp.element.createElement('div',{'class':'memberCard-step-item'},' ',wp.element.createElement('span',{'class':'num'},' ',wp.element.createElement('b',null,'3')),wp.element.createElement('div',{'class':'info'},wp.element.createElement('h6',{'class':'h6 text-primary text-center mb-4'},'\u99AC\u4E0A\u9818\u53D6\u597D\u5EB7\u5361'),wp.element.createElement('div',{'class':'px-md-5 pl-5 pr-0'},wp.element.createElement('p',{'class':'h6 text-navy mb-0'},'\u7ACB\u5373\u6D88\u8CBB\u5373\u53EF\u958B\u59CB\u7D2F\u7A4D\u9EDE\u6578\uFF0C\u9EDE\u6578\u65BC\u6B21\u65E5\u8CFC\u7269\u59CB\u53EF\u6298\u62B5\uFF0C\u6298\u62B5\u7121\u4E0A\u9650\uFF0C\u8CFC\u7269\u7701\u6700\u591A\u3002'))))))),wp.element.createElement('div',{'class':'card card-storeInfo shadow-0 card-border-width-1 rounded-20 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'row align-items-center justify-content-center'},wp.element.createElement('div',{'class':'col-8 col-md-3 mx-md-0 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/credit_card2.svg',alt:''})),wp.element.createElement('div',{'class':'col-md-auto'},wp.element.createElement('div',{'class':'text-center'},wp.element.createElement('h5',{'class':'h4 text-navy my-4 fw-700'},'\u67E5\u8A62\u6703\u54E1\u5361\u9EDE\u6578'),wp.element.createElement('p',{'class':'p text-dark mb-5'},'\u5DF2\u7D93\u662F\u6703\u54E1\u4E86\u55CE\uFF1F \u7ACB\u5373\u7D81\u5B9A\u5361\u7247\uFF0C\u67E5\u8A62\u9EDE\u6578\u597D\u8F15\u9B06\uFF01'),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-9 col-6 mx-auto'},$query)))))))))));}}]);return MemberCobrandedcard;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NewsInfoEditor", function() { return NewsInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_module_scss__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultListInfo={"current":1,//目前頁數
"page_size":10,//一頁幾筆
"total":1,//以此query條件，總共幾筆資料
"rows":[]// 前端頁面
};var NewsInfo=function(_Component){_inherits(NewsInfo,_Component);function NewsInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsInfo.__proto__||Object.getPrototypeOf(NewsInfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={newsInfo:{images:[]},data:[],loading:false,hasMore:true},_this.loadData=function(){var search=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_14_query_string___default.a.parse(search);var id=queryParams.id;console.log('bb',queryParams);if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+('/api/v1/news/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/news');return;}_this.setState({newsInfo:data});_this.handleInfiniteOnLoad();});},_this.handleInfiniteOnLoad=function(page){var newsInfo=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this.state,'newsInfo');_this.setState({loading:true});setTimeout(function(){var data=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(newsInfo,'images'),0,data.length+1);console.log('handleInfiniteOnLoad',page,data,newData);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsInfo,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}// 抓取頁面資訊
},{key:'render',value:function render(){var _state$newsInfo=this.state.newsInfo,newsInfo=_state$newsInfo===undefined?{}:_state$newsInfo;var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});var category_ids=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props,'category_ids',[]);var pdf=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(newsInfo,'pdfs.0');return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('h2',{'class':'card-title'},newsInfo.name),wp.element.createElement('div',{className:'col-md-12 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button'},wp.element.createElement('div',{'class':'img-2-1 card-img-top',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(newsInfo,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'title-head'},wp.element.createElement('h2',{'class':'card-title'},newsInfo.name),wp.element.createElement('span',{'class':'date'},newsInfo.start_date,'-',newsInfo.end_date)),wp.element.createElement('p',{'class':'card-text'},newsInfo.desc)))),wp.element.createElement('section',{'class':'pt-md-5'},pdf&&wp.element.createElement('a',{href:pdf,target:'_blank'},' ',Object(__WEBPACK_IMPORTED_MODULE_20__wordpress_i18n__["__"])('PDF下載','cec-plugin-stores')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a,{grid:{gutter:16,xs:1,sm:1,md:2,lg:2,xl:2,xxl:2},dataSource:this.state.data,renderItem:function renderItem(imageInfo,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_list___default.a.Item,{key:idx},wp.element.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(imageInfo,'url'),alt:'\u76EE\u9304',style:{width:'100%'}}));}},this.state.loading&&this.state.hasMore&&wp.element.createElement('div',{className:'demo-loading-container'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,null)))))));}}]);return NewsInfo;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var NewsInfoEditor=function(_Component2){_inherits(NewsInfoEditor,_Component2);function NewsInfoEditor(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,NewsInfoEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=NewsInfoEditor.__proto__||Object.getPrototypeOf(NewsInfoEditor)).call.apply(_ref2,[this].concat(args))),_this2),_this2.formRef=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef(),_this2.state={listInfo:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(defaultListInfo)},_this2.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(_this2,'props.match.params.id');if(!id)return;_this2.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+('/api/v1/news/'+id),null,function(state,res){_this2.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.warning(reason);_this2.props.history.replace('/news');return;}_this2.fillData(data);});},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(NewsInfoEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].updateConfig();}// 抓取頁面資訊
},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u5167\u5BB9'));}}]);return NewsInfoEditor;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NewsListEditor", function() { return NewsListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_module_scss__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_libs_FormHelper__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Locale=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG');var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var NewsMode={Banner:1,// 首頁大版位Banner 前5則
Carousel:2,// 首頁中版位Banner 前5則
List:3,// 首頁圖文清單  前5則
TextOnlyList:4,// 首頁文字清單 前5則 （最新消息、重要公告）
Table:5,// 文字清單包含分頁
Grid:6,// 圖文清單
ByQuery:7,// 依據URL Query決定
Grid2:8,// 購物中心圖文清單，會依照個數變換顯示
News:9,// 最新消息/news內頁
shopping:10,//美食購物Banner 取第一筆
Life:11// 生活專欄/life內頁
};function isMobile(){var mobileDevices=['Android','iPhone','iPad'];return mobileDevices.some(function(device){return navigator.userAgent.match(device);});}var swiper55=null;var swiper128=null;var swiper132=null;var tabList=[{name:'品酒初學',bannerImg:VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/banner5.jpg'},{name:'夯品開箱',bannerImg:VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/banner2.jpg'},{name:'美好生活',bannerImg:VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/banner3.jpg'},{name:'健康樂活',bannerImg:VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/banner6.jpg'}];// 前端頁面
var NewsList=function(_Component){_inherits(NewsList,_Component);function NewsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsList.__proto__||Object.getPrototypeOf(NewsList)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'',cname:'品酒初學',listInfo:{},categoryList:[]},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_12_jquery___default()(document).off('click','#Banner-M div a').on('click','#Banner-M div a',function(){var $text=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).attr('alt');dataLayer.push({event:'Banner-M_click',item:$text});});__WEBPACK_IMPORTED_MODULE_12_jquery___default()(document).off('click','#List ul li a').on('click','#List ul li a',function(){var $text=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).attr('alt');dataLayer.push({event:'news_click',item:$text});});__WEBPACK_IMPORTED_MODULE_12_jquery___default()(document).off('click','#TextOnlyList ul li a').on('click','#TextOnlyList ul li a',function(){var $text=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).attr('alt');dataLayer.push({event:'news_click',item:$text});});__WEBPACK_IMPORTED_MODULE_12_jquery___default()(document).on('click','#Banner div iframe',function(){var $text=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).attr('alt');dataLayer.push({event:'Banner_youtube_click',item:$text});});},_this.fetchCategoryList=function(){var mode=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this,'props.mode');// 只有購物中心要處理
if([NewsMode.Grid2].indexOf(mode)<0){return;}__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/v1/news',{page:1,page_size:'all'},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200)return;_this.setState({categoryList:data.rows},function(){var categoryList=_this.state.categoryList;if(mode===NewsMode.Grid2){var category55=categoryList.filter(function(c){return c.category_id===55;});//活動快訊
var category128=categoryList.filter(function(c){return c.category_id===128;});//新櫃登場
var category132=categoryList.filter(function(c){return c.category_id===132;});//期間限定
if(category55.length===0){document.querySelector('.category55').style.display='none';}else{document.querySelector('.category55').style.display='block';_this.reloadSwiperShoppingMall55();}if(category128.length===0){document.querySelector('.category128').style.display='none';}else{document.querySelector('.category128').style.display='block';_this.reloadSwiperShoppingMall128();}if(category132.length===0){document.querySelector('.category132').style.display='none';}else{document.querySelector('.category132').style.display='block';_this.reloadSwiperShoppingMall132();}var categoryIgList=categoryList.filter(function(c){return c.category_id===(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]==='https://testwww.uni-prosperity.com.tw/console'?128:131);});var igListSorted=categoryIgList.filter(function(c){return c.status;}).sort(function(a,b){return Math.abs(Date.parse(new Date())-Date.parse(a.start_date))-Math.abs(Date.parse(new Date())-Date.parse(b.start_date));});console.log('igListSorted',igListSorted);if(igListSorted[0]){var igEmbedCode=igListSorted[0].ig;var igWrapperEl=document.querySelector('.ig-wrapper');igWrapperEl.innerHTML=igEmbedCode;igWrapperEl.style.display='block';igWrapperEl.style.width=isMobile()?'100%':'350px';window.instgrm&&window.instgrm.Embeds.process();}}});});},_this.loadData=function(opt){var query=__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].getURLQuery();var mode=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this,'props.mode');var category_ids=mode!==NewsMode.ByQuery||mode!==NewsMode.News||mode!==NewsMode.Life?__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this,'props.category_ids'):undefined;var category_name=mode===NewsMode.ByQuery||mode===NewsMode.News||mode===NewsMode.Life?__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(query,'cname','注目活動'):undefined;// 如果 category_name 以 'uniopen' 開頭，去除 'uniopen' 字樣
if(typeof category_name==='string'&&category_name.startsWith('uniopen')){category_name=category_name.replace(/^uniopen/,'');}var size='all';// 減少前端顯示筆數以加快速度
switch(mode){case NewsMode.News:size=10;break;case NewsMode.TextOnlyList:size=isMobile()?2:5;break;default:break;}var params={page:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(opt,'page',1),page_size:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(opt,'pageSize',size),'category_ids[]':category_ids,category_name:category_name,mode:mode};switch(mode){case NewsMode.List:params.is_middle_banner=0;break;case NewsMode.Carousel:params.is_middle_banner=1;break;default:break;}var queryString=__WEBPACK_IMPORTED_MODULE_11_query_string___default.a.stringify(params,{skipNull:true});__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/v1/news?'+queryString,null,function(state,res){console.log('news = '+queryString,res);var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false||code!==200)return;console.log(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/v1/news?'+queryString,data);_this.setState({listInfo:data,categories:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(data,'categories')},function(){_this.reloadSwiper();});});},_this.reloadSwiper=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper)return;var swiperKV=new Swiper('.KV-swiper',{autoplay:true,loop:true,speed:800,navigation:{nextEl:'.KV-swiper-button-next',prevEl:'.KV-swiper-button-prev'},pagination:{el:'.swiper-pagination',clickable:true}});var swiperAD=new Swiper('.AD-banner-swiper',{autoplay:true,loop:true,speed:800,pagination:{el:'.AD-banner-swiper-pagination',clickable:true}});},500),_this.reloadSwiper2=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper)return;var mobile=window.matchMedia('(min-width: 0px) and (max-width: 767px)');var tablet=window.matchMedia('(min-width: 767px) and (max-width: 1024px)');var desktop=window.matchMedia('(min-width: 1025px)');new Swiper('.swiper-container1',{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:'auto',pagination:{el:'.swiper-pagination'}});},500),_this.reloadSwiperShoppingMall55=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper||swiper55)return;swiper55=new Swiper('.swiper-container-55',{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:'auto',autoplay:{delay:5000},pagination:{el:'.swiper-container-55 .swiper-pagination',clickable:true}});},500),_this.reloadSwiperShoppingMall128=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper||swiper128)return;swiper128=new Swiper('.swiper-container-128',{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:'auto',autoplay:{delay:5000},pagination:{el:'.swiper-container-128 .swiper-pagination',clickable:true}});},500),_this.reloadSwiperShoppingMall132=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper||swiper132)return;swiper132=new Swiper('.swiper-container-132',{initialSlide:0,spaceBetween:10,loop:true,slidesPerView:'auto',autoplay:{delay:5000},pagination:{el:'.swiper-container-132 .swiper-pagination',clickable:true}});},500),_this.getNewsLink=function(newsInfo){var action_type=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(newsInfo,'action_type');var post_id=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(newsInfo,'post_id');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');if(action_type==1){//let En_Post = _.get(window, "VC_CONFIG.En_Post");
if(Locale=='en_US')return INDEX_URL+'/en-post?postid='+post_id;else return INDEX_URL+'?p='+post_id;}if(action_type==2){var link=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(newsInfo,'link');if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(link))return link;// return `${VC_CONFIG.INDEX_URL}/news-info/?id=${newsInfo.id}`
}return'#';},_this.getMode=function(){return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(_this,'props.mode',NewsMode.Carousel);},_this.fetchmode=function(){var getUrlString=window.location.href;var url=new URL(getUrlString);_this.setState({mode:url.searchParams.get('mode'),cname:url.searchParams.get('cname')});},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_12_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get($magicLine,0)){__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_12_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_12_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_12_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_12_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_12_jquery___default()('.highlight').addClass('current_page_item');});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();this.fetchmode();this.GTM();this.fetchCategoryList();// let mode = this.props.mode;
// if (isMobile() && mode === NewsMode.Grid2) {
//   document.querySelector(".shopping-mall-banner").style.display = "none";
// }
}// forMobile 首頁、Shopping mall活動快訊
},{key:'render',value:function render(){var _this2=this;var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});var mode=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.mode',NewsMode.Carousel);var category_ids=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.category_ids');if(mode===NewsMode.ByQuery){var query=__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].getURLQuery();mode=parseInt(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(query,'mode',NewsMode.Grid),10);}var listInfo=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.listInfo');var list=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows',[]).filter(function(item){return category_ids.indexOf(item.category_id)!==-1;});var news_categories=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(options,'news_categories',[]).filter(function(item){return category_ids.indexOf(item.id)!==-1;});var selectedCategoryId=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.selectedCategoryId',__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(news_categories,'0.id'));var selectedCategoryName=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.selectedCategoryName',__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(news_categories,'0.name'));var news_url=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/news';if(Locale=='en_US'){news_url=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/news-en';}var life_url=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/life';if(Locale=='en_US'){life_url=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/life-en';}if(mode===NewsMode.Banner){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'KV-banner'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(list,function(item,idx){return wp.element.createElement('div',{id:'Banner'},idx==0&&(item.youtube&&wp.element.createElement('div',{'class':'jumbotron wp-block-cec-vulcan-block-news-list','vu-attributes':'{"mode":1,"category_ids":[50]}'},wp.element.createElement('div',{'class':'KV-banner'},wp.element.createElement('div',{'class':'kv-title',style:{top:'50%'}},item.name,wp.element.createElement('span',{'class':'kv-sub-title'},item.desc)),wp.element.createElement('iframe',{alt:item.name,id:'player',title:'player','class':'w-100 h-100',src:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'youtube')+'?frameborder=0&modestbranding=1&controls=0&rel=0&autoplay=0&enablejsapi=1',allow:'accelerometer;autohide; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:''})))||!item.youtube&&wp.element.createElement('div',{'class':'KV-banner'},wp.element.createElement('div',{'class':'kv-title',style:{top:'50%'}},item.name,wp.element.createElement('span',{'class':'kv-sub-title'},item.desc)),wp.element.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url'),alt:item.name}))));})));}if(mode===NewsMode.Carousel){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container AD-banner-swiper'},wp.element.createElement('div',{id:'Banner-M','class':'swiper-wrapper'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(list,function(item,idx){return item.is_middle_banner==1&&wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('a',{'class':'banner-item',role:'button',alt:item.category_name+'-'+item.name,href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}})));}))),wp.element.createElement('div',{'class':'AD-banner-swiper-pagination'}));}if(mode===NewsMode.List){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'card-header tag-tabs'},wp.element.createElement('nav',{'class':'tabs-wrap'},wp.element.createElement('ul',{'class':'tabs-content'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(news_categories,function(categoryInfo){return wp.element.createElement('li',{className:categoryInfo.id===selectedCategoryId?'current_page_item':null,onClick:function onClick(){return _this2.setState({selectedCategoryId:categoryInfo.id,selectedCategoryName:categoryInfo.name});}},wp.element.createElement('a',{alt:categoryInfo.name,role:'button'},Locale=='en_US'&&categoryInfo.name_en?categoryInfo.name_en:categoryInfo.name));}))),wp.element.createElement('a',{'class':'h6 text-decoration-none mb-0',role:'button',href:VC_CONFIG.INDEX_URL+'/news'+(Locale==='en_US'?'-en':'')+'?mode=6&cname='+selectedCategoryName,'data-toggle':'tooltip','data-placement':'right',title:'\u770B\u66F4\u591A'},wp.element.createElement('i',{'class':'icon-plus'}))),wp.element.createElement('div',{id:'List','class':'card-body pb-0'},wp.element.createElement('ul',{'class':'list-unstyled list-item'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(list,function(item){return item.category_id===selectedCategoryId&&item.is_middle_banner==0;}).slice(0,5).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-md-5'},wp.element.createElement('div',{'class':'img-2-1 mb-lg-0 mb-3',style:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images_previews.0.url')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images_previews.0.url')+')'}:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}})),wp.element.createElement('div',{'class':'col-md'},wp.element.createElement('div',{'class':'py-2'},wp.element.createElement('h5',{'class':'text-navy fw-700 limit-line-1 flex-fill mb-2 h6'},item.name),wp.element.createElement('span',{'class':'fw-300 text-body text-justify limit-line-2 mb-2 p'},item.desc),wp.element.createElement('span',{'class':'text-navy text-nowrap d-block mb-0 note'},item.start_date,' - ',item.end_date))))));}),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'d-flex justify-content-end py-3'},wp.element.createElement('a',{'class':'fw-700 mb-0 text-navy d-inline-flex align-items-center line-hight-fit p',role:'button',href:VC_CONFIG.INDEX_URL+'/news'+(Locale==='en_US'?'-en':'')+'?mode=6&cname='+selectedCategoryName},Locale==='en_US'?'more':'更多活動',wp.element.createElement('i',{'class':'text-primary fas fa-chevron-circle-right line-hight-fit mb-0 ml-2'})))))));}if(mode===NewsMode.TextOnlyList){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(news_categories,function(categoryInfo){return wp.element.createElement('div',{'class':'card card-border-primary shadow-0 mb-5'},wp.element.createElement('div',{'class':'card-header d-flex justify-content-between align-items-center'},' ',wp.element.createElement('strong',{'class':'h6 fw-700 mb-0'},Locale=='en_US'&&categoryInfo.name_en?categoryInfo.name_en:categoryInfo.name),wp.element.createElement('a',{'class':'h6 text-decoration-none mb-0',role:'button',href:VC_CONFIG.INDEX_URL+'/news'+(Locale==='en_US'?'-en':'')+'/?mode='+NewsMode.TextOnlyList+'&cname='+categoryInfo.name,'data-toggle':'tooltip','data-placement':'right',title:'\u770B\u66F4\u591A'},wp.element.createElement('i',{'class':'icon-plus'}))),wp.element.createElement('div',{id:'TextOnlyList','class':'card-body py-0'},wp.element.createElement('ul',{'class':'list-unstyled list-item'},!isMobile()&&__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(list,function(item){return item.category_id===categoryInfo.id;}).slice(0,5).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center text-navy mb-3'},wp.element.createElement('h5',{'class':'p fw-700 limit-line-1 text-highlight mb-0 mr-2'},item.name),wp.element.createElement('span',{'class':'p text-nowrap mb-0 ml-auto'},item.start_date&&__WEBPACK_IMPORTED_MODULE_10_moment___default()(item.start_date).format('YYYY-MM-DD'))),wp.element.createElement('span',{'class':'note fw-300 text-body text-justify limit-line-2 mb-0'},' ',item.desc)));}),isMobile()&&__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.filter(list,function(item){return item.category_id===categoryInfo.id;}).slice(0,2).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center text-navy mb-3'},wp.element.createElement('h5',{'class':'p fw-700 limit-line-1 text-highlight mb-0 mr-2'},item.name),wp.element.createElement('span',{'class':'p text-nowrap mb-0 ml-auto'},item.start_date&&__WEBPACK_IMPORTED_MODULE_10_moment___default()(item.start_date).format('YYYY-MM-DD'))),wp.element.createElement('span',{'class':'note fw-300 text-body text-justify limit-line-2 mb-0'},' ',item.desc)));}))));}));}if(mode===NewsMode.Table){return wp.element.createElement('div',{'class':'container'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows'),function(item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,item.category_id==45&&idx==0&&wp.element.createElement('div',{'class':'px-4 p-3 px-md-5 bg-primary d-none d-lg-block',style:{backgroundColor:'#2B61AF'}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('公佈日期','cec-plugin-stores'))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('活動名稱','cec-plugin-stores'))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement('a',{'class':'px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},item.category_id==45&&wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u516C\u4F48\u65E5\u671F'},item.show_at.substring(0,10))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u6D3B\u52D5\u540D\u7A31'},item.name))),item.category_id!=45&&wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-md-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-auto'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.start_date,' - ',item.end_date)),wp.element.createElement('div',{'class':'col-auto ml-auto mt-md-0 mt-4'},wp.element.createElement('p',{'class':'h6 text-primary mb-0'},item.start_date,wp.element.createElement('span',{'class':'ml-2'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('發佈','cec-plugin-stores')))))));}),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this2.loadData({page:page,pageSize:pageSize});}}));}if(mode===NewsMode.Grid){return wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows'),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'col-lg-6 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1 card-img-top bg-contain',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images_previews.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center mb-3'},wp.element.createElement('h5',{'class':'h5 text-navy limit-line-1 mb-0'},item.name),wp.element.createElement('span',{'class':'note text-dark mb-0 text-nowrap'},item.start_date,'-',item.end_date)),wp.element.createElement('p',{'class':'p text-dark limit-line-1 mb-0'},item.desc)))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this2.loadData({page:page,pageSize:pageSize});}}));}if(mode===NewsMode.Grid2){var rows=listInfo.rows||[];return wp.element.createElement('div',{'class':'swiper-container-'+this.props.category_ids[0],style:{overflow:'hidden'}},wp.element.createElement('div',{'class':'swiper-wrapper',style:{height:'fit-content'}},rows.map(function(item,idx){return wp.element.createElement('div',{key:idx,'class':'swiper-slide'},wp.element.createElement('a',{'class':'card text-decoration-none border-0 shadow-0 p-0',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body p-3'},wp.element.createElement('h5',{'class':'text-navy limit-line-1 mb-2 h6'},item.name))));})),wp.element.createElement('div',{'class':'swiper-pagination'}));}if(mode===NewsMode.Grid2){var _rows=listInfo.rows||[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'event-card-scroll_mobile mb-md-0 mb-5 swiper-container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3 w-auto swiper-wrapper'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(_rows,function(item,idx){return wp.element.createElement('div',{key:idx,'class':'col-auto col-md-12 px-3 mb-4 swiper-slide'},wp.element.createElement('a',{'class':'card text-decoration-none border-0 shadow-0 p-0',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body p-3'},wp.element.createElement('h5',{'class':'text-navy limit-line-1 mb-2 h6'},item.name))));})),wp.element.createElement('div',{'class':'swiper-pagination'})));}if(mode===NewsMode.News){var _rows2=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows',[]);return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL+(Locale=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{// href='javascript:void(0)'
onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('最新消息','cec-plugin-stores'))),this.state.cname&&wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])(''+this.state.cname,'cec-plugin-stores')))))),wp.element.createElement('div',{'class':'banner banner-news'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/event.svg',alt:''}),this.state.cname&&wp.element.createElement('h3',{'class':'title'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])(''+this.state.cname,'cec-plugin-stores'))))),wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='量販活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=\u91CF\u8CA9\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('量販活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='超市活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=\u8D85\u5E02\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('超市活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='會員活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=\u6703\u54E1\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('會員活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='uniopen聯名卡活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=uniopen\u806F\u540D\u5361\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('uniopen聯名卡活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='新聞中心'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=4&cname=\u65B0\u805E\u4E2D\u5FC3'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('新聞中心','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='公告訊息'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=4&cname=\u516C\u544A\u8A0A\u606F'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('公告訊息','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='得獎公告'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=5&cname=\u5F97\u734E\u516C\u544A'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('得獎公告','cec-plugin-stores'))))),this.state.mode==6&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows'),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'col-lg-6 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}},target:item.action_type==2?'_blank':'_self'},wp.element.createElement('div',{'class':'img-2-1 card-img-top bg-contain',style:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images_previews.0.url')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images_previews.0.url')+')'}:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body',style:{padding:' 1rem 2rem'}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center mb-3'},wp.element.createElement('h5',{'class':'h5 text-navy limit-line-1 mb-0'},item.name),wp.element.createElement('span',{'class':'note text-dark mb-0 text-nowrap'},item.start_date,'-',item.end_date)),wp.element.createElement('p',{'class':'h6 text-font limit-line-2 mb-0'},item.desc)))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this2.loadData({page:page,pageSize:pageSize});window.scrollTo(0,0);}})),(this.state.mode==5||this.state.mode==4)&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'px-4 p-3 px-md-5 bg-primary d-none d-lg-block',style:{backgroundColor:'#2B61AF'}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('公佈日期','cec-plugin-stores'))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},this.state.mode==5?Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('活動名稱','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('消息名稱','cec-plugin-stores'))))),__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows'),function(item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',null,wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement('a',{'class':'px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u516C\u4F48\u65E5\u671F'},item.show_at.substring(0,10))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u6D3B\u52D5\u540D\u7A31'},item.name))))));}),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this2.loadData({page:page,pageSize:pageSize});window.scrollTo(0,0);}})));}if(mode===NewsMode.shopping){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'banner-image'},list&&__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.head(list),'images.0.url')&&wp.element.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.head(list),'images.0.url'),alt:''}),(!list||!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.head(list),'images.0.url'))&&wp.element.createElement('img',{src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/banner/mall/banner-mall2.jpeg',alt:''})));}if(mode===NewsMode.Life){return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+VC_CONFIG.INDEX_URL+(Locale=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{// href='javascript:void(0)'
onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])('生活專欄','cec-plugin-stores'))),this.state.cname&&wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])(''+this.state.cname,'cec-plugin-stores')))))),wp.element.createElement('div',{'class':'banner banner-md'},wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:tabList.find(function(t){return t.name===_this2.state.cname;}).bannerImg,alt:''}),this.state.cname&&wp.element.createElement('h3',{'class':'title'},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])(''+this.state.cname,'cec-plugin-stores')))),wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},tabList.map(function(t,idx){return wp.element.createElement('li',{key:idx,'class':_this2.state.cname&&_this2.state.cname==t.name?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:life_url+'/?mode=6&cname='+t.name},Object(__WEBPACK_IMPORTED_MODULE_13__wordpress_i18n__["__"])(t.name,'cec-plugin-stores')));}))),this.state.mode==6&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'rows'),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'col-lg-6 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button',href:_this2.getNewsLink(item),onClick:function onClick(e){if(_this2.getNewsLink(item)==='#'){e.preventDefault();}},target:item.action_type==2?'_blank':'_self'},wp.element.createElement('div',{'class':'img-2-1 card-img-top bg-contain',style:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item,'images.0.url')+')'}:{backgroundImage:'url('+VC_CONFIG.PLUGIN_ASSETS_URL+'img/news/logo_empty.jpg)'}}),wp.element.createElement('div',{'class':'card-body',style:{padding:' 1rem 2rem'}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center mb-3'},wp.element.createElement('h5',{'class':'h5 text-navy limit-line-1 mb-0'},item.name),wp.element.createElement('span',{'class':'note text-dark mb-0 text-nowrap'},item.start_date,'-',item.end_date)),wp.element.createElement('p',{'class':'h6 text-font limit-line-2 mb-0'},item.desc)))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this2.loadData({page:page,pageSize:pageSize});window.scrollTo(0,0);}})));}return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null);}}]);return NewsList;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var NewsListEditor=function(_Component2){_inherits(NewsListEditor,_Component2);function NewsListEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,NewsListEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=NewsListEditor.__proto__||Object.getPrototypeOf(NewsListEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(NewsListEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this4=this;var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-megaphone'})),'\u6D88\u606F\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical'// onFinish={values => this.submitData(values)}
,onValuesChange:function onValuesChange(changedFields,allFields){return _this4.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_19_libs_FormHelper__["a" /* genFormItemAtrribute */])('mode','顯示方式'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Banner},'\u9996\u9801\u5927\u7248\u4F4DBanner'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Carousel},'\u9996\u9801\u4E2D\u7248\u4F4DBanner'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.List},'\u9996\u9801\u5716\u6587\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.TextOnlyList},'\u9996\u9801\u7D14\u6587\u5B57\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Table},'\u6587\u5B57\u6E05\u55AE\u542B\u5206\u9801'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Grid},'\u5716\u6587\u6E05\u55AE'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.ByQuery},'\u4F9D\u64DAURL Query\u5448\u73FE'))),this.formRef.current&&this.formRef.current.getFieldValue('mode')!==NewsMode.ByQuery&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_19_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_ids','顯示類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(options,'news_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:item.id},item.name));}})))));}}]);return NewsListEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsListPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NewsListPreviewEditor", function() { return NewsListPreviewEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Pagination_Pagination__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_module_scss__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Locale=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.Locale');var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var NewsMode={Banner:1,// 首頁大版位Banner 前5則
Carousel:2,// 首頁中版位Banner 前5則
List:3,// 首頁圖文清單  前5則
TextOnlyList:4,// 首頁文字清單 前5則 （最新消息、重要公告）
Table:5,// 文字清單包含分頁
Grid:6,// 圖文清單
ByQuery:7,// 依據URL Query決定
Grid2:8,// 購物中心圖文清單，會依照個數變換顯示
News:9// 最新消息/news內頁
};function isMobileDevice(){var mobileDevices=['Android','iPhone','iPad'];var isMobileDevice=1;for(var i=0;i<mobileDevices.length;i++){if(navigator.userAgent.match(mobileDevices[i])){isMobileDevice=0;}}return isMobileDevice;}var newsSwiper=void 0;var init=false;// 前端頁面
var NewsListPreview=function(_Component){_inherits(NewsListPreview,_Component);function NewsListPreview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsListPreview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsListPreview.__proto__||Object.getPrototypeOf(NewsListPreview)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'',cname:''},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_14_jquery___default()(document).off('click','#Banner-M div a').on('click','#Banner-M div a',function(){var $text=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).attr('alt');dataLayer.push({event:'Banner-M_click',item:$text});});__WEBPACK_IMPORTED_MODULE_14_jquery___default()(document).off('click','#List ul li a').on('click','#List ul li a',function(){var $text=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).attr('alt');dataLayer.push({event:'news_click',item:$text});});__WEBPACK_IMPORTED_MODULE_14_jquery___default()(document).off('click','#TextOnlyList ul li a').on('click','#TextOnlyList ul li a',function(){var $text=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).attr('alt');dataLayer.push({event:'news_click',item:$text});});__WEBPACK_IMPORTED_MODULE_14_jquery___default()(document).on('click','#Banner div iframe',function(){var $text=__WEBPACK_IMPORTED_MODULE_14_jquery___default()(this).attr('alt');dataLayer.push({event:'Banner_youtube_click',item:$text});});},_this.loadData=function(opt){var query=__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].getURLQuery();console.log('qq',query);var mode=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'props.mode');console.log('loaddata-mode',mode);var category_ids=mode!==NewsMode.ByQuery||mode!==NewsMode.News?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'props.category_ids'):undefined;var category_name=mode===NewsMode.ByQuery||mode===NewsMode.News?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(query,'cname','注目活動'):undefined;// 如果 category_name 以 'uniopen' 開頭，去除 'uniopen' 字樣
if(typeof category_name==='string'&&category_name.startsWith('uniopen')){category_name=category_name.replace(/^uniopen/,'');}var previewid=mode===NewsMode.ByQuery||mode===NewsMode.News?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(query,'previewid',''):undefined;_this.setState({isFetchData:true});var size='all';if(mode==9){size=10;}var queryString=__WEBPACK_IMPORTED_MODULE_12_query_string___default.a.stringify({page:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(opt,'page',1),page_size:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(opt,'pageSize',size),'category_ids[]':category_ids,category_name:category_name,previewid:previewid},{skipNull:true});console.log('loaddata-queryString',queryString);__WEBPACK_IMPORTED_MODULE_19__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_18__configs_env__["b" /* API_HOST */]+'/api/v1/news?'+queryString,null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log('loaddata-qqqqq',queryString);console.log(code,reason,data,res);console.log('loaddata',data);if(state===false||code!==200){console.error(reason);return;}_this.setState({listInfo:data,categories:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(data,'categories')},function(){var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'props.app.options',{});var mode=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'props.mode',NewsMode.Carousel);if(mode===NewsMode.Grid2){_this.reloadSwiper2();}else{_this.reloadSwiper();}});});},_this.reloadSwiper=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function(){var Swiper=window.Swiper;if(!Swiper)return;var swiperKV=new Swiper('.KV-swiper',{autoplay:true,loop:true,speed:800,navigation:{nextEl:'.KV-swiper-button-next',prevEl:'.KV-swiper-button-prev'},pagination:{el:'.swiper-pagination',clickable:true}});var swiperAD=new Swiper('.AD-banner-swiper',{autoplay:true,loop:true,speed:800,pagination:{el:'.AD-banner-swiper-pagination',clickable:true}});},500),_this.reloadSwiper2=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function(){var Swiper=window.Swiper;console.log('reloadSwiper2');if(!Swiper)return;var mobile=window.matchMedia('(min-width: 0px) and (max-width: 767px)');var tablet=window.matchMedia('(min-width: 767px) and (max-width: 1024px)');var desktop=window.matchMedia('(min-width: 1025px)');// Enable (for mobile)
if(mobile.matches){if(!init){init=true;console.log('kkkkk1');setTimeout(function(){console.log('kkkkk2');newsSwiper=new Swiper('.event-card-scroll_mobile',{spaceBetween:10,loop:true,slidesPerView:'auto',// init: false,
pagination:{el:'.swiper-pagination',dynamicBullets:true},breakpoints:{767:{spaceBetween:0}}});console.log('kkkkk3',newsSwiper);},1000);}}// Disable (for tablet)
else if(tablet.matches){newsSwiper&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isFunction(newsSwiper.destroy)&&newsSwiper.destroy();init=false;}// Disable (for desktop)
else if(desktop.matches){newsSwiper&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isFunction(newsSwiper.destroy)&&newsSwiper.destroy();init=false;}},500),_this.getNewsLink=function(newsInfo){var action_type=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(newsInfo,'action_type');var post_id=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(newsInfo,'post_id');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');if(action_type==1){if(Locale=='en_US')return INDEX_URL+'/en-post?postid='+post_id;else return INDEX_URL+'?p='+post_id;}if(action_type==2){var link=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(newsInfo,'link');console.log('getNewsLink',link,newsInfo);if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(link))return link;// return `${VC_CONFIG.INDEX_URL}/news-info/?id=${newsInfo.id}`
}return'#';},_this.getMode=function(){return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'props.mode',NewsMode.Carousel);},_this.fetchmode=function(){var getUrlString=window.location.href;var url=new URL(getUrlString);_this.setState({mode:url.searchParams.get('mode'),cname:url.searchParams.get('cname')});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsListPreview,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].updateConfig();this.loadData();/* On Resize
     **************************************************************/window.addEventListener('resize',function(){_this2.reloadSwiper2();});this.fetchmode();this.GTM();}// forMobile 首頁、Shopping mall活動快訊
},{key:'render',value:function render(){var _this3=this;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});var mode=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.mode',NewsMode.Carousel);var category_ids=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.category_ids');console.log('AppHelper.getURLQuery()',__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].getURLQuery());if(mode===NewsMode.ByQuery){var query=__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].getURLQuery();mode=parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(query,'mode',NewsMode.Grid),10);console.log('mode',mode);}var listInfo=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'state.listInfo');var list=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows',[]).filter(function(item){return category_ids.indexOf(item.category_id)!==-1;});var news_categories=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(options,'news_categories',[]).filter(function(item){return category_ids.indexOf(item.id)!==-1;});var selectedCategoryId=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'state.selectedCategoryId',__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(news_categories,'0.id'));var selectedCategoryName=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'state.selectedCategoryName',__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(news_categories,'0.name'));var isMobile=isMobileDevice();var news_url=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/news';if(Locale=='en_US')news_url=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL')+'/news-en';if(mode===NewsMode.Banner){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'KV-banner'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(list,function(item,idx){return wp.element.createElement('div',{id:'Banner'},idx==0&&(item.youtube&&wp.element.createElement('div',{'class':'jumbotron wp-block-cec-vulcan-block-news-list','vu-attributes':'{"mode":1,"category_ids":[50]}'},wp.element.createElement('div',{'class':'KV-banner'},wp.element.createElement('div',{'class':'kv-title'},item.name,wp.element.createElement('span',{'class':'kv-sub-title'},item.desc)),wp.element.createElement('iframe',{alt:item.name,id:'player',title:'player','class':'w-100 h-100',src:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'youtube')+'?frameborder=0&modestbranding=1&controls=0&rel=0&autoplay=0&enablejsapi=1',allow:'accelerometer;autohide; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:''})))||!item.youtube&&wp.element.createElement('div',{'class':'KV-banner'},wp.element.createElement('div',{'class':'kv-title'},item.name,wp.element.createElement('span',{'class':'kv-sub-title'},item.desc)),wp.element.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url'),alt:item.name}))));})));}if(mode===NewsMode.Carousel){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'swiper-container AD-banner-swiper'},wp.element.createElement('div',{id:'Banner-M','class':'swiper-wrapper'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(list,function(item,idx){return wp.element.createElement('div',{'class':'swiper-slide'},wp.element.createElement('a',{'class':'banner-item',role:'button',alt:item.category_name+'-'+item.name,href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')+')'}})));}))),wp.element.createElement('div',{'class':'AD-banner-swiper-pagination'}));}if(mode===NewsMode.List){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'card-header tag-tabs'},wp.element.createElement('nav',{'class':'tabs-wrap'},wp.element.createElement('ul',{'class':'tabs-content'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(news_categories,function(categoryInfo){return wp.element.createElement('li',{className:categoryInfo.id===selectedCategoryId?'current_page_item':null,onClick:function onClick(){return _this3.setState({selectedCategoryId:categoryInfo.id,selectedCategoryName:categoryInfo.name});}},wp.element.createElement('a',{alt:categoryInfo.name,role:'button'},categoryInfo.name));}))),wp.element.createElement('a',{'class':'h6 text-decoration-none mb-0',role:'button',href:window.VC_CONFIG.INDEX_URL+'/news?mode=6&cname='+selectedCategoryName,'data-toggle':'tooltip','data-placement':'right',title:'\u770B\u66F4\u591A'},wp.element.createElement('i',{'class':'icon-plus'}))),wp.element.createElement('div',{id:'List','class':'card-body pb-0'},wp.element.createElement('ul',{'class':'list-unstyled list-item'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.filter(list,function(item){return item.category_id===selectedCategoryId;}).slice(0,5).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-md-5'},wp.element.createElement('div',{'class':'img-2-1 mb-lg-0 mb-3',style:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')+')'}:{backgroundImage:'url('+window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/news/logo_empty.jpg)'}})),wp.element.createElement('div',{'class':'col-md'},wp.element.createElement('div',{'class':'py-2'},wp.element.createElement('h5',{'class':'text-navy fw-700 limit-line-1 flex-fill mb-2 h6'},item.name),wp.element.createElement('span',{'class':'fw-300 text-body text-justify limit-line-2 mb-2 p'},item.desc),wp.element.createElement('span',{'class':'text-navy text-nowrap d-block mb-0 note'},item.start_date,' - ',item.end_date))))));}),wp.element.createElement('li',null,wp.element.createElement('div',{'class':'d-flex justify-content-end py-3'},wp.element.createElement('a',{'class':'fw-700 mb-0 text-navy d-inline-flex align-items-center line-hight-fit p',role:'button',href:window.VC_CONFIG.INDEX_URL+'/news?mode=6&cname='+selectedCategoryName},'\u66F4\u591A\u6D3B\u52D5',wp.element.createElement('i',{'class':'text-primary fas fa-chevron-circle-right line-hight-fit mb-0 ml-2'})))))));}if(mode===NewsMode.TextOnlyList){console.log('_.filter(news_categories)',news_categories);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(news_categories,function(categoryInfo){return wp.element.createElement('div',{'class':'card card-border-primary shadow-0 mb-5'},wp.element.createElement('div',{'class':'card-header d-flex justify-content-between align-items-center'},' ',wp.element.createElement('strong',{'class':'h6 fw-700 mb-0'},categoryInfo.name),wp.element.createElement('a',{'class':'h6 text-decoration-none mb-0',role:'button',href:window.VC_CONFIG.INDEX_URL+'/news/?mode='+NewsMode.TextOnlyList+'&cname='+categoryInfo.name,'data-toggle':'tooltip','data-placement':'right',title:'\u770B\u66F4\u591A'},wp.element.createElement('i',{'class':'icon-plus'}))),wp.element.createElement('div',{id:'TextOnlyList','class':'card-body py-0'},wp.element.createElement('ul',{'class':'list-unstyled list-item'},isMobile==1&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.filter(list,function(item){return item.category_id===categoryInfo.id;}).slice(0,5).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center text-navy mb-3'},wp.element.createElement('h5',{'class':'p fw-700 limit-line-1 text-highlight mb-0 mr-2'},item.name),wp.element.createElement('span',{'class':'p text-nowrap mb-0 ml-auto'},item.start_date&&__WEBPACK_IMPORTED_MODULE_11_moment___default()(item.start_date).format('YYYY-MM-DD'))),wp.element.createElement('span',{'class':'note fw-300 text-body text-justify limit-line-2 mb-0'},' ',item.desc)));}),isMobile==0&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.filter(list,function(item){return item.category_id===categoryInfo.id;}).slice(0,2).map(function(item){return wp.element.createElement('li',null,wp.element.createElement('a',{alt:item.category_name+'-'+item.name,role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center text-navy mb-3'},wp.element.createElement('h5',{'class':'p fw-700 limit-line-1 text-highlight mb-0 mr-2'},item.name),wp.element.createElement('span',{'class':'p text-nowrap mb-0 ml-auto'},item.start_date&&__WEBPACK_IMPORTED_MODULE_11_moment___default()(item.start_date).format('YYYY-MM-DD'))),wp.element.createElement('span',{'class':'note fw-300 text-body text-justify limit-line-2 mb-0'},' ',item.desc)));}))));}));}if(mode===NewsMode.Table){return wp.element.createElement('div',{'class':'container'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows'),function(item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,item.category_id==45&&idx==0&&wp.element.createElement('div',{'class':'px-4 p-3 px-md-5 bg-primary d-none d-lg-block',style:{backgroundColor:'#2B61AF'}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('公佈日期','cec-plugin-stores'))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('活動名稱','cec-plugin-stores'))))),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement('a',{'class':'px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list',role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},item.category_id==45&&wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u516C\u4F48\u65E5\u671F'},item.show_at.substring(0,10))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u6D3B\u52D5\u540D\u7A31'},item.name))),item.category_id!=45&&wp.element.createElement('div',{'class':'row align-items-center'},wp.element.createElement('div',{'class':'col-md-3'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.name)),wp.element.createElement('div',{'class':'col-auto'},wp.element.createElement('h6',{'class':'h5 text-navy mb-0'},item.start_date,' - ',item.end_date)),wp.element.createElement('div',{'class':'col-auto ml-auto mt-md-0 mt-4'},wp.element.createElement('p',{'class':'h6 text-primary mb-0'},item.start_date,wp.element.createElement('span',{'class':'ml-2'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('發佈','cec-plugin-stores')))))));}),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this3.loadData({page:page,pageSize:pageSize});}}));}if(mode===NewsMode.Grid){return wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows'),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'col-lg-6 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1 card-img-top bg-contain',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center mb-3'},wp.element.createElement('h5',{'class':'h5 text-navy limit-line-1 mb-0'},item.name),wp.element.createElement('span',{'class':'note text-dark mb-0 text-nowrap'},item.start_date,'-',item.end_date)),wp.element.createElement('p',{'class':'p text-dark limit-line-1 mb-0'},item.desc)))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this3.loadData({page:page,pageSize:pageSize});}}));}if(mode===NewsMode.Grid2){var rows=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows',[]);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'event-card-scroll_mobile mb-md-0 mb-5 swiper-container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3 w-auto swiper-wrapper'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(rows,function(item,idx){return wp.element.createElement('div',{key:idx,'class':'col-auto col-md-12 px-3 mb-4 swiper-slide'},wp.element.createElement('a',{'class':'card text-decoration-none border-0 shadow-0 p-0',role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')+')'}}),wp.element.createElement('div',{'class':'card-body p-3'},wp.element.createElement('h5',{'class':'text-navy limit-line-1 mb-2 h6'},item.name))));})),wp.element.createElement('div',{'class':'swiper-pagination'})));// 4個以下滿版
// 5個以上第一個滿版，之後對分
// return (
//   <Fragment>
//     <h1>舊的上線確認後就可移除</h1>
//     <div class='col-lg'>
//       <div class='event-card-scroll_mobile mb-md-0 mb-5'>
//         <div class='row no-gutters mx-n3'>
//           {_.map(rows, (item, idx) => {
//             let col =
//               idx === 0 || rows.length <= 4 ? 'col-md-12' : 'col-md-6';
//             return (
//               <Fragment>
//                 <div className={classnames(col, ' col-auto px-3 mb-4')}>
//                   <a
//                     class='card text-decoration-none border-0 shadow-0 p-0'
//                     role='button'
//                     href={this.getNewsLink(item)}
//                   >
//                     <div
//                       class='img-2-1'
//                       style={{
//                         backgroundImage: `url(${_.get(
//                           item,
//                           'images.0.url'
//                         )})`,
//                       }}
//                     />
//                     <div class='card-body p-3'>
//                       <h5 class='text-navy limit-line-1 mb-2 p'>
//                         {item.name}
//                       </h5>
//                       {/* <span class="date">{item.start_date}-{item.end_date}</span> */}
//                       {/* <p class="card-text">{item.desc}</p> */}
//                     </div>
//                   </a>
//                 </div>
//               </Fragment>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//     <h1>新的整合中</h1>
//     <div class='event-card-scroll_mobile mb-md-0 mb-5 swiper-container'>
//       <div class='row no-gutters mx-n3 w-auto swiper-wrapper'>
//         {_.map(rows, (item, idx) => (
//           <div class='col-auto col-md-12 px-3 mb-4 swiper-slide'>
//             <a
//               class='card text-decoration-none border-0 shadow-0 p-0'
//               role='button'
//               href={this.getNewsLink(item)}
//             >
//               <div
//                 class='img-2-1'
//                 style={{
//                   backgroundImage: `url(${_.get(item, 'images.0.url')})`,
//                 }}
//               />
//               <div class='card-body p-3'>
//                 <h5 class='text-navy limit-line-1 mb-2 h6'>
//                   {item.name}
//                 </h5>
//                 {/* <p class="note text-dark mb-0">目前在台灣已超過百家店，並具有多元發展的店家型態。</p> */}
//               </div>
//             </a>
//           </div>
//         ))}
//       </div>
//       <div class='swiper-pagination' />
//     </div>
//   </Fragment>
// );
}if(mode===NewsMode.News){var _rows=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows',[]);var Local=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.Locale');return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+window.VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{// href='javascript:void(0)'
onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('最新消息','cec-plugin-stores'))),this.state.cname&&wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])(''+this.state.cname,'cec-plugin-stores')))))),wp.element.createElement('div',{'class':'banner banner-news'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/news/event.svg',alt:''}),this.state.cname&&wp.element.createElement('h3',{'class':'title'},this.state.cname)))),wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='注目活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=\u6CE8\u76EE\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('注目活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='會員活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=\u6703\u54E1\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('會員活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='uniopen聯名卡活動'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=6&cname=uniopen\u806F\u540D\u5361\u6D3B\u52D5'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('uniopen聯名卡活動','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='新聞中心'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=4&cname=\u65B0\u805E\u4E2D\u5FC3'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('新聞中心','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='公告訊息'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=4&cname=\u516C\u544A\u8A0A\u606F'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('公告訊息','cec-plugin-stores'))),wp.element.createElement('li',{'class':this.state.cname&&this.state.cname=='得獎公告'?'nav-item current_page_item highlight':'nav-item'},wp.element.createElement('a',{'class':'nav-link',href:news_url+'/?mode=5&cname=\u5F97\u734E\u516C\u544A'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('得獎公告','cec-plugin-stores'))))),this.state.mode==6&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows'),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'col-lg-6 px-3 my-3'},wp.element.createElement('a',{'class':'card card-event',role:'button',href:_this3.getNewsLink(item),target:item.action_type==2?'_blank':'_self',onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'img-2-1 card-img-top bg-contain',style:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'images.0.url')+')'}:{backgroundImage:'url('+window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/news/logo_empty.jpg)'}}),wp.element.createElement('div',{'class':'card-body',style:{padding:' 1rem 2rem'}},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center mb-3'},wp.element.createElement('h5',{'class':'h5 text-navy limit-line-1 mb-0'},item.name),wp.element.createElement('span',{'class':'note text-dark mb-0 text-nowrap'},item.start_date,'-',item.end_date)),wp.element.createElement('p',{'class':'h6 text-font limit-line-2 mb-0'},item.desc)))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this3.loadData({page:page,pageSize:pageSize});window.scrollTo(0,0);}})),(this.state.mode==5||this.state.mode==4)&&wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'px-4 p-3 px-md-5 bg-primary d-none d-lg-block',style:{backgroundColor:'#2B61AF'}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('公佈日期','cec-plugin-stores'))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h5 text-white mb-0'},this.state.mode==5?Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('活動名稱','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_15__wordpress_i18n__["__"])('消息名稱','cec-plugin-stores'))))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'rows'),function(item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',null,wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement('a',{'class':'px-4 p-3 px-md-5 bg-white d-block text-decoration-none flex-list',role:'button',href:_this3.getNewsLink(item),onClick:function onClick(e){if(_this3.getNewsLink(item)==='#'){e.preventDefault();}}},wp.element.createElement('div',{'class':'row align-items-center p-1'},wp.element.createElement('div',{'class':'col-lg-2'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u516C\u4F48\u65E5\u671F'},item.show_at.substring(0,10))),wp.element.createElement('div',{'class':'col-lg'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0','data-title':'\u6D3B\u52D5\u540D\u7A31'},item.name))))));}),wp.element.createElement('hr',{'class':'border-top border-primary m-0'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Pagination_Pagination__["a" /* default */],{current:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'current',0),pageSize:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'page_size',10),total:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(listInfo,'total',0),onChange:function onChange(page,pageSize){_this3.loadData({page:page,pageSize:pageSize});window.scrollTo(0,0);}})));}return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null);}}]);return NewsListPreview;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var NewsListPreviewEditor=function(_Component2){_inherits(NewsListPreviewEditor,_Component2);function NewsListPreviewEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,NewsListPreviewEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=NewsListPreviewEditor.__proto__||Object.getPrototypeOf(NewsListPreviewEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(NewsListPreviewEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_17_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var _this5=this;var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-megaphone'})),'\u6D88\u606F\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical'// onFinish={values => this.submitData(values)}
,onValuesChange:function onValuesChange(changedFields,allFields){return _this5.props.setAttributes(changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__["a" /* genFormItemAtrribute */])('mode','顯示方式'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Banner},'\u9996\u9801\u5927\u7248\u4F4DBanner'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Carousel},'\u9996\u9801\u4E2D\u7248\u4F4DBanner'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.List},'\u9996\u9801\u5716\u6587\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.TextOnlyList},'\u9996\u9801\u7D14\u6587\u5B57\u5217\u8868'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Table},'\u6587\u5B57\u6E05\u55AE\u542B\u5206\u9801'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.Grid},'\u5716\u6587\u6E05\u55AE'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_select___default.a.Option,{value:NewsMode.ByQuery},'\u4F9D\u64DAURL Query\u5448\u73FE'))),this.formRef.current&&this.formRef.current.getFieldValue('mode')!==NewsMode.ByQuery&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_20_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_ids','顯示類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(options,'news_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_checkbox___default.a,{value:item.id},item.name));}})))));}}]);return NewsListPreviewEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecipeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecipeInfoEditor", function() { return RecipeInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INDEX_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,page_size:10,total:1,rows:[]};var RecipeInfo=function(_Component){_inherits(RecipeInfo,_Component);function RecipeInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecipeInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipeInfo.__proto__||Object.getPrototypeOf(RecipeInfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={recipeInfo:{category_name:'',condiments:[],dips:[],dishes:[],images:[],ingredients:[],name:'',source:'',steps:[]},listInfo:{current:1,page_size:'10',rows:[],total:40}},_this.loadData=function(){var queryParams=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(window.location.search);var recipe=queryParams.recipe;if(!recipe)return;__WEBPACK_IMPORTED_MODULE_10_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8_configs_env__["b" /* API_HOST */]+'/api/v1/recipes/'+recipe,null,function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning(reason);_this.props.history.replace(INDEX_URL+'/recipes');return;}_this.setState({recipeInfo:data},function(){_this.loadSimilarData(data);});_this.loadHTMLdesc(data);});_this.reloadSwiper();},_this.loadSimilarData=function(recipeInfo){var opt=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{page:1,pageSize:10};var queryString=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify({page:opt.page,page_size:opt.pageSize,'category_ids[]':[recipeInfo.category_id]},{skipNull:true});__WEBPACK_IMPORTED_MODULE_10_libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_8_configs_env__["b" /* API_HOST */]+'/api/v1/recipes?'+queryString,null,function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false||code!==200){return;}_this.setState({listInfo:data});});},_this.loadHTMLdesc=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(info.source.length>7){document.getElementById('output-source-content').innerHTML=info.source;}if(info.additional.length>7){document.getElementById('output-additional-content').innerHTML=info.additional;}},_this.reloadSwiper=function(){var Swiper=window.Swiper;var init=false;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(document).ready(function(){var swiper1;/* Which media query */function swiperMode(){var mobile=window.matchMedia('(min-width: 0px) and (max-width: 767px)');var tablet=window.matchMedia('(min-width: 767px) and (max-width: 1024px)');var desktop=window.matchMedia('(min-width: 1025px)');// Enable (for mobile)
if(mobile.matches){if(!init){init=true;swiper1=new Swiper('.event-card-scroll_mobile',{spaceBetween:10,loop:true,slidesPerView:'auto',// init: false,
pagination:{el:'.swiper-pagination',dynamicBullets:true},breakpoints:{767:{spaceBetween:0}}});}}// Disable (for tablet)
else if(tablet.matches){if(swiper1)swiper1.destroy();init=false;}// Disable (for desktop)
else if(desktop.matches){if(swiper1)swiper1.destroy();init=false;}}/* On Load
       **************************************************************/window.addEventListener('load',function(){swiperMode();});/* On Resize
       **************************************************************/window.addEventListener('resize',function(){swiperMode();});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipeInfo,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}},{key:'render',value:function render(){var _state=this.state,recipeInfo=_state.recipeInfo,listInfo=_state.listInfo;var Local=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');return wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb',style:{justifyContent:'left'}},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+window.VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/recipes'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('廚房','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/recipes'+(Local=='en_US'?'-en':'')},recipeInfo.category_name)),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},recipeInfo.name))))),wp.element.createElement('div',{'class':'banner banner-md'},wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/kitchen/banner-kitchen.png',alt:''}),wp.element.createElement('h3',{'class':'title mb-0'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('廚房','cec-plugin-stores')))),wp.element.createElement('div',{'class':'container'},wp.element.createElement('section',{'class':'pt-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-8 col-lg-9 mb-4'},wp.element.createElement('h4',{'class':'heading-title align-items-center'},recipeInfo.name,wp.element.createElement('div',{'class':'add-favorite'})),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'card shadow-0 border-0 bg-transparent mb-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-4'},wp.element.createElement('div',{'class':'img-1-1 mb-lg-0 mb-3',style:{backgroundImage:'url(\''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'images.0')+'\')'}})),wp.element.createElement('div',{'class':'col-lg-8'},wp.element.createElement('div',{'class':'d-flex flex-column justify-content-between'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-6'},wp.element.createElement('div',{'class':'d-flex align-items-center p-3'},wp.element.createElement('i',{'class':'icon-people2 h3 text-font mb-0 line-hight-fit mr-4'}),wp.element.createElement('p',{'class':'h6 mb-0 text-font'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('份量','cec-plugin-stores')),wp.element.createElement('span',{'class':'d-inline-block ml-auto h6 text-primary mb-0'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'portion',1),Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('人份','cec-plugin-stores'))),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'})),wp.element.createElement('div',{'class':'col-6'},wp.element.createElement('div',{'class':'d-flex align-items-center p-3'},wp.element.createElement('i',{'class':'icon-timer h3 text-font mb-0 line-hight-fit mr-4'}),wp.element.createElement('p',{'class':'h6 mb-0 text-font'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('準備','cec-plugin-stores'),wp.element.createElement('span',{'class':'d-none d-md-inline'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('時間','cec-plugin-stores'))),wp.element.createElement('span',{'class':'d-inline-block ml-auto h6 text-primary mb-0'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'prepare_time'),' ',Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('分鐘','cec-plugin-stores'))),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'})),wp.element.createElement('div',{'class':'col-6'},wp.element.createElement('div',{'class':'d-flex align-items-center p-3'},wp.element.createElement('i',{'class':'icon-star h3 text-font mb-0 line-hight-fit mr-4'}),wp.element.createElement('p',{'class':'h6 mb-0 text-font'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('難度','cec-plugin-stores')),wp.element.createElement('span',{'class':'d-inline-block ml-auto h6 text-primary mb-0'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'level_name'))),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'})),wp.element.createElement('div',{'class':'col-6'},wp.element.createElement('div',{'class':'d-flex align-items-center p-3'},wp.element.createElement('i',{'class':'icon-cook h3 text-font mb-0 line-hight-fit mr-4'}),wp.element.createElement('p',{'class':'h6 mb-0 text-font'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('烹調','cec-plugin-stores'),wp.element.createElement('span',{'class':'d-none d-md-inline'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('時間','cec-plugin-stores'))),wp.element.createElement('span',{'class':'d-inline-block ml-auto h6 text-primary mb-0'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'cook_time'),' ',Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('分鐘','cec-plugin-stores'))),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}))),wp.element.createElement('p',{'class':'h6 mb-3 text-font fw-300',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(recipeInfo,'desc')}}))))),[{list:recipeInfo.ingredients,name:Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('主要食材','cec-plugin-stores')},{list:recipeInfo.dishes,name:Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('配菜','cec-plugin-stores')},{list:recipeInfo.condiments,name:Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('調味料','cec-plugin-stores')},{list:recipeInfo.dips,name:Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('醃料','cec-plugin-stores')}].filter(function(collection){return collection.list.length>0;}).map(function(_ref2){var list=_ref2.list,name=_ref2.name;return wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('h4',{'class':'heading-title align-items-center'},name),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(list,function(item){return wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'row no-gutters mx-n3 p-3'},wp.element.createElement('div',{'class':'col px-3'},item.url==null&&wp.element.createElement('p',{'class':'h6 mb-0 text-font limit-line-lg-1','data-toggle':'tooltip','data-placement':'top',title:item.name},item.name),item.url!=null&&wp.element.createElement('p',{'class':'h6 mb-0 text-font limit-line-lg-1','data-toggle':'tooltip','data-placement':'top',title:item.name},wp.element.createElement('a',{href:item.url,style:{color:'#6e6060'},target:'_blank',rel:'noopener noreferrer'},item.name,wp.element.createElement('span',null,wp.element.createElement('h',{'class':'icon icon_cart-full'}))))),wp.element.createElement('div',{'class':'col-auto px-3'},wp.element.createElement('p',{'class':'h6 mb-0 text-primary'},item.portion,item.unit))),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}));})));}),recipeInfo.youtube&&wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('iframe',{'class':'w-100 my-4',height:'350',src:recipeInfo.youtube,frameborder:'0',allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:'',title:'youtube'})),recipeInfo.steps.length>0&&wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('h4',{'class':'heading-title align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('烹調步驟','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(recipeInfo.steps,function(item,idx){return wp.element.createElement('div',{'class':'card shadow-0 border-0 mb-3'},wp.element.createElement('div',{'class':'row no-gutters align-items-lg-center'},wp.element.createElement('div',{'class':'col-4 col-md-3 col-lg-2'},wp.element.createElement('div',{'class':'img-1-1',style:{backgroundImage:'url(\''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item,'image.url')+'\')'}})),wp.element.createElement('div',{'class':'col'},wp.element.createElement('div',{'class':'card-body px-md-5 p-3'},wp.element.createElement('h6',{'class':'h3 text-primary mb-3'},'Step ',idx+1),wp.element.createElement('p',{'class':'h6 text-font text-justify mb-0'},wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:item.desc}}),item.tip&&wp.element.createElement('p',{className:'note text-success mb-0',dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('訣竅','cec-plugin-stores')+': '+item.tip}}))))));})),recipeInfo.source.length>7&&wp.element.createElement('section',{'class':'py-3'},wp.element.createElement('h4',{'class':'heading-title align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('了解更多','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'card shadow-0 border-0 bg-transparent mb-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-lg-8'},wp.element.createElement('div',{'class':'d-flex flex-column justify-content-between'},wp.element.createElement('p',{id:'output-source-content','class':'p mb-3 text-font fw-300'}))))))),wp.element.createElement('div',{'class':'col-md-4 col-lg-3 mb-4'},wp.element.createElement('h5',{'class':'heading-subTitle align-items-start'},Object(__WEBPACK_IMPORTED_MODULE_6__wordpress_i18n__["__"])('推薦食譜','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'event-card-scroll_mobile mb-md-0 mb-5 swiper-container'},wp.element.createElement('div',{'class':'row no-gutters mx-n3 w-auto swiper-wrapper'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(listInfo,'rows',[]),function(item){return wp.element.createElement('div',{'class':'col-auto col-md-12 px-3 mb-4 swiper-slide'},wp.element.createElement('a',{'class':'card shadow-0 border-0',role:'button',href:INDEX_URL+'/recipe-info'+(Locale=='en_US'?'-en':'')+'/?recipe='+item.name},wp.element.createElement('div',{'class':'row no-gutters align-items-center'},wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'img-1-1',style:{backgroundImage:'url(\''+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item,'images.0')+'\')'}})),wp.element.createElement('div',{'class':'col-md-6'},wp.element.createElement('div',{'class':'card-body px-4 py-3'},wp.element.createElement('h5',{'class':'note text-font limit-line-3 mb-0'},item.name))))));})),wp.element.createElement('div',{'class':'swiper-pagination'})),wp.element.createElement('div',{'class':'row'}))))));}}]);return RecipeInfo;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var RecipeInfoEditor=function(_Component2){_inherits(RecipeInfoEditor,_Component2);function RecipeInfoEditor(){var _ref3;var _temp2,_this2,_ret2;_classCallCheck(this,RecipeInfoEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref3=RecipeInfoEditor.__proto__||Object.getPrototypeOf(RecipeInfoEditor)).call.apply(_ref3,[this].concat(args))),_this2),_this2.formRef=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef(),_this2.state={listInfo:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(defaultListInfo)},_this2.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2,'props.match.params.id');if(!id)return;__WEBPACK_IMPORTED_MODULE_10_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8_configs_env__["b" /* API_HOST */]+('/api/v1/recipes/'+id),null,function(state,res){var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning(reason);_this2.props.history.replace('/recipes');return;}_this2.fillData(data);});},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(RecipeInfoEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_9_libs_AppHelper__["a" /* default */].updateConfig();}},{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-book'})),'\u98DF\u8B5C\u8A73\u7D30\u8CC7\u8A0A'));}}]);return RecipeInfoEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NewsListEditor", function() { return NewsListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Pagination_Pagination__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INDEX_URL=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,page_size:40,total:1,rows:[]};var NewsList=function(_Component){_inherits(NewsList,_Component);function NewsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsList.__proto__||Object.getPrototypeOf(NewsList)).call.apply(_ref,[this].concat(args))),_this),_this.state={queryInfo:{search:'',category_name:'',keyword:''},listInfo:{current:1,page_size:'40',rows:[],total:0}},_this.loadData=function(opt){var queryInfo=_this.state.queryInfo;__WEBPACK_IMPORTED_MODULE_13_libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_11_configs_env__["b" /* API_HOST */]+'/api/v1/recipes?',{'category_names[]':__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'category_name'),keyword:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'keyword'),search:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'search'),page:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(opt,'page',1),page_size:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(opt,'pageSize',40)},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){return;}_this.setState({listInfo:data});});var hrefQuery=_this.state.queryInfo.search===''?__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify({category_name:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'category_name'),keyword:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'keyword')},{skipNull:true}):__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify({category_name:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'category_name'),keyword:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'keyword'),search:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(queryInfo,'search')},{skipNull:true});window.location.href='#'+hrefQuery;window.scrollTo(0,0);},_this.recipeCategoriesSelect=function(value){var queryInfo=_this.state.queryInfo;queryInfo.category_name=[value];queryInfo.search='';_this.setState({queryInfo:queryInfo},function(){return _this.loadData();});},_this.handleClickTag=function(item){var queryInfo=_this.state.queryInfo;if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#'+item.name).hasClass('active')){queryInfo.keyword='';}else{queryInfo.keyword=item.keyword;queryInfo.search='';}_this.setState({queryInfo:queryInfo},function(){return _this.loadData();});},_this.handleClickHot=function(item){var queryInfo=_this.state.queryInfo;queryInfo.search=item.keyword;_this.setState({queryInfo:queryInfo},function(){return _this.loadData();});},_this.handleClickCategory=function(item){var queryInfo=_this.state.queryInfo;if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('#'+item.id).hasClass('active')){queryInfo.category_name='';}else{queryInfo.category_name=item.name;queryInfo.search='';}_this.setState({queryInfo:queryInfo},function(){return _this.loadData();});},_this.handleChangePagination=function(page,pageSize){_this.loadData({page:page,pageSize:pageSize});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsList,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();var hashQuery=__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].getHashParamaters();if(hashQuery){var queryInfo=this.state.queryInfo;queryInfo.search=hashQuery.search;queryInfo.category_name=hashQuery.category_name;queryInfo.keyword=hashQuery.keyword;this.setState({queryInfo:queryInfo});}this.loadData();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,queryInfo=_state.queryInfo,listInfo=_state.listInfo;var Local=__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(window,'VC_CONFIG.Locale');var options=this.props.app.options||{};var recipeTags=options.recipe_tags||[];var recipeCategories=options.recipe_categories||[];var recipeList=listInfo.rows||[];var hotKeywords=options.hot_keywords||[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+window.VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('廚房','cec-plugin-stores'))))))),wp.element.createElement('div',{'class':'banner banner-md'},wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:window.VC_CONFIG.PLUGIN_ASSETS_URL+'img/banner/kitchen/banner-kitchen.png',alt:''}),wp.element.createElement('h3',{'class':'title mb-0'},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('廚房','cec-plugin-stores')))),wp.element.createElement('div',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('section',{'class':'pt-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-4 col-lg-3 mb-4'},wp.element.createElement('aside',null,wp.element.createElement('div',{'class':'kitchen-filter-aside'},wp.element.createElement('div',{'class':'card'},wp.element.createElement('div',{'class':'card-header'},wp.element.createElement('h5',{style:{color:'white'}},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('食譜共','cec-plugin-stores'),wp.element.createElement('span',{'class':'reault'},listInfo.total),Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('件','cec-plugin-stores'))),wp.element.createElement('div',{className:'search-dev'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:'\u8ACB\u8F38\u5165\u98DF\u6750\u6216\u98DF\u8B5C\u540D\u7A31',className:'search',onPressEnter:function onPressEnter(){queryInfo.category_name='';queryInfo.keyword='';_this2.loadData();},allowClear:true,value:queryInfo.search,suffix:wp.element.createElement('button',{'class':'icon-search mr-3 mr-md-0',style:{color:'#316ede',border:'none',backgroundColor:'transparent',fontSize:'20px'},onClick:function onClick(){queryInfo.category_name='';queryInfo.keyword='';_this2.loadData();}}),onChange:function onChange(e){queryInfo.search=e.target.value;_this2.setState({queryInfo:queryInfo});}})),wp.element.createElement('div',{'class':'card-body card-level-filter'},wp.element.createElement('p',{'class':'hot-keyword-text'},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('熱門搜尋','cec-plugin-stores')),wp.element.createElement('div',null,wp.element.createElement('div',{'class':'row no-gutters mx-n2 px-4',id:'item'},hotKeywords.filter(function(word){return word.keyword.length<=3;}).slice(0,10).map(function(hot){return wp.element.createElement('div',{style:{marginTop:'4px'},'class':'col-auto px-1 hot-keywords'},wp.element.createElement('span',{'class':'hot-keyword',id:hot.keyword,role:'button',onClick:function onClick(){return _this2.handleClickHot(hot);}},hot.keyword));})))),wp.element.createElement('div',{'class':'card-body card-level-filter'},wp.element.createElement('a',{'class':'btn','data-toggle':'collapse',href:'#typefilter',role:'button','aria-expanded':'false','aria-controls':'typefilter'},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('食材類別篩選','cec-plugin-stores')),wp.element.createElement('div',{'class':'collapse show',id:'typefilter'},wp.element.createElement('div',{'class':'row no-gutters mx-n2 px-4',id:'item'},recipeTags.map(function(tag){return wp.element.createElement('div',{style:{marginTop:'10px'},'class':'col-auto px-2'},wp.element.createElement('span',{'class':'keyword-btn '+(queryInfo.keyword===tag.keyword?'active':''),id:tag.name,role:'button',onClick:function onClick(){return _this2.handleClickTag(tag);}},tag.name));})))),wp.element.createElement('div',{'class':'card-body card-level-filter'},wp.element.createElement('a',{'class':'btn d-none d-lg-flex','data-toggle':'collapse',href:'#recipeList',role:'button','aria-expanded':'false','aria-controls':'recipeList'},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('食譜分類','cec-plugin-stores')),wp.element.createElement('div',{'class':'collapse show',id:'recipeList'},wp.element.createElement('div',{'class':'d-none d-lg-block'},wp.element.createElement('div',{'class':'recipe-item my-4'},wp.element.createElement('ul',null,recipeCategories.map(function(category){return wp.element.createElement('li',null,wp.element.createElement('div',{onClick:function onClick(){_this2.handleClickCategory(category);}},wp.element.createElement('a',{id:category.id,role:'button',className:queryInfo.category_name===category.name?'active':null},category.name)));}))))),wp.element.createElement('div',{'class':'p-4 d-lg-none'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a,{defaultValue:'disabled',className:' bootstrap-select form-select ',onChange:this.recipeCategoriesSelect},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{value:'disabled',disabled:true},'\u8ACB\u9078\u64C7\u98DF\u8B5C\u5206\u985E'),recipeCategories.map(function(category){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_select___default.a.Option,{key:category.id,value:category.name},category.name);})))))))),wp.element.createElement('div',{'class':'col-md-8 col-lg-9 mb-4'},wp.element.createElement('div',{'class':'row kitchen-list no-gutters mx-n2'},recipeList.map(function(recipe){return wp.element.createElement('div',{'class':'col-6 col-lg-3 px-2 mb-4'},wp.element.createElement('a',{'class':'card',role:'button',href:INDEX_URL+'/recipe-info'+(Locale=='en_US'?'-en':'')+'/?recipe='+recipe.name},wp.element.createElement('div',{'class':'card-img-top'},wp.element.createElement('div',{'class':'img-1-1',style:{backgroundImage:'url(\''+__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(recipe,'images.0')+'\')'}})),wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('h5',{'class':'card-title'},recipe.name),wp.element.createElement('p',{'class':'card-text'},wp.element.createElement('div',{dangerouslySetInnerHTML:{__html:recipe.desc}})))));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Pagination_Pagination__["a" /* default */],{current:listInfo.current,pageSize:listInfo.page_size,total:listInfo.total,onChange:function onChange(page,pageSize){return _this2.handleChangePagination(page,pageSize);}}))))))));}}]);return NewsList;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);// 編輯器
var NewsListEditor=function(_Component2){_inherits(NewsListEditor,_Component2);function NewsListEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,NewsListEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=NewsListEditor.__proto__||Object.getPrototypeOf(NewsListEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(NewsListEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-megaphone'})),'\u98DF\u8B5C\u5217\u8868'));}}]);return NewsListEditor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RepairInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RepairInfoEditor", function() { return RepairInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG');var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
var RepairInfo=function(_Component){_inherits(RepairInfo,_Component);function RepairInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RepairInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RepairInfo.__proto__||Object.getPrototypeOf(RepairInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this.state={tabType:'info',listInfo:null,repairInfo:null,query:{sno:null,phone:null}},_this.loadListData=function(query){_this.setState({isFetchData:true,listInfo:null,repairInfo:null});__WEBPACK_IMPORTED_MODULE_14__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_13__configs_env__["b" /* API_HOST */]+'/api/repair/query',{sno:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(query,'sno'),phone:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(query,'phone')},function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_message___default.a.warning(reason);return;}var cecRepairList=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(data,'cec',[]);var carrefourRepairList=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(data,'carrefour',[]);var repairList=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(cecRepairList)?carrefourRepairList:cecRepairList;_this.setState({listInfo:repairList});});},_this.isFromThemePage=function(){var isFromPage=window.location.href;if(isFromPage.indexOf('?')!=-1){var ary1=isFromPage.split('?');var ary2=ary1[1].split('=');var ary3=ary2[1].split('/');var type=ary2[0];var number=ary3[0];if(type==='SN_NO'){var query={sno:number,phone:null};_this.formRef.current.setFieldsValue(query);_this.formRef.current.submit();}else if(type==='Phone'){var _query={sno:null,phone:number};_this.formRef.current.setFieldsValue(_query);_this.formRef.current.submit();}}},_this.formValidator=function(rule,value){if(['sno','phone'].indexOf(rule.field)!==-1){if(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(_this.formRef.current.getFieldValue('sno'))&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(_this.formRef.current.getFieldValue('phone'))){return Promise.reject('ERROR');}}return Promise.resolve();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RepairInfo,[{key:'componentDidMount',value:function componentDidMount(){this.setState({tabType:__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].getHashValue('tab')||'info'});this.isFromThemePage();// this.formRef.current.setFieldsValue({ sno: 'TM20191022004' })
}},{key:'render',value:function render(){var _this2=this;var listInfo=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'state.listInfo');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'row mb-5 pt-5'},wp.element.createElement('div',{'class':'col-8 col-md-2 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:PLUGIN_ASSETS_URL+'img/maintain/web_search.svg',alt:''}))),wp.element.createElement('h4',{'class':'heading-title align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('維修紀錄查詢','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-5'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this2.loadListData(values);},initialValues:this.state.query},wp.element.createElement('p',{'class':'p text-muted text-center mb-5',style:{fontSize:'16px'}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('請輸入維修單號或電話號碼查詢','cec-plugin-stores')),wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-sm-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__["a" /* genFormItemAtrribute */])('sno'),{dependencies:['sno'],rules:[{validator:this.formValidator,message:'請輸入維修單號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{className:'form-control',style:{fontSize:'16px'},placeholder:'\u8ACB\u8F38\u5165\u7DAD\u4FEE\u55AE\u865F'}))),wp.element.createElement('div',{'class':'col-sm-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_15_libs_FormHelper__["a" /* genFormItemAtrribute */])('phone'),{dependencies:['phone'],rules:[{validator:this.formValidator,message:'請輸入電話號碼查詢'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_input___default.a,{className:'form-control',style:{fontSize:'16px'},placeholder:'\u8ACB\u8F38\u5165\u96FB\u8A71\u865F\u78BC\u67E5\u8A62'})))),wp.element.createElement('div',{'class':'text-center mt-5'},wp.element.createElement('a',{'class':'h6 btn btn-outline-primary rounded-pill px-5 py-3',role:'button',href:'#',onClick:function onClick(e){e.preventDefault();_this2.formRef.current.submit();}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('查詢維修進度','cec-plugin-stores')))),wp.element.createElement('hr',{'class':'border-top border-gray my-5'}),this.state.isFetchData===true&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_spin___default.a,null,wp.element.createElement('div',{'class':'row justify-content-center',style:{minHeight:200}},wp.element.createElement('hr',{'class':'border-top border-gray my-5'}))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(listInfo)&&this.state.isFetchData===false&&wp.element.createElement('div',{'class':'h4 row justify-content-center',style:{minHeight:200}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('查無此資料的訊息','cec-plugin-stores')),!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(listInfo)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('div',{'class':'row justify-content-center'},wp.element.createElement('div',{'class':'col-4'},wp.element.createElement('p',{'class':'h5 text-font fw-300 mb-4'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('選擇維修紀錄以查看進度','cec-plugin-stores')),wp.element.createElement('div',{'class':'nav flex-column nav-pills outline-tab',id:'v-pills-tab',role:'tablist','aria-orientation':'vertical'},wp.element.createElement('a',{'class':'nav-link active',id:'v-pills-tab-0','data-toggle':'pill',href:'#v-pills-0',role:'tab','aria-controls':'v-pills-0','aria-selected':'false'},wp.element.createElement('div',{'class':'d-flex justify-content-between mb-2'},wp.element.createElement('p',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('客戶姓名','cec-plugin-stores'),'\uFF1A',listInfo[0].CUSTOMERNAME,' ',Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('先生/小姐','cec-plugin-stores'))),wp.element.createElement('p',{'class':'p mb-2'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('單號','cec-plugin-stores'),'\uFF1A',listInfo[0].FORMNUMBER),wp.element.createElement('p',{'class':'p mb-2'},listInfo[0].FIXITEM),wp.element.createElement('p',{'class':'p mb-0'},listInfo[0].STORE),listInfo[0].REMARK2&&wp.element.createElement('p',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('備註','cec-plugin-stores'),'\uFF1A',listInfo[0].REMARK2)),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(listInfo,function(item,idx){if(idx>0){return wp.element.createElement('a',{'class':'nav-link',id:'v-pills-tab-'+idx,'data-toggle':'pill',href:'#v-pills-'+idx,role:'tab','aria-controls':'v-pills-'+idx,'aria-selected':'false'},wp.element.createElement('div',{'class':'d-flex justify-content-between mb-2'},wp.element.createElement('p',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('客戶姓名','cec-plugin-stores'),'\uFF1A',item.CUSTOMERNAME,' ',Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('先生/小姐','cec-plugin-stores'))),wp.element.createElement('p',{'class':'p mb-2'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('單號','cec-plugin-stores'),'\uFF1A',item.FORMNUMBER),wp.element.createElement('p',{'class':'p mb-2'},item.FIXITEM),wp.element.createElement('p',{'class':'p mb-0'},item.STORE),item.REMARK2&&wp.element.createElement('p',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('備註','cec-plugin-stores'),'\uFF1A',item.REMARK2));}}))),wp.element.createElement('div',{'class':'col-auto'},wp.element.createElement('div',{'class':'tab-content',id:'v-pills-tabContent'},wp.element.createElement('div',{'class':'tab-pane fade active show ',id:'v-pills-0',role:'tabpanel','aria-labelledby':'#v-pills-tab-0'},wp.element.createElement('div',{'class':'maintain-timeline'},wp.element.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map([{step:1,icon:'icon-shipping',name:'商品已收件'},{step:2,icon:'icon-repair',name:'商品送件維修'},{step:3,icon:'icon-store',name:'商品已完修\n回店途中'},{step:4,icon:'icon-ready',name:'請顧客至原店取件'},{step:5,icon:'icon-customer',name:'顧客已取件'}],function(stepInfo){return wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(stepInfo.step<=listInfo[0].FIXPROGRESS&&listInfo[0].FIXPROGRESS<'6'&&'active',stepInfo.step==listInfo[0].FIXPROGRESS&&'is-active')},wp.element.createElement('div',{'class':'item'},wp.element.createElement('div',{'class':'icon'},wp.element.createElement('i',{className:stepInfo.icon})),wp.element.createElement('span',{'class':'dot'}),wp.element.createElement('div',{'class':'text'},wp.element.createElement('p',null,stringToBr(stepInfo.name)))));})))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(listInfo,function(item,idx){if(idx>0){return wp.element.createElement('div',{'class':'tab-pane fade ',id:'v-pills-'+idx,role:'tabpanel','aria-labelledby':'#v-pills-tab-'+idx},wp.element.createElement('div',{'class':'maintain-timeline'},wp.element.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map([{step:1,icon:'icon-shipping',name:'商品已收件'},{step:2,icon:'icon-repair',name:'商品送件維修'},{step:3,icon:'icon-store',name:'商品已完修\n回店途中'},{step:4,icon:'icon-ready',name:'請顧客至原店取件'},{step:5,icon:'icon-customer',name:'顧客已取件'}],function(stepInfo){return wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(stepInfo.step<=listInfo[0].FIXPROGRESS&&listInfo[0].FIXPROGRESS<'6'&&'active',stepInfo.step==item.FIXPROGRESS&&'is-active')},wp.element.createElement('div',{'class':'item'},wp.element.createElement('div',{'class':'icon'},wp.element.createElement('i',{className:stepInfo.icon})),wp.element.createElement('span',{'class':'dot'}),wp.element.createElement('div',{'class':'text'},wp.element.createElement('p',null,stringToBr(stepInfo.name)))));}))));}})))),wp.element.createElement('hr',{'class':'border-top border-gray my-5'}),wp.element.createElement('ol',{'class':'list-unstyled text-center text-muted mb-0'},wp.element.createElement('li',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('1. 送修時間約二至三週工作天，實際完成日會因廠商維修、待料等因素有所變動，完修後會主動以簡訊與您聯繫前來領取維修品。','cec-plugin-stores'),' '),wp.element.createElement('li',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('2. 請在接獲萬家福通知領回維修品後立即前來領取。如逾期三個月，恕不負保管責任。','cec-plugin-stores'),' '),wp.element.createElement('li',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('3.廠商費用報價經台端確認後礙難更改，有效保固證明(有蓋店章)或發票請於報價前提供。','cec-plugin-stores'),' '),wp.element.createElement('li',{'class':'p mb-0'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('4.商品故障原因依原廠判定，本公司不做判定。','cec-plugin-stores'))),wp.element.createElement('hr',{'class':'border-top border-gray my-5'})),wp.element.createElement('h4',{'class':'heading-title justify-content-center'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('需要進一步協助？','cec-plugin-stores')),wp.element.createElement('div',{'class':'my-5 text-center'},wp.element.createElement('div',{'class':'pb-5'},wp.element.createElement('p',{'class':'p text-muted mb-2',style:{fontSize:'16px'}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('請在營業時間內撥打','cec-plugin-stores')),wp.element.createElement('a',{'class':'p fw-400 mb-0 text-primary',style:{fontSize:'16px'},role:'button',href:VC_CONFIG.INDEX_URL+'/stores'},wp.element.createElement('u',null,Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('全國服務專線','cec-plugin-stores'))))))));}}]);return RepairInfo;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var RepairInfoEditor=function(_Component2){_inherits(RepairInfoEditor,_Component2);function RepairInfoEditor(){_classCallCheck(this,RepairInfoEditor);return _possibleConstructorReturn(this,(RepairInfoEditor.__proto__||Object.getPrototypeOf(RepairInfoEditor)).apply(this,arguments));}_createClass(RepairInfoEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-admin-tools'})),'\u5BB6\u96FB\u7DAD\u4FEE\u6A21\u7D44'),wp.element.createElement('p',null,'\u67E5\u8A62\u7DAD\u4FEE\u9032\u5EA6\u3001\u7DAD\u4FEE\u55AE\u3001\u7DAD\u4FEE\u55AE\u5167\u5BB9'));}}]);return RepairInfoEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___QZpda","container_1":"container_1___3iYKr","container_2":"container_2___2Rjrj"};

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StockStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StockStoreEditor", function() { return StockStoreEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_space_style__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_space_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_space_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_space__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_space___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_space__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_libs_AppHelper__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StockStore=function(_Component){_inherits(StockStore,_Component);function StockStore(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StockStore);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StockStore.__proto__||Object.getPrototypeOf(StockStore)).call.apply(_ref,[this].concat(args))),_this),_this.state={query:{city_id:null,area_id:null}},_this.handleChange=function(value,queryKey){var stateQuery=Object.assign({},_this.state.query);stateQuery[queryKey]=!isNaN(value)?value:null;if(queryKey==='city_id'){stateQuery.area_id=null;}_this.setState({query:stateQuery});__WEBPACK_IMPORTED_MODULE_5_libs_AppHelper__["a" /* default */].getStoreList(stateQuery);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StockStore,[{key:'render',value:function render(){var _this2=this;var configOptions=this.props.app.options||{};var cityListAll=configOptions.citys||[];var storeListAll=configOptions.stores||[];var query=this.state.query||{};var selectedCityId=query.city_id;var cityListAvailable=[].concat(_toConsumableArray(new Set(storeListAll.map(function(storeInfo){return storeInfo['store_city_name'];}))));var cityList=cityListAll.filter(function(obj){return cityListAvailable.indexOf(obj.name)>-1;}).map(function(obj){return Object.assign({},obj,{value:obj.id,label:obj.name});});var citySelected=cityList.filter(function(obj){return obj.value===selectedCityId;})||[];var areaListSelected=citySelected.length>0?[].concat(_toConsumableArray(new Set(storeListAll.filter(function(obj){return obj['store_city_name']===citySelected[0].name&&obj['status_name']!=='停用';}).map(function(obj){return obj['store_area_name'];})))):[];var areaList=citySelected.length>0?citySelected[0].children.filter(function(obj){return areaListSelected.indexOf(obj.name)>-1;}).map(function(obj){return{value:obj.id,label:obj.name};}):[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_space___default.a,{wrap:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u7E23\u5E02',style:{width:'112px'},onChange:function onChange(e){return _this2.handleChange(e,'city_id');},options:cityList}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_select___default.a,{placeholder:'\u8ACB\u9078\u64C7\u5340\u57DF',value:query.area_id,style:{width:'112px'},disabled:query.city_id===null,onChange:function onChange(e){return _this2.handleChange(e,'area_id');},options:areaList}));}}]);return StockStore;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);// 編輯器
var StockStoreEditor=function(_Component2){_inherits(StockStoreEditor,_Component2);function StockStoreEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,StockStoreEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=StockStoreEditor.__proto__||Object.getPrototypeOf(StockStoreEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef(),_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(StockStoreEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h5',null,'\u9580\u5E02\u9078\u64C7\u5668'));}}]);return StockStoreEditor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SpaceContext = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _configProvider = __webpack_require__(8);

var _Item = _interopRequireDefault(__webpack_require__(2178));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var SpaceContext = /*#__PURE__*/React.createContext({
  latestIndex: 0,
  horizontalSize: 0,
  verticalSize: 0
});
exports.SpaceContext = SpaceContext;
var spaceSize = {
  small: 8,
  middle: 16,
  large: 24
};

function getNumberSize(size) {
  return typeof size === 'string' ? spaceSize[size] : size || 0;
}

var Space = function Space(props) {
  var _classNames;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      space = _React$useContext.space,
      directionConfig = _React$useContext.direction;

  var _props$size = props.size,
      size = _props$size === void 0 ? (space === null || space === void 0 ? void 0 : space.size) || 'small' : _props$size,
      align = props.align,
      className = props.className,
      children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
      customizePrefixCls = props.prefixCls,
      split = props.split,
      style = props.style,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? false : _props$wrap,
      otherProps = __rest(props, ["size", "align", "className", "children", "direction", "prefixCls", "split", "style", "wrap"]);

  var _React$useMemo = React.useMemo(function () {
    return (Array.isArray(size) ? size : [size, size]).map(function (item) {
      return getNumberSize(item);
    });
  }, [size]),
      _React$useMemo2 = (0, _slicedToArray2["default"])(_React$useMemo, 2),
      horizontalSize = _React$useMemo2[0],
      verticalSize = _React$useMemo2[1];

  var childNodes = (0, _toArray["default"])(children, {
    keepEmpty: true
  });

  if (childNodes.length === 0) {
    return null;
  }

  var mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
  var prefixCls = getPrefixCls('space', customizePrefixCls);
  var cn = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(direction), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-align-").concat(mergedAlign), mergedAlign), _classNames), className);
  var itemClassName = "".concat(prefixCls, "-item");
  var marginDirection = directionConfig === 'rtl' ? 'marginLeft' : 'marginRight'; // Calculate latest one

  var latestIndex = 0;
  var nodes = childNodes.map(function (child, i) {
    if (child !== null && child !== undefined) {
      latestIndex = i;
    }
    /* eslint-disable react/no-array-index-key */


    return /*#__PURE__*/React.createElement(_Item["default"], {
      className: itemClassName,
      key: "".concat(itemClassName, "-").concat(i),
      direction: direction,
      index: i,
      marginDirection: marginDirection,
      split: split,
      wrap: wrap
    }, child);
    /* eslint-enable */
  });
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: cn,
    style: (0, _extends2["default"])((0, _extends2["default"])({}, wrap && {
      flexWrap: 'wrap',
      marginBottom: -verticalSize
    }), style)
  }, otherProps), /*#__PURE__*/React.createElement(SpaceContext.Provider, {
    value: {
      horizontalSize: horizontalSize,
      verticalSize: verticalSize,
      latestIndex: latestIndex
    }
  }, nodes));
};

var _default = Space;
exports["default"] = _default;

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreInfoEditor", function() { return StoreInfoEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
var StoreInfo=function(_Component){_inherits(StoreInfo,_Component);function StoreInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreInfo.__proto__||Object.getPrototypeOf(StoreInfo)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:'info',storeInfo:undefined,query:{}},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get($magicLine,0)){__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this);//console.log('basic-tabs-label', $el)
leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(){var urlQuery=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getURLQuery();var store=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(urlQuery,'store');if(!store)return _this.props.history.replace('/stores');_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+('/api/v1/stores/'+store),null,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_1_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/stores');return;}_this.setState({storeInfo:data},function(){_this.reloadMaps();_this.reloadTab();_this.ServiceCollapse();});});},_this.reloadMaps=function(){var _this$state=_this.state,map=_this$state.map,maps=_this$state.maps,storeInfo=_this$state.storeInfo;//console.log('reloadMaps', map, maps)
if(!maps||!map||!storeInfo)return;var stores=[storeInfo];if(!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(stores)||stores.length===0)return;if(Array.isArray(_this.state.markers)){_this.state.markers.forEach(function(marker){return marker.setMap(null);});}// zoom預設為能呈現出地形等高線的大小
// 所以改成呈現最新的裝置位置
var bounds=new maps.LatLngBounds();var markers=stores.map(function(store,idx){var icon='';if(store.store_type_id==2)icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-m-loc.png';else icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-loc.png';var marker=new maps.Marker({map:map,position:{lat:store.latitude,lng:store.longitude},store:store,icon:icon});var infowindow=new maps.InfoWindow({content:'<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">'+store.name+'</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">'+store.address+'</div> </div> </div>'});marker.addListener('click',function(){infowindow.open(map,marker);});// marker.addListener('mouseover', function () {
//   infowindow.open(map, marker);
// });
// marker.addListener('mouseout', function () {
//   infowindow.close();
// });
if(idx==0){bounds.extend(marker.getPosition());}return marker;});map.fitBounds(bounds);map.setZoom(16);_this.setState({markers:markers});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(query,key,value);_this.setState({query:query});},_this.getSearchPath=function(query){return window.location.origin+(window.VC_CONFIG.INDEX_URL+'/stores/#')+__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(query,{skipNull:true});},_this.ServiceCollapse=function(){var iconCollapse=__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.icon_service-collapse');var iconCollapseIn=__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.icon_service-collapse-in');iconCollapse.css({height:__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.icon_service-block .inner').height()+20+30+'px'});__WEBPACK_IMPORTED_MODULE_8_jquery___default()(document).on('click','.icon_service-collapse .collapse-link',function(){__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).parent().toggleClass('show');if(iconCollapse.hasClass('show')){iconCollapse.css({height:iconCollapseIn.height()+24+'px'});}else{iconCollapse.css({height:__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.icon_service-block .inner').height()+20+30+'px'});}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreInfo,[{key:'componentDidMount',value:function componentDidMount(){this.loadConfig();this.setState({tabType:__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getHashValue('tab')||'info'});this.loadData();}},{key:'render',value:function render(){var _this2=this;var urlQuery=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getURLQuery();var storeInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.storeInfo',{});var tabType=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.tabType',{});var options=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.query',{});var listInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'props.stores.listInfo',[]);var news=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'news',[]);var services=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'services',[]);var foods=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'foods',[]);var brands=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'brands',[]);var banners=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'banners',[]);this.refreshPicker();var storeBanner=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,'images.0');var Local=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('div',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+window.VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/stores'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('分店搜尋','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page',id:'name'},storeInfo.name)))))),wp.element.createElement('div',{'class':'banner-location'},(storeInfo.en_name||storeInfo.name)&&wp.element.createElement('div',{'class':'banner-image'},wp.element.createElement('img',{src:storeBanner?storeBanner:PLUGIN_ASSETS_URL+'img/banner/store/banner-store.png',alt:''}),Local=='en_US'&&storeInfo.en_name&&wp.element.createElement('h3',{'class':'title'},''+storeInfo.en_name),(Local=='zh_TW'||Local=='en_US'&&!storeInfo.en_name)&&storeInfo.name&&wp.element.createElement('h3',{'class':'title'},''+storeInfo.name))),wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'mt-4'},wp.element.createElement('div',{'class':'mb-5 basic-tabs-label'},wp.element.createElement('ul',{'class':'nav nav-pills',id:'pills-tab'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map([{type:'info',name:Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('分店資訊','cec-plugin-stores')},{type:'foods',name:Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('美食餐廳','cec-plugin-stores')},{type:'brands',name:Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('專櫃介紹','cec-plugin-stores')}],function(item){return wp.element.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-item',item.type===tabType?'current_page_item highlight':null),key:item.type},item.type=='info'&&wp.element.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-link'),href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+urlQuery.store+'#tab='+item.type,onClick:function onClick(){return _this2.setState({tabType:item.type},function(){_this2.reloadTab();});}},item.name),item.type=='foods'&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(foods)&&foods.length>0&&wp.element.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-link'),href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+urlQuery.store+'#tab='+item.type,onClick:function onClick(){return _this2.setState({tabType:item.type},function(){_this2.reloadTab();});}},item.name),item.type=='brands'&&__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(brands)&&brands.length>0&&wp.element.createElement('a',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('nav-link'),href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+urlQuery.store+'#tab='+item.type,onClick:function onClick(){return _this2.setState({tabType:item.type},function(){_this2.reloadTab();});}},item.name));})))),tabType==='info'&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap pt-3'}),wp.element.createElement('h4',{'class':'heading-title justify-content-center'},(Local=='zh_TW'||Local=='en_US'&&!storeInfo.en_name)&&storeInfo.name&&storeInfo.name,Local=='en_US'&&storeInfo.en_name&&storeInfo.en_name),wp.element.createElement('hr',{'class':'border-top border-primary mt-0 mb-5'})),wp.element.createElement('div',{'class':'map-section',id:'map'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_google_map_react___default.a,{bootstrapURLKeys:{key:__WEBPACK_IMPORTED_MODULE_11__configs_env__["f" /* GOOGLE_MAP_KEY */]},defaultCenter:[25.1243218,121.4971524],defaultZoom:13,options:{mapTypeControl:false,styles:[{elementType:'all'}]},onGoogleApiLoaded:function onGoogleApiLoaded(_ref2){var map=_ref2.map,maps=_ref2.maps;return _this2.setState({map:map,maps:maps},function(){return _this2.reloadMaps();});}})),wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'store-traffic-info my-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('div',{'class':'d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom'},wp.element.createElement('h6',{'class':'h6 text-navy mb-0'},'\u57FA\u672C\u8CC7\u8A0A'),wp.element.createElement('a',{'class':'h4 mb-0',role:'button',href:storeInfo.fb||'https://www.facebook.com/prosperity.tw/',target:'_blank'},' ',wp.element.createElement('i',{'class':'fab fa-facebook'})))),wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_map'}),wp.element.createElement('span',null,(Local=='zh_TW'||Local=='en_US'&&!storeInfo.address)&&storeInfo.address&&storeInfo.address,' ',Local=='en_US'&&storeInfo.en_street&&storeInfo.en_street,wp.element.createElement('a',{'class':'gMap-link',role:'button'// href={`https://www.google.com.tw/maps/place/${
//   storeInfo.address
// }`}
,href:storeInfo.store_link?storeInfo.store_link:'https://www.google.com.tw/maps/place/'+storeInfo.address,target:'_blank'},wp.element.createElement('img',{'class':'ml-3',src:PLUGIN_ASSETS_URL+'img/icon/google_map.svg',alt:'map'})))),storeInfo.contact_tel&&wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_phone'}),wp.element.createElement('span',null,wp.element.createElement('a',{href:'tel:+886-'+storeInfo.contact_tel},storeInfo.contact_tel))),storeInfo.contact_fax&&wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-fax'}),wp.element.createElement('span',null,storeInfo.contact_fax)))),storeInfo.business_hours&&wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_clock'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('營業時間','cec-plugin-stores'),wp.element.createElement('br',null),Local=='en_US'&&storeInfo.en_business_hours&&stringToBr((storeInfo.en_business_hours?storeInfo.en_business_hours:'').split('<BR>').join('')),(Local=='zh_TW'||Local=='en_US'&&!storeInfo.en_business_hours)&&stringToBr((storeInfo.business_hours?storeInfo.business_hours:'').split('<BR>').join('')))))),storeInfo.business_hours_special&&Local=='zh_TW'&&wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_conversation'}),wp.element.createElement('span',null,stringToBr((storeInfo.business_hours_special?storeInfo.business_hours_special:'').split('<BR>').join('')))))),storeInfo.en_business_hours_special&&Local=='en_US'&&wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,' ',wp.element.createElement('i',{'class':'icon-store_conversation'}),wp.element.createElement('span',null,stringToBr((storeInfo.en_business_hours_special?storeInfo.en_business_hours_special:'').split('<BR>').join('')))))),wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},(storeInfo.bus_info&&Local=='zh_TW'||!storeInfo.en_bus_info&&Local=='en_US')&&wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_bus'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('公車交通方式','cec-plugin-stores'),wp.element.createElement('br',null),stringToBr((storeInfo.bus_info?storeInfo.bus_info:'').split('<BR>').join('')))),storeInfo.en_bus_info&&Local=='en_US'&&wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_bus'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('公車交通方式','cec-plugin-stores'),wp.element.createElement('br',null),stringToBr((storeInfo.en_bus_info?storeInfo.en_bus_info:'').split('<BR>').join('')))),(storeInfo.traffic_info&&Local=='zh_TW'||!storeInfo.en_traffic_info&&Local=='en_US')&&wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_train'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('其他交通方式','cec-plugin-stores'),wp.element.createElement('br',null),stringToBr((storeInfo.traffic_info?storeInfo.traffic_info:'').split('<BR>').join('')))),storeInfo.en_traffic_info&&Local=='en_US'&&wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_train'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('其他交通方式','cec-plugin-stores'),wp.element.createElement('br',null),stringToBr((storeInfo.en_traffic_info?storeInfo.en_traffic_info:'').split('<BR>').join('')))))),wp.element.createElement('div',{'class':'col-12'},wp.element.createElement('h6',{'class':'h6 text-navy py-3 mb-3 border-bottom'},'\u505C\u8ECA\u8CC7\u8A0A')),wp.element.createElement('div',{'class':'col-md-6 col-lg-3'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-store_car'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('停車資訊','cec-plugin-stores'),wp.element.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('汽車停車位','cec-plugin-stores'),' ',!storeInfo.parking_spaces_car&&storeInfo.parking_spaces_car!=0&&0,storeInfo.parking_spaces_car&&storeInfo.parking_spaces_car,' ',Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('位','cec-plugin-stores'),' ',wp.element.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('機車停車位','cec-plugin-stores'),' ',!storeInfo.parking_spaces_moto&&storeInfo.parking_spaces_moto!=0&&0,storeInfo.parking_spaces_moto&&storeInfo.parking_spaces_moto,' ',Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('位','cec-plugin-stores'),wp.element.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('汽車無障礙車位','cec-plugin-stores'),' ',!storeInfo.parking_spaces_handicapped&&storeInfo.parking_spaces_handicapped!=0&&0,storeInfo.parking_spaces_handicapped&&storeInfo.parking_spaces_handicapped,' ',Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('位','cec-plugin-stores'),wp.element.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('親子車位','cec-plugin-stores'),' ',!storeInfo.parking_spaces_parent&&storeInfo.parking_spaces_parent!=0&&0,storeInfo.parking_spaces_parent&&storeInfo.parking_spaces_parent,' ',Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('位','cec-plugin-stores'),wp.element.createElement('br',null))))),wp.element.createElement('div',{'class':'col-md-6 col-lg-9'},wp.element.createElement('ul',{'class':'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{'class':'icon-parking'}),wp.element.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('停車收費方式','cec-plugin-stores'),wp.element.createElement('br',null),(Local=='zh_TW'&&storeInfo.parking_info||Local=='en_US'&&!storeInfo.en_parking_info)&&stringToBr((storeInfo.parking_info?storeInfo.parking_info:'').split('<BR>').join('')),Local=='en_US'&&storeInfo.en_parking_info&&stringToBr((storeInfo.en_parking_info?storeInfo.en_parking_info:'').split('<BR>').join('')))))))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(services)&&services.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('h4',{'class':'heading-title align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('分店服務','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'icon_service-collapse'},wp.element.createElement('div',{'class':'icon_service-collapse-in row no-gutters mx-n3'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(services,function(serviceInfo){return wp.element.createElement('div',{'class':'col-6 col-sm-4 col-md-3 col-lg-auto icon_service-wrap px-3'},wp.element.createElement('a',{role:'button','class':'icon_service-block'// href='javascript:void(0)'
,'data-toggle':'modal','data-target':'#icon-service-modal-'+serviceInfo.id,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('span',{'class':'inner'},wp.element.createElement('img',{src:serviceInfo.icon,alt:serviceInfo.name}),wp.element.createElement('span',{'class':'name'},serviceInfo.name))));})),wp.element.createElement('a',{'class':'collapse-link'// href='javascript:void(0);'
,role:'button',onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('span',null,wp.element.createElement('i',{'class':'fas fa-angle-double-down'})))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(services,function(serviceInfo){return wp.element.createElement('div',{'class':'modal fade',id:'icon-service-modal-'+serviceInfo.id,tabindex:'-1',role:'dialog','aria-labelledby':'icon-service-modalTitle','aria-hidden':'true'},wp.element.createElement('div',{'class':'modal-dialog modal-dialog-centered',role:'document'},wp.element.createElement('div',{'class':'modal-content'},wp.element.createElement('div',{'class':'modal-header border-0'},wp.element.createElement('button',{'class':'text-navy close',type:'button','data-dismiss':'modal','aria-label':'Close'},wp.element.createElement('span',{'class':'text-navy','aria-hidden':'true'},'\xD7'))),wp.element.createElement('div',{'class':'modal-body px-5 pb-5'},wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-3'},wp.element.createElement('img',{style:{width:'100%'},src:serviceInfo.icon,alt:serviceInfo.name})),wp.element.createElement('div',{'class':'col-9'},wp.element.createElement('h6',{'class':'h4 text-navy mb-4'},serviceInfo.name),wp.element.createElement('p',{'class':'h6 fw-300 text-font text-justify'},serviceInfo.desc)))))));})),wp.element.createElement('div',{'class':'row my-5'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(storeInfo.deliveries,function(vendor){return vendor.vendor_type===1;})!==undefined&&wp.element.createElement('div',{'class':'col-md-6 mb-md-0 mb-4'},wp.element.createElement('a',{'class':'d-block bg-sky text-decoration-none p-4',role:'button',href:window.VC_CONFIG.INDEX_URL+'/store-vendor?type=1&id='+storeInfo.id},wp.element.createElement('div',{'class':'p-2'},wp.element.createElement('h5',{'class':'h6 text-center mb-5'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('美食外送','cec-plugin-stores')),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-10 col-lg-9 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:PLUGIN_ASSETS_URL+'img/store/svg/delivery.svg',alt:'\u7F8E\u98DF\u5916\u9001'})))))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(storeInfo.deliveries,function(vendor){return vendor.vendor_type===2;})!==undefined&&wp.element.createElement('div',{'class':'col-md-6 mb-md-0 mb-4'},wp.element.createElement('a',{'class':'d-block bg-sky text-decoration-none p-4',role:'button',href:window.VC_CONFIG.INDEX_URL+'/store-vendor?type=2&id='+storeInfo.id},wp.element.createElement('div',{'class':'p-2'},wp.element.createElement('h5',{'class':'h6 text-center mb-5'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('商店購物','cec-plugin-stores')),wp.element.createElement('div',{'class':'row'},wp.element.createElement('div',{'class':'col-md-10 col-lg-9 mx-auto'},wp.element.createElement('img',{'class':'img-contain',src:PLUGIN_ASSETS_URL+'img/store/svg/ec.svg',alt:'\u5546\u5E97\u8CFC\u7269'}))))))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(banners)&&banners.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('h4',{'class':'heading-title justify-content-center'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('分店活動','cec-plugin-stores')),wp.element.createElement('hr',{'class':'border-top border-gray mt-0 mb-4'}),wp.element.createElement('div',{'class':'row no-gutters mx-n3'},banners.map(function(banner){return wp.element.createElement('div',{className:'col-md-6 px-3 mb-4'},wp.element.createElement('a',{'class':'card h-100 text-decoration-none border-0 shadow-0 p-0',role:'button',href:banner.link},wp.element.createElement('div',{'class':'img-2-1',style:{backgroundImage:'url('+banner.url+')'}})));}))))),[{type:'foods',name:Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('美食餐廳','cec-plugin-stores')},{type:'brands',name:Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('專櫃介紹','cec-plugin-stores')}].filter(function(tabInfo){return tabInfo.type===tabType;}).map(function(tabInfo){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('div',{'class':'container'},wp.element.createElement('h4',{'class':'heading-title justify-content-center'},tabInfo.name),wp.element.createElement('hr',{'class':'border-top border-navy mt-0 mb-4'}),wp.element.createElement('div',{'class':'mb-5'},wp.element.createElement('div',{'class':'row'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(storeInfo,tabInfo.type,[]),function(brandInfo){return wp.element.createElement('div',{'class':'col-4 col-md-3 col-lg-2 my-4'},wp.element.createElement('a',{role:'button','class':'store-brand-logo-link',href:INDEX_URL+'/brand-info'+(Locale=='en_US'?'-en':'')+'/?brand='+brandInfo.name},wp.element.createElement('img',{src:brandInfo.logo,alt:brandInfo.name})));})))));})));}}]);return StoreInfo;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var StoreInfoEditor=function(_Component2){_inherits(StoreInfoEditor,_Component2);function StoreInfoEditor(){_classCallCheck(this,StoreInfoEditor);return _possibleConstructorReturn(this,(StoreInfoEditor.__proto__||Object.getPrototypeOf(StoreInfoEditor)).apply(this,arguments));}_createClass(StoreInfoEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return StoreInfoEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreListEditor", function() { return StoreListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(window,'VC_CONFIG.Locale');var STORE_TYPE_IMAGE_URL_MAP={1:PLUGIN_ASSETS_URL+'/img/store/storeImage_a.png',2:PLUGIN_ASSETS_URL+'/img/store/storeImage_s.png'};var getStoreImageUrl=function getStoreImageUrl(store){var storeTypeId=Number(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(store,'store_type_id'));return STORE_TYPE_IMAGE_URL_MAP[storeTypeId];};// 前端頁面
var defaultQuery={store_type_id:null,city_id:null,area_id:null,id:null,is24h:null,service_ids:[]};var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],// 分頁
listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},query:Object.assign({},defaultQuery),hotKey:[13,86,29],configOptions:{},visible:false},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_5_jquery___default()(document).on('click','#store div a',function(){var $text=__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).attr('alt');dataLayer.push({event:'store_click',item:$text});});},_this.loadData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultQuery;var callback=arguments[1];if(_this.getStoreListCancel){_this.getStoreListCancel('Cancel Last Query');}var store_type_id=query.store_type_id,city_id=query.city_id,area_id=query.area_id,id=query.id,service_ids=query.service_ids,is24h=query.is24h;__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/v1/stores',{headers:__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].getHeaders(),cancelToken:new __WEBPACK_IMPORTED_MODULE_6_axios__["CancelToken"](function(cancel){_this.getStoreListCancel=cancel;}),params:{store_type_id:store_type_id,city_id:city_id,area_id:area_id,id:id,service_ids:service_ids,is24h:is24h,page_size:'all'}}).then(function(response){var _response$status=response.status,status=_response$status===undefined?100:_response$status,_response$data=response.data;_response$data=_response$data===undefined?{}:_response$data;var _response$data$code=_response$data.code,code=_response$data$code===undefined?100:_response$data$code,_response$data$reason=_response$data.reason,reason=_response$data$reason===undefined?'未知錯誤':_response$data$reason,_response$data$data=_response$data.data,data=_response$data$data===undefined?{}:_response$data$data;var resp={status:status,code:code,reason:reason,data:data};_this.setState({data:[],listInfo:data},function(){_this.reloadMaps();_this.handleInfiniteOnLoad();if(callback)callback(resp);});}).catch(function(error){var _error$response=error.response;_error$response=_error$response===undefined?{}:_error$response;var _error$response$data=_error$response.data;_error$response$data=_error$response$data===undefined?{}:_error$response$data;var _error$response$data$=_error$response$data.code,code=_error$response$data$===undefined?100:_error$response$data$,_error$response$data$2=_error$response$data.reason,reason=_error$response$data$2===undefined?'未知錯誤':_error$response$data$2,_error$response$data$3=_error$response$data.data,data=_error$response$data$3===undefined?{}:_error$response$data$3;if(__WEBPACK_IMPORTED_MODULE_6_axios___default.a.isCancel(error)){code=0;reason='canceled';}if(callback)callback({code:code,reason:reason,data:data,error:error});});},100),_this.reloadMaps=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function(){var _this$state=_this.state,map=_this$state.map,maps=_this$state.maps;if(!maps||!map)return;var stores=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this,'state.listInfo.rows',[]);if(!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(stores)||stores.length===0)return;if(Array.isArray(_this.state.markers)){_this.state.markers.forEach(function(marker){return marker.setMap(null);});}// zoom預設為能呈現出地形等高線的大小
// 所以改成呈現最新的裝置位置
var bounds=new maps.LatLngBounds();var markers=stores.map(function(store,idx){var icon='';switch(store.store_type_id){case 1:icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-loc.png';break;case 2:icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/cec-m-loc.png';break;case 3:icon=window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/icon/wellcome-loc.png';break;default:break;}var marker=new maps.Marker({map:map,position:{lat:store.latitude,lng:store.longitude},store:store,icon:icon});var infowindow=new maps.InfoWindow({content:'<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">'+store.name+'</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">'+store.address+'</div> </div> </div>'});marker.addListener('click',function(){infowindow.open(map,marker);});// marker.addListener('mouseover', function () {
//   infowindow.open(map, marker);
// });
// marker.addListener('mouseout', function () {
//   infowindow.close();
// });
if(idx==0){bounds.extend(marker.getPosition());}return marker;});map.fitBounds(bounds);map.setZoom(16);_this.setState({markers:markers});},100),_this.loadConfig=function(){__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({configOptions:data.options});});},_this.refreshPicker=function(){var query=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker[name=id]').selectpicker('val',__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(query,'id'));__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker').selectpicker('refresh');},_this.getSearchPath=function(query){return window.VC_CONFIG.INDEX_URL+'/stores/#'+__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify(query,{skipNull:true});},_this.handleInfiniteOnLoad=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function(page){var listInfo=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this,'state.listInfo');_this.setState({loading:true});var data=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(listInfo,'rows'),0,data.length+3);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100),_this.resetSearch=function(){var storeItemCount=0;__WEBPACK_IMPORTED_MODULE_5_jquery___default()('#more-filter #item > div > span').each(function(){if(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).hasClass('is-active')){__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).removeClass('is-active');//移除啟動模式
__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).removeClass('btn-primary');//移除原始按鈕樣式
__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass('btn-outline-primary');}});if(storeItemCount>0){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rounded-circle.service-filter-count').addClass('d-inline-flex');__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rounded-circle.service-filter-count').show();}else{__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rounded-circle.service-filter-count').removeClass('d-inline-flex');__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.rounded-circle.service-filter-count').hide();}__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.service-filter-count').text(storeItemCount);_this.setState({query:Object.assign({},_this.state.query,{service_ids:[]})});},_this.handleChangeSelect=function(e,queryKey){window.location.hash='';var query=Object.assign({},_this.state.query);query[queryKey]=!isNaN(Number(e.target.value))?Number(e.target.value):null;if(queryKey==='city_id'){query.area_id=null;}if(['store_type_id','city_id','area_id'].indexOf(queryKey)!==-1){query.id=null;}_this.loadData(query);_this.setState({query:query});_this.refreshPicker();// 更新下拉選單
},_this.handleSwitch24Hr=function(value){var query=Object.assign({},_this.state.query);value?query.is24h=1:query.is24h=null;_this.setState({query:query},function(){return _this.loadData(query);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:'componentDidMount',value:function componentDidMount(){var isFromWellcomePage=window.location.hash.includes('wellcome');this.loadConfig();if(isFromWellcomePage){this.loadData(Object.assign({},defaultQuery,{store_type_id:3}));this.setState({query:Object.assign({},defaultQuery,{store_type_id:3})});}else{this.loadData();}this.GTM();this.refreshPicker();// 更新下拉選單
}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.refreshPicker();}},{key:'render',value:function render(){var _this2=this;var listInfo=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.listInfo',[]);var data=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.data');var query=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.query',{});var selectedCityId=query.city_id;var configOptions=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.configOptions',{});var hotKey=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this,'state.hotKey');var categoryOptions=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(configOptions,'service_categories',[]).filter(function(categoryInfo){return!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(categoryInfo.items);});var storeTypes=configOptions.store_types||[];var cityListAll=configOptions.citys||[];var storeListAll=configOptions.stores||[];var storeTypeName=storeTypes.filter(function(obj){return obj.id===query.store_type_id;}).map(function(obj){return obj.name;})[0]||'';var cityListAvailable=[].concat(_toConsumableArray(new Set(storeListAll.map(function(storeInfo){return storeInfo['store_city_name'];}))));var cityList=cityListAll.filter(function(obj){return cityListAvailable.indexOf(obj.name)>-1;});var citySelected=cityList.filter(function(obj){return obj.id===selectedCityId;})||[];var areaListSelected=citySelected.length>0?[].concat(_toConsumableArray(new Set(storeListAll.filter(function(obj){if(storeTypeName){return obj['store_city_name']===citySelected[0].name&&obj['store_type_name']===storeTypeName&&obj['status_name']!=='停用';}else{return obj['store_city_name']===citySelected[0].name&&obj['status_name']!=='停用';}}).map(function(obj){return obj['store_area_name'];})))):[];var areaList=citySelected.length>0?citySelected[0].children.filter(function(obj){return areaListSelected.indexOf(obj.name)>-1;}):[];var service_categorys=categoryOptions;this.refreshPicker();// 更新下拉選單
return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,wp.element.createElement('div',{className:'banner-location'},wp.element.createElement('div',{id:'map'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_google_map_react___default.a,{bootstrapURLKeys:{key:__WEBPACK_IMPORTED_MODULE_11__configs_env__["f" /* GOOGLE_MAP_KEY */]},defaultCenter:[25.1243218,121.4971524],defaultZoom:13,options:{mapTypeControl:false,styles:[{elementType:'all'}]},yesIWantToUseGoogleMapApiInternals:true,onGoogleApiLoaded:function onGoogleApiLoaded(_ref2){var map=_ref2.map,maps=_ref2.maps;return _this2.setState({map:map,maps:maps},function(){return _this2.reloadMaps();});}})),wp.element.createElement('div',{className:'map-filter-bar'},wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row justify-content-center no-gutters mx-n2'},wp.element.createElement('div',{className:'col-md-2 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'store_type_id',value:query.store_type_id,'data-none-selected-text':Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇分店型態','cec-plugin-stores'),onChange:function onChange(e){return _this2.handleChangeSelect(e,'store_type_id');}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇分店型態','cec-plugin-stores'),' '),storeTypes.map(function(item){return wp.element.createElement('option',{key:item.id,value:item.id},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])(item.name,'cec-plugin-stores'));})))),wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'city_id',value:query.city_id,'data-none-selected-text':Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇城市','cec-plugin-stores'),onChange:function onChange(e){return _this2.handleChangeSelect(e,'city_id');}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇城市','cec-plugin-stores')),cityList.map(function(city){return wp.element.createElement('option',{key:city.id,value:city.id},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])(city.name,'cec-plugin-stores'));})))),wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'area_id',value:query.area_id,'data-none-selected-text':Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇區域','cec-plugin-stores'),disabled:query.city_id===null,onChange:function onChange(e){return _this2.handleChangeSelect(e,'area_id');}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇區域','cec-plugin-stores')),areaList.map(function(area){return wp.element.createElement('option',{key:area.id,value:area.id},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])(area.name,'cec-plugin-stores'));})))),wp.element.createElement('div',{className:'col-md-3 px-2'},wp.element.createElement('div',{className:'form-group'},wp.element.createElement('select',{className:'form-select selectpicker',name:'id','data-none-selected-text':Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇分店','cec-plugin-stores'),value:query.id,onChange:function onChange(e){return _this2.handleChangeSelect(e,'id');}},wp.element.createElement('option',{value:null},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請選擇分店','cec-plugin-stores'),' '),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(listInfo,'rows',[]),function(item){return wp.element.createElement('option',{key:item.id,value:item.id},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])(item.name,'cec-plugin-stores'));})))))))),wp.element.createElement('main',{className:'bg-light',style:{minHeight:'400px'}},wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'d-flex flex-md-row flex-column align-items-md-center justify-content-between pt-4'},Locale==='en_US'?wp.element.createElement('p',{className:'p fw-300 mb-0 d-md-inline-flex align-items-center text-primary'},listInfo.total,' stores match your search criteria'):wp.element.createElement('p',{className:'p fw-300 mb-0 d-md-inline-flex align-items-center text-primary'},'\u76EE\u524D\u5730\u5716\u7BC4\u570D\u5167',wp.element.createElement('br',{className:'d-block d-md-none'}),'\u7B26\u5408\u641C\u5C0B\u689D\u4EF6\u5171',' ',wp.element.createElement('span',{className:'h3 mb-0 px-1 px-md-3 fw-700 line-hight-fit text-center'},listInfo.total,' '),'\u9593\u5206\u5E97'),wp.element.createElement('div',{className:'d-flex align-items-md-center mt-md-0 mt-4'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default.a,{checkedChildren:Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('24小時營業','cec-plugin-stores'),unCheckedChildren:Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('24小時營業','cec-plugin-stores'),onChange:this.handleSwitch24Hr}),Locale!=='en_US'&&wp.element.createElement('a',{className:'p d-inline-block d-md-inline-flex align-items-center text-primary ml-auto text-decoration-none text-nowrap',role:'button'// href='javascript:void(0)'
,'data-toggle':'modal','data-target':'#more-filter',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('服務篩選','cec-plugin-stores'),wp.element.createElement('span',{className:'rounded-circle text-white bg-primary note line-hight-fit align-items-center justify-content-center ml-2 mb-0 service-filter-count',style:{display:'none',width:'20px',height:'20px'}},'0'),wp.element.createElement('i',{className:'note icon-plus ml-2'})))),wp.element.createElement('div',{className:'modal modal-store-service-morefilter fade',id:'more-filter',tabindex:'-1',role:'dialog','aria-labelledby':'more-filterTitle','aria-hidden':'true'},wp.element.createElement('div',{className:'modal-dialog modal-dialog-centered modal-dialog-scrollable',role:'document'},wp.element.createElement('div',{className:'modal-content'},wp.element.createElement('div',{'class':'modal-header pl-lg-5 border-primary'},wp.element.createElement('div',{'class':'d-flex align-items-center justify-content-between flex-fill'},wp.element.createElement('span',null,'\xA0'),wp.element.createElement('h5',{'class':'p text-primary modal-title mb-0',id:'more-filterTitle'},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('請點選下列您所需的服務','cec-plugin-stores')),wp.element.createElement('button',{'class':'text-navy close m-0',type:'button','data-dismiss':'modal','aria-label':'Close'},wp.element.createElement('span',{'class':'text-navy','aria-hidden':'true'},'\xD7')))),wp.element.createElement('div',{className:'modal-body px-lg-5 pb-5'},wp.element.createElement('div',{className:'row no-gutters mx-n2',id:'item'},wp.element.createElement('h6',{'class':'p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'},'\u71B1\u9580\u670D\u52D9'),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(service_categorys,function(categoryInfo){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(hotKey,function(key){return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(categoryInfo,'items',[]).filter(function(item){return key==item.id;}),function(serviceInfo){return wp.element.createElement('div',{className:'col-auto px-2'},wp.element.createElement('span',{className:'p btn btn-outline-primary px-3 rounded-pill my-2 service-badge',role:'button',id:serviceInfo.id,onClick:function onClick(e){if(!__WEBPACK_IMPORTED_MODULE_5_jquery___default()(e.target).hasClass('is-active')){var temp=_this2.state.query.service_ids;var index=temp.findIndex(function(e){return e==serviceInfo.id;});_this2.state.query.service_ids.splice(index,1);}else{_this2.state.query.service_ids.push(serviceInfo.id);}}},serviceInfo.name,wp.element.createElement('a',{className:'close note ml-2',role:'button'// href='javascript:void(0)'
,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('i',{className:'icon-close'}))));});});})),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(service_categorys,function(categoryInfo){return wp.element.createElement('div',{className:'row no-gutters mx-n2',id:'item'},wp.element.createElement('h6',{'class':'p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'},categoryInfo.name),__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(categoryInfo,'items',[]),function(serviceInfo){if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(hotKey,function(key){return key==serviceInfo.id;}))return wp.element.createElement('div',null);else{return wp.element.createElement('div',{className:'col-auto px-2'},wp.element.createElement('span',{className:'p btn btn-outline-primary px-3 rounded-pill my-2 service-badge',role:'button',id:serviceInfo.id,onClick:function onClick(e){if(!__WEBPACK_IMPORTED_MODULE_5_jquery___default()(e.target).hasClass('is-active')){var temp=_this2.state.query.service_ids;var index=temp.findIndex(function(e){return e==serviceInfo.id;});_this2.state.query.service_ids.splice(index,1);}else{_this2.state.query.service_ids.push(serviceInfo.id);}}},serviceInfo.name,wp.element.createElement('a',{className:'close note ml-2',role:'button'// href='javascript:void(0)'
,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('i',{className:'icon-close'}))));}}));})),wp.element.createElement('div',{className:'modal-footer border-primary px-lg-5'},wp.element.createElement('div',{className:'row align-items-center justify-content-center justify-content-md-between flex-fill'},wp.element.createElement('div',{className:'col-8 col-md-6 ml-md-auto order-md-2'},wp.element.createElement('div',{'class':'d-flex align-items-center',id:'item-bottom'},wp.element.createElement('a',{className:'btn btn-block btn-outline-primary rounded-pill my-0 mx-2',role:'button',id:'reset'// data-dismiss="modal"
// aria-label="Close"
// href='javascript:void(0)'
,onClick:function onClick(e){e.preventDefault();_this2.resetSearch();}},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('重選','cec-plugin-stores')),wp.element.createElement('a',{className:'btn btn-block btn-outline-primary rounded-pill my-0 mx-2',role:'button','data-dismiss':'modal','aria-label':'Close',href:this.getSearchPath(query),onClick:function onClick(){return _this2.loadData(query);}},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('確認','cec-plugin-stores')))),wp.element.createElement('div',{className:'col-md-auto text-md-left text-center order-md-1'},wp.element.createElement('p',{className:'p text-primary mb-0 d-inline-flex align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('您已選擇','cec-plugin-stores'),wp.element.createElement('span',{className:'h5 px-2 mb-0 text-orange line-hight-fit service-filter-count'},'0'),Object(__WEBPACK_IMPORTED_MODULE_9__wordpress_i18n__["__"])('種服務','cec-plugin-stores'),wp.element.createElement('span',{className:'h6 text-gray ml-3 mb-0',role:'button',href:'#','data-toggle':'tooltip','data-placement':'top',title:'\u8CBC\u5FC3\u63D0\u9192\uFF1A\u82E5\u9078\u64C7\u592A\u591A\u670D\u52D9\u9805\u76EE\uFF0C\u5C07\u6709\u53EF\u80FD\u641C\u5C0B\u4E0D\u5230\u76F8\u61C9\u9580\u5E02\uFF0C\u8ACB\u659F\u914C\u60A8\u7684\u9078\u64C7\u3002'},wp.element.createElement('i',{className:'far fa-question-circle'}))))))))),wp.element.createElement('section',{className:'pt-md-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement('div',{id:'store',className:'row'},__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(item){return wp.element.createElement('div',{className:'col-md-6 col-lg-4 d-flex align-items-stretch'},wp.element.createElement('div',{className:'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('a',{alt:item.name,className:'card-body',role:'button',href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+item.name+'#tab=info',style:{position:'relative'}},item.is24h&&wp.element.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_10__styles_module_scss___default.a['hour-24-tag']},'24h'),wp.element.createElement('div',{className:'img-2-1 mb-4',style:{backgroundImage:'url('+getStoreImageUrl(item)+')'}}),wp.element.createElement('h5',{className:'h4 text-center mb-4'},(Locale=='zh_TW'||Locale=='en_US'&&!item.en_name)&&item.name,Locale=='en_US'&&item.en_name&&item.en_name),wp.element.createElement('ul',{className:'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('img',{style:{marginRight:'1rem'},src:PLUGIN_ASSETS_URL+'/img/store/svg/home.svg',alt:''}),wp.element.createElement('span',null,wp.element.createElement('a',null,item.full_name))),wp.element.createElement('li',null,wp.element.createElement('img',{style:{marginRight:'1rem'},src:PLUGIN_ASSETS_URL+'/img/store/svg/map-pin.svg',alt:''}),wp.element.createElement('span',null,(Locale=='zh_TW'||Locale=='en_US'&&!item.en_street)&&item.address,Locale=='en_US'&&item.en_street&&item.en_street,wp.element.createElement('a',{className:'gMap-link',role:'button'// href={`https://www.google.com.tw/maps/place/${
//   item.address
// }`}
,href:item.store_link?item.store_link:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{className:'ml-3',src:PLUGIN_ASSETS_URL+'/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,wp.element.createElement('img',{style:{marginRight:'1rem'},src:PLUGIN_ASSETS_URL+'/img/store/svg/phone.svg',alt:''}),wp.element.createElement('span',null,wp.element.createElement('a',{href:'tel:+886-'+item.contact_tel},item.contact_tel))),wp.element.createElement('li',null,wp.element.createElement('img',{style:{marginRight:'1rem'},src:PLUGIN_ASSETS_URL+'/img/store/svg/clipboard.svg',alt:''}),wp.element.createElement('span',null,wp.element.createElement('a',null,'\u7D71\u7DE8\uFF1A',item.tax_id)))))));})))))));}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var StoreListEditor=function(_Component2){_inherits(StoreListEditor,_Component2);function StoreListEditor(){_classCallCheck(this,StoreListEditor);return _possibleConstructorReturn(this,(StoreListEditor.__proto__||Object.getPrototypeOf(StoreListEditor)).apply(this,arguments));}_createClass(StoreListEditor,[{key:'render',value:function render(){return wp.element.createElement('div',null,'\u5546\u5E97\u5217\u8868');}}]);return StoreListEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreListEditor", function() { return StoreListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_hash__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_wjson__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');var Locale=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(window,'VC_CONFIG.Locale');// 前端頁面
var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.state={data:[],// 分頁
listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]},query:{a:null,t:null,id:null,service_ids:[],is24h:null},hotKey:[13,86,29]},_this.GTM=function(){var dataLayer=window.dataLayer||[];__WEBPACK_IMPORTED_MODULE_8_jquery___default()(document).on('click','#store div a',function(){var $text=__WEBPACK_IMPORTED_MODULE_8_jquery___default()(this).attr('alt');dataLayer.push({event:'store_click',item:$text});});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cacheQuery=__WEBPACK_IMPORTED_MODULE_13_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[],is24h:null};query.a=cacheQuery.a;query.t=cacheQuery.t;localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_13_libs_wjson__["a" /* default */].encode(query));__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getStoreList({store_type_id:query.t,store_area_id:query.a,id:query.id,service_ids:query.service_ids,is24h:query.is24h?1:''});},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options});});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function(){var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.selectpicker[name=id]').selectpicker('val',__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(query,'id'));__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(query,key,value);if(key==='a'||key==='t'||key==='service_ids'){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(query,'id',null);__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.selectpicker[name=id]').selectpicker('val',null);}localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_13_libs_wjson__["a" /* default */].encode(query));_this.loadData(query);_this.setState({query:query},function(){_this.refreshPicker();});},_this.getSearchPath=function(query){return window.VC_CONFIG.INDEX_URL+'/stores/#'+__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify(query,{skipNull:true});},_this.handleInfiniteOnLoad=function(page){var listInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this,'props.stores.listInfo');_this.setState({loading:true});setTimeout(function(){var data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this,'state.data',[]);var newData=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.slice(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(listInfo,'rows'),0,data.length+1);_this.setState({loading:false,data:newData,hasMore:data.length<newData.length});},100);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getHashParamaters();var cacheQuery=__WEBPACK_IMPORTED_MODULE_13_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null,service_ids:[]};if(!query.a&&cacheQuery.a){query.a=1;}localStorage.setItem('c4-map-query',__WEBPACK_IMPORTED_MODULE_13_libs_wjson__["a" /* default */].encode(query));this.loadData(query);this.loadConfig();this.GTM();}},{key:'render',value:function render(){var _this2=this;// const {listInfo={} } = this.state;
var listInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'props.stores.listInfo');var data=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.data');var query=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.query',{});var options=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.options',{});var hotKey=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this,'state.hotKey');var categoryOptions=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(options,'service_categories',[]).filter(function(categoryInfo){return!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(categoryInfo.items);});var service_categorys=categoryOptions;this.refreshPicker();return wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'d-flex align-items-md-center justify-content-between pt-4'},wp.element.createElement('div',{'class':'ml-auto',style:{padding:'20px'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_switch___default.a,{checkedChildren:'24\u5C0F\u6642\u71DF\u696D',unCheckedChildren:'24\u5C0F\u6642\u71DF\u696D',onChange:function onChange(value){if(value===true)query.is24h=1;else query.is24h=0;_this2.setState({query:query},function(){_this2.loadData(query);});}})),wp.element.createElement('a',{className:'p d-inline-block d-md-inline-flex align-items-center text-primary text-decoration-none text-nowrap',role:'button'// href='javascript:void(0)'
,'data-toggle':'modal','data-target':'#more-filter',onClick:function onClick(e){return e.preventDefault();}},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('服務篩選','cec-plugin-stores'),wp.element.createElement('span',{className:'rounded-circle text-white bg-primary note line-hight-fit align-items-center justify-content-center ml-2 mb-0 service-filter-count',style:{display:'none',width:'20px',height:'20px'}},'0'),wp.element.createElement('i',{className:'note icon-plus ml-2'}))),wp.element.createElement('div',{className:'modal modal-store-service-morefilter fade',id:'more-filter',tabindex:'-1',role:'dialog','aria-labelledby':'more-filterTitle','aria-hidden':'true'},wp.element.createElement('div',{className:'modal-dialog modal-dialog-centered modal-dialog-scrollable',role:'document'},wp.element.createElement('div',{className:'modal-content'},wp.element.createElement('div',{'class':'modal-header pl-lg-5 border-primary'},wp.element.createElement('div',{'class':'d-flex align-items-center justify-content-between flex-fill'},wp.element.createElement('span',null,'\xA0'),wp.element.createElement('h5',{'class':'p text-primary modal-title mb-0',id:'more-filterTitle'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('請點選下列您所需的服務','cec-plugin-stores')),wp.element.createElement('button',{'class':'text-navy close m-0',type:'button','data-dismiss':'modal','aria-label':'Close'},wp.element.createElement('span',{'class':'text-navy','aria-hidden':'true'},'\xD7')))),wp.element.createElement('div',{className:'modal-body px-lg-5 pb-5'},wp.element.createElement('div',{className:'row no-gutters mx-n2',id:'item'},wp.element.createElement('h6',{'class':'p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'},'\u71B1\u9580\u670D\u52D9'),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(service_categorys,function(categoryInfo){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(hotKey,function(key){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(categoryInfo,'items',[]).filter(function(item){return key==item.id;}),function(serviceInfo){return wp.element.createElement('div',{className:'col-auto px-2'},wp.element.createElement('span',{className:'p btn btn-outline-primary px-3 rounded-pill my-2 service-badge',role:'button',id:serviceInfo.id,onClick:function onClick(e){if(!__WEBPACK_IMPORTED_MODULE_8_jquery___default()(e.target).hasClass('is-active')){var temp=_this2.state.query.service_ids;var index=temp.findIndex(function(e){return e==serviceInfo.id;});_this2.state.query.service_ids.splice(index,1);console.log('is-active',_this2.state.query.service_ids);}else{_this2.state.query.service_ids.push(serviceInfo.id);console.log('is-active',_this2.state.query.service_ids);}}},serviceInfo.name,wp.element.createElement('a',{className:'close note ml-2',role:'button'// href='javascript:void(0)'
,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('i',{className:'icon-close'}))));});});})),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(service_categorys,function(categoryInfo){return wp.element.createElement('div',{className:'row no-gutters mx-n2',id:'item'},wp.element.createElement('h6',{'class':'p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'},categoryInfo.name),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(categoryInfo,'items',[]),function(serviceInfo){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(hotKey,function(key){return key==serviceInfo.id;}))return wp.element.createElement('div',null);else{return wp.element.createElement('div',{className:'col-auto px-2'},wp.element.createElement('span',{className:'p btn btn-outline-primary px-3 rounded-pill my-2 service-badge',role:'button',id:serviceInfo.id,onClick:function onClick(e){if(!__WEBPACK_IMPORTED_MODULE_8_jquery___default()(e.target).hasClass('is-active')){var temp=_this2.state.query.service_ids;var index=temp.findIndex(function(e){return e==serviceInfo.id;});_this2.state.query.service_ids.splice(index,1);console.log('is-active',_this2.state.query.service_ids);}else{_this2.state.query.service_ids.push(serviceInfo.id);console.log('is-active',_this2.state.query.service_ids);}}},serviceInfo.name,wp.element.createElement('a',{className:'close note ml-2',role:'button'// href='javascript:void(0)'
,onClick:function onClick(e){return e.preventDefault();}},wp.element.createElement('i',{className:'icon-close'}))));}}));})),wp.element.createElement('div',{className:'modal-footer border-gray px-lg-5'},wp.element.createElement('div',{className:'row align-items-center justify-content-center justify-content-md-between flex-fill'},wp.element.createElement('div',{className:'col-8 col-md-6 ml-md-auto order-md-2'},wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button','data-dismiss':'modal','aria-label':'Close',href:this.getSearchPath(query),onClick:function onClick(){return _this2.loadData(query);}},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('確認搜尋','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-md-auto text-md-left text-center order-md-1'},wp.element.createElement('p',{className:'p text-primary mb-0 d-inline-flex align-items-center'},Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('您已選擇','cec-plugin-stores'),wp.element.createElement('span',{className:'h5 px-2 mb-0 text-orange line-hight-fit service-filter-count'},'0'),Object(__WEBPACK_IMPORTED_MODULE_7__wordpress_i18n__["__"])('種服務','cec-plugin-stores'),wp.element.createElement('span',{className:'h6 text-gray ml-3 mb-0',role:'button',href:'#','data-toggle':'tooltip','data-placement':'top',title:'\u8CBC\u5FC3\u63D0\u9192\uFF1A\u82E5\u9078\u64C7\u592A\u591A\u670D\u52D9\u9805\u76EE\uFF0C\u5C07\u6709\u53EF\u80FD\u641C\u5C0B\u4E0D\u5230\u76F8\u61C9\u9580\u5E02\uFF0C\u8ACB\u659F\u914C\u60A8\u7684\u9078\u64C7\u3002'},wp.element.createElement('i',{className:'far fa-question-circle'}))))))))),wp.element.createElement('section',{className:'pt-md-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default.a,{initialLoad:true,pageStart:0,loadMore:this.handleInfiniteOnLoad,hasMore:!this.state.loading&&this.state.hasMore// useWindow={false}
},wp.element.createElement('div',{id:'store',className:'row'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data,function(item){return wp.element.createElement('div',{className:'col-md-6 col-lg-4 d-flex align-items-stretch'},wp.element.createElement('div',{className:'card card-storeInfo shadow-0 card-border-width-1 type-1'},wp.element.createElement('a',{alt:item.name,className:'card-body',role:'button',href:INDEX_URL+'/store-info'+(Locale=='en_US'?'-en':'')+'/?store='+item.name+'#tab=info'},wp.element.createElement('div',{className:'img-2-1 mb-4',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item,'images.0')+')'}}),wp.element.createElement('h5',{className:'h4 text-center mb-4'},(Locale=='zh_TW'||Locale=='en_US'&&!item.en_name)&&item.name,Locale=='en_US'&&item.en_name&&item.en_name,item.is24h&&wp.element.createElement('span',{className:'hour-24-tag'},'24h')),wp.element.createElement('ul',{className:'traffic-info-list'},wp.element.createElement('li',null,wp.element.createElement('i',{className:'icon-store_map'}),wp.element.createElement('span',null,(Locale=='zh_TW'||Locale=='en_US'&&!item.en_street)&&item.address,Locale=='en_US'&&item.en_street&&item.en_street,wp.element.createElement('a',{className:'gMap-link',role:'button',href:'https://www.google.com.tw/maps/place/'+item.address,target:'_blank'},wp.element.createElement('img',{className:'ml-3',src:PLUGIN_ASSETS_URL+'/img/icon/google_map.svg',alt:''})))),wp.element.createElement('li',null,' ',wp.element.createElement('i',{className:'icon-store_phone'}),wp.element.createElement('span',null,wp.element.createElement('a',{href:'tel:+886-'+item.contact_tel},item.contact_tel)))))));}))))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var nextListInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(props,'stores.listInfo');var prevListInfo=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(state,'listInfo');console.log('getDerivedStateFromProps',__WEBPACK_IMPORTED_MODULE_4_object_hash___default()(nextListInfo)!==__WEBPACK_IMPORTED_MODULE_4_object_hash___default()(prevListInfo));if(__WEBPACK_IMPORTED_MODULE_4_object_hash___default()(nextListInfo)!==__WEBPACK_IMPORTED_MODULE_4_object_hash___default()(prevListInfo)){return{data:[],listInfo:nextListInfo};}// Return null to indicate no change to state.
return null;}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);// 編輯器
var StoreListEditor=function(_Component2){_inherits(StoreListEditor,_Component2);function StoreListEditor(){_classCallCheck(this,StoreListEditor);return _possibleConstructorReturn(this,(StoreListEditor.__proto__||Object.getPrototypeOf(StoreListEditor)).apply(this,arguments));}_createClass(StoreListEditor,[{key:'render',value:function render(){return wp.element.createElement('div',null,'\u5546\u5E97\u5217\u8868');}}]);return StoreListEditor;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreVendor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreVendorEditor", function() { return StoreVendorEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');//console.log('VC_CONFIG', window.VC_CONFIG)
var stringToBr=function stringToBr(text){return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.split(text,'\n'),function(line,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],{key:idx},line,wp.element.createElement('br',null));});};var Local=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(window,'VC_CONFIG.Locale');// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
var StoreVendor=function(_Component){_inherits(StoreVendor,_Component);function StoreVendor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreVendor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreVendor.__proto__||Object.getPrototypeOf(StoreVendor)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabType:'info',storeInfo:undefined,query:{}},_this.loadConfig=function(){_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+'/api/v1/system/configs',{},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({options:data.options},function(){_this.refreshPicker();});});},_this.loadData=function(){var urlQuery=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getURLQuery();var id=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(urlQuery,'id');if(!id){window.location.href=window.VC_CONFIG.INDEX_URL+'/stores';}_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_12__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_11__configs_env__["b" /* API_HOST */]+('/api/v1/stores/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/stores');return;}_this.setState({storeInfo:data},function(){_this.reloadMaps();});});},_this.reloadMaps=function(){var _this$state=_this.state,map=_this$state.map,maps=_this$state.maps,storeInfo=_this$state.storeInfo;console.log('reloadMaps',map,maps);if(!maps||!map||!storeInfo)return;var stores=[storeInfo];if(!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isArray(stores)||stores.length===0)return;if(Array.isArray(_this.state.markers)){_this.state.markers.forEach(function(marker){return marker.setMap(null);});}// zoom預設為能呈現出地形等高線的大小
// 所以改成呈現最新的裝置位置
var bounds=new maps.LatLngBounds();var markers=stores.map(function(store,idx){var marker=new maps.Marker({map:map,position:{lat:store.latitude,lng:store.longitude},store:store});var infowindow=new maps.InfoWindow({content:'<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">'+store.name+'</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">'+store.address+'</div> </div> </div>'});marker.addListener('click',function(){infowindow.open(map,marker);});// marker.addListener('mouseover', function () {
//   infowindow.open(map, marker);
// });
// marker.addListener('mouseout', function () {
//   infowindow.close();
// });
if(idx==0){bounds.extend(marker.getPosition());}return marker;});map.fitBounds(bounds);map.setZoom(16);_this.setState({markers:markers});},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_5_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.handleQueryUpdate=function(key,value){var query=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(_this,'state.query',{});__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(query,key,value);_this.setState({query:query});},_this.getSearchPath=function(query){return window.location.origin+(window.VC_CONFIG.INDEX_URL+'/stores/#')+__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.stringify(query,{skipNull:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreVendor,[{key:'componentDidMount',value:function componentDidMount(){this.loadConfig();this.setState({tabType:__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getHashValue('tab')||'info'});this.loadData();}},{key:'render',value:function render(){var urlQuery=__WEBPACK_IMPORTED_MODULE_10_libs_AppHelper__["a" /* default */].getURLQuery();var filterVendorType=parseInt(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(urlQuery,'type',1),10);var storeInfo=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.storeInfo',{});var tabType=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.tabType',{});var options=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.options',{});var query=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'state.query',{});var listInfo=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(this,'props.stores.listInfo',[]);var banners=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(storeInfo,'banners',[]);var services=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(storeInfo,'services',[]);var foods=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(storeInfo,'foods',[]);var brands=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(storeInfo,'brands',[]);this.refreshPicker();var storeBanner=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(storeInfo,'images.0');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,wp.element.createElement('div',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},wp.element.createElement('div',{'class':'breadcrumb-wrap py-4 m-0'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{'class':'breadcrumb'},wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:''+window.VC_CONFIG.INDEX_URL+(Local=='en_US'?'/en':'')},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/stores'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_8__wordpress_i18n__["__"])('分店搜尋','cec-plugin-stores'))),wp.element.createElement('li',{'class':'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/store-info'+(Local=='en_US'?'-en':'')+'?store='+storeInfo.name},storeInfo.name)),wp.element.createElement('li',{'class':'breadcrumb-item active','aria-current':'page',id:'name'},filterVendorType===1&&'美食外送',filterVendorType===2&&'商店購物')))))),wp.element.createElement('main',{'class':'bg-light'},wp.element.createElement('div',{'class':'container'},__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.groupBy(storeInfo.deliveries,function(vendor){return vendor.vendor_id;}),function(vendors,idx){var vendorHasIcon=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(vendors,function(vendor){return vendor.image!==null;});return wp.element.createElement('div',{key:idx,'class':'my-lg-5 my-3',onClick:function onClick(e){__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.info({title:'請選擇品牌',okText:'取消',content:wp.element.createElement('div',{'class':'row no-gutters mx-n2',id:'item'},vendors.map(function(vendor,idx){return wp.element.createElement('div',{key:idx,'class':'col-auto px-2'},wp.element.createElement('a',{href:vendor.url},wp.element.createElement('span',{'class':'p btn btn-outline-primary px-3 rounded-pill my-2 service-badge',role:'button'},vendor.brand_name)));}))});}},wp.element.createElement('img',{role:'button','class':'img-cover',src:vendorHasIcon.image,alt:vendorHasIcon.vendor_name}));}))));}}]);return StoreVendor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);// 編輯器
var StoreVendorEditor=function(_Component2){_inherits(StoreVendorEditor,_Component2);function StoreVendorEditor(){_classCallCheck(this,StoreVendorEditor);return _possibleConstructorReturn(this,(StoreVendorEditor.__proto__||Object.getPrototypeOf(StoreVendorEditor)).apply(this,arguments));}_createClass(StoreVendorEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},'\u7DE8\u8F2F\u5668');}}]);return StoreVendorEditor;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserProfileEditor", function() { return UserProfileEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_jsbarcode__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_jsbarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_jsbarcode__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Local=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_17_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_15_antd_lib_tabs___default.a.TabPane;// 前端頁面
var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_18_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,tableData:[],isLoading:false},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get($magicLine,0)){console.log('kkk c',$magicLine);__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_21_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_21_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_21_jquery___default()('.highlight').addClass('current_page_item');});},_this.pad=function(num,n){var y='00000000000000000000000000000'+num;return y.substr(y.length-n);},_this.fillData=function(data){data.birthday=data.birth_year+'-'+data.birth_month+'-'+data.birth_day;data.birthday=data.birth_year+'-'+data.birth_month+'-'+data.birth_day;console.log('filldata-in',data);if(!_this.formRef.current)return;console.log('filldata-1111111111111');// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isNil(data.addresses)||!__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isArray(data.addresses)){//data.address = {
//  city_id : _.get(data.addresses[0], 'city_id'),
//  area_id : _.get(data.addresses[0], 'area_id'),
//}
data.street=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(data.addresses[0],'street');console.log('filldata-2222222222222');}if(data.birth_day&&data.birth_year&&data.birth_month){data.birthday=data.birth_year+'-'+_this.pad(data.birth_month,2)+'-'+_this.pad(data.birth_day,2);console.log('filldata-birthday',data.birthday);data.birthday=__WEBPACK_IMPORTED_MODULE_19_moment___default()(data.birthday,'YYYY-MM-DD');console.log('filldata-birthday-moment',data.birthday);}console.log('filldata',data);_this.formRef.current.setFieldsValue(data);},_this.submitData=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};info.addresses=[{//city_id : _.get(info,'address.city_id'),
//area_id : _.get(info, 'address.area_id'),
city_id:null,area_id:null,street:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(info,'street')}];console.log('submitdata',info);info.birthday=__WEBPACK_IMPORTED_MODULE_19_moment___default()(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(info,'birthday')).format('YYYY-MM-DD');info.birth_year=__WEBPACK_IMPORTED_MODULE_19_moment___default()(info.birthday).format('YYYY');info.birth_month=__WEBPACK_IMPORTED_MODULE_19_moment___default()(info.birthday).format('M');info.birth_day=__WEBPACK_IMPORTED_MODULE_19_moment___default()(info.birthday).format('D');//info.flag  = _.get(info, 'flag') ? 1 : 0
//info.agree_receive_sms  = _.get(info, 'agree_receive_sms') ? 1 : 0
//info.sync_to_cls  = _.get(info, 'sync_to_cls') ? 1 : 0
//delete info['address']
delete info['birthday'];_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_25__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_24__configs_env__["b" /* API_HOST */]+'/api/account/updCardProfile',info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_11_antd_lib_notification___default.a['success']({message:'修改成功'});window.location.href=window.VC_CONFIG.INDEX_URL+'/loyaltyprofile';});},_this.getCardProfile=function(){var query=__WEBPACK_IMPORTED_MODULE_23_libs_AppHelper__["a" /* default */].getHashParamaters();_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_25__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_24__configs_env__["b" /* API_HOST */]+'/api/account/getProfiles',{},function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_13_antd_lib_message___default.a.warning(reason);//this.props.history.replace("/brands")
return;}_this.setState({tableData:data});console.log('getCardProfile',data);_this.fillData(data.cardProfile);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfile,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var auth=this.props.auth;//if (!auth && !auth.isLogin)
//{
//UAT
//window.location.href= `https://toaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=b8f848827a0667870c436cca772b66a6&redirect_uri=https://cec.syscom.tw/sso/&state=C4&scope=read&device=1`;
//正式機
//window.location.href = `https://oaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=66baf15062e6d2bf305217507553ce8c&redirect_uri=${VC_CONFIG.INDEX_URL}/sso/&state=C4&scope=read&device=1`;
//}
__WEBPACK_IMPORTED_MODULE_23_libs_AppHelper__["a" /* default */].updateConfig();this.setState({isFetchData:true,isLoading:true,info:this.props.user});__WEBPACK_IMPORTED_MODULE_23_libs_AppHelper__["a" /* default */].updateUserCardInfo(function(){_this2.setState({isFetchData:false,isLoading:false},function(){_this2.reloadTab();});_this2.getCardProfile();});// 登入換 tokne
//http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
// 電子發票列表
// http://{{hostip}}//api/account/eInvoiceList
// 點數紀錄 / 消費記錄
// 密碼變更
// 查詢編輯會員資料
// 查詢好康卡會員資料
}},{key:'render',value:function render(){var _this3=this;var errors=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_22_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});var _state=this.state,info=_state.info,tableData=_state.tableData;var profile=tableData.profile;var cardProfile=tableData.cardProfile;return wp.element.createElement('div',null,this.state.isLoading?wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a,null,wp.element.createElement('div',{'class':'row justify-content-center',style:{minHeight:200}})):wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.cn_name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/point'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/invoice'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/connect'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('網站帳號','cec-plugin-stores'))),info&&info.spcode==='C4'&&wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/point-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點數紀錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/invoice-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('電子發票記錄','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:window.VC_CONFIG.INDEX_URL+'/connect-en'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('第三方登入設定','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row justify-content-center'},wp.element.createElement('div',{className:'col-6 col-lg-9'},wp.element.createElement('img',{className:'img-fluid',src:window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/member/card0'+(info&&info.vip_flag==0?'1':'2')+'.svg',alt:''}))),wp.element.createElement('h5',{className:'h4 text-navy text-center mb-0'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-sm-5'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('會員等級','cec-plugin-stores'),'\uFF1A',profile&&profile.vip_flag==0?Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('一般會員','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('VIP會員','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('連結會員卡號','cec-plugin-stores'),'\uFF1A',profile&&profile.cardInfo&&profile.cardInfo.cardnumber),wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('目前點數記錄','cec-plugin-stores'),'\uFF1A',profile&&profile.point_balance&&profile.point_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('點','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('可兌換金額','cec-plugin-stores'),'\uFF1A',Local=='en_US'&&'$',profile&&profile.amt_balance&&profile.amt_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),Local=='zh_TW'&&'元')),wp.element.createElement('div',{className:'col-sm-7'},wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('最新消費日','cec-plugin-stores'),'\uFF1A',profile&&profile.lastPurInfo&&__WEBPACK_IMPORTED_MODULE_19_moment___default()(profile.lastPurInfo.pur_dt).format('YYYY/MM/DD')||Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('無','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('最近消費分店','cec-plugin-stores'),'\uFF1A',profile&&profile.lastPurInfo&&profile.lastPurInfo.pur_store||Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('無','cec-plugin-stores'),' '),wp.element.createElement('p',{className:'h6 text-navy fw-700 mb-2'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('最近消費金額','cec-plugin-stores'),'\uFF1A',Local=='en_US'&&'$',profile&&profile.lastPurInfo&&profile.lastPurInfo.pur_amount&&profile.lastPurInfo.pur_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')||'0',Local=='zh_TW'&&'元')),wp.element.createElement('div',{className:'col-12 mt-5'},wp.element.createElement('p',{className:'h6 text-success'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('正確點數將於消費之24小時後更新,如遇系統或資料更新, 以實際作業為準。','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('好康卡會員資料','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_spin___default.a,{spinning:this.state.isSubmitData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{noStyle:true,ref:this.formRef,name:'basic',layout:'vertical',onFinish:function onFinish(values){return _this3.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){console.log('onValuesChange:',changedFields,allFields);}// onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
// onFieldsChange={(changedFields, allFields) => {
//     const storeInfo = _.reduce(allFields,(obj,item) => {
//         _.set(obj, item.name.join('.'), item.value)
//         return obj
//       }, {})
//       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
//       return true
//     }}
},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},info&&info.spcode==='C4'&&wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('帳號','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement('input',{className:'form-control',type:'text',disabled:'disabled',readonly:'',value:info&&info.email,id:''}))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('中文姓名','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請輸入中文姓名','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('full_cname')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('英文姓名','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('full_ename'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('生日','cec-plugin-stores'),'\uFF0A'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請選擇生日','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('birthday',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_date_picker___default.a,{placeholder:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請選擇生日','cec-plugin-stores'),className:'form-control',format:'YYYY-MM-DD',disabled:true})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('地址','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{label:''},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a.Group,{compact:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,{name:'street',noStyle:true,className:'form-control',rules:[{required:true,message:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請輸入地址','cec-plugin-stores')}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{style:{width:'70%'},placeholder:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請輸入地址','cec-plugin-stores')})))))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('手機','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,pattern:new RegExp('^[0-9]{10}$'),message:Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('請輸入正確手機號碼','cec-plugin-stores')}]},Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('mobile')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('居住電話','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('home_phone'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('公司電話','cec-plugin-stores')),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('company_phone'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'})))),wp.element.createElement('div',{className:'form-group mb-4 row align-items-center'},wp.element.createElement('label',{className:'col-sm-2 col-form-label h6 text-navy','for':''},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('電子信箱','cec-plugin-stores'),'*'),wp.element.createElement('div',{className:'col-sm-10'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a.Item,_extends({rules:[{required:true,message:'請輸入信箱'}]},Object(__WEBPACK_IMPORTED_MODULE_26_libs_FormHelper__["a" /* genFormItemAtrribute */])('email')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,{className:'form-control'}))))))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確 性。客服中心：市話 0809-001-365 / 手機(02)8006-9999','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於 網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！ ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores')))))),wp.element.createElement('div',{className:'text-center mt-5'},wp.element.createElement('a',{className:'h6 btn btn-outline-primary rounded-pill px-5 py-4',role:'button',onClick:function onClick(e){e.preventDefault();_this3.formRef.current.submit();}},Object(__WEBPACK_IMPORTED_MODULE_27__wordpress_i18n__["__"])('確定修改','cec-plugin-stores')))))));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);__WEBPACK_IMPORTED_MODULE_21_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_28_jsbarcode___default()('.barcode').init();});// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserProfileEditor=function(_Component2){_inherits(UserProfileEditor,_Component2);function UserProfileEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserProfileEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserProfileEditor.__proto__||Object.getPrototypeOf(UserProfileEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_18_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserProfileEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_23_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'\u6703\u54E1\u8CC7\u8A0A\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserProfileEditor;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfileOca; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPasswordOcaEditor", function() { return UserPasswordOcaEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var Local=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};var Option=__WEBPACK_IMPORTED_MODULE_11_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_9_antd_lib_tabs___default.a.TabPane;var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.get(window,'VC_CONFIG');// 前端頁面
var UserProfileOca=function(_Component){_inherits(UserProfileOca,_Component);function UserProfileOca(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfileOca);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfileOca.__proto__||Object.getPrototypeOf(UserProfileOca)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createRef(),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,memberVip:'',memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,isLoading:true},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_15_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.get($magicLine,0)){//console.log('kkk c', $magicLine)
__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_15_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_15_jquery___default()(this);//console.log('basic-tabs-label', $el)
leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_15_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_15_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_15_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_15_jquery___default()('.highlight').addClass('current_page_item');});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/account/oca/getProfiles',{},function(state,res){console.log('getProfiles','/api/account/oca/getProfiles',res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}console.log('getProfiles',data);_this.setState({memberVip:data.member_profile_isvip==0?'一般會員':'VIP',memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10)});});},_this.LoadOCA=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/account/oca/ocaUri?type=changepwd',{},function(state,res){//console.log(state, res, info)
_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a['error']({message:'資料讀取失敗',description:reason});return _this.setState({messages:data.messages||{}});}//console.log(data)
_this.setState({ocaUrl:data.uri});});},_this.getProfile=function(){_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_18__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_17__configs_env__["b" /* API_HOST */]+'/api/account/oca/getProfile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification___default.a['error']({message:'資料讀取失敗',description:reason});return _this.setState({messages:data.messages||{}});}_this.setState({info:data});//console.log('getProfile',data)
});},_this.getIframeHeight=function(){var f=document.getElementById('iframe-pwd');f.style.height=f.contentWindow.document.body.scrollHeight+40+'px';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfileOca,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.LoadOCA();__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].updateConfig();this.getMemberProfile();this.getProfile();//this.setState({ isFetchData: true},() => {this.reloadTab()})
this.setState({info:this.props.user},function(){_this2.reloadTab();});}},{key:'render',value:function render(){var _this3=this;//const info  = this.state.info
var ocaUrl=this.state.ocaUrl;var ProfileInfo=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.get(this,'state.info');var MemberVip=this.state.memberVip;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),wp.element.createElement('b',{className:'fw-700'},ProfileInfo&&ProfileInfo.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}},MemberVip=='VIP'?wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/2021VIPcard.png',alt:''}):wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/newHKcard.png',alt:''}))))),wp.element.createElement('div',{'class':'col-lg-8 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',MemberVip),wp.element.createElement('li',{'class':'pb-1'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,'\u9EDE'),wp.element.createElement('li',{'class':'pb-1'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,'\u5143')),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item  current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item  current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_29__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{align:'center'},ocaUrl&&wp.element.createElement('iframe',{id:'iframe-pwd',title:'iframe-pwd'//src="https://ppr-online.uni-prosperity.com.tw/testaccount/member/profile?client_id=c4fhcruwmgh6vz7n0l&amp;nonce_str=%21QAZxdr5×tamp=1595570823&amp;sign=7f9868830fe95472bc4e0d8bc37e926c5bba1b8272fdde1911bb78b60ba7f2c8&amp;access_token=9c1956af-9451-422d-8845-b63393b91776&amp;redirect_uri=https%3A%2F%2Fcec.syscom.tw%2Fservice%2Fsso%2F&amp;lang=zh_TW"
,src:ocaUrl,width:'75%',height:'600',scrolling:'no',frameborder:'no',onload:function onload(){return _this3.getIframeHeight();}}))));}}]);return UserProfileOca;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPasswordOcaEditor=function(_Component2){_inherits(UserPasswordOcaEditor,_Component2);function UserPasswordOcaEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserPasswordOcaEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserPasswordOcaEditor.__proto__||Object.getPrototypeOf(UserPasswordOcaEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserPasswordOcaEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_16_libs_AppHelper__["a" /* default */].updateConfig();//console.log('kkk', this.props.attributes)
this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_14_lodash___default.a.get(this,'props.app.options',{});//console.log('editor', this.props)
return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'OCA\u66F4\u6539\u5BC6\u78BC'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPasswordOcaEditor;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserPaymentOca; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserPaymentOcaEditor", function() { return UserPaymentOcaEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]// 消費日期: pur_dt (all)
// 分店名稱: pur_store (all)
// 交易型態: pur_trantypeid
// 消費金額: pur_amount (all)
// 紅利折抵: pur_discount
// 獲得點數: pur_accounts[0].earnValue
// 發票號碼: einvoice_no
// 是否列印發票: einvoice_type
// 是否中獎: einvoice_type
// 前端頁面
};var UserPaymentOca=function(_Component){_inherits(UserPaymentOca,_Component);function UserPaymentOca(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserPaymentOca);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserPaymentOca.__proto__||Object.getPrototypeOf(UserPaymentOca)).call.apply(_ref,[this].concat(args))),_this),_this.cancelList=[],_this.state={query:{start_dt:'',end_dt:''},tableData:[],tableData_Detail:[],selectmonth:__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('month').format('YYYY-MM-DD'),startMonth:__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('month').format('YYYY-MM-DD'),endMonth:__WEBPACK_IMPORTED_MODULE_9_moment___default()(__WEBPACK_IMPORTED_MODULE_9_moment___default()().startOf('month').format('YYYY-MM-DD')).add(1,'months').format('YYYY-MM-DD'),paymentInfo:undefined,purLoading:true,memberVip:'',memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,detailData:[],activityPoint:[]},_this.control=function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()(document).ready(function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()(document).on('show.bs.collapse','.tbody .order-detail-info',function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.order-detail-info').removeClass('show');});});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+'/api/account/oca/getProfiles',{},function(state,res){var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});}_this.setState({memberVip:data.member_profile_isvip===0?'一般會員':'VIP',memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10)});});},_this.getPointList=function(_ref2){var _ref2$start_dt=_ref2.start_dt,start_dt=_ref2$start_dt===undefined?'':_ref2$start_dt,_ref2$end_dt=_ref2.end_dt,end_dt=_ref2$end_dt===undefined?'':_ref2$end_dt;_this.setState({purLoading:true});__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+('/api/account/oca/getpointlist?start_dt='+start_dt+'&end_dt='+end_dt),null,function(state,res){_this.setState({purLoading:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?[]:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}// if (code !== 200) {
//   return message.error(reason);
// }
if(code===997){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#exampleModalCenter').modal('show');}var dataAllStores=data.filter(function(obj){return obj.storeName==='All Stores';}).map(function(obj){var date=obj.transactionTime.split(' ');return Object.assign({},obj,{pur_dt:date[0],pur_store:obj.storeName,pur_trantypeid:obj.posId,pur_remarks:obj.remarks,pur_amount:'',pur_accounts:[{earnValue:obj.earnValue,redeemValue:obj.redeemValue}],einvoice_no:'',einvoice_type:'',pur_id:obj.transactionId,pur_tenders:[],pur_transactionTime:obj.transactionTime,isLoaded:true});});_this.setState({activityPoint:dataAllStores});});},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get($magicLine,0)){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this);console.log('basic-tabs-label',$el);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.highlight').addClass('current_page_item');});},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log('loadData',_this.cancelList);_this.setState({purLoading:true});__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+('/api/account/oca/purchaseListV2?start_dt='+query.start_dt+'&end_dt='+query.end_dt),null,function(state,res){_this.setState({purLoading:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?[]:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}// if (code !== 200) {
//   return message.error(reason);
// }
// 這邊把tableData先記錄下來
// loadDetailData的時候再塞回去
// 預設都沒有載入過Detail
__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.forEach(data,function(item){return item.isLoaded=false;});_this.setState({tableData:data,purLoading:false},function(){_this.refreshPicker();_this.cancelList.length>0&&_this.cancelList.forEach(function(cancelFn){console.log('1');cancelFn();});for(var i=0;i<data.length;i++){_this.loadDetailData(query,data,i);}});});},_this.loadDetailData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var tableData=arguments[1];var i=arguments[2];var transactionId=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tableData,i+'.pur_id');var storeId=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tableData,i+'.pur_storeId');var posId=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tableData,i+'.pur_posId');var businessDate=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tableData,i+'.pur_dt');var detailData=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'state.detailData');var cancelToken=__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+('/api/account/oca/purchaseDetail?start_dt='+query.start_dt+'&end_dt='+query.end_dt+'&transactionId='+transactionId+'&storeId='+storeId+'&posId='+posId+'&businessDate='+businessDate),null,function(state,res){_this.setState({purLoading:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_message___default.a.error(reason);}var tableData=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(_this,'state.tableData');// 找到tableData中的資料
var record=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.find(tableData,function(item){return parseInt(item.id,10)===parseInt(data.id,10);});// 處理資料合併，把detail資料合併到record
__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.assign(record,data);if(!record){return _this.setState({message:'沒有資料'});}record.isLoaded=true;_this.setState({tableData:tableData});});_this.cancelList.push(cancelToken);},_this.refreshPicker=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.debounce(function(){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.selectpicker').selectpicker('refresh');},1000),_this.wincode=function(num){var codeA='特別獎 1000萬';var codeB='千元獎 2000元';var codeC='百萬獎 100萬';var code=['特　獎 200萬','頭　獎 20萬','二　獎 <br> 4萬','三　獎 <br> 1萬','四　獎 4,000元','五　獎 1,000元','六　獎 200元'];if(num==='A'){return codeA||'??';}else if(num==='B'){return codeB||'??';}else if(num==='C'){return codeC||'??';}else{num=parseInt(num,10);return code[num]||'??';}},_this.nonwincode=function(selectmonth){if(selectmonth){var getDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()(selectmonth);var currDate=__WEBPACK_IMPORTED_MODULE_9_moment___default()();if(__WEBPACK_IMPORTED_MODULE_9_moment___default()(getDate).isBefore(currDate)){var getDateMonth=getDate.format('M');var currDateMonth=currDate.format('M');var currDateDay=currDate.format('D');var diffMonth=Math.abs(currDateMonth-getDateMonth);if(currDateMonth>=7){//7-12月
if(diffMonth>2){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth>1){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}else{if(diffMonth>2&&diffMonth<10){if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}else{if(currDateMonth%2==0){//偶數月
if(diffMonth<=1){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}}else{//開獎月(奇數月)
if(diffMonth==0){if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}else{if(currDateDay>25){// 已開獎
if(localStorage.getItem('setlang')=='en'){return"Didn't win a Prize";}else{return'已開獎';}}else{if(localStorage.getItem('setlang')=='en'){return'未開獎';}else{return'未開獎';}}}}}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}}else{if(localStorage.getItem('setlang')=='en'){return'無法判斷';}else{return'無法判斷';}}},_this.selectChange=function(e){var query=_this.state.query;query.start_dt=e.target.value;query.end_dt=__WEBPACK_IMPORTED_MODULE_9_moment___default()(e.target.value).endOf('month').format('YYYY-MM-DD');var startMonth=e.target.value.replace(/-/g,'/');var endMonth=__WEBPACK_IMPORTED_MODULE_9_moment___default()(startMonth).add(1,'months').format('YYYY-MM-DD');_this.setState({selectmonth:e.target.value,startMonth:startMonth,endMonth:endMonth,detailData:[],tableData:[],activityPoint:[]});_this.loadData(query);_this.getPointList(query);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserPaymentOca,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var date=new Date();var y=date.getFullYear();var m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var query={start_dt:__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY-MM-DD'),end_dt:__WEBPACK_IMPORTED_MODULE_9_moment___default()(lastDay).format('YYYY-MM-DD')};this.setState({query:query});this.setState({info:this.props.user},function(){_this2.reloadTab();});this.getMemberProfile();this.getPointList(query);this.loadData(query);this.control();}},{key:'render',value:function render(){console.log(this.cancelList);var _state=this.state,info=_state.info,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?[]:_state$tableData,_state$activityPoint=_state.activityPoint,activityPoint=_state$activityPoint===undefined?[]:_state$activityPoint;var mixTableData=[].concat(_toConsumableArray(tableData),_toConsumableArray(activityPoint)).sort(function(a,b){return new Date(a.pur_dt)>new Date(b.pur_dt)?-1:1;});var MemberVip=this.state.memberVip;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;var selectmonth=this.state.selectmonth;var diffdd=this.nonwincode(selectmonth);var date=new Date();var y=date.getFullYear();var m=date.getMonth();var firstDay=new Date(y,m,1);var lastDay=new Date(y,m+1,0);var areaMonth={month:[__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY-MM-DD')],value:[__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).format('YYYY年MM月')]};for(var i=0;i<5;i++){areaMonth.month.push(__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD'));areaMonth.value.push(__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY年MM月'));firstDay=__WEBPACK_IMPORTED_MODULE_9_moment___default()(firstDay).subtract(1,'months').format('YYYY-MM-DD');lastDay=__WEBPACK_IMPORTED_MODULE_9_moment___default()(lastDay).subtract(1,'months').format('YYYY-MM-DD');}this.refreshPicker();return wp.element.createElement('div',null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{'class':'modal fade',id:'exampleModalCenter',tabindex:'-1',role:'dialog','aria-labelledby':'exampleModalCenterTitle','aria-hidden':'true'},wp.element.createElement('div',{style:{justifyContent:'center'},'class':'modal-dialog modal-dialog-centered',role:'document'},wp.element.createElement('div',{style:{width:'355px',height:'200px'},'class':'modal-content'},wp.element.createElement('div',{style:{padding:'1rem',margin:'auto',borderBottom:'0px'},'class':'modal-header'},wp.element.createElement('h5',{'class':'modal-title',id:'exampleModalCenterTitle'},'\u76EE\u524D\u6703\u54E1\u7CFB\u7D71\u7DAD\u8B77\u4E2D\uFF0C\u66AB\u6642\u7121\u6CD5\u66F4\u65B0\u6703\u54E1\u500B\u8CC7\u3001\u67E5\u8A62\u9EDE\u6578\u3001\u4EA4\u6613\u53CA\u767C\u7968\u7B49\uFF0C\u9020\u6210\u4E0D\u4FBF\u4E4B\u8655\uFF0C\u656C\u8ACB\u898B\u8AD2\uFF01')),wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default.a.container},wp.element.createElement('button',{style:{backgroundColor:'#0072E3',color:'white',width:'120px',height:'41px',border:'0.65rem'},type:'button','class':'btn btn-secondary','data-dismiss':'modal'},'\u78BA\u8A8D'))))),wp.element.createElement('div',{className:'container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'+(Local=='en_US'?'en':'')},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('會員中心','cec-plugin-stores')))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),' ',wp.element.createElement('b',{className:'fw-700'},info&&info.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-28 px-3',style:{flexGrow:0,flexShrink:0,flexBasis:'calc((100% / 7) * 2)',maxWidth:'calc((100% / 7) * 2)'}},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}},MemberVip=='VIP'?wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/2021VIPcard.png',alt:''}):wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/newHKcard.png',alt:''}))))),wp.element.createElement('div',{'class':'col-lg-71 px-3',style:{flexGrow:0,flexShrink:0,flexBasis:'calc((100% / 7) * 5)',maxWidth:'calc((100% / 7) * 5)'}},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',MemberVip),wp.element.createElement('li',{'class':'pb-1'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,'\u9EDE'),wp.element.createElement('li',{'class':'pb-1'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,'\u5143')),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('section',{className:'pt-0'},wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{className:'container d-lg-none'},wp.element.createElement('div',{className:'card shadow-5 rounded-20 border-0 mb-4'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-auto'},wp.element.createElement('h6',{className:'h6 text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('查詢月份','cec-plugin-stores'))),wp.element.createElement('div',{className:'col'},wp.element.createElement('select',{className:'form-select border border-primary mb-md-0 mb-4',name:'SelectMonth',id:'SelectMonth',value:this.state.selectmonth,onChange:this.selectChange},wp.element.createElement('option',{value:areaMonth.month[0]},areaMonth.value[0]),wp.element.createElement('option',{value:areaMonth.month[1]},areaMonth.value[1]),wp.element.createElement('option',{value:areaMonth.month[2]},areaMonth.value[2]),wp.element.createElement('option',{value:areaMonth.month[3]},areaMonth.value[3]),wp.element.createElement('option',{value:areaMonth.month[4]},areaMonth.value[4]),wp.element.createElement('option',{value:areaMonth.month[5]},areaMonth.value[5])))),wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('網站僅提供六個月內消費紀錄查詢，若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！','cec-plugin-stores')))),wp.element.createElement('div',{className:'mb-5'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:this.state.purLoading},mixTableData.length===0&&wp.element.createElement('div',{className:'card-record-list-mobile card shadow-5 rounded-20 border-0 mb-3','data-toggle':'collapse',href:'#order-detail-m-1',role:'button','aria-expanded':'false','aria-controls':'order-detail-m-1'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'row align-items-center',style:{'text-align':'center'}},wp.element.createElement('h6',{className:'h6 text-navy mb-0',style:{width:'100%'}},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('尚無任何消費記錄','cec-plugin-stores'))))),mixTableData.length!==0&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(mixTableData,function(v){var purAccounts=v['pur_accounts']||[];var purTenders=v['pur_tenders']||[];var purItems=v['pur_items']||[];var purNetAmount=v['pur_netamount']||[];// 小計
var purTotalamount=parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(v,'pur_totalamount',[]),10);// 總計
var purDiscount=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(v,'pur_discount',0)?parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(v,'pur_discount',[]),10):'';// 紅利折抵
// 紅利點數
var BonusPointEarnValue=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.earnValue',0)?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.earnValue',[]):'';// __('暫無資料','cec-plugin-stores')
var BonusPointBalance=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.balance',[])?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.balance',[]):'';var BonusPointDiscount=parseInt(BonusPointBalance/300,10);var BonusPointRedeemValue=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.redeemValue',[])?parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.redeemValue',[]),10):0;var BonusPointEarnAmount=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purTenders,'1.amount',[])?parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purTenders,'1.amount',[]),10):Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores');return wp.element.createElement('div',null,wp.element.createElement('div',null,wp.element.createElement('div',{className:'card-record-list-mobile card shadow-5 rounded-20 border-0 mb-3','data-toggle':'collapse',href:'#order-detail-m-'+v.pur_id,role:'button','aria-expanded':'false','aria-controls':'#order-detail-m-'+v.pur_id},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'row align-items-center'},wp.element.createElement('div',{className:'col-auto'},wp.element.createElement('h6',{className:'h6 text-navy mb-0'},v.pur_dt)),wp.element.createElement('div',{className:'col'},wp.element.createElement('h6',{className:'h6 text-navy mb-0'},!v.pur_store?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('店外消費','cec-plugin-stores'):v.pur_store==='All Stores'?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('總公司','cec-plugin-stores'):v.pur_store)),wp.element.createElement('div',{className:'col-auto'},wp.element.createElement('h6',{className:'h6 text-primary mb-0'},Local==='en_US'&&v.pur_amount&&'$'+v.pur_amount,Local==='zh_TW'&&v.pur_amount&&v.pur_amount+'\u5143',Local==='en_US'&&v.pur_amount===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),Local==='en_US'&&v.pur_amount===0&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')))))),wp.element.createElement('div',{className:'card-record-info-mobile collapse',id:'order-detail-m-'+v.pur_id},wp.element.createElement('div',{className:'card shadow-5 rounded-20 border-0 mb-4'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('h6',{className:'h6 text-primary my-4'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('交易明細','cec-plugin-stores')),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('消費日期','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},v.pur_dt)))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('分店名稱','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},!v.pur_store?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('店外消費','cec-plugin-stores'):v.pur_store==='All Stores'?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('總公司','cec-plugin-stores'):v.pur_store)))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('交易型態','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},v.pur_trantypeid==='20'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('消費','cec-plugin-stores'),v.pur_trantypeid==='23'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('退費','cec-plugin-stores'),v.pur_trantypeid===-66&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點數調整','cec-plugin-stores'))))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('是否列印發票','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},v.isLoaded!==true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('','cec-plugin-stores'),v.einvoice_type==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('電子發票','cec-plugin-stores'),v.einvoice_type!=='2'&&v.einvoice_type!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('紙本發票','cec-plugin-stores'),v.einvoice_type!=='2'&&v.einvoice_type===''&&v.isLoaded===true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'))))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('是否中獎','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},diffdd==='未開獎'&&v.einvoice_type==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('未開獎','cec-plugin-stores'),diffdd==='未開獎'&&v.einvoice_type==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('請自行對獎','cec-plugin-stores'),v.isLoaded!==true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('','cec-plugin-stores'),v.einvoice_type===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),diffdd==='已開獎'&&v.einvoice_type==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('請自行對獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('未中獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='B'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無實體發票專屬獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='C'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無實體百萬元獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='A'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('特別獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='0'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('特獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='1'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('頭獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('二獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('三獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='4'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('四獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='5'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('五獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='6'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('六獎','cec-plugin-stores'))))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票捐贈','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},![2,3].includes(parseInt(v.einvoice_type,10))?'-':wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,v.donation===1?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('有','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無','cec-plugin-stores')))))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('備註','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},v.pur_remarks!==''&&v.pur_remarks,v.pur_remarks===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')))),wp.element.createElement('hr',{className:'my-5'}),wp.element.createElement('h6',{className:'h6 text-primary my-4'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('商品','cec-plugin-stores')),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(purItems,function(item){var itemName=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'itemName',[]);var qty=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'qty',[]);return wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},itemName)),wp.element.createElement('div',{className:'col-3 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary mb-0'},qty)),wp.element.createElement('div',{className:'col-3 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary mb-0'},'$',__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'amount',0))));}),wp.element.createElement('hr',{className:'my-5'}),wp.element.createElement('h6',{className:'h6 text-primary my-4'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票/金額','cec-plugin-stores')),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票號碼','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},v.einvoice_no!==''&&v.einvoice_no,v.einvoice_no===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'))))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('小計','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},'$',purNetAmount)))),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(purTenders,function(tender){return wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tender,'tenderName','-'),'cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},'$',__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.toInteger(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tender,'amount',0))))));}),wp.element.createElement('hr',{className:'my-5'}),wp.element.createElement('h6',{className:'h6 text-primary my-4'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點數','cec-plugin-stores')),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('本次扣抵','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block text-danger'},BonusPointRedeemValue,BonusPointRedeemValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores')),wp.element.createElement('span',{className:'rounded-o rounded-red'},'P')))),wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-6'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('本次回饋','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-6 text-right border-left border-gary'},wp.element.createElement('p',{className:'p text-primary d-flex align-items-center justify-content-end mb-0'},wp.element.createElement('span',{className:'d-inline-block'},BonusPointEarnValue,BonusPointEarnValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores'),v.isLoaded===true&&BonusPointEarnValue===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')),wp.element.createElement('span',{className:'rounded-o rounded-blue'},'P')))))))));}),wp.element.createElement('div',{className:'row mb-5 mt-4'},wp.element.createElement('div',{className:'col-8 col-md-3 mx-auto'},wp.element.createElement('a',{className:'h6 btn btn-block btn-outline-primary rounded-pill py-4',role:'button',href:'#'},'\u770B\u66F4\u591A'))))),wp.element.createElement('div',{className:'card shadow-5 rounded-20 border-0 mb-4'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'row align-items-center mb-4'},wp.element.createElement('div',{className:'col-12'},wp.element.createElement('h6',{className:'h5 text-navy text-center mb-4'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))),wp.element.createElement('div',{className:'col-12'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))),wp.element.createElement('div',{className:'container d-none d-lg-block'},wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-28 px-3',style:{flexGrow:0,flexShrink:0,flexBasis:'calc((100% / 7) * 2)',maxWidth:'calc((100% / 7) * 2)'}},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{'class':'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('查詢月份','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-71 px-3',style:{flexGrow:0,flexShrink:0,flexBasis:'calc((100% / 7) * 5)',maxWidth:'calc((100% / 7) * 5)'}},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('div',{className:'row'},wp.element.createElement('div',{className:'col-md-3'},wp.element.createElement('select',{className:'form-select border border-primary mb-md-0 mb-4',name:'SelectMonth',id:'SelectMonth',value:this.state.selectmonth,onChange:this.selectChange},wp.element.createElement('option',{value:areaMonth.month[0]},areaMonth.value[0]),wp.element.createElement('option',{value:areaMonth.month[1]},areaMonth.value[1]),wp.element.createElement('option',{value:areaMonth.month[2]},areaMonth.value[2]),wp.element.createElement('option',{value:areaMonth.month[3]},areaMonth.value[3]),wp.element.createElement('option',{value:areaMonth.month[4]},areaMonth.value[4]),wp.element.createElement('option',{value:areaMonth.month[5]},areaMonth.value[5]))),wp.element.createElement('div',{className:'col-md-9'},wp.element.createElement('p',{className:'p text-navy mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！','cec-plugin-stores')))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-12 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-4 p-lg-0'},wp.element.createElement('div',{className:'flex-table','data-theme':'primary'},wp.element.createElement('div',{className:'thead'},wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('消費日期','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('分店名稱','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('交易型態','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('消費金額','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('紅利折抵','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('獲得點數','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票號碼','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('是否列印發票','cec-plugin-stores')),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('是否中獎','cec-plugin-stores')))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:this.state.purLoading},mixTableData.length===0&&wp.element.createElement('div',{className:'tbody'},wp.element.createElement('ul',{className:'table-row order-detail-item'},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('尚無任何消費記錄','cec-plugin-stores')))),mixTableData.length!==0&&__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(mixTableData,function(v){var purAccounts=v['pur_accounts']||[];var purTenders=v['pur_tenders']||[];var purItems=v['pur_items']||[];var purNetAmount=v['pur_netamount']||[];var BonusPointEarnValue=purAccounts[0]?purAccounts[0].earnValue:'';var BonusPointBalance=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.balance',[])?__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.balance',[]):0;var BonusPointDiscount=parseInt(BonusPointBalance/300,10);var BonusPointRedeemValue=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.redeemValue',0)?parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purAccounts,'0.redeemValue',0),10):0;var BonusPointEarnAmount=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purTenders,'1.amount',[])?parseInt(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(purTenders,'1.amount',[]),10):Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores');return wp.element.createElement('div',null,wp.element.createElement('div',{className:'tbody'},wp.element.createElement('ul',{'class':'table-row order-detail-item','data-toggle':'collapse',href:'#order-detail-'+v.pur_id,role:'button','aria-expanded':'false','aria-controls':'#order-detail-'+v.pur_id,id:v.pur_id// onClick={() => this.clickgetdetail(v)}
},wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u65E5\u671F',style:{textAlign:'left'}},v.pur_dt,' ',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{spinning:!v.isLoaded,size:'small'})),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u5206\u5E97\u540D\u7A31'},!v.pur_store?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('店外消費','cec-plugin-stores'):v.pur_store==='All Stores'?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('總公司','cec-plugin-stores'):v.pur_store),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u4EA4\u6613\u578B\u614B'},v.pur_trantypeid===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),v.pur_trantypeid==='20'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('消費','cec-plugin-stores'),v.pur_trantypeid==='23'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('退費','cec-plugin-stores'),v.pur_trantypeid===-66&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點數調整','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u6D88\u8CBB\u91D1\u984D'},Local==='en_US'&&v.pur_amount&&'$'+v.pur_amount,Local==='zh_TW'&&v.pur_amount&&v.pur_amount+'\u5143',Local==='zh_TW'&&v.pur_amount===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),Local==='en_US'&&v.pur_amount===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u7D05\u5229\u6298\u62B5'},BonusPointRedeemValue,BonusPointRedeemValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores')),wp.element.createElement('li',{'data-title':'\u7372\u5F97\u9EDE\u6578'},BonusPointEarnValue,BonusPointEarnValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores'),v.isLoaded===true&&BonusPointEarnValue===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u767C\u7968\u865F\u78BC'},v.einvoice_no!==''&&v.einvoice_no,v.einvoice_no===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u662F\u5426\u5217\u5370\u767C\u7968'},v.isLoaded!==true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),v.einvoice_type==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('電子發票','cec-plugin-stores'),v.einvoice_type!=='2'&&v.einvoice_type!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('紙本發票','cec-plugin-stores'),v.einvoice_type!=='2'&&v.einvoice_type===''&&v.isLoaded===true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')),wp.element.createElement('li',{className:'d-none d-lg-block','data-title':'\u662F\u5426\u4E2D\u734E'},diffdd==='未開獎'&&v.einvoice_type==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('未開獎','cec-plugin-stores'),diffdd==='未開獎'&&v.einvoice_type==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('請自行對獎','cec-plugin-stores'),v.isLoaded!==true&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('','cec-plugin-stores'),v.einvoice_type===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'),diffdd==='已開獎'&&v.einvoice_type==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('請自行對獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('未中獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='B'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無實體發票專屬獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='C'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無實體百萬元獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='A'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('特別獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='0'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('特獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='1'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('頭獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='2'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('二獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='3'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('三獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='4'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('四獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='5'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('五獎','cec-plugin-stores'),diffdd==='已開獎'&&v.isLoaded===true&&v.einvoice_type==='2'&&v.win==='6'&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('六獎','cec-plugin-stores'))),wp.element.createElement('div',{className:'order-detail-info collapse',id:'order-detail-'+v.pur_id},wp.element.createElement('div',{className:'card'},wp.element.createElement('div',{className:'card-body'},wp.element.createElement('div',{className:'card points-list'},wp.element.createElement('h5',{className:'card-header'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點數明細','cec-plugin-stores')),wp.element.createElement('div',{className:'card-body p-0'},wp.element.createElement('ul',{className:'list-unstyled'},wp.element.createElement('li',{className:'d-flex align-items-center justify-content-between text-navy p-4 border-light border-bottom'},wp.element.createElement('p',{className:'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('本次扣抵','cec-plugin-stores')),wp.element.createElement('p',{className:'p text-right text-danger mb-0'},BonusPointRedeemValue,BonusPointRedeemValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores'))),wp.element.createElement('li',{className:'d-flex align-items-center justify-content-between text-navy p-4 border-light border-bottom'},wp.element.createElement('p',{className:'p text-left mb-0'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('本次回饋點數總計','cec-plugin-stores')),wp.element.createElement('p',{className:'p text-right text-primary mb-0'},BonusPointEarnValue,BonusPointEarnValue!==''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('點','cec-plugin-stores'),v.isLoaded===true&&BonusPointEarnValue===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores')))))),wp.element.createElement('div',{className:'card order-list'},wp.element.createElement('h5',{className:'card-header text-left'},wp.element.createElement('span',{className:'d-block'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('交易明細： ','cec-plugin-stores'),v.pur_transactionTime),wp.element.createElement('span',{className:'d-block'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('發票捐贈： ','cec-plugin-stores'),![2,3].includes(parseInt(v.einvoice_type,10))?'-':wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,v.donation===1?Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('有','cec-plugin-stores'):Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('無','cec-plugin-stores'))),wp.element.createElement('span',{className:'d-block'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('備註： ','cec-plugin-stores'),v.pur_remarks!==''&&v.pur_remarks,v.pur_remarks===''&&Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('-','cec-plugin-stores'))),wp.element.createElement('div',{className:'card-body p-0'},wp.element.createElement('div',{className:'flex-table','data-theme':'light'},wp.element.createElement('div',{className:'thead tbody'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(purItems,function(item){var itemName=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'itemName',[]);var qty=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'qty',[]);return wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{className:'text-left','data-title':'\u54C1\u540D'},itemName),wp.element.createElement('li',{'data-title':'\u6578\u91CF'},qty),wp.element.createElement('li',{className:'text-center','data-title':'\u91D1\u984D'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(item,'amount',0)));}),wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{className:'text-lg-left d-none d-lg-block'},' '),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('小計','cec-plugin-stores')),wp.element.createElement('li',{className:'text-center','data-title':'\u91D1\u984D'},purNetAmount)),__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.map(purTenders,function(tender){return wp.element.createElement('ul',{className:'table-row'},wp.element.createElement('li',{className:'text-center'},'\xA0'),wp.element.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tender,'tenderName','-'),'cec-plugin-stores')),wp.element.createElement('li',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.toInteger(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(tender,'amount',0))));}))))))))));}))))))),wp.element.createElement('div',{className:'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{className:'col-lg-3 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('h5',{className:'h4 text-navy text-center'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('注意事項','cec-plugin-stores'))))),wp.element.createElement('div',{className:'col-lg-9 px-3'},wp.element.createElement('div',{className:'card border-0 shadow-0 h-100'},wp.element.createElement('div',{className:'card-body p-5'},wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('客服中心：市話 0809-001-365 / 手機(02)8006-9999 ','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！','cec-plugin-stores')),wp.element.createElement('p',{className:'h6 text-navy text-justify'},Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。','cec-plugin-stores'))))))))));}}]);return UserPaymentOca;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);var test_list=[{id:1050,pur_amount:100,pur_dt:'2020-07-26',pur_id:1050,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1049,pur_amount:100,pur_dt:'2020-07-26',pur_id:1049,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1048,pur_amount:100,pur_dt:'2020-07-26',pur_id:1048,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1047,pur_amount:100,pur_dt:'2020-07-26',pur_id:1047,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1046,pur_amount:100,pur_dt:'2020-07-26',pur_id:1046,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1045,pur_amount:100,pur_dt:'2020-07-26',pur_id:1045,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1044,pur_amount:100,pur_dt:'2020-07-26',pur_id:1044,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1043,pur_amount:100,pur_dt:'2020-07-26',pur_id:1043,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1042,pur_amount:100,pur_dt:'2020-07-26',pur_id:1042,pur_store:'測試店',pur_storeId:'888',pur_posId:1},{id:1040,pur_amount:100,pur_dt:'2020-07-26',pur_id:1040,pur_store:'測試店',pur_storeId:'888',pur_posId:1}];var test_detail=[{id:'1050',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0,win:'6',prize_amount:200},{id:'1049',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0,win:'6',prize_amount:200},{id:'1048',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0,win:'6',prize_amount:200},{id:'1047',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0,win:'6',prize_amount:200},{id:'1046',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0,win:'6',prize_amount:200},{id:'1045',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0},{id:'1044',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0},{id:'1043',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0},{id:'1042',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0},{id:'1040',pur_transactionTime:'2020-07-26 20:00:10',pur_discount:'0.000',pur_accounts:[{id:'1',name:'紅利點數',earnValue:99,redeemValue:0,balance:19979}],pur_items:[{itemId:'1806328',itemName:'雪山啤酒Can473ml',hierarchyId:'10100',amount:100,price:100,netPrice:100,qty:1}],pur_tenders:[{tenderId:1,tenderName:'Cash',amount:'99.000'},{tenderId:16,tenderName:'紅利兌換',amount:'1.000'}],pur_coupons:null,pur_trantypeid:'20',pur_totalamount:'100.000',pur_netamount:100,einvoice_no:'DS99767892',redemption_status:1,einvoice_type:'2',donation:0}];var test=[{pur_amount:25,pur_dt:'2020-07-24 14:09:00',pur_id:1324310059,pur_redeem_pts:0,pur_reward_pts:50,pur_store:'北投店',don_fl:0,inv_code:'BS75554229',inv_date:'2020-06-27 00:00:00',inv_id:336502898,inv_type:'電子發票(有列印)',inv_win_code:'',inv_win_flag:0},{pur_amount:256,pur_dt:'2020-07-19 18:54:00',pur_id:1322730315,pur_redeem_pts:0,pur_reward_pts:512,pur_store:'重新店',don_fl:0,inv_code:'BS75554228',inv_date:'2020-06-27 00:00:00',inv_id:336502877,inv_type:'電子發票(有列印)',inv_win_code:'',inv_win_flag:0}];// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserPaymentOcaEditor=function(_Component2){_inherits(UserPaymentOcaEditor,_Component2);function UserPaymentOcaEditor(){var _ref3;var _temp2,_this3,_ret2;_classCallCheck(this,UserPaymentOcaEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref3=UserPaymentOcaEditor.__proto__||Object.getPrototypeOf(UserPaymentOcaEditor)).call.apply(_ref3,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(UserPaymentOcaEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);//this.formRef.current.setFieldsValue(this.props.attributes)
}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'OCA-\u6D88\u8CBB\u8A18\u9304'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserPaymentOcaEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserProfileOca; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserProfileOcaEditor", function() { return UserProfileOcaEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styles from './styles.module.scss';
var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG',{});var Local=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(window,'VC_CONFIG.Locale');var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};function isMobileDevice(){var mobileDevices=['Android','iPhone','iPad'];var isMobileDevice=0;for(var i=0;i<mobileDevices.length;i++){if(navigator.userAgent.match(mobileDevices[i])){isMobileDevice=1;}}return isMobileDevice;}// 前端頁面
var UserProfileOca=function(_Component){_inherits(UserProfileOca,_Component);function UserProfileOca(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserProfileOca);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserProfileOca.__proto__||Object.getPrototypeOf(UserProfileOca)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this.logoutTimer=null,_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo),isSubmitData:false,isLoading:false,ocaUrl:null,memberVip:'',memberLinkcode:'',bonusPoint:0,bonusPointDiscount:0,iframeHeight:900,logoutModal:false,iframeLoaded:false,isLoadingLogout:false},_this.LoadOCA=function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/ocaUri?type=profile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'發生錯誤'});}if(code===401){// Modal.error({
//   title: '登入資訊已過期',
//   onOk: () => {
//     window.location.replace(VC_CONFIG.INDEX_URL);
//   }
// });
console.log('登入資訊過期');}else if(code!==200){// notification['error']({
//   message: '資料讀取失敗',
//   description: reason,
// });
__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({ocaUrl:data.uri},function(){_this.getIframeHeight();_this.logoutTimer=setTimeout(function(){_this.setState({logoutModal:true});},120000);});});},_this.reloadTab=function(){// tab 共用動態
var $el,leftPos,newWidth;/* Add Magic Line markup via JavaScript, because it ain't gonna work without */var $magicLine=__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#magic-line');if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get($magicLine,0)){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul').append("<li id='magic-line'></li>");}/* Cache it */$magicLine=__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#magic-line');$magicLine.width(__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.current_page_item').width()).css('left',__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.current_page_item a').position().left).data('origLeft',$magicLine.position().left).data('origWidth',$magicLine.width());__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.basic-tabs-label ul li').find('a').hover(function(){$el=__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this);leftPos=$el.position().left;newWidth=$el.parent().width();$magicLine.stop().animate({left:leftPos,width:newWidth});},function(){$magicLine.stop().animate({left:$magicLine.data('origLeft'),width:$magicLine.data('origWidth')});});__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#pills-tab .nav-item').unbind('mouseenter mouseleave');__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#pills-tab .nav-item').mouseenter(function(){if(!__WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).hasClass('highlight')){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.highlight').removeClass('current_page_item');}}).mouseleave(function(){__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.highlight').addClass('current_page_item');});},_this.getProfile=function(){_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/getProfile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){// return message.error('發生錯誤');
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'發生錯誤'});}if(code===401){// Modal.error({
//   title: '登入資訊已過期',
//   onOk: () => {
//     window.location.replace(VC_CONFIG.INDEX_URL);
//   }
// });
console.log('登入資訊過期');}else if(code!==200){// notification['error']({
//   message: '資料讀取失敗',
//   description: reason,
// });
__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({info:data});__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].thirdPartyLogin(data.client_id,data.access_token);});},_this.getMemberProfile=function(){__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/getProfiles',{},function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(code!==200){__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'資料讀取失敗',content:reason});console.log('資料讀取失敗： ',reason);return _this.setState({messages:data.messages||{}});}_this.setState({memberVip:data.member_profile_isvip==0?'一般會員':'VIP',memberLinkcode:data.member_profile_linkcode,bonusPoint:parseInt(data.member_account_value,10),bonusPointDiscount:parseInt(data.member_account_value/300,10)});});},_this.getIframeHeight=function(){var url=_this.state.ocaUrl;var frame=document.getElementById('iframe-profile');var message={parentOrigin:window.origin,msg:'收到請回覆'};frame.addEventListener('load',function(){var frameContent=frame.contentWindow;frameContent.postMessage(JSON.stringify(message),url);_this.setState({iframeLoaded:true});});},_this.logout=function(){_this.setState({isLoadingLogout:true});__WEBPACK_IMPORTED_MODULE_13__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_12__configs_env__["b" /* API_HOST */]+'/api/account/oca/ocaUri?type=logout',{},function(state,res){var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!==200){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');_this.props.cleanUserInfo();_this.props.cleanAuthInfo();window.location.href=data.uri;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserProfileOca,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.LoadOCA();__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].updateConfig();this.getMemberProfile();this.getProfile();this.setState({info:this.props.user},function(){_this2.reloadTab();});// 獲取 iframe 高度
window.addEventListener('message',function(event){console.log('event.data',event.data);if(typeof event.data==='number'){clearTimeout(_this2.logoutTimer);var iframeHeight=event.data+20;__WEBPACK_IMPORTED_MODULE_10_jquery___default()('#iframe-profile').css({visibility:'visible'});_this2.setState({iframeHeight:iframeHeight});}});}},{key:'render',value:function render(){var _this3=this;var ocaUrl=this.state.ocaUrl;var ProfileInfo=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'state.info');var MemberVip=this.state.memberVip;var MemberLinkcode=this.state.memberLinkcode;var BonusPoint=this.state.bonusPoint;var BonusPointDiscount=this.state.bonusPointDiscount;var iframeHeight=this.state.iframeHeight;var isMobile=isMobileDevice();return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,wp.element.createElement('main',{className:'bg-light'},wp.element.createElement('div',{className:' container'},wp.element.createElement('section',{className:'pt-2 pb-2'},wp.element.createElement('div',{className:'breadcrumb-wrap'},wp.element.createElement('nav',{'aria-label':'breadcrumb'},Local=='zh_TW'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),Local=='en_US'&&wp.element.createElement('ol',{className:'breadcrumb'},wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('首頁','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item'},wp.element.createElement('a',{href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('會員中心','cec-plugin-stores'))),wp.element.createElement('li',{className:'breadcrumb-item active','aria-current':'page'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))))),wp.element.createElement('h6',{className:'h5 lh-h4 mb-5 text-navy text-lg-left text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('親愛的','cec-plugin-stores'),wp.element.createElement('b',{className:'fw-700'},ProfileInfo&&ProfileInfo.name),wp.element.createElement('br',{className:'d-block d-lg-none'}),Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('您好，歡迎來到會員中心！','cec-plugin-stores')),wp.element.createElement('div',{'class':'row no-gutters mx-n3 mb-4'},wp.element.createElement('div',{'class':'col-lg-4 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body justify-content-center align-items-center pb-0 pt-5 p-lg-5'},wp.element.createElement('div',{'class':'hkcardontop',style:{textAlign:'center'}},MemberVip=='VIP'?wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/2021VIPcard.png',alt:''}):wp.element.createElement('img',{style:{maxWidth:'180px'},className:'img-contain',src:VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/img/membercard/newHKcard.png',alt:''}))))),wp.element.createElement('div',{'class':'col-lg-8 px-3'},wp.element.createElement('div',{'class':'card border-0 shadow-0 h-100'},wp.element.createElement('div',{'class':'card-body'},wp.element.createElement('ul',{'class':'h6 text-navy text-justify list-unstyled'},wp.element.createElement('li',{'class':'pb-1'},'\u6703\u54E1\u7B49\u7D1A\uFF1A',MemberVip),wp.element.createElement('li',{'class':'pb-1'},'\u597D\u5EB7\u9EDE\u6578\uFF1A',BonusPoint,'\u9EDE'),wp.element.createElement('li',{'class':'pb-1'},'\u53EF\u514C\u63DB\u91D1\u984D\uFF1A',BonusPointDiscount,'\u5143')),wp.element.createElement('p',{'class':'h6 pt-4 text-font text-justify'},'*\u986F\u793A\u4E4B\u9EDE\u6578\u8996\u6D88\u8CBB\u60C5\u6CC1\u66F4\u65B0\uFF01\u5982\u9047\u8CC7\u6599\u4EA4\u63DB\u9020\u6210\u9EDE\u6578\u5EF6\u9072\u7570\u52D5\uFF0C\u4EE5\u96FB\u8166\u7CFB\u7D71\u70BA\u6E96\u3002'))))))),wp.element.createElement('div',{className:'mb-5 basic-tabs-label'},Local=='zh_TW'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores')))),Local=='en_US'&&wp.element.createElement('ul',{className:'nav nav-pills',id:'pills-tab'},wp.element.createElement('li',{className:'nav-item current_page_item highlight'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/profile-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('我的帳戶','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/pwd-en'},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('更改密碼','cec-plugin-stores'))),wp.element.createElement('li',{className:'nav-item'},wp.element.createElement('a',{className:'nav-link',href:VC_CONFIG.INDEX_URL+'/einvoice-carrier-consolidation'+(Local=='en_US'?'-en':'')},Object(__WEBPACK_IMPORTED_MODULE_14__wordpress_i18n__["__"])('發票歸戶','cec-plugin-stores'))))),wp.element.createElement('div',{align:'center',style:{backgroundColor:'#F5F4F2',height:iframeHeight+'px',position:'relative'}},ocaUrl&&wp.element.createElement('iframe',{id:'iframe-profile',title:'iframe-profile',style:{visibility:'hidden',height:'100%'},src:ocaUrl,width:isMobile?'100%':'80%',border:'0',frameborder:'no',scrolling:'no'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{size:'large',style:{position:'absolute',top:'50%',left:'50%'},spinning:!this.state.iframeLoaded}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a,{visible:this.state.logoutModal,title:'Oops !',closable:false,okText:'\u78BA\u5B9A',confirmLoading:this.state.isLoadingLogout,cancelButtonProps:{style:{display:'none'}},onOk:function onOk(){return _this3.logout();}},wp.element.createElement('div',null,'\u6703\u54E1\u5E33\u865F\u767B\u5165\u6642\u9593\u5DF2\u904E\u671F\uFF0C\u8ACB\u91CD\u65B0\u767B\u5165\u3002')));}}]);return UserProfileOca;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var UserProfileOcaEditor=function(_Component2){_inherits(UserProfileOcaEditor,_Component2);function UserProfileOcaEditor(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,UserProfileOcaEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=UserProfileOcaEditor.__proto__||Object.getPrototypeOf(UserProfileOcaEditor)).call.apply(_ref2,[this].concat(args))),_this4),_this4.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this4.state={listInfo:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(UserProfileOcaEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_11_libs_AppHelper__["a" /* default */].updateConfig();this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(this,'props.app.options',{});return wp.element.createElement('div',{className:'wp-block-cec-vulcan-block-catalogue-list-editor'},wp.element.createElement('h2',null,'OCA-\u6703\u54E1\u8CC7\u8A0A\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserProfileOcaEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UserLoginOca; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserLoginOcaEditor", function() { return UserLoginOcaEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_spin_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__wordpress_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__wordpress_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_img_banner_banner_catalog_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reducers_auth__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(window,'VC_CONFIG',{});var defaultListInfo={current:1,//目前頁數
page_size:10,//一頁幾筆
total:1,//以此query條件，總共幾筆資料
rows:[]};// 前端頁面
var UserLoginOca=function(_Component){_inherits(UserLoginOca,_Component);function UserLoginOca(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserLoginOca);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserLoginOca.__proto__||Object.getPrototypeOf(UserLoginOca)).call.apply(_ref,[this].concat(args))),_this),_this.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo),To:null,ContactData:{}},_this.exchangeToken=function(code){_this.props.cleanAuthInfo();console.log('exchangecode',code);if(code==null){// return notification['error']({
//   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+('/api/account/getAccessTokenOca?code='+code),{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){// return notification['error']({
//           message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//           description: reason,
//           onClose:() => {
//             //window.location.href = VC_CONFIG.INDEX_URL;
//           }
//         });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'登入失敗，請稍候再試。',content:reason});}if(code!==200){if(code==901){//進行手機綁定流程，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
// return notification['warning']({
//   message: __('須將帳號改為手機', 'cec-plugin-stores'),
//   description: reason,
//   onClose: () => {
//     window.location.href = data.uri;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('須將帳號改為手機','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==902){//調用OCA帳號更新UI，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
// return notification['warning']({
//   message: __('更新帳號資訊。', 'cec-plugin-stores'),
//   description: reason,
//   onClose: () => {
//     window.location.href = data.uri;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('更新帳號資訊。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==903){//調用OCA帳號更新UI，根據回傳的uri轉導到該頁面(回傳格式在下方)。由OCA UI進行資料異動
// return notification['warning']({
//   message: __('進行解除綁定後補資料流程', 'cec-plugin-stores'),
//   description: reason,
//   onClose: () => {
//     window.location.href = data.uri;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.warning({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('進行解除綁定後補資料流程','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=data.uri;}});}else if(code==999){//顯示錯誤訊息並返回首頁
// return notification['error']({
//   message: __('解除綁定不完全，請與客服中心聯繫。', 'cec-plugin-stores'),
//   description: reason,
//   onClose: () => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('解除綁定不完全，請與客服中心聯繫。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}// return notification['error']({
//   message: '提示',
//   description: reason,
//   onClose: () => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:'提示',content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}_this.props.updateAuthInfo({authorization:data.token});console.log('exchangeToken',data.token);_this.fetchUserInfo();});},_this.fetchUserInfo=function(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateUserInfo(function(resp){console.log('updateUserInfo userInfo:',resp);var link=VC_CONFIG.INDEX_URL;__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['success']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入成功','cec-plugin-stores'),duration:1,onClose:function onClose(){if(_this.state.To){link=link+_this.state.To;if(_this.state.ContactData){link=link+'?data='+encodeURIComponent(JSON.stringify(_this.state.ContactData));}}else{link=VC_CONFIG.INDEX_URL+'/profile';}console.log('sso網頁轉至: ',link);window.location.replace(link);}});});},_this.subLogin=function(src_token,src_client_id){_this.props.cleanAuthInfo();if(src_token==null||src_client_id==null){// return notification['error']({
//   message: __('登入失敗，請稍候再試','cec-plugin-stores'),
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_15__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__configs_env__["b" /* API_HOST */]+'/api/account/getSubLogInOca',{src_token:src_token,src_client_id:src_client_id},function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){// return notification['error']({
//   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//   description: reason,
//   onClose:() => {
//     //window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){// window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code==300){//顯示錯誤訊息並返回首頁
// return notification['error']({
//         message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//         description: reason,
//         onClose:() => {
//           window.location.href = VC_CONFIG.INDEX_URL;
//         }
//       });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL;}});}else if(code!==200&&code!==300){// return notification['error']({
//   message: __('登入失敗，請稍候再試。','cec-plugin-stores'),
//   description: reason,
//   onClose:() => {
//     //window.location.href = VC_CONFIG.INDEX_URL;
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.error({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入失敗，請稍候再試。','cec-plugin-stores'),content:reason,onOk:function onOk(){// window.location.href = VC_CONFIG.INDEX_URL;
}});}if(code==200){_this.props.updateAuthInfo({authorization:data.token});console.log('subLogin',data,data.token);__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateUserInfo(function(){var link=VC_CONFIG.INDEX_URL;__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['success']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入成功','cec-plugin-stores'),duration:1,onClose:function onClose(){if(_this.state.To){link=link+_this.state.To;if(_this.state.ContactData){link=link+'?data='+encodeURIComponent(JSON.stringify(_this.state.ContactData));}}else{link=VC_CONFIG.INDEX_URL+'/profile';}console.log('sso網頁轉至: ',link);window.location.href=link;}});});}});},_this.Logout=function(){__WEBPACK_IMPORTED_MODULE_5_antd_lib_notification___default.a['warning']({message:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('已成功登出','cec-plugin-stores'),duration:1,onClose:function onClose(){//AppHelper.removeLocalStorage('contact-data')
//AppHelper.removeLocalStorage('to-href')
//this.props.cleanUserInfo();
//this.props.cleanAuthInfo();
window.location.href=VC_CONFIG.INDEX_URL;}});},_this.thirdBinding=function(redirectFlag){var showMessage='您已完成綁定第三方帳號';switch(redirectFlag){case'1':showMessage='您已完成綁定第三方帳號(Facebook)關聯';break;case'2':showMessage='您已完成解除第三方帳號(Facebook)關聯';break;case'3':showMessage='您已完成綁定第三方帳號(G+)關聯';break;case'4':showMessage='您已完成解除第三方帳號(G+)關聯';break;case'5':showMessage='您已完成綁定第三方帳號(Line)關聯';break;case'6':showMessage='您已完成解除第三方帳號(Line)關聯';break;default:return;}// return notification['success']({
//   message: __(showMessage,'cec-plugin-stores'),
//   duration: 3,
//   onClose:() => {
//     window.location.href = VC_CONFIG.INDEX_URL+"/profile";
//   }
// });
return __WEBPACK_IMPORTED_MODULE_7_antd_lib_modal___default.a.success({title:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])(showMessage,'cec-plugin-stores'),onOk:function onOk(){window.location.href=VC_CONFIG.INDEX_URL+'/profile';}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserLoginOca,[{key:'getParameterByName',value:function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\]]/g,'\\$&');var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)'),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var To=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('to-href');var ContactData=__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].getLocalStorage('contact-data');if(To){this.setState({To:To},function(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');});if(ContactData)this.setState({ContactData:ContactData},function(){_this2.exchangeToken(_this2.getParameterByName('code'));__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');});console.log('sso',To,ContactData);}var code=this.getParameterByName('code');console.log('code:',code);if(this.getParameterByName('src_token')&&this.getParameterByName('src_client_id')){return this.subLogin(this.getParameterByName('src_token'),this.getParameterByName('src_client_id'));}if(this.getParameterByName('redirectFlag')){return this.thirdBinding(this.getParameterByName('redirectFlag'));}if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(code)){return this.exchangeToken(code);}// 判斷是否有user
var authorization=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this.props,'auth.authorization');if(!__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isEmpty(authorization)){return this.fetchUserInfo();}window.location.href='/';}//測試： https://www.uni-prosperity.com.tw/sso?src_token=123&src_client_id=123
//第三方綁定
},{key:'render',value:function render(){return wp.element.createElement('div',{style:{height:'350px'},className:'jumbotron d-flex align-items-center'},wp.element.createElement('div',{className:'text-center'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_spin___default.a,{className:'mt-4',size:'large',tip:Object(__WEBPACK_IMPORTED_MODULE_22__wordpress_i18n__["__"])('登入中...','cec-plugin-stores')})));}}]);return UserLoginOca;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);// 編輯器
var UserLoginOcaEditor=function(_Component2){_inherits(UserLoginOcaEditor,_Component2);function UserLoginOcaEditor(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,UserLoginOcaEditor);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=UserLoginOcaEditor.__proto__||Object.getPrototypeOf(UserLoginOcaEditor)).call.apply(_ref2,[this].concat(args))),_this3),_this3.formRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(),_this3.state={listInfo:__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(defaultListInfo)},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(UserLoginOcaEditor,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_13_libs_AppHelper__["a" /* default */].updateConfig();console.log('kkk',this.props.attributes);this.formRef.current.setFieldsValue(this.props.attributes);}},{key:'render',value:function render(){var listInfo=this.state.listInfo;var options=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(this,'props.app.options',{});console.log('editor',this.props);return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('h2',null,'\u6703\u54E1 SSO \u767B\u5165\u6A21\u7D44'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm'}));}}]);return UserLoginOcaEditor;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetFacebook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetFacebookEditor", function() { return WidgetFacebookEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instagram_embed__ = __webpack_require__(2180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 前端頁面
var WidgetFacebook=function(_Component){_inherits(WidgetFacebook,_Component);function WidgetFacebook(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WidgetFacebook);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WidgetFacebook.__proto__||Object.getPrototypeOf(WidgetFacebook)).call.apply(_ref,[this].concat(args))),_this),_this.loadData=function(){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_4__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/account/giveme5',{},function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;//console.log(code, reason, data, res)
if(state===false||code!==200){console.error(reason);return;}_this.setState({posts:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data,'facebook',[]),igPostInfo:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data,'instagram.0')},function(){if(window.FB){window.FB.init({xfbml:true,version:'v6.0'});}//if (window.instgrm) window.instgrm.Embeds.process()
});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WidgetFacebook,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}},{key:'render',value:function render(){var postInfo=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this,'state.posts.0',{});var igLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this,'state.igPostInfo.link');var found=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(postInfo,'link','').match(/https:\/\/www.facebook.com\/(\d*)_(\d*)/);var postId=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(found,'2');var fbLink=postId?'https://www.facebook.com/prosperity.tw/posts/'+postId:null;// # Embedded Posts
// https://developers.facebook.com/docs/plugins/embedded-posts?locale=zh_HK
//window.instgrm.Embeds.process()
return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,wp.element.createElement('div',{'class':'fb-wrapper'},igLink&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_react_instagram_embed__["a" /* default */],{url:igLink,hideCaption:false,protocol:'',containerTagName:'Fragment',injectScript:true}))));}}]);return WidgetFacebook;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// 編輯器
var WidgetFacebookEditor=function(_Component2){_inherits(WidgetFacebookEditor,_Component2);function WidgetFacebookEditor(){_classCallCheck(this,WidgetFacebookEditor);return _possibleConstructorReturn(this,(WidgetFacebookEditor.__proto__||Object.getPrototypeOf(WidgetFacebookEditor)).apply(this,arguments));}_createClass(WidgetFacebookEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-cloud'})),'\u5929\u6C23\u5143\u4EF6'));}}]);return WidgetFacebookEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetFacebookMall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetFacebookMallEditor", function() { return WidgetFacebookMallEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_whttp__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 前端頁面
var WidgetFacebookMall=function(_Component){_inherits(WidgetFacebookMall,_Component);function WidgetFacebookMall(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WidgetFacebookMall);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WidgetFacebookMall.__proto__||Object.getPrototypeOf(WidgetFacebookMall)).call.apply(_ref,[this].concat(args))),_this),_this.loadData=function(){_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_4__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_3__configs_env__["b" /* API_HOST */]+'/api/account/giveme5',{},function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){console.error(reason);return;}_this.setState({posts:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data,'facebook_mall',[]),igPostInfo:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data,'instagram.0')},function(){if(window.FB){window.FB.init({xfbml:true,version:'v6.0'});}if(window.instgrm)window.instgrm.Embeds.process();});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WidgetFacebookMall,[{key:'componentDidMount',value:function componentDidMount(){this.loadData();}},{key:'render',value:function render(){var postInfo=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this,'state.posts.0',{});var igLink=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this,'state.igPostInfo.link');var found=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(postInfo,'link','').match(/https:\/\/www.facebook.com\/(\d*)_(\d*)/);var postId=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(found,'2');var fbLink=postId?'https://www.facebook.com/cec.mall.tw/posts/'+postId:null;console.log('re');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,fbLink&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,wp.element.createElement('script',{async:'',defer:'',crossorigin:'anonymous',src:'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v6.0',integrity:'sha384-tGX9ELjlGPfAjLclS6ecSCLOYvJv8fPBjbWdPdsWANwE4VxBwBPmhPqBnqFsuT0Y'}),wp.element.createElement('div',{'class':'fb-post d-block','data-href':fbLink,'data-show-text':'false','data-width':'auto'})));}}]);return WidgetFacebookMall;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// 編輯器
var WidgetFacebookMallEditor=function(_Component2){_inherits(WidgetFacebookMallEditor,_Component2);function WidgetFacebookMallEditor(){_classCallCheck(this,WidgetFacebookMallEditor);return _possibleConstructorReturn(this,(WidgetFacebookMallEditor.__proto__||Object.getPrototypeOf(WidgetFacebookMallEditor)).apply(this,arguments));}_createClass(WidgetFacebookMallEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-cloud'})),'\u5929\u6C23\u5143\u4EF6'));}}]);return WidgetFacebookMallEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetWeatherEditor", function() { return WidgetWeatherEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libs_wjson__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');// 前端頁面
var WidgetWeather=function(_Component){_inherits(WidgetWeather,_Component);function WidgetWeather(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WidgetWeather);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WidgetWeather.__proto__||Object.getPrototypeOf(WidgetWeather)).call.apply(_ref,[this].concat(args))),_this),_this.state={query:{a:null,t:null,id:null},cityid:null},_this.loadData=function(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.setState({isFetchData:true});var cityid=query.a;__WEBPACK_IMPORTED_MODULE_6__libs_whttp__["a" /* default */].sharedGet(__WEBPACK_IMPORTED_MODULE_5__configs_env__["b" /* API_HOST */]+('/api/account/getWeather/'+(cityid||'')),{},function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;//console.log(code, reason, data, res)
if(state===false||code!==200){console.error(reason);return;}_this.setState({weatherInfo:data.weather});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WidgetWeather,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_4_libs_AppHelper__["a" /* default */].getHashParamaters();var cacheQuery=__WEBPACK_IMPORTED_MODULE_7_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null};if(!query.a&&cacheQuery.a){query.a=cacheQuery.a;}//console.log('componentDidMount', query, cacheQuery)
this.setState({query:query});this.loadData(query);}},{key:'render',value:function render(){var weatherInfo=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this,'state.weatherInfo');var className='icon-weather_8-1';var wx=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(weatherInfo,'Wx','');if(wx.includes('雲')){className='icon-weather_8-2';}if(wx.includes('雨')){className='icon-weather_8-6';}if(wx.includes('雪')){className='icon-weather_8-7';}if(wx.includes('風大')){className='icon-weather_8-8';}if(wx.includes('晴時多雲')){className='icon-weather_8-3';}if(wx.includes('多雲時陰短暫陣雨')){className='icon-weather_8-4';}if(wx.includes('雷雨')||wx.includes('雷陣雨')){className='icon-weather_8-5';}this.setState();return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,wp.element.createElement('div',{'class':'weather'},wp.element.createElement('span',{'class':'iconBox'},' ',wp.element.createElement('i',{className:className})),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(weatherInfo,'MaxT','--'),'\xB0C'));}}]);return WidgetWeather;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// 編輯器
var WidgetWeatherEditor=function(_Component2){_inherits(WidgetWeatherEditor,_Component2);function WidgetWeatherEditor(){_classCallCheck(this,WidgetWeatherEditor);return _possibleConstructorReturn(this,(WidgetWeatherEditor.__proto__||Object.getPrototypeOf(WidgetWeatherEditor)).apply(this,arguments));}_createClass(WidgetWeatherEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-cloud'})),'\u5929\u6C23\u5143\u4EF6'));}}]);return WidgetWeatherEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetWine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetWineEditor", function() { return WidgetWineEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libs_wjson__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');// 前端頁面
var WidgetWine=function(_Component){_inherits(WidgetWine,_Component);function WidgetWine(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WidgetWine);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WidgetWine.__proto__||Object.getPrototypeOf(WidgetWine)).call.apply(_ref,[this].concat(args))),_this),_this.state={query:{a:null,t:null,id:null},cityid:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WidgetWine,[{key:'componentDidMount',value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_4_libs_AppHelper__["a" /* default */].getHashParamaters();var cacheQuery=__WEBPACK_IMPORTED_MODULE_7_libs_wjson__["a" /* default */].decode(localStorage.getItem('c4-map-query'))||{a:null,t:null,id:null};if(!query.a&&cacheQuery.a){query.a=cacheQuery.a;}console.log('componentDidMount',query,cacheQuery);this.setState({query:query});}},{key:'render',value:function render(){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,wp.element.createElement('div',{'class':'prohibit-minors-bar'},wp.element.createElement('strong',null,'\u7981\u6B62\u9152\u99D5\u672A\u6EFF\u5341\u516B\u6B72\u7981\u6B62\u98F2\u9152')));}}]);return WidgetWine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// 編輯器
var WidgetWineEditor=function(_Component2){_inherits(WidgetWineEditor,_Component2);function WidgetWineEditor(){_classCallCheck(this,WidgetWineEditor);return _possibleConstructorReturn(this,(WidgetWineEditor.__proto__||Object.getPrototypeOf(WidgetWineEditor)).apply(this,arguments));}_createClass(WidgetWineEditor,[{key:'render',value:function render(){return wp.element.createElement('div',{className:'vu-blocks-editor'},wp.element.createElement('div',{'class':'components-placeholder__label'},wp.element.createElement('span',{'class':'block-editor-block-icon'},wp.element.createElement('div',{'class':'dashicons dashicons-cloud'})),'\u9152\u6A19\u5143\u4EF6'));}}]);return WidgetWineEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(916);
module.exports = __webpack_require__(920);


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(917).enable();
  window.Promise = __webpack_require__(918);
}

// fetch() polyfill for making API calls.
__webpack_require__(919);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(64);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(480);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(480);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 919 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_config_provider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_locale_provider_zh_TW__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_locale_provider_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_locale_provider_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_libs_wjson__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_App__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes_Login__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_ECLogin__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_blocks_stores_store_list_v2__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_blocks_stores_store_map__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_blocks_brands_brand_list__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_blocks_users_user_sso_login__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_blocks_users_user_sso_login_cc__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_blocks_users_user_profile__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_blocks_users_user_profile_cc__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_blocks_users_user_password__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_blocks_users_user_password_cc__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_blocks_users_user_payment__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_blocks_users_user_point__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_blocks_users_user_invoice__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_blocks_users_user_invoice_carrier_consolidation__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_blocks_users_user_connect__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_blocks_users_user_big_platform_process__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_blocks_users_user_carrier_binding__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_blocks_catalogues_catalogue_list__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_blocks_cibc_cibc_recruit__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_blocks_customer_service_faq_us__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_blocks_cibc_cibc_contact_us__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_blocks_cibc_cibc_servicepoint__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_blocks_customer_service_feedback__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_blocks_stock_stock_list_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__blocks_stock_stock_all_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__blocks__ = __webpack_require__(323);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// 引入模組-blocks
__WEBPACK_IMPORTED_MODULE_12_libs_AppHelper__["a" /* default */].updateConfig();var renderReactDOM=function renderReactDOM(id,MixNode){// className for blocks
var mountPoints=[].concat(_toConsumableArray(document.getElementsByClassName('wp-block-'+id)));// id for 後台管理
var mountPoint=document.getElementById(id);if(mountPoint&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(mountPoints,mountPoint)===-1){mountPoints.push(mountPoint);}// console.log(`renderReactDOM`, id, `wp-block-${id}`, mountPoint, mountPoints)
if(mountPoints.length===0)return;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(mountPoints,function(node){var attributes=__WEBPACK_IMPORTED_MODULE_8_libs_wjson__["a" /* default */].decode(node.getAttribute('vu-attributes'));// console.log('renderReactDOM', attributes, node)
__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6__reducers__["a" /* store */]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_config_provider___default.a,{locale:__WEBPACK_IMPORTED_MODULE_7_antd_lib_locale_provider_zh_TW___default.a},wp.element.createElement(MixNode,attributes))),node);});};// 掛載ReactComponent
renderReactDOM('loginButton',__WEBPACK_IMPORTED_MODULE_10__routes_Login__["a" /* default */]);renderReactDOM('ECLogin',__WEBPACK_IMPORTED_MODULE_11__routes_ECLogin__["a" /* default */]);// 管理頁面
renderReactDOM('cec-mount-point',__WEBPACK_IMPORTED_MODULE_9__routes_App__["a" /* default */]);// Blocks 頁面編輯器 & 前端
var blocksSetting=[{module:'stock',name:'stock-all',title:'全台總庫存數量',icon:'megaphone',editor:__WEBPACK_IMPORTED_MODULE_37__blocks_stock_stock_all_js__["StockAllEditor"],keywords:['全台庫存','stock'],attributes:{productId:{type:'int'}}},{module:'stock',name:'stock-list',title:'庫存列表',icon:'megaphone',editor:__WEBPACK_IMPORTED_MODULE_36_blocks_stock_stock_list_js__["StockListEditor"],keywords:['庫存','stock'],attributes:{productId:{type:'int'},productName:{type:'string'}}},{module:'stock',name:'stock-store',title:'門市選擇器',icon:'store',keywords:['庫存','stock']},{module:'news',name:'news-list',title:'消息列表',icon:'megaphone',keywords:['消息','news'],attributes:{mode:{type:'int',default:1},category_ids:{type:'array',default:[]}}},{module:'news',name:'news-list-preview',title:'預覽消息列表',icon:'megaphone',keywords:['消息','news'],attributes:{mode:{type:'int',default:1},category_ids:{type:'array',default:[]}}},{module:'news',name:'news-info',title:'消息資訊',icon:'megaphone',keywords:['消息','news']},{module:'stores',name:'store-map',title:'分店地圖',icon:'admin-site-alt3',editor:__WEBPACK_IMPORTED_MODULE_15_blocks_stores_store_map__["StoreMapEditor"],keywords:['分店','store','地圖','map']},{module:'stores',name:'store-list',title:'分店列表',icon:'store',editor:__WEBPACK_IMPORTED_MODULE_14_blocks_stores_store_list_v2__["StoreListEditor"],keywords:['分店','store']},{module:'stores',name:'store-info',title:'分店資訊',icon:'tagcloud',keywords:['分店','store']},{module:'stores',name:'store-vendor',title:'分店第三方平台列表',icon:'tagcloud',keywords:['第三方平台','store']},{module:'brands',name:'brand-list',title:'品牌列表',icon:'layout',editor:__WEBPACK_IMPORTED_MODULE_16_blocks_brands_brand_list__["BrandListEditor"],keywords:['品牌','brand']},{module:'brands',name:'brand-info',title:'品牌資訊',icon:'layout',keywords:['品牌','brand']},{module:'users',name:'user-sso-login',title:'會員登入',icon:'admin-users',editor:__WEBPACK_IMPORTED_MODULE_17_blocks_users_user_sso_login__["UserLoginEditor"],keywords:['會員','user']},{module:'users',name:'user-profile',title:'會員資料',icon:'edit',editor:__WEBPACK_IMPORTED_MODULE_19_blocks_users_user_profile__["UserProfileEditor"],keywords:['會員','user']},{module:'users',name:'user-loyaltyprofile',title:'好康卡會員資料',icon:'edit',editor:__WEBPACK_IMPORTED_MODULE_19_blocks_users_user_profile__["UserProfileEditor"],keywords:['會員','user']},{module:'users',name:'user-password',title:'密碼變更',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_21_blocks_users_user_password__["UserPasswordEditor"],keywords:['會員','user']},{module:'users',name:'user-payment',title:'我的消費紀錄',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_23_blocks_users_user_payment__["UserPaymentEditor"],keywords:['會員','user']},{module:'users',name:'user-point',title:'點數紀錄',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_24_blocks_users_user_point__["UserPointEditor"],keywords:['會員','user']},{module:'users',name:'user-invoice',title:'電子發票',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_25_blocks_users_user_invoice__["UserInvoiceEditor"],keywords:['會員','user']},{module:'users',name:'user-connect',title:'關連帳號',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_27_blocks_users_user_connect__["UserConnectEditor"],keywords:['會員','user']},{module:'users',name:'user-sso-login-cc',title:'CC會員登入',icon:'admin-users',editor:__WEBPACK_IMPORTED_MODULE_18_blocks_users_user_sso_login_cc__["UserLoginCCEditor"],keywords:['會員','user']},{module:'users',name:'user-sso-login-oca',title:'OCA會員登入',icon:'admin-users',editor:__WEBPACK_IMPORTED_MODULE_17_blocks_users_user_sso_login__["UserLoginEditor"],keywords:['會員','user']},{module:'users',name:'user-profile-oca',title:'OCA會員資料',icon:'edit',editor:__WEBPACK_IMPORTED_MODULE_19_blocks_users_user_profile__["UserProfileEditor"],keywords:['會員','user']},{module:'users',name:'user-profile-cc',title:'CC會員資料',icon:'edit',editor:__WEBPACK_IMPORTED_MODULE_20_blocks_users_user_profile_cc__["UserProfileCCEditor"],keywords:['會員','user']},{module:'users',name:'user-password-oca',title:'OCA密碼變更',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_21_blocks_users_user_password__["UserPasswordEditor"],keywords:['會員','user']},{module:'users',name:'user-password-cc',title:'CC密碼變更',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_22_blocks_users_user_password_cc__["UserPasswordCCEditor"],keywords:['會員','user']},{module:'users',name:'user-payment-oca',title:'OCA我的消費紀錄',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_23_blocks_users_user_payment__["UserPaymentEditor"],keywords:['會員','user']},{module:'users',name:'user-invoice-carrier-consolidation',title:'OCA發票歸戶',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_26_blocks_users_user_invoice_carrier_consolidation__["UserInvoiceCarrierConsolidationEditor"],keywords:['會員','user']},{module:'users',name:'user-big-platform-process',title:'大平台載具歸戶-處理頁面',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_28_blocks_users_user_big_platform_process__["UserBigPlatformProcessEditor"],keywords:['會員','user','大平台','載具','歸戶']},{module:'users',name:'user-carrier-binding',title:'大平台載具綁定頁面',icon:'admin-site',editor:__WEBPACK_IMPORTED_MODULE_29_blocks_users_user_carrier_binding__["UserCarrierBindingEditor"],keywords:['會員','user','大平台','載具','綁定']},{module:'catalogues',name:'catalogue-list',title:'促銷目錄列表',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_30_blocks_catalogues_catalogue_list__["CatalogueListEditor"],keywords:['目錄','catalogue'],attributes:{category_ids:{type:'array',default:[]}}},{module:'catalogues',name:'catalogue-pos',title:'促銷目錄POS',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_30_blocks_catalogues_catalogue_list__["CatalogueListEditor"],keywords:['目錄','catalogue'],attributes:{category_ids:{type:'array',default:[]}}},{module:'catalogues',name:'catalogue-info',title:'促銷目錄內容',icon:'book',keywords:['目錄','catalogue']},{module:'widget',name:'widget-weather',title:'天氣',icon:'admin-generic',keywords:['天氣','weather']},{module:'widget',name:'widget-facebook',title:'SocialMedia',icon:'admin-generic',keywords:['facebook']},{module:'widget',name:'widget-facebook-mall',title:'MallSocialMedia',icon:'admin-generic',keywords:['facebookmall']},{module:'widget',name:'widget-wine',title:'酒標',icon:'admin-generic',keywords:['酒標','wine']},{module:'repair',name:'repair-info',title:'家電維修',icon:'layout',keywords:['維修','repair']},{module:'customer-service',name:'contact-us',title:'聯絡我們',icon:'format-status',keywords:['聯絡我們','contact']},{module:'customer-service',name:'service-us',title:'服務',icon:'format-status',keywords:['服務','service']},{module:'customer-service',name:'faq-us',title:'常見問題',icon:'format-status',editor:__WEBPACK_IMPORTED_MODULE_32_blocks_customer_service_faq_us__["FAQUsEditor"],keywords:['常見問題','faq']},{module:'customer-service',name:'feedback',title:'滿意度調查',icon:'format-status',editor:__WEBPACK_IMPORTED_MODULE_35_blocks_customer_service_feedback__["FeedBackEditor"],keywords:['滿意度調查','feedback']},{module:'recipes',name:'recipe-list',title:'食譜列表',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_16_blocks_brands_brand_list__["BrandListEditor"],keywords:['食譜','recipe']},{module:'recipes',name:'recipe-info',title:'食譜資訊',icon:'book',keywords:['食譜','recipe']},{module:'cibc',name:'cibc-recruit',title:'保經人才招募',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_31_blocks_cibc_cibc_recruit__["RecruitEditor"],keywords:['保經人才招募','cibc']},{module:'cibc',name:'cibc-servicepoint',title:'保經服務據點',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_34_blocks_cibc_cibc_servicepoint__["CIBCServicePointEditor"],keywords:['保經服務據點','cibc']},{module:'cibc',name:'cibc-calculation',title:'保障試算',icon:'book',keywords:['保障試算','cibc']},{module:'cibc',name:'cibc-contact-us',title:'保經聯絡我們',icon:'book',editor:__WEBPACK_IMPORTED_MODULE_33_blocks_cibc_cibc_contact_us__["CIBCInfoEditor"],keywords:['保經聯絡我們','cibc']}];Object(__WEBPACK_IMPORTED_MODULE_38__blocks__["default"])(blocksSetting);blocksSetting.forEach(function(item){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isBoolean(item.mountView)&&item.mountView===false)return;renderReactDOM(Object(__WEBPACK_IMPORTED_MODULE_38__blocks__["getBlockMountIdByName"])(item.name),Object(__WEBPACK_IMPORTED_MODULE_13_reducers__["b" /* wConnectRedux */])(__webpack_require__(861)("./"+item.module+'/'+item.name).default));});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(922);

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(201);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(485);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(929);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(933);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(488);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_asyncToGenerator__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_typeof__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async_validator__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__valueUtil__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages__ = __webpack_require__(498);










 // Remove incorrect original ts define

var AsyncValidator = __WEBPACK_IMPORTED_MODULE_6_async_validator__["a" /* default */];
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */

function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function (str) {
    var key = str.slice(2, -1);
    return kv[key];
  });
}
/**
 * We use `async-validator` to validate rules. So have to hot replace the message with validator.
 * { required: '${name} is required' } => { required: () => 'field is required' }
 */


function convertMessages(messages, name, rule, messageVariables) {
  var kv = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, rule), {}, {
    name: name,
    enum: (rule.enum || []).join(', ')
  });

  var replaceFunc = function replaceFunc(template, additionalKV) {
    return function () {
      return replaceMessage(template, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, kv), additionalKV));
    };
  };
  /* eslint-disable no-param-reassign */


  function fillTemplate(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Object.keys(source).forEach(function (ruleName) {
      var value = source[ruleName];

      if (typeof value === 'string') {
        target[ruleName] = replaceFunc(value, messageVariables);
      } else if (value && Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object') {
        target[ruleName] = {};
        fillTemplate(value, target[ruleName]);
      } else {
        target[ruleName] = value;
      }
    });
    return target;
  }
  /* eslint-enable */


  return fillTemplate(Object(__WEBPACK_IMPORTED_MODULE_9__valueUtil__["j" /* setValues */])({}, __WEBPACK_IMPORTED_MODULE_10__messages__["a" /* defaultValidateMessages */], messages));
}

function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */


function _validateRule() {
  _validateRule = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_asyncToGenerator__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, subRuleField, validator, messages, result, subResults;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cloneRule = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, rule); // We should special handle array validate

            subRuleField = null;

            if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }

            validator = new AsyncValidator(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, name, [cloneRule]));
            messages = convertMessages(options.validateMessages, name, cloneRule, messageVariables);
            validator.messages(messages);
            result = [];
            _context2.prev = 7;
            _context2.next = 10;
            return Promise.resolve(validator.validate(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, name, value), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, options)));

          case 10:
            _context2.next = 15;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](7);

            if (_context2.t0.errors) {
              result = _context2.t0.errors.map(function (_ref2, index) {
                var message = _ref2.message;
                return (// Wrap ReactNode with `key`

                  /*#__PURE__*/
                  __WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"](message) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"](message, {
                    key: "error_".concat(index)
                  }) : message
                );
              });
            } else {
              console.error(_context2.t0);
              result = [messages.default()];
            }

          case 15:
            if (!(!result.length && subRuleField)) {
              _context2.next = 20;
              break;
            }

            _context2.next = 18;
            return Promise.all(value.map(function (subValue, i) {
              return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
            }));

          case 18:
            subResults = _context2.sent;
            return _context2.abrupt("return", subResults.reduce(function (prev, errors) {
              return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(prev), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(errors));
            }, []));

          case 20:
            return _context2.abrupt("return", result);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[7, 12]]);
  }));
  return _validateRule.apply(this, arguments);
}

function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
  var name = namePath.join('.'); // Fill rule with context

  var filledRules = rules.map(function (currentRule) {
    var originValidatorFunc = currentRule.validator;

    if (!originValidatorFunc) {
      return currentRule;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, currentRule), {}, {
      validator: function validator(rule, val, callback) {
        var hasPromise = false; // Wrap callback only accept when promise not provided

        var wrappedCallback = function wrappedCallback() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          // Wait a tick to make sure return type is a promise
          Promise.resolve().then(function () {
            Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_warning__["a" /* default */])(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');

            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        }; // Get promise


        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
        /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */

        Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_warning__["a" /* default */])(hasPromise, '`callback` is deprecated. Please return a promise instead.');

        if (hasPromise) {
          promise.then(function () {
            callback();
          }).catch(function (err) {
            callback(err || ' ');
          });
        }
      }
    });
  });
  var summaryPromise;

  if (validateFirst === true) {
    // >>>>> Validate by serialization
    summaryPromise = new Promise( /*#__PURE__*/function () {
      var _ref = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_asyncToGenerator__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
        var i, errors;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < filledRules.length)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 4;
                return validateRule(name, value, filledRules[i], options, messageVariables);

              case 4:
                errors = _context.sent;

                if (!errors.length) {
                  _context.next = 8;
                  break;
                }

                reject(errors);
                return _context.abrupt("return");

              case 8:
                i += 1;
                _context.next = 1;
                break;

              case 11:
                /* eslint-enable */
                resolve([]);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x6, _x7) {
        return _ref.apply(this, arguments);
      };
    }());
  } else {
    // >>>>> Validate by parallel
    var rulePromises = filledRules.map(function (rule) {
      return validateRule(name, value, rule, options, messageVariables);
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function (errors) {
      if (!errors.length) {
        return [];
      }

      return Promise.reject(errors);
    });
  } // Internal catch error to avoid console error log.


  summaryPromise.catch(function (e) {
    return e;
  });
  return summaryPromise;
}

function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}

function _finishOnAllFailed() {
  _finishOnAllFailed = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_asyncToGenerator__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee3(rulePromises) {
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function (errorsList) {
              var _ref3;

              var errors = (_ref3 = []).concat.apply(_ref3, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(errorsList));

              return errors;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}

function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}

function _finishOnFirstFailed() {
  _finishOnFirstFailed = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_asyncToGenerator__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee4(rulePromises) {
    var count;
    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function (resolve) {
              rulePromises.forEach(function (promise) {
                promise.then(function (errors) {
                  if (errors.length) {
                    resolve(errors);
                  }

                  count += 1;

                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(937)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(490)["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _asyncToGenerator;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/* eslint no-console:0 */
var formatRegExp = /%[sdj%]/g;
var warning = function warning() {}; // don't print warning message when in production env or node runtime

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"/kiosk"}) && "production" !== 'production' && typeof window !== 'undefined' && typeof document !== 'undefined') {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;

  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }

  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }

      if (i >= len) {
        return x;
      }

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

          break;

        default:
          return x;
      }
    });
    return str;
  }

  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }

  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }

  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }

  return false;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;

    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }

    var original = index;
    index = index + 1;

    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

var AsyncValidationError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(AsyncValidationError, _Error);

  function AsyncValidationError(errors, fields) {
    var _this;

    _this = _Error.call(this, 'Async Validation Error') || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }

  return AsyncValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var _pending = new Promise(function (resolve, reject) {
      var next = function next(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve();
      };

      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });

    _pending["catch"](function (e) {
      return e;
    });

    return _pending;
  }

  var firstFields = option.firstFields || [];

  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }

  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;

      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve();
      }
    };

    if (!objArrKeys.length) {
      callback(results);
      resolve();
    }

    objArrKeys.forEach(function (key) {
      var arr = objArr[key];

      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function (e) {
    return e;
  });
  return pending;
}
function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }

    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];

        if (typeof value === 'object' && typeof target[s] === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }

  return target;
}

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
}

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
}

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }

    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }

    return typeof value === 'number';
  },
  object: function object(value) {
    return typeof value === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};
/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    required(rule, value, source, errors, options);
    return;
  }

  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;

  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    } // straight typeof check

  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）

  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);

  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  } // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type


  if (!key) {
    return false;
  }

  if (arr) {
    val = value.length;
  }

  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }

  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

var ENUM = 'enum';
/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];

  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function pattern$1(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;

      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);

      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

var rules = {
  required: required,
  whitespace: whitespace,
  type: type,
  range: range,
  "enum": enumerable,
  pattern: pattern$1
};

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'string');

    if (!isEmptyValue(value, 'string')) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);

      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }

  callback(errors);
}

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (value === '') {
      value = undefined;
    }

    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function _boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if ((value === undefined || value === null) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, 'array');

    if (value !== undefined && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

var ENUM$1 = 'enum';
/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function enumerable$1(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (value !== undefined) {
      rules[ENUM$1](rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function pattern$2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, 'string') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'string')) {
      rules.pattern(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);

  if (validate) {
    if (isEmptyValue(value, 'date') && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);

    if (!isEmptyValue(value, 'date')) {
      var dateObject;

      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }

      rules.type(rule, dateObject, source, errors, options);

      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }

  callback(errors);
}

function required$1(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value;
  rules.required(rule, value, source, errors, options, type);
  callback(errors);
}

function type$1(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options, ruleType);

    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }

  callback(errors);
}

/**
 *  Performs validation for any type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */

function any(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);

  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }

    rules.required(rule, value, source, errors, options);
  }

  callback(errors);
}

var validators = {
  string: string,
  method: method,
  number: number,
  "boolean": _boolean,
  regexp: regexp,
  integer: integer,
  "float": floatFn,
  array: array,
  object: object,
  "enum": enumerable$1,
  pattern: pattern$2,
  date: date,
  url: type$1,
  hex: type$1,
  email: type$1,
  required: required$1,
  any: any
};

function newMessages() {
  return {
    "default": 'Validation error on field %s',
    required: '%s is required',
    "enum": '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      "boolean": '%s is not a %s',
      integer: '%s is not an %s',
      "float": '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */

function Schema(descriptor) {
  this.rules = null;
  this._messages = messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }

    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }

    if (typeof rules !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }

    this.rules = {};
    var z;
    var item;

    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_, o, oc) {
    var _this = this;

    if (o === void 0) {
      o = {};
    }

    if (oc === void 0) {
      oc = function oc() {};
    }

    var source = source_;
    var options = o;
    var callback = oc;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }

      return Promise.resolve();
    }

    function complete(results) {
      var i;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }

      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = convertFieldsError(errors);
      }

      callback(errors, fields);
    }

    if (options.messages) {
      var messages$1 = this.messages();

      if (messages$1 === messages) {
        messages$1 = newMessages();
      }

      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }

    var arr;
    var value;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;

        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }

          value = source[z] = rule.transform(value);
        }

        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }

        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);

        if (!rule.validator) {
          return;
        }

        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + "." + key
        });
      }

      function cb(e) {
        if (e === void 0) {
          e = [];
        }

        var errors = e;

        if (!Array.isArray(errors)) {
          errors = [errors];
        }

        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }

        if (errors.length && rule.message !== undefined) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(complementError(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }

        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message !== undefined) {
              errors = [].concat(rule.message).map(complementError(rule));
            } else if (options.error) {
              errors = [options.error(rule, format(options.messages.required, rule.field))];
            }

            return doIt(errors);
          }

          var fieldsSchema = {};

          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }

          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);

          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }

          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);

          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }

          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];

            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }

            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }

            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res;

      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);

        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }

      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }

    if (typeof rule.validator !== 'function' && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format('Unknown rule type %s', rule.type));
    }

    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }

    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');

    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }

    if (keys.length === 1 && keys[0] === 'required') {
      return validators.required;
    }

    return validators[this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }

  validators[type] = validator;
};

Schema.warning = warning;
Schema.messages = messages;
Schema.validators = validators;

/* harmony default export */ __webpack_exports__["a"] = (Schema);
//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(329)))

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = set;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toArray__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get__ = __webpack_require__(491);




function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toArray__["a" /* default */])(paths),
    path = _paths[0],
    restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path === 'number') {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(entity);
  } else {
    clone = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, entity);
  }

  // Delete prop if `removeIfUndefined` and value is undefined
  if (removeIfUndefined && value === undefined && restPath.length === 1) {
    delete clone[path][restPath[0]];
  } else {
    clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // Do nothing if `removeIfUndefined` and parent object not exist
  if (paths.length && removeIfUndefined && value === undefined && !Object(__WEBPACK_IMPORTED_MODULE_3__get__["a" /* default */])(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(159);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(494);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(497);




function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldContext__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Field__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_valueUtil__ = __webpack_require__(158);








var List = function List(_ref) {
  var name = _ref.name,
      initialValue = _ref.initialValue,
      children = _ref.children,
      rules = _ref.rules,
      validateTrigger = _ref.validateTrigger;
  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__FieldContext__["b" /* default */]);
  var keyRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current; // User should not pass `children` as other type.

  if (typeof children !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_warning__["a" /* default */])(false, 'Form.List only accepts function as children.');
    return null;
  }

  var parentPrefixName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_valueUtil__["d" /* getNamePath */])(context.prefixName) || [];
  var prefixName = [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(parentPrefixName), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_valueUtil__["d" /* getNamePath */])(name)));

  var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
    var source = _ref2.source;

    if (source === 'internal') {
      return false;
    }

    return prevValue !== nextValue;
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FieldContext__["b" /* default */].Provider, {
    value: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, context), {}, {
      prefixName: prefixName
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Field__["a" /* default */], {
    name: [],
    shouldUpdate: shouldUpdate,
    rules: rules,
    validateTrigger: validateTrigger,
    initialValue: initialValue,
    isList: true
  }, function (_ref3, meta) {
    var _ref3$value = _ref3.value,
        value = _ref3$value === void 0 ? [] : _ref3$value,
        onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;

    var getNewValue = function getNewValue() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    /**
     * Always get latest value in case user update fields by `form` api.
     */


    var operations = {
      add: function add(defaultValue, index) {
        // Mapping keys
        var newValue = getNewValue();

        if (index >= 0 && index <= newValue.length) {
          keyManager.keys = [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(keyManager.keys.slice(0, index)), [keyManager.id], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(keyManager.keys.slice(index)));
          onChange([].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(newValue.slice(0, index)), [defaultValue], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(newValue.slice(index))));
        } else {
          if (false) {
            warning(false, 'The second parameter of the add function should be a valid positive number.');
          }

          keyManager.keys = [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(keyManager.keys), [keyManager.id]);
          onChange([].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(newValue), [defaultValue]));
        }

        keyManager.id += 1;
      },
      remove: function remove(index) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index) ? index : [index]);

        if (indexSet.size <= 0) {
          return;
        }

        keyManager.keys = keyManager.keys.filter(function (_, keysIndex) {
          return !indexSet.has(keysIndex);
        }); // Trigger store change

        onChange(newValue.filter(function (_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move(from, to) {
        if (from === to) {
          return;
        }

        var newValue = getNewValue(); // Do not handle out of range

        if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }

        keyManager.keys = Object(__WEBPACK_IMPORTED_MODULE_6__utils_valueUtil__["h" /* move */])(keyManager.keys, from, to); // Trigger store change

        onChange(Object(__WEBPACK_IMPORTED_MODULE_6__utils_valueUtil__["h" /* move */])(newValue, from, to));
      }
    };
    var listValue = value || [];

    if (!Array.isArray(listValue)) {
      listValue = [];

      if (false) {
        warning(false, "Current value of '".concat(prefixName.join(' > '), "' is not an array type."));
      }
    }

    return children(listValue.map(function (__, index) {
      var key = keyManager.keys[index];

      if (key === undefined) {
        keyManager.keys[index] = keyManager.id;
        key = keyManager.keys[index];
        keyManager.id += 1;
      }

      return {
        name: index,
        key: key,
        isListField: true
      };
    }), operations, meta);
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allPromiseFinish;
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];

  if (!promiseList.length) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve, reject) {
    promiseList.forEach(function (promise, index) {
      promise.catch(function (e) {
        hasError = true;
        return e;
      }).then(function (result) {
        count -= 1;
        results[index] = result;

        if (count > 0) {
          return;
        }

        if (hasError) {
          reject(results);
        }

        resolve(results);
      });
    });
  });
}

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__valueUtil__ = __webpack_require__(158);



/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */

var NameMap = /*#__PURE__*/function () {
  function NameMap() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NameMap);

    this.list = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(NameMap, [{
    key: "set",
    value: function set(key, value) {
      var index = this.list.findIndex(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__valueUtil__["g" /* matchNamePath */])(item.key, key);
      });

      if (index !== -1) {
        this.list[index].value = value;
      } else {
        this.list.push({
          key: key,
          value: value
        });
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var result = this.list.find(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__valueUtil__["g" /* matchNamePath */])(item.key, key);
      });
      return result && result.value;
    }
  }, {
    key: "update",
    value: function update(key, updater) {
      var origin = this.get(key);
      var next = updater(origin);

      if (!next) {
        this.delete(key);
      } else {
        this.set(key, next);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.list = this.list.filter(function (item) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2__valueUtil__["g" /* matchNamePath */])(item.key, key);
      });
    }
  }, {
    key: "map",
    value: function map(callback) {
      return this.list.map(callback);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function (_ref) {
        var key = _ref.key,
            value = _ref.value;
        json[key.join('.')] = value;
        return null;
      });
      return json;
    }
  }]);

  return NameMap;
}();

/* harmony default export */ __webpack_exports__["a"] = (NameMap);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useForm__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldContext__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormContext__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_valueUtil__ = __webpack_require__(158);










var Form = function Form(_ref, ref) {
  var name = _ref.name,
      initialValues = _ref.initialValues,
      fields = _ref.fields,
      form = _ref.form,
      preserve = _ref.preserve,
      children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'form' : _ref$component,
      validateMessages = _ref.validateMessages,
      _ref$validateTrigger = _ref.validateTrigger,
      validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger,
      onValuesChange = _ref.onValuesChange,
      _onFieldsChange = _ref.onFieldsChange,
      _onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"]);

  var formContext = __WEBPACK_IMPORTED_MODULE_4_react__["useContext"](__WEBPACK_IMPORTED_MODULE_7__FormContext__["b" /* default */]); // We customize handle event since Context will makes all the consumer re-render:
  // https://reactjs.org/docs/context.html#contextprovider

  var _useForm = Object(__WEBPACK_IMPORTED_MODULE_5__useForm__["a" /* default */])(form),
      _useForm2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useForm, 1),
      formInstance = _useForm2[0];

  var _formInstance$getInte = formInstance.getInternalHooks(__WEBPACK_IMPORTED_MODULE_6__FieldContext__["a" /* HOOK_MARK */]),
      useSubscribe = _formInstance$getInte.useSubscribe,
      setInitialValues = _formInstance$getInte.setInitialValues,
      setCallbacks = _formInstance$getInte.setCallbacks,
      setValidateMessages = _formInstance$getInte.setValidateMessages,
      setPreserve = _formInstance$getInte.setPreserve; // Pass ref with form instance


  __WEBPACK_IMPORTED_MODULE_4_react__["useImperativeHandle"](ref, function () {
    return formInstance;
  }); // Register form into Context

  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    formContext.registerForm(name, formInstance);
    return function () {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]); // Pass props to store

  setValidateMessages(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange: onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);

      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);

      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed: onFinishFailed
  });
  setPreserve(preserve); // Set initial value, init store value when first mount

  var mountRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](null);
  setInitialValues(initialValues, !mountRef.current);

  if (!mountRef.current) {
    mountRef.current = true;
  } // Prepare children by `children` type


  var childrenNode = children;
  var childrenRenderProps = typeof children === 'function';

  if (childrenRenderProps) {
    var values = formInstance.getFieldsValue(true);
    childrenNode = children(values, formInstance);
  } // Not use subscribe when using render props


  useSubscribe(!childrenRenderProps); // Listen if fields provided. We use ref to save prev data here to avoid additional render

  var prevFieldsRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_valueUtil__["f" /* isSimilar */])(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }

    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, formInstance), {}, {
      validateTrigger: validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__FieldContext__["b" /* default */].Provider, {
    value: formContextValue
  }, childrenNode);

  if (Component === false) {
    return wrapperNode;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, restProps, {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    }
  }), wrapperNode);
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ANT_MARK = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _locale = __webpack_require__(333);

var _context = _interopRequireDefault(__webpack_require__(505));

var ANT_MARK = 'internalMark';
exports.ANT_MARK = ANT_MARK;

var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LocaleProvider, _React$Component);

  var _super = (0, _createSuper2["default"])(LocaleProvider);

  function LocaleProvider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LocaleProvider);
    _this = _super.call(this, props);
    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
    (0, _devWarning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    return _this;
  }

  (0, _createClass2["default"])(LocaleProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var locale = this.props.locale;

      if (prevProps.locale !== locale) {
        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _locale.changeConfirmLocale)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(_context["default"].Provider, {
        value: (0, _extends2["default"])((0, _extends2["default"])({}, locale), {
          exist: true
        })
      }, children);
    }
  }]);
  return LocaleProvider;
}(React.Component);

exports["default"] = LocaleProvider;
LocaleProvider.defaultProps = {
  locale: {}
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(40)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 954 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 955 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 956 */
/***/ (function(module, exports) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(40)["default"];
var assertThisInitialized = __webpack_require__(203);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var locale = {
  locale: 'en_US',
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
var _default = locale;
exports.default = _default;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(250));

var _default = _en_US["default"];
exports["default"] = _default;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _default = _default2["default"];
exports["default"] = _default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _empty = _interopRequireDefault(__webpack_require__(335));

var _ = __webpack_require__(8);

var renderEmpty = function renderEmpty(componentName) {
  return /*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
      case 'Mentions':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });

      default:
        return /*#__PURE__*/React.createElement(_empty["default"], null);
    }
  });
};

var _default = renderEmpty;
exports["default"] = _default;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _configProvider = __webpack_require__(8);

var Empty = function Empty() {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('empty-img-default');
  return /*#__PURE__*/React.createElement("svg", {
    className: prefixCls,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 31.67)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "".concat(prefixCls, "-ellipse"),
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-path-1"),
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-path-2"),
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    transform: "translate(13.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-path-3"),
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-path-4"),
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-path-5"),
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "".concat(prefixCls, "-g"),
    transform: "translate(149.65 15.383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};

var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _configProvider = __webpack_require__(8);

var Simple = function Simple() {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('empty-img-simple');
  return /*#__PURE__*/React.createElement("svg", {
    className: prefixCls,
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "".concat(prefixCls, "-ellipse"),
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "".concat(prefixCls, "-g"),
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    className: "".concat(prefixCls, "-path")
  }))));
};

var _default = Simple;
exports["default"] = _default;

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Notice__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useNotification__ = __webpack_require__(994);














var seed = 0;
var now = Date.now();

function getUuid() {
  var id = seed;
  seed += 1;
  return "rcNotification_".concat(now, "_").concat(id);
}

var Notification = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Notification, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Notification);

  function Notification() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Notification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      notices: []
    };
    _this.hookRefs = new Map();

    _this.add = function (originNotice, holderCallback) {
      var key = originNotice.key || getUuid();

      var notice = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, originNotice), {}, {
        key: key
      });

      var maxCount = _this.props.maxCount;

      _this.setState(function (previousState) {
        var notices = previousState.notices;
        var noticeIndex = notices.map(function (v) {
          return v.notice.key;
        }).indexOf(key);
        var updatedNotices = notices.concat();

        if (noticeIndex !== -1) {
          updatedNotices.splice(noticeIndex, 1, {
            notice: notice,
            holderCallback: holderCallback
          });
        } else {
          if (maxCount && notices.length >= maxCount) {
            // XXX, use key of first item to update new added (let React to move exsiting
            // instead of remove and mount). Same key was used before for both a) external
            // manual control and b) internal react 'key' prop , which is not that good.
            // eslint-disable-next-line no-param-reassign
            // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
            // Change to `updateMark` for compare instead.
            // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
            notice.key = updatedNotices[0].notice.key;
            notice.updateMark = getUuid(); // zombieJ: That's why. User may close by key directly.
            // We need record this but not re-render to avoid upper issue
            // https://github.com/react-component/notification/issues/129

            notice.userPassKey = key;
            updatedNotices.shift();
          }

          updatedNotices.push({
            notice: notice,
            holderCallback: holderCallback
          });
        }

        return {
          notices: updatedNotices
        };
      });
    };

    _this.remove = function (removeKey) {
      _this.setState(function (_ref) {
        var notices = _ref.notices;
        return {
          notices: notices.filter(function (_ref2) {
            var _ref2$notice = _ref2.notice,
                key = _ref2$notice.key,
                userPassKey = _ref2$notice.userPassKey;
            var mergedKey = userPassKey || key;
            return mergedKey !== removeKey;
          })
        };
      });
    };

    _this.noticePropsMap = {};
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Notification, [{
    key: "getTransitionName",
    value: function getTransitionName() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          animation = _this$props.animation;
      var transitionName = this.props.transitionName;

      if (!transitionName && animation) {
        transitionName = "".concat(prefixCls, "-").concat(animation);
      }

      return transitionName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var notices = this.state.notices;
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          closeIcon = _this$props2.closeIcon,
          style = _this$props2.style;
      var noticeKeys = [];
      notices.forEach(function (_ref3, index) {
        var notice = _ref3.notice,
            holderCallback = _ref3.holderCallback;
        var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
        var key = notice.key,
            userPassKey = notice.userPassKey;

        var noticeProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          prefixCls: prefixCls,
          closeIcon: closeIcon
        }, notice), notice.props), {}, {
          key: key,
          noticeKey: userPassKey || key,
          updateMark: updateMark,
          onClose: function onClose(noticeKey) {
            var _notice$onClose;

            _this2.remove(noticeKey);

            (_notice$onClose = notice.onClose) === null || _notice$onClose === void 0 ? void 0 : _notice$onClose.call(notice);
          },
          onClick: notice.onClick,
          children: notice.content
        }); // Give to motion


        noticeKeys.push(key);
        _this2.noticePropsMap[key] = {
          props: noticeProps,
          holderCallback: holderCallback
        };
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, className),
        style: style
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_rc_motion__["CSSMotionList"], {
        keys: noticeKeys,
        motionName: this.getTransitionName(),
        onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
          var key = _ref4.key;

          if (!changedVisible) {
            delete _this2.noticePropsMap[key];
          }
        }
      }, function (_ref5) {
        var key = _ref5.key,
            motionClassName = _ref5.className,
            motionStyle = _ref5.style,
            visible = _ref5.visible;
        var _this2$noticePropsMap = _this2.noticePropsMap[key],
            noticeProps = _this2$noticePropsMap.props,
            holderCallback = _this2$noticePropsMap.holderCallback;

        if (holderCallback) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
            key: key,
            className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(motionClassName, "".concat(prefixCls, "-hook-holder")),
            style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle),
            ref: function ref(div) {
              if (typeof key === 'undefined') {
                return;
              }

              if (div) {
                _this2.hookRefs.set(key, div);

                holderCallback(div, noticeProps);
              } else {
                _this2.hookRefs.delete(key);
              }
            }
          });
        }

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Notice__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, noticeProps, {
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
          style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
          visible: visible
        }));
      }));
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.newInstance = void 0;
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};

Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref6 = properties || {},
      getContainer = _ref6.getContainer,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref6, ["getContainer"]);

  var div = document.createElement('div');

  if (getContainer) {
    var root = getContainer();
    root.appendChild(div);
  } else {
    document.body.appendChild(div);
  }

  var called = false;

  function ref(notification) {
    if (called) {
      return;
    }

    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },
      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(div);

        if (div.parentNode) {
          div.parentNode.removeChild(div);
        }
      },
      // Hooks
      useNotification: function useNotification() {
        return Object(__WEBPACK_IMPORTED_MODULE_12__useNotification__["a" /* default */])(notification);
      }
    });
  } // Only used for test case usage


  if (false) {
    properties.TEST_RENDER( /*#__PURE__*/React.createElement(Notification, _extends({}, props, {
      ref: ref
    })));
    return;
  }

  __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.render( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](Notification, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref
  })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(966);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(507);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(337);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(973);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(160);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(978);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_hooks_useState__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interface__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useStepQueue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__useDomMotionEvents__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useIsomorphicLayoutEffect__ = __webpack_require__(517);










function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
      motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
      _ref$motionAppear = _ref.motionAppear,
      motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
      _ref$motionLeave = _ref.motionLeave,
      motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
      motionDeadline = _ref.motionDeadline,
      motionLeaveImmediately = _ref.motionLeaveImmediately,
      onAppearPrepare = _ref.onAppearPrepare,
      onEnterPrepare = _ref.onEnterPrepare,
      onLeavePrepare = _ref.onLeavePrepare,
      onAppearStart = _ref.onAppearStart,
      onEnterStart = _ref.onEnterStart,
      onLeaveStart = _ref.onLeaveStart,
      onAppearActive = _ref.onAppearActive,
      onEnterActive = _ref.onEnterActive,
      onLeaveActive = _ref.onLeaveActive,
      onAppearEnd = _ref.onAppearEnd,
      onEnterEnd = _ref.onEnterEnd,
      onLeaveEnd = _ref.onLeaveEnd,
      onVisibleChanged = _ref.onVisibleChanged;

  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_hooks_useState__["a" /* default */])(),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      asyncVisible = _useState2[0],
      setAsyncVisible = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_hooks_useState__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__interface__["d" /* STATUS_NONE */]),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_hooks_useState__["a" /* default */])(null),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      style = _useState6[0],
      setStyle = _useState6[1];

  var mountedRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
  var deadlineRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null); // =========================== Dom Node ===========================

  function getDomElement() {
    return getElement();
  } // ========================== Motion End ==========================


  var activeRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);

  function onInternalMotionEnd(event) {
    var element = getDomElement();

    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }

    var currentActive = activeRef.current;
    var canEnd;

    if (status === __WEBPACK_IMPORTED_MODULE_5__interface__["a" /* STATUS_APPEAR */] && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === __WEBPACK_IMPORTED_MODULE_5__interface__["b" /* STATUS_ENTER */] && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === __WEBPACK_IMPORTED_MODULE_5__interface__["c" /* STATUS_LEAVE */] && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    } // Only update status when `canEnd` and not destroyed


    if (status !== __WEBPACK_IMPORTED_MODULE_5__interface__["d" /* STATUS_NONE */] && currentActive && canEnd !== false) {
      setStatus(__WEBPACK_IMPORTED_MODULE_5__interface__["d" /* STATUS_NONE */], true);
      setStyle(null, true);
    }
  }

  var _useDomMotionEvents = Object(__WEBPACK_IMPORTED_MODULE_7__useDomMotionEvents__["a" /* default */])(onInternalMotionEnd),
      _useDomMotionEvents2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useDomMotionEvents, 1),
      patchMotionEvents = _useDomMotionEvents2[0]; // ============================= Step =============================


  var eventHandlers = __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"](function () {
    var _ref2, _ref3, _ref4;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_5__interface__["a" /* STATUS_APPEAR */]:
        return _ref2 = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, __WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */], onAppearPrepare), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, __WEBPACK_IMPORTED_MODULE_5__interface__["i" /* STEP_START */], onAppearStart), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref2, __WEBPACK_IMPORTED_MODULE_5__interface__["f" /* STEP_ACTIVE */], onAppearActive), _ref2;

      case __WEBPACK_IMPORTED_MODULE_5__interface__["b" /* STATUS_ENTER */]:
        return _ref3 = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, __WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */], onEnterPrepare), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, __WEBPACK_IMPORTED_MODULE_5__interface__["i" /* STEP_START */], onEnterStart), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, __WEBPACK_IMPORTED_MODULE_5__interface__["f" /* STEP_ACTIVE */], onEnterActive), _ref3;

      case __WEBPACK_IMPORTED_MODULE_5__interface__["c" /* STATUS_LEAVE */]:
        return _ref4 = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref4, __WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */], onLeavePrepare), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref4, __WEBPACK_IMPORTED_MODULE_5__interface__["i" /* STEP_START */], onLeaveStart), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref4, __WEBPACK_IMPORTED_MODULE_5__interface__["f" /* STEP_ACTIVE */], onLeaveActive), _ref4;

      default:
        return {};
    }
  }, [status]);

  var _useStepQueue = Object(__WEBPACK_IMPORTED_MODULE_6__useStepQueue__["c" /* default */])(status, function (newStep) {
    // Only prepare step can be skip
    if (newStep === __WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */]) {
      var onPrepare = eventHandlers[__WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */]];

      if (!onPrepare) {
        return __WEBPACK_IMPORTED_MODULE_6__useStepQueue__["b" /* SkipStep */];
      }

      return onPrepare(getDomElement());
    } // Rest step is sync update


    if (step in eventHandlers) {
      var _eventHandlers$step;

      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }

    if (step === __WEBPACK_IMPORTED_MODULE_5__interface__["f" /* STEP_ACTIVE */]) {
      // Patch events when motion needed
      patchMotionEvents(getDomElement());

      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function () {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_6__useStepQueue__["a" /* DoStep */];
  }),
      _useStepQueue2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useStepQueue, 2),
      startStep = _useStepQueue2[0],
      step = _useStepQueue2[1];

  var active = Object(__WEBPACK_IMPORTED_MODULE_6__useStepQueue__["d" /* isActive */])(step);
  activeRef.current = active; // ============================ Status ============================
  // Update with new status

  Object(__WEBPACK_IMPORTED_MODULE_8__useIsomorphicLayoutEffect__["a" /* default */])(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    if (!supportMotion) {
      return;
    }

    var nextStatus; // Appear

    if (!isMounted && visible && motionAppear) {
      nextStatus = __WEBPACK_IMPORTED_MODULE_5__interface__["a" /* STATUS_APPEAR */];
    } // Enter


    if (isMounted && visible && motionEnter) {
      nextStatus = __WEBPACK_IMPORTED_MODULE_5__interface__["b" /* STATUS_ENTER */];
    } // Leave


    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = __WEBPACK_IMPORTED_MODULE_5__interface__["c" /* STATUS_LEAVE */];
    } // Update to next status


    if (nextStatus) {
      setStatus(nextStatus);
      startStep();
    }
  }, [visible]); // ============================ Effect ============================
  // Reset when motion changed

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if ( // Cancel appear
    status === __WEBPACK_IMPORTED_MODULE_5__interface__["a" /* STATUS_APPEAR */] && !motionAppear || // Cancel enter
    status === __WEBPACK_IMPORTED_MODULE_5__interface__["b" /* STATUS_ENTER */] && !motionEnter || // Cancel leave
    status === __WEBPACK_IMPORTED_MODULE_5__interface__["c" /* STATUS_LEAVE */] && !motionLeave) {
      setStatus(__WEBPACK_IMPORTED_MODULE_5__interface__["d" /* STATUS_NONE */]);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []); // Trigger `onVisibleChanged`

  var firstMountChangeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](false);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }

    if (asyncVisible !== undefined && status === __WEBPACK_IMPORTED_MODULE_5__interface__["d" /* STATUS_NONE */]) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
      }

      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, status]); // ============================ Styles ============================

  var mergedStyle = style;

  if (eventHandlers[__WEBPACK_IMPORTED_MODULE_5__interface__["h" /* STEP_PREPARE */]] && step === __WEBPACK_IMPORTED_MODULE_5__interface__["i" /* STEP_START */]) {
    mergedStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      transition: 'none'
    }, mergedStyle);
  }

  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__ = __webpack_require__(75);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var nextFrameRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);

  function cancelNextFrame() {
    __WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__["a" /* default */].cancel(nextFrameRef.current);
  }

  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__["a" /* default */])(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_motion__ = __webpack_require__(339);



/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
  var cacheElementRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(); // Cache callback

  var callbackRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(callback);
  callbackRef.current = callback; // Internal motion event handler

  var onInternalMotionEnd = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    callbackRef.current(event);
  }, []); // Remove events

  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__util_motion__["d" /* transitionEndName */], onInternalMotionEnd);
      element.removeEventListener(__WEBPACK_IMPORTED_MODULE_1__util_motion__["a" /* animationEndName */], onInternalMotionEnd);
    }
  } // Patch events


  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }

    if (element && element !== cacheElementRef.current) {
      element.addEventListener(__WEBPACK_IMPORTED_MODULE_1__util_motion__["d" /* transitionEndName */], onInternalMotionEnd);
      element.addEventListener(__WEBPACK_IMPORTED_MODULE_1__util_motion__["a" /* animationEndName */], onInternalMotionEnd); // Save as cache in case dom removed trigger by `motionDeadline`

      cacheElementRef.current = element;
    }
  } // Clean up when removed


  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var DomWrapper = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(DomWrapper, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DomWrapper);

  function DomWrapper() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DomWrapper);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DomWrapper;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DomWrapper);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(522);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CSSMotion__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_motion__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_diff__ = __webpack_require__(993);









var _excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
    _excluded2 = ["status"];

/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];

/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_10__CSSMotion__["a" /* default */];

  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(CSSMotionList, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(CSSMotionList);

    function CSSMotionList() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, CSSMotionList);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "state", {
        keyEntities: []
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "removeKey", function (removeKey) {
        var keyEntities = _this.state.keyEntities;
        var nextKeyEntities = keyEntities.map(function (entity) {
          if (entity.key !== removeKey) return entity;
          return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, entity), {}, {
            status: __WEBPACK_IMPORTED_MODULE_12__util_diff__["d" /* STATUS_REMOVED */]
          });
        });

        _this.setState({
          keyEntities: nextKeyEntities
        });

        return nextKeyEntities.filter(function (_ref) {
          var status = _ref.status;
          return status !== __WEBPACK_IMPORTED_MODULE_12__util_diff__["d" /* STATUS_REMOVED */];
        }).length;
      });

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var keyEntities = this.state.keyEntities;

        var _this$props = this.props,
            component = _this$props.component,
            children = _this$props.children,
            _onVisibleChanged = _this$props.onVisibleChanged,
            onAllRemoved = _this$props.onAllRemoved,
            restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, _excluded);

        var Component = component || __WEBPACK_IMPORTED_MODULE_9_react__["Fragment"];
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](Component, restProps, keyEntities.map(function (_ref2) {
          var status = _ref2.status,
              eventProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, _excluded2);

          var visible = status === __WEBPACK_IMPORTED_MODULE_12__util_diff__["a" /* STATUS_ADD */] || status === __WEBPACK_IMPORTED_MODULE_12__util_diff__["b" /* STATUS_KEEP */];
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](CSSMotion, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });

              if (!changedVisible) {
                var restKeysCount = _this2.removeKey(eventProps.key);

                if (restKeysCount === 0 && onAllRemoved) {
                  onAllRemoved();
                }
              }
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = Object(__WEBPACK_IMPORTED_MODULE_12__util_diff__["f" /* parseKeys */])(keys);
        var mixedKeyEntities = Object(__WEBPACK_IMPORTED_MODULE_12__util_diff__["e" /* diffKeys */])(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            }); // Remove if already mark as removed

            if (prevEntity && prevEntity.status === __WEBPACK_IMPORTED_MODULE_12__util_diff__["d" /* STATUS_REMOVED */] && entity.status === __WEBPACK_IMPORTED_MODULE_12__util_diff__["c" /* STATUS_REMOVE */]) {
              return false;
            }

            return true;
          })
        };
      } // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.

    }]);

    return CSSMotionList;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(CSSMotionList, "defaultProps", {
    component: 'div'
  });

  return CSSMotionList;
}
/* harmony default export */ __webpack_exports__["a"] = (genCSSMotionList(__WEBPACK_IMPORTED_MODULE_11__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(992);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_KEEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_REMOVED; });
/* unused harmony export wrapKeyToObject */
/* harmony export (immutable) */ __webpack_exports__["f"] = parseKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = diffKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(160);


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;

  if (key && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys); // Check prev keys to insert or keep

  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;

    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];

      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }

        list.push(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    } // If not hit, it means key is removed


    if (!hit) {
      list.push(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  }); // Add rest to the list

  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */


  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
          status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    }); // Update `STATUS_ADD` to `STATUS_KEEP`

    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notice__ = __webpack_require__(523);





function useNotification(notificationInstance) {
  var createdRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]({});

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]([]),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      elements = _React$useState2[0],
      setElements = _React$useState2[1];

  function notify(noticeProps) {
    var firstMount = true;
    notificationInstance.add(noticeProps, function (div, props) {
      var key = props.key;

      if (div && (!createdRef.current[key] || firstMount)) {
        var noticeEle = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Notice__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          holder: div
        }));
        createdRef.current[key] = noticeEle;
        setElements(function (originElements) {
          var index = originElements.findIndex(function (ele) {
            return ele.key === props.key;
          });

          if (index === -1) {
            return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(originElements), [noticeEle]);
          }

          var cloneList = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(originElements);

          cloneList[index] = noticeEle;
          return cloneList;
        });
      }

      firstMount = false;
    });
  }

  return [notify, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, elements)];
}

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(998);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(524);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1002);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _LoadingOutlined = _interopRequireDefault(__webpack_require__(1006));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _LoadingOutlined.default
  }));
};
LoadingOutlined.displayName = 'LoadingOutlined';
var _default = /*#__PURE__*/React.forwardRef(LoadingOutlined);
exports.default = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(13)["default"];
var toPrimitive = __webpack_require__(1005);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(13)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LoadingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
exports.default = LoadingOutlined;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(1010);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "geekblue", function() { return geekblue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generate", function() { return generate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gold", function() { return gold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "magenta", function() { return magenta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetDarkPalettes", function() { return presetDarkPalettes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetPalettes", function() { return presetPalettes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetPrimaryColors", function() { return presetPrimaryColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volcano", function() { return volcano; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__ = __webpack_require__(531);


var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`

function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["d" /* rgbToHsv */])(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["c" /* rgbToHex */])(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["b" /* inputToRGB */])(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["b" /* inputToRGB */])({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["b" /* inputToRGB */])({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["b" /* inputToRGB */])(opts.backgroundColor || '#141414'), Object(__WEBPACK_IMPORTED_MODULE_0__ctrl_tinycolor__["b" /* inputToRGB */])(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
var red = presetPalettes.red;
var volcano = presetPalettes.volcano;
var gold = presetPalettes.gold;
var orange = presetPalettes.orange;
var yellow = presetPalettes.yellow;
var lime = presetPalettes.lime;
var green = presetPalettes.green;
var cyan = presetPalettes.cyan;
var blue = presetPalettes.blue;
var geekblue = presetPalettes.geekblue;
var purple = presetPalettes.purple;
var magenta = presetPalettes.magenta;
var grey = presetPalettes.grey;




/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export readability */
/* unused harmony export isReadable */
/* unused harmony export mostReadable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(163);

// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
/**
 * AKA `contrast`
 *
 * Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
 */
function readability(color1, color2) {
    var c1 = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](color1);
    var c2 = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](color2);
    return ((Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) /
        (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05));
}
/**
 * Ensure that foreground and background color combinations meet WCAG2 guidelines.
 * The third argument is an object.
 *      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
 *      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
 * If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
 *
 * Example
 * ```ts
 * new TinyColor().isReadable('#000', '#111') => false
 * new TinyColor().isReadable('#000', '#111', { level: 'AA', size: 'large' }) => false
 * ```
 */
function isReadable(color1, color2, wcag2) {
    var _a, _b;
    if (wcag2 === void 0) { wcag2 = { level: 'AA', size: 'small' }; }
    var readabilityLevel = readability(color1, color2);
    switch (((_a = wcag2.level) !== null && _a !== void 0 ? _a : 'AA') + ((_b = wcag2.size) !== null && _b !== void 0 ? _b : 'small')) {
        case 'AAsmall':
        case 'AAAlarge':
            return readabilityLevel >= 4.5;
        case 'AAlarge':
            return readabilityLevel >= 3;
        case 'AAAsmall':
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
/**
 * Given a base color and a list of possible foreground or background
 * colors for that base, returns the most readable color.
 * Optionally returns Black or White if the most readable color is unreadable.
 *
 * @param baseColor - the base color.
 * @param colorList - array of colors to pick the most readable one from.
 * @param args - and object with extra arguments
 *
 * Example
 * ```ts
 * new TinyColor().mostReadable('#123', ['#124", "#125'], { includeFallbackColors: false }).toHexString(); // "#112255"
 * new TinyColor().mostReadable('#123', ['#124", "#125'],{ includeFallbackColors: true }).toHexString();  // "#ffffff"
 * new TinyColor().mostReadable('#a8015a', ["#faf3f3"], { includeFallbackColors:true, level: 'AAA', size: 'large' }).toHexString(); // "#faf3f3"
 * new TinyColor().mostReadable('#a8015a', ["#faf3f3"], { includeFallbackColors:true, level: 'AAA', size: 'small' }).toHexString(); // "#ffffff"
 * ```
 */
function mostReadable(baseColor, colorList, args) {
    if (args === void 0) { args = { includeFallbackColors: false, level: 'AA', size: 'small' }; }
    var bestColor = null;
    var bestScore = 0;
    var includeFallbackColors = args.includeFallbackColors, level = args.level, size = args.size;
    for (var _i = 0, colorList_1 = colorList; _i < colorList_1.length; _i++) {
        var color = colorList_1[_i];
        var score = readability(baseColor, color);
        if (score > bestScore) {
            bestScore = score;
            bestColor = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](color);
        }
    }
    if (isReadable(baseColor, bestColor, { level: level, size: size }) || !includeFallbackColors) {
        return bestColor;
    }
    args.includeFallbackColors = false;
    return mostReadable(baseColor, ['#fff', '#000'], args);
}


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toMsFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversion__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(163);


/**
 * Returns the color represented as a Microsoft filter for use in old versions of IE.
 */
function toMsFilter(firstColor, secondColor) {
    var color = new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TinyColor */](firstColor);
    var hex8String = '#' + Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["j" /* rgbaToArgbHex */])(color.r, color.g, color.b, color.a);
    var secondHex8String = hex8String;
    var gradientType = color.gradientType ? 'GradientType = 1, ' : '';
    if (secondColor) {
        var s = new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TinyColor */](secondColor);
        secondHex8String = '#' + Object(__WEBPACK_IMPORTED_MODULE_0__conversion__["j" /* rgbaToArgbHex */])(s.r, s.g, s.b, s.a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(".concat(gradientType, "startColorstr=").concat(hex8String, ",endColorstr=").concat(secondHex8String, ")");
}


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromRatio */
/* unused harmony export legacyRandom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(256);


/**
 * If input is an object, force 1 into "1.0" to handle ratios properly
 * String input requires "1.0" as input, so 1 will be treated as 1
 */
function fromRatio(ratio, opts) {
    var newColor = {
        r: Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* convertToPercentage */])(ratio.r),
        g: Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* convertToPercentage */])(ratio.g),
        b: Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* convertToPercentage */])(ratio.b),
    };
    if (ratio.a !== undefined) {
        newColor.a = Number(ratio.a);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](newColor, opts);
}
/** old random function */
function legacyRandom() {
    return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */]({
        r: Math.random(),
        g: Math.random(),
        b: Math.random(),
    });
}


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export random */
/* unused harmony export bounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(163);
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
// randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/

function random(options) {
    if (options === void 0) { options = {}; }
    // Check if we need to generate multiple colors
    if (options.count !== undefined &&
        options.count !== null) {
        var totalColors = options.count;
        var colors = [];
        options.count = undefined;
        while (totalColors > colors.length) {
            // Since we're generating multiple colors,
            // incremement the seed. Otherwise we'd just
            // generate the same color each time...
            options.count = null;
            if (options.seed) {
                options.seed += 1;
            }
            colors.push(random(options));
        }
        options.count = totalColors;
        return colors;
    }
    // First we pick a hue (H)
    var h = pickHue(options.hue, options.seed);
    // Then use H to determine saturation (S)
    var s = pickSaturation(h, options);
    // Then use S and H to determine brightness (B).
    var v = pickBrightness(h, s, options);
    var res = { h: h, s: s, v: v };
    if (options.alpha !== undefined) {
        res.a = options.alpha;
    }
    // Then we return the HSB color in the desired format
    return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](res);
}
function pickHue(hue, seed) {
    var hueRange = getHueRange(hue);
    var res = randomWithin(hueRange, seed);
    // Instead of storing red as two seperate ranges,
    // we group them, using negative numbers
    if (res < 0) {
        res = 360 + res;
    }
    return res;
}
function pickSaturation(hue, options) {
    if (options.hue === 'monochrome') {
        return 0;
    }
    if (options.luminosity === 'random') {
        return randomWithin([0, 100], options.seed);
    }
    var saturationRange = getColorInfo(hue).saturationRange;
    var sMin = saturationRange[0];
    var sMax = saturationRange[1];
    switch (options.luminosity) {
        case 'bright':
            sMin = 55;
            break;
        case 'dark':
            sMin = sMax - 10;
            break;
        case 'light':
            sMax = 55;
            break;
        default:
            break;
    }
    return randomWithin([sMin, sMax], options.seed);
}
function pickBrightness(H, S, options) {
    var bMin = getMinimumBrightness(H, S);
    var bMax = 100;
    switch (options.luminosity) {
        case 'dark':
            bMax = bMin + 20;
            break;
        case 'light':
            bMin = (bMax + bMin) / 2;
            break;
        case 'random':
            bMin = 0;
            bMax = 100;
            break;
        default:
            break;
    }
    return randomWithin([bMin, bMax], options.seed);
}
function getMinimumBrightness(H, S) {
    var lowerBounds = getColorInfo(H).lowerBounds;
    for (var i = 0; i < lowerBounds.length - 1; i++) {
        var s1 = lowerBounds[i][0];
        var v1 = lowerBounds[i][1];
        var s2 = lowerBounds[i + 1][0];
        var v2 = lowerBounds[i + 1][1];
        if (S >= s1 && S <= s2) {
            var m = (v2 - v1) / (s2 - s1);
            var b = v1 - m * s1;
            return m * S + b;
        }
    }
    return 0;
}
function getHueRange(colorInput) {
    var num = parseInt(colorInput, 10);
    if (!Number.isNaN(num) && num < 360 && num > 0) {
        return [num, num];
    }
    if (typeof colorInput === 'string') {
        var namedColor = bounds.find(function (n) { return n.name === colorInput; });
        if (namedColor) {
            var color = defineColor(namedColor);
            if (color.hueRange) {
                return color.hueRange;
            }
        }
        var parsed = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* TinyColor */](colorInput);
        if (parsed.isValid) {
            var hue = parsed.toHsv().h;
            return [hue, hue];
        }
    }
    return [0, 360];
}
function getColorInfo(hue) {
    // Maps red colors to make picking hue easier
    if (hue >= 334 && hue <= 360) {
        hue -= 360;
    }
    for (var _i = 0, bounds_1 = bounds; _i < bounds_1.length; _i++) {
        var bound = bounds_1[_i];
        var color = defineColor(bound);
        if (color.hueRange && hue >= color.hueRange[0] && hue <= color.hueRange[1]) {
            return color;
        }
    }
    throw Error('Color not found');
}
function randomWithin(range, seed) {
    if (seed === undefined) {
        return Math.floor(range[0] + Math.random() * (range[1] + 1 - range[0]));
    }
    // Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
    var max = range[1] || 1;
    var min = range[0] || 0;
    seed = (seed * 9301 + 49297) % 233280;
    var rnd = seed / 233280.0;
    return Math.floor(min + rnd * (max - min));
}
function defineColor(bound) {
    var sMin = bound.lowerBounds[0][0];
    var sMax = bound.lowerBounds[bound.lowerBounds.length - 1][0];
    var bMin = bound.lowerBounds[bound.lowerBounds.length - 1][1];
    var bMax = bound.lowerBounds[0][1];
    return {
        name: bound.name,
        hueRange: bound.hueRange,
        lowerBounds: bound.lowerBounds,
        saturationRange: [sMin, sMax],
        brightnessRange: [bMin, bMax],
    };
}
/**
 * @hidden
 */
var bounds = [
    {
        name: 'monochrome',
        hueRange: null,
        lowerBounds: [
            [0, 0],
            [100, 0],
        ],
    },
    {
        name: 'red',
        hueRange: [-26, 18],
        lowerBounds: [
            [20, 100],
            [30, 92],
            [40, 89],
            [50, 85],
            [60, 78],
            [70, 70],
            [80, 60],
            [90, 55],
            [100, 50],
        ],
    },
    {
        name: 'orange',
        hueRange: [19, 46],
        lowerBounds: [
            [20, 100],
            [30, 93],
            [40, 88],
            [50, 86],
            [60, 85],
            [70, 70],
            [100, 70],
        ],
    },
    {
        name: 'yellow',
        hueRange: [47, 62],
        lowerBounds: [
            [25, 100],
            [40, 94],
            [50, 89],
            [60, 86],
            [70, 84],
            [80, 82],
            [90, 80],
            [100, 75],
        ],
    },
    {
        name: 'green',
        hueRange: [63, 178],
        lowerBounds: [
            [30, 100],
            [40, 90],
            [50, 85],
            [60, 81],
            [70, 74],
            [80, 64],
            [90, 50],
            [100, 40],
        ],
    },
    {
        name: 'blue',
        hueRange: [179, 257],
        lowerBounds: [
            [20, 100],
            [30, 86],
            [40, 80],
            [50, 74],
            [60, 60],
            [70, 52],
            [80, 44],
            [90, 39],
            [100, 35],
        ],
    },
    {
        name: 'purple',
        hueRange: [258, 282],
        lowerBounds: [
            [20, 100],
            [30, 87],
            [40, 79],
            [50, 70],
            [60, 65],
            [70, 59],
            [80, 52],
            [90, 45],
            [100, 42],
        ],
    },
    {
        name: 'pink',
        hueRange: [283, 334],
        lowerBounds: [
            [20, 100],
            [30, 90],
            [40, 86],
            [60, 84],
            [80, 80],
            [90, 75],
            [100, 73],
        ],
    },
];


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearContainerCache = clearContainerCache;
exports.injectCSS = injectCSS;
exports.removeCSS = removeCSS;
exports.updateCSS = updateCSS;
var _canUseDom = _interopRequireDefault(__webpack_require__(343));
var _contains = _interopRequireDefault(__webpack_require__(1020));
var APPEND_ORDER = 'data-rc-order';
var MARK_KEY = "rc-util-key";
var containerCache = new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mark = _ref.mark;
  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector('head');
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === 'queue') {
    return 'prependQueue';
  }
  return prepend ? 'prepend' : 'append';
}

/**
 * Find style which inject by rc-util
 */
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function (node) {
    return node.tagName === 'STYLE';
  });
}
function injectCSS(css) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(0, _canUseDom.default)()) {
    return null;
  }
  var csp = option.csp,
    prepend = option.prepend;
  var styleNode = document.createElement('style');
  styleNode.setAttribute(APPEND_ORDER, getOrder(prepend));
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    // If is queue `prepend`, it will prepend first style and then append rest style
    if (prepend === 'queue') {
      var existStyle = findStyles(container).filter(function (node) {
        return ['prepend', 'prependQueue'].includes(node.getAttribute(APPEND_ORDER));
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }

    // Use `insertBefore` as `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return findStyles(container).find(function (node) {
    return node.getAttribute(getMark(option)) === key;
  });
}
function removeCSS(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var existNode = findExistNode(key, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}

/**
 * qiankun will inject `appendChild` to insert into other
 */
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);

  // Find real container when not cached or cached container removed
  if (!cachedRealContainer || !(0, _contains.default)(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}

/**
 * manually clear container cache to avoid global cache in unit testes
 */
function clearContainerCache() {
  containerCache.clear();
}
function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option);

  // Sync real parent
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contains;
function contains(root, n) {
  if (!root) {
    return false;
  }

  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }

  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTwoToneColor = getTwoToneColor;
exports.setTwoToneColor = setTwoToneColor;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(527));
var _IconBase = _interopRequireDefault(__webpack_require__(530));
var _utils = __webpack_require__(341);
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = (0, _utils.normalizeTwoToneColors)(twoToneColor),
    _normalizeTwoToneColo2 = (0, _slicedToArray2.default)(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return _IconBase.default.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = _IconBase.default.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(1023));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _ExclamationCircleFilled.default
  }));
};
ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
var _default = /*#__PURE__*/React.forwardRef(ExclamationCircleFilled);
exports.default = _default;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
exports.default = ExclamationCircleFilled;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(1025));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CloseCircleFilled.default
  }));
};
CloseCircleFilled.displayName = 'CloseCircleFilled';
var _default = /*#__PURE__*/React.forwardRef(CloseCircleFilled);
exports.default = _default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CloseCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };
exports.default = CloseCircleFilled;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(1027));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CheckCircleFilled.default
  }));
};
CheckCircleFilled.displayName = 'CheckCircleFilled';
var _default = /*#__PURE__*/React.forwardRef(CheckCircleFilled);
exports.default = _default;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CheckCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
exports.default = CheckCircleFilled;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _InfoCircleFilled = _interopRequireDefault(__webpack_require__(1029));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _InfoCircleFilled.default
  }));
};
InfoCircleFilled.displayName = 'InfoCircleFilled';
var _default = /*#__PURE__*/React.forwardRef(InfoCircleFilled);
exports.default = _default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var InfoCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
exports.default = InfoCircleFilled;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createUseMessage;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _useNotification = _interopRequireDefault(__webpack_require__(537));

var _configProvider = __webpack_require__(8);

var _ = __webpack_require__(15);

function createUseMessage(getRcNotificationInstance, getRCNoticeProps) {
  var useMessage = function useMessage() {
    // We can only get content by render
    var getPrefixCls; // We create a proxy to handle delay created instance

    var innerInstance = null;
    var proxy = {
      add: function add(noticeProps, holderCallback) {
        innerInstance === null || innerInstance === void 0 ? void 0 : innerInstance.component.add(noticeProps, holderCallback);
      }
    };

    var _useRCNotification = (0, _useNotification["default"])(proxy),
        _useRCNotification2 = (0, _slicedToArray2["default"])(_useRCNotification, 2),
        hookNotify = _useRCNotification2[0],
        holder = _useRCNotification2[1];

    function notify(args) {
      var customizePrefixCls = args.prefixCls;
      var mergedPrefixCls = getPrefixCls('message', customizePrefixCls);
      var target = args.key || (0, _.getKeyThenIncreaseKey)();
      var closePromise = new Promise(function (resolve) {
        var callback = function callback() {
          if (typeof args.onClose === 'function') {
            args.onClose();
          }

          return resolve(true);
        };

        getRcNotificationInstance((0, _extends2["default"])((0, _extends2["default"])({}, args), {
          prefixCls: mergedPrefixCls
        }), function (_ref) {
          var prefixCls = _ref.prefixCls,
              instance = _ref.instance;
          innerInstance = instance;
          hookNotify(getRCNoticeProps((0, _extends2["default"])((0, _extends2["default"])({}, args), {
            key: target,
            onClose: callback
          }), prefixCls));
        });
      });

      var result = function result() {
        if (innerInstance) {
          innerInstance.removeNotice(target);
        }
      };

      result.then = function (filled, rejected) {
        return closePromise.then(filled, rejected);
      };

      result.promise = closePromise;
      return result;
    } // Fill functions


    var hookApiRef = React.useRef({});
    hookApiRef.current.open = notify;
    ['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
      return (0, _.attachTypeApi)(hookApiRef.current, type);
    });
    return [hookApiRef.current, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, {
      key: "holder"
    }, function (context) {
      getPrefixCls = context.getPrefixCls;
      return holder;
    })];
  };

  return useMessage;
}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1033);
var iterableToArray = __webpack_require__(1034);
var unsupportedIterableToArray = __webpack_require__(541);
var nonIterableSpread = __webpack_require__(1035);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(540);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1037);
var iterableToArrayLimit = __webpack_require__(1038);
var unsupportedIterableToArray = __webpack_require__(541);
var nonIterableRest = __webpack_require__(1039);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(538);

var _interopRequireDefault = __webpack_require__(539);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(542));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1041));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1043));

var _createClass2 = _interopRequireDefault(__webpack_require__(1044));

var _inherits2 = _interopRequireDefault(__webpack_require__(1045));

var _createSuper2 = _interopRequireDefault(__webpack_require__(1047));

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(52));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var Notice = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Notice, _Component);

  var _super = (0, _createSuper2.default)(Notice);

  function Notice() {
    var _this;

    (0, _classCallCheck2.default)(this, Notice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.closeTimer = null;

    _this.close = function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.clearCloseTimer();

      var _this$props = _this.props,
          onClose = _this$props.onClose,
          noticeKey = _this$props.noticeKey;

      if (onClose) {
        onClose(noticeKey);
      }
    };

    _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = window.setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    };

    _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Notice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
      this.props.visible !== prevProps.visible && this.props.visible) {
        this.restartCloseTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          closable = _this$props2.closable,
          closeIcon = _this$props2.closeIcon,
          style = _this$props2.style,
          onClick = _this$props2.onClick,
          children = _this$props2.children,
          holder = _this$props2.holder;
      var componentClass = "".concat(prefixCls, "-notice");
      var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function (acc, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          acc[key] = _this2.props[key];
        }

        return acc;
      }, {});
      var node = /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(componentClass, className, (0, _defineProperty2.default)({}, "".concat(componentClass, "-closable"), closable)),
        style: style,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer,
        onClick: onClick
      }, dataOrAriaAttributeProps), /*#__PURE__*/React.createElement("div", {
        className: "".concat(componentClass, "-content")
      }, children), closable ? /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        onClick: this.close,
        className: "".concat(componentClass, "-close")
      }, closeIcon || /*#__PURE__*/React.createElement("span", {
        className: "".concat(componentClass, "-close-x")
      })) : null);

      if (holder) {
        return /*#__PURE__*/_reactDom.default.createPortal(node, holder);
      }

      return node;
    }
  }]);
  return Notice;
}(React.Component);

exports.default = Notice;
Notice.defaultProps = {
  onClose: function onClose() {},
  duration: 1.5
};

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(543);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(259)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(543);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1046);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(1048);
var isNativeReflectConstruct = __webpack_require__(1049);
var possibleConstructorReturn = __webpack_require__(1050);
function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return possibleConstructorReturn(this, result);
  };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(259)["default"];
var assertThisInitialized = __webpack_require__(1051);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(1053)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(40)["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CloseOutlined = _interopRequireDefault(__webpack_require__(1055));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CloseOutlined = function CloseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CloseOutlined.default
  }));
};
CloseOutlined.displayName = 'CloseOutlined';
var _default = /*#__PURE__*/React.forwardRef(CloseOutlined);
exports.default = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CloseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };
exports.default = CloseOutlined;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(1057));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CheckCircleOutlined.default
  }));
};
CheckCircleOutlined.displayName = 'CheckCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(CheckCircleOutlined);
exports.default = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CheckCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
exports.default = CheckCircleOutlined;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CloseCircleOutlined = _interopRequireDefault(__webpack_require__(1059));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CloseCircleOutlined.default
  }));
};
CloseCircleOutlined.displayName = 'CloseCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(CloseCircleOutlined);
exports.default = _default;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CloseCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };
exports.default = CloseCircleOutlined;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };
exports.default = ExclamationCircleOutlined;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _InfoCircleOutlined = _interopRequireDefault(__webpack_require__(1062));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _InfoCircleOutlined.default
  }));
};
InfoCircleOutlined.displayName = 'InfoCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(InfoCircleOutlined);
exports.default = _default;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var InfoCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
exports.default = InfoCircleOutlined;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createUseNotification;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _useNotification = _interopRequireDefault(__webpack_require__(537));

var _configProvider = __webpack_require__(8);

function createUseNotification(getNotificationInstance, getRCNoticeProps) {
  var useNotification = function useNotification() {
    // We can only get content by render
    var getPrefixCls; // We create a proxy to handle delay created instance

    var innerInstance = null;
    var proxy = {
      add: function add(noticeProps, holderCallback) {
        innerInstance === null || innerInstance === void 0 ? void 0 : innerInstance.component.add(noticeProps, holderCallback);
      }
    };

    var _useRCNotification = (0, _useNotification["default"])(proxy),
        _useRCNotification2 = (0, _slicedToArray2["default"])(_useRCNotification, 2),
        hookNotify = _useRCNotification2[0],
        holder = _useRCNotification2[1];

    function notify(args) {
      var customizePrefixCls = args.prefixCls;
      var mergedPrefixCls = getPrefixCls('notification', customizePrefixCls);
      getNotificationInstance((0, _extends2["default"])((0, _extends2["default"])({}, args), {
        prefixCls: mergedPrefixCls
      }), function (_ref) {
        var prefixCls = _ref.prefixCls,
            instance = _ref.instance;
        innerInstance = instance;
        hookNotify(getRCNoticeProps(args, prefixCls));
      });
    } // Fill functions


    var hookApiRef = React.useRef({});
    hookApiRef.current.open = notify;
    ['success', 'info', 'warning', 'error'].forEach(function (type) {
      hookApiRef.current[type] = function (args) {
        return hookApiRef.current.open((0, _extends2["default"])((0, _extends2["default"])({}, args), {
          type: type
        }));
      };
    });
    return [hookApiRef.current, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, {
      key: "holder"
    }, function (context) {
      getPrefixCls = context.getPrefixCls;
      return holder;
    })];
  };

  return useNotification;
}

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(350);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(261);
var invariant = __webpack_require__(34);
var ReactPropTypesSecret = __webpack_require__(1066);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(262);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.4
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1080);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(547);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1076);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71), __webpack_require__(1075)(module)))

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(547);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(548);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1081);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(350);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zh_TW = _interopRequireDefault(__webpack_require__(1083));

var _default = _zh_TW["default"];
exports["default"] = _default;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zh_TW = _interopRequireDefault(__webpack_require__(1084));

var _zh_TW2 = _interopRequireDefault(__webpack_require__(552));

var _zh_TW3 = _interopRequireDefault(__webpack_require__(553));

var _zh_TW4 = _interopRequireDefault(__webpack_require__(1086));

/* eslint-disable no-template-curly-in-string */
var typeTemplate = '${label}不是一個有效的${type}';
var localeValues = {
  locale: 'zh-tw',
  Pagination: _zh_TW["default"],
  DatePicker: _zh_TW2["default"],
  TimePicker: _zh_TW3["default"],
  Calendar: _zh_TW4["default"],
  global: {
    placeholder: '請選擇'
  },
  Table: {
    filterTitle: '篩選器',
    filterConfirm: '確定',
    filterReset: '重置',
    filterEmptyText: '無篩選項',
    selectAll: '全部選取',
    selectInvert: '反向選取',
    selectNone: '清空所有',
    selectionAll: '全選所有',
    sortTitle: '排序',
    expand: '展開行',
    collapse: '關閉行',
    triggerDesc: '點擊降序',
    triggerAsc: '點擊升序',
    cancelSort: '取消排序'
  },
  Modal: {
    okText: '確定',
    cancelText: '取消',
    justOkText: '知道了'
  },
  Popconfirm: {
    okText: '確定',
    cancelText: '取消'
  },
  Transfer: {
    searchPlaceholder: '搜尋資料',
    itemUnit: '項目',
    itemsUnit: '項目'
  },
  Upload: {
    uploading: '正在上傳...',
    removeFile: '刪除檔案',
    uploadError: '上傳失敗',
    previewFile: '檔案預覽',
    downloadFile: '下载文件'
  },
  Empty: {
    description: '無此資料'
  },
  Icon: {
    icon: '圖標'
  },
  Text: {
    edit: '編輯',
    copy: '複製',
    copied: '複製成功',
    expand: '展開'
  },
  PageHeader: {
    back: '返回'
  },
  Form: {
    defaultValidateMessages: {
      "default": '字段驗證錯誤${label}',
      required: '請輸入${label}',
      "enum": '${label}必須是其中一個[${enum}]',
      whitespace: '${label}不能為空字符',
      date: {
        format: '${label}日期格式無效',
        parse: '${label}不能轉換為日期',
        invalid: '${label}是一個無效日期'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        "boolean": typeTemplate,
        integer: typeTemplate,
        "float": typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label}須為${len}個字符',
        min: '${label}最少${min}個字符',
        max: '${label}最多${max}個字符',
        range: '${label}須在${min}-${max}字符之間'
      },
      number: {
        len: '${label}必須等於${len}',
        min: '${label}最小值為${min}',
        max: '${label}最大值為${max}',
        range: '${label}須在${min}-${max}之間'
      },
      array: {
        len: '須為${len}個${label}',
        min: '最少${min}個${label}',
        max: '最多${max}個${label}',
        range: '${label}數量須在${min}-${max}之間'
      },
      pattern: {
        mismatch: '${label}與模式不匹配${pattern}'
      }
    }
  }
};
var _default = localeValues;
exports["default"] = _default;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // Options.jsx
  items_per_page: '條/頁',
  jump_to: '跳至',
  jump_to_confirm: '確定',
  page: '頁',
  // Pagination.jsx
  prev_page: '上一頁',
  next_page: '下一頁',
  prev_5: '向前 5 頁',
  next_5: '向後 5 頁',
  prev_3: '向前 3 頁',
  next_3: '向後 3 頁',
  page_size: '頁碼'
};
exports.default = _default;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var locale = {
  locale: 'zh_TW',
  today: '今天',
  now: '此刻',
  backToToday: '返回今天',
  ok: '確定',
  timeSelect: '選擇時間',
  dateSelect: '選擇日期',
  weekSelect: '選擇周',
  clear: '清除',
  month: '月',
  year: '年',
  previousMonth: '上個月 (翻頁上鍵)',
  nextMonth: '下個月 (翻頁下鍵)',
  monthSelect: '選擇月份',
  yearSelect: '選擇年份',
  decadeSelect: '選擇年代',
  yearFormat: 'YYYY年',
  dayFormat: 'D日',
  dateFormat: 'YYYY年M月D日',
  dateTimeFormat: 'YYYY年M月D日 HH時mm分ss秒',
  previousYear: '上一年 (Control鍵加左方向鍵)',
  nextYear: '下一年 (Control鍵加右方向鍵)',
  previousDecade: '上一年代',
  nextDecade: '下一年代',
  previousCentury: '上一世紀',
  nextCentury: '下一世紀'
};
var _default = locale;
exports.default = _default;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _zh_TW = _interopRequireDefault(__webpack_require__(552));

var _default = _zh_TW["default"];
exports["default"] = _default;

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_module_scss__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_history__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_app_module_scss__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_app_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styles_app_module_scss__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { hot } from 'react-hot-loader/root';
// import LayoutFactory from '../layouts/Layout/LayoutFactory';
var _=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a;var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var auth=this.props.auth;if(auth&&auth.isLogin){__WEBPACK_IMPORTED_MODULE_6__libs_AppHelper__["a" /* default */].updateUserInfo();}// auth異動
this.authDeniedToken=__WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__["b" /* default */].default.addObserver(this,function(notification){_this2.props.cleanUserInfo&&_this2.props.cleanUserInfo();_this2.props.cleanAuthInfo&&_this2.props.cleanAuthInfo();__WEBPACK_IMPORTED_MODULE_7__libs_history__["a" /* default */].push('/login');},__WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__["a" /* NotificationName */].AuthDenied);// auth異常
this.authDeniedToken=__WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__["b" /* default */].default.addObserver(this,function(notification){console.log('PermissionsDidChanged',notification);_this2.forceUpdate();},__WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__["a" /* NotificationName */].PermissionsDidChanged);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_8__libs_NotificationCenter__["b" /* default */].default.removeObserver(this);}},{key:'render',value:function render(){var user=_.get(this,'props.user');var roles=_.get(this,'props.user.roles',[]);// 此處可簡單處理轉導功能
// if (user.isLogin === false && window.location.pathname !== '/')
//   history.replace('/')
var search=_.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(search);var slug=_.get(queryParams,'page');// 此處不使用Route原本Path的功能
// 改看wp-admin/admin.php?page=stores
return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* HashRouter */],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,Object(__WEBPACK_IMPORTED_MODULE_2__web__["a" /* getRouterData */])().filter(function(router){return _.isNil(router.wp_slug)||router.wp_slug===slug;}).map(function(router){// let Layout = LayoutFactory.create(router.layout, router)
// let routerSetting = {...router, component:null}
var routerSetting=Object.assign({},router);return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],_extends({key:router.path},routerSetting));}// render={() => <Layout {...router} componentView={router.component}/>}
)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__reducers__["b" /* wConnectRedux */])(App));// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(355);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(555);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(555);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(354);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(355);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(557);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(556);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(560);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(561);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(562);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(563);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(357);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(266);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(564);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(557);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(560);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(561);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(356);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(265);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(562);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(563);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(357);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(266);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Content=__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Content;var ErrorPage=function(_Component){_inherits(ErrorPage,_Component);function ErrorPage(){_classCallCheck(this,ErrorPage);return _possibleConstructorReturn(this,(ErrorPage.__proto__||Object.getPrototypeOf(ErrorPage)).apply(this,arguments));}_createClass(ErrorPage,[{key:'render',value:function render(){return wp.element.createElement(Content,{className:__WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default.a.content_404},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default.a.page404},wp.element.createElement('h1',null,'404 !'),wp.element.createElement('h2',null,'PAGE NOT FOUND'),wp.element.createElement('p',null,'Sorry, the page you requested was not found.'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:''},'\u56DE\u9996\u9801')));}}]);return ErrorPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(535);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _BarsOutlined = _interopRequireDefault(__webpack_require__(1112));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _BarsOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _BarsOutlined = _interopRequireDefault(__webpack_require__(1113));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _BarsOutlined.default
  }));
};
BarsOutlined.displayName = 'BarsOutlined';
var _default = /*#__PURE__*/React.forwardRef(BarsOutlined);
exports.default = _default;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var BarsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };
exports.default = BarsOutlined;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _RightOutlined = _interopRequireDefault(__webpack_require__(1115));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _RightOutlined.default
  }));
};
RightOutlined.displayName = 'RightOutlined';
var _default = /*#__PURE__*/React.forwardRef(RightOutlined);
exports.default = _default;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
exports.default = RightOutlined;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _LeftOutlined = _interopRequireDefault(__webpack_require__(1117));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var LeftOutlined = function LeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _LeftOutlined.default
  }));
};
LeftOutlined.displayName = 'LeftOutlined';
var _default = /*#__PURE__*/React.forwardRef(LeftOutlined);
exports.default = _default;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
exports.default = LeftOutlined;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

var _default = isNumeric;
exports["default"] = _default;

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Content=__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a.Content;var ErrorPage=function(_Component){_inherits(ErrorPage,_Component);function ErrorPage(){_classCallCheck(this,ErrorPage);return _possibleConstructorReturn(this,(ErrorPage.__proto__||Object.getPrototypeOf(ErrorPage)).apply(this,arguments));}_createClass(ErrorPage,[{key:'render',value:function render(){var _props$match=this.props.match;_props$match=_props$match===undefined?{}:_props$match;var _props$match$params=_props$match.params;_props$match$params=_props$match$params===undefined?{}:_props$match$params;var _props$match$params$m=_props$match$params.message,message=_props$match$params$m===undefined?null:_props$match$params$m;return wp.element.createElement(Content,{className:__WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default.a.content_404},wp.element.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__styles_module_scss___default.a.page404},wp.element.createElement('h1',null,'Information'),wp.element.createElement('h2',null,message?message:'頁面製作中'),wp.element.createElement('p',null)));}}]);return ErrorPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _rcTable = _interopRequireWildcard(__webpack_require__(570));

var _Table = __webpack_require__(1171);

var _useColumns = __webpack_require__(593);

var _spin = _interopRequireDefault(__webpack_require__(50));

var _pagination = _interopRequireDefault(__webpack_require__(598));

var _context = __webpack_require__(334);

var _usePagination3 = _interopRequireWildcard(__webpack_require__(1341));

var _useLazyKVMap3 = _interopRequireDefault(__webpack_require__(1342));

var _useSelection3 = _interopRequireWildcard(__webpack_require__(1343));

var _useSorter3 = _interopRequireWildcard(__webpack_require__(1448));

var _useFilter3 = _interopRequireWildcard(__webpack_require__(1455));

var _useTitleColumns3 = _interopRequireDefault(__webpack_require__(1527));

var _ExpandIcon = _interopRequireDefault(__webpack_require__(1528));

var _scrollTo = _interopRequireDefault(__webpack_require__(1529));

var _en_US = _interopRequireDefault(__webpack_require__(1532));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _Column = _interopRequireDefault(__webpack_require__(1533));

var _ColumnGroup = _interopRequireDefault(__webpack_require__(1534));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _useBreakpoint = _interopRequireDefault(__webpack_require__(217));

var EMPTY_LIST = [];

function Table(props) {
  var _classNames3;

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      customizeSize = props.size,
      bordered = props.bordered,
      customizeDropdownPrefixCls = props.dropdownPrefixCls,
      dataSource = props.dataSource,
      pagination = props.pagination,
      rowSelection = props.rowSelection,
      rowKey = props.rowKey,
      rowClassName = props.rowClassName,
      columns = props.columns,
      children = props.children,
      legacyChildrenColumnName = props.childrenColumnName,
      onChange = props.onChange,
      getPopupContainer = props.getPopupContainer,
      loading = props.loading,
      expandIcon = props.expandIcon,
      expandable = props.expandable,
      expandedRowRender = props.expandedRowRender,
      expandIconColumnIndex = props.expandIconColumnIndex,
      indentSize = props.indentSize,
      scroll = props.scroll,
      sortDirections = props.sortDirections,
      locale = props.locale,
      _props$showSorterTool = props.showSorterTooltip,
      showSorterTooltip = _props$showSorterTool === void 0 ? true : _props$showSorterTool;
  (0, _devWarning["default"])(!(typeof rowKey === 'function' && rowKey.length > 1), 'Table', '`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.');
  var screens = (0, _useBreakpoint["default"])();
  var mergedColumns = React.useMemo(function () {
    var matched = new Set(Object.keys(screens).filter(function (m) {
      return screens[m];
    }));
    return (columns || (0, _useColumns.convertChildrenToColumns)(children)).filter(function (c) {
      return !c.responsive || c.responsive.some(function (r) {
        return matched.has(r);
      });
    });
  }, [children, columns, screens]);
  var tableProps = (0, _omit["default"])(props, ['className', 'style', 'columns']);
  var size = React.useContext(_SizeContext["default"]);

  var _React$useContext = React.useContext(_context.ConfigContext),
      _React$useContext$loc = _React$useContext.locale,
      contextLocale = _React$useContext$loc === void 0 ? _en_US["default"] : _React$useContext$loc,
      renderEmpty = _React$useContext.renderEmpty,
      direction = _React$useContext.direction;

  var mergedSize = customizeSize || size;
  var tableLocale = (0, _extends2["default"])((0, _extends2["default"])({}, contextLocale.Table), locale);
  var rawData = dataSource || EMPTY_LIST;

  var _React$useContext2 = React.useContext(_context.ConfigContext),
      getPrefixCls = _React$useContext2.getPrefixCls;

  var prefixCls = getPrefixCls('table', customizePrefixCls);
  var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
  var mergedExpandable = (0, _extends2["default"])({
    childrenColumnName: legacyChildrenColumnName,
    expandIconColumnIndex: expandIconColumnIndex
  }, expandable);
  var _mergedExpandable$chi = mergedExpandable.childrenColumnName,
      childrenColumnName = _mergedExpandable$chi === void 0 ? 'children' : _mergedExpandable$chi;
  var expandType = React.useMemo(function () {
    if (rawData.some(function (item) {
      var _a;

      return (_a = item) === null || _a === void 0 ? void 0 : _a[childrenColumnName];
    })) {
      return 'nest';
    }

    if (expandedRowRender || expandable && expandable.expandedRowRender) {
      return 'row';
    }

    return null;
  }, [rawData]);
  var internalRefs = {
    body: React.useRef()
  }; // ============================ RowKey ============================

  var getRowKey = React.useMemo(function () {
    if (typeof rowKey === 'function') {
      return rowKey;
    }

    return function (record) {
      var _a;

      return (_a = record) === null || _a === void 0 ? void 0 : _a[rowKey];
    };
  }, [rowKey]);

  var _useLazyKVMap = (0, _useLazyKVMap3["default"])(rawData, childrenColumnName, getRowKey),
      _useLazyKVMap2 = (0, _slicedToArray2["default"])(_useLazyKVMap, 1),
      getRecordByKey = _useLazyKVMap2[0]; // ============================ Events =============================


  var changeEventInfo = {};

  var triggerOnChange = function triggerOnChange(info, action) {
    var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var changeInfo = (0, _extends2["default"])((0, _extends2["default"])({}, changeEventInfo), info);

    if (reset) {
      changeEventInfo.resetPagination(); // Reset event param

      if (changeInfo.pagination.current) {
        changeInfo.pagination.current = 1;
      } // Trigger pagination events


      if (pagination && pagination.onChange) {
        pagination.onChange(1, changeInfo.pagination.pageSize);
      }
    }

    if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) {
      (0, _scrollTo["default"])(0, {
        getContainer: function getContainer() {
          return internalRefs.body.current;
        }
      });
    }

    if (onChange) {
      onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
        currentDataSource: (0, _useFilter3.getFilterData)((0, _useSorter3.getSortData)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates),
        action: action
      });
    }
  };
  /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big version.
   */
  // ============================ Sorter =============================


  var onSorterChange = function onSorterChange(sorter, sorterStates) {
    triggerOnChange({
      sorter: sorter,
      sorterStates: sorterStates
    }, 'sort', false);
  };

  var _useSorter = (0, _useSorter3["default"])({
    prefixCls: prefixCls,
    mergedColumns: mergedColumns,
    onSorterChange: onSorterChange,
    sortDirections: sortDirections || ['ascend', 'descend'],
    tableLocale: tableLocale,
    showSorterTooltip: showSorterTooltip
  }),
      _useSorter2 = (0, _slicedToArray2["default"])(_useSorter, 4),
      transformSorterColumns = _useSorter2[0],
      sortStates = _useSorter2[1],
      sorterTitleProps = _useSorter2[2],
      getSorters = _useSorter2[3];

  var sortedData = React.useMemo(function () {
    return (0, _useSorter3.getSortData)(rawData, sortStates, childrenColumnName);
  }, [rawData, sortStates]);
  changeEventInfo.sorter = getSorters();
  changeEventInfo.sorterStates = sortStates; // ============================ Filter ============================

  var onFilterChange = function onFilterChange(filters, filterStates) {
    triggerOnChange({
      filters: filters,
      filterStates: filterStates
    }, 'filter', true);
  };

  var _useFilter = (0, _useFilter3["default"])({
    prefixCls: prefixCls,
    locale: tableLocale,
    dropdownPrefixCls: dropdownPrefixCls,
    mergedColumns: mergedColumns,
    onFilterChange: onFilterChange,
    getPopupContainer: getPopupContainer
  }),
      _useFilter2 = (0, _slicedToArray2["default"])(_useFilter, 3),
      transformFilterColumns = _useFilter2[0],
      filterStates = _useFilter2[1],
      getFilters = _useFilter2[2];

  var mergedData = (0, _useFilter3.getFilterData)(sortedData, filterStates);
  changeEventInfo.filters = getFilters();
  changeEventInfo.filterStates = filterStates; // ============================ Column ============================

  var columnTitleProps = React.useMemo(function () {
    return (0, _extends2["default"])({}, sorterTitleProps);
  }, [sorterTitleProps]);

  var _useTitleColumns = (0, _useTitleColumns3["default"])(columnTitleProps),
      _useTitleColumns2 = (0, _slicedToArray2["default"])(_useTitleColumns, 1),
      transformTitleColumns = _useTitleColumns2[0]; // ========================== Pagination ==========================


  var onPaginationChange = function onPaginationChange(current, pageSize) {
    triggerOnChange({
      pagination: (0, _extends2["default"])((0, _extends2["default"])({}, changeEventInfo.pagination), {
        current: current,
        pageSize: pageSize
      })
    }, 'paginate');
  };

  var _usePagination = (0, _usePagination3["default"])(mergedData.length, pagination, onPaginationChange),
      _usePagination2 = (0, _slicedToArray2["default"])(_usePagination, 2),
      mergedPagination = _usePagination2[0],
      resetPagination = _usePagination2[1];

  changeEventInfo.pagination = pagination === false ? {} : (0, _usePagination3.getPaginationParam)(pagination, mergedPagination);
  changeEventInfo.resetPagination = resetPagination; // ============================= Data =============================

  var pageData = React.useMemo(function () {
    if (pagination === false || !mergedPagination.pageSize) {
      return mergedData;
    }

    var _mergedPagination$cur = mergedPagination.current,
        current = _mergedPagination$cur === void 0 ? 1 : _mergedPagination$cur,
        total = mergedPagination.total,
        _mergedPagination$pag = mergedPagination.pageSize,
        pageSize = _mergedPagination$pag === void 0 ? _usePagination3.DEFAULT_PAGE_SIZE : _mergedPagination$pag; // Dynamic table data

    if (mergedData.length < total) {
      if (mergedData.length > pageSize) {
        (0, _devWarning["default"])(false, 'Table', '`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode.');
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
      }

      return mergedData;
    }

    return mergedData.slice((current - 1) * pageSize, current * pageSize);
  }, [!!pagination, mergedData, mergedPagination && mergedPagination.current, mergedPagination && mergedPagination.pageSize, mergedPagination && mergedPagination.total]); // ========================== Selections ==========================

  var _useSelection = (0, _useSelection3["default"])(rowSelection, {
    prefixCls: prefixCls,
    data: mergedData,
    pageData: pageData,
    getRowKey: getRowKey,
    getRecordByKey: getRecordByKey,
    expandType: expandType,
    childrenColumnName: childrenColumnName,
    locale: tableLocale,
    expandIconColumnIndex: mergedExpandable.expandIconColumnIndex,
    getPopupContainer: getPopupContainer
  }),
      _useSelection2 = (0, _slicedToArray2["default"])(_useSelection, 2),
      transformSelectionColumns = _useSelection2[0],
      selectedKeySet = _useSelection2[1];

  var internalRowClassName = function internalRowClassName(record, index, indent) {
    var mergedRowClassName;

    if (typeof rowClassName === 'function') {
      mergedRowClassName = (0, _classnames["default"])(rowClassName(record, index, indent));
    } else {
      mergedRowClassName = (0, _classnames["default"])(rowClassName);
    }

    return (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(prefixCls, "-row-selected"), selectedKeySet.has(getRowKey(record, index))), mergedRowClassName);
  }; // ========================== Expandable ==========================
  // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`


  mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon; // Customize expandable icon

  mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, _ExpandIcon["default"])(tableLocale); // Adjust expand icon index, no overwrite expandIconColumnIndex if set.

  if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) {
    mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
  } else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) {
    mergedExpandable.expandIconColumnIndex -= 1;
  } // Indent size


  if (typeof mergedExpandable.indentSize !== 'number') {
    mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
  } // ============================ Render ============================


  var transformColumns = React.useCallback(function (innerColumns) {
    return transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns))));
  }, [transformSorterColumns, transformFilterColumns, transformSelectionColumns]);
  var topPaginationNode;
  var bottomPaginationNode;

  if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
    var paginationSize;

    if (mergedPagination.size) {
      paginationSize = mergedPagination.size;
    } else {
      paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
    }

    var renderPagination = function renderPagination(position) {
      return /*#__PURE__*/React.createElement(_pagination["default"], (0, _extends2["default"])({
        className: "".concat(prefixCls, "-pagination ").concat(prefixCls, "-pagination-").concat(position)
      }, mergedPagination, {
        size: paginationSize
      }));
    };

    var defaultPosition = direction === 'rtl' ? 'left' : 'right';

    if (mergedPagination.position !== null && Array.isArray(mergedPagination.position)) {
      var topPos = mergedPagination.position.find(function (p) {
        return p.indexOf('top') !== -1;
      });
      var bottomPos = mergedPagination.position.find(function (p) {
        return p.indexOf('bottom') !== -1;
      });

      if (!topPos && !bottomPos) {
        bottomPaginationNode = renderPagination(defaultPosition);
      } else {
        if (topPos) {
          topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
        }

        if (bottomPos) {
          bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
        }
      }
    } else {
      bottomPaginationNode = renderPagination(defaultPosition);
    }
  } // >>>>>>>>> Spinning


  var spinProps;

  if (typeof loading === 'boolean') {
    spinProps = {
      spinning: loading
    };
  } else if ((0, _typeof2["default"])(loading) === 'object') {
    spinProps = (0, _extends2["default"])({
      spinning: true
    }, loading);
  }

  var wrapperClassNames = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), className);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames,
    style: style
  }, /*#__PURE__*/React.createElement(_spin["default"], (0, _extends2["default"])({
    spinning: false
  }, spinProps), topPaginationNode, /*#__PURE__*/React.createElement(_rcTable["default"], (0, _extends2["default"])({}, tableProps, {
    columns: mergedColumns,
    direction: direction,
    expandable: mergedExpandable,
    prefixCls: prefixCls,
    className: (0, _classnames["default"])((_classNames3 = {}, (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-middle"), mergedSize === 'middle'), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-small"), mergedSize === 'small'), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-bordered"), bordered), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-empty"), rawData.length === 0), _classNames3)),
    data: pageData,
    rowKey: getRowKey,
    rowClassName: internalRowClassName,
    emptyText: locale && locale.emptyText || renderEmpty('Table') // Internal
    ,
    internalHooks: _Table.INTERNAL_HOOKS,
    internalRefs: internalRefs,
    transformColumns: transformColumns
  })), bottomPaginationNode));
}

Table.defaultProps = {
  rowKey: 'key'
};
Table.SELECTION_ALL = _useSelection3.SELECTION_ALL;
Table.SELECTION_INVERT = _useSelection3.SELECTION_INVERT;
Table.SELECTION_NONE = _useSelection3.SELECTION_NONE;
Table.Column = _Column["default"];
Table.ColumnGroup = _ColumnGroup["default"];
Table.Summary = _rcTable.Summary;
var _default = Table;
exports["default"] = _default;

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INTERNAL_HOOKS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_typeof__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_isVisible__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shallowequal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_resize_observer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_getScrollBarSize__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sugar_ColumnGroup__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sugar_Column__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Header_FixedHeader__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Header_Header__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__context_BodyContext__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Body__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hooks_useColumns__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hooks_useFrame__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__context_ResizeContext__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hooks_useStickyOffsets__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ColGroup__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_legacyUtil__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Panel__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Footer__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_expandUtil__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_fixUtil__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stickyScrollBar__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hooks_useSticky__ = __webpack_require__(1170);







/**
 * Feature:
 *  - fixed not need to set width
 *  - support `rowExpandable` to config row expand logic
 *  - add `summary` to support `() => ReactNode`
 *
 * Update:
 *  - `dataIndex` is `array[]` now
 *  - `expandable` wrap all the expand related props
 *
 * Removed:
 *  - expandIconAsCell
 *  - useFixedHeader
 *  - rowRef
 *  - columns[number].onCellClick
 *  - onRowClick
 *  - onRowDoubleClick
 *  - onRowMouseEnter
 *  - onRowMouseLeave
 *  - getBodyWrapper
 *  - bodyStyle
 *
 * Deprecated:
 *  - All expanded props, move into expandable
 */


























 // Used for conditions cache

var EMPTY_DATA = []; // Used for customize scroll

var EMPTY_SCROLL_TARGET = {};
var INTERNAL_HOOKS = 'rc-table-internal-hook';
var MemoTableContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["memo"](function (_ref) {
  var children = _ref.children;
  return children;
}, function (prev, next) {
  if (!__WEBPACK_IMPORTED_MODULE_9_shallowequal___default()(prev.props, next.props)) {
    return false;
  } // No additional render when pinged status change.
  // This is not a bug.


  return prev.pingLeft !== next.pingLeft || prev.pingRight !== next.pingRight;
});

function Table(props) {
  var _classNames;

  var prefixCls = props.prefixCls,
      className = props.className,
      rowClassName = props.rowClassName,
      style = props.style,
      data = props.data,
      rowKey = props.rowKey,
      scroll = props.scroll,
      tableLayout = props.tableLayout,
      direction = props.direction,
      title = props.title,
      footer = props.footer,
      summary = props.summary,
      id = props.id,
      showHeader = props.showHeader,
      components = props.components,
      emptyText = props.emptyText,
      onRow = props.onRow,
      onHeaderRow = props.onHeaderRow,
      internalHooks = props.internalHooks,
      transformColumns = props.transformColumns,
      internalRefs = props.internalRefs,
      sticky = props.sticky;
  var mergedData = data || EMPTY_DATA;
  var hasData = !!mergedData.length; // ===================== Effects ======================

  var _React$useState = __WEBPACK_IMPORTED_MODULE_6_react__["useState"](0),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      scrollbarSize = _React$useState2[0],
      setScrollbarSize = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_6_react__["useEffect"](function () {
    setScrollbarSize(Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_getScrollBarSize__["a" /* default */])());
  }); // ===================== Warning ======================

  if (false) {
    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      warning(props[name] === undefined, "`".concat(name, "` is removed, please use `onRow` instead."));
    });
    warning(!('getBodyWrapper' in props), '`getBodyWrapper` is deprecated, please use custom `components` instead.');
  } // ==================== Customize =====================


  var mergedComponents = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__["c" /* mergeObject */])(components, {});
  }, [components]);
  var getComponent = __WEBPACK_IMPORTED_MODULE_6_react__["useCallback"](function (path, defaultComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__["b" /* getPathValue */])(mergedComponents, path) || defaultComponent;
  }, [mergedComponents]);
  var getRowKey = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    if (typeof rowKey === 'function') {
      return rowKey;
    }

    return function (record) {
      var key = record && record[rowKey];

      if (false) {
        warning(key !== undefined, 'Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key.');
      }

      return key;
    };
  }, [rowKey]); // ====================== Expand ======================

  var expandableConfig = Object(__WEBPACK_IMPORTED_MODULE_26__utils_legacyUtil__["c" /* getExpandableProps */])(props);
  var expandIcon = expandableConfig.expandIcon,
      expandedRowKeys = expandableConfig.expandedRowKeys,
      defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys,
      defaultExpandAllRows = expandableConfig.defaultExpandAllRows,
      expandedRowRender = expandableConfig.expandedRowRender,
      onExpand = expandableConfig.onExpand,
      onExpandedRowsChange = expandableConfig.onExpandedRowsChange,
      expandRowByClick = expandableConfig.expandRowByClick,
      rowExpandable = expandableConfig.rowExpandable,
      expandIconColumnIndex = expandableConfig.expandIconColumnIndex,
      expandedRowClassName = expandableConfig.expandedRowClassName,
      childrenColumnName = expandableConfig.childrenColumnName,
      indentSize = expandableConfig.indentSize;
  var mergedExpandIcon = expandIcon || __WEBPACK_IMPORTED_MODULE_29__utils_expandUtil__["b" /* renderExpandIcon */];
  var mergedChildrenColumnName = childrenColumnName || 'children';
  var expandableType = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    if (expandedRowRender) {
      return 'row';
    }
    /* eslint-disable no-underscore-dangle */

    /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */


    if (props.expandable && internalHooks === INTERNAL_HOOKS && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function (record) {
      return record && Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_typeof__["a" /* default */])(record) === 'object' && record[mergedChildrenColumnName];
    })) {
      return 'nest';
    }
    /* eslint-enable */


    return false;
  }, [!!expandedRowRender, mergedData]);

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_6_react__["useState"](function () {
    if (defaultExpandedRowKeys) {
      return defaultExpandedRowKeys;
    }

    if (defaultExpandAllRows) {
      return Object(__WEBPACK_IMPORTED_MODULE_29__utils_expandUtil__["a" /* findAllChildrenKeys */])(mergedData, getRowKey, mergedChildrenColumnName);
    }

    return [];
  }),
      _React$useState4 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState3, 2),
      innerExpandedKeys = _React$useState4[0],
      setInnerExpandedKeys = _React$useState4[1];

  var mergedExpandedKeys = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return new Set(expandedRowKeys || innerExpandedKeys || []);
  }, [expandedRowKeys, innerExpandedKeys]);
  var onTriggerExpand = __WEBPACK_IMPORTED_MODULE_6_react__["useCallback"](function (record) {
    var key = getRowKey(record, mergedData.indexOf(record));
    var newExpandedKeys;
    var hasKey = mergedExpandedKeys.has(key);

    if (hasKey) {
      mergedExpandedKeys.delete(key);
      newExpandedKeys = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedExpandedKeys);
    } else {
      newExpandedKeys = [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedExpandedKeys), [key]);
    }

    setInnerExpandedKeys(newExpandedKeys);

    if (onExpand) {
      onExpand(!hasKey, record);
    }

    if (onExpandedRowsChange) {
      onExpandedRowsChange(newExpandedKeys);
    }
  }, [getRowKey, mergedExpandedKeys, mergedData, onExpand, onExpandedRowsChange]); // ====================== Column ======================

  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_6_react__["useState"](0),
      _React$useState6 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState5, 2),
      componentWidth = _React$useState6[0],
      setComponentWidth = _React$useState6[1];

  var _useColumns = Object(__WEBPACK_IMPORTED_MODULE_20__hooks_useColumns__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), expandableConfig), {}, {
    expandable: !!expandedRowRender,
    expandedKeys: mergedExpandedKeys,
    getRowKey: getRowKey,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: onTriggerExpand,
    expandIcon: mergedExpandIcon,
    expandIconColumnIndex: expandIconColumnIndex,
    direction: direction
  }), internalHooks === INTERNAL_HOOKS ? transformColumns : null),
      _useColumns2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useColumns, 2),
      columns = _useColumns2[0],
      flattenColumns = _useColumns2[1];

  var columnContext = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return {
      columns: columns,
      flattenColumns: flattenColumns
    };
  }, [columns, flattenColumns]); // ====================== Scroll ======================

  var fullTableRef = __WEBPACK_IMPORTED_MODULE_6_react__["useRef"]();
  var scrollHeaderRef = __WEBPACK_IMPORTED_MODULE_6_react__["useRef"]();
  var scrollBodyRef = __WEBPACK_IMPORTED_MODULE_6_react__["useRef"]();

  var _React$useState7 = __WEBPACK_IMPORTED_MODULE_6_react__["useState"](false),
      _React$useState8 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState7, 2),
      pingedLeft = _React$useState8[0],
      setPingedLeft = _React$useState8[1];

  var _React$useState9 = __WEBPACK_IMPORTED_MODULE_6_react__["useState"](false),
      _React$useState10 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState9, 2),
      pingedRight = _React$useState10[0],
      setPingedRight = _React$useState10[1];

  var _useLayoutState = Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useFrame__["a" /* useLayoutState */])(new Map()),
      _useLayoutState2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useLayoutState, 2),
      colsWidths = _useLayoutState2[0],
      updateColsWidths = _useLayoutState2[1]; // Convert map to number width


  var colsKeys = Object(__WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__["a" /* getColumnsKey */])(flattenColumns);
  var pureColWidths = colsKeys.map(function (columnKey) {
    return colsWidths.get(columnKey);
  });
  var colWidths = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return pureColWidths;
  }, [pureColWidths.join('_')]);
  var stickyOffsets = Object(__WEBPACK_IMPORTED_MODULE_24__hooks_useStickyOffsets__["a" /* default */])(colWidths, flattenColumns.length, direction);
  var fixHeader = scroll && Object(__WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__["d" /* validateValue */])(scroll.y);
  var horizonScroll = scroll && Object(__WEBPACK_IMPORTED_MODULE_22__utils_valueUtil__["d" /* validateValue */])(scroll.x);
  var fixColumn = horizonScroll && flattenColumns.some(function (_ref2) {
    var fixed = _ref2.fixed;
    return fixed;
  }); // Sticky

  var stickyRef = __WEBPACK_IMPORTED_MODULE_6_react__["useRef"]();

  var _useSticky = Object(__WEBPACK_IMPORTED_MODULE_32__hooks_useSticky__["a" /* default */])(sticky, prefixCls),
      isSticky = _useSticky.isSticky,
      offsetHeader = _useSticky.offsetHeader,
      offsetScroll = _useSticky.offsetScroll,
      stickyClassName = _useSticky.stickyClassName,
      container = _useSticky.container;

  var scrollXStyle;
  var scrollYStyle;
  var scrollTableStyle;

  if (fixHeader) {
    scrollYStyle = {
      overflowY: 'scroll',
      maxHeight: scroll.y
    };
  }

  if (horizonScroll) {
    scrollXStyle = {
      overflowX: 'auto'
    }; // When no vertical scrollbar, should hide it
    // https://github.com/ant-design/ant-design/pull/20705
    // https://github.com/ant-design/ant-design/issues/21879

    if (!fixHeader) {
      scrollYStyle = {
        overflowY: 'hidden'
      };
    }

    scrollTableStyle = {
      width: scroll.x === true ? 'auto' : scroll.x,
      minWidth: '100%'
    };
  }

  var onColumnResize = __WEBPACK_IMPORTED_MODULE_6_react__["useCallback"](function (columnKey, width) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_isVisible__["a" /* default */])(fullTableRef.current)) {
      updateColsWidths(function (widths) {
        if (widths.get(columnKey) !== width) {
          var newWidths = new Map(widths);
          newWidths.set(columnKey, width);
          return newWidths;
        }

        return widths;
      });
    }
  }, []);

  var _useTimeoutLock = Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useFrame__["b" /* useTimeoutLock */])(null),
      _useTimeoutLock2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTimeoutLock, 2),
      setScrollTarget = _useTimeoutLock2[0],
      getScrollTarget = _useTimeoutLock2[1];

  function forceScroll(scrollLeft, target) {
    if (!target) {
      return;
    }

    if (typeof target === 'function') {
      target(scrollLeft);
    } else if (target.scrollLeft !== scrollLeft) {
      // eslint-disable-next-line no-param-reassign
      target.scrollLeft = scrollLeft;
    }
  }

  var onScroll = function onScroll(_ref3) {
    var currentTarget = _ref3.currentTarget,
        scrollLeft = _ref3.scrollLeft;
    var isRTL = direction === 'rtl';
    var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
    var compareTarget = currentTarget || EMPTY_SCROLL_TARGET;

    if (!getScrollTarget() || getScrollTarget() === compareTarget) {
      var _stickyRef$current;

      setScrollTarget(compareTarget);
      forceScroll(mergedScrollLeft, scrollHeaderRef.current);
      forceScroll(mergedScrollLeft, scrollBodyRef.current);
      forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
    }

    if (currentTarget) {
      var scrollWidth = currentTarget.scrollWidth,
          clientWidth = currentTarget.clientWidth;

      if (isRTL) {
        setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
        setPingedRight(-mergedScrollLeft > 0);
      } else {
        setPingedLeft(mergedScrollLeft > 0);
        setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
      }
    }
  };

  var triggerOnScroll = function triggerOnScroll() {
    if (scrollBodyRef.current) {
      onScroll({
        currentTarget: scrollBodyRef.current
      });
    }
  };

  var onFullTableResize = function onFullTableResize(_ref4) {
    var width = _ref4.width;
    triggerOnScroll();
    setComponentWidth(fullTableRef.current ? fullTableRef.current.offsetWidth : width);
  }; // Sync scroll bar when init or `horizonScroll` changed


  __WEBPACK_IMPORTED_MODULE_6_react__["useEffect"](function () {
    return triggerOnScroll;
  }, []);
  __WEBPACK_IMPORTED_MODULE_6_react__["useEffect"](function () {
    if (horizonScroll) {
      triggerOnScroll();
    }
  }, [horizonScroll]); // ================== INTERNAL HOOKS ==================

  __WEBPACK_IMPORTED_MODULE_6_react__["useEffect"](function () {
    if (internalHooks === INTERNAL_HOOKS && internalRefs) {
      internalRefs.body.current = scrollBodyRef.current;
    }
  }); // ====================== Render ======================

  var TableComponent = getComponent(['table'], 'table'); // Table layout

  var mergedTableLayout = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    if (tableLayout) {
      return tableLayout;
    } // https://github.com/ant-design/ant-design/issues/25227
    // When scroll.x is max-content, no need to fix table layout
    // it's width should stretch out to fit content


    if (fixColumn) {
      return scroll.x === 'max-content' ? 'auto' : 'fixed';
    }

    if (fixHeader || isSticky || flattenColumns.some(function (_ref5) {
      var ellipsis = _ref5.ellipsis;
      return ellipsis;
    })) {
      return 'fixed';
    }

    return 'auto';
  }, [fixHeader, fixColumn, flattenColumns, tableLayout, isSticky]);
  var groupTableNode; // Header props

  var headerProps = {
    colWidths: colWidths,
    columCount: flattenColumns.length,
    stickyOffsets: stickyOffsets,
    onHeaderRow: onHeaderRow,
    fixHeader: fixHeader
  }; // Empty

  var emptyNode = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    if (hasData) {
      return null;
    }

    if (typeof emptyText === 'function') {
      return emptyText();
    }

    return emptyText;
  }, [hasData, emptyText]); // Body

  var bodyTable = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__Body__["a" /* default */], {
    data: mergedData,
    measureColumnWidth: fixHeader || horizonScroll || isSticky,
    expandedKeys: mergedExpandedKeys,
    rowExpandable: rowExpandable,
    getRowKey: getRowKey,
    onRow: onRow,
    emptyNode: emptyNode,
    childrenColumnName: mergedChildrenColumnName
  });
  var bodyColGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__ColGroup__["a" /* default */], {
    colWidths: flattenColumns.map(function (_ref6) {
      var width = _ref6.width;
      return width;
    }),
    columns: flattenColumns
  });
  var footerTable = summary && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__Footer__["b" /* default */], null, summary(mergedData));
  var customizeScrollBody = getComponent(['body']);

  if (false) {
    warning(false, '`components.body` with render props is only work on `scroll.y`.');
  }

  if (fixHeader || isSticky) {
    var bodyContent;

    if (typeof customizeScrollBody === 'function') {
      bodyContent = customizeScrollBody(mergedData, {
        scrollbarSize: scrollbarSize,
        ref: scrollBodyRef,
        onScroll: onScroll
      });
      headerProps.colWidths = flattenColumns.map(function (_ref7, index) {
        var width = _ref7.width;
        var colWidth = index === columns.length - 1 ? width - scrollbarSize : width;

        if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) {
          return colWidth;
        }

        Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_warning__["a" /* default */])(false, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
        return 0;
      });
    } else {
      bodyContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scrollXStyle), scrollYStyle),
        onScroll: onScroll,
        ref: scrollBodyRef,
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-body"))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](TableComponent, {
        style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scrollTableStyle), {}, {
          tableLayout: mergedTableLayout
        })
      }, bodyColGroup, bodyTable, footerTable));
    }

    groupTableNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, showHeader !== false && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Header_FixedHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      noData: !mergedData.length
    }, headerProps, columnContext, {
      direction: direction // Fixed Props
      ,
      offsetHeader: offsetHeader,
      stickyClassName: stickyClassName,
      ref: scrollHeaderRef,
      onScroll: onScroll
    })), bodyContent, isSticky && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__stickyScrollBar__["a" /* default */], {
      ref: stickyRef,
      offsetScroll: offsetScroll,
      scrollBodyRef: scrollBodyRef,
      onScroll: onScroll,
      container: container
    }));
  } else {
    groupTableNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
      style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scrollXStyle), scrollYStyle),
      className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-content")),
      onScroll: onScroll,
      ref: scrollBodyRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](TableComponent, {
      style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scrollTableStyle), {}, {
        tableLayout: mergedTableLayout
      })
    }, bodyColGroup, showHeader !== false && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Header_Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headerProps, columnContext)), bodyTable, footerTable));
  }

  var ariaProps = Object(__WEBPACK_IMPORTED_MODULE_26__utils_legacyUtil__["b" /* getDataAndAriaProps */])(props);
  var fullTable = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right'), _classNames)),
    style: style,
    id: id,
    ref: fullTableRef
  }, ariaProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MemoTableContent, {
    pingLeft: pingedLeft,
    pingRight: pingedRight,
    props: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
      stickyOffsets: stickyOffsets,
      mergedExpandedKeys: mergedExpandedKeys
    })
  }, title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__Panel__["a" /* default */], {
    className: "".concat(prefixCls, "-title")
  }, title(mergedData)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-container")
  }, groupTableNode), footer && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__Panel__["a" /* default */], {
    className: "".concat(prefixCls, "-footer")
  }, footer(mergedData))));

  if (horizonScroll) {
    fullTable = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_rc_resize_observer__["default"], {
      onResize: onFullTableResize
    }, fullTable);
  }

  var TableContextValue = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return {
      prefixCls: prefixCls,
      getComponent: getComponent,
      scrollbarSize: scrollbarSize,
      direction: direction,
      fixedInfoList: flattenColumns.map(function (_, colIndex) {
        return Object(__WEBPACK_IMPORTED_MODULE_30__utils_fixUtil__["a" /* getCellFixedInfo */])(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
      }),
      isSticky: isSticky
    };
  }, [prefixCls, getComponent, scrollbarSize, direction, flattenColumns, stickyOffsets, direction, isSticky]);
  var BodyContextValue = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, columnContext), {}, {
      tableLayout: mergedTableLayout,
      rowClassName: rowClassName,
      expandedRowClassName: expandedRowClassName,
      componentWidth: componentWidth,
      fixHeader: fixHeader,
      fixColumn: fixColumn,
      horizonScroll: horizonScroll,
      expandIcon: mergedExpandIcon,
      expandableType: expandableType,
      expandRowByClick: expandRowByClick,
      expandedRowRender: expandedRowRender,
      onTriggerExpand: onTriggerExpand,
      expandIconColumnIndex: expandIconColumnIndex,
      indentSize: indentSize
    });
  }, [columnContext, mergedTableLayout, rowClassName, expandedRowClassName, componentWidth, fixHeader, fixColumn, horizonScroll, mergedExpandIcon, expandableType, expandRowByClick, expandedRowRender, onTriggerExpand, expandIconColumnIndex, indentSize]);
  var ResizeContextValue = __WEBPACK_IMPORTED_MODULE_6_react__["useMemo"](function () {
    return {
      onColumnResize: onColumnResize
    };
  }, [onColumnResize]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__context_TableContext__["a" /* default */].Provider, {
    value: TableContextValue
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__context_BodyContext__["a" /* default */].Provider, {
    value: BodyContextValue
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__context_ResizeContext__["a" /* default */].Provider, {
    value: ResizeContextValue
  }, fullTable)));
}

Table.Column = __WEBPACK_IMPORTED_MODULE_14__sugar_Column__["a" /* default */];
Table.ColumnGroup = __WEBPACK_IMPORTED_MODULE_13__sugar_ColumnGroup__["a" /* default */];
Table.Summary = __WEBPACK_IMPORTED_MODULE_28__Footer__["a" /* FooterComponents */];
Table.defaultProps = {
  rowKey: 'key',
  prefixCls: 'rc-table',
  emptyText: function emptyText() {
    return 'No Data';
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1133);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(165);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(571);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_Dom_findDOMNode__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_observerUtil__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DomWrapper__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Collection__ = __webpack_require__(574);







function SingleObserver(props, ref) {
  var children = props.children,
    disabled = props.disabled;
  var elementRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var wrapperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var onCollectionResize = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__Collection__["b" /* CollectionContext */]);
  // =========================== Children ===========================
  var isRenderProps = typeof children === 'function';
  var mergedChildren = isRenderProps ? children(elementRef) : children;
  // ============================= Size =============================
  var sizeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });
  // ============================= Ref ==============================
  var canRef = !isRenderProps && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](mergedChildren) && Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_ref__["c" /* supportRef */])(mergedChildren);
  var originRef = canRef ? mergedChildren.ref : null;
  var mergedRef = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_ref__["a" /* composeRef */])(originRef, elementRef);
  }, [originRef, elementRef]);
  var getDom = function getDom() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Dom_findDOMNode__["a" /* default */])(elementRef.current) || Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Dom_findDOMNode__["a" /* default */])(wrapperRef.current);
  };
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](ref, function () {
    return getDom();
  });
  // =========================== Observe ============================
  var propsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](props);
  propsRef.current = props;
  // Handler
  var onInternalResize = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (target) {
    var _propsRef$current = propsRef.current,
      onResize = _propsRef$current.onResize,
      data = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(),
      width = _target$getBoundingCl.width,
      height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth,
      offsetHeight = target.offsetHeight;
    /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth: offsetWidth,
        offsetHeight: offsetHeight
      };
      sizeRef.current = size;
      // IE is strange, right?
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });
      // Let collection know what happened
      onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(sizeInfo, target, data);
      if (onResize) {
        // defer the callback but not defer to next frame
        Promise.resolve().then(function () {
          onResize(sizeInfo, target);
        });
      }
    }
  }, []);
  // Dynamic observe
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_observerUtil__["a" /* observe */])(currentElement, onInternalResize);
    }
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_observerUtil__["b" /* unobserve */])(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);
  // ============================ Render ============================
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DomWrapper__["a" /* default */], {
    ref: wrapperRef
  }, canRef ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](SingleObserver);
if (false) {
  RefSingleObserver.displayName = 'SingleObserver';
}
/* harmony default export */ __webpack_exports__["a"] = (RefSingleObserver);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1143);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(573);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(364);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _el */
/* unused harmony export _rs */
/* harmony export (immutable) */ __webpack_exports__["a"] = observe;
/* harmony export (immutable) */ __webpack_exports__["b"] = unobserve;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resize_observer_polyfill__ = __webpack_require__(269);

// =============================== Const ===============================
var elementListeners = new Map();
function onResize(entities) {
  entities.forEach(function (entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 ? void 0 : _elementListeners$get.forEach(function (listener) {
      return listener(target);
    });
  });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var resizeObserver = new __WEBPACK_IMPORTED_MODULE_0_resize_observer_polyfill__["default"](onResize);
// Dev env only
var _el =  false ? elementListeners : null; // eslint-disable-line
var _rs =  false ? onResize : null; // eslint-disable-line
// ============================== Observe ==============================
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DomWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */
var DomWrapper = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(DomWrapper, _React$Component);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DomWrapper);
  function DomWrapper() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DomWrapper);
    return _super.apply(this, arguments);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return DomWrapper;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(573);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1150);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1154);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1155);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColGroup__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_TableContext__ = __webpack_require__(107);













function useColumnWidth(colWidths, columCount) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    var cloneColumns = [];

    for (var i = 0; i < columCount; i += 1) {
      var val = colWidths[i];

      if (val !== undefined) {
        cloneColumns[i] = val;
      } else {
        return null;
      }
    }

    return cloneColumns;
  }, [colWidths.join('_'), columCount]);
}

var FixedHeader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](function (_ref, ref) {
  var noData = _ref.noData,
      columns = _ref.columns,
      flattenColumns = _ref.flattenColumns,
      colWidths = _ref.colWidths,
      columCount = _ref.columCount,
      stickyOffsets = _ref.stickyOffsets,
      direction = _ref.direction,
      fixHeader = _ref.fixHeader,
      offsetHeader = _ref.offsetHeader,
      stickyClassName = _ref.stickyClassName,
      onScroll = _ref.onScroll,
      props = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "offsetHeader", "stickyClassName", "onScroll"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_5_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      scrollbarSize = _React$useContext.scrollbarSize,
      isSticky = _React$useContext.isSticky;

  var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize; // Pass wheel to scroll event

  var scrollRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](null);
  var setScrollRef = __WEBPACK_IMPORTED_MODULE_5_react__["useCallback"](function (element) {
    Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_ref__["b" /* fillRef */])(ref, element);
    Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_ref__["b" /* fillRef */])(scrollRef, element);
  }, []);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    var _scrollRef$current;

    function onWheel(e) {
      var currentTarget = e.currentTarget,
          deltaX = e.deltaX;

      if (deltaX) {
        onScroll({
          currentTarget: currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e.preventDefault();
      }
    }

    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.addEventListener('wheel', onWheel);
    return function () {
      var _scrollRef$current2;

      (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.removeEventListener('wheel', onWheel);
    };
  }, []); // Add scrollbar column

  var lastColumn = flattenColumns[flattenColumns.length - 1];
  var ScrollBarColumn = {
    fixed: lastColumn ? lastColumn.fixed : null,
    onHeaderCell: function onHeaderCell() {
      return {
        className: "".concat(prefixCls, "-cell-scrollbar")
      };
    }
  };
  var columnsWithScrollbar = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    return combinationScrollBarSize ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(columns), [ScrollBarColumn]) : columns;
  }, [combinationScrollBarSize, columns]);
  var flattenColumnsWithScrollbar = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    return combinationScrollBarSize ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(flattenColumns), [ScrollBarColumn]) : flattenColumns;
  }, [combinationScrollBarSize, flattenColumns]); // Calculate the sticky offsets

  var headerStickyOffsets = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    var right = stickyOffsets.right,
        left = stickyOffsets.left;
    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, stickyOffsets), {}, {
      left: direction === 'rtl' ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(left.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]) : left,
      right: direction === 'rtl' ? right : [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(right.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]),
      isSticky: isSticky
    });
  }, [combinationScrollBarSize, stickyOffsets, isSticky]);
  var mergedColumnWidth = useColumnWidth(colWidths, columCount);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      overflow: 'hidden'
    }, isSticky ? {
      top: offsetHeader
    } : {}),
    ref: setScrollRef,
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-header"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, stickyClassName, !!stickyClassName))
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("table", {
    style: {
      tableLayout: 'fixed',
      visibility: noData || mergedColumnWidth ? null : 'hidden'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ColGroup__["a" /* default */], {
    colWidths: mergedColumnWidth ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedColumnWidth), [combinationScrollBarSize]) : [],
    columCount: columCount + 1,
    columns: flattenColumnsWithScrollbar
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    stickyOffsets: headerStickyOffsets,
    columns: columnsWithScrollbar,
    flattenColumns: flattenColumnsWithScrollbar
  }))));
});
FixedHeader.displayName = 'FixedHeader';
/* harmony default export */ __webpack_exports__["a"] = (FixedHeader);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cell__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_fixUtil__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_valueUtil__ = __webpack_require__(208);







function HeaderRow(_ref) {
  var cells = _ref.cells,
      stickyOffsets = _ref.stickyOffsets,
      flattenColumns = _ref.flattenColumns,
      RowComponent = _ref.rowComponent,
      CellComponent = _ref.cellComponent,
      onHeaderRow = _ref.onHeaderRow,
      index = _ref.index;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      direction = _React$useContext.direction;

  var rowProps;

  if (onHeaderRow) {
    rowProps = onHeaderRow(cells.map(function (cell) {
      return cell.column;
    }), index);
  }

  var columnsKey = Object(__WEBPACK_IMPORTED_MODULE_5__utils_valueUtil__["a" /* getColumnsKey */])(cells.map(function (cell) {
    return cell.column;
  }));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RowComponent, rowProps, cells.map(function (cell, cellIndex) {
    var column = cell.column;
    var fixedInfo = Object(__WEBPACK_IMPORTED_MODULE_4__utils_fixUtil__["a" /* getCellFixedInfo */])(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
    var additionalProps;

    if (column && column.onHeaderCell) {
      additionalProps = cell.column.onHeaderCell(column);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Cell__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, cell, {
      ellipsis: column.ellipsis,
      align: column.align,
      component: CellComponent,
      prefixCls: prefixCls,
      key: columnsKey[cellIndex]
    }, fixedInfo, {
      additionalProps: additionalProps,
      rowType: "header"
    }));
  }));
}

HeaderRow.displayName = 'HeaderRow';
/* harmony default export */ __webpack_exports__["a"] = (HeaderRow);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BodyRow__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExpandedRow__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_BodyContext__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_valueUtil__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_ResizeContext__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MeasureCell__ = __webpack_require__(1161);









function Body(_ref) {
  var data = _ref.data,
      getRowKey = _ref.getRowKey,
      measureColumnWidth = _ref.measureColumnWidth,
      expandedKeys = _ref.expandedKeys,
      onRow = _ref.onRow,
      rowExpandable = _ref.rowExpandable,
      emptyNode = _ref.emptyNode,
      childrenColumnName = _ref.childrenColumnName;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__context_ResizeContext__["a" /* default */]),
      onColumnResize = _React$useContext.onColumnResize;

  var _React$useContext2 = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext2.prefixCls,
      getComponent = _React$useContext2.getComponent;

  var _React$useContext3 = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__context_BodyContext__["a" /* default */]),
      fixHeader = _React$useContext3.fixHeader,
      horizonScroll = _React$useContext3.horizonScroll,
      flattenColumns = _React$useContext3.flattenColumns,
      componentWidth = _React$useContext3.componentWidth;

  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    var WrapperComponent = getComponent(['body', 'wrapper'], 'tbody');
    var trComponent = getComponent(['body', 'row'], 'tr');
    var tdComponent = getComponent(['body', 'cell'], 'td');
    var rows;

    if (data.length) {
      rows = data.map(function (record, index) {
        var key = getRowKey(record, index);
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__BodyRow__["a" /* default */], {
          key: key,
          rowKey: key,
          record: record,
          recordKey: key,
          index: index,
          rowComponent: trComponent,
          cellComponent: tdComponent,
          expandedKeys: expandedKeys,
          onRow: onRow,
          getRowKey: getRowKey,
          rowExpandable: rowExpandable,
          childrenColumnName: childrenColumnName
        });
      });
    } else {
      rows = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ExpandedRow__["a" /* default */], {
        expanded: true,
        className: "".concat(prefixCls, "-placeholder"),
        prefixCls: prefixCls,
        fixHeader: fixHeader,
        fixColumn: horizonScroll,
        horizonScroll: horizonScroll,
        component: trComponent,
        componentWidth: componentWidth,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length
      }, emptyNode);
    }

    var columnsKey = Object(__WEBPACK_IMPORTED_MODULE_5__utils_valueUtil__["a" /* getColumnsKey */])(flattenColumns);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrapperComponent, {
      className: "".concat(prefixCls, "-tbody")
    }, measureColumnWidth && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", {
      "aria-hidden": "true",
      className: "".concat(prefixCls, "-measure-row"),
      style: {
        height: 0,
        fontSize: 0
      }
    }, columnsKey.map(function (columnKey) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__MeasureCell__["a" /* default */], {
        key: columnKey,
        columnKey: columnKey,
        onColumnResize: onColumnResize
      });
    })), rows);
  }, [data, prefixCls, onRow, measureColumnWidth, expandedKeys, getRowKey, getComponent, componentWidth, emptyNode, flattenColumns]);
}

var MemoBody = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["memo"](Body);
MemoBody.displayName = 'Body';
/* harmony default export */ __webpack_exports__["a"] = (MemoBody);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cell__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_BodyContext__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_valueUtil__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExpandedRow__ = __webpack_require__(580);











function BodyRow(props) {
  var className = props.className,
      style = props.style,
      record = props.record,
      index = props.index,
      rowKey = props.rowKey,
      getRowKey = props.getRowKey,
      rowExpandable = props.rowExpandable,
      expandedKeys = props.expandedKeys,
      onRow = props.onRow,
      _props$indent = props.indent,
      indent = _props$indent === void 0 ? 0 : _props$indent,
      RowComponent = props.rowComponent,
      cellComponent = props.cellComponent,
      childrenColumnName = props.childrenColumnName;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_3_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      fixedInfoList = _React$useContext.fixedInfoList;

  var _React$useContext2 = __WEBPACK_IMPORTED_MODULE_3_react__["useContext"](__WEBPACK_IMPORTED_MODULE_7__context_BodyContext__["a" /* default */]),
      fixHeader = _React$useContext2.fixHeader,
      fixColumn = _React$useContext2.fixColumn,
      horizonScroll = _React$useContext2.horizonScroll,
      componentWidth = _React$useContext2.componentWidth,
      flattenColumns = _React$useContext2.flattenColumns,
      expandableType = _React$useContext2.expandableType,
      expandRowByClick = _React$useContext2.expandRowByClick,
      onTriggerExpand = _React$useContext2.onTriggerExpand,
      rowClassName = _React$useContext2.rowClassName,
      expandedRowClassName = _React$useContext2.expandedRowClassName,
      indentSize = _React$useContext2.indentSize,
      expandIcon = _React$useContext2.expandIcon,
      expandedRowRender = _React$useContext2.expandedRowRender,
      expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      expandRended = _React$useState2[0],
      setExpandRended = _React$useState2[1];

  var expanded = expandedKeys && expandedKeys.has(props.recordKey);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (expanded) {
      setExpandRended(true);
    }
  }, [expanded]);
  var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record)); // Only when row is not expandable and `children` exist in record

  var nestExpandable = expandableType === 'nest';
  var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
  var mergedExpandable = rowSupportExpand || nestExpandable; // =========================== onRow ===========================

  var additionalProps;

  if (onRow) {
    additionalProps = onRow(record, index);
  }

  var onClick = function onClick(event) {
    if (expandRowByClick && mergedExpandable) {
      onTriggerExpand(record, event);
    }

    if (additionalProps && additionalProps.onClick) {
      var _additionalProps;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_additionalProps = additionalProps).onClick.apply(_additionalProps, [event].concat(args));
    }
  }; // ======================== Base tr row ========================


  var computeRowClassName;

  if (typeof rowClassName === 'string') {
    computeRowClassName = rowClassName;
  } else if (typeof rowClassName === 'function') {
    computeRowClassName = rowClassName(record, index, indent);
  }

  var columnsKey = Object(__WEBPACK_IMPORTED_MODULE_8__utils_valueUtil__["a" /* getColumnsKey */])(flattenColumns);
  var baseRowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](RowComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, additionalProps, {
    "data-row-key": rowKey,
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), additionalProps ? additionalProps.style : null),
    onClick: onClick
  }), flattenColumns.map(function (column, colIndex) {
    var render = column.render,
        dataIndex = column.dataIndex,
        columnClassName = column.className;
    var key = columnsKey[colIndex];
    var fixedInfo = fixedInfoList[colIndex]; // ============= Used for nest expandable =============

    var appendCellNode;

    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) {
      appendCellNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
      }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
      }));
    }

    var additionalCellProps;

    if (column.onCell) {
      additionalCellProps = column.onCell(record, index);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Cell__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: columnClassName,
      ellipsis: column.ellipsis,
      align: column.align,
      component: cellComponent,
      prefixCls: prefixCls,
      key: key,
      record: record,
      index: index,
      dataIndex: dataIndex,
      render: render,
      shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
      appendNode: appendCellNode,
      additionalProps: additionalCellProps
    }));
  })); // ======================== Expand Row =========================

  var expandRowNode;

  if (rowSupportExpand && (expandRended || expanded)) {
    var expandContent = expandedRowRender(record, index, indent + 1, expanded);
    var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
    expandRowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ExpandedRow__["a" /* default */], {
      expanded: expanded,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
      prefixCls: prefixCls,
      fixHeader: fixHeader,
      fixColumn: fixColumn,
      horizonScroll: horizonScroll,
      component: RowComponent,
      componentWidth: componentWidth,
      cellComponent: cellComponent,
      colSpan: flattenColumns.length
    }, expandContent);
  } // ========================= Nest Row ==========================


  var nestRowNode;

  if (hasNestChildren && expanded) {
    nestRowNode = (record[childrenColumnName] || []).map(function (subRecord, subIndex) {
      var subKey = getRowKey(subRecord, subIndex);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](BodyRow, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        key: subKey,
        rowKey: subKey,
        record: subRecord,
        recordKey: subKey,
        index: subIndex,
        indent: indent + 1
      }));
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, baseRowNode, expandRowNode, nestRowNode);
}

BodyRow.displayName = 'BodyRow';
/* harmony default export */ __webpack_exports__["a"] = (BodyRow);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MeasureCell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_resize_observer__ = __webpack_require__(97);


function MeasureCell(_ref) {
  var columnKey = _ref.columnKey,
      onColumnResize = _ref.onColumnResize;
  var cellRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (cellRef.current) {
      onColumnResize(columnKey, cellRef.current.offsetWidth);
    }
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_rc_resize_observer__["default"], {
    onResize: function onResize(_ref2) {
      var offsetWidth = _ref2.offsetWidth;
      onColumnResize(columnKey, offsetWidth);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", {
    ref: cellRef,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: {
      height: 0,
      overflow: 'hidden'
    }
  }, "\xA0")));
}

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertChildrenToColumns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_legacyUtil__ = __webpack_require__(272);








function convertChildrenToColumns(children) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_Children_toArray__["a" /* default */])(children).filter(function (node) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"](node);
  }).map(function (_ref) {
    var key = _ref.key,
        props = _ref.props;

    var nodeChildren = props.children,
        restProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children"]);

    var column = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      key: key
    }, restProps);

    if (nodeChildren) {
      column.children = convertChildrenToColumns(nodeChildren);
    }

    return column;
  });
}

function flatColumns(columns) {
  return columns.reduce(function (list, column) {
    var fixed = column.fixed; // Convert `fixed='true'` to `fixed='left'` instead

    var parsedFixed = fixed === true ? 'left' : fixed;
    var subColumns = column.children;

    if (subColumns && subColumns.length > 0) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(list), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(flatColumns(subColumns).map(function (subColum) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          fixed: parsedFixed
        }, subColum);
      })));
    }

    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(list), [Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, column), {}, {
      fixed: parsedFixed
    })]);
  }, []);
}

function warningFixed(flattenColumns) {
  var allFixLeft = true;

  for (var i = 0; i < flattenColumns.length; i += 1) {
    var col = flattenColumns[i];

    if (allFixLeft && col.fixed !== 'left') {
      allFixLeft = false;
    } else if (!allFixLeft && col.fixed === 'left') {
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__["a" /* default */])(false, "Index ".concat(i - 1, " of `columns` missing `fixed='left'` prop."));
      break;
    }
  }

  var allFixRight = true;

  for (var _i = flattenColumns.length - 1; _i >= 0; _i -= 1) {
    var _col = flattenColumns[_i];

    if (allFixRight && _col.fixed !== 'right') {
      allFixRight = false;
    } else if (!allFixRight && _col.fixed === 'right') {
      Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_warning__["a" /* default */])(false, "Index ".concat(_i + 1, " of `columns` missing `fixed='right'` prop."));
      break;
    }
  }
}

function revertForRtl(columns) {
  return columns.map(function (column) {
    var fixed = column.fixed,
        restProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(column, ["fixed"]); // Convert `fixed='left'` to `fixed='right'` instead


    var parsedFixed = fixed;

    if (fixed === 'left') {
      parsedFixed = 'right';
    } else if (fixed === 'right') {
      parsedFixed = 'left';
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      fixed: parsedFixed
    }, restProps);
  });
}
/**
 * Parse `columns` & `children` into `columns`.
 */


function useColumns(_ref2, transformColumns) {
  var prefixCls = _ref2.prefixCls,
      columns = _ref2.columns,
      children = _ref2.children,
      expandable = _ref2.expandable,
      expandedKeys = _ref2.expandedKeys,
      getRowKey = _ref2.getRowKey,
      onTriggerExpand = _ref2.onTriggerExpand,
      expandIcon = _ref2.expandIcon,
      rowExpandable = _ref2.rowExpandable,
      expandIconColumnIndex = _ref2.expandIconColumnIndex,
      direction = _ref2.direction,
      expandRowByClick = _ref2.expandRowByClick,
      columnWidth = _ref2.columnWidth;
  var baseColumns = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return columns || convertChildrenToColumns(children);
  }, [columns, children]); // Add expand column

  var withExpandColumns = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    if (expandable) {
      var _expandColumn;

      var expandColIndex = expandIconColumnIndex || 0;
      var prevColumn = baseColumns[expandColIndex];
      var expandColumn = (_expandColumn = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, __WEBPACK_IMPORTED_MODULE_7__utils_legacyUtil__["a" /* INTERNAL_COL_DEFINE */], {
        className: "".concat(prefixCls, "-expand-icon-col")
      }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, "title", ''), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, "fixed", prevColumn ? prevColumn.fixed : null), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, "width", columnWidth), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_expandColumn, "render", function render(_, record, index) {
        var rowKey = getRowKey(record, index);
        var expanded = expandedKeys.has(rowKey);
        var recordExpandable = rowExpandable ? rowExpandable(record) : true;
        var icon = expandIcon({
          prefixCls: prefixCls,
          expanded: expanded,
          expandable: recordExpandable,
          record: record,
          onExpand: onTriggerExpand
        });

        if (expandRowByClick) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, icon);
        }

        return icon;
      }), _expandColumn); // Insert expand column in the target position

      var cloneColumns = baseColumns.slice();

      if (expandColIndex >= 0) {
        cloneColumns.splice(expandColIndex, 0, expandColumn);
      }

      return cloneColumns;
    }

    return baseColumns;
  }, [expandable, baseColumns, getRowKey, expandedKeys, expandIcon, direction]);
  var mergedColumns = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    var finalColumns = withExpandColumns;

    if (transformColumns) {
      finalColumns = transformColumns(finalColumns);
    } // Always provides at least one column for table display


    if (!finalColumns.length) {
      finalColumns = [{
        render: function render() {
          return null;
        }
      }];
    }

    return finalColumns;
  }, [transformColumns, withExpandColumns, direction]);
  var flattenColumns = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    if (direction === 'rtl') {
      return revertForRtl(flatColumns(mergedColumns));
    }

    return flatColumns(mergedColumns);
  }, [mergedColumns, direction]); // Only check out of production since it's waste for each render

  if (false) {
    warningFixed(flattenColumns);
  }

  return [mergedColumns, flattenColumns];
}

/* harmony default export */ __webpack_exports__["a"] = (useColumns);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Get sticky column offset width
 */

function useStickyOffsets(colWidths, columnCount, direction) {
  var stickyOffsets = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var leftOffsets = [];
    var rightOffsets = [];
    var left = 0;
    var right = 0;

    for (var start = 0; start < columnCount; start += 1) {
      if (direction === 'rtl') {
        // Left offset
        rightOffsets[start] = right;
        right += colWidths[start] || 0; // Right offset

        var end = columnCount - start - 1;
        leftOffsets[end] = left;
        left += colWidths[end] || 0;
      } else {
        // Left offset
        leftOffsets[start] = left;
        left += colWidths[start] || 0; // Right offset

        var _end = columnCount - start - 1;

        rightOffsets[_end] = right;
        right += colWidths[_end] || 0;
      }
    }

    return {
      left: leftOffsets,
      right: rightOffsets
    };
  }, [colWidths, columnCount, direction]);
  return stickyOffsets;
}

/* harmony default export */ __webpack_exports__["a"] = (useStickyOffsets);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: className
  }, children);
}

/* harmony default export */ __webpack_exports__["a"] = (Panel);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SummaryCell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cell__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_TableContext__ = __webpack_require__(107);




function SummaryCell(_ref) {
  var className = _ref.className,
      index = _ref.index,
      children = _ref.children,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan,
      align = _ref.align;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      fixedInfoList = _React$useContext.fixedInfoList;

  var fixedInfo = fixedInfoList[index];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Cell__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: className,
    index: index,
    component: "td",
    prefixCls: prefixCls,
    record: null,
    dataIndex: null,
    align: align,
    render: function render() {
      return {
        children: children,
        props: {
          colSpan: colSpan,
          rowSpan: rowSpan
        }
      };
    }
  }, fixedInfo));
}

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FooterRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function FooterRow(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", props);
}

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = renderExpandIcon;
/* harmony export (immutable) */ __webpack_exports__["a"] = findAllChildrenKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



function renderExpandIcon(_ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      record = _ref.record,
      onExpand = _ref.onExpand,
      expanded = _ref.expanded,
      expandable = _ref.expandable;
  var expandClassName = "".concat(prefixCls, "-row-expand-icon");

  if (!expandable) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
  }

  var onClick = function onClick(event) {
    onExpand(record, event);
    event.stopPropagation();
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(expandClassName, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
    onClick: onClick
  });
}
function findAllChildrenKeys(data, getRowKey, childrenColumnName) {
  var keys = [];

  function dig(list) {
    (list || []).forEach(function (item, index) {
      keys.push(getRowKey(item, index));
      dig(item[childrenColumnName]);
    });
  }

  dig(data);
  return keys;
}

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_getScrollBarSize__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_css__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_TableContext__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useFrame__ = __webpack_require__(582);











var StickyScrollBar = function StickyScrollBar(_ref, ref) {
  var _scrollBodyRef$curren, _scrollBodyRef$curren2;

  var scrollBodyRef = _ref.scrollBodyRef,
      onScroll = _ref.onScroll,
      offsetScroll = _ref.offsetScroll,
      container = _ref.container;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_3_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__context_TableContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls;

  var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
  var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
  var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
  var scrollBarRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var _useLayoutState = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useFrame__["a" /* useLayoutState */])({
    scrollLeft: 0,
    isHiddenScrollBar: false
  }),
      _useLayoutState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useLayoutState, 2),
      scrollState = _useLayoutState2[0],
      setScrollState = _useLayoutState2[1];

  var refState = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]({
    delta: 0,
    x: 0
  });

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      isActive = _React$useState2[0],
      setActive = _React$useState2[1];

  var onMouseUp = function onMouseUp() {
    setActive(false);
  };

  var onMouseDown = function onMouseDown(event) {
    event.persist();
    refState.current.delta = event.pageX - scrollState.scrollLeft;
    refState.current.x = 0;
    setActive(true);
    event.preventDefault();
  };

  var onMouseMove = function onMouseMove(event) {
    var _window;

    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
    var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event),
        buttons = _ref2.buttons;

    if (!isActive || buttons === 0) {
      // If out body mouse up, we can set isActive false when mouse move
      if (isActive) {
        setActive(false);
      }

      return;
    }

    var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;

    if (left <= 0) {
      left = 0;
    }

    if (left + scrollBarWidth >= bodyWidth) {
      left = bodyWidth - scrollBarWidth;
    }

    onScroll({
      scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
    });
    refState.current.x = event.pageX;
  };

  var onContainerScroll = function onContainerScroll() {
    var tableOffsetTop = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_css__["a" /* getOffset */])(scrollBodyRef.current).top;
    var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
    var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_css__["a" /* getOffset */])(container).top + container.clientHeight;

    if (tableBottomOffset - Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_getScrollBarSize__["a" /* default */])() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) {
      setScrollState(function (state) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
          isHiddenScrollBar: true
        });
      });
    } else {
      setScrollState(function (state) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
          isHiddenScrollBar: false
        });
      });
    }
  };

  var setScrollLeft = function setScrollLeft(left) {
    setScrollState(function (state) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
        scrollLeft: left / bodyScrollWidth * bodyWidth || 0
      });
    });
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      setScrollLeft: setScrollLeft
    };
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__["a" /* default */])(document.body, 'mouseup', onMouseUp, false);
    var onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__["a" /* default */])(document.body, 'mousemove', onMouseMove, false);
    onContainerScroll();
    return function () {
      onMouseUpListener.remove();
      onMouseMoveListener.remove();
    };
  }, [scrollBarWidth, isActive]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var onScrollListener = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__["a" /* default */])(container, 'scroll', onContainerScroll, false);
    var onResizeListener = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', onContainerScroll, false);
    return function () {
      onScrollListener.remove();
      onResizeListener.remove();
    };
  }, [container]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!scrollState.isHiddenScrollBar) {
      setScrollState(function (state) {
        var _scrollBodyRef$curren3, _scrollBodyRef$curren4;

        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
          scrollLeft: scrollBodyRef.current.scrollLeft / ((_scrollBodyRef$curren3 = scrollBodyRef.current) === null || _scrollBodyRef$curren3 === void 0 ? void 0 : _scrollBodyRef$curren3.scrollWidth) * ((_scrollBodyRef$curren4 = scrollBodyRef.current) === null || _scrollBodyRef$curren4 === void 0 ? void 0 : _scrollBodyRef$curren4.clientWidth)
        });
      });
    }
  }, [scrollState.isHiddenScrollBar]);

  if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    style: {
      height: Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_getScrollBarSize__["a" /* default */])(),
      width: bodyWidth,
      bottom: offsetScroll
    },
    className: "".concat(prefixCls, "-sticky-scroll")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    onMouseDown: onMouseDown,
    ref: scrollBarRef,
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-sticky-scroll-bar"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
    style: {
      width: "".concat(scrollBarWidth, "px"),
      transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
    }
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](StickyScrollBar));

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export get */
/* unused harmony export set */
/* unused harmony export getOuterWidth */
/* unused harmony export getOuterHeight */
/* unused harmony export getDocSize */
/* unused harmony export getClientSize */
/* unused harmony export getScroll */
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffset;
/* eslint-disable no-nested-ternary */
var PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var removePixel = {
  left: true,
  top: true
};
var floatMap = {
  cssFloat: 1,
  styleFloat: 1,
  float: 1
};
function getComputedStyle(node) {
  return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function getStyleValue(node, type, value) {
  type = type.toLowerCase();
  if (value === 'auto') {
    if (type === 'height') {
      return node.offsetHeight;
    }
    if (type === 'width') {
      return node.offsetWidth;
    }
  }
  if (!(type in removePixel)) {
    removePixel[type] = PIXEL_PATTERN.test(type);
  }
  return removePixel[type] ? parseFloat(value) || 0 : value;
}
function get(node, name) {
  var length = arguments.length;
  var style = getComputedStyle(node);
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  return length === 1 ? style : getStyleValue(node, name, style[name] || node.style[name]);
}
function set(node, name, value) {
  var length = arguments.length;
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  if (length === 3) {
    if (typeof value === 'number' && PIXEL_PATTERN.test(name)) {
      value = "".concat(value, "px");
    }
    node.style[name] = value; // Number
    return value;
  }
  for (var x in name) {
    if (name.hasOwnProperty(x)) {
      set(node, x, name[x]);
    }
  }
  return getComputedStyle(node);
}
function getOuterWidth(el) {
  if (el === document.body) {
    return document.documentElement.clientWidth;
  }
  return el.offsetWidth;
}
function getOuterHeight(el) {
  if (el === document.body) {
    return window.innerHeight || document.documentElement.clientHeight;
  }
  return el.offsetHeight;
}
function getDocSize() {
  var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
  var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
  return {
    width: width,
    height: height
  };
}
function getClientSize() {
  var width = document.documentElement.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: width,
    height: height
  };
}
function getScroll() {
  return {
    scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
    scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
  };
}
function getOffset(node) {
  var box = node.getBoundingClientRect();
  var docElem = document.documentElement;

  // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
  return {
    left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSticky;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_canUseDom__ = __webpack_require__(161);


 // fix ssr render

var defaultContainer = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_canUseDom__["a" /* default */])() ? window : null;
/** Sticky header hooks */

function useSticky(sticky, prefixCls) {
  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(sticky) === 'object' ? sticky : {},
      _ref$offsetHeader = _ref.offsetHeader,
      offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader,
      _ref$offsetScroll = _ref.offsetScroll,
      offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? function () {
    return defaultContainer;
  } : _ref$getContainer;

  var container = getContainer() || defaultContainer;
  return __WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function () {
    var isSticky = !!sticky;
    return {
      isSticky: isSticky,
      stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-header") : '',
      offsetHeader: offsetHeader,
      offsetScroll: offsetScroll,
      container: container
    };
  }, [offsetScroll, offsetHeader, prefixCls, container]);
}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INTERNAL_HOOKS = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(366));

var _typeof2 = _interopRequireDefault(__webpack_require__(142));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(273));

var React = _interopRequireWildcard(__webpack_require__(0));

var _isVisible = _interopRequireDefault(__webpack_require__(1180));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _shallowequal = _interopRequireDefault(__webpack_require__(96));

var _warning = _interopRequireDefault(__webpack_require__(106));

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(97));

var _getScrollBarSize = _interopRequireDefault(__webpack_require__(367));

var _ColumnGroup = _interopRequireDefault(__webpack_require__(1181));

var _Column = _interopRequireDefault(__webpack_require__(1182));

var _FixedHeader = _interopRequireDefault(__webpack_require__(1183));

var _Header = _interopRequireDefault(__webpack_require__(588));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _BodyContext = _interopRequireDefault(__webpack_require__(369));

var _Body = _interopRequireDefault(__webpack_require__(1186));

var _useColumns3 = _interopRequireDefault(__webpack_require__(593));

var _useFrame = __webpack_require__(594);

var _valueUtil = __webpack_require__(210);

var _ResizeContext = _interopRequireDefault(__webpack_require__(592));

var _useStickyOffsets = _interopRequireDefault(__webpack_require__(1189));

var _ColGroup = _interopRequireDefault(__webpack_require__(590));

var _legacyUtil = __webpack_require__(368);

var _Panel = _interopRequireDefault(__webpack_require__(1190));

var _Footer = _interopRequireWildcard(__webpack_require__(1191));

var _expandUtil = __webpack_require__(1194);

var _fixUtil = __webpack_require__(589);

var _stickyScrollBar = _interopRequireDefault(__webpack_require__(1195));

var _useSticky2 = _interopRequireDefault(__webpack_require__(1197));

/**
 * Feature:
 *  - fixed not need to set width
 *  - support `rowExpandable` to config row expand logic
 *  - add `summary` to support `() => ReactNode`
 *
 * Update:
 *  - `dataIndex` is `array[]` now
 *  - `expandable` wrap all the expand related props
 *
 * Removed:
 *  - expandIconAsCell
 *  - useFixedHeader
 *  - rowRef
 *  - columns[number].onCellClick
 *  - onRowClick
 *  - onRowDoubleClick
 *  - onRowMouseEnter
 *  - onRowMouseLeave
 *  - getBodyWrapper
 *  - bodyStyle
 *
 * Deprecated:
 *  - All expanded props, move into expandable
 */
// Used for conditions cache
var EMPTY_DATA = []; // Used for customize scroll

var EMPTY_SCROLL_TARGET = {};
var INTERNAL_HOOKS = 'rc-table-internal-hook';
exports.INTERNAL_HOOKS = INTERNAL_HOOKS;
var MemoTableContent = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (prev, next) {
  if (!(0, _shallowequal.default)(prev.props, next.props)) {
    return false;
  } // No additional render when pinged status change.
  // This is not a bug.


  return prev.pingLeft !== next.pingLeft || prev.pingRight !== next.pingRight;
});

function Table(props) {
  var _classNames;

  var prefixCls = props.prefixCls,
      className = props.className,
      rowClassName = props.rowClassName,
      style = props.style,
      data = props.data,
      rowKey = props.rowKey,
      scroll = props.scroll,
      tableLayout = props.tableLayout,
      direction = props.direction,
      title = props.title,
      footer = props.footer,
      summary = props.summary,
      id = props.id,
      showHeader = props.showHeader,
      components = props.components,
      emptyText = props.emptyText,
      onRow = props.onRow,
      onHeaderRow = props.onHeaderRow,
      internalHooks = props.internalHooks,
      transformColumns = props.transformColumns,
      internalRefs = props.internalRefs,
      sticky = props.sticky;
  var mergedData = data || EMPTY_DATA;
  var hasData = !!mergedData.length; // ===================== Effects ======================

  var _React$useState = React.useState(0),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      scrollbarSize = _React$useState2[0],
      setScrollbarSize = _React$useState2[1];

  React.useEffect(function () {
    setScrollbarSize((0, _getScrollBarSize.default)());
  }); // ===================== Warning ======================

  if (false) {
    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      (0, _warning.default)(props[name] === undefined, "`".concat(name, "` is removed, please use `onRow` instead."));
    });
    (0, _warning.default)(!('getBodyWrapper' in props), '`getBodyWrapper` is deprecated, please use custom `components` instead.');
  } // ==================== Customize =====================


  var mergedComponents = React.useMemo(function () {
    return (0, _valueUtil.mergeObject)(components, {});
  }, [components]);
  var getComponent = React.useCallback(function (path, defaultComponent) {
    return (0, _valueUtil.getPathValue)(mergedComponents, path) || defaultComponent;
  }, [mergedComponents]);
  var getRowKey = React.useMemo(function () {
    if (typeof rowKey === 'function') {
      return rowKey;
    }

    return function (record) {
      var key = record && record[rowKey];

      if (false) {
        (0, _warning.default)(key !== undefined, 'Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key.');
      }

      return key;
    };
  }, [rowKey]); // ====================== Expand ======================

  var expandableConfig = (0, _legacyUtil.getExpandableProps)(props);
  var expandIcon = expandableConfig.expandIcon,
      expandedRowKeys = expandableConfig.expandedRowKeys,
      defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys,
      defaultExpandAllRows = expandableConfig.defaultExpandAllRows,
      expandedRowRender = expandableConfig.expandedRowRender,
      onExpand = expandableConfig.onExpand,
      onExpandedRowsChange = expandableConfig.onExpandedRowsChange,
      expandRowByClick = expandableConfig.expandRowByClick,
      rowExpandable = expandableConfig.rowExpandable,
      expandIconColumnIndex = expandableConfig.expandIconColumnIndex,
      expandedRowClassName = expandableConfig.expandedRowClassName,
      childrenColumnName = expandableConfig.childrenColumnName,
      indentSize = expandableConfig.indentSize;
  var mergedExpandIcon = expandIcon || _expandUtil.renderExpandIcon;
  var mergedChildrenColumnName = childrenColumnName || 'children';
  var expandableType = React.useMemo(function () {
    if (expandedRowRender) {
      return 'row';
    }
    /* eslint-disable no-underscore-dangle */

    /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */


    if (props.expandable && internalHooks === INTERNAL_HOOKS && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function (record) {
      return record && (0, _typeof2.default)(record) === 'object' && record[mergedChildrenColumnName];
    })) {
      return 'nest';
    }
    /* eslint-enable */


    return false;
  }, [!!expandedRowRender, mergedData]);

  var _React$useState3 = React.useState(function () {
    if (defaultExpandedRowKeys) {
      return defaultExpandedRowKeys;
    }

    if (defaultExpandAllRows) {
      return (0, _expandUtil.findAllChildrenKeys)(mergedData, getRowKey, mergedChildrenColumnName);
    }

    return [];
  }),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      innerExpandedKeys = _React$useState4[0],
      setInnerExpandedKeys = _React$useState4[1];

  var mergedExpandedKeys = React.useMemo(function () {
    return new Set(expandedRowKeys || innerExpandedKeys || []);
  }, [expandedRowKeys, innerExpandedKeys]);
  var onTriggerExpand = React.useCallback(function (record) {
    var key = getRowKey(record, mergedData.indexOf(record));
    var newExpandedKeys;
    var hasKey = mergedExpandedKeys.has(key);

    if (hasKey) {
      mergedExpandedKeys.delete(key);
      newExpandedKeys = (0, _toConsumableArray2.default)(mergedExpandedKeys);
    } else {
      newExpandedKeys = [].concat((0, _toConsumableArray2.default)(mergedExpandedKeys), [key]);
    }

    setInnerExpandedKeys(newExpandedKeys);

    if (onExpand) {
      onExpand(!hasKey, record);
    }

    if (onExpandedRowsChange) {
      onExpandedRowsChange(newExpandedKeys);
    }
  }, [getRowKey, mergedExpandedKeys, mergedData, onExpand, onExpandedRowsChange]); // ====================== Column ======================

  var _React$useState5 = React.useState(0),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      componentWidth = _React$useState6[0],
      setComponentWidth = _React$useState6[1];

  var _useColumns = (0, _useColumns3.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), expandableConfig), {}, {
    expandable: !!expandedRowRender,
    expandedKeys: mergedExpandedKeys,
    getRowKey: getRowKey,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: onTriggerExpand,
    expandIcon: mergedExpandIcon,
    expandIconColumnIndex: expandIconColumnIndex,
    direction: direction
  }), internalHooks === INTERNAL_HOOKS ? transformColumns : null),
      _useColumns2 = (0, _slicedToArray2.default)(_useColumns, 2),
      columns = _useColumns2[0],
      flattenColumns = _useColumns2[1];

  var columnContext = React.useMemo(function () {
    return {
      columns: columns,
      flattenColumns: flattenColumns
    };
  }, [columns, flattenColumns]); // ====================== Scroll ======================

  var fullTableRef = React.useRef();
  var scrollHeaderRef = React.useRef();
  var scrollBodyRef = React.useRef();

  var _React$useState7 = React.useState(false),
      _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
      pingedLeft = _React$useState8[0],
      setPingedLeft = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
      pingedRight = _React$useState10[0],
      setPingedRight = _React$useState10[1];

  var _useLayoutState = (0, _useFrame.useLayoutState)(new Map()),
      _useLayoutState2 = (0, _slicedToArray2.default)(_useLayoutState, 2),
      colsWidths = _useLayoutState2[0],
      updateColsWidths = _useLayoutState2[1]; // Convert map to number width


  var colsKeys = (0, _valueUtil.getColumnsKey)(flattenColumns);
  var pureColWidths = colsKeys.map(function (columnKey) {
    return colsWidths.get(columnKey);
  });
  var colWidths = React.useMemo(function () {
    return pureColWidths;
  }, [pureColWidths.join('_')]);
  var stickyOffsets = (0, _useStickyOffsets.default)(colWidths, flattenColumns.length, direction);
  var fixHeader = scroll && (0, _valueUtil.validateValue)(scroll.y);
  var horizonScroll = scroll && (0, _valueUtil.validateValue)(scroll.x);
  var fixColumn = horizonScroll && flattenColumns.some(function (_ref2) {
    var fixed = _ref2.fixed;
    return fixed;
  }); // Sticky

  var stickyRef = React.useRef();

  var _useSticky = (0, _useSticky2.default)(sticky, prefixCls),
      isSticky = _useSticky.isSticky,
      offsetHeader = _useSticky.offsetHeader,
      offsetScroll = _useSticky.offsetScroll,
      stickyClassName = _useSticky.stickyClassName,
      container = _useSticky.container;

  var scrollXStyle;
  var scrollYStyle;
  var scrollTableStyle;

  if (fixHeader) {
    scrollYStyle = {
      overflowY: 'scroll',
      maxHeight: scroll.y
    };
  }

  if (horizonScroll) {
    scrollXStyle = {
      overflowX: 'auto'
    }; // When no vertical scrollbar, should hide it
    // https://github.com/ant-design/ant-design/pull/20705
    // https://github.com/ant-design/ant-design/issues/21879

    if (!fixHeader) {
      scrollYStyle = {
        overflowY: 'hidden'
      };
    }

    scrollTableStyle = {
      width: scroll.x === true ? 'auto' : scroll.x,
      minWidth: '100%'
    };
  }

  var onColumnResize = React.useCallback(function (columnKey, width) {
    if ((0, _isVisible.default)(fullTableRef.current)) {
      updateColsWidths(function (widths) {
        if (widths.get(columnKey) !== width) {
          var newWidths = new Map(widths);
          newWidths.set(columnKey, width);
          return newWidths;
        }

        return widths;
      });
    }
  }, []);

  var _useTimeoutLock = (0, _useFrame.useTimeoutLock)(null),
      _useTimeoutLock2 = (0, _slicedToArray2.default)(_useTimeoutLock, 2),
      setScrollTarget = _useTimeoutLock2[0],
      getScrollTarget = _useTimeoutLock2[1];

  function forceScroll(scrollLeft, target) {
    if (!target) {
      return;
    }

    if (typeof target === 'function') {
      target(scrollLeft);
    } else if (target.scrollLeft !== scrollLeft) {
      // eslint-disable-next-line no-param-reassign
      target.scrollLeft = scrollLeft;
    }
  }

  var onScroll = function onScroll(_ref3) {
    var currentTarget = _ref3.currentTarget,
        scrollLeft = _ref3.scrollLeft;
    var isRTL = direction === 'rtl';
    var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
    var compareTarget = currentTarget || EMPTY_SCROLL_TARGET;

    if (!getScrollTarget() || getScrollTarget() === compareTarget) {
      var _stickyRef$current;

      setScrollTarget(compareTarget);
      forceScroll(mergedScrollLeft, scrollHeaderRef.current);
      forceScroll(mergedScrollLeft, scrollBodyRef.current);
      forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
    }

    if (currentTarget) {
      var scrollWidth = currentTarget.scrollWidth,
          clientWidth = currentTarget.clientWidth;

      if (isRTL) {
        setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
        setPingedRight(-mergedScrollLeft > 0);
      } else {
        setPingedLeft(mergedScrollLeft > 0);
        setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
      }
    }
  };

  var triggerOnScroll = function triggerOnScroll() {
    if (scrollBodyRef.current) {
      onScroll({
        currentTarget: scrollBodyRef.current
      });
    }
  };

  var onFullTableResize = function onFullTableResize(_ref4) {
    var width = _ref4.width;
    triggerOnScroll();
    setComponentWidth(fullTableRef.current ? fullTableRef.current.offsetWidth : width);
  }; // Sync scroll bar when init or `horizonScroll` changed


  React.useEffect(function () {
    return triggerOnScroll;
  }, []);
  React.useEffect(function () {
    if (horizonScroll) {
      triggerOnScroll();
    }
  }, [horizonScroll]); // ================== INTERNAL HOOKS ==================

  React.useEffect(function () {
    if (internalHooks === INTERNAL_HOOKS && internalRefs) {
      internalRefs.body.current = scrollBodyRef.current;
    }
  }); // ====================== Render ======================

  var TableComponent = getComponent(['table'], 'table'); // Table layout

  var mergedTableLayout = React.useMemo(function () {
    if (tableLayout) {
      return tableLayout;
    } // https://github.com/ant-design/ant-design/issues/25227
    // When scroll.x is max-content, no need to fix table layout
    // it's width should stretch out to fit content


    if (fixColumn) {
      return scroll.x === 'max-content' ? 'auto' : 'fixed';
    }

    if (fixHeader || isSticky || flattenColumns.some(function (_ref5) {
      var ellipsis = _ref5.ellipsis;
      return ellipsis;
    })) {
      return 'fixed';
    }

    return 'auto';
  }, [fixHeader, fixColumn, flattenColumns, tableLayout, isSticky]);
  var groupTableNode; // Header props

  var headerProps = {
    colWidths: colWidths,
    columCount: flattenColumns.length,
    stickyOffsets: stickyOffsets,
    onHeaderRow: onHeaderRow,
    fixHeader: fixHeader
  }; // Empty

  var emptyNode = React.useMemo(function () {
    if (hasData) {
      return null;
    }

    if (typeof emptyText === 'function') {
      return emptyText();
    }

    return emptyText;
  }, [hasData, emptyText]); // Body

  var bodyTable = /*#__PURE__*/React.createElement(_Body.default, {
    data: mergedData,
    measureColumnWidth: fixHeader || horizonScroll || isSticky,
    expandedKeys: mergedExpandedKeys,
    rowExpandable: rowExpandable,
    getRowKey: getRowKey,
    onRow: onRow,
    emptyNode: emptyNode,
    childrenColumnName: mergedChildrenColumnName
  });
  var bodyColGroup = /*#__PURE__*/React.createElement(_ColGroup.default, {
    colWidths: flattenColumns.map(function (_ref6) {
      var width = _ref6.width;
      return width;
    }),
    columns: flattenColumns
  });
  var footerTable = summary && /*#__PURE__*/React.createElement(_Footer.default, null, summary(mergedData));
  var customizeScrollBody = getComponent(['body']);

  if (false) {
    (0, _warning.default)(false, '`components.body` with render props is only work on `scroll.y`.');
  }

  if (fixHeader || isSticky) {
    var bodyContent;

    if (typeof customizeScrollBody === 'function') {
      bodyContent = customizeScrollBody(mergedData, {
        scrollbarSize: scrollbarSize,
        ref: scrollBodyRef,
        onScroll: onScroll
      });
      headerProps.colWidths = flattenColumns.map(function (_ref7, index) {
        var width = _ref7.width;
        var colWidth = index === columns.length - 1 ? width - scrollbarSize : width;

        if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) {
          return colWidth;
        }

        (0, _warning.default)(false, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
        return 0;
      });
    } else {
      bodyContent = /*#__PURE__*/React.createElement("div", {
        style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, scrollXStyle), scrollYStyle),
        onScroll: onScroll,
        ref: scrollBodyRef,
        className: (0, _classnames.default)("".concat(prefixCls, "-body"))
      }, /*#__PURE__*/React.createElement(TableComponent, {
        style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, scrollTableStyle), {}, {
          tableLayout: mergedTableLayout
        })
      }, bodyColGroup, bodyTable, footerTable));
    }

    groupTableNode = /*#__PURE__*/React.createElement(React.Fragment, null, showHeader !== false && /*#__PURE__*/React.createElement(_FixedHeader.default, (0, _extends2.default)({
      noData: !mergedData.length
    }, headerProps, columnContext, {
      direction: direction // Fixed Props
      ,
      offsetHeader: offsetHeader,
      stickyClassName: stickyClassName,
      ref: scrollHeaderRef,
      onScroll: onScroll
    })), bodyContent, isSticky && /*#__PURE__*/React.createElement(_stickyScrollBar.default, {
      ref: stickyRef,
      offsetScroll: offsetScroll,
      scrollBodyRef: scrollBodyRef,
      onScroll: onScroll,
      container: container
    }));
  } else {
    groupTableNode = /*#__PURE__*/React.createElement("div", {
      style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, scrollXStyle), scrollYStyle),
      className: (0, _classnames.default)("".concat(prefixCls, "-content")),
      onScroll: onScroll,
      ref: scrollBodyRef
    }, /*#__PURE__*/React.createElement(TableComponent, {
      style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, scrollTableStyle), {}, {
        tableLayout: mergedTableLayout
      })
    }, bodyColGroup, showHeader !== false && /*#__PURE__*/React.createElement(_Header.default, (0, _extends2.default)({}, headerProps, columnContext)), bodyTable, footerTable));
  }

  var ariaProps = (0, _legacyUtil.getDataAndAriaProps)(props);
  var fullTable = /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(prefixCls, className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right'), _classNames)),
    style: style,
    id: id,
    ref: fullTableRef
  }, ariaProps), /*#__PURE__*/React.createElement(MemoTableContent, {
    pingLeft: pingedLeft,
    pingRight: pingedRight,
    props: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
      stickyOffsets: stickyOffsets,
      mergedExpandedKeys: mergedExpandedKeys
    })
  }, title && /*#__PURE__*/React.createElement(_Panel.default, {
    className: "".concat(prefixCls, "-title")
  }, title(mergedData)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, groupTableNode), footer && /*#__PURE__*/React.createElement(_Panel.default, {
    className: "".concat(prefixCls, "-footer")
  }, footer(mergedData))));

  if (horizonScroll) {
    fullTable = /*#__PURE__*/React.createElement(_rcResizeObserver.default, {
      onResize: onFullTableResize
    }, fullTable);
  }

  var TableContextValue = React.useMemo(function () {
    return {
      prefixCls: prefixCls,
      getComponent: getComponent,
      scrollbarSize: scrollbarSize,
      direction: direction,
      fixedInfoList: flattenColumns.map(function (_, colIndex) {
        return (0, _fixUtil.getCellFixedInfo)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
      }),
      isSticky: isSticky
    };
  }, [prefixCls, getComponent, scrollbarSize, direction, flattenColumns, stickyOffsets, direction, isSticky]);
  var BodyContextValue = React.useMemo(function () {
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, columnContext), {}, {
      tableLayout: mergedTableLayout,
      rowClassName: rowClassName,
      expandedRowClassName: expandedRowClassName,
      componentWidth: componentWidth,
      fixHeader: fixHeader,
      fixColumn: fixColumn,
      horizonScroll: horizonScroll,
      expandIcon: mergedExpandIcon,
      expandableType: expandableType,
      expandRowByClick: expandRowByClick,
      expandedRowRender: expandedRowRender,
      onTriggerExpand: onTriggerExpand,
      expandIconColumnIndex: expandIconColumnIndex,
      indentSize: indentSize
    });
  }, [columnContext, mergedTableLayout, rowClassName, expandedRowClassName, componentWidth, fixHeader, fixColumn, horizonScroll, mergedExpandIcon, expandableType, expandRowByClick, expandedRowRender, onTriggerExpand, expandIconColumnIndex, indentSize]);
  var ResizeContextValue = React.useMemo(function () {
    return {
      onColumnResize: onColumnResize
    };
  }, [onColumnResize]);
  return /*#__PURE__*/React.createElement(_TableContext.default.Provider, {
    value: TableContextValue
  }, /*#__PURE__*/React.createElement(_BodyContext.default.Provider, {
    value: BodyContextValue
  }, /*#__PURE__*/React.createElement(_ResizeContext.default.Provider, {
    value: ResizeContextValue
  }, fullTable)));
}

Table.Column = _Column.default;
Table.ColumnGroup = _ColumnGroup.default;
Table.Summary = _Footer.FooterComponents;
Table.defaultProps = {
  rowKey: 'key',
  prefixCls: 'rc-table',
  emptyText: function emptyText() {
    return 'No Data';
  }
};
var _default = Table;
exports.default = _default;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(142)["default"];
var toPrimitive = __webpack_require__(1173);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(142)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(584);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(element) {
  if (!element) {
    return false;
  }
  if (element instanceof HTMLElement && element.offsetParent) {
    return true;
  }
  if (element instanceof SVGGraphicsElement && element.getBBox) {
    var _element$getBBox = element.getBBox(),
      width = _element$getBBox.width,
      height = _element$getBBox.height;
    if (width || height) {
      return true;
    }
  }
  if (element instanceof HTMLElement && element.getBoundingClientRect) {
    var _element$getBoundingC = element.getBoundingClientRect(),
      _width = _element$getBoundingC.width,
      _height = _element$getBoundingC.height;
    if (_width || _height) {
      return true;
    }
  }
  return false;
};
exports.default = _default;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ColumnGroup(_) {
  return null;
}

var _default = ColumnGroup;
exports.default = _default;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_) {
  return null;
}

var _default = Column;
exports.default = _default;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(366));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(274));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _ref2 = __webpack_require__(117);

var _Header = _interopRequireDefault(__webpack_require__(588));

var _ColGroup = _interopRequireDefault(__webpack_require__(590));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

function useColumnWidth(colWidths, columCount) {
  return (0, React.useMemo)(function () {
    var cloneColumns = [];

    for (var i = 0; i < columCount; i += 1) {
      var val = colWidths[i];

      if (val !== undefined) {
        cloneColumns[i] = val;
      } else {
        return null;
      }
    }

    return cloneColumns;
  }, [colWidths.join('_'), columCount]);
}

var FixedHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var noData = _ref.noData,
      columns = _ref.columns,
      flattenColumns = _ref.flattenColumns,
      colWidths = _ref.colWidths,
      columCount = _ref.columCount,
      stickyOffsets = _ref.stickyOffsets,
      direction = _ref.direction,
      fixHeader = _ref.fixHeader,
      offsetHeader = _ref.offsetHeader,
      stickyClassName = _ref.stickyClassName,
      onScroll = _ref.onScroll,
      props = (0, _objectWithoutProperties2.default)(_ref, ["noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "offsetHeader", "stickyClassName", "onScroll"]);

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls,
      scrollbarSize = _React$useContext.scrollbarSize,
      isSticky = _React$useContext.isSticky;

  var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize; // Pass wheel to scroll event

  var scrollRef = React.useRef(null);
  var setScrollRef = React.useCallback(function (element) {
    (0, _ref2.fillRef)(ref, element);
    (0, _ref2.fillRef)(scrollRef, element);
  }, []);
  React.useEffect(function () {
    var _scrollRef$current;

    function onWheel(e) {
      var currentTarget = e.currentTarget,
          deltaX = e.deltaX;

      if (deltaX) {
        onScroll({
          currentTarget: currentTarget,
          scrollLeft: currentTarget.scrollLeft + deltaX
        });
        e.preventDefault();
      }
    }

    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.addEventListener('wheel', onWheel);
    return function () {
      var _scrollRef$current2;

      (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.removeEventListener('wheel', onWheel);
    };
  }, []); // Add scrollbar column

  var lastColumn = flattenColumns[flattenColumns.length - 1];
  var ScrollBarColumn = {
    fixed: lastColumn ? lastColumn.fixed : null,
    onHeaderCell: function onHeaderCell() {
      return {
        className: "".concat(prefixCls, "-cell-scrollbar")
      };
    }
  };
  var columnsWithScrollbar = (0, React.useMemo)(function () {
    return combinationScrollBarSize ? [].concat((0, _toConsumableArray2.default)(columns), [ScrollBarColumn]) : columns;
  }, [combinationScrollBarSize, columns]);
  var flattenColumnsWithScrollbar = (0, React.useMemo)(function () {
    return combinationScrollBarSize ? [].concat((0, _toConsumableArray2.default)(flattenColumns), [ScrollBarColumn]) : flattenColumns;
  }, [combinationScrollBarSize, flattenColumns]); // Calculate the sticky offsets

  var headerStickyOffsets = (0, React.useMemo)(function () {
    var right = stickyOffsets.right,
        left = stickyOffsets.left;
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stickyOffsets), {}, {
      left: direction === 'rtl' ? [].concat((0, _toConsumableArray2.default)(left.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]) : left,
      right: direction === 'rtl' ? right : [].concat((0, _toConsumableArray2.default)(right.map(function (width) {
        return width + combinationScrollBarSize;
      })), [0]),
      isSticky: isSticky
    });
  }, [combinationScrollBarSize, stickyOffsets, isSticky]);
  var mergedColumnWidth = useColumnWidth(colWidths, columCount);
  return /*#__PURE__*/React.createElement("div", {
    style: (0, _objectSpread2.default)({
      overflow: 'hidden'
    }, isSticky ? {
      top: offsetHeader
    } : {}),
    ref: setScrollRef,
    className: (0, _classnames.default)("".concat(prefixCls, "-header"), (0, _defineProperty2.default)({}, stickyClassName, !!stickyClassName))
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      tableLayout: 'fixed',
      visibility: noData || mergedColumnWidth ? null : 'hidden'
    }
  }, /*#__PURE__*/React.createElement(_ColGroup.default, {
    colWidths: mergedColumnWidth ? [].concat((0, _toConsumableArray2.default)(mergedColumnWidth), [combinationScrollBarSize]) : [],
    columCount: columCount + 1,
    columns: flattenColumnsWithScrollbar
  }), /*#__PURE__*/React.createElement(_Header.default, (0, _extends2.default)({}, props, {
    stickyOffsets: headerStickyOffsets,
    columns: columnsWithScrollbar,
    flattenColumns: flattenColumnsWithScrollbar
  }))));
});
FixedHeader.displayName = 'FixedHeader';
var _default = FixedHeader;
exports.default = _default;

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var React = _interopRequireWildcard(__webpack_require__(0));

var _Cell = _interopRequireDefault(__webpack_require__(276));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _fixUtil = __webpack_require__(589);

var _valueUtil = __webpack_require__(210);

function HeaderRow(_ref) {
  var cells = _ref.cells,
      stickyOffsets = _ref.stickyOffsets,
      flattenColumns = _ref.flattenColumns,
      RowComponent = _ref.rowComponent,
      CellComponent = _ref.cellComponent,
      onHeaderRow = _ref.onHeaderRow,
      index = _ref.index;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls,
      direction = _React$useContext.direction;

  var rowProps;

  if (onHeaderRow) {
    rowProps = onHeaderRow(cells.map(function (cell) {
      return cell.column;
    }), index);
  }

  var columnsKey = (0, _valueUtil.getColumnsKey)(cells.map(function (cell) {
    return cell.column;
  }));
  return /*#__PURE__*/React.createElement(RowComponent, rowProps, cells.map(function (cell, cellIndex) {
    var column = cell.column;
    var fixedInfo = (0, _fixUtil.getCellFixedInfo)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
    var additionalProps;

    if (column && column.onHeaderCell) {
      additionalProps = cell.column.onHeaderCell(column);
    }

    return /*#__PURE__*/React.createElement(_Cell.default, (0, _extends2.default)({}, cell, {
      ellipsis: column.ellipsis,
      align: column.align,
      component: CellComponent,
      prefixCls: prefixCls,
      key: columnsKey[cellIndex]
    }, fixedInfo, {
      additionalProps: additionalProps,
      rowType: "header"
    }));
  }));
}

HeaderRow.displayName = 'HeaderRow';
var _default = HeaderRow;
exports.default = _default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _BodyRow = _interopRequireDefault(__webpack_require__(1187));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _ExpandedRow = _interopRequireDefault(__webpack_require__(591));

var _BodyContext = _interopRequireDefault(__webpack_require__(369));

var _valueUtil = __webpack_require__(210);

var _ResizeContext = _interopRequireDefault(__webpack_require__(592));

var _MeasureCell = _interopRequireDefault(__webpack_require__(1188));

function Body(_ref) {
  var data = _ref.data,
      getRowKey = _ref.getRowKey,
      measureColumnWidth = _ref.measureColumnWidth,
      expandedKeys = _ref.expandedKeys,
      onRow = _ref.onRow,
      rowExpandable = _ref.rowExpandable,
      emptyNode = _ref.emptyNode,
      childrenColumnName = _ref.childrenColumnName;

  var _React$useContext = React.useContext(_ResizeContext.default),
      onColumnResize = _React$useContext.onColumnResize;

  var _React$useContext2 = React.useContext(_TableContext.default),
      prefixCls = _React$useContext2.prefixCls,
      getComponent = _React$useContext2.getComponent;

  var _React$useContext3 = React.useContext(_BodyContext.default),
      fixHeader = _React$useContext3.fixHeader,
      horizonScroll = _React$useContext3.horizonScroll,
      flattenColumns = _React$useContext3.flattenColumns,
      componentWidth = _React$useContext3.componentWidth;

  return React.useMemo(function () {
    var WrapperComponent = getComponent(['body', 'wrapper'], 'tbody');
    var trComponent = getComponent(['body', 'row'], 'tr');
    var tdComponent = getComponent(['body', 'cell'], 'td');
    var rows;

    if (data.length) {
      rows = data.map(function (record, index) {
        var key = getRowKey(record, index);
        return /*#__PURE__*/React.createElement(_BodyRow.default, {
          key: key,
          rowKey: key,
          record: record,
          recordKey: key,
          index: index,
          rowComponent: trComponent,
          cellComponent: tdComponent,
          expandedKeys: expandedKeys,
          onRow: onRow,
          getRowKey: getRowKey,
          rowExpandable: rowExpandable,
          childrenColumnName: childrenColumnName
        });
      });
    } else {
      rows = /*#__PURE__*/React.createElement(_ExpandedRow.default, {
        expanded: true,
        className: "".concat(prefixCls, "-placeholder"),
        prefixCls: prefixCls,
        fixHeader: fixHeader,
        fixColumn: horizonScroll,
        horizonScroll: horizonScroll,
        component: trComponent,
        componentWidth: componentWidth,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length
      }, emptyNode);
    }

    var columnsKey = (0, _valueUtil.getColumnsKey)(flattenColumns);
    return /*#__PURE__*/React.createElement(WrapperComponent, {
      className: "".concat(prefixCls, "-tbody")
    }, measureColumnWidth && /*#__PURE__*/React.createElement("tr", {
      "aria-hidden": "true",
      className: "".concat(prefixCls, "-measure-row"),
      style: {
        height: 0,
        fontSize: 0
      }
    }, columnsKey.map(function (columnKey) {
      return /*#__PURE__*/React.createElement(_MeasureCell.default, {
        key: columnKey,
        columnKey: columnKey,
        onColumnResize: onColumnResize
      });
    })), rows);
  }, [data, prefixCls, onRow, measureColumnWidth, expandedKeys, getRowKey, getComponent, componentWidth, emptyNode, flattenColumns]);
}

var MemoBody = /*#__PURE__*/React.memo(Body);
MemoBody.displayName = 'Body';
var _default = MemoBody;
exports.default = _default;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(273));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Cell = _interopRequireDefault(__webpack_require__(276));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _BodyContext = _interopRequireDefault(__webpack_require__(369));

var _valueUtil = __webpack_require__(210);

var _ExpandedRow = _interopRequireDefault(__webpack_require__(591));

function BodyRow(props) {
  var className = props.className,
      style = props.style,
      record = props.record,
      index = props.index,
      rowKey = props.rowKey,
      getRowKey = props.getRowKey,
      rowExpandable = props.rowExpandable,
      expandedKeys = props.expandedKeys,
      onRow = props.onRow,
      _props$indent = props.indent,
      indent = _props$indent === void 0 ? 0 : _props$indent,
      RowComponent = props.rowComponent,
      cellComponent = props.cellComponent,
      childrenColumnName = props.childrenColumnName;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls,
      fixedInfoList = _React$useContext.fixedInfoList;

  var _React$useContext2 = React.useContext(_BodyContext.default),
      fixHeader = _React$useContext2.fixHeader,
      fixColumn = _React$useContext2.fixColumn,
      horizonScroll = _React$useContext2.horizonScroll,
      componentWidth = _React$useContext2.componentWidth,
      flattenColumns = _React$useContext2.flattenColumns,
      expandableType = _React$useContext2.expandableType,
      expandRowByClick = _React$useContext2.expandRowByClick,
      onTriggerExpand = _React$useContext2.onTriggerExpand,
      rowClassName = _React$useContext2.rowClassName,
      expandedRowClassName = _React$useContext2.expandedRowClassName,
      indentSize = _React$useContext2.indentSize,
      expandIcon = _React$useContext2.expandIcon,
      expandedRowRender = _React$useContext2.expandedRowRender,
      expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      expandRended = _React$useState2[0],
      setExpandRended = _React$useState2[1];

  var expanded = expandedKeys && expandedKeys.has(props.recordKey);
  React.useEffect(function () {
    if (expanded) {
      setExpandRended(true);
    }
  }, [expanded]);
  var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record)); // Only when row is not expandable and `children` exist in record

  var nestExpandable = expandableType === 'nest';
  var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
  var mergedExpandable = rowSupportExpand || nestExpandable; // =========================== onRow ===========================

  var additionalProps;

  if (onRow) {
    additionalProps = onRow(record, index);
  }

  var onClick = function onClick(event) {
    if (expandRowByClick && mergedExpandable) {
      onTriggerExpand(record, event);
    }

    if (additionalProps && additionalProps.onClick) {
      var _additionalProps;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_additionalProps = additionalProps).onClick.apply(_additionalProps, [event].concat(args));
    }
  }; // ======================== Base tr row ========================


  var computeRowClassName;

  if (typeof rowClassName === 'string') {
    computeRowClassName = rowClassName;
  } else if (typeof rowClassName === 'function') {
    computeRowClassName = rowClassName(record, index, indent);
  }

  var columnsKey = (0, _valueUtil.getColumnsKey)(flattenColumns);
  var baseRowNode = /*#__PURE__*/React.createElement(RowComponent, (0, _extends2.default)({}, additionalProps, {
    "data-row-key": rowKey,
    className: (0, _classnames.default)(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, style), additionalProps ? additionalProps.style : null),
    onClick: onClick
  }), flattenColumns.map(function (column, colIndex) {
    var render = column.render,
        dataIndex = column.dataIndex,
        columnClassName = column.className;
    var key = columnsKey[colIndex];
    var fixedInfo = fixedInfoList[colIndex]; // ============= Used for nest expandable =============

    var appendCellNode;

    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) {
      appendCellNode = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
      }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
      }));
    }

    var additionalCellProps;

    if (column.onCell) {
      additionalCellProps = column.onCell(record, index);
    }

    return /*#__PURE__*/React.createElement(_Cell.default, (0, _extends2.default)({
      className: columnClassName,
      ellipsis: column.ellipsis,
      align: column.align,
      component: cellComponent,
      prefixCls: prefixCls,
      key: key,
      record: record,
      index: index,
      dataIndex: dataIndex,
      render: render,
      shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
      appendNode: appendCellNode,
      additionalProps: additionalCellProps
    }));
  })); // ======================== Expand Row =========================

  var expandRowNode;

  if (rowSupportExpand && (expandRended || expanded)) {
    var expandContent = expandedRowRender(record, index, indent + 1, expanded);
    var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
    expandRowNode = /*#__PURE__*/React.createElement(_ExpandedRow.default, {
      expanded: expanded,
      className: (0, _classnames.default)("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
      prefixCls: prefixCls,
      fixHeader: fixHeader,
      fixColumn: fixColumn,
      horizonScroll: horizonScroll,
      component: RowComponent,
      componentWidth: componentWidth,
      cellComponent: cellComponent,
      colSpan: flattenColumns.length
    }, expandContent);
  } // ========================= Nest Row ==========================


  var nestRowNode;

  if (hasNestChildren && expanded) {
    nestRowNode = (record[childrenColumnName] || []).map(function (subRecord, subIndex) {
      var subKey = getRowKey(subRecord, subIndex);
      return /*#__PURE__*/React.createElement(BodyRow, (0, _extends2.default)({}, props, {
        key: subKey,
        rowKey: subKey,
        record: subRecord,
        recordKey: subKey,
        index: subIndex,
        indent: indent + 1
      }));
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, baseRowNode, expandRowNode, nestRowNode);
}

BodyRow.displayName = 'BodyRow';
var _default = BodyRow;
exports.default = _default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MeasureCell;

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(97));

function MeasureCell(_ref) {
  var columnKey = _ref.columnKey,
      onColumnResize = _ref.onColumnResize;
  var cellRef = React.useRef();
  React.useEffect(function () {
    if (cellRef.current) {
      onColumnResize(columnKey, cellRef.current.offsetWidth);
    }
  }, []);
  return /*#__PURE__*/React.createElement(_rcResizeObserver.default, {
    onResize: function onResize(_ref2) {
      var offsetWidth = _ref2.offsetWidth;
      onColumnResize(columnKey, offsetWidth);
    }
  }, /*#__PURE__*/React.createElement("td", {
    ref: cellRef,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 0,
      overflow: 'hidden'
    }
  }, "\xA0")));
}

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = __webpack_require__(0);

/**
 * Get sticky column offset width
 */
function useStickyOffsets(colWidths, columnCount, direction) {
  var stickyOffsets = (0, _react.useMemo)(function () {
    var leftOffsets = [];
    var rightOffsets = [];
    var left = 0;
    var right = 0;

    for (var start = 0; start < columnCount; start += 1) {
      if (direction === 'rtl') {
        // Left offset
        rightOffsets[start] = right;
        right += colWidths[start] || 0; // Right offset

        var end = columnCount - start - 1;
        leftOffsets[end] = left;
        left += colWidths[end] || 0;
      } else {
        // Left offset
        leftOffsets[start] = left;
        left += colWidths[start] || 0; // Right offset

        var _end = columnCount - start - 1;

        rightOffsets[_end] = right;
        right += colWidths[_end] || 0;
      }
    }

    return {
      left: leftOffsets,
      right: rightOffsets
    };
  }, [colWidths, columnCount, direction]);
  return stickyOffsets;
}

var _default = useStickyOffsets;
exports.default = _default;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
}

var _default = Panel;
exports.default = _default;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(56);

var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterComponents = exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _Cell = _interopRequireDefault(__webpack_require__(1192));

var _Row = _interopRequireDefault(__webpack_require__(1193));

function Footer(_ref) {
  var children = _ref.children;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls;

  return /*#__PURE__*/React.createElement("tfoot", {
    className: "".concat(prefixCls, "-summary")
  }, children);
}

var _default = Footer;
exports.default = _default;
var FooterComponents = {
  Cell: _Cell.default,
  Row: _Row.default
};
exports.FooterComponents = FooterComponents;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SummaryCell;

var _extends2 = _interopRequireDefault(__webpack_require__(167));

var React = _interopRequireWildcard(__webpack_require__(0));

var _Cell = _interopRequireDefault(__webpack_require__(276));

var _TableContext = _interopRequireDefault(__webpack_require__(108));

function SummaryCell(_ref) {
  var className = _ref.className,
      index = _ref.index,
      children = _ref.children,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan,
      align = _ref.align;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls,
      fixedInfoList = _React$useContext.fixedInfoList;

  var fixedInfo = fixedInfoList[index];
  return /*#__PURE__*/React.createElement(_Cell.default, (0, _extends2.default)({
    className: className,
    index: index,
    component: "td",
    prefixCls: prefixCls,
    record: null,
    dataIndex: null,
    align: align,
    render: function render() {
      return {
        children: children,
        props: {
          colSpan: colSpan,
          rowSpan: rowSpan
        }
      };
    }
  }, fixedInfo));
}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterRow;

var React = _interopRequireWildcard(__webpack_require__(0));

function FooterRow(props) {
  return /*#__PURE__*/React.createElement("tr", props);
}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderExpandIcon = renderExpandIcon;
exports.findAllChildrenKeys = findAllChildrenKeys;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

function renderExpandIcon(_ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      record = _ref.record,
      onExpand = _ref.onExpand,
      expanded = _ref.expanded,
      expandable = _ref.expandable;
  var expandClassName = "".concat(prefixCls, "-row-expand-icon");

  if (!expandable) {
    return /*#__PURE__*/React.createElement("span", {
      className: (0, _classnames.default)(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
  }

  var onClick = function onClick(event) {
    onExpand(record, event);
    event.stopPropagation();
  };

  return /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(expandClassName, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
    onClick: onClick
  });
}

function findAllChildrenKeys(data, getRowKey, childrenColumnName) {
  var keys = [];

  function dig(list) {
    (list || []).forEach(function (item, index) {
      keys.push(getRowKey(item, index));
      dig(item[childrenColumnName]);
    });
  }

  dig(data);
  return keys;
}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(143));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(144));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(273));

var React = _interopRequireWildcard(__webpack_require__(0));

var _addEventListener = _interopRequireDefault(__webpack_require__(595));

var _getScrollBarSize = _interopRequireDefault(__webpack_require__(367));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _css = __webpack_require__(1196);

var _TableContext = _interopRequireDefault(__webpack_require__(108));

var _useFrame = __webpack_require__(594);

var StickyScrollBar = function StickyScrollBar(_ref, ref) {
  var _scrollBodyRef$curren, _scrollBodyRef$curren2;

  var scrollBodyRef = _ref.scrollBodyRef,
      onScroll = _ref.onScroll,
      offsetScroll = _ref.offsetScroll,
      container = _ref.container;

  var _React$useContext = React.useContext(_TableContext.default),
      prefixCls = _React$useContext.prefixCls;

  var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
  var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
  var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
  var scrollBarRef = React.useRef();

  var _useLayoutState = (0, _useFrame.useLayoutState)({
    scrollLeft: 0,
    isHiddenScrollBar: false
  }),
      _useLayoutState2 = (0, _slicedToArray2.default)(_useLayoutState, 2),
      scrollState = _useLayoutState2[0],
      setScrollState = _useLayoutState2[1];

  var refState = React.useRef({
    delta: 0,
    x: 0
  });

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isActive = _React$useState2[0],
      setActive = _React$useState2[1];

  var onMouseUp = function onMouseUp() {
    setActive(false);
  };

  var onMouseDown = function onMouseDown(event) {
    event.persist();
    refState.current.delta = event.pageX - scrollState.scrollLeft;
    refState.current.x = 0;
    setActive(true);
    event.preventDefault();
  };

  var onMouseMove = function onMouseMove(event) {
    var _window;

    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
    var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event),
        buttons = _ref2.buttons;

    if (!isActive || buttons === 0) {
      // If out body mouse up, we can set isActive false when mouse move
      if (isActive) {
        setActive(false);
      }

      return;
    }

    var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;

    if (left <= 0) {
      left = 0;
    }

    if (left + scrollBarWidth >= bodyWidth) {
      left = bodyWidth - scrollBarWidth;
    }

    onScroll({
      scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
    });
    refState.current.x = event.pageX;
  };

  var onContainerScroll = function onContainerScroll() {
    var tableOffsetTop = (0, _css.getOffset)(scrollBodyRef.current).top;
    var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
    var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, _css.getOffset)(container).top + container.clientHeight;

    if (tableBottomOffset - (0, _getScrollBarSize.default)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) {
      setScrollState(function (state) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          isHiddenScrollBar: true
        });
      });
    } else {
      setScrollState(function (state) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          isHiddenScrollBar: false
        });
      });
    }
  };

  var setScrollLeft = function setScrollLeft(left) {
    setScrollState(function (state) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        scrollLeft: left / bodyScrollWidth * bodyWidth || 0
      });
    });
  };

  React.useImperativeHandle(ref, function () {
    return {
      setScrollLeft: setScrollLeft
    };
  });
  React.useEffect(function () {
    var onMouseUpListener = (0, _addEventListener.default)(document.body, 'mouseup', onMouseUp, false);
    var onMouseMoveListener = (0, _addEventListener.default)(document.body, 'mousemove', onMouseMove, false);
    onContainerScroll();
    return function () {
      onMouseUpListener.remove();
      onMouseMoveListener.remove();
    };
  }, [scrollBarWidth, isActive]);
  React.useEffect(function () {
    var onScrollListener = (0, _addEventListener.default)(container, 'scroll', onContainerScroll, false);
    var onResizeListener = (0, _addEventListener.default)(window, 'resize', onContainerScroll, false);
    return function () {
      onScrollListener.remove();
      onResizeListener.remove();
    };
  }, [container]);
  React.useEffect(function () {
    if (!scrollState.isHiddenScrollBar) {
      setScrollState(function (state) {
        var _scrollBodyRef$curren3, _scrollBodyRef$curren4;

        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          scrollLeft: scrollBodyRef.current.scrollLeft / ((_scrollBodyRef$curren3 = scrollBodyRef.current) === null || _scrollBodyRef$curren3 === void 0 ? void 0 : _scrollBodyRef$curren3.scrollWidth) * ((_scrollBodyRef$curren4 = scrollBodyRef.current) === null || _scrollBodyRef$curren4 === void 0 ? void 0 : _scrollBodyRef$curren4.clientWidth)
        });
      });
    }
  }, [scrollState.isHiddenScrollBar]);

  if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: (0, _getScrollBarSize.default)(),
      width: bodyWidth,
      bottom: offsetScroll
    },
    className: "".concat(prefixCls, "-sticky-scroll")
  }, /*#__PURE__*/React.createElement("div", {
    onMouseDown: onMouseDown,
    ref: scrollBarRef,
    className: (0, _classnames.default)("".concat(prefixCls, "-sticky-scroll-bar"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
    style: {
      width: "".concat(scrollBarWidth, "px"),
      transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
    }
  }));
};

var _default = /*#__PURE__*/React.forwardRef(StickyScrollBar);

exports.default = _default;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.getClientSize = getClientSize;
exports.getDocSize = getDocSize;
exports.getOffset = getOffset;
exports.getOuterHeight = getOuterHeight;
exports.getOuterWidth = getOuterWidth;
exports.getScroll = getScroll;
exports.set = set;
/* eslint-disable no-nested-ternary */
var PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var removePixel = {
  left: true,
  top: true
};
var floatMap = {
  cssFloat: 1,
  styleFloat: 1,
  float: 1
};
function getComputedStyle(node) {
  return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function getStyleValue(node, type, value) {
  type = type.toLowerCase();
  if (value === 'auto') {
    if (type === 'height') {
      return node.offsetHeight;
    }
    if (type === 'width') {
      return node.offsetWidth;
    }
  }
  if (!(type in removePixel)) {
    removePixel[type] = PIXEL_PATTERN.test(type);
  }
  return removePixel[type] ? parseFloat(value) || 0 : value;
}
function get(node, name) {
  var length = arguments.length;
  var style = getComputedStyle(node);
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  return length === 1 ? style : getStyleValue(node, name, style[name] || node.style[name]);
}
function set(node, name, value) {
  var length = arguments.length;
  name = floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
  if (length === 3) {
    if (typeof value === 'number' && PIXEL_PATTERN.test(name)) {
      value = "".concat(value, "px");
    }
    node.style[name] = value; // Number
    return value;
  }
  for (var x in name) {
    if (name.hasOwnProperty(x)) {
      set(node, x, name[x]);
    }
  }
  return getComputedStyle(node);
}
function getOuterWidth(el) {
  if (el === document.body) {
    return document.documentElement.clientWidth;
  }
  return el.offsetWidth;
}
function getOuterHeight(el) {
  if (el === document.body) {
    return window.innerHeight || document.documentElement.clientHeight;
  }
  return el.offsetHeight;
}
function getDocSize() {
  var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
  var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
  return {
    width: width,
    height: height
  };
}
function getClientSize() {
  var width = document.documentElement.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: width,
    height: height
  };
}
function getScroll() {
  return {
    scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
    scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
  };
}
function getOffset(node) {
  var box = node.getBoundingClientRect();
  var docElem = document.documentElement;

  // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
  return {
    left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(49);

var _interopRequireDefault = __webpack_require__(56);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSticky;

var _typeof2 = _interopRequireDefault(__webpack_require__(142));

var React = _interopRequireWildcard(__webpack_require__(0));

var _canUseDom = _interopRequireDefault(__webpack_require__(343));

// fix ssr render
var defaultContainer = (0, _canUseDom.default)() ? window : null;
/** Sticky header hooks */

function useSticky(sticky, prefixCls) {
  var _ref = (0, _typeof2.default)(sticky) === 'object' ? sticky : {},
      _ref$offsetHeader = _ref.offsetHeader,
      offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader,
      _ref$offsetScroll = _ref.offsetScroll,
      offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? function () {
    return defaultContainer;
  } : _ref$getContainer;

  var container = getContainer() || defaultContainer;
  return React.useMemo(function () {
    var isSticky = !!sticky;
    return {
      isSticky: isSticky,
      stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-header") : '',
      offsetHeader: offsetHeader,
      offsetScroll: offsetScroll,
      container: container
    };
  }, [offsetScroll, offsetHeader, prefixCls, container]);
}

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(109);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1200),
    isObject = __webpack_require__(277),
    isSymbol = __webpack_require__(1202);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1201);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(211),
    isObjectLike = __webpack_require__(212);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(370);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcPagination = _interopRequireDefault(__webpack_require__(1206));

var _en_US = _interopRequireDefault(__webpack_require__(503));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _LeftOutlined = _interopRequireDefault(__webpack_require__(360));

var _RightOutlined = _interopRequireDefault(__webpack_require__(267));

var _DoubleLeftOutlined = _interopRequireDefault(__webpack_require__(1219));

var _DoubleRightOutlined = _interopRequireDefault(__webpack_require__(1222));

var _MiniSelect = _interopRequireDefault(__webpack_require__(1225));

var _select = _interopRequireDefault(__webpack_require__(28));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _configProvider = __webpack_require__(8);

var _useBreakpoint2 = _interopRequireDefault(__webpack_require__(217));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Pagination = function Pagination(_a) {
  var customizePrefixCls = _a.prefixCls,
      customizeSelectPrefixCls = _a.selectPrefixCls,
      className = _a.className,
      size = _a.size,
      customLocale = _a.locale,
      restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);

  var _useBreakpoint = (0, _useBreakpoint2["default"])(),
      xs = _useBreakpoint.xs;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('pagination', customizePrefixCls);

  var getIconsProps = function getIconsProps() {
    var ellipsis = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-item-ellipsis")
    }, "\u2022\u2022\u2022");
    var prevIcon = /*#__PURE__*/React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(_LeftOutlined["default"], null));
    var nextIcon = /*#__PURE__*/React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(_RightOutlined["default"], null));
    var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /*#__PURE__*/React.createElement(_DoubleLeftOutlined["default"], {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /*#__PURE__*/React.createElement(_DoubleRightOutlined["default"], {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis)); // change arrows direction in right-to-left direction

    if (direction === 'rtl') {
      var _ref = [nextIcon, prevIcon];
      prevIcon = _ref[0];
      nextIcon = _ref[1];
      var _ref2 = [jumpNextIcon, jumpPrevIcon];
      jumpPrevIcon = _ref2[0];
      jumpNextIcon = _ref2[1];
    }

    return {
      prevIcon: prevIcon,
      nextIcon: nextIcon,
      jumpPrevIcon: jumpPrevIcon,
      jumpNextIcon: jumpNextIcon
    };
  };

  var renderPagination = function renderPagination(contextLocale) {
    var locale = (0, _extends2["default"])((0, _extends2["default"])({}, contextLocale), customLocale);
    var isSmall = size === 'small' || !!(xs && !size && restProps.responsive);
    var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    var extendedClassName = (0, _classnames["default"])((0, _defineProperty2["default"])({
      mini: isSmall
    }, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/React.createElement(_rcPagination["default"], (0, _extends2["default"])({}, restProps, {
      prefixCls: prefixCls,
      selectPrefixCls: selectPrefixCls
    }, getIconsProps(), {
      className: extendedClassName,
      selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
      locale: locale
    }));
  };

  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Pagination",
    defaultLocale: _en_US["default"]
  }, renderPagination);
};

var _default = Pagination;
exports["default"] = _default;

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(1207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pager__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Options__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__ = __webpack_require__(1218);








/* eslint react/prop-types: 0 */







function noop() {}

function isInteger(v) {
  var value = Number(v);
  return (// eslint-disable-next-line no-restricted-globals
    typeof value === 'number' && !isNaN(value) && isFinite(value) && Math.floor(value) === value
  );
}

function defaultItemRender(page, type, element) {
  return element;
}

function calculatePage(p, state, props) {
  var pageSize = typeof p === 'undefined' ? state.pageSize : p;
  return Math.floor((props.total - 1) / pageSize) + 1;
}

var Pagination = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Pagination, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Pagination);

  function Pagination(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Pagination);

    _this = _super.call(this, props);

    _this.getJumpPrevPage = function () {
      return Math.max(1, _this.state.current - (_this.props.showLessItems ? 3 : 5));
    };

    _this.getJumpNextPage = function () {
      return Math.min(calculatePage(undefined, _this.state, _this.props), _this.state.current + (_this.props.showLessItems ? 3 : 5));
    };

    _this.getItemIcon = function (icon, label) {
      var prefixCls = _this.props.prefixCls;
      var iconNode = icon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("button", {
        type: "button",
        "aria-label": label,
        className: "".concat(prefixCls, "-item-link")
      });

      if (typeof icon === 'function') {
        iconNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(icon, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.props));
      }

      return iconNode;
    };

    _this.savePaginationNode = function (node) {
      _this.paginationNode = node;
    };

    _this.isValid = function (page) {
      var total = _this.props.total;
      return isInteger(page) && page !== _this.state.current && isInteger(total) && total > 0;
    };

    _this.shouldDisplayQuickJumper = function () {
      var _this$props = _this.props,
          showQuickJumper = _this$props.showQuickJumper,
          total = _this$props.total;
      var pageSize = _this.state.pageSize;

      if (total <= pageSize) {
        return false;
      }

      return showQuickJumper;
    };

    _this.handleKeyDown = function (e) {
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP || e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
        e.preventDefault();
      }
    };

    _this.handleKeyUp = function (e) {
      var value = _this.getValidValue(e);

      var currentInputValue = _this.state.currentInputValue;

      if (value !== currentInputValue) {
        _this.setState({
          currentInputValue: value
        });
      }

      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER) {
        _this.handleChange(value);
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_UP) {
        _this.handleChange(value - 1);
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ARROW_DOWN) {
        _this.handleChange(value + 1);
      }
    };

    _this.handleBlur = function (e) {
      var value = _this.getValidValue(e);

      _this.handleChange(value);
    };

    _this.changePageSize = function (size) {
      var current = _this.state.current;
      var newCurrent = calculatePage(size, _this.state, _this.props);
      current = current > newCurrent ? newCurrent : current; // fix the issue:
      // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.

      if (newCurrent === 0) {
        // eslint-disable-next-line prefer-destructuring
        current = _this.state.current;
      }

      if (typeof size === 'number') {
        if (!('pageSize' in _this.props)) {
          _this.setState({
            pageSize: size
          });
        }

        if (!('current' in _this.props)) {
          _this.setState({
            current: current,
            currentInputValue: current
          });
        }
      }

      _this.props.onShowSizeChange(current, size);

      if ('onChange' in _this.props && _this.props.onChange) {
        _this.props.onChange(current, size);
      }
    };

    _this.handleChange = function (page) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange;
      var _this$state = _this.state,
          pageSize = _this$state.pageSize,
          current = _this$state.current,
          currentInputValue = _this$state.currentInputValue;

      if (_this.isValid(page) && !disabled) {
        var currentPage = calculatePage(undefined, _this.state, _this.props);
        var newPage = page;

        if (page > currentPage) {
          newPage = currentPage;
        } else if (page < 1) {
          newPage = 1;
        }

        if (!('current' in _this.props)) {
          _this.setState({
            current: newPage
          });
        }

        if (newPage !== currentInputValue) {
          _this.setState({
            currentInputValue: newPage
          });
        }

        onChange(newPage, pageSize);
        return newPage;
      }

      return current;
    };

    _this.prev = function () {
      if (_this.hasPrev()) {
        _this.handleChange(_this.state.current - 1);
      }
    };

    _this.next = function () {
      if (_this.hasNext()) {
        _this.handleChange(_this.state.current + 1);
      }
    };

    _this.jumpPrev = function () {
      _this.handleChange(_this.getJumpPrevPage());
    };

    _this.jumpNext = function () {
      _this.handleChange(_this.getJumpNextPage());
    };

    _this.hasPrev = function () {
      return _this.state.current > 1;
    };

    _this.hasNext = function () {
      return _this.state.current < calculatePage(undefined, _this.state, _this.props);
    };

    _this.runIfEnter = function (event, callback) {
      if (event.key === 'Enter' || event.charCode === 13) {
        for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          restParams[_key - 2] = arguments[_key];
        }

        callback.apply(void 0, restParams);
      }
    };

    _this.runIfEnterPrev = function (e) {
      _this.runIfEnter(e, _this.prev);
    };

    _this.runIfEnterNext = function (e) {
      _this.runIfEnter(e, _this.next);
    };

    _this.runIfEnterJumpPrev = function (e) {
      _this.runIfEnter(e, _this.jumpPrev);
    };

    _this.runIfEnterJumpNext = function (e) {
      _this.runIfEnter(e, _this.jumpNext);
    };

    _this.handleGoTO = function (e) {
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.handleChange(_this.state.currentInputValue);
      }
    };

    var hasOnChange = props.onChange !== noop;
    var hasCurrent = ('current' in props);

    if (hasCurrent && !hasOnChange) {
      // eslint-disable-next-line no-console
      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.');
    }

    var _current = props.defaultCurrent;

    if ('current' in props) {
      // eslint-disable-next-line prefer-destructuring
      _current = props.current;
    }

    var _pageSize = props.defaultPageSize;

    if ('pageSize' in props) {
      // eslint-disable-next-line prefer-destructuring
      _pageSize = props.pageSize;
    }

    _current = Math.min(_current, calculatePage(_pageSize, undefined, props));
    _this.state = {
      current: _current,
      currentInputValue: _current,
      pageSize: _pageSize
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Pagination, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // When current page change, fix focused style of prev item
      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
      var prefixCls = this.props.prefixCls;

      if (prevState.current !== this.state.current && this.paginationNode) {
        var lastCurrentNode = this.paginationNode.querySelector(".".concat(prefixCls, "-item-").concat(prevState.current));

        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
          lastCurrentNode.blur();
        }
      }
    }
  }, {
    key: "getValidValue",
    value: function getValidValue(e) {
      var inputValue = e.target.value;
      var allPages = calculatePage(undefined, this.state, this.props);
      var currentInputValue = this.state.currentInputValue;
      var value;

      if (inputValue === '') {
        value = inputValue; // eslint-disable-next-line no-restricted-globals
      } else if (isNaN(Number(inputValue))) {
        value = currentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }

      return value;
    }
  }, {
    key: "getShowSizeChanger",
    value: function getShowSizeChanger() {
      var _this$props3 = this.props,
          showSizeChanger = _this$props3.showSizeChanger,
          total = _this$props3.total,
          totalBoundaryShowSizeChanger = _this$props3.totalBoundaryShowSizeChanger;

      if (typeof showSizeChanger !== 'undefined') {
        return showSizeChanger;
      }

      return total > totalBoundaryShowSizeChanger;
    }
  }, {
    key: "renderPrev",
    value: function renderPrev(prevPage) {
      var _this$props4 = this.props,
          prevIcon = _this$props4.prevIcon,
          itemRender = _this$props4.itemRender;
      var prevButton = itemRender(prevPage, 'prev', this.getItemIcon(prevIcon, 'prev page'));
      var disabled = !this.hasPrev();
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(prevButton) ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(prevButton, {
        disabled: disabled
      }) : prevButton;
    }
  }, {
    key: "renderNext",
    value: function renderNext(nextPage) {
      var _this$props5 = this.props,
          nextIcon = _this$props5.nextIcon,
          itemRender = _this$props5.itemRender;
      var nextButton = itemRender(nextPage, 'next', this.getItemIcon(nextIcon, 'next page'));
      var disabled = !this.hasNext();
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(nextButton) ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(nextButton, {
        disabled: disabled
      }) : nextButton;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          className = _this$props6.className,
          style = _this$props6.style,
          disabled = _this$props6.disabled,
          hideOnSinglePage = _this$props6.hideOnSinglePage,
          total = _this$props6.total,
          locale = _this$props6.locale,
          showQuickJumper = _this$props6.showQuickJumper,
          showLessItems = _this$props6.showLessItems,
          showTitle = _this$props6.showTitle,
          showTotal = _this$props6.showTotal,
          simple = _this$props6.simple,
          itemRender = _this$props6.itemRender,
          showPrevNextJumpers = _this$props6.showPrevNextJumpers,
          jumpPrevIcon = _this$props6.jumpPrevIcon,
          jumpNextIcon = _this$props6.jumpNextIcon,
          selectComponentClass = _this$props6.selectComponentClass,
          selectPrefixCls = _this$props6.selectPrefixCls,
          pageSizeOptions = _this$props6.pageSizeOptions;
      var _this$state2 = this.state,
          current = _this$state2.current,
          pageSize = _this$state2.pageSize,
          currentInputValue = _this$state2.currentInputValue; // When hideOnSinglePage is true and there is only 1 page, hide the pager

      if (hideOnSinglePage === true && total <= pageSize) {
        return null;
      }

      var allPages = calculatePage(undefined, this.state, this.props);
      var pagerList = [];
      var jumpPrev = null;
      var jumpNext = null;
      var firstPager = null;
      var lastPager = null;
      var gotoButton = null;
      var goButton = showQuickJumper && showQuickJumper.goButton;
      var pageBufferSize = showLessItems ? 1 : 2;
      var prevPage = current - 1 > 0 ? current - 1 : 0;
      var nextPage = current + 1 < allPages ? current + 1 : allPages;
      var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          // eslint-disable-next-line no-param-reassign
          prev[key] = _this2.props[key];
        }

        return prev;
      }, {});

      if (simple) {
        if (goButton) {
          if (typeof goButton === 'boolean') {
            gotoButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("button", {
              type: "button",
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, locale.jump_to_confirm);
          } else {
            gotoButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", {
              onClick: this.handleGoTO,
              onKeyUp: this.handleGoTO
            }, goButton);
          }

          gotoButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
            title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
          }, gotoButton);
        }

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, "".concat(prefixCls, "-simple"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), disabled), className),
          style: style,
          ref: this.savePaginationNode
        }, dataOrAriaAttributeProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
          title: showTitle ? locale.prev_page : null,
          onClick: this.prev,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterPrev,
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-prev"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), !this.hasPrev())),
          "aria-disabled": !this.hasPrev()
        }, this.renderPrev(prevPage)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
          title: showTitle ? "".concat(current, "/").concat(allPages) : null,
          className: "".concat(prefixCls, "-simple-pager")
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("input", {
          type: "text",
          value: currentInputValue,
          disabled: disabled,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onChange: this.handleKeyUp,
          onBlur: this.handleBlur,
          size: "3"
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", {
          className: "".concat(prefixCls, "-slash")
        }, "/"), allPages), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
          title: showTitle ? locale.next_page : null,
          onClick: this.next,
          tabIndex: this.hasPrev() ? 0 : null,
          onKeyPress: this.runIfEnterNext,
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-next"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), !this.hasNext())),
          "aria-disabled": !this.hasNext()
        }, this.renderNext(nextPage)), gotoButton);
      }

      if (allPages <= 3 + pageBufferSize * 2) {
        var pagerProps = {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          showTitle: showTitle,
          itemRender: itemRender
        };

        if (!allPages) {
          pagerList.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: "".concat(prefixCls, "-item-disabled")
          })));
        }

        for (var i = 1; i <= allPages; i += 1) {
          var active = current === i;
          pagerList.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, pagerProps, {
            key: i,
            page: i,
            active: active
          })));
        }
      } else {
        var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;

        if (showPrevNextJumpers) {
          jumpPrev = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
            title: showTitle ? prevItemTitle : null,
            key: "prev",
            onClick: this.jumpPrev,
            tabIndex: "0",
            onKeyPress: this.runIfEnterJumpPrev,
            className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-jump-prev"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
          }, itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(jumpPrevIcon, 'prev page')));
          jumpNext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
            title: showTitle ? nextItemTitle : null,
            key: "next",
            tabIndex: "0",
            onClick: this.jumpNext,
            onKeyPress: this.runIfEnterJumpNext,
            className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-jump-next"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
          }, itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(jumpNextIcon, 'next page')));
        }

        lastPager = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: locale,
          last: true,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: allPages,
          page: allPages,
          active: false,
          showTitle: showTitle,
          itemRender: itemRender
        });
        firstPager = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
          locale: locale,
          rootPrefixCls: prefixCls,
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: 1,
          page: 1,
          active: false,
          showTitle: showTitle,
          itemRender: itemRender
        });
        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);

        if (current - 1 <= pageBufferSize) {
          right = 1 + pageBufferSize * 2;
        }

        if (allPages - current <= pageBufferSize) {
          left = allPages - pageBufferSize * 2;
        }

        for (var _i = left; _i <= right; _i += 1) {
          var _active = current === _i;

          pagerList.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pager__["a" /* default */], {
            locale: locale,
            rootPrefixCls: prefixCls,
            onClick: this.handleChange,
            onKeyPress: this.runIfEnter,
            key: _i,
            page: _i,
            active: _active,
            showTitle: showTitle,
            itemRender: itemRender
          }));
        }

        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
          pagerList[0] = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(pagerList[0], {
            className: "".concat(prefixCls, "-item-after-jump-prev")
          });
          pagerList.unshift(jumpPrev);
        }

        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
          pagerList[pagerList.length - 1] = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(pagerList[pagerList.length - 1], {
            className: "".concat(prefixCls, "-item-before-jump-next")
          });
          pagerList.push(jumpNext);
        }

        if (left !== 1) {
          pagerList.unshift(firstPager);
        }

        if (right !== allPages) {
          pagerList.push(lastPager);
        }
      }

      var totalText = null;

      if (showTotal) {
        totalText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
          className: "".concat(prefixCls, "-total-text")
        }, showTotal(total, [total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > total ? total : current * pageSize]));
      }

      var prevDisabled = !this.hasPrev() || !allPages;
      var nextDisabled = !this.hasNext() || !allPages;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), disabled)),
        style: style,
        unselectable: "unselectable",
        ref: this.savePaginationNode
      }, dataOrAriaAttributeProps), totalText, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
        title: showTitle ? locale.prev_page : null,
        onClick: this.prev,
        tabIndex: prevDisabled ? null : 0,
        onKeyPress: this.runIfEnterPrev,
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-prev"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
        "aria-disabled": prevDisabled
      }, this.renderPrev(prevPage)), pagerList, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", {
        title: showTitle ? locale.next_page : null,
        onClick: this.next,
        tabIndex: nextDisabled ? null : 0,
        onKeyPress: this.runIfEnterNext,
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()("".concat(prefixCls, "-next"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
        "aria-disabled": nextDisabled
      }, this.renderNext(nextPage)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Options__["a" /* default */], {
        disabled: disabled,
        locale: locale,
        rootPrefixCls: prefixCls,
        selectComponentClass: selectComponentClass,
        selectPrefixCls: selectPrefixCls,
        changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
        current: current,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
        goButton: goButton
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      var newState = {};

      if ('current' in props) {
        newState.current = props.current;

        if (props.current !== prevState.current) {
          newState.currentInputValue = newState.current;
        }
      }

      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
        var current = prevState.current;
        var newCurrent = calculatePage(props.pageSize, prevState, props);
        current = current > newCurrent ? newCurrent : current;

        if (!('current' in props)) {
          newState.current = current;
          newState.currentInputValue = current;
        }

        newState.pageSize = props.pageSize;
      }

      return newState;
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Pagination.defaultProps = {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  onChange: noop,
  className: '',
  selectPrefixCls: 'rc-select',
  prefixCls: 'rc-pagination',
  selectComponentClass: null,
  hideOnSinglePage: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showLessItems: false,
  showTitle: true,
  onShowSizeChange: noop,
  locale: __WEBPACK_IMPORTED_MODULE_12__locale_zh_CN__["a" /* default */],
  style: {},
  itemRender: defaultItemRender,
  totalBoundaryShowSizeChanger: 50
};
/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(372);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(371);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1215);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);


/* eslint react/prop-types: 0 */



var Pager = function Pager(props) {
  var _classNames;

  var prefixCls = "".concat(props.rootPrefixCls, "-item");
  var cls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(props.page), (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-active"), props.active), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), !props.page), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, props.className, !!props.className), _classNames));

  var handleClick = function handleClick() {
    props.onClick(props.page);
  };

  var handleKeyPress = function handleKeyPress(e) {
    props.onKeyPress(e, props.onClick, props.page);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", {
    title: props.showTitle ? props.page : null,
    className: cls,
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: "0"
  }, props.itemRender(props.page, 'page', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    rel: "nofollow"
  }, props.page)));
};

/* harmony default export */ __webpack_exports__["a"] = (Pager);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KeyCode__ = __webpack_require__(604);





/* eslint react/prop-types: 0 */



var Options = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Options, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Options);

  function Options() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Options);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      goInputText: ''
    };

    _this.buildOptionText = function (value) {
      return "".concat(value, " ").concat(_this.props.locale.items_per_page);
    };

    _this.changeSize = function (value) {
      _this.props.changeSize(Number(value));
    };

    _this.handleChange = function (e) {
      _this.setState({
        goInputText: e.target.value
      });
    };

    _this.handleBlur = function (e) {
      var _this$props = _this.props,
          goButton = _this$props.goButton,
          quickGo = _this$props.quickGo,
          rootPrefixCls = _this$props.rootPrefixCls;
      var goInputText = _this.state.goInputText;

      if (goButton || goInputText === '') {
        return;
      }

      _this.setState({
        goInputText: ''
      });

      if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
        return;
      }

      quickGo(_this.getValidValue());
    };

    _this.go = function (e) {
      var goInputText = _this.state.goInputText;

      if (goInputText === '') {
        return;
      }

      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_5__KeyCode__["a" /* default */].ENTER || e.type === 'click') {
        _this.setState({
          goInputText: ''
        });

        _this.props.quickGo(_this.getValidValue());
      }
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Options, [{
    key: "getValidValue",
    value: function getValidValue() {
      var goInputText = this.state.goInputText; // eslint-disable-next-line no-restricted-globals

      return !goInputText || isNaN(goInputText) ? undefined : Number(goInputText);
    }
  }, {
    key: "getPageSizeOptions",
    value: function getPageSizeOptions() {
      var _this$props2 = this.props,
          pageSize = _this$props2.pageSize,
          pageSizeOptions = _this$props2.pageSizeOptions;

      if (pageSizeOptions.some(function (option) {
        return option.toString() === pageSize.toString();
      })) {
        return pageSizeOptions;
      }

      return pageSizeOptions.concat([pageSize.toString()]).sort(function (a, b) {
        // eslint-disable-next-line no-restricted-globals
        var numberA = isNaN(Number(a)) ? 0 : Number(a); // eslint-disable-next-line no-restricted-globals

        var numberB = isNaN(Number(b)) ? 0 : Number(b);
        return numberA - numberB;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          pageSize = _this$props3.pageSize,
          locale = _this$props3.locale,
          rootPrefixCls = _this$props3.rootPrefixCls,
          changeSize = _this$props3.changeSize,
          quickGo = _this$props3.quickGo,
          goButton = _this$props3.goButton,
          selectComponentClass = _this$props3.selectComponentClass,
          buildOptionText = _this$props3.buildOptionText,
          selectPrefixCls = _this$props3.selectPrefixCls,
          disabled = _this$props3.disabled;
      var goInputText = this.state.goInputText;
      var prefixCls = "".concat(rootPrefixCls, "-options");
      var Select = selectComponentClass;
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;

      if (!changeSize && !quickGo) {
        return null;
      }

      var pageSizeOptions = this.getPageSizeOptions();

      if (changeSize && Select) {
        var options = pageSizeOptions.map(function (opt, i) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Select.Option, {
            key: i,
            value: opt.toString()
          }, (buildOptionText || _this2.buildOptionText)(opt));
        });
        changeSelect = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Select, {
          disabled: disabled,
          prefixCls: selectPrefixCls,
          showSearch: false,
          className: "".concat(prefixCls, "-size-changer"),
          optionLabelProp: "children",
          dropdownMatchSelectWidth: false,
          value: (pageSize || pageSizeOptions[0]).toString(),
          onChange: this.changeSize,
          getPopupContainer: function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          },
          "aria-label": locale.page_size,
          defaultOpen: false
        }, options);
      }

      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", {
            type: "button",
            onClick: this.go,
            onKeyUp: this.go,
            disabled: disabled,
            className: "".concat(prefixCls, "-quick-jumper-button")
          }, locale.jump_to_confirm) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
            onClick: this.go,
            onKeyUp: this.go
          }, goButton);
        }

        goInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
          className: "".concat(prefixCls, "-quick-jumper")
        }, locale.jump_to, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
          disabled: disabled,
          type: "text",
          value: goInputText,
          onChange: this.handleChange,
          onKeyUp: this.go,
          onBlur: this.handleBlur,
          "aria-label": locale.page
        }), locale.page, gotoButton);
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
        className: "".concat(prefixCls)
      }, changeSelect, goInput);
    }
  }]);

  return Options;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Options.defaultProps = {
  pageSizeOptions: ['10', '20', '50', '100']
};
/* harmony default export */ __webpack_exports__["a"] = (Options);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // Options.jsx
  items_per_page: '条/页',
  jump_to: '跳至',
  jump_to_confirm: '确定',
  page: '页',
  // Pagination.jsx
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前 5 页',
  next_5: '向后 5 页',
  prev_3: '向前 3 页',
  next_3: '向后 3 页',
  page_size: '页码'
});

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DoubleLeftOutlined = _interopRequireDefault(__webpack_require__(1220));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DoubleLeftOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _DoubleLeftOutlined = _interopRequireDefault(__webpack_require__(1221));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _DoubleLeftOutlined.default
  }));
};
DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
var _default = /*#__PURE__*/React.forwardRef(DoubleLeftOutlined);
exports.default = _default;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DoubleLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
exports.default = DoubleLeftOutlined;


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DoubleRightOutlined = _interopRequireDefault(__webpack_require__(1223));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DoubleRightOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _DoubleRightOutlined = _interopRequireDefault(__webpack_require__(1224));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _DoubleRightOutlined.default
  }));
};
DoubleRightOutlined.displayName = 'DoubleRightOutlined';
var _default = /*#__PURE__*/React.forwardRef(DoubleRightOutlined);
exports.default = _default;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DoubleRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
exports.default = DoubleRightOutlined;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _select = _interopRequireDefault(__webpack_require__(28));

var MiniSelect = function MiniSelect(props) {
  return /*#__PURE__*/React.createElement(_select["default"], (0, _extends2["default"])({
    size: "small"
  }, props));
};

MiniSelect.Option = _select["default"].Option;
var _default = MiniSelect;
exports["default"] = _default;

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OptGroup__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OptGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__OptGroup__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Select__["a" /* default */]);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OptionList__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Option__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OptGroup__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_legacyUtil__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__generate__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_warningPropsUtil__ = __webpack_require__(1334);





/**
 * To match accessibility requirement, we always provide an input in the component.
 * Other element will not set `tabIndex` to avoid `onBlur` sequence problem.
 * For focused select, we set `aria-live="polite"` to update the accessibility content.
 *
 * ref:
 * - keyboard: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role#Keyboard_interactions
 *
 * New api:
 * - listHeight
 * - listItemHeight
 * - component
 *
 * Remove deprecated api:
 * - multiple
 * - tags
 * - combobox
 * - firstActiveValue
 * - dropdownMenuStyle
 * - openClassName (Not list in api)
 *
 * Update:
 * - `backfill` only support `combobox` mode
 * - `combobox` mode not support `labelInValue` since it's meaningless
 * - `getInputElement` only support `combobox` mode
 * - `onChange` return OptionData instead of ReactNode
 * - `filterOption` `onChange` `onSelect` accept OptionData instead of ReactNode
 * - `combobox` mode trigger `onChange` will get `undefined` if no `value` match in Option
 * - `combobox` mode not support `optionLabelProp`
 */








var RefSelect = Object(__WEBPACK_IMPORTED_MODULE_10__generate__["a" /* default */])({
  prefixCls: 'rc-select',
  components: {
    optionList: __WEBPACK_IMPORTED_MODULE_5__OptionList__["a" /* default */]
  },
  convertChildrenToData: __WEBPACK_IMPORTED_MODULE_8__utils_legacyUtil__["a" /* convertChildrenToData */],
  flattenOptions: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["d" /* flattenOptions */],
  getLabeledValue: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["e" /* getLabeledValue */],
  filterOptions: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["b" /* filterOptions */],
  isValueDisabled: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["g" /* isValueDisabled */],
  findValueOption: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["c" /* findValueOption */],
  warningProps: __WEBPACK_IMPORTED_MODULE_11__utils_warningPropsUtil__["a" /* default */],
  fillOptionsWithMissingValue: __WEBPACK_IMPORTED_MODULE_9__utils_valueUtil__["a" /* fillOptionsWithMissingValue */]
});
/**
 * Typescript not support generic with function component,
 * we have to wrap an class component to handle this.
 */

var Select = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Select);

  function Select() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = _super.apply(this, arguments);
    _this.selectRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createRef"]();

    _this.focus = function () {
      _this.selectRef.current.focus();
    };

    _this.blur = function () {
      _this.selectRef.current.blur();
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](RefSelect, Object.assign({
        ref: this.selectRef
      }, this.props));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Select.Option = __WEBPACK_IMPORTED_MODULE_6__Option__["a" /* default */];
Select.OptGroup = __WEBPACK_IMPORTED_MODULE_7__OptGroup__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(605);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(213);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1232);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1236);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1237);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_pickAttrs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_hooks_useMemo__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_virtual_list__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TransBtn__ = __webpack_require__(375);










/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */

var OptionList = function OptionList(_ref, ref) {
  var prefixCls = _ref.prefixCls,
      id = _ref.id,
      flattenOptions = _ref.flattenOptions,
      childrenAsData = _ref.childrenAsData,
      values = _ref.values,
      searchValue = _ref.searchValue,
      multiple = _ref.multiple,
      defaultActiveFirstOption = _ref.defaultActiveFirstOption,
      height = _ref.height,
      itemHeight = _ref.itemHeight,
      notFoundContent = _ref.notFoundContent,
      open = _ref.open,
      menuItemSelectedIcon = _ref.menuItemSelectedIcon,
      virtual = _ref.virtual,
      onSelect = _ref.onSelect,
      onToggleOpen = _ref.onToggleOpen,
      onActiveValue = _ref.onActiveValue,
      onScroll = _ref.onScroll,
      onMouseEnter = _ref.onMouseEnter;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_hooks_useMemo__["a" /* default */])(function () {
    return flattenOptions;
  }, [open, flattenOptions], function (prev, next) {
    return next[0] && prev[1] !== next[1];
  }); // =========================== List ===========================

  var listRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);

  var onListMouseDown = function onListMouseDown(event) {
    event.preventDefault();
  };

  var scrollIntoView = function scrollIntoView(index) {
    if (listRef.current) {
      listRef.current.scrollTo({
        index: index
      });
    }
  }; // ========================== Active ==========================


  var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var len = memoFlattenOptions.length;

    for (var i = 0; i < len; i += 1) {
      var current = (index + i * offset + len) % len;
      var _memoFlattenOptions$c = memoFlattenOptions[current],
          group = _memoFlattenOptions$c.group,
          data = _memoFlattenOptions$c.data;

      if (!group && !data.disabled) {
        return current;
      }
    }

    return -1;
  };

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](function () {
    return getEnabledActiveIndex(0);
  }),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var setActive = function setActive(index) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setActiveIndex(index);
    var info = {
      source: fromKeyboard ? 'keyboard' : 'mouse'
    }; // Trigger active event

    var flattenItem = memoFlattenOptions[index];

    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }

    onActiveValue(flattenItem.data.value, index, info);
  }; // Auto active first item when list length or searchValue changed


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]); // Auto scroll to item position in single mode

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */
    var timeoutId = setTimeout(function () {
      if (!multiple && open && values.size === 1) {
        var value = Array.from(values)[0];
        var index = memoFlattenOptions.findIndex(function (_ref2) {
          var data = _ref2.data;
          return data.value === value;
        });
        setActive(index);
        scrollIntoView(index);
      }
    }); // Force trigger scrollbar visible when open

    if (open) {
      var _listRef$current;

      (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(undefined);
    }

    return function () {
      return clearTimeout(timeoutId);
    };
  }, [open]); // ========================== Values ==========================

  var onSelectValue = function onSelectValue(value) {
    if (value !== undefined) {
      onSelect(value, {
        selected: !values.has(value)
      });
    } // Single mode should always close by select


    if (!multiple) {
      onToggleOpen(false);
    }
  }; // ========================= Keyboard =========================


  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      onKeyDown: function onKeyDown(event) {
        var which = event.which;

        switch (which) {
          // >>> Arrow keys
          case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].UP:
          case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].DOWN:
            {
              var offset = 0;

              if (which === __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].UP) {
                offset = -1;
              } else if (which === __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].DOWN) {
                offset = 1;
              }

              if (offset !== 0) {
                var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                scrollIntoView(nextActiveIndex);
                setActive(nextActiveIndex, true);
              }

              break;
            }
          // >>> Select

          case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].ENTER:
            {
              // value
              var item = memoFlattenOptions[activeIndex];

              if (item && !item.data.disabled) {
                onSelectValue(item.data.value);
              } else {
                onSelectValue(undefined);
              }

              if (open) {
                event.preventDefault();
              }

              break;
            }
          // >>> Close

          case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].ESC:
            {
              onToggleOpen(false);
            }
        }
      },
      onKeyUp: function onKeyUp() {},
      scrollTo: function scrollTo(index) {
        scrollIntoView(index);
      }
    };
  }); // ========================== Render ==========================

  if (memoFlattenOptions.length === 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      role: "listbox",
      id: "".concat(id, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }

  function renderItem(index) {
    var item = memoFlattenOptions[index];
    if (!item) return null;
    var itemData = item.data || {};
    var value = itemData.value,
        label = itemData.label,
        children = itemData.children;
    var attrs = Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_pickAttrs__["a" /* default */])(itemData, true);
    var mergedLabel = childrenAsData ? children : label;
    return item ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object.assign({
      "aria-label": typeof mergedLabel === 'string' ? mergedLabel : null
    }, attrs, {
      key: index,
      role: "option",
      id: "".concat(id, "_list_").concat(index),
      "aria-selected": values.has(value)
    }), value) : null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    role: "listbox",
    id: "".concat(id, "_list"),
    style: {
      height: 0,
      width: 0,
      overflow: 'hidden'
    }
  }, renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_virtual_list__["a" /* default */], {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height: height,
    itemHeight: itemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll: onScroll,
    virtual: virtual,
    onMouseEnter: onMouseEnter
  }, function (_ref3, itemIndex) {
    var _classNames;

    var group = _ref3.group,
        groupOption = _ref3.groupOption,
        data = _ref3.data;
    var label = data.label,
        key = data.key; // Group

    if (group) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(itemPrefixCls, "".concat(itemPrefixCls, "-group"))
      }, label !== undefined ? label : key);
    }

    var disabled = data.disabled,
        value = data.value,
        title = data.title,
        children = data.children,
        style = data.style,
        className = data.className,
        otherProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(data, ["disabled", "value", "title", "children", "style", "className"]); // Option


    var selected = values.has(value);
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
    var mergedLabel = childrenAsData ? children : label;
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
    var content = mergedLabel || value; // https://github.com/ant-design/ant-design/issues/26717

    var optionTitle = typeof content === 'string' || typeof content === 'number' ? content.toString() : undefined;

    if (title !== undefined) {
      optionTitle = title;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object.assign({}, otherProps, {
      "aria-selected": selected,
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || disabled) {
          return;
        }

        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!disabled) {
          onSelectValue(value);
        }
      },
      style: style
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, content), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__TransBtn__["a" /* default */], {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        isSelected: selected
      }
    }, selected ? '✓' : null));
  }));
};

var RefOptionList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](OptionList);
RefOptionList.displayName = 'OptionList';
/* harmony default export */ __webpack_exports__["a"] = (RefOptionList);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1242);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__List__["a" /* default */]);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RawList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Filler__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ScrollBar__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useChildren__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks_useHeights__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks_useScrollTo__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useDiffItem__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_useFrameWheel__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks_useMobileTouchMove__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useOriginScroll__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rc_util_es_hooks_useLayoutEffect__ = __webpack_require__(170);





var _excluded = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "component", "onScroll", "onVisibleChange", "innerProps"];













var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: 'auto',
  overflowAnchor: 'none'
};
function RawList(props, ref) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls,
    className = props.className,
    height = props.height,
    itemHeight = props.itemHeight,
    _props$fullHeight = props.fullHeight,
    fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight,
    style = props.style,
    data = props.data,
    children = props.children,
    itemKey = props.itemKey,
    virtual = props.virtual,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'div' : _props$component,
    onScroll = props.onScroll,
    onVisibleChange = props.onVisibleChange,
    innerProps = props.innerProps,
    restProps = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);
  // ================================= MISC =================================
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var inVirtual = useVirtual && data && itemHeight * data.length > height;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
    _useState2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
    scrollTop = _useState2[0],
    setScrollTop = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
    _useState4 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
    scrollMoving = _useState4[0],
    setScrollMoving = _useState4[1];
  var mergedClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(prefixCls, className);
  var mergedData = data || EMPTY_DATA;
  var componentRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var fillerInnerRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var scrollBarRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(); // Hack on scrollbar to enable flash call
  // =============================== Item Key ===============================
  var getKey = __WEBPACK_IMPORTED_MODULE_5_react__["useCallback"](function (item) {
    if (typeof itemKey === 'function') {
      return itemKey(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey];
  }, [itemKey]);
  var sharedConfig = {
    getKey: getKey
  };
  // ================================ Scroll ================================
  function syncScrollTop(newTop) {
    setScrollTop(function (origin) {
      var value;
      if (typeof newTop === 'function') {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }
  // ================================ Legacy ================================
  // Put ref here since the range is generate by follow
  var rangeRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var _useDiffItem = Object(__WEBPACK_IMPORTED_MODULE_12__hooks_useDiffItem__["a" /* default */])(mergedData, getKey),
    _useDiffItem2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useDiffItem, 1),
    diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;
  // ================================ Height ================================
  var _useHeights = Object(__WEBPACK_IMPORTED_MODULE_10__hooks_useHeights__["a" /* default */])(getKey, null, null),
    _useHeights2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useHeights, 4),
    setInstanceRef = _useHeights2[0],
    collectHeight = _useHeights2[1],
    heights = _useHeights2[2],
    heightUpdatedMark = _useHeights2[3];
  // ========================== Visible Calculation =========================
  var _React$useMemo = __WEBPACK_IMPORTED_MODULE_5_react__["useMemo"](function () {
      if (!useVirtual) {
        return {
          scrollHeight: undefined,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }
      // Always use virtual scroll bar in avoid shaking
      if (!inVirtual) {
        var _fillerInnerRef$curre;
        return {
          scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
          start: 0,
          end: mergedData.length - 1,
          offset: undefined
        };
      }
      var itemTop = 0;
      var startIndex;
      var startOffset;
      var endIndex;
      var dataLen = mergedData.length;
      for (var i = 0; i < dataLen; i += 1) {
        var item = mergedData[i];
        var key = getKey(item);
        var cacheHeight = heights.get(key);
        var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
        // Check item top in the range
        if (currentItemBottom >= scrollTop && startIndex === undefined) {
          startIndex = i;
          startOffset = itemTop;
        }
        // Check item bottom in the range. We will render additional one item for motion usage
        if (currentItemBottom > scrollTop + height && endIndex === undefined) {
          endIndex = i;
        }
        itemTop = currentItemBottom;
      }
      // When scrollTop at the end but data cut to small count will reach this
      if (startIndex === undefined) {
        startIndex = 0;
        startOffset = 0;
        endIndex = Math.ceil(height / itemHeight);
      }
      if (endIndex === undefined) {
        endIndex = mergedData.length - 1;
      }
      // Give cache to improve scroll experience
      endIndex = Math.min(endIndex + 1, mergedData.length);
      return {
        scrollHeight: itemTop,
        start: startIndex,
        end: endIndex,
        offset: startOffset
      };
    }, [inVirtual, useVirtual, scrollTop, mergedData, heightUpdatedMark, height]),
    scrollHeight = _React$useMemo.scrollHeight,
    start = _React$useMemo.start,
    end = _React$useMemo.end,
    offset = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;
  // =============================== In Range ===============================
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = scrollTop <= 0;
  var isScrollAtBottom = scrollTop >= maxScrollHeight;
  var originScroll = Object(__WEBPACK_IMPORTED_MODULE_15__hooks_useOriginScroll__["a" /* default */])(isScrollAtTop, isScrollAtBottom);
  // ================================ Scroll ================================
  function onScrollBar(newScrollTop) {
    var newTop = newScrollTop;
    syncScrollTop(newTop);
  }
  // When data size reduce. It may trigger native scroll event back to fit scroll position
  function onFallbackScroll(e) {
    var newScrollTop = e.currentTarget.scrollTop;
    if (newScrollTop !== scrollTop) {
      syncScrollTop(newScrollTop);
    }
    // Trigger origin onScroll
    onScroll === null || onScroll === void 0 ? void 0 : onScroll(e);
  }
  // Since this added in global,should use ref to keep update
  var _useFrameWheel = Object(__WEBPACK_IMPORTED_MODULE_13__hooks_useFrameWheel__["a" /* default */])(useVirtual, isScrollAtTop, isScrollAtBottom, function (offsetY) {
      syncScrollTop(function (top) {
        var newTop = top + offsetY;
        return newTop;
      });
    }),
    _useFrameWheel2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useFrameWheel, 2),
    onRawWheel = _useFrameWheel2[0],
    onFireFoxScroll = _useFrameWheel2[1];
  // Mobile touch move
  Object(__WEBPACK_IMPORTED_MODULE_14__hooks_useMobileTouchMove__["a" /* default */])(useVirtual, componentRef, function (deltaY, smoothOffset) {
    if (originScroll(deltaY, smoothOffset)) {
      return false;
    }
    onRawWheel({
      preventDefault: function preventDefault() {},
      deltaY: deltaY
    });
    return true;
  });
  Object(__WEBPACK_IMPORTED_MODULE_16_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    // Firefox only
    function onMozMousePixelScroll(e) {
      if (useVirtual) {
        e.preventDefault();
      }
    }
    componentRef.current.addEventListener('wheel', onRawWheel);
    componentRef.current.addEventListener('DOMMouseScroll', onFireFoxScroll);
    componentRef.current.addEventListener('MozMousePixelScroll', onMozMousePixelScroll);
    return function () {
      if (componentRef.current) {
        componentRef.current.removeEventListener('wheel', onRawWheel);
        componentRef.current.removeEventListener('DOMMouseScroll', onFireFoxScroll);
        componentRef.current.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
      }
    };
  }, [useVirtual]);
  // ================================= Ref ==================================
  var scrollTo = Object(__WEBPACK_IMPORTED_MODULE_11__hooks_useScrollTo__["a" /* default */])(componentRef, mergedData, heights, itemHeight, getKey, collectHeight, syncScrollTop, function () {
    var _scrollBarRef$current;
    (_scrollBarRef$current = scrollBarRef.current) === null || _scrollBarRef$current === void 0 ? void 0 : _scrollBarRef$current.delayHidden();
  });
  __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](ref, function () {
    return {
      scrollTo: scrollTo
    };
  });
  // ================================ Effect ================================
  /** We need told outside that some list not rendered */
  Object(__WEBPACK_IMPORTED_MODULE_16_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);
  // ================================ Render ================================
  var listChildren = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useChildren__["a" /* default */])(mergedData, start, end, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, fullHeight ? 'height' : 'maxHeight', height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = 'hidden';
      if (scrollMoving) {
        componentStyle.pointerEvents = 'none';
      }
    }
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    style: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), {}, {
      position: 'relative'
    }),
    className: mergedClassName
  }, restProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](Component, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Filler__["a" /* default */], {
    prefixCls: prefixCls,
    height: scrollHeight,
    offset: offset,
    onInnerResize: collectHeight,
    ref: fillerInnerRef,
    innerProps: innerProps
  }, listChildren)), useVirtual && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ScrollBar__["a" /* default */], {
    ref: scrollBarRef,
    prefixCls: prefixCls,
    scrollTop: scrollTop,
    height: height,
    scrollHeight: scrollHeight,
    count: mergedData.length,
    onScroll: onScrollBar,
    onStartMove: function onStartMove() {
      setScrollMoving(true);
    },
    onStopMove: function onStopMove() {
      setScrollMoving(false);
    }
  }));
}
var List = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](RawList);
List.displayName = 'List';
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(214);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1247);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1250);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_resize_observer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);






/**
 * Fill component to provided the scroll content real height.
 */
var Filler = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function (_ref, ref) {
  var height = _ref.height,
    offset = _ref.offset,
    children = _ref.children,
    prefixCls = _ref.prefixCls,
    onInnerResize = _ref.onInnerResize,
    innerProps = _ref.innerProps;
  var outerStyle = {};
  var innerStyle = {
    display: 'flex',
    flexDirection: 'column'
  };
  if (offset !== undefined) {
    outerStyle = {
      height: height,
      position: 'relative',
      overflow: 'hidden'
    };
    innerStyle = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, innerStyle), {}, {
      transform: "translateY(".concat(offset, "px)"),
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    style: outerStyle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_resize_observer__["default"], {
    onResize: function onResize(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    style: innerStyle,
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref: ref
  }, innerProps), children)));
});
Filler.displayName = 'Filler';
/* harmony default export */ __webpack_exports__["a"] = (Filler);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__ = __webpack_require__(75);








var MIN_SIZE = 20;
function getPageY(e) {
  return 'touches' in e ? e.touches[0].pageY : e.pageY;
}
var ScrollBar = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBar, _React$Component);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ScrollBar);
  function ScrollBar() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.moveRaf = null;
    _this.scrollbarRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createRef"]();
    _this.thumbRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createRef"]();
    _this.visibleTimeout = null;
    _this.state = {
      dragging: false,
      pageY: null,
      startTop: null,
      visible: false
    };
    _this.delayHidden = function () {
      clearTimeout(_this.visibleTimeout);
      _this.setState({
        visible: true
      });
      _this.visibleTimeout = setTimeout(function () {
        _this.setState({
          visible: false
        });
      }, 2000);
    };
    _this.onScrollbarTouchStart = function (e) {
      e.preventDefault();
    };
    _this.onContainerMouseDown = function (e) {
      e.stopPropagation();
      e.preventDefault();
    };
    _this.patchEvents = function () {
      window.addEventListener('mousemove', _this.onMouseMove);
      window.addEventListener('mouseup', _this.onMouseUp);
      _this.thumbRef.current.addEventListener('touchmove', _this.onMouseMove);
      _this.thumbRef.current.addEventListener('touchend', _this.onMouseUp);
    };
    _this.removeEvents = function () {
      var _this$scrollbarRef$cu;
      window.removeEventListener('mousemove', _this.onMouseMove);
      window.removeEventListener('mouseup', _this.onMouseUp);
      (_this$scrollbarRef$cu = _this.scrollbarRef.current) === null || _this$scrollbarRef$cu === void 0 ? void 0 : _this$scrollbarRef$cu.removeEventListener('touchstart', _this.onScrollbarTouchStart);
      if (_this.thumbRef.current) {
        _this.thumbRef.current.removeEventListener('touchstart', _this.onMouseDown);
        _this.thumbRef.current.removeEventListener('touchmove', _this.onMouseMove);
        _this.thumbRef.current.removeEventListener('touchend', _this.onMouseUp);
      }
      __WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__["a" /* default */].cancel(_this.moveRaf);
    };
    _this.onMouseDown = function (e) {
      var onStartMove = _this.props.onStartMove;
      _this.setState({
        dragging: true,
        pageY: getPageY(e),
        startTop: _this.getTop()
      });
      onStartMove();
      _this.patchEvents();
      e.stopPropagation();
      e.preventDefault();
    };
    _this.onMouseMove = function (e) {
      var _this$state = _this.state,
        dragging = _this$state.dragging,
        pageY = _this$state.pageY,
        startTop = _this$state.startTop;
      var onScroll = _this.props.onScroll;
      __WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__["a" /* default */].cancel(_this.moveRaf);
      if (dragging) {
        var offsetY = getPageY(e) - pageY;
        var newTop = startTop + offsetY;
        var enableScrollRange = _this.getEnableScrollRange();
        var enableHeightRange = _this.getEnableHeightRange();
        var ptg = enableHeightRange ? newTop / enableHeightRange : 0;
        var newScrollTop = Math.ceil(ptg * enableScrollRange);
        _this.moveRaf = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__["a" /* default */])(function () {
          onScroll(newScrollTop);
        });
      }
    };
    _this.onMouseUp = function () {
      var onStopMove = _this.props.onStopMove;
      _this.setState({
        dragging: false
      });
      onStopMove();
      _this.removeEvents();
    };
    _this.getSpinHeight = function () {
      var _this$props = _this.props,
        height = _this$props.height,
        count = _this$props.count;
      var baseHeight = height / count * 10;
      baseHeight = Math.max(baseHeight, MIN_SIZE);
      baseHeight = Math.min(baseHeight, height / 2);
      return Math.floor(baseHeight);
    };
    _this.getEnableScrollRange = function () {
      var _this$props2 = _this.props,
        scrollHeight = _this$props2.scrollHeight,
        height = _this$props2.height;
      return scrollHeight - height || 0;
    };
    _this.getEnableHeightRange = function () {
      var height = _this.props.height;
      var spinHeight = _this.getSpinHeight();
      return height - spinHeight || 0;
    };
    _this.getTop = function () {
      var scrollTop = _this.props.scrollTop;
      var enableScrollRange = _this.getEnableScrollRange();
      var enableHeightRange = _this.getEnableHeightRange();
      if (scrollTop === 0 || enableScrollRange === 0) {
        return 0;
      }
      var ptg = scrollTop / enableScrollRange;
      return ptg * enableHeightRange;
    };
    _this.showScroll = function () {
      var _this$props3 = _this.props,
        height = _this$props3.height,
        scrollHeight = _this$props3.scrollHeight;
      return scrollHeight > height;
    };
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollbarRef.current.addEventListener('touchstart', this.onScrollbarTouchStart);
      this.thumbRef.current.addEventListener('touchstart', this.onMouseDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollTop !== this.props.scrollTop) {
        this.delayHidden();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
      clearTimeout(this.visibleTimeout);
    }
  }, {
    key: "render",
    value:
    // ====================== Render =======================
    function render() {
      var _this$state2 = this.state,
        dragging = _this$state2.dragging,
        visible = _this$state2.visible;
      var prefixCls = this.props.prefixCls;
      var spinHeight = this.getSpinHeight();
      var top = this.getTop();
      var canScroll = this.showScroll();
      var mergedVisible = canScroll && visible;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        ref: this.scrollbarRef,
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-scrollbar"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-scrollbar-show"), canScroll)),
        style: {
          width: 8,
          top: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: mergedVisible ? null : 'none'
        },
        onMouseDown: this.onContainerMouseDown,
        onMouseMove: this.delayHidden
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        ref: this.thumbRef,
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-scrollbar-thumb"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-scrollbar-thumb-moving"), dragging)),
        style: {
          width: '100%',
          height: spinHeight,
          top: top,
          left: 0,
          position: 'absolute',
          background: 'rgba(0, 0, 0, 0.5)',
          borderRadius: 99,
          cursor: 'pointer',
          userSelect: 'none'
        },
        onMouseDown: this.onMouseDown
      }));
    }
  }]);
  return ScrollBar;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1254);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1258);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1259);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item__ = __webpack_require__(1261);


function useChildren(list, startIndex, endIndex, setNodeRef, renderFunc, _ref) {
  var getKey = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function (item, index) {
    var eleIndex = startIndex + index;
    var node = renderFunc(item, eleIndex, {
      // style: status === 'MEASURE_START' ? { visibility: 'hidden' } : {},
    });
    var key = getKey(item);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Item__["a" /* Item */], {
      key: key,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node);
  });
}

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Item;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Item(_ref) {
  var children = _ref.children,
    setRef = _ref.setRef;
  var refFunc = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (node) {
    setRef(node);
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
    ref: refFunc
  });
}

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useHeights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_findDOMNode__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_CacheMap__ = __webpack_require__(1263);






function useHeights(getKey, onItemAdd, onItemRemove) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](0),
    _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
    updatedMark = _React$useState2[0],
    setUpdatedMark = _React$useState2[1];
  var instanceRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(new Map());
  var heightsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(new __WEBPACK_IMPORTED_MODULE_4__utils_CacheMap__["a" /* default */]());
  var collectRafRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();
  function cancelRaf() {
    __WEBPACK_IMPORTED_MODULE_3_rc_util_es_raf__["a" /* default */].cancel(collectRafRef.current);
  }
  function collectHeight() {
    cancelRaf();
    collectRafRef.current = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_raf__["a" /* default */])(function () {
      instanceRef.current.forEach(function (element, key) {
        if (element && element.offsetParent) {
          var htmlElement = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_findDOMNode__["a" /* default */])(element);
          var offsetHeight = htmlElement.offsetHeight;
          if (heightsRef.current.get(key) !== offsetHeight) {
            heightsRef.current.set(key, htmlElement.offsetHeight);
          }
        }
      });
      // Always trigger update mark to tell parent that should re-calculate heights when resized
      setUpdatedMark(function (c) {
        return c + 1;
      });
    });
  }
  function setInstanceRef(item, instance) {
    var key = getKey(item);
    var origin = instanceRef.current.get(key);
    if (instance) {
      instanceRef.current.set(key, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key);
    }
    // Instance changed
    if (!origin !== !instance) {
      if (instance) {
        onItemAdd === null || onItemAdd === void 0 ? void 0 : onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(item);
      }
    }
  }
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(613);


// Firefox has low performance of map.
var CacheMap = /*#__PURE__*/function () {
  function CacheMap() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, CacheMap);
    this.maps = void 0;
    this.maps = Object.create(null);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(CacheMap, [{
    key: "set",
    value: function set(key, value) {
      this.maps[key] = value;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.maps[key];
    }
  }]);
  return CacheMap;
}();
/* harmony default export */ __webpack_exports__["a"] = (CacheMap);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useScrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__ = __webpack_require__(75);

/* eslint-disable no-param-reassign */


function useScrollTo(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"]();
  return function (arg) {
    // When not argument provided, we think dev may want to show the scrollbar
    if (arg === null || arg === undefined) {
      triggerFlash();
      return;
    }
    // Normal scroll logic
    __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */].cancel(scrollRef.current);
    if (typeof arg === 'number') {
      syncScrollTop(arg);
    } else if (arg && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(arg) === 'object') {
      var index;
      var align = arg.align;
      if ('index' in arg) {
        index = arg.index;
      } else {
        index = data.findIndex(function (item) {
          return getKey(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset,
        offset = _arg$offset === void 0 ? 0 : _arg$offset;
      // We will retry 3 times in case dynamic height shaking
      var syncScroll = function syncScroll(times, targetAlign) {
        if (times < 0 || !containerRef.current) return;
        var height = containerRef.current.clientHeight;
        var needCollectHeight = false;
        var newTargetAlign = targetAlign;
        // Go to next frame if height not exist
        if (height) {
          var mergedAlign = targetAlign || align;
          // Get top & bottom
          var stackTop = 0;
          var itemTop = 0;
          var itemBottom = 0;
          var maxLen = Math.min(data.length, index);
          for (var i = 0; i <= maxLen; i += 1) {
            var key = getKey(data[i]);
            itemTop = stackTop;
            var cacheHeight = heights.get(key);
            itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            stackTop = itemBottom;
            if (i === index && cacheHeight === undefined) {
              needCollectHeight = true;
            }
          }
          // Scroll to
          var targetTop = null;
          switch (mergedAlign) {
            case 'top':
              targetTop = itemTop - offset;
              break;
            case 'bottom':
              targetTop = itemBottom - height + offset;
              break;
            default:
              {
                var scrollTop = containerRef.current.scrollTop;
                var scrollBottom = scrollTop + height;
                if (itemTop < scrollTop) {
                  newTargetAlign = 'top';
                } else if (itemBottom > scrollBottom) {
                  newTargetAlign = 'bottom';
                }
              }
          }
          if (targetTop !== null && targetTop !== containerRef.current.scrollTop) {
            syncScrollTop(targetTop);
          }
        }
        // We will retry since element may not sync height as it described
        scrollRef.current = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */])(function () {
          if (needCollectHeight) {
            collectHeight();
          }
          syncScroll(times - 1, newTargetAlign);
        }, 2); // Delay 2 to wait for List collect heights
      };

      syncScroll(3);
    }
  };
}

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDiffItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_algorithmUtil__ = __webpack_require__(1266);



function useDiffItem(data, getKey, onDiff) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](data),
    _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
    prevData = _React$useState2[0],
    setPrevData = _React$useState2[1];
  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](null),
    _React$useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState3, 2),
    diffItem = _React$useState4[0],
    setDiffItem = _React$useState4[1];
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    var diff = Object(__WEBPACK_IMPORTED_MODULE_2__utils_algorithmUtil__["a" /* findListDiffIndex */])(prevData || [], data || [], getKey);
    if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
      onDiff === null || onDiff === void 0 ? void 0 : onDiff(diff.index);
      setDiffItem(data[diff.index]);
    }
    setPrevData(data);
  }, [data]);
  return [diffItem];
}

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIndexByStartLoc */
/* harmony export (immutable) */ __webpack_exports__["a"] = findListDiffIndex;
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */
function getIndexByStartLoc(min, max, start, index) {
  var beforeCount = start - min;
  var afterCount = max - start;
  var balanceCount = Math.min(beforeCount, afterCount) * 2;
  // Balance
  if (index <= balanceCount) {
    var stepIndex = Math.floor(index / 2);
    if (index % 2) {
      return start + stepIndex + 1;
    }
    return start - stepIndex;
  }
  // One is out of range
  if (beforeCount > afterCount) {
    return start - (index - afterCount);
  }
  return start + (index - beforeCount);
}
/**
 * We assume that 2 list has only 1 item diff and others keeping the order.
 * So we can use dichotomy algorithm to find changed one.
 */
function findListDiffIndex(originList, targetList, getKey) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== undefined) {
      return getKey(item);
    }
    return notExistKey;
  }
  // Loop to find diff one
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i = 0; i < longList.length; i += 1) {
    var shortKey = getItemKey(shortList[i]);
    var longKey = getItemKey(longList[i]);
    if (shortKey !== longKey) {
      diffIndex = i;
      multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple: multiple
  };
}

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFrameWheel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isFirefox__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useOriginScroll__ = __webpack_require__(614);




function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, onWheelDelta) {
  var offsetRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  var nextFrameRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  // Firefox patch
  var wheelValueRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var isMouseScrollRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  // Scroll status sync
  var originScroll = Object(__WEBPACK_IMPORTED_MODULE_3__useOriginScroll__["a" /* default */])(isScrollAtTop, isScrollAtBottom);
  function onWheel(event) {
    if (!inVirtual) return;
    __WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__["a" /* default */].cancel(nextFrameRef.current);
    var deltaY = event.deltaY;
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;
    // Do nothing when scroll at the edge, Skip check when is in scroll
    if (originScroll(deltaY)) return;
    // Proxy of scroll events
    if (!__WEBPACK_IMPORTED_MODULE_2__utils_isFirefox__["a" /* default */]) {
      event.preventDefault();
    }
    nextFrameRef.current = Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_raf__["a" /* default */])(function () {
      // Patch a multiple for Firefox to fix wheel number too small
      // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple);
      offsetRef.current = 0;
    });
  }
  // A patch for firefox
  function onFireFoxScroll(event) {
    if (!inVirtual) return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(214);

var isFF = (typeof navigator === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
/* harmony default export */ __webpack_exports__["a"] = (isFF);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMobileTouchMove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_hooks_useLayoutEffect__ = __webpack_require__(170);


var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var touchYRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  var elementRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  // Smooth scroll
  var intervalRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  /* eslint-disable prefer-const */
  var cleanUpEvents;
  var onTouchMove = function onTouchMove(e) {
    if (touchedRef.current) {
      var currentY = Math.ceil(e.touches[0].pageY);
      var offsetY = touchYRef.current - currentY;
      touchYRef.current = currentY;
      if (callback(offsetY)) {
        e.preventDefault();
      }
      // Smooth interval
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(function () {
        offsetY *= SMOOTH_PTG;
        if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) {
          clearInterval(intervalRef.current);
        }
      }, 16);
    }
  };
  var onTouchEnd = function onTouchEnd() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart(e) {
    cleanUpEvents();
    if (e.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchYRef.current = Math.ceil(e.touches[0].pageY);
      elementRef.current = e.target;
      elementRef.current.addEventListener('touchmove', onTouchMove);
      elementRef.current.addEventListener('touchend', onTouchEnd);
    }
  };
  cleanUpEvents = function cleanUpEvents() {
    if (elementRef.current) {
      elementRef.current.removeEventListener('touchmove', onTouchMove);
      elementRef.current.removeEventListener('touchend', onTouchEnd);
    }
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    if (inVirtual) {
      listRef.current.addEventListener('touchstart', onTouchStart);
    }
    return function () {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.removeEventListener('touchstart', onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(608);




function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(607);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateSelector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Selector__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SelectTrigger__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interface_generator__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_commonUtil__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TransBtn__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks_useLock__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useDelayReset__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hooks_useLayoutEffect__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_valueUtil__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hooks_useSelectTriggerControl__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hooks_useCacheDisplayValue__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hooks_useCacheOptions__ = __webpack_require__(1333);






/**
 * To match accessibility requirement, we always provide an input in the component.
 * Other element will not set `tabIndex` to avoid `onBlur` sequence problem.
 * For focused select, we set `aria-live="polite"` to update the accessibility content.
 *
 * ref:
 * - keyboard: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role#Keyboard_interactions
 */

















var DEFAULT_OMIT_PROPS = ['removeIcon', 'placeholder', 'autoFocus', 'maxTagCount', 'maxTagTextLength', 'maxTagPlaceholder', 'choiceTransitionName', 'onInputKeyDown', 'tabIndex'];
/**
 * This function is in internal usage.
 * Do not use it in your prod env since we may refactor this.
 */

function generateSelector(config) {
  var defaultPrefixCls = config.prefixCls,
      OptionList = config.components.optionList,
      convertChildrenToData = config.convertChildrenToData,
      flattenOptions = config.flattenOptions,
      getLabeledValue = config.getLabeledValue,
      filterOptions = config.filterOptions,
      isValueDisabled = config.isValueDisabled,
      findValueOption = config.findValueOption,
      warningProps = config.warningProps,
      fillOptionsWithMissingValue = config.fillOptionsWithMissingValue,
      omitDOMProps = config.omitDOMProps; // Use raw define since `React.FC` not support generic

  function Select(props, ref) {
    var _classNames2;

    var _props$prefixCls = props.prefixCls,
        prefixCls = _props$prefixCls === void 0 ? defaultPrefixCls : _props$prefixCls,
        className = props.className,
        id = props.id,
        open = props.open,
        defaultOpen = props.defaultOpen,
        options = props.options,
        children = props.children,
        mode = props.mode,
        value = props.value,
        defaultValue = props.defaultValue,
        labelInValue = props.labelInValue,
        showSearch = props.showSearch,
        inputValue = props.inputValue,
        searchValue = props.searchValue,
        filterOption = props.filterOption,
        filterSort = props.filterSort,
        _props$optionFilterPr = props.optionFilterProp,
        optionFilterProp = _props$optionFilterPr === void 0 ? 'value' : _props$optionFilterPr,
        _props$autoClearSearc = props.autoClearSearchValue,
        autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
        onSearch = props.onSearch,
        allowClear = props.allowClear,
        clearIcon = props.clearIcon,
        showArrow = props.showArrow,
        inputIcon = props.inputIcon,
        menuItemSelectedIcon = props.menuItemSelectedIcon,
        disabled = props.disabled,
        loading = props.loading,
        defaultActiveFirstOption = props.defaultActiveFirstOption,
        _props$notFoundConten = props.notFoundContent,
        notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten,
        optionLabelProp = props.optionLabelProp,
        backfill = props.backfill,
        tabIndex = props.tabIndex,
        getInputElement = props.getInputElement,
        getPopupContainer = props.getPopupContainer,
        _props$listHeight = props.listHeight,
        listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight,
        _props$listItemHeight = props.listItemHeight,
        listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight,
        animation = props.animation,
        transitionName = props.transitionName,
        virtual = props.virtual,
        dropdownStyle = props.dropdownStyle,
        dropdownClassName = props.dropdownClassName,
        dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
        dropdownRender = props.dropdownRender,
        dropdownAlign = props.dropdownAlign,
        _props$showAction = props.showAction,
        showAction = _props$showAction === void 0 ? [] : _props$showAction,
        direction = props.direction,
        tokenSeparators = props.tokenSeparators,
        tagRender = props.tagRender,
        onPopupScroll = props.onPopupScroll,
        onDropdownVisibleChange = props.onDropdownVisibleChange,
        onFocus = props.onFocus,
        onBlur = props.onBlur,
        onKeyUp = props.onKeyUp,
        onKeyDown = props.onKeyDown,
        onMouseDown = props.onMouseDown,
        onChange = props.onChange,
        onSelect = props.onSelect,
        onDeselect = props.onDeselect,
        onClear = props.onClear,
        _props$internalProps = props.internalProps,
        internalProps = _props$internalProps === void 0 ? {} : _props$internalProps,
        restProps = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["prefixCls", "className", "id", "open", "defaultOpen", "options", "children", "mode", "value", "defaultValue", "labelInValue", "showSearch", "inputValue", "searchValue", "filterOption", "filterSort", "optionFilterProp", "autoClearSearchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "inputIcon", "menuItemSelectedIcon", "disabled", "loading", "defaultActiveFirstOption", "notFoundContent", "optionLabelProp", "backfill", "tabIndex", "getInputElement", "getPopupContainer", "listHeight", "listItemHeight", "animation", "transitionName", "virtual", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown", "onChange", "onSelect", "onDeselect", "onClear", "internalProps"]);

    var useInternalProps = internalProps.mark === __WEBPACK_IMPORTED_MODULE_11__interface_generator__["a" /* INTERNAL_PROPS_MARK */];
    var domProps = omitDOMProps ? omitDOMProps(restProps) : restProps;
    DEFAULT_OMIT_PROPS.forEach(function (prop) {
      delete domProps[prop];
    });
    var containerRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
    var triggerRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
    var selectorRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
    var listRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
    var tokenWithEnter = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      return (tokenSeparators || []).some(function (tokenSeparator) {
        return ['\n', '\r\n'].includes(tokenSeparator);
      });
    }, [tokenSeparators]);
    /** Used for component focused management */

    var _useDelayReset = Object(__WEBPACK_IMPORTED_MODULE_15__hooks_useDelayReset__["a" /* default */])(),
        _useDelayReset2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useDelayReset, 3),
        mockFocused = _useDelayReset2[0],
        setMockFocused = _useDelayReset2[1],
        cancelSetMockFocused = _useDelayReset2[2]; // Inner id for accessibility usage. Only work in client side


    var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
        _useState2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
        innerId = _useState2[0],
        setInnerId = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      setInnerId("rc_select_".concat(Object(__WEBPACK_IMPORTED_MODULE_12__utils_commonUtil__["a" /* getUUID */])()));
    }, []);
    var mergedId = id || innerId; // optionLabelProp

    var mergedOptionLabelProp = optionLabelProp;

    if (mergedOptionLabelProp === undefined) {
      mergedOptionLabelProp = options ? 'label' : 'children';
    } // labelInValue


    var mergedLabelInValue = mode === 'combobox' ? false : labelInValue;
    var isMultiple = mode === 'tags' || mode === 'multiple';
    var mergedShowSearch = showSearch !== undefined ? showSearch : isMultiple || mode === 'combobox'; // ============================== Ref ===============================

    var selectorDomRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
    __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](ref, function () {
      var _listRef$current;

      return {
        focus: selectorRef.current.focus,
        blur: selectorRef.current.blur,
        scrollTo: (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo
      };
    }); // ============================= Value ==============================

    var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_hooks_useMergedState__["a" /* default */])(defaultValue, {
      value: value
    }),
        _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
        mergedValue = _useMergedState2[0],
        setMergedValue = _useMergedState2[1];
    /** Unique raw values */


    var mergedRawValue = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils_commonUtil__["e" /* toInnerValue */])(mergedValue, {
        labelInValue: mergedLabelInValue,
        combobox: mode === 'combobox'
      });
    }, [mergedValue, mergedLabelInValue]);
    /** We cache a set of raw values to speed up check */

    var rawValues = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      return new Set(mergedRawValue);
    }, [mergedRawValue]); // ============================= Option =============================
    // Set by option list active, it will merge into search input when mode is `combobox`

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(null),
        _useState4 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
        activeValue = _useState4[0],
        setActiveValue = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(''),
        _useState6 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
        innerSearchValue = _useState6[0],
        setInnerSearchValue = _useState6[1];

    var mergedSearchValue = innerSearchValue;

    if (mode === 'combobox' && mergedValue !== undefined) {
      mergedSearchValue = mergedValue;
    } else if (searchValue !== undefined) {
      mergedSearchValue = searchValue;
    } else if (inputValue) {
      mergedSearchValue = inputValue;
    }

    var mergedOptions = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      var newOptions = options;

      if (newOptions === undefined) {
        newOptions = convertChildrenToData(children);
      }
      /**
       * `tags` should fill un-list item.
       * This is not cool here since TreeSelect do not need this
       */


      if (mode === 'tags' && fillOptionsWithMissingValue) {
        newOptions = fillOptionsWithMissingValue(newOptions, mergedValue, mergedOptionLabelProp, labelInValue);
      }

      return newOptions || [];
    }, [options, children, mode, mergedValue]);
    var mergedFlattenOptions = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      return flattenOptions(mergedOptions, props);
    }, [mergedOptions]);
    var getValueOption = Object(__WEBPACK_IMPORTED_MODULE_20__hooks_useCacheOptions__["a" /* default */])(mergedRawValue, mergedFlattenOptions); // Display options for OptionList

    var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      if (!mergedSearchValue || !mergedShowSearch) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedOptions);
      }

      var filteredOptions = filterOptions(mergedSearchValue, mergedOptions, {
        optionFilterProp: optionFilterProp,
        filterOption: mode === 'combobox' && filterOption === undefined ? function () {
          return true;
        } : filterOption
      });

      if (mode === 'tags' && filteredOptions.every(function (opt) {
        return opt[optionFilterProp] !== mergedSearchValue;
      })) {
        filteredOptions.unshift({
          value: mergedSearchValue,
          label: mergedSearchValue,
          key: '__RC_SELECT_TAG_PLACEHOLDER__'
        });
      }

      if (filterSort && Array.isArray(filteredOptions)) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(filteredOptions).sort(filterSort);
      }

      return filteredOptions;
    }, [mergedOptions, mergedSearchValue, mode, mergedShowSearch, filterSort]);
    var displayFlattenOptions = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      return flattenOptions(displayOptions, props);
    }, [displayOptions]);
    Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (listRef.current && listRef.current.scrollTo) {
        listRef.current.scrollTo(0);
      }
    }, [mergedSearchValue]); // ============================ Selector ============================

    var displayValues = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
      var tmpValues = mergedRawValue.map(function (val) {
        var valueOptions = getValueOption([val]);
        var displayValue = getLabeledValue(val, {
          options: valueOptions,
          prevValue: mergedValue,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        });
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, displayValue), {}, {
          disabled: isValueDisabled(val, valueOptions)
        });
      });

      if (!mode && tmpValues.length === 1 && tmpValues[0].value === null && tmpValues[0].label === null) {
        return [];
      }

      return tmpValues;
    }, [mergedValue, mergedOptions, mode]); // Polyfill with cache label

    displayValues = Object(__WEBPACK_IMPORTED_MODULE_19__hooks_useCacheDisplayValue__["a" /* default */])(displayValues);

    var triggerSelect = function triggerSelect(newValue, isSelect, source) {
      var newValueOption = getValueOption([newValue]);
      var outOption = findValueOption([newValue], newValueOption)[0];

      if (!internalProps.skipTriggerSelect) {
        // Skip trigger `onSelect` or `onDeselect` if configured
        var selectValue = mergedLabelInValue ? getLabeledValue(newValue, {
          options: newValueOption,
          prevValue: mergedValue,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        }) : newValue;

        if (isSelect && onSelect) {
          onSelect(selectValue, outOption);
        } else if (!isSelect && onDeselect) {
          onDeselect(selectValue, outOption);
        }
      } // Trigger internal event


      if (useInternalProps) {
        if (isSelect && internalProps.onRawSelect) {
          internalProps.onRawSelect(newValue, outOption, source);
        } else if (!isSelect && internalProps.onRawDeselect) {
          internalProps.onRawDeselect(newValue, outOption, source);
        }
      }
    }; // We need cache options here in case user update the option list


    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])([]),
        _useState8 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState7, 2),
        prevValueOptions = _useState8[0],
        setPrevValueOptions = _useState8[1];

    var triggerChange = function triggerChange(newRawValues) {
      if (useInternalProps && internalProps.skipTriggerChange) {
        return;
      }

      var newRawValuesOptions = getValueOption(newRawValues);
      var outValues = Object(__WEBPACK_IMPORTED_MODULE_12__utils_commonUtil__["f" /* toOuterValues */])(Array.from(newRawValues), {
        labelInValue: mergedLabelInValue,
        options: newRawValuesOptions,
        getLabeledValue: getLabeledValue,
        prevValue: mergedValue,
        optionLabelProp: mergedOptionLabelProp
      });
      var outValue = isMultiple ? outValues : outValues[0]; // Skip trigger if prev & current value is both empty

      if (onChange && (mergedRawValue.length !== 0 || outValues.length !== 0)) {
        var outOptions = findValueOption(newRawValues, newRawValuesOptions, {
          prevValueOptions: prevValueOptions
        }); // We will cache option in case it removed by ajax

        setPrevValueOptions(outOptions.map(function (option, index) {
          var clone = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, option);

          Object.defineProperty(clone, '_INTERNAL_OPTION_VALUE_', {
            get: function get() {
              return newRawValues[index];
            }
          });
          return clone;
        }));
        onChange(outValue, isMultiple ? outOptions : outOptions[0]);
      }

      setMergedValue(outValue);
    };

    var onInternalSelect = function onInternalSelect(newValue, _ref) {
      var selected = _ref.selected,
          source = _ref.source;

      if (disabled) {
        return;
      }

      var newRawValue;

      if (isMultiple) {
        newRawValue = new Set(mergedRawValue);

        if (selected) {
          newRawValue.add(newValue);
        } else {
          newRawValue.delete(newValue);
        }
      } else {
        newRawValue = new Set();
        newRawValue.add(newValue);
      } // Multiple always trigger change and single should change if value changed


      if (isMultiple || !isMultiple && Array.from(mergedRawValue)[0] !== newValue) {
        triggerChange(Array.from(newRawValue));
      } // Trigger `onSelect`. Single mode always trigger select


      triggerSelect(newValue, !isMultiple || selected, source); // Clean search value if single or configured

      if (mode === 'combobox') {
        setInnerSearchValue(String(newValue));
        setActiveValue('');
      } else if (!isMultiple || autoClearSearchValue) {
        setInnerSearchValue('');
        setActiveValue('');
      }
    };

    var onInternalOptionSelect = function onInternalOptionSelect(newValue, info) {
      onInternalSelect(newValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, info), {}, {
        source: 'option'
      }));
    };

    var onInternalSelectionSelect = function onInternalSelectionSelect(newValue, info) {
      onInternalSelect(newValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, info), {}, {
        source: 'selection'
      }));
    }; // ============================= Input ==============================
    // Only works in `combobox`


    var customizeInputElement = mode === 'combobox' && getInputElement && getInputElement() || null; // ============================== Open ==============================

    var _useMergedState3 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_hooks_useMergedState__["a" /* default */])(undefined, {
      defaultValue: defaultOpen,
      value: open
    }),
        _useMergedState4 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState3, 2),
        innerOpen = _useMergedState4[0],
        setInnerOpen = _useMergedState4[1];

    var mergedOpen = innerOpen; // Not trigger `open` in `combobox` when `notFoundContent` is empty

    var emptyListContent = !notFoundContent && !displayOptions.length;

    if (disabled || emptyListContent && mergedOpen && mode === 'combobox') {
      mergedOpen = false;
    }

    var triggerOpen = emptyListContent ? false : mergedOpen;

    var onToggleOpen = function onToggleOpen(newOpen) {
      var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;

      if (innerOpen !== nextOpen && !disabled) {
        setInnerOpen(nextOpen);

        if (onDropdownVisibleChange) {
          onDropdownVisibleChange(nextOpen);
        }
      }
    };

    Object(__WEBPACK_IMPORTED_MODULE_18__hooks_useSelectTriggerControl__["a" /* default */])([containerRef.current, triggerRef.current && triggerRef.current.getPopupElement()], triggerOpen, onToggleOpen); // ============================= Search =============================

    var triggerSearch = function triggerSearch(searchText, fromTyping, isCompositing) {
      var ret = true;
      var newSearchText = searchText;
      setActiveValue(null); // Check if match the `tokenSeparators`

      var patchLabels = isCompositing ? null : Object(__WEBPACK_IMPORTED_MODULE_17__utils_valueUtil__["f" /* getSeparatedContent */])(searchText, tokenSeparators);
      var patchRawValues = patchLabels;

      if (mode === 'combobox') {
        // Only typing will trigger onChange
        if (fromTyping) {
          triggerChange([newSearchText]);
        }
      } else if (patchLabels) {
        newSearchText = '';

        if (mode !== 'tags') {
          patchRawValues = patchLabels.map(function (label) {
            var item = mergedFlattenOptions.find(function (_ref2) {
              var data = _ref2.data;
              return data[mergedOptionLabelProp] === label;
            });
            return item ? item.data.value : null;
          }).filter(function (val) {
            return val !== null;
          });
        }

        var newRawValues = Array.from(new Set([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedRawValue), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(patchRawValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function (newRawValue) {
          triggerSelect(newRawValue, true, 'input');
        }); // Should close when paste finish

        onToggleOpen(false); // Tell Selector that break next actions

        ret = false;
      }

      setInnerSearchValue(newSearchText);

      if (onSearch && mergedSearchValue !== newSearchText) {
        onSearch(newSearchText);
      }

      return ret;
    }; // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option


    var onSearchSubmit = function onSearchSubmit(searchText) {
      var newRawValues = Array.from(new Set([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedRawValue), [searchText])));
      triggerChange(newRawValues);
      newRawValues.forEach(function (newRawValue) {
        triggerSelect(newRawValue, true, 'input');
      });
      setInnerSearchValue('');
    }; // Close dropdown when disabled change


    Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (innerOpen && !!disabled) {
        setInnerOpen(false);
      }
    }, [disabled]); // Close will clean up single mode search text

    Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (!mergedOpen && !isMultiple && mode !== 'combobox') {
        triggerSearch('', false, false);
      }
    }, [mergedOpen]); // ============================ Keyboard ============================

    /**
     * We record input value here to check if can press to clean up by backspace
     * - null: Key is not down, this is reset by key up
     * - true: Search text is empty when first time backspace down
     * - false: Search text is not empty when first time backspace down
     */

    var _useLock = Object(__WEBPACK_IMPORTED_MODULE_14__hooks_useLock__["a" /* default */])(),
        _useLock2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useLock, 2),
        getClearLock = _useLock2[0],
        setClearLock = _useLock2[1]; // KeyDown


    var onInternalKeyDown = function onInternalKeyDown(event) {
      var clearLock = getClearLock();
      var which = event.which; // We only manage open state here, close logic should handle by list component

      if (!mergedOpen && which === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        onToggleOpen(true);
      }

      setClearLock(!!mergedSearchValue); // Remove value by `backspace`

      if (which === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].BACKSPACE && !clearLock && isMultiple && !mergedSearchValue && mergedRawValue.length) {
        var removeInfo = Object(__WEBPACK_IMPORTED_MODULE_12__utils_commonUtil__["c" /* removeLastEnabledValue */])(displayValues, mergedRawValue);

        if (removeInfo.removedValue !== null) {
          triggerChange(removeInfo.values);
          triggerSelect(removeInfo.removedValue, false, 'input');
        }
      }

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (mergedOpen && listRef.current) {
        var _listRef$current2;

        (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [event].concat(rest));
      }

      if (onKeyDown) {
        onKeyDown.apply(void 0, [event].concat(rest));
      }
    }; // KeyUp


    var onInternalKeyUp = function onInternalKeyUp(event) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      if (mergedOpen && listRef.current) {
        var _listRef$current3;

        (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [event].concat(rest));
      }

      if (onKeyUp) {
        onKeyUp.apply(void 0, [event].concat(rest));
      }
    }; // ========================== Focus / Blur ==========================

    /** Record real focus status */


    var focusRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var onContainerFocus = function onContainerFocus() {
      setMockFocused(true);

      if (!disabled) {
        if (onFocus && !focusRef.current) {
          onFocus.apply(void 0, arguments);
        } // `showAction` should handle `focus` if set


        if (showAction.includes('focus')) {
          onToggleOpen(true);
        }
      }

      focusRef.current = true;
    };

    var onContainerBlur = function onContainerBlur() {
      setMockFocused(false, function () {
        focusRef.current = false;
        onToggleOpen(false);
      });

      if (disabled) {
        return;
      }

      if (mergedSearchValue) {
        // `tags` mode should move `searchValue` into values
        if (mode === 'tags') {
          triggerSearch('', false, false);
          triggerChange(Array.from(new Set([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(mergedRawValue), [mergedSearchValue]))));
        } else if (mode === 'multiple') {
          // `multiple` mode only clean the search value but not trigger event
          setInnerSearchValue('');
        }
      }

      if (onBlur) {
        onBlur.apply(void 0, arguments);
      }
    };

    var activeTimeoutIds = [];
    Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      return function () {
        activeTimeoutIds.forEach(function (timeoutId) {
          return clearTimeout(timeoutId);
        });
        activeTimeoutIds.splice(0, activeTimeoutIds.length);
      };
    }, []);

    var onInternalMouseDown = function onInternalMouseDown(event) {
      var target = event.target;
      var popupElement = triggerRef.current && triggerRef.current.getPopupElement(); // We should give focus back to selector if clicked item is not focusable

      if (popupElement && popupElement.contains(target)) {
        var timeoutId = setTimeout(function () {
          var index = activeTimeoutIds.indexOf(timeoutId);

          if (index !== -1) {
            activeTimeoutIds.splice(index, 1);
          }

          cancelSetMockFocused();

          if (!popupElement.contains(document.activeElement)) {
            selectorRef.current.focus();
          }
        });
        activeTimeoutIds.push(timeoutId);
      }

      if (onMouseDown) {
        for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          restArgs[_key3 - 1] = arguments[_key3];
        }

        onMouseDown.apply(void 0, [event].concat(restArgs));
      }
    }; // ========================= Accessibility ==========================


    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
        _useState10 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState9, 2),
        accessibilityIndex = _useState10[0],
        setAccessibilityIndex = _useState10[1];

    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';

    var onActiveValue = function onActiveValue(active, index) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref3$source = _ref3.source,
          source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;

      setAccessibilityIndex(index);

      if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') {
        setActiveValue(String(active));
      }
    }; // ============================= Popup ==============================


    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(null),
        _useState12 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState11, 2),
        containerWidth = _useState12[0],
        setContainerWidth = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])({}),
        _useState14 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState13, 2),
        forceUpdate = _useState14[1]; // We need force update here since popup dom is render async


    function onPopupMouseEnter() {
      forceUpdate({});
    }

    Object(__WEBPACK_IMPORTED_MODULE_16__hooks_useLayoutEffect__["a" /* default */])(function () {
      if (triggerOpen) {
        var newWidth = Math.ceil(containerRef.current.offsetWidth);

        if (containerWidth !== newWidth) {
          setContainerWidth(newWidth);
        }
      }
    }, [triggerOpen]);
    var popupNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](OptionList, {
      ref: listRef,
      prefixCls: prefixCls,
      id: mergedId,
      open: mergedOpen,
      childrenAsData: !options,
      options: displayOptions,
      flattenOptions: displayFlattenOptions,
      multiple: isMultiple,
      values: rawValues,
      height: listHeight,
      itemHeight: listItemHeight,
      onSelect: onInternalOptionSelect,
      onToggleOpen: onToggleOpen,
      onActiveValue: onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      notFoundContent: notFoundContent,
      onScroll: onPopupScroll,
      searchValue: mergedSearchValue,
      menuItemSelectedIcon: menuItemSelectedIcon,
      virtual: virtual !== false && dropdownMatchSelectWidth !== false,
      onMouseEnter: onPopupMouseEnter
    }); // ============================= Clear ==============================

    var clearNode;

    var onClearMouseDown = function onClearMouseDown() {
      // Trigger internal `onClear` event
      if (useInternalProps && internalProps.onClear) {
        internalProps.onClear();
      }

      if (onClear) {
        onClear();
      }

      triggerChange([]);
      triggerSearch('', false, false);
    };

    if (!disabled && allowClear && (mergedRawValue.length || mergedSearchValue)) {
      clearNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__TransBtn__["a" /* default */], {
        className: "".concat(prefixCls, "-clear"),
        onMouseDown: onClearMouseDown,
        customizeIcon: clearIcon
      }, "\xD7");
    } // ============================= Arrow ==============================


    var mergedShowArrow = showArrow !== undefined ? showArrow : loading || !isMultiple && mode !== 'combobox';
    var arrowNode;

    if (mergedShowArrow) {
      arrowNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__TransBtn__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()("".concat(prefixCls, "-arrow"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: inputIcon,
        customizeIconProps: {
          loading: loading,
          searchValue: mergedSearchValue,
          open: mergedOpen,
          focused: mockFocused,
          showSearch: mergedShowSearch
        }
      });
    } // ============================ Warning =============================


    if (false) {
      warningProps(props);
    } // ============================= Render =============================


    var mergedClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, (_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-multiple"), isMultiple), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-single"), !isMultiple), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-loading"), loading), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object.assign({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
      style: {
        width: 0,
        height: 0,
        display: 'flex',
        overflow: 'hidden',
        opacity: 0
      },
      "aria-live": "polite"
    }, "".concat(mergedRawValue.join(', '))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SelectTrigger__["a" /* default */], {
      ref: triggerRef,
      disabled: disabled,
      prefixCls: prefixCls,
      visible: triggerOpen,
      popupElement: popupNode,
      containerWidth: containerWidth,
      animation: animation,
      transitionName: transitionName,
      dropdownStyle: dropdownStyle,
      dropdownClassName: dropdownClassName,
      direction: direction,
      dropdownMatchSelectWidth: dropdownMatchSelectWidth,
      dropdownRender: dropdownRender,
      dropdownAlign: dropdownAlign,
      getPopupContainer: getPopupContainer,
      empty: !mergedOptions.length,
      getTriggerDOMNode: function getTriggerDOMNode() {
        return selectorDomRef.current;
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Selector__["a" /* default */], Object.assign({}, props, {
      domRef: selectorDomRef,
      prefixCls: prefixCls,
      inputElement: customizeInputElement,
      ref: selectorRef,
      id: mergedId,
      showSearch: mergedShowSearch,
      mode: mode,
      accessibilityIndex: accessibilityIndex,
      multiple: isMultiple,
      tagRender: tagRender,
      values: displayValues,
      open: mergedOpen,
      onToggleOpen: onToggleOpen,
      searchValue: mergedSearchValue,
      activeValue: activeValue,
      onSearch: triggerSearch,
      onSearchSubmit: onSearchSubmit,
      onSelect: onInternalSelectionSelect,
      tokenWithEnter: tokenWithEnter
    }))), arrowNode, clearNode);
  }

  var RefSelect = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](Select);
  return RefSelect;
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function useEvent(callback) {
  var fnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  fnRef.current = callback;
  var memoFn = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultipleSelector__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SingleSelector__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useLock__ = __webpack_require__(627);


/**
 * Cursor rule:
 * 1. Only `showSearch` enabled
 * 2. Only `open` is `true`
 * 3. When typing, set `open` to `true` which hit rule of 2
 *
 * Accessibility:
 * - https://www.w3.org/TR/wai-aria-practices/examples/combobox/aria1.1pattern/listbox-combo.html
 */







var Selector = function Selector(props, ref) {
  var inputRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var compositionStatusRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var prefixCls = props.prefixCls,
      multiple = props.multiple,
      open = props.open,
      mode = props.mode,
      showSearch = props.showSearch,
      tokenWithEnter = props.tokenWithEnter,
      onSearch = props.onSearch,
      onSearchSubmit = props.onSearchSubmit,
      onToggleOpen = props.onToggleOpen,
      onInputKeyDown = props.onInputKeyDown,
      domRef = props.domRef; // ======================= Ref =======================

  __WEBPACK_IMPORTED_MODULE_1_react__["useImperativeHandle"](ref, function () {
    return {
      focus: function focus() {
        inputRef.current.focus();
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  }); // ====================== Input ======================

  var _useLock = Object(__WEBPACK_IMPORTED_MODULE_5__hooks_useLock__["a" /* default */])(0),
      _useLock2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useLock, 2),
      getInputMouseDown = _useLock2[0],
      setInputMouseDown = _useLock2[1];

  var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
    var which = event.which;

    if (which === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP || which === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      event.preventDefault();
    }

    if (onInputKeyDown) {
      onInputKeyDown(event);
    }

    if (which === __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ENTER && mode === 'tags' && !compositionStatusRef.current && !open) {
      // When menu isn't open, OptionList won't trigger a value change
      // So when enter is pressed, the tag's input value should be emitted here to let selector know
      onSearchSubmit(event.target.value);
    }

    if (![__WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].SHIFT, __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].TAB, __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].BACKSPACE, __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].ESC].includes(which)) {
      onToggleOpen(true);
    }
  };
  /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */


  var onInternalInputMouseDown = function onInternalInputMouseDown() {
    setInputMouseDown(true);
  }; // When paste come, ignore next onChange


  var pastedTextRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);

  var triggerOnSearch = function triggerOnSearch(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };

  var onInputCompositionStart = function onInputCompositionStart() {
    compositionStatusRef.current = true;
  };

  var onInputCompositionEnd = function onInputCompositionEnd(e) {
    compositionStatusRef.current = false;
    triggerOnSearch(e.target.value);
  };

  var onInputChange = function onInputChange(event) {
    var value = event.target.value; // Pasted text should replace back to origin content

    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      // CRLF will be treated as a single space for input element
      var replacedText = pastedTextRef.current.replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
      value = value.replace(replacedText, pastedTextRef.current);
    }

    pastedTextRef.current = null;
    triggerOnSearch(value);
  };

  var onInputPaste = function onInputPaste(e) {
    var clipboardData = e.clipboardData;
    var value = clipboardData.getData('text');
    pastedTextRef.current = value;
  };

  var onClick = function onClick(_ref) {
    var target = _ref.target;

    if (target !== inputRef.current) {
      // Should focus input if click the selector
      var isIE = document.body.style.msTouchAction !== undefined;

      if (isIE) {
        setTimeout(function () {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };

  var onMouseDown = function onMouseDown(event) {
    var inputMouseDown = getInputMouseDown();

    if (event.target !== inputRef.current && !inputMouseDown) {
      event.preventDefault();
    }

    if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
      if (open) {
        onSearch('', true, false);
      }

      onToggleOpen();
    }
  }; // ================= Inner Selector ==================


  var sharedProps = {
    inputRef: inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange: onInputChange,
    onInputPaste: onInputPaste,
    onInputCompositionStart: onInputCompositionStart,
    onInputCompositionEnd: onInputCompositionEnd
  };
  var selectNode = multiple ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MultipleSelector__["a" /* default */], Object.assign({}, props, sharedProps)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SingleSelector__["a" /* default */], Object.assign({}, props, sharedProps));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick: onClick,
    onMouseDown: onMouseDown
  }, selectNode);
};

var ForwardSelector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](Selector);
ForwardSelector.displayName = 'Selector';
/* harmony default export */ __webpack_exports__["a"] = (ForwardSelector);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_pickAttrs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_overflow__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransBtn__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useLayoutEffect__ = __webpack_require__(626);











var onPreventMouseDown = function onPreventMouseDown(event) {
  event.preventDefault();
  event.stopPropagation();
};

var SelectSelector = function SelectSelector(props) {
  var id = props.id,
      prefixCls = props.prefixCls,
      values = props.values,
      open = props.open,
      searchValue = props.searchValue,
      inputRef = props.inputRef,
      placeholder = props.placeholder,
      disabled = props.disabled,
      mode = props.mode,
      showSearch = props.showSearch,
      autoFocus = props.autoFocus,
      autoComplete = props.autoComplete,
      accessibilityIndex = props.accessibilityIndex,
      tabIndex = props.tabIndex,
      removeIcon = props.removeIcon,
      maxTagCount = props.maxTagCount,
      maxTagTextLength = props.maxTagTextLength,
      _props$maxTagPlacehol = props.maxTagPlaceholder,
      maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function (omittedValues) {
    return "+ ".concat(omittedValues.length, " ...");
  } : _props$maxTagPlacehol,
      tagRender = props.tagRender,
      onToggleOpen = props.onToggleOpen,
      onSelect = props.onSelect,
      onInputChange = props.onInputChange,
      onInputPaste = props.onInputPaste,
      onInputKeyDown = props.onInputKeyDown,
      onInputMouseDown = props.onInputMouseDown,
      onInputCompositionStart = props.onInputCompositionStart,
      onInputCompositionEnd = props.onInputCompositionEnd;
  var measureRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(0),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      inputWidth = _useState2[0],
      setInputWidth = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var selectionPrefixCls = "".concat(prefixCls, "-selection"); // ===================== Search ======================

  var inputValue = open || mode === 'tags' ? searchValue : '';
  var inputEditable = mode === 'tags' || showSearch && (open || focused); // We measure width and set to the input immediately

  Object(__WEBPACK_IMPORTED_MODULE_8__hooks_useLayoutEffect__["a" /* default */])(function () {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]); // ===================== Render ======================
  // >>> Render Selector Node. Includes Item & Rest

  function defaultRenderSelector(content, itemDisabled, closable, onClose) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(selectionPrefixCls, "-item"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TransBtn__["a" /* default */], {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose,
      customizeIcon: removeIcon
    }, "\xD7"));
  }

  function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
    var onMouseDown = function onMouseDown(e) {
      onPreventMouseDown(e);
      onToggleOpen(true);
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
      onMouseDown: onMouseDown
    }, tagRender({
      label: content,
      value: value,
      disabled: itemDisabled,
      closable: closable,
      onClose: onClose
    }));
  }

  function renderItem(_ref) {
    var itemDisabled = _ref.disabled,
        label = _ref.label,
        value = _ref.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;

    if (typeof maxTagTextLength === 'number') {
      if (typeof label === 'string' || typeof label === 'number') {
        var strLabel = String(displayLabel);

        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }

    var onClose = function onClose(event) {
      if (event) event.stopPropagation();
      onSelect(value, {
        selected: false
      });
    };

    return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(displayLabel, itemDisabled, closable, onClose);
  }

  function renderRest(omittedValues) {
    var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return defaultRenderSelector(content, false);
  } // >>> Input Node


  var inputNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Input__["a" /* default */], {
    ref: inputRef,
    open: open,
    prefixCls: prefixCls,
    id: id,
    inputElement: null,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    accessibilityIndex: accessibilityIndex,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex: tabIndex,
    attrs: Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_pickAttrs__["a" /* default */])(props, true)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0")); // >>> Selections

  var selectionNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_overflow__["a" /* default */], {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem: renderItem,
    renderRest: renderRest,
    suffix: inputNode,
    itemKey: "key",
    maxCount: maxTagCount
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, selectionNode, !values.length && !inputValue && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};

/* harmony default export */ __webpack_exports__["a"] = (SelectSelector);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overflow__ = __webpack_require__(620);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Overflow__["b" /* default */]);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1279);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1280);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(622);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1284);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBatchFrameState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_hooks_useState__ = __webpack_require__(204);




/**
 * State generate. Return a `setState` but it will flush all state with one render to save perf.
 * This is not a realization of `unstable_batchedUpdates`.
 */

function useBatchFrameState() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_hooks_useState__["a" /* default */])({}),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      forceUpdate = _useState2[1];

  var statesRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);
  var walkingIndex = 0;
  var beforeFrameId = 0;

  function createState(defaultValue) {
    var myIndex = walkingIndex;
    walkingIndex += 1; // Fill value if not exist yet

    if (statesRef.current.length < myIndex + 1) {
      statesRef.current[myIndex] = defaultValue;
    } // Return filled as `setState`


    var value = statesRef.current[myIndex];

    function setValue(val) {
      statesRef.current[myIndex] = typeof val === 'function' ? val(statesRef.current[myIndex]) : val;
      __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */].cancel(beforeFrameId); // Flush with batch

      beforeFrameId = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */])(function () {
        forceUpdate({}, true);
      });
    }

    return [value, setValue];
  }

  return createState;
}

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Overflow__ = __webpack_require__(620);


var _excluded = ["component"],
    _excluded2 = ["className"],
    _excluded3 = ["className"];





var InternalRawItem = function InternalRawItem(props, ref) {
  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_5__Overflow__["a" /* OverflowContext */]); // Render directly when context not provided

  if (!context) {
    var _props$component = props.component,
        Component = _props$component === void 0 ? 'div' : _props$component,
        _restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _restProps, {
      ref: ref
    }));
  }

  var contextClassName = context.className,
      restContext = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(context, _excluded2);

  var className = props.className,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded3); // Do not pass context to sub item to avoid multiple measure


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Overflow__["a" /* OverflowContext */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(contextClassName, className)
  }, restContext, restProps)));
};

var RawItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](InternalRawItem);
RawItem.displayName = 'RawItem';
/* harmony default export */ __webpack_exports__["a"] = (RawItem);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_pickAttrs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input__ = __webpack_require__(625);





var SingleSelector = function SingleSelector(props) {
  var inputElement = props.inputElement,
      prefixCls = props.prefixCls,
      id = props.id,
      inputRef = props.inputRef,
      disabled = props.disabled,
      autoFocus = props.autoFocus,
      autoComplete = props.autoComplete,
      accessibilityIndex = props.accessibilityIndex,
      mode = props.mode,
      open = props.open,
      values = props.values,
      placeholder = props.placeholder,
      tabIndex = props.tabIndex,
      showSearch = props.showSearch,
      searchValue = props.searchValue,
      activeValue = props.activeValue,
      maxLength = props.maxLength,
      onInputKeyDown = props.onInputKeyDown,
      onInputMouseDown = props.onInputMouseDown,
      onInputChange = props.onInputChange,
      onInputPaste = props.onInputPaste,
      onInputCompositionStart = props.onInputCompositionStart,
      onInputCompositionEnd = props.onInputCompositionEnd;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](false),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      inputChanged = _React$useState2[0],
      setInputChanged = _React$useState2[1];

  var combobox = mode === 'combobox';
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || '';

  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]); // Not show text when closed expect combobox mode

  var hasTextInput = mode !== 'combobox' && !open ? false : !!inputValue;
  var title = item && (typeof item.label === 'string' || typeof item.label === 'number') ? item.label.toString() : undefined;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Input__["a" /* default */], {
    ref: inputRef,
    prefixCls: prefixCls,
    id: id,
    open: open,
    inputElement: inputElement,
    disabled: disabled,
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    editable: inputEditable,
    accessibilityIndex: accessibilityIndex,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e) {
      setInputChanged(true);
      onInputChange(e);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex: tabIndex,
    attrs: Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_pickAttrs__["a" /* default */])(props, true),
    maxLength: combobox ? maxLength : undefined
  })), !combobox && item && !hasTextInput && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title: title
  }, item.label), !item && !hasTextInput && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: "".concat(prefixCls, "-selection-placeholder")
  }, placeholder));
};

/* harmony default export */ __webpack_exports__["a"] = (SingleSelector);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_trigger__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);







var getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
  // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
  var adjustX = typeof dropdownMatchSelectWidth !== 'number' ? 0 : 1;
  return {
    bottomLeft: {
      points: ['tl', 'bl'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ['tr', 'br'],
      offset: [0, 4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      }
    },
    topLeft: {
      points: ['bl', 'tl'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      }
    },
    topRight: {
      points: ['br', 'tr'],
      offset: [0, -4],
      overflow: {
        adjustX: adjustX,
        adjustY: 1
      }
    }
  };
};

var SelectTrigger = function SelectTrigger(props, ref) {
  var prefixCls = props.prefixCls,
      disabled = props.disabled,
      visible = props.visible,
      children = props.children,
      popupElement = props.popupElement,
      containerWidth = props.containerWidth,
      animation = props.animation,
      transitionName = props.transitionName,
      dropdownStyle = props.dropdownStyle,
      dropdownClassName = props.dropdownClassName,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'ltr' : _props$direction,
      _props$dropdownMatchS = props.dropdownMatchSelectWidth,
      dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS,
      dropdownRender = props.dropdownRender,
      dropdownAlign = props.dropdownAlign,
      getPopupContainer = props.getPopupContainer,
      empty = props.empty,
      getTriggerDOMNode = props.getTriggerDOMNode,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode"]);

  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;

  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }

  var builtInPlacements = __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"](function () {
    return getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [dropdownMatchSelectWidth]); // ===================== Motion ======================

  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName; // ======================= Ref =======================

  var popupRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      getPopupElement: function getPopupElement() {
        return popupRef.current;
      }
    };
  });

  var popupStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    minWidth: containerWidth
  }, dropdownStyle);

  if (typeof dropdownMatchSelectWidth === 'number') {
    popupStyle.width = dropdownMatchSelectWidth;
  } else if (dropdownMatchSelectWidth) {
    popupStyle.width = containerWidth;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_trigger__["a" /* default */], Object.assign({}, restProps, {
    showAction: [],
    hideAction: [],
    popupPlacement: direction === 'rtl' ? 'bottomRight' : 'bottomLeft',
    builtinPlacements: builtInPlacements,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      ref: popupRef
    }, popupNode),
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer: getPopupContainer,
    popupClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dropdownClassName, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
    popupStyle: popupStyle,
    getTriggerDOMNode: getTriggerDOMNode
  }), children);
};

var RefSelectTrigger = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](SelectTrigger);
RefSelectTrigger.displayName = 'SelectTrigger';
/* harmony default export */ __webpack_exports__["a"] = (RefSelectTrigger);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(282);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(629);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1295);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1299);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(630);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);


function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }

  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);

  for (var i = 0; i < placements.length; i += 1) {
    var placement = placements[i];

    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }

  return '';
}

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_isMobile__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Mask__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PopupInner__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MobilePopupInner__ = __webpack_require__(1327);




var _excluded = ["visible", "mobile"];






var Popup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function (_ref, ref) {
  var visible = _ref.visible,
      mobile = _ref.mobile,
      props = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(visible),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      innerVisible = _useState2[0],
      serInnerVisible = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      inMobile = _useState4[0],
      setInMobile = _useState4[1];

  var cloneProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
    visible: innerVisible
  }); // We check mobile in visible changed here.
  // And this also delay set `innerVisible` to avoid popup component render flash


  Object(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
    serInnerVisible(visible);

    if (visible && mobile) {
      setInMobile(Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_isMobile__["a" /* default */])());
    }
  }, [visible, mobile]);
  var popupNode = inMobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__MobilePopupInner__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, cloneProps, {
    mobile: mobile,
    ref: ref
  })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PopupInner__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, cloneProps, {
    ref: ref
  })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Mask__["a" /* default */], cloneProps), popupNode);
});
Popup.displayName = 'Popup';
/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1305);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1308);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Mask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_legacyUtil__ = __webpack_require__(633);






function Mask(props) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      mask = props.mask,
      maskMotion = props.maskMotion,
      maskAnimation = props.maskAnimation,
      maskTransitionName = props.maskTransitionName;

  if (!mask) {
    return null;
  }

  var motion = {};

  if (maskMotion || maskTransitionName || maskAnimation) {
    motion = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      motionAppear: true
    }, Object(__WEBPACK_IMPORTED_MODULE_5__utils_legacyUtil__["a" /* getMotion */])({
      motion: maskMotion,
      prefixCls: prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    }));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_motion__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, motion, {
    visible: visible,
    removeOnLeave: true
  }), function (_ref) {
    var className = _ref.className;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
      style: {
        zIndex: zIndex
      },
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-mask"), className)
    });
  });
}

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_align__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useLayoutEffect__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useVisibleStatus__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_legacyUtil__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__useStretchStyle__ = __webpack_require__(1326);












var PopupInner = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function (props, ref) {
  var visible = props.visible,
      prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      children = props.children,
      zIndex = props.zIndex,
      stretch = props.stretch,
      destroyPopupOnHide = props.destroyPopupOnHide,
      forceRender = props.forceRender,
      align = props.align,
      point = props.point,
      getRootDomNode = props.getRootDomNode,
      getClassNameFromAlign = props.getClassNameFromAlign,
      onAlign = props.onAlign,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseDown = props.onMouseDown,
      onTouchStart = props.onTouchStart,
      onClick = props.onClick;
  var alignRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  var elementRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      alignedClassName = _useState2[0],
      setAlignedClassName = _useState2[1]; // ======================= Measure ========================


  var _useStretchStyle = Object(__WEBPACK_IMPORTED_MODULE_10__useStretchStyle__["a" /* default */])(stretch),
      _useStretchStyle2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useStretchStyle, 2),
      stretchStyle = _useStretchStyle2[0],
      measureStretchStyle = _useStretchStyle2[1];

  function doMeasure() {
    if (stretch) {
      measureStretchStyle(getRootDomNode());
    }
  } // ======================== Status ========================


  var _useVisibleStatus = Object(__WEBPACK_IMPORTED_MODULE_8__useVisibleStatus__["a" /* default */])(visible, doMeasure),
      _useVisibleStatus2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useVisibleStatus, 2),
      status = _useVisibleStatus2[0],
      goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================

  /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */


  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(0),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      alignTimes = _useState4[0],
      setAlignTimes = _useState4[1];

  var prepareResolveRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    if (status === 'alignPre') {
      setAlignTimes(0);
    }
  }, [status]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align

  function getAlignTarget() {
    if (point) {
      return point;
    }

    return getRootDomNode;
  }

  function forceAlign() {
    var _alignRef$current;

    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
  }

  function onInternalAlign(popupDomNode, matchAlign) {
    var nextAlignedClassName = getClassNameFromAlign(matchAlign);

    if (alignedClassName !== nextAlignedClassName) {
      setAlignedClassName(nextAlignedClassName);
    } // We will retry multi times to make sure that the element has been align in the right position.


    setAlignTimes(function (val) {
      return val + 1;
    });

    if (status === 'align') {
      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
    }
  } // Delay to go to next status


  Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    if (status === 'align') {
      // Repeat until not more align needed
      if (alignTimes < 3) {
        forceAlign();
      } else {
        goNextStatus(function () {
          var _prepareResolveRef$cu;

          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
        });
      }
    }
  }, [alignTimes]); // ======================== Motion ========================

  var motion = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_legacyUtil__["a" /* getMotion */])(props));

  ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd'].forEach(function (eventName) {
    var originHandler = motion[eventName];

    motion[eventName] = function (element, event) {
      goNextStatus();
      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
    };
  });

  function onShowPrepare() {
    return new Promise(function (resolve) {
      prepareResolveRef.current = resolve;
    });
  } // Go to stable directly when motion not provided


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!motion.motionName && status === 'motion') {
      goNextStatus();
    }
  }, [motion.motionName, status]); // ========================= Refs =========================

  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      forceAlign: forceAlign,
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, stretchStyle), {}, {
    zIndex: zIndex,
    opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
  }, style); // Align status


  var alignDisabled = true;

  if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) {
    alignDisabled = false;
  }

  var childNode = children; // Wrapper when multiple children

  if (__WEBPACK_IMPORTED_MODULE_3_react__["Children"].count(children) > 1) {
    childNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_rc_motion__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    visible: visible,
    ref: elementRef,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }, motion, {
    onAppearPrepare: onShowPrepare,
    onEnterPrepare: onShowPrepare,
    removeOnLeave: destroyPopupOnHide,
    forceRender: forceRender
  }), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, className, alignedClassName, motionClassName);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_align__["a" /* default */], {
      target: getAlignTarget(),
      key: "popup",
      ref: alignRef,
      monitorWindowResize: true,
      disabled: alignDisabled,
      align: align,
      onAlign: onInternalAlign
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      ref: motionRef,
      className: mergedClassName,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDownCapture: onMouseDown,
      onTouchStartCapture: onTouchStart,
      onClick: onClick,
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle), mergedStyle)
    }, childNode));
  });
});
PopupInner.displayName = 'PopupInner';
/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1312);
// export this package's api

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_align__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_isEqual__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_isVisible__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_hooks_useLayoutEffect__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_ref__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useBuffer__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(1322);



/**
 * Removed props:
 *  - childrenProps
 */










function getElement(func) {
  if (typeof func !== 'function') return null;
  return func();
}

function getPoint(point) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(point) !== 'object' || !point) return null;
  return point;
}

var Align = function Align(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      target = _ref.target,
      align = _ref.align,
      onAlign = _ref.onAlign,
      monitorWindowResize = _ref.monitorWindowResize,
      _ref$monitorBufferTim = _ref.monitorBufferTime,
      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = __WEBPACK_IMPORTED_MODULE_8_react___default.a.useRef({});
  /** Popup node ref */

  var nodeRef = __WEBPACK_IMPORTED_MODULE_8_react___default.a.useRef();
  var childNode = __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(children); // ===================== Align ======================
  // We save the props here to avoid closure makes props ood

  var forceAlignPropsRef = __WEBPACK_IMPORTED_MODULE_8_react___default.a.useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.align = align;
  forceAlignPropsRef.current.onAlign = onAlign;

  var _useBuffer = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useBuffer__["a" /* default */])(function () {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
        latestDisabled = _forceAlignPropsRef$c.disabled,
        latestTarget = _forceAlignPropsRef$c.target,
        latestAlign = _forceAlignPropsRef$c.align,
        latestOnAlign = _forceAlignPropsRef$c.onAlign;
    var source = nodeRef.current;

    if (!latestDisabled && latestTarget && source) {
      var _result;

      var _element = getElement(latestTarget);

      var _point = getPoint(latestTarget);

      cacheRef.current.element = _element;
      cacheRef.current.point = _point;
      cacheRef.current.align = latestAlign; // IE lose focus after element realign
      // We should record activeElement and restore later

      var _document = document,
          activeElement = _document.activeElement; // We only align when element is visible

      if (_element && Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_isVisible__["a" /* default */])(_element)) {
        _result = Object(__WEBPACK_IMPORTED_MODULE_2_dom_align__["a" /* alignElement */])(source, _element, latestAlign);
      } else if (_point) {
        _result = Object(__WEBPACK_IMPORTED_MODULE_2_dom_align__["b" /* alignPoint */])(source, _point, latestAlign);
      }

      Object(__WEBPACK_IMPORTED_MODULE_10__util__["c" /* restoreFocus */])(activeElement, source);

      if (latestOnAlign && _result) {
        latestOnAlign(source, _result);
      }

      return true;
    }

    return false;
  }, monitorBufferTime),
      _useBuffer2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useBuffer, 2),
      _forceAlign = _useBuffer2[0],
      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
  // Handle props change


  var _React$useState = __WEBPACK_IMPORTED_MODULE_8_react___default.a.useState(),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      element = _React$useState2[0],
      setElement = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_8_react___default.a.useState(),
      _React$useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState3, 2),
      point = _React$useState4[0],
      setPoint = _React$useState4[1];

  Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_hooks_useLayoutEffect__["a" /* default */])(function () {
    setElement(getElement(target));
    setPoint(getPoint(target));
  });
  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    if (cacheRef.current.element !== element || !Object(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* isSamePoint */])(cacheRef.current.point, point) || !Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_isEqual__["a" /* default */])(cacheRef.current.align, align)) {
      _forceAlign();
    }
  }); // Watch popup element resize

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    var cancelFn = Object(__WEBPACK_IMPORTED_MODULE_10__util__["b" /* monitorResize */])(nodeRef.current, _forceAlign);
    return cancelFn;
  }, [nodeRef.current]); // Watch target element resize

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    var cancelFn = Object(__WEBPACK_IMPORTED_MODULE_10__util__["b" /* monitorResize */])(element, _forceAlign);
    return cancelFn;
  }, [element]); // Listen for disabled change

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]); // Listen for window resize

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    if (monitorWindowResize) {
      var cancelFn = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', _forceAlign);
      return cancelFn.remove;
    }
  }, [monitorWindowResize]); // Clear all if unmount

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useEffect(function () {
    return function () {
      cancelForceAlign();
    };
  }, []); // ====================== Ref =======================

  __WEBPACK_IMPORTED_MODULE_8_react___default.a.useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  }); // ===================== Render =====================

  if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.isValidElement(childNode)) {
    childNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(childNode, {
      ref: Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_ref__["a" /* composeRef */])(childNode.ref, nodeRef)
    });
  }

  return childNode;
};

var RcAlign = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.forwardRef(Align);
RcAlign.displayName = 'Align';
/* harmony default export */ __webpack_exports__["a"] = (RcAlign);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1316);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(55);



/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */
function isEqual(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
  var refSet = new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var circular = refSet.has(a);
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(!circular, 'Warning: There may be circular references');
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) === 'object') {
      var keys = Object.keys(a);
      if (keys.length !== Object.keys(b).length) {
        return false;
      }
      return keys.every(function (key) {
        return deepEqual(a[key], b[key], newLevel);
      });
    }
    // other
    return false;
  }
  return deepEqual(obj1, obj2);
}
/* harmony default export */ __webpack_exports__["a"] = (isEqual);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function (callback, buffer) {
  var calledRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var timeoutRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);

  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }

  function trigger(force) {
    cancelTrigger();

    if (!calledRef.current || force === true) {
      if (callback(force) === false) {
        // Not delay since callback cancelled self
        return;
      }

      calledRef.current = true;
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
      }, buffer);
    } else {
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }

  return [trigger, function () {
    calledRef.current = false;
    cancelTrigger();
  }];
});

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = restoreFocus;
/* harmony export (immutable) */ __webpack_exports__["b"] = monitorResize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_contains__ = __webpack_require__(379);



function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}
function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement) && typeof activeElement.focus === 'function') {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;

  function onResize(_ref) {
    var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 1),
        target = _ref2[0].target;

    if (!document.documentElement.contains(target)) return;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
      Promise.resolve().then(function () {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }

    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }

  var resizeObserver = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["default"](onResize);

  if (element) {
    resizeObserver.observe(element);
  }

  return function () {
    resizeObserver.disconnect();
  };
}

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_regeneratorRuntime__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_asyncToGenerator__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useState__ = __webpack_require__(204);






/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */

var StatusQueue = ['measure', 'alignPre', 'align', null, 'motion'];
/* harmony default export */ __webpack_exports__["a"] = (function (visible, doMeasure) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useState__["a" /* default */])(null),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      status = _useState2[0],
      setInternalStatus = _useState2[1];

  var rafRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

  function setStatus(nextStatus) {
    setInternalStatus(nextStatus, true);
  }

  function cancelRaf() {
    __WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__["a" /* default */].cancel(rafRef.current);
  }

  function goNextStatus(callback) {
    cancelRaf();
    rafRef.current = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__["a" /* default */])(function () {
      // Only align should be manually trigger
      setStatus(function (prev) {
        switch (status) {
          case 'align':
            return 'motion';

          case 'motion':
            return 'stable';

          default:
        }

        return prev;
      });
      callback === null || callback === void 0 ? void 0 : callback();
    });
  } // Init status


  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    setStatus('measure');
  }, [visible]); // Go next status

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    switch (status) {
      case 'measure':
        doMeasure();
        break;

      default:
    }

    if (status) {
      rafRef.current = Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_raf__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_asyncToGenerator__["a" /* default */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_regeneratorRuntime__["a" /* default */])().mark(function _callee() {
        var index, nextStatus;
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_regeneratorRuntime__["a" /* default */])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = StatusQueue.indexOf(status);
                nextStatus = StatusQueue[index + 1];

                if (nextStatus && index !== -1) {
                  setStatus(nextStatus);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, [status]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    return function () {
      cancelRaf();
    };
  }, []);
  return [status, goNextStatus];
});

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _regeneratorRuntime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(282);

function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _asyncToGenerator;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (stretch) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"]({
    width: 0,
    height: 0
  }),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      targetSize = _React$useState2[0],
      setTargetSize = _React$useState2[1];

  function measureStretch(element) {
    var tgtWidth = element.offsetWidth,
        tgtHeight = element.offsetHeight;

    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near


    if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
      tgtWidth = width;
      tgtHeight = height;
    }

    setTargetSize({
      width: tgtWidth,
      height: tgtHeight
    });
  } // Merge stretch style


  var style = __WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function () {
    var sizeStyle = {};

    if (stretch) {
      var width = targetSize.width,
          height = targetSize.height; // Stretch with target

      if (stretch.indexOf('height') !== -1 && height) {
        sizeStyle.height = height;
      } else if (stretch.indexOf('minHeight') !== -1 && height) {
        sizeStyle.minHeight = height;
      }

      if (stretch.indexOf('width') !== -1 && width) {
        sizeStyle.width = width;
      } else if (stretch.indexOf('minWidth') !== -1 && width) {
        sizeStyle.minWidth = width;
      }
    }

    return sizeStyle;
  }, [stretch, targetSize]);
  return [style, measureStretch];
});

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);





var MobilePopupInner = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function (props, ref) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      children = props.children,
      _props$mobile = props.mobile;
  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
  var popupClassName = _props$mobile.popupClassName,
      popupStyle = _props$mobile.popupStyle,
      _props$mobile$popupMo = _props$mobile.popupMotion,
      popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo,
      popupRender = _props$mobile.popupRender,
      onClick = props.onClick;
  var elementRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // ========================= Refs =========================

  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](ref, function () {
    return {
      forceAlign: function forceAlign() {},
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    zIndex: zIndex
  }, popupStyle);

  var childNode = children; // Wrapper when multiple children

  if (__WEBPACK_IMPORTED_MODULE_2_react__["Children"].count(children) > 1) {
    childNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  } // Mobile support additional render


  if (popupRender) {
    childNode = popupRender(childNode);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_motion__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    visible: visible,
    ref: elementRef,
    removeOnLeave: true
  }, popupMotion), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls, popupClassName, motionClassName);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
      ref: motionRef,
      className: mergedClassName,
      onClick: onClick,
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle), mergedStyle)
    }, childNode);
  });
});
MobilePopupInner.displayName = 'MobilePopupInner';
/* harmony default export */ __webpack_exports__["a"] = (MobilePopupInner);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TriggerContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
/* harmony default export */ __webpack_exports__["a"] = (TriggerContext);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTERNAL_PROPS_MARK; });
var INTERNAL_PROPS_MARK = 'RC_SELECT_INTERNAL_PROPS_MARK';

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDelayReset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Similar with `useLock`, but this hook will always execute last value.
 * When set to `true`, it will keep `true` for a short time even if `false` is set.
 */

function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](false),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      bool = _React$useState2[0],
      setBool = _React$useState2[1];

  var delayRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](null);

  var cancelLatest = function cancelLatest() {
    window.clearTimeout(delayRef.current);
  };

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    return cancelLatest;
  }, []);

  var delaySetBool = function delaySetBool(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function () {
      setBool(value);

      if (callback) {
        callback();
      }
    }, timeout);
  };

  return [bool, delaySetBool, cancelLatest];
}

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSelectTriggerControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function useSelectTriggerControl(elements, open, triggerOpen) {
  var propsRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  propsRef.current = {
    elements: elements.filter(function (e) {
      return e;
    }),
    open: open,
    triggerOpen: triggerOpen
  };
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    function onGlobalMouseDown(event) {
      var target = event.target;

      if (propsRef.current.open && propsRef.current.elements.every(function (element) {
        return !element.contains(target) && element !== target;
      })) {
        // Should trigger close
        propsRef.current.triggerOpen(false);
      }
    }

    window.addEventListener('mousedown', onGlobalMouseDown);
    return function () {
      return window.removeEventListener('mousedown', onGlobalMouseDown);
    };
  }, []);
}

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCacheDisplayValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function useCacheDisplayValue(values) {
  var prevValuesRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](values);
  var mergedValues = __WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function () {
    // Create value - label map
    var valueLabels = new Map();
    prevValuesRef.current.forEach(function (_ref) {
      var value = _ref.value,
          label = _ref.label;

      if (value !== label) {
        valueLabels.set(value, label);
      }
    });
    var resultValues = values.map(function (item) {
      var cacheLabel = valueLabels.get(item.value);

      if (item.isCacheable && cacheLabel) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, item), {}, {
          label: cacheLabel
        });
      }

      return item;
    });
    prevValuesRef.current = resultValues;
    return resultValues;
  }, [values]);
  return mergedValues;
}

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCacheOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function useCacheOptions(values, options) {
  var prevOptionMapRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var optionMap = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    var map = new Map();
    options.forEach(function (item) {
      var value = item.data.value;
      map.set(value, item);
    });
    return map;
  }, [values, options]);
  prevOptionMapRef.current = optionMap;

  var getValueOption = function getValueOption(vals) {
    return vals.map(function (value) {
      return prevOptionMapRef.current.get(value);
    }).filter(Boolean);
  };

  return getValueOption;
}

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__legacyUtil__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonUtil__ = __webpack_require__(281);







function warningProps(props) {
  var mode = props.mode,
      options = props.options,
      children = props.children,
      backfill = props.backfill,
      allowClear = props.allowClear,
      placeholder = props.placeholder,
      getInputElement = props.getInputElement,
      showSearch = props.showSearch,
      onSearch = props.onSearch,
      defaultOpen = props.defaultOpen,
      autoFocus = props.autoFocus,
      labelInValue = props.labelInValue,
      value = props.value,
      inputValue = props.inputValue,
      optionLabelProp = props.optionLabelProp;
  var multiple = mode === 'multiple' || mode === 'tags';
  var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
  var mergedOptions = options || Object(__WEBPACK_IMPORTED_MODULE_4__legacyUtil__["a" /* convertChildrenToData */])(children); // `tags` should not set option as disabled

  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(mode !== 'tags' || mergedOptions.every(function (opt) {
    return !opt.disabled;
  }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.'); // `combobox` & `tags` should option be `string` type

  if (mode === 'tags' || mode === 'combobox') {
    var hasNumberValue = mergedOptions.some(function (item) {
      if (item.options) {
        return item.options.some(function (opt) {
          return typeof ('value' in opt ? opt.value : opt.key) === 'number';
        });
      }

      return typeof ('value' in item ? item.value : item.key) === 'number';
    });
    Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
  } // `combobox` should not use `optionLabelProp`


  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.'); // Only `combobox` support `backfill`

  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.'); // Only `combobox` support `getInputElement`

  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.'); // Customize `getInputElement` should not use `allowClear` & `placeholder`

  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["b" /* noteOnce */])(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.'); // `onSearch` should use in `combobox` or `showSearch`

  if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') {
    Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(false, '`onSearch` should work with `showSearch` instead of use alone.');
  }

  Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["b" /* noteOnce */])(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');

  if (value !== undefined && value !== null) {
    var values = Object(__WEBPACK_IMPORTED_MODULE_5__commonUtil__["d" /* toArray */])(value);
    Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(!labelInValue || values.every(function (val) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(val) === 'object' && ('key' in val || 'value' in val);
    }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
    Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
  } // Syntactic sugar should use correct children type


  if (children) {
    var invalidateChildType = null;
    Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_toArray__["a" /* default */])(children).some(function (node) {
      if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"](node) || !node.type) {
        return false;
      }

      var type = node.type;

      if (type.isSelectOption) {
        return false;
      }

      if (type.isSelectOptGroup) {
        var allChildrenValid = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_Children_toArray__["a" /* default */])(node.props.children).every(function (subNode) {
          if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"](subNode) || !node.type || subNode.type.isSelectOption) {
            return true;
          }

          invalidateChildType = subNode.type;
          return false;
        });

        if (allChildrenValid) {
          return false;
        }

        return true;
      }

      invalidateChildType = type;
      return true;
    });

    if (invalidateChildType) {
      Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_warning__["a" /* default */])(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
  }
}

/* harmony default export */ __webpack_exports__["a"] = (warningProps);

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIcons;

var React = _interopRequireWildcard(__webpack_require__(0));

var _DownOutlined = _interopRequireDefault(__webpack_require__(216));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var _CheckOutlined = _interopRequireDefault(__webpack_require__(635));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _SearchOutlined = _interopRequireDefault(__webpack_require__(636));

function getIcons(_ref) {
  var suffixIcon = _ref.suffixIcon,
      clearIcon = _ref.clearIcon,
      menuItemSelectedIcon = _ref.menuItemSelectedIcon,
      removeIcon = _ref.removeIcon,
      loading = _ref.loading,
      multiple = _ref.multiple,
      prefixCls = _ref.prefixCls;
  // Clear Icon
  var mergedClearIcon = clearIcon;

  if (!clearIcon) {
    mergedClearIcon = /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], null);
  } // Arrow item icon


  var mergedSuffixIcon = null;

  if (suffixIcon !== undefined) {
    mergedSuffixIcon = suffixIcon;
  } else if (loading) {
    mergedSuffixIcon = /*#__PURE__*/React.createElement(_LoadingOutlined["default"], {
      spin: true
    });
  } else {
    var iconCls = "".concat(prefixCls, "-suffix");

    mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
      var open = _ref2.open,
          showSearch = _ref2.showSearch;

      if (open && showSearch) {
        return /*#__PURE__*/React.createElement(_SearchOutlined["default"], {
          className: iconCls
        });
      }

      return /*#__PURE__*/React.createElement(_DownOutlined["default"], {
        className: iconCls
      });
    };
  } // Checked item icon


  var mergedItemIcon = null;

  if (menuItemSelectedIcon !== undefined) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /*#__PURE__*/React.createElement(_CheckOutlined["default"], null);
  } else {
    mergedItemIcon = null;
  }

  var mergedRemoveIcon = null;

  if (removeIcon !== undefined) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /*#__PURE__*/React.createElement(_CloseOutlined["default"], null);
  }

  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _DownOutlined = _interopRequireDefault(__webpack_require__(1337));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _DownOutlined.default
  }));
};
DownOutlined.displayName = 'DownOutlined';
var _default = /*#__PURE__*/React.forwardRef(DownOutlined);
exports.default = _default;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
exports.default = DownOutlined;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CheckOutlined = _interopRequireDefault(__webpack_require__(1339));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CheckOutlined.default
  }));
};
CheckOutlined.displayName = 'CheckOutlined';
var _default = /*#__PURE__*/React.forwardRef(CheckOutlined);
exports.default = _default;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
exports.default = CheckOutlined;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
exports.default = SearchOutlined;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaginationParam = getPaginationParam;
exports["default"] = usePagination;
exports.DEFAULT_PAGE_SIZE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _react = __webpack_require__(0);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var DEFAULT_PAGE_SIZE = 10;
exports.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;

function getPaginationParam(pagination, mergedPagination) {
  var param = {
    current: mergedPagination.current,
    pageSize: mergedPagination.pageSize
  };
  var paginationObj = pagination && (0, _typeof2["default"])(pagination) === 'object' ? pagination : {};
  Object.keys(paginationObj).forEach(function (pageProp) {
    var value = mergedPagination[pageProp];

    if (typeof value !== 'function') {
      param[pageProp] = value;
    }
  });
  return param;
}

function extendsObject() {
  var result = {};

  for (var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++) {
    list[_key] = arguments[_key];
  }

  list.forEach(function (obj) {
    if (obj) {
      Object.keys(obj).forEach(function (key) {
        var val = obj[key];

        if (val !== undefined) {
          result[key] = val;
        }
      });
    }
  });
  return result;
}

function usePagination(total, pagination, onChange) {
  var _a = pagination && (0, _typeof2["default"])(pagination) === 'object' ? pagination : {},
      _a$total = _a.total,
      paginationTotal = _a$total === void 0 ? 0 : _a$total,
      paginationObj = __rest(_a, ["total"]);

  var _useState = (0, _react.useState)(function () {
    return {
      current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
      pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : DEFAULT_PAGE_SIZE
    };
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerPagination = _useState2[0],
      setInnerPagination = _useState2[1]; // ============ Basic Pagination Config ============


  var mergedPagination = extendsObject(innerPagination, paginationObj, {
    total: paginationTotal > 0 ? paginationTotal : total
  });

  if (!paginationTotal) {
    // Reset `current` if data length changed. Only reset when paginationObj do not have total
    var maxPage = Math.ceil(total / mergedPagination.pageSize);

    if (maxPage < mergedPagination.current) {
      mergedPagination.current = 1;
    }
  }

  var refreshPagination = function refreshPagination() {
    var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var pageSize = arguments.length > 1 ? arguments[1] : undefined;
    setInnerPagination({
      current: current,
      pageSize: pageSize || mergedPagination.pageSize
    });
  };

  var onInternalChange = function onInternalChange(current, pageSize) {
    var paginationPageSize = mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize;

    if (pageSize && pageSize !== paginationPageSize) {
      current = 1;
    }

    if (pagination && pagination.onChange) pagination.onChange(current, pageSize);
    refreshPagination(current, pageSize);
    onChange(current, pageSize || paginationPageSize);
  };

  if (pagination === false) {
    return [{}, function () {}];
  }

  return [(0, _extends2["default"])((0, _extends2["default"])({}, mergedPagination), {
    onChange: onInternalChange
  }), refreshPagination];
}

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useLazyKVMap;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

function useLazyKVMap(data, childrenColumnName, getRowKey) {
  var mapCacheRef = React.useRef({});

  function getRecordByKey(key) {
    if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
      /* eslint-disable no-inner-declarations */
      var dig = function dig(records) {
        records.forEach(function (record, index) {
          var rowKey = getRowKey(record, index);
          kvMap.set(rowKey, record);

          if (record && (0, _typeof2["default"])(record) === 'object' && childrenColumnName in record) {
            dig(record[childrenColumnName] || []);
          }
        });
      };
      /* eslint-enable */


      var kvMap = new Map();
      dig(data);
      mapCacheRef.current = {
        data: data,
        childrenColumnName: childrenColumnName,
        kvMap: kvMap,
        getRowKey: getRowKey
      };
    }

    return mapCacheRef.current.kvMap.get(key);
  }

  return [getRecordByKey];
}

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSelection;
exports.SELECTION_NONE = exports.SELECTION_INVERT = exports.SELECTION_ALL = void 0;

var _toArray2 = _interopRequireDefault(__webpack_require__(1344));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _DownOutlined = _interopRequireDefault(__webpack_require__(216));

var _treeUtil = __webpack_require__(637);

var _conductUtil = __webpack_require__(1363);

var _util = __webpack_require__(382);

var _rcTable = __webpack_require__(570);

var _useMergedState3 = _interopRequireDefault(__webpack_require__(384));

var _checkbox = _interopRequireDefault(__webpack_require__(70));

var _dropdown = _interopRequireDefault(__webpack_require__(649));

var _menu = _interopRequireDefault(__webpack_require__(388));

var _radio = _interopRequireDefault(__webpack_require__(110));

var _devWarning = _interopRequireDefault(__webpack_require__(41));

// TODO: warning if use ajax!!!
var SELECTION_ALL = 'SELECT_ALL';
exports.SELECTION_ALL = SELECTION_ALL;
var SELECTION_INVERT = 'SELECT_INVERT';
exports.SELECTION_INVERT = SELECTION_INVERT;
var SELECTION_NONE = 'SELECT_NONE';
exports.SELECTION_NONE = SELECTION_NONE;

function getFixedType(column) {
  return column && column.fixed;
}

function flattenData(data, childrenColumnName) {
  var list = [];
  (data || []).forEach(function (record) {
    list.push(record);

    if (record && (0, _typeof2["default"])(record) === 'object' && childrenColumnName in record) {
      list = [].concat((0, _toConsumableArray2["default"])(list), (0, _toConsumableArray2["default"])(flattenData(record[childrenColumnName], childrenColumnName)));
    }
  });
  return list;
}

function useSelection(rowSelection, config) {
  var _ref = rowSelection || {},
      preserveSelectedRowKeys = _ref.preserveSelectedRowKeys,
      selectedRowKeys = _ref.selectedRowKeys,
      getCheckboxProps = _ref.getCheckboxProps,
      onSelectionChange = _ref.onChange,
      onSelect = _ref.onSelect,
      onSelectAll = _ref.onSelectAll,
      onSelectInvert = _ref.onSelectInvert,
      onSelectNone = _ref.onSelectNone,
      onSelectMultiple = _ref.onSelectMultiple,
      selectionColWidth = _ref.columnWidth,
      selectionType = _ref.type,
      selections = _ref.selections,
      fixed = _ref.fixed,
      customizeRenderCell = _ref.renderCell,
      hideSelectAll = _ref.hideSelectAll,
      _ref$checkStrictly = _ref.checkStrictly,
      checkStrictly = _ref$checkStrictly === void 0 ? true : _ref$checkStrictly;

  var prefixCls = config.prefixCls,
      data = config.data,
      pageData = config.pageData,
      getRecordByKey = config.getRecordByKey,
      getRowKey = config.getRowKey,
      expandType = config.expandType,
      childrenColumnName = config.childrenColumnName,
      tableLocale = config.locale,
      expandIconColumnIndex = config.expandIconColumnIndex,
      getPopupContainer = config.getPopupContainer; // ======================== Caches ========================

  var preserveRecordsRef = React.useRef(new Map()); // ========================= Keys =========================

  var _useMergedState = (0, _useMergedState3["default"])(selectedRowKeys || [], {
    value: selectedRowKeys
  }),
      _useMergedState2 = (0, _slicedToArray2["default"])(_useMergedState, 2),
      mergedSelectedKeys = _useMergedState2[0],
      setMergedSelectedKeys = _useMergedState2[1];

  var _useMemo = (0, React.useMemo)(function () {
    return checkStrictly ? {
      keyEntities: null
    } : (0, _treeUtil.convertDataToEntities)(data, {
      externalGetKey: getRowKey,
      childrenPropName: childrenColumnName
    });
  }, [data, getRowKey, checkStrictly, childrenColumnName]),
      keyEntities = _useMemo.keyEntities; // Get flatten data


  var flattedData = (0, React.useMemo)(function () {
    return flattenData(pageData, childrenColumnName);
  }, [pageData, childrenColumnName]); // Get all checkbox props

  var checkboxPropsMap = (0, React.useMemo)(function () {
    var map = new Map();
    flattedData.forEach(function (record, index) {
      var key = getRowKey(record, index);
      var checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
      map.set(key, checkboxProps);

      if (false) {
        (0, _devWarning["default"])(false, 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
      }
    });
    return map;
  }, [flattedData, getRowKey, getCheckboxProps]);
  var isCheckboxDisabled = (0, React.useCallback)(function (r) {
    var _a;

    return !!((_a = checkboxPropsMap.get(getRowKey(r))) === null || _a === void 0 ? void 0 : _a.disabled);
  }, [checkboxPropsMap, getRowKey]);

  var _useMemo2 = (0, React.useMemo)(function () {
    if (checkStrictly) {
      return [mergedSelectedKeys || [], []];
    }

    var _conductCheck = (0, _conductUtil.conductCheck)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled),
        checkedKeys = _conductCheck.checkedKeys,
        halfCheckedKeys = _conductCheck.halfCheckedKeys;

    return [checkedKeys || [], halfCheckedKeys];
  }, [mergedSelectedKeys, checkStrictly, keyEntities, isCheckboxDisabled]),
      _useMemo3 = (0, _slicedToArray2["default"])(_useMemo2, 2),
      derivedSelectedKeys = _useMemo3[0],
      derivedHalfSelectedKeys = _useMemo3[1];

  var derivedSelectedKeySet = (0, React.useMemo)(function () {
    var keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
    return new Set(keys);
  }, [derivedSelectedKeys, selectionType]);
  var derivedHalfSelectedKeySet = (0, React.useMemo)(function () {
    return selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys);
  }, [derivedHalfSelectedKeys, selectionType]); // Save last selected key to enable range selection

  var _useState = (0, React.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      lastSelectedKey = _useState2[0],
      setLastSelectedKey = _useState2[1]; // Reset if rowSelection reset


  React.useEffect(function () {
    if (!rowSelection) {
      setMergedSelectedKeys([]);
    }
  }, [!!rowSelection]);
  var setSelectedKeys = (0, React.useCallback)(function (keys) {
    var availableKeys;
    var records;

    if (preserveSelectedRowKeys) {
      // Keep key if mark as preserveSelectedRowKeys
      var newCache = new Map();
      availableKeys = keys;
      records = keys.map(function (key) {
        var record = getRecordByKey(key);

        if (!record && preserveRecordsRef.current.has(key)) {
          record = preserveRecordsRef.current.get(key);
        }

        newCache.set(key, record);
        return record;
      }); // Refresh to new cache

      preserveRecordsRef.current = newCache;
    } else {
      // Filter key which not exist in the `dataSource`
      availableKeys = [];
      records = [];
      keys.forEach(function (key) {
        var record = getRecordByKey(key);

        if (record !== undefined) {
          availableKeys.push(key);
          records.push(record);
        }
      });
    }

    setMergedSelectedKeys(availableKeys);

    if (onSelectionChange) {
      onSelectionChange(availableKeys, records);
    }
  }, [setMergedSelectedKeys, getRecordByKey, onSelectionChange, preserveSelectedRowKeys]); // ====================== Selections ======================
  // Trigger single `onSelect` event

  var triggerSingleSelection = (0, React.useCallback)(function (key, selected, keys, event) {
    if (onSelect) {
      var rows = keys.map(function (k) {
        return getRecordByKey(k);
      });
      onSelect(getRecordByKey(key), selected, rows, event);
    }

    setSelectedKeys(keys);
  }, [onSelect, getRecordByKey, setSelectedKeys]);
  var mergedSelections = (0, React.useMemo)(function () {
    if (!selections || hideSelectAll) {
      return null;
    }

    var selectionList = selections === true ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : selections;
    return selectionList.map(function (selection) {
      if (selection === SELECTION_ALL) {
        return {
          key: 'all',
          text: tableLocale.selectionAll,
          onSelect: function onSelect() {
            setSelectedKeys(data.map(function (record, index) {
              return getRowKey(record, index);
            }));
          }
        };
      }

      if (selection === SELECTION_INVERT) {
        return {
          key: 'invert',
          text: tableLocale.selectInvert,
          onSelect: function onSelect() {
            var keySet = new Set(derivedSelectedKeySet);
            pageData.forEach(function (record, index) {
              var key = getRowKey(record, index);

              if (keySet.has(key)) {
                keySet["delete"](key);
              } else {
                keySet.add(key);
              }
            });
            var keys = Array.from(keySet);
            setSelectedKeys(keys);

            if (onSelectInvert) {
              (0, _devWarning["default"])(false, 'Table', '`onSelectInvert` will be removed in future. Please use `onChange` instead.');
              onSelectInvert(keys);
            }
          }
        };
      }

      if (selection === SELECTION_NONE) {
        return {
          key: 'none',
          text: tableLocale.selectNone,
          onSelect: function onSelect() {
            setSelectedKeys([]);

            if (onSelectNone) {
              onSelectNone();
            }
          }
        };
      }

      return selection;
    });
  }, [selections, derivedSelectedKeySet, pageData, getRowKey, onSelectInvert, setSelectedKeys]); // ======================= Columns ========================

  var transformColumns = (0, React.useCallback)(function (columns) {
    if (!rowSelection) {
      return columns;
    } // Support selection


    var keySet = new Set(derivedSelectedKeySet); // Record key only need check with enabled

    var recordKeys = flattedData.map(getRowKey).filter(function (key) {
      return !checkboxPropsMap.get(key).disabled;
    });
    var checkedCurrentAll = recordKeys.every(function (key) {
      return keySet.has(key);
    });
    var checkedCurrentSome = recordKeys.some(function (key) {
      return keySet.has(key);
    });

    var onSelectAllChange = function onSelectAllChange() {
      var changeKeys = [];

      if (checkedCurrentAll) {
        recordKeys.forEach(function (key) {
          keySet["delete"](key);
          changeKeys.push(key);
        });
      } else {
        recordKeys.forEach(function (key) {
          if (!keySet.has(key)) {
            keySet.add(key);
            changeKeys.push(key);
          }
        });
      }

      var keys = Array.from(keySet);
      setSelectedKeys(keys);

      if (onSelectAll) {
        onSelectAll(!checkedCurrentAll, keys.map(function (k) {
          return getRecordByKey(k);
        }), changeKeys.map(function (k) {
          return getRecordByKey(k);
        }));
      }
    }; // ===================== Render =====================
    // Title Cell


    var title;

    if (selectionType !== 'radio') {
      var customizeSelections;

      if (mergedSelections) {
        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
          getPopupContainer: getPopupContainer
        }, mergedSelections.map(function (selection, index) {
          var key = selection.key,
              text = selection.text,
              onSelectionClick = selection.onSelect;
          return /*#__PURE__*/React.createElement(_menu["default"].Item, {
            key: key || index,
            onClick: function onClick() {
              if (onSelectionClick) {
                onSelectionClick(recordKeys);
              }
            }
          }, text);
        }));
        customizeSelections = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-selection-extra")
        }, /*#__PURE__*/React.createElement(_dropdown["default"], {
          overlay: menu,
          getPopupContainer: getPopupContainer
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_DownOutlined["default"], null))));
      }

      var allDisabled = flattedData.every(function (record, index) {
        var key = getRowKey(record, index);
        var checkboxProps = checkboxPropsMap.get(key) || {};
        return checkboxProps.disabled;
      });
      title = !hideSelectAll && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-selection")
      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
        checked: !allDisabled && !!flattedData.length && checkedCurrentAll,
        indeterminate: !checkedCurrentAll && checkedCurrentSome,
        onChange: onSelectAllChange,
        disabled: flattedData.length === 0 || allDisabled,
        skipGroup: true
      }), customizeSelections);
    } // Body Cell


    var renderCell;

    if (selectionType === 'radio') {
      renderCell = function renderCell(_, record, index) {
        var key = getRowKey(record, index);
        var checked = keySet.has(key);
        return {
          node: /*#__PURE__*/React.createElement(_radio["default"], (0, _extends2["default"])({}, checkboxPropsMap.get(key), {
            checked: checked,
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            onChange: function onChange(event) {
              if (!keySet.has(key)) {
                triggerSingleSelection(key, true, [key], event.nativeEvent);
              }
            }
          })),
          checked: checked
        };
      };
    } else {
      renderCell = function renderCell(_, record, index) {
        var _a;

        var key = getRowKey(record, index);
        var checked = keySet.has(key);
        var indeterminate = derivedHalfSelectedKeySet.has(key);
        var checkboxProps = checkboxPropsMap.get(key);
        var mergedIndeterminate;

        if (expandType === 'nest') {
          mergedIndeterminate = indeterminate;
          (0, _devWarning["default"])(!(typeof (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) === 'boolean'), 'Table', 'set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.');
        } else {
          mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
        } // Record checked


        return {
          node: /*#__PURE__*/React.createElement(_checkbox["default"], (0, _extends2["default"])({}, checkboxProps, {
            indeterminate: mergedIndeterminate,
            checked: checked,
            skipGroup: true,
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            onChange: function onChange(_ref2) {
              var nativeEvent = _ref2.nativeEvent;
              var shiftKey = nativeEvent.shiftKey;
              var startIndex = -1;
              var endIndex = -1; // Get range of this

              if (shiftKey && checkStrictly) {
                var pointKeys = new Set([lastSelectedKey, key]);
                recordKeys.some(function (recordKey, recordIndex) {
                  if (pointKeys.has(recordKey)) {
                    if (startIndex === -1) {
                      startIndex = recordIndex;
                    } else {
                      endIndex = recordIndex;
                      return true;
                    }
                  }

                  return false;
                });
              }

              if (endIndex !== -1 && startIndex !== endIndex && checkStrictly) {
                // Batch update selections
                var rangeKeys = recordKeys.slice(startIndex, endIndex + 1);
                var changedKeys = [];

                if (checked) {
                  rangeKeys.forEach(function (recordKey) {
                    if (keySet.has(recordKey)) {
                      changedKeys.push(recordKey);
                      keySet["delete"](recordKey);
                    }
                  });
                } else {
                  rangeKeys.forEach(function (recordKey) {
                    if (!keySet.has(recordKey)) {
                      changedKeys.push(recordKey);
                      keySet.add(recordKey);
                    }
                  });
                }

                var keys = Array.from(keySet);
                setSelectedKeys(keys);

                if (onSelectMultiple) {
                  onSelectMultiple(!checked, keys.map(function (recordKey) {
                    return getRecordByKey(recordKey);
                  }), changedKeys.map(function (recordKey) {
                    return getRecordByKey(recordKey);
                  }));
                }
              } else {
                // Single record selected
                var originCheckedKeys = derivedSelectedKeys;

                if (checkStrictly) {
                  var checkedKeys = checked ? (0, _util.arrDel)(originCheckedKeys, key) : (0, _util.arrAdd)(originCheckedKeys, key);
                  triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                } else {
                  // Always fill first
                  var result = (0, _conductUtil.conductCheck)([].concat((0, _toConsumableArray2["default"])(originCheckedKeys), [key]), true, keyEntities, isCheckboxDisabled);
                  var _checkedKeys = result.checkedKeys,
                      halfCheckedKeys = result.halfCheckedKeys;
                  var nextCheckedKeys = _checkedKeys; // If remove, we do it again to correction

                  if (checked) {
                    var tempKeySet = new Set(_checkedKeys);
                    tempKeySet["delete"](key);
                    nextCheckedKeys = (0, _conductUtil.conductCheck)(Array.from(tempKeySet), {
                      checked: false,
                      halfCheckedKeys: halfCheckedKeys
                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                  }

                  triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                }
              }

              setLastSelectedKey(key);
            }
          })),
          checked: checked
        };
      };
    }

    var renderSelectionCell = function renderSelectionCell(_, record, index) {
      var _renderCell = renderCell(_, record, index),
          node = _renderCell.node,
          checked = _renderCell.checked;

      if (customizeRenderCell) {
        return customizeRenderCell(checked, record, index, node);
      }

      return node;
    }; // Columns


    var selectionColumn = (0, _defineProperty2["default"])({
      width: selectionColWidth,
      className: "".concat(prefixCls, "-selection-column"),
      title: rowSelection.columnTitle || title,
      render: renderSelectionCell
    }, _rcTable.INTERNAL_COL_DEFINE, {
      className: "".concat(prefixCls, "-selection-col")
    });

    if (expandType === 'row' && columns.length && !expandIconColumnIndex) {
      var _columns = (0, _toArray2["default"])(columns),
          expandColumn = _columns[0],
          restColumns = _columns.slice(1);

      var selectionFixed = fixed || getFixedType(restColumns[0]);

      if (selectionFixed) {
        expandColumn.fixed = selectionFixed;
      }

      return [expandColumn, (0, _extends2["default"])((0, _extends2["default"])({}, selectionColumn), {
        fixed: selectionFixed
      })].concat((0, _toConsumableArray2["default"])(restColumns));
    }

    return [(0, _extends2["default"])((0, _extends2["default"])({}, selectionColumn), {
      fixed: fixed || getFixedType(columns[0])
    })].concat((0, _toConsumableArray2["default"])(columns));
  }, [getRowKey, flattedData, rowSelection, derivedSelectedKeys, derivedSelectedKeySet, derivedHalfSelectedKeySet, selectionColWidth, mergedSelections, expandType, lastSelectedKey, checkboxPropsMap, onSelectMultiple, triggerSingleSelection, isCheckboxDisabled]);
  return [transformColumns, derivedSelectedKeySet];
}

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(534);
var iterableToArray = __webpack_require__(566);
var unsupportedIterableToArray = __webpack_require__(344);
var nonIterableRest = __webpack_require__(536);
function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
}
module.exports = _toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(639);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(639);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(175)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(383);

var _interopRequireDefault = __webpack_require__(218);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InternalTreeNode = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(1352));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(380));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(381));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(640));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1353));

var _createClass2 = _interopRequireDefault(__webpack_require__(1354));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(642));

var _inherits2 = _interopRequireDefault(__webpack_require__(1355));

var _createSuper2 = _interopRequireDefault(__webpack_require__(1357));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _contextTypes = __webpack_require__(1361);

var _util = __webpack_require__(382);

var _Indent = _interopRequireDefault(__webpack_require__(1362));

var _treeUtil = __webpack_require__(637);

// @ts-ignore
var ICON_OPEN = 'open';
var ICON_CLOSE = 'close';
var defaultTitle = '---';

var InternalTreeNode = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(InternalTreeNode, _React$Component);

  var _super = (0, _createSuper2.default)(InternalTreeNode);

  function InternalTreeNode() {
    var _this;

    (0, _classCallCheck2.default)(this, InternalTreeNode);
    _this = _super.apply(this, arguments);
    _this.state = {
      dragNodeHighlight: false
    };

    _this.onSelectorClick = function (e) {
      // Click trigger before select/check operation
      var onNodeClick = _this.props.context.onNodeClick;
      onNodeClick(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));

      if (_this.isSelectable()) {
        _this.onSelect(e);
      } else {
        _this.onCheck(e);
      }
    };

    _this.onSelectorDoubleClick = function (e) {
      var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
      onNodeDoubleClick(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    };

    _this.onSelect = function (e) {
      if (_this.isDisabled()) return;
      var onNodeSelect = _this.props.context.onNodeSelect;
      e.preventDefault();
      onNodeSelect(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    };

    _this.onCheck = function (e) {
      if (_this.isDisabled()) return;
      var _this$props = _this.props,
          disableCheckbox = _this$props.disableCheckbox,
          checked = _this$props.checked;
      var onNodeCheck = _this.props.context.onNodeCheck;
      if (!_this.isCheckable() || disableCheckbox) return;
      e.preventDefault();
      var targetChecked = !checked;
      onNodeCheck(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props), targetChecked);
    };

    _this.onMouseEnter = function (e) {
      var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
      onNodeMouseEnter(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    };

    _this.onMouseLeave = function (e) {
      var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
      onNodeMouseLeave(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    };

    _this.onContextMenu = function (e) {
      var onNodeContextMenu = _this.props.context.onNodeContextMenu;
      onNodeContextMenu(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    };

    _this.onDragStart = function (e) {
      var onNodeDragStart = _this.props.context.onNodeDragStart;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: true
      });

      onNodeDragStart(e, (0, _assertThisInitialized2.default)(_this));

      try {
        // ie throw error
        // firefox-need-it
        e.dataTransfer.setData('text/plain', '');
      } catch (error) {// empty
      }
    };

    _this.onDragEnter = function (e) {
      var onNodeDragEnter = _this.props.context.onNodeDragEnter;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragEnter(e, (0, _assertThisInitialized2.default)(_this));
    };

    _this.onDragOver = function (e) {
      var onNodeDragOver = _this.props.context.onNodeDragOver;
      e.preventDefault();
      e.stopPropagation();
      onNodeDragOver(e, (0, _assertThisInitialized2.default)(_this));
    };

    _this.onDragLeave = function (e) {
      var onNodeDragLeave = _this.props.context.onNodeDragLeave;
      e.stopPropagation();
      onNodeDragLeave(e, (0, _assertThisInitialized2.default)(_this));
    };

    _this.onDragEnd = function (e) {
      var onNodeDragEnd = _this.props.context.onNodeDragEnd;
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDragEnd(e, (0, _assertThisInitialized2.default)(_this));
    };

    _this.onDrop = function (e) {
      var onNodeDrop = _this.props.context.onNodeDrop;
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        dragNodeHighlight: false
      });

      onNodeDrop(e, (0, _assertThisInitialized2.default)(_this));
    }; // Disabled item still can be switch


    _this.onExpand = function (e) {
      var _this$props2 = _this.props,
          loading = _this$props2.loading,
          onNodeExpand = _this$props2.context.onNodeExpand;
      if (loading) return;
      onNodeExpand(e, (0, _treeUtil.convertNodePropsToEventData)(_this.props));
    }; // Drag usage


    _this.setSelectHandle = function (node) {
      _this.selectHandle = node;
    };

    _this.getNodeState = function () {
      var expanded = _this.props.expanded;

      if (_this.isLeaf()) {
        return null;
      }

      return expanded ? ICON_OPEN : ICON_CLOSE;
    };

    _this.hasChildren = function () {
      var eventKey = _this.props.eventKey;
      var keyEntities = _this.props.context.keyEntities;

      var _ref = keyEntities[eventKey] || {},
          children = _ref.children;

      return !!(children || []).length;
    };

    _this.isLeaf = function () {
      var _this$props3 = _this.props,
          isLeaf = _this$props3.isLeaf,
          loaded = _this$props3.loaded;
      var loadData = _this.props.context.loadData;

      var hasChildren = _this.hasChildren();

      if (isLeaf === false) {
        return false;
      }

      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
    };

    _this.isDisabled = function () {
      var disabled = _this.props.disabled;
      var treeDisabled = _this.props.context.disabled;
      return !!(treeDisabled || disabled);
    };

    _this.isCheckable = function () {
      var checkable = _this.props.checkable;
      var treeCheckable = _this.props.context.checkable; // Return false if tree or treeNode is not checkable

      if (!treeCheckable || checkable === false) return false;
      return treeCheckable;
    }; // Load data to avoid default expanded tree without data


    _this.syncLoadData = function (props) {
      var expanded = props.expanded,
          loading = props.loading,
          loaded = props.loaded;
      var _this$props$context = _this.props.context,
          loadData = _this$props$context.loadData,
          onNodeLoad = _this$props$context.onNodeLoad;
      if (loading) return; // read from state to avoid loadData at same time

      if (loadData && expanded && !_this.isLeaf()) {
        // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        if (!_this.hasChildren() && !loaded) {
          onNodeLoad((0, _treeUtil.convertNodePropsToEventData)(_this.props));
        }
      }
    };

    _this.renderSwitcherIconDom = function (isLeaf) {
      var switcherIconFromProps = _this.props.switcherIcon;
      var switcherIconFromCtx = _this.props.context.switcherIcon;
      var switcherIcon = switcherIconFromProps || switcherIconFromCtx; // if switcherIconDom is null, no render switcher span

      if (typeof switcherIcon === 'function') {
        return switcherIcon((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.props), {}, {
          isLeaf: isLeaf
        }));
      }

      return switcherIcon;
    }; // Switcher


    _this.renderSwitcher = function () {
      var expanded = _this.props.expanded;
      var prefixCls = _this.props.context.prefixCls;

      if (_this.isLeaf()) {
        // if switcherIconDom is null, no render switcher span
        var _switcherIconDom = _this.renderSwitcherIconDom(true);

        return _switcherIconDom !== false ? /*#__PURE__*/React.createElement("span", {
          className: (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
        }, _switcherIconDom) : null;
      }

      var switcherCls = (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE));

      var switcherIconDom = _this.renderSwitcherIconDom(false);

      return switcherIconDom !== false ? /*#__PURE__*/React.createElement("span", {
        onClick: _this.onExpand,
        className: switcherCls
      }, switcherIconDom) : null;
    }; // Checkbox


    _this.renderCheckbox = function () {
      var _this$props4 = _this.props,
          checked = _this$props4.checked,
          halfChecked = _this$props4.halfChecked,
          disableCheckbox = _this$props4.disableCheckbox;
      var prefixCls = _this.props.context.prefixCls;

      var disabled = _this.isDisabled();

      var checkable = _this.isCheckable();

      if (!checkable) return null; // [Legacy] Custom element should be separate with `checkable` in future

      var $custom = typeof checkable !== 'boolean' ? checkable : null;
      return /*#__PURE__*/React.createElement("span", {
        className: (0, _classnames.default)("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
        onClick: _this.onCheck
      }, $custom);
    };

    _this.renderIcon = function () {
      var loading = _this.props.loading;
      var prefixCls = _this.props.context.prefixCls;
      return /*#__PURE__*/React.createElement("span", {
        className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
      });
    }; // Icon + Title


    _this.renderSelector = function () {
      var dragNodeHighlight = _this.state.dragNodeHighlight;
      var _this$props5 = _this.props,
          title = _this$props5.title,
          selected = _this$props5.selected,
          icon = _this$props5.icon,
          loading = _this$props5.loading,
          data = _this$props5.data;
      var _this$props$context2 = _this.props.context,
          prefixCls = _this$props$context2.prefixCls,
          showIcon = _this$props$context2.showIcon,
          treeIcon = _this$props$context2.icon,
          draggable = _this$props$context2.draggable,
          loadData = _this$props$context2.loadData,
          titleRender = _this$props$context2.titleRender;

      var disabled = _this.isDisabled();

      var mergedDraggable = typeof draggable === 'function' ? draggable(data) : draggable;
      var wrapClass = "".concat(prefixCls, "-node-content-wrapper"); // Icon - Still show loading icon when loading without showIcon

      var $icon;

      if (showIcon) {
        var currentIcon = icon || treeIcon;
        $icon = currentIcon ? /*#__PURE__*/React.createElement("span", {
          className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
        }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
      } else if (loadData && loading) {
        $icon = _this.renderIcon();
      } // Title


      var titleNode;

      if (typeof title === 'function') {
        titleNode = title(data);
      } else if (titleRender) {
        titleNode = titleRender(data);
      } else {
        titleNode = title;
      }

      var $title = /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, titleNode);
      return /*#__PURE__*/React.createElement("span", {
        ref: _this.setSelectHandle,
        title: typeof title === 'string' ? title : '',
        className: (0, _classnames.default)("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected"), !disabled && mergedDraggable && 'draggable'),
        draggable: !disabled && mergedDraggable || undefined,
        "aria-grabbed": !disabled && mergedDraggable || undefined,
        onMouseEnter: _this.onMouseEnter,
        onMouseLeave: _this.onMouseLeave,
        onContextMenu: _this.onContextMenu,
        onClick: _this.onSelectorClick,
        onDoubleClick: _this.onSelectorDoubleClick,
        onDragStart: mergedDraggable ? _this.onDragStart : undefined
      }, $icon, $title, _this.renderDropIndicator());
    };

    _this.renderDropIndicator = function () {
      var _this$props6 = _this.props,
          disabled = _this$props6.disabled,
          eventKey = _this$props6.eventKey;
      var _this$props$context3 = _this.props.context,
          draggable = _this$props$context3.draggable,
          dropLevelOffset = _this$props$context3.dropLevelOffset,
          dropPosition = _this$props$context3.dropPosition,
          prefixCls = _this$props$context3.prefixCls,
          indent = _this$props$context3.indent,
          dropIndicatorRender = _this$props$context3.dropIndicatorRender,
          dragOverNodeKey = _this$props$context3.dragOverNodeKey,
          direction = _this$props$context3.direction;
      var mergedDraggable = draggable !== false; // allowDrop is calculated in Tree.tsx, there is no need for calc it here

      var showIndicator = !disabled && mergedDraggable && dragOverNodeKey === eventKey;
      return showIndicator ? dropIndicatorRender({
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        indent: indent,
        prefixCls: prefixCls,
        direction: direction
      }) : null;
    };

    return _this;
  } // Isomorphic needn't load data in server side


  (0, _createClass2.default)(InternalTreeNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function isSelectable() {
      var selectable = this.props.selectable;
      var treeSelectable = this.props.context.selectable; // Ignore when selectable is undefined or null

      if (typeof selectable === 'boolean') {
        return selectable;
      }

      return treeSelectable;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props7 = this.props,
          eventKey = _this$props7.eventKey,
          className = _this$props7.className,
          style = _this$props7.style,
          dragOver = _this$props7.dragOver,
          dragOverGapTop = _this$props7.dragOverGapTop,
          dragOverGapBottom = _this$props7.dragOverGapBottom,
          isLeaf = _this$props7.isLeaf,
          isStart = _this$props7.isStart,
          isEnd = _this$props7.isEnd,
          expanded = _this$props7.expanded,
          selected = _this$props7.selected,
          checked = _this$props7.checked,
          halfChecked = _this$props7.halfChecked,
          loading = _this$props7.loading,
          domRef = _this$props7.domRef,
          active = _this$props7.active,
          data = _this$props7.data,
          onMouseMove = _this$props7.onMouseMove,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props7, ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove"]);
      var _this$props$context4 = this.props.context,
          prefixCls = _this$props$context4.prefixCls,
          filterTreeNode = _this$props$context4.filterTreeNode,
          draggable = _this$props$context4.draggable,
          keyEntities = _this$props$context4.keyEntities,
          dropContainerKey = _this$props$context4.dropContainerKey,
          dropTargetKey = _this$props$context4.dropTargetKey;
      var disabled = this.isDisabled();
      var dataOrAriaAttributeProps = (0, _util.getDataAndAria)(otherProps);

      var _ref2 = keyEntities[eventKey] || {},
          level = _ref2.level;

      var isEndNode = isEnd[isEnd.length - 1];
      var mergedDraggable = typeof draggable === 'function' ? draggable(data) : draggable;
      return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
        ref: domRef,
        className: (0, _classnames.default)(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-active"), active), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), (0, _defineProperty2.default)(_classNames, 'drop-target', dropTargetKey === eventKey), (0, _defineProperty2.default)(_classNames, 'drop-container', dropContainerKey === eventKey), (0, _defineProperty2.default)(_classNames, 'drag-over', !disabled && dragOver), (0, _defineProperty2.default)(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, _defineProperty2.default)(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, _defineProperty2.default)(_classNames, 'filter-node', filterTreeNode && filterTreeNode((0, _treeUtil.convertNodePropsToEventData)(this.props))), _classNames)),
        style: style,
        onDragEnter: mergedDraggable ? this.onDragEnter : undefined,
        onDragOver: mergedDraggable ? this.onDragOver : undefined,
        onDragLeave: mergedDraggable ? this.onDragLeave : undefined,
        onDrop: mergedDraggable ? this.onDrop : undefined,
        onDragEnd: mergedDraggable ? this.onDragEnd : undefined,
        onMouseMove: onMouseMove
      }, dataOrAriaAttributeProps), /*#__PURE__*/React.createElement(_Indent.default, {
        prefixCls: prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
      }), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
    }
  }]);
  return InternalTreeNode;
}(React.Component);

exports.InternalTreeNode = InternalTreeNode;

var ContextTreeNode = function ContextTreeNode(props) {
  return /*#__PURE__*/React.createElement(_contextTypes.TreeContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(InternalTreeNode, (0, _extends2.default)({}, props, {
      context: context
    }));
  });
};

ContextTreeNode.displayName = 'TreeNode';
ContextTreeNode.defaultProps = {
  title: defaultTitle
};
ContextTreeNode.isTreeNode = 1;
var _default = ContextTreeNode;
exports.default = _default;

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(641);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1356);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(1358);
var isNativeReflectConstruct = __webpack_require__(1359);
var possibleConstructorReturn = __webpack_require__(1360);
function _createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return possibleConstructorReturn(this, result);
  };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(175)["default"];
var assertThisInitialized = __webpack_require__(642);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(383);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */
var TreeContext = /*#__PURE__*/React.createContext(null);
exports.TreeContext = TreeContext;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(383);

var _interopRequireDefault = __webpack_require__(218);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(380));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var Indent = function Indent(_ref) {
  var prefixCls = _ref.prefixCls,
      level = _ref.level,
      isStart = _ref.isStart,
      isEnd = _ref.isEnd;
  var baseClassName = "".concat(prefixCls, "-indent-unit");
  var list = [];

  for (var i = 0; i < level; i += 1) {
    var _classNames;

    list.push( /*#__PURE__*/React.createElement("span", {
      key: i,
      className: (0, _classnames.default)(baseClassName, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(baseClassName, "-start"), isStart[i]), (0, _defineProperty2.default)(_classNames, "".concat(baseClassName, "-end"), isEnd[i]), _classNames))
    }));
  }

  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(prefixCls, "-indent")
  }, list);
};

var _default = Indent;
exports.default = _default;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(218);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCheckDisabled = isCheckDisabled;
exports.conductCheck = conductCheck;

var _warning = _interopRequireDefault(__webpack_require__(106));

function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = new Set();
  halfCheckedKeys.forEach(function (key) {
    if (!checkedKeys.has(key)) {
      filteredKeys.add(key);
    }
  });
  return filteredKeys;
}

function isCheckDisabled(node) {
  var _ref = node || {},
      disabled = _ref.disabled,
      disableCheckbox = _ref.disableCheckbox,
      checkable = _ref.checkable;

  return !!(disabled || disableCheckbox) || checkable === false;
} // Fill miss keys


function fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys);
  var halfCheckedKeys = new Set(); // Add checked keys top to bottom

  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function (entity) {
      var key = entity.key,
          node = entity.node,
          _entity$children = entity.children,
          children = _entity$children === void 0 ? [] : _entity$children;

      if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) {
        children.filter(function (childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function (childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  } // Add checked keys from bottom to top


  var visitedKeys = new Set();

  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || new Set();

    _entities.forEach(function (entity) {
      var parent = entity.parent,
          node = entity.node; // Skip if no need to check

      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      } // Skip if parent is disabled


      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }

      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function (childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function (_ref2) {
        var key = _ref2.key;
        var checked = checkedKeys.has(key);

        if (allChecked && !checked) {
          allChecked = false;
        }

        if (!partialChecked && (checked || halfCheckedKeys.has(key))) {
          partialChecked = true;
        }
      });

      if (allChecked) {
        checkedKeys.add(parent.key);
      }

      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }

      visitedKeys.add(parent.key);
    });
  }

  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
} // Remove useless key


function cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys);
  var halfCheckedKeys = new Set(halfKeys); // Remove checked keys from top to bottom

  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || new Set();
    entities.forEach(function (entity) {
      var key = entity.key,
          node = entity.node,
          _entity$children2 = entity.children,
          children = _entity$children2 === void 0 ? [] : _entity$children2;

      if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) {
        children.filter(function (childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function (childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  } // Remove checked keys form bottom to top


  halfCheckedKeys = new Set();
  var visitedKeys = new Set();

  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || new Set();

    _entities2.forEach(function (entity) {
      var parent = entity.parent,
          node = entity.node; // Skip if no need to check

      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      } // Skip if parent is disabled


      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }

      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function (childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function (_ref3) {
        var key = _ref3.key;
        var checked = checkedKeys.has(key);

        if (allChecked && !checked) {
          allChecked = false;
        }

        if (!partialChecked && (checked || halfCheckedKeys.has(key))) {
          partialChecked = true;
        }
      });

      if (!allChecked) {
        checkedKeys.delete(parent.key);
      }

      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }

      visitedKeys.add(parent.key);
    });
  }

  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
/**
 * Conduct with keys.
 * @param keyList current key list
 * @param keyEntities key - dataEntity map
 * @param mode `fill` to fill missing key, `clean` to remove useless key
 */


function conductCheck(keyList, checked, keyEntities, getCheckDisabled) {
  var warningMissKeys = [];
  var syntheticGetCheckDisabled;

  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled;
  } // We only handle exist keys


  var keys = new Set(keyList.filter(function (key) {
    var hasEntity = !!keyEntities[key];

    if (!hasEntity) {
      warningMissKeys.push(key);
    }

    return hasEntity;
  }));
  var levelEntities = new Map();
  var maxLevel = 0; // Convert entities by level for calculation

  Object.keys(keyEntities).forEach(function (key) {
    var entity = keyEntities[key];
    var level = entity.level;
    var levelSet = levelEntities.get(level);

    if (!levelSet) {
      levelSet = new Set();
      levelEntities.set(level, levelSet);
    }

    levelSet.add(entity);
    maxLevel = Math.max(maxLevel, level);
  });
  (0, _warning.default)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function (key) {
    return "'".concat(key, "'");
  }).join(', ')));
  var result;

  if (checked === true) {
    result = fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }

  return result;
}

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(1367);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(275).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEvent;
var React = _interopRequireWildcard(__webpack_require__(0));
function useEvent(callback) {
  var fnRef = React.useRef();
  fnRef.current = callback;
  var memoFn = React.useCallback(function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(137).default;
var _interopRequireWildcard = __webpack_require__(275).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayoutUpdateEffect = exports.default = void 0;
var React = _interopRequireWildcard(__webpack_require__(0));
var _canUseDom = _interopRequireDefault(__webpack_require__(343));
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useLayoutEffect = "production" !== 'test' && (0, _canUseDom.default)() ? React.useLayoutEffect : React.useEffect;
var _default = useLayoutEffect;
exports.default = _default;
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  var firstMountRef = React.useRef(true);
  useLayoutEffect(function () {
    if (!firstMountRef.current) {
      return callback();
    }
  }, deps);

  // We tell react that first mount has passed
  useLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
exports.useLayoutUpdateEffect = useLayoutUpdateEffect;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(275).default;
var _interopRequireDefault = __webpack_require__(137).default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSafeState;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(643));
var React = _interopRequireWildcard(__webpack_require__(0));
/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = React.useRef(false);
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(385);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1375);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(646);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(647);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1380);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1384);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1385);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_trigger__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__placements__ = __webpack_require__(1398);




var _excluded = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger"];





function Dropdown(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls,
      transitionName = props.transitionName,
      animation = props.animation,
      align = props.align,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement,
      _props$placements = props.placements,
      placements = _props$placements === void 0 ? __WEBPACK_IMPORTED_MODULE_7__placements__["a" /* default */] : _props$placements,
      getPopupContainer = props.getPopupContainer,
      showAction = props.showAction,
      hideAction = props.hideAction,
      overlayClassName = props.overlayClassName,
      overlayStyle = props.overlayStyle,
      visible = props.visible,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      otherProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      triggerVisible = _React$useState2[0],
      setTriggerVisible = _React$useState2[1];

  var mergedVisible = 'visible' in props ? visible : triggerVisible;
  var triggerRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_4_react__["useImperativeHandle"](ref, function () {
    return triggerRef.current;
  });

  var getOverlayElement = function getOverlayElement() {
    var overlay = props.overlay;
    var overlayElement;

    if (typeof overlay === 'function') {
      overlayElement = overlay();
    } else {
      overlayElement = overlay;
    }

    return overlayElement;
  };

  var onClick = function onClick(e) {
    var onOverlayClick = props.onOverlayClick;
    var overlayProps = getOverlayElement().props;
    setTriggerVisible(false);

    if (onOverlayClick) {
      onOverlayClick(e);
    }

    if (overlayProps.onClick) {
      overlayProps.onClick(e);
    }
  };

  var onVisibleChange = function onVisibleChange(newVisible) {
    var onVisibleChangeProp = props.onVisibleChange;
    setTriggerVisible(newVisible);

    if (typeof onVisibleChangeProp === 'function') {
      onVisibleChangeProp(newVisible);
    }
  };

  var getMenuElement = function getMenuElement() {
    var overlayElement = getOverlayElement();
    var extraOverlayProps = {
      prefixCls: "".concat(prefixCls, "-menu"),
      onClick: onClick
    };

    if (typeof overlayElement.type === 'string') {
      delete extraOverlayProps.prefixCls;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null, arrow && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"](overlayElement, extraOverlayProps));
  };

  var getMenuElementOrLambda = function getMenuElementOrLambda() {
    var overlay = props.overlay;

    if (typeof overlay === 'function') {
      return getMenuElement;
    }

    return getMenuElement();
  };

  var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
    var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger,
        alignPoint = props.alignPoint;

    if ('minOverlayWidthMatchTrigger' in props) {
      return minOverlayWidthMatchTrigger;
    }

    return !alignPoint;
  };

  var getOpenClassName = function getOpenClassName() {
    var openClassName = props.openClassName;

    if (openClassName !== undefined) {
      return openClassName;
    }

    return "".concat(prefixCls, "-open");
  };

  var renderChildren = function renderChildren() {
    var children = props.children;
    var childrenProps = children.props ? children.props : {};
    var childClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(childrenProps.className, getOpenClassName());
    return mergedVisible && children ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"](children, {
      className: childClassName
    }) : children;
  };

  var triggerHideAction = hideAction;

  if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
    triggerHideAction = ['click'];
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_trigger__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
    builtinPlacements: placements
  }, otherProps), {}, {
    prefixCls: prefixCls,
    ref: triggerRef,
    popupClassName: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(overlayClassName, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-show-arrow"), arrow)),
    popupStyle: overlayStyle,
    action: trigger,
    showAction: showAction,
    hideAction: triggerHideAction || [],
    popupPlacement: placement,
    popupAlign: align,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupVisible: mergedVisible,
    stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
    popup: getMenuElementOrLambda(),
    onPopupVisibleChange: onVisibleChange,
    getPopupContainer: getPopupContainer
  }), renderChildren());
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](Dropdown));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1388);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(652);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(651);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1395);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1394);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1397);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topCenter: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomCenter: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _EllipsisOutlined = _interopRequireDefault(__webpack_require__(653));

var _button = _interopRequireDefault(__webpack_require__(26));

var _configProvider = __webpack_require__(8);

var _dropdown = _interopRequireDefault(__webpack_require__(386));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = _button["default"].Group;

var DropdownButton = function DropdownButton(props) {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getContextPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var customizePrefixCls = props.prefixCls,
      type = props.type,
      disabled = props.disabled,
      onClick = props.onClick,
      htmlType = props.htmlType,
      children = props.children,
      className = props.className,
      overlay = props.overlay,
      trigger = props.trigger,
      align = props.align,
      visible = props.visible,
      onVisibleChange = props.onVisibleChange,
      placement = props.placement,
      getPopupContainer = props.getPopupContainer,
      href = props.href,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? /*#__PURE__*/React.createElement(_EllipsisOutlined["default"], null) : _props$icon,
      title = props.title,
      buttonsRender = props.buttonsRender,
      restProps = __rest(props, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender"]);

  var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
  var dropdownProps = {
    align: align,
    overlay: overlay,
    disabled: disabled,
    trigger: disabled ? [] : trigger,
    onVisibleChange: onVisibleChange,
    getPopupContainer: getPopupContainer || getContextPopupContainer
  };

  if ('visible' in props) {
    dropdownProps.visible = visible;
  }

  if ('placement' in props) {
    dropdownProps.placement = placement;
  } else {
    dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
  }

  var leftButton = /*#__PURE__*/React.createElement(_button["default"], {
    type: type,
    disabled: disabled,
    onClick: onClick,
    htmlType: htmlType,
    href: href,
    title: title
  }, children);
  var rightButton = /*#__PURE__*/React.createElement(_button["default"], {
    type: type,
    icon: icon
  });

  var _buttonsRender = buttonsRender([leftButton, rightButton]),
      _buttonsRender2 = (0, _slicedToArray2["default"])(_buttonsRender, 2),
      leftButtonToRender = _buttonsRender2[0],
      rightButtonToRender = _buttonsRender2[1];

  return /*#__PURE__*/React.createElement(ButtonGroup, (0, _extends2["default"])({}, restProps, {
    className: (0, _classnames["default"])(prefixCls, className)
  }), leftButtonToRender, /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, rightButtonToRender));
};

DropdownButton.__ANT_BUTTON = true;
DropdownButton.defaultProps = {
  type: 'default',
  buttonsRender: function buttonsRender(buttons) {
    return buttons;
  }
};
var _default = DropdownButton;
exports["default"] = _default;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _EllipsisOutlined = _interopRequireDefault(__webpack_require__(1401));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _EllipsisOutlined.default
  }));
};
EllipsisOutlined.displayName = 'EllipsisOutlined';
var _default = /*#__PURE__*/React.forwardRef(EllipsisOutlined);
exports.default = _default;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var EllipsisOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
exports.default = EllipsisOutlined;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var _unreachableException = _interopRequireDefault(__webpack_require__(1403));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;

    var customizePrefixCls = props.prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);

    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
    // small => sm

    var sizeCls = '';

    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;

      case 'small':
        sizeCls = 'sm';
        break;

      case 'middle':
      case undefined:
        break;

      default:
        // eslint-disable-next-line no-console
        console.warn(new _unreachableException["default"](size));
    }

    var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, others, {
      className: classes
    }));
  });
};

var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var UnreachableException = function UnreachableException(value) {
  (0, _classCallCheck2["default"])(this, UnreachableException);
  return new Error("unreachable case: ".concat(JSON.stringify(value)));
};

exports["default"] = UnreachableException;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapperRaf;

var _raf = _interopRequireDefault(__webpack_require__(176));

var id = 0;
var ids = {}; // Support call raf with delay specified frame

function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;

  function internalCallback() {
    restFrames -= 1;

    if (restFrames <= 0) {
      callback();
      delete ids[myId];
    } else {
      ids[myId] = (0, _raf["default"])(internalCallback);
    }
  }

  ids[myId] = (0, _raf["default"])(internalCallback);
  return myId;
}

wrapperRaf.cancel = function cancel(pid) {
  if (pid === undefined) return;

  _raf["default"].cancel(ids[pid]);

  delete ids[pid];
};

wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _rcMotion = _interopRequireDefault(__webpack_require__(84));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var getCollapsedWidth = function getCollapsedWidth() {
  return {
    width: 0,
    opacity: 0,
    transform: 'scale(0)'
  };
};

var getRealWidth = function getRealWidth(node) {
  return {
    width: node.scrollWidth,
    opacity: 1,
    transform: 'scale(1)'
  };
};

var LoadingIcon = function LoadingIcon(_ref) {
  var prefixCls = _ref.prefixCls,
      loading = _ref.loading,
      existIcon = _ref.existIcon;
  var visible = !!loading;

  if (existIcon) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(prefixCls, "-loading-icon")
    }, /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], null));
  }

  return /*#__PURE__*/_react["default"].createElement(_rcMotion["default"], {
    visible: visible // We do not really use this motionName
    ,
    motionName: "".concat(prefixCls, "-loading-icon-motion"),
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, function (_ref2, ref) {
    var className = _ref2.className,
        style = _ref2.style;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(prefixCls, "-loading-icon"),
      style: style,
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      className: className
    }));
  });
};

var _default = LoadingIcon;
exports["default"] = _default;

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mini_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_omit__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SubPopupMenu__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_legacyUtil__ = __webpack_require__(1429);














var Menu = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Menu, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Menu);

  function Menu(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Menu);

    _this = _super.call(this, props);

    _this.onSelect = function (selectInfo) {
      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize.props;

      if (props.selectable) {
        // root menu
        var _this$store$getState = _this.store.getState(),
            _selectedKeys = _this$store$getState.selectedKeys;

        var selectedKey = selectInfo.key;

        if (props.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys
          });
        }

        props.onSelect(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, selectInfo), {}, {
          selectedKeys: _selectedKeys
        }));
      }
    };

    _this.onClick = function (e) {
      var mode = _this.getRealMenuMode();

      var _assertThisInitialize2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          store = _assertThisInitialize2.store,
          onOpenChange = _assertThisInitialize2.props.onOpenChange;

      if (mode !== 'inline' && !('openKeys' in _this.props)) {
        // closing vertical popup submenu after click it
        store.setState({
          openKeys: []
        });
        onOpenChange([]);
      }

      _this.props.onClick(e);
    }; // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself


    _this.onKeyDown = function (e, callback) {
      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };

    _this.onOpenChange = function (event) {
      var _assertThisInitialize3 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize3.props;

      var openKeys = _this.store.getState().openKeys.concat();

      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!('openKeys' in _this.props)) {
          _this.store.setState({
            openKeys: openKeys
          });
        }

        props.onOpenChange(openKeys);
      }
    };

    _this.onDeselect = function (selectInfo) {
      var _assertThisInitialize4 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          props = _assertThisInitialize4.props;

      if (props.selectable) {
        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();

        var selectedKey = selectInfo.key;

        var index = _selectedKeys2.indexOf(selectedKey);

        if (index !== -1) {
          _selectedKeys2.splice(index, 1);
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys2
          });
        }

        props.onDeselect(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, selectInfo), {}, {
          selectedKeys: _selectedKeys2
        }));
      }
    }; // Restore vertical mode when menu is collapsed responsively when mounted
    // https://github.com/ant-design/ant-design/issues/13104
    // TODO: not a perfect solution,
    // looking a new way to avoid setting switchingModeFromInline in this situation


    _this.onMouseEnter = function (e) {
      _this.restoreModeVerticalFromInline();

      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(e);
      }
    };

    _this.onTransitionEnd = function (e) {
      // when inlineCollapsed menu width animation finished
      // https://github.com/ant-design/ant-design/issues/12864
      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
      // https://github.com/ant-design/ant-design/issues/15699

      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal,
      // unless during an animation.

      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />,
      // the width transition won't trigger when menu is collapsed
      // https://github.com/ant-design/ant-design-pro/issues/2783

      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;

      if (widthCollapsed || iconScaled) {
        _this.restoreModeVerticalFromInline();
      }
    };

    _this.setInnerMenu = function (node) {
      _this.innerMenu = node;
    };

    _this.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_8_mini_store__["c" /* create */])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_10__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey)
      }
    });
    _this.state = {
      switchingModeFromInline: false,
      prevProps: props,
      inlineOpenKeys: [],
      store: _this.store
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
      this.updateMenuDisplay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          siderCollapsed = _this$props.siderCollapsed,
          inlineCollapsed = _this$props.inlineCollapsed,
          onOpenChange = _this$props.onOpenChange;

      if (!prevProps.inlineCollapsed && inlineCollapsed || !prevProps.siderCollapsed && siderCollapsed) {
        onOpenChange([]);
      }

      this.updateMiniStore();
      this.updateMenuDisplay();
    }
  }, {
    key: "updateMenuDisplay",
    value: function updateMenuDisplay() {
      var collapsedWidth = this.props.collapsedWidth,
          store = this.store,
          prevOpenKeys = this.prevOpenKeys; // https://github.com/ant-design/ant-design/issues/8587

      var hideMenu = this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');

      if (hideMenu) {
        this.prevOpenKeys = store.getState().openKeys.concat();
        this.store.setState({
          openKeys: []
        });
      } else if (prevOpenKeys) {
        this.store.setState({
          openKeys: prevOpenKeys
        });
        this.prevOpenKeys = null;
      }
    }
  }, {
    key: "getRealMenuMode",
    value: function getRealMenuMode() {
      var mode = this.props.mode;
      var switchingModeFromInline = this.state.switchingModeFromInline;
      var inlineCollapsed = this.getInlineCollapsed();

      if (switchingModeFromInline && inlineCollapsed) {
        return 'inline';
      }

      return inlineCollapsed ? 'vertical' : mode;
    }
  }, {
    key: "getInlineCollapsed",
    value: function getInlineCollapsed() {
      var _this$props2 = this.props,
          inlineCollapsed = _this$props2.inlineCollapsed,
          siderCollapsed = _this$props2.siderCollapsed;

      if (siderCollapsed !== undefined) {
        return siderCollapsed;
      }

      return inlineCollapsed;
    }
  }, {
    key: "restoreModeVerticalFromInline",
    value: function restoreModeVerticalFromInline() {
      var switchingModeFromInline = this.state.switchingModeFromInline;

      if (switchingModeFromInline) {
        this.setState({
          switchingModeFromInline: false
        });
      }
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ('selectedKeys' in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }

      if ('openKeys' in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_omit__["a" /* default */])(this.props, ['collapsedWidth', 'siderCollapsed', 'defaultMotions']));

      var mode = this.getRealMenuMode();
      props.className += " ".concat(props.prefixCls, "-root");

      if (props.direction === 'rtl') {
        props.className += " ".concat(props.prefixCls, "-rtl");
      }

      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
        mode: mode,
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        onMouseEnter: this.onMouseEnter,
        onTransitionEnd: this.onTransitionEnd,
        parentMenu: this,
        motion: Object(__WEBPACK_IMPORTED_MODULE_12__utils_legacyUtil__["a" /* getMotion */])(this.props, this.state, mode)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_mini_store__["a" /* Provider */], {
        store: this.store
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SubPopupMenu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps,
          store = prevState.store;
      var prevStoreState = store.getState();
      var newStoreState = {};
      var newState = {
        prevProps: nextProps
      };

      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
        newState.switchingModeFromInline = true;
      }

      if ('openKeys' in nextProps) {
        newStoreState.openKeys = nextProps.openKeys || [];
      } else {
        // [Legacy] Old code will return after `openKeys` changed.
        // Not sure the reason, we should keep this logic still.
        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
          newState.switchingModeFromInline = true;
          newState.inlineOpenKeys = prevStoreState.openKeys;
          newStoreState.openKeys = [];
        }

        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
          newStoreState.openKeys = prevState.inlineOpenKeys;
          newState.inlineOpenKeys = [];
        }
      }

      if (Object.keys(newStoreState).length) {
        store.setState(newStoreState);
      }

      return newState;
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_11__util__["h" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", null, "\xB7\xB7\xB7")
};
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(219);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(220);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallowequal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Provider__ = __webpack_require__(655);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
var defaultMapStateToProps = function () { return ({}); };
function connect(mapStateToProps, options) {
    if (options === void 0) { options = {}; }
    var shouldSubscribe = !!mapStateToProps;
    var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
    return function wrapWithConnect(WrappedComponent) {
        var Connect = /** @class */ (function (_super) {
            __extends(Connect, _super);
            function Connect(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.unsubscribe = null;
                _this.handleChange = function () {
                    if (!_this.unsubscribe) {
                        return;
                    }
                    var nextState = finalMapStateToProps(_this.store.getState(), _this.props);
                    _this.setState({ subscribed: nextState });
                };
                _this.store = _this.context;
                _this.state = {
                    subscribed: finalMapStateToProps(_this.store.getState(), props),
                    store: _this.store,
                    props: props,
                };
                return _this;
            }
            Connect.getDerivedStateFromProps = function (props, prevState) {
                // using ownProps
                if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
                    return {
                        subscribed: finalMapStateToProps(prevState.store.getState(), props),
                        props: props,
                    };
                }
                return { props: props };
            };
            Connect.prototype.componentDidMount = function () {
                this.trySubscribe();
            };
            Connect.prototype.componentWillUnmount = function () {
                this.tryUnsubscribe();
            };
            Connect.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                return (!__WEBPACK_IMPORTED_MODULE_1_shallowequal___default()(this.props, nextProps) ||
                    !__WEBPACK_IMPORTED_MODULE_1_shallowequal___default()(this.state.subscribed, nextState.subscribed));
            };
            Connect.prototype.trySubscribe = function () {
                if (shouldSubscribe) {
                    this.unsubscribe = this.store.subscribe(this.handleChange);
                    this.handleChange();
                }
            };
            Connect.prototype.tryUnsubscribe = function () {
                if (this.unsubscribe) {
                    this.unsubscribe();
                    this.unsubscribe = null;
                }
            };
            Connect.prototype.render = function () {
                var props = __assign(__assign(__assign({}, this.props), this.state.subscribed), { store: this.store });
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, __assign({}, props, { ref: this.props.miniStoreForwardedRef }));
            };
            Connect.displayName = "Connect(" + getDisplayName(WrappedComponent) + ")";
            Connect.contextType = __WEBPACK_IMPORTED_MODULE_3__Provider__["a" /* MiniStoreContext */];
            return Connect;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
        if (options.forwardRef) {
            var forwarded = __WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function (props, ref) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Connect, __assign({}, props, { miniStoreForwardedRef: ref }));
            });
            return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
        }
        return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
    };
}


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(262);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function create(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = __assign(__assign({}, state), partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
    };
}


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }
  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1417);


// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = (ua || '').split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, isMobile()), {}, {
  isMobile: isMobile
});

/* harmony default export */ __webpack_exports__["a"] = (defaultResult);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1420);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_resize_observer_polyfill__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SubMenu__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(183);












var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5;

var DOMWrap = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(DOMWrap, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DOMWrap);

  function DOMWrap() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DOMWrap);

    _this = _super.apply(this, arguments);
    _this.resizeObserver = null;
    _this.mutationObserver = null; // original scroll size of the list

    _this.originalTotalWidth = 0; // copy of overflowed items

    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    _this.menuItemSizes = [];
    _this.cancelFrameId = null;
    _this.state = {
      lastVisibleIndex: undefined
    };
    _this.childRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createRef"](); // get all valid menuItem nodes

    _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;
      var ul = _this.childRef.current;

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };

    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = _this.props.children[0];

      var _copy$props = copy.props,
          throwAway = _copy$props.children,
          title = _copy$props.title,
          propStyle = _copy$props.style,
          rest = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_copy$props, ["children", "title", "style"]);

      var style = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, propStyle);

      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), {}, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), {}, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      __WEBPACK_IMPORTED_MODULE_11__util__["g" /* menuAllProps */].forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SubMenu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName: popupClassName
      }, props, {
        key: key,
        eventKey: eventKey,
        disabled: false,
        style: style
      }), overflowedItems);
    }; // memorize rendered menuSize


    _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = _this.childRef.current;

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      Object(__WEBPACK_IMPORTED_MODULE_11__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation


      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_11__util__["i" /* setStyle */])(c, 'display', 'inline-block');
      });
      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* getWidth */])(c, true);
      });
      overflowedItems.forEach(function (c) {
        Object(__WEBPACK_IMPORTED_MODULE_11__util__["i" /* setStyle */])(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* getWidth */])(ul.children[ul.children.length - 1], true);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      _this.handleResize(); // prevent the overflowed indicator from taking space;


      Object(__WEBPACK_IMPORTED_MODULE_11__util__["i" /* setStyle */])(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    };

    _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = _this.childRef.current;

      if (!ul) {
        return;
      }

      var width = Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* getWidth */])(ul);
      _this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      _this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(DOMWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setChildrenWidthAndResize();

      if (this.props.level === 1 && this.props.mode === 'horizontal') {
        var menuUl = this.childRef.current;

        if (!menuUl) {
          return;
        }

        this.resizeObserver = new __WEBPACK_IMPORTED_MODULE_9_resize_observer_polyfill__["default"](function (entries) {
          entries.forEach(function () {
            var cancelFrameId = _this2.cancelFrameId;
            cancelAnimationFrame(cancelFrameId);
            _this2.cancelFrameId = requestAnimationFrame(_this2.setChildrenWidthAndResize);
          });
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this2.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(function () {
            _this2.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this2.resizeObserver.observe(el);
            });

            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }

      cancelAnimationFrame(this.cancelFrameId);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;

        if (_this3.props.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);

          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index > lastVisibleIndex) {
              item = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"](childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                eventKey: "".concat(childNode.props.eventKey, "-hidden"),

                /**
                 * Legacy code. Here `className` never used:
                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
                 */
                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"](c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: c.props.eventKey,
                  mode: 'vertical-left'
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }

          return ret;
        }

        return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          prefixCls = _this$props2.prefixCls,
          overflowedIndicator = _this$props2.overflowedIndicator,
          mode = _this$props2.mode,
          level = _this$props2.level,
          tag = _this$props2.tag,
          children = _this$props2.children,
          theme = _this$props2.theme,
          rest = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);

      var Tag = tag;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Tag, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: this.childRef
      }, rest), this.renderChildren(children));
    }
  }]);

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1425);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(658);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1427);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placementsRtl; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var placementsRtl = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  rightTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  leftTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMotion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_warning__ = __webpack_require__(55);


function getMotion(_ref, _ref2, menuMode) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      _ref$defaultMotions = _ref.defaultMotions,
      defaultMotions = _ref$defaultMotions === void 0 ? {} : _ref$defaultMotions,
      openAnimation = _ref.openAnimation,
      openTransitionName = _ref.openTransitionName;
  var switchingModeFromInline = _ref2.switchingModeFromInline;

  if (motion) {
    return motion;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(openAnimation) === 'object' && openAnimation) {
    Object(__WEBPACK_IMPORTED_MODULE_1_rc_util_es_warning__["a" /* default */])(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
  } else if (typeof openAnimation === 'string') {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }

  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  } // Default logic


  var defaultMotion = defaultMotions[menuMode];

  if (defaultMotion) {
    return defaultMotion;
  } // When mode switch from inline
  // submenu should hide without animation


  return switchingModeFromInline ? null : defaultMotions.other;
}

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_omit__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mini_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(183);














var MenuItem = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuItem, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(MenuItem);

  function MenuItem() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuItem);

    _this = _super.apply(this, arguments);

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_9_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);

        return true;
      }

      return undefined;
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
        domEvent: e
      };
      onClick(info);

      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    _this.saveNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;

      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.props);

      var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, this.getActiveClassName(), !props.disabled && props.active), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, this.getSelectedClassName(), props.isSelected), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, this.getDisabledClassName(), props.disabled), _classNames));

      var attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props.attribute), {}, {
        title: typeof props.title === 'string' ? props.title : undefined,
        className: className,
        // set to menuitem by default
        role: props.role || 'menuitem',
        'aria-disabled': props.disabled
      });

      if (props.role === 'option') {
        // overwrite to option
        attrs = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, attrs), {}, {
          role: 'option',
          'aria-selected': props.isSelected
        });
      } else if (props.role === null || props.role === 'none') {
        // sometimes we want to specify role inside <li/> element
        // <li><a role='menuitem'>Link</a></li> would be a good example
        // in this case the role on <li/> should be "none" to
        // remove the implied listitem role.
        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
        attrs.role = 'none';
      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };

      var style = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props.style);

      if (props.mode === 'inline') {
        if (props.direction === 'rtl') {
          style.paddingRight = props.inlineIndent * props.level;
        } else {
          style.paddingLeft = props.inlineIndent * props.level;
        }
      }

      __WEBPACK_IMPORTED_MODULE_13__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      });
      delete props.direction;
      var icon = this.props.itemIcon;

      if (typeof this.props.itemIcon === 'function') {
        // TODO: This is a bug which should fixed after TS refactor
        icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](this.props.itemIcon, this.props);
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_omit__["a" /* default */])(props, ['onClick', 'onMouseEnter', 'onMouseLeave', 'onSelect']), attrs, mouseEvent, {
        style: style,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
MenuItem.isMenuItem = true;
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_13__util__["h" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_13__util__["h" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_13__util__["h" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_13__util__["h" /* noop */]
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_12_mini_store__["b" /* connect */])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    // selectedKeys should be array in any circumstance
    // when it is not, we have fallback logic for https://github.com/ant-design/ant-design/issues/29430
    isSelected: Array.isArray(selectedKeys) ? selectedKeys.indexOf(eventKey) !== -1 : selectedKeys === eventKey
  };
})(MenuItem);
/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(183);








var MenuItemGroup = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuItemGroup, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(MenuItemGroup);

  function MenuItemGroup() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuItemGroup);

    _this = _super.apply(this, arguments);

    _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;
      return renderMenuItem(item, index, _this.props.subMenuKey);
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuItemGroup, [{
    key: "render",
    value: function render() {
      var props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props);

      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title,
          children = props.children;
      __WEBPACK_IMPORTED_MODULE_6__util__["g" /* menuAllProps */].forEach(function (key) {
        return delete props[key];
      });
      delete props.direction;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        className: titleClassName,
        title: typeof title === 'string' ? title : undefined
      }, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("ul", {
        className: listClassName
      }, __WEBPACK_IMPORTED_MODULE_5_react__["Children"].map(children, this.renderInnerMenuItem)));
    }
  }]);

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.defaultProps = {
  disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Divider = function Divider(_ref) {
  var className = _ref.className,
      rootPrefixCls = _ref.rootPrefixCls,
      style = _ref.style;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};

Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = __webpack_require__(286);

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _MenuContext = _interopRequireDefault(__webpack_require__(390));

var _reactNode = __webpack_require__(57);

var SubMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SubMenu, _React$Component);

  var _super = (0, _createSuper2["default"])(SubMenu);

  function SubMenu() {
    (0, _classCallCheck2["default"])(this, SubMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SubMenu, [{
    key: "renderTitle",
    value: function renderTitle(inlineCollapsed) {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          level = _this$props.level,
          rootPrefixCls = _this$props.rootPrefixCls;

      if (!icon) {
        return inlineCollapsed && level === 1 && title && typeof title === 'string' ? /*#__PURE__*/React.createElement("div", {
          className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
        }, title.charAt(0)) : title;
      } // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
      // ref: https://github.com/ant-design/ant-design/pull/23456


      var titleIsSpan = (0, _reactNode.isValidElement)(title) && title.type === 'span';
      return /*#__PURE__*/React.createElement(React.Fragment, null, icon, titleIsSpan ? title : /*#__PURE__*/React.createElement("span", null, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          rootPrefixCls = _this$props2.rootPrefixCls,
          popupClassName = _this$props2.popupClassName;
      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
        var inlineCollapsed = _ref.inlineCollapsed,
            antdMenuTheme = _ref.antdMenuTheme;
        return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, (0, _extends2["default"])({}, (0, _omit["default"])(_this.props, ['icon']), {
          title: _this.renderTitle(inlineCollapsed),
          popupClassName: (0, _classnames["default"])(rootPrefixCls, "".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
        }));
      });
    }
  }]);
  return SubMenu;
}(React.Component);

SubMenu.contextType = _MenuContext["default"]; // fix issue:https://github.com/ant-design/ant-design/issues/8666

SubMenu.isSubMenu = 1;
var _default = SubMenu;
exports["default"] = _default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMenu = __webpack_require__(286);

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _MenuContext = _interopRequireDefault(__webpack_require__(390));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var _Sider = __webpack_require__(359);

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var MenuItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuItem, _React$Component);

  var _super = (0, _createSuper2["default"])(MenuItem);

  function MenuItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = _super.apply(this, arguments);

    _this.renderItem = function (_ref) {
      var siderCollapsed = _ref.siderCollapsed;
      var _this$props = _this.props,
          level = _this$props.level,
          className = _this$props.className,
          children = _this$props.children,
          rootPrefixCls = _this$props.rootPrefixCls;

      var _a = _this.props,
          title = _a.title,
          icon = _a.icon,
          danger = _a.danger,
          rest = __rest(_a, ["title", "icon", "danger"]);

      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
        var _classNames;

        var inlineCollapsed = _ref2.inlineCollapsed,
            direction = _ref2.direction;

        var _a;

        var tooltipTitle = title;

        if (typeof title === 'undefined') {
          tooltipTitle = level === 1 ? children : '';
        } else if (title === false) {
          tooltipTitle = '';
        }

        var tooltipProps = {
          title: tooltipTitle
        };

        if (!siderCollapsed && !inlineCollapsed) {
          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
          // ref: https://github.com/ant-design/ant-design/issues/16742

          tooltipProps.visible = false;
        }

        var childrenLength = (0, _toArray["default"])(children).length;
        return /*#__PURE__*/React.createElement(_tooltip["default"], (0, _extends2["default"])({}, tooltipProps, {
          placement: direction === 'rtl' ? 'left' : 'right',
          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
        }), /*#__PURE__*/React.createElement(_rcMenu.Item, (0, _extends2["default"])({}, rest, {
          className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(rootPrefixCls, "-item-danger"), danger), (0, _defineProperty2["default"])(_classNames, "".concat(rootPrefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _classNames), className),
          title: title
        }), (0, _reactNode.cloneElement)(icon, {
          className: (0, _classnames["default"])((0, _reactNode.isValidElement)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(rootPrefixCls, "-item-icon"))
        }), _this.renderItemChildren(inlineCollapsed)));
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "renderItemChildren",
    value: function renderItemChildren(inlineCollapsed) {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          children = _this$props2.children,
          level = _this$props2.level,
          rootPrefixCls = _this$props2.rootPrefixCls; // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
      // ref: https://github.com/ant-design/ant-design/pull/23456

      if (!icon || (0, _reactNode.isValidElement)(children) && children.type === 'span') {
        if (children && inlineCollapsed && level === 1 && typeof children === 'string') {
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
          }, children.charAt(0));
        }

        return children;
      }

      return /*#__PURE__*/React.createElement("span", null, children);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem);
    }
  }]);
  return MenuItem;
}(React.Component);

exports["default"] = MenuItem;
MenuItem.isMenuItem = true;

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_trigger__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placements__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Content__ = __webpack_require__(1443);









var Tooltip = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      _props$mouseEnterDela = props.mouseEnterDelay,
      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      overlayStyle = props.overlayStyle,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
      children = props.children,
      onVisibleChange = props.onVisibleChange,
      afterVisibleChange = props.afterVisibleChange,
      transitionName = props.transitionName,
      animation = props.animation,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$align = props.align,
      align = _props$align === void 0 ? {} : _props$align,
      _props$destroyTooltip = props.destroyTooltipOnHide,
      destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
      defaultVisible = props.defaultVisible,
      getTooltipContainer = props.getTooltipContainer,
      overlayInnerStyle = props.overlayInnerStyle,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);

  var domRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"])(ref, function () {
    return domRef.current;
  });

  var extraProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, restProps);

  if ('visible' in props) {
    extraProps.popupVisible = props.visible;
  }

  var getPopupElement = function getPopupElement() {
    var _props$arrowContent = props.arrowContent,
        arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent,
        overlay = props.overlay,
        id = props.id;
    return [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-arrow"),
      key: "arrow"
    }, arrowContent), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Content__["a" /* default */], {
      key: "content",
      prefixCls: prefixCls,
      id: id,
      overlay: overlay,
      overlayInnerStyle: overlayInnerStyle
    })];
  };

  var destroyTooltip = false;
  var autoDestroy = false;

  if (typeof destroyTooltipOnHide === 'boolean') {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(destroyTooltipOnHide) === 'object') {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_trigger__["a" /* default */], Object.assign({
    popupClassName: overlayClassName,
    prefixCls: prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_5__placements__["a" /* placements */],
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy: autoDestroy,
    mouseLeaveDelay: mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay: mouseEnterDelay
  }, extraProps), children);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"])(Tooltip));

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1437);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1438);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1439);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(391);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1441);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Content = function Content(props) {
  var overlay = props.overlay,
      prefixCls = props.prefixCls,
      id = props.id,
      overlayInnerStyle = props.overlayInnerStyle;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof overlay === 'function' ? overlay() : overlay);
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverflowOptions = getOverflowOptions;
exports["default"] = getPlacements;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _placements = __webpack_require__(1445);

var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset = [0, 0];

function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }

  return (0, _extends2["default"])((0, _extends2["default"])({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}

function getPlacements(config) {
  var _config$arrowWidth = config.arrowWidth,
      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
      _config$horizontalArr = config.horizontalArrowShift,
      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
      _config$verticalArrow = config.verticalArrowShift,
      verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow,
      autoAdjustOverflow = config.autoAdjustOverflow;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-4, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [4, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -4]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, 4]
    },
    topLeft: {
      points: ['bl', 'tc'],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ['tr', 'cl'],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ['br', 'tc'],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ['tl', 'cr'],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ['tr', 'bc'],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ['bl', 'cr'],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ['tl', 'bc'],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ['br', 'cl'],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? (0, _extends2["default"])((0, _extends2["default"])({}, placementMap[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: targetOffset
    }) : (0, _extends2["default"])((0, _extends2["default"])({}, _placements.placements[key]), {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
    placementMap[key].ignoreShake = true;
  });
  return placementMap;
}

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.placements = void 0;
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};
exports.placements = placements;
var _default = placements;
exports.default = _default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _useMergedState3 = _interopRequireDefault(__webpack_require__(384));

var _radio = _interopRequireDefault(__webpack_require__(392));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _context = __webpack_require__(393);

var RadioGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = React.useContext(_SizeContext["default"]);

  var _useMergedState = (0, _useMergedState3["default"])(props.defaultValue, {
    value: props.value
  }),
      _useMergedState2 = (0, _slicedToArray2["default"])(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  var onRadioChange = function onRadioChange(ev) {
    var lastValue = value;
    var val = ev.target.value;

    if (!('value' in props)) {
      setValue(val);
    }

    var onChange = props.onChange;

    if (onChange && val !== lastValue) {
      onChange(ev);
    }
  };

  var renderGroup = function renderGroup() {
    var _classNames;

    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        options = props.options,
        optionType = props.optionType,
        _props$buttonStyle = props.buttonStyle,
        buttonStyle = _props$buttonStyle === void 0 ? 'outline' : _props$buttonStyle,
        disabled = props.disabled,
        children = props.children,
        customizeSize = props.size,
        style = props.style,
        id = props.id,
        onMouseEnter = props.onMouseEnter,
        onMouseLeave = props.onMouseLeave;
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children; // 如果存在 options, 优先使用

    if (options && options.length > 0) {
      var optionsPrefixCls = optionType === 'button' ? "".concat(prefixCls, "-button") : prefixCls;
      childrenToRender = options.map(function (option) {
        if (typeof option === 'string') {
          // 此处类型自动推导为 string
          return /*#__PURE__*/React.createElement(_radio["default"], {
            key: option,
            prefixCls: optionsPrefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
          }, option);
        } // 此处类型自动推导为 { label: string value: string }


        return /*#__PURE__*/React.createElement(_radio["default"], {
          key: "radio-group-value-options-".concat(option.value),
          prefixCls: optionsPrefixCls,
          disabled: option.disabled || disabled,
          value: option.value,
          checked: value === option.value,
          style: option.style
        }, option.label);
      });
    }

    var mergedSize = customizeSize || size;
    var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), (0, _defineProperty2["default"])(_classNames, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/React.createElement("div", {
      className: classString,
      style: style,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      id: id,
      ref: ref
    }, childrenToRender);
  };

  return /*#__PURE__*/React.createElement(_context.RadioGroupContextProvider, {
    value: {
      onChange: onRadioChange,
      value: value,
      disabled: props.disabled,
      name: props.name
    }
  }, renderGroup());
});

var _default = /*#__PURE__*/React.memo(RadioGroup);

exports["default"] = _default;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _radio = _interopRequireDefault(__webpack_require__(392));

var _configProvider = __webpack_require__(8);

var _context = _interopRequireDefault(__webpack_require__(393));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RadioButton = function RadioButton(props, ref) {
  var radioGroupContext = React.useContext(_context["default"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var customizePrefixCls = props.prefixCls,
      radioProps = __rest(props, ["prefixCls"]);

  var prefixCls = getPrefixCls('radio-button', customizePrefixCls);

  if (radioGroupContext) {
    radioProps.checked = props.value === radioGroupContext.value;
    radioProps.disabled = props.disabled || radioGroupContext.disabled;
  }

  return /*#__PURE__*/React.createElement(_radio["default"], (0, _extends2["default"])({
    prefixCls: prefixCls
  }, radioProps, {
    type: "radio",
    ref: ref
  }));
};

var _default = /*#__PURE__*/React.forwardRef(RadioButton);

exports["default"] = _default;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSortData = getSortData;
exports["default"] = useFilterSorter;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CaretDownOutlined = _interopRequireDefault(__webpack_require__(1449));

var _CaretUpOutlined = _interopRequireDefault(__webpack_require__(1452));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var _util = __webpack_require__(394);

var ASCEND = 'ascend';
var DESCEND = 'descend';

function getMultiplePriority(column) {
  if ((0, _typeof2["default"])(column.sorter) === 'object' && typeof column.sorter.multiple === 'number') {
    return column.sorter.multiple;
  }

  return false;
}

function getSortFunction(sorter) {
  if (typeof sorter === 'function') {
    return sorter;
  }

  if (sorter && (0, _typeof2["default"])(sorter) === 'object' && sorter.compare) {
    return sorter.compare;
  }

  return false;
}

function nextSortDirection(sortDirections, current) {
  if (!current) {
    return sortDirections[0];
  }

  return sortDirections[sortDirections.indexOf(current) + 1];
}

function collectSortStates(columns, init, pos) {
  var sortStates = [];

  function pushState(column, columnPos) {
    sortStates.push({
      column: column,
      key: (0, _util.getColumnKey)(column, columnPos),
      multiplePriority: getMultiplePriority(column),
      sortOrder: column.sortOrder
    });
  }

  (columns || []).forEach(function (column, index) {
    var columnPos = (0, _util.getColumnPos)(index, pos);

    if (column.children) {
      if ('sortOrder' in column) {
        // Controlled
        pushState(column, columnPos);
      }

      sortStates = [].concat((0, _toConsumableArray2["default"])(sortStates), (0, _toConsumableArray2["default"])(collectSortStates(column.children, init, columnPos)));
    } else if (column.sorter) {
      if ('sortOrder' in column) {
        // Controlled
        pushState(column, columnPos);
      } else if (init && column.defaultSortOrder) {
        // Default sorter
        sortStates.push({
          column: column,
          key: (0, _util.getColumnKey)(column, columnPos),
          multiplePriority: getMultiplePriority(column),
          sortOrder: column.defaultSortOrder
        });
      }
    }
  });
  return sortStates;
}

function injectSorter(prefixCls, columns, sorterSates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
  return (columns || []).map(function (column, index) {
    var columnPos = (0, _util.getColumnPos)(index, pos);
    var newColumn = column;

    if (newColumn.sorter) {
      var sortDirections = newColumn.sortDirections || defaultSortDirections;
      var showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
      var columnKey = (0, _util.getColumnKey)(newColumn, columnPos);
      var sorterState = sorterSates.find(function (_ref) {
        var key = _ref.key;
        return key === columnKey;
      });
      var sorterOrder = sorterState ? sorterState.sortOrder : null;
      var nextSortOrder = nextSortDirection(sortDirections, sorterOrder);
      var upNode = sortDirections.includes(ASCEND) && /*#__PURE__*/React.createElement(_CaretUpOutlined["default"], {
        className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-up"), {
          active: sorterOrder === ASCEND
        })
      });
      var downNode = sortDirections.includes(DESCEND) && /*#__PURE__*/React.createElement(_CaretDownOutlined["default"], {
        className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-down"), {
          active: sorterOrder === DESCEND
        })
      });

      var _ref2 = tableLocale || {},
          cancelSort = _ref2.cancelSort,
          triggerAsc = _ref2.triggerAsc,
          triggerDesc = _ref2.triggerDesc;

      var sortTip = cancelSort;

      if (nextSortOrder === DESCEND) {
        sortTip = triggerDesc;
      } else if (nextSortOrder === ASCEND) {
        sortTip = triggerAsc;
      }

      newColumn = (0, _extends3["default"])((0, _extends3["default"])({}, newColumn), {
        className: (0, _classnames["default"])(newColumn.className, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-column-sort"), sorterOrder)),
        title: function title(renderProps) {
          var renderSortTitle = /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-column-sorters")
          }, /*#__PURE__*/React.createElement("span", null, (0, _util.renderColumnTitle)(column.title, renderProps)), /*#__PURE__*/React.createElement("span", {
            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-column-sorter-full"), upNode && downNode))
          }, /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-column-sorter-inner")
          }, upNode, downNode)));
          return showSorterTooltip ? /*#__PURE__*/React.createElement(_tooltip["default"], {
            title: sortTip
          }, /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-column-sorters-with-tooltip")
          }, renderSortTitle)) : renderSortTitle;
        },
        onHeaderCell: function onHeaderCell(col) {
          var cell = column.onHeaderCell && column.onHeaderCell(col) || {};
          var originOnClick = cell.onClick;

          cell.onClick = function (event) {
            triggerSorter({
              column: column,
              key: columnKey,
              sortOrder: nextSortOrder,
              multiplePriority: getMultiplePriority(column)
            });

            if (originOnClick) {
              originOnClick(event);
            }
          };

          cell.className = (0, _classnames["default"])(cell.className, "".concat(prefixCls, "-column-has-sorters"));
          return cell;
        }
      });
    }

    if ('children' in newColumn) {
      newColumn = (0, _extends3["default"])((0, _extends3["default"])({}, newColumn), {
        children: injectSorter(prefixCls, newColumn.children, sorterSates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
      });
    }

    return newColumn;
  });
}

function stateToInfo(sorterStates) {
  var column = sorterStates.column,
      sortOrder = sorterStates.sortOrder;
  return {
    column: column,
    order: sortOrder,
    field: column.dataIndex,
    columnKey: column.key
  };
}

function generateSorterInfo(sorterStates) {
  var list = sorterStates.filter(function (_ref3) {
    var sortOrder = _ref3.sortOrder;
    return sortOrder;
  }).map(stateToInfo); // =========== Legacy compatible support ===========
  // https://github.com/ant-design/ant-design/pull/19226

  if (list.length === 0 && sorterStates.length) {
    return (0, _extends3["default"])((0, _extends3["default"])({}, stateToInfo(sorterStates[sorterStates.length - 1])), {
      column: undefined
    });
  }

  if (list.length <= 1) {
    return list[0] || {};
  }

  return list;
}

function getSortData(data, sortStates, childrenColumnName) {
  var innerSorterStates = sortStates.slice().sort(function (a, b) {
    return b.multiplePriority - a.multiplePriority;
  });
  var cloneData = data.slice();
  var runningSorters = innerSorterStates.filter(function (_ref4) {
    var sorter = _ref4.column.sorter,
        sortOrder = _ref4.sortOrder;
    return getSortFunction(sorter) && sortOrder;
  }); // Skip if no sorter needed

  if (!runningSorters.length) {
    return cloneData;
  }

  return cloneData.sort(function (record1, record2) {
    for (var i = 0; i < runningSorters.length; i += 1) {
      var sorterState = runningSorters[i];
      var sorter = sorterState.column.sorter,
          sortOrder = sorterState.sortOrder;
      var compareFn = getSortFunction(sorter);

      if (compareFn && sortOrder) {
        var compareResult = compareFn(record1, record2, sortOrder);

        if (compareResult !== 0) {
          return sortOrder === ASCEND ? compareResult : -compareResult;
        }
      }
    }

    return 0;
  }).map(function (record) {
    var subRecords = record[childrenColumnName];

    if (subRecords) {
      return (0, _extends3["default"])((0, _extends3["default"])({}, record), (0, _defineProperty2["default"])({}, childrenColumnName, getSortData(subRecords, sortStates, childrenColumnName)));
    }

    return record;
  });
}

function useFilterSorter(_ref5) {
  var prefixCls = _ref5.prefixCls,
      mergedColumns = _ref5.mergedColumns,
      onSorterChange = _ref5.onSorterChange,
      sortDirections = _ref5.sortDirections,
      tableLocale = _ref5.tableLocale,
      showSorterTooltip = _ref5.showSorterTooltip;

  var _React$useState = React.useState(collectSortStates(mergedColumns, true)),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      sortStates = _React$useState2[0],
      setSortStates = _React$useState2[1];

  var mergedSorterStates = React.useMemo(function () {
    var validate = true;
    var collectedStates = collectSortStates(mergedColumns, false); // Return if not controlled

    if (!collectedStates.length) {
      return sortStates;
    }

    var validateStates = [];

    function patchStates(state) {
      if (validate) {
        validateStates.push(state);
      } else {
        validateStates.push((0, _extends3["default"])((0, _extends3["default"])({}, state), {
          sortOrder: null
        }));
      }
    }

    var multipleMode = null;
    collectedStates.forEach(function (state) {
      if (multipleMode === null) {
        patchStates(state);

        if (state.sortOrder) {
          if (state.multiplePriority === false) {
            validate = false;
          } else {
            multipleMode = true;
          }
        }
      } else if (multipleMode && state.multiplePriority !== false) {
        patchStates(state);
      } else {
        validate = false;
        patchStates(state);
      }
    });
    return validateStates;
  }, [mergedColumns, sortStates]); // Get render columns title required props

  var columnTitleSorterProps = React.useMemo(function () {
    var sortColumns = mergedSorterStates.map(function (_ref6) {
      var column = _ref6.column,
          sortOrder = _ref6.sortOrder;
      return {
        column: column,
        order: sortOrder
      };
    });
    return {
      sortColumns: sortColumns,
      // Legacy
      sortColumn: sortColumns[0] && sortColumns[0].column,
      sortOrder: sortColumns[0] && sortColumns[0].order
    };
  }, [mergedSorterStates]);

  function triggerSorter(sortState) {
    var newSorterStates;

    if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) {
      newSorterStates = [sortState];
    } else {
      newSorterStates = [].concat((0, _toConsumableArray2["default"])(mergedSorterStates.filter(function (_ref7) {
        var key = _ref7.key;
        return key !== sortState.key;
      })), [sortState]);
    }

    setSortStates(newSorterStates);
    onSorterChange(generateSorterInfo(newSorterStates), newSorterStates);
  }

  var transformColumns = function transformColumns(innerColumns) {
    return injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
  };

  var getSorters = function getSorters() {
    return generateSorterInfo(mergedSorterStates);
  };

  return [transformColumns, mergedSorterStates, columnTitleSorterProps, getSorters];
}

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CaretDownOutlined = _interopRequireDefault(__webpack_require__(1450));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CaretDownOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CaretDownOutlined = _interopRequireDefault(__webpack_require__(1451));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CaretDownOutlined.default
  }));
};
CaretDownOutlined.displayName = 'CaretDownOutlined';
var _default = /*#__PURE__*/React.forwardRef(CaretDownOutlined);
exports.default = _default;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CaretDownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };
exports.default = CaretDownOutlined;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CaretUpOutlined = _interopRequireDefault(__webpack_require__(1453));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CaretUpOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CaretUpOutlined = _interopRequireDefault(__webpack_require__(1454));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CaretUpOutlined.default
  }));
};
CaretUpOutlined.displayName = 'CaretUpOutlined';
var _default = /*#__PURE__*/React.forwardRef(CaretUpOutlined);
exports.default = _default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CaretUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };
exports.default = CaretUpOutlined;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterData = getFilterData;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var React = _interopRequireWildcard(__webpack_require__(0));

var _util = __webpack_require__(394);

var _FilterDropdown = _interopRequireDefault(__webpack_require__(1456));

function collectFilterStates(columns, init, pos) {
  var filterStates = [];
  (columns || []).forEach(function (column, index) {
    var columnPos = (0, _util.getColumnPos)(index, pos);

    if ('children' in column) {
      filterStates = [].concat((0, _toConsumableArray2["default"])(filterStates), (0, _toConsumableArray2["default"])(collectFilterStates(column.children, init, columnPos)));
    } else if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
      if ('filteredValue' in column) {
        // Controlled
        var filteredValues = Array.isArray(column.filteredValue) ? column.filteredValue.map(String) : column.filteredValue;
        filterStates.push({
          column: column,
          key: (0, _util.getColumnKey)(column, columnPos),
          filteredKeys: filteredValues,
          forceFiltered: column.filtered
        });
      } else {
        // Uncontrolled
        filterStates.push({
          column: column,
          key: (0, _util.getColumnKey)(column, columnPos),
          filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
          forceFiltered: column.filtered
        });
      }
    }
  });
  return filterStates;
}

function injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos) {
  return columns.map(function (column, index) {
    var columnPos = (0, _util.getColumnPos)(index, pos);
    var _column$filterMultipl = column.filterMultiple,
        filterMultiple = _column$filterMultipl === void 0 ? true : _column$filterMultipl;
    var newColumn = column;

    if (newColumn.filters || newColumn.filterDropdown) {
      var columnKey = (0, _util.getColumnKey)(newColumn, columnPos);
      var filterState = filterStates.find(function (_ref) {
        var key = _ref.key;
        return columnKey === key;
      });
      newColumn = (0, _extends2["default"])((0, _extends2["default"])({}, newColumn), {
        title: function title(renderProps) {
          return /*#__PURE__*/React.createElement(_FilterDropdown["default"], {
            prefixCls: "".concat(prefixCls, "-filter"),
            dropdownPrefixCls: dropdownPrefixCls,
            column: newColumn,
            columnKey: columnKey,
            filterState: filterState,
            filterMultiple: filterMultiple,
            triggerFilter: triggerFilter,
            locale: locale,
            getPopupContainer: getPopupContainer
          }, (0, _util.renderColumnTitle)(column.title, renderProps));
        }
      });
    }

    if ('children' in newColumn) {
      newColumn = (0, _extends2["default"])((0, _extends2["default"])({}, newColumn), {
        children: injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos)
      });
    }

    return newColumn;
  });
}

function generateFilterInfo(filterStates) {
  var currentFilters = {};
  filterStates.forEach(function (_ref2) {
    var key = _ref2.key,
        filteredKeys = _ref2.filteredKeys,
        column = _ref2.column;
    var filters = column.filters,
        filterDropdown = column.filterDropdown;

    if (filterDropdown) {
      currentFilters[key] = filteredKeys || null;
    } else {
      var originKeys = [];

      if (Array.isArray(filteredKeys)) {
        filters === null || filters === void 0 ? void 0 : filters.forEach(function (filter) {
          if (filteredKeys.includes(String(filter.value))) {
            originKeys.push(filter.value);
          }
        });
        currentFilters[key] = originKeys;
      } else {
        currentFilters[key] = null;
      }
    }
  });
  return currentFilters;
}

function flattenKeys(filters) {
  var keys = [];
  (filters || []).forEach(function (_ref3) {
    var value = _ref3.value,
        children = _ref3.children;
    keys.push(value);

    if (children) {
      keys = [].concat((0, _toConsumableArray2["default"])(keys), (0, _toConsumableArray2["default"])(flattenKeys(children)));
    }
  });
  return keys;
}

function getFilterData(data, filterStates) {
  return filterStates.reduce(function (currentData, filterState) {
    var _filterState$column = filterState.column,
        onFilter = _filterState$column.onFilter,
        filters = _filterState$column.filters,
        filteredKeys = filterState.filteredKeys;

    if (onFilter && filteredKeys && filteredKeys.length) {
      return currentData.filter(function (record) {
        return filteredKeys.some(function (key) {
          var keys = flattenKeys(filters);
          var keyIndex = keys.findIndex(function (k) {
            return String(k) === String(key);
          });
          var realKey = keyIndex !== -1 ? keys[keyIndex] : key;
          return onFilter(realKey, record);
        });
      });
    }

    return currentData;
  }, data);
}

function useFilter(_ref4) {
  var prefixCls = _ref4.prefixCls,
      dropdownPrefixCls = _ref4.dropdownPrefixCls,
      mergedColumns = _ref4.mergedColumns,
      onFilterChange = _ref4.onFilterChange,
      getPopupContainer = _ref4.getPopupContainer,
      tableLocale = _ref4.locale;

  var _React$useState = React.useState(collectFilterStates(mergedColumns, true)),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      filterStates = _React$useState2[0],
      setFilterStates = _React$useState2[1];

  var mergedFilterStates = React.useMemo(function () {
    var collectedStates = collectFilterStates(mergedColumns, false); // Return if not controlled

    if (collectedStates.every(function (_ref5) {
      var filteredKeys = _ref5.filteredKeys;
      return filteredKeys === undefined;
    })) {
      return filterStates;
    }

    return collectedStates;
  }, [mergedColumns, filterStates]);
  var getFilters = React.useCallback(function () {
    return generateFilterInfo(mergedFilterStates);
  }, [mergedFilterStates]);

  var triggerFilter = function triggerFilter(filterState) {
    var newFilterStates = mergedFilterStates.filter(function (_ref6) {
      var key = _ref6.key;
      return key !== filterState.key;
    });
    newFilterStates.push(filterState);
    setFilterStates(newFilterStates);
    onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
  };

  var transformColumns = function transformColumns(innerColumns) {
    return injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale);
  };

  return [transformColumns, mergedFilterStates, getFilters];
}

var _default = useFilter;
exports["default"] = _default;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _isEqual = _interopRequireDefault(__webpack_require__(663));

var _FilterFilled = _interopRequireDefault(__webpack_require__(1522));

var _button = _interopRequireDefault(__webpack_require__(26));

var _menu = _interopRequireDefault(__webpack_require__(388));

var _checkbox = _interopRequireDefault(__webpack_require__(70));

var _radio = _interopRequireDefault(__webpack_require__(110));

var _dropdown = _interopRequireDefault(__webpack_require__(649));

var _empty = _interopRequireDefault(__webpack_require__(335));

var _FilterWrapper = _interopRequireDefault(__webpack_require__(1525));

var _useSyncState3 = _interopRequireDefault(__webpack_require__(1526));

var _context = __webpack_require__(334);

var SubMenu = _menu["default"].SubMenu,
    MenuItem = _menu["default"].Item;

function hasSubMenu(filters) {
  return filters.some(function (_ref) {
    var children = _ref.children;
    return children;
  });
}

function renderFilterItems(_ref2) {
  var filters = _ref2.filters,
      prefixCls = _ref2.prefixCls,
      filteredKeys = _ref2.filteredKeys,
      filterMultiple = _ref2.filterMultiple,
      locale = _ref2.locale;

  if (filters.length === 0) {
    // wrapped with <div /> to avoid react warning
    // https://github.com/ant-design/ant-design/issues/25979
    return /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '16px 0'
      }
    }, /*#__PURE__*/React.createElement(_empty["default"], {
      image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
      description: locale.filterEmptyText,
      imageStyle: {
        height: 24
      }
    }));
  }

  return filters.map(function (filter, index) {
    var key = String(filter.value);

    if (filter.children) {
      return /*#__PURE__*/React.createElement(SubMenu, {
        key: key || index,
        title: filter.text,
        popupClassName: "".concat(prefixCls, "-dropdown-submenu")
      }, renderFilterItems({
        filters: filter.children,
        prefixCls: prefixCls,
        filteredKeys: filteredKeys,
        filterMultiple: filterMultiple,
        locale: locale
      }));
    }

    var Component = filterMultiple ? _checkbox["default"] : _radio["default"];
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: filter.value !== undefined ? key : index
    }, /*#__PURE__*/React.createElement(Component, {
      checked: filteredKeys.includes(key)
    }), /*#__PURE__*/React.createElement("span", null, filter.text));
  });
}

function FilterDropdown(props) {
  var _a;

  var prefixCls = props.prefixCls,
      column = props.column,
      dropdownPrefixCls = props.dropdownPrefixCls,
      columnKey = props.columnKey,
      filterMultiple = props.filterMultiple,
      filterState = props.filterState,
      triggerFilter = props.triggerFilter,
      locale = props.locale,
      children = props.children,
      getPopupContainer = props.getPopupContainer;
  var filterDropdownVisible = column.filterDropdownVisible,
      onFilterDropdownVisibleChange = column.onFilterDropdownVisibleChange;

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  var filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));

  var triggerVisible = function triggerVisible(newVisible) {
    setVisible(newVisible);

    if (onFilterDropdownVisibleChange) {
      onFilterDropdownVisibleChange(newVisible);
    }
  };

  var mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible; // ===================== Select Keys =====================

  var propFilteredKeys = filterState && filterState.filteredKeys;

  var _useSyncState = (0, _useSyncState3["default"])(propFilteredKeys || []),
      _useSyncState2 = (0, _slicedToArray2["default"])(_useSyncState, 2),
      getFilteredKeysSync = _useSyncState2[0],
      setFilteredKeysSync = _useSyncState2[1];

  var onSelectKeys = function onSelectKeys(_ref3) {
    var selectedKeys = _ref3.selectedKeys;
    setFilteredKeysSync(selectedKeys);
  };

  React.useEffect(function () {
    onSelectKeys({
      selectedKeys: propFilteredKeys || []
    });
  }, [propFilteredKeys]); // ====================== Open Keys ======================

  var _React$useState3 = React.useState([]),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      openKeys = _React$useState4[0],
      setOpenKeys = _React$useState4[1];

  var openRef = React.useRef();

  var onOpenChange = function onOpenChange(keys) {
    openRef.current = window.setTimeout(function () {
      setOpenKeys(keys);
    });
  };

  var onMenuClick = function onMenuClick() {
    window.clearTimeout(openRef.current);
  };

  React.useEffect(function () {
    return function () {
      window.clearTimeout(openRef.current);
    };
  }, []); // ======================= Submit ========================

  var internalTriggerFilter = function internalTriggerFilter(keys) {
    triggerVisible(false);
    var mergedKeys = keys && keys.length ? keys : null;

    if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
      return null;
    }

    if ((0, _isEqual["default"])(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) {
      return null;
    }

    triggerFilter({
      column: column,
      key: columnKey,
      filteredKeys: mergedKeys
    });
  };

  var onConfirm = function onConfirm() {
    internalTriggerFilter(getFilteredKeysSync());
  };

  var onReset = function onReset() {
    setFilteredKeysSync([]);
    internalTriggerFilter([]);
  };

  var onVisibleChange = function onVisibleChange(newVisible) {
    if (newVisible && propFilteredKeys !== undefined) {
      // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
      setFilteredKeysSync(propFilteredKeys || []);
    }

    triggerVisible(newVisible); // Default will filter when closed

    if (!newVisible && !column.filterDropdown) {
      onConfirm();
    }
  }; // ======================== Style ========================


  var dropdownMenuClass = (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !hasSubMenu(column.filters || [])));
  var dropdownContent;

  if (typeof column.filterDropdown === 'function') {
    dropdownContent = column.filterDropdown({
      prefixCls: "".concat(dropdownPrefixCls, "-custom"),
      setSelectedKeys: function setSelectedKeys(selectedKeys) {
        return onSelectKeys({
          selectedKeys: selectedKeys
        });
      },
      selectedKeys: getFilteredKeysSync(),
      confirm: onConfirm,
      clearFilters: onReset,
      filters: column.filters,
      visible: mergedVisible
    });
  } else if (column.filterDropdown) {
    dropdownContent = column.filterDropdown;
  } else {
    var selectedKeys = getFilteredKeysSync() || [];
    dropdownContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_menu["default"], {
      multiple: filterMultiple,
      prefixCls: "".concat(dropdownPrefixCls, "-menu"),
      className: dropdownMenuClass,
      onClick: onMenuClick,
      onSelect: onSelectKeys,
      onDeselect: onSelectKeys,
      selectedKeys: selectedKeys,
      getPopupContainer: getPopupContainer,
      openKeys: openKeys,
      onOpenChange: onOpenChange
    }, renderFilterItems({
      filters: column.filters || [],
      prefixCls: prefixCls,
      filteredKeys: getFilteredKeysSync(),
      filterMultiple: filterMultiple,
      locale: locale
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-dropdown-btns")
    }, /*#__PURE__*/React.createElement(_button["default"], {
      type: "link",
      size: "small",
      disabled: selectedKeys.length === 0,
      onClick: onReset
    }, locale.filterReset), /*#__PURE__*/React.createElement(_button["default"], {
      type: "primary",
      size: "small",
      onClick: onConfirm
    }, locale.filterConfirm)));
  }

  var menu = /*#__PURE__*/React.createElement(_FilterWrapper["default"], {
    className: "".concat(prefixCls, "-dropdown")
  }, dropdownContent);
  var filterIcon;

  if (typeof column.filterIcon === 'function') {
    filterIcon = column.filterIcon(filtered);
  } else if (column.filterIcon) {
    filterIcon = column.filterIcon;
  } else {
    filterIcon = /*#__PURE__*/React.createElement(_FilterFilled["default"], null);
  }

  var _React$useContext = React.useContext(_context.ConfigContext),
      direction = _React$useContext.direction;

  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])("".concat(prefixCls, "-column"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-column-title")
  }, children), /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])("".concat(prefixCls, "-trigger-container"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-trigger-container-open"), mergedVisible)),
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(_dropdown["default"], {
    overlay: menu,
    trigger: ['click'],
    visible: mergedVisible,
    onVisibleChange: onVisibleChange,
    getPopupContainer: getPopupContainer,
    placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight'
  }, /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: -1,
    className: (0, _classnames["default"])("".concat(prefixCls, "-trigger"), {
      active: filtered
    })
  }, filterIcon))));
}

var _default = FilterDropdown;
exports["default"] = _default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1458),
    isObjectLike = __webpack_require__(212);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1459),
    equalArrays = __webpack_require__(668),
    equalByTag = __webpack_require__(1491),
    equalObjects = __webpack_require__(1495),
    getTag = __webpack_require__(1517),
    isArray = __webpack_require__(396),
    isBuffer = __webpack_require__(669),
    isTypedArray = __webpack_require__(670);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(289),
    stackClear = __webpack_require__(1465),
    stackDelete = __webpack_require__(1466),
    stackGet = __webpack_require__(1467),
    stackHas = __webpack_require__(1468),
    stackSet = __webpack_require__(1469);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(290);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(290);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(290);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(290);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(289);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1468 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(289),
    Map = __webpack_require__(395),
    MapCache = __webpack_require__(667);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(665),
    isMasked = __webpack_require__(1471),
    isObject = __webpack_require__(277),
    toSource = __webpack_require__(666);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1472);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(109);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1473 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1475),
    ListCache = __webpack_require__(289),
    Map = __webpack_require__(395);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1476),
    hashDelete = __webpack_require__(1477),
    hashGet = __webpack_require__(1478),
    hashHas = __webpack_require__(1479),
    hashSet = __webpack_require__(1480);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(291);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(291);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(291);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(291);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(292);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(292);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(292);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(292);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(667),
    setCacheAdd = __webpack_require__(1487),
    setCacheHas = __webpack_require__(1488);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1487 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1489 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(370),
    Uint8Array = __webpack_require__(1492),
    eq = __webpack_require__(664),
    equalArrays = __webpack_require__(668),
    mapToArray = __webpack_require__(1493),
    setToArray = __webpack_require__(1494);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(109);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1493 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1496);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1497),
    getSymbols = __webpack_require__(1499),
    keys = __webpack_require__(1502);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1498),
    isArray = __webpack_require__(396);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1500),
    stubArray = __webpack_require__(1501);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1501 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1503),
    baseKeys = __webpack_require__(1512),
    isArrayLike = __webpack_require__(1516);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1504),
    isArguments = __webpack_require__(1505),
    isArray = __webpack_require__(396),
    isBuffer = __webpack_require__(669),
    isIndex = __webpack_require__(1508),
    isTypedArray = __webpack_require__(670);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1504 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1506),
    isObjectLike = __webpack_require__(212);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(211),
    isObjectLike = __webpack_require__(212);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(211),
    isLength = __webpack_require__(671),
    isObjectLike = __webpack_require__(212);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(597);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)(module)))

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1513),
    nativeKeys = __webpack_require__(1514);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1515);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(665),
    isLength = __webpack_require__(671);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1518),
    Map = __webpack_require__(395),
    Promise = __webpack_require__(1519),
    Set = __webpack_require__(1520),
    WeakMap = __webpack_require__(1521),
    baseGetTag = __webpack_require__(211),
    toSource = __webpack_require__(666);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184),
    root = __webpack_require__(109);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184),
    root = __webpack_require__(109);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184),
    root = __webpack_require__(109);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(184),
    root = __webpack_require__(109);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FilterFilled = _interopRequireDefault(__webpack_require__(1523));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _FilterFilled;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _FilterFilled = _interopRequireDefault(__webpack_require__(1524));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _FilterFilled.default
  }));
};
FilterFilled.displayName = 'FilterFilled';
var _default = /*#__PURE__*/React.forwardRef(FilterFilled);
exports.default = _default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var FilterFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };
exports.default = FilterFilled;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
};

var _default = FilterDropdownMenuWrapper;
exports["default"] = _default;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSyncState;

var React = _interopRequireWildcard(__webpack_require__(0));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

function useSyncState(initialValue) {
  var ref = React.useRef(initialValue);
  var forceUpdate = (0, _useForceUpdate["default"])();
  return [function () {
    return ref.current;
  }, function (newValue) {
    ref.current = newValue; // re-render

    forceUpdate();
  }];
}

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTitleColumns;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _util = __webpack_require__(394);

function fillTitle(columns, columnTitleProps) {
  return columns.map(function (column) {
    var cloneColumn = (0, _extends2["default"])({}, column);
    cloneColumn.title = (0, _util.renderColumnTitle)(column.title, columnTitleProps);

    if ('children' in cloneColumn) {
      cloneColumn.children = fillTitle(cloneColumn.children, columnTitleProps);
    }

    return cloneColumn;
  });
}

function useTitleColumns(columnTitleProps) {
  var filledColumns = React.useCallback(function (columns) {
    return fillTitle(columns, columnTitleProps);
  }, [columnTitleProps]);
  return [filledColumns];
}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

function renderExpandIcon(locale) {
  return function expandIcon(_ref) {
    var _classNames;

    var prefixCls = _ref.prefixCls,
        onExpand = _ref.onExpand,
        record = _ref.record,
        expanded = _ref.expanded,
        expandable = _ref.expandable;
    var iconPrefix = "".concat(prefixCls, "-row-expand-icon");
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick(e) {
        onExpand(record, e);
        e.stopPropagation();
      },
      className: (0, _classnames["default"])(iconPrefix, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(iconPrefix, "-spaced"), !expandable), (0, _defineProperty2["default"])(_classNames, "".concat(iconPrefix, "-expanded"), expandable && expanded), (0, _defineProperty2["default"])(_classNames, "".concat(iconPrefix, "-collapsed"), expandable && !expanded), _classNames)),
      "aria-label": expanded ? locale.collapse : locale.expand
    });
  };
}

var _default = renderExpandIcon;
exports["default"] = _default;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

var _raf = _interopRequireDefault(__webpack_require__(176));

var _getScroll = _interopRequireWildcard(__webpack_require__(1530));

var _easings = __webpack_require__(1531);

function scrollTo(y) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$getContainer = options.getContainer,
      getContainer = _options$getContainer === void 0 ? function () {
    return window;
  } : _options$getContainer,
      callback = options.callback,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 450 : _options$duration;
  var container = getContainer();
  var scrollTop = (0, _getScroll["default"])(container, true);
  var startTime = Date.now();

  var frameFunc = function frameFunc() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);

    if ((0, _getScroll.isWindow)(container)) {
      container.scrollTo(window.pageXOffset, nextScrollTop);
    } else if (container instanceof HTMLDocument || container.constructor.name === 'HTMLDocument') {
      container.documentElement.scrollTop = nextScrollTop;
    } else {
      container.scrollTop = nextScrollTop;
    }

    if (time < duration) {
      (0, _raf["default"])(frameFunc);
    } else if (typeof callback === 'function') {
      callback();
    }
  };

  (0, _raf["default"])(frameFunc);
}

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWindow = isWindow;
exports["default"] = getScroll;

function isWindow(obj) {
  return obj !== null && obj !== undefined && obj === obj.window;
}

function getScroll(target, top) {
  if (typeof window === 'undefined') {
    return 0;
  }

  var method = top ? 'scrollTop' : 'scrollLeft';
  var result = 0;

  if (isWindow(target)) {
    result = target[top ? 'pageYOffset' : 'pageXOffset'];
  } else if (target instanceof Document) {
    result = target.documentElement[method];
  } else if (target) {
    result = target[method];
  }

  if (target && !isWindow(target) && typeof result !== 'number') {
    result = (target.ownerDocument || target).documentElement[method];
  }

  return result;
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeInOutCubic = easeInOutCubic;

// eslint-disable-next-line import/prefer-default-export
function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;

  if (t < 1) {
    return cc / 2 * t * t * t + b;
  } // eslint-disable-next-line no-return-assign


  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _default = _default2["default"];
exports["default"] = _default;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* istanbul ignore next */

/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
// eslint-disable-next-line no-unused-vars
function Column(_) {
  return null;
}

var _default = Column;
exports["default"] = _default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* istanbul ignore next */

/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
// eslint-disable-next-line no-unused-vars
function ColumnGroup(_) {
  return null;
}

var _default = ColumnGroup;
exports["default"] = _default;

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Meta = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _index = __webpack_require__(37);

var _grid = __webpack_require__(294);

var _configProvider = __webpack_require__(8);

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Meta = function Meta(_a) {
  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      avatar = _a.avatar,
      title = _a.title,
      description = _a.description,
      others = __rest(_a, ["prefixCls", "className", "avatar", "title", "description"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('list', customizePrefixCls);
  var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
  var content = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-content")
  }, title && /*#__PURE__*/React.createElement("h4", {
    className: "".concat(prefixCls, "-item-meta-title")
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-description")
  }, description));
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, others, {
    className: classString
  }), avatar && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-meta-avatar")
  }, avatar), (title || description) && content);
};

exports.Meta = Meta;

var Item = function Item(_a) {
  var customizePrefixCls = _a.prefixCls,
      children = _a.children,
      actions = _a.actions,
      extra = _a.extra,
      className = _a.className,
      colStyle = _a.colStyle,
      others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className", "colStyle"]);

  var _React$useContext2 = React.useContext(_index.ListContext),
      grid = _React$useContext2.grid,
      itemLayout = _React$useContext2.itemLayout;

  var _React$useContext3 = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext3.getPrefixCls;

  var isItemContainsTextNodeAndNotSingular = function isItemContainsTextNodeAndNotSingular() {
    var result;
    React.Children.forEach(children, function (element) {
      if (typeof element === 'string') {
        result = true;
      }
    });
    return result && React.Children.count(children) > 1;
  };

  var isFlexMode = function isFlexMode() {
    if (itemLayout === 'vertical') {
      return !!extra;
    }

    return !isItemContainsTextNodeAndNotSingular();
  };

  var prefixCls = getPrefixCls('list', customizePrefixCls);
  var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-item-action"),
    key: "actions"
  }, actions.map(function (action, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        key: "".concat(prefixCls, "-item-action-").concat(i)
      }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
        className: "".concat(prefixCls, "-item-action-split")
      }))
    );
  }));
  var Element = grid ? 'div' : 'li';
  var itemChildren = /*#__PURE__*/React.createElement(Element, (0, _extends2["default"])({}, others, {
    // `li` element `onCopy` prop args is not same as `div`
    className: (0, _classnames["default"])("".concat(prefixCls, "-item"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-item-no-flex"), !isFlexMode()), className)
  }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-main"),
    key: "content"
  }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item-extra"),
    key: "extra"
  }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
    key: 'extra'
  })]);
  return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
    flex: 1,
    style: colStyle
  }, itemChildren) : itemChildren;
};

Item.Meta = Meta;
var _default = Item;
exports["default"] = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var FormOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] }, "name": "form", "theme": "outlined" };
exports.default = FormOutlined;


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _reactNode = __webpack_require__(57);

var _configProvider = __webpack_require__(8);

var _avatar = _interopRequireDefault(__webpack_require__(674));

var _popover = _interopRequireDefault(__webpack_require__(676));

var _SizeContext = __webpack_require__(675);

var Group = function Group(props) {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var customizePrefixCls = props.prefixCls,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      maxCount = props.maxCount,
      maxStyle = props.maxStyle,
      size = props.size;
  var prefixCls = getPrefixCls('avatar-group', customizePrefixCls);
  var cls = (0, _classnames["default"])(prefixCls, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
  var children = props.children,
      _props$maxPopoverPlac = props.maxPopoverPlacement,
      maxPopoverPlacement = _props$maxPopoverPlac === void 0 ? 'top' : _props$maxPopoverPlac;
  var childrenWithProps = (0, _toArray["default"])(children).map(function (child, index) {
    return (0, _reactNode.cloneElement)(child, {
      key: "avatar-key-".concat(index)
    });
  });
  var numOfChildren = childrenWithProps.length;

  if (maxCount && maxCount < numOfChildren) {
    var childrenShow = childrenWithProps.slice(0, maxCount);
    var childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
    childrenShow.push( /*#__PURE__*/React.createElement(_popover["default"], {
      key: "avatar-popover-key",
      content: childrenHidden,
      trigger: "hover",
      placement: maxPopoverPlacement,
      overlayClassName: "".concat(prefixCls, "-popover")
    }, /*#__PURE__*/React.createElement(_avatar["default"], {
      style: maxStyle
    }, "+".concat(numOfChildren - maxCount))));
    return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
      size: size
    }, /*#__PURE__*/React.createElement("div", {
      className: cls,
      style: props.style
    }, childrenShow));
  }

  return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
    size: size
  }, /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: props.style
  }, childrenWithProps));
};

var _default = Group;
exports["default"] = _default;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ShopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z" } }] }, "name": "shop", "theme": "outlined" };
exports.default = ShopOutlined;


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1545);

__webpack_require__(139);

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(1547));

var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1548));

var _menu = _interopRequireDefault(__webpack_require__(388));

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _reactNode = __webpack_require__(57);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function getBreadcrumbName(route, params) {
  if (!route.breadcrumbName) {
    return null;
  }

  var paramsKeys = Object.keys(params).join('|');
  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
    return params[key] || replacement;
  });
  return name;
}

function defaultItemRender(route, params, routes, paths) {
  var isLastItem = routes.indexOf(route) === routes.length - 1;
  var name = getBreadcrumbName(route, params);
  return isLastItem ? /*#__PURE__*/React.createElement("span", null, name) : /*#__PURE__*/React.createElement("a", {
    href: "#/".concat(paths.join('/'))
  }, name);
}

var getPath = function getPath(path, params) {
  path = (path || '').replace(/^\//, '');
  Object.keys(params).forEach(function (key) {
    path = path.replace(":".concat(key), params[key]);
  });
  return path;
};

var addChildPath = function addChildPath(paths) {
  var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var params = arguments.length > 2 ? arguments[2] : undefined;
  var originalPaths = (0, _toConsumableArray2["default"])(paths);
  var path = getPath(childPath, params);

  if (path) {
    originalPaths.push(path);
  }

  return originalPaths;
};

var Breadcrumb = function Breadcrumb(_a) {
  var customizePrefixCls = _a.prefixCls,
      _a$separator = _a.separator,
      separator = _a$separator === void 0 ? '/' : _a$separator,
      style = _a.style,
      className = _a.className,
      routes = _a.routes,
      children = _a.children,
      _a$itemRender = _a.itemRender,
      itemRender = _a$itemRender === void 0 ? defaultItemRender : _a$itemRender,
      _a$params = _a.params,
      params = _a$params === void 0 ? {} : _a$params,
      restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children", "itemRender", "params"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var crumbs;
  var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);

  if (routes && routes.length > 0) {
    // generated by route
    var paths = [];
    crumbs = routes.map(function (route) {
      var path = getPath(route.path, params);

      if (path) {
        paths.push(path);
      } // generated overlay by route.children


      var overlay;

      if (route.children && route.children.length) {
        overlay = /*#__PURE__*/React.createElement(_menu["default"], null, route.children.map(function (child) {
          return /*#__PURE__*/React.createElement(_menu["default"].Item, {
            key: child.path || child.breadcrumbName
          }, itemRender(child, params, routes, addChildPath(paths, child.path, params)));
        }));
      }

      return /*#__PURE__*/React.createElement(_BreadcrumbItem["default"], {
        overlay: overlay,
        separator: separator,
        key: path || route.breadcrumbName
      }, itemRender(route, params, routes, paths));
    });
  } else if (children) {
    crumbs = (0, _toArray["default"])(children).map(function (element, index) {
      if (!element) {
        return element;
      }

      (0, _devWarning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
      return (0, _reactNode.cloneElement)(element, {
        separator: separator,
        key: index
      });
    });
  }

  var breadcrumbClassName = (0, _classnames["default"])(prefixCls, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: breadcrumbClassName,
    style: style
  }, restProps), crumbs);
};

Breadcrumb.Item = _BreadcrumbItem["default"];
Breadcrumb.Separator = _BreadcrumbSeparator["default"];
var _default = Breadcrumb;
exports["default"] = _default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _DownOutlined = _interopRequireDefault(__webpack_require__(216));

var _dropdown = _interopRequireDefault(__webpack_require__(386));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var BreadcrumbItem = function BreadcrumbItem(_a) {
  var customizePrefixCls = _a.prefixCls,
      _a$separator = _a.separator,
      separator = _a$separator === void 0 ? '/' : _a$separator,
      children = _a.children,
      overlay = _a.overlay,
      dropdownProps = _a.dropdownProps,
      restProps = __rest(_a, ["prefixCls", "separator", "children", "overlay", "dropdownProps"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
  /** If overlay is have Wrap a DropDown */

  var renderBreadcrumbNode = function renderBreadcrumbNode(breadcrumbItem) {
    if (overlay) {
      return /*#__PURE__*/React.createElement(_dropdown["default"], (0, _extends2["default"])({
        overlay: overlay,
        placement: "bottomCenter"
      }, dropdownProps), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-overlay-link")
      }, breadcrumbItem, /*#__PURE__*/React.createElement(_DownOutlined["default"], null)));
    }

    return breadcrumbItem;
  };

  var link;

  if ('href' in restProps) {
    link = /*#__PURE__*/React.createElement("a", (0, _extends2["default"])({
      className: "".concat(prefixCls, "-link")
    }, restProps), children);
  } else {
    link = /*#__PURE__*/React.createElement("span", (0, _extends2["default"])({
      className: "".concat(prefixCls, "-link")
    }, restProps), children);
  } // wrap to dropDown


  link = renderBreadcrumbNode(link);

  if (children) {
    return /*#__PURE__*/React.createElement("span", null, link, separator && separator !== '' && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-separator")
    }, separator));
  }

  return null;
};

BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
var _default = BreadcrumbItem;
exports["default"] = _default;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _configProvider = __webpack_require__(8);

var BreadcrumbSeparator = function BreadcrumbSeparator(_ref) {
  var children = _ref.children;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('breadcrumb');
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-separator")
  }, children || '/');
};

BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
var _default = BreadcrumbSeparator;
exports["default"] = _default;

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1552);

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1554);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(__webpack_require__(44));

var _warning = __webpack_require__(106);

var generateConfig = {
  // get
  getNow: function getNow() {
    return (0, _moment.default)();
  },
  getFixedDate: function getFixedDate(string) {
    return (0, _moment.default)(string, 'YYYY-MM-DD');
  },
  getEndDate: function getEndDate(date) {
    var clone = date.clone();
    return clone.endOf('month');
  },
  getWeekDay: function getWeekDay(date) {
    var clone = date.clone().locale('en_US');
    return clone.weekday() + clone.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date) {
    return date.year();
  },
  getMonth: function getMonth(date) {
    return date.month();
  },
  getDate: function getDate(date) {
    return date.date();
  },
  getHour: function getHour(date) {
    return date.hour();
  },
  getMinute: function getMinute(date) {
    return date.minute();
  },
  getSecond: function getSecond(date) {
    return date.second();
  },
  // set
  addYear: function addYear(date, diff) {
    var clone = date.clone();
    return clone.add(diff, 'year');
  },
  addMonth: function addMonth(date, diff) {
    var clone = date.clone();
    return clone.add(diff, 'month');
  },
  addDate: function addDate(date, diff) {
    var clone = date.clone();
    return clone.add(diff, 'day');
  },
  setYear: function setYear(date, year) {
    var clone = date.clone();
    return clone.year(year);
  },
  setMonth: function setMonth(date, month) {
    var clone = date.clone();
    return clone.month(month);
  },
  setDate: function setDate(date, num) {
    var clone = date.clone();
    return clone.date(num);
  },
  setHour: function setHour(date, hour) {
    var clone = date.clone();
    return clone.hour(hour);
  },
  setMinute: function setMinute(date, minute) {
    var clone = date.clone();
    return clone.minute(minute);
  },
  setSecond: function setSecond(date, second) {
    var clone = date.clone();
    return clone.second(second);
  },
  // Compare
  isAfter: function isAfter(date1, date2) {
    return date1.isAfter(date2);
  },
  isValidate: function isValidate(date) {
    return date.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale) {
      var date = (0, _moment.default)().locale(locale);
      return date.localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale, date) {
      var clone = date.clone();
      var result = clone.locale(locale);
      return result.weekday(0);
    },
    getWeek: function getWeek(locale, date) {
      var clone = date.clone();
      var result = clone.locale(locale);
      return result.week();
    },
    getShortWeekDays: function getShortWeekDays(locale) {
      var date = (0, _moment.default)().locale(locale);
      return date.localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale) {
      var date = (0, _moment.default)().locale(locale);
      return date.localeData().monthsShort();
    },
    format: function format(locale, date, _format) {
      var clone = date.clone();
      var result = clone.locale(locale);
      return result.format(_format);
    },
    parse: function parse(locale, text, formats) {
      var fallbackFormatList = [];

      for (var i = 0; i < formats.length; i += 1) {
        var format = formats[i];
        var formatText = text;

        if (format.includes('wo') || format.includes('Wo')) {
          format = format.replace(/wo/g, 'w').replace(/Wo/g, 'W');
          var matchFormat = format.match(/[-YyMmDdHhSsWwGg]+/g);
          var matchText = formatText.match(/[-\d]+/g);

          if (matchFormat && matchText) {
            format = matchFormat.join('');
            formatText = matchText.join('');
          } else {
            fallbackFormatList.push(format.replace(/o/g, ''));
          }
        }

        var date = (0, _moment.default)(formatText, format, locale, true);

        if (date.isValid()) {
          return date;
        }
      } // Fallback to fuzzy matching, this should always not reach match or need fire a issue


      for (var _i = 0; _i < fallbackFormatList.length; _i += 1) {
        var _date = (0, _moment.default)(text, fallbackFormatList[_i], locale, false);
        /* istanbul ignore next */


        if (_date.isValid()) {
          (0, _warning.noteOnce)(false, 'Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this.');
          return _date;
        }
      }

      return null;
    }
  }
};
var _default = generateConfig;
exports.default = _default;

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PickerButton;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _button = _interopRequireDefault(__webpack_require__(26));

function PickerButton(props) {
  return /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({
    size: "small",
    type: "primary"
  }, props));
}

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PickerTag;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _tag = _interopRequireDefault(__webpack_require__(1557));

function PickerTag(props) {
  return /*#__PURE__*/React.createElement(_tag["default"], (0, _extends2["default"])({
    color: "blue"
  }, props));
}

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _CheckableTag = _interopRequireDefault(__webpack_require__(1558));

var _configProvider = __webpack_require__(8);

var _colors = __webpack_require__(661);

var _wave = _interopRequireDefault(__webpack_require__(387));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));
var PresetStatusColorRegex = new RegExp("^(".concat(_colors.PresetStatusColorTypes.join('|'), ")$"));

var InternalTag = function InternalTag(_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      style = _a.style,
      children = _a.children,
      icon = _a.icon,
      color = _a.color,
      onClose = _a.onClose,
      closeIcon = _a.closeIcon,
      _a$closable = _a.closable,
      closable = _a$closable === void 0 ? false : _a$closable,
      props = __rest(_a, ["prefixCls", "className", "style", "children", "icon", "color", "onClose", "closeIcon", "closable"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var _React$useState = React.useState(true),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  React.useEffect(function () {
    if ('visible' in props) {
      setVisible(props.visible);
    }
  }, [props.visible]);

  var isPresetColor = function isPresetColor() {
    if (!color) {
      return false;
    }

    return PresetColorRegex.test(color) || PresetStatusColorRegex.test(color);
  };

  var tagStyle = (0, _extends2["default"])({
    backgroundColor: color && !isPresetColor() ? color : undefined
  }, style);
  var presetColor = isPresetColor();
  var prefixCls = getPrefixCls('tag', customizePrefixCls);
  var tagClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(color), presetColor), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-has-color"), color && !presetColor), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-hidden"), !visible), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);

  var handleCloseClick = function handleCloseClick(e) {
    e.stopPropagation();

    if (onClose) {
      onClose(e);
    }

    if (e.defaultPrevented) {
      return;
    }

    if (!('visible' in props)) {
      setVisible(false);
    }
  };

  var renderCloseIcon = function renderCloseIcon() {
    if (closable) {
      return closeIcon ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      }, closeIcon) : /*#__PURE__*/React.createElement(_CloseOutlined["default"], {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: handleCloseClick
      });
    }

    return null;
  };

  var isNeedWave = 'onClick' in props || children && children.type === 'a';
  var tagProps = (0, _omit["default"])(props, ['visible']);
  var iconNode = icon || null;
  var kids = iconNode ? /*#__PURE__*/React.createElement(React.Fragment, null, iconNode, /*#__PURE__*/React.createElement("span", null, children)) : children;
  var tagNode = /*#__PURE__*/React.createElement("span", (0, _extends2["default"])({}, tagProps, {
    ref: ref,
    className: tagClassName,
    style: tagStyle
  }), kids, renderCloseIcon());
  return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, tagNode) : tagNode;
};

var Tag = /*#__PURE__*/React.forwardRef(InternalTag);
Tag.displayName = 'Tag';
Tag.CheckableTag = _CheckableTag["default"];
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var CheckableTag = function CheckableTag(_a) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      className = _a.className,
      checked = _a.checked,
      onChange = _a.onChange,
      onClick = _a.onClick,
      restProps = __rest(_a, ["prefixCls", "className", "checked", "onChange", "onClick"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var handleClick = function handleClick(e) {
    if (onChange) {
      onChange(!checked);
    }

    if (onClick) {
      onClick(e);
    }
  };

  var prefixCls = getPrefixCls('tag', customizePrefixCls);
  var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-checkable"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
  return /*#__PURE__*/React.createElement("span", (0, _extends2["default"])({}, restProps, {
    className: cls,
    onClick: handleClick
  }));
};

var _default = CheckableTag;
exports["default"] = _default;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = generatePicker;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CalendarOutlined = _interopRequireDefault(__webpack_require__(678));

var _ClockCircleOutlined = _interopRequireDefault(__webpack_require__(679));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _rcPicker = _interopRequireDefault(__webpack_require__(680));

var _en_US = _interopRequireDefault(__webpack_require__(250));

var _util = __webpack_require__(695);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _configProvider = __webpack_require__(8);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _ = __webpack_require__(400);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function generatePicker(generateConfig) {
  function getPicker(picker, displayName) {
    var Picker = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2["default"])(Picker, _React$Component);

      var _super = (0, _createSuper2["default"])(Picker);

      function Picker(props) {
        var _this;

        (0, _classCallCheck2["default"])(this, Picker);
        _this = _super.call(this, props);
        _this.pickerRef = /*#__PURE__*/React.createRef();

        _this.focus = function () {
          if (_this.pickerRef.current) {
            _this.pickerRef.current.focus();
          }
        };

        _this.blur = function () {
          if (_this.pickerRef.current) {
            _this.pickerRef.current.blur();
          }
        };

        _this.getDefaultLocale = function () {
          var locale = _this.props.locale;
          var result = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"]), locale);
          result.lang = (0, _extends2["default"])((0, _extends2["default"])({}, result.lang), (locale || {}).lang);
          return result;
        };

        _this.renderPicker = function (locale) {
          var _this$context = _this.context,
              getPrefixCls = _this$context.getPrefixCls,
              direction = _this$context.direction,
              getPopupContainer = _this$context.getPopupContainer;

          var _a = _this.props,
              customizePrefixCls = _a.prefixCls,
              customizeGetPopupContainer = _a.getPopupContainer,
              className = _a.className,
              customizeSize = _a.size,
              _a$bordered = _a.bordered,
              bordered = _a$bordered === void 0 ? true : _a$bordered,
              placeholder = _a.placeholder,
              restProps = __rest(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);

          var _this$props = _this.props,
              format = _this$props.format,
              showTime = _this$props.showTime;
          var prefixCls = getPrefixCls('picker', customizePrefixCls);
          var additionalProps = {
            showToday: true
          };
          var additionalOverrideProps = {};

          if (picker) {
            additionalOverrideProps.picker = picker;
          }

          var mergedPicker = picker || _this.props.picker;
          additionalOverrideProps = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, additionalOverrideProps), showTime ? (0, _.getTimeProps)((0, _extends2["default"])({
            format: format,
            picker: mergedPicker
          }, showTime)) : {}), mergedPicker === 'time' ? (0, _.getTimeProps)((0, _extends2["default"])((0, _extends2["default"])({
            format: format
          }, _this.props), {
            picker: mergedPicker
          })) : {});
          return /*#__PURE__*/React.createElement(_SizeContext["default"].Consumer, null, function (size) {
            var _classNames;

            var mergedSize = customizeSize || size;
            return /*#__PURE__*/React.createElement(_rcPicker["default"], (0, _extends2["default"])({
              ref: _this.pickerRef,
              placeholder: (0, _util.getPlaceholder)(mergedPicker, locale, placeholder),
              suffixIcon: mergedPicker === 'time' ? /*#__PURE__*/React.createElement(_ClockCircleOutlined["default"], null) : /*#__PURE__*/React.createElement(_CalendarOutlined["default"], null),
              clearIcon: /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], null),
              allowClear: true,
              transitionName: "slide-up"
            }, additionalProps, restProps, additionalOverrideProps, {
              locale: locale.lang,
              className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames), className),
              prefixCls: prefixCls,
              getPopupContainer: customizeGetPopupContainer || getPopupContainer,
              generateConfig: generateConfig,
              prevIcon: /*#__PURE__*/React.createElement("span", {
                className: "".concat(prefixCls, "-prev-icon")
              }),
              nextIcon: /*#__PURE__*/React.createElement("span", {
                className: "".concat(prefixCls, "-next-icon")
              }),
              superPrevIcon: /*#__PURE__*/React.createElement("span", {
                className: "".concat(prefixCls, "-super-prev-icon")
              }),
              superNextIcon: /*#__PURE__*/React.createElement("span", {
                className: "".concat(prefixCls, "-super-next-icon")
              }),
              components: _.Components,
              direction: direction
            }));
          });
        };

        (0, _devWarning["default"])(picker !== 'quarter', displayName, "DatePicker.".concat(displayName, " is legacy usage. Please use DatePicker[picker='").concat(picker, "'] directly."));
        return _this;
      }

      (0, _createClass2["default"])(Picker, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
            componentName: "DatePicker",
            defaultLocale: this.getDefaultLocale
          }, this.renderPicker);
        }
      }]);
      return Picker;
    }(React.Component);

    Picker.contextType = _configProvider.ConfigContext;

    if (displayName) {
      Picker.displayName = displayName;
    }

    return Picker;
  }

  var DatePicker = getPicker();
  var WeekPicker = getPicker('week', 'WeekPicker');
  var MonthPicker = getPicker('month', 'MonthPicker');
  var YearPicker = getPicker('year', 'YearPicker');
  var TimePicker = getPicker('time', 'TimePicker');
  var QuarterPicker = getPicker('quarter', 'QuarterPicker');
  return {
    DatePicker: DatePicker,
    WeekPicker: WeekPicker,
    MonthPicker: MonthPicker,
    YearPicker: YearPicker,
    TimePicker: TimePicker,
    QuarterPicker: QuarterPicker
  };
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _CalendarOutlined = _interopRequireDefault(__webpack_require__(1561));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CalendarOutlined.default
  }));
};
CalendarOutlined.displayName = 'CalendarOutlined';
var _default = /*#__PURE__*/React.forwardRef(CalendarOutlined);
exports.default = _default;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CalendarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };
exports.default = CalendarOutlined;


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _ClockCircleOutlined = _interopRequireDefault(__webpack_require__(1563));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _ClockCircleOutlined.default
  }));
};
ClockCircleOutlined.displayName = 'ClockCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(ClockCircleOutlined);
exports.default = _default;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ClockCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };
exports.default = ClockCircleOutlined;


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PickerPanel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PickerTrigger__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hooks_usePickerInput__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hooks_useTextValueMapping__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hooks_useValueTexts__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hooks_useHoverValue__ = __webpack_require__(694);









/**
 * Removed:
 *  - getCalendarContainer: use `getPopupContainer` instead
 *  - onOk
 *
 * New Feature:
 *  - picker
 *  - allowEmpty
 *  - selectable
 *
 * Tips: Should add faq about `datetime` mode with `defaultValue`
 */















function InnerPicker(props) {
  var _classNames2;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      id = props.id,
      tabIndex = props.tabIndex,
      style = props.style,
      className = props.className,
      dropdownClassName = props.dropdownClassName,
      dropdownAlign = props.dropdownAlign,
      popupStyle = props.popupStyle,
      transitionName = props.transitionName,
      generateConfig = props.generateConfig,
      locale = props.locale,
      inputReadOnly = props.inputReadOnly,
      allowClear = props.allowClear,
      autoFocus = props.autoFocus,
      showTime = props.showTime,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      format = props.format,
      use12Hours = props.use12Hours,
      value = props.value,
      defaultValue = props.defaultValue,
      open = props.open,
      defaultOpen = props.defaultOpen,
      defaultOpenValue = props.defaultOpenValue,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      disabled = props.disabled,
      disabledDate = props.disabledDate,
      placeholder = props.placeholder,
      getPopupContainer = props.getPopupContainer,
      pickerRef = props.pickerRef,
      panelRender = props.panelRender,
      onChange = props.onChange,
      onOpenChange = props.onOpenChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onContextMenu = props.onContextMenu,
      onClick = props.onClick,
      _onKeyDown = props.onKeyDown,
      _onSelect = props.onSelect,
      direction = props.direction,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
  var inputRef = __WEBPACK_IMPORTED_MODULE_8_react__["useRef"](null);
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time'; // ============================= State =============================

  var formatList = Object(__WEBPACK_IMPORTED_MODULE_15__utils_miscUtil__["d" /* toArray */])(Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["e" /* getDefaultFormat */])(format, picker, showTime, use12Hours)); // Panel ref

  var panelDivRef = __WEBPACK_IMPORTED_MODULE_8_react__["useRef"](null);
  var inputDivRef = __WEBPACK_IMPORTED_MODULE_8_react__["useRef"](null);
  var containerRef = __WEBPACK_IMPORTED_MODULE_8_react__["useRef"](null); // Real value

  var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_hooks_useMergedState__["a" /* default */])(null, {
    value: value,
    defaultValue: defaultValue
  }),
      _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setInnerValue = _useMergedState2[1]; // Selected value


  var _React$useState = __WEBPACK_IMPORTED_MODULE_8_react__["useState"](mergedValue),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1]; // Operation ref


  var operationRef = __WEBPACK_IMPORTED_MODULE_8_react__["useRef"](null); // Open

  var _useMergedState3 = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_hooks_useMergedState__["a" /* default */])(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return disabled ? false : postOpen;
    },
    onChange: function onChange(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }

      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }),
      _useMergedState4 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState3, 2),
      mergedOpen = _useMergedState4[0],
      triggerInnerOpen = _useMergedState4[1]; // ============================= Text ==============================


  var _useValueTexts = Object(__WEBPACK_IMPORTED_MODULE_20__hooks_useValueTexts__["a" /* default */])(selectedValue, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useValueTexts2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useValueTexts, 2),
      valueTexts = _useValueTexts2[0],
      firstValueText = _useValueTexts2[1];

  var _useTextValueMapping = Object(__WEBPACK_IMPORTED_MODULE_19__hooks_useTextValueMapping__["a" /* default */])({
    valueTexts: valueTexts,
    onTextChange: function onTextChange(newText) {
      var inputDate = Object(__WEBPACK_IMPORTED_MODULE_14__utils_dateUtil__["o" /* parseValue */])(newText, {
        locale: locale,
        formatList: formatList,
        generateConfig: generateConfig
      });

      if (inputDate && (!disabledDate || !disabledDate(inputDate))) {
        setSelectedValue(inputDate);
      }
    }
  }),
      _useTextValueMapping2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTextValueMapping, 3),
      text = _useTextValueMapping2[0],
      triggerTextChange = _useTextValueMapping2[1],
      resetText = _useTextValueMapping2[2]; // ============================ Trigger ============================


  var triggerChange = function triggerChange(newValue) {
    setSelectedValue(newValue);
    setInnerValue(newValue);

    if (onChange && !Object(__WEBPACK_IMPORTED_MODULE_14__utils_dateUtil__["g" /* isEqual */])(generateConfig, mergedValue, newValue)) {
      onChange(newValue, newValue ? Object(__WEBPACK_IMPORTED_MODULE_14__utils_dateUtil__["b" /* formatValue */])(newValue, {
        generateConfig: generateConfig,
        locale: locale,
        format: formatList[0]
      }) : '');
    }
  };

  var triggerOpen = function triggerOpen(newOpen) {
    if (disabled && newOpen) {
      return;
    }

    triggerInnerOpen(newOpen);
  };

  var forwardKeyDown = function forwardKeyDown(e) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      // Let popup panel handle keyboard
      return operationRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_warning__["a" /* default */])(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
      return false;
    }
  };

  var onInternalMouseUp = function onInternalMouseUp() {
    if (onMouseUp) {
      onMouseUp.apply(void 0, arguments);
    }

    if (inputRef.current) {
      inputRef.current.focus();
      triggerOpen(true);
    }
  }; // ============================= Input =============================


  var _usePickerInput = Object(__WEBPACK_IMPORTED_MODULE_18__hooks_usePickerInput__["a" /* default */])({
    blurToCancel: needConfirmButton,
    open: mergedOpen,
    value: text,
    triggerOpen: triggerOpen,
    forwardKeyDown: forwardKeyDown,
    isClickOutside: function isClickOutside(target) {
      return !Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["d" /* elementsContains */])([panelDivRef.current, inputDivRef.current, containerRef.current], target);
    },
    onSubmit: function onSubmit() {
      if ( // When user typing disabledDate with keyboard and enter, this value will be empty
      !selectedValue || // Normal disabled check
      disabledDate && disabledDate(selectedValue)) {
        return false;
      }

      triggerChange(selectedValue);
      triggerOpen(false);
      resetText();
      return true;
    },
    onCancel: function onCancel() {
      triggerOpen(false);
      setSelectedValue(mergedValue);
      resetText();
    },
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    },
    onFocus: onFocus,
    onBlur: onBlur
  }),
      _usePickerInput2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_usePickerInput, 2),
      inputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      focused = _usePickerInput2$.focused,
      typing = _usePickerInput2$.typing; // ============================= Sync ==============================
  // Close should sync back with text value


  __WEBPACK_IMPORTED_MODULE_8_react__["useEffect"](function () {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);

      if (!valueTexts.length || valueTexts[0] === '') {
        triggerTextChange('');
      } else if (firstValueText !== text) {
        resetText();
      }
    }
  }, [mergedOpen, valueTexts]); // Change picker should sync back with text value

  __WEBPACK_IMPORTED_MODULE_8_react__["useEffect"](function () {
    if (!mergedOpen) {
      resetText();
    }
  }, [picker]); // Sync innerValue with control mode

  __WEBPACK_IMPORTED_MODULE_8_react__["useEffect"](function () {
    // Sync select value
    setSelectedValue(mergedValue);
  }, [mergedValue]); // ============================ Private ============================

  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      },
      blur: function blur() {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }
    };
  }

  var _useHoverValue = Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useHoverValue__["a" /* default */])(text, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useHoverValue, 3),
      hoverValue = _useHoverValue2[0],
      onEnter = _useHoverValue2[1],
      onLeave = _useHoverValue2[2]; // ============================= Panel =============================


  var panelProps = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
    className: undefined,
    style: undefined,
    pickerValue: undefined,
    onPickerValueChange: undefined,
    onChange: null
  });

  var panelNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__PickerPanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({}, panelProps, {
    generateConfig: generateConfig,
    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-panel-focused"), !typing)),
    value: selectedValue,
    locale: locale,
    tabIndex: -1,
    onSelect: function onSelect(date) {
      _onSelect === null || _onSelect === void 0 ? void 0 : _onSelect(date);
      setSelectedValue(date);
    },
    direction: direction,
    onPanelChange: function onPanelChange(viewDate, mode) {
      var onPanelChange = props.onPanelChange;
      onLeave(true);
      onPanelChange === null || onPanelChange === void 0 ? void 0 : onPanelChange(viewDate, mode);
    }
  }));

  if (panelRender) {
    panelNode = panelRender(panelNode);
  }

  var panel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-panel-container"),
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    }
  }, panelNode);
  var suffixNode;

  if (suffixIcon) {
    suffixNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }

  var clearNode;

  if (allowClear && mergedValue && !disabled) {
    clearNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerChange(null);
        triggerOpen(false);
      },
      className: "".concat(prefixCls, "-clear"),
      role: "button"
    }, clearIcon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  } // ============================ Warning ============================


  if (false) {
    warning(!defaultOpenValue, '`defaultOpenValue` may confuse user for the current value status. Please use `defaultValue` instead.');
  } // ============================ Return =============================


  var onContextSelect = function onContextSelect(date, type) {
    if (type === 'submit' || type !== 'key' && !needConfirmButton) {
      // triggerChange will also update selected values
      triggerChange(date);
      triggerOpen(false);
    }
  };

  var popupPlacement = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__PanelContext__["a" /* default */].Provider, {
    value: {
      operationRef: operationRef,
      hideHeader: picker === 'time',
      panelRef: panelDivRef,
      onSelect: onContextSelect,
      open: mergedOpen,
      defaultOpenValue: defaultOpenValue,
      onDateMouseEnter: onEnter,
      onDateMouseLeave: onLeave
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__PickerTrigger__["a" /* default */], {
    visible: mergedOpen,
    popupElement: panel,
    popupStyle: popupStyle,
    prefixCls: prefixCls,
    dropdownClassName: dropdownClassName,
    dropdownAlign: dropdownAlign,
    getPopupContainer: getPopupContainer,
    transitionName: transitionName,
    popupPlacement: popupPlacement,
    direction: direction
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
    ref: containerRef,
    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, className, (_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-focused"), focused), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
    style: style,
    onMouseDown: onMouseDown,
    onMouseUp: onInternalMouseUp,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onContextMenu: onContextMenu,
    onClick: onClick
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()("".concat(prefixCls, "-input"), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue)),
    ref: inputDivRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: id,
    tabIndex: tabIndex,
    disabled: disabled,
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !typing,
    value: hoverValue || text,
    onChange: function onChange(e) {
      triggerTextChange(e.target.value);
    },
    autoFocus: autoFocus,
    placeholder: placeholder,
    ref: inputRef,
    title: text
  }, inputProps, {
    size: Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["f" /* getInputSize */])(picker, formatList[0], generateConfig)
  }, Object(__WEBPACK_IMPORTED_MODULE_15__utils_miscUtil__["a" /* default */])(props), {
    autoComplete: autoComplete
  })), suffixNode, clearNode))));
} // Wrap with class component to enable pass generic with instance method


var Picker = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Picker, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Picker);

  function Picker() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Picker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.pickerRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createRef"]();

    _this.focus = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.focus();
      }
    };

    _this.blur = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.blur();
      }
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Picker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](InnerPicker, Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Picker);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(186);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1570);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__ = __webpack_require__(61);





function TimeHeader(props) {
  var _React$useContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      value = props.value,
      format = props.format;
  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */], {
    prefixCls: headerPrefixCls
  }, value ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["b" /* formatValue */])(value, {
    locale: locale,
    format: format,
    generateConfig: generateConfig
  }) : "\xA0");
}

/* harmony default export */ __webpack_exports__["a"] = (TimeHeader);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContext__ = __webpack_require__(86);






function DecadeHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      onPrevDecades = props.onPrevDecades,
      onNextDecades = props.onNextDecades;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */]) * __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */];
  var endYear = startYear + __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */] - 1;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecades,
    onSuperNext: onNextDecades
  }), startYear, "-", endYear);
}

/* harmony default export */ __webpack_exports__["a"] = (DecadeHeader);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DECADE_COL_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelBody__ = __webpack_require__(222);





var DECADE_COL_COUNT = 3;
var DECADE_ROW_COUNT = 4;

function DecadeBody(props) {
  var DECADE_UNIT_DIFF_DES = __WEBPACK_IMPORTED_MODULE_3____["b" /* DECADE_UNIT_DIFF */] - 1;
  var prefixCls = props.prefixCls,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var yearNumber = generateConfig.getYear(viewDate);
  var decadeYearNumber = Math.floor(yearNumber / __WEBPACK_IMPORTED_MODULE_3____["b" /* DECADE_UNIT_DIFF */]) * __WEBPACK_IMPORTED_MODULE_3____["b" /* DECADE_UNIT_DIFF */];
  var startDecadeYear = Math.floor(yearNumber / __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */]) * __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */];
  var endDecadeYear = startDecadeYear + __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */] - 1;
  var baseDecadeYear = generateConfig.setYear(viewDate, startDecadeYear - Math.ceil((DECADE_COL_COUNT * DECADE_ROW_COUNT * __WEBPACK_IMPORTED_MODULE_3____["b" /* DECADE_UNIT_DIFF */] - __WEBPACK_IMPORTED_MODULE_3____["a" /* DECADE_DISTANCE_COUNT */]) / 2));

  var getCellClassName = function getCellClassName(date) {
    var _ref;

    var startDecadeNumber = generateConfig.getYear(date);
    var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
    return _ref = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PanelBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    rowNum: DECADE_ROW_COUNT,
    colNum: DECADE_COL_COUNT,
    baseDate: baseDecadeYear,
    getCellText: function getCellText(date) {
      var startDecadeNumber = generateConfig.getYear(date);
      return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
    },
    getCellClassName: getCellClassName,
    getCellDate: function getCellDate(date, offset) {
      return generateConfig.addYear(date, offset * __WEBPACK_IMPORTED_MODULE_3____["b" /* DECADE_UNIT_DIFF */]);
    }
  }));
}

/* harmony default export */ __webpack_exports__["b"] = (DecadeBody);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1580);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(687);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_hooks_useMemo__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimeUnitColumn__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_timeUtil__ = __webpack_require__(296);








function shouldUnitsUpdate(prevUnits, nextUnits) {
  if (prevUnits.length !== nextUnits.length) return true; // if any unit's disabled status is different, the units should be re-evaluted

  for (var i = 0; i < prevUnits.length; i += 1) {
    if (prevUnits[i].disabled !== nextUnits[i].disabled) return true;
  }

  return false;
}

function generateUnits(start, end, step, disabledUnits) {
  var units = [];

  for (var i = start; i <= end; i += step) {
    units.push({
      label: Object(__WEBPACK_IMPORTED_MODULE_5__utils_miscUtil__["c" /* leftPad */])(i, 2),
      value: i,
      disabled: (disabledUnits || []).includes(i)
    });
  }

  return units;
}

function TimeBody(props) {
  var generateConfig = props.generateConfig,
      prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      activeColumnIndex = props.activeColumnIndex,
      value = props.value,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      use12Hours = props.use12Hours,
      _props$hourStep = props.hourStep,
      hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep,
      _props$minuteStep = props.minuteStep,
      minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep,
      _props$secondStep = props.secondStep,
      secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep,
      disabledHours = props.disabledHours,
      disabledMinutes = props.disabledMinutes,
      disabledSeconds = props.disabledSeconds,
      hideDisabledOptions = props.hideDisabledOptions,
      onSelect = props.onSelect;
  var columns = [];
  var contentPrefixCls = "".concat(prefixCls, "-content");
  var columnPrefixCls = "".concat(prefixCls, "-time-panel");
  var isPM;
  var originHour = value ? generateConfig.getHour(value) : -1;
  var hour = originHour;
  var minute = value ? generateConfig.getMinute(value) : -1;
  var second = value ? generateConfig.getSecond(value) : -1;

  var setTime = function setTime(isNewPM, newHour, newMinute, newSecond) {
    var newDate = value || generateConfig.getNow();
    var mergedHour = Math.max(0, newHour);
    var mergedMinute = Math.max(0, newMinute);
    var mergedSecond = Math.max(0, newSecond);
    newDate = Object(__WEBPACK_IMPORTED_MODULE_6__utils_timeUtil__["d" /* setTime */])(generateConfig, newDate, !use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
    return newDate;
  }; // ========================= Unit =========================


  var rawHours = generateUnits(0, 23, hourStep, disabledHours && disabledHours());
  var memorizedRawHours = Object(__WEBPACK_IMPORTED_MODULE_3_rc_util_es_hooks_useMemo__["a" /* default */])(function () {
    return rawHours;
  }, rawHours, shouldUnitsUpdate); // Should additional logic to handle 12 hours

  if (use12Hours) {
    isPM = hour >= 12; // -1 means should display AM

    hour %= 12;
  }

  var _React$useMemo = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    if (!use12Hours) {
      return [false, false];
    }

    var AMPMDisabled = [true, true];
    memorizedRawHours.forEach(function (_ref) {
      var disabled = _ref.disabled,
          hourValue = _ref.value;
      if (disabled) return;

      if (hourValue >= 12) {
        AMPMDisabled[1] = false;
      } else {
        AMPMDisabled[0] = false;
      }
    });
    return AMPMDisabled;
  }, [use12Hours, memorizedRawHours]),
      _React$useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useMemo, 2),
      AMDisabled = _React$useMemo2[0],
      PMDisabled = _React$useMemo2[1];

  var hours = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    if (!use12Hours) return memorizedRawHours;
    return memorizedRawHours.filter(isPM ? function (hourMeta) {
      return hourMeta.value >= 12;
    } : function (hourMeta) {
      return hourMeta.value < 12;
    }).map(function (hourMeta) {
      var hourValue = hourMeta.value % 12;
      var hourLabel = hourValue === 0 ? '12' : Object(__WEBPACK_IMPORTED_MODULE_5__utils_miscUtil__["c" /* leftPad */])(hourValue, 2);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, hourMeta), {}, {
        label: hourLabel,
        value: hourValue
      });
    });
  }, [use12Hours, isPM, memorizedRawHours]);
  var minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour));
  var seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute)); // ====================== Operations ======================

  operationRef.current = {
    onUpDown: function onUpDown(diff) {
      var column = columns[activeColumnIndex];

      if (column) {
        var valueIndex = column.units.findIndex(function (unit) {
          return unit.value === column.value;
        });
        var unitLen = column.units.length;

        for (var i = 1; i < unitLen; i += 1) {
          var nextUnit = column.units[(valueIndex + diff * i + unitLen) % unitLen];

          if (nextUnit.disabled !== true) {
            column.onSelect(nextUnit.value);
            break;
          }
        }
      }
    }
  }; // ======================== Render ========================

  function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
    if (condition !== false) {
      columns.push({
        node: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](node, {
          prefixCls: columnPrefixCls,
          value: columnValue,
          active: activeColumnIndex === columns.length,
          onSelect: onColumnSelect,
          units: units,
          hideDisabledOptions: hideDisabledOptions
        }),
        onSelect: onColumnSelect,
        value: columnValue,
        units: units
      });
    }
  } // Hour


  addColumnNode(showHour, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TimeUnitColumn__["a" /* default */], {
    key: "hour"
  }), hour, hours, function (num) {
    onSelect(setTime(isPM, num, minute, second), 'mouse');
  }); // Minute

  addColumnNode(showMinute, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TimeUnitColumn__["a" /* default */], {
    key: "minute"
  }), minute, minutes, function (num) {
    onSelect(setTime(isPM, hour, num, second), 'mouse');
  }); // Second

  addColumnNode(showSecond, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TimeUnitColumn__["a" /* default */], {
    key: "second"
  }), second, seconds, function (num) {
    onSelect(setTime(isPM, hour, minute, num), 'mouse');
  }); // 12 Hours

  var PMIndex = -1;

  if (typeof isPM === 'boolean') {
    PMIndex = isPM ? 1 : 0;
  }

  addColumnNode(use12Hours === true, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__TimeUnitColumn__["a" /* default */], {
    key: "12hours"
  }), PMIndex, [{
    label: 'AM',
    value: 0,
    disabled: AMDisabled
  }, {
    label: 'PM',
    value: 1,
    disabled: PMDisabled
  }], function (num) {
    onSelect(setTime(!!num, hour, minute, second), 'mouse');
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: contentPrefixCls
  }, columns.map(function (_ref2) {
    var node = _ref2.node;
    return node;
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (TimeBody);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContext__ = __webpack_require__(86);







function TimeUnitColumn(props) {
  var prefixCls = props.prefixCls,
      units = props.units,
      onSelect = props.onSelect,
      value = props.value,
      active = props.active,
      hideDisabledOptions = props.hideDisabledOptions;
  var cellPrefixCls = "".concat(prefixCls, "-cell");

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__PanelContext__["a" /* default */]),
      open = _React$useContext.open;

  var ulRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var liRefs = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(new Map());
  var scrollRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(); // `useLayoutEffect` here to avoid blink by duration is 0

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"])(function () {
    var li = liRefs.current.get(value);

    if (li && open !== false) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__["h" /* scrollTo */])(ulRef.current, li.offsetTop, 120);
    }
  }, [value]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"])(function () {
    if (open) {
      var li = liRefs.current.get(value);

      if (li) {
        scrollRef.current = Object(__WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__["i" /* waitElementReady */])(li, function () {
          Object(__WEBPACK_IMPORTED_MODULE_3__utils_uiUtil__["h" /* scrollTo */])(ulRef.current, li.offsetTop, 0);
        });
      }
    }

    return function () {
      var _scrollRef$current;

      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.call(scrollRef);
    };
  }, [open]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-column"), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-column-active"), active)),
    ref: ulRef,
    style: {
      position: 'relative'
    }
  }, units.map(function (unit) {
    var _classNames2;

    if (hideDisabledOptions && unit.disabled) {
      return null;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", {
      key: unit.value,
      ref: function ref(element) {
        liRefs.current.set(unit.value, element);
      },
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(cellPrefixCls, (_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
      onClick: function onClick() {
        if (unit.disabled) {
          return;
        }

        onSelect(unit.value);
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, unit.label));
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (TimeUnitColumn);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DatePanel__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TimePanel__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_timeUtil__ = __webpack_require__(296);












var ACTIVE_PANEL = Object(__WEBPACK_IMPORTED_MODULE_10__utils_miscUtil__["e" /* tuple */])('date', 'time');

function DatetimePanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      generateConfig = props.generateConfig,
      value = props.value,
      defaultValue = props.defaultValue,
      disabledTime = props.disabledTime,
      showTime = props.showTime,
      onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](null),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      activePanel = _React$useState2[0],
      setActivePanel = _React$useState2[1];

  var dateOperationRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"]({});
  var timeOperationRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"]({});
  var timeProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(showTime) === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, showTime) : {}; // ======================= Keyboard =======================

  function getNextActive(offset) {
    var activeIndex = ACTIVE_PANEL.indexOf(activePanel) + offset;
    var nextActivePanel = ACTIVE_PANEL[activeIndex] || null;
    return nextActivePanel;
  }

  var onBlur = function onBlur(e) {
    if (timeOperationRef.current.onBlur) {
      timeOperationRef.current.onBlur(e);
    }

    setActivePanel(null);
  };

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      // Switch active panel
      if (event.which === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].TAB) {
        var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
        setActivePanel(nextActivePanel);

        if (nextActivePanel) {
          event.preventDefault();
        }

        return true;
      } // Operate on current active panel


      if (activePanel) {
        var ref = activePanel === 'date' ? dateOperationRef : timeOperationRef;

        if (ref.current && ref.current.onKeyDown) {
          ref.current.onKeyDown(event);
        }

        return true;
      } // Switch first active panel if operate without panel


      if ([__WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].LEFT, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].RIGHT, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].UP, __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].DOWN].includes(event.which)) {
        setActivePanel('date');
        return true;
      }

      return false;
    },
    onBlur: onBlur,
    onClose: onBlur
  }; // ======================== Events ========================

  var onInternalSelect = function onInternalSelect(date, source) {
    var selectedDate = date;

    if (source === 'date' && !value && timeProps.defaultValue) {
      // Date with time defaultValue
      selectedDate = generateConfig.setHour(selectedDate, generateConfig.getHour(timeProps.defaultValue));
      selectedDate = generateConfig.setMinute(selectedDate, generateConfig.getMinute(timeProps.defaultValue));
      selectedDate = generateConfig.setSecond(selectedDate, generateConfig.getSecond(timeProps.defaultValue));
    } else if (source === 'time' && !value && defaultValue) {
      selectedDate = generateConfig.setYear(selectedDate, generateConfig.getYear(defaultValue));
      selectedDate = generateConfig.setMonth(selectedDate, generateConfig.getMonth(defaultValue));
      selectedDate = generateConfig.setDate(selectedDate, generateConfig.getDate(defaultValue));
    }

    if (onSelect) {
      onSelect(selectedDate, 'mouse');
    }
  }; // ======================== Render ========================


  var disabledTimes = disabledTime ? disabledTime(value || null) : {};
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(panelPrefixCls, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(panelPrefixCls, "-active"), activePanel))
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__DatePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    operationRef: dateOperationRef,
    active: activePanel === 'date',
    onSelect: function onSelect(date) {
      onInternalSelect(Object(__WEBPACK_IMPORTED_MODULE_11__utils_timeUtil__["c" /* setDateTime */])(generateConfig, date, showTime && Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(showTime) === 'object' ? showTime.defaultValue : null), 'date');
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__TimePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    format: undefined
  }, timeProps, disabledTimes, {
    defaultValue: undefined,
    operationRef: timeOperationRef,
    active: activePanel === 'time',
    onSelect: function onSelect(date) {
      onInternalSelect(date, 'time');
    }
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (DatetimePanel);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelBody__ = __webpack_require__(222);







function DateBody(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      prefixColumn = props.prefixColumn,
      locale = props.locale,
      rowCount = props.rowCount,
      viewDate = props.viewDate,
      value = props.value,
      dateRender = props.dateRender;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__RangeContext__["a" /* default */]),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var baseDate = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["f" /* getWeekStartDate */])(locale.locale, generateConfig, viewDate);
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
  var today = generateConfig.getNow(); // ============================== Header ==============================

  var headerCells = [];
  var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);

  if (prefixColumn) {
    headerCells.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", {
      key: "empty",
      "aria-label": "empty cell"
    }));
  }

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["a" /* WEEK_DAY_COUNT */]; i += 1) {
    headerCells.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", {
      key: i
    }, weekDaysLocale[(i + weekFirstDay) % __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["a" /* WEEK_DAY_COUNT */]]));
  } // =============================== Body ===============================


  var getCellClassName = Object(__WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__["a" /* default */])({
    cellPrefixCls: cellPrefixCls,
    today: today,
    value: value,
    generateConfig: generateConfig,
    rangedValue: prefixColumn ? null : rangedValue,
    hoverRangedValue: prefixColumn ? null : hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["i" /* isSameDate */])(generateConfig, current, target);
    },
    isInView: function isInView(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["k" /* isSameMonth */])(generateConfig, date, viewDate);
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addDate(date, offset);
    }
  });
  var getCellNode = dateRender ? function (date) {
    return dateRender(date, today);
  } : undefined;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PanelBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    rowNum: rowCount,
    colNum: __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["a" /* WEEK_DAY_COUNT */],
    baseDate: baseDate,
    getCellNode: getCellNode,
    getCellText: generateConfig.getDate,
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addDate,
    titleCell: function titleCell(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: 'YYYY-MM-DD',
        generateConfig: generateConfig
      });
    },
    headerCells: headerCells
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (DateBody);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__ = __webpack_require__(61);






function DateHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextMonth = props.onNextMonth,
      onPrevMonth = props.onPrevMonth,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick,
      onMonthClick = props.onMonthClick;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
  var month = generateConfig.getMonth(viewDate); // =================== Month & Year ===================

  var yearNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    key: "year",
    onClick: onYearClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["b" /* formatValue */])(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));
  var monthNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    key: "month",
    onClick: onMonthClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-month-btn")
  }, locale.monthFormat ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["b" /* formatValue */])(viewDate, {
    locale: locale,
    format: locale.monthFormat,
    generateConfig: generateConfig
  }) : monthsLocale[month]);
  var monthYearNodes = locale.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onPrev: onPrevMonth,
    onNext: onNextMonth,
    onSuperNext: onNextYear
  }), monthYearNodes);
}

/* harmony default export */ __webpack_exports__["a"] = (DateHeader);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DatePanel__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dateUtil__ = __webpack_require__(61);







function WeekPanel(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      value = props.value; // Render additional column

  var cellPrefixCls = "".concat(prefixCls, "-cell");

  var prefixColumn = function prefixColumn(date) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("td", {
      key: "week",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
    }, generateConfig.locale.getWeek(locale.locale, date));
  }; // Add row className


  var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");

  var rowClassName = function rowClassName(date) {
    return __WEBPACK_IMPORTED_MODULE_3_classnames___default()(rowPrefixCls, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(rowPrefixCls, "-selected"), Object(__WEBPACK_IMPORTED_MODULE_5__utils_dateUtil__["m" /* isSameWeek */])(generateConfig, locale.locale, value, date)));
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DatePanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    panelName: "week",
    prefixColumn: prefixColumn,
    rowClassName: rowClassName,
    keyboardConfig: {
      onLeftRight: null
    }
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (WeekPanel);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MonthHeader__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonthBody__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__ = __webpack_require__(99);






function MonthPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-month-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__["c" /* createKeyDownHandler */])(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff * __WEBPACK_IMPORTED_MODULE_3__MonthBody__["a" /* MONTH_COL_COUNT */]), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange('date', value || viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MonthHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MonthBody__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      _onSelect(date, 'mouse');

      onPanelChange('date', date);
    }
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (MonthPanel);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__ = __webpack_require__(61);






function MonthHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["b" /* formatValue */])(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (MonthHeader);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MONTH_COL_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelBody__ = __webpack_require__(222);






var MONTH_COL_COUNT = 3;
var MONTH_ROW_COUNT = 4;

function MonthBody(props) {
  var prefixCls = props.prefixCls,
      locale = props.locale,
      value = props.value,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig,
      monthCellRender = props.monthCellRender;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__RangeContext__["a" /* default */]),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = Object(__WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__["a" /* default */])({
    cellPrefixCls: cellPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["k" /* isSameMonth */])(generateConfig, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addMonth(date, offset);
    }
  });
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
  var baseMonth = generateConfig.setMonth(viewDate, 0);
  var getCellNode = monthCellRender ? function (date) {
    return monthCellRender(date, locale);
  } : undefined;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PanelBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    rowNum: MONTH_ROW_COUNT,
    colNum: MONTH_COL_COUNT,
    baseDate: baseMonth,
    getCellNode: getCellNode,
    getCellText: function getCellText(date) {
      return locale.monthFormat ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
      }) : monthsLocale[generateConfig.getMonth(date)];
    },
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addMonth,
    titleCell: function titleCell(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: 'YYYY-MM',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ __webpack_exports__["b"] = (MonthBody);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuarterHeader__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuarterBody__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__ = __webpack_require__(99);






function QuarterPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-quarter-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_uiUtil__["c" /* createKeyDownHandler */])(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff * 3), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        }
      });
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__QuarterHeader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__QuarterBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      _onSelect(date, 'mouse');
    }
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (QuarterPanel);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__ = __webpack_require__(61);






function QuarterHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["b" /* formatValue */])(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  })));
}

/* harmony default export */ __webpack_exports__["a"] = (QuarterHeader);

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QUARTER_COL_COUNT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelBody__ = __webpack_require__(222);






var QUARTER_COL_COUNT = 4;
var QUARTER_ROW_COUNT = 1;

function QuarterBody(props) {
  var prefixCls = props.prefixCls,
      locale = props.locale,
      value = props.value,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__RangeContext__["a" /* default */]),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = Object(__WEBPACK_IMPORTED_MODULE_4__hooks_useCellClassName__["a" /* default */])({
    cellPrefixCls: cellPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["l" /* isSameQuarter */])(generateConfig, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addMonth(date, offset * 3);
    }
  });
  var baseQuarter = generateConfig.setDate(generateConfig.setMonth(viewDate, 0), 1);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PanelBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    rowNum: QUARTER_ROW_COUNT,
    colNum: QUARTER_COL_COUNT,
    baseDate: baseQuarter,
    getCellText: function getCellText(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: locale.quarterFormat || '[Q]Q',
        generateConfig: generateConfig
      });
    },
    getCellClassName: getCellClassName,
    getCellDate: function getCellDate(date, offset) {
      return generateConfig.addMonth(date, offset * 3);
    },
    titleCell: function titleCell(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: 'YYYY-[Q]Q',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (QuarterBody);

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelContext__ = __webpack_require__(86);






function YearHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      onPrevDecade = props.onPrevDecade,
      onNextDecade = props.onNextDecade,
      onDecadeClick = props.onDecadeClick;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_4__PanelContext__["a" /* default */]),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / __WEBPACK_IMPORTED_MODULE_3____["a" /* YEAR_DECADE_COUNT */]) * __WEBPACK_IMPORTED_MODULE_3____["a" /* YEAR_DECADE_COUNT */];
  var endYear = startYear + __WEBPACK_IMPORTED_MODULE_3____["a" /* YEAR_DECADE_COUNT */] - 1;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecade,
    onSuperNext: onNextDecade
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    onClick: onDecadeClick,
    className: "".concat(prefixCls, "-decade-btn")
  }, startYear, "-", endYear));
}

/* harmony default export */ __webpack_exports__["a"] = (YearHeader);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YEAR_COL_COUNT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useCellClassName__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelBody__ = __webpack_require__(222);







var YEAR_COL_COUNT = 3;
var YEAR_ROW_COUNT = 4;

function YearBody(props) {
  var prefixCls = props.prefixCls,
      value = props.value,
      viewDate = props.viewDate,
      locale = props.locale,
      generateConfig = props.generateConfig;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_5__RangeContext__["a" /* default */]),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var yearPrefixCls = "".concat(prefixCls, "-cell"); // =============================== Year ===============================

  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / __WEBPACK_IMPORTED_MODULE_2____["a" /* YEAR_DECADE_COUNT */]) * __WEBPACK_IMPORTED_MODULE_2____["a" /* YEAR_DECADE_COUNT */];
  var endYear = startYear + __WEBPACK_IMPORTED_MODULE_2____["a" /* YEAR_DECADE_COUNT */] - 1;
  var baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - __WEBPACK_IMPORTED_MODULE_2____["a" /* YEAR_DECADE_COUNT */]) / 2));

  var isInView = function isInView(date) {
    var currentYearNumber = generateConfig.getYear(date);
    return startYear <= currentYearNumber && currentYearNumber <= endYear;
  };

  var getCellClassName = Object(__WEBPACK_IMPORTED_MODULE_3__hooks_useCellClassName__["a" /* default */])({
    cellPrefixCls: yearPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["n" /* isSameYear */])(generateConfig, current, target);
    },
    isInView: isInView,
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addYear(date, offset);
    }
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PanelBody__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    rowNum: YEAR_ROW_COUNT,
    colNum: YEAR_COL_COUNT,
    baseDate: baseYear,
    getCellText: generateConfig.getYear,
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addYear,
    titleCell: function titleCell(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_dateUtil__["b" /* formatValue */])(date, {
        locale: locale,
        format: 'YYYY',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ __webpack_exports__["b"] = (YearBody);

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_typeof__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PickerTrigger__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PickerPanel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_usePickerInput__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PanelContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hooks_useValueTexts__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hooks_useTextValueMapping__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RangeContext__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hooks_useRangeDisabled__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_getExtraFooter__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_getRanges__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hooks_useRangeViewDates__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hooks_useHoverValue__ = __webpack_require__(694);






























function reorderValues(values, generateConfig) {
  if (values && values[0] && values[1] && generateConfig.isAfter(values[0], values[1])) {
    return [values[1], values[0]];
  }

  return values;
}

function canValueTrigger(value, index, disabled, allowEmpty) {
  if (value) {
    return true;
  }

  if (allowEmpty && allowEmpty[index]) {
    return true;
  }

  if (disabled[(index + 1) % 2]) {
    return true;
  }

  return false;
}

function InnerRangePicker(props) {
  var _classNames2, _classNames3, _classNames4;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      id = props.id,
      style = props.style,
      className = props.className,
      popupStyle = props.popupStyle,
      dropdownClassName = props.dropdownClassName,
      transitionName = props.transitionName,
      dropdownAlign = props.dropdownAlign,
      getPopupContainer = props.getPopupContainer,
      generateConfig = props.generateConfig,
      locale = props.locale,
      placeholder = props.placeholder,
      autoFocus = props.autoFocus,
      disabled = props.disabled,
      format = props.format,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      showTime = props.showTime,
      use12Hours = props.use12Hours,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '~' : _props$separator,
      value = props.value,
      defaultValue = props.defaultValue,
      defaultPickerValue = props.defaultPickerValue,
      open = props.open,
      defaultOpen = props.defaultOpen,
      disabledDate = props.disabledDate,
      _disabledTime = props.disabledTime,
      dateRender = props.dateRender,
      panelRender = props.panelRender,
      ranges = props.ranges,
      allowEmpty = props.allowEmpty,
      allowClear = props.allowClear,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      pickerRef = props.pickerRef,
      inputReadOnly = props.inputReadOnly,
      mode = props.mode,
      renderExtraFooter = props.renderExtraFooter,
      onChange = props.onChange,
      onOpenChange = props.onOpenChange,
      onPanelChange = props.onPanelChange,
      onCalendarChange = props.onCalendarChange,
      _onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      _onOk = props.onOk,
      _onKeyDown = props.onKeyDown,
      components = props.components,
      order = props.order,
      direction = props.direction,
      activePickerIndex = props.activePickerIndex,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time'; // We record opened status here in case repeat open with picker

  var openRecordsRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])({});
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var panelDivRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var startInputDivRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var endInputDivRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var separatorRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var startInputRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var endInputRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null); // ============================= Misc ==============================

  var formatList = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["d" /* toArray */])(Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["e" /* getDefaultFormat */])(format, picker, showTime, use12Hours)); // Active picker

  var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__["a" /* default */])(0, {
    value: activePickerIndex
  }),
      _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
      mergedActivePickerIndex = _useMergedState2[0],
      setMergedActivePickerIndex = _useMergedState2[1]; // Operation ref


  var operationRef = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useRef"])(null);
  var mergedDisabled = __WEBPACK_IMPORTED_MODULE_9_react__["useMemo"](function () {
    if (Array.isArray(disabled)) {
      return disabled;
    }

    return [disabled || false, disabled || false];
  }, [disabled]); // ============================= Value =============================

  var _useMergedState3 = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__["a" /* default */])(null, {
    value: value,
    defaultValue: defaultValue,
    postState: function postState(values) {
      return picker === 'time' && !order ? values : reorderValues(values, generateConfig);
    }
  }),
      _useMergedState4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState3, 2),
      mergedValue = _useMergedState4[0],
      setInnerValue = _useMergedState4[1]; // =========================== View Date ===========================
  // Config view panel


  var _useRangeViewDates = Object(__WEBPACK_IMPORTED_MODULE_26__hooks_useRangeViewDates__["a" /* default */])({
    values: mergedValue,
    picker: picker,
    defaultDates: defaultPickerValue,
    generateConfig: generateConfig
  }),
      _useRangeViewDates2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useRangeViewDates, 2),
      getViewDate = _useRangeViewDates2[0],
      setViewDate = _useRangeViewDates2[1]; // ========================= Select Values =========================


  var _useMergedState5 = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__["a" /* default */])(mergedValue, {
    postState: function postState(values) {
      var postValues = values;

      if (mergedDisabled[0] && mergedDisabled[1]) {
        return postValues;
      } // Fill disabled unit


      // Fill disabled unit
      for (var i = 0; i < 2; i += 1) {
        if (mergedDisabled[i] && !Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(postValues, i) && !Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(allowEmpty, i)) {
          postValues = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(postValues, generateConfig.getNow(), i);
        }
      }

      return postValues;
    }
  }),
      _useMergedState6 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState5, 2),
      selectedValue = _useMergedState6[0],
      setSelectedValue = _useMergedState6[1]; // ============================= Modes =============================


  var _useMergedState7 = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__["a" /* default */])([picker, picker], {
    value: mode
  }),
      _useMergedState8 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState7, 2),
      mergedModes = _useMergedState8[0],
      setInnerModes = _useMergedState8[1];

  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    setInnerModes([picker, picker]);
  }, [picker]);

  var triggerModesChange = function triggerModesChange(modes, values) {
    setInnerModes(modes);

    if (onPanelChange) {
      onPanelChange(values, modes);
    }
  }; // ========================= Disable Date ==========================


  var _useRangeDisabled = Object(__WEBPACK_IMPORTED_MODULE_23__hooks_useRangeDisabled__["a" /* default */])({
    picker: picker,
    selectedValue: selectedValue,
    locale: locale,
    disabled: mergedDisabled,
    disabledDate: disabledDate,
    generateConfig: generateConfig
  }, openRecordsRef.current[1], openRecordsRef.current[0]),
      _useRangeDisabled2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useRangeDisabled, 2),
      disabledStartDate = _useRangeDisabled2[0],
      disabledEndDate = _useRangeDisabled2[1]; // ============================= Open ==============================


  var _useMergedState9 = Object(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_hooks_useMergedState__["a" /* default */])(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
    },
    onChange: function onChange(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }

      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }),
      _useMergedState10 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState9, 2),
      mergedOpen = _useMergedState10[0],
      triggerInnerOpen = _useMergedState10[1];

  var startOpen = mergedOpen && mergedActivePickerIndex === 0;
  var endOpen = mergedOpen && mergedActivePickerIndex === 1; // ============================= Popup =============================
  // Popup min width

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])(0),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      popupMinWidth = _useState2[0],
      setPopupMinWidth = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    if (!mergedOpen && containerRef.current) {
      setPopupMinWidth(containerRef.current.offsetWidth);
    }
  }, [mergedOpen]); // ============================ Trigger ============================

  var triggerRef = __WEBPACK_IMPORTED_MODULE_9_react__["useRef"]();

  function _triggerOpen(newOpen, index) {
    if (newOpen) {
      clearTimeout(triggerRef.current);
      openRecordsRef.current[index] = true;
      setMergedActivePickerIndex(index);
      triggerInnerOpen(newOpen); // Open to reset view date

      if (!mergedOpen) {
        setViewDate(null, index);
      }
    } else if (mergedActivePickerIndex === index) {
      triggerInnerOpen(newOpen); // Clean up async
      // This makes ref not quick refresh in case user open another input with blur trigger

      var openRecords = openRecordsRef.current;
      triggerRef.current = setTimeout(function () {
        if (openRecords === openRecordsRef.current) {
          openRecordsRef.current = {};
        }
      });
    }
  }

  function triggerOpenAndFocus(index) {
    _triggerOpen(true, index); // Use setTimeout to make sure panel DOM exists


    setTimeout(function () {
      var inputRef = [startInputRef, endInputRef][index];

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  }

  function triggerChange(newValue, sourceIndex) {
    var values = newValue;
    var startValue = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(values, 0);
    var endValue = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(values, 1); // >>>>> Format start & end values

    if (startValue && endValue && generateConfig.isAfter(startValue, endValue)) {
      if ( // WeekPicker only compare week
      picker === 'week' && !Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["m" /* isSameWeek */])(generateConfig, locale.locale, startValue, endValue) || // QuotaPicker only compare week
      picker === 'quarter' && !Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["l" /* isSameQuarter */])(generateConfig, startValue, endValue) || // Other non-TimePicker compare date
      picker !== 'week' && picker !== 'quarter' && picker !== 'time' && !Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["i" /* isSameDate */])(generateConfig, startValue, endValue)) {
        // Clean up end date when start date is after end date
        if (sourceIndex === 0) {
          values = [startValue, null];
          endValue = null;
        } else {
          startValue = null;
          values = [null, endValue];
        } // Clean up cache since invalidate


        openRecordsRef.current = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, sourceIndex, true);
      } else if (picker !== 'time' || order !== false) {
        // Reorder when in same date
        values = reorderValues(values, generateConfig);
      }
    }

    setSelectedValue(values);
    var startStr = values && values[0] ? Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["b" /* formatValue */])(values[0], {
      generateConfig: generateConfig,
      locale: locale,
      format: formatList[0]
    }) : '';
    var endStr = values && values[1] ? Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["b" /* formatValue */])(values[1], {
      generateConfig: generateConfig,
      locale: locale,
      format: formatList[0]
    }) : '';

    if (onCalendarChange) {
      var info = {
        range: sourceIndex === 0 ? 'start' : 'end'
      };
      onCalendarChange(values, [startStr, endStr], info);
    } // >>>>> Trigger `onChange` event


    var canStartValueTrigger = canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
    var canEndValueTrigger = canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
    var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;

    if (canTrigger) {
      // Trigger onChange only when value is validate
      setInnerValue(values);

      if (onChange && (!Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["g" /* isEqual */])(generateConfig, Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(mergedValue, 0), startValue) || !Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["g" /* isEqual */])(generateConfig, Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(mergedValue, 1), endValue))) {
        onChange(values, [startStr, endStr]);
      }
    } // >>>>> Open picker when
    // Always open another picker if possible


    var nextOpenIndex = null;

    if (sourceIndex === 0 && !mergedDisabled[1]) {
      nextOpenIndex = 1;
    } else if (sourceIndex === 1 && !mergedDisabled[0]) {
      nextOpenIndex = 0;
    }

    if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && (!openRecordsRef.current[nextOpenIndex] || !Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(values, nextOpenIndex)) && Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(values, sourceIndex)) {
      // Delay to focus to avoid input blur trigger expired selectedValues
      triggerOpenAndFocus(nextOpenIndex);
    } else {
      _triggerOpen(false, sourceIndex);
    }
  }

  var forwardKeyDown = function forwardKeyDown(e) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      // Let popup panel handle keyboard
      return operationRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_warning__["a" /* default */])(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
      return false;
    }
  }; // ============================= Text ==============================


  var sharedTextHooksProps = {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  };

  var _useValueTexts = Object(__WEBPACK_IMPORTED_MODULE_20__hooks_useValueTexts__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, 0), sharedTextHooksProps),
      _useValueTexts2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useValueTexts, 2),
      startValueTexts = _useValueTexts2[0],
      firstStartValueText = _useValueTexts2[1];

  var _useValueTexts3 = Object(__WEBPACK_IMPORTED_MODULE_20__hooks_useValueTexts__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, 1), sharedTextHooksProps),
      _useValueTexts4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useValueTexts3, 2),
      endValueTexts = _useValueTexts4[0],
      firstEndValueText = _useValueTexts4[1];

  var _onTextChange = function onTextChange(newText, index) {
    var inputDate = Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["o" /* parseValue */])(newText, {
      locale: locale,
      formatList: formatList,
      generateConfig: generateConfig
    });
    var disabledFunc = index === 0 ? disabledStartDate : disabledEndDate;

    if (inputDate && !disabledFunc(inputDate)) {
      setSelectedValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(selectedValue, inputDate, index));
      setViewDate(inputDate, index);
    }
  };

  var _useTextValueMapping = Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useTextValueMapping__["a" /* default */])({
    valueTexts: startValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 0);
    }
  }),
      _useTextValueMapping2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTextValueMapping, 3),
      startText = _useTextValueMapping2[0],
      triggerStartTextChange = _useTextValueMapping2[1],
      resetStartText = _useTextValueMapping2[2];

  var _useTextValueMapping3 = Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useTextValueMapping__["a" /* default */])({
    valueTexts: endValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 1);
    }
  }),
      _useTextValueMapping4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTextValueMapping3, 3),
      endText = _useTextValueMapping4[0],
      triggerEndTextChange = _useTextValueMapping4[1],
      resetEndText = _useTextValueMapping4[2];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])(null),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      rangeHoverValue = _useState4[0],
      setRangeHoverValue = _useState4[1]; // ========================== Hover Range ==========================


  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_9_react__["useState"])(null),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      hoverRangedValue = _useState6[0],
      setHoverRangedValue = _useState6[1];

  var _useHoverValue = Object(__WEBPACK_IMPORTED_MODULE_27__hooks_useHoverValue__["a" /* default */])(startText, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useHoverValue, 3),
      startHoverValue = _useHoverValue2[0],
      onStartEnter = _useHoverValue2[1],
      onStartLeave = _useHoverValue2[2];

  var _useHoverValue3 = Object(__WEBPACK_IMPORTED_MODULE_27__hooks_useHoverValue__["a" /* default */])(endText, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useHoverValue3, 3),
      endHoverValue = _useHoverValue4[0],
      onEndEnter = _useHoverValue4[1],
      onEndLeave = _useHoverValue4[2];

  var onDateMouseEnter = function onDateMouseEnter(date) {
    setHoverRangedValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(selectedValue, date, mergedActivePickerIndex));

    if (mergedActivePickerIndex === 0) {
      onStartEnter(date);
    } else {
      onEndEnter(date);
    }
  };

  var onDateMouseLeave = function onDateMouseLeave() {
    setHoverRangedValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(selectedValue, null, mergedActivePickerIndex));

    if (mergedActivePickerIndex === 0) {
      onStartLeave();
    } else {
      onEndLeave();
    }
  }; // ============================= Input =============================


  var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
    return {
      blurToCancel: needConfirmButton,
      forwardKeyDown: forwardKeyDown,
      onBlur: onBlur,
      isClickOutside: function isClickOutside(target) {
        return !Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["d" /* elementsContains */])([panelDivRef.current, startInputDivRef.current, endInputDivRef.current, containerRef.current], target);
      },
      onFocus: function onFocus(e) {
        setMergedActivePickerIndex(index);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      triggerOpen: function triggerOpen(newOpen) {
        _triggerOpen(newOpen, index);
      },
      onSubmit: function onSubmit() {
        triggerChange(selectedValue, index);
        resetText();
      },
      onCancel: function onCancel() {
        _triggerOpen(false, index);

        setSelectedValue(mergedValue);
        resetText();
      }
    };
  };

  var _usePickerInput = Object(__WEBPACK_IMPORTED_MODULE_15__hooks_usePickerInput__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, getSharedInputHookProps(0, resetStartText)), {}, {
    open: startOpen,
    value: startText,
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    }
  })),
      _usePickerInput2 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_usePickerInput, 2),
      startInputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      startFocused = _usePickerInput2$.focused,
      startTyping = _usePickerInput2$.typing;

  var _usePickerInput3 = Object(__WEBPACK_IMPORTED_MODULE_15__hooks_usePickerInput__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, getSharedInputHookProps(1, resetEndText)), {}, {
    open: endOpen,
    value: endText,
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    }
  })),
      _usePickerInput4 = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_usePickerInput3, 2),
      endInputProps = _usePickerInput4[0],
      _usePickerInput4$ = _usePickerInput4[1],
      endFocused = _usePickerInput4$.focused,
      endTyping = _usePickerInput4$.typing; // ========================== Click Picker ==========================


  var onPickerClick = function onPickerClick(e) {
    // When click inside the picker & outside the picker's input elements
    // the panel should still be opened
    if (!mergedOpen && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      if (!mergedDisabled[0]) {
        triggerOpenAndFocus(0);
      } else if (!mergedDisabled[1]) {
        triggerOpenAndFocus(1);
      }
    }
  };

  var onPickerMouseDown = function onPickerMouseDown(e) {
    // shouldn't affect input elements if picker is active
    if (mergedOpen && (startFocused || endFocused) && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      e.preventDefault();
    }
  }; // ============================= Sync ==============================
  // Close should sync back with text value


  var startStr = mergedValue && mergedValue[0] ? Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["b" /* formatValue */])(mergedValue[0], {
    locale: locale,
    format: 'YYYYMMDDHHmmss',
    generateConfig: generateConfig
  }) : '';
  var endStr = mergedValue && mergedValue[1] ? Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["b" /* formatValue */])(mergedValue[1], {
    locale: locale,
    format: 'YYYYMMDDHHmmss',
    generateConfig: generateConfig
  }) : '';
  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);

      if (!startValueTexts.length || startValueTexts[0] === '') {
        triggerStartTextChange('');
      } else if (firstStartValueText !== startText) {
        resetStartText();
      }

      if (!endValueTexts.length || endValueTexts[0] === '') {
        triggerEndTextChange('');
      } else if (firstEndValueText !== endText) {
        resetEndText();
      }
    }
  }, [mergedOpen, startValueTexts, endValueTexts]); // Sync innerValue with control mode

  Object(__WEBPACK_IMPORTED_MODULE_9_react__["useEffect"])(function () {
    setSelectedValue(mergedValue);
  }, [startStr, endStr]); // ============================ Warning ============================

  if (false) {
    if (value && Array.isArray(disabled) && (getValue(disabled, 0) && !getValue(value, 0) || getValue(disabled, 1) && !getValue(value, 1))) {
      warning(false, '`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.');
    }
  } // ============================ Private ============================


  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (startInputRef.current) {
          startInputRef.current.focus();
        }
      },
      blur: function blur() {
        if (startInputRef.current) {
          startInputRef.current.blur();
        }

        if (endInputRef.current) {
          endInputRef.current.blur();
        }
      }
    };
  } // ============================ Ranges =============================


  var rangeLabels = Object.keys(ranges || {});
  var rangeList = rangeLabels.map(function (label) {
    var range = ranges[label];
    var newValues = typeof range === 'function' ? range() : range;
    return {
      label: label,
      onClick: function onClick() {
        triggerChange(newValues, null);

        _triggerOpen(false, mergedActivePickerIndex);
      },
      onMouseEnter: function onMouseEnter() {
        setRangeHoverValue(newValues);
      },
      onMouseLeave: function onMouseLeave() {
        setRangeHoverValue(null);
      }
    };
  }); // ============================= Panel =============================

  function renderPanel() {
    var panelPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var panelProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var panelHoverRangedValue = null;

    if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig.isAfter(hoverRangedValue[1], hoverRangedValue[0])) {
      panelHoverRangedValue = hoverRangedValue;
    }

    var panelShowTime = showTime;

    if (showTime && Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_typeof__["a" /* default */])(showTime) === 'object' && showTime.defaultValue) {
      var timeDefaultValues = showTime.defaultValue;
      panelShowTime = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, showTime), {}, {
        defaultValue: Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(timeDefaultValues, mergedActivePickerIndex) || undefined
      });
    }

    var panelDateRender = null;

    if (dateRender) {
      panelDateRender = function panelDateRender(date, today) {
        return dateRender(date, today, {
          range: mergedActivePickerIndex ? 'end' : 'start'
        });
      };
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__RangeContext__["a" /* default */].Provider, {
      value: {
        inRange: true,
        panelPosition: panelPosition,
        rangedValue: rangeHoverValue || selectedValue,
        hoverRangedValue: panelHoverRangedValue
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__PickerPanel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, panelProps, {
      dateRender: panelDateRender,
      showTime: panelShowTime,
      mode: mergedModes[mergedActivePickerIndex],
      generateConfig: generateConfig,
      style: undefined,
      direction: direction,
      disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
      disabledTime: function disabledTime(date) {
        if (_disabledTime) {
          return _disabledTime(date, mergedActivePickerIndex === 0 ? 'start' : 'end');
        }

        return false;
      },
      className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-panel-focused"), mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
      value: Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, mergedActivePickerIndex),
      locale: locale,
      tabIndex: -1,
      onPanelChange: function onPanelChange(date, newMode) {
        // clear hover value when panel change
        if (mergedActivePickerIndex === 0) {
          onStartLeave(true);
        }

        if (mergedActivePickerIndex === 1) {
          onEndLeave(true);
        }

        triggerModesChange(Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(mergedModes, newMode, mergedActivePickerIndex), Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(selectedValue, date, mergedActivePickerIndex));
        var viewDate = date;

        if (panelPosition === 'right' && mergedModes[mergedActivePickerIndex] === newMode) {
          viewDate = Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["d" /* getClosingViewDate */])(viewDate, newMode, generateConfig, -1);
        }

        setViewDate(viewDate, mergedActivePickerIndex);
      },
      onOk: null,
      onSelect: undefined,
      onChange: undefined,
      defaultValue: mergedActivePickerIndex === 0 ? Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, 1) : Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, 0)
    })));
  }

  var arrowLeft = 0;
  var panelLeft = 0;

  if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
    // Arrow offset
    arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;

    if (panelDivRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth) {
      panelLeft = arrowLeft;
    }
  }

  var arrowPositionStyle = direction === 'rtl' ? {
    right: arrowLeft
  } : {
    left: arrowLeft
  };

  function renderPanels() {
    var panels;
    var extraNode = Object(__WEBPACK_IMPORTED_MODULE_24__utils_getExtraFooter__["a" /* default */])(prefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
    var rangesNode = Object(__WEBPACK_IMPORTED_MODULE_25__utils_getRanges__["a" /* default */])({
      prefixCls: prefixCls,
      components: components,
      needConfirmButton: needConfirmButton,
      okDisabled: !Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, mergedActivePickerIndex) || disabledDate && disabledDate(selectedValue[mergedActivePickerIndex]),
      locale: locale,
      rangeList: rangeList,
      onOk: function onOk() {
        if (Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(selectedValue, mergedActivePickerIndex)) {
          // triggerChangeOld(selectedValue);
          triggerChange(selectedValue, mergedActivePickerIndex);

          if (_onOk) {
            _onOk(selectedValue);
          }
        }
      }
    });

    if (picker !== 'time' && !showTime) {
      var viewDate = getViewDate(mergedActivePickerIndex);
      var nextViewDate = Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["d" /* getClosingViewDate */])(viewDate, picker, generateConfig);
      var currentMode = mergedModes[mergedActivePickerIndex];
      var showDoublePanel = currentMode === picker;
      var leftPanel = renderPanel(showDoublePanel ? 'left' : false, {
        pickerValue: viewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(newViewDate, mergedActivePickerIndex);
        }
      });
      var rightPanel = renderPanel('right', {
        pickerValue: nextViewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(Object(__WEBPACK_IMPORTED_MODULE_19__utils_dateUtil__["d" /* getClosingViewDate */])(newViewDate, picker, generateConfig, -1), mergedActivePickerIndex);
        }
      });

      if (direction === 'rtl') {
        panels = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, rightPanel, showDoublePanel && leftPanel);
      } else {
        panels = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, leftPanel, showDoublePanel && rightPanel);
      }
    } else {
      panels = renderPanel();
    }

    var mergedNodes = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-panels")
    }, panels), (extraNode || rangesNode) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-footer")
    }, extraNode, rangesNode));

    if (panelRender) {
      mergedNodes = panelRender(mergedNodes);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-panel-container"),
      style: {
        marginLeft: panelLeft
      },
      ref: panelDivRef,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      }
    }, mergedNodes);
  }

  var rangePanel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper")),
    style: {
      minWidth: popupMinWidth
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-range-arrow"),
    style: arrowPositionStyle
  }), renderPanels()); // ============================= Icons =============================

  var suffixNode;

  if (suffixIcon) {
    suffixNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }

  var clearNode;

  if (allowClear && (Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(mergedValue, 0) && !mergedDisabled[0] || Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(mergedValue, 1) && !mergedDisabled[1])) {
    clearNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        var values = mergedValue;

        if (!mergedDisabled[0]) {
          values = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(values, null, 0);
        }

        if (!mergedDisabled[1]) {
          values = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(values, null, 1);
        }

        triggerChange(values, null);

        _triggerOpen(false, mergedActivePickerIndex);
      },
      className: "".concat(prefixCls, "-clear")
    }, clearIcon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  }

  var inputSharedProps = {
    size: Object(__WEBPACK_IMPORTED_MODULE_17__utils_uiUtil__["f" /* getInputSize */])(picker, formatList[0], generateConfig)
  };
  var activeBarLeft = 0;
  var activeBarWidth = 0;

  if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
    if (mergedActivePickerIndex === 0) {
      activeBarWidth = startInputDivRef.current.offsetWidth;
    } else {
      activeBarLeft = arrowLeft;
      activeBarWidth = endInputDivRef.current.offsetWidth;
    }
  }

  var activeBarPositionStyle = direction === 'rtl' ? {
    right: activeBarLeft
  } : {
    left: activeBarLeft
  }; // ============================ Return =============================

  var onContextSelect = function onContextSelect(date, type) {
    var values = Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["f" /* updateValues */])(selectedValue, date, mergedActivePickerIndex);

    if (type === 'submit' || type !== 'key' && !needConfirmButton) {
      // triggerChange will also update selected values
      triggerChange(values, mergedActivePickerIndex); // clear hover value style

      if (mergedActivePickerIndex === 0) {
        onStartLeave();
      } else {
        onEndLeave();
      }
    } else {
      setSelectedValue(values);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__PanelContext__["a" /* default */].Provider, {
    value: {
      operationRef: operationRef,
      hideHeader: picker === 'time',
      onDateMouseEnter: onDateMouseEnter,
      onDateMouseLeave: onDateMouseLeave,
      hideRanges: true,
      onSelect: onContextSelect,
      open: mergedOpen
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__PickerTrigger__["a" /* default */], {
    visible: mergedOpen,
    popupElement: rangePanel,
    popupStyle: popupStyle,
    prefixCls: prefixCls,
    dropdownClassName: dropdownClassName,
    dropdownAlign: dropdownAlign,
    getPopupContainer: getPopupContainer,
    transitionName: transitionName,
    range: true,
    direction: direction
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: containerRef,
    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, "".concat(prefixCls, "-range"), className, (_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
    style: style,
    onClick: onPickerClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: onPickerMouseDown
  }, Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["a" /* default */])(props)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()("".concat(prefixCls, "-input"), (_classNames3 = {}, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _classNames3)),
    ref: startInputDivRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: id,
    disabled: mergedDisabled[0],
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !startTyping,
    value: startHoverValue || startText,
    onChange: function onChange(e) {
      triggerStartTextChange(e.target.value);
    },
    autoFocus: autoFocus,
    placeholder: Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(placeholder, 0) || '',
    ref: startInputRef
  }, startInputProps, inputSharedProps, {
    autoComplete: autoComplete
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-range-separator"),
    ref: separatorRef
  }, separator), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()("".concat(prefixCls, "-input"), (_classNames4 = {}, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _classNames4)),
    ref: endInputDivRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({
    disabled: mergedDisabled[1],
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !endTyping,
    value: endHoverValue || endText,
    onChange: function onChange(e) {
      triggerEndTextChange(e.target.value);
    },
    placeholder: Object(__WEBPACK_IMPORTED_MODULE_16__utils_miscUtil__["b" /* getValue */])(placeholder, 1) || '',
    ref: endInputRef
  }, endInputProps, inputSharedProps, {
    autoComplete: autoComplete
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, activeBarPositionStyle), {}, {
      width: activeBarWidth,
      position: 'absolute'
    })
  }), suffixNode, clearNode)));
} // Wrap with class component to enable pass generic with instance method


var RangePicker = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(RangePicker, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(RangePicker);

  function RangePicker() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RangePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.pickerRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createRef"]();

    _this.focus = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.focus();
      }
    };

    _this.blur = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.blur();
      }
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RangePicker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](InnerRangePicker, Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);

  return RangePicker;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RangePicker);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRangeDisabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__ = __webpack_require__(61);



function useRangeDisabled(_ref, disabledStart, disabledEnd) {
  var picker = _ref.picker,
      locale = _ref.locale,
      selectedValue = _ref.selectedValue,
      disabledDate = _ref.disabledDate,
      disabled = _ref.disabled,
      generateConfig = _ref.generateConfig;
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_miscUtil__["b" /* getValue */])(selectedValue, 0);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_miscUtil__["b" /* getValue */])(selectedValue, 1);

  function weekFirstDate(date) {
    return generateConfig.locale.getWeekFirstDate(locale.locale, date);
  }

  function monthNumber(date) {
    var year = generateConfig.getYear(date);
    var month = generateConfig.getMonth(date);
    return year * 100 + month;
  }

  function quarterNumber(date) {
    var year = generateConfig.getYear(date);
    var quarter = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["e" /* getQuarter */])(generateConfig, date);
    return year * 10 + quarter;
  }

  var disabledStartDate = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    } // Disabled range


    if (disabled[1] && endDate) {
      return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["i" /* isSameDate */])(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
    } // Disabled part


    if (disabledStart && endDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) > quarterNumber(endDate);

        case 'month':
          return monthNumber(date) > monthNumber(endDate);

        case 'week':
          return weekFirstDate(date) > weekFirstDate(endDate);

        default:
          return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["i" /* isSameDate */])(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
      }
    }

    return false;
  }, [disabledDate, disabled[1], endDate, disabledStart]);
  var disabledEndDate = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    } // Disabled range


    if (disabled[0] && startDate) {
      return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["i" /* isSameDate */])(generateConfig, date, endDate) && generateConfig.isAfter(startDate, date);
    } // Disabled part


    if (disabledEnd && startDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) < quarterNumber(startDate);

        case 'month':
          return monthNumber(date) < monthNumber(startDate);

        case 'week':
          return weekFirstDate(date) < weekFirstDate(startDate);

        default:
          return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dateUtil__["i" /* isSameDate */])(generateConfig, date, startDate) && generateConfig.isAfter(startDate, date);
      }
    }

    return false;
  }, [disabledDate, disabled[0], startDate, disabledEnd]);
  return [disabledStartDate, disabledEndDate];
}

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRangeViewDates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__ = __webpack_require__(61);





function getStartEndDistance(startDate, endDate, picker, generateConfig) {
  var startNext = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["d" /* getClosingViewDate */])(startDate, picker, generateConfig, 1);

  function getDistance(compareFunc) {
    if (compareFunc(startDate, endDate)) {
      return 'same';
    }

    if (compareFunc(startNext, endDate)) {
      return 'closing';
    }

    return 'far';
  }

  switch (picker) {
    case 'year':
      return getDistance(function (start, end) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["j" /* isSameDecade */])(generateConfig, start, end);
      });

    case 'quarter':
    case 'month':
      return getDistance(function (start, end) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["n" /* isSameYear */])(generateConfig, start, end);
      });

    default:
      return getDistance(function (start, end) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["k" /* isSameMonth */])(generateConfig, start, end);
      });
  }
}

function getRangeViewDate(values, index, picker, generateConfig) {
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(values, 0);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(values, 1);

  if (index === 0) {
    return startDate;
  }

  if (startDate && endDate) {
    var distance = getStartEndDistance(startDate, endDate, picker, generateConfig);

    switch (distance) {
      case 'same':
        return startDate;

      case 'closing':
        return startDate;

      default:
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dateUtil__["d" /* getClosingViewDate */])(endDate, picker, generateConfig, -1);
    }
  }

  return startDate;
}

function useRangeViewDates(_ref) {
  var values = _ref.values,
      picker = _ref.picker,
      defaultDates = _ref.defaultDates,
      generateConfig = _ref.generateConfig;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](function () {
    return [Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(defaultDates, 0), Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(defaultDates, 1)];
  }),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      defaultViewDates = _React$useState2[0],
      setDefaultViewDates = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](null),
      _React$useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState3, 2),
      viewDates = _React$useState4[0],
      setInternalViewDates = _React$useState4[1];

  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(values, 0);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(values, 1);

  function getViewDate(index) {
    // If set default view date, use it
    if (defaultViewDates[index]) {
      return defaultViewDates[index];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(viewDates, index) || getRangeViewDate(values, index, picker, generateConfig) || startDate || endDate || generateConfig.getNow();
  }

  function setViewDate(viewDate, index) {
    if (viewDate) {
      var newViewDates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["f" /* updateValues */])(viewDates, viewDate, index); // Set view date will clean up default one

      setDefaultViewDates( // Should always be an array
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["f" /* updateValues */])(defaultViewDates, null, index) || [null, null]); // Reset another one when not have value

      var anotherIndex = (index + 1) % 2;

      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["b" /* getValue */])(values, anotherIndex)) {
        newViewDates = Object(__WEBPACK_IMPORTED_MODULE_2__utils_miscUtil__["f" /* updateValues */])(newViewDates, viewDate, anotherIndex);
      }

      setInternalViewDates(newViewDates);
    } else if (startDate || endDate) {
      // Reset all when has values when `viewDate` is `null` which means from open trigger
      setInternalViewDates(null);
    }
  }

  return [getViewDate, setViewDate];
}

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = generateRangePicker;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _CalendarOutlined = _interopRequireDefault(__webpack_require__(678));

var _ClockCircleOutlined = _interopRequireDefault(__webpack_require__(679));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _SwapRightOutlined = _interopRequireDefault(__webpack_require__(1599));

var _rcPicker = __webpack_require__(680);

var _en_US = _interopRequireDefault(__webpack_require__(250));

var _configProvider = __webpack_require__(8);

var _SizeContext = _interopRequireDefault(__webpack_require__(72));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _util = __webpack_require__(695);

var _ = __webpack_require__(400);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function generateRangePicker(generateConfig) {
  var RangePicker = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(RangePicker, _React$Component);

    var _super = (0, _createSuper2["default"])(RangePicker);

    function RangePicker() {
      var _this;

      (0, _classCallCheck2["default"])(this, RangePicker);
      _this = _super.apply(this, arguments);
      _this.pickerRef = /*#__PURE__*/React.createRef();

      _this.focus = function () {
        if (_this.pickerRef.current) {
          _this.pickerRef.current.focus();
        }
      };

      _this.blur = function () {
        if (_this.pickerRef.current) {
          _this.pickerRef.current.blur();
        }
      };

      _this.getDefaultLocale = function () {
        var locale = _this.props.locale;
        var result = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"]), locale);
        result.lang = (0, _extends2["default"])((0, _extends2["default"])({}, result.lang), (locale || {}).lang);
        return result;
      };

      _this.renderPicker = function (locale) {
        var _this$context = _this.context,
            getPrefixCls = _this$context.getPrefixCls,
            direction = _this$context.direction,
            getPopupContainer = _this$context.getPopupContainer;

        var _a = _this.props,
            customizePrefixCls = _a.prefixCls,
            customGetPopupContainer = _a.getPopupContainer,
            className = _a.className,
            customizeSize = _a.size,
            _a$bordered = _a.bordered,
            bordered = _a$bordered === void 0 ? true : _a$bordered,
            placeholder = _a.placeholder,
            restProps = __rest(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);

        var _this$props = _this.props,
            format = _this$props.format,
            showTime = _this$props.showTime,
            picker = _this$props.picker;
        var prefixCls = getPrefixCls('picker', customizePrefixCls);
        var additionalOverrideProps = {};
        additionalOverrideProps = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, additionalOverrideProps), showTime ? (0, _.getTimeProps)((0, _extends2["default"])({
          format: format,
          picker: picker
        }, showTime)) : {}), picker === 'time' ? (0, _.getTimeProps)((0, _extends2["default"])((0, _extends2["default"])({
          format: format
        }, _this.props), {
          picker: picker
        })) : {});
        return /*#__PURE__*/React.createElement(_SizeContext["default"].Consumer, null, function (size) {
          var _classNames;

          var mergedSize = customizeSize || size;
          return /*#__PURE__*/React.createElement(_rcPicker.RangePicker, (0, _extends2["default"])({
            separator: /*#__PURE__*/React.createElement("span", {
              "aria-label": "to",
              className: "".concat(prefixCls, "-separator")
            }, /*#__PURE__*/React.createElement(_SwapRightOutlined["default"], null)),
            ref: _this.pickerRef,
            placeholder: (0, _util.getRangePlaceholder)(picker, locale, placeholder),
            suffixIcon: picker === 'time' ? /*#__PURE__*/React.createElement(_ClockCircleOutlined["default"], null) : /*#__PURE__*/React.createElement(_CalendarOutlined["default"], null),
            clearIcon: /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], null),
            allowClear: true,
            transitionName: "slide-up"
          }, restProps, additionalOverrideProps, {
            className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _classNames), className),
            locale: locale.lang,
            prefixCls: prefixCls,
            getPopupContainer: customGetPopupContainer || getPopupContainer,
            generateConfig: generateConfig,
            prevIcon: /*#__PURE__*/React.createElement("span", {
              className: "".concat(prefixCls, "-prev-icon")
            }),
            nextIcon: /*#__PURE__*/React.createElement("span", {
              className: "".concat(prefixCls, "-next-icon")
            }),
            superPrevIcon: /*#__PURE__*/React.createElement("span", {
              className: "".concat(prefixCls, "-super-prev-icon")
            }),
            superNextIcon: /*#__PURE__*/React.createElement("span", {
              className: "".concat(prefixCls, "-super-next-icon")
            }),
            components: _.Components,
            direction: direction
          }));
        });
      };

      return _this;
    }

    (0, _createClass2["default"])(RangePicker, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        }, this.renderPicker);
      }
    }]);
    return RangePicker;
  }(React.Component);

  RangePicker.contextType = _configProvider.ConfigContext;
  return RangePicker;
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SwapRightOutlined = _interopRequireDefault(__webpack_require__(1600));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _SwapRightOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _SwapRightOutlined = _interopRequireDefault(__webpack_require__(1601));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _SwapRightOutlined.default
  }));
};
SwapRightOutlined.displayName = 'SwapRightOutlined';
var _default = /*#__PURE__*/React.forwardRef(SwapRightOutlined);
exports.default = _default;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SwapRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };
exports.default = SwapRightOutlined;


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-compact"), props.compact), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

var _default = Group;
exports["default"] = _default;

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResizableTextArea__ = __webpack_require__(1611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResizableTextArea", function() { return __WEBPACK_IMPORTED_MODULE_6__ResizableTextArea__["a"]; });








var TextArea = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(TextArea, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(TextArea);

  function TextArea(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, TextArea);

    _this = _super.call(this, props);
    _this.resizableTextArea = void 0;

    _this.focus = function () {
      _this.resizableTextArea.textArea.focus();
    };

    _this.saveTextArea = function (resizableTextArea) {
      _this.resizableTextArea = resizableTextArea;
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;

      _this.setValue(e.target.value, function () {
        _this.resizableTextArea.resizeTextarea();
      });

      if (onChange) {
        onChange(e);
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    var value = typeof props.value === 'undefined' || props.value === null ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(TextArea, [{
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ResizableTextArea__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        ref: this.saveTextArea
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


/* harmony default export */ __webpack_exports__["default"] = (TextArea);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(405);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1610);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_resize_observer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_omit__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calculateNodeHeight__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shallowequal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shallowequal__);












 // eslint-disable-next-line @typescript-eslint/naming-convention

var RESIZE_STATUS;

(function (RESIZE_STATUS) {
  RESIZE_STATUS[RESIZE_STATUS["NONE"] = 0] = "NONE";
  RESIZE_STATUS[RESIZE_STATUS["RESIZING"] = 1] = "RESIZING";
  RESIZE_STATUS[RESIZE_STATUS["RESIZED"] = 2] = "RESIZED";
})(RESIZE_STATUS || (RESIZE_STATUS = {}));

var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(ResizableTextArea, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ResizableTextArea);

  function ResizableTextArea(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ResizableTextArea);

    _this = _super.call(this, props);
    _this.nextFrameActionId = void 0;
    _this.resizeFrameId = void 0;
    _this.textArea = void 0;

    _this.saveTextArea = function (textArea) {
      _this.textArea = textArea;
    };

    _this.handleResize = function (size) {
      var resizeStatus = _this.state.resizeStatus;
      var _this$props = _this.props,
          autoSize = _this$props.autoSize,
          onResize = _this$props.onResize;

      if (resizeStatus !== RESIZE_STATUS.NONE) {
        return;
      }

      if (typeof onResize === 'function') {
        onResize(size);
      }

      if (autoSize) {
        _this.resizeOnNextFrame();
      }
    };

    _this.resizeOnNextFrame = function () {
      cancelAnimationFrame(_this.nextFrameActionId);
      _this.nextFrameActionId = requestAnimationFrame(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autoSize = _this.props.autoSize;

      if (!autoSize || !_this.textArea) {
        return;
      }

      var minRows = autoSize.minRows,
          maxRows = autoSize.maxRows;
      var textareaStyles = Object(__WEBPACK_IMPORTED_MODULE_11__calculateNodeHeight__["a" /* default */])(_this.textArea, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles,
        resizeStatus: RESIZE_STATUS.RESIZING
      }, function () {
        cancelAnimationFrame(_this.resizeFrameId);
        _this.resizeFrameId = requestAnimationFrame(function () {
          _this.setState({
            resizeStatus: RESIZE_STATUS.RESIZED
          }, function () {
            _this.resizeFrameId = requestAnimationFrame(function () {
              _this.setState({
                resizeStatus: RESIZE_STATUS.NONE
              });

              _this.fixFirefoxAutoScroll();
            });
          });
        });
      });
    };

    _this.renderTextArea = function () {
      var _this$props2 = _this.props,
          _this$props2$prefixCl = _this$props2.prefixCls,
          prefixCls = _this$props2$prefixCl === void 0 ? 'rc-textarea' : _this$props2$prefixCl,
          autoSize = _this$props2.autoSize,
          onResize = _this$props2.onResize,
          className = _this$props2.className,
          disabled = _this$props2.disabled;
      var _this$state = _this.state,
          textareaStyles = _this$state.textareaStyles,
          resizeStatus = _this$state.resizeStatus;
      var otherProps = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_omit__["a" /* default */])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'defaultValue', 'onResize']);
      var cls = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, className, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator

      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      var style = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.props.style), textareaStyles), resizeStatus === RESIZE_STATUS.RESIZING ? // React will warning when mix `overflow` & `overflowY`.
      // We need to define this separately.
      {
        overflowX: 'hidden',
        overflowY: 'hidden'
      } : null);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_resize_observer__["default"], {
        onResize: _this.handleResize,
        disabled: !(autoSize || onResize)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, otherProps, {
        className: cls,
        style: style,
        ref: _this.saveTextArea
      })));
    };

    _this.state = {
      textareaStyles: {},
      resizeStatus: RESIZE_STATUS.NONE
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(ResizableTextArea, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content or new autoSize property then recalculate the height as required.
      if (prevProps.value !== this.props.value || !__WEBPACK_IMPORTED_MODULE_12_shallowequal___default()(prevProps.autoSize, this.props.autoSize)) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.nextFrameActionId);
      cancelAnimationFrame(this.resizeFrameId);
    } // https://github.com/ant-design/ant-design/issues/21870

  }, {
    key: "fixFirefoxAutoScroll",
    value: function fixFirefoxAutoScroll() {
      try {
        if (document.activeElement === this.textArea) {
          var currentStart = this.textArea.selectionStart;
          var currentEnd = this.textArea.selectionEnd;
          this.textArea.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderTextArea();
    }
  }]);

  return ResizableTextArea;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ResizableTextArea);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(705);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculateNodeStyling */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing', 'word-break'];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY,
    resize: 'none'
  };
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _EyeOutlined = _interopRequireDefault(__webpack_require__(706));

var _EyeInvisibleOutlined = _interopRequireDefault(__webpack_require__(1616));

var _configProvider = __webpack_require__(8);

var _Input = _interopRequireDefault(__webpack_require__(223));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};
var Password = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = (0, React.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var onVisibleChange = function onVisibleChange() {
    var disabled = props.disabled;

    if (disabled) {
      return;
    }

    setVisible(!visible);
  };

  var getIcon = function getIcon(prefixCls) {
    var _iconProps;

    var action = props.action,
        _props$iconRender = props.iconRender,
        iconRender = _props$iconRender === void 0 ? function () {
      return null;
    } : _props$iconRender;
    var iconTrigger = ActionMap[action] || '';
    var icon = iconRender(visible);
    var iconProps = (_iconProps = {}, (0, _defineProperty2["default"])(_iconProps, iconTrigger, onVisibleChange), (0, _defineProperty2["default"])(_iconProps, "className", "".concat(prefixCls, "-icon")), (0, _defineProperty2["default"])(_iconProps, "key", 'passwordIcon'), (0, _defineProperty2["default"])(_iconProps, "onMouseDown", function onMouseDown(e) {
      // Prevent focused state lost
      // https://github.com/ant-design/ant-design/issues/15173
      e.preventDefault();
    }), (0, _defineProperty2["default"])(_iconProps, "onMouseUp", function onMouseUp(e) {
      // Prevent caret position change
      // https://github.com/ant-design/ant-design/issues/23524
      e.preventDefault();
    }), _iconProps);
    return /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/React.createElement("span", null, icon), iconProps);
  };

  var renderPassword = function renderPassword(_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        customizePrefixCls = props.prefixCls,
        customizeInputPrefixCls = props.inputPrefixCls,
        size = props.size,
        visibilityToggle = props.visibilityToggle,
        restProps = __rest(props, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);

    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var prefixCls = getPrefixCls('input-password', customizePrefixCls);
    var suffixIcon = visibilityToggle && getIcon(prefixCls);
    var inputClassName = (0, _classnames["default"])(prefixCls, className, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(size), !!size));
    var omittedProps = (0, _extends2["default"])((0, _extends2["default"])({}, (0, _omit["default"])(restProps, ['suffix', 'iconRender'])), {
      type: visible ? 'text' : 'password',
      className: inputClassName,
      prefixCls: inputPrefixCls,
      suffix: suffixIcon
    });

    if (size) {
      omittedProps.size = size;
    }

    return /*#__PURE__*/React.createElement(_Input["default"], (0, _extends2["default"])({
      ref: ref
    }, omittedProps));
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderPassword);
});
Password.defaultProps = {
  action: 'click',
  visibilityToggle: true,
  iconRender: function iconRender(visible) {
    return visible ? /*#__PURE__*/React.createElement(_EyeOutlined["default"], null) : /*#__PURE__*/React.createElement(_EyeInvisibleOutlined["default"], null);
  }
};
Password.displayName = 'Password';
var _default = Password;
exports["default"] = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
exports.default = EyeOutlined;


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _EyeInvisibleOutlined = _interopRequireDefault(__webpack_require__(1617));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _EyeInvisibleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _EyeInvisibleOutlined = _interopRequireDefault(__webpack_require__(1618));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _EyeInvisibleOutlined.default
  }));
};
EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
var _default = /*#__PURE__*/React.forwardRef(EyeInvisibleOutlined);
exports.default = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
exports.default = EyeInvisibleOutlined;


/***/ }),
/* 1619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _rcFieldForm.List;
  }
});
Object.defineProperty(exports, "useForm", {
  enumerable: true,
  get: function get() {
    return _useForm3["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcFieldForm = _interopRequireWildcard(__webpack_require__(157));

var _configProvider = __webpack_require__(8);

var _context = __webpack_require__(126);

var _useForm3 = _interopRequireDefault(__webpack_require__(1621));

var _SizeContext = _interopRequireWildcard(__webpack_require__(72));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var InternalForm = function InternalForm(props, ref) {
  var _classNames;

  var contextSize = React.useContext(_SizeContext["default"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction,
      contextForm = _React$useContext.form;

  var customizePrefixCls = props.prefixCls,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? contextSize : _props$size,
      form = props.form,
      colon = props.colon,
      labelAlign = props.labelAlign,
      labelCol = props.labelCol,
      wrapperCol = props.wrapperCol,
      hideRequiredMark = props.hideRequiredMark,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
      scrollToFirstError = props.scrollToFirstError,
      requiredMark = props.requiredMark,
      onFinishFailed = props.onFinishFailed,
      name = props.name,
      restFormProps = __rest(props, ["prefixCls", "className", "size", "form", "colon", "labelAlign", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name"]);

  var mergedRequiredMark = (0, React.useMemo)(function () {
    if (requiredMark !== undefined) {
      return requiredMark;
    }

    if (contextForm && contextForm.requiredMark !== undefined) {
      return contextForm.requiredMark;
    }

    if (hideRequiredMark) {
      return false;
    }

    return true;
  }, [hideRequiredMark, requiredMark, contextForm]);
  var prefixCls = getPrefixCls('form', customizePrefixCls);
  var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(layout), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-hide-required-mark"), mergedRequiredMark === false), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);

  var _useForm = (0, _useForm3["default"])(form),
      _useForm2 = (0, _slicedToArray2["default"])(_useForm, 1),
      wrapForm = _useForm2[0];

  var __INTERNAL__ = wrapForm.__INTERNAL__;
  __INTERNAL__.name = name;
  var formContextValue = (0, React.useMemo)(function () {
    return {
      name: name,
      labelAlign: labelAlign,
      labelCol: labelCol,
      wrapperCol: wrapperCol,
      vertical: layout === 'vertical',
      colon: colon,
      requiredMark: mergedRequiredMark,
      itemRef: __INTERNAL__.itemRef
    };
  }, [name, labelAlign, labelCol, wrapperCol, layout, colon, mergedRequiredMark]);
  React.useImperativeHandle(ref, function () {
    return wrapForm;
  });

  var onInternalFinishFailed = function onInternalFinishFailed(errorInfo) {
    if (onFinishFailed) {
      onFinishFailed(errorInfo);
    }

    var defaultScrollToFirstError = {
      block: 'nearest'
    };

    if (scrollToFirstError && errorInfo.errorFields.length) {
      if ((0, _typeof2["default"])(scrollToFirstError) === 'object') {
        defaultScrollToFirstError = scrollToFirstError;
      }

      wrapForm.scrollToField(errorInfo.errorFields[0].name, defaultScrollToFirstError);
    }
  };

  return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
    size: size
  }, /*#__PURE__*/React.createElement(_context.FormContext.Provider, {
    value: formContextValue
  }, /*#__PURE__*/React.createElement(_rcFieldForm["default"], (0, _extends2["default"])({
    id: name
  }, restFormProps, {
    name: name,
    onFinishFailed: onInternalFinishFailed,
    form: wrapForm,
    className: formClassName
  }))));
};

var Form = /*#__PURE__*/React.forwardRef(InternalForm);
var _default = Form;
exports["default"] = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useForm;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcFieldForm = __webpack_require__(157);

var _scrollIntoViewIfNeeded = _interopRequireDefault(__webpack_require__(1622));

var _util = __webpack_require__(707);

function toNamePathStr(name) {
  var namePath = (0, _util.toArray)(name);
  return namePath.join('_');
}

function useForm(form) {
  var _useRcForm = (0, _rcFieldForm.useForm)(),
      _useRcForm2 = (0, _slicedToArray2["default"])(_useRcForm, 1),
      rcForm = _useRcForm2[0];

  var itemsRef = React.useRef({});
  var wrapForm = React.useMemo(function () {
    return form || (0, _extends2["default"])((0, _extends2["default"])({}, rcForm), {
      __INTERNAL__: {
        itemRef: function itemRef(name) {
          return function (node) {
            var namePathStr = toNamePathStr(name);

            if (node) {
              itemsRef.current[namePathStr] = node;
            } else {
              delete itemsRef.current[namePathStr];
            }
          };
        }
      },
      scrollToField: function scrollToField(name) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var namePath = (0, _util.toArray)(name);
        var fieldId = (0, _util.getFieldId)(namePath, wrapForm.__INTERNAL__.name);
        var node = fieldId ? document.getElementById(fieldId) : null;

        if (node) {
          (0, _scrollIntoViewIfNeeded["default"])(node, (0, _extends2["default"])({
            scrollMode: 'if-needed',
            block: 'nearest'
          }, options));
        }
      },
      getFieldInstance: function getFieldInstance(name) {
        var namePathStr = toNamePathStr(name);
        return itemsRef.current[namePathStr];
      }
    });
  }, [form, rcForm]);
  return [wrapForm];
}

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__ = __webpack_require__(1623);

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }
  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: 'start',
    inline: 'nearest'
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? Object(__WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__["a" /* default */])(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(Object(__WEBPACK_IMPORTED_MODULE_0_compute_scroll_into_view__["a" /* default */])(target, computeOptions), computeOptions.behavior);
}
/* harmony default export */ __webpack_exports__["default"] = (scrollIntoView);

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i; });
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}var i=function(e,i){var o=window,l=i.scrollMode,d=i.block,f=i.inline,h=i.boundary,u=i.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var a,c,g=document.scrollingElement||document.documentElement,p=[],m=e;t(m)&&s(m);){if((m=null==(c=(a=m).parentElement)?a.getRootNode().host||null:c)===g){p.push(m);break}null!=m&&m===document.body&&n(m)&&!n(document.documentElement)||null!=m&&n(m,u)&&p.push(m)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<p.length;k++){var B=p[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?r(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:r(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?r(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:r(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
//# sourceMappingURL=index.mjs.map


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _isEqual = _interopRequireDefault(__webpack_require__(663));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _rcFieldForm = __webpack_require__(157);

var _FieldContext = _interopRequireDefault(__webpack_require__(1625));

var _ref2 = __webpack_require__(117);

var _omit = _interopRequireDefault(__webpack_require__(47));

var _row = _interopRequireDefault(__webpack_require__(672));

var _configProvider = __webpack_require__(8);

var _type = __webpack_require__(118);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _FormItemLabel = _interopRequireDefault(__webpack_require__(1628));

var _FormItemInput = _interopRequireDefault(__webpack_require__(1631));

var _context = __webpack_require__(126);

var _util = __webpack_require__(707);

var _reactNode = __webpack_require__(57);

var _useFrameState3 = _interopRequireDefault(__webpack_require__(1633));

var _useItemRef = _interopRequireDefault(__webpack_require__(1634));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
var MemoInput = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (prev, next) {
  return prev.value === next.value && prev.update === next.update;
});

function hasValidName(name) {
  if (name === null) {
    (0, _devWarning["default"])(false, 'Form.Item', '`null` is passed as `name` property');
  }

  return !(name === undefined || name === null);
}

function FormItem(props) {
  var name = props.name,
      fieldKey = props.fieldKey,
      noStyle = props.noStyle,
      dependencies = props.dependencies,
      customizePrefixCls = props.prefixCls,
      style = props.style,
      className = props.className,
      shouldUpdate = props.shouldUpdate,
      hasFeedback = props.hasFeedback,
      help = props.help,
      rules = props.rules,
      validateStatus = props.validateStatus,
      children = props.children,
      required = props.required,
      label = props.label,
      messageVariables = props.messageVariables,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'onChange' : _props$trigger,
      validateTrigger = props.validateTrigger,
      hidden = props.hidden,
      restProps = __rest(props, ["name", "fieldKey", "noStyle", "dependencies", "prefixCls", "style", "className", "shouldUpdate", "hasFeedback", "help", "rules", "validateStatus", "children", "required", "label", "messageVariables", "trigger", "validateTrigger", "hidden"]);

  var destroyRef = (0, React.useRef)(false);

  var _useContext = (0, React.useContext)(_configProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var _useContext2 = (0, React.useContext)(_context.FormContext),
      formName = _useContext2.name,
      requiredMark = _useContext2.requiredMark;

  var _useContext3 = (0, React.useContext)(_context.FormItemContext),
      updateItemErrors = _useContext3.updateItemErrors;

  var _React$useState = React.useState(!!help),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      domErrorVisible = _React$useState2[0],
      innerSetDomErrorVisible = _React$useState2[1];

  var _useFrameState = (0, _useFrameState3["default"])({}),
      _useFrameState2 = (0, _slicedToArray2["default"])(_useFrameState, 2),
      inlineErrors = _useFrameState2[0],
      setInlineErrors = _useFrameState2[1];

  var _useContext4 = (0, React.useContext)(_FieldContext["default"]),
      contextValidateTrigger = _useContext4.validateTrigger;

  var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;

  function setDomErrorVisible(visible) {
    if (!destroyRef.current) {
      innerSetDomErrorVisible(visible);
    }
  }

  var hasName = hasValidName(name); // Cache Field NamePath

  var nameRef = (0, React.useRef)([]); // Should clean up if Field removed

  React.useEffect(function () {
    return function () {
      destroyRef.current = true;
      updateItemErrors(nameRef.current.join('__SPLIT__'), []);
    };
  }, []);
  var prefixCls = getPrefixCls('form', customizePrefixCls); // ======================== Errors ========================
  // Collect noStyle Field error to the top FormItem

  var updateChildItemErrors = noStyle ? updateItemErrors : function (subName, subErrors) {
    setInlineErrors(function () {
      var prevInlineErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!(0, _isEqual["default"])(prevInlineErrors[subName], subErrors)) {
        return (0, _extends3["default"])((0, _extends3["default"])({}, prevInlineErrors), (0, _defineProperty2["default"])({}, subName, subErrors));
      }

      return prevInlineErrors;
    });
  }; // ===================== Children Ref =====================

  var getItemRef = (0, _useItemRef["default"])();

  function renderLayout(baseChildren, fieldId, meta, isRequired) {
    var _itemClassName;

    var _a;

    if (noStyle && !hidden) {
      return baseChildren;
    } // ======================== Errors ========================
    // >>> collect sub errors


    var subErrorList = [];
    Object.keys(inlineErrors).forEach(function (subName) {
      subErrorList = [].concat((0, _toConsumableArray2["default"])(subErrorList), (0, _toConsumableArray2["default"])(inlineErrors[subName] || []));
    }); // >>> merged errors

    var mergedErrors;

    if (help !== undefined && help !== null) {
      mergedErrors = (0, _util.toArray)(help);
    } else {
      mergedErrors = meta ? meta.errors : [];
      mergedErrors = [].concat((0, _toConsumableArray2["default"])(mergedErrors), (0, _toConsumableArray2["default"])(subErrorList));
    } // ======================== Status ========================


    var mergedValidateStatus = '';

    if (validateStatus !== undefined) {
      mergedValidateStatus = validateStatus;
    } else if (meta === null || meta === void 0 ? void 0 : meta.validating) {
      mergedValidateStatus = 'validating';
    } else if (((_a = meta === null || meta === void 0 ? void 0 : meta.errors) === null || _a === void 0 ? void 0 : _a.length) || subErrorList.length) {
      mergedValidateStatus = 'error';
    } else if (meta === null || meta === void 0 ? void 0 : meta.touched) {
      mergedValidateStatus = 'success';
    }

    var itemClassName = (_itemClassName = {}, (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item"), true), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-with-help"), domErrorVisible || help), (0, _defineProperty2["default"])(_itemClassName, "".concat(className), !!className), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-has-feedback"), mergedValidateStatus && hasFeedback), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-has-success"), mergedValidateStatus === 'success'), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-has-warning"), mergedValidateStatus === 'warning'), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-has-error"), mergedValidateStatus === 'error'), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-is-validating"), mergedValidateStatus === 'validating'), (0, _defineProperty2["default"])(_itemClassName, "".concat(prefixCls, "-item-hidden"), hidden), _itemClassName); // ======================= Children =======================

    return /*#__PURE__*/React.createElement(_row["default"], (0, _extends3["default"])({
      className: (0, _classnames["default"])(itemClassName),
      style: style,
      key: "row"
    }, (0, _omit["default"])(restProps, ['colon', 'extra', 'getValueFromEvent', 'getValueProps', 'hasFeedback', 'help', 'htmlFor', 'id', 'initialValue', 'isListField', 'label', 'labelAlign', 'labelCol', 'normalize', 'preserve', 'required', 'tooltip', 'validateFirst', 'validateStatus', 'valuePropName', 'wrapperCol', '_internalItemRender'])), /*#__PURE__*/React.createElement(_FormItemLabel["default"], (0, _extends3["default"])({
      htmlFor: fieldId,
      required: isRequired,
      requiredMark: requiredMark
    }, props, {
      prefixCls: prefixCls
    })), /*#__PURE__*/React.createElement(_FormItemInput["default"], (0, _extends3["default"])({}, props, meta, {
      errors: mergedErrors,
      prefixCls: prefixCls,
      status: mergedValidateStatus,
      onDomErrorVisibleChange: setDomErrorVisible,
      validateStatus: mergedValidateStatus
    }), /*#__PURE__*/React.createElement(_context.FormItemContext.Provider, {
      value: {
        updateItemErrors: updateChildItemErrors
      }
    }, baseChildren)));
  }

  var isRenderProps = typeof children === 'function'; // Record for real component render

  var updateRef = (0, React.useRef)(0);
  updateRef.current += 1;

  if (!hasName && !isRenderProps && !dependencies) {
    return renderLayout(children);
  }

  var variables = {};

  if (typeof label === 'string') {
    variables.label = label;
  }

  if (messageVariables) {
    variables = (0, _extends3["default"])((0, _extends3["default"])({}, variables), messageVariables);
  }

  return /*#__PURE__*/React.createElement(_rcFieldForm.Field, (0, _extends3["default"])({}, props, {
    messageVariables: variables,
    trigger: trigger,
    validateTrigger: mergedValidateTrigger,
    onReset: function onReset() {
      setDomErrorVisible(false);
    }
  }), function (control, meta, context) {
    var errors = meta.errors;
    var mergedName = (0, _util.toArray)(name).length && meta ? meta.name : [];
    var fieldId = (0, _util.getFieldId)(mergedName, formName);

    if (noStyle) {
      nameRef.current = (0, _toConsumableArray2["default"])(mergedName);

      if (fieldKey) {
        var fieldKeys = Array.isArray(fieldKey) ? fieldKey : [fieldKey];
        nameRef.current = [].concat((0, _toConsumableArray2["default"])(mergedName.slice(0, -1)), (0, _toConsumableArray2["default"])(fieldKeys));
      }

      updateItemErrors(nameRef.current.join('__SPLIT__'), errors);
    }

    var isRequired = required !== undefined ? required : !!(rules && rules.some(function (rule) {
      if (rule && (0, _typeof2["default"])(rule) === 'object' && rule.required) {
        return true;
      }

      if (typeof rule === 'function') {
        var ruleEntity = rule(context);
        return ruleEntity && ruleEntity.required;
      }

      return false;
    })); // ======================= Children =======================

    var mergedControl = (0, _extends3["default"])({}, control);
    var childNode = null;
    (0, _devWarning["default"])(!(shouldUpdate && dependencies), 'Form.Item', "`shouldUpdate` and `dependencies` shouldn't be used together. See https://ant.design/components/form/#dependencies.");

    if (Array.isArray(children) && hasName) {
      (0, _devWarning["default"])(false, 'Form.Item', '`children` is array of render props cannot have `name`.');
      childNode = children;
    } else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) {
      (0, _devWarning["default"])(!!(shouldUpdate || dependencies), 'Form.Item', '`children` of render props only work with `shouldUpdate` or `dependencies`.');
      (0, _devWarning["default"])(!hasName, 'Form.Item', "Do not use `name` with `children` of render props since it's not a field.");
    } else if (dependencies && !isRenderProps && !hasName) {
      (0, _devWarning["default"])(false, 'Form.Item', 'Must set `name` or use render props when `dependencies` is set.');
    } else if ((0, _reactNode.isValidElement)(children)) {
      (0, _devWarning["default"])(children.props.defaultValue === undefined, 'Form.Item', '`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.');
      var childProps = (0, _extends3["default"])((0, _extends3["default"])({}, children.props), mergedControl);

      if (!childProps.id) {
        childProps.id = fieldId;
      }

      if ((0, _ref2.supportRef)(children)) {
        childProps.ref = getItemRef(mergedName, children);
      } // We should keep user origin event handler


      var triggers = new Set([].concat((0, _toConsumableArray2["default"])((0, _util.toArray)(trigger)), (0, _toConsumableArray2["default"])((0, _util.toArray)(mergedValidateTrigger))));
      triggers.forEach(function (eventName) {
        childProps[eventName] = function () {
          var _a2, _c2;

          var _a, _b, _c;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          (_a = mergedControl[eventName]) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [mergedControl].concat(args));
          (_c = (_b = children.props)[eventName]) === null || _c === void 0 ? void 0 : (_c2 = _c).call.apply(_c2, [_b].concat(args));
        };
      });
      childNode = /*#__PURE__*/React.createElement(MemoInput, {
        value: mergedControl[props.valuePropName || 'value'],
        update: updateRef.current
      }, (0, _reactNode.cloneElement)(children, childProps));
    } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) {
      childNode = children(context);
    } else {
      (0, _devWarning["default"])(!mergedName.length, 'Form.Item', '`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead.');
      childNode = children;
    }

    return renderLayout(childNode, fieldId, meta, isRequired);
  });
}

var _default = FormItem;
exports["default"] = _default;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1626);

var _interopRequireWildcard = __webpack_require__(1627);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HOOK_MARK = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(106));

var HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

exports.HOOK_MARK = HOOK_MARK;

var warningFunc = function warningFunc() {
  (0, _warning.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};

var Context = /*#__PURE__*/React.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      setCallbacks: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc
    };
  }
});
var _default = Context;
exports.default = _default;

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(490)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _QuestionCircleOutlined = _interopRequireDefault(__webpack_require__(1629));

var _col = _interopRequireDefault(__webpack_require__(398));

var _context = __webpack_require__(126);

var _LocaleReceiver = __webpack_require__(94);

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function toTooltipProps(tooltip) {
  if (!tooltip) {
    return null;
  }

  if ((0, _typeof2["default"])(tooltip) === 'object' && ! /*#__PURE__*/React.isValidElement(tooltip)) {
    return tooltip;
  }

  return {
    title: tooltip
  };
}

var FormItemLabel = function FormItemLabel(_ref) {
  var prefixCls = _ref.prefixCls,
      label = _ref.label,
      htmlFor = _ref.htmlFor,
      labelCol = _ref.labelCol,
      labelAlign = _ref.labelAlign,
      colon = _ref.colon,
      required = _ref.required,
      requiredMark = _ref.requiredMark,
      tooltip = _ref.tooltip;

  var _useLocaleReceiver = (0, _LocaleReceiver.useLocaleReceiver)('Form'),
      _useLocaleReceiver2 = (0, _slicedToArray2["default"])(_useLocaleReceiver, 1),
      formLocale = _useLocaleReceiver2[0];

  if (!label) return null;
  return /*#__PURE__*/React.createElement(_context.FormContext.Consumer, {
    key: "label"
  }, function (_ref2) {
    var _classNames;

    var vertical = _ref2.vertical,
        contextLabelAlign = _ref2.labelAlign,
        contextLabelCol = _ref2.labelCol,
        contextColon = _ref2.colon;

    var _a;

    var mergedLabelCol = labelCol || contextLabelCol || {};
    var mergedLabelAlign = labelAlign || contextLabelAlign;
    var labelClsBasic = "".concat(prefixCls, "-item-label");
    var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
    var labelChildren = label; // Keep label is original where there should have no colon

    var computedColon = colon === true || contextColon !== false && colon !== false;
    var haveColon = computedColon && !vertical; // Remove duplicated user input colon

    if (haveColon && typeof label === 'string' && label.trim() !== '') {
      labelChildren = label.replace(/[:|：]\s*$/, '');
    } // Tooltip


    var tooltipProps = toTooltipProps(tooltip);

    if (tooltipProps) {
      var _tooltipProps$icon = tooltipProps.icon,
          icon = _tooltipProps$icon === void 0 ? /*#__PURE__*/React.createElement(_QuestionCircleOutlined["default"], null) : _tooltipProps$icon,
          restTooltipProps = __rest(tooltipProps, ["icon"]);

      var tooltipNode = /*#__PURE__*/React.createElement(_tooltip["default"], restTooltipProps, /*#__PURE__*/React.cloneElement(icon, {
        className: "".concat(prefixCls, "-item-tooltip")
      }));
      labelChildren = /*#__PURE__*/React.createElement(React.Fragment, null, labelChildren, tooltipNode);
    } // Add required mark if optional


    if (requiredMark === 'optional' && !required) {
      labelChildren = /*#__PURE__*/React.createElement(React.Fragment, null, labelChildren, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item-optional")
      }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = _default2["default"].Form) === null || _a === void 0 ? void 0 : _a.optional)));
    }

    var labelClassName = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-item-required"), required), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-item-required-mark-optional"), requiredMark === 'optional'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
    return /*#__PURE__*/React.createElement(_col["default"], (0, _extends2["default"])({}, mergedLabelCol, {
      className: labelColClassName
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: htmlFor,
      className: labelClassName,
      title: typeof label === 'string' ? label : ''
    }, labelChildren));
  });
};

var _default = FormItemLabel;
exports["default"] = _default;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _QuestionCircleOutlined = _interopRequireDefault(__webpack_require__(406));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _QuestionCircleOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var QuestionCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };
exports.default = QuestionCircleOutlined;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(258));

var _ExclamationCircleFilled = _interopRequireDefault(__webpack_require__(257));

var _col = _interopRequireDefault(__webpack_require__(398));

var _context = __webpack_require__(126);

var _ErrorList = _interopRequireDefault(__webpack_require__(708));

var iconMap = {
  success: _CheckCircleFilled["default"],
  warning: _ExclamationCircleFilled["default"],
  error: _CloseCircleFilled["default"],
  validating: _LoadingOutlined["default"]
};

var FormItemInput = function FormItemInput(props) {
  var prefixCls = props.prefixCls,
      status = props.status,
      wrapperCol = props.wrapperCol,
      children = props.children,
      help = props.help,
      errors = props.errors,
      onDomErrorVisibleChange = props.onDomErrorVisibleChange,
      hasFeedback = props.hasFeedback,
      formItemRender = props._internalItemRender,
      validateStatus = props.validateStatus,
      extra = props.extra;
  var baseClassName = "".concat(prefixCls, "-item");
  var formContext = React.useContext(_context.FormContext);
  var mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
  var className = (0, _classnames["default"])("".concat(baseClassName, "-control"), mergedWrapperCol.className);
  React.useEffect(function () {
    return function () {
      onDomErrorVisibleChange(false);
    };
  }, []); // Should provides additional icon if `hasFeedback`

  var IconNode = validateStatus && iconMap[validateStatus];
  var icon = hasFeedback && IconNode ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(baseClassName, "-children-icon")
  }, /*#__PURE__*/React.createElement(IconNode, null)) : null; // Pass to sub FormItem should not with col info

  var subFormContext = (0, _extends2["default"])({}, formContext);
  delete subFormContext.labelCol;
  delete subFormContext.wrapperCol;
  var inputDom = /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-control-input")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-control-input-content")
  }, children), icon);
  var errorListDom = /*#__PURE__*/React.createElement(_context.FormItemPrefixContext.Provider, {
    value: {
      prefixCls: prefixCls,
      status: status
    }
  }, /*#__PURE__*/React.createElement(_ErrorList["default"], {
    errors: errors,
    help: help,
    onDomErrorVisibleChange: onDomErrorVisibleChange
  })); // If extra = 0, && will goes wrong
  // 0&&error -> 0

  var extraDom = extra ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClassName, "-extra")
  }, extra) : null;
  var dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorListDom,
    extra: extraDom
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, inputDom, errorListDom, extraDom);
  return /*#__PURE__*/React.createElement(_context.FormContext.Provider, {
    value: subFormContext
  }, /*#__PURE__*/React.createElement(_col["default"], (0, _extends2["default"])({}, mergedWrapperCol, {
    className: className
  }), dom));
};

var _default = FormItemInput;
exports["default"] = _default;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCacheErrors;

var React = _interopRequireWildcard(__webpack_require__(0));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

/** Always debounce error to avoid [error -> null -> error] blink */
function useCacheErrors(errors, changeTrigger, directly) {
  var cacheRef = React.useRef({
    errors: errors,
    visible: !!errors.length
  });
  var forceUpdate = (0, _useForceUpdate["default"])();

  var update = function update() {
    var prevVisible = cacheRef.current.visible;
    var newVisible = !!errors.length;
    var prevErrors = cacheRef.current.errors;
    cacheRef.current.errors = errors;
    cacheRef.current.visible = newVisible;

    if (prevVisible !== newVisible) {
      changeTrigger(newVisible);
    } else if (prevErrors.length !== errors.length || prevErrors.some(function (prevErr, index) {
      return prevErr !== errors[index];
    })) {
      forceUpdate();
    }
  };

  React.useEffect(function () {
    if (!directly) {
      var timeout = setTimeout(update, 10);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [errors]);

  if (directly) {
    update();
  }

  return [cacheRef.current.visible, cacheRef.current.errors];
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFrameState;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _raf = _interopRequireDefault(__webpack_require__(176));

function useFrameState(defaultValue) {
  var _React$useState = React.useState(defaultValue),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var frameRef = (0, React.useRef)(null);
  var batchRef = (0, React.useRef)([]);
  var destroyRef = (0, React.useRef)(false);
  React.useEffect(function () {
    return function () {
      destroyRef.current = true;

      _raf["default"].cancel(frameRef.current);
    };
  }, []);

  function setFrameValue(updater) {
    if (destroyRef.current) {
      return;
    }

    if (frameRef.current === null) {
      batchRef.current = [];
      frameRef.current = (0, _raf["default"])(function () {
        frameRef.current = null;
        setValue(function (prevValue) {
          var current = prevValue;
          batchRef.current.forEach(function (func) {
            current = func(current);
          });
          return current;
        });
      });
    }

    batchRef.current.push(updater);
  }

  return [value, setFrameValue];
}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useItemRef;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ref = __webpack_require__(117);

var _context = __webpack_require__(126);

function useItemRef() {
  var _React$useContext = React.useContext(_context.FormContext),
      itemRef = _React$useContext.itemRef;

  var cacheRef = React.useRef({});

  function getRef(name, children) {
    var childrenRef = children && (0, _typeof2["default"])(children) === 'object' && children.ref;
    var nameStr = name.join('_');

    if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
      cacheRef.current.name = nameStr;
      cacheRef.current.originRef = childrenRef;
      cacheRef.current.ref = (0, _ref.composeRef)(itemRef(name), childrenRef);
    }

    return cacheRef.current.ref;
  }

  return getRef;
}

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcFieldForm = __webpack_require__(157);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _configProvider = __webpack_require__(8);

var _context = __webpack_require__(126);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var FormList = function FormList(_a) {
  var customizePrefixCls = _a.prefixCls,
      children = _a.children,
      props = __rest(_a, ["prefixCls", "children"]);

  (0, _devWarning["default"])(!!props.name, 'Form.List', 'Miss `name` prop.');

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('form', customizePrefixCls);
  return /*#__PURE__*/React.createElement(_rcFieldForm.List, props, function (fields, operation, meta) {
    return /*#__PURE__*/React.createElement(_context.FormItemPrefixContext.Provider, {
      value: {
        prefixCls: prefixCls,
        status: 'error'
      }
    }, children(fields.map(function (field) {
      return (0, _extends2["default"])((0, _extends2["default"])({}, field), {
        fieldKey: field.key
      });
    }), operation, {
      errors: meta.errors
    }));
  });
};

var _default = FormList;
exports["default"] = _default;

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPanelList_TabPane__ = __webpack_require__(713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPanelList_TabPane__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_isMobile__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabNavList__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabPanelList__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TabPanelList_TabPane__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TabContext__ = __webpack_require__(408);






// Accessibility https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role










/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */
// Used for accessibility

var uuid = 0;

function parseTabList(children) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Children_toArray__["a" /* default */])(children).map(function (node) {
    if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"](node)) {
      var key = node.key !== undefined ? String(node.key) : undefined;
      return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        key: key
      }, node.props), {}, {
        node: node
      });
    }

    return null;
  }).filter(function (tab) {
    return tab;
  });
}

function Tabs(_ref, ref) {
  var _classNames;

  var id = _ref.id,
      _ref$prefixCls = _ref.prefixCls,
      prefixCls = _ref$prefixCls === void 0 ? 'rc-tabs' : _ref$prefixCls,
      className = _ref.className,
      children = _ref.children,
      direction = _ref.direction,
      activeKey = _ref.activeKey,
      defaultActiveKey = _ref.defaultActiveKey,
      editable = _ref.editable,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? {
    inkBar: true,
    tabPane: false
  } : _ref$animated,
      _ref$tabPosition = _ref.tabPosition,
      tabPosition = _ref$tabPosition === void 0 ? 'top' : _ref$tabPosition,
      tabBarGutter = _ref.tabBarGutter,
      tabBarStyle = _ref.tabBarStyle,
      tabBarExtraContent = _ref.tabBarExtraContent,
      locale = _ref.locale,
      moreIcon = _ref.moreIcon,
      moreTransitionName = _ref.moreTransitionName,
      destroyInactiveTabPane = _ref.destroyInactiveTabPane,
      renderTabBar = _ref.renderTabBar,
      onChange = _ref.onChange,
      onTabClick = _ref.onTabClick,
      onTabScroll = _ref.onTabScroll,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["id", "prefixCls", "className", "children", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "moreIcon", "moreTransitionName", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll"]);

  var tabs = parseTabList(children);
  var rtl = direction === 'rtl';
  var mergedAnimated;

  if (animated === false) {
    mergedAnimated = {
      inkBar: false,
      tabPane: false
    };
  } else if (animated === true) {
    mergedAnimated = {
      inkBar: true,
      tabPane: true
    };
  } else {
    mergedAnimated = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      inkBar: true,
      tabPane: false
    }, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(animated) === 'object' ? animated : {});
  } // ======================== Mobile ========================


  var _useState = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(false),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      mobile = _useState2[0],
      setMobile = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
    // Only update on the client side
    setMobile(Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_isMobile__["a" /* default */])());
  }, []); // ====================== Active Key ======================

  var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_hooks_useMergedState__["a" /* default */])(function () {
    var _tabs$;

    return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
  }, {
    value: activeKey,
    defaultValue: defaultActiveKey
  }),
      _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
      mergedActiveKey = _useMergedState2[0],
      setMergedActiveKey = _useMergedState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(function () {
    return tabs.findIndex(function (tab) {
      return tab.key === mergedActiveKey;
    });
  }),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1]; // Reset active key if not exist anymore


  Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
    var newActiveIndex = tabs.findIndex(function (tab) {
      return tab.key === mergedActiveKey;
    });

    if (newActiveIndex === -1) {
      var _tabs$newActiveIndex;

      newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
      setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
    }

    setActiveIndex(newActiveIndex);
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_'), mergedActiveKey, activeIndex]); // ===================== Accessibility ====================

  var _useMergedState3 = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_hooks_useMergedState__["a" /* default */])(null, {
    value: id
  }),
      _useMergedState4 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState3, 2),
      mergedId = _useMergedState4[0],
      setMergedId = _useMergedState4[1];

  var mergedTabPosition = tabPosition;

  if (mobile && !['left', 'right'].includes(tabPosition)) {
    mergedTabPosition = 'top';
  } // Async generate id to avoid ssr mapping failed


  Object(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
    if (!id) {
      setMergedId("rc-tabs-".concat( false ? 'test' : uuid));
      uuid += 1;
    }
  }, []); // ======================== Events ========================

  function onInternalTabClick(key, e) {
    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(key, e);
    setMergedActiveKey(key);
    onChange === null || onChange === void 0 ? void 0 : onChange(key);
  } // ======================== Render ========================


  var sharedProps = {
    id: mergedId,
    activeKey: mergedActiveKey,
    animated: mergedAnimated,
    tabPosition: mergedTabPosition,
    rtl: rtl,
    mobile: mobile
  };
  var tabNavBar;

  var tabNavBarProps = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, sharedProps), {}, {
    editable: editable,
    locale: locale,
    moreIcon: moreIcon,
    moreTransitionName: moreTransitionName,
    tabBarGutter: tabBarGutter,
    onTabClick: onInternalTabClick,
    onTabScroll: onTabScroll,
    extra: tabBarExtraContent,
    style: tabBarStyle,
    panes: children
  });

  if (renderTabBar) {
    tabNavBar = renderTabBar(tabNavBarProps, __WEBPACK_IMPORTED_MODULE_11__TabNavList__["a" /* default */]);
  } else {
    tabNavBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__TabNavList__["a" /* default */], tabNavBarProps);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__TabContext__["a" /* default */].Provider, {
    value: {
      tabs: tabs,
      prefixCls: prefixCls
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    id: id,
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(prefixCls, "".concat(prefixCls, "-").concat(mergedTabPosition), (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-mobile"), mobile), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-editable"), editable), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-rtl"), rtl), _classNames), className)
  }, restProps), tabNavBar, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__TabPanelList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    destroyInactiveTabPane: destroyInactiveTabPane
  }, sharedProps, {
    animated: mergedAnimated
  }))));
}

var ForwardTabs = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react__["forwardRef"](Tabs);
ForwardTabs.TabPane = __WEBPACK_IMPORTED_MODULE_13__TabPanelList_TabPane__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (ForwardTabs);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1640);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(407);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1645);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_resize_observer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useRaf__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabNode__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks_useOffsets__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useVisibleRange__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OperationNode__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TabContext__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useTouchMove__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hooks_useRefs__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddButton__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hooks_useSyncState__ = __webpack_require__(1658);





















var ExtraContent = function ExtraContent(_ref) {
  var position = _ref.position,
      prefixCls = _ref.prefixCls,
      extra = _ref.extra;
  if (!extra) return null;
  var content;
  var assertExtra = extra;

  if (position === 'right') {
    content = assertExtra.right || !assertExtra.left && assertExtra || null;
  }

  if (position === 'left') {
    content = assertExtra.left || null;
  }

  return content ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-extra-content")
  }, content) : null;
};

function TabNavList(props, ref) {
  var _classNames;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_5_react__["useContext"](__WEBPACK_IMPORTED_MODULE_14__TabContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      tabs = _React$useContext.tabs;

  var className = props.className,
      style = props.style,
      id = props.id,
      animated = props.animated,
      activeKey = props.activeKey,
      rtl = props.rtl,
      extra = props.extra,
      editable = props.editable,
      locale = props.locale,
      tabPosition = props.tabPosition,
      tabBarGutter = props.tabBarGutter,
      children = props.children,
      onTabClick = props.onTabClick,
      onTabScroll = props.onTabScroll;
  var tabsWrapperRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var tabListRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var operationsRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var innerAddButtonRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

  var _useRefs = Object(__WEBPACK_IMPORTED_MODULE_16__hooks_useRefs__["a" /* default */])(),
      _useRefs2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useRefs, 2),
      getBtnRef = _useRefs2[0],
      removeBtnRef = _useRefs2[1];

  var tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';

  var _useSyncState = Object(__WEBPACK_IMPORTED_MODULE_18__hooks_useSyncState__["a" /* default */])(0, function (next, prev) {
    if (tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next > prev ? 'left' : 'right'
      });
    }
  }),
      _useSyncState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useSyncState, 2),
      transformLeft = _useSyncState2[0],
      setTransformLeft = _useSyncState2[1];

  var _useSyncState3 = Object(__WEBPACK_IMPORTED_MODULE_18__hooks_useSyncState__["a" /* default */])(0, function (next, prev) {
    if (!tabPositionTopOrBottom && onTabScroll) {
      onTabScroll({
        direction: next > prev ? 'top' : 'bottom'
      });
    }
  }),
      _useSyncState4 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useSyncState3, 2),
      transformTop = _useSyncState4[0],
      setTransformTop = _useSyncState4[1];

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      wrapperScrollWidth = _useState2[0],
      setWrapperScrollWidth = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      wrapperScrollHeight = _useState4[0],
      setWrapperScrollHeight = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      wrapperContentWidth = _useState6[0],
      setWrapperContentWidth = _useState6[1];

  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState8 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState7, 2),
      wrapperContentHeight = _useState8[0],
      setWrapperContentHeight = _useState8[1];

  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(null),
      _useState10 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState9, 2),
      wrapperWidth = _useState10[0],
      setWrapperWidth = _useState10[1];

  var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(null),
      _useState12 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState11, 2),
      wrapperHeight = _useState12[0],
      setWrapperHeight = _useState12[1];

  var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState14 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState13, 2),
      addWidth = _useState14[0],
      setAddWidth = _useState14[1];

  var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(0),
      _useState16 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState15, 2),
      addHeight = _useState16[0],
      setAddHeight = _useState16[1];

  var _useRafState = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useRaf__["b" /* useRafState */])(new Map()),
      _useRafState2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useRafState, 2),
      tabSizes = _useRafState2[0],
      setTabSizes = _useRafState2[1];

  var tabOffsets = Object(__WEBPACK_IMPORTED_MODULE_11__hooks_useOffsets__["a" /* default */])(tabs, tabSizes, wrapperScrollWidth); // ========================== Util =========================

  var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
  var transformMin = 0;
  var transformMax = 0;

  if (!tabPositionTopOrBottom) {
    transformMin = Math.min(0, wrapperHeight - wrapperScrollHeight);
    transformMax = 0;
  } else if (rtl) {
    transformMin = 0;
    transformMax = Math.max(0, wrapperScrollWidth - wrapperWidth);
  } else {
    transformMin = Math.min(0, wrapperWidth - wrapperScrollWidth);
    transformMax = 0;
  }

  function alignInRange(value) {
    if (value < transformMin) {
      return transformMin;
    }

    if (value > transformMax) {
      return transformMax;
    }

    return value;
  } // ========================= Mobile ========================


  var touchMovingRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

  var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
      _useState18 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState17, 2),
      lockAnimation = _useState18[0],
      setLockAnimation = _useState18[1];

  function doLockAnimation() {
    setLockAnimation(Date.now());
  }

  function clearTouchMoving() {
    window.clearTimeout(touchMovingRef.current);
  }

  Object(__WEBPACK_IMPORTED_MODULE_15__hooks_useTouchMove__["a" /* default */])(tabsWrapperRef, function (offsetX, offsetY) {
    function doMove(setState, offset) {
      setState(function (value) {
        var newValue = alignInRange(value + offset);
        return newValue;
      });
    }

    if (tabPositionTopOrBottom) {
      // Skip scroll if place is enough
      if (wrapperWidth >= wrapperScrollWidth) {
        return false;
      }

      doMove(setTransformLeft, offsetX);
    } else {
      if (wrapperHeight >= wrapperScrollHeight) {
        return false;
      }

      doMove(setTransformTop, offsetY);
    }

    clearTouchMoving();
    doLockAnimation();
    return true;
  });
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    clearTouchMoving();

    if (lockAnimation) {
      touchMovingRef.current = window.setTimeout(function () {
        setLockAnimation(0);
      }, 100);
    }

    return clearTouchMoving;
  }, [lockAnimation]); // ========================= Scroll ========================

  function scrollToTab() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
    var tabOffset = tabOffsets.get(key) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };

    if (tabPositionTopOrBottom) {
      // ============ Align with top & bottom ============
      var newTransform = transformLeft; // RTL

      if (rtl) {
        if (tabOffset.right < transformLeft) {
          newTransform = tabOffset.right;
        } else if (tabOffset.right + tabOffset.width > transformLeft + wrapperWidth) {
          newTransform = tabOffset.right + tabOffset.width - wrapperWidth;
        }
      } // LTR
      else if (tabOffset.left < -transformLeft) {
          newTransform = -tabOffset.left;
        } else if (tabOffset.left + tabOffset.width > -transformLeft + wrapperWidth) {
          newTransform = -(tabOffset.left + tabOffset.width - wrapperWidth);
        }

      setTransformTop(0);
      setTransformLeft(alignInRange(newTransform));
    } else {
      // ============ Align with left & right ============
      var _newTransform = transformTop;

      if (tabOffset.top < -transformTop) {
        _newTransform = -tabOffset.top;
      } else if (tabOffset.top + tabOffset.height > -transformTop + wrapperHeight) {
        _newTransform = -(tabOffset.top + tabOffset.height - wrapperHeight);
      }

      setTransformLeft(0);
      setTransformTop(alignInRange(_newTransform));
    }
  } // ========================== Tab ==========================
  // Render tab node & collect tab offset


  var _useVisibleRange = Object(__WEBPACK_IMPORTED_MODULE_12__hooks_useVisibleRange__["a" /* default */])(tabOffsets, {
    width: wrapperWidth,
    height: wrapperHeight,
    left: transformLeft,
    top: transformTop
  }, {
    width: wrapperContentWidth,
    height: wrapperContentHeight
  }, {
    width: addWidth,
    height: addHeight
  }, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
    tabs: tabs
  })),
      _useVisibleRange2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useVisibleRange, 2),
      visibleStart = _useVisibleRange2[0],
      visibleEnd = _useVisibleRange2[1];

  var tabNodes = tabs.map(function (tab) {
    var key = tab.key;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TabNode__["a" /* default */], {
      id: id,
      prefixCls: prefixCls,
      key: key,
      rtl: rtl,
      tab: tab,
      closable: tab.closable,
      editable: editable,
      active: key === activeKey,
      tabPosition: tabPosition,
      tabBarGutter: tabBarGutter,
      renderWrapper: children,
      removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
      ref: getBtnRef(key),
      onClick: function onClick(e) {
        onTabClick(key, e);
      },
      onRemove: function onRemove() {
        removeBtnRef(key);
      },
      onFocus: function onFocus() {
        scrollToTab(key);
        doLockAnimation(); // Focus element will make scrollLeft change which we should reset back

        if (!rtl) {
          tabsWrapperRef.current.scrollLeft = 0;
        }

        tabsWrapperRef.current.scrollTop = 0;
      }
    });
  });
  var onListHolderResize = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useRaf__["a" /* default */])(function () {
    var _tabsWrapperRef$curre, _tabsWrapperRef$curre2, _innerAddButtonRef$cu, _innerAddButtonRef$cu2, _operationsRef$curren, _operationsRef$curren2, _tabListRef$current, _tabListRef$current2, _operationsRef$curren3;

    // Update wrapper records
    var offsetWidth = ((_tabsWrapperRef$curre = tabsWrapperRef.current) === null || _tabsWrapperRef$curre === void 0 ? void 0 : _tabsWrapperRef$curre.offsetWidth) || 0;
    var offsetHeight = ((_tabsWrapperRef$curre2 = tabsWrapperRef.current) === null || _tabsWrapperRef$curre2 === void 0 ? void 0 : _tabsWrapperRef$curre2.offsetHeight) || 0;
    var newAddWidth = ((_innerAddButtonRef$cu = innerAddButtonRef.current) === null || _innerAddButtonRef$cu === void 0 ? void 0 : _innerAddButtonRef$cu.offsetWidth) || 0;
    var newAddHeight = ((_innerAddButtonRef$cu2 = innerAddButtonRef.current) === null || _innerAddButtonRef$cu2 === void 0 ? void 0 : _innerAddButtonRef$cu2.offsetHeight) || 0;
    var newOperationWidth = ((_operationsRef$curren = operationsRef.current) === null || _operationsRef$curren === void 0 ? void 0 : _operationsRef$curren.offsetWidth) || 0;
    var newOperationHeight = ((_operationsRef$curren2 = operationsRef.current) === null || _operationsRef$curren2 === void 0 ? void 0 : _operationsRef$curren2.offsetHeight) || 0;
    setWrapperWidth(offsetWidth);
    setWrapperHeight(offsetHeight);
    setAddWidth(newAddWidth);
    setAddHeight(newAddHeight);
    var newWrapperScrollWidth = (((_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.offsetWidth) || 0) - newAddWidth;
    var newWrapperScrollHeight = (((_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.offsetHeight) || 0) - newAddHeight;
    setWrapperScrollWidth(newWrapperScrollWidth);
    setWrapperScrollHeight(newWrapperScrollHeight);
    var isOperationHidden = (_operationsRef$curren3 = operationsRef.current) === null || _operationsRef$curren3 === void 0 ? void 0 : _operationsRef$curren3.className.includes(operationsHiddenClassName);
    setWrapperContentWidth(newWrapperScrollWidth - (isOperationHidden ? 0 : newOperationWidth));
    setWrapperContentHeight(newWrapperScrollHeight - (isOperationHidden ? 0 : newOperationHeight)); // Update buttons records

    setTabSizes(function () {
      var newSizes = new Map();
      tabs.forEach(function (_ref2) {
        var key = _ref2.key;
        var btnNode = getBtnRef(key).current;

        if (btnNode) {
          newSizes.set(key, {
            width: btnNode.offsetWidth,
            height: btnNode.offsetHeight,
            left: btnNode.offsetLeft,
            top: btnNode.offsetTop
          });
        }
      });
      return newSizes;
    });
  }); // ======================== Dropdown =======================

  var startHiddenTabs = tabs.slice(0, visibleStart);
  var endHiddenTabs = tabs.slice(visibleEnd + 1);
  var hiddenTabs = [].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(startHiddenTabs), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(endHiddenTabs)); // =================== Link & Operations ===================

  var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
      _useState20 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState19, 2),
      inkStyle = _useState20[0],
      setInkStyle = _useState20[1];

  var activeTabOffset = tabOffsets.get(activeKey); // Delay set ink style to avoid remove tab blink

  var inkBarRafRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

  function cleanInkBarRaf() {
    __WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__["a" /* default */].cancel(inkBarRafRef.current);
  }

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    var newInkStyle = {};

    if (activeTabOffset) {
      if (tabPositionTopOrBottom) {
        if (rtl) {
          newInkStyle.right = activeTabOffset.right;
        } else {
          newInkStyle.left = activeTabOffset.left;
        }

        newInkStyle.width = activeTabOffset.width;
      } else {
        newInkStyle.top = activeTabOffset.top;
        newInkStyle.height = activeTabOffset.height;
      }
    }

    cleanInkBarRaf();
    inkBarRafRef.current = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_raf__["a" /* default */])(function () {
      setInkStyle(newInkStyle);
    });
    return cleanInkBarRaf;
  }, [activeTabOffset, tabPositionTopOrBottom, rtl]); // ========================= Effect ========================

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    scrollToTab();
  }, [activeKey, activeTabOffset, tabOffsets, tabPositionTopOrBottom]); // Should recalculate when rtl changed

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    onListHolderResize();
  }, [rtl, tabBarGutter, activeKey, tabs.map(function (tab) {
    return tab.key;
  }).join('_')]); // ========================= Render ========================

  var hasDropdown = !!hiddenTabs.length;
  var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
  var pingLeft;
  var pingRight;
  var pingTop;
  var pingBottom;

  if (tabPositionTopOrBottom) {
    if (rtl) {
      pingRight = transformLeft > 0;
      pingLeft = transformLeft + wrapperWidth < wrapperScrollWidth;
    } else {
      pingLeft = transformLeft < 0;
      pingRight = -transformLeft + wrapperWidth < wrapperScrollWidth;
    }
  } else {
    pingTop = transformTop < 0;
    pingBottom = -transformTop + wrapperHeight < wrapperScrollHeight;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    ref: ref,
    role: "tablist",
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-nav"), className),
    style: style,
    onKeyDown: function onKeyDown() {
      // No need animation when use keyboard
      doLockAnimation();
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ExtraContent, {
    position: "left",
    extra: extra,
    prefixCls: prefixCls
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_resize_observer__["default"], {
    onResize: onListHolderResize
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(wrapPrefix, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
    ref: tabsWrapperRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_resize_observer__["default"], {
    onResize: onListHolderResize
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    ref: tabListRef,
    className: "".concat(prefixCls, "-nav-list"),
    style: {
      transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
      transition: lockAnimation ? 'none' : undefined
    }
  }, tabNodes, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__AddButton__["a" /* default */], {
    ref: innerAddButtonRef,
    prefixCls: prefixCls,
    locale: locale,
    editable: editable,
    style: {
      visibility: hasDropdown ? 'hidden' : null
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("".concat(prefixCls, "-ink-bar"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
    style: inkStyle
  }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__OperationNode__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: operationsRef,
    prefixCls: prefixCls,
    tabs: hiddenTabs,
    className: !hasDropdown && operationsHiddenClassName
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](ExtraContent, {
    position: "right",
    extra: extra,
    prefixCls: prefixCls
  }));
  /* eslint-enable */
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](TabNavList));

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1650);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(711);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRaf;
/* harmony export (immutable) */ __webpack_exports__["b"] = useRafState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__ = __webpack_require__(75);



function useRaf(callback) {
  var rafRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();
  var removedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);

  function trigger() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!removedRef.current) {
      __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */].cancel(rafRef.current);
      rafRef.current = Object(__WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */])(function () {
        callback.apply(void 0, args);
      });
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return function () {
      removedRef.current = true;
      __WEBPACK_IMPORTED_MODULE_2_rc_util_es_raf__["a" /* default */].cancel(rafRef.current);
    };
  }, []);
  return trigger;
}
function useRafState(defaultState) {
  var batchRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      forceUpdate = _useState2[1];

  var state = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(typeof defaultState === 'function' ? defaultState() : defaultState);
  var flushUpdate = useRaf(function () {
    var current = state.current;
    batchRef.current.forEach(function (callback) {
      current = callback(current);
    });
    batchRef.current = [];
    state.current = current;
    forceUpdate({});
  });

  function updater(callback) {
    batchRef.current.push(callback);
    flushUpdate();
  }

  return [state.current, updater];
}

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__ = __webpack_require__(60);





function TabNode(_ref, ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      id = _ref.id,
      active = _ref.active,
      rtl = _ref.rtl,
      _ref$tab = _ref.tab,
      key = _ref$tab.key,
      tab = _ref$tab.tab,
      disabled = _ref$tab.disabled,
      closeIcon = _ref$tab.closeIcon,
      tabBarGutter = _ref.tabBarGutter,
      tabPosition = _ref.tabPosition,
      closable = _ref.closable,
      renderWrapper = _ref.renderWrapper,
      removeAriaLabel = _ref.removeAriaLabel,
      editable = _ref.editable,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      onFocus = _ref.onFocus;
  var tabPrefix = "".concat(prefixCls, "-tab");
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    return onRemove;
  }, []);
  var nodeStyle = {};

  if (tabPosition === 'top' || tabPosition === 'bottom') {
    nodeStyle[rtl ? 'marginLeft' : 'marginRight'] = tabBarGutter;
  } else {
    nodeStyle.marginBottom = tabBarGutter;
  }

  var removable = editable && closable !== false && !disabled;

  function onInternalClick(e) {
    if (disabled) return;
    onClick(e);
  }

  function onRemoveTab(event) {
    event.preventDefault();
    event.stopPropagation();
    editable.onEdit('remove', {
      key: key,
      event: event
    });
  }

  var node = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    key: key,
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(tabPrefix, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(tabPrefix, "-with-remove"), removable), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(tabPrefix, "-active"), active), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
    style: nodeStyle,
    onClick: onInternalClick
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    role: "tab",
    "aria-selected": active,
    id: id && "".concat(id, "-tab-").concat(key),
    className: "".concat(tabPrefix, "-btn"),
    "aria-controls": id && "".concat(id, "-panel-").concat(key),
    "aria-disabled": disabled,
    tabIndex: disabled ? null : 0,
    onClick: function onClick(e) {
      e.stopPropagation();
      onInternalClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      if ([__WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].SPACE, __WEBPACK_IMPORTED_MODULE_3_rc_util_es_KeyCode__["a" /* default */].ENTER].includes(e.which)) {
        e.preventDefault();
        onInternalClick(e);
      }
    },
    onFocus: onFocus
  }, tab), removable && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", {
    type: "button",
    "aria-label": removeAriaLabel || 'remove',
    tabIndex: 0,
    className: "".concat(tabPrefix, "-remove"),
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemoveTab(e);
    }
  }, closeIcon || editable.removeIcon || '×'));

  if (renderWrapper) {
    node = renderWrapper(node);
  }

  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](TabNode));

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useOffsets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(tabs, tabSizes, holderScrollWidth) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function () {
    var _tabs$;

    var map = new Map();
    var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || DEFAULT_SIZE;
    var rightOffset = lastOffset.left + lastOffset.width;

    for (var i = 0; i < tabs.length; i += 1) {
      var key = tabs[i].key;
      var data = tabSizes.get(key); // Reuse last one when not exist yet

      if (!data) {
        var _tabs;

        data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || DEFAULT_SIZE;
      }

      var entity = map.get(key) || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, data); // Right


      entity.right = rightOffset - entity.left - entity.width; // Update entity

      map.set(key, entity);
    }

    return map;
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_'), tabSizes, holderScrollWidth]);
}

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useVisibleRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(tabOffsets, containerSize, tabContentNodeSize, addNodeSize, _ref) {
  var tabs = _ref.tabs,
      tabPosition = _ref.tabPosition,
      rtl = _ref.rtl;
  var unit;
  var position;
  var transformSize;

  if (['top', 'bottom'].includes(tabPosition)) {
    unit = 'width';
    position = rtl ? 'right' : 'left';
    transformSize = Math.abs(containerSize.left);
  } else {
    unit = 'height';
    position = 'top';
    transformSize = -containerSize.top;
  }

  var basicSize = containerSize[unit];
  var tabContentSize = tabContentNodeSize[unit];
  var addSize = addNodeSize[unit];
  var mergedBasicSize = basicSize;

  if (tabContentSize + addSize > basicSize) {
    mergedBasicSize = basicSize - addSize;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (!tabs.length) {
      return [0, 0];
    }

    var len = tabs.length;
    var endIndex = len;

    for (var i = 0; i < len; i += 1) {
      var offset = tabOffsets.get(tabs[i].key) || DEFAULT_SIZE;

      if (offset[position] + offset[unit] > transformSize + mergedBasicSize) {
        endIndex = i - 1;
        break;
      }
    }

    var startIndex = 0;

    for (var _i = len - 1; _i >= 0; _i -= 1) {
      var _offset = tabOffsets.get(tabs[_i].key) || DEFAULT_SIZE;

      if (_offset[position] < transformSize) {
        startIndex = _i + 1;
        break;
      }
    }

    return [startIndex, endIndex];
  }, [tabOffsets, transformSize, mergedBasicSize, tabPosition, tabs.map(function (tab) {
    return tab.key;
  }).join('_'), rtl]);
}

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_menu__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_dropdown__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddButton__ = __webpack_require__(712);










function OperationNode(_ref, ref) {
  var prefixCls = _ref.prefixCls,
      id = _ref.id,
      tabs = _ref.tabs,
      locale = _ref.locale,
      mobile = _ref.mobile,
      _ref$moreIcon = _ref.moreIcon,
      moreIcon = _ref$moreIcon === void 0 ? 'More' : _ref$moreIcon,
      moreTransitionName = _ref.moreTransitionName,
      style = _ref.style,
      className = _ref.className,
      editable = _ref.editable,
      tabBarGutter = _ref.tabBarGutter,
      rtl = _ref.rtl,
      onTabClick = _ref.onTabClick;

  // ======================== Dropdown ========================
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(null),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      selectedKey = _useState4[0],
      setSelectedKey = _useState4[1];

  var popupId = "".concat(id, "-more-popup");
  var dropdownPrefix = "".concat(prefixCls, "-dropdown");
  var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
  var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
  var menu = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_menu__["default"], {
    onClick: function onClick(_ref2) {
      var key = _ref2.key,
          domEvent = _ref2.domEvent;
      onTabClick(key, domEvent);
      setOpen(false);
    },
    id: popupId,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": selectedItemId,
    selectedKeys: [selectedKey],
    "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
  }, tabs.map(function (tab) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_menu__["MenuItem"], {
      key: tab.key,
      id: "".concat(popupId, "-").concat(tab.key),
      role: "option",
      "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
      disabled: tab.disabled
    }, tab.tab);
  }));

  function selectOffset(offset) {
    var enabledTabs = tabs.filter(function (tab) {
      return !tab.disabled;
    });
    var selectedIndex = enabledTabs.findIndex(function (tab) {
      return tab.key === selectedKey;
    }) || 0;
    var len = enabledTabs.length;

    for (var i = 0; i < len; i += 1) {
      selectedIndex = (selectedIndex + offset + len) % len;
      var tab = enabledTabs[selectedIndex];

      if (!tab.disabled) {
        setSelectedKey(tab.key);
        return;
      }
    }
  }

  function onKeyDown(e) {
    var which = e.which;

    if (!open) {
      if ([__WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].DOWN, __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].SPACE, __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].ENTER].includes(which)) {
        setOpen(true);
        e.preventDefault();
      }

      return;
    }

    switch (which) {
      case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].UP:
        selectOffset(-1);
        e.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].DOWN:
        selectOffset(1);
        e.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].ESC:
        setOpen(false);
        break;

      case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].SPACE:
      case __WEBPACK_IMPORTED_MODULE_4_rc_util_es_KeyCode__["a" /* default */].ENTER:
        if (selectedKey !== null) onTabClick(selectedKey, e);
        break;
    }
  } // ========================= Effect =========================


  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    // We use query element here to avoid React strict warning
    var ele = document.getElementById(selectedItemId);

    if (ele && ele.scrollIntoView) {
      ele.scrollIntoView(false);
    }
  }, [selectedKey]);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    if (!open) {
      setSelectedKey(null);
    }
  }, [open]); // ========================= Render =========================

  var moreStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, rtl ? 'marginLeft' : 'marginRight', tabBarGutter);

  if (!tabs.length) {
    moreStyle.visibility = 'hidden';
    moreStyle.order = 1;
  }

  var overlayClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(dropdownPrefix, "-rtl"), rtl));
  var moreNode = mobile ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_rc_dropdown__["default"], {
    prefixCls: dropdownPrefix,
    overlay: menu,
    trigger: ['hover'],
    visible: open,
    transitionName: moreTransitionName,
    onVisibleChange: setOpen,
    overlayClassName: overlayClassName,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("button", {
    type: "button",
    className: "".concat(prefixCls, "-nav-more"),
    style: moreStyle,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": popupId,
    id: "".concat(id, "-more"),
    "aria-expanded": open,
    onKeyDown: onKeyDown
  }, moreIcon));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-nav-operations"), className),
    style: style,
    ref: ref
  }, moreNode, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__AddButton__["a" /* default */], {
    prefixCls: prefixCls,
    locale: locale,
    editable: editable
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](OperationNode));

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTouchMove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var MIN_SWIPE_DISTANCE = 0.1;
var STOP_SWIPE_DISTANCE = 0.01;
var REFRESH_INTERVAL = 20;
var SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL); // ================================= Hook =================================

function useTouchMove(ref, onOffset) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),
      _useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState, 2),
      touchPosition = _useState2[0],
      setTouchPosition = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),
      _useState4 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState3, 2),
      lastTimestamp = _useState4[0],
      setLastTimestamp = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),
      _useState6 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState5, 2),
      lastTimeDiff = _useState6[0],
      setLastTimeDiff = _useState6[1];

  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),
      _useState8 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useState7, 2),
      lastOffset = _useState8[0],
      setLastOffset = _useState8[1];

  var motionRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(); // ========================= Events =========================
  // >>> Touch events

  function onTouchStart(e) {
    var _e$touches$ = e.touches[0],
        screenX = _e$touches$.screenX,
        screenY = _e$touches$.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    window.clearInterval(motionRef.current);
  }

  function onTouchMove(e) {
    if (!touchPosition) return;
    e.preventDefault();
    var _e$touches$2 = e.touches[0],
        screenX = _e$touches$2.screenX,
        screenY = _e$touches$2.screenY;
    setTouchPosition({
      x: screenX,
      y: screenY
    });
    var offsetX = screenX - touchPosition.x;
    var offsetY = screenY - touchPosition.y;
    onOffset(offsetX, offsetY);
    var now = Date.now();
    setLastTimestamp(now);
    setLastTimeDiff(now - lastTimestamp);
    setLastOffset({
      x: offsetX,
      y: offsetY
    });
  }

  function onTouchEnd() {
    if (!touchPosition) return;
    setTouchPosition(null);
    setLastOffset(null); // Swipe if needed

    if (lastOffset) {
      var distanceX = lastOffset.x / lastTimeDiff;
      var distanceY = lastOffset.y / lastTimeDiff;
      var absX = Math.abs(distanceX);
      var absY = Math.abs(distanceY); // Skip swipe if low distance

      if (Math.max(absX, absY) < MIN_SWIPE_DISTANCE) return;
      var currentX = distanceX;
      var currentY = distanceY;
      motionRef.current = window.setInterval(function () {
        if (Math.abs(currentX) < STOP_SWIPE_DISTANCE && Math.abs(currentY) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(motionRef.current);
          return;
        }

        currentX *= SPEED_OFF_MULTIPLE;
        currentY *= SPEED_OFF_MULTIPLE;
        onOffset(currentX * REFRESH_INTERVAL, currentY * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  } // >>> Wheel event


  var lastWheelDirectionRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();

  function onWheel(e) {
    var deltaX = e.deltaX,
        deltaY = e.deltaY; // Convert both to x & y since wheel only happened on PC

    var mixed = 0;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);

    if (absX === absY) {
      mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
    } else if (absX > absY) {
      mixed = deltaX;
      lastWheelDirectionRef.current = 'x';
    } else {
      mixed = deltaY;
      lastWheelDirectionRef.current = 'y';
    }

    if (onOffset(-mixed, -mixed)) {
      e.preventDefault();
    }
  } // ========================= Effect =========================


  var touchEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  touchEventsRef.current = {
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    onWheel: onWheel
  };
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    function onProxyTouchStart(e) {
      touchEventsRef.current.onTouchStart(e);
    }

    function onProxyTouchMove(e) {
      touchEventsRef.current.onTouchMove(e);
    }

    function onProxyTouchEnd(e) {
      touchEventsRef.current.onTouchEnd(e);
    }

    function onProxyWheel(e) {
      touchEventsRef.current.onWheel(e);
    }

    document.addEventListener('touchmove', onProxyTouchMove, {
      passive: false
    });
    document.addEventListener('touchend', onProxyTouchEnd, {
      passive: false
    }); // No need to clean up since element removed

    ref.current.addEventListener('touchstart', onProxyTouchStart, {
      passive: false
    });
    ref.current.addEventListener('wheel', onProxyWheel);
    return function () {
      document.removeEventListener('touchmove', onProxyTouchMove);
      document.removeEventListener('touchend', onProxyTouchEnd);
    };
  }, []);
}

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRefs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function useRefs() {
  var cacheRefs = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Map());

  function getRef(key) {
    if (!cacheRefs.current.has(key)) {
      cacheRefs.current.set(key, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createRef"]());
    }

    return cacheRefs.current.get(key);
  }

  function removeRef(key) {
    cacheRefs.current.delete(key);
  }

  return [getRef, removeRef];
}

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSyncState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function useSyncState(defaultState, onChange) {
  var stateRef = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](defaultState);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"]({}),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      forceUpdate = _React$useState2[1];

  function setState(updater) {
    var newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;

    if (newValue !== stateRef.current) {
      onChange(newValue, stateRef.current);
    }

    stateRef.current = newValue;
    forceUpdate({});
  }

  return [stateRef.current, setState];
}

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TabPanelList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabContext__ = __webpack_require__(408);




function TabPanelList(_ref) {
  var id = _ref.id,
      activeKey = _ref.activeKey,
      animated = _ref.animated,
      tabPosition = _ref.tabPosition,
      rtl = _ref.rtl,
      destroyInactiveTabPane = _ref.destroyInactiveTabPane;

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__TabContext__["a" /* default */]),
      prefixCls = _React$useContext.prefixCls,
      tabs = _React$useContext.tabs;

  var tabPaneAnimated = animated.tabPane;
  var activeIndex = tabs.findIndex(function (tab) {
    return tab.key === activeKey;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-content-holder"))
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated)),
    style: activeIndex && tabPaneAnimated ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, rtl ? 'marginRight' : 'marginLeft', "-".concat(activeIndex, "00%")) : null
  }, tabs.map(function (tab) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](tab.node, {
      key: tab.key,
      prefixCls: prefixCls,
      tabKey: tab.key,
      id: id,
      animated: tabPaneAnimated,
      active: tab.key === activeKey,
      destroyInactiveTabPane: destroyInactiveTabPane
    });
  })));
}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _PlusOutlined = _interopRequireDefault(__webpack_require__(1661));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _PlusOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _PlusOutlined = _interopRequireDefault(__webpack_require__(1662));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _PlusOutlined.default
  }));
};
PlusOutlined.displayName = 'PlusOutlined';
var _default = /*#__PURE__*/React.forwardRef(PlusOutlined);
exports.default = _default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
exports.default = PlusOutlined;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);
var bind = __webpack_require__(714);
var Axios = __webpack_require__(1665);
var defaults = __webpack_require__(410);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(718);
axios.CancelToken = __webpack_require__(1678);
axios.isCancel = __webpack_require__(717);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1679);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1664 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(410);
var utils = __webpack_require__(88);
var InterceptorManager = __webpack_require__(1673);
var dispatchRequest = __webpack_require__(1674);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(716);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);
var transformData = __webpack_require__(1675);
var isCancel = __webpack_require__(717);
var defaults = __webpack_require__(410);
var isAbsoluteURL = __webpack_require__(1676);
var combineURLs = __webpack_require__(1677);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(88);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(718);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };
exports.default = DeleteOutlined;


/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateBadgeInfo; });
/* unused harmony export cleanBadgeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_wjson__ = __webpack_require__(85);
var UPDATE_BADGE_INFO="UPDATE_BADGE_INFO";var CLEAN_BADGE_INFO="CLEAN_BADGE_INFO";// dispatch function
var updateBadgeInfo=function updateBadgeInfo(newState){return{type:UPDATE_BADGE_INFO,newState:newState};};var cleanBadgeInfo=function cleanBadgeInfo(newState){return{type:CLEAN_BADGE_INFO,newState:newState};};var defaultBadgeInfo={shop_in_application:0// reducer
};/* unused harmony default export */ var _unused_webpack_default_export = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var badges=__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].decode(localStorage.getItem('wbadge'))||defaultBadgeInfo;badges=Object.assign({},defaultBadgeInfo,badges,state);if(action.type===UPDATE_BADGE_INFO){badges=Object.assign({},badges,action.newState);localStorage.setItem('wbadge',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(badges));return badges;}if(action.type===CLEAN_BADGE_INFO){localStorage.setItem('wbadge',__WEBPACK_IMPORTED_MODULE_0__libs_wjson__["a" /* default */].encode(defaultBadgeInfo));return defaultBadgeInfo;}return badges;});

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({options:{store_types:[{id:1,name:'量販'},{id:2,name:'超市'}],store_areas:[{id:1,name:'台北市地區'},{id:2,name:'宜花東地區'}],store_groups:[{id:1,name:'北北區'},{id:2,name:'北南區'}],service_categories:[{id:'6abf74d1-f3d8-4370-ab27-287999d8d5f5',name:'服務中心',items:[{id:'5be46471-a3dd-406c-a298-59b4eb920462',name:'VIP咖啡機',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/5be46471-a3dd-406c-a298-59b4eb920462/09377880-7b79-44af-9fa9-38292e1b1b53.png'},{id:'d2b7b9ed-a67d-4657-86a0-0bcbd33c3ef1',name:'不滿意可退貨',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/d2b7b9ed-a67d-4657-86a0-0bcbd33c3ef1/c6afb56c-0f31-4b00-be94-510f7abfe927.png'},{id:'1b74e941-1ef3-4d93-84b2-cc6b327b5b8a',name:'乾洗服務站',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/1b74e941-1ef3-4d93-84b2-cc6b327b5b8a/a9baf3c4-ae4b-475e-8344-ce7a34b73306.png'},{id:'4466040c-06f8-471f-83f3-217d07681777',name:'二手3C變購物金',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4466040c-06f8-471f-83f3-217d07681777/e97b2054-910b-4015-862a-1d4fb348e01f.png'},{id:'9e5c506d-e10a-4610-843c-0c74bd28b98e',name:'享樂券',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/9e5c506d-e10a-4610-843c-0c74bd28b98e/204d2712-49fb-478b-8cc6-72d3c70c6885.png'},{id:'2ca3d394-7e1e-4360-9327-54a6c855b6c5',name:'休憩區',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/2ca3d394-7e1e-4360-9327-54a6c855b6c5/1992f110-bd16-4760-aa21-2f0da7786901.png'},{id:'c6c521d7-f59b-453a-9244-a6d6600ccee6',name:'便利銀行',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/c6c521d7-f59b-453a-9244-a6d6600ccee6/b054cae3-7151-4aed-aa98-92a7468ec376.png'},{id:'e9c97b62-ef1c-456b-8a02-e792613844af',name:'便當訂購服務',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/e9c97b62-ef1c-456b-8a02-e792613844af/538b9051-2fd9-4cc1-8f20-c0924cf2628c.png'},{id:'9f6005d8-4c81-492f-89f7-d92b7986d95c',name:'保冷袋',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/9f6005d8-4c81-492f-89f7-d92b7986d95c/629dd103-de97-4506-893a-e26dbf57dc07.png'},{id:'4400e4a2-9db9-4dda-b215-b89b7661b54d',name:'傢俱商品宅配服務',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4400e4a2-9db9-4dda-b215-b89b7661b54d/30f9cffb-2770-4455-b53a-9db3966103b3.png'},{id:'61e88c0d-e4fe-4b1d-a438-dcb20a7a2080',name:'免費冰塊',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/61e88c0d-e4fe-4b1d-a438-dcb20a7a2080/13ca13e6-9dbe-4172-95fb-13aad7db4eba.png'}]},{id:'0c5f9d29-def3-4592-8d1f-a570cc5e41be',name:'其他服務',items:[{id:'4701d010-b47f-47b3-935f-e6a4c4b38393',name:'中獎發票兌換-五獎&六獎',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storeservice/4701d010-b47f-47b3-935f-e6a4c4b38393/60d96cef-b9fa-4d2d-97f8-79630b219b8f.png'}]}],brand_categories:[{id:'00fb7c8d-e18f-4615-b6dd-5ced270d9219',name:'家電 / 通訊 / 3C',items:[{id:'de96e13d-d8bd-40e0-87d4-bc9bb0ea14a1',name:'BEST電器',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Best_Logo_300x300.jpg'},{id:'7361db02-92f3-42bd-af34-6c0ae6ddd161',name:'LG',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7361db02-92f3-42bd-af34-6c0ae6ddd161/047376b5-8923-4ba4-94c7-bc19b5e9a812.jpg'},{id:'f3563b1f-1596-48f4-a028-92c5c4f01392',name:'NOKIA',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/nokia_300x300.jpg'},{id:'dc66a9f1-67dd-4b89-80f2-35b01225c800',name:'NOVA',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc66a9f1-67dd-4b89-80f2-35b01225c800/c75761da-3152-4064-a9fa-6c8cd9b73581.jpg'},{id:'d77417e0-c72e-4738-9812-122a1faa381a',name:'PYXIS',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pyxis_300x300.jpg'},{id:'43d46df9-7410-4356-83b8-abb73b29d692',name:'Samsung',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/samsung_300x300.jpg'},{id:'7321fa71-4ecf-4607-acbf-9317ccbfb2e4',name:'SONY',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sony_300x300.jpg'},{id:'d64dfd76-c451-48ea-88d5-84609b1c9289',name:'仙德曼',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d64dfd76-c451-48ea-88d5-84609b1c9289/3c3d1ab6-249c-457d-9b3b-b446e88260ac.jpg'},{id:'8fc91ba7-d438-49ad-beec-75035a60a470',name:'吸霸',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/'},{id:'af2895f0-62a1-4307-bcb2-b085e01c7bef',name:'德國海豚',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af2895f0-62a1-4307-bcb2-b085e01c7bef/bdb56a76-3d83-4188-92c9-a2d4eb2e44ce.jpg'},{id:'fab088f0-04d2-4e95-8698-a10b6ad6d847',name:'百享科技',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/richman_300x300.jpg'},{id:'7fe7c349-6e48-4263-8664-974669e483d4',name:'順發',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7fe7c349-6e48-4263-8664-974669e483d4/d738503a-8b4a-4519-8316-6f36926c1c4b.jpg'}]},{id:'0630e6fa-a5df-468b-bb9e-047669677603',name:'教育 / 學習 / 諮詢',items:[{id:'579df2af-d724-49b7-b69b-3694ca8e8477',name:'金石堂',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Kingstone_300x300.jpg'}]}],food_categories:[{id:1,name:'輕食點心',items:[{id:'ff773a48-f96c-43f9-96e2-4c43447c2860',name:'Häagen-Dazs',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Haagan_300x300.jpg'},{id:'7ce6e2e7-85c1-458f-82f7-8bedca6cecf2',name:'Mister Donut 多拿滋先生',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mister_300x300.jpg'},{id:'42ccbcdc-d46f-47cb-9f2e-224739b9679d',name:'Yamazaki 山崎麵包',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/42ccbcdc-d46f-47cb-9f2e-224739b9679d/e8d875c4-151f-4e95-a832-0d82a3601e8d.jpg'},{id:'4364e8c4-d1e6-4379-bdb3-88f4fa474daf',name:'Zen Q',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4364e8c4-d1e6-4379-bdb3-88f4fa474daf/97cd9d48-9592-4fe4-9121-b1ea53e4d07b.jpg'},{id:'8b990877-8c1f-4f52-949f-a03d46581ad1',name:'丹堤咖啡',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b990877-8c1f-4f52-949f-a03d46581ad1/7c01eebb-3e44-44dd-b192-4211ca9b9eea.jpg'},{id:'2838c4a4-1c1d-4fcd-bbca-dd5a149553df',name:'京都苑',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2838c4a4-1c1d-4fcd-bbca-dd5a149553df/7c4a5425-652d-4808-b221-79d6cbc1c8f9.jpg'},{id:'80135b2a-de42-42d0-b194-ffcb6dd3b3e3',name:'八月堂',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/80135b2a-de42-42d0-b194-ffcb6dd3b3e3/06537889-502d-4e56-a79d-7f141d90db30.jpg'},{id:'bd9040f3-f332-43ca-879d-19f741643096',name:'包心粉圓',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bd9040f3-f332-43ca-879d-19f741643096/a2eecaa6-962e-44db-91dd-7f1491cdfd87.jpg'},{id:'798af07b-2338-425c-add5-8c2d35c8af0d',name:'匠喝',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/798af07b-2338-425c-add5-8c2d35c8af0d/7ee4aaaa-5f7c-4792-b3d1-51dc02efd095.jpg'},{id:'4d790c1b-ea76-46cb-bf69-7f31191908f1',name:'半雞八兩',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d790c1b-ea76-46cb-bf69-7f31191908f1/8c685470-ad02-47af-9b56-7a0fab1041d3.jpg'},{id:'cc99dca6-6749-4a73-b5d9-44bbaf1723d2',name:'咖啡先生',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc99dca6-6749-4a73-b5d9-44bbaf1723d2/4561405d-762b-4122-ab60-99b0436c5e75.jpg'},{id:'2999fd26-deef-47c6-8c11-b849b5026daa',name:'哈根達斯',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2999fd26-deef-47c6-8c11-b849b5026daa/71159304-96a0-46dc-8fee-918fa35b07dc.jpg'},{id:'cb380a5f-3474-4088-9e9b-4aa4a0366e4e',name:'均均紅豆餅',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb380a5f-3474-4088-9e9b-4aa4a0366e4e/aee22aa9-3a33-4786-8d6b-ebaffdb4858f.jpg'},{id:'0701501d-ac69-4d62-a729-2dbef6137652',name:'大象山',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Da_300x300.jpg'},{id:'98cb49d6-8c1f-434d-a165-7d2e4147544b',name:'山茶園',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98cb49d6-8c1f-434d-a165-7d2e4147544b/de8f49c9-2d7e-41fb-a1c2-8278fef23fb3.jpg'},{id:'3a628197-8287-4af1-bc6c-dfa8ca026383',name:'怡客咖啡',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a628197-8287-4af1-bc6c-dfa8ca026383/b17a5386-da44-4b9c-a263-0c30bf011a8a.jpg'},{id:'e5ebef7a-33c3-40e8-905f-17e0deae60a9',name:'法爵',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5ebef7a-33c3-40e8-905f-17e0deae60a9/bfecc94f-b3c0-4d6b-b418-787fa97c48e4.jpg'},{id:'4a1cf24a-8821-465c-bd3a-ea2c4928629b',name:'滷底撈',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4a1cf24a-8821-465c-bd3a-ea2c4928629b/14ad323e-2ea1-4913-8a8c-75e33cdc636c.jpg'},{id:'0a710bf7-dd22-4ebd-9383-f6c9a780822a',name:'炸鷄大獅',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0a710bf7-dd22-4ebd-9383-f6c9a780822a/6d5b099f-02af-48ab-8a80-e6fab249cb47.png'},{id:'3e7fe1f5-025b-4d76-b556-78eb837e36ce',name:'私房小廚店',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e7fe1f5-025b-4d76-b556-78eb837e36ce/caceb09a-a3a8-4351-8e1a-b26b1a5787d1.jpg'},{id:'e84a04e3-8215-46e0-8d8b-5cdbefe4358b',name:'紅玉滿赤心雞蛋糕',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e84a04e3-8215-46e0-8d8b-5cdbefe4358b/673b07ee-a053-4137-b8c7-3b9af72188f3.jpg'},{id:'f2a914e7-3618-4ac4-98ab-fc6fc055870c',name:'老蔡水煎包',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2a914e7-3618-4ac4-98ab-fc6fc055870c/aedc7ad2-d09b-44a0-a8a8-02b037ca6a47.jpg'},{id:'cf68a166-93c4-420c-afe7-652884ccc7e4',name:'薔薇派',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf68a166-93c4-420c-afe7-652884ccc7e4/a75f769b-405a-4fac-87f9-c4c097bd6dde.jpg'},{id:'e10a8e62-d73a-4496-b97b-41fd2eb63145',name:'許留山',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e10a8e62-d73a-4496-b97b-41fd2eb63145/edeb3912-e9c3-426a-b5d7-067cc3a2f5d9.jpg'},{id:'089cd74c-cb14-4c03-bb2e-9989debcad27',name:'酷聖石',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cold_stone_300x300.jpg'},{id:'c54ae1a0-6544-4488-a5c5-059902d29bc4',name:'醇蛋糕',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c54ae1a0-6544-4488-a5c5-059902d29bc4/3617cdeb-c714-4f38-a7f0-566fcd26938c.jpg'},{id:'4d387614-7a9a-4f99-aa2f-85e81e0c039a',name:'陸家班',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d387614-7a9a-4f99-aa2f-85e81e0c039a/007271de-9e1e-41fe-99f3-f77d765df7cf.jpg'},{id:'e7ce0b9b-5688-44f0-b6ab-e9a1156a2307',name:'風和家現烤烘焙',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7ce0b9b-5688-44f0-b6ab-e9a1156a2307/3c649c9e-eb20-4873-887b-d186bdcb05b6.jpg'},{id:'98516093-278b-4da2-8f6d-7a3edd1dd1c0',name:'麥當勞點心吧',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98516093-278b-4da2-8f6d-7a3edd1dd1c0/be9d3399-b134-409d-92b2-af4a3562fd72.jpg'}]},{id:2,name:'咖啡茶飲',items:[{id:'1bc0a8de-0071-4e6c-aa9e-38b9386b5366',name:'50嵐',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc0a8de-0071-4e6c-aa9e-38b9386b5366/671fb07f-0f0f-4745-94f5-7ebd73d8f56d.jpg'},{id:'fc2cc3db-156e-4426-8677-de0fdfd5bc84',name:'85度C',image:'https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc2cc3db-156e-4426-8677-de0fdfd5bc84/cefc4f9d-29a0-433c-8f5e-9fa48e0882fa.jpg'}]}],citys:[{id:1,name:'臺北市',children:[{id:1,name:'中正區',zip:'100'},{id:2,name:'大同區',zip:'103'},{id:3,name:'中山區',zip:'104'},{id:4,name:'松山區',zip:'105'},{id:5,name:'大安區',zip:'106'},{id:6,name:'萬華區',zip:'108'},{id:7,name:'信義區',zip:'110'},{id:8,name:'士林區',zip:'111'},{id:9,name:'北投區',zip:'112'},{id:10,name:'內湖區',zip:'114'},{id:11,name:'南港區',zip:'115'},{id:12,name:'文山區',zip:'116'}]}]}});

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({listInfo:{current:1,//目前頁數
page_size:10,//一頁幾筆
total:5,//以此query條件，總共幾筆資料
rows:[{address:'台北中山區中山西路236號',// 以下同/api/mgt/v1/stores/{id}的資料
id:'8268a2a7-a1e7-43d0-a718-a67e5a6f2eca','24h':true,name:'鳳山店',is_favorite:true,en_name:'FS Store',icon:'/images/ceccontext/store/default/FS.jpg',localizable:true,code:'FS',sn:'01E',store_area_id:'a5fd7183-0ad2-4b28-8bfc-2f91c80125d5',store_area_name:'高屏地區',store_group_id:'49dd9336-8c85-48e7-8038-a87e8edd8dcd',store_type_id:'a89f5233-021c-4853-ac4e-9ebb79972ea2',fb:'https://www.facebook.com/pages/%E5%AE%B6%E6%A8%82%E7%A6%8F-%E9%B3%B3%E5%B1%B1%E5%BA%97/146596082071518',line:'@xat.0000191799.eey',contact_name:'服務中心',contact_tel:'(07)740-1789',contact_fax:'(07)740-1677',business_hours:'週一 : 08:30-23:00\n週二 : 08:30-23:00\n週三 : 08:30-23:00\n週四 : 08:30-23:00\n週五 : 08:30-24:00\n週六 : 08:30-24:00\n週日 : 08:30-23:00',business_hours_special:'重大節慶之營業時間調整，請以店內公告為準',en_business_hours_special:"For business hours on major festivals,please refer to the shops' announcements",parking_info:'停車收費方式:【車牌辨識系統啟用停車收費公告】\n/美食街商店街當日消費發票不限金額免費停車2小時。\n\n一、一般停車優惠\n/美食商店街當日消費累計:\n滿200元，可加停1小時;滿400元，可加停2小時(以此類推，當日消費最高折抵6小時)。\n\n二、刷聯名卡消費停車優惠\n1.使用玉山聯名卡:\n/美食商店街當日消費發票「不限金額」抵3小時。\n2.使用VIP卡:\n/美食商店街當日消費發票「不限金額」抵6小時。\n\n三、若無消費，入場前1小時免費，超過1小時每小時收費30元;繳費後請於30分鐘內離場，逾時請重新驗票繳費。',parking_spaces_moto:300,// 機車車位數
parking_spaces_car:280,// 汽車車位數
parking_spaces_handicapped:7,// 殘障車位數
parking_spaces_parent:7,// 親子車位數
bus_info:'公車資訊:可搭乘以下公車：\n光復路路線「婦幼站」：248路，高雄客運\n澄清路路線「縣府站」：70路，30路長庚專車，高雄客運\n中山西路路線「省中站」：248路，國光客運，高雄客運',city_id:1,city_name:'台北',area_id:100,area_name:'中山區',zip:100,street:'中山西路236號',longitude:120.347885,latitude:22.6280975,images:['http://..../xxx/abc.mgp','http://..../xxx/abc.mgp'],service_ids:['01040e9f-300a-48d4-980d-5f527b1f447b','175716ad-195e-4f7b-97de-500484f93bca'],brand_ids:['c98916d0-ca80-4129-9809-97cd0e6d8c97','74154e47-c5d7-4564-b961-fa32e523d128'],created_at:'2016-09-29 18:13:50',cpdated_at:'2020-03-04 14:54:09',deleted_at:null,modified_user:{id:1,name:'雷固',email:'aleiku@gmail.com'}}]}});

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CopyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
exports.default = CopyOutlined;


/***/ }),
/* 1686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useMergedState__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(60);







var Switch = __WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function (_ref, ref) {
  var _classNames;

  var _ref$prefixCls = _ref.prefixCls,
      prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls,
      className = _ref.className,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      loadingIcon = _ref.loadingIcon,
      checkedChildren = _ref.checkedChildren,
      unCheckedChildren = _ref.unCheckedChildren,
      onClick = _ref.onClick,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"]);

  var _useMergedState = Object(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_hooks_useMergedState__["a" /* default */])(false, {
    value: checked,
    defaultValue: defaultChecked
  }),
      _useMergedState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useMergedState, 2),
      innerChecked = _useMergedState2[0],
      setInnerChecked = _useMergedState2[1];

  function triggerChange(newChecked, event) {
    var mergedChecked = innerChecked;

    if (!disabled) {
      mergedChecked = newChecked;
      setInnerChecked(mergedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
    }

    return mergedChecked;
  }

  function onInternalKeyDown(e) {
    if (e.which === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].LEFT) {
      triggerChange(false, e);
    } else if (e.which === __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
      triggerChange(true, e);
    }

    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }

  function onInternalClick(e) {
    var ret = triggerChange(!innerChecked, e); // [Legacy] trigger onClick with value

    onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
  }

  var switchClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls, className, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-checked"), innerChecked), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("button", Object.assign({}, restProps, {
    type: "button",
    role: "switch",
    "aria-checked": innerChecked,
    disabled: disabled,
    className: switchClassName,
    ref: ref,
    onKeyDown: onInternalKeyDown,
    onClick: onInternalClick
  }), loadingIcon, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    className: "".concat(prefixCls, "-inner")
  }, innerChecked ? checkedChildren : unCheckedChildren));
});
Switch.displayName = 'Switch';
/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1689);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1690);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(742);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1696);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1695);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1698);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _PlusCircleOutlined = _interopRequireDefault(__webpack_require__(1700));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _PlusCircleOutlined.default
  }));
};
PlusCircleOutlined.displayName = 'PlusCircleOutlined';
var _default = /*#__PURE__*/React.forwardRef(PlusCircleOutlined);
exports.default = _default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PlusCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "plus-circle", "theme": "outlined" };
exports.default = PlusCircleOutlined;


/***/ }),
/* 1701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___3lsbn","container_1":"container_1___3G61G","container_2":"container_2___1kqOt"};

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_PictureOutlined__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_PictureOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_PictureOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_QuestionCircleOutlined__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_QuestionCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_QuestionCircleOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_immutability_helper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__styles_module_scss__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__styles_module_scss__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var devNewsInfo={name:"最新消息名稱",type:1,desc:"內容",sort:99,logo:null,pdfs:[],images:[]};function ImageSize(category){//大Banner
if(category==50)return"建議尺寸: 1440 x 640";//中Banner
else if(category==53)return"建議尺寸: 1200 x 600";//美食購物, 品牌列表 Banner
else if(category==54||category==110)return"建議尺寸: 1080 x 400";//活動消息
else return"封面建議尺寸: 1200 x 600 (2:1) ; 內頁建議尺寸: 最小寬度1080以上即可";}var NewsInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_44_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_45_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(NewsInfo,_Component);function NewsInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsInfo.__proto__||Object.getPrototypeOf(NewsInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_42_react___default.a.createRef(),_this.state={newsInfo:{id:null,status:1,name:null,logo:null,type:1,action_type:0,category_id:null,is_middle_banner:0,app_status:1},data:[],messages:{},isFetchData:false,isSubmitData:false,cate:null,cateName:null,brandList:[],selectState:false,selbrandList:[]},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.cloneDeep(devNewsInfo);if(!_this.formRef.current)return;data.show_range0=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"show_at")?__WEBPACK_IMPORTED_MODULE_49_moment___default()(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"show_at")):null;data.show_range1=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"hide_at")?__WEBPACK_IMPORTED_MODULE_49_moment___default()(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"hide_at")):null;data.date_range=[__WEBPACK_IMPORTED_MODULE_49_moment___default()(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"start_date")),__WEBPACK_IMPORTED_MODULE_49_moment___default()(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(data,"end_date"))];if(!__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isBoolean(data.status)){data.status=data.status===1;}if(!__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isBoolean(data.app_status)){data.app_status=data.app_status===1;}if(!__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isBoolean(data.is_middle_banner)){data.is_middle_banner=data.is_middle_banner===1;}data.images.forEach(function(item,idx){if(item.path==null||item.url==null){data.images.splice(idx,1);}});_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(_this,"props.match.params.id");if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_53_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_56_configs_env__["b" /* API_HOST */]+("/api/mgt/v1/news/"+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?"發生錯誤":_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.warning(reason);_this.props.history.replace("/news");return;}_this.fillData(data);});},_this.fetchBrands=function(){__WEBPACK_IMPORTED_MODULE_53_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_56_configs_env__["b" /* API_HOST */]+"/api/mgt/v1/brands",{per_page:10000,status:1},function(state,res){var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?"發生錯誤":_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return _this.setState({message:"發生錯誤"});}if(code!==200){return _this.setState({message:reason});}_this.setState({brandList:data.rows});});},_this.submitData=function(){var newsInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};console.log("submitData start",newsInfo);if(_this.getFieldValue("category_id")===131){newsInfo.action_type=0;newsInfo.type=0;newsInfo.app_status=false;}// 把Control元件轉換回上傳資料
newsInfo.cover=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"cover.path");newsInfo.show_at=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"show_range0")?__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"show_range0").format("YYYY-MM-DD HH:mm:ss"):"";newsInfo.hide_at=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"show_range1")?__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"show_range1").format("YYYY-MM-DD HH:mm:ss"):"";newsInfo.start_date=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"date_range.0").format("YYYY-MM-DD");newsInfo.end_date=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"date_range.1").format("YYYY-MM-DD");newsInfo.category_id=_this.getFieldValue("category_id");if(_this.getFieldValue("category_id")===53){newsInfo.is_middle_banner=1;}var current_user=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(window,"VC_CONFIG.WP_CURRENT_USER","");newsInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(_this,"props.match.params.id","");_this.setState({isSubmitData:true,messages:{}});console.log("submitData end",newsInfo);__WEBPACK_IMPORTED_MODULE_53_libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_56_configs_env__["b" /* API_HOST */]+("/api/mgt/v1/news/"+id),newsInfo,function(state,res){_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?"發生錯誤":_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.error("發生錯誤");}if(code!==200){__WEBPACK_IMPORTED_MODULE_39_antd_lib_notification___default.a["error"]({message:"更新失敗",description:reason});var messages=data.messages;if(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isObject(messages)){//處理錯誤訊息
__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.map(messages,function(errors,key){console.log("map",key,errors);return{touched:true,validating:false,errors:[],name:[key],value:_this.getFieldValue(key)};});_this.forceUpdate();}return _this.setState({messages:data.messages||{}});}var _res$data4=res.data;_res$data4=_res$data4===undefined?{}:_res$data4;var new_id=_res$data4.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.success("新增成功");_this.fillData(data);_this.linkInsert();}else{__WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.success("更新成功");_this.fillData(data);_this.linkInsert();}});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_53_libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_56_configs_env__["b" /* API_HOST */]+("/api/mgt/v1/news/"+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?"發生錯誤":_res$reason4,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.error("發生錯誤");}if(code!==200){return __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.success("刪除成功");_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_53_libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_56_configs_env__["b" /* API_HOST */]+("/api/mgt/v1/news/"+item.id+"/clone"),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?"發生錯誤":_res$reason5,_res$data6=res.data,data=_res$data6===undefined?{}:_res$data6;if(state===false){return __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.error("發生錯誤");}if(code!==200){return __WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_41_antd_lib_message___default.a.success("複製成功");if(!__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isNil(data.id))_this.props.history.push("/news/view/"+data.id);});},_this.getImages=function(){return _this.formRef.current&&__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isArray(_this.formRef.current.getFieldValue("images"))?_this.formRef.current.getFieldValue("images"):[];},_this.moveRow=function(dragIndex,hoverIndex){var _this$state=_this.state,_this$state$table_dat=_this$state.table_data,table_data=_this$state$table_dat===undefined?{}:_this$state$table_dat,_this$state$table_dat2=_this$state.table_data;_this$state$table_dat2=_this$state$table_dat2===undefined?{}:_this$state$table_dat2;var _this$state$table_dat3=_this$state$table_dat2.rows,rows=_this$state$table_dat3===undefined?[]:_this$state$table_dat3;var images=_this.getImages();var dragRow=images[dragIndex];images=__WEBPACK_IMPORTED_MODULE_46_immutability_helper___default()(images,{$splice:[[dragIndex,1],[hoverIndex,0,dragRow]]});_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:["images"],value:images}]);},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.openPost=function(e){e.preventDefault();var newsInfo=_this.formRef.current.getFieldValue();window.formRef=_this.formRef;window.newsInfo=newsInfo;window.Post=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(window,"wp.api.models.Post");var Post=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(window,"wp.api.models.Post");var post_id=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"post_id");console.log("newsInfo",newsInfo);console.log("post_id",__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isNil(post_id),post_id);var WP_ADMIN_URL=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(window,"VC_CONFIG.WP_ADMIN_URL");if(post_id&&post_id>0){window.open(WP_ADMIN_URL+("post.php?post="+post_id+"&action=edit"));return;}_this.setState({isOpeningPost:true});var post=new Post({title:__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(newsInfo,"name")});post.save().done(function(){_this.setState({isOpeningPost:false});console.log("post",post);console.log(WP_ADMIN_URL+("post.php?post="+post.id+"&action=edit"));window.open(WP_ADMIN_URL+("post.php?post="+post.id+"&action=edit"));newsInfo.post_id=post.id;_this.submitData(newsInfo);});},_this.previewNewsList=function(){var id=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(_this,"props.match.params.id");var INDEX_URL=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(window,"VC_CONFIG.INDEX_URL");var category_name=_this.getFieldValue("category_name");// 若為聯名卡活動，前方加上 uniopen
if(category_name==="聯名卡活動"){category_name="uniopen"+category_name;}if(id&&id>0){window.open(INDEX_URL+("/news-preview/?previewid="+id+"&cname="+category_name+"&mode=6"));return;}},_this.enterNotSubmit=function(e){if(e.key==="Enter"){var value=e.target+"";if(value.indexOf("TextArea")!==-1){console.log("TextArea");}else e.preventDefault();}},_this.linkInsert=function(){var category_id=__WEBPACK_IMPORTED_MODULE_54_libs_AppHelper__["a" /* default */].getLocalStorage("category_ids");if(category_id==="undefined"||category_id===undefined){console.log("category_id = undefined!");return _this.props.history.replace("/news/");}else{__WEBPACK_IMPORTED_MODULE_54_libs_AppHelper__["a" /* default */].removeLocalStorage("category_ids");return _this.props.history.replace("/news?category_id="+category_id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsInfo,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_54_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();this.fillData();this.fetchBrands();}//預覽最新消息列表
// 將儲存的 category_ids 參數丟到網址列上
},{key:"render",value:function render(){var _this2=this;var _state=this.state,brandList=_state.brandList,selectState=_state.selectState,selbrandList=_state.selbrandList;// 登入使用者的權限
var errors=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(this,"state.validator.errors",new __WEBPACK_IMPORTED_MODULE_48_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(this,"props.app.options",{});var id=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(this,"props.match.params.id");var category_id=this.getFieldValue("category_id");window.getFieldValue=this.getFieldValue;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_57__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_43_react_router_dom__["b" /* Link */],{to:"/news"},"\u6D88\u606F\u8CC7\u8A0A\u7BA1\u7406")),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_breadcrumb___default.a.Item,null,"\u6D88\u606F\u8CC7\u8A0A")),wp.element.createElement("h2",null,"\u6D88\u606F\u8CC7\u8A0A",wp.element.createElement("span",null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_52_components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement("div",{className:"block search"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a,{ref:this.formRef,name:"basic",className:"basicForm",layout:"vertical",onFinish:function onFinish(values){return _this2.submitData(values);},onKeyDown:function onKeyDown(e){return _this2.enterNotSubmit(e);},onValuesChange:function onValuesChange(changedFields,allFields){_this2.setState({cate:_this2.getFieldValue("category_id"),cateName:_this2.getFieldValue("category_name")});var type=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(changedFields,"type");if(_this2.getFieldValue("youtube")&&_this2.getFieldValue("category_id")!==50&&category_id!==122){_this2.formRef.current.setFields([{name:["youtube"],value:null,touched:true,validating:false,errors:[]}]);}if(!__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.isNil(type)){if(type===0){_this2.formRef.current.setFields([{name:["store_id"],value:null,touched:true,validating:false,errors:[]},{name:["brand_ids"],value:null,touched:true,validating:false,errors:[]}]);}if(type===1){_this2.formRef.current.setFields([{name:["brand_ids"],value:null,touched:true,validating:false,errors:[]}]);}if(type===2){_this2.formRef.current.setFields([{name:["store_id"],value:null,touched:true,validating:false,errors:[]}]);}}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{style:{textAlign:"right"},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default.a,{type:"primary",htmlType:"submit",style:{marginLeft:8},loading:this.state.isSubmitData},"\u5132\u5B58"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default.a,{type:"primary",style:{marginLeft:8},disabled:id==undefined||!(category_id==42||category_id==43||category_id==44),onClick:this.previewNewsList},"\u9810\u89BD\u5217\u8868")),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("name","名稱"),{rules:[{required:true,message:"請填寫名稱"}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default.a,{defaultValue:"\u6700\u65B0\u6D88\u606F\u540D\u7A31"})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("sort","排序"),{rules:[{required:true,message:"請填寫排序"}],extra:"\u6578\u5B57\u6700\u5C0F\u8005\u6392\u5728\u524D\u9762"}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_number___default.a,{style:{width:"100%"},min:0,max:99,defaultValue:99})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("status","狀態","checked"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_switch___default.a,{checkedChildren:"\u555F\u7528",unCheckedChildren:"\u505C\u7528"}))),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("show_range0","系統上架時間"),{extra:"\u7CFB\u7D71\u65BC\u8A72\u6642\u6BB5\u986F\u793A\u65BC\u5B98\u7DB2\uFF0C\u6CE8\u610F\u72C0\u614B\u9700\u70BA\u300C\u555F\u7528\u300D\u3002"}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker___default.a,{showTime:{defaultValue:__WEBPACK_IMPORTED_MODULE_49_moment___default()("09:00:00","HH:mm:ss"),format:"HH:mm"},format:"YYYY-MM-DD HH:mm"})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("show_range1","系統下架時間"),{extra:"\u7CFB\u7D71\u65BC\u8A72\u6642\u6BB5\u986F\u793A\u65BC\u5B98\u7DB2\uFF0C\u6CE8\u610F\u72C0\u614B\u9700\u70BA\u300C\u555F\u7528\u300D\u3002"}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker___default.a,{showTime:{defaultValue:__WEBPACK_IMPORTED_MODULE_49_moment___default()("23:59:59","HH:mm:ss"),format:"HH:mm"},format:"YYYY-MM-DD HH:mm"})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("date_range","活動日期"),{rules:[{required:true,message:"請填寫促銷活動日期"}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_date_picker___default.a.RangePicker,null))),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{name:"category_id",label:"\u6D88\u606F\u985E\u5225",rules:[{required:true,message:"請選擇消息類別"}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a,{showSearch:true,disabled:id!==undefined,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;},onSelect:function onSelect(id){if(id===131){_this2.formRef.current.setFields([{name:["ig"],value:null}]);}}},__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(options,"news_categories",[]),function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option,{key:item.id,value:item.id},item.name);})))),[131].includes(category_id)&&wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{name:"ig",label:"IG \u5167\u5D4C\u7A0B\u5F0F\u78BC",rules:[{required:true,message:"必填"}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default.a.TextArea,{rows:10}))),category_id!==131&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_42_react___default.a.Fragment,null,wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("is_middle_banner","中版位設定","checked"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_switch___default.a,{checkedChildren:"\u555F\u7528",unCheckedChildren:"\u505C\u7528"})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("app_status","APP最新消息","checked"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_switch___default.a,{disabled:category_id!==42&&category_id!==43&&category_id!==44&&category_id!==120,checkedChildren:"\u555F\u7528",unCheckedChildren:"\u505C\u7528"}))),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{name:"action_type",label:"\u9EDE\u64CA\u52D5\u4F5C",rules:[{required:true,message:"請選擇點擊動作"}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a,{value:0},"\u4E0D\u52D5\u4F5C"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a,{value:1},"\u958B\u555F\u9801\u9762"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a,{value:2},"\u958B\u555F\u9023\u7D50"))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{shouldUpdate:true,noStyle:true},function(){if(!_this2.formRef.current)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_42_react__["Fragment"],null);var action_type=_this2.formRef.current.getFieldValue("action_type");if(action_type==1){return wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("post_id","頁面編號"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_input_number___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{label:"\u7DE8\u8F2F\u9801\u9762"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default.a,{type:"primary",loading:_this2.state.isOpeningPost,onClick:_this2.openPost},"\u958B\u555F\u9801\u9762\u7DE8\u8F2F\u5668")));}if(action_type==2){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("link","開啟連結"),{rules:[{type:"url",message:"請填寫正確連結"}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default.a,null));}})),[129,130].includes(category_id)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_42_react__["Fragment"],null,wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{name:"type",label:"\u6D88\u606F\u9069\u7528\u7BC4\u570D",rules:[{required:true,message:"請選擇消息適用範圍"}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a,{value:0},"\u5168\u7AD9"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_radio___default.a,{value:2},"\u54C1\u724C\u5C08\u5C6C")))),wp.element.createElement("div",null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{shouldUpdate:true,noStyle:true},function(){if(!_this2.formRef.current)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_42_react__["Fragment"],null);var type=_this2.formRef.current.getFieldValue("type");// 2: 品牌
if(type===2){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{name:"brand_ids",label:"\u9069\u7528\u54C1\u724C"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a,{mode:"multiple",showSearch:true,allowClear:true,filterOption:function filterOption(input,option){return option.children.toUpperCase().includes(input.toUpperCase());},dropdownRender:function dropdownRender(menu){return wp.element.createElement("div",null,menu,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_divider___default.a,{style:{margin:"2px 0"}}),wp.element.createElement("div",{style:{padding:"4px 8px 8px 8px",cursor:"pointer"}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_checkbox___default.a,{checked:selectState,onChange:function onChange(e){if(e.target.checked===true){_this2.setState({selectState:true});_this2.formRef.current.setFields([{name:["brand_ids"],value:brandList.map(function(brand){return brand.id;}),touched:true,validating:false,errors:[]}]);}else{_this2.setState({selectState:false});_this2.formRef.current.setFields([{name:["brand_ids"],value:[],touched:true,validating:false,errors:[]}]);}}},"\u5168\u9078")));}},brandList.map(function(brand){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_select___default.a.Option,{key:brand.id,value:brand.id},brand.name);})));}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("youtube","Youtube連結"),{rules:[{type:"url",message:"請填寫正確連結"}],extra:wp.element.createElement("a",{href:"https://support.google.com/youtube/answer/57741?hl=zh-Hant&co=GENIE.Platform=Desktop",target:"_blank",rel:"noopener noreferrer"},"\u8907\u88FDYoutube\u9023\u7D50 ",wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_QuestionCircleOutlined___default.a,null))}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default.a,{disabled:this.getFieldValue("category_id")!==50&&category_id!==122,placeholder:"\u50C5\u4F9B \u6D88\u606F\u985E\u5225: \u9996\u9801\u5927\u7248\u4F4DBanner\u53CA\u6D3B\u52D5\u5F71\u7247 \u4F7F\u7528"})),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("desc","消息資訊說明"),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_input___default.a.TextArea,{defaultValue:"\u5167\u5BB9",rows:3}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_divider___default.a,null,"\u6D88\u606F\u5716\u7247"),wp.element.createElement("span",null,"\u6B64\u5340\u584A\u64CD\u4F5C\u5F8C\u9084\u9700\u6309\u4E0B\u4E0A\u65B9\u7684\u300C\u5132\u5B58\u300D\u8CC7\u6599\u65B9\u5F97\u4FDD\u7559"),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,{label:"\u5C01\u9762",style:{minHeight:166}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.List,{name:"images"},function(){var url=__WEBPACK_IMPORTED_MODULE_47_lodash___default.a.get(_this2.getFieldValue("images"),"0.url");return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar___default.a,{shape:"square",size:538,style:{height:270,lineHeight:270},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_PictureOutlined___default.a,null),src:url});}))),wp.element.createElement("div",{className:"flexBox"},wp.element.createElement("p",null,"\u5C01\u9762\u5716\u7247\u4E0A\u50B3 "+ImageSize(this.getFieldValue("category_id")))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,null,wp.element.createElement("div",{className:"flexBox"},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])("images"," "),{valuePropName:"fileList",extra:"\u7B2C\u4E00\u5F35\u5716\u7247\u70BA\u5C01\u9762"}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_50_components_WUpload_WUpload__["b" /* default */],{multiple:true,showUploadList:false},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined___default.a,null)," \u4E0A\u50B3")))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_33_antd_lib_form___default.a.List,{name:"images"},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;return wp.element.createElement("div",null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:_this2.getFieldValue("images"),loading:_this2.state.isLoadingData,pagination:false,rowKey:"id",components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:"id",title:"#"},{dataIndex:"url",title:"圖片",render:function render(url,asset){return wp.element.createElement("div",{className:"tableImg",style:{backgroundImage:"url("+url+")"},alt:"avatar"});}},{dataIndex:"name",title:"名稱",render:function render(name,item){return _this2.getFieldValue("images").indexOf(item)===0?"[\u5C01\u9762] "+name:name;}},{title:"Action",dataIndex:"id",key:"tools",width:250,render:function render(id,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_51_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:"small",onConfirm:function onConfirm(){var images=_this2.getFieldValue("images");remove(images.indexOf(record));}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35_antd_lib_button___default.a,{type:"default",size:"small",icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined___default.a,null),onClick:function onClick(){return _this2.setState({previewImage:{url:record.url}});}},"\u6AA2\u8996")],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));}))))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement("img",{alt:"Preview",style:{width:"100%"},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return NewsInfo;}(__WEBPACK_IMPORTED_MODULE_42_react__["Component"]))||_class);/* DnD */var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:"render",value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,["isOver","connectDragSource","connectDropTarget","moveRow"]);var style=Object.assign({},restProps.style,{cursor:"move"});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=" drop-over-downward";}if(restProps.index<dragingIndex){className+=" drop-over-upward";}}return connectDragSource(connectDropTarget(wp.element.createElement("tr",_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_42_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_44_react_dnd__["DropTarget"])("row",rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_44_react_dnd__["DragSource"])("row",rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));/* DnD */

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Title = _interopRequireDefault(__webpack_require__(1705));

var _Paragraph = _interopRequireDefault(__webpack_require__(1706));

var _configProvider = __webpack_require__(8);

var _Element = _interopRequireDefault(__webpack_require__(299));

var _Avatar = _interopRequireDefault(__webpack_require__(1707));

var _Button = _interopRequireDefault(__webpack_require__(1708));

var _Input = _interopRequireDefault(__webpack_require__(1709));

var _Image = _interopRequireDefault(__webpack_require__(1710));

function getComponentProps(prop) {
  if (prop && (0, _typeof2["default"])(prop) === 'object') {
    return prop;
  }

  return {};
}

function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    // Square avatar
    return {
      size: 'large',
      shape: 'square'
    };
  }

  return {
    size: 'large',
    shape: 'circle'
  };
}

function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: '38%'
    };
  }

  if (hasAvatar && hasParagraph) {
    return {
      width: '50%'
    };
  }

  return {};
}

function getParagraphBasicProps(hasAvatar, hasTitle) {
  var basicProps = {}; // Width

  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  } // Rows


  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }

  return basicProps;
}

var Skeleton = function Skeleton(props) {
  var renderSkeleton = function renderSkeleton(_ref) {
    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;
    var customizePrefixCls = props.prefixCls,
        loading = props.loading,
        className = props.className,
        children = props.children,
        avatar = props.avatar,
        title = props.title,
        paragraph = props.paragraph,
        active = props.active,
        round = props.round;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);

    if (loading || !('loading' in props)) {
      var _classNames;

      var hasAvatar = !!avatar;
      var hasTitle = !!title;
      var hasParagraph = !!paragraph; // Avatar

      var avatarNode;

      if (hasAvatar) {
        var avatarProps = (0, _extends2["default"])((0, _extends2["default"])({
          prefixCls: "".concat(prefixCls, "-avatar")
        }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar)); // We direct use SkeletonElement as avatar in skeleton internal.

        avatarNode = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-header")
        }, /*#__PURE__*/React.createElement(_Element["default"], avatarProps));
      }

      var contentNode;

      if (hasTitle || hasParagraph) {
        // Title
        var $title;

        if (hasTitle) {
          var titleProps = (0, _extends2["default"])((0, _extends2["default"])({
            prefixCls: "".concat(prefixCls, "-title")
          }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
          $title = /*#__PURE__*/React.createElement(_Title["default"], titleProps);
        } // Paragraph


        var paragraphNode;

        if (hasParagraph) {
          var paragraphProps = (0, _extends2["default"])((0, _extends2["default"])({
            prefixCls: "".concat(prefixCls, "-paragraph")
          }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
          paragraphNode = /*#__PURE__*/React.createElement(_Paragraph["default"], paragraphProps);
        }

        contentNode = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-content")
        }, $title, paragraphNode);
      }

      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-active"), active), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-round"), round), _classNames), className);
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, avatarNode, contentNode);
    }

    return children;
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderSkeleton);
};

Skeleton.defaultProps = {
  avatar: false,
  title: true,
  paragraph: true
};
Skeleton.Button = _Button["default"];
Skeleton.Avatar = _Avatar["default"];
Skeleton.Input = _Input["default"];
Skeleton.Image = _Image["default"];
var _default = Skeleton;
exports["default"] = _default;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

/* eslint-disable jsx-a11y/heading-has-content */
var Title = function Title(_ref) {
  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      width = _ref.width,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("h3", {
    className: (0, _classnames["default"])(prefixCls, className),
    style: (0, _extends2["default"])({
      width: width
    }, style)
  });
};

var _default = Title;
exports["default"] = _default;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var Paragraph = function Paragraph(props) {
  var getWidth = function getWidth(index) {
    var width = props.width,
        _props$rows = props.rows,
        rows = _props$rows === void 0 ? 2 : _props$rows;

    if (Array.isArray(width)) {
      return width[index];
    } // last paragraph


    if (rows - 1 === index) {
      return width;
    }

    return undefined;
  };

  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      rows = props.rows;
  var rowList = (0, _toConsumableArray2["default"])(Array(rows)).map(function (_, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        key: index,
        style: {
          width: getWidth(index)
        }
      })
    );
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: (0, _classnames["default"])(prefixCls, className),
    style: style
  }, rowList);
};

var _default = Paragraph;
exports["default"] = _default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var _Element = _interopRequireDefault(__webpack_require__(299));

var SkeletonAvatar = function SkeletonAvatar(props) {
  var renderSkeletonAvatar = function renderSkeletonAvatar(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, _omit["default"])(props, ['prefixCls']);
    var cls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-element"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(_Element["default"], (0, _extends2["default"])({
      prefixCls: "".concat(prefixCls, "-avatar")
    }, otherProps)));
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderSkeletonAvatar);
};

SkeletonAvatar.defaultProps = {
  size: 'default',
  shape: 'circle'
};
var _default = SkeletonAvatar;
exports["default"] = _default;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Element = _interopRequireDefault(__webpack_require__(299));

var _configProvider = __webpack_require__(8);

var SkeletonButton = function SkeletonButton(props) {
  var renderSkeletonButton = function renderSkeletonButton(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, _omit["default"])(props, ['prefixCls']);
    var cls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-element"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(_Element["default"], (0, _extends2["default"])({
      prefixCls: "".concat(prefixCls, "-button")
    }, otherProps)));
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderSkeletonButton);
};

SkeletonButton.defaultProps = {
  size: 'default'
};
var _default = SkeletonButton;
exports["default"] = _default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _Element = _interopRequireDefault(__webpack_require__(299));

var _configProvider = __webpack_require__(8);

var SkeletonInput = function SkeletonInput(props) {
  var renderSkeletonInput = function renderSkeletonInput(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, _omit["default"])(props, ['prefixCls']);
    var cls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-element"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(_Element["default"], (0, _extends2["default"])({
      prefixCls: "".concat(prefixCls, "-input")
    }, otherProps)));
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderSkeletonInput);
};

SkeletonInput.defaultProps = {
  size: 'default'
};
var _default = SkeletonInput;
exports["default"] = _default;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

var _interopRequireWildcard = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';

var SkeletonImage = function SkeletonImage(props) {
  var renderSkeletonImage = function renderSkeletonImage(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        style = props.style;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-element"), className);
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-image"), className),
      style: style
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 1098 1024",
      xmlns: "http://www.w3.org/2000/svg",
      className: "".concat(prefixCls, "-image-svg")
    }, /*#__PURE__*/React.createElement("path", {
      d: path,
      className: "".concat(prefixCls, "-image-path")
    }))));
  };

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, renderSkeletonImage);
};

var _default = SkeletonImage;
exports["default"] = _default;

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogWrap__ = __webpack_require__(1713);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__DialogWrap__["a" /* default */]);

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dialog__ = __webpack_require__(1727);




 // fix issue #10656

/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */

var DialogWrap = function DialogWrap(props) {
  var visible = props.visible,
      getContainer = props.getContainer,
      forceRender = props.forceRender,
      _props$destroyOnClose = props.destroyOnClose,
      destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose,
      _afterClose = props.afterClose;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](visible),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      animatedVisible = _React$useState2[0],
      setAnimatedVisible = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]); // 渲染在当前 dom 里；

  if (getContainer === false) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Dialog__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      getOpenCount: function getOpenCount() {
        return 2;
      } // 不对 body 做任何操作。。

    }));
  } // Destroy on close will remove wrapped div


  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_util_es_PortalWrapper__["a" /* default */], {
    visible: visible,
    forceRender: forceRender,
    getContainer: getContainer
  }, function (childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Dialog__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      destroyOnClose: destroyOnClose,
      afterClose: function afterClose() {
        _afterClose === null || _afterClose === void 0 ? void 0 : _afterClose();
        setAnimatedVisible(false);
      }
    }, childProps));
  });
};

DialogWrap.displayName = 'Dialog';
/* harmony default export */ __webpack_exports__["a"] = (DialogWrap);

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1717);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1720);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1724);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(746);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setStyle__ = __webpack_require__(414);


function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle = {};
/* harmony default export */ __webpack_exports__["a"] = (function (close) {
  if (!isBodyOverflowing() && !close) {
    return;
  }

  // https://github.com/ant-design/ant-design/issues/19729
  var scrollingEffectClassName = 'ant-scrolling-effect';
  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
  var bodyClassName = document.body.className;
  if (close) {
    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
    Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])(cacheStyle);
    cacheStyle = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
    return;
  }
  var scrollBarSize = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollBarSize__["a" /* default */])();
  if (scrollBarSize) {
    cacheStyle = Object(__WEBPACK_IMPORTED_MODULE_1__setStyle__["a" /* default */])({
      position: 'relative',
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });
    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
      document.body.className = addClassName.trim();
    }
  }
});

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollLocker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getScrollBarSize__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setStyle__ = __webpack_require__(414);






var uuid = 0;
var locks = [];
var scrollingEffectClassName = 'ant-scrolling-effect';
var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');

// https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332
var cacheStyle = new Map();
var ScrollLocker = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(function ScrollLocker(_options) {
  var _this = this;
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollLocker);
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "lockTarget", void 0);
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "options", void 0);
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "getContainer", function () {
    var _this$options;
    return (_this$options = _this.options) === null || _this$options === void 0 ? void 0 : _this$options.container;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "reLock", function (options) {
    var findLock = locks.find(function (_ref) {
      var target = _ref.target;
      return target === _this.lockTarget;
    });
    if (findLock) {
      _this.unLock();
    }
    _this.options = options;
    if (findLock) {
      findLock.options = options;
      _this.lock();
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "lock", function () {
    var _this$options3;
    // If lockTarget exist return
    if (locks.some(function (_ref2) {
      var target = _ref2.target;
      return target === _this.lockTarget;
    })) {
      return;
    }

    // If same container effect, return
    if (locks.some(function (_ref3) {
      var _this$options2;
      var options = _ref3.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options2 = _this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.container);
    })) {
      locks = [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(locks), [{
        target: _this.lockTarget,
        options: _this.options
      }]);
      return;
    }
    var scrollBarSize = 0;
    var container = ((_this$options3 = _this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.container) || document.body;
    if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
      if (getComputedStyle(container).overflow !== 'hidden') {
        scrollBarSize = Object(__WEBPACK_IMPORTED_MODULE_4__getScrollBarSize__["a" /* default */])();
      }
    }
    var containerClassName = container.className;
    if (locks.filter(function (_ref4) {
      var _this$options4;
      var options = _ref4.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options4 = _this.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.container);
    }).length === 0) {
      cacheStyle.set(container, Object(__WEBPACK_IMPORTED_MODULE_5__setStyle__["a" /* default */])({
        width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : undefined,
        overflow: 'hidden',
        overflowX: 'hidden',
        overflowY: 'hidden'
      }, {
        element: container
      }));
    }

    // https://github.com/ant-design/ant-design/issues/19729
    if (!scrollingEffectClassNameReg.test(containerClassName)) {
      var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
      container.className = addClassName.trim();
    }
    locks = [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(locks), [{
      target: _this.lockTarget,
      options: _this.options
    }]);
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "unLock", function () {
    var _this$options5;
    var findLock = locks.find(function (_ref5) {
      var target = _ref5.target;
      return target === _this.lockTarget;
    });
    locks = locks.filter(function (_ref6) {
      var target = _ref6.target;
      return target !== _this.lockTarget;
    });
    if (!findLock || locks.some(function (_ref7) {
      var _findLock$options;
      var options = _ref7.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_findLock$options = findLock.options) === null || _findLock$options === void 0 ? void 0 : _findLock$options.container);
    })) {
      return;
    }

    // Remove Effect
    var container = ((_this$options5 = _this.options) === null || _this$options5 === void 0 ? void 0 : _this$options5.container) || document.body;
    var containerClassName = container.className;
    if (!scrollingEffectClassNameReg.test(containerClassName)) return;
    Object(__WEBPACK_IMPORTED_MODULE_5__setStyle__["a" /* default */])(cacheStyle.get(container), {
      element: container
    });
    cacheStyle.delete(container);
    container.className = container.className.replace(scrollingEffectClassNameReg, '').trim();
  });
  // eslint-disable-next-line no-plusplus
  this.lockTarget = uuid++;
  this.options = _options;
});


/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Dialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_Dom_contains__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Mask__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1732);











function Dialog(props) {
  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls,
      zIndex = props.zIndex,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? false : _props$visible,
      _props$keyboard = props.keyboard,
      keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
      _props$focusTriggerAf = props.focusTriggerAfterClose,
      focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
      _props$switchScrollin = props.switchScrollingEffect,
      switchScrollingEffect = _props$switchScrollin === void 0 ? function () {} : _props$switchScrollin,
      title = props.title,
      wrapStyle = props.wrapStyle,
      wrapClassName = props.wrapClassName,
      wrapProps = props.wrapProps,
      onClose = props.onClose,
      afterClose = props.afterClose,
      transitionName = props.transitionName,
      animation = props.animation,
      _props$closable = props.closable,
      closable = _props$closable === void 0 ? true : _props$closable,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? true : _props$mask,
      maskTransitionName = props.maskTransitionName,
      maskAnimation = props.maskAnimation,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
      maskStyle = props.maskStyle,
      maskProps = props.maskProps;
  var lastOutSideActiveElementRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  var wrapperRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  var contentRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](visible),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      animatedVisible = _React$useState2[0],
      setAnimatedVisible = _React$useState2[1]; // ========================== Init ==========================


  var ariaIdRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

  if (!ariaIdRef.current) {
    ariaIdRef.current = "rcDialogTitle".concat(Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* getUUID */])());
  } // ========================= Events =========================


  function onDialogVisibleChanged(newVisible) {
    if (newVisible) {
      // Try to focus
      if (!Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_Dom_contains__["a" /* default */])(wrapperRef.current, document.activeElement)) {
        var _contentRef$current;

        lastOutSideActiveElementRef.current = document.activeElement;
        (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.focus();
      }
    } else {
      // Clean up scroll bar & focus back
      setAnimatedVisible(false);
      switchScrollingEffect();

      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {// Do nothing
        }

        lastOutSideActiveElementRef.current = null;
      }

      afterClose === null || afterClose === void 0 ? void 0 : afterClose();
    }
  }

  function onInternalClose(e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  } // >>> Content


  var contentClickRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
  var contentTimeoutRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(); // We need record content click incase content popup out of dialog

  var onContentMouseDown = function onContentMouseDown() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };

  var onContentMouseUp = function onContentMouseUp() {
    contentTimeoutRef.current = setTimeout(function () {
      contentClickRef.current = false;
    });
  }; // >>> Wrapper
  // Close only when element not on dialog


  var onWrapperClick = null;

  if (maskClosable) {
    onWrapperClick = function onWrapperClick(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }

  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    } // keep focus inside dialog


    if (visible) {
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_5_rc_util_es_KeyCode__["a" /* default */].TAB) {
        contentRef.current.changeActive(!e.shiftKey);
      }
    }
  } // ========================= Effect =========================


  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (visible) {
      setAnimatedVisible(true);
      switchScrollingEffect();
    }
  }, [visible]); // Remove direct should also check the scroll bar update

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    return function () {
      switchScrollingEffect();
      clearTimeout(contentTimeoutRef.current);
    };
  }, []); // ========================= Render =========================

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-root")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Mask__["a" /* default */], {
    prefixCls: prefixCls,
    visible: mask && visible,
    motionName: Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* getMotionName */])(prefixCls, maskTransitionName, maskAnimation),
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      zIndex: zIndex
    }, maskStyle),
    maskProps: maskProps
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("".concat(prefixCls, "-wrap"), wrapClassName),
    ref: wrapperRef,
    onClick: onWrapperClick,
    role: "dialog",
    "aria-labelledby": title ? ariaIdRef.current : null,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      zIndex: zIndex
    }, wrapStyle), {}, {
      display: !animatedVisible ? 'none' : null
    })
  }, wrapProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable: closable,
    ariaId: ariaIdRef.current,
    prefixCls: prefixCls,
    visible: visible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* getMotionName */])(prefixCls, transitionName, animation)
  }))));
}

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(1729);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1730);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(747);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Mask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_motion__ = __webpack_require__(84);





function Mask(props) {
  var prefixCls = props.prefixCls,
      style = props.style,
      visible = props.visible,
      maskProps = props.maskProps,
      motionName = props.motionName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_rc_motion__["default"], {
    key: "mask",
    visible: visible,
    motionName: motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function (_ref) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle), style),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-mask"), motionClassName)
    }, maskProps));
  });
}

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_motion__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MemoChildren__ = __webpack_require__(1733);









var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  outline: 'none'
};
var Content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function (props, ref) {
  var closable = props.closable,
      prefixCls = props.prefixCls,
      width = props.width,
      height = props.height,
      footer = props.footer,
      title = props.title,
      closeIcon = props.closeIcon,
      style = props.style,
      className = props.className,
      visible = props.visible,
      forceRender = props.forceRender,
      bodyStyle = props.bodyStyle,
      bodyProps = props.bodyProps,
      children = props.children,
      destroyOnClose = props.destroyOnClose,
      modalRender = props.modalRender,
      motionName = props.motionName,
      ariaId = props.ariaId,
      onClose = props.onClose,
      onVisibleChanged = props.onVisibleChanged,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      mousePosition = props.mousePosition;
  var sentinelStartRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  var sentinelEndRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  var dialogRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(); // ============================== Ref ===============================

  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;

        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 ? void 0 : _sentinelStartRef$cur.focus();
      },
      changeActive: function changeActive(next) {
        var _document = document,
            activeElement = _document.activeElement;

        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus();
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus();
        }
      }
    };
  }); // ============================= Style ==============================

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](),
      _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_React$useState, 2),
      transformOrigin = _React$useState2[0],
      setTransformOrigin = _React$useState2[1];

  var contentStyle = {};

  if (width !== undefined) {
    contentStyle.width = width;
  }

  if (height !== undefined) {
    contentStyle.height = height;
  }

  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }

  function onPrepare() {
    var elementOffset = Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* offset */])(dialogRef.current);
    setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
  } // ============================= Render =============================


  var footerNode;

  if (footer) {
    footerNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-footer")
    }, footer);
  }

  var headerNode;

  if (title) {
    headerNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-header")
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: "".concat(prefixCls, "-title"),
      id: ariaId
    }, title));
  }

  var closer;

  if (closable) {
    closer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
      className: "".concat(prefixCls, "-close-x")
    }));
  }

  var content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: "".concat(prefixCls, "-content")
  }, closer, headerNode, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, bodyProps), children), footerNode);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_rc_motion__["default"], {
    visible: visible,
    onVisibleChanged: onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender: forceRender,
    motionName: motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      key: "dialog-element",
      role: "document",
      ref: motionRef,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, motionStyle), style), contentStyle),
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls, className, motionClassName),
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      tabIndex: 0,
      ref: sentinelStartRef,
      style: sentinelStyle,
      "aria-hidden": "true"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__MemoChildren__["a" /* default */], {
      shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      tabIndex: 0,
      ref: sentinelEndRef,
      style: sentinelStyle,
      "aria-hidden": "true"
    }));
  });
});
Content.displayName = 'Content';
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
}));

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useModal;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _usePatchElement3 = _interopRequireDefault(__webpack_require__(1735));

var _HookModal = _interopRequireDefault(__webpack_require__(1736));

var _confirm = __webpack_require__(750);

var uuid = 0;
var ElementsHolder = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function (_props, ref) {
  var _usePatchElement = (0, _usePatchElement3["default"])(),
      _usePatchElement2 = (0, _slicedToArray2["default"])(_usePatchElement, 2),
      elements = _usePatchElement2[0],
      patchElement = _usePatchElement2[1];

  React.useImperativeHandle(ref, function () {
    return {
      patchElement: patchElement
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, elements);
}));

function useModal() {
  var holderRef = React.useRef(null);
  var getConfirmFunc = React.useCallback(function (withFunc) {
    return function hookConfirm(config) {
      var _a;

      uuid += 1;
      var modalRef = /*#__PURE__*/React.createRef();
      var closeFunc;
      var modal = /*#__PURE__*/React.createElement(_HookModal["default"], {
        key: "modal-".concat(uuid),
        config: withFunc(config),
        ref: modalRef,
        afterClose: function afterClose() {
          closeFunc();
        }
      });
      closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
      return {
        destroy: function destroy() {
          if (modalRef.current) {
            modalRef.current.destroy();
          }
        },
        update: function update(newConfig) {
          if (modalRef.current) {
            modalRef.current.update(newConfig);
          }
        }
      };
    };
  }, []);
  var fns = React.useMemo(function () {
    return {
      info: getConfirmFunc(_confirm.withInfo),
      success: getConfirmFunc(_confirm.withSuccess),
      error: getConfirmFunc(_confirm.withError),
      warning: getConfirmFunc(_confirm.withWarn),
      confirm: getConfirmFunc(_confirm.withConfirm)
    };
  }, []); // eslint-disable-next-line react/jsx-key

  return [fns, /*#__PURE__*/React.createElement(ElementsHolder, {
    ref: holderRef
  })];
}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePatchElement;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

function usePatchElement() {
  var _React$useState = React.useState([]),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      elements = _React$useState2[0],
      setElements = _React$useState2[1];

  var patchElement = React.useCallback(function (element) {
    // append a new element to elements (and create a new ref)
    setElements(function (originElements) {
      return [].concat((0, _toConsumableArray2["default"])(originElements), [element]);
    }); // return a function that removes the new element out of elements (and create a new ref)
    // it works a little like useEffect

    return function () {
      setElements(function (originElements) {
        return originElements.filter(function (ele) {
          return ele !== element;
        });
      });
    };
  }, []);
  return [elements, patchElement];
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ConfirmDialog = _interopRequireDefault(__webpack_require__(749));

var _default2 = _interopRequireDefault(__webpack_require__(136));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(94));

var _configProvider = __webpack_require__(8);

var HookModal = function HookModal(_ref, ref) {
  var afterClose = _ref.afterClose,
      config = _ref.config;

  var _React$useState = React.useState(true),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  var _React$useState3 = React.useState(config),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      innerConfig = _React$useState4[0],
      setInnerConfig = _React$useState4[1];

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      direction = _React$useContext.direction,
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('modal');
  var rootPrefixCls = getPrefixCls();

  function close() {
    setVisible(false);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (innerConfig.onCancel && triggerCancel) {
      innerConfig.onCancel();
    }
  }

  React.useImperativeHandle(ref, function () {
    return {
      destroy: close,
      update: function update(newConfig) {
        setInnerConfig(function (originConfig) {
          return (0, _extends2["default"])((0, _extends2["default"])({}, originConfig), newConfig);
        });
      }
    };
  });
  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Modal",
    defaultLocale: _default2["default"].Modal
  }, function (modalLocale) {
    return /*#__PURE__*/React.createElement(_ConfirmDialog["default"], (0, _extends2["default"])({
      prefixCls: prefixCls,
      rootPrefixCls: rootPrefixCls
    }, innerConfig, {
      close: close,
      visible: visible,
      afterClose: afterClose,
      okText: innerConfig.okText || (innerConfig.okCancel ? modalLocale.okText : modalLocale.justOkText),
      direction: direction,
      cancelText: innerConfig.cancelText || modalLocale.cancelText
    }));
  });
};

var _default = /*#__PURE__*/React.forwardRef(HookModal);

exports["default"] = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _button = _interopRequireDefault(__webpack_require__(26));

var _button2 = __webpack_require__(285);

var ActionButton = function ActionButton(props) {
  var clickedRef = React.useRef(false);
  var ref = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  React.useEffect(function () {
    var timeoutId;

    if (props.autoFocus) {
      var $this = ref.current;
      timeoutId = setTimeout(function () {
        return $this.focus();
      });
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  var handlePromiseOnOk = function handlePromiseOnOk(returnValueOfOnOk) {
    var closeModal = props.closeModal;

    if (!returnValueOfOnOk || !returnValueOfOnOk.then) {
      return;
    }

    setLoading(true);
    returnValueOfOnOk.then(function () {
      // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
      // setState({ loading: false });
      closeModal.apply(void 0, arguments);
    }, function (e) {
      // Emit error when catch promise reject
      // eslint-disable-next-line no-console
      console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183

      setLoading(false);
      clickedRef.current = false;
    });
  };

  var onClick = function onClick() {
    var actionFn = props.actionFn,
        closeModal = props.closeModal;

    if (clickedRef.current) {
      return;
    }

    clickedRef.current = true;

    if (!actionFn) {
      closeModal();
      return;
    }

    var returnValueOfOnOk;

    if (actionFn.length) {
      returnValueOfOnOk = actionFn(closeModal); // https://github.com/ant-design/ant-design/issues/23358

      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();

      if (!returnValueOfOnOk) {
        closeModal();
        return;
      }
    }

    handlePromiseOnOk(returnValueOfOnOk);
  };

  var type = props.type,
      children = props.children,
      prefixCls = props.prefixCls,
      buttonProps = props.buttonProps;
  return /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({}, (0, _button2.convertLegacyProps)(type), {
    onClick: onClick,
    loading: loading,
    prefixCls: prefixCls
  }, buttonProps, {
    ref: ref
  }), children);
};

var _default = ActionButton;
exports["default"] = _default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var UploadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "upload", "theme": "outlined" };
exports.default = UploadOutlined;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PictureOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, "name": "picture", "theme": "outlined" };
exports.default = PictureOutlined;


/***/ }),
/* 1740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputNumber__ = __webpack_require__(1743);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InputNumber__["a" /* default */]);

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__ = __webpack_require__(60);









/* eslint-disable react/prop-types */




function noop() {}

function preventDefault(e) {
  e.preventDefault();
}

var defaultParser = function defaultParser(input) {
  return input.replace(/[^\w.-]+/g, '');
};
/**
 * When click and hold on a button - the speed of auto changin the value.
 */


var SPEED = 200;
/**
 * When click and hold on a button - the delay before auto changin the value.
 */

var DELAY = 600;
/**
 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
 */

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var isValidProps = function isValidProps(value) {
  return value !== undefined && value !== null;
};

var isEqual = function isEqual(oldValue, newValue) {
  return newValue === oldValue || typeof newValue === 'number' && typeof oldValue === 'number' && isNaN(newValue) && isNaN(oldValue);
};

var InputNumber = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(InputNumber, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    _this.onKeyDown = function (e) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          onPressEnter = _this$props.onPressEnter;

      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].UP) {
        var ratio = _this.getRatio(e);

        _this.up(e, ratio, null);

        _this.stop();
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DOWN) {
        var _ratio = _this.getRatio(e);

        _this.down(e, _ratio, null);

        _this.stop();
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ENTER && onPressEnter) {
        onPressEnter(e);
      } // Trigger user key down


      _this.recordCursorPosition();

      _this.lastKeyCode = e.keyCode;

      if (onKeyDown) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        onKeyDown.apply(void 0, [e].concat(args));
      }
    };

    _this.onKeyUp = function (e) {
      var onKeyUp = _this.props.onKeyUp;

      _this.stop();

      _this.recordCursorPosition(); // Trigger user key up


      if (onKeyUp) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        onKeyUp.apply(void 0, [e].concat(args));
      }
    };

    _this.onChange = function (e) {
      var onChange = _this.props.onChange;

      if (_this.state.focused) {
        _this.inputting = true;
      }

      _this.rawInput = _this.props.parser(_this.getValueFromEvent(e));

      _this.setState({
        inputValue: _this.rawInput
      });

      onChange(_this.toNumber(_this.rawInput)); // valid number or invalid string
    };

    _this.onMouseUp = function () {
      var onMouseUp = _this.props.onMouseUp;

      _this.recordCursorPosition();

      if (onMouseUp) {
        onMouseUp.apply(void 0, arguments);
      }
    };

    _this.onFocus = function () {
      var _this$props2;

      _this.setState({
        focused: true
      });

      (_this$props2 = _this.props).onFocus.apply(_this$props2, arguments);
    };

    _this.onBlur = function () {
      var onBlur = _this.props.onBlur;
      _this.inputting = false;

      _this.setState({
        focused: false
      });

      var value = _this.getCurrentValidValue(_this.state.inputValue);

      var newValue = _this.setValue(value, noop);

      if (onBlur) {
        var originValue = _this.input.value;

        var displayValue = _this.getInputDisplayValue({
          focus: false,
          value: newValue
        });

        _this.input.value = displayValue;
        onBlur.apply(void 0, arguments);
        _this.input.value = originValue;
      }
    };

    _this.getRatio = function (e) {
      var ratio = 1;

      if (e.metaKey || e.ctrlKey) {
        ratio = 0.1;
      } else if (e.shiftKey) {
        ratio = 10;
      }

      return ratio;
    };

    _this.getFullNum = function (num) {
      if (isNaN(num)) {
        return num;
      }

      if (!/e/i.test(String(num))) {
        return num;
      }

      return Number(num).toFixed(18).replace(/\.?0+$/, '');
    };

    _this.getPrecision = function (value) {
      if (isValidProps(_this.props.precision)) {
        return _this.props.precision;
      }

      var valueString = String(value);

      if (valueString.indexOf('e-') >= 0) {
        return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
      }

      var precision = 0;

      if (valueString.indexOf('.') >= 0) {
        precision = valueString.length - valueString.indexOf('.') - 1;
      }

      return precision;
    };

    _this.getInputDisplayValue = function (state) {
      var _ref = state || _this.state,
          focused = _ref.focused,
          inputValue = _ref.inputValue,
          value = _ref.value;

      var inputDisplayValue;

      if (focused) {
        inputDisplayValue = inputValue;
      } else {
        inputDisplayValue = _this.toPrecisionAsStep(value);
      }

      if (inputDisplayValue === undefined || inputDisplayValue === null) {
        inputDisplayValue = '';
      }

      var inputDisplayValueFormat = _this.formatWrapper(inputDisplayValue);

      if (isValidProps(_this.props.decimalSeparator)) {
        inputDisplayValueFormat = inputDisplayValueFormat.toString().replace('.', _this.props.decimalSeparator);
      }

      return inputDisplayValueFormat;
    };

    _this.recordCursorPosition = function () {
      // Record position
      try {
        _this.cursorStart = _this.input.selectionStart;
        _this.cursorEnd = _this.input.selectionEnd;
        _this.currentValue = _this.input.value;
        _this.cursorBefore = _this.input.value.substring(0, _this.cursorStart);
        _this.cursorAfter = _this.input.value.substring(_this.cursorEnd);
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    };

    _this.restoreByAfter = function (str) {
      if (str === undefined) return false;
      var fullStr = _this.input.value;
      var index = fullStr.lastIndexOf(str);
      if (index === -1) return false;
      var prevCursorPos = _this.cursorBefore.length;

      if (_this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DELETE && _this.cursorBefore.charAt(prevCursorPos - 1) === str[0]) {
        _this.fixCaret(prevCursorPos, prevCursorPos);

        return true;
      }

      if (index + str.length === fullStr.length) {
        _this.fixCaret(index, index);

        return true;
      }

      return false;
    };

    _this.partRestoreByAfter = function (str) {
      if (str === undefined) return false; // For loop from full str to the str with last char to map. e.g. 123
      // -> 123
      // -> 23
      // -> 3

      return Array.prototype.some.call(str, function (_, start) {
        var partStr = str.substring(start);
        return _this.restoreByAfter(partStr);
      });
    }; // '1.' '1x' 'xx' '' => are not complete numbers


    _this.isNotCompleteNumber = function (num) {
      return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
    };

    _this.stop = function () {
      if (_this.autoStepTimer) {
        clearTimeout(_this.autoStepTimer);
      }
    };

    _this.down = function (e, ratio, recursive) {
      _this.pressingUpOrDown = true;

      _this.step('down', e, ratio, recursive);
    };

    _this.up = function (e, ratio, recursive) {
      _this.pressingUpOrDown = true;

      _this.step('up', e, ratio, recursive);
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var value = props.value;

    if (value === undefined) {
      value = props.defaultValue;
    }

    _this.state = {
      focused: props.autoFocus
    };

    var validValue = _this.getValidValue(_this.toNumber(value));

    _this.state = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, _this.state), {}, {
      inputValue: _this.toPrecisionAsStep(validValue),
      value: validValue
    });
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(InputNumber, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          max = _this$props3.max,
          min = _this$props3.min;
      var focused = this.state.focused; // Don't trigger in componentDidMount

      if (prevProps) {
        if (!isEqual(prevProps.value, value) || !isEqual(prevProps.max, max) || !isEqual(prevProps.min, min)) {
          var validValue = focused ? value : this.getValidValue(value);
          var nextInputValue;

          if (this.pressingUpOrDown) {
            nextInputValue = validValue;
          } else if (this.inputting) {
            nextInputValue = this.rawInput;
          } else {
            nextInputValue = this.toPrecisionAsStep(validValue);
          }

          this.setState({
            // eslint-disable-line
            value: validValue,
            inputValue: nextInputValue
          });
        } // Trigger onChange when max or min change
        // https://github.com/ant-design/ant-design/issues/11574


        var nextValue = 'value' in this.props ? value : this.state.value; // ref: null < 20 === true
        // https://github.com/ant-design/ant-design/issues/14277

        if ('max' in this.props && prevProps.max !== max && typeof nextValue === 'number' && nextValue > max && onChange) {
          onChange(max);
        }

        if ('min' in this.props && prevProps.min !== min && typeof nextValue === 'number' && nextValue < min && onChange) {
          onChange(min);
        }
      } // Restore cursor


      try {
        // Firefox set the input cursor after it get focused.
        // This caused that if an input didn't init with the selection,
        // set will cause cursor not correct when first focus.
        // Safari will focus input if set selection. We need skip this.
        if (this.cursorStart !== undefined && this.state.focused) {
          // In most cases, the string after cursor is stable.
          // We can move the cursor before it
          if ( // If not match full str, try to match part of str
          !this.partRestoreByAfter(this.cursorAfter) && this.state.value !== this.props.value) {
            // If not match any of then, let's just keep the position
            // TODO: Logic should not reach here, need check if happens
            var pos = this.getInputDisplayValue(this.state).length; // If not have last string, just position to the end

            if (!this.cursorAfter) {
              pos = this.input.value.length;
            } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
              pos = this.cursorStart - 1;
            } else if (this.lastKeyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DELETE) {
              pos = this.cursorStart;
            }

            this.fixCaret(pos, pos);
          } else if (this.currentValue === this.input.value) {
            // Handle some special key code
            switch (this.lastKeyCode) {
              case __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].BACKSPACE:
                this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
                break;

              case __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DELETE:
                this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
                break;

              default: // Do nothing

            }
          }
        }
      } catch (e) {// Do nothing
      } // Reset last key


      this.lastKeyCode = null; // pressingUpOrDown is true means that someone just click up or down button

      if (!this.pressingUpOrDown) {
        return;
      }

      if (this.props.focusOnUpDown && this.state.focused) {
        if (document.activeElement !== this.input) {
          this.focus();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "getCurrentValidValue",
    value: function getCurrentValidValue(value) {
      var val = value;

      if (val === '') {
        val = '';
      } else if (!this.isNotCompleteNumber(parseFloat(val))) {
        val = this.getValidValue(val);
      } else {
        val = this.state.value;
      }

      return this.toNumber(val);
    }
  }, {
    key: "getValueFromEvent",
    value: function getValueFromEvent(e) {
      // optimize for chinese input expierence
      // https://github.com/ant-design/ant-design/issues/8196
      var value = e.target.value.trim().replace(/。/g, '.');

      if (isValidProps(this.props.decimalSeparator)) {
        value = value.replace(this.props.decimalSeparator, '.');
      }

      return value;
    }
  }, {
    key: "getValidValue",
    value: function getValidValue(value) {
      var _this$props4 = this.props,
          min = _this$props4.min,
          max = _this$props4.max;
      var val = parseFloat(value); // https://github.com/ant-design/ant-design/issues/7358

      if (isNaN(val)) {
        return value;
      }

      if (val < min) {
        val = min;
      }

      if (val > max) {
        val = max;
      }

      return val;
    }
  }, {
    key: "setValue",
    value: function setValue(v, callback) {
      // trigger onChange
      var precision = this.props.precision;
      var newValue = this.isNotCompleteNumber(parseFloat(v)) ? null : parseFloat(v);
      var _this$state$value = this.state.value,
          value = _this$state$value === void 0 ? null : _this$state$value;
      var _this$state$inputValu = this.state.inputValue,
          inputValue = _this$state$inputValu === void 0 ? null : _this$state$inputValu; // https://github.com/ant-design/ant-design/issues/7363
      // https://github.com/ant-design/ant-design/issues/16622

      var newValueInString = typeof newValue === 'number' ? newValue.toFixed(precision) : "".concat(newValue);
      var changed = newValue !== value || newValueInString !== "".concat(inputValue);

      if (!('value' in this.props)) {
        this.setState({
          value: newValue,
          inputValue: this.toPrecisionAsStep(v)
        }, callback);
      } else {
        // always set input value same as value
        inputValue = this.toPrecisionAsStep(this.state.value);
        this.setState({
          inputValue: inputValue
        }, callback);
      }

      if (changed) {
        this.props.onChange(newValue);
      }

      return newValue;
    } // step={1.0} value={1.51}
    // press +
    // then value should be 2.51, rather than 2.5
    // if this.props.precision is undefined
    // https://github.com/react-component/input-number/issues/39

  }, {
    key: "getMaxPrecision",
    value: function getMaxPrecision(currentValue) {
      var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var _this$props5 = this.props,
          precision = _this$props5.precision,
          step = _this$props5.step;

      if (isValidProps(precision)) {
        return precision;
      }

      var ratioPrecision = this.getPrecision(ratio);
      var stepPrecision = this.getPrecision(step);
      var currentValuePrecision = this.getPrecision(currentValue);

      if (!currentValue) {
        return ratioPrecision + stepPrecision;
      }

      return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
    }
  }, {
    key: "getPrecisionFactor",
    value: function getPrecisionFactor(currentValue) {
      var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var precision = this.getMaxPrecision(currentValue, ratio);
      return Math.pow(10, precision);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
      this.recordCursorPosition();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "formatWrapper",
    value: function formatWrapper(num) {
      // http://2ality.com/2012/03/signedzero.html
      // https://github.com/ant-design/ant-design/issues/9439
      if (this.props.formatter) {
        return this.props.formatter(num);
      }

      return num;
    }
  }, {
    key: "toPrecisionAsStep",
    value: function toPrecisionAsStep(num) {
      if (this.isNotCompleteNumber(num) || num === '') {
        return num;
      }

      var precision = Math.abs(this.getMaxPrecision(num));

      if (!isNaN(precision)) {
        return Number(num).toFixed(precision);
      }

      return num.toString();
    }
  }, {
    key: "toNumber",
    value: function toNumber(num) {
      var precision = this.props.precision;
      var focused = this.state.focused; // num.length > 16 => This is to prevent input of large numbers

      var numberIsTooLarge = num && num.length > 16 && focused;

      if (this.isNotCompleteNumber(num) || numberIsTooLarge) {
        return num;
      }

      if (isValidProps(precision)) {
        return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
      }

      return Number(num);
    }
  }, {
    key: "upStep",
    value: function upStep(val, rat) {
      var step = this.props.step;
      var precisionFactor = this.getPrecisionFactor(val, rat);
      var precision = Math.abs(this.getMaxPrecision(val, rat));
      var result = ((precisionFactor * val + precisionFactor * Number(step) * rat) / precisionFactor).toFixed(precision);
      return this.toNumber(result);
    }
  }, {
    key: "downStep",
    value: function downStep(val, rat) {
      var step = this.props.step;
      var precisionFactor = this.getPrecisionFactor(val, rat);
      var precision = Math.abs(this.getMaxPrecision(val, rat));
      var result = ((precisionFactor * val - precisionFactor * Number(step) * rat) / precisionFactor).toFixed(precision);
      return this.toNumber(result);
    }
  }, {
    key: "step",
    value: function step(type, e) {
      var _this2 = this;

      var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var recursive = arguments.length > 3 ? arguments[3] : undefined;
      this.stop();
      this.recordCursorPosition();

      if (e) {
        e.persist();
        e.preventDefault();
      }

      var props = this.props;

      if (props.disabled) {
        return;
      }

      var value = this.getCurrentValidValue(this.state.inputValue) || 0;

      if (this.isNotCompleteNumber(value)) {
        return;
      }

      var val = this["".concat(type, "Step")](value, ratio);
      var outOfRange = val > props.max || val < props.min;

      if (val > props.max) {
        val = props.max;
      } else if (val < props.min) {
        val = props.min;
      }

      this.setValue(val, null);
      if (props.onStep) props.onStep(val, {
        offset: ratio,
        type: type
      });
      this.setState({
        focused: true
      }, function () {
        _this2.pressingUpOrDown = false;
      });

      if (outOfRange) {
        return;
      }

      this.autoStepTimer = setTimeout(function () {
        _this2[type](e, ratio, true);
      }, recursive ? SPEED : DELAY);
    }
  }, {
    key: "fixCaret",
    value: function fixCaret(start, end) {
      if (start === undefined || end === undefined || !this.input || !this.input.value) {
        return;
      }

      try {
        var currentStart = this.input.selectionStart;
        var currentEnd = this.input.selectionEnd;

        if (start !== currentStart || end !== currentEnd) {
          this.input.setSelectionRange(start, end);
        }
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          disabled = _this$props6.disabled,
          readOnly = _this$props6.readOnly,
          useTouch = _this$props6.useTouch,
          autoComplete = _this$props6.autoComplete,
          upHandler = _this$props6.upHandler,
          downHandler = _this$props6.downHandler,
          className = _this$props6.className,
          max = _this$props6.max,
          min = _this$props6.min,
          style = _this$props6.style,
          title = _this$props6.title,
          onMouseEnter = _this$props6.onMouseEnter,
          onMouseLeave = _this$props6.onMouseLeave,
          onMouseOver = _this$props6.onMouseOver,
          onMouseOut = _this$props6.onMouseOut,
          required = _this$props6.required,
          onClick = _this$props6.onClick,
          tabIndex = _this$props6.tabIndex,
          type = _this$props6.type,
          placeholder = _this$props6.placeholder,
          id = _this$props6.id,
          inputMode = _this$props6.inputMode,
          pattern = _this$props6.pattern,
          step = _this$props6.step,
          maxLength = _this$props6.maxLength,
          autoFocus = _this$props6.autoFocus,
          name = _this$props6.name,
          onPaste = _this$props6.onPaste,
          onInput = _this$props6.onInput,
          rest = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props6, ["prefixCls", "disabled", "readOnly", "useTouch", "autoComplete", "upHandler", "downHandler", "className", "max", "min", "style", "title", "onMouseEnter", "onMouseLeave", "onMouseOver", "onMouseOut", "required", "onClick", "tabIndex", "type", "placeholder", "id", "inputMode", "pattern", "step", "maxLength", "autoFocus", "name", "onPaste", "onInput"]);

      var _this$state = this.state,
          value = _this$state.value,
          focused = _this$state.focused;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, (_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, className, !!className), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-focused"), focused), _classNames));
      var dataOrAriaAttributeProps = {};
      Object.keys(rest).forEach(function (key) {
        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
          dataOrAriaAttributeProps[key] = rest[key];
        }
      });
      var editable = !readOnly && !disabled; // focus state, show input value
      // unfocus state, show valid value

      var inputDisplayValue = this.getInputDisplayValue(null);
      var upDisabled = (value || value === 0) && (isNaN(value) || Number(value) >= max);
      var downDisabled = (value || value === 0) && (isNaN(value) || Number(value) <= min);
      var isUpDisabled = upDisabled || disabled || readOnly;
      var isDownDisabled = downDisabled || disabled || readOnly;
      var upClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()("".concat(prefixCls, "-handler"), "".concat(prefixCls, "-handler-up"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-handler-up-disabled"), isUpDisabled));
      var downClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()("".concat(prefixCls, "-handler"), "".concat(prefixCls, "-handler-down"), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "".concat(prefixCls, "-handler-down-disabled"), isDownDisabled));
      var upEvents = useTouch ? {
        onTouchStart: isUpDisabled ? noop : this.up,
        onTouchEnd: this.stop
      } : {
        onMouseDown: isUpDisabled ? noop : this.up,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      var downEvents = useTouch ? {
        onTouchStart: isDownDisabled ? noop : this.down,
        onTouchEnd: this.stop
      } : {
        onMouseDown: isDownDisabled ? noop : this.down,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: classes,
        style: style,
        title: title,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: function onFocus() {
          return null;
        },
        onBlur: function onBlur() {
          return null;
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-handler-wrap")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        unselectable: "on"
      }, upEvents, {
        role: "button",
        "aria-label": "Increase Value",
        "aria-disabled": isUpDisabled,
        className: upClassName
      }), upHandler || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner"),
        onClick: preventDefault
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        unselectable: "on"
      }, downEvents, {
        role: "button",
        "aria-label": "Decrease Value",
        "aria-disabled": isDownDisabled,
        className: downClassName
      }), downHandler || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner"),
        onClick: preventDefault
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        required: required,
        type: type,
        placeholder: placeholder,
        onPaste: onPaste,
        onClick: onClick,
        onMouseUp: this.onMouseUp,
        className: "".concat(prefixCls, "-input"),
        tabIndex: tabIndex,
        autoComplete: autoComplete,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: editable ? this.onKeyDown : noop,
        onKeyUp: editable ? this.onKeyUp : noop,
        autoFocus: autoFocus,
        maxLength: maxLength,
        readOnly: readOnly,
        disabled: disabled,
        max: max,
        min: min,
        step: step,
        name: name,
        title: title,
        id: id,
        onChange: this.onChange,
        ref: this.saveInput,
        value: this.getFullNum(inputDisplayValue),
        pattern: pattern,
        inputMode: inputMode,
        onInput: onInput
      }, dataOrAriaAttributeProps))));
    }
  }]);

  return InputNumber;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

InputNumber.defaultProps = {
  focusOnUpDown: true,
  useTouch: false,
  prefixCls: 'rc-input-number',
  max: MAX_SAFE_INTEGER,
  min: -MAX_SAFE_INTEGER,
  step: 1,
  style: {},
  onChange: noop,
  onKeyDown: noop,
  onPressEnter: noop,
  onFocus: noop,
  onBlur: noop,
  parser: defaultParser,
  required: false,
  autoComplete: 'off'
};
/* harmony default export */ __webpack_exports__["a"] = (InputNumber);

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(416);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1747);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(752);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(753);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1752);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(1756);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1757);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _UpOutlined = _interopRequireDefault(__webpack_require__(1759));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _UpOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _UpOutlined = _interopRequireDefault(__webpack_require__(1760));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _UpOutlined.default
  }));
};
UpOutlined.displayName = 'UpOutlined';
var _default = /*#__PURE__*/React.forwardRef(UpOutlined);
exports.default = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var UpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
exports.default = UpOutlined;


/***/ }),
/* 1761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(754));
__export(__webpack_require__(1763));


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DragDropManagerImpl_1 = __webpack_require__(1764);
function createDragDropManager(backend, context, debugMode) {
    return new DragDropManagerImpl_1.default(backend, context, debugMode);
}
exports.createDragDropManager = createDragDropManager;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(353);
var reducers_1 = __webpack_require__(1765);
var dragDrop_1 = __webpack_require__(302);
var DragDropMonitorImpl_1 = __webpack_require__(1777);
var HandlerRegistryImpl_1 = __webpack_require__(1779);
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== 'undefined' &&
        window.__REDUX_DEVTOOLS_EXTENSION__;
    return redux_1.createStore(reducers_1.default, debugMode &&
        reduxDevTools &&
        reduxDevTools({
            name: 'dnd-core',
            instanceId: 'dnd-core',
        }));
}
var DragDropManagerImpl = /** @class */ (function () {
    function DragDropManagerImpl(createBackend, context, debugMode) {
        var _this = this;
        if (context === void 0) { context = {}; }
        if (debugMode === void 0) { debugMode = false; }
        this.context = context;
        this.isSetUp = false;
        this.handleRefCountChange = function () {
            var shouldSetUp = _this.store.getState().refCount > 0;
            if (shouldSetUp && !_this.isSetUp) {
                _this.backend.setup();
                _this.isSetUp = true;
            }
            else if (!shouldSetUp && _this.isSetUp) {
                _this.backend.teardown();
                _this.isSetUp = false;
            }
        };
        var store = makeStoreInstance(debugMode);
        this.store = store;
        this.monitor = new DragDropMonitorImpl_1.default(store, new HandlerRegistryImpl_1.default(store));
        this.backend = createBackend(this);
        store.subscribe(this.handleRefCountChange);
    }
    DragDropManagerImpl.prototype.getContext = function () {
        return this.context;
    };
    DragDropManagerImpl.prototype.getMonitor = function () {
        return this.monitor;
    };
    DragDropManagerImpl.prototype.getBackend = function () {
        return this.backend;
    };
    DragDropManagerImpl.prototype.getRegistry = function () {
        return this.monitor.registry;
    };
    DragDropManagerImpl.prototype.getActions = function () {
        var manager = this;
        var dispatch = this.store.dispatch;
        function bindActionCreator(actionCreator) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') {
                    dispatch(action);
                }
            };
        }
        var actions = dragDrop_1.default(this);
        return Object.keys(actions).reduce(function (boundActions, key) {
            var action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    };
    DragDropManagerImpl.prototype.dispatch = function (action) {
        this.store.dispatch(action);
    };
    return DragDropManagerImpl;
}());
exports.default = DragDropManagerImpl;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragOffset_1 = __webpack_require__(1766);
var dragOperation_1 = __webpack_require__(1773);
var refCount_1 = __webpack_require__(1774);
var dirtyHandlerIds_1 = __webpack_require__(1775);
var stateId_1 = __webpack_require__(1776);
var discount_lodash_1 = __webpack_require__(193);
function reduce(state, action) {
    if (state === void 0) { state = {}; }
    return {
        dirtyHandlerIds: dirtyHandlerIds_1.default(state.dirtyHandlerIds, {
            type: action.type,
            payload: __assign({}, action.payload, { prevTargetIds: discount_lodash_1.get(state, 'dragOperation.targetIds', []) }),
        }),
        dragOffset: dragOffset_1.default(state.dragOffset, action),
        refCount: refCount_1.default(state.refCount, action),
        dragOperation: dragOperation_1.default(state.dragOperation, action),
        stateId: stateId_1.default(state.stateId),
    };
}
exports.default = reduce;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragDrop_1 = __webpack_require__(302);
var equality_1 = __webpack_require__(756);
var initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null,
};
function dragOffset(state, action) {
    if (state === void 0) { state = initialState; }
    var payload = action.payload;
    switch (action.type) {
        case dragDrop_1.INIT_COORDS:
        case dragDrop_1.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset,
            };
        case dragDrop_1.HOVER:
            if (equality_1.areCoordsEqual(state.clientOffset, payload.clientOffset)) {
                return state;
            }
            return __assign({}, state, { clientOffset: payload.clientOffset });
        case dragDrop_1.END_DRAG:
        case dragDrop_1.DROP:
            return initialState;
        default:
            return state;
    }
}
exports.default = dragOffset;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setClientOffset_1 = __webpack_require__(1768);
var discount_lodash_1 = __webpack_require__(193);
var invariant = __webpack_require__(25);
var types_1 = __webpack_require__(152);
var ResetCoordinatesAction = {
    type: types_1.INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null,
    },
};
function createBeginDrag(manager) {
    return function beginDrag(sourceIds, options) {
        if (sourceIds === void 0) { sourceIds = []; }
        if (options === void 0) { options = {
            publishSource: true,
        }; }
        var _a = options.publishSource, publishSource = _a === void 0 ? true : _a, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch(setClientOffset_1.setClientOffset(clientOffset));
        verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        var sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId === null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        var sourceClientOffset = null;
        if (clientOffset) {
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch(setClientOffset_1.setClientOffset(clientOffset, sourceClientOffset));
        var source = registry.getSource(sourceId);
        var item = source.beginDrag(monitor, sourceId);
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        var itemType = registry.getSourceType(sourceId);
        return {
            type: types_1.BEGIN_DRAG,
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource,
            },
        };
    };
}
exports.default = createBeginDrag;
function verifyInvariants(sourceIds, monitor, registry) {
    invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    for (var _i = 0, sourceIds_1 = sourceIds; _i < sourceIds_1.length; _i++) {
        var s = sourceIds_1[_i];
        invariant(registry.getSource(s), 'Expected sourceIds to be registered.');
    }
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    invariant(discount_lodash_1.isObject(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    var sourceId = null;
    for (var i = sourceIds.length - 1; i >= 0; i--) {
        if (monitor.canDragSource(sourceIds[i])) {
            sourceId = sourceIds[i];
            break;
        }
    }
    return sourceId;
}


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(152);
function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: types_1.INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null,
        },
    };
}
exports.setClientOffset = setClientOffset;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(152);
function createPublishDragSource(manager) {
    return function publishDragSource() {
        var monitor = manager.getMonitor();
        if (monitor.isDragging()) {
            return { type: types_1.PUBLISH_DRAG_SOURCE };
        }
    };
}
exports.default = createPublishDragSource;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var matchesType_1 = __webpack_require__(755);
var types_1 = __webpack_require__(152);
var invariant = __webpack_require__(25);
function createHover(manager) {
    return function hover(targetIdsArg, _a) {
        var clientOffset = (_a === void 0 ? {} : _a).clientOffset;
        verifyTargetIdsIsArray(targetIdsArg);
        var targetIds = targetIdsArg.slice(0);
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        checkInvariants(targetIds, monitor, registry);
        var draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: types_1.HOVER,
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null,
            },
        };
    };
}
exports.default = createHover;
function verifyTargetIdsIsArray(targetIdsArg) {
    invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call hover after drop.');
    for (var i = 0; i < targetIds.length; i++) {
        var targetId = targetIds[i];
        invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        var target = registry.getTarget(targetId);
        invariant(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for (var i = targetIds.length - 1; i >= 0; i--) {
        var targetId = targetIds[i];
        var targetType = registry.getTargetType(targetId);
        if (!matchesType_1.default(targetType, draggedItemType)) {
            targetIds.splice(i, 1);
        }
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    for (var _i = 0, targetIds_1 = targetIds; _i < targetIds_1.length; _i++) {
        var targetId = targetIds_1[_i];
        var target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    }
}


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(152);
var discount_lodash_1 = __webpack_require__(193);
var invariant = __webpack_require__(25);
function createDrop(manager) {
    return function drop(options) {
        if (options === void 0) { options = {}; }
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        verifyInvariants(monitor);
        var targetIds = getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach(function (targetId, index) {
            var dropResult = determineDropResult(targetId, index, registry, monitor);
            var action = {
                type: types_1.DROP,
                payload: {
                    dropResult: __assign({}, options, dropResult),
                },
            };
            manager.dispatch(action);
        });
    };
}
exports.default = createDrop;
function verifyInvariants(monitor) {
    invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') {
        dropResult = index === 0 ? {} : monitor.getDropResult();
    }
    return dropResult;
}
function verifyDropResultType(dropResult) {
    invariant(typeof dropResult === 'undefined' || discount_lodash_1.isObject(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    var targetIds = monitor
        .getTargetIds()
        .filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(152);
var invariant = __webpack_require__(25);
function createEndDrag(manager) {
    return function endDrag() {
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        verifyIsDragging(monitor);
        var sourceId = monitor.getSourceId();
        var source = registry.getSource(sourceId, true);
        source.endDrag(monitor, sourceId);
        registry.unpinSource();
        return { type: types_1.END_DRAG };
    };
}
exports.default = createEndDrag;
function verifyIsDragging(monitor) {
    invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dragDrop_1 = __webpack_require__(302);
var registry_1 = __webpack_require__(303);
var discount_lodash_1 = __webpack_require__(193);
var initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null,
};
function dragOperation(state, action) {
    if (state === void 0) { state = initialState; }
    var payload = action.payload;
    switch (action.type) {
        case dragDrop_1.BEGIN_DRAG:
            return __assign({}, state, { itemType: payload.itemType, item: payload.item, sourceId: payload.sourceId, isSourcePublic: payload.isSourcePublic, dropResult: null, didDrop: false });
        case dragDrop_1.PUBLISH_DRAG_SOURCE:
            return __assign({}, state, { isSourcePublic: true });
        case dragDrop_1.HOVER:
            return __assign({}, state, { targetIds: payload.targetIds });
        case registry_1.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) {
                return state;
            }
            return __assign({}, state, { targetIds: discount_lodash_1.without(state.targetIds, payload.targetId) });
        case dragDrop_1.DROP:
            return __assign({}, state, { dropResult: payload.dropResult, didDrop: true, targetIds: [] });
        case dragDrop_1.END_DRAG:
            return __assign({}, state, { itemType: null, item: null, sourceId: null, dropResult: null, didDrop: false, isSourcePublic: null, targetIds: [] });
        default:
            return state;
    }
}
exports.default = dragOperation;


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var registry_1 = __webpack_require__(303);
function refCount(state, action) {
    if (state === void 0) { state = 0; }
    switch (action.type) {
        case registry_1.ADD_SOURCE:
        case registry_1.ADD_TARGET:
            return state + 1;
        case registry_1.REMOVE_SOURCE:
        case registry_1.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}
exports.default = refCount;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dragDrop_1 = __webpack_require__(302);
var registry_1 = __webpack_require__(303);
var equality_1 = __webpack_require__(756);
var dirtiness_1 = __webpack_require__(757);
var discount_lodash_1 = __webpack_require__(193);
function dirtyHandlerIds(state, action) {
    if (state === void 0) { state = dirtiness_1.NONE; }
    switch (action.type) {
        case dragDrop_1.HOVER:
            break;
        case registry_1.ADD_SOURCE:
        case registry_1.ADD_TARGET:
        case registry_1.REMOVE_TARGET:
        case registry_1.REMOVE_SOURCE:
            return dirtiness_1.NONE;
        case dragDrop_1.BEGIN_DRAG:
        case dragDrop_1.PUBLISH_DRAG_SOURCE:
        case dragDrop_1.END_DRAG:
        case dragDrop_1.DROP:
        default:
            return dirtiness_1.ALL;
    }
    var _a = action.payload, _b = _a.targetIds, targetIds = _b === void 0 ? [] : _b, _c = _a.prevTargetIds, prevTargetIds = _c === void 0 ? [] : _c;
    var result = discount_lodash_1.xor(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !equality_1.areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) {
        return dirtiness_1.NONE;
    }
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) {
            result.push(prevInnermostTargetId);
        }
        if (innermostTargetId) {
            result.push(innermostTargetId);
        }
    }
    return result;
}
exports.default = dirtyHandlerIds;


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function stateId(state) {
    if (state === void 0) { state = 0; }
    return state + 1;
}
exports.default = stateId;


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var matchesType_1 = __webpack_require__(755);
var coords_1 = __webpack_require__(1778);
var dirtiness_1 = __webpack_require__(757);
var invariant = __webpack_require__(25);
var DragDropMonitorImpl = /** @class */ (function () {
    function DragDropMonitorImpl(store, registry) {
        this.store = store;
        this.registry = registry;
    }
    DragDropMonitorImpl.prototype.subscribeToStateChange = function (listener, options) {
        var _this = this;
        if (options === void 0) { options = { handlerIds: undefined }; }
        var handlerIds = options.handlerIds;
        invariant(typeof listener === 'function', 'listener must be a function.');
        invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        var prevStateId = this.store.getState().stateId;
        var handleChange = function () {
            var state = _this.store.getState();
            var currentStateId = state.stateId;
            try {
                var canSkipListener = currentStateId === prevStateId ||
                    (currentStateId === prevStateId + 1 &&
                        !dirtiness_1.areDirty(state.dirtyHandlerIds, handlerIds));
                if (!canSkipListener) {
                    listener();
                }
            }
            finally {
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    };
    DragDropMonitorImpl.prototype.subscribeToOffsetChange = function (listener) {
        var _this = this;
        invariant(typeof listener === 'function', 'listener must be a function.');
        var previousState = this.store.getState().dragOffset;
        var handleChange = function () {
            var nextState = _this.store.getState().dragOffset;
            if (nextState === previousState) {
                return;
            }
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    };
    DragDropMonitorImpl.prototype.canDragSource = function (sourceId) {
        if (!sourceId) {
            return false;
        }
        var source = this.registry.getSource(sourceId);
        invariant(source, 'Expected to find a valid source.');
        if (this.isDragging()) {
            return false;
        }
        return source.canDrag(this, sourceId);
    };
    DragDropMonitorImpl.prototype.canDropOnTarget = function (targetId) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        var target = this.registry.getTarget(targetId);
        invariant(target, 'Expected to find a valid target.');
        if (!this.isDragging() || this.didDrop()) {
            return false;
        }
        var targetType = this.registry.getTargetType(targetId);
        var draggedItemType = this.getItemType();
        return (matchesType_1.default(targetType, draggedItemType) && target.canDrop(this, targetId));
    };
    DragDropMonitorImpl.prototype.isDragging = function () {
        return Boolean(this.getItemType());
    };
    DragDropMonitorImpl.prototype.isDraggingSource = function (sourceId) {
        // undefined on initial render
        if (!sourceId) {
            return false;
        }
        var source = this.registry.getSource(sourceId, true);
        invariant(source, 'Expected to find a valid source.');
        if (!this.isDragging() || !this.isSourcePublic()) {
            return false;
        }
        var sourceType = this.registry.getSourceType(sourceId);
        var draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) {
            return false;
        }
        return source.isDragging(this, sourceId);
    };
    DragDropMonitorImpl.prototype.isOverTarget = function (targetId, options) {
        if (options === void 0) { options = { shallow: false }; }
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        var shallow = options.shallow;
        if (!this.isDragging()) {
            return false;
        }
        var targetType = this.registry.getTargetType(targetId);
        var draggedItemType = this.getItemType();
        if (draggedItemType && !matchesType_1.default(targetType, draggedItemType)) {
            return false;
        }
        var targetIds = this.getTargetIds();
        if (!targetIds.length) {
            return false;
        }
        var index = targetIds.indexOf(targetId);
        if (shallow) {
            return index === targetIds.length - 1;
        }
        else {
            return index > -1;
        }
    };
    DragDropMonitorImpl.prototype.getItemType = function () {
        return this.store.getState().dragOperation.itemType;
    };
    DragDropMonitorImpl.prototype.getItem = function () {
        return this.store.getState().dragOperation.item;
    };
    DragDropMonitorImpl.prototype.getSourceId = function () {
        return this.store.getState().dragOperation.sourceId;
    };
    DragDropMonitorImpl.prototype.getTargetIds = function () {
        return this.store.getState().dragOperation.targetIds;
    };
    DragDropMonitorImpl.prototype.getDropResult = function () {
        return this.store.getState().dragOperation.dropResult;
    };
    DragDropMonitorImpl.prototype.didDrop = function () {
        return this.store.getState().dragOperation.didDrop;
    };
    DragDropMonitorImpl.prototype.isSourcePublic = function () {
        return this.store.getState().dragOperation.isSourcePublic;
    };
    DragDropMonitorImpl.prototype.getInitialClientOffset = function () {
        return this.store.getState().dragOffset.initialClientOffset;
    };
    DragDropMonitorImpl.prototype.getInitialSourceClientOffset = function () {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    };
    DragDropMonitorImpl.prototype.getClientOffset = function () {
        return this.store.getState().dragOffset.clientOffset;
    };
    DragDropMonitorImpl.prototype.getSourceClientOffset = function () {
        return coords_1.getSourceClientOffset(this.store.getState().dragOffset);
    };
    DragDropMonitorImpl.prototype.getDifferenceFromInitialOffset = function () {
        return coords_1.getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    };
    return DragDropMonitorImpl;
}());
exports.default = DragDropMonitorImpl;


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */
function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y,
    };
}
exports.add = add;
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */
function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y,
    };
}
exports.subtract = subtract;
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */
function getSourceClientOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
        return null;
    }
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
exports.getSourceClientOffset = getSourceClientOffset;
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */
function getDifferenceFromInitialOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) {
        return null;
    }
    return subtract(clientOffset, initialClientOffset);
}
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var registry_1 = __webpack_require__(303);
var getNextUniqueId_1 = __webpack_require__(1780);
var interfaces_1 = __webpack_require__(754);
var contracts_1 = __webpack_require__(1781);
var invariant = __webpack_require__(25);
var asap = __webpack_require__(1782);
function getNextHandlerId(role) {
    var id = getNextUniqueId_1.default().toString();
    switch (role) {
        case interfaces_1.HandlerRole.SOURCE:
            return "S" + id;
        case interfaces_1.HandlerRole.TARGET:
            return "T" + id;
        default:
            throw new Error("Unknown Handler Role: " + role);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch (handlerId[0]) {
        case 'S':
            return interfaces_1.HandlerRole.SOURCE;
        case 'T':
            return interfaces_1.HandlerRole.TARGET;
        default:
            invariant(false, "Cannot parse handler ID: " + handlerId);
    }
}
function mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;
    do {
        var _a = entries.next(), done = _a.done, _b = _a.value, value = _b[1];
        if (value === searchValue) {
            return true;
        }
        isDone = done;
    } while (!isDone);
    return false;
}
var HandlerRegistryImpl = /** @class */ (function () {
    function HandlerRegistryImpl(store) {
        this.store = store;
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    HandlerRegistryImpl.prototype.addSource = function (type, source) {
        contracts_1.validateType(type);
        contracts_1.validateSourceContract(source);
        var sourceId = this.addHandler(interfaces_1.HandlerRole.SOURCE, type, source);
        this.store.dispatch(registry_1.addSource(sourceId));
        return sourceId;
    };
    HandlerRegistryImpl.prototype.addTarget = function (type, target) {
        contracts_1.validateType(type, true);
        contracts_1.validateTargetContract(target);
        var targetId = this.addHandler(interfaces_1.HandlerRole.TARGET, type, target);
        this.store.dispatch(registry_1.addTarget(targetId));
        return targetId;
    };
    HandlerRegistryImpl.prototype.containsHandler = function (handler) {
        return (mapContainsValue(this.dragSources, handler) ||
            mapContainsValue(this.dropTargets, handler));
    };
    HandlerRegistryImpl.prototype.getSource = function (sourceId, includePinned) {
        if (includePinned === void 0) { includePinned = false; }
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        var isPinned = includePinned && sourceId === this.pinnedSourceId;
        var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    };
    HandlerRegistryImpl.prototype.getTarget = function (targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    };
    HandlerRegistryImpl.prototype.getSourceType = function (sourceId) {
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    };
    HandlerRegistryImpl.prototype.getTargetType = function (targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    };
    HandlerRegistryImpl.prototype.isSourceId = function (handlerId) {
        var role = parseRoleFromHandlerId(handlerId);
        return role === interfaces_1.HandlerRole.SOURCE;
    };
    HandlerRegistryImpl.prototype.isTargetId = function (handlerId) {
        var role = parseRoleFromHandlerId(handlerId);
        return role === interfaces_1.HandlerRole.TARGET;
    };
    HandlerRegistryImpl.prototype.removeSource = function (sourceId) {
        var _this = this;
        invariant(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch(registry_1.removeSource(sourceId));
        asap(function () {
            _this.dragSources.delete(sourceId);
            _this.types.delete(sourceId);
        });
    };
    HandlerRegistryImpl.prototype.removeTarget = function (targetId) {
        invariant(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch(registry_1.removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    };
    HandlerRegistryImpl.prototype.pinSource = function (sourceId) {
        var source = this.getSource(sourceId);
        invariant(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    };
    HandlerRegistryImpl.prototype.unpinSource = function () {
        invariant(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    };
    HandlerRegistryImpl.prototype.addHandler = function (role, type, handler) {
        var id = getNextHandlerId(role);
        this.types.set(id, type);
        if (role === interfaces_1.HandlerRole.SOURCE) {
            this.dragSources.set(id, handler);
        }
        else if (role === interfaces_1.HandlerRole.TARGET) {
            this.dropTargets.set(id, handler);
        }
        return id;
    };
    return HandlerRegistryImpl;
}());
exports.default = HandlerRegistryImpl;


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}
exports.default = getNextUniqueId;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var invariant = __webpack_require__(25);
function validateSourceContract(source) {
    invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
exports.validateSourceContract = validateSourceContract;
function validateTargetContract(target) {
    invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
    invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
exports.validateTargetContract = validateTargetContract;
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach(function (t) { return validateType(t, false); });
        return;
    }
    invariant(typeof type === 'string' || typeof type === 'symbol', allowArray
        ? 'Type can only be a string, a symbol, or an array of either.'
        : 'Type can only be a string or a symbol.');
}
exports.validateType = validateType;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(481);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var checkDecoratorArguments_1 = __webpack_require__(304);
var DragDropContext_1 = __webpack_require__(301);
var isRefable_1 = __webpack_require__(417);
var discount_lodash_1 = __webpack_require__(153);
var hoistStatics = __webpack_require__(418);
var invariant = __webpack_require__(25);
var shallowEqual = __webpack_require__(96);
function DragLayer(collect, options) {
    if (options === void 0) { options = {}; }
    checkDecoratorArguments_1.default('DragLayer', 'collect[, options]', collect, options);
    invariant(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', collect);
    invariant(discount_lodash_1.isPlainObject(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' +
        'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
    return function decorateLayer(DecoratedComponent) {
        var Decorated = DecoratedComponent;
        var _a = options.arePropsEqual, arePropsEqual = _a === void 0 ? shallowEqual : _a;
        var displayName = Decorated.displayName || Decorated.name || 'Component';
        var DragLayerContainer = /** @class */ (function (_super) {
            __extends(DragLayerContainer, _super);
            function DragLayerContainer() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.isCurrentlyMounted = false;
                _this.ref = React.createRef();
                _this.handleChange = function () {
                    if (!_this.isCurrentlyMounted) {
                        return;
                    }
                    var nextState = _this.getCurrentState();
                    if (!shallowEqual(nextState, _this.state)) {
                        _this.setState(nextState);
                    }
                };
                return _this;
            }
            DragLayerContainer.prototype.getDecoratedComponentInstance = function () {
                invariant(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
                return this.ref.current;
            };
            DragLayerContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                return (!arePropsEqual(nextProps, this.props) ||
                    !shallowEqual(nextState, this.state));
            };
            DragLayerContainer.prototype.componentDidMount = function () {
                this.isCurrentlyMounted = true;
                this.handleChange();
            };
            DragLayerContainer.prototype.componentWillUnmount = function () {
                this.isCurrentlyMounted = false;
                if (this.unsubscribeFromOffsetChange) {
                    this.unsubscribeFromOffsetChange();
                    this.unsubscribeFromOffsetChange = undefined;
                }
                if (this.unsubscribeFromStateChange) {
                    this.unsubscribeFromStateChange();
                    this.unsubscribeFromStateChange = undefined;
                }
            };
            DragLayerContainer.prototype.render = function () {
                var _this = this;
                return (React.createElement(DragDropContext_1.Consumer, null, function (_a) {
                    var dragDropManager = _a.dragDropManager;
                    if (dragDropManager === undefined) {
                        return null;
                    }
                    _this.receiveDragDropManager(dragDropManager);
                    // Let componentDidMount fire to initialize the collected state
                    if (!_this.isCurrentlyMounted) {
                        return null;
                    }
                    return (React.createElement(Decorated, __assign({}, _this.props, _this.state, { ref: isRefable_1.isRefable(Decorated) ? _this.ref : null })));
                }));
            };
            DragLayerContainer.prototype.receiveDragDropManager = function (dragDropManager) {
                if (this.manager !== undefined) {
                    return;
                }
                this.manager = dragDropManager;
                invariant(typeof dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' +
                    'Make sure to wrap the top-level component of your app with DragDropContext. ' +
                    'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
                var monitor = this.manager.getMonitor();
                this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
                this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
            };
            DragLayerContainer.prototype.getCurrentState = function () {
                if (!this.manager) {
                    return {};
                }
                var monitor = this.manager.getMonitor();
                return collect(monitor, this.props);
            };
            DragLayerContainer.displayName = "DragLayer(" + displayName + ")";
            DragLayerContainer.DecoratedComponent = DecoratedComponent;
            return DragLayerContainer;
        }(React.Component));
        return hoistStatics(DragLayerContainer, DecoratedComponent);
    };
}
exports.default = DragLayer;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var checkDecoratorArguments_1 = __webpack_require__(304);
var decorateHandler_1 = __webpack_require__(758);
var registerSource_1 = __webpack_require__(759);
var createSourceFactory_1 = __webpack_require__(1789);
var DragSourceMonitorImpl_1 = __webpack_require__(761);
var SourceConnector_1 = __webpack_require__(762);
var isValidType_1 = __webpack_require__(765);
var discount_lodash_1 = __webpack_require__(153);
var invariant = __webpack_require__(25);
/**
 * Decorates a component as a dragsource
 * @param type The dragsource type
 * @param spec The drag source specification
 * @param collect The props collector function
 * @param options DnD options
 */
function DragSource(type, spec, collect, options) {
    if (options === void 0) { options = {}; }
    checkDecoratorArguments_1.default('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
    var getType = type;
    if (typeof type !== 'function') {
        invariant(isValidType_1.default(type), 'Expected "type" provided as the first argument to DragSource to be ' +
            'a string, or a function that returns a string given the current props. ' +
            'Instead, received %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);
        getType = function () { return type; };
    }
    invariant(discount_lodash_1.isPlainObject(spec), 'Expected "spec" provided as the second argument to DragSource to be ' +
        'a plain object. Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
    var createSource = createSourceFactory_1.default(spec);
    invariant(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' +
        'a function that returns a plain object of props to inject. ' +
        'Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
    invariant(discount_lodash_1.isPlainObject(options), 'Expected "options" provided as the fourth argument to DragSource to be ' +
        'a plain object when specified. ' +
        'Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
    return function decorateSource(DecoratedComponent) {
        return decorateHandler_1.default({
            containerDisplayName: 'DragSource',
            createHandler: createSource,
            registerHandler: registerSource_1.default,
            createConnector: function (backend) { return new SourceConnector_1.default(backend); },
            createMonitor: function (manager) {
                return new DragSourceMonitorImpl_1.default(manager);
            },
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options,
        });
    };
}
exports.default = DragSource;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1786));
__export(__webpack_require__(1787));
__export(__webpack_require__(1788));


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discount_lodash_1 = __webpack_require__(153);
/**
 * Provides a set of static methods for creating Disposables.
 * @param {Function} action Action to run during the first call to dispose.
 * The action is guaranteed to be run at most once.
 */
var Disposable = /** @class */ (function () {
    function Disposable(action) {
        this.isDisposed = false;
        this.action = discount_lodash_1.isFunction(action) ? action : discount_lodash_1.noop;
    }
    /**
     * Validates whether the given object is a disposable
     * @param {Object} Object to test whether it has a dispose method
     * @returns {Boolean} true if a disposable object, else false.
     */
    Disposable.isDisposable = function (d) {
        return d && discount_lodash_1.isFunction(d.dispose);
    };
    Disposable._fixup = function (result) {
        return Disposable.isDisposable(result) ? result : Disposable.empty;
    };
    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose.
     * The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */
    Disposable.create = function (action) {
        return new Disposable(action);
    };
    /** Performs the task of cleaning up resources. */
    Disposable.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.action();
            this.isDisposed = true;
        }
    };
    /**
     * Gets the disposable that does nothing when disposed.
     */
    Disposable.empty = { dispose: discount_lodash_1.noop };
    return Disposable;
}());
exports.Disposable = Disposable;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a disposable resource whose underlying disposable resource can
 * be replaced by another disposable resource, causing automatic disposal of
 * the previous underlying disposable resource.
 */
var SerialDisposable = /** @class */ (function () {
    function SerialDisposable() {
        this.isDisposed = false;
    }
    /**
     * Gets the underlying disposable.
     * @returns {Any} the underlying disposable.
     */
    SerialDisposable.prototype.getDisposable = function () {
        return this.current;
    };
    SerialDisposable.prototype.setDisposable = function (value) {
        var shouldDispose = this.isDisposed;
        if (!shouldDispose) {
            var old = this.current;
            this.current = value;
            if (old) {
                old.dispose();
            }
        }
        if (shouldDispose && value) {
            value.dispose();
        }
    };
    /** Performs the task of cleaning up resources. */
    SerialDisposable.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var old = this.current;
            this.current = undefined;
            if (old) {
                old.dispose();
            }
        }
    };
    return SerialDisposable;
}());
exports.SerialDisposable = SerialDisposable;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a group of disposable resources that are disposed together.
 * @constructor
 */
var CompositeDisposable = /** @class */ (function () {
    function CompositeDisposable() {
        var disposables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            disposables[_i] = arguments[_i];
        }
        this.isDisposed = false;
        this.disposables = disposables;
    }
    /**
     * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
     * @param {Any} item Disposable to add.
     */
    CompositeDisposable.prototype.add = function (item) {
        if (this.isDisposed) {
            item.dispose();
        }
        else {
            this.disposables.push(item);
        }
    };
    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Any} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */
    CompositeDisposable.prototype.remove = function (item) {
        var shouldDispose = false;
        if (!this.isDisposed) {
            var idx = this.disposables.indexOf(item);
            if (idx !== -1) {
                shouldDispose = true;
                this.disposables.splice(idx, 1);
                item.dispose();
            }
        }
        return shouldDispose;
    };
    /**
     *  Disposes all disposables in the group and removes them from the group but
     *  does not dispose the CompositeDisposable.
     */
    CompositeDisposable.prototype.clear = function () {
        if (!this.isDisposed) {
            var len = this.disposables.length;
            var currentDisposables = new Array(len);
            for (var i = 0; i < len; i++) {
                currentDisposables[i] = this.disposables[i];
            }
            this.disposables = [];
            for (var i = 0; i < len; i++) {
                currentDisposables[i].dispose();
            }
        }
    };
    /**
     *  Disposes all disposables in the group and removes them from the group.
     */
    CompositeDisposable.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var len = this.disposables.length;
            var currentDisposables = new Array(len);
            for (var i = 0; i < len; i++) {
                currentDisposables[i] = this.disposables[i];
            }
            this.disposables = [];
            for (var i = 0; i < len; i++) {
                currentDisposables[i].dispose();
            }
        }
    };
    return CompositeDisposable;
}());
exports.CompositeDisposable = CompositeDisposable;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getDecoratedComponent_1 = __webpack_require__(760);
var discount_lodash_1 = __webpack_require__(153);
var invariant = __webpack_require__(25);
var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];
var SourceImpl = /** @class */ (function () {
    function SourceImpl(spec, monitor, ref) {
        var _this = this;
        this.spec = spec;
        this.monitor = monitor;
        this.ref = ref;
        this.props = null;
        this.beginDrag = function () {
            if (!_this.props) {
                return;
            }
            var item = _this.spec.beginDrag(_this.props, _this.monitor, _this.ref.current);
            if (false) {
                invariant(discount_lodash_1.isPlainObject(item), 'beginDrag() must return a plain object that represents the dragged item. ' +
                    'Instead received %s. ' +
                    'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', item);
            }
            return item;
        };
    }
    SourceImpl.prototype.receiveProps = function (props) {
        this.props = props;
    };
    SourceImpl.prototype.canDrag = function () {
        if (!this.props) {
            return false;
        }
        if (!this.spec.canDrag) {
            return true;
        }
        return this.spec.canDrag(this.props, this.monitor);
    };
    SourceImpl.prototype.isDragging = function (globalMonitor, sourceId) {
        if (!this.props) {
            return false;
        }
        if (!this.spec.isDragging) {
            return sourceId === globalMonitor.getSourceId();
        }
        return this.spec.isDragging(this.props, this.monitor);
    };
    SourceImpl.prototype.endDrag = function () {
        if (!this.props) {
            return;
        }
        if (!this.spec.endDrag) {
            return;
        }
        this.spec.endDrag(this.props, this.monitor, getDecoratedComponent_1.getDecoratedComponent(this.ref));
    };
    return SourceImpl;
}());
function createSourceFactory(spec) {
    Object.keys(spec).forEach(function (key) {
        invariant(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' +
            'some of the following keys: %s. ' +
            'Instead received a specification with an unexpected "%s" key. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', ALLOWED_SPEC_METHODS.join(', '), key);
        invariant(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' +
            'Instead received a specification with %s: %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
    });
    REQUIRED_SPEC_METHODS.forEach(function (key) {
        invariant(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' +
            'Instead received a specification with %s: %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
    });
    return function createSource(monitor, ref) {
        return new SourceImpl(spec, monitor, ref);
    };
}
exports.default = createSourceFactory;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var invariant = __webpack_require__(25);
function setRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else {
        ref.current = node;
    }
}
function cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    invariant(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' +
        'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' +
        'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
    if (!previousRef) {
        // When there is no ref on the element, use the new ref directly
        return react_1.cloneElement(element, {
            ref: newRef,
        });
    }
    return react_1.cloneElement(element, {
        ref: function (node) {
            setRef(newRef, node);
            if (previousRef) {
                setRef(previousRef, node);
            }
        },
    });
}
exports.default = cloneWithRef;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, thisLen) {
        if (thisLen === undefined || thisLen > this.length) {
            thisLen = this.length;
        }
        return this.substring(thisLen - search.length, thisLen) === search;
    };
}


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var checkDecoratorArguments_1 = __webpack_require__(304);
var decorateHandler_1 = __webpack_require__(758);
var registerTarget_1 = __webpack_require__(766);
var createTargetFactory_1 = __webpack_require__(1793);
var isValidType_1 = __webpack_require__(765);
var DropTargetMonitorImpl_1 = __webpack_require__(767);
var TargetConnector_1 = __webpack_require__(768);
var discount_lodash_1 = __webpack_require__(153);
var invariant = __webpack_require__(25);
function DropTarget(type, spec, collect, options) {
    if (options === void 0) { options = {}; }
    checkDecoratorArguments_1.default('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
    var getType = type;
    if (typeof type !== 'function') {
        invariant(isValidType_1.default(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' +
            'a string, an array of strings, or a function that returns either given ' +
            'the current props. Instead, received %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);
        getType = function () { return type; };
    }
    invariant(discount_lodash_1.isPlainObject(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' +
        'a plain object. Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
    var createTarget = createTargetFactory_1.default(spec);
    invariant(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' +
        'a function that returns a plain object of props to inject. ' +
        'Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
    invariant(discount_lodash_1.isPlainObject(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' +
        'a plain object when specified. ' +
        'Instead, received %s. ' +
        'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
    return function decorateTarget(DecoratedComponent) {
        return decorateHandler_1.default({
            containerDisplayName: 'DropTarget',
            createHandler: createTarget,
            registerHandler: registerTarget_1.default,
            createMonitor: function (manager) {
                return new DropTargetMonitorImpl_1.default(manager);
            },
            createConnector: function (backend) { return new TargetConnector_1.default(backend); },
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options,
        });
    };
}
exports.default = DropTarget;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getDecoratedComponent_1 = __webpack_require__(760);
var discount_lodash_1 = __webpack_require__(153);
var invariant = __webpack_require__(25);
var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
var TargetImpl = /** @class */ (function () {
    function TargetImpl(spec, monitor, ref) {
        this.spec = spec;
        this.monitor = monitor;
        this.ref = ref;
        this.props = null;
    }
    TargetImpl.prototype.receiveProps = function (props) {
        this.props = props;
    };
    TargetImpl.prototype.receiveMonitor = function (monitor) {
        this.monitor = monitor;
    };
    TargetImpl.prototype.canDrop = function () {
        if (!this.spec.canDrop) {
            return true;
        }
        return this.spec.canDrop(this.props, this.monitor);
    };
    TargetImpl.prototype.hover = function () {
        if (!this.spec.hover) {
            return;
        }
        this.spec.hover(this.props, this.monitor, getDecoratedComponent_1.getDecoratedComponent(this.ref));
    };
    TargetImpl.prototype.drop = function () {
        if (!this.spec.drop) {
            return undefined;
        }
        var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);
        if (false) {
            invariant(typeof dropResult === 'undefined' || discount_lodash_1.isPlainObject(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' +
                'Instead received %s. ' +
                'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
        }
        return dropResult;
    };
    return TargetImpl;
}());
function createTargetFactory(spec) {
    Object.keys(spec).forEach(function (key) {
        invariant(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' +
            'some of the following keys: %s. ' +
            'Instead received a specification with an unexpected "%s" key. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', ALLOWED_SPEC_METHODS.join(', '), key);
        invariant(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' +
            'Instead received a specification with %s: %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
    });
    return function createTarget(monitor, ref) {
        return new TargetImpl(spec, monitor, ref);
    };
}
exports.default = createTargetFactory;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
/*
 * A utility for rendering a drag preview image
 */
var DragPreviewImage = React.memo(function (_a) {
    var connect = _a.connect, src = _a.src;
    if (typeof Image !== 'undefined') {
        var img_1 = new Image();
        img_1.src = src;
        img_1.onload = function () { return connect(img_1); };
    }
    return null;
});
DragPreviewImage.displayName = 'DragPreviewImage';
exports.default = DragPreviewImage;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1796));
__export(__webpack_require__(1798));
__export(__webpack_require__(1800));


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var useMonitorOutput_1 = __webpack_require__(769);
var drag_1 = __webpack_require__(1797);
var react_1 = __webpack_require__(0);
var invariant = __webpack_require__(25);
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification *
 */
function useDrag(spec) {
    var specRef = react_1.useRef(spec);
    specRef.current = spec;
    // TODO: wire options into createSourceConnector
    invariant(spec.item != null, 'item must be defined');
    invariant(spec.item.type != null, 'item type must be defined');
    var _a = drag_1.useDragSourceMonitor(), monitor = _a[0], connector = _a[1];
    drag_1.useDragHandler(specRef, monitor, connector);
    var result = useMonitorOutput_1.useMonitorOutput(monitor, specRef.current.collect || (function () { return ({}); }), function () { return connector.reconnect(); });
    var connectDragSource = react_1.useMemo(function () { return connector.hooks.dragSource(); }, [
        connector,
    ]);
    var connectDragPreview = react_1.useMemo(function () { return connector.hooks.dragPreview(); }, [
        connector,
    ]);
    react_1.useEffect(function () {
        connector.dragSourceOptions = specRef.current.options || null;
        connector.reconnect();
    }, [connector]);
    react_1.useEffect(function () {
        connector.dragPreviewOptions = specRef.current.previewOptions || null;
        connector.reconnect();
    }, [connector]);
    return [result, connectDragSource, connectDragPreview];
}
exports.useDrag = useDrag;


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var registerSource_1 = __webpack_require__(759);
var useDragDropManager_1 = __webpack_require__(419);
var DragSourceMonitorImpl_1 = __webpack_require__(761);
var SourceConnector_1 = __webpack_require__(762);
var invariant = __webpack_require__(25);
function useDragSourceMonitor() {
    var manager = useDragDropManager_1.useDragDropManager();
    var monitor = react_1.useMemo(function () { return new DragSourceMonitorImpl_1.default(manager); }, [manager]);
    var connector = react_1.useMemo(function () { return new SourceConnector_1.default(manager.getBackend()); }, [
        manager,
    ]);
    return [monitor, connector];
}
exports.useDragSourceMonitor = useDragSourceMonitor;
function useDragHandler(spec, monitor, connector) {
    var manager = useDragDropManager_1.useDragDropManager();
    // Can't use createSourceFactory, as semantics are different
    var handler = react_1.useMemo(function () {
        return {
            beginDrag: function () {
                var _a = spec.current, begin = _a.begin, item = _a.item;
                if (begin) {
                    var beginResult = begin(monitor);
                    invariant(beginResult == null || typeof beginResult === 'object', 'dragSpec.begin() must either return an object, undefined, or null');
                    return beginResult || item || {};
                }
                return item || {};
            },
            canDrag: function () {
                if (typeof spec.current.canDrag === 'boolean') {
                    return spec.current.canDrag;
                }
                else if (typeof spec.current.canDrag === 'function') {
                    return spec.current.canDrag(monitor);
                }
                else {
                    return true;
                }
            },
            isDragging: function (globalMonitor, target) {
                var isDragging = spec.current.isDragging;
                return isDragging
                    ? isDragging(monitor)
                    : target === globalMonitor.getSourceId();
            },
            endDrag: function () {
                var end = spec.current.end;
                if (end) {
                    end(monitor.getItem(), monitor);
                }
                connector.reconnect();
            },
        };
    }, []);
    react_1.useEffect(function registerHandler() {
        var _a = registerSource_1.default(spec.current.item.type, handler, manager), handlerId = _a[0], unregister = _a[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, []);
}
exports.useDragHandler = useDragHandler;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var useMonitorOutput_1 = __webpack_require__(769);
var drop_1 = __webpack_require__(1799);
var react_1 = __webpack_require__(0);
var invariant = __webpack_require__(25);
/**
 * useDropTarget Hook
 * @param spec The drop target specification
 */
function useDrop(spec) {
    var specRef = react_1.useRef(spec);
    specRef.current = spec;
    invariant(spec.accept != null, 'accept must be defined');
    var _a = drop_1.useDropTargetMonitor(), monitor = _a[0], connector = _a[1];
    drop_1.useDropHandler(specRef, monitor, connector);
    var result = useMonitorOutput_1.useMonitorOutput(monitor, specRef.current.collect || (function () { return ({}); }), function () { return connector.reconnect(); });
    var connectDropTarget = react_1.useMemo(function () { return connector.hooks.dropTarget(); }, [
        connector,
    ]);
    react_1.useEffect(function () {
        connector.dropTargetOptions = spec.options || null;
        connector.reconnect();
    }, [spec.options]);
    return [result, connectDropTarget];
}
exports.useDrop = useDrop;


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var registerTarget_1 = __webpack_require__(766);
var useDragDropManager_1 = __webpack_require__(419);
var TargetConnector_1 = __webpack_require__(768);
var DropTargetMonitorImpl_1 = __webpack_require__(767);
function useDropTargetMonitor() {
    var manager = useDragDropManager_1.useDragDropManager();
    var monitor = react_1.useMemo(function () { return new DropTargetMonitorImpl_1.default(manager); }, [manager]);
    var connector = react_1.useMemo(function () { return new TargetConnector_1.default(manager.getBackend()); }, [
        manager,
    ]);
    return [monitor, connector];
}
exports.useDropTargetMonitor = useDropTargetMonitor;
function useDropHandler(spec, monitor, connector) {
    var manager = useDragDropManager_1.useDragDropManager();
    // Can't use createSourceFactory, as semantics are different
    var handler = react_1.useMemo(function () {
        return {
            canDrop: function () {
                var canDrop = spec.current.canDrop;
                return canDrop ? canDrop(monitor.getItem(), monitor) : true;
            },
            hover: function () {
                var hover = spec.current.hover;
                if (hover) {
                    hover(monitor.getItem(), monitor);
                }
            },
            drop: function () {
                var drop = spec.current.drop;
                if (drop) {
                    return drop(monitor.getItem(), monitor);
                }
            },
        };
    }, [monitor]);
    react_1.useEffect(function registerHandler() {
        var _a = registerTarget_1.default(spec.current.accept, handler, manager), handlerId = _a[0], unregister = _a[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [monitor, connector]);
}
exports.useDropHandler = useDropHandler;


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var useDragDropManager_1 = __webpack_require__(419);
var useCollector_1 = __webpack_require__(770);
/**
 * useDragLayer Hook
 * @param collector The property collector
 */
function useDragLayer(collect) {
    var dragDropManager = useDragDropManager_1.useDragDropManager();
    var monitor = dragDropManager.getMonitor();
    var _a = useCollector_1.useCollector(monitor, collect), collected = _a[0], updateCollected = _a[1];
    react_1.useEffect(function () { return monitor.subscribeToOffsetChange(updateCollected); });
    react_1.useEffect(function () { return monitor.subscribeToStateChange(updateCollected); });
    return collected;
}
exports.useDragLayer = useDragLayer;


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var EnterLeaveCounter_1 = __webpack_require__(1802);
var BrowserDetector_1 = __webpack_require__(772);
var OffsetUtils_1 = __webpack_require__(1803);
var NativeDragSources_1 = __webpack_require__(1805);
var NativeTypes = __webpack_require__(420);
var HTML5Backend = /** @class */ (function () {
    function HTML5Backend(manager) {
        var _this = this;
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.getSourceClientOffset = function (sourceId) {
            return OffsetUtils_1.getNodeClientOffset(_this.sourceNodes.get(sourceId));
        };
        this.endDragNativeItem = function () {
            if (!_this.isDraggingNativeItem()) {
                return;
            }
            _this.actions.endDrag();
            _this.registry.removeSource(_this.currentNativeHandle);
            _this.currentNativeHandle = null;
            _this.currentNativeSource = null;
        };
        this.isNodeInDocument = function (node) {
            // Check the node either in the main document or in the current context
            return ((!!document && document.body.contains(node)) ||
                (!!_this.window && _this.window.document.body.contains(node)));
        };
        this.endDragIfSourceWasRemovedFromDOM = function () {
            var node = _this.currentDragSourceNode;
            if (_this.isNodeInDocument(node)) {
                return;
            }
            if (_this.clearCurrentDragSourceNode()) {
                _this.actions.endDrag();
            }
        };
        this.handleTopDragStartCapture = function () {
            _this.clearCurrentDragSourceNode();
            _this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = function (e) {
            var dragStartSourceIds = _this.dragStartSourceIds;
            _this.dragStartSourceIds = null;
            var clientOffset = OffsetUtils_1.getEventClientOffset(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (_this.monitor.isDragging()) {
                _this.actions.endDrag();
            }
            // Don't publish the source just yet (see why below)
            _this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: _this.getSourceClientOffset,
                clientOffset: clientOffset,
            });
            var dataTransfer = e.dataTransfer;
            var nativeType = NativeDragSources_1.matchNativeItemType(dataTransfer);
            if (_this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    var sourceId = _this.monitor.getSourceId();
                    var sourceNode = _this.sourceNodes.get(sourceId);
                    var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        var _a = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _a.anchorX, anchorY = _a.anchorY, offsetX = _a.offsetX, offsetY = _a.offsetY;
                        var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
                        var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
                        var dragPreviewOffset = OffsetUtils_1.getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer.setData('application/json', {});
                }
                catch (err) {
                    // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                _this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                var captureDraggingState = _this.getCurrentSourcePreviewNodeOptions().captureDraggingState;
                if (!captureDraggingState) {
                    // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(function () { return _this.actions.publishDragSource(); }, 0);
                }
                else {
                    // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    _this.actions.publishDragSource();
                }
            }
            else if (nativeType) {
                // A native item (such as URL) dragged from inside the document
                _this.beginDragNativeItem(nativeType);
            }
            else if (dataTransfer &&
                !dataTransfer.types &&
                ((e.target && !e.target.hasAttribute) ||
                    !e.target.hasAttribute('draggable'))) {
                // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return;
            }
            else {
                // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        };
        this.handleTopDragEndCapture = function () {
            if (_this.clearCurrentDragSourceNode()) {
                // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                _this.actions.endDrag();
            }
        };
        this.handleTopDragEnterCapture = function (e) {
            _this.dragEnterTargetIds = [];
            var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || _this.monitor.isDragging()) {
                return;
            }
            var dataTransfer = e.dataTransfer;
            var nativeType = NativeDragSources_1.matchNativeItemType(dataTransfer);
            if (nativeType) {
                // A native item (such as file or URL) dragged from outside the document
                _this.beginDragNativeItem(nativeType);
            }
        };
        this.handleTopDragEnter = function (e) {
            var dragEnterTargetIds = _this.dragEnterTargetIds;
            _this.dragEnterTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                return;
            }
            _this.altKeyPressed = e.altKey;
            if (!BrowserDetector_1.isFirefox()) {
                // Don't emit hover in `dragenter` on Firefox due to an edge case.
                // If the target changes position as the result of `dragenter`, Firefox
                // will still happily dispatch `dragover` despite target being no longer
                // there. The easy solution is to only fire `hover` in `dragover` on FF.
                _this.actions.hover(dragEnterTargetIds, {
                    clientOffset: OffsetUtils_1.getEventClientOffset(e),
                });
            }
            var canDrop = dragEnterTargetIds.some(function (targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
                }
            }
        };
        this.handleTopDragOverCapture = function () {
            _this.dragOverTargetIds = [];
        };
        this.handleTopDragOver = function (e) {
            var dragOverTargetIds = _this.dragOverTargetIds;
            _this.dragOverTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
                return;
            }
            _this.altKeyPressed = e.altKey;
            _this.actions.hover(dragOverTargetIds || [], {
                clientOffset: OffsetUtils_1.getEventClientOffset(e),
            });
            var canDrop = (dragOverTargetIds || []).some(function (targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
                }
            }
            else if (_this.isDraggingNativeItem()) {
                // Don't show a nice cursor but still prevent default
                // "drop and blow away the whole document" action.
                e.preventDefault();
            }
            else {
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
            }
        };
        this.handleTopDragLeaveCapture = function (e) {
            if (_this.isDraggingNativeItem()) {
                e.preventDefault();
            }
            var isLastLeave = _this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) {
                return;
            }
            if (_this.isDraggingNativeItem()) {
                _this.endDragNativeItem();
            }
        };
        this.handleTopDropCapture = function (e) {
            _this.dropTargetIds = [];
            e.preventDefault();
            if (_this.isDraggingNativeItem()) {
                _this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
            }
            _this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = function (e) {
            var dropTargetIds = _this.dropTargetIds;
            _this.dropTargetIds = [];
            _this.actions.hover(dropTargetIds, {
                clientOffset: OffsetUtils_1.getEventClientOffset(e),
            });
            _this.actions.drop({ dropEffect: _this.getCurrentDropEffect() });
            if (_this.isDraggingNativeItem()) {
                _this.endDragNativeItem();
            }
            else {
                _this.endDragIfSourceWasRemovedFromDOM();
            }
        };
        this.handleSelectStart = function (e) {
            var target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') {
                return;
            }
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' ||
                target.tagName === 'SELECT' ||
                target.tagName === 'TEXTAREA' ||
                target.isContentEditable) {
                return;
            }
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.context = manager.getContext();
        this.enterLeaveCounter = new EnterLeaveCounter_1.default(this.isNodeInDocument);
    }
    Object.defineProperty(HTML5Backend.prototype, "window", {
        // public for test
        get: function () {
            if (this.context && this.context.window) {
                return this.context.window;
            }
            else if (typeof window !== 'undefined') {
                return window;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    HTML5Backend.prototype.setup = function () {
        if (this.window === undefined) {
            return;
        }
        if (this.window.__isReactDndBackendSetUp) {
            throw new Error('Cannot have two HTML5 backends at the same time.');
        }
        this.window.__isReactDndBackendSetUp = true;
        this.addEventListeners(this.window);
    };
    HTML5Backend.prototype.teardown = function () {
        if (this.window === undefined) {
            return;
        }
        this.window.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.window);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    };
    HTML5Backend.prototype.connectDragPreview = function (sourceId, node, options) {
        var _this = this;
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return function () {
            _this.sourcePreviewNodes.delete(sourceId);
            _this.sourcePreviewNodeOptions.delete(sourceId);
        };
    };
    HTML5Backend.prototype.connectDragSource = function (sourceId, node, options) {
        var _this = this;
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        var handleDragStart = function (e) { return _this.handleDragStart(e, sourceId); };
        var handleSelectStart = function (e) { return _this.handleSelectStart(e); };
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return function () {
            _this.sourceNodes.delete(sourceId);
            _this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    };
    HTML5Backend.prototype.connectDropTarget = function (targetId, node) {
        var _this = this;
        var handleDragEnter = function (e) { return _this.handleDragEnter(e, targetId); };
        var handleDragOver = function (e) { return _this.handleDragOver(e, targetId); };
        var handleDrop = function (e) { return _this.handleDrop(e, targetId); };
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return function () {
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    };
    HTML5Backend.prototype.addEventListeners = function (target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) {
            return;
        }
        target.addEventListener('dragstart', this
            .handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this
            .handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    };
    HTML5Backend.prototype.removeEventListeners = function (target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) {
            return;
        }
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this
            .handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this
            .handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    };
    HTML5Backend.prototype.getCurrentSourceNodeOptions = function () {
        var sourceId = this.monitor.getSourceId();
        var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return __assign({ dropEffect: this.altKeyPressed ? 'copy' : 'move' }, (sourceNodeOptions || {}));
    };
    HTML5Backend.prototype.getCurrentDropEffect = function () {
        if (this.isDraggingNativeItem()) {
            // It makes more sense to default to 'copy' for native resources
            return 'copy';
        }
        return this.getCurrentSourceNodeOptions().dropEffect;
    };
    HTML5Backend.prototype.getCurrentSourcePreviewNodeOptions = function () {
        var sourceId = this.monitor.getSourceId();
        var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return __assign({ anchorX: 0.5, anchorY: 0.5, captureDraggingState: false }, (sourcePreviewNodeOptions || {}));
    };
    HTML5Backend.prototype.isDraggingNativeItem = function () {
        var itemType = this.monitor.getItemType();
        return Object.keys(NativeTypes).some(function (key) { return NativeTypes[key] === itemType; });
    };
    HTML5Backend.prototype.beginDragNativeItem = function (type) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = NativeDragSources_1.createNativeDragSource(type);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([this.currentNativeHandle]);
    };
    HTML5Backend.prototype.setCurrentDragSourceNode = function (node) {
        var _this = this;
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        var MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(function () {
            return (_this.window &&
                _this.window.addEventListener('mousemove', _this.endDragIfSourceWasRemovedFromDOM, true));
        }, MOUSE_MOVE_TIMEOUT);
    };
    HTML5Backend.prototype.clearCurrentDragSourceNode = function () {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.window) {
                this.window.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    };
    HTML5Backend.prototype.handleDragStart = function (e, sourceId) {
        if (!this.dragStartSourceIds) {
            this.dragStartSourceIds = [];
        }
        this.dragStartSourceIds.unshift(sourceId);
    };
    HTML5Backend.prototype.handleDragEnter = function (e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    };
    HTML5Backend.prototype.handleDragOver = function (e, targetId) {
        if (this.dragOverTargetIds === null) {
            this.dragOverTargetIds = [];
        }
        this.dragOverTargetIds.unshift(targetId);
    };
    HTML5Backend.prototype.handleDrop = function (e, targetId) {
        this.dropTargetIds.unshift(targetId);
    };
    return HTML5Backend;
}());
exports.default = HTML5Backend;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var discount_lodash_1 = __webpack_require__(771);
var EnterLeaveCounter = /** @class */ (function () {
    function EnterLeaveCounter(isNodeInDocument) {
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
    EnterLeaveCounter.prototype.enter = function (enteringNode) {
        var _this = this;
        var previousLength = this.entered.length;
        var isNodeEntered = function (node) {
            return _this.isNodeInDocument(node) &&
                (!node.contains || node.contains(enteringNode));
        };
        this.entered = discount_lodash_1.union(this.entered.filter(isNodeEntered), [enteringNode]);
        return previousLength === 0 && this.entered.length > 0;
    };
    EnterLeaveCounter.prototype.leave = function (leavingNode) {
        var previousLength = this.entered.length;
        this.entered = discount_lodash_1.without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    };
    EnterLeaveCounter.prototype.reset = function () {
        this.entered = [];
    };
    return EnterLeaveCounter;
}());
exports.default = EnterLeaveCounter;


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BrowserDetector_1 = __webpack_require__(772);
var MonotonicInterpolant_1 = __webpack_require__(1804);
var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) {
        return null;
    }
    var _a = el.getBoundingClientRect(), top = _a.top, left = _a.left;
    return { x: left, y: top };
}
exports.getNodeClientOffset = getNodeClientOffset;
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY,
    };
}
exports.getEventClientOffset = getEventClientOffset;
function isImageNode(node) {
    return (node.nodeName === 'IMG' &&
        (BrowserDetector_1.isFirefox() || !document.documentElement.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if (BrowserDetector_1.isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y,
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _a = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _a.dragPreviewWidth, dragPreviewHeight = _a.dragPreviewHeight;
    var calculateYOffset = function () {
        var interpolantY = new MonotonicInterpolant_1.default([0, 0.5, 1], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            (offsetFromDragPreview.y / sourceHeight) * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight,
        ]);
        var y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if (BrowserDetector_1.isSafari() && isImage) {
            // We'll have to wait for @3x to see if this is entirely correct
            y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        }
        return y;
    };
    var calculateXOffset = function () {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new MonotonicInterpolant_1.default([0, 0.5, 1], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            (offsetFromDragPreview.x / sourceWidth) * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth,
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset(),
    };
}
exports.getDragPreviewOffset = getDragPreviewOffset;


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MonotonicInterpolant = /** @class */ (function () {
    function MonotonicInterpolant(xs, ys) {
        var length = xs.length;
        // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for (var i = 0; i < length; i++) {
            indexes.push(i);
        }
        indexes.sort(function (a, b) { return (xs[a] < xs[b] ? -1 : 1); });
        // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx;
        var dy;
        for (var i = 0; i < length - 1; i++) {
            dx = xs[i + 1] - xs[i];
            dy = ys[i + 1] - ys[i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        var c1s = [ms[0]];
        for (var i = 0; i < dxs.length - 1; i++) {
            var m2 = ms[i];
            var mNext = ms[i + 1];
            if (m2 * mNext <= 0) {
                c1s.push(0);
            }
            else {
                dx = dxs[i];
                var dxNext = dxs[i + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m;
        for (var i = 0; i < c1s.length - 1; i++) {
            m = ms[i];
            var c1 = c1s[i];
            var invDx = 1 / dxs[i];
            var common = c1 + c1s[i + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    MonotonicInterpolant.prototype.interpolate = function (x) {
        var _a = this, xs = _a.xs, ys = _a.ys, c1s = _a.c1s, c2s = _a.c2s, c3s = _a.c3s;
        // The rightmost point in the dataset should give an exact result
        var i = xs.length - 1;
        if (x === xs[i]) {
            return ys[i];
        }
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        var low = 0;
        var high = c3s.length - 1;
        var mid;
        while (low <= high) {
            mid = Math.floor(0.5 * (low + high));
            var xHere = xs[mid];
            if (xHere < x) {
                low = mid + 1;
            }
            else if (xHere > x) {
                high = mid - 1;
            }
            else {
                return ys[mid];
            }
        }
        i = Math.max(0, high);
        // Interpolate
        var diff = x - xs[i];
        var diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    };
    return MonotonicInterpolant;
}());
exports.default = MonotonicInterpolant;


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var nativeTypesConfig_1 = __webpack_require__(1806);
var NativeDragSource_1 = __webpack_require__(1808);
function createNativeDragSource(type) {
    return new NativeDragSource_1.NativeDragSource(nativeTypesConfig_1.nativeTypesConfig[type]);
}
exports.createNativeDragSource = createNativeDragSource;
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) {
        return null;
    }
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return (Object.keys(nativeTypesConfig_1.nativeTypesConfig).filter(function (nativeItemType) {
        var matchesTypes = nativeTypesConfig_1.nativeTypesConfig[nativeItemType].matchesTypes;
        return matchesTypes.some(function (t) { return dataTransferTypes.indexOf(t) > -1; });
    })[0] || null);
}
exports.matchNativeItemType = matchNativeItemType;


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var NativeTypes = __webpack_require__(420);
var getDataFromDataTransfer_1 = __webpack_require__(1807);
exports.nativeTypesConfig = (_a = {},
    _a[NativeTypes.FILE] = {
        exposeProperties: {
            files: function (dataTransfer) {
                return Array.prototype.slice.call(dataTransfer.files);
            },
            items: function (dataTransfer) { return dataTransfer.items; },
        },
        matchesTypes: ['Files'],
    },
    _a[NativeTypes.URL] = {
        exposeProperties: {
            urls: function (dataTransfer, matchesTypes) {
                return getDataFromDataTransfer_1.getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
            },
        },
        matchesTypes: ['Url', 'text/uri-list'],
    },
    _a[NativeTypes.TEXT] = {
        exposeProperties: {
            text: function (dataTransfer, matchesTypes) {
                return getDataFromDataTransfer_1.getDataFromDataTransfer(dataTransfer, matchesTypes, '');
            },
        },
        matchesTypes: ['Text', 'text/plain'],
    },
    _a);


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function (resultSoFar, typeToTry) { return resultSoFar || dataTransfer.getData(typeToTry); }, '');
    return result != null ? result : defaultValue;
}
exports.getDataFromDataTransfer = getDataFromDataTransfer;


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NativeDragSource = /** @class */ (function () {
    function NativeDragSource(config) {
        var _this = this;
        this.config = config;
        this.item = {};
        Object.keys(this.config.exposeProperties).forEach(function (property) {
            Object.defineProperty(_this.item, property, {
                configurable: true,
                enumerable: true,
                get: function () {
                    // eslint-disable-next-line no-console
                    console.warn("Browser doesn't allow reading \"" + property + "\" until the drop event.");
                    return null;
                },
            });
        });
    }
    NativeDragSource.prototype.mutateItemByReadingDataTransfer = function (dataTransfer) {
        var _this = this;
        var newProperties = {};
        if (dataTransfer) {
            Object.keys(this.config.exposeProperties).forEach(function (property) {
                newProperties[property] = {
                    value: _this.config.exposeProperties[property](dataTransfer, _this.config.matchesTypes),
                };
            });
        }
        Object.defineProperties(this.item, newProperties);
    };
    NativeDragSource.prototype.canDrag = function () {
        return true;
    };
    NativeDragSource.prototype.beginDrag = function () {
        return this.item;
    };
    NativeDragSource.prototype.isDragging = function (monitor, handle) {
        return handle === monitor.getSourceId();
    };
    NativeDragSource.prototype.endDrag = function () {
        // empty
    };
    return NativeDragSource;
}());
exports.NativeDragSource = NativeDragSource;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emptyImage;
function getEmptyImage() {
    if (!emptyImage) {
        emptyImage = new Image();
        emptyImage.src =
            'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return emptyImage;
}
exports.default = getEmptyImage;


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1811);

__webpack_require__(27);

__webpack_require__(1812);

__webpack_require__(139);

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(1813);

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Upload = _interopRequireDefault(__webpack_require__(773));

var _Dragger = _interopRequireDefault(__webpack_require__(780));

_Upload["default"].Dragger = _Dragger["default"];
var _default = _Upload["default"];
exports["default"] = _default;

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload__ = __webpack_require__(1816);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Upload__["a" /* default */]);

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AjaxUploader__ = __webpack_require__(1823);






/* eslint react/prop-types:0 */



function empty() {}

var Upload = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Upload, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Upload);

  function Upload() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Upload);

    _this = _super.apply(this, arguments);

    _this.saveUploader = function (node) {
      _this.uploader = node;
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Upload, [{
    key: "abort",
    value: function abort(file) {
      this.uploader.abort(file);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AjaxUploader__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]);

  return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Upload.defaultProps = {
  component: 'span',
  prefixCls: 'rc-upload',
  data: {},
  headers: {},
  name: 'file',
  multipart: false,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  multiple: false,
  beforeUpload: null,
  customRequest: null,
  withCredentials: false,
  openFileDialogOnClick: true
};
/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(421);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1822);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_pickAttrs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__request__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__uid__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__attr_accept__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__traverseFileTree__ = __webpack_require__(1836);









/* eslint react/no-is-mounted:0,react/sort-comp:0,react/prop-types:0 */








var AjaxUploader = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(AjaxUploader, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(AjaxUploader);

  function AjaxUploader() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, AjaxUploader);

    _this = _super.apply(this, arguments);
    _this.state = {
      uid: Object(__WEBPACK_IMPORTED_MODULE_12__uid__["a" /* default */])()
    };
    _this.reqs = {};

    _this.onChange = function (e) {
      var files = e.target.files;

      _this.uploadFiles(files);

      _this.reset();
    };

    _this.onClick = function (e) {
      var el = _this.fileInput;

      if (!el) {
        return;
      }

      var _this$props = _this.props,
          children = _this$props.children,
          onClick = _this$props.onClick;

      if (children && children.type === 'button') {
        var parent = el.parentNode;
        parent.focus();
        parent.querySelector('button').blur();
      }

      el.click();

      if (onClick) {
        onClick(e);
      }
    };

    _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        _this.onClick(e);
      }
    };

    _this.onFileDrop = function (e) {
      var multiple = _this.props.multiple;
      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (_this.props.directory) {
        Object(__WEBPACK_IMPORTED_MODULE_14__traverseFileTree__["a" /* default */])(Array.prototype.slice.call(e.dataTransfer.items), _this.uploadFiles, function (_file) {
          return Object(__WEBPACK_IMPORTED_MODULE_13__attr_accept__["a" /* default */])(_file, _this.props.accept);
        });
      } else {
        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
          return Object(__WEBPACK_IMPORTED_MODULE_13__attr_accept__["a" /* default */])(file, _this.props.accept);
        });

        if (multiple === false) {
          files = files.slice(0, 1);
        }

        _this.uploadFiles(files);
      }
    };

    _this.uploadFiles = function (files) {
      var postFiles = Array.prototype.slice.call(files);
      postFiles.map(function (file) {
        // eslint-disable-next-line no-param-reassign
        file.uid = Object(__WEBPACK_IMPORTED_MODULE_12__uid__["a" /* default */])();
        return file;
      }).forEach(function (file) {
        _this.upload(file, postFiles);
      });
    };

    _this.saveFileInput = function (node) {
      _this.fileInput = node;
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(AjaxUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.abort();
    }
  }, {
    key: "upload",
    value: function upload(file, fileList) {
      var _this2 = this;

      var props = this.props;

      if (!props.beforeUpload) {
        // always async in case use react state to keep fileList
        Promise.resolve().then(function () {
          _this2.post(file);
        });
        return;
      }

      var before = props.beforeUpload(file, fileList);

      if (before && typeof before !== 'boolean' && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);

          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            _this2.post(processedFile);

            return;
          }

          _this2.post(file);
        }).catch(function (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        });
      } else if (before !== false) {
        Promise.resolve().then(function () {
          _this2.post(file);
        });
      }
    }
  }, {
    key: "post",
    value: function post(file) {
      var _this3 = this;

      if (!this._isMounted) {
        return;
      }

      var props = this.props;
      var onStart = props.onStart,
          onProgress = props.onProgress,
          _props$transformFile = props.transformFile,
          transformFile = _props$transformFile === void 0 ? function (originFile) {
        return originFile;
      } : _props$transformFile;
      new Promise(function (resolve) {
        var actionRet = props.action;

        if (typeof actionRet === 'function') {
          actionRet = actionRet(file);
        }

        return resolve(actionRet);
      }).then(function (action) {
        var uid = file.uid;
        var request = props.customRequest || __WEBPACK_IMPORTED_MODULE_11__request__["a" /* default */];
        var transform = Promise.resolve(transformFile(file)).then(function (transformedFile) {
          var data = props.data;

          if (typeof data === 'function') {
            data = data(transformedFile);
          }

          return Promise.all([transformedFile, data]);
        }).catch(function (e) {
          console.error(e); // eslint-disable-line no-console
        });
        transform.then(function (_ref) {
          var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
              transformedFile = _ref2[0],
              data = _ref2[1];

          var requestOption = {
            action: action,
            filename: props.name,
            data: data,
            file: transformedFile,
            headers: props.headers,
            withCredentials: props.withCredentials,
            method: props.method || 'post',
            onProgress: onProgress ? function (e) {
              onProgress(e, file);
            } : null,
            onSuccess: function onSuccess(ret, xhr) {
              delete _this3.reqs[uid];
              props.onSuccess(ret, file, xhr);
            },
            onError: function onError(err, ret) {
              delete _this3.reqs[uid];
              props.onError(err, ret, file);
            }
          };
          onStart(file);
          _this3.reqs[uid] = request(requestOption);
        });
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        uid: Object(__WEBPACK_IMPORTED_MODULE_12__uid__["a" /* default */])()
      });
    }
  }, {
    key: "abort",
    value: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file.uid ? file.uid : file;

        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }

        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          Tag = _this$props2.component,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          style = _this$props2.style,
          multiple = _this$props2.multiple,
          accept = _this$props2.accept,
          children = _this$props2.children,
          directory = _this$props2.directory,
          openFileDialogOnClick = _this$props2.openFileDialogOnClick,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          otherProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["component", "prefixCls", "className", "disabled", "id", "style", "multiple", "accept", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave"]);

      var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, prefixCls, true), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-disabled"), disabled), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, className, className), _classNames)); // because input don't have directory/webkitdirectory type declaration

      var dirProps = directory ? {
        directory: 'directory',
        webkitdirectory: 'webkitdirectory'
      } : {};
      var events = disabled ? {} : {
        onClick: openFileDialogOnClick ? this.onClick : function () {},
        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function () {},
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: '0'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, events, {
        className: cls,
        role: "button",
        style: style
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_pickAttrs__["a" /* default */])(otherProps, {
        aria: true,
        data: true
      }), {
        id: id,
        type: "file",
        ref: this.saveFileInput,
        onClick: function onClick(e) {
          return e.stopPropagation();
        } // https://github.com/ant-design/ant-design/issues/19948
        ,
        key: this.state.uid,
        style: {
          display: 'none'
        },
        accept: accept
      }, dirProps, {
        multiple: multiple,
        onChange: this.onChange
      })), children);
    }
  }]);

  return AjaxUploader;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AjaxUploader);

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(777);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1826);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1832);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1831);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upload;
function getError(option, xhr) {
  var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;

  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function upload(option) {
  // eslint-disable-next-line no-undef
  var xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }

      option.onProgress(e);
    };
  } // eslint-disable-next-line no-undef


  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      var value = option.data[key]; // support key-value array data

      if (Array.isArray(value)) {
        value.forEach(function (item) {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
          formData.append("".concat(key, "[]"), item);
        });
        return;
      }

      formData.append(key, option.data[key]);
    });
  } // eslint-disable-next-line no-undef


  if (option.file instanceof Blob) {
    formData.append(option.filename, option.file, option.file.name);
  } else {
    formData.append(option.filename, option.file);
  }

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    return option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open(option.method, option.action, true); // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {}; // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33

  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  Object.keys(headers).forEach(function (h) {
    if (headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  });
  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var now = +new Date();
var index = 0;
function uid() {
  // eslint-disable-next-line no-plusplus
  return "rc-upload-".concat(now, "-").concat(++index);
}

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();

      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      }

      if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
});

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];

  function sequence() {
    dirReader.readEntries(function (entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList); // Check if all the file has been viewed

      var isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}

var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  var _traverseFileTree = function _traverseFileTree(item, path) {
    // eslint-disable-next-line no-param-reassign
    item.path = path || '';

    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          // https://github.com/ant-design/ant-design/issues/16426
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            }); // eslint-disable-next-line no-param-reassign

            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }

          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function (entries) {
        entries.forEach(function (entryItem) {
          _traverseFileTree(entryItem, "".concat(path).concat(item.name, "/"));
        });
      });
    }
  };

  files.forEach(function (file) {
    _traverseFileTree(file.webkitGetAsEntry());
  });
};

/* harmony default export */ __webpack_exports__["a"] = (traverseFileTree);

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMotion = _interopRequireWildcard(__webpack_require__(84));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _LoadingOutlined = _interopRequireDefault(__webpack_require__(162));

var _PaperClipOutlined = _interopRequireDefault(__webpack_require__(1838));

var _PictureTwoTone = _interopRequireDefault(__webpack_require__(1841));

var _FileTwoTone = _interopRequireDefault(__webpack_require__(1844));

var _reactNode = __webpack_require__(57);

var _utils = __webpack_require__(781);

var _motion = _interopRequireDefault(__webpack_require__(662));

var _configProvider = __webpack_require__(8);

var _button = _interopRequireDefault(__webpack_require__(26));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

var _ListItem = _interopRequireDefault(__webpack_require__(1847));

var listItemMotion = (0, _extends2["default"])({}, _motion["default"]);
delete listItemMotion.onAppearEnd;
delete listItemMotion.onEnterEnd;
delete listItemMotion.onLeaveEnd;

var InternalUploadList = function InternalUploadList(_ref, ref) {
  var _classNames;

  var listType = _ref.listType,
      previewFile = _ref.previewFile,
      onPreview = _ref.onPreview,
      onDownload = _ref.onDownload,
      onRemove = _ref.onRemove,
      locale = _ref.locale,
      iconRender = _ref.iconRender,
      isImgUrl = _ref.isImageUrl,
      customizePrefixCls = _ref.prefixCls,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      showPreviewIcon = _ref.showPreviewIcon,
      showRemoveIcon = _ref.showRemoveIcon,
      showDownloadIcon = _ref.showDownloadIcon,
      removeIcon = _ref.removeIcon,
      downloadIcon = _ref.downloadIcon,
      progress = _ref.progress,
      appendAction = _ref.appendAction,
      itemRender = _ref.itemRender;
  var forceUpdate = (0, _useForceUpdate["default"])();

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      motionAppear = _React$useState2[0],
      setMotionAppear = _React$useState2[1]; // ============================= Effect =============================


  React.useEffect(function () {
    if (listType !== 'picture' && listType !== 'picture-card') {
      return;
    }

    (items || []).forEach(function (file) {
      if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
        return;
      }

      file.thumbUrl = '';

      if (previewFile) {
        previewFile(file.originFileObj).then(function (previewDataUrl) {
          // Need append '' to avoid dead loop
          file.thumbUrl = previewDataUrl || '';
          forceUpdate();
        });
      }
    });
  }, [listType, items, previewFile]);
  React.useEffect(function () {
    setMotionAppear(true);
  }, []); // ============================= Events =============================

  var onInternalPreview = function onInternalPreview(file, e) {
    if (!onPreview) {
      return;
    }

    e.preventDefault();
    return onPreview(file);
  };

  var onInternalDownload = function onInternalDownload(file) {
    if (typeof onDownload === 'function') {
      onDownload(file);
    } else if (file.url) {
      window.open(file.url);
    }
  };

  var onInternalClose = function onInternalClose(file) {
    if (onRemove) {
      onRemove(file);
    }
  };

  var internalIconRender = function internalIconRender(file) {
    if (iconRender) {
      return iconRender(file, listType);
    }

    var isLoading = file.status === 'uploading';
    var fileIcon = isImgUrl && isImgUrl(file) ? /*#__PURE__*/React.createElement(_PictureTwoTone["default"], null) : /*#__PURE__*/React.createElement(_FileTwoTone["default"], null);
    var icon = isLoading ? /*#__PURE__*/React.createElement(_LoadingOutlined["default"], null) : /*#__PURE__*/React.createElement(_PaperClipOutlined["default"], null);

    if (listType === 'picture') {
      icon = isLoading ? /*#__PURE__*/React.createElement(_LoadingOutlined["default"], null) : fileIcon;
    } else if (listType === 'picture-card') {
      icon = isLoading ? locale.uploading : fileIcon;
    }

    return icon;
  };

  var actionIconRender = function actionIconRender(customIcon, callback, prefixCls, title) {
    var btnProps = {
      type: 'text',
      size: 'small',
      title: title,
      onClick: function onClick(e) {
        callback();

        if ((0, _reactNode.isValidElement)(customIcon) && customIcon.props.onClick) {
          customIcon.props.onClick(e);
        }
      },
      className: "".concat(prefixCls, "-list-item-card-actions-btn")
    };

    if ((0, _reactNode.isValidElement)(customIcon)) {
      var btnIcon = (0, _reactNode.cloneElement)(customIcon, (0, _extends2["default"])((0, _extends2["default"])({}, customIcon.props), {
        onClick: function onClick() {}
      }));
      return /*#__PURE__*/React.createElement(_button["default"], (0, _extends2["default"])({}, btnProps, {
        icon: btnIcon
      }));
    }

    return /*#__PURE__*/React.createElement(_button["default"], btnProps, /*#__PURE__*/React.createElement("span", null, customIcon));
  }; // ============================== Ref ===============================
  // Test needs


  React.useImperativeHandle(ref, function () {
    return {
      handlePreview: onInternalPreview,
      handleDownload: onInternalDownload
    };
  });

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction; // ============================= Render =============================


  var prefixCls = getPrefixCls('upload', customizePrefixCls);
  var listClassNames = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-list"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-list-").concat(listType), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-list-rtl"), direction === 'rtl'), _classNames)); // >>> Motion config

  var motionKeyList = (0, _toConsumableArray2["default"])(items.map(function (file) {
    return {
      key: file.uid,
      file: file
    };
  }));
  var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate'; // const transitionName = list.length === 0 ? '' : `${prefixCls}-${animationDirection}`;

  var motionConfig = {
    motionName: "".concat(prefixCls, "-").concat(animationDirection),
    keys: motionKeyList,
    motionAppear: motionAppear
  };

  if (listType !== 'picture-card') {
    motionConfig = (0, _extends2["default"])((0, _extends2["default"])({}, listItemMotion), motionConfig);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: listClassNames
  }, /*#__PURE__*/React.createElement(_rcMotion.CSSMotionList, (0, _extends2["default"])({}, motionConfig, {
    component: false
  }), function (_ref2) {
    var key = _ref2.key,
        file = _ref2.file,
        motionClassName = _ref2.className,
        motionStyle = _ref2.style;
    return /*#__PURE__*/React.createElement(_ListItem["default"], {
      key: key,
      locale: locale,
      prefixCls: prefixCls,
      className: motionClassName,
      style: motionStyle,
      file: file,
      items: items,
      progress: progress,
      listType: listType,
      isImgUrl: isImgUrl,
      showPreviewIcon: showPreviewIcon,
      showRemoveIcon: showRemoveIcon,
      showDownloadIcon: showDownloadIcon,
      removeIcon: removeIcon,
      downloadIcon: downloadIcon,
      iconRender: internalIconRender,
      actionIconRender: actionIconRender,
      itemRender: itemRender,
      onPreview: onInternalPreview,
      onDownload: onInternalDownload,
      onClose: onInternalClose
    });
  }), appendAction && /*#__PURE__*/React.createElement(_rcMotion["default"], motionConfig, function (_ref3) {
    var motionClassName = _ref3.className,
        motionStyle = _ref3.style;
    return (0, _reactNode.cloneElement)(appendAction, function (oriProps) {
      return {
        className: (0, _classnames["default"])(oriProps.className, motionClassName),
        style: (0, _extends2["default"])((0, _extends2["default"])({}, motionStyle), oriProps.style)
      };
    });
  }));
};

var UploadList = /*#__PURE__*/React.forwardRef(InternalUploadList);
UploadList.displayName = 'UploadList';
UploadList.defaultProps = {
  listType: 'text',
  progress: {
    strokeWidth: 2,
    showInfo: false
  },
  showRemoveIcon: true,
  showDownloadIcon: false,
  showPreviewIcon: true,
  previewFile: _utils.previewImage,
  isImageUrl: _utils.isImageUrl
};
var _default = UploadList;
exports["default"] = _default;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _PaperClipOutlined = _interopRequireDefault(__webpack_require__(1839));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _PaperClipOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _PaperClipOutlined = _interopRequireDefault(__webpack_require__(1840));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _PaperClipOutlined.default
  }));
};
PaperClipOutlined.displayName = 'PaperClipOutlined';
var _default = /*#__PURE__*/React.forwardRef(PaperClipOutlined);
exports.default = _default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PaperClipOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };
exports.default = PaperClipOutlined;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _PictureTwoTone = _interopRequireDefault(__webpack_require__(1842));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _PictureTwoTone;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _PictureTwoTone = _interopRequireDefault(__webpack_require__(1843));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _PictureTwoTone.default
  }));
};
PictureTwoTone.displayName = 'PictureTwoTone';
var _default = /*#__PURE__*/React.forwardRef(PictureTwoTone);
exports.default = _default;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PictureTwoTone = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] }; }, "name": "picture", "theme": "twotone" };
exports.default = PictureTwoTone;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FileTwoTone = _interopRequireDefault(__webpack_require__(1845));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _FileTwoTone;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _FileTwoTone = _interopRequireDefault(__webpack_require__(1846));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var FileTwoTone = function FileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _FileTwoTone.default
  }));
};
FileTwoTone.displayName = 'FileTwoTone';
var _default = /*#__PURE__*/React.forwardRef(FileTwoTone);
exports.default = _default;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var FileTwoTone = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] }; }, "name": "file", "theme": "twotone" };
exports.default = FileTwoTone;


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcMotion = _interopRequireDefault(__webpack_require__(84));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _EyeOutlined = _interopRequireDefault(__webpack_require__(706));

var _DeleteOutlined = _interopRequireDefault(__webpack_require__(1848));

var _DownloadOutlined = _interopRequireDefault(__webpack_require__(1849));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var _progress = _interopRequireDefault(__webpack_require__(1852));

var ListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames3;

  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      style = _ref.style,
      locale = _ref.locale,
      listType = _ref.listType,
      file = _ref.file,
      items = _ref.items,
      progressProps = _ref.progress,
      iconRender = _ref.iconRender,
      actionIconRender = _ref.actionIconRender,
      itemRender = _ref.itemRender,
      isImgUrl = _ref.isImgUrl,
      showPreviewIcon = _ref.showPreviewIcon,
      showRemoveIcon = _ref.showRemoveIcon,
      showDownloadIcon = _ref.showDownloadIcon,
      customRemoveIcon = _ref.removeIcon,
      customDownloadIcon = _ref.downloadIcon,
      onPreview = _ref.onPreview,
      onDownload = _ref.onDownload,
      onClose = _ref.onClose;

  // Delay to show the progress bar
  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      showProgress = _React$useState2[0],
      setShowProgress = _React$useState2[1];

  var progressRafRef = React.useRef();
  React.useEffect(function () {
    progressRafRef.current = setTimeout(function () {
      setShowProgress(true);
    }, 300);
    return function () {
      window.clearTimeout(progressRafRef.current);
    };
  }, []); // This is used for legacy span make scrollHeight the wrong value.
  // We will force these to be `display: block` with non `picture-card`

  var spanClassName = "".concat(prefixCls, "-span");
  var iconNode = iconRender(file);
  var icon = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-text-icon")
  }, iconNode);

  if (listType === 'picture' || listType === 'picture-card') {
    if (file.status === 'uploading' || !file.thumbUrl && !file.url) {
      var _classNames;

      var uploadingClassName = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-list-item-thumbnail"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-list-item-file"), file.status !== 'uploading'), _classNames));
      icon = /*#__PURE__*/React.createElement("div", {
        className: uploadingClassName
      }, iconNode);
    } else {
      var _classNames2;

      var thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/React.createElement("img", {
        src: file.thumbUrl || file.url,
        alt: file.name,
        className: "".concat(prefixCls, "-list-item-image")
      }) : iconNode;
      var aClassName = (0, _classnames["default"])((_classNames2 = {}, (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-list-item-thumbnail"), true), (0, _defineProperty2["default"])(_classNames2, "".concat(prefixCls, "-list-item-file"), isImgUrl && !isImgUrl(file)), _classNames2));
      icon = /*#__PURE__*/React.createElement("a", {
        className: aClassName,
        onClick: function onClick(e) {
          return onPreview(file, e);
        },
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, thumbnail);
    }
  }

  var infoUploadingClass = (0, _classnames["default"])((_classNames3 = {}, (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-list-item"), true), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-list-item-").concat(file.status), true), (0, _defineProperty2["default"])(_classNames3, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames3));
  var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
  var removeIcon = showRemoveIcon ? actionIconRender((typeof customRemoveIcon === 'function' ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/React.createElement(_DeleteOutlined["default"], null), function () {
    return onClose(file);
  }, prefixCls, locale.removeFile) : null;
  var downloadIcon = showDownloadIcon && file.status === 'done' ? actionIconRender((typeof customDownloadIcon === 'function' ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/React.createElement(_DownloadOutlined["default"], null), function () {
    return onDownload(file);
  }, prefixCls, locale.downloadFile) : null;
  var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
    key: "download-delete",
    className: (0, _classnames["default"])("".concat(prefixCls, "-list-item-card-actions"), {
      picture: listType === 'picture'
    })
  }, downloadIcon, removeIcon);
  var listItemNameClass = (0, _classnames["default"])("".concat(prefixCls, "-list-item-name"));
  var preview = file.url ? [/*#__PURE__*/React.createElement("a", (0, _extends2["default"])({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: listItemNameClass,
    title: file.name
  }, linkProps, {
    href: file.url,
    onClick: function onClick(e) {
      return onPreview(file, e);
    }
  }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
    key: "view",
    className: listItemNameClass,
    onClick: function onClick(e) {
      return onPreview(file, e);
    },
    title: file.name
  }, file.name), downloadOrDelete];
  var previewStyle = {
    pointerEvents: 'none',
    opacity: 0.5
  };
  var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
    href: file.url || file.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    style: file.url || file.thumbUrl ? undefined : previewStyle,
    onClick: function onClick(e) {
      return onPreview(file, e);
    },
    title: locale.previewFile
  }, /*#__PURE__*/React.createElement(_EyeOutlined["default"], null)) : null;
  var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-list-item-actions")
  }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
  var message;

  if (file.response && typeof file.response === 'string') {
    message = file.response;
  } else {
    message = file.error && file.error.statusText || locale.uploadError;
  }

  var iconAndPreview = /*#__PURE__*/React.createElement("span", {
    className: spanClassName
  }, icon, preview);
  var dom = /*#__PURE__*/React.createElement("div", {
    className: infoUploadingClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-list-item-info")
  }, iconAndPreview), actions, showProgress && /*#__PURE__*/React.createElement(_rcMotion["default"], {
    motionName: "fade",
    visible: file.status === 'uploading'
  }, function (_ref2) {
    var motionClassName = _ref2.className;
    // show loading icon if upload progress listener is disabled
    var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], (0, _extends2["default"])({}, progressProps, {
      type: "line",
      percent: file.percent
    })) : null;
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])("".concat(prefixCls, "-list-item-progress"), motionClassName)
    }, loadingProgress);
  }));
  var listContainerNameClass = (0, _classnames["default"])("".concat(prefixCls, "-list-").concat(listType, "-container"), className);
  var item = file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
    title: message,
    getPopupContainer: function getPopupContainer(node) {
      return node.parentNode;
    }
  }, dom) : dom;
  return /*#__PURE__*/React.createElement("div", {
    className: listContainerNameClass,
    style: style,
    ref: ref
  }, itemRender ? itemRender(item, file, items) : item);
});
var _default = ListItem;
exports["default"] = _default;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DeleteOutlined = _interopRequireDefault(__webpack_require__(722));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DeleteOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _DownloadOutlined = _interopRequireDefault(__webpack_require__(1850));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _DownloadOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _DownloadOutlined = _interopRequireDefault(__webpack_require__(1851));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _DownloadOutlined.default
  }));
};
DownloadOutlined.displayName = 'DownloadOutlined';
var _default = /*#__PURE__*/React.forwardRef(DownloadOutlined);
exports.default = _default;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DownloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };
exports.default = DownloadOutlined;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _progress = _interopRequireDefault(__webpack_require__(1853));

var _default = _progress["default"];
exports["default"] = _default;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(203));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _CheckOutlined = _interopRequireDefault(__webpack_require__(635));

var _CheckCircleFilled = _interopRequireDefault(__webpack_require__(258));

var _CloseCircleFilled = _interopRequireDefault(__webpack_require__(115));

var _configProvider = __webpack_require__(8);

var _type = __webpack_require__(118);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _Line = _interopRequireDefault(__webpack_require__(1854));

var _Circle = _interopRequireDefault(__webpack_require__(1855));

var _Steps = _interopRequireDefault(__webpack_require__(1865));

var _utils = __webpack_require__(422);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');

var Progress = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Progress, _React$Component);

  var _super = (0, _createSuper2["default"])(Progress);

  function Progress() {
    var _this;

    (0, _classCallCheck2["default"])(this, Progress);
    _this = _super.apply(this, arguments);

    _this.renderProgress = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          direction = _ref.direction;

      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          className = props.className,
          size = props.size,
          type = props.type,
          steps = props.steps,
          showInfo = props.showInfo,
          strokeColor = props.strokeColor,
          restProps = __rest(props, ["prefixCls", "className", "size", "type", "steps", "showInfo", "strokeColor"]);

      var prefixCls = getPrefixCls('progress', customizePrefixCls);

      var progressStatus = _this.getProgressStatus();

      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);

      (0, _devWarning["default"])(!('successPercent' in props), 'Progress', '`successPercent` is deprecated. Please use `success.percent` instead.');
      var progress; // Render progress shape

      if (type === 'line') {
        progress = steps ? /*#__PURE__*/React.createElement(_Steps["default"], (0, _extends2["default"])({}, _this.props, {
          strokeColor: typeof strokeColor === 'string' ? strokeColor : undefined,
          prefixCls: prefixCls,
          steps: steps
        }), progressInfo) : /*#__PURE__*/React.createElement(_Line["default"], (0, _extends2["default"])({}, _this.props, {
          prefixCls: prefixCls,
          direction: direction
        }), progressInfo);
      } else if (type === 'circle' || type === 'dashboard') {
        progress = /*#__PURE__*/React.createElement(_Circle["default"], (0, _extends2["default"])({}, _this.props, {
          prefixCls: prefixCls,
          progressStatus: progressStatus
        }), progressInfo);
      }

      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || steps && 'steps' || type), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-show-info"), showInfo), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-").concat(size), size), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
      return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent', 'steps', 'success', 'successPercent']), {
        className: classString
      }), progress);
    };

    return _this;
  }

  (0, _createClass2["default"])(Progress, [{
    key: "getPercentNumber",
    value: function getPercentNumber() {
      var _this$props$percent = this.props.percent,
          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
      var successPercent = (0, _utils.getSuccessPercent)(this.props);
      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    }
  }, {
    key: "getProgressStatus",
    value: function getProgressStatus() {
      var status = this.props.status;

      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
        return 'success';
      }

      return status || 'normal';
    }
  }, {
    key: "renderProcessInfo",
    value: function renderProcessInfo(prefixCls, progressStatus) {
      var _this$props = this.props,
          showInfo = _this$props.showInfo,
          format = _this$props.format,
          type = _this$props.type,
          percent = _this$props.percent;
      var successPercent = (0, _utils.getSuccessPercent)(this.props);
      if (!showInfo) return null;
      var text;

      var textFormatter = format || function (percentNumber) {
        return "".concat(percentNumber, "%");
      };

      var isLineType = type === 'line';

      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
      } else if (progressStatus === 'exception') {
        text = isLineType ? /*#__PURE__*/React.createElement(_CloseCircleFilled["default"], null) : /*#__PURE__*/React.createElement(_CloseOutlined["default"], null);
      } else if (progressStatus === 'success') {
        text = isLineType ? /*#__PURE__*/React.createElement(_CheckCircleFilled["default"], null) : /*#__PURE__*/React.createElement(_CheckOutlined["default"], null);
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-text"),
        title: typeof text === 'string' ? text : undefined
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress);
    }
  }]);
  return Progress;
}(React.Component);

exports["default"] = Progress;
Progress.defaultProps = {
  type: 'line',
  percent: 0,
  showInfo: true,
  // null for different theme definition
  trailColor: null,
  size: 'default',
  gapDegree: undefined,
  strokeLinecap: 'round'
};

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.handleGradient = exports.sortGradient = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _colors = __webpack_require__(782);

var _utils = __webpack_require__(422);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * @example
 *   {
 *     "0%": "#afc163",
 *     "75%": "#009900",
 *     "50%": "green", // ====> '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
 *     "25%": "#66FF00",
 *     "100%": "#ffffff"
 *   }
 */
var sortGradient = function sortGradient(gradients) {
  var tempArr = [];
  Object.keys(gradients).forEach(function (key) {
    var formattedKey = parseFloat(key.replace(/%/g, ''));

    if (!isNaN(formattedKey)) {
      tempArr.push({
        key: formattedKey,
        value: gradients[key]
      });
    }
  });
  tempArr = tempArr.sort(function (a, b) {
    return a.key - b.key;
  });
  return tempArr.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return "".concat(value, " ").concat(key, "%");
  }).join(', ');
};
/**
 * Then this man came to realize the truth: Besides six pence, there is the moon. Besides bread and
 * butter, there is the bug. And... Besides women, there is the code.
 *
 * @example
 *   {
 *     "0%": "#afc163",
 *     "25%": "#66FF00",
 *     "50%": "#00CC00", // ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
 *     "75%": "#009900", //        #00CC00 50%, #009900 75%, #ffffff 100%)
 *     "100%": "#ffffff"
 *   }
 */


exports.sortGradient = sortGradient;

var handleGradient = function handleGradient(strokeColor, directionConfig) {
  var _strokeColor$from = strokeColor.from,
      from = _strokeColor$from === void 0 ? _colors.presetPrimaryColors.blue : _strokeColor$from,
      _strokeColor$to = strokeColor.to,
      to = _strokeColor$to === void 0 ? _colors.presetPrimaryColors.blue : _strokeColor$to,
      _strokeColor$directio = strokeColor.direction,
      direction = _strokeColor$directio === void 0 ? directionConfig === 'rtl' ? 'to left' : 'to right' : _strokeColor$directio,
      rest = __rest(strokeColor, ["from", "to", "direction"]);

  if (Object.keys(rest).length !== 0) {
    var sortedGradients = sortGradient(rest);
    return {
      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
    };
  }

  return {
    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
  };
};

exports.handleGradient = handleGradient;

var Line = function Line(props) {
  var prefixCls = props.prefixCls,
      directionConfig = props.direction,
      percent = props.percent,
      strokeWidth = props.strokeWidth,
      size = props.size,
      strokeColor = props.strokeColor,
      strokeLinecap = props.strokeLinecap,
      children = props.children,
      trailColor = props.trailColor,
      success = props.success;
  var backgroundProps = strokeColor && typeof strokeColor !== 'string' ? handleGradient(strokeColor, directionConfig) : {
    background: strokeColor
  };
  var trailStyle = trailColor ? {
    backgroundColor: trailColor
  } : undefined;
  var percentStyle = (0, _extends2["default"])({
    width: "".concat((0, _utils.validProgress)(percent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : ''
  }, backgroundProps);
  var successPercent = (0, _utils.getSuccessPercent)(props);
  var successPercentStyle = {
    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
    height: strokeWidth || (size === 'small' ? 6 : 8),
    borderRadius: strokeLinecap === 'square' ? 0 : '',
    backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
  };
  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-success-bg"),
    style: successPercentStyle
  }) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-outer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    style: trailStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-bg"),
    style: percentStyle
  }), successSegment)), children);
};

var _default = Line;
exports["default"] = _default;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcProgress = __webpack_require__(1856);

var _colors = __webpack_require__(782);

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _utils = __webpack_require__(422);

function getPercentage(_ref) {
  var percent = _ref.percent,
      success = _ref.success,
      successPercent = _ref.successPercent;
  var ptg = (0, _utils.validProgress)(percent);
  var realSuccessPercent = (0, _utils.getSuccessPercent)({
    success: success,
    successPercent: successPercent
  });

  if (!realSuccessPercent) {
    return ptg;
  }

  return [(0, _utils.validProgress)(realSuccessPercent), (0, _utils.validProgress)(ptg - (0, _utils.validProgress)(realSuccessPercent))];
}

function getStrokeColor(_ref2) {
  var success = _ref2.success,
      strokeColor = _ref2.strokeColor,
      successPercent = _ref2.successPercent;
  var color = strokeColor || null;
  var realSuccessPercent = (0, _utils.getSuccessPercent)({
    success: success,
    successPercent: successPercent
  });

  if (!realSuccessPercent) {
    return color;
  }

  return [_colors.presetPrimaryColors.green, color];
}

var Circle = function Circle(props) {
  var prefixCls = props.prefixCls,
      width = props.width,
      strokeWidth = props.strokeWidth,
      trailColor = props.trailColor,
      strokeLinecap = props.strokeLinecap,
      gapPosition = props.gapPosition,
      gapDegree = props.gapDegree,
      type = props.type,
      children = props.children;
  var circleSize = width || 120;
  var circleStyle = {
    width: circleSize,
    height: circleSize,
    fontSize: circleSize * 0.15 + 6
  };
  var circleWidth = strokeWidth || 6;
  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';

  var getGapDegree = function getGapDegree() {
    // Support gapDeg = 0 when type = 'dashboard'
    if (gapDegree || gapDegree === 0) {
      return gapDegree;
    }

    if (type === 'dashboard') {
      return 75;
    }

    return undefined;
  }; // using className to style stroke color


  var strokeColor = getStrokeColor(props);
  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
    percent: getPercentage(props),
    strokeWidth: circleWidth,
    trailWidth: circleWidth,
    strokeColor: strokeColor,
    strokeLinecap: strokeLinecap,
    trailColor: trailColor,
    prefixCls: prefixCls,
    gapDegree: getGapDegree(),
    gapPosition: gapPos
  }), children);
};

var _default = Circle;
exports["default"] = _default;

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Line__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Circle__ = __webpack_require__(1864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__Line__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_1__Circle__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = ({
  Line: __WEBPACK_IMPORTED_MODULE_0__Line__["a" /* default */],
  Circle: __WEBPACK_IMPORTED_MODULE_1__Circle__["a" /* default */]
});

/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(786);







var Line = function Line(_ref) {
  var className = _ref.className,
      percent = _ref.percent,
      prefixCls = _ref.prefixCls,
      strokeColor = _ref.strokeColor,
      strokeLinecap = _ref.strokeLinecap,
      strokeWidth = _ref.strokeWidth,
      style = _ref.style,
      trailColor = _ref.trailColor,
      trailWidth = _ref.trailWidth,
      transition = _ref.transition,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"]);

  // eslint-disable-next-line no-param-reassign
  delete restProps.gapPosition;
  var percentList = Array.isArray(percent) ? percent : [percent];
  var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];

  var _useTransitionDuratio = Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* useTransitionDuration */])(percentList),
      _useTransitionDuratio2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTransitionDuratio, 1),
      paths = _useTransitionDuratio2[0];

  var center = strokeWidth / 2;
  var right = 100 - strokeWidth / 2;
  var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
  var viewBoxString = "0 0 100 ".concat(strokeWidth);
  var stackPtg = 0;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("".concat(prefixCls, "-line"), className),
    viewBox: viewBoxString,
    preserveAspectRatio: "none",
    style: style
  }, restProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    className: "".concat(prefixCls, "-line-trail"),
    d: pathString,
    strokeLinecap: strokeLinecap,
    stroke: trailColor,
    strokeWidth: trailWidth || strokeWidth,
    fillOpacity: "0"
  }), percentList.map(function (ptg, index) {
    var dashPercent = 1;

    switch (strokeLinecap) {
      case 'round':
        dashPercent = 1 - strokeWidth / 100;
        break;

      case 'square':
        dashPercent = 1 - strokeWidth / 2 / 100;
        break;

      default:
        dashPercent = 1;
        break;
    }

    var pathStyle = {
      strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
      strokeDashoffset: "-".concat(stackPtg, "px"),
      transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
    };
    var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
    stackPtg += ptg;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
      key: index,
      className: "".concat(prefixCls, "-line-path"),
      d: pathString,
      strokeLinecap: strokeLinecap,
      stroke: color,
      strokeWidth: strokeWidth,
      fillOpacity: "0",
      ref: paths[index],
      style: pathStyle
    });
  }));
};

Line.defaultProps = __WEBPACK_IMPORTED_MODULE_5__common__["a" /* defaultProps */];
Line.displayName = 'Line';
/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1861);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(786);






var gradientSeed = 0;

function stripPercentToNumber(percent) {
  return +percent.replace('%', '');
}

function toArray(symArray) {
  return Array.isArray(symArray) ? symArray : [symArray];
}

function getPathStyles(offset, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : undefined;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;

  switch (gapPosition) {
    case 'left':
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;

    case 'right':
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;

    case 'bottom':
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;

    default:
  }

  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s' // eslint-disable-line

  };
  return {
    pathString: pathString,
    pathStyle: pathStyle
  };
}

var Circle = function Circle(_ref) {
  var prefixCls = _ref.prefixCls,
      strokeWidth = _ref.strokeWidth,
      trailWidth = _ref.trailWidth,
      gapDegree = _ref.gapDegree,
      gapPosition = _ref.gapPosition,
      trailColor = _ref.trailColor,
      strokeLinecap = _ref.strokeLinecap,
      style = _ref.style,
      className = _ref.className,
      strokeColor = _ref.strokeColor,
      percent = _ref.percent,
      restProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"]);

  var gradientId = __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"](function () {
    gradientSeed += 1;
    return gradientSeed;
  }, []);

  var _getPathStyles = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
      pathString = _getPathStyles.pathString,
      pathStyle = _getPathStyles.pathStyle;

  var percentList = toArray(percent);
  var strokeColorList = toArray(strokeColor);
  var gradient = strokeColorList.find(function (color) {
    return Object.prototype.toString.call(color) === '[object Object]';
  });

  var _useTransitionDuratio = Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* useTransitionDuration */])(percentList),
      _useTransitionDuratio2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useTransitionDuratio, 1),
      paths = _useTransitionDuratio2[0];

  var getStokeList = function getStokeList() {
    var stackPtg = 0;
    return percentList.map(function (ptg, index) {
      var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
      var stroke = Object.prototype.toString.call(color) === '[object Object]' ? "url(#".concat(prefixCls, "-gradient-").concat(gradientId, ")") : '';
      var pathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition);
      stackPtg += ptg;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
        key: index,
        className: "".concat(prefixCls, "-circle-path"),
        d: pathStyles.pathString,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        fillOpacity: "0",
        style: pathStyles.pathStyle,
        ref: paths[index]
      });
    });
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("svg", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()("".concat(prefixCls, "-circle"), className),
    viewBox: "0 0 100 100",
    style: style
  }, restProps), gradient && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("linearGradient", {
    id: "".concat(prefixCls, "-gradient-").concat(gradientId),
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "0%"
  }, Object.keys(gradient).sort(function (a, b) {
    return stripPercentToNumber(a) - stripPercentToNumber(b);
  }).map(function (key, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("stop", {
      key: index,
      offset: key,
      stopColor: gradient[key]
    });
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    className: "".concat(prefixCls, "-circle-trail"),
    d: pathString,
    stroke: trailColor,
    strokeLinecap: strokeLinecap,
    strokeWidth: trailWidth || strokeWidth,
    fillOpacity: "0",
    style: pathStyle
  }), getStokeList().reverse());
};

Circle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__common__["a" /* defaultProps */];
Circle.displayName = 'Circle';
/* harmony default export */ __webpack_exports__["a"] = (Circle);

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var Steps = function Steps(props) {
  var size = props.size,
      steps = props.steps,
      _props$percent = props.percent,
      percent = _props$percent === void 0 ? 0 : _props$percent,
      _props$strokeWidth = props.strokeWidth,
      strokeWidth = _props$strokeWidth === void 0 ? 8 : _props$strokeWidth,
      strokeColor = props.strokeColor,
      trailColor = props.trailColor,
      prefixCls = props.prefixCls,
      children = props.children;
  var current = Math.round(steps * (percent / 100));
  var stepWidth = size === 'small' ? 2 : 14;
  var styledSteps = [];

  for (var i = 0; i < steps; i += 1) {
    styledSteps.push( /*#__PURE__*/React.createElement("div", {
      key: i,
      className: (0, _classnames["default"])("".concat(prefixCls, "-steps-item"), (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-steps-item-active"), i <= current - 1)),
      style: {
        backgroundColor: i <= current - 1 ? strokeColor : trailColor,
        width: stepWidth,
        height: strokeWidth
      }
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-steps-outer")
  }, styledSteps, children);
};

var _default = Steps;
exports["default"] = _default;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFreshState;

var _react = __webpack_require__(0);

var _raf = _interopRequireDefault(__webpack_require__(176));

var _useForceUpdate = _interopRequireDefault(__webpack_require__(185));

// Note. Only for upload usage. Do not export to global util hooks
function useFreshState(defaultValue, propValue) {
  var valueRef = (0, _react.useRef)(defaultValue);
  var forceUpdate = (0, _useForceUpdate["default"])();
  var rafRef = (0, _react.useRef)(); // Set value

  function setValue(newValue) {
    valueRef.current = newValue;
    forceUpdate();
  }

  function cleanUp() {
    _raf["default"].cancel(rafRef.current);
  }

  function rafSyncValue(newValue) {
    cleanUp();
    rafRef.current = (0, _raf["default"])(function () {
      setValue(newValue);
    });
  } // Get value


  function getValue() {
    var displayValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (displayValue) {
      return propValue || valueRef.current;
    }

    return valueRef.current;
  } // Effect will always update in a next frame to avoid sync state overwrite current processing state


  (0, _react.useEffect)(function () {
    if (propValue) {
      rafSyncValue(propValue);
    }
  }, [propValue]); // Clean up

  (0, _react.useEffect)(function () {
    return function () {
      cleanUp();
    };
  }, []);
  return [getValue, setValue];
}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataOrAriaProps;

function getDataOrAriaProps(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
      prev[key] = props[key];
    }

    return prev;
  }, {});
}

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ = _interopRequireDefault(__webpack_require__(423));

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);

  var _super = (0, _createSuper2["default"])(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = _super.apply(this, arguments);
    _this.state = {
      error: undefined,
      info: {
        componentStack: ''
      }
    };
    return _this;
  }

  (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          message = _this$props.message,
          description = _this$props.description,
          children = _this$props.children;
      var _this$state = this.state,
          error = _this$state.error,
          info = _this$state.info;
      var componentStack = info && info.componentStack ? info.componentStack : null;
      var errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
      var errorDescription = typeof description === 'undefined' ? componentStack : description;

      if (error) {
        return /*#__PURE__*/React.createElement(_["default"], {
          type: "error",
          message: errorMessage,
          description: /*#__PURE__*/React.createElement("pre", null, errorDescription)
        });
      }

      return children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);

exports["default"] = ErrorBoundary;

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StoreInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_card_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_EyeOutlined__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_EyeOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_EyeOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_time_picker_style__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_tabs_style__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_tabs_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_antd_lib_tabs_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_tabs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_antd_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__styles_module_scss__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__brands_json__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__brands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__brands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a.Option;var TabPane=__WEBPACK_IMPORTED_MODULE_37_antd_lib_tabs___default.a.TabPane;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var StoreInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_46_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_47_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(StoreInfo,_Component);function StoreInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreInfo.__proto__||Object.getPrototypeOf(StoreInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_40_react___default.a.createRef(),_this.state={storeInfo:{status:1,name:null,account:null,type:1,email:null,phone:null,tax_no:null,roles:[4],permissions:{},last_online_date:null,modified_date:null,modified_user_name:null},data:[],messages:{},isFetchData:false,isSubmitData:false,is24:false,searchItem:'',checked:true,previewImage:null,banners:[]},_this.fillData=function(data){if(!_this.formRef.current)return;if(data.mon_start&&data.mon_end){data.day1_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'mon_start'),'HH:mm');data.day1_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'mon_end'),'HH:mm');}if(data.tue_start&&data.tue_end){data.day2_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'tue_start'),'HH:mm');data.day2_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'tue_end'),'HH:mm');}if(data.wed_start&&data.wed_end){data.day3_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'wed_start'),'HH:mm');data.day3_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'wed_end'),'HH:mm');}if(data.thur_start&&data.thur_end){data.day4_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'thur_start'),'HH:mm');data.day4_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'thur_end'),'HH:mm');}if(data.fri_start&&data.fri_end){data.day5_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'fri_start'),'HH:mm');data.day5_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'fri_end'),'HH:mm');}if(data.sat_start&&data.sat_end){data.day6_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'sat_start'),'HH:mm');data.day6_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'sat_end'),'HH:mm');}if(data.sun_start&&data.sun_end){data.day7_1=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'sun_start'),'HH:mm');data.day7_2=__WEBPACK_IMPORTED_MODULE_44_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'sun_end'),'HH:mm');}// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isNil(data.address)||!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isObject(data.address)){data.address={city_id:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'city_id'),area_id:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'area_id')};}data.deliveries=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(data.deliveries,function(vendor){return Object.assign({},vendor,{image:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(vendor,'icon_url')!==null?{uid:0,path:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(vendor,'icon'),url:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(vendor,'icon_url')}:null});});if(!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isBoolean(data.status))data.status=data.status===1;if(!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isBoolean(data.scango_flg))data.scango_flg=data.scango_flg===1;_this.setState({checked:data.scango_flg});__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(data.images,function(item,idx){if(item.path==null||item.url==null){data.images.splice(idx,1);}});_this.setState({is24:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'is24h')});_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_49__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_50__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/stores/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/stores');return;}_this.fillData(data);});},_this.submitData=function(){var storeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day1_1'))storeInfo.mon_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day1_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day1_2'))storeInfo.mon_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day1_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day2_1'))storeInfo.tue_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day2_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day2_2'))storeInfo.tue_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day2_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day3_1'))storeInfo.wed_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day3_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day3_2'))storeInfo.wed_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day3_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day4_1'))storeInfo.thur_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day4_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day4_2'))storeInfo.thur_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day4_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day5_1'))storeInfo.fri_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day5_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day5_2'))storeInfo.fri_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day5_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day6_1'))storeInfo.sat_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day6_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day6_2'))storeInfo.sat_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day6_2').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day7_1'))storeInfo.sun_start=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day7_1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day7_2'))storeInfo.sun_end=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'day7_2').format('HH:mm');storeInfo.is24h=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'state.is24');delete storeInfo.day1;delete storeInfo.day2;delete storeInfo.day3;delete storeInfo.day4;delete storeInfo.day5;delete storeInfo.day6;delete storeInfo.day7;storeInfo.city_id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'address.city_id');storeInfo.area_id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'address.area_id');storeInfo.street=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'street');storeInfo.status=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'status')?1:0;storeInfo.scango_flg=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(storeInfo,'scango_flg')?1:2;//取得「英文資訊」頁籤資料
storeInfo.en_bus_info=_this.formRef.current.getFieldValue('en_bus_info');//storeInfo.en_business_hours = this.formRef.current.getFieldValue('en_business_hours')
storeInfo.en_business_hours_special=_this.formRef.current.getFieldValue('en_business_hours_special');storeInfo.en_name=_this.formRef.current.getFieldValue('en_name');storeInfo.en_parking_info=_this.formRef.current.getFieldValue('en_parking_info');storeInfo.en_street=_this.formRef.current.getFieldValue('en_street');storeInfo.en_traffic_info=_this.formRef.current.getFieldValue('en_traffic_info');//取得「店內服務」、「美食餐廳」、「專櫃介紹」頁籤資料
storeInfo.service_ids=_this.formRef.current.getFieldValue('service_ids');storeInfo.food_ids=_this.formRef.current.getFieldValue('food_ids');storeInfo.common_ids=_this.formRef.current.getFieldValue('common_ids');delete storeInfo['address'];storeInfo.deliveries=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(storeInfo.deliveries,function(vendor){return Object.assign({},vendor,{icon:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(vendor,'image.path')});});// storeInfo.vip_store = _.map(storeInfo.vip_store, (vips) => ({
//   id: vips.brand_id,
//   is_vip: 1,
// }));
var current_user=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');storeInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id','');console.log('storeInfo',storeInfo);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_49__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_50__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/stores/'+id),storeInfo,function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.success('建立成功');_this.setState({storeInfo:data});return _this.props.history.replace('/stores/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_49__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_50__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/stores/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/stores');});},_this.reloadMaps=function(){var _this$state=_this.state,map=_this$state.map,maps=_this$state.maps;if(!maps||!map)return;if(Array.isArray(_this.state.markers)){_this.state.markers.forEach(function(marker){return marker.setMap(null);});}// zoom預設為能呈現出地形等高線的大小
// 所以改成呈現最新的裝置位置
var bounds=new maps.LatLngBounds();var stores=[{name:_this.formRef.current.getFieldValue('name'),latitude:parseFloat(_this.formRef.current.getFieldValue('latitude')),longitude:parseFloat(_this.formRef.current.getFieldValue('longitude'))}];var markers=stores.map(function(store,idx){var marker=new maps.Marker({map:map,position:{lat:store.latitude,lng:store.longitude},store:store});var infowindow=new maps.InfoWindow({content:store.name});marker.addListener('mouseover',function(){infowindow.open(map,marker);});marker.addListener('mouseout',function(){infowindow.close();});if(idx==0){bounds.extend(marker.getPosition());}return marker;});map.fitBounds(bounds);map.setZoom(16);_this.setState({markers:markers});},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){}else e.preventDefault();}},_this.handleFinishFailed=function(errorInfo){if(errorInfo&&errorInfo.errorFields){var fieldNamesMap={name:'分店中文名稱',full_name:'分店完整名稱',tax_id:'分店統一編號',scs_number_id:'詢問對象流水號',scs_number:'聯絡我們代碼',address:'地址',street:'地址'};var emptyFields=[];errorInfo.errorFields.forEach(function(field){var fieldKey=field.name[0];if(fieldNamesMap[fieldKey]){if(!emptyFields.includes(fieldNamesMap[fieldKey])){emptyFields.push(fieldNamesMap[fieldKey]);}}else if(fieldKey==='deliveries'){if(!emptyFields.includes('第三方平台連結')){emptyFields.push('第三方平台連結');}}});if(emptyFields.length>0){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error('['+emptyFields.join('、')+' \u70BA\u5FC5\u586B]');}}},_this.set24h=function(value){_this.formRef.current.setFieldsValue({day1_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day1_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day2_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day2_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day3_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day3_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day4_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day4_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day5_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day5_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day6_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day6_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),day7_1:__WEBPACK_IMPORTED_MODULE_44_moment___default()('00:00','HH:mm'),day7_2:__WEBPACK_IMPORTED_MODULE_44_moment___default()('23:59','HH:mm'),is24h:value});_this.setState({is24:value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_51_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();}// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;var _state=this.state,storeInfo=_state.storeInfo,messages=_state.messages,is24=_state.is24;var errors=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_43_validatorjs_src_errors___default.a());// 登入使用者的權限
var editorPermissions=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this,'props.app.options',{});var privileges=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(window,'VC_CONFIG.privileges');var id=parseInt(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this,'props.match.params.id'),10);var isEdit=!isNaN(id);var storesModify=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(privileges,'stores.modify',[]);var canCreate=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(privileges,'stores.create',false);var canEdit=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.indexOf(storesModify,'all')!==-1||__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.indexOf(storesModify,id)!==-1;var banners=this.formRef.current?this.formRef.current.getFieldValue('banners'):[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_48__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_41_react_router_dom__["b" /* Link */],{to:'/stores'},'\u5206\u5E97\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a.Item,null,'\u5206\u5E97\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u5206\u5E97\u8CC7\u8A0A',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_54__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onFinishFailed:this.handleFinishFailed,onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);}},(canCreate||canEdit)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_tabs___default.a,{animated:false},wp.element.createElement(TabPane,{tab:'\u4E2D\u6587\u8CC7\u8A0A',key:'1'},wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('full_name','分店完整名稱'),{rules:[{required:true,message:'請輸入分店完整名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('tax_id','分店統一編號'),{rules:[{required:true,message:'請輸入分店統一編號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','分店中文名稱'),{rules:[{required:true,message:'請輸入分店中文名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('scs_number_id','詢問對象流水號'),{rules:[{required:true,message:'請選擇詢問對象流水號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,null,__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'store_scs_number_id',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('scs_number','聯絡我們代碼請勿更動'),{rules:[{required:true,message:'請輸入購物流水號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,{disabled:isEdit})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('status','狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('code','分店代號'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('sn','分店代碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('sort','排序'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('scango_flg','Scan & go'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_switch___default.a,{unCheckedChildren:'\u505C\u7528',checkedChildren:'\u555F\u7528',checked:this.state.checked,onChange:function onChange(checked){return _this2.setState(Object.assign({},_this2.state,{checked:checked}));}}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('store_area_id','分店所在地區'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,null,__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'store_areas',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('store_group_id','分店群組'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,null,__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'store_groups',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('store_type_id','分店型態'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,null,__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'store_types',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);})))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('fb','臉書代碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('contact_name','連絡人'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('contact_email','連絡信箱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('contact_tel','電話號碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('contact_tel_ext','分機號碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('contact_fax','傳真號碼'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('address','地址'),{rules:[{required:true,message:'請輸入地址'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.Group,{compact:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'address',noStyle:true,rules:[{required:true,message:'請選擇縣市區域'}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_52_components_CitySelect_CitySelect__["a" /* default */],{placeholder:'\u7E23\u5E02\u5340\u57DF',style:{width:'30%'}})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'street',noStyle:true,rules:[{required:true,message:'請輸入地址'}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,{style:{width:'70%'},placeholder:'\u8F38\u5165\u5730\u5740'})))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('store_link','商家連結'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,{style:{width:'100%'}})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('latitude','GPS緯度'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'}})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('longitude','GPS經度'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'}}))),wp.element.createElement('div',{style:{height:'40vh',width:'100%'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_45_google_map_react___default.a,{bootstrapURLKeys:{key:__WEBPACK_IMPORTED_MODULE_50__configs_env__["f" /* GOOGLE_MAP_KEY */]},defaultCenter:[25.0349656,121.5444463],defaultZoom:13,options:{mapTypeControl:false},onGoogleApiLoaded:function onGoogleApiLoaded(_ref2){var map=_ref2.map,maps=_ref2.maps;return _this2.setState({map:map,maps:maps},function(){return _this2.reloadMaps();});}}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',null,wp.element.createElement('div',{style:{paddingTop:'10px',paddingBottom:'10px'}},'\u71DF\u696D\u6642\u9593',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox___default.a,{style:{paddingLeft:'130px'},checked:this.state.is24,onChange:function onChange(e){_this2.set24h(e.target.checked);}},'24\u5C0F\u6642\u71DF\u696D')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u4E00\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day1_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day1_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u4E8C\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day2_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day2_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u4E09\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day3_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day3_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u56DB\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day4_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day4_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u4E94\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day5_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day5_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u516D\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day6_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day6_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement('div',{style:{flex:'none'}},'\u9031\u65E5\uFF1A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day7_1'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:'day7_2'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_time_picker___default.a,{disabled:is24,format:'HH:mm'})))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('business_hours_special','特殊營業時間'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:15}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('parking_info','停車收費方式'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10})),wp.element.createElement('div',null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('parking_spaces_moto','機車車位數'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('parking_spaces_car','汽車車位數'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'},min:0}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('parking_spaces_handicapped','殘障車位數'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('parking_spaces_parent','親子車位數'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_input_number___default.a,{style:{width:'100%'},min:0}))))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('bus_info','公車資訊'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('traffic_info','其他交通資訊'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('images','樓層圖'),{valuePropName:'fileList',extra:'\u7B2C\u4E00\u5F35\u5716\u7247\u8ACB\u4F7F\u7528\u5E97\u5916\u89C0\u5716\uFF0C\u5EFA\u8B70\u89E3\u6790\u5EA6 \u5BEC1000x\u9AD8500\uFF0C\u6700\u4F73\u6BD4\u4F8B 2:1'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_53_components_WUpload_WUpload__["b" /* default */],{name:'image',listType:'picture('},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' \u4E0A\u50B3 \u5BEC1000x\u9AD8500\uFF0C\u6700\u4F73\u6BD4\u4F8B 2:1')))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('banners','分店公告圖'),{valuePropName:'fileList',extra:'\u5BEC530 x \u9AD8365 \u6700\u4F73\u6BD4\u4F8B 2:1'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_53_components_WUpload_WUpload__["b" /* default */],{multiple:true,showUploadList:false,onChange:function onChange(fileList){_this2.setState({banners:fileList});}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' \u4E0A\u50B3')))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'banners'},function(fields,_ref3){var add=_ref3.add,remove=_ref3.remove,move=_ref3.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_table___default.a,{dataSource:banners,pagination:false,rowKey:'id',components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){console.log('1',banners);console.log('2',_this2.state.banners);return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){move(dragIndex,hoverIndex);_this2.setState({banners:banners});}};},columns:[{dataIndex:'id',title:'#'},{dataIndex:'url',title:'圖片',render:function render(url){return wp.element.createElement('div',{className:'tableImg',style:{backgroundImage:'url('+url+')'},alt:'avatar'});}},{dataIndex:'link',title:'分店公告圖URL',render:function render(text,record,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'link']),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'id',title:'Action',key:'tools',width:250,render:function render(id,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_57_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{size:'small',onConfirm:function onConfirm(){remove(banners.indexOf(record));_this2.setState({banners:_this2.state.banners.filter(function(b){return b.id!==record.id;})});}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_EyeOutlined___default.a,null),onClick:function onClick(){return _this2.setState({previewImage:{url:record.url}});}},'\u6AA2\u8996')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a.Item,null,item);}});}}]});}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_divider___default.a,null,'\u7B2C\u4E09\u65B9\u5E73\u53F0'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'deliveries'},function(fields,_ref4){var add=_ref4.add,remove=_ref4.remove,move=_ref4.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return idx+1;}},{dataIndex:'portion',title:'平台',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'vendor_id']),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'vendors',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))));}},{dataIndex:'portion',title:'品牌',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'brand_id']),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'brands',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))));}},{dataIndex:'portion',title:'連結',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'url']),{rules:[{required:true,message:'請填寫連結'},{type:'url',message:'請填寫正確連結'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'));})),wp.element.createElement(TabPane,{tab:'\u82F1\u6587\u8CC7\u8A0A',key:'2'},wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_name','分店英文名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{label:'\u82F1\u6587\u5730\u5740'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.Group,{compact:true},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({noStyle:true},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('address','縣市區域')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_52_components_CitySelect_CitySelect__["a" /* default */],{placeholder:'\u7E23\u5E02\u5340\u57DF\uFF08\u82F1\u6587\uFF09',style:{width:'30%'},language:'en'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({noStyle:true},Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_street','英文地址')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,{style:{width:'70%'}})))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_business_hours_special','特殊營業時間(英文）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_parking_info','停車收費方式(英文）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10})),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_bus_info','公車資訊(英文）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_55_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_traffic_info','其他交通資訊(英文）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:10})))),[{tabKey:'services',fieldName:'service_ids',optionKey:'service_categories',name:'店內服務'},{tabKey:'foods',fieldName:'food_ids',optionKey:'food_categories',name:'美食餐廳'},{tabKey:'brands',fieldName:'common_ids',optionKey:'brand_categories',name:'專櫃介紹'}].map(function(tabInfo){return wp.element.createElement(TabPane,{tab:tabInfo.name,key:tabInfo.tabKey},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,{value:_this2.state.searchItem,placeholder:'input search text',onChange:function onChange(e){_this2.setState({searchItem:e.target.value},function(){var value=_this2.formRef.current.getFieldValue(tabInfo.fieldName);});},style:{width:200}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{name:tabInfo.fieldName},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox___default.a.Group,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,tabInfo.optionKey,[]),function(categoryInfo){if(categoryInfo.items.filter(function(item){if(item.name.length>0&&item.name.indexOf(_this2.state.searchItem)>-1)return true;else return false;}).length>0)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_divider___default.a,null,categoryInfo.name),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a,{grid:listGrid,dataSource:categoryInfo.items.filter(function(item){if(item.name.length>0&&item.name.indexOf(_this2.state.searchItem)>-1)return true;else return false;}),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a,{hoverable:true,bodyStyle:cardBodyStyle,style:{width:'100%'},cover:wp.element.createElement('div',{className:'aspect-fit',style:{backgroundImage:'url('+item.image+')'}}),onClick:function onClick(){var value=_this2.formRef.current.getFieldValue(tabInfo.fieldName);if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.indexOf(value,item.id)===-1){value.push(item.id);}else{__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.remove(value,function(id){return id===item.id;});}_this2.formRef.current.setFields([{touched:true,validating:false,errors:[],name:[tabInfo.fieldName],value:value}]);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_card___default.a.Meta,{title:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_checkbox___default.a,{value:item.id},item.name)})));}}));}))));})))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement('img',{alt:'Preview',style:{width:'100%'},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return StoreInfo;}(__WEBPACK_IMPORTED_MODULE_40_react__["Component"]))||_class);var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:'render',value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,['isOver','connectDragSource','connectDropTarget','moveRow']);var style=Object.assign({},restProps.style,{cursor:'move'});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=' drop-over-downward';}if(restProps.index<dragingIndex){className+=' drop-over-upward';}}return connectDragSource(connectDropTarget(wp.element.createElement('tr',_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_40_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_46_react_dnd__["DropTarget"])('row',rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_46_react_dnd__["DragSource"])('row',rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(293);

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(293);

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Grid = function Grid(_a) {
  var prefixCls = _a.prefixCls,
      className = _a.className,
      _a$hoverable = _a.hoverable,
      hoverable = _a$hoverable === void 0 ? true : _a$hoverable,
      props = __rest(_a, ["prefixCls", "className", "hoverable"]);

  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('card', prefixCls);
    var classString = (0, _classnames["default"])("".concat(prefix, "-grid"), className, (0, _defineProperty2["default"])({}, "".concat(prefix, "-grid-hoverable"), hoverable));
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, props, {
      className: classString
    }));
  });
};

var _default = Grid;
exports["default"] = _default;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Meta = function Meta(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        className = props.className,
        avatar = props.avatar,
        title = props.title,
        description = props.description,
        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);

    var prefixCls = getPrefixCls('card', customizePrefixCls);
    var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
    var avatarDom = avatar ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-meta-avatar")
    }, avatar) : null;
    var titleDom = title ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-meta-title")
    }, title) : null;
    var descriptionDom = description ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-meta-description")
    }, description) : null;
    var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-meta-detail")
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, others, {
      className: classString
    }), avatarDom, MetaDetail);
  });
};

var _default = Meta;
exports["default"] = _default;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(294);

var _default = _grid.Row;
exports["default"] = _default;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(294);

var _default = _grid.Col;
exports["default"] = _default;

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(63);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(52);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _google_map_map = __webpack_require__(1882);

var _google_map_map2 = _interopRequireDefault(_google_map_map);

var _marker_dispatcher = __webpack_require__(1883);

var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);

var _google_map_markers = __webpack_require__(792);

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

var _google_map_markers_prerender = __webpack_require__(1885);

var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);

var _google_heatmap = __webpack_require__(1886);

var _google_map_loader = __webpack_require__(1887);

var _google_map_loader2 = _interopRequireDefault(_google_map_loader);

var _geo = __webpack_require__(1889);

var _geo2 = _interopRequireDefault(_geo);

var _raf = __webpack_require__(1891);

var _raf2 = _interopRequireDefault(_raf);

var _pick = __webpack_require__(1892);

var _pick2 = _interopRequireDefault(_pick);

var _omit = __webpack_require__(793);

var _omit2 = _interopRequireDefault(_omit);

var _log = __webpack_require__(1893);

var _log2 = _interopRequireDefault(_log);

var _isEmpty = __webpack_require__(1894);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNumber = __webpack_require__(1895);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _detect = __webpack_require__(1896);

var _detect2 = _interopRequireDefault(_detect);

var _shallowEqual = __webpack_require__(794);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _isPlainObject = __webpack_require__(1897);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArraysEqualEps = __webpack_require__(1898);

var _isArraysEqualEps2 = _interopRequireDefault(_isArraysEqualEps);

var _detectElementResize = __webpack_require__(1899);

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

var _passiveEvents = __webpack_require__(798);

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */


// helpers


// loaders


// utils


// consts
var kEPS = 0.00001;
var K_GOOGLE_TILE_SIZE = 256;
// real minZoom calculated here _getMinZoom
var K_IDLE_TIMEOUT = 100;
var K_IDLE_CLICK_TIMEOUT = 300;
var DEFAULT_MIN_ZOOM = 3;
// Starting with version 3.32, the maps API calls `draw()` each frame during
// a zoom animation.
var DRAW_CALLED_DURING_ANIMATION_VERSION = 32;
var IS_REACT_16 = _reactDom2.default.createPortal !== undefined;

var createPortal = IS_REACT_16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function defaultOptions_() /* maps */{
  return {
    overviewMapControl: false,
    streetViewControl: false,
    rotateControl: true,
    mapTypeControl: false,
    // disable poi
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    }],
    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
  };
}

var latLng2Obj = function latLng2Obj(latLng) {
  return (0, _isPlainObject2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
};

var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
  if (false) {
    if (zoom < minZoom) {
      console.warn('GoogleMap: ' + // eslint-disable-line
      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
    }
  }

  if (minZoom < zoom) {
    return zoom;
  }
  return minZoom;
};

var isFullScreen = function isFullScreen() {
  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
};

var GoogleMap = function (_Component) {
  _inherits(GoogleMap, _Component);

  // eslint-disable-line

  function GoogleMap(props) {
    _classCallCheck(this, GoogleMap);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._getMinZoom = function () {
      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
        return Math.ceil((0, _log2.default)(maxTilesPerDim));
      }
      return DEFAULT_MIN_ZOOM;
    };

    _this._computeMinZoom = function (minZoom) {
      if (!(0, _isEmpty2.default)(minZoom)) {
        return minZoom;
      }
      return _this._getMinZoom();
    };

    _this._mapDomResizeCallback = function () {
      _this.resetSizeOnIdle_ = true;
      if (_this.maps_) {
        var originalCenter = _this.props.center || _this.props.defaultCenter;
        var currentCenter = _this.map_.getCenter();
        _this.maps_.event.trigger(_this.map_, 'resize');
        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
      }
    };

    _this._setLayers = function (layerTypes) {
      layerTypes.forEach(function (layerType) {
        _this.layers_[layerType] = new _this.maps_[layerType]();
        _this.layers_[layerType].setMap(_this.map_);
      });
    };

    _this._renderPortal = function () {
      return _react2.default.createElement(_google_map_markers2.default, {
        experimental: _this.props.experimental,
        onChildClick: _this._onChildClick,
        onChildMouseDown: _this._onChildMouseDown,
        onChildMouseEnter: _this._onChildMouseEnter,
        onChildMouseLeave: _this._onChildMouseLeave,
        geoService: _this.geoService_,
        insideMapPanes: true,
        distanceToMouse: _this.props.distanceToMouse,
        getHoverDistance: _this._getHoverDistance,
        dispatcher: _this.markersDispatcher_
      });
    };

    _this._initMap = function () {
      // only initialize the map once
      if (_this.initialized_) {
        return;
      }
      _this.initialized_ = true;

      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);

      _this._onBoundsChanged(); // now we can calculate map bounds center etc...

      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);

      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
        if (!_this.mounted_) {
          return;
        }

        var centerLatLng = _this.geoService_.getCenter();

        var propsOptions = {
          zoom: _this.props.zoom || _this.props.defaultZoom,
          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
        };

        // Start Heatmap
        if (_this.props.heatmap.positions) {
          Object.assign(_this, {
            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
          });
          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
        }
        // End Heatmap

        // prevent to exapose full api
        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
        // "SymbolPath", "ZoomControlStyle",
        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
        // "DistanceMatrixStatus",
        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
        // "GeocoderStatus", "KmlLayerStatus",
        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
        // "TravelMode", "UnitSystem"
        var mapPlainObjects = (0, _pick2.default)(maps, _isPlainObject2.default);
        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
        var defaultOptions = defaultOptions_(mapPlainObjects);

        var draggableOptions = !(0, _isEmpty2.default)(_this.props.draggable) && {
          draggable: _this.props.draggable
        };

        var minZoom = _this._computeMinZoom(options.minZoom);
        _this.minZoom_ = minZoom;

        var preMapOptions = _extends({}, defaultOptions, {
          minZoom: minZoom
        }, options, propsOptions);

        _this.defaultDraggableOption_ = !(0, _isEmpty2.default)(preMapOptions.draggable) ? preMapOptions.draggable : _this.defaultDraggableOption_;

        var mapOptions = _extends({}, preMapOptions, draggableOptions);

        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);

        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);

        _this.map_ = map;
        _this.maps_ = maps;

        _this._setLayers(_this.props.layerTypes);

        // Parse `google.maps.version` to capture the major version number.
        var versionMatch = maps.version.match(/^3\.(\d+)\./);
        // The major version is the first (and only) captured group.
        var mapsVersion = versionMatch && Number(versionMatch[1]);

        // render in overlay
        var this_ = _this;
        var overlay = Object.assign(new maps.OverlayView(), {
          onAdd: function onAdd() {
            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';

            var div = document.createElement('div');
            div.style.backgroundColor = 'transparent';
            div.style.position = 'absolute';
            div.style.left = '0px';
            div.style.top = '0px';
            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
            div.style.height = K_MAX_HEIGHT;

            if (this_.props.overlayViewDivStyle) {
              var overlayViewDivStyle = this_.props.overlayViewDivStyle;

              if ((typeof overlayViewDivStyle === 'undefined' ? 'undefined' : _typeof(overlayViewDivStyle)) === 'object') {
                Object.keys(overlayViewDivStyle).forEach(function (property) {
                  div.style[property] = overlayViewDivStyle[property];
                });
              }
            }

            var panes = this.getPanes();
            panes.overlayMouseTarget.appendChild(div);
            this_.geoService_.setMapCanvasProjection(maps, overlay.getProjection());

            if (!IS_REACT_16) {
              createPortal(this_, this_._renderPortal(), div,
              // remove prerendered markers
              function () {
                return this_.setState({ overlay: div });
              });
            } else {
              this_.setState({ overlay: div });
            }
          },
          onRemove: function onRemove() {
            var renderedOverlay = this_.state.overlay;
            if (renderedOverlay && !IS_REACT_16) {
              _reactDom2.default.unmountComponentAtNode(renderedOverlay);
            }
            this_.setState({ overlay: null });
          },
          draw: function draw() {
            this_.updateCounter_++;
            this_._onBoundsChanged(map, maps, !this_.props.debounced);

            if (!this_.googleApiLoadedCalled_) {
              this_._onGoogleApiLoaded({ map: map, maps: maps, ref: this_.googleMapDom_ });
              this_.googleApiLoadedCalled_ = true;
            }

            if (this_.mouse_) {
              var latLng = this_.geoService_.fromContainerPixelToLatLng(this_.mouse_);
              this_.mouse_.lat = latLng.lat;
              this_.mouse_.lng = latLng.lng;
            }

            this_._onChildMouseMove();

            if (this_.markersDispatcher_) {
              this_.markersDispatcher_.emit('kON_CHANGE');
              if (this_.fireMouseEventOnIdle_) {
                this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
              }
            }
          }
        });

        _this.overlay_ = overlay;

        overlay.setMap(map);
        if (_this.props.heatmap.positions) {
          _this.heatmap.setMap(map);
        }

        if (_this.props.onTilesLoaded) {
          maps.event.addListener(map, 'tilesloaded', function () {
            this_._onTilesLoaded();
          });
        }

        maps.event.addListener(map, 'zoom_changed', function () {
          // recalc position at zoom start
          if (this_.geoService_.getZoom() !== map.getZoom()) {
            if (!this_.zoomAnimationInProgress_) {
              this_.zoomAnimationInProgress_ = true;
              this_._onZoomAnimationStart(map.zoom);
            }

            // If draw() is not called each frame during a zoom animation,
            // simulate it.
            if (mapsVersion < DRAW_CALLED_DURING_ANIMATION_VERSION) {
              var TIMEOUT_ZOOM = 300;

              if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
                // there is strange Google Map Api behavior in chrome when zoom animation of map
                // is started only on second raf call, if was click on zoom control
                // or +- keys pressed, so i wait for two rafs before change state

                // this does not fully prevent animation jump
                // but reduce it's occurence probability
                (0, _raf2.default)(function () {
                  return (0, _raf2.default)(function () {
                    this_.updateCounter_++;
                    this_._onBoundsChanged(map, maps);
                  });
                });
              } else {
                this_.updateCounter_++;
                this_._onBoundsChanged(map, maps);
              }
            }
          }
        });

        maps.event.addListener(map, 'idle', function () {
          if (_this.resetSizeOnIdle_) {
            _this._setViewSize();
            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);

            if (currMinZoom !== _this.minZoom_) {
              _this.minZoom_ = currMinZoom;
              map.setOptions({ minZoom: currMinZoom });
            }

            _this.resetSizeOnIdle_ = false;
          }

          if (this_.zoomAnimationInProgress_) {
            this_.zoomAnimationInProgress_ = false;
            this_._onZoomAnimationEnd(map.zoom);
          }

          this_.updateCounter_++;
          this_._onBoundsChanged(map, maps);

          this_.dragTime_ = 0;

          if (this_.markersDispatcher_) {
            this_.markersDispatcher_.emit('kON_CHANGE');
          }
        });

        maps.event.addListener(map, 'mouseover', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = true;
        });

        // an alternative way to know the mouse is back within the map
        // This would not fire when clicking/interacting with google maps
        // own on-map countrols+markers. This handles an edge case for touch devices
        // + 'draggable:false' custom option. See #332 for more details.
        maps.event.addListener(map, 'click', function () {
          this_.mouseInMap_ = true;
        });

        maps.event.addListener(map, 'mouseout', function () {
          // has advantage over div MouseLeave
          this_.mouseInMap_ = false;
          this_.mouse_ = null;
          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        });

        maps.event.addListener(map, 'drag', function () {
          this_.dragTime_ = new Date().getTime();
          this_._onDrag(map);
        });

        maps.event.addListener(map, 'dragend', function () {
          // 'dragend' fires on mouse release.
          // 'idle' listener waits until drag inertia ends before firing `onDragEnd`
          var idleListener = maps.event.addListener(map, 'idle', function () {
            maps.event.removeListener(idleListener);
            this_._onDragEnd(map);
          });
        });
        // user choosing satellite vs roads, etc
        maps.event.addListener(map, 'maptypeid_changed', function () {
          this_._onMapTypeIdChange(map.getMapTypeId());
        });
      }).catch(function (e) {
        // notify callback of load failure
        _this._onGoogleApiLoaded({
          map: null,
          maps: null,
          ref: _this.googleMapDom_
        });
        console.error(e); // eslint-disable-line no-console
        throw e;
      });
    };

    _this._onGoogleApiLoaded = function () {
      if (_this.props.onGoogleApiLoaded) {
        var _this$props;

        if (false) {
          console.warn('GoogleMap: ' + // eslint-disable-line
          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
        }

        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
      }
    };

    _this._getHoverDistance = function () {
      return _this.props.hoverDistance;
    };

    _this._onDrag = function () {
      var _this$props2;

      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
    };

    _this._onDragEnd = function () {
      var _this$props3;

      return _this.props.onDragEnd && (_this$props3 = _this.props).onDragEnd.apply(_this$props3, arguments);
    };

    _this._onMapTypeIdChange = function () {
      var _this$props4;

      return _this.props.onMapTypeIdChange && (_this$props4 = _this.props).onMapTypeIdChange.apply(_this$props4, arguments);
    };

    _this._onZoomAnimationStart = function () {
      var _this$props5;

      return _this.props.onZoomAnimationStart && (_this$props5 = _this.props).onZoomAnimationStart.apply(_this$props5, arguments);
    };

    _this._onZoomAnimationEnd = function () {
      var _this$props6;

      return _this.props.onZoomAnimationEnd && (_this$props6 = _this.props).onZoomAnimationEnd.apply(_this$props6, arguments);
    };

    _this._onTilesLoaded = function () {
      return _this.props.onTilesLoaded && _this.props.onTilesLoaded();
    };

    _this._onChildClick = function () {
      if (_this.props.onChildClick) {
        var _this$props7;

        return (_this$props7 = _this.props).onChildClick.apply(_this$props7, arguments);
      }
      return undefined;
    };

    _this._onChildMouseDown = function (hoverKey, childProps) {
      _this.childMouseDownArgs_ = [hoverKey, childProps];
      if (_this.props.onChildMouseDown) {
        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
      }
    };

    _this._onChildMouseUp = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseUp) {
          var _this$props8;

          (_this$props8 = _this.props).onChildMouseUp.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
        _this.childMouseDownArgs_ = null;
        _this.childMouseUpTime_ = new Date().getTime();
      }
    };

    _this._onChildMouseMove = function () {
      if (_this.childMouseDownArgs_) {
        if (_this.props.onChildMouseMove) {
          var _this$props9;

          (_this$props9 = _this.props).onChildMouseMove.apply(_this$props9, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
        }
      }
    };

    _this._onChildMouseEnter = function () {
      if (_this.props.onChildMouseEnter) {
        var _this$props10;

        return (_this$props10 = _this.props).onChildMouseEnter.apply(_this$props10, arguments);
      }
      return undefined;
    };

    _this._onChildMouseLeave = function () {
      if (_this.props.onChildMouseLeave) {
        var _this$props11;

        return (_this$props11 = _this.props).onChildMouseLeave.apply(_this$props11, arguments);
      }
      return undefined;
    };

    _this._setViewSize = function () {
      if (!_this.mounted_) return;
      if (isFullScreen()) {
        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
      } else {
        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
      }
      _this._onBoundsChanged();
    };

    _this._onWindowResize = function () {
      _this.resetSizeOnIdle_ = true;
    };

    _this._onMapMouseMove = function (e) {
      if (!_this.mouseInMap_) return;

      var currTime = new Date().getTime();
      var K_RECALC_CLIENT_RECT_MS = 50;

      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
      }
      _this.mouseMoveTime_ = currTime;

      var mousePosX = e.clientX - _this.boundingRect_.left;
      var mousePosY = e.clientY - _this.boundingRect_.top;

      if (!_this.mouse_) {
        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
      }

      _this.mouse_.x = mousePosX;
      _this.mouse_.y = mousePosY;

      var latLng = _this.geoService_.fromContainerPixelToLatLng(_this.mouse_);
      _this.mouse_.lat = latLng.lat;
      _this.mouse_.lng = latLng.lng;

      _this._onChildMouseMove();

      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
        _this.fireMouseEventOnIdle_ = true;
      } else {
        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
        _this.fireMouseEventOnIdle_ = false;
      }
    };

    _this._onClick = function () {
      var _this$props12;

      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props12 = _this.props).onClick.apply(_this$props12, arguments);
    };

    _this._onMapClick = function (event) {
      if (_this.markersDispatcher_) {
        // support touch events and recalculate mouse position on click
        _this._onMapMouseMove(event);
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          if (_this.mouse_) {
            _this._onClick(_extends({}, _this.mouse_, {
              event: event
            }));
          }

          _this.markersDispatcher_.emit('kON_CLICK', event);
        }
      }
    };

    _this._onMapMouseDownNative = function (event) {
      if (!_this.mouseInMap_) return;

      _this._onMapMouseDown(event);
    };

    _this._onMapMouseDown = function (event) {
      if (_this.markersDispatcher_) {
        var currTime = new Date().getTime();
        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
          // Hovered marker detected at mouse move could be deleted at mouse down time
          // so it will be good to force hovered marker recalculation
          _this._onMapMouseMove(event);
          _this.markersDispatcher_.emit('kON_MDOWN', event);
        }
      }
    };

    _this._onMapMouseDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        // to fix strange zoom in chrome
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._onKeyDownCapture = function () {
      if ((0, _detect2.default)().isChrome) {
        _this.zoomControlClickTime_ = new Date().getTime();
      }
    };

    _this._isCenterDefined = function (center) {
      return center && ((0, _isPlainObject2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
    };

    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
      if (map) {
        var gmC = map.getCenter();
        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
      }

      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
        var zoom = _this.geoService_.getZoom();
        var bounds = _this.geoService_.getBounds();
        var centerLatLng = _this.geoService_.getCenter();

        if (!(0, _isArraysEqualEps2.default)(bounds, _this.prevBounds_, kEPS)) {
          if (callExtBoundsChange !== false) {
            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
            if (_this.props.onBoundsChange) {
              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
            }

            if (_this.props.onChange) {
              _this.props.onChange({
                center: _extends({}, centerLatLng),
                zoom: zoom,
                bounds: {
                  nw: {
                    lat: bounds[0],
                    lng: bounds[1]
                  },
                  se: {
                    lat: bounds[2],
                    lng: bounds[3]
                  },
                  sw: {
                    lat: bounds[4],
                    lng: bounds[5]
                  },
                  ne: {
                    lat: bounds[6],
                    lng: bounds[7]
                  }
                },
                marginBounds: {
                  nw: {
                    lat: marginBounds[0],
                    lng: marginBounds[1]
                  },
                  se: {
                    lat: marginBounds[2],
                    lng: marginBounds[3]
                  },
                  sw: {
                    lat: marginBounds[4],
                    lng: marginBounds[5]
                  },
                  ne: {
                    lat: marginBounds[6],
                    lng: marginBounds[7]
                  }
                },

                size: _this.geoService_.hasSize() ? {
                  width: _this.geoService_.getWidth(),
                  height: _this.geoService_.getHeight()
                } : {
                  width: 0,
                  height: 0
                }
              });
            }

            _this.prevBounds_ = bounds;
          }
        }
      }
    };

    _this._registerChild = function (ref) {
      _this.googleMapDom_ = ref;
    };

    _this.mounted_ = false;
    _this.initialized_ = false;
    _this.googleApiLoadedCalled_ = false;

    _this.map_ = null;
    _this.maps_ = null;
    _this.prevBounds_ = null;
    _this.heatmap = null;

    _this.layers_ = {};

    _this.mouse_ = null;
    _this.mouseMoveTime_ = 0;
    _this.boundingRect_ = null;
    _this.mouseInMap_ = true;

    _this.dragTime_ = 0;
    _this.fireMouseEventOnIdle_ = false;
    _this.updateCounter_ = 0;

    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
    _this.centerIsObject_ = (0, _isPlainObject2.default)(_this.props.center);

    _this.minZoom_ = DEFAULT_MIN_ZOOM;
    _this.defaultDraggableOption_ = true;

    _this.zoomControlClickTime_ = 0;

    _this.childMouseDownArgs_ = null;
    _this.childMouseUpTime_ = 0;

    _this.googleMapDom_ = null;

    if (false) {
      if (_this.props.apiKey) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
      }

      if (_this.props.onBoundsChange) {
        console.warn('GoogleMap: ' + // eslint-disable-line no-console
        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
      }

      if ((0, _isEmpty2.default)(_this.props.center) && (0, _isEmpty2.default)(_this.props.defaultCenter)) {
        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
        );
      }

      if ((0, _isEmpty2.default)(_this.props.zoom) && (0, _isEmpty2.default)(_this.props.defaultZoom)) {
        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
        );
      }
    }

    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
    }

    _this.zoomAnimationInProgress_ = false;

    _this.state = {
      overlay: null
    };
    return _this;
  }

  GoogleMap.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted_ = true;
    (0, _passiveEvents2.default)(window, 'resize', this._onWindowResize, false);
    (0, _passiveEvents2.default)(window, 'keydown', this._onKeyDownCapture, true);
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    // gmap can't prevent map drag if mousedown event already occured
    // the only workaround I find is prevent mousedown native browser event

    if (mapDom) {
      (0, _passiveEvents2.default)(mapDom, 'mousedown', this._onMapMouseDownNative, true);
    }

    (0, _passiveEvents2.default)(window, 'mouseup', this._onChildMouseUp, false);
    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);

    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly

    setTimeout(function () {
      // to detect size
      _this2._setViewSize();
      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
        _this2._initMap();
      }
    }, 0, this);
    if (this.props.resetBoundsOnResize) {
      var that = this;
      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
    }
  };

  GoogleMap.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (false) {
      if (!(0, _shallowEqual2.default)(this.props.defaultCenter, nextProps.defaultCenter)) {
        console.warn("GoogleMap: defaultCenter prop changed. You can't change default props.");
      }

      if (!(0, _shallowEqual2.default)(this.props.defaultZoom, nextProps.defaultZoom)) {
        console.warn("GoogleMap: defaultZoom prop changed. You can't change default props.");
      }
    }

    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
      setTimeout(function () {
        return _this3._initMap();
      }, 0);
    }

    if (this.map_) {
      var centerLatLng = this.geoService_.getCenter();
      if (this._isCenterDefined(nextProps.center)) {
        var nextPropsCenter = latLng2Obj(nextProps.center);
        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;

        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
            this.map_.panTo({
              lat: nextPropsCenter.lat,
              lng: nextPropsCenter.lng
            });
          }
        }
      }

      if (!(0, _isEmpty2.default)(nextProps.zoom)) {
        // if zoom chaged by user
        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
          this.map_.setZoom(nextProps.zoom);
        }
      }

      if (!(0, _isEmpty2.default)(this.props.draggable) && (0, _isEmpty2.default)(nextProps.draggable)) {
        // reset to default
        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
      } else if (!(0, _shallowEqual2.default)(this.props.draggable, nextProps.draggable)) {
        // also prevent this on window 'mousedown' event to prevent map move
        this.map_.setOptions({ draggable: nextProps.draggable });
      }

      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
      if (!(0, _isEmpty2.default)(nextProps.options) && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
        var mapPlainObjects = (0, _pick2.default)(this.maps_, _isPlainObject2.default);
        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
        // remove zoom, center and draggable options as these are managed by google-maps-react
        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);

        if ('minZoom' in options) {
          var minZoom = this._computeMinZoom(options.minZoom);
          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
        }

        this.map_.setOptions(options);
      }

      if (!(0, _shallowEqual2.default)(nextProps.layerTypes, this.props.layerTypes)) {
        Object.keys(this.layers_).forEach(function (layerKey) {
          _this3.layers_[layerKey].setMap(null);
          delete _this3.layers_[layerKey];
        });
        this._setLayers(nextProps.layerTypes);
      }

      if (this.heatmap && !(0, _shallowEqual2.default)(nextProps.heatmap.positions, this.props.heatmap.positions)) {
        this.heatmap.setData(nextProps.heatmap.positions.map(function (p) {
          return {
            location: new _this3.maps_.LatLng(p.lat, p.lng),
            weight: p.weight
          };
        }));
      }
    }
  };

  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // draggable does not affect inner components
    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
  };

  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.markersDispatcher_.emit('kON_CHANGE');

    if (!(0, _shallowEqual2.default)(this.props.hoverDistance, prevProps.hoverDistance)) {
      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
    }
  };

  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted_ = false;
    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
    if (mapDom) {
      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
    }
    window.removeEventListener('resize', this._onWindowResize);
    window.removeEventListener('keydown', this._onKeyDownCapture);
    window.removeEventListener('mouseup', this._onChildMouseUp, false);
    if (this.props.resetBoundsOnResize) {
      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
    }

    if (this.overlay_) {
      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
      this.overlay_.setMap(null);
    }

    if (this.maps_ && this.map_ && this.props.shouldUnregisterMapOnUnmount) {
      // fix google, as otherwise listeners works even without map
      this.map_.setOptions({ scrollwheel: false });
      this.maps_.event.clearInstanceListeners(this.map_);
    }

    if (this.props.shouldUnregisterMapOnUnmount) {
      this.map_ = null;
      this.maps_ = null;
    }
    this.markersDispatcher_.dispose();

    this.resetSizeOnIdle_ = false;

    if (this.props.shouldUnregisterMapOnUnmount) {
      delete this.map_;
      delete this.markersDispatcher_;
    }
  };
  // calc minZoom if map size available
  // it's better to not set minZoom less than this calculation gives
  // otherwise there is no homeomorphism between screen coordinates and map
  // (one map coordinate can have different screen coordinates)


  // this method works only if this.props.onChildMouseDown was called


  // this method works only if this.props.onChildMouseDown was called


  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough


  // gmap can't prevent map drag if mousedown event already occured
  // the only workaround I find is prevent mousedown native browser event


  GoogleMap.prototype.render = function render() {
    var overlay = this.state.overlay;
    var mapMarkerPrerender = !overlay ? _react2.default.createElement(_google_map_markers_prerender2.default, {
      experimental: this.props.experimental,
      onChildClick: this._onChildClick,
      onChildMouseDown: this._onChildMouseDown,
      onChildMouseEnter: this._onChildMouseEnter,
      onChildMouseLeave: this._onChildMouseLeave,
      geoService: this.geoService_,
      insideMapPanes: false,
      distanceToMouse: this.props.distanceToMouse,
      getHoverDistance: this._getHoverDistance,
      dispatcher: this.markersDispatcher_
    }) : null;

    return _react2.default.createElement(
      'div',
      {
        style: this.props.style,
        onMouseMove: this._onMapMouseMove,
        onMouseDownCapture: this._onMapMouseDownCapture,
        onClick: this._onMapClick
      },
      _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
      IS_REACT_16 && overlay && createPortal(this._renderPortal(), overlay),
      mapMarkerPrerender
    );
  };

  return GoogleMap;
}(_react.Component);

GoogleMap.propTypes = {
  apiKey: _propTypes2.default.string,
  bootstrapURLKeys: _propTypes2.default.any,

  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  })]),
  defaultZoom: _propTypes2.default.number,
  zoom: _propTypes2.default.number,
  onBoundsChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onChildClick: _propTypes2.default.func,
  onChildMouseDown: _propTypes2.default.func,
  onChildMouseUp: _propTypes2.default.func,
  onChildMouseMove: _propTypes2.default.func,
  onChildMouseEnter: _propTypes2.default.func,
  onChildMouseLeave: _propTypes2.default.func,
  onZoomAnimationStart: _propTypes2.default.func,
  onZoomAnimationEnd: _propTypes2.default.func,
  onDrag: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  onMapTypeIdChange: _propTypes2.default.func,
  onTilesLoaded: _propTypes2.default.func,
  options: _propTypes2.default.any,
  distanceToMouse: _propTypes2.default.func,
  hoverDistance: _propTypes2.default.number,
  debounced: _propTypes2.default.bool,
  margin: _propTypes2.default.array,
  googleMapLoader: _propTypes2.default.any,
  onGoogleApiLoaded: _propTypes2.default.func,
  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
  draggable: _propTypes2.default.bool,
  style: _propTypes2.default.any,
  resetBoundsOnResize: _propTypes2.default.bool,
  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string), // ['TransitLayer', 'TrafficLayer']
  shouldUnregisterMapOnUnmount: _propTypes2.default.bool
};
GoogleMap.defaultProps = {
  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
  },

  hoverDistance: 30,
  debounced: true,
  options: defaultOptions_,
  googleMapLoader: _google_map_loader2.default,
  yesIWantToUseGoogleMapApiInternals: false,
  style: {
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    position: 'relative'
  },
  layerTypes: [],
  heatmap: {},
  heatmapLibrary: false,
  shouldUnregisterMapOnUnmount: true
};
GoogleMap.googleMapLoader = _google_map_loader2.default;
exports.default = GoogleMap;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 0,
  padding: 0,
  position: 'absolute'
};

var GoogleMapMap = function (_Component) {
  _inherits(GoogleMapMap, _Component);

  function GoogleMapMap() {
    _classCallCheck(this, GoogleMapMap);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false; // disable react on this div
  };

  GoogleMapMap.prototype.render = function render() {
    var registerChild = this.props.registerChild;

    return _react2.default.createElement('div', { ref: registerChild, style: style });
  };

  return GoogleMapMap;
}(_react.Component);

exports.default = GoogleMapMap;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _eventemitter = __webpack_require__(1884);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkerDispatcher = function (_EventEmitter) {
  _inherits(MarkerDispatcher, _EventEmitter);

  function MarkerDispatcher(gmapInstance) {
    _classCallCheck(this, MarkerDispatcher);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.gmapInstance = gmapInstance;
    return _this;
  }

  MarkerDispatcher.prototype.getChildren = function getChildren() {
    return this.gmapInstance.props.children;
  };

  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
    return this.gmapInstance.mouse_;
  };

  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
    return this.gmapInstance.updateCounter_;
  };

  MarkerDispatcher.prototype.dispose = function dispose() {
    this.gmapInstance = null;
    this.removeAllListeners();
  };

  return MarkerDispatcher;
}(_eventemitter2.default);

exports.default = MarkerDispatcher;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
  );
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _google_map_markers = __webpack_require__(792);

var _google_map_markers2 = _interopRequireDefault(_google_map_markers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  width: '50%',
  height: '50%',
  left: '50%',
  top: '50%',
  // backgroundColor: 'red',
  margin: 0,
  padding: 0,
  position: 'absolute'
  // opacity: 0.3
};

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
  var positions = _ref.positions;
  return new instance.visualization.HeatmapLayer({
    data: positions.reduce(function (acc, _ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng,
          _ref2$weight = _ref2.weight,
          weight = _ref2$weight === undefined ? 1 : _ref2$weight;

      acc.push({
        location: new instance.LatLng(lat, lng),
        weight: weight
      });
      return acc;
    }, [])
  });
};

var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === undefined ? {} : _ref3$options;
  return Object.keys(options).map(function (option) {
    return instance.set(option, options[option]);
  });
};

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var BASE_URL = 'https://maps';
var DEFAULT_URL = BASE_URL + '.googleapis.com';
var API_PATH = '/maps/api/js?callback=_$_google_map_initialize_$_';

var $script_ = null;

var loadPromise_ = void 0;

var resolveCustomPromise_ = void 0;

var _customPromise = new Promise(function (resolve) {
  resolveCustomPromise_ = resolve;
});

// TODO add libraries language and other map options

exports.default = function (bootstrapURLKeys, heatmapLibrary) {
  if (!$script_) {
    $script_ = __webpack_require__(1888); // eslint-disable-line
  }

  // call from outside google-map-react
  // will be as soon as loadPromise_ resolved
  if (!bootstrapURLKeys) {
    return _customPromise;
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = function () {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };

    if (false) {
      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
        var message = '"callback" key in bootstrapURLKeys is not allowed,\n                          use onGoogleApiLoaded property instead';
        // eslint-disable-next-line no-console
        console.error(message);
        throw new Error(message);
      }
    }

    var params = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
      return r + '&' + key + '=' + bootstrapURLKeys[key];
    }, '');

    var libraries = heatmapLibrary ? '&libraries=visualization' : '';

    $script_('' + DEFAULT_URL + API_PATH + params + libraries, function () {
      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
    });
  });

  resolveCustomPromise_(loadPromise_);

  return loadPromise_;
};

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pointGeometry = __webpack_require__(795);

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__(796);

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _transform = __webpack_require__(1890);

var _transform2 = _interopRequireDefault(_transform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Geo = function () {
  function Geo(tileSize) {
    _classCallCheck(this, Geo);

    // left_top view пользует гугл
    // super();
    this.hasSize_ = false;
    this.hasView_ = false;
    this.transform_ = new _transform2.default(tileSize || 512);
  }

  Geo.prototype.setView = function setView(center, zoom, bearing) {
    this.transform_.center = _lat_lng2.default.convert(center);
    this.transform_.zoom = +zoom;
    this.transform_.bearing = +bearing;
    this.hasView_ = true;
  };

  Geo.prototype.setViewSize = function setViewSize(width, height) {
    this.transform_.width = width;
    this.transform_.height = height;
    this.hasSize_ = true;
  };

  Geo.prototype.setMapCanvasProjection = function setMapCanvasProjection(maps, mapCanvasProjection) {
    this.maps_ = maps;
    this.mapCanvasProjection_ = mapCanvasProjection;
  };

  Geo.prototype.canProject = function canProject() {
    return this.hasSize_ && this.hasView_;
  };

  Geo.prototype.hasSize = function hasSize() {
    return this.hasSize_;
  };

  /** Returns the pixel position relative to the map center. */


  Geo.prototype.fromLatLngToCenterPixel = function fromLatLngToCenterPixel(ptLatLng) {
    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
  };

  /**
   * Returns the pixel position relative to the map panes,
   * or relative to the map center if there are no panes.
   */


  Geo.prototype.fromLatLngToDivPixel = function fromLatLngToDivPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToDivPixel(latLng);
    }
    return this.fromLatLngToCenterPixel(ptLatLng);
  };

  /** Returns the pixel position relative to the map top-left. */


  Geo.prototype.fromLatLngToContainerPixel = function fromLatLngToContainerPixel(ptLatLng) {
    if (this.mapCanvasProjection_) {
      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
      return this.mapCanvasProjection_.fromLatLngToContainerPixel(latLng);
    }

    var pt = this.fromLatLngToCenterPixel(ptLatLng);
    pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);

    pt.x += this.transform_.width / 2;
    pt.y += this.transform_.height / 2;

    return pt;
  };

  /** Returns the LatLng for the given offset from the map top-left. */


  Geo.prototype.fromContainerPixelToLatLng = function fromContainerPixelToLatLng(ptXY) {
    if (this.mapCanvasProjection_) {
      var latLng = this.mapCanvasProjection_.fromContainerPixelToLatLng(ptXY);
      return { lat: latLng.lat(), lng: latLng.lng() };
    }

    var ptxy = _extends({}, ptXY);
    ptxy.x -= this.transform_.width / 2;
    ptxy.y -= this.transform_.height / 2;
    var ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));

    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
    return ptRes;
  };

  Geo.prototype.getWidth = function getWidth() {
    return this.transform_.width;
  };

  Geo.prototype.getHeight = function getHeight() {
    return this.transform_.height;
  };

  Geo.prototype.getZoom = function getZoom() {
    return this.transform_.zoom;
  };

  Geo.prototype.getCenter = function getCenter() {
    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });

    return ptRes;
  };

  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
    var bndT = margins && margins[0] || 0;
    var bndR = margins && margins[1] || 0;
    var bndB = margins && margins[2] || 0;
    var bndL = margins && margins[3] || 0;

    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
      var topLeftCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: bndL - this.getWidth() / 2,
        y: bndT - this.getHeight() / 2
      }));
      var bottomRightCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
        x: this.getWidth() / 2 - bndR,
        y: this.getHeight() / 2 - bndB
      }));

      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
      bottomRightCorner.lat, bottomRightCorner.lng, // SE
      bottomRightCorner.lat, topLeftCorner.lng, // SW
      topLeftCorner.lat, bottomRightCorner.lng];

      if (roundFactor) {
        res = res.map(function (r) {
          return Math.round(r * roundFactor) / roundFactor;
        });
      }
      return res;
    }

    return [0, 0, 0, 0];
  };

  return Geo;
}();

exports.default = Geo;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */


var _pointGeometry = __webpack_require__(795);

var _pointGeometry2 = _interopRequireDefault(_pointGeometry);

var _lat_lng = __webpack_require__(796);

var _lat_lng2 = _interopRequireDefault(_lat_lng);

var _wrap = __webpack_require__(797);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
var Transform = function () {
  function Transform(tileSize, minZoom, maxZoom) {
    _classCallCheck(this, Transform);

    this.tileSize = tileSize || 512; // constant

    this._minZoom = minZoom || 0;
    this._maxZoom = maxZoom || 52;

    this.latRange = [-85.05113, 85.05113];

    this.width = 0;
    this.height = 0;
    this.zoom = 0;
    this.center = new _lat_lng2.default(0, 0);
    this.angle = 0;
  }

  Transform.prototype.zoomScale = function zoomScale(zoom) {
    return Math.pow(2, zoom);
  };

  Transform.prototype.scaleZoom = function scaleZoom(scale) {
    return Math.log(scale) / Math.LN2;
  };

  Transform.prototype.project = function project(latlng, worldSize) {
    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
  };

  Transform.prototype.unproject = function unproject(point, worldSize) {
    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
  };

  // lat/lon <-> absolute pixel coords convertion
  Transform.prototype.lngX = function lngX(lon, worldSize) {
    return (180 + lon) * (worldSize || this.worldSize) / 360;
  };

  // latitude to absolute y coord


  Transform.prototype.latY = function latY(lat, worldSize) {
    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
    return (180 - y) * (worldSize || this.worldSize) / 360;
  };

  Transform.prototype.xLng = function xLng(x, worldSize) {
    return x * 360 / (worldSize || this.worldSize) - 180;
  };

  Transform.prototype.yLat = function yLat(y, worldSize) {
    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  };

  Transform.prototype.locationPoint = function locationPoint(latlng) {
    var p = this.project(latlng);
    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
  };

  Transform.prototype.pointLocation = function pointLocation(p) {
    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
    return this.unproject(this.point.sub(p2));
  };

  _createClass(Transform, [{
    key: 'minZoom',
    get: function get() {
      return this._minZoom;
    },
    set: function set(zoom) {
      this._minZoom = zoom;
      this.zoom = Math.max(this.zoom, zoom);
    }
  }, {
    key: 'maxZoom',
    get: function get() {
      return this._maxZoom;
    },
    set: function set(zoom) {
      this._maxZoom = zoom;
      this.zoom = Math.min(this.zoom, zoom);
    }
  }, {
    key: 'worldSize',
    get: function get() {
      return this.tileSize * this.scale;
    }
  }, {
    key: 'centerPoint',
    get: function get() {
      return new _pointGeometry2.default(0, 0); // this.size._div(2);
    }
  }, {
    key: 'size',
    get: function get() {
      return new _pointGeometry2.default(this.width, this.height);
    }
  }, {
    key: 'bearing',
    get: function get() {
      return -this.angle / Math.PI * 180;
    },
    set: function set(bearing) {
      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
    }
  }, {
    key: 'zoom',
    get: function get() {
      return this._zoom;
    },
    set: function set(zoom) {
      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
      this._zoom = zoomV;
      this.scale = this.zoomScale(zoomV);
      this.tileZoom = Math.floor(zoomV);
      this.zoomFraction = zoomV - this.tileZoom;
    }
  }, {
    key: 'x',
    get: function get() {
      return this.lngX(this.center.lng);
    }
  }, {
    key: 'y',
    get: function get() {
      return this.latY(this.center.lat);
    }
  }, {
    key: 'point',
    get: function get() {
      return new _pointGeometry2.default(this.x, this.y);
    }
  }]);

  return Transform;
}();

exports.default = Transform;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isEmpty = function isEmpty(val) {
  // check for empty object {}, array []
  if (val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    if (Object.keys(val).length === 0) {
      return true;
    }
  } else if (val === null || val === undefined || val === '') {
    // check for undefined, null and ""
    return true;
  }
  return false;
};

exports.default = isEmpty;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumber;
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

var objectToString = Object.prototype.toString;

function isNumber(value) {
  var numberTag = '[object Number]';
  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
}

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = detectBrowser;
// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
var detectBrowserResult_ = null;

function detectBrowser() {
  if (detectBrowserResult_) {
    return detectBrowserResult_;
  }

  if (typeof navigator !== 'undefined') {
    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    var isSafari = navigator.userAgent.indexOf('Safari') > -1;

    if (isChrome && isSafari) {
      isSafari = false;
    }

    if (isChrome && isOpera) {
      isChrome = false;
    }

    detectBrowserResult_ = {
      isExplorer: isExplorer,
      isFirefox: isFirefox,
      isOpera: isOpera,
      isChrome: isChrome,
      isSafari: isSafari
    };
    return detectBrowserResult_;
  }

  detectBrowserResult_ = {
    isChrome: true,
    isExplorer: false,
    isFirefox: false,
    isOpera: false,
    isSafari: false
  };

  return detectBrowserResult_;
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isPlainObject;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _passiveEvents = __webpack_require__(798);

var _passiveEvents2 = _interopRequireDefault(_passiveEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reliable `window` and `document` detection
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Check `document` and `window` in case of server-side rendering
/* eslint-disable */
/**
* Detect Element Resize.
* Forked in order to guard against unsafe 'window' and 'document' references.
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

var _window;
if (canUseDOM) {
  _window = window;
} else if (typeof self !== 'undefined') {
  _window = self;
} else {
  _window = undefined;
}

var attachEvent = typeof document !== 'undefined' && document.attachEvent;
var stylesCreated = false;

if (canUseDOM && !attachEvent) {
  var requestFrame = function () {
    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
      return _window.setTimeout(fn, 20);
    };
    return function (fn) {
      return raf(fn);
    };
  }();

  var cancelFrame = function () {
    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
    return function (id) {
      return cancel(id);
    };
  }();

  var resetTriggers = function resetTriggers(element) {
    var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
    contract.scrollLeft = contract.scrollWidth;
    contract.scrollTop = contract.scrollHeight;
    expandChild.style.width = expand.offsetWidth + 1 + 'px';
    expandChild.style.height = expand.offsetHeight + 1 + 'px';
    expand.scrollLeft = expand.scrollWidth;
    expand.scrollTop = expand.scrollHeight;
  };

  var checkTriggers = function checkTriggers(element) {
    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
  };

  var scrollListener = function scrollListener(e) {
    var element = this;
    resetTriggers(this);
    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
    this.__resizeRAF__ = requestFrame(function () {
      if (checkTriggers(element)) {
        element.__resizeLast__.width = element.offsetWidth;
        element.__resizeLast__.height = element.offsetHeight;
        element.__resizeListeners__.forEach(function (fn) {
          fn.call(element, e);
        });
      }
    });
  };

  /* Detect CSS Animations support to detect element display/re-attach */
  var animation = false,
      animationstring = 'animation',
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';

  if (canUseDOM) {
    var elm = document.createElement('fakeelement');
    if (elm.style.animationName !== undefined) {
      animation = true;
    }

    if (animation === false) {
      for (var i = 0; i < domPrefixes.length; i++) {
        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
          pfx = domPrefixes[i];
          animationstring = pfx + 'Animation';
          keyframeprefix = '-' + pfx.toLowerCase() + '-';
          animationstartevent = startEvents[i];
          animation = true;
          break;
        }
      }
    }
  }

  var animationName = 'resizeanim';
  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
}

var createStyles = function createStyles() {
  if (!stylesCreated) {
    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    stylesCreated = true;
  }
};

var addResizeListener = function addResizeListener(element, fn) {
  if (element.parentNode === undefined) {
    var tempParentDiv = document.createElement('div');
    element.parentNode = tempParentDiv;
  }
  element = element.parentNode;
  if (attachEvent) element.attachEvent('onresize', fn);else {
    if (!element.__resizeTriggers__) {
      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
      createStyles();
      element.__resizeLast__ = {};
      element.__resizeListeners__ = [];
      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
      element.appendChild(element.__resizeTriggers__);
      resetTriggers(element);

      (0, _passiveEvents2.default)(element, 'scroll', scrollListener, true);

      /* Listen for a css animation to detect element display/re-attach */
      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
        if (e.animationName == animationName) resetTriggers(element);
      });
    }
    element.__resizeListeners__.push(fn);
  }
};

var removeResizeListener = function removeResizeListener(element, fn) {
  element = element.parentNode;
  if (attachEvent) element.detachEvent('onresize', fn);else {
    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
    if (!element.__resizeListeners__.length) {
      element.removeEventListener('scroll', scrollListener);
      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
    }
  }
};

module.exports = {
  addResizeListener: addResizeListener,
  removeResizeListener: removeResizeListener
};

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cascader__ = __webpack_require__(1902);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Cascader__["a" /* default */]);

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_trigger__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_array_tree_filter__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_array_tree_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Menus__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__placements__ = __webpack_require__(1920);
















var Cascader = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Cascader, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Cascader);

  function Cascader(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Cascader);

    _this = _super.call(this, props);

    _this.setPopupVisible = function (popupVisible) {
      var value = _this.state.value;

      if (!('popupVisible' in _this.props)) {
        _this.setState({
          popupVisible: popupVisible
        });
      } // sync activeValue with value when panel open


      if (popupVisible && !_this.state.popupVisible) {
        _this.setState({
          activeValue: value
        });
      }

      _this.props.onPopupVisibleChange(popupVisible);
    };

    _this.handleChange = function (options, _ref, e) {
      var visible = _ref.visible;

      if (e.type !== 'keydown' || e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.props.onChange(options.map(function (o) {
          return o[_this.getFieldName('value')];
        }), options);

        _this.setPopupVisible(visible);
      }
    };

    _this.handlePopupVisibleChange = function (popupVisible) {
      _this.setPopupVisible(popupVisible);
    };

    _this.handleMenuSelect = function (targetOption, menuIndex, e) {
      // Keep focused state for keyboard support
      var triggerNode = _this.trigger.getRootDomNode();

      if (triggerNode && triggerNode.focus) {
        triggerNode.focus();
      }

      var _this$props = _this.props,
          changeOnSelect = _this$props.changeOnSelect,
          loadData = _this$props.loadData,
          expandTrigger = _this$props.expandTrigger;

      if (!targetOption || targetOption.disabled) {
        return;
      }

      var activeValue = _this.state.activeValue;
      activeValue = activeValue.slice(0, menuIndex + 1);
      activeValue[menuIndex] = targetOption[_this.getFieldName('value')];

      var activeOptions = _this.getActiveOptions(activeValue);

      if (targetOption.isLeaf === false && !targetOption[_this.getFieldName('children')] && loadData) {
        if (changeOnSelect) {
          _this.handleChange(activeOptions, {
            visible: true
          }, e);
        }

        _this.setState({
          activeValue: activeValue
        });

        loadData(activeOptions);
        return;
      }

      var newState = {};

      if (!targetOption[_this.getFieldName('children')] || !targetOption[_this.getFieldName('children')].length) {
        _this.handleChange(activeOptions, {
          visible: false
        }, e); // set value to activeValue when select leaf option


        newState.value = activeValue; // add e.type judgement to prevent `onChange` being triggered by mouseEnter
      } else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
        if (expandTrigger === 'hover') {
          _this.handleChange(activeOptions, {
            visible: false
          }, e);
        } else {
          _this.handleChange(activeOptions, {
            visible: true
          }, e);
        } // set value to activeValue on every select


        newState.value = activeValue;
      }

      newState.activeValue = activeValue; //  not change the value by keyboard

      if ('value' in _this.props || e.type === 'keydown' && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        delete newState.value;
      }

      _this.setState(newState);
    };

    _this.handleItemDoubleClick = function () {
      var changeOnSelect = _this.props.changeOnSelect;

      if (changeOnSelect) {
        _this.setPopupVisible(false);
      }
    };

    _this.handleKeyDown = function (e) {
      var children = _this.props.children; // https://github.com/ant-design/ant-design/issues/6717
      // Don't bind keyboard support when children specify the onKeyDown

      if (children && children.props.onKeyDown) {
        children.props.onKeyDown(e);
        return;
      }

      var activeValue = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(_this.state.activeValue);

      var currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;

      var currentOptions = _this.getCurrentLevelOptions();

      var currentIndex = currentOptions.map(function (o) {
        return o[_this.getFieldName('value')];
      }).indexOf(activeValue[currentLevel]);

      if (e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DOWN && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].UP && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].LEFT && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].RIGHT && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ENTER && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].SPACE && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].BACKSPACE && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ESC && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].TAB) {
        return;
      } // Press any keys above to reopen menu


      if (!_this.state.popupVisible && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].BACKSPACE && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].LEFT && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].RIGHT && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ESC && e.keyCode !== __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].TAB) {
        _this.setPopupVisible(true);

        if (_this.props.onKeyDown) {
          _this.props.onKeyDown(e);
        }

        return;
      }

      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DOWN || e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].UP) {
        e.preventDefault();
        var nextIndex = currentIndex;

        if (nextIndex !== -1) {
          if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].DOWN) {
            nextIndex += 1;
            nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
          } else {
            nextIndex -= 1;
            nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
          }
        } else {
          nextIndex = 0;
        }

        activeValue[currentLevel] = currentOptions[nextIndex][_this.getFieldName('value')];
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].LEFT || e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].BACKSPACE) {
        e.preventDefault();
        activeValue.splice(activeValue.length - 1, 1);
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
        e.preventDefault();

        if (currentOptions[currentIndex] && currentOptions[currentIndex][_this.getFieldName('children')]) {
          activeValue.push(currentOptions[currentIndex][_this.getFieldName('children')][0][_this.getFieldName('value')]);
        }
      } else if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ESC || e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].TAB) {
        _this.setPopupVisible(false);

        if (_this.props.onKeyDown) {
          _this.props.onKeyDown(e);
        }

        return;
      }

      if (!activeValue || activeValue.length === 0) {
        _this.setPopupVisible(false);
      }

      var activeOptions = _this.getActiveOptions(activeValue);

      var targetOption = activeOptions[activeOptions.length - 1];

      _this.handleMenuSelect(targetOption, activeOptions.length - 1, e);

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.saveTrigger = function (node) {
      _this.trigger = node;
    };

    var initialValue = [];

    if ('value' in props) {
      initialValue = props.value || [];
    } else if ('defaultValue' in props) {
      initialValue = props.defaultValue || [];
    }

    __WEBPACK_IMPORTED_MODULE_9_warning___default()(!('filedNames' in props), '`filedNames` of Cascader is a typo usage and deprecated, please use `fieldNames` instead.');
    _this.state = {
      popupVisible: props.popupVisible,
      activeValue: initialValue,
      value: initialValue,
      prevProps: props
    };
    _this.defaultFieldNames = {
      label: 'label',
      value: 'value',
      children: 'children'
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Cascader, [{
    key: "getPopupDOMNode",
    value: function getPopupDOMNode() {
      return this.trigger.getPopupDomNode();
    }
  }, {
    key: "getFieldName",
    value: function getFieldName(name) {
      var defaultFieldNames = this.defaultFieldNames;
      var _this$props2 = this.props,
          fieldNames = _this$props2.fieldNames,
          filedNames = _this$props2.filedNames;

      if ('filedNames' in this.props) {
        return filedNames[name] || defaultFieldNames[name]; // For old compatibility
      }

      return fieldNames[name] || defaultFieldNames[name];
    }
  }, {
    key: "getFieldNames",
    value: function getFieldNames() {
      var _this$props3 = this.props,
          fieldNames = _this$props3.fieldNames,
          filedNames = _this$props3.filedNames;

      if ('filedNames' in this.props) {
        return filedNames; // For old compatibility
      }

      return fieldNames;
    }
  }, {
    key: "getCurrentLevelOptions",
    value: function getCurrentLevelOptions() {
      var _this2 = this;

      var _this$props$options = this.props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options;
      var _this$state$activeVal = this.state.activeValue,
          activeValue = _this$state$activeVal === void 0 ? [] : _this$state$activeVal;
      var result = __WEBPACK_IMPORTED_MODULE_11_array_tree_filter___default()(options, function (o, level) {
        return o[_this2.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });

      if (result[result.length - 2]) {
        return result[result.length - 2][this.getFieldName('children')];
      }

      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(options).filter(function (o) {
        return !o.disabled;
      });
    }
  }, {
    key: "getActiveOptions",
    value: function getActiveOptions(activeValue) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_11_array_tree_filter___default()(this.props.options || [], function (o, level) {
        return o[_this3.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          transitionName = _this$props4.transitionName,
          popupClassName = _this$props4.popupClassName,
          _this$props4$options = _this$props4.options,
          options = _this$props4$options === void 0 ? [] : _this$props4$options,
          disabled = _this$props4.disabled,
          builtinPlacements = _this$props4.builtinPlacements,
          popupPlacement = _this$props4.popupPlacement,
          children = _this$props4.children,
          dropdownRender = _this$props4.dropdownRender,
          restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props4, ["prefixCls", "transitionName", "popupClassName", "options", "disabled", "builtinPlacements", "popupPlacement", "children", "dropdownRender"]); // Did not show popup when there is no options


      var menus = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", null);
      var emptyMenuClassName = '';

      if (options && options.length > 0) {
        menus = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Menus__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
          fieldNames: this.getFieldNames(),
          defaultFieldNames: this.defaultFieldNames,
          activeValue: this.state.activeValue,
          onSelect: this.handleMenuSelect,
          onItemDoubleClick: this.handleItemDoubleClick,
          visible: this.state.popupVisible
        }));
      } else {
        emptyMenuClassName = " ".concat(prefixCls, "-menus-empty");
      }

      var popupNode = menus;

      if (dropdownRender) {
        popupNode = dropdownRender(menus);
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_rc_trigger__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: this.saveTrigger
      }, restProps, {
        popupPlacement: popupPlacement,
        builtinPlacements: builtinPlacements,
        popupTransitionName: transitionName,
        action: disabled ? [] : ['click'],
        popupVisible: disabled ? false : this.state.popupVisible,
        onPopupVisibleChange: this.handlePopupVisibleChange,
        prefixCls: "".concat(prefixCls, "-menus"),
        popupClassName: popupClassName + emptyMenuClassName,
        popup: popupNode
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"](children, {
        onKeyDown: this.handleKeyDown,
        tabIndex: disabled ? undefined : 0
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var _prevState$prevProps = prevState.prevProps,
          prevProps = _prevState$prevProps === void 0 ? {} : _prevState$prevProps;
      var newState = {
        prevProps: nextProps
      };

      if ('value' in nextProps && !Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* isEqualArrays */])(prevProps.value, nextProps.value)) {
        newState.value = nextProps.value || []; // allow activeValue diff from value
        // https://github.com/ant-design/ant-design/issues/2767

        if (!('loadData' in nextProps)) {
          newState.activeValue = nextProps.value || [];
        }
      }

      if ('popupVisible' in nextProps) {
        newState.popupVisible = nextProps.popupVisible;
      }

      return newState;
    }
  }]);

  return Cascader;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Cascader.defaultProps = {
  onChange: function onChange() {},
  onPopupVisibleChange: function onPopupVisibleChange() {},
  disabled: false,
  transitionName: '',
  prefixCls: 'rc-cascader',
  popupClassName: '',
  popupPlacement: 'bottomLeft',
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_14__placements__["a" /* default */],
  expandTrigger: 'click',
  fieldNames: {
    label: 'label',
    value: 'value',
    children: 'children'
  },
  expandIcon: '>'
};
/* harmony default export */ __webpack_exports__["a"] = (Cascader);

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(1904);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1909);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(802);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(802);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1911);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(424);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(1916);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqualArrays;
function isEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  } // eslint-disable-next-line no-plusplus


  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_array_tree_filter__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_array_tree_filter__);








var Menus = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Menus, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Menus);

  function Menus() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Menus);

    _this = _super.apply(this, arguments);
    _this.menuItems = {};

    _this.saveMenuItem = function (index) {
      return function (node) {
        _this.menuItems[index] = node;
      };
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Menus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollActiveItemToView();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.visible && this.props.visible) {
        this.scrollActiveItemToView();
      }
    }
  }, {
    key: "getFieldName",
    value: function getFieldName(name) {
      var _this$props = this.props,
          fieldNames = _this$props.fieldNames,
          defaultFieldNames = _this$props.defaultFieldNames; // 防止只设置单个属性的名字

      return fieldNames[name] || defaultFieldNames[name];
    }
  }, {
    key: "getOption",
    value: function getOption(option, menuIndex) {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          expandTrigger = _this$props2.expandTrigger,
          expandIcon = _this$props2.expandIcon,
          loadingIcon = _this$props2.loadingIcon;
      var onSelect = this.props.onSelect.bind(this, option, menuIndex);
      var onItemDoubleClick = this.props.onItemDoubleClick.bind(this, option, menuIndex);
      var expandProps = {
        onClick: onSelect,
        onDoubleClick: onItemDoubleClick
      };
      var menuItemCls = "".concat(prefixCls, "-menu-item");
      var expandIconNode = null;
      var hasChildren = option[this.getFieldName('children')] && option[this.getFieldName('children')].length > 0;

      if (hasChildren || option.isLeaf === false) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-expand");

        if (!option.loading) {
          expandIconNode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
            className: "".concat(prefixCls, "-menu-item-expand-icon")
          }, expandIcon);
        }
      }

      if (expandTrigger === 'hover' && (hasChildren || option.isLeaf === false)) {
        expandProps = {
          onMouseEnter: this.delayOnSelect.bind(this, onSelect),
          onMouseLeave: this.delayOnSelect.bind(this),
          onClick: onSelect
        };
      }

      if (this.isActiveOption(option, menuIndex)) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-active");
        expandProps.ref = this.saveMenuItem(menuIndex);
      }

      if (option.disabled) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-disabled");
      }

      var loadingIconNode = null;

      if (option.loading) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-loading");
        loadingIconNode = loadingIcon || null;
      }

      var title = '';

      if ('title' in option) {
        // eslint-disable-next-line prefer-destructuring
        title = option.title;
      } else if (typeof option[this.getFieldName('label')] === 'string') {
        title = option[this.getFieldName('label')];
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        key: option[this.getFieldName('value')],
        className: menuItemCls,
        title: title
      }, expandProps, {
        role: "menuitem",
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }), option[this.getFieldName('label')], expandIconNode, loadingIconNode);
    }
  }, {
    key: "getActiveOptions",
    value: function getActiveOptions(values) {
      var _this2 = this;

      var options = this.props.options;
      var activeValue = values || this.props.activeValue;
      return __WEBPACK_IMPORTED_MODULE_6_array_tree_filter___default()(options, function (o, level) {
        return o[_this2.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });
    }
  }, {
    key: "getShowOptions",
    value: function getShowOptions() {
      var _this3 = this;

      var options = this.props.options;
      var result = this.getActiveOptions().map(function (activeOption) {
        return activeOption[_this3.getFieldName('children')];
      }).filter(function (activeOption) {
        return !!activeOption && activeOption.length > 0;
      });
      result.unshift(options);
      return result;
    }
  }, {
    key: "delayOnSelect",
    value: function delayOnSelect(onSelect) {
      var _this4 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      if (typeof onSelect === 'function') {
        this.delayTimer = window.setTimeout(function () {
          onSelect(args);
          _this4.delayTimer = null;
        }, 150);
      }
    }
  }, {
    key: "scrollActiveItemToView",
    value: function scrollActiveItemToView() {
      // scroll into view
      var optionsLength = this.getShowOptions().length; // eslint-disable-next-line no-plusplus

      for (var i = 0; i < optionsLength; i++) {
        var itemComponent = this.menuItems[i];

        if (itemComponent && itemComponent.parentElement) {
          itemComponent.parentElement.scrollTop = itemComponent.offsetTop;
        }
      }
    }
  }, {
    key: "isActiveOption",
    value: function isActiveOption(option, menuIndex) {
      var _this$props$activeVal = this.props.activeValue,
          activeValue = _this$props$activeVal === void 0 ? [] : _this$props$activeVal;
      return activeValue[menuIndex] === option[this.getFieldName('value')];
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          dropdownMenuColumnStyle = _this$props3.dropdownMenuColumnStyle;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", null, this.getShowOptions().map(function (options, menuIndex) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("ul", {
          className: "".concat(prefixCls, "-menu"),
          key: menuIndex,
          style: dropdownMenuColumnStyle
        }, options.map(function (option) {
          return _this5.getOption(option, menuIndex);
        }));
      }));
    }
  }]);

  return Menus;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Menus.defaultProps = {
  options: [],
  value: [],
  activeValue: [],
  onSelect: function onSelect() {},
  prefixCls: 'rc-cascader-menus',
  visible: false,
  expandTrigger: 'click'
};
/* harmony default export */ __webpack_exports__["a"] = (Menus);

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BUILT_IN_PLACEMENTS);

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _RedoOutlined = _interopRequireDefault(__webpack_require__(1922));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _RedoOutlined;
  exports.default = _default;
  module.exports = _default;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);
var _typeof = __webpack_require__(13);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
var React = _interopRequireWildcard(__webpack_require__(0));
var _RedoOutlined = _interopRequireDefault(__webpack_require__(1923));
var _AntdIcon = _interopRequireDefault(__webpack_require__(18));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var RedoOutlined = function RedoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _RedoOutlined.default
  }));
};
RedoOutlined.displayName = 'RedoOutlined';
var _default = /*#__PURE__*/React.forwardRef(RedoOutlined);
exports.default = _default;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var RedoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };
exports.default = RedoOutlined;


/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports = [{"id":"b8b5f218-21e0-45fa-9f65-9ad5ae9657a6","name":"21Century 風味館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/21th_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"dd54eea6-e02e-4eba-ad5e-21f8c792dbe3","name":"3皇3家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd54eea6-e02e-4eba-ad5e-21f8c792dbe3/8c75e7e8-5cdd-4166-a691-7d87ad79c479.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1bc0a8de-0071-4e6c-aa9e-38b9386b5366","name":"50嵐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc0a8de-0071-4e6c-aa9e-38b9386b5366/671fb07f-0f0f-4745-94f5-7ebd73d8f56d.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"fc2cc3db-156e-4426-8677-de0fdfd5bc84","name":"85度C","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc2cc3db-156e-4426-8677-de0fdfd5bc84/cefc4f9d-29a0-433c-8f5e-9fa48e0882fa.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"35380f58-bfe7-494a-8673-730a0d174688","name":"88號樂章婚宴會館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/35380f58-bfe7-494a-8673-730a0d174688/02cf623a-15ff-4f65-908e-681a0db202e5.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"efd4ca02-0495-4d28-a72d-826d71c04af7","name":"8M瓷化工藝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/efd4ca02-0495-4d28-a72d-826d71c04af7/fb180d95-1fdc-4cd7-a166-7b3943cda50e.png","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"6de5be7e-6c74-4566-a289-c6af3892652c","name":"946韓式豆腐鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6de5be7e-6c74-4566-a289-c6af3892652c/ac1ad464-415f-4046-82c5-d656c8f5fc0f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b75814f8-d94a-4908-a356-8946ef87c2f8","name":"A Mi Ya鞋坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b75814f8-d94a-4908-a356-8946ef87c2f8/e59bf00a-eb07-4241-8096-0d2bd2fddad2.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"90267a8f-0899-4438-902b-131a7e99a338","name":"A5 Studio","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/90267a8f-0899-4438-902b-131a7e99a338/7d8f2621-993f-435f-bc4f-1d9738845d86.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"228bd48a-77e6-4e35-85f1-3a243d2f459b","name":"Adidas","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ADIDAS_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ffbb3859-f9d3-4ad3-85c9-f713d454df71","name":"Adidas & Reebok Outlet","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ADIDAS_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"082d9402-35ca-4a2c-9b95-be0174153a7a","name":"AGE BOAT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/082d9402-35ca-4a2c-9b95-be0174153a7a/30fb9a55-b28e-4609-b878-7c544ae3e8ed.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"dd87ef74-d663-424a-b19d-6c4a5d2657d5","name":"AMG","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd87ef74-d663-424a-b19d-6c4a5d2657d5/80829dc2-2e2f-4549-8e2c-e2012f3a2005.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"21f919b3-a06f-4f63-bb1d-89e82b9d434a","name":"ANKL","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ANKL_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"198e53fe-1982-4469-a4dc-de0722696454","name":"ARENA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/198e53fe-1982-4469-a4dc-de0722696454/5fa75839-f85f-4f96-a722-10c8aa4841df.png","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8f044e32-f4cb-4da1-9af4-6e35fec85db7","name":"asics","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8f044e32-f4cb-4da1-9af4-6e35fec85db7/cad63bcb-11b6-4445-8223-c40de08ae34e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"e254a286-d883-4ec6-af7e-3fbceef6b5b7","name":"BABY FISH","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e254a286-d883-4ec6-af7e-3fbceef6b5b7/d3b61c9c-3ab7-40dd-a700-8e7caf508235.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"fa1e8aaf-3130-4850-bbdd-a7f122fa541b","name":"Baleno","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Baleno_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1ace8239-7cb5-4532-aea2-983929e47d0d","name":"Baronece百諾禮士","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ace8239-7cb5-4532-aea2-983929e47d0d/decc8823-4899-4c4b-bf86-e741c593aaf3.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"eec900c5-ef26-4316-94ce-f919fa79d881","name":"Bazzar","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/eec900c5-ef26-4316-94ce-f919fa79d881/f3fd9b69-af06-4f09-b85b-9efe0840a131.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"88e90d92-af64-4c05-9af1-155a68fdb44e","name":"Bernice Furniture","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/88e90d92-af64-4c05-9af1-155a68fdb44e/dcb757c5-aa7b-404b-9231-58d7cc8ae85e.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"de96e13d-d8bd-40e0-87d4-bc9bb0ea14a1","name":"BEST電器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Best_Logo_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"bb9e3006-461b-465e-8875-3310920fb6cb","name":"BH歐洲百年健身器材","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/bh_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"690c6c1f-b427-4ab3-899a-cecd14d9cf4d","name":"BIG TRAIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/690c6c1f-b427-4ab3-899a-cecd14d9cf4d/53edcde4-e4ad-44c1-a629-18317dcc0140.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cda2d017-b369-4048-a860-45d59d85f8aa","name":"BIG TRAIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/bigtrain_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1aab9073-eebc-4a23-9c5d-53cd2959eaf3","name":"BLUE WAY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1aab9073-eebc-4a23-9c5d-53cd2959eaf3/1dd291d3-a9af-46f6-bcaa-856dd8fa2c98.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5f67d4bb-8e39-4267-b38f-66fac3ce7a0d","name":"BM","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5f67d4bb-8e39-4267-b38f-66fac3ce7a0d/38984882-4f63-4c6c-8de0-88d4e1723c1c.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ab8ee62e-a7bb-4804-8957-e1d02ab2a3c2","name":"BOBSON","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab8ee62e-a7bb-4804-8957-e1d02ab2a3c2/0a155925-7373-4f3f-a6fd-031b40452bd7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cd2f1804-b6c5-4393-bfa6-4afe09b16787","name":"BOSSINI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BOSSINI_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"aa856f23-8e69-424d-aacd-52d7f7b165c4","name":"BTU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aa856f23-8e69-424d-aacd-52d7f7b165c4/45fe4bf7-bf55-4804-a68a-ffb9f8810639.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"01e3c3bf-d535-4a3c-9229-e0a87bf5d578","name":"Caffebene","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/01e3c3bf-d535-4a3c-9229-e0a87bf5d578/85a64c10-be33-466b-8a72-3f12af16da62.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"5ecb74f1-156b-47e5-b4ae-c70ac793b5f1","name":"CASIO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5ecb74f1-156b-47e5-b4ae-c70ac793b5f1/d1cd6053-76e3-427d-9dff-89d00631d3f0.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"998b8a69-35f9-4c97-bf5e-20355358fd2e","name":"CASIO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/998b8a69-35f9-4c97-bf5e-20355358fd2e/c25dad7e-226f-480e-b224-6736d5c8fcef.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"b06e1827-2d7f-41ca-8cd5-469ab3a4eafa","name":"CAT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b06e1827-2d7f-41ca-8cd5-469ab3a4eafa/dc93abe3-eca5-4c23-9007-c92ed6fa7dac.png","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"8f99126c-e047-4193-8994-bb5a39876552","name":"Coco","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8f99126c-e047-4193-8994-bb5a39876552/fb9a4356-c22f-48c3-963e-3a3446008be3.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"a8beed52-14d6-4fbf-a3b3-3e0cb21f2f6a","name":"Columbia","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Columbia_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"19a1d96f-6cc9-44c8-a34c-3494287565f2","name":"COMEBUY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/19a1d96f-6cc9-44c8-a34c-3494287565f2/ced24e49-d624-4656-9981-2ac63fb4c13e.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4ecc4b7f-7f78-410c-8a9e-df51da189f3e","name":"COMEBUY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4ecc4b7f-7f78-410c-8a9e-df51da189f3e/c366574e-b2aa-4363-af19-66ba5a12279d.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"b2afe3b2-af12-4646-8f07-d63a72d82601","name":"COMODE 紳士西服","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b2afe3b2-af12-4646-8f07-d63a72d82601/a9836b13-abba-41c9-a02d-037d7a73f53f.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"60bb5f0e-54d3-444e-8f31-443cbe0cb44c","name":"Converse","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/converse-logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"e76e8a18-3129-4cd8-b768-132a5f8226f1","name":"CONVERSE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/converse-logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"4103c7e3-cb81-4512-9453-f1f7ef3ed5dc","name":"CQ2 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/CQ2_Logo_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"3b920de7-a759-4c0c-94a7-73096aef59bd","name":"Crocodile","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b920de7-a759-4c0c-94a7-73096aef59bd/4a30c69f-9290-4457-9b17-09c7f480a119.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"c02f6c51-8d2a-44a5-92cb-35dc8b725fd6","name":"Crocs","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c02f6c51-8d2a-44a5-92cb-35dc8b725fd6/d644d357-b2e5-45fc-ba97-a760c677cbec.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"cf013f29-a243-4e06-87c5-8e6a93bf5ff2","name":"Curves 可爾姿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf013f29-a243-4e06-87c5-8e6a93bf5ff2/435caa94-1038-4691-97e3-a0a360042318.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"ed630301-ebfb-409f-a25b-a8c712e1aa26","name":"DECO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ed630301-ebfb-409f-a25b-a8c712e1aa26/fe4431f8-2ac6-4541-bd29-8501b0a22290.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"9475e3f7-267e-4c32-afe9-ee597aceb705","name":"DNA 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/DNA_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"d45f486f-c062-464c-843d-18cedc4bd31b","name":"EASY SHOP","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Easyshop_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"0b43f343-0da0-4f4f-8452-7b05e4434eb1","name":"e-baby","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0b43f343-0da0-4f4f-8452-7b05e4434eb1/8b3d8f70-a4ff-47d3-84e5-faafd1098d0a.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"4ef9c598-1e4f-4ea9-878a-b790d1fa392e","name":"ECCO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ecco_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"ea9e3413-f05b-4035-8919-91d09b836d53","name":"eCosway 特惠屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/COSWAY_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"12767bde-0196-4c57-b6bd-f529b8fce8c0","name":"EDWIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/EDWIN.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"e874a0c7-626a-441b-8622-c385f7fd0366","name":"Emily 艾美麗","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Emily_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"b37a73d0-efb0-4a5e-aada-7db07963c28b","name":"ESPRIT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b37a73d0-efb0-4a5e-aada-7db07963c28b/58670a8b-2679-4973-a42c-34f98034e30b.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b4537079-d5b3-45ea-99cd-574f1990a988","name":"Extreme","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/extreme_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3b40d7b8-f402-4598-9226-d662c09ef8d0","name":"Eye Fun","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b40d7b8-f402-4598-9226-d662c09ef8d0/44958864-491b-499f-907b-403741cfa87e.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"15acdfb5-43e1-4baf-9e57-30ce51f1d642","name":"EYE PAY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/15acdfb5-43e1-4baf-9e57-30ce51f1d642/74f57cc7-0e94-4180-8ec6-e45deb6b05cc.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"b7ce8261-b16e-4da1-be43-d8438509247c","name":"EZ專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b7ce8261-b16e-4da1-be43-d8438509247c/b95ec845-a820-40e6-9219-c915734b21f0.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"bef9a2dd-c43c-4180-9f6f-f07176981ba6","name":"F100極速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bef9a2dd-c43c-4180-9f6f-f07176981ba6/da1a929f-2cc9-424a-a169-c47a79f747b8.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"aea7e8c3-6e22-4f2e-8da5-0cfbc0ae98cc","name":"Favori","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aea7e8c3-6e22-4f2e-8da5-0cfbc0ae98cc/80ee385f-5944-4d6d-ac2d-9e952349d0d8.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"54f174e2-572e-4346-b0e9-9df5bebaa09a","name":"FUJI富士","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Fuji_Logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"62db36a5-12fe-472d-a62d-d43dadffe091","name":"fun box","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/62db36a5-12fe-472d-a62d-d43dadffe091/624dbad0-d214-4abf-b322-e710bfadcc47.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"7140d17b-8153-45d2-9ac4-30e50ba0c77a","name":"G2000","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7140d17b-8153-45d2-9ac4-30e50ba0c77a/ef080fb0-516c-4c8e-8df6-7b7553c3127e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5c2c34b3-9416-448e-877a-df5e3345cc93","name":"GNC","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c2c34b3-9416-448e-877a-df5e3345cc93/ea04e103-66b5-4287-b08d-80490c56fe1b.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"a04f17c0-6666-4aa0-a68f-612a94af1472","name":"GOORIK","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/GOORIK_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"655f3e9e-57e0-4afd-a12a-aacec3dbb7aa","name":"H&J","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/655f3e9e-57e0-4afd-a12a-aacec3dbb7aa/5cfddb49-d53b-418c-8359-3edf9bd5a9b7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ff773a48-f96c-43f9-96e2-4c43447c2860","name":"Häagen-Dazs","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Haagan_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"8079a854-b2d5-4681-b6d1-49bf1e76693c","name":"HANG TEN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8079a854-b2d5-4681-b6d1-49bf1e76693c/85b6bc10-e985-4c29-86d7-45211e6f525d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"0668063f-e997-4201-9aa0-c1c8791f09fa","name":"Hedgren&ELLE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0668063f-e997-4201-9aa0-c1c8791f09fa/06fc68c9-f3ac-41e3-bfd3-cc61195e900e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"289e56bf-f703-4692-85f4-1e317a16a488","name":"HOLA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Hola_Logo_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"60630aea-c821-49d6-b995-9e034b752221","name":"HOLA Petite","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/60630aea-c821-49d6-b995-9e034b752221/f548a02a-8745-4bac-8cce-a2f71a22b181.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"f5961805-6e2c-4692-b510-308bd7e43584","name":"hot 7","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f5961805-6e2c-4692-b510-308bd7e43584/04cd03c4-80e5-46dd-9958-531ef3ab4d9d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"349b92c1-e8da-4c1e-9af5-ac7d329fe2be","name":"HUSH PUPPIES","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/349b92c1-e8da-4c1e-9af5-ac7d329fe2be/a8bf57d7-9539-4996-ae07-964f3e794c47.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"95270f8f-7e09-4a15-a6fa-52a8f0f1e371","name":"i Color","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/95270f8f-7e09-4a15-a6fa-52a8f0f1e371/2fb1353a-b265-4462-be40-cfe94e85bd62.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"e30fb9f6-0db3-45ef-8414-005e669f295f","name":"IBEX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ibex-R_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b8736a4b-fca7-4667-81c7-cd014992ffa2","name":"ICU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b8736a4b-fca7-4667-81c7-cd014992ffa2/c10f1ede-9fab-4723-bbe5-9aca48bfe6d2.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"9a8c84a8-97d3-4a64-9e47-67d7d7f6afc0","name":"IF 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ifsalon_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"140a203a-69cc-4137-868b-7b71551c4d2f","name":"in89豪華影城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/140a203a-69cc-4137-868b-7b71551c4d2f/745d00d4-358a-43f4-a8a9-7c2b9bf77aa6.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"7b606808-4c18-4fc2-8003-a5d3def4825c","name":"J&C 典將鞋業","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7b606808-4c18-4fc2-8003-a5d3def4825c/6fbc26dc-4c4a-455e-9acb-b9d61b265ab5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"0baa02d2-6685-42c6-981b-57bdbe4a8fce","name":"Jeko","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0baa02d2-6685-42c6-981b-57bdbe4a8fce/628b3297-bef0-4f3c-bb17-b45431108c63.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"8b188537-d2b0-4292-99c3-6e72de6e48da","name":"JIT快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b188537-d2b0-4292-99c3-6e72de6e48da/babd7906-572d-449c-94ce-f85ce21fa609.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"50d46f6e-d047-4863-a209-127b83f2bb2c","name":"Johnson","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/johnson_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"7628c507-9ccc-49d9-a7b2-484bc15a07b5","name":"JUSTHOME","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7628c507-9ccc-49d9-a7b2-484bc15a07b5/91b63bce-3939-4c06-aeab-e1ea527a9ad8.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1bc64c0b-ef31-47f4-bf3a-1b9bc94ed633","name":"K.SWISS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc64c0b-ef31-47f4-bf3a-1b9bc94ed633/87d3e3a9-82eb-4ae3-a630-07c723a1e750.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f495bf1c-c728-4e33-a92a-a8437dbc3953","name":"Keds","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f495bf1c-c728-4e33-a92a-a8437dbc3953/436363c0-0366-4f8f-88db-12d0b68e746e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"67a970d6-09ec-414d-a499-a8866c94a0ae","name":"KiKi Studio","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/67a970d6-09ec-414d-a499-a8866c94a0ae/b333a285-4778-4624-8bf6-1175a0059e93.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"0f8f9092-58d2-4702-9b6e-0bb677477a52","name":"Kipling","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0f8f9092-58d2-4702-9b6e-0bb677477a52/abbfc65f-64d6-4594-bc53-f3ae04cd8224.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"9250e2dc-7d8c-46df-b70c-9c8ad7b5a8c1","name":"LACASA家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9250e2dc-7d8c-46df-b70c-9c8ad7b5a8c1/4f6bdbbe-a563-461e-a0a7-50aa92e9f3d5.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"f2d6df11-2959-49ce-82b7-57df0a009d1f","name":"LACHELN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2d6df11-2959-49ce-82b7-57df0a009d1f/39569070-fa76-46f0-af3c-33615fb0317e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a463cd6d-72b1-4368-ae27-4b12c4efb464","name":"L'A'CHELN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a463cd6d-72b1-4368-ae27-4b12c4efb464/da368c7d-726a-4379-96a2-50b5eba44311.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d160c40d-3796-4703-8910-c95601ffe185","name":"Lady Love","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d160c40d-3796-4703-8910-c95601ffe185/21c7af5d-3779-41f7-8578-1fa686a34afa.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"041f9483-00b3-4918-b7dc-a2c5bffdc354","name":"le coq sportif","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/041f9483-00b3-4918-b7dc-a2c5bffdc354/ca45be1e-d84b-41a4-96cd-b86389130c89.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"076b2476-2362-41d8-a400-c9a2ea2d9554","name":"LEE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/LEE_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"dfb071ac-4a9c-4aab-836a-41575ff096bf","name":"Lee Cooper","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/LeeCooper_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1ee9544a-d866-44fe-bddd-a134b0719fcd","name":"LEVIS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ee9544a-d866-44fe-bddd-a134b0719fcd/5aab47c1-96a0-4bfc-9ad5-4ed17c53e53d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7361db02-92f3-42bd-af34-6c0ae6ddd161","name":"LG","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7361db02-92f3-42bd-af34-6c0ae6ddd161/047376b5-8923-4ba4-94c7-bc19b5e9a812.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"d44d983e-05f5-442c-91d2-eda872a99a6c","name":"LiCha芙","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d44d983e-05f5-442c-91d2-eda872a99a6c/007caae3-89c1-4233-80a0-21adadbf77ba.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"f9660562-d589-4e3c-b184-d2d61f4af0c6","name":"LOTUS 樂德鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f9660562-d589-4e3c-b184-d2d61f4af0c6/90a5e538-0347-4dd1-b7ad-3304a7ce3f16.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"70e7448b-686b-463f-bfac-12656cd66195","name":"LOUISA COFFEE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/70e7448b-686b-463f-bfac-12656cd66195/883ade89-0fda-42f4-9371-00852c8b74b2.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"5c46ed35-56d0-42af-a969-28d96daced6f","name":"MACANNA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MACANNA_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"e1dc0bfe-e8c4-42cd-8716-913f43cf26de","name":"MANGO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mango_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"644f6fae-2446-4639-a568-a8c70b4ee4b6","name":"MARCROCOO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/644f6fae-2446-4639-a568-a8c70b4ee4b6/d12e6568-a839-426a-81e6-925e085810de.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"94e2bef9-8eff-4625-a877-ab14ea6ad392","name":"MERRELL","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/94e2bef9-8eff-4625-a877-ab14ea6ad392/33807470-d1fc-48a7-b81b-ba2e28335874.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"bbbb9ac9-e9cf-44f9-ab0f-52eb4a9473f7","name":"MIRUKU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bbbb9ac9-e9cf-44f9-ab0f-52eb4a9473f7/c4fe18bd-fc79-4d4e-a464-ac08a5374195.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b205ac21-334e-409e-a1eb-323b27f4ba59","name":"MISS TEEN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b205ac21-334e-409e-a1eb-323b27f4ba59/8d77a2de-7c1a-4c99-97cc-3a42b7cbc6c3.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7ce6e2e7-85c1-458f-82f7-8bedca6cecf2","name":"Mister Donut 多拿滋先生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mister_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"0c5871d9-37b6-45d7-a3f2-ff4651c6c8f2","name":"MOMA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MOMA_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"8af749f1-ca85-4e75-ae60-ffd697ced4a9","name":"MO-MO Paradise","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mo-Mo-Paradise_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2e839413-7764-4a4d-ac4b-277e6bc4628e","name":"Mr.Onion牛排餐廳","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mronion_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6353bbbe-8436-4a31-980b-f5f199d8ad5c","name":"Mr.拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6353bbbe-8436-4a31-980b-f5f199d8ad5c/cf797599-8f9f-4484-944a-59be083419f2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1bb605c2-a7cf-46c8-80f3-d891cc62cbdb","name":"NEOX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/neox_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"0190246c-9717-4c0e-a943-b6e12dcea304","name":"NET","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/NET_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"f91a697f-c0bc-4659-8cad-36e519749ea6","name":"New Balance","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f91a697f-c0bc-4659-8cad-36e519749ea6/afa077f5-bc5d-440d-811e-e9f6dfe227fc.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"89c47b4b-d0e4-4bb5-8f7e-d7f13a94895d","name":"New City House","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/89c47b4b-d0e4-4bb5-8f7e-d7f13a94895d/aef7cfad-4a6c-42bb-9c76-fdf050e266e3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a733cf1e-b259-4184-894b-07b8310d86fb","name":"New House","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a733cf1e-b259-4184-894b-07b8310d86fb/eb15b07b-5f2f-4976-8a42-645b106854f9.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b38d1dc-521f-4fe2-9340-50bf1f4a3566","name":"NICEIOI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Nice101_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b9786e7c-5d5a-4225-93a4-3c0c8fd721e7","name":"NIKE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b9786e7c-5d5a-4225-93a4-3c0c8fd721e7/8c590584-f72e-45e5-9cc4-0d5d493c8853.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f3563b1f-1596-48f4-a028-92c5c4f01392","name":"NOKIA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/nokia_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"a93cdfd2-cf8a-4a4e-8392-f6141741e16c","name":"NOODDI EXPRESS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a93cdfd2-cf8a-4a4e-8392-f6141741e16c/84d8ebdb-9d2b-4d52-96b2-f558a6059c4b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dc66a9f1-67dd-4b89-80f2-35b01225c800","name":"NOVA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc66a9f1-67dd-4b89-80f2-35b01225c800/c75761da-3152-4064-a9fa-6c8cd9b73581.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"f5d65a30-8ab8-4183-b3bd-d1d06eab53bf","name":"NU PASTA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f5d65a30-8ab8-4183-b3bd-d1d06eab53bf/a2670dfd-5e7f-4e32-8b2f-5bfa9d839cd5.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"82c1e840-9a64-49ac-8ddb-599777daa595","name":"ohoh-mini","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/82c1e840-9a64-49ac-8ddb-599777daa595/e4eb9277-0567-4c85-818e-5d9adb2b841d.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"e78e209f-728f-4b74-9600-7928cf1cfafc","name":"OMG運動休閒館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e78e209f-728f-4b74-9600-7928cf1cfafc/eb424b5c-4d1e-41c7-a227-685bc34fc018.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"6cc4645f-e30c-4e9f-a6ff-43d45691d678","name":"OTTO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6cc4645f-e30c-4e9f-a6ff-43d45691d678/f2151915-67b1-4e26-80d8-72aa486814cc.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cbd4d3f2-79a0-4e84-9cb3-8f8b01010715","name":"OUTDOOR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cbd4d3f2-79a0-4e84-9cb3-8f8b01010715/3ee9edc9-1542-4018-bc30-a053e5b415b5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"4ea1c43a-d4ce-441f-9fb4-b11f4f0bcc0d","name":"OWNDAYS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4ea1c43a-d4ce-441f-9fb4-b11f4f0bcc0d/3a740e89-e314-47ae-b649-cf3c2a1aac7c.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"0e3ef1da-0f00-4822-84a2-58e4dc0471f6","name":"P.B&P.C","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0e3ef1da-0f00-4822-84a2-58e4dc0471f6/7cd687fc-2071-46e2-b564-b1c82298c6b9.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8730083c-706f-4e51-8b4d-4a48a5fb159f","name":"PAPAYA泰式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8730083c-706f-4e51-8b4d-4a48a5fb159f/00aefe5b-9fdc-4c44-8e34-ac6cc35783cd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af70f7c9-cec3-483a-84ca-16e4049e1c89","name":"Paulmauriat","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af70f7c9-cec3-483a-84ca-16e4049e1c89/f82ee4d8-0fe2-4eff-815c-1560371b3c7c.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"3afcdfe5-dcc5-4204-a007-55bfb08b42e0","name":"POLAR BEAR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Polar_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ab1b4f7c-a63f-4b91-b5a8-f01457f72165","name":"POM POM PLUS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab1b4f7c-a63f-4b91-b5a8-f01457f72165/c2d8f136-d0c6-4aa0-84a0-f4751c73dc97.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"b7660278-e2b8-4e64-8332-b24e9a64d5ab","name":"POYA寶雅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b7660278-e2b8-4e64-8332-b24e9a64d5ab/f7ae7496-f1d4-4120-b423-d7affcb821c1.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"8b097921-f2bc-4926-b8c0-e67807688b0e","name":"PROTEST","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b097921-f2bc-4926-b8c0-e67807688b0e/a557ac23-8a04-4e69-80c4-44cd88b48ae5.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8b8ef5d7-e1d4-47cd-b8e1-65dc562c3f99","name":"PUMA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b8ef5d7-e1d4-47cd-b8e1-65dc562c3f99/47ff48da-c166-4038-bd3f-bbea60fd6a90.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d77417e0-c72e-4738-9812-122a1faa381a","name":"PYXIS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pyxis_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"368f2850-db75-4caf-a9cd-9bf39e63842a","name":"Quick cut KK","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/368f2850-db75-4caf-a9cd-9bf39e63842a/39147e6b-7bdc-4527-b89f-5b8dd18c962c.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"6ab26818-1601-4f15-a558-5a48d5d92465","name":"Reebok","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/reebok_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"696315d1-c632-4a2d-9e95-4d6e945b18c3","name":"Rockport","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/696315d1-c632-4a2d-9e95-4d6e945b18c3/e399d155-4db2-46cb-9170-c9b1663294f3.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"516f46db-ad9a-422c-a98b-de7712840a83","name":"Rookie","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/516f46db-ad9a-422c-a98b-de7712840a83/134808e8-9b45-4e84-b776-f47881866871.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"23b5f8ee-08c7-430e-b20b-1396e678eae5","name":"RQ POLO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/rqpolo_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"43d46df9-7410-4356-83b8-abb73b29d692","name":"Samsung","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/samsung_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"25bfdf40-3efc-475d-8b0c-900c7b575328","name":"SKECHERS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/25bfdf40-3efc-475d-8b0c-900c7b575328/aef9bf33-a5c9-424e-810d-301d9d10008b.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"88e251bb-8a75-40f9-8662-611b0604b357","name":"SO NICE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Sonice_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"e7dc4186-61fd-4989-8fbb-e9ecbd7a0484","name":"SOFTSUN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/softsun_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"876ed210-de00-4729-8ad5-7723eb38208a","name":"Sonora 尚諾奈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/876ed210-de00-4729-8ad5-7723eb38208a/c1a1c6c3-f08b-4a2d-bf5c-fdc11b83a6f6.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7321fa71-4ecf-4607-acbf-9317ccbfb2e4","name":"SONY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sony_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"ecdca60a-917c-4753-90a4-df61e4145e0b","name":"Speed Cut","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ecdca60a-917c-4753-90a4-df61e4145e0b/2861fff3-3dc4-4986-abd8-1b5098486c5d.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"c571d3e6-f58e-4f40-9da9-382eb9a47aa4","name":"Sperry","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c571d3e6-f58e-4f40-9da9-382eb9a47aa4/12d7f673-cf59-4e56-8f16-0127d2477926.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"a6715bae-a31a-4f32-b8a2-d99070f099e0","name":"Takara standard 日本寶廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a6715bae-a31a-4f32-b8a2-d99070f099e0/465cf851-68ba-45d5-ad22-fc0f75840a99.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"fc1c860a-a1e8-40b1-bd2c-22945b5412fd","name":"Tamoya烏龍麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc1c860a-a1e8-40b1-bd2c-22945b5412fd/e66f60a4-0233-480f-866f-ebbf98b5e39c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cd76fda4-aa36-4bda-bddc-4faee4376db4","name":"THE BODY SHOP","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cd76fda4-aa36-4bda-bddc-4faee4376db4/b0c9a57d-4d7d-49b3-839b-64dc3053da9b.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"2b4d2300-b699-4d03-8714-e5e49494f90b","name":"THE NORTH FACE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b4d2300-b699-4d03-8714-e5e49494f90b/ddd1866a-4c3d-4616-a76f-3548fec0694e.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b925f70a-831e-4e5c-b01f-aa471d4723e3","name":"Theme","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Theme_logo_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a1542fd9-225b-4ad1-9758-5ac77b99b952","name":"Timberland","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a1542fd9-225b-4ad1-9758-5ac77b99b952/79e68881-2bf2-4f1a-8e09-8c1a034a694b.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"62aff5dc-c0d6-4ee2-9a9b-7948ef298d68","name":"TINOS PIZZA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/62aff5dc-c0d6-4ee2-9a9b-7948ef298d68/027ba257-56af-4533-9618-8673ccc04697.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4349acd6-9639-43ca-b3ec-22122e15cbc7","name":"TOKUYO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4349acd6-9639-43ca-b3ec-22122e15cbc7/71666968-39c2-4f22-adf4-c7beae88cb38.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"5e25198d-8b0a-4677-90b2-6053a6f9bd2e","name":"TOKUYO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5e25198d-8b0a-4677-90b2-6053a6f9bd2e/a6ee3125-56a0-4113-8224-e25542f9c524.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ab22be48-2254-4890-bdbb-2d867984625b","name":"TOMS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab22be48-2254-4890-bdbb-2d867984625b/4abd5dc5-660b-47dd-86de-540f67340796.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"d16faeab-6193-4504-b46c-2ad965c6161e","name":"TRAVEL FOX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/travelfox_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"affcc816-1df5-4a43-a3be-77265b045be5","name":"Traveler","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/affcc816-1df5-4a43-a3be-77265b045be5/a2437c3b-2361-4ddc-baae-d849596c0f76.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"3d0e4ee8-a5b2-41fb-a147-d9cd411e465e","name":"UNDER ARMOUR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3d0e4ee8-a5b2-41fb-a147-d9cd411e465e/48ff0c96-e4e2-494a-9b41-3f4c660b57bd.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"0c7d9b35-56e7-4fab-a77b-cc2df52aa95c","name":"UNIQLO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/UNIQLO_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"687b3080-543f-4462-9104-fef76149e90c","name":"Verage","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Verage_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"23d20a13-0723-4948-99c8-0e59a36f275c","name":"VICTOR勝利體育","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/23d20a13-0723-4948-99c8-0e59a36f275c/99644fba-dfed-49c7-8e24-29b93919905c.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b57ca098-3532-491f-a72b-3308440b325e","name":"VIZ","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/viz_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b4d57c58-6dd3-4558-b2f1-522953399941","name":"WALLABY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b4d57c58-6dd3-4558-b2f1-522953399941/04d2cc99-521d-4ba1-99c0-254fccec7afd.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"e5f667ac-9e9c-4685-aa5d-808ec2bf6c84","name":"waltz","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5f667ac-9e9c-4685-aa5d-808ec2bf6c84/8fbf2a08-31c1-4594-b3d1-9164bcd16f2c.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"3ab1e14a-2e29-4b40-a820-1163229adefa","name":"WORLD GYM","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3ab1e14a-2e29-4b40-a820-1163229adefa/f4b537a8-b575-4167-bc9d-ffc56a97f1c7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"42ccbcdc-d46f-47cb-9f2e-224739b9679d","name":"Yamazaki 山崎麵包","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/42ccbcdc-d46f-47cb-9f2e-224739b9679d/e8d875c4-151f-4e95-a832-0d82a3601e8d.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e9fc6306-ba28-4bb6-afc6-6347de7facd0","name":"Y寶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e9fc6306-ba28-4bb6-afc6-6347de7facd0/8b75ff0a-7a59-4276-828e-01df6182adba.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4364e8c4-d1e6-4379-bdb3-88f4fa474daf","name":"Zen Q","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4364e8c4-d1e6-4379-bdb3-88f4fa474daf/97cd9d48-9592-4fe4-9121-b1ea53e4d07b.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"d0f3e251-ecff-4edd-8d2d-89c5f5ade87c","name":"一亨運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/iheng_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ca081d99-49fc-46fe-8f58-43d6a23c2d64","name":"一點工夫","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ca081d99-49fc-46fe-8f58-43d6a23c2d64/fe2ff446-0807-42fd-80bd-0acf9e68234d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cf3fd45c-60d9-4f44-bfea-34bc9572fbfe","name":"三友藥妝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf3fd45c-60d9-4f44-bfea-34bc9572fbfe/cb64ec8c-0747-4917-8bd6-1a0e9cd245b2.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"6565a3d4-977e-4efd-a952-0b40ef5e98e6","name":"三商巧福","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6565a3d4-977e-4efd-a952-0b40ef5e98e6/8c3cec6b-159a-42a3-91f8-787b058d86e3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"72669bb9-0fd1-48fe-a144-c60af315f051","name":"上都","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/72669bb9-0fd1-48fe-a144-c60af315f051/b60a0f65-c5fd-4579-8147-2e5b769fc540.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"958c94b5-36ad-48d3-b117-b05724b0f402","name":"上騰鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/958c94b5-36ad-48d3-b117-b05724b0f402/2b57e18e-1f65-4dc0-b4e1-f58c38d013c5.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0d4bc4fc-e7e9-4044-a0ce-75a74d09b835","name":"世偉運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/shihweisport_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"5eceaacd-effb-4bd1-81e9-a4655de58729","name":"中一排骨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5eceaacd-effb-4bd1-81e9-a4655de58729/b785bf70-f1cb-44d3-904c-e0b19b1590cb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dc25a6bc-dab6-4c05-93eb-bdef21b8f697","name":"丸龜製麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc25a6bc-dab6-4c05-93eb-bdef21b8f697/ca0fef7a-e072-4ec2-9b53-20707f228b6f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8b990877-8c1f-4f52-949f-a03d46581ad1","name":"丹堤咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b990877-8c1f-4f52-949f-a03d46581ad1/7c01eebb-3e44-44dd-b192-4211ca9b9eea.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"940a7a8c-b42c-4a87-954a-1bd0999372c2","name":"丹尼先生自己喝茶飲","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/940a7a8c-b42c-4a87-954a-1bd0999372c2/2f1d1c55-4435-4057-a4ee-318f2c5c2ea1.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"3a15e182-c1f2-46c1-9fd6-106cbedc4f90","name":"乾杯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a15e182-c1f2-46c1-9fd6-106cbedc4f90/a56a7a60-43a2-433b-b519-65ee8a58eeee.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"aafb5a89-cc51-4077-97c1-d39a6c0afdc5","name":"五花馬水餃館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aafb5a89-cc51-4077-97c1-d39a6c0afdc5/7fbfa812-19cd-4d9f-9509-6edd8bf29a30.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7489abd4-6a26-44da-ae48-1418b82d8a55","name":"享趣玩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7489abd4-6a26-44da-ae48-1418b82d8a55/21020d83-ab7c-4274-b12d-4188bc1c0aec.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"681a3181-7625-406e-a6c4-9ce81e0ddf9b","name":"京澤苑日式鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/681a3181-7625-406e-a6c4-9ce81e0ddf9b/ad4ab922-bdaa-49b0-8354-de76ed8952a3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2838c4a4-1c1d-4fcd-bbca-dd5a149553df","name":"京都苑","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2838c4a4-1c1d-4fcd-bbca-dd5a149553df/7c4a5425-652d-4808-b221-79d6cbc1c8f9.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"7cc179e0-e362-4fba-9dc6-1711e5f72fc2","name":"亮誠美車科技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7cc179e0-e362-4fba-9dc6-1711e5f72fc2/597562f8-3ea4-4555-a0cc-4c390a004674.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"97648411-edbc-4cd2-bd4d-def34a2f3c25","name":"仙妮蕾德","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97648411-edbc-4cd2-bd4d-def34a2f3c25/d5669c39-6060-4e71-b1f7-2406dc5be3da.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"d64dfd76-c451-48ea-88d5-84609b1c9289","name":"仙德曼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d64dfd76-c451-48ea-88d5-84609b1c9289/3c3d1ab6-249c-457d-9b3b-b446e88260ac.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"2e02bc5c-f1d6-4d2b-993c-3d9679c0e8d7","name":"仙霖茶行","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2e02bc5c-f1d6-4d2b-993c-3d9679c0e8d7/817fd5ed-4fed-4e45-b5d5-1914091e6a0a.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"6e2c6613-6794-4319-ba3b-66c23ab95f78","name":"伊太郎","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6e2c6613-6794-4319-ba3b-66c23ab95f78/572c481f-d097-45df-b08e-d5bf9da8233a.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e564ac07-56b8-48f4-b321-68022ce49046","name":"伊妮 INI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e564ac07-56b8-48f4-b321-68022ce49046/86f845ae-0e74-499c-b2d2-9b0613ad7082.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"fa2ba7c4-e5ca-4a30-a572-5495a53cd89e","name":"伯朗咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MR_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5a874689-95bd-4feb-bcc2-4eaa1f8c7a91","name":"佐丹奴 GIORDANO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a874689-95bd-4feb-bcc2-4eaa1f8c7a91/af083a2b-1927-4847-a601-2451d71f17e9.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"fd7f8bed-887e-4083-a7ce-d700ff256338","name":"依夢內衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fd7f8bed-887e-4083-a7ce-d700ff256338/b4560929-ff73-41de-a59d-8413c527122a.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"a98e9d24-10a5-49be-b022-7e08afb0ba04","name":"倍儷蔻","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BELECO_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3c9a3138-f8b1-494d-b4b2-6d6d85bc6dac","name":"健身工廠","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3c9a3138-f8b1-494d-b4b2-6d6d85bc6dac/e7cfac19-7810-4c10-af89-cf84bff17be7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"73711921-d262-41ca-9417-5c7208a1f129","name":"優尼聖運動聯盟","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/73711921-d262-41ca-9417-5c7208a1f129/17cca759-b561-4ab8-bb65-53de91bfa78f.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"9fd2366d-e086-451e-a314-8acac96d6fa6","name":"優衣庫","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9fd2366d-e086-451e-a314-8acac96d6fa6/dde61bc6-06fc-4e31-aba4-7ba70eb84d7e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"19478ed1-cc8c-4fd8-9e3a-ae1c64e2e1f6","name":"元呈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/19478ed1-cc8c-4fd8-9e3a-ae1c64e2e1f6/b3b1f9ce-7ca8-4f0a-b660-f4b0e75f8e7b.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"601d3768-6c4f-4e41-974e-9b10883bb748","name":"元氣咖哩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/601d3768-6c4f-4e41-974e-9b10883bb748/ccafd184-87d8-46eb-9311-e5e498d01291.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"fd6fa8d0-e0f5-44d3-a40b-88eb854817aa","name":"克萊緹","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fd6fa8d0-e0f5-44d3-a40b-88eb854817aa/48723c01-6339-47ce-9f3b-245788640893.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"1be21ee2-b1d3-4e9d-8fc8-633167138cd9","name":"全家便利商店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1be21ee2-b1d3-4e9d-8fc8-633167138cd9/feca2efa-053f-4496-8fa3-03b57ac6d946.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"d637b4e3-b959-441e-862b-82740659514d","name":"全家福","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Familyshoes_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"cb4a4cc0-4cab-4899-9556-71574b3859cb","name":"全廉工坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/chainlive_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"9a2b0de5-a8c9-434a-9683-30f7df6f6a01","name":"兩餐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9a2b0de5-a8c9-434a-9683-30f7df6f6a01/1137af29-85d8-4497-b975-c7e6cb7d642e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9c3a482f-39e9-47f8-9b2a-5ffe92c20f69","name":"八&#22338;丼屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9c3a482f-39e9-47f8-9b2a-5ffe92c20f69/62a77b88-261c-4726-83d1-5ec2aab1c003.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"80135b2a-de42-42d0-b194-ffcb6dd3b3e3","name":"八月堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/80135b2a-de42-42d0-b194-ffcb6dd3b3e3/06537889-502d-4e56-a79d-7f141d90db30.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"416f2646-e590-4232-bd6c-4205a0daa5e4","name":"八番赤野","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/416f2646-e590-4232-bd6c-4205a0daa5e4/9744b9ce-0f56-4273-a83c-95a841cee598.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cc776de5-ee39-4fe8-90d0-6625b7df76d5","name":"凱林鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc776de5-ee39-4fe8-90d0-6625b7df76d5/b0d87634-6a5a-4e43-a871-3d3f4da91007.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4316048f-1a25-437e-97cf-44f2a0feaad9","name":"初丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4316048f-1a25-437e-97cf-44f2a0feaad9/20a9d2eb-8fae-46e7-ae38-0d4849f139ce.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1b0a8e21-1bf3-41c4-b791-24bfbfb72d63","name":"初嘛超市火鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1b0a8e21-1bf3-41c4-b791-24bfbfb72d63/6689f4f1-38ac-416f-895f-16cc75be6642.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b1d40047-aa25-42f8-9917-798ab2dd355a","name":"勃肯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b1d40047-aa25-42f8-9917-798ab2dd355a/90d2a9ed-bab6-48fc-af01-1d3e9c292861.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"71d0782d-9452-4027-b8c2-d9a63532f4f4","name":"勝博殿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/71d0782d-9452-4027-b8c2-d9a63532f4f4/71839e83-2e77-4250-b811-013d2d60d184.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af9ea9b2-f396-4449-a0a8-f8fc97880618","name":"勝里日式豬排專賣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af9ea9b2-f396-4449-a0a8-f8fc97880618/db246bd0-517e-4a78-87ca-a236a54bc24a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bd9040f3-f332-43ca-879d-19f741643096","name":"包心粉圓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bd9040f3-f332-43ca-879d-19f741643096/a2eecaa6-962e-44db-91dd-7f1491cdfd87.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"a09bde1e-0559-45f5-a05a-81dcd4bb0a50","name":"北澤壽喜燒專門店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a09bde1e-0559-45f5-a05a-81dcd4bb0a50/fdbbe9a1-091f-49ef-a2a8-56c6cf12a0a8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"798af07b-2338-425c-add5-8c2d35c8af0d","name":"匠喝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/798af07b-2338-425c-add5-8c2d35c8af0d/7ee4aaaa-5f7c-4792-b3d1-51dc02efd095.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"c74f933e-718a-4f3c-bdf3-0215b46d9962","name":"匠關東煮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c74f933e-718a-4f3c-bdf3-0215b46d9962/540dae9e-1f0c-4270-9f87-d2dff0dbd300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"120497f4-df26-42eb-9317-96aa9bd89e9a","name":"卉豐園藝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/120497f4-df26-42eb-9317-96aa9bd89e9a/c27c3a2b-3998-434c-9941-64af8e0a851b.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"4d790c1b-ea76-46cb-bf69-7f31191908f1","name":"半雞八兩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d790c1b-ea76-46cb-bf69-7f31191908f1/8c685470-ad02-47af-9b56-7a0fab1041d3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2bdbf841-739b-4206-92a0-d37ddf52df5d","name":"卓越汽車","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2bdbf841-739b-4206-92a0-d37ddf52df5d/43470ad0-32e8-4c29-a8ab-ef72df9c2e72.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"c0d5c603-69cf-4b31-97aa-be3691812f14","name":"南大門","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c0d5c603-69cf-4b31-97aa-be3691812f14/a2d00ac5-bf55-47ce-b99d-329d56a1c5c0.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7e0400ec-fa0e-406b-89fd-08ae61843e06","name":"博帝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7e0400ec-fa0e-406b-89fd-08ae61843e06/dfbd6511-dc2c-4d72-92c6-2f37ed89cdc7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"4b2d1d69-ee36-42f4-8d3c-24d33f63fffd","name":"卡氏汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b2d1d69-ee36-42f4-8d3c-24d33f63fffd/96bc7669-a80d-46e7-b8b7-a87563826aba.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"1cb2252d-5f98-4907-889f-d567c6091e59","name":"卡紛","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1cb2252d-5f98-4907-889f-d567c6091e59/a347c061-9164-4917-815c-9b489d0c27f0.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3e529030-bf1f-4e91-a274-3398595838af","name":"卡西歐樂器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e529030-bf1f-4e91-a274-3398595838af/be20322a-efa7-428b-9ae9-c38442c73b6c.jpg","cat":"8d59d7ab-8fa9-4ee0-871d-f46962bf7456"},{"id":"6eb06bcf-add1-4d04-95b3-2fe8b2989db1","name":"原燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6eb06bcf-add1-4d04-95b3-2fe8b2989db1/882dc47e-ca36-43ca-a9d8-f8045f245e96.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"171fedc7-61aa-45f9-8505-3799c5e543f2","name":"口力口里","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/171fedc7-61aa-45f9-8505-3799c5e543f2/ad14b648-9420-465c-ab09-88ea0e4e80e3.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"be55930a-01ff-44dc-8cab-e7b27de84c7d","name":"古拉爵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/be55930a-01ff-44dc-8cab-e7b27de84c7d/e7f22830-cf5f-49b2-b0d6-f412b90093fe.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3b002889-cfc8-41b2-9df4-3c7ded51fdc6","name":"叭咘遊戲樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b002889-cfc8-41b2-9df4-3c7ded51fdc6/d496c058-445d-4389-bf0a-a7994754446e.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"2d72b272-77c9-46a7-aa06-71d1758d1541","name":"台灣大創百貨股份有限公司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2d72b272-77c9-46a7-aa06-71d1758d1541/81840717-e6f4-40ea-b11e-3abedfb59e91.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"382327f6-73e8-4ada-a926-9f8ee17b4d80","name":"台灣彩券","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/382327f6-73e8-4ada-a926-9f8ee17b4d80/363823de-a162-4da4-b43f-74742db12fb5.jpg","cat":"11ed25a1-d424-42d1-bfb6-4671f87bbf55"},{"id":"0f7b9822-ad6f-4b9c-ba50-79559461d4b2","name":"吉豚屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0f7b9822-ad6f-4b9c-ba50-79559461d4b2/ecb5fcf4-1cba-419d-b341-a5c38dc3f29d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f84e8bfe-4988-4705-9597-4e14ce29ca6e","name":"吉野家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f84e8bfe-4988-4705-9597-4e14ce29ca6e/b00e763e-9ae9-47fe-bb82-59adbd013fe3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8fc91ba7-d438-49ad-beec-75035a60a470","name":"吸霸","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"a4288f92-60de-4b2c-8dcf-79915d73b739","name":"吸霸","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a4288f92-60de-4b2c-8dcf-79915d73b739/2573ae46-6714-4c1e-addc-8b6bfe326761.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"45596f36-93ec-4009-afe4-daeed7813e79","name":"味滿食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/45596f36-93ec-4009-afe4-daeed7813e79/35549280-a0e2-4f8d-95b1-a23d0ae4a615.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"21973f1e-7996-4630-bdc8-69b4feb56ff6","name":"和漢鐵板燒Express","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/21973f1e-7996-4630-bdc8-69b4feb56ff6/eea2cfff-f78e-4ba7-8d06-3a47d933f9de.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f227db39-6e9b-4fec-9fec-437bd94cc905","name":"和美國際","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f227db39-6e9b-4fec-9fec-437bd94cc905/38678df3-d7f4-444c-b360-29dc50971227.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cc99dca6-6749-4a73-b5d9-44bbaf1723d2","name":"咖啡先生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc99dca6-6749-4a73-b5d9-44bbaf1723d2/4561405d-762b-4122-ab60-99b0436c5e75.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"9cf4b456-c0e9-4bc9-8d50-0f7b2ef79d4b","name":"品川蘭","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9cf4b456-c0e9-4bc9-8d50-0f7b2ef79d4b/9868ff9f-9efb-423b-a3a9-0d71f295bf60.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a54bccdc-50b7-4c55-bd1d-f7c409b10834","name":"品田牧場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a54bccdc-50b7-4c55-bd1d-f7c409b10834/57a70a67-f821-4199-8c73-3cac23d4a04c.jpeg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7bdc6bf4-a7c8-41f0-be7b-29330974bc96","name":"品赫鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7bdc6bf4-a7c8-41f0-be7b-29330974bc96/441b78db-7efa-4efd-8630-ea99a917b064.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1044f851-2ab6-49d8-be6a-66451fad1a42","name":"哈克士戶外","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1044f851-2ab6-49d8-be6a-66451fad1a42/96db3d9c-b382-4474-82ad-99423719b455.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"2999fd26-deef-47c6-8c11-b849b5026daa","name":"哈根達斯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2999fd26-deef-47c6-8c11-b849b5026daa/71159304-96a0-46dc-8fee-918fa35b07dc.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"d506cc1f-b153-43c3-911c-78008b4e5725","name":"哈肉鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d506cc1f-b153-43c3-911c-78008b4e5725/53ec318b-dd9d-4043-9057-8a655d3fea40.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"25307012-f82c-4f0f-9319-c34bc3ddd941","name":"喜粵樓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/25307012-f82c-4f0f-9319-c34bc3ddd941/898c8df2-7d6e-4fc9-9296-ccef9c36bb91.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b4078d12-a020-4b29-88fd-6ab0a6334484","name":"喫茶趣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Tea_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"58927fab-2dbd-439e-bfe8-455905c89b6d","name":"喬治派克","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/58927fab-2dbd-439e-bfe8-455905c89b6d/77463e52-b9bd-4613-96b2-18c722bf1d3f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4804a210-6fdb-4d61-8921-8280949c1dbd","name":"喬治皮鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4804a210-6fdb-4d61-8921-8280949c1dbd/4a991e3d-2948-473d-a4f8-f24e801d3de3.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"ff371136-288e-4dce-b683-17d357b22496","name":"嘉晉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ff371136-288e-4dce-b683-17d357b22496/3ae8af93-bebf-483f-9857-27919fb3286f.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"faa6b93f-cafc-4b9a-be25-e9b7686ceb39","name":"四作良食","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/faa6b93f-cafc-4b9a-be25-e9b7686ceb39/b5a1f161-fcb4-4a75-b0b6-ecb5e552f2aa.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bba359e7-2c77-4ba8-942c-b55bd350df2b","name":"圓圓圓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bba359e7-2c77-4ba8-942c-b55bd350df2b/3e178a92-4a7d-4700-984d-a05a21361ace.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cb380a5f-3474-4088-9e9b-4aa4a0366e4e","name":"均均紅豆餅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb380a5f-3474-4088-9e9b-4aa4a0366e4e/aee22aa9-3a33-4786-8d6b-ebaffdb4858f.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e7a69103-0740-4f3c-a4c4-06af4ca0c62c","name":"均岱鍋具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7a69103-0740-4f3c-a4c4-06af4ca0c62c/d710863b-7a07-48f0-a189-190343fd5835.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"684a88c3-eea1-459b-84d5-ad20429acfdd","name":"城市家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/684a88c3-eea1-459b-84d5-ad20429acfdd/109091b2-7b37-41b3-bd68-2c129a56d2de.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"97c4e862-b502-46b1-83f4-97a7cd016c48","name":"夢工場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97c4e862-b502-46b1-83f4-97a7cd016c48/b76413ea-367c-4e44-a066-fd6b5fe1e729.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"3bf28389-2ca6-4dc3-804c-6f134f7fa84d","name":"夢想銀行","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3bf28389-2ca6-4dc3-804c-6f134f7fa84d/9a27295f-dc2e-4688-93e6-b79b1466485b.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"eafa9174-154c-4521-9b1d-61bd771cad7f","name":"夢特嬌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/montagut_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ac14bcf4-0346-4428-9ba0-17b879eb0d26","name":"夥伴生活","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ac14bcf4-0346-4428-9ba0-17b879eb0d26/e84f204a-ebf7-4bde-a6bd-089fa6a91ff9.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"9738d572-bba4-49d8-aacd-aa7c8124b186","name":"大喜鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9738d572-bba4-49d8-aacd-aa7c8124b186/a8f81f78-5aa3-4fcc-a77b-41f24bec7e55.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"014cd87a-988d-4786-9fbd-65ec0ed28464","name":"大心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/014cd87a-988d-4786-9fbd-65ec0ed28464/89c2ade9-082b-4d07-a8ae-df431efe3c2f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"68f75d02-892f-45ae-96a3-955eebba9a85","name":"大戶屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/68f75d02-892f-45ae-96a3-955eebba9a85/72249dc8-3dd0-4ff8-b5f9-fdf103565f04.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ed450dd8-0c10-49c4-8e6d-8ef3d8baf9cc","name":"大手前鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ed450dd8-0c10-49c4-8e6d-8ef3d8baf9cc/958ec79c-2033-49d7-8025-57e746a25f9c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e3e7864f-6efb-41eb-9f82-3a6f7b4b1bf7","name":"大河屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e3e7864f-6efb-41eb-9f82-3a6f7b4b1bf7/0439d413-417f-49b3-9dd8-9d0453ee3545.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bf1de11f-1bbe-4c12-a8f4-44976431f02c","name":"大目黑山寨飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf1de11f-1bbe-4c12-a8f4-44976431f02c/89513c53-d7ee-4e08-bcb7-6c6ea11f0b6b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7ac2e6d9-cd68-4e50-b939-ce5b0f3c2a15","name":"大紅袍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7ac2e6d9-cd68-4e50-b939-ce5b0f3c2a15/b6d68d4b-8a7d-41ba-b1cb-9707e359825b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0701501d-ac69-4d62-a729-2dbef6137652","name":"大象山","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Da_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2c852077-d9aa-49e6-af55-c213240fc220","name":"大阪王將","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2c852077-d9aa-49e6-af55-c213240fc220/9c84c44a-45e7-4efa-abe5-516cd636cc12.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dd1a326d-4563-4fe7-b65c-384dd58ed734","name":"天仁茗茶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd1a326d-4563-4fe7-b65c-384dd58ed734/7a4338bf-5e5d-4988-b6da-599f5527ade9.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"ef54c7d1-c875-40bc-90e6-8ad9126b162e","name":"太和工房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/TAHE_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"5ca5782e-0956-4f73-b3fb-33a7e1a682b9","name":"太子鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5ca5782e-0956-4f73-b3fb-33a7e1a682b9/af803768-dcfc-43e0-a139-e3772028a293.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"402f0b13-5ebf-4b2d-aa8e-831cea79c148","name":"奇威名品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/KeyWear_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"74154e47-c5d7-4564-b961-fa32e523d128","name":"奧特龍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/74154e47-c5d7-4564-b961-fa32e523d128/12329bdd-6e42-46a8-8848-f979068c8aef.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"e03c4d79-e1d0-49d5-b301-850bcfe77c52","name":"奧黛莉 Audrey","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Audrey_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"66ed5472-a2ad-4196-9338-a3a63ea55da7","name":"好事晴","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/66ed5472-a2ad-4196-9338-a3a63ea55da7/980b834f-694a-407d-ad25-8390b53f50b2.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"df19b2be-f64a-4c00-a807-dfc1f2e3d3c6","name":"娜娜廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/df19b2be-f64a-4c00-a807-dfc1f2e3d3c6/5f24c432-19e0-4dec-817d-0d3fd34cf6ea.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"3ea309de-599c-46bb-892e-2053964c7715","name":"季季樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3ea309de-599c-46bb-892e-2053964c7715/e47b75c6-b2b5-4133-bb4b-7997f4b87e89.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"4aed4907-54a4-4f7c-bb15-ec9817f9697c","name":"宅技研","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4aed4907-54a4-4f7c-bb15-ec9817f9697c/e82077e7-e785-49d8-b5ab-1ec8959f838b.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"77d2ec18-8d9f-4a9d-b27a-aa0077b24657","name":"定食8","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77d2ec18-8d9f-4a9d-b27a-aa0077b24657/0724b083-8390-4110-821f-121b2847bd7f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a6bc72af-06fd-4d4a-b076-8e80b5a3eb0b","name":"宜得利家居 NITORI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a6bc72af-06fd-4d4a-b076-8e80b5a3eb0b/ac006af6-b3a2-4ed7-92d4-b42ea2b86a1c.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"0b320730-8eac-40e6-bbd6-a4bd8760a187","name":"家飾主義","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0b320730-8eac-40e6-bbd6-a4bd8760a187/102841b0-d805-45b4-a314-d0c78aa2a048.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"8888a8e7-f43a-458a-a87c-d93ceb4b3e83","name":"富士匠鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8888a8e7-f43a-458a-a87c-d93ceb4b3e83/76d9a92b-5212-4f7e-97e7-52645f653e9a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"83095780-dcce-4ba5-88d1-7a1594274f9c","name":"富發牌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83095780-dcce-4ba5-88d1-7a1594274f9c/7f9560e4-46c6-44c6-b780-dd11793393d5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"a99c0f56-9a3d-4c38-9b33-6dd91f4c3e9d","name":"寵物公園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a99c0f56-9a3d-4c38-9b33-6dd91f4c3e9d/5a540b0e-4756-4881-b8d2-c666ab0b50a6.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"a1204f7f-a937-46c5-8d04-4724fed73fdd","name":"小蒙牛","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a1204f7f-a937-46c5-8d04-4724fed73fdd/ef4c2253-df5c-4c4c-8682-86d5acdba551.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5368a2f4-3655-47c1-aaba-2bb8d592e09f","name":"小鐵鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5368a2f4-3655-47c1-aaba-2bb8d592e09f/99cfcc6a-feaf-45f2-b28c-7a6d092f9f7b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a49aa441-0cde-40e3-81ff-c3e4bea1c7c4","name":"小陽鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a49aa441-0cde-40e3-81ff-c3e4bea1c7c4/de524ed4-009b-4f60-b61b-209ba0010913.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"030110bd-b95b-4e86-881a-e6069868e8ab","name":"小鱷魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Crocodile_300x300.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"2d98a747-a6dd-4ac9-bc20-4e79a5e61544","name":"屈臣氏","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Watsons_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"2481f7a3-f503-419f-9bfa-ea43b24cbaf0","name":"山水婆新加坡南洋料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2481f7a3-f503-419f-9bfa-ea43b24cbaf0/5114794a-1bc9-46b9-9539-36f344f5b00c.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"bf8bcbf0-f8f9-4ddb-9a80-0949f1cedf7d","name":"山羊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf8bcbf0-f8f9-4ddb-9a80-0949f1cedf7d/c3b617d8-a092-43fd-b9b1-9ce0e3d34625.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"98cb49d6-8c1f-434d-a165-7d2e4147544b","name":"山茶園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98cb49d6-8c1f-434d-a165-7d2e4147544b/de8f49c9-2d7e-41fb-a1c2-8278fef23fb3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e53f7925-771e-44ef-b4a2-1408fa18d763","name":"山頂鳥","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/HillTop_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"7646e04f-2daf-411a-b956-785913485523","name":"岩葉拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7646e04f-2daf-411a-b956-785913485523/e0f54bba-2615-4190-bfd6-381b6401ec9a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"98c5055f-b3f5-452e-adb2-dd4b3c8502b4","name":"幸福汽車","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98c5055f-b3f5-452e-adb2-dd4b3c8502b4/895bdcb1-3425-4835-a283-5c20daaabb97.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3d3a3480-a8a5-42e0-87e2-ad19dc1f8beb","name":"幾分甜","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/howsweet_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"652573a9-b0c4-4186-8419-2db6a0b0232e","name":"府城食府","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/652573a9-b0c4-4186-8419-2db6a0b0232e/acbe1578-ddfe-438a-b3d3-3b151ef5fc4f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"857e3e77-8e05-47a8-b623-e6423ba27a70","name":"康是美","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/COSMED_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"dbf18f7e-3a7c-4392-a8d6-b20b5570840f","name":"廣生堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dbf18f7e-3a7c-4392-a8d6-b20b5570840f/f68d77fc-ddc0-4415-b3b3-01100a025125.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"136c3078-a749-4776-a92c-9f16b545fc4b","name":"彩遊館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/saiyukan_300x300.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"c7c3090a-7ac1-4ceb-9b7b-88e869a2a1da","name":"御之饌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/lohascoffee_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2b592671-748e-413e-ae74-d177a5b82759","name":"御膳屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b592671-748e-413e-ae74-d177a5b82759/1a431e47-60fb-4dde-addf-fa923ab4d985.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b217f65c-2e57-4085-803f-7e029fc4d593","name":"御鐵板","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b217f65c-2e57-4085-803f-7e029fc4d593/25947aa8-621d-460d-9bdb-9c07f0863292.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6933d8ad-6d9f-4d72-96e3-cc30bd02f5cd","name":"御閣日本料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6933d8ad-6d9f-4d72-96e3-cc30bd02f5cd/ad90cb12-019d-40a7-b35b-43a14f0d44cb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af2895f0-62a1-4307-bcb2-b085e01c7bef","name":"德國海豚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af2895f0-62a1-4307-bcb2-b085e01c7bef/bdb56a76-3d83-4188-92c9-a2d4eb2e44ce.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"2139d888-0756-443b-a00c-86e522ab50cc","name":"必勝客","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/pizzahut_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2f42a4d1-f87d-45bc-bf6d-9b2515957bb3","name":"思夢樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2f42a4d1-f87d-45bc-bf6d-9b2515957bb3/f9f08324-becf-4704-a9db-9799ae2b3dc7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7343e395-aae6-46e0-b809-84b7ee2b6b7a","name":"思薇爾內衣 Swear","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/swear_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"3a628197-8287-4af1-bc6c-dfa8ca026383","name":"怡客咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a628197-8287-4af1-bc6c-dfa8ca026383/b17a5386-da44-4b9c-a263-0c30bf011a8a.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2b429ff8-d4d6-4d8d-b922-db4a3387dcd7","name":"愛車坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b429ff8-d4d6-4d8d-b922-db4a3387dcd7/72878787-876f-45e5-925a-8477887caaca.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"965f6bbd-8779-4c2d-b9aa-5aa1816829a6","name":"慢享日初手作茶鋪","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/965f6bbd-8779-4c2d-b9aa-5aa1816829a6/90788213-97c7-4988-942f-e1f12bc0df65.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"49550ef3-6410-42b4-8f36-d67c31a4d877","name":"戀金店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/49550ef3-6410-42b4-8f36-d67c31a4d877/5bd78cb0-f5ad-4469-8e3d-9fa1fa9a33c8.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"dece8390-462b-4c13-9de4-e1f8cccbbbfe","name":"拿坡里披薩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/napoli_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3bc8077e-8671-42ef-b9ac-9938e7e76905","name":"挑戰者汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3bc8077e-8671-42ef-b9ac-9938e7e76905/7e0a6c7d-f841-4d05-934b-3ed64a987009.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3ba987c1-d8ad-4e13-b61d-48be8726bb34","name":"捷安特","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Giant_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"01d832f3-faa5-4e1a-88ce-dd28fb6ccf5b","name":"揚龍原木家具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/YangLong_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"ed566160-61ea-4ba7-99f5-f2d96ca48ae5","name":"摩斯漢堡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mose_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"cf2441a8-2a8b-4622-9b51-2d813c74f35d","name":"摩曼頓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Momentum_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"9d181505-7832-49c3-b761-8561f2a0cb22","name":"斐樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9d181505-7832-49c3-b761-8561f2a0cb22/a630586f-33d0-4381-bbc3-14243c69606d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"bf075240-8835-4006-84e5-417c53c21f51","name":"斑鳩的窩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf075240-8835-4006-84e5-417c53c21f51/4ac9b5e8-f5af-4f94-af7e-aaa01facf6b1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b330062a-6fad-404c-9d34-dc2cd26e7e71","name":"方塊7","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b330062a-6fad-404c-9d34-dc2cd26e7e71/2c42ec9a-a759-4f41-b817-94fe6d4cc91c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0fc8434d-6d9d-4acf-9f28-4f551aa41c80","name":"旅狐-鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0fc8434d-6d9d-4acf-9f28-4f551aa41c80/20903498-e30b-45a4-9c9a-009cffa2cc4e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"d1ec40d5-5813-4704-a346-bfb37f859f7a","name":"日出茶太","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d1ec40d5-5813-4704-a346-bfb37f859f7a/9a61655e-d3c2-4652-a229-06db9b46eb0c.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"fc8965b4-0105-41aa-8aaa-973d6e2fd8fb","name":"早點名露營生活館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc8965b4-0105-41aa-8aaa-973d6e2fd8fb/05908683-9e01-4215-9459-4afb617b1365.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"2fa32631-3f13-44b1-b6cd-a99af0ebb1b4","name":"旭媄","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2fa32631-3f13-44b1-b6cd-a99af0ebb1b4/68b8a67a-6ec2-411c-9f62-3d0592ec7da7.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"6cbd3c78-afcb-44b1-916a-e560aa263ddd","name":"昂路名鞋館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/EnRo_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"2c94f91d-1515-4520-95b8-1f7567d66a73","name":"星巴克 Starbucks","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2c94f91d-1515-4520-95b8-1f7567d66a73/7a7268af-2ec6-4d4d-bc07-161f320c53ce.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"93abf2b2-7c90-4a73-9f0b-0172bfc44283","name":"春一籠港式茶樓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/93abf2b2-7c90-4a73-9f0b-0172bfc44283/65728e5e-61b3-41d5-8fcd-fbe90be740ba.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5c9b9cda-20c8-4887-8f40-86c2ab70c2bd","name":"時壹越河粉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c9b9cda-20c8-4887-8f40-86c2ab70c2bd/c97b0ed2-db74-43ee-9513-9c24b58a4390.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"d5d3a111-3ccd-4099-abad-452139e9e89b","name":"時懿花雕雞米飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d5d3a111-3ccd-4099-abad-452139e9e89b/d9eb37de-1eec-4bcb-a1be-d373cd5db1b7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8701beba-ee56-4ee9-b550-2d9839bd026f","name":"晶璽健康體驗館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8701beba-ee56-4ee9-b550-2d9839bd026f/a344ed3e-9729-4484-a8de-97dcc0c21036.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"29dfc416-815f-4df8-8102-711f99e570ae","name":"晶碩光學","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pega_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"e5806c6c-6e04-4833-b533-45272b3dd556","name":"曼黛瑪璉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mode_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"5dcf7f6b-0577-4255-a3ab-4ff07f639401","name":"月星","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5dcf7f6b-0577-4255-a3ab-4ff07f639401/ff371bdb-a3f2-46a5-a0e7-96002a74c646.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"587766ff-3301-4cda-9821-e24ac24e6576","name":"木本鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/587766ff-3301-4cda-9821-e24ac24e6576/14836542-4398-4c66-8a25-9eaea67961c7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ef80e3ac-e9e7-46dc-9ac7-956dbd817fbb","name":"朱記餡餅粥","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ef80e3ac-e9e7-46dc-9ac7-956dbd817fbb/312ec540-1970-4b17-bfa9-14ff5e5a4466.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ea3fd150-f04d-401f-ae16-d2048646ae01","name":"杏一","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ea3fd150-f04d-401f-ae16-d2048646ae01/192ed5fe-1215-44f1-bb56-a3400931003e.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"88db8ea5-2997-4e03-82ac-6f085610d7b1","name":"村子口川菜料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/88db8ea5-2997-4e03-82ac-6f085610d7b1/ed9aad15-beb4-4075-a5d3-fc0cbe584fb2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"d68dab01-4706-4a80-9fbc-7adc0f36a1c6","name":"松下健康生活工房有限公司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d68dab01-4706-4a80-9fbc-7adc0f36a1c6/0498e3c4-a6a0-40ba-99b6-c4c786bfeab0.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"bc9ec8b9-6df0-4cfa-a880-2947580febcb","name":"柏蒂家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc9ec8b9-6df0-4cfa-a880-2947580febcb/4c77d013-5f06-4036-a1be-0186b5df3054.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"518b2435-a08d-4dcd-9d93-bd61938e578b","name":"桂林鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/518b2435-a08d-4dcd-9d93-bd61938e578b/04e719ed-2183-414b-85bf-274c639ecf09.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"3c487df1-02ec-464d-b032-1df6e588e1b4","name":"極限健身中心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3c487df1-02ec-464d-b032-1df6e588e1b4/07cf058c-4bac-48c6-9338-bff45fd50c5f.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b5fd6b6b-8d5d-4a2f-8e54-e23bd858fda8","name":"樂樂屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b5fd6b6b-8d5d-4a2f-8e54-e23bd858fda8/f334157f-ce08-48de-bf3d-44abb4d86c55.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"87e53455-85c3-4a31-bc2e-d83aa2733408","name":"樂法Le Phare","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/87e53455-85c3-4a31-bc2e-d83aa2733408/11fb85f7-973e-40db-8f35-6e9f8c862147.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"85e47bd7-bc1b-4298-ba9f-a3a654891479","name":"樂津津","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/85e47bd7-bc1b-4298-ba9f-a3a654891479/dca65045-5722-4f62-a289-dab2b670214e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6961819d-010a-4e71-bd25-d7801fe8ac17","name":"樹太老日式定食專賣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6961819d-010a-4e71-bd25-d7801fe8ac17/07835a7f-11bc-4e12-ac68-5a3ab4c2136b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"35caef53-80a0-43bf-a47f-c72233cbf9e2","name":"橋屋拉麵食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/35caef53-80a0-43bf-a47f-c72233cbf9e2/95f13e0b-4035-4cfb-a698-73d2e888028d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"96cfef10-b795-416b-86d6-87cd43367ffe","name":"檸檬香茅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/96cfef10-b795-416b-86d6-87cd43367ffe/2ac4337a-275a-40ce-a291-be7295f0c881.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"74cfb16e-8383-4973-ab6c-c26f59534032","name":"檸檬香草","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/74cfb16e-8383-4973-ab6c-c26f59534032/0d775b08-9d06-4e62-8705-f5ee2bf5cc99.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6588f07b-5743-4bbd-a057-d25e8fa3075c","name":"歐日洗衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6588f07b-5743-4bbd-a057-d25e8fa3075c/fc5a6462-be9d-48cf-b753-830e9ab35e6f.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"5c0c980b-ef31-4c4f-8c02-f80e4f72e8c0","name":"歐羅巴遺風","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c0c980b-ef31-4c4f-8c02-f80e4f72e8c0/bb819ecc-e345-4ccc-be34-803bb9ad386b.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"97486024-11da-4fa7-b247-23bc34bbf7a1","name":"歡樂龍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97486024-11da-4fa7-b247-23bc34bbf7a1/49d43b71-f1d6-43a5-a2f4-b9ad7dee8dba.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"3b18d88b-99e1-4f49-8900-803a4c2c5a1c","name":"正官庄","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/image00_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"9639e4a5-27e0-4473-be13-6112164e7c03","name":"水雲堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9639e4a5-27e0-4473-be13-6112164e7c03/c0159555-a296-4c25-8210-c6c95d23a972.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"d34749fc-188e-4598-9ec6-c721de91e17f","name":"江江順來","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d34749fc-188e-4598-9ec6-c721de91e17f/f01eb572-da57-492a-b4d7-c7bc1751289e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3cc7db36-f5e5-4e22-990b-7a5eb4673718","name":"汰汰熱情食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3cc7db36-f5e5-4e22-990b-7a5eb4673718/9e14f45f-eb41-428e-a38f-568a4b80f220.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b6f98e35-7877-43b7-8fcf-ca597ad8eac4","name":"汽車家族國際美容中心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b6f98e35-7877-43b7-8fcf-ca597ad8eac4/bf8d2ab8-3347-4e40-b2b6-41ffefa6a9fc.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"1a2a0887-d3a4-4449-97fa-dd0cee1a83e1","name":"油蔥黑鐵牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1a2a0887-d3a4-4449-97fa-dd0cee1a83e1/f349d19e-5cba-4a90-9df9-6e0d32735278.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e5ebef7a-33c3-40e8-905f-17e0deae60a9","name":"法爵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5ebef7a-33c3-40e8-905f-17e0deae60a9/bfecc94f-b3c0-4d6b-b418-787fa97c48e4.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"726bcbb8-3869-4331-b346-2205882eab70","name":"法迪耐名店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/fadina_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"9e4e2d3d-fa90-49b9-9a9a-16a69ba861aa","name":"洋城義大利餐廳","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9e4e2d3d-fa90-49b9-9a9a-16a69ba861aa/2ce44100-fbab-46dc-91b3-f17c337182ee.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d8abe2f-b521-42dd-b3d7-01407a5cfb47","name":"洋朵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d8abe2f-b521-42dd-b3d7-01407a5cfb47/4faa4807-dd3b-4346-9a78-55298f3db9b3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e28f574e-d4c4-40ee-9b89-c8922722da72","name":"清田拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e28f574e-d4c4-40ee-9b89-c8922722da72/08429ab6-d064-472e-b416-efc9415fae5d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1932deb9-beeb-4874-8b52-9ee7776c5f81","name":"湯姆熊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1932deb9-beeb-4874-8b52-9ee7776c5f81/672b67c9-2e98-408d-9914-e33a2fa93d6c.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"4a1cf24a-8821-465c-bd3a-ea2c4928629b","name":"滷底撈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4a1cf24a-8821-465c-bd3a-ea2c4928629b/14ad323e-2ea1-4913-8a8c-75e33cdc636c.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"54e2094e-d4e4-4f0c-ac04-a69ffcc739ee","name":"漢堡王","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BURGER_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"5c71f0dd-3655-4c72-9cda-3974d74afa2d","name":"灶紅了","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c71f0dd-3655-4c72-9cda-3974d74afa2d/e0f12fdd-c74e-48b7-8400-44e7bf9c9da1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cb610335-7ba2-49fa-b4e6-4007a0a0989e","name":"炙 鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb610335-7ba2-49fa-b4e6-4007a0a0989e/66ce455d-cfce-472b-85fb-decf4c18b3ad.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0a710bf7-dd22-4ebd-9383-f6c9a780822a","name":"炸鷄大獅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0a710bf7-dd22-4ebd-9383-f6c9a780822a/6d5b099f-02af-48ab-8a80-e6fab249cb47.png","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"aadc9ca5-8383-4b04-bacf-ec593f983b47","name":"点爭鮮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aadc9ca5-8383-4b04-bacf-ec593f983b47/d8bf1078-62c9-44c0-80ff-09c6cf6168fb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1dc92840-a6bb-4725-9810-362040e00769","name":"燒丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1dc92840-a6bb-4725-9810-362040e00769/e04ba34d-6233-4d12-a56d-60f65be2e85e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cc0bdf9d-ff5c-43d0-bbea-2317ce5b11b0","name":"爭鮮迴轉壽司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc0bdf9d-ff5c-43d0-bbea-2317ce5b11b0/6552a462-f437-4be6-bf5e-e289f55b6a65.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4496e68e-3a0d-4f60-99ab-4e8e699cd204","name":"牛仔部落","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4496e68e-3a0d-4f60-99ab-4e8e699cd204/de525a7b-c946-42e0-946e-57e2dbdaea50.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bc85774c-a73d-4e68-82a2-a2876e22a8e9","name":"牛大大pizza牛排屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc85774c-a73d-4e68-82a2-a2876e22a8e9/b1370489-5d72-4482-a333-18575499e114.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"fbfcfd40-6c71-48ac-99c5-53381a0824af","name":"牛車水","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fbfcfd40-6c71-48ac-99c5-53381a0824af/e15789e4-489a-4d55-98e4-e9c309129971.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8a12aa66-48ab-431a-ac49-d79fca81f75d","name":"牛頭牌運動鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8a12aa66-48ab-431a-ac49-d79fca81f75d/d29020f0-4906-4643-ae70-a185e4d9035a.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"95f04aeb-afc9-422a-b712-b57029bcf5e2","name":"玉紅泰式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/95f04aeb-afc9-422a-b712-b57029bcf5e2/7b6013e4-e3c6-498f-b121-e07d34d72445.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"102f038a-355e-4ba6-b719-c66595476eb8","name":"玉豆腐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/102f038a-355e-4ba6-b719-c66595476eb8/a2172c56-824b-4571-9e64-d69f50dfec55.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f4bf6d30-1f18-4766-9f9a-16c951fb201c","name":"玩具反斗城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/toysrus_300x300.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"824f261f-58f4-490b-a080-850edfe24dc1","name":"玩具總動員","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/824f261f-58f4-490b-a080-850edfe24dc1/1a4e2d9d-62e4-4603-a515-4f8a69f95b95.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"1a0f8ecc-dd6e-414e-b308-2446f6a80ec4","name":"瑪荷尼傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mahogany_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"936a4fdf-e11d-424a-ba51-f305f513bfa9","name":"瓦城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/936a4fdf-e11d-424a-ba51-f305f513bfa9/0a5be116-0a01-4ba9-b494-3bfb6a63f752.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5cd5b5ed-7c68-408b-891f-eafdff395aa1","name":"甘榜馳名海南雞飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5cd5b5ed-7c68-408b-891f-eafdff395aa1/5e318c7e-4313-45f7-aca9-f254b071bb73.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"702edd74-db8a-4ae5-855b-a30d58a6bd98","name":"生活工場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/WorkingH_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"c61e9d94-0f7e-4199-8b0c-5e69faf77d82","name":"異人館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c61e9d94-0f7e-4199-8b0c-5e69faf77d82/263fa8d8-aebd-490c-b1bb-1d9ddc64c0bd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ee8eeb11-52d5-4763-80b3-1155f26fdedd","name":"瘋佬墨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ee8eeb11-52d5-4763-80b3-1155f26fdedd/eb0e626a-6c88-4c50-b580-7186b7db17cc.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"fab088f0-04d2-4e95-8698-a10b6ad6d847","name":"百享科技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/richman_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"e2f07c09-9458-4dd8-a495-a79b28af2e41","name":"百八魚場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e2f07c09-9458-4dd8-a495-a79b28af2e41/a80a240c-5447-452d-b1bd-20818f05ba52.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ca63c81d-3d5b-44c7-8a62-ed70900ca9d9","name":"百悅板燒料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ca63c81d-3d5b-44c7-8a62-ed70900ca9d9/0fd5ca82-da9b-42a8-9617-eaa57092e26d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a8edc331-b2f8-4492-95b8-ef781e97d3ec","name":"皇品鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/royal_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5a5e3add-e700-4117-8e13-18dd6c5b39c4","name":"皮爾卡登","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a5e3add-e700-4117-8e13-18dd6c5b39c4/9bceab82-7589-4e73-9a14-b81498d107c7.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5a49208d-39bc-4229-897d-544764ee5c4b","name":"眼窩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a49208d-39bc-4229-897d-544764ee5c4b/8516e579-cd4e-4082-a499-9c3e9da1cbd5.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"d958b45d-a872-4931-8de5-871ea58a6e9f","name":"睿麗傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d958b45d-a872-4931-8de5-871ea58a6e9f/a8b881a1-840d-49d5-aec3-a9ddbdbd261a.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"83d80557-681b-4beb-ad4e-c10004d6e467","name":"石二鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83d80557-681b-4beb-ad4e-c10004d6e467/b43704a8-8272-4955-947b-a9074d56cf4b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"08df16da-00c9-48f6-a10a-6dc0b00fb9bf","name":"石板屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/08df16da-00c9-48f6-a10a-6dc0b00fb9bf/79b9ec2a-8d46-460f-b09a-4a5ef83949ba.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"2a786d7c-ff83-4ded-b2a1-c4196cfe1689","name":"磨豆咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2a786d7c-ff83-4ded-b2a1-c4196cfe1689/df515c6d-c1c7-4789-9b27-4ba077894c1f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"b177b525-5089-49ac-a04d-10ef425641c1","name":"祥富水產","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b177b525-5089-49ac-a04d-10ef425641c1/1148e560-5313-487a-972a-bab05ad5ab8d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ce07e47c-0025-457a-ac7b-eb3ae355e65f","name":"福勝亭","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ce07e47c-0025-457a-ac7b-eb3ae355e65f/a5bf4077-af04-4b49-9cd7-535f4a4734c3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9ace505f-5e25-4303-a894-196688f6fd6c","name":"禾樂鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9ace505f-5e25-4303-a894-196688f6fd6c/ea0bbc37-b97e-4ed0-9bb2-279c6eb80f3f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7d407022-0837-4d44-b19f-5225b9ac68ad","name":"禾豐鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7d407022-0837-4d44-b19f-5225b9ac68ad/4c8ac47a-8abd-4f05-a7d4-8243276302f2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7d7e8db5-2781-436b-a38a-f4cce91df4ec","name":"禾野鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7d7e8db5-2781-436b-a38a-f4cce91df4ec/05f67d4c-71ac-4b00-aaa7-7c939d786fcf.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b12dd63-688d-4387-bc99-96ca0d36cbe3","name":"秀泰影城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b12dd63-688d-4387-bc99-96ca0d36cbe3/60f3e8e7-e7ae-4162-817b-86926bb1d4c6.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"a600b803-a760-4d96-a20c-bda215a23a61","name":"私房小廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/instant_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3e7fe1f5-025b-4d76-b556-78eb837e36ce","name":"私房小廚店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e7fe1f5-025b-4d76-b556-78eb837e36ce/caceb09a-a3a8-4351-8e1a-b26b1a5787d1.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"18a13750-7d8a-4d78-8d1f-f34f5a7ccb76","name":"米塔義式廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/18a13750-7d8a-4d78-8d1f-f34f5a7ccb76/d05ba7ed-3984-4e42-8587-f1e6f562f5af.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"956ec994-8fc4-4c39-8d10-ed108fe85e94","name":"米塔黑糖飲品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/956ec994-8fc4-4c39-8d10-ed108fe85e94/8e37a170-ca93-40c1-a6ae-412699b97120.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"e84a04e3-8215-46e0-8d8b-5cdbefe4358b","name":"紅玉滿赤心雞蛋糕","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e84a04e3-8215-46e0-8d8b-5cdbefe4358b/673b07ee-a053-4137-b8c7-3b9af72188f3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"83f60353-411f-444b-895a-1bbd073838d8","name":"紐西蘭牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83f60353-411f-444b-895a-1bbd073838d8/7fbaf93e-aa6a-4337-8be6-8768007155fd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"00c729ee-6aa5-4dd6-a7e7-9422397e704e","name":"羅蘭索傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/lorenzo_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"66ff8428-90ad-44e2-a064-48a6dc2ebc93","name":"美威鮭魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/66ff8428-90ad-44e2-a064-48a6dc2ebc93/ac69e57a-078d-4193-95ec-245eb87a2dd8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0ca78690-f93a-440f-aed1-03a0c1289b9a","name":"美珍香","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BEE_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b78bb013-a9de-4818-a95d-68224e1bb907","name":"美蒂亞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b78bb013-a9de-4818-a95d-68224e1bb907/d7634648-4780-44b1-9cc4-dc73e0860725.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"75217a21-1cb8-4468-a17b-03dcaa5482e9","name":"美麗華高級汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/75217a21-1cb8-4468-a17b-03dcaa5482e9/1532b37b-9f63-4b38-b034-91fd04fb4d63.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3fef6ce5-0a0a-4812-ad65-e81987f9f654","name":"羽衣精緻專業服務","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3fef6ce5-0a0a-4812-ad65-e81987f9f654/b19f3d27-2894-41a2-9fa1-0be1fb6e5a07.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"d7bb5da9-c3c2-458d-99d5-f765821b98c4","name":"翊新","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d7bb5da9-c3c2-458d-99d5-f765821b98c4/a5268e25-78a2-46a4-b4d2-ce912fce51b1.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"4142d10b-6f78-4745-be5f-c58988be7d28","name":"老船長","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4142d10b-6f78-4745-be5f-c58988be7d28/57228bca-060c-45cf-9b56-5e01906a1d3e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"f2a914e7-3618-4ac4-98ab-fc6fc055870c","name":"老蔡水煎包","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2a914e7-3618-4ac4-98ab-fc6fc055870c/aedc7ad2-d09b-44a0-a8a8-02b037ca6a47.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"79b74f42-a56b-4afd-978a-8057d9735463","name":"老饕牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/79b74f42-a56b-4afd-978a-8057d9735463/e4bd4b2d-8aac-4185-bf35-5004eb906c76.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"c7fbcb7c-9b57-47cf-8946-1205a73e42b3","name":"聊聊鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c7fbcb7c-9b57-47cf-8946-1205a73e42b3/0d2d1797-e236-4f6a-9e06-c07cdddaddc1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8936096b-76ce-4b96-b214-da318d704b8b","name":"聖地亞精品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sandia_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"daf28770-f0f3-40a6-87e0-7197af5c2eac","name":"聖荃童鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/daf28770-f0f3-40a6-87e0-7197af5c2eac/62176237-ecf4-4f5d-aec2-33e262057859.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"8c7e580b-54b9-4f00-a89d-997e6ed05b13","name":"聚-北海道昆布鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Gi_hot_pot.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0776fc46-e260-4d5f-b110-f1beecf135f1","name":"肯德基","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0776fc46-e260-4d5f-b110-f1beecf135f1/43e3aaae-1903-4b08-8eb0-691fc0f4885a.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"d6d59e18-c728-45a9-a7d1-9b87d301cd79","name":"胡桃鉗生活傢飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d6d59e18-c728-45a9-a7d1-9b87d301cd79/6a5b63fe-730e-4486-a853-648c2fe96250.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1075e811-264b-45f6-8805-d982fdf099dd","name":"花月嵐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1075e811-264b-45f6-8805-d982fdf099dd/cfb91fc5-22d6-46d0-943b-a02610751090.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8cf4b69d-c032-44d8-976a-b25015782290","name":"花蓮扁食","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8cf4b69d-c032-44d8-976a-b25015782290/a547df52-8dcf-4f6e-92ca-57382b9aabde.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d57c195-9ddd-4bd9-93b4-d5b365ef5f18","name":"茶自點","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d57c195-9ddd-4bd9-93b4-d5b365ef5f18/c876db9f-b0ae-40a2-a227-c11a60c719cc.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"0816f19c-25f5-4136-8b8a-b64ff63725ce","name":"茶與波記","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0816f19c-25f5-4136-8b8a-b64ff63725ce/fdf3a008-d9e0-4521-9415-746ac9909f03.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"52b71b16-d74e-4365-afd0-ba6ef60e9786","name":"菈菈派","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/52b71b16-d74e-4365-afd0-ba6ef60e9786/2b5fd611-d650-49d6-bc98-1a1e493a590f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e9f04fe3-16d9-4e61-b09c-b00cc4494ee5","name":"華歌爾內衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Wacoal_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"3b3f07b9-2740-48a1-9d2e-9542f8fc12c2","name":"菲凡創意剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b3f07b9-2740-48a1-9d2e-9542f8fc12c2/310eced8-6088-48c7-a11b-9990e031b046.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"85f06a87-cbcf-40b1-bfb8-c02f18c07e15","name":"萬國通路","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/eminent_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"5ae415bc-f2c7-4a8e-b944-729389ab6f6c","name":"葛洛麗雅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/gloria-logo_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"907755fb-edbd-4f63-9233-d270fe61d312","name":"葳達","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/907755fb-edbd-4f63-9233-d270fe61d312/ae97bbb1-8629-4142-a9d2-ec9edbd69d06.png","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"f7ad7136-8b49-4c85-b4d0-84cdf2eb09b9","name":"蕾絲妮傢飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f7ad7136-8b49-4c85-b4d0-84cdf2eb09b9/7fdac87f-8108-4731-95d3-b36beb4aaa31.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"cf68a166-93c4-420c-afe7-652884ccc7e4","name":"薔薇派","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf68a166-93c4-420c-afe7-652884ccc7e4/a75f769b-405a-4fac-87f9-c4c097bd6dde.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"5d70e0e6-7e34-4b58-9309-aafdecbd1d61","name":"薩莉亞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5d70e0e6-7e34-4b58-9309-aafdecbd1d61/72516c0c-33de-46e2-9e9a-eb09e3e74f61.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d1e7b0e-402b-42fa-98c3-7faad0efbff8","name":"虎爸廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d1e7b0e-402b-42fa-98c3-7faad0efbff8/82d5a2bd-cc20-4ced-b995-2e684e3ee637.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"c487ac36-3637-4a27-9b1d-de650df60de5","name":"衣匠服飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c487ac36-3637-4a27-9b1d-de650df60de5/f039bcff-8e9f-4b38-8284-3ea8222d7fdc.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"3d421283-1fae-4843-973d-4009b7211eab","name":"衣貝潔洗衣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3d421283-1fae-4843-973d-4009b7211eab/bba5b430-3b39-46f1-a98d-a1fe045fb6d1.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"e3871517-09cb-4342-a059-078ef4d43ded","name":"裊裊鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e3871517-09cb-4342-a059-078ef4d43ded/c4988fb0-c28b-4135-9197-2c3dc2f739c7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3aef8279-63e3-48ea-bd7d-ef2754d3a875","name":"西堤牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3aef8279-63e3-48ea-bd7d-ef2754d3a875/c0811f5a-428a-4203-b94e-96f483e900b0.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1ebc78b3-8cbc-4ede-bf64-75a79b23af43","name":"角子虎","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ebc78b3-8cbc-4ede-bf64-75a79b23af43/5cf80651-0619-49b2-aa52-fdb909b09e25.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e10a8e62-d73a-4496-b97b-41fd2eb63145","name":"許留山","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e10a8e62-d73a-4496-b97b-41fd2eb63145/edeb3912-e9c3-426a-b5d7-067cc3a2f5d9.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"f22c504f-a4bd-4303-b224-beecd406f3e5","name":"請坐專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f22c504f-a4bd-4303-b224-beecd406f3e5/2ed1c458-e4bb-476e-bbab-021f25bafd57.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"7740c753-823d-4cdb-8592-2e13ce5269cf","name":"豆咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7740c753-823d-4cdb-8592-2e13ce5269cf/daae6993-fdc1-465e-b15e-59ddb8a0102f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"6ab341a2-55ed-4f3e-a267-068421a132f7","name":"貝兒絲樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6ab341a2-55ed-4f3e-a267-068421a132f7/b0335bb6-e881-4709-b261-214cd91a71a3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7a2dd721-65ba-430e-8a3a-23b3fd7dfb16","name":"貝妮嘉露","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7a2dd721-65ba-430e-8a3a-23b3fd7dfb16/1fe013aa-3744-4c9c-af98-6eb2823d6dca.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"52c233b3-f4ca-49da-9172-1296c8873521","name":"貢湯宴水產超市火鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/52c233b3-f4ca-49da-9172-1296c8873521/16cd06f4-9f5e-444b-accc-15b65706e70f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8791adb1-88c3-4b2e-888d-594e49198d55","name":"貴妃廚具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8791adb1-88c3-4b2e-888d-594e49198d55/19de3d2f-2399-466c-bf01-7e0f70121ee1.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"8b0e91aa-5c47-4211-b553-d54f7bca0b56","name":"資生堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/shiseido_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"1444b8e8-c6f9-410f-8acb-b1eac26d53dc","name":"足適姿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1444b8e8-c6f9-410f-8acb-b1eac26d53dc/a0e5f71b-3ae6-4c00-8246-af11b66bd265.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"419cff9a-5ba0-42a8-8cc9-eff1f9eb6a50","name":"路豹 Zobr","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/zobr_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"dc7c8aa5-5e1e-4ce5-a54e-0691dd18c9f1","name":"車之坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc7c8aa5-5e1e-4ce5-a54e-0691dd18c9f1/61c36cd1-309b-4aea-9faa-3cfe18500a3d.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"11701c86-90a7-4241-ab01-579792858974","name":"車美樂汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/11701c86-90a7-4241-ab01-579792858974/f7a28988-7108-4efb-87ba-969445b0d558.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"6a8ca671-9939-40e9-98ed-f45fec799694","name":"車藝鉉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6a8ca671-9939-40e9-98ed-f45fec799694/8c7b1392-c600-4ace-8b0f-fe2d92f83143.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"7c34b00d-4033-49d8-aa5e-70f3ffc28401","name":"車鉅星","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7c34b00d-4033-49d8-aa5e-70f3ffc28401/1d81d567-f289-4b40-b53b-a09631c86cf4.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"4d9a9c4f-5dec-40f1-a409-dd1bf63cf3e6","name":"車麗屋汽車百貨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d9a9c4f-5dec-40f1-a409-dd1bf63cf3e6/29d298de-ba09-4136-b444-a3d7a135333d.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"546b1510-90fd-46d1-a0e8-bd6cebac5a6a","name":"迪卡儂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/546b1510-90fd-46d1-a0e8-bd6cebac5a6a/a6901c36-2dd0-4f55-9541-fbd7589dccfe.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"035b252a-90f1-4214-ab99-bdf47cd062a3","name":"逗點咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/035b252a-90f1-4214-ab99-bdf47cd062a3/77f95877-c8ff-4bf5-a1d1-962aa2a0d1d7.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"f3dbb797-7208-4062-aa82-1bf0c884991c","name":"這味泰泰","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f3dbb797-7208-4062-aa82-1bf0c884991c/f7929570-5c0f-4baf-a70f-1efac5fcbd98.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ac19886a-50ec-45e1-a42a-59f271ff71d1","name":"遊戲愛樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ac19886a-50ec-45e1-a42a-59f271ff71d1/eedafaa3-ae69-41c6-a943-f8c84a860905.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"8b04c58f-bd54-4ec9-ae96-3e60c20fb651","name":"達芙妮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/DFN_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"7e2f094d-b6c7-48e6-92dc-c8d2fb7c4e64","name":"邦德蕾斯（蘿舒漫）","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/loosemag_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"9241d77b-ea98-4772-a5c4-64668be93e29","name":"酷克牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9241d77b-ea98-4772-a5c4-64668be93e29/85ccc8df-4756-46e6-882b-83b6794f2e4e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"089cd74c-cb14-4c03-bb2e-9989debcad27","name":"酷聖石","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cold_stone_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"c54ae1a0-6544-4488-a5c5-059902d29bc4","name":"醇蛋糕","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c54ae1a0-6544-4488-a5c5-059902d29bc4/3617cdeb-c714-4f38-a7f0-566fcd26938c.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e04679e1-ba05-43cc-bd6c-295bb85e125d","name":"野宴二代王漾店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e04679e1-ba05-43cc-bd6c-295bb85e125d/cc5ee7da-8c1d-48ed-83e6-0a39f5c1774b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"d90ddf31-0659-4c5c-b771-e6bf7517dd7a","name":"金大鋤壽喜燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d90ddf31-0659-4c5c-b771-e6bf7517dd7a/42b39d56-7be4-4f91-b57d-b8a54f9d4f01.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5c41e371-a678-4b87-afcd-09dac7305600","name":"金安德森","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c41e371-a678-4b87-afcd-09dac7305600/2a1801aa-ab37-438b-90da-2c639acd1580.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"537337af-117e-4f06-b99f-70575d98b4f8","name":"金安德森皮件","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/537337af-117e-4f06-b99f-70575d98b4f8/3965bd58-86a0-4faa-93e8-05ba6da5b63f.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"b6171f9f-e0c8-47e3-86a2-b63275580a31","name":"金宏鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b6171f9f-e0c8-47e3-86a2-b63275580a31/360b489b-e3aa-4fde-aca6-9456f8975efb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9f1cc218-9f8c-4c37-aa07-bfdff6bd3e46","name":"金宗家韓式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9f1cc218-9f8c-4c37-aa07-bfdff6bd3e46/25ba1d30-765e-4e22-95c7-2b55837bfab8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"579df2af-d724-49b7-b69b-3694ca8e8477","name":"金石堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Kingstone_300x300.jpg","cat":"0630e6fa-a5df-468b-bb9e-047669677603"},{"id":"311fcde0-ab49-40e4-9cd5-76b51b04657b","name":"金緻品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/justin_300x300.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"bab8a6b0-58da-4e23-a467-3dd43fc37bfc","name":"金豆腐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bab8a6b0-58da-4e23-a467-3dd43fc37bfc/79dac46c-1f21-4839-9a01-c126838970c6.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6adeb867-f8ce-4983-b7bd-872fb638cdac","name":"金首爾韓國料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6adeb867-f8ce-4983-b7bd-872fb638cdac/b6a1c5f2-ee40-49ce-8f45-a23d32737114.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"77399192-6826-443e-be83-b3a49aea4fba","name":"銀座日式杏子豬排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77399192-6826-443e-be83-b3a49aea4fba/5b84c7fb-41ba-49fb-8c9b-22b64361388c.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"c2e02210-12b1-414f-b918-e92a68ad2b4b","name":"銀盾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Vital_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a721344c-f3c6-49b4-8497-1519b51fb11f","name":"鍋裡鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a721344c-f3c6-49b4-8497-1519b51fb11f/d4f402be-1b1a-4082-bdae-c0dac8963a3a.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7a6f0886-a1e1-4fdb-991d-1c085d54ad67","name":"鍾愛一生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cherishdesign_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1651382b-cf88-4f17-bbf8-0cd52db43033","name":"長壽石鍋拌飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1651382b-cf88-4f17-bbf8-0cd52db43033/d3e6a5a4-c1b2-4e02-955a-ad04538d943f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1c37d3da-83fc-4b00-b9d9-5f31724f2b8c","name":"長庚生技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1c37d3da-83fc-4b00-b9d9-5f31724f2b8c/8d61b04e-117e-4f77-86d7-133c0d323b52.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"bf5c5249-c206-4dad-bd7e-f7ecf2cebe42","name":"開心牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf5c5249-c206-4dad-bd7e-f7ecf2cebe42/b41b0749-3115-4533-8d69-e0a412fcc06c.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"97de8a85-1ac0-4bcc-918a-9b60711722f0","name":"開心魔法屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97de8a85-1ac0-4bcc-918a-9b60711722f0/f13cc5c9-7e69-4922-8af3-58db9e2894eb.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"88877a18-dad9-4843-bc23-2a4138e26b77","name":"阿瘦皮鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/aso_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"98710a1d-f5bc-4ecd-8633-6b293f69e60a","name":"陶板屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98710a1d-f5bc-4ecd-8633-6b293f69e60a/9774be1a-19ba-40b9-9c22-f33b1f726fc3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4d387614-7a9a-4f99-aa2f-85e81e0c039a","name":"陸家班","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d387614-7a9a-4f99-aa2f-85e81e0c039a/007271de-9e1e-41fe-99f3-f77d765df7cf.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"8d560b0c-5c77-435d-be20-cc817df20063","name":"雷根運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8d560b0c-5c77-435d-be20-cc817df20063/2e4e475b-2a1e-4308-a331-1713508e2335.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f403c3fe-3d81-4bf5-9129-20cf7a75b1cc","name":"靈光眼鏡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f403c3fe-3d81-4bf5-9129-20cf7a75b1cc/7dd076f8-80a4-434f-aab7-258a94113ede.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"77d4b69e-1e29-432e-a778-afdf53ee5560","name":"非卡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77d4b69e-1e29-432e-a778-afdf53ee5560/59f00547-354c-4911-b004-fee0636bebc3.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"76491617-4538-443c-8e5f-6ce864d3d59f","name":"非常量販","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/very_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5f5d130e-95c1-49b5-85f6-b6aaaa956993","name":"非越即泰","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5f5d130e-95c1-49b5-85f6-b6aaaa956993/5732b0c6-b899-4f21-a9fe-41ba753df0c0.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"adb080be-c3e3-4580-8bf0-ef44b63e3d53","name":"韓姜熙的小廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/adb080be-c3e3-4580-8bf0-ef44b63e3d53/c26b3789-6cca-4c3f-8e88-3fd5b1e72646.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"96c3dca7-c914-435c-be94-2b090b7fbd8e","name":"韓州","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/96c3dca7-c914-435c-be94-2b090b7fbd8e/166e42c7-6dec-4687-b319-c1d2a268db60.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"50ca7868-7736-4940-b848-1dd87c3b199d","name":"韓本家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/50ca7868-7736-4940-b848-1dd87c3b199d/8291c27a-bb0a-4d90-959a-c964ae5e67d2.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"9f3dab01-2d15-4808-b57b-6d39bc8b93a9","name":"韓牛村","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9f3dab01-2d15-4808-b57b-6d39bc8b93a9/4669a508-c26f-4cd5-8303-b4042af8dd8a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"29a66805-27d6-45f7-aba0-b0f84dacd02e","name":"韓金饌韓式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/29a66805-27d6-45f7-aba0-b0f84dacd02e/80e4be87-2ba3-489c-bb9a-f4003840509d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7fe7c349-6e48-4263-8664-974669e483d4","name":"順發","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7fe7c349-6e48-4263-8664-974669e483d4/d738503a-8b4a-4519-8316-6f36926c1c4b.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"e7ce0b9b-5688-44f0-b6ab-e9a1156a2307","name":"風和家現烤烘焙","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7ce0b9b-5688-44f0-b6ab-e9a1156a2307/3c649c9e-eb20-4873-887b-d186bdcb05b6.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"55cda70a-b7e8-428d-bd82-fd68bb73e6aa","name":"飛寶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/55cda70a-b7e8-428d-bd82-fd68bb73e6aa/ffbdc889-cfb8-4c79-acba-8df0f8f9e947.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"fdd65a63-b447-4f2a-be29-17a47582cf80","name":"香草工坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fdd65a63-b447-4f2a-be29-17a47582cf80/50164e72-b924-4e9f-9207-ac25ab54f96e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bfea58cd-29d5-4aac-a404-3ff8071d5a0a","name":"馫鱻鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bfea58cd-29d5-4aac-a404-3ff8071d5a0a/c0a9da3d-711e-40d8-b2c6-2265b261f460.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"75903fb7-4711-4e81-b9eb-a073e75f71ad","name":"馬祖新村","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/75903fb7-4711-4e81-b9eb-a073e75f71ad/8ca17856-7a8b-4b5e-95a8-8c7a9e0a1141.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"e9ea1c5a-0d6b-445f-ac77-12831651bf5f","name":"高島","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e9ea1c5a-0d6b-445f-ac77-12831651bf5f/b34fb688-d860-4caf-ac44-5b05179a8b35.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d01f1b24-ce4e-407e-aae5-63ff57b874f9","name":"鬍鬚張","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d01f1b24-ce4e-407e-aae5-63ff57b874f9/94e159c9-4d4a-43dd-af78-ea1e52399ad3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dd9b3b80-3d71-43e5-81a1-ec13bc3a3965","name":"鬼椒一番鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd9b3b80-3d71-43e5-81a1-ec13bc3a3965/4254f92f-b406-48ee-b5de-ff19e3049967.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e248f947-570c-4c63-92ca-3add32484c1c","name":"魔法咖哩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e248f947-570c-4c63-92ca-3add32484c1c/61e73b61-d4c8-46bc-8229-d3d6727db6fd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"aacafd3c-9e81-4fa9-9a7e-af5b999ae1e2","name":"鮮五丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aacafd3c-9e81-4fa9-9a7e-af5b999ae1e2/354e5863-71b1-45c9-8753-ee6c3b8ce2b6.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e008a8d8-05e3-438f-87f6-997344793d66","name":"鮮茶道","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e008a8d8-05e3-438f-87f6-997344793d66/905f6355-c664-48ac-8230-cd21d0885e15.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"9e250a2d-dd91-4a93-b87f-0ff126ecda05","name":"鯊魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9e250a2d-dd91-4a93-b87f-0ff126ecda05/b9aa3e2a-d89b-4b68-9ff7-37d948bdebb7.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"9c2137b7-d973-4c97-a0a8-a7474b45853f","name":"鯣口鮮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9c2137b7-d973-4c97-a0a8-a7474b45853f/17ac10fd-2da7-4794-917d-bae3e31edd28.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"da7a78dd-c7d3-4757-97b2-b8153e95f30b","name":"麗兒采家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/da7a78dd-c7d3-4757-97b2-b8153e95f30b/91ca9fad-31f4-430e-a40c-3196f2cc22af.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"33259a42-e295-4663-b964-5d81d2c8ca4b","name":"麗嬰國際","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/FunBox_300x300.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"b366defc-fee9-4d13-bdc2-e331e48fd028","name":"麥當勞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/McDonalds.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"98516093-278b-4da2-8f6d-7a3edd1dd1c0","name":"麥當勞點心吧","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98516093-278b-4da2-8f6d-7a3edd1dd1c0/be9d3399-b134-409d-92b2-af4a3562fd72.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"bc2cc438-53f9-4d9f-909e-f2f3675e49af","name":"麥皇后寢具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc2cc438-53f9-4d9f-909e-f2f3675e49af/2cd6a7de-cc4f-425d-b031-23f8f8c4c6b2.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"7195efb9-7ae6-4542-81c0-2a3ea31da53b","name":"麵屋虎徹-朱雀","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7195efb9-7ae6-4542-81c0-2a3ea31da53b/f8111692-ec45-4a18-b5ef-3554cde77652.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"bb212930-d568-44a4-8aa5-31a93b5b5ba3","name":"麻佬大","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bb212930-d568-44a4-8aa5-31a93b5b5ba3/2b17d1c7-153f-4d03-b38a-b142be51ca33.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5cfd7f83-3059-4405-909a-e61d9d4d5b42","name":"麻膳堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5cfd7f83-3059-4405-909a-e61d9d4d5b42/57f3b36c-34d1-45b4-8d05-828e53128001.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e224d996-00a3-4d95-8a24-b95286ccce65","name":"黃子庚天珠、玉器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/HUANG_300x300.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"898aae6e-681a-4ff3-bf31-3f88806436f0","name":"黎陽","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/898aae6e-681a-4ff3-bf31-3f88806436f0/dddbc27e-e8af-4b93-92fe-1c61437bac12.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"e4ce7863-4100-4ae4-a10a-bf7d9f4103bc","name":"黛安芬泳衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e4ce7863-4100-4ae4-a10a-bf7d9f4103bc/46dd9a88-013e-40b8-9dfc-0b2f2a1b1ab2.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"a8ff7b71-b3ac-44a6-b938-d4cd0a4dc7e4","name":"點心道","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a8ff7b71-b3ac-44a6-b938-d4cd0a4dc7e4/e27f3f97-f1ad-4cf1-b820-1b1bc6eca0c4.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b768865-181d-4010-b991-46fb02338ede","name":"鼎晶鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b768865-181d-4010-b991-46fb02338ede/9063898b-089e-4464-8f8f-618859115c83.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"}]

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrandInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles_module_scss__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_google_map_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__brands_json__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__brands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__brands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_braft_editor_dist_index_css__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_braft_editor_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_braft_editor_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_braft_editor__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_braft_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_braft_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_braft_utils__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_braft_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_braft_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_antd_lib_input_TextArea__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_antd_lib_input_TextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_antd_lib_input_TextArea__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a.Option;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var BrandInfo=function(_Component){_inherits(BrandInfo,_Component);function BrandInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrandInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrandInfo.__proto__||Object.getPrototypeOf(BrandInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_30_react___default.a.createRef(),_this.state={brandInfo:{id:null,status:1,name:null,logo:null,image:null,type:1},data:[],messages:{},isFetchData:false,isSubmitData:false,isImage:false,desc:null,en_desc:null,giftStore:[]},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.cloneDeep(devBrandInfo);if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.isString(data.logo)){data.logo=null;}else{data.logo={id:1,path:data.logo,url:data.logo_url};}if(!__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.isString(data.image)){data.image=null;}else{data.image={id:2,path:data.image,url:data.image_url};}data.deliveries=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.map(data.deliveries,function(vendor){return Object.assign({},vendor,{image:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(vendor,'icon_url')!==null?{uid:0,path:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(vendor,'icon'),url:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(vendor,'icon_url')}:null});});if(!__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.isBoolean(data.status))data.status=data.status===1;//_.set(this, 'state.desc',data.desc)
//_.set(this, 'state.en_desc',data.en_desc)
//data.desc=BraftEditor.createEditorState(data.desc)
//data.en_desc=BraftEditor.createEditorState(data.en_desc)
_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_34__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_35__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/brands/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/brands');return;}_this.fillData(data);_this.setState({data:data,giftStore:data.gift_store});});},_this.handleChange=function(editorState){_this.setState({desc:editorState});},_this.handleChange_en=function(editorState){_this.setState({en_desc:editorState});},_this.submitData=function(){var brandInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// 把Control元件轉換回上傳資料
brandInfo.logo=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(brandInfo,'logo.path');brandInfo.image=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(brandInfo,'image.path');//const desc = brandInfo.desc.toHTML()
//var desc = _.get(this,'state.desc').toHTML()
//desc = _.get(this,'state.desc').toHTML()
//var en_desc = _.get(this,'state.en_desc').toHTML()
//en_desc = _.get(this,'state.en_desc').toHTML()
//brandInfo.desc = desc
//brandInfo.en_desc = en_desc
brandInfo.deliveries=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.map(brandInfo.deliveries,function(vendor){return Object.assign({},vendor,{icon:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(vendor,'image.path')});});brandInfo.gift_store=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.map(brandInfo.gift_store,function(gifts){return{id:gifts.store_id,is_vip:gifts.is_vip,is_gift:gifts.is_gift};});var current_user=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');brandInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(_this,'props.match.params.id','');console.log('submitData',brandInfo);_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_34__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_35__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/brands/'+id),brandInfo,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_25_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.success('建立成功');_this.setState({brandInfo:data});return _this.props.history.replace('/brands/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_34__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_35__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/brands/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_27_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_25_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/brands');});},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrandInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_36_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();}// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;var desc=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this,'state.desc');var en_desc=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this,'state.en_desc');var controls=['font-size','line-height','text-color','bold','italic','underline','text-align','text-color','blockquote','separator','headings','undo','redo','separator'];var errors=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_40_validatorjs_src_errors___default.a());// 登入使用者的權限
var editorPermissions=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this,'props.app.options',{});var uploadList=this.formRef.current&&__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.isArray(this.formRef.current.getFieldValue('uploadList'))?this.formRef.current.getFieldValue('uploadList'):[];var id=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(this,'props.match.params.id','');var privileges=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(window,'VC_CONFIG.privileges',{});var brandsModify=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(privileges,'brands.modify',[]);var canCreate=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(privileges,'brands.create',false);var canEdit=__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.indexOf(brandsModify,'all')!==-1||brandsModify;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_33__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_react_router_dom__["b" /* Link */],{to:'/brands'},'\u54C1\u724C\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_breadcrumb___default.a.Item,null,'\u54C1\u724C\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u54C1\u724C\u8CC7\u8A0A',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_41__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){_this2.submitData(values);console.log('values',values);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);console.log(e);},onFieldsChange:function onFieldsChange(changedFields){console.log('changedFields',changedFields);},onValuesChange:function onValuesChange(changedValues){console.log('changedValues',changedValues);}//onValuesChange={(changedFields, allFields) => console.log('onValuesChange', changedFields)}
},(canCreate||canEdit)&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('logo','品牌 寬137.5x高137.5 (1:1)'),{style:{minHeight:166}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_components_WUpload_WUpload__["a" /* AvatarUpload */],null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('image','形象圖 寬1080x高400'),{style:{minHeight:166}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_components_WUpload_WUpload__["a" /* AvatarUpload */],{listType:'picture-text',className:'avatar-uploader'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','品牌名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_name','英文品牌名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('sort','排序'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('status','狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('type','類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a,null,wp.element.createElement(Option,{value:1},'\u54C1\u724C\u8CFC\u7269'),wp.element.createElement(Option,{value:2},'\u7F8E\u98DF\u9910\u5EF3')))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc','品牌說明'),{validateTrigger:'onBlur'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default.a.TextArea,{rows:5}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_desc','英文品牌說明'),{validateTrigger:'onBlur'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_input___default.a.TextArea,{rows:5}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])('categorie_ids','品牌類別'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u54C1\u724C\u5206\u985E'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(options,'brand_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{value:item.id},item.name));}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u7F8E\u98DF\u5206\u985E'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(options,'food_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{value:item.id},item.name));}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u670D\u52D9\u9805\u76EE'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.List,{name:'gift_store'},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;var giftStoreForm=_this2.state.giftStore;var giftStore=fields.map(function(field,idx){return Object.assign({},giftStoreForm[idx]);});return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:giftStore,columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return idx+1;}},{dataIndex:'store_id',title:'分店',render:function render(storeId,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'store_id']),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_32_lodash___default.a.get(options,'stores',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);})));}},{dataIndex:'is_vip',title:'',render:function render(is_vip,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_39_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'is_vip']),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{checked:item.is_vip===1,onChange:function onChange(e){var giftStore=[].concat(_toConsumableArray(_this2.formRef.current.getFieldValue('gift_store')));giftStore[idx].is_vip=e.target.checked?1:0;_this2.formRef.current.setFieldsValue({gift_store:giftStore});_this2.setState({giftStore:giftStore});console.log('giftStore',giftStore);}},'VIP'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{checked:item.is_gift===1,onChange:function onChange(e){var giftStore=[].concat(_toConsumableArray(_this2.formRef.current.getFieldValue('gift_store')));giftStore[idx].is_gift=e.target.checked?1:0;_this2.formRef.current.setFieldsValue({gift_store:giftStore});_this2.setState({giftStore:giftStore});console.log('giftStore',giftStore);}},'\u79AE\u5238\u53CA\u79AE\u7269\u5361'));}},{dataIndex:'delete',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'));})))));}}]);return BrandInfo;}(__WEBPACK_IMPORTED_MODULE_30_react__["Component"]);var devBrandInfo={name:'品牌名稱',type:1,sort:null,logo:null,image:null};

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports = [{"id":"b8b5f218-21e0-45fa-9f65-9ad5ae9657a6","name":"21Century 風味館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/21th_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"dd54eea6-e02e-4eba-ad5e-21f8c792dbe3","name":"3皇3家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd54eea6-e02e-4eba-ad5e-21f8c792dbe3/8c75e7e8-5cdd-4166-a691-7d87ad79c479.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1bc0a8de-0071-4e6c-aa9e-38b9386b5366","name":"50嵐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc0a8de-0071-4e6c-aa9e-38b9386b5366/671fb07f-0f0f-4745-94f5-7ebd73d8f56d.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"fc2cc3db-156e-4426-8677-de0fdfd5bc84","name":"85度C","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc2cc3db-156e-4426-8677-de0fdfd5bc84/cefc4f9d-29a0-433c-8f5e-9fa48e0882fa.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"35380f58-bfe7-494a-8673-730a0d174688","name":"88號樂章婚宴會館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/35380f58-bfe7-494a-8673-730a0d174688/02cf623a-15ff-4f65-908e-681a0db202e5.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"efd4ca02-0495-4d28-a72d-826d71c04af7","name":"8M瓷化工藝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/efd4ca02-0495-4d28-a72d-826d71c04af7/fb180d95-1fdc-4cd7-a166-7b3943cda50e.png","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"6de5be7e-6c74-4566-a289-c6af3892652c","name":"946韓式豆腐鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6de5be7e-6c74-4566-a289-c6af3892652c/ac1ad464-415f-4046-82c5-d656c8f5fc0f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b75814f8-d94a-4908-a356-8946ef87c2f8","name":"A Mi Ya鞋坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b75814f8-d94a-4908-a356-8946ef87c2f8/e59bf00a-eb07-4241-8096-0d2bd2fddad2.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"90267a8f-0899-4438-902b-131a7e99a338","name":"A5 Studio","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/90267a8f-0899-4438-902b-131a7e99a338/7d8f2621-993f-435f-bc4f-1d9738845d86.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"228bd48a-77e6-4e35-85f1-3a243d2f459b","name":"Adidas","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ADIDAS_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ffbb3859-f9d3-4ad3-85c9-f713d454df71","name":"Adidas & Reebok Outlet","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ADIDAS_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"082d9402-35ca-4a2c-9b95-be0174153a7a","name":"AGE BOAT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/082d9402-35ca-4a2c-9b95-be0174153a7a/30fb9a55-b28e-4609-b878-7c544ae3e8ed.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"dd87ef74-d663-424a-b19d-6c4a5d2657d5","name":"AMG","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd87ef74-d663-424a-b19d-6c4a5d2657d5/80829dc2-2e2f-4549-8e2c-e2012f3a2005.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"21f919b3-a06f-4f63-bb1d-89e82b9d434a","name":"ANKL","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ANKL_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"198e53fe-1982-4469-a4dc-de0722696454","name":"ARENA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/198e53fe-1982-4469-a4dc-de0722696454/5fa75839-f85f-4f96-a722-10c8aa4841df.png","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8f044e32-f4cb-4da1-9af4-6e35fec85db7","name":"asics","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8f044e32-f4cb-4da1-9af4-6e35fec85db7/cad63bcb-11b6-4445-8223-c40de08ae34e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"e254a286-d883-4ec6-af7e-3fbceef6b5b7","name":"BABY FISH","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e254a286-d883-4ec6-af7e-3fbceef6b5b7/d3b61c9c-3ab7-40dd-a700-8e7caf508235.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"fa1e8aaf-3130-4850-bbdd-a7f122fa541b","name":"Baleno","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Baleno_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1ace8239-7cb5-4532-aea2-983929e47d0d","name":"Baronece百諾禮士","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ace8239-7cb5-4532-aea2-983929e47d0d/decc8823-4899-4c4b-bf86-e741c593aaf3.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"eec900c5-ef26-4316-94ce-f919fa79d881","name":"Bazzar","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/eec900c5-ef26-4316-94ce-f919fa79d881/f3fd9b69-af06-4f09-b85b-9efe0840a131.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"88e90d92-af64-4c05-9af1-155a68fdb44e","name":"Bernice Furniture","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/88e90d92-af64-4c05-9af1-155a68fdb44e/dcb757c5-aa7b-404b-9231-58d7cc8ae85e.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"de96e13d-d8bd-40e0-87d4-bc9bb0ea14a1","name":"BEST電器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Best_Logo_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"bb9e3006-461b-465e-8875-3310920fb6cb","name":"BH歐洲百年健身器材","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/bh_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"690c6c1f-b427-4ab3-899a-cecd14d9cf4d","name":"BIG TRAIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/690c6c1f-b427-4ab3-899a-cecd14d9cf4d/53edcde4-e4ad-44c1-a629-18317dcc0140.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cda2d017-b369-4048-a860-45d59d85f8aa","name":"BIG TRAIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/bigtrain_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1aab9073-eebc-4a23-9c5d-53cd2959eaf3","name":"BLUE WAY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1aab9073-eebc-4a23-9c5d-53cd2959eaf3/1dd291d3-a9af-46f6-bcaa-856dd8fa2c98.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5f67d4bb-8e39-4267-b38f-66fac3ce7a0d","name":"BM","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5f67d4bb-8e39-4267-b38f-66fac3ce7a0d/38984882-4f63-4c6c-8de0-88d4e1723c1c.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ab8ee62e-a7bb-4804-8957-e1d02ab2a3c2","name":"BOBSON","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab8ee62e-a7bb-4804-8957-e1d02ab2a3c2/0a155925-7373-4f3f-a6fd-031b40452bd7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cd2f1804-b6c5-4393-bfa6-4afe09b16787","name":"BOSSINI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BOSSINI_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"aa856f23-8e69-424d-aacd-52d7f7b165c4","name":"BTU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aa856f23-8e69-424d-aacd-52d7f7b165c4/45fe4bf7-bf55-4804-a68a-ffb9f8810639.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"01e3c3bf-d535-4a3c-9229-e0a87bf5d578","name":"Caffebene","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/01e3c3bf-d535-4a3c-9229-e0a87bf5d578/85a64c10-be33-466b-8a72-3f12af16da62.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"5ecb74f1-156b-47e5-b4ae-c70ac793b5f1","name":"CASIO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5ecb74f1-156b-47e5-b4ae-c70ac793b5f1/d1cd6053-76e3-427d-9dff-89d00631d3f0.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"998b8a69-35f9-4c97-bf5e-20355358fd2e","name":"CASIO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/998b8a69-35f9-4c97-bf5e-20355358fd2e/c25dad7e-226f-480e-b224-6736d5c8fcef.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"b06e1827-2d7f-41ca-8cd5-469ab3a4eafa","name":"CAT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b06e1827-2d7f-41ca-8cd5-469ab3a4eafa/dc93abe3-eca5-4c23-9007-c92ed6fa7dac.png","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"8f99126c-e047-4193-8994-bb5a39876552","name":"Coco","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8f99126c-e047-4193-8994-bb5a39876552/fb9a4356-c22f-48c3-963e-3a3446008be3.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"a8beed52-14d6-4fbf-a3b3-3e0cb21f2f6a","name":"Columbia","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Columbia_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"19a1d96f-6cc9-44c8-a34c-3494287565f2","name":"COMEBUY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/19a1d96f-6cc9-44c8-a34c-3494287565f2/ced24e49-d624-4656-9981-2ac63fb4c13e.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4ecc4b7f-7f78-410c-8a9e-df51da189f3e","name":"COMEBUY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4ecc4b7f-7f78-410c-8a9e-df51da189f3e/c366574e-b2aa-4363-af19-66ba5a12279d.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"b2afe3b2-af12-4646-8f07-d63a72d82601","name":"COMODE 紳士西服","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b2afe3b2-af12-4646-8f07-d63a72d82601/a9836b13-abba-41c9-a02d-037d7a73f53f.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"60bb5f0e-54d3-444e-8f31-443cbe0cb44c","name":"Converse","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/converse-logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"e76e8a18-3129-4cd8-b768-132a5f8226f1","name":"CONVERSE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/converse-logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"4103c7e3-cb81-4512-9453-f1f7ef3ed5dc","name":"CQ2 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/CQ2_Logo_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"3b920de7-a759-4c0c-94a7-73096aef59bd","name":"Crocodile","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b920de7-a759-4c0c-94a7-73096aef59bd/4a30c69f-9290-4457-9b17-09c7f480a119.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"c02f6c51-8d2a-44a5-92cb-35dc8b725fd6","name":"Crocs","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c02f6c51-8d2a-44a5-92cb-35dc8b725fd6/d644d357-b2e5-45fc-ba97-a760c677cbec.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"cf013f29-a243-4e06-87c5-8e6a93bf5ff2","name":"Curves 可爾姿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf013f29-a243-4e06-87c5-8e6a93bf5ff2/435caa94-1038-4691-97e3-a0a360042318.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"ed630301-ebfb-409f-a25b-a8c712e1aa26","name":"DECO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ed630301-ebfb-409f-a25b-a8c712e1aa26/fe4431f8-2ac6-4541-bd29-8501b0a22290.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"9475e3f7-267e-4c32-afe9-ee597aceb705","name":"DNA 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/DNA_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"d45f486f-c062-464c-843d-18cedc4bd31b","name":"EASY SHOP","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Easyshop_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"0b43f343-0da0-4f4f-8452-7b05e4434eb1","name":"e-baby","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0b43f343-0da0-4f4f-8452-7b05e4434eb1/8b3d8f70-a4ff-47d3-84e5-faafd1098d0a.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"4ef9c598-1e4f-4ea9-878a-b790d1fa392e","name":"ECCO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ecco_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"ea9e3413-f05b-4035-8919-91d09b836d53","name":"eCosway 特惠屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/COSWAY_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"12767bde-0196-4c57-b6bd-f529b8fce8c0","name":"EDWIN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/EDWIN.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"e874a0c7-626a-441b-8622-c385f7fd0366","name":"Emily 艾美麗","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Emily_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"b37a73d0-efb0-4a5e-aada-7db07963c28b","name":"ESPRIT","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b37a73d0-efb0-4a5e-aada-7db07963c28b/58670a8b-2679-4973-a42c-34f98034e30b.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b4537079-d5b3-45ea-99cd-574f1990a988","name":"Extreme","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/extreme_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3b40d7b8-f402-4598-9226-d662c09ef8d0","name":"Eye Fun","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b40d7b8-f402-4598-9226-d662c09ef8d0/44958864-491b-499f-907b-403741cfa87e.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"15acdfb5-43e1-4baf-9e57-30ce51f1d642","name":"EYE PAY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/15acdfb5-43e1-4baf-9e57-30ce51f1d642/74f57cc7-0e94-4180-8ec6-e45deb6b05cc.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"b7ce8261-b16e-4da1-be43-d8438509247c","name":"EZ專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b7ce8261-b16e-4da1-be43-d8438509247c/b95ec845-a820-40e6-9219-c915734b21f0.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"bef9a2dd-c43c-4180-9f6f-f07176981ba6","name":"F100極速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bef9a2dd-c43c-4180-9f6f-f07176981ba6/da1a929f-2cc9-424a-a169-c47a79f747b8.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"aea7e8c3-6e22-4f2e-8da5-0cfbc0ae98cc","name":"Favori","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aea7e8c3-6e22-4f2e-8da5-0cfbc0ae98cc/80ee385f-5944-4d6d-ac2d-9e952349d0d8.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"54f174e2-572e-4346-b0e9-9df5bebaa09a","name":"FUJI富士","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Fuji_Logo_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"62db36a5-12fe-472d-a62d-d43dadffe091","name":"fun box","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/62db36a5-12fe-472d-a62d-d43dadffe091/624dbad0-d214-4abf-b322-e710bfadcc47.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"7140d17b-8153-45d2-9ac4-30e50ba0c77a","name":"G2000","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7140d17b-8153-45d2-9ac4-30e50ba0c77a/ef080fb0-516c-4c8e-8df6-7b7553c3127e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5c2c34b3-9416-448e-877a-df5e3345cc93","name":"GNC","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c2c34b3-9416-448e-877a-df5e3345cc93/ea04e103-66b5-4287-b08d-80490c56fe1b.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"a04f17c0-6666-4aa0-a68f-612a94af1472","name":"GOORIK","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/GOORIK_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"655f3e9e-57e0-4afd-a12a-aacec3dbb7aa","name":"H&J","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/655f3e9e-57e0-4afd-a12a-aacec3dbb7aa/5cfddb49-d53b-418c-8359-3edf9bd5a9b7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ff773a48-f96c-43f9-96e2-4c43447c2860","name":"Häagen-Dazs","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Haagan_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"8079a854-b2d5-4681-b6d1-49bf1e76693c","name":"HANG TEN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8079a854-b2d5-4681-b6d1-49bf1e76693c/85b6bc10-e985-4c29-86d7-45211e6f525d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"0668063f-e997-4201-9aa0-c1c8791f09fa","name":"Hedgren&ELLE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0668063f-e997-4201-9aa0-c1c8791f09fa/06fc68c9-f3ac-41e3-bfd3-cc61195e900e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"289e56bf-f703-4692-85f4-1e317a16a488","name":"HOLA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Hola_Logo_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"60630aea-c821-49d6-b995-9e034b752221","name":"HOLA Petite","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/60630aea-c821-49d6-b995-9e034b752221/f548a02a-8745-4bac-8cce-a2f71a22b181.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"f5961805-6e2c-4692-b510-308bd7e43584","name":"hot 7","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f5961805-6e2c-4692-b510-308bd7e43584/04cd03c4-80e5-46dd-9958-531ef3ab4d9d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"349b92c1-e8da-4c1e-9af5-ac7d329fe2be","name":"HUSH PUPPIES","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/349b92c1-e8da-4c1e-9af5-ac7d329fe2be/a8bf57d7-9539-4996-ae07-964f3e794c47.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"95270f8f-7e09-4a15-a6fa-52a8f0f1e371","name":"i Color","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/95270f8f-7e09-4a15-a6fa-52a8f0f1e371/2fb1353a-b265-4462-be40-cfe94e85bd62.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"e30fb9f6-0db3-45ef-8414-005e669f295f","name":"IBEX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ibex-R_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b8736a4b-fca7-4667-81c7-cd014992ffa2","name":"ICU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b8736a4b-fca7-4667-81c7-cd014992ffa2/c10f1ede-9fab-4723-bbe5-9aca48bfe6d2.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"9a8c84a8-97d3-4a64-9e47-67d7d7f6afc0","name":"IF 專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/ifsalon_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"140a203a-69cc-4137-868b-7b71551c4d2f","name":"in89豪華影城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/140a203a-69cc-4137-868b-7b71551c4d2f/745d00d4-358a-43f4-a8a9-7c2b9bf77aa6.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"7b606808-4c18-4fc2-8003-a5d3def4825c","name":"J&C 典將鞋業","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7b606808-4c18-4fc2-8003-a5d3def4825c/6fbc26dc-4c4a-455e-9acb-b9d61b265ab5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"0baa02d2-6685-42c6-981b-57bdbe4a8fce","name":"Jeko","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0baa02d2-6685-42c6-981b-57bdbe4a8fce/628b3297-bef0-4f3c-bb17-b45431108c63.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"8b188537-d2b0-4292-99c3-6e72de6e48da","name":"JIT快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b188537-d2b0-4292-99c3-6e72de6e48da/babd7906-572d-449c-94ce-f85ce21fa609.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"50d46f6e-d047-4863-a209-127b83f2bb2c","name":"Johnson","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/johnson_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"7628c507-9ccc-49d9-a7b2-484bc15a07b5","name":"JUSTHOME","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7628c507-9ccc-49d9-a7b2-484bc15a07b5/91b63bce-3939-4c06-aeab-e1ea527a9ad8.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1bc64c0b-ef31-47f4-bf3a-1b9bc94ed633","name":"K.SWISS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1bc64c0b-ef31-47f4-bf3a-1b9bc94ed633/87d3e3a9-82eb-4ae3-a630-07c723a1e750.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f495bf1c-c728-4e33-a92a-a8437dbc3953","name":"Keds","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f495bf1c-c728-4e33-a92a-a8437dbc3953/436363c0-0366-4f8f-88db-12d0b68e746e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"67a970d6-09ec-414d-a499-a8866c94a0ae","name":"KiKi Studio","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/67a970d6-09ec-414d-a499-a8866c94a0ae/b333a285-4778-4624-8bf6-1175a0059e93.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"0f8f9092-58d2-4702-9b6e-0bb677477a52","name":"Kipling","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0f8f9092-58d2-4702-9b6e-0bb677477a52/abbfc65f-64d6-4594-bc53-f3ae04cd8224.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"9250e2dc-7d8c-46df-b70c-9c8ad7b5a8c1","name":"LACASA家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9250e2dc-7d8c-46df-b70c-9c8ad7b5a8c1/4f6bdbbe-a563-461e-a0a7-50aa92e9f3d5.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"f2d6df11-2959-49ce-82b7-57df0a009d1f","name":"LACHELN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2d6df11-2959-49ce-82b7-57df0a009d1f/39569070-fa76-46f0-af3c-33615fb0317e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a463cd6d-72b1-4368-ae27-4b12c4efb464","name":"L'A'CHELN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a463cd6d-72b1-4368-ae27-4b12c4efb464/da368c7d-726a-4379-96a2-50b5eba44311.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d160c40d-3796-4703-8910-c95601ffe185","name":"Lady Love","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d160c40d-3796-4703-8910-c95601ffe185/21c7af5d-3779-41f7-8578-1fa686a34afa.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"041f9483-00b3-4918-b7dc-a2c5bffdc354","name":"le coq sportif","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/041f9483-00b3-4918-b7dc-a2c5bffdc354/ca45be1e-d84b-41a4-96cd-b86389130c89.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"076b2476-2362-41d8-a400-c9a2ea2d9554","name":"LEE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/LEE_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"dfb071ac-4a9c-4aab-836a-41575ff096bf","name":"Lee Cooper","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/LeeCooper_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"1ee9544a-d866-44fe-bddd-a134b0719fcd","name":"LEVIS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ee9544a-d866-44fe-bddd-a134b0719fcd/5aab47c1-96a0-4bfc-9ad5-4ed17c53e53d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7361db02-92f3-42bd-af34-6c0ae6ddd161","name":"LG","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7361db02-92f3-42bd-af34-6c0ae6ddd161/047376b5-8923-4ba4-94c7-bc19b5e9a812.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"d44d983e-05f5-442c-91d2-eda872a99a6c","name":"LiCha芙","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d44d983e-05f5-442c-91d2-eda872a99a6c/007caae3-89c1-4233-80a0-21adadbf77ba.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"f9660562-d589-4e3c-b184-d2d61f4af0c6","name":"LOTUS 樂德鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f9660562-d589-4e3c-b184-d2d61f4af0c6/90a5e538-0347-4dd1-b7ad-3304a7ce3f16.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"70e7448b-686b-463f-bfac-12656cd66195","name":"LOUISA COFFEE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/70e7448b-686b-463f-bfac-12656cd66195/883ade89-0fda-42f4-9371-00852c8b74b2.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"5c46ed35-56d0-42af-a969-28d96daced6f","name":"MACANNA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MACANNA_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"e1dc0bfe-e8c4-42cd-8716-913f43cf26de","name":"MANGO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mango_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"644f6fae-2446-4639-a568-a8c70b4ee4b6","name":"MARCROCOO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/644f6fae-2446-4639-a568-a8c70b4ee4b6/d12e6568-a839-426a-81e6-925e085810de.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"94e2bef9-8eff-4625-a877-ab14ea6ad392","name":"MERRELL","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/94e2bef9-8eff-4625-a877-ab14ea6ad392/33807470-d1fc-48a7-b81b-ba2e28335874.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"bbbb9ac9-e9cf-44f9-ab0f-52eb4a9473f7","name":"MIRUKU","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bbbb9ac9-e9cf-44f9-ab0f-52eb4a9473f7/c4fe18bd-fc79-4d4e-a464-ac08a5374195.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b205ac21-334e-409e-a1eb-323b27f4ba59","name":"MISS TEEN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b205ac21-334e-409e-a1eb-323b27f4ba59/8d77a2de-7c1a-4c99-97cc-3a42b7cbc6c3.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7ce6e2e7-85c1-458f-82f7-8bedca6cecf2","name":"Mister Donut 多拿滋先生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mister_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"0c5871d9-37b6-45d7-a3f2-ff4651c6c8f2","name":"MOMA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MOMA_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"8af749f1-ca85-4e75-ae60-ffd697ced4a9","name":"MO-MO Paradise","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mo-Mo-Paradise_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2e839413-7764-4a4d-ac4b-277e6bc4628e","name":"Mr.Onion牛排餐廳","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mronion_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6353bbbe-8436-4a31-980b-f5f199d8ad5c","name":"Mr.拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6353bbbe-8436-4a31-980b-f5f199d8ad5c/cf797599-8f9f-4484-944a-59be083419f2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1bb605c2-a7cf-46c8-80f3-d891cc62cbdb","name":"NEOX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/neox_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"0190246c-9717-4c0e-a943-b6e12dcea304","name":"NET","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/NET_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"f91a697f-c0bc-4659-8cad-36e519749ea6","name":"New Balance","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f91a697f-c0bc-4659-8cad-36e519749ea6/afa077f5-bc5d-440d-811e-e9f6dfe227fc.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"89c47b4b-d0e4-4bb5-8f7e-d7f13a94895d","name":"New City House","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/89c47b4b-d0e4-4bb5-8f7e-d7f13a94895d/aef7cfad-4a6c-42bb-9c76-fdf050e266e3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a733cf1e-b259-4184-894b-07b8310d86fb","name":"New House","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a733cf1e-b259-4184-894b-07b8310d86fb/eb15b07b-5f2f-4976-8a42-645b106854f9.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b38d1dc-521f-4fe2-9340-50bf1f4a3566","name":"NICEIOI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Nice101_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b9786e7c-5d5a-4225-93a4-3c0c8fd721e7","name":"NIKE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b9786e7c-5d5a-4225-93a4-3c0c8fd721e7/8c590584-f72e-45e5-9cc4-0d5d493c8853.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f3563b1f-1596-48f4-a028-92c5c4f01392","name":"NOKIA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/nokia_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"a93cdfd2-cf8a-4a4e-8392-f6141741e16c","name":"NOODDI EXPRESS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a93cdfd2-cf8a-4a4e-8392-f6141741e16c/84d8ebdb-9d2b-4d52-96b2-f558a6059c4b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dc66a9f1-67dd-4b89-80f2-35b01225c800","name":"NOVA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc66a9f1-67dd-4b89-80f2-35b01225c800/c75761da-3152-4064-a9fa-6c8cd9b73581.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"f5d65a30-8ab8-4183-b3bd-d1d06eab53bf","name":"NU PASTA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f5d65a30-8ab8-4183-b3bd-d1d06eab53bf/a2670dfd-5e7f-4e32-8b2f-5bfa9d839cd5.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"82c1e840-9a64-49ac-8ddb-599777daa595","name":"ohoh-mini","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/82c1e840-9a64-49ac-8ddb-599777daa595/e4eb9277-0567-4c85-818e-5d9adb2b841d.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"e78e209f-728f-4b74-9600-7928cf1cfafc","name":"OMG運動休閒館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e78e209f-728f-4b74-9600-7928cf1cfafc/eb424b5c-4d1e-41c7-a227-685bc34fc018.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"6cc4645f-e30c-4e9f-a6ff-43d45691d678","name":"OTTO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6cc4645f-e30c-4e9f-a6ff-43d45691d678/f2151915-67b1-4e26-80d8-72aa486814cc.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cbd4d3f2-79a0-4e84-9cb3-8f8b01010715","name":"OUTDOOR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cbd4d3f2-79a0-4e84-9cb3-8f8b01010715/3ee9edc9-1542-4018-bc30-a053e5b415b5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"4ea1c43a-d4ce-441f-9fb4-b11f4f0bcc0d","name":"OWNDAYS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4ea1c43a-d4ce-441f-9fb4-b11f4f0bcc0d/3a740e89-e314-47ae-b649-cf3c2a1aac7c.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"0e3ef1da-0f00-4822-84a2-58e4dc0471f6","name":"P.B&P.C","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0e3ef1da-0f00-4822-84a2-58e4dc0471f6/7cd687fc-2071-46e2-b564-b1c82298c6b9.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8730083c-706f-4e51-8b4d-4a48a5fb159f","name":"PAPAYA泰式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8730083c-706f-4e51-8b4d-4a48a5fb159f/00aefe5b-9fdc-4c44-8e34-ac6cc35783cd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af70f7c9-cec3-483a-84ca-16e4049e1c89","name":"Paulmauriat","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af70f7c9-cec3-483a-84ca-16e4049e1c89/f82ee4d8-0fe2-4eff-815c-1560371b3c7c.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"3afcdfe5-dcc5-4204-a007-55bfb08b42e0","name":"POLAR BEAR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Polar_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ab1b4f7c-a63f-4b91-b5a8-f01457f72165","name":"POM POM PLUS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab1b4f7c-a63f-4b91-b5a8-f01457f72165/c2d8f136-d0c6-4aa0-84a0-f4751c73dc97.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"b7660278-e2b8-4e64-8332-b24e9a64d5ab","name":"POYA寶雅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b7660278-e2b8-4e64-8332-b24e9a64d5ab/f7ae7496-f1d4-4120-b423-d7affcb821c1.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"8b097921-f2bc-4926-b8c0-e67807688b0e","name":"PROTEST","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b097921-f2bc-4926-b8c0-e67807688b0e/a557ac23-8a04-4e69-80c4-44cd88b48ae5.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"8b8ef5d7-e1d4-47cd-b8e1-65dc562c3f99","name":"PUMA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b8ef5d7-e1d4-47cd-b8e1-65dc562c3f99/47ff48da-c166-4038-bd3f-bbea60fd6a90.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d77417e0-c72e-4738-9812-122a1faa381a","name":"PYXIS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pyxis_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"368f2850-db75-4caf-a9cd-9bf39e63842a","name":"Quick cut KK","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/368f2850-db75-4caf-a9cd-9bf39e63842a/39147e6b-7bdc-4527-b89f-5b8dd18c962c.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"6ab26818-1601-4f15-a558-5a48d5d92465","name":"Reebok","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/reebok_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"696315d1-c632-4a2d-9e95-4d6e945b18c3","name":"Rockport","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/696315d1-c632-4a2d-9e95-4d6e945b18c3/e399d155-4db2-46cb-9170-c9b1663294f3.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"516f46db-ad9a-422c-a98b-de7712840a83","name":"Rookie","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/516f46db-ad9a-422c-a98b-de7712840a83/134808e8-9b45-4e84-b776-f47881866871.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"23b5f8ee-08c7-430e-b20b-1396e678eae5","name":"RQ POLO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/rqpolo_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"43d46df9-7410-4356-83b8-abb73b29d692","name":"Samsung","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/samsung_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"25bfdf40-3efc-475d-8b0c-900c7b575328","name":"SKECHERS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/25bfdf40-3efc-475d-8b0c-900c7b575328/aef9bf33-a5c9-424e-810d-301d9d10008b.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"88e251bb-8a75-40f9-8662-611b0604b357","name":"SO NICE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Sonice_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"e7dc4186-61fd-4989-8fbb-e9ecbd7a0484","name":"SOFTSUN","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/softsun_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"876ed210-de00-4729-8ad5-7723eb38208a","name":"Sonora 尚諾奈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/876ed210-de00-4729-8ad5-7723eb38208a/c1a1c6c3-f08b-4a2d-bf5c-fdc11b83a6f6.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7321fa71-4ecf-4607-acbf-9317ccbfb2e4","name":"SONY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sony_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"ecdca60a-917c-4753-90a4-df61e4145e0b","name":"Speed Cut","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ecdca60a-917c-4753-90a4-df61e4145e0b/2861fff3-3dc4-4986-abd8-1b5098486c5d.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"c571d3e6-f58e-4f40-9da9-382eb9a47aa4","name":"Sperry","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c571d3e6-f58e-4f40-9da9-382eb9a47aa4/12d7f673-cf59-4e56-8f16-0127d2477926.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"a6715bae-a31a-4f32-b8a2-d99070f099e0","name":"Takara standard 日本寶廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a6715bae-a31a-4f32-b8a2-d99070f099e0/465cf851-68ba-45d5-ad22-fc0f75840a99.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"fc1c860a-a1e8-40b1-bd2c-22945b5412fd","name":"Tamoya烏龍麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc1c860a-a1e8-40b1-bd2c-22945b5412fd/e66f60a4-0233-480f-866f-ebbf98b5e39c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cd76fda4-aa36-4bda-bddc-4faee4376db4","name":"THE BODY SHOP","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cd76fda4-aa36-4bda-bddc-4faee4376db4/b0c9a57d-4d7d-49b3-839b-64dc3053da9b.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"2b4d2300-b699-4d03-8714-e5e49494f90b","name":"THE NORTH FACE","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b4d2300-b699-4d03-8714-e5e49494f90b/ddd1866a-4c3d-4616-a76f-3548fec0694e.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b925f70a-831e-4e5c-b01f-aa471d4723e3","name":"Theme","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Theme_logo_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a1542fd9-225b-4ad1-9758-5ac77b99b952","name":"Timberland","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a1542fd9-225b-4ad1-9758-5ac77b99b952/79e68881-2bf2-4f1a-8e09-8c1a034a694b.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"62aff5dc-c0d6-4ee2-9a9b-7948ef298d68","name":"TINOS PIZZA","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/62aff5dc-c0d6-4ee2-9a9b-7948ef298d68/027ba257-56af-4533-9618-8673ccc04697.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4349acd6-9639-43ca-b3ec-22122e15cbc7","name":"TOKUYO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4349acd6-9639-43ca-b3ec-22122e15cbc7/71666968-39c2-4f22-adf4-c7beae88cb38.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"5e25198d-8b0a-4677-90b2-6053a6f9bd2e","name":"TOKUYO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5e25198d-8b0a-4677-90b2-6053a6f9bd2e/a6ee3125-56a0-4113-8224-e25542f9c524.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ab22be48-2254-4890-bdbb-2d867984625b","name":"TOMS","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ab22be48-2254-4890-bdbb-2d867984625b/4abd5dc5-660b-47dd-86de-540f67340796.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"d16faeab-6193-4504-b46c-2ad965c6161e","name":"TRAVEL FOX","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/travelfox_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"affcc816-1df5-4a43-a3be-77265b045be5","name":"Traveler","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/affcc816-1df5-4a43-a3be-77265b045be5/a2437c3b-2361-4ddc-baae-d849596c0f76.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"3d0e4ee8-a5b2-41fb-a147-d9cd411e465e","name":"UNDER ARMOUR","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3d0e4ee8-a5b2-41fb-a147-d9cd411e465e/48ff0c96-e4e2-494a-9b41-3f4c660b57bd.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"0c7d9b35-56e7-4fab-a77b-cc2df52aa95c","name":"UNIQLO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/UNIQLO_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"687b3080-543f-4462-9104-fef76149e90c","name":"Verage","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Verage_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"23d20a13-0723-4948-99c8-0e59a36f275c","name":"VICTOR勝利體育","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/23d20a13-0723-4948-99c8-0e59a36f275c/99644fba-dfed-49c7-8e24-29b93919905c.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b57ca098-3532-491f-a72b-3308440b325e","name":"VIZ","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/viz_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"b4d57c58-6dd3-4558-b2f1-522953399941","name":"WALLABY","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b4d57c58-6dd3-4558-b2f1-522953399941/04d2cc99-521d-4ba1-99c0-254fccec7afd.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"e5f667ac-9e9c-4685-aa5d-808ec2bf6c84","name":"waltz","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5f667ac-9e9c-4685-aa5d-808ec2bf6c84/8fbf2a08-31c1-4594-b3d1-9164bcd16f2c.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"3ab1e14a-2e29-4b40-a820-1163229adefa","name":"WORLD GYM","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3ab1e14a-2e29-4b40-a820-1163229adefa/f4b537a8-b575-4167-bc9d-ffc56a97f1c7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"42ccbcdc-d46f-47cb-9f2e-224739b9679d","name":"Yamazaki 山崎麵包","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/42ccbcdc-d46f-47cb-9f2e-224739b9679d/e8d875c4-151f-4e95-a832-0d82a3601e8d.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e9fc6306-ba28-4bb6-afc6-6347de7facd0","name":"Y寶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e9fc6306-ba28-4bb6-afc6-6347de7facd0/8b75ff0a-7a59-4276-828e-01df6182adba.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4364e8c4-d1e6-4379-bdb3-88f4fa474daf","name":"Zen Q","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4364e8c4-d1e6-4379-bdb3-88f4fa474daf/97cd9d48-9592-4fe4-9121-b1ea53e4d07b.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"d0f3e251-ecff-4edd-8d2d-89c5f5ade87c","name":"一亨運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/iheng_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"ca081d99-49fc-46fe-8f58-43d6a23c2d64","name":"一點工夫","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ca081d99-49fc-46fe-8f58-43d6a23c2d64/fe2ff446-0807-42fd-80bd-0acf9e68234d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cf3fd45c-60d9-4f44-bfea-34bc9572fbfe","name":"三友藥妝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf3fd45c-60d9-4f44-bfea-34bc9572fbfe/cb64ec8c-0747-4917-8bd6-1a0e9cd245b2.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"6565a3d4-977e-4efd-a952-0b40ef5e98e6","name":"三商巧福","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6565a3d4-977e-4efd-a952-0b40ef5e98e6/8c3cec6b-159a-42a3-91f8-787b058d86e3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"72669bb9-0fd1-48fe-a144-c60af315f051","name":"上都","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/72669bb9-0fd1-48fe-a144-c60af315f051/b60a0f65-c5fd-4579-8147-2e5b769fc540.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"958c94b5-36ad-48d3-b117-b05724b0f402","name":"上騰鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/958c94b5-36ad-48d3-b117-b05724b0f402/2b57e18e-1f65-4dc0-b4e1-f58c38d013c5.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0d4bc4fc-e7e9-4044-a0ce-75a74d09b835","name":"世偉運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/shihweisport_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"5eceaacd-effb-4bd1-81e9-a4655de58729","name":"中一排骨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5eceaacd-effb-4bd1-81e9-a4655de58729/b785bf70-f1cb-44d3-904c-e0b19b1590cb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dc25a6bc-dab6-4c05-93eb-bdef21b8f697","name":"丸龜製麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc25a6bc-dab6-4c05-93eb-bdef21b8f697/ca0fef7a-e072-4ec2-9b53-20707f228b6f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8b990877-8c1f-4f52-949f-a03d46581ad1","name":"丹堤咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8b990877-8c1f-4f52-949f-a03d46581ad1/7c01eebb-3e44-44dd-b192-4211ca9b9eea.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"940a7a8c-b42c-4a87-954a-1bd0999372c2","name":"丹尼先生自己喝茶飲","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/940a7a8c-b42c-4a87-954a-1bd0999372c2/2f1d1c55-4435-4057-a4ee-318f2c5c2ea1.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"3a15e182-c1f2-46c1-9fd6-106cbedc4f90","name":"乾杯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a15e182-c1f2-46c1-9fd6-106cbedc4f90/a56a7a60-43a2-433b-b519-65ee8a58eeee.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"aafb5a89-cc51-4077-97c1-d39a6c0afdc5","name":"五花馬水餃館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aafb5a89-cc51-4077-97c1-d39a6c0afdc5/7fbfa812-19cd-4d9f-9509-6edd8bf29a30.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7489abd4-6a26-44da-ae48-1418b82d8a55","name":"享趣玩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7489abd4-6a26-44da-ae48-1418b82d8a55/21020d83-ab7c-4274-b12d-4188bc1c0aec.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"681a3181-7625-406e-a6c4-9ce81e0ddf9b","name":"京澤苑日式鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/681a3181-7625-406e-a6c4-9ce81e0ddf9b/ad4ab922-bdaa-49b0-8354-de76ed8952a3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2838c4a4-1c1d-4fcd-bbca-dd5a149553df","name":"京都苑","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2838c4a4-1c1d-4fcd-bbca-dd5a149553df/7c4a5425-652d-4808-b221-79d6cbc1c8f9.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"7cc179e0-e362-4fba-9dc6-1711e5f72fc2","name":"亮誠美車科技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7cc179e0-e362-4fba-9dc6-1711e5f72fc2/597562f8-3ea4-4555-a0cc-4c390a004674.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"97648411-edbc-4cd2-bd4d-def34a2f3c25","name":"仙妮蕾德","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97648411-edbc-4cd2-bd4d-def34a2f3c25/d5669c39-6060-4e71-b1f7-2406dc5be3da.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"d64dfd76-c451-48ea-88d5-84609b1c9289","name":"仙德曼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d64dfd76-c451-48ea-88d5-84609b1c9289/3c3d1ab6-249c-457d-9b3b-b446e88260ac.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"2e02bc5c-f1d6-4d2b-993c-3d9679c0e8d7","name":"仙霖茶行","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2e02bc5c-f1d6-4d2b-993c-3d9679c0e8d7/817fd5ed-4fed-4e45-b5d5-1914091e6a0a.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"6e2c6613-6794-4319-ba3b-66c23ab95f78","name":"伊太郎","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6e2c6613-6794-4319-ba3b-66c23ab95f78/572c481f-d097-45df-b08e-d5bf9da8233a.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e564ac07-56b8-48f4-b321-68022ce49046","name":"伊妮 INI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e564ac07-56b8-48f4-b321-68022ce49046/86f845ae-0e74-499c-b2d2-9b0613ad7082.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"fa2ba7c4-e5ca-4a30-a572-5495a53cd89e","name":"伯朗咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/MR_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5a874689-95bd-4feb-bcc2-4eaa1f8c7a91","name":"佐丹奴 GIORDANO","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a874689-95bd-4feb-bcc2-4eaa1f8c7a91/af083a2b-1927-4847-a601-2451d71f17e9.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"fd7f8bed-887e-4083-a7ce-d700ff256338","name":"依夢內衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fd7f8bed-887e-4083-a7ce-d700ff256338/b4560929-ff73-41de-a59d-8413c527122a.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"a98e9d24-10a5-49be-b022-7e08afb0ba04","name":"倍儷蔻","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BELECO_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3c9a3138-f8b1-494d-b4b2-6d6d85bc6dac","name":"健身工廠","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3c9a3138-f8b1-494d-b4b2-6d6d85bc6dac/e7cfac19-7810-4c10-af89-cf84bff17be7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"73711921-d262-41ca-9417-5c7208a1f129","name":"優尼聖運動聯盟","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/73711921-d262-41ca-9417-5c7208a1f129/17cca759-b561-4ab8-bb65-53de91bfa78f.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"9fd2366d-e086-451e-a314-8acac96d6fa6","name":"優衣庫","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9fd2366d-e086-451e-a314-8acac96d6fa6/dde61bc6-06fc-4e31-aba4-7ba70eb84d7e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"19478ed1-cc8c-4fd8-9e3a-ae1c64e2e1f6","name":"元呈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/19478ed1-cc8c-4fd8-9e3a-ae1c64e2e1f6/b3b1f9ce-7ca8-4f0a-b660-f4b0e75f8e7b.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"601d3768-6c4f-4e41-974e-9b10883bb748","name":"元氣咖哩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/601d3768-6c4f-4e41-974e-9b10883bb748/ccafd184-87d8-46eb-9311-e5e498d01291.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"fd6fa8d0-e0f5-44d3-a40b-88eb854817aa","name":"克萊緹","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fd6fa8d0-e0f5-44d3-a40b-88eb854817aa/48723c01-6339-47ce-9f3b-245788640893.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"1be21ee2-b1d3-4e9d-8fc8-633167138cd9","name":"全家便利商店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1be21ee2-b1d3-4e9d-8fc8-633167138cd9/feca2efa-053f-4496-8fa3-03b57ac6d946.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"d637b4e3-b959-441e-862b-82740659514d","name":"全家福","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Familyshoes_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"cb4a4cc0-4cab-4899-9556-71574b3859cb","name":"全廉工坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/chainlive_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"9a2b0de5-a8c9-434a-9683-30f7df6f6a01","name":"兩餐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9a2b0de5-a8c9-434a-9683-30f7df6f6a01/1137af29-85d8-4497-b975-c7e6cb7d642e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9c3a482f-39e9-47f8-9b2a-5ffe92c20f69","name":"八&#22338;丼屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9c3a482f-39e9-47f8-9b2a-5ffe92c20f69/62a77b88-261c-4726-83d1-5ec2aab1c003.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"80135b2a-de42-42d0-b194-ffcb6dd3b3e3","name":"八月堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/80135b2a-de42-42d0-b194-ffcb6dd3b3e3/06537889-502d-4e56-a79d-7f141d90db30.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"416f2646-e590-4232-bd6c-4205a0daa5e4","name":"八番赤野","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/416f2646-e590-4232-bd6c-4205a0daa5e4/9744b9ce-0f56-4273-a83c-95a841cee598.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cc776de5-ee39-4fe8-90d0-6625b7df76d5","name":"凱林鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc776de5-ee39-4fe8-90d0-6625b7df76d5/b0d87634-6a5a-4e43-a871-3d3f4da91007.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4316048f-1a25-437e-97cf-44f2a0feaad9","name":"初丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4316048f-1a25-437e-97cf-44f2a0feaad9/20a9d2eb-8fae-46e7-ae38-0d4849f139ce.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1b0a8e21-1bf3-41c4-b791-24bfbfb72d63","name":"初嘛超市火鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1b0a8e21-1bf3-41c4-b791-24bfbfb72d63/6689f4f1-38ac-416f-895f-16cc75be6642.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b1d40047-aa25-42f8-9917-798ab2dd355a","name":"勃肯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b1d40047-aa25-42f8-9917-798ab2dd355a/90d2a9ed-bab6-48fc-af01-1d3e9c292861.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"71d0782d-9452-4027-b8c2-d9a63532f4f4","name":"勝博殿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/71d0782d-9452-4027-b8c2-d9a63532f4f4/71839e83-2e77-4250-b811-013d2d60d184.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af9ea9b2-f396-4449-a0a8-f8fc97880618","name":"勝里日式豬排專賣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af9ea9b2-f396-4449-a0a8-f8fc97880618/db246bd0-517e-4a78-87ca-a236a54bc24a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bd9040f3-f332-43ca-879d-19f741643096","name":"包心粉圓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bd9040f3-f332-43ca-879d-19f741643096/a2eecaa6-962e-44db-91dd-7f1491cdfd87.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"a09bde1e-0559-45f5-a05a-81dcd4bb0a50","name":"北澤壽喜燒專門店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a09bde1e-0559-45f5-a05a-81dcd4bb0a50/fdbbe9a1-091f-49ef-a2a8-56c6cf12a0a8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"798af07b-2338-425c-add5-8c2d35c8af0d","name":"匠喝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/798af07b-2338-425c-add5-8c2d35c8af0d/7ee4aaaa-5f7c-4792-b3d1-51dc02efd095.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"c74f933e-718a-4f3c-bdf3-0215b46d9962","name":"匠關東煮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c74f933e-718a-4f3c-bdf3-0215b46d9962/540dae9e-1f0c-4270-9f87-d2dff0dbd300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"120497f4-df26-42eb-9317-96aa9bd89e9a","name":"卉豐園藝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/120497f4-df26-42eb-9317-96aa9bd89e9a/c27c3a2b-3998-434c-9941-64af8e0a851b.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"4d790c1b-ea76-46cb-bf69-7f31191908f1","name":"半雞八兩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d790c1b-ea76-46cb-bf69-7f31191908f1/8c685470-ad02-47af-9b56-7a0fab1041d3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2bdbf841-739b-4206-92a0-d37ddf52df5d","name":"卓越汽車","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2bdbf841-739b-4206-92a0-d37ddf52df5d/43470ad0-32e8-4c29-a8ab-ef72df9c2e72.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"c0d5c603-69cf-4b31-97aa-be3691812f14","name":"南大門","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c0d5c603-69cf-4b31-97aa-be3691812f14/a2d00ac5-bf55-47ce-b99d-329d56a1c5c0.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7e0400ec-fa0e-406b-89fd-08ae61843e06","name":"博帝","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7e0400ec-fa0e-406b-89fd-08ae61843e06/dfbd6511-dc2c-4d72-92c6-2f37ed89cdc7.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"4b2d1d69-ee36-42f4-8d3c-24d33f63fffd","name":"卡氏汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b2d1d69-ee36-42f4-8d3c-24d33f63fffd/96bc7669-a80d-46e7-b8b7-a87563826aba.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"1cb2252d-5f98-4907-889f-d567c6091e59","name":"卡紛","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1cb2252d-5f98-4907-889f-d567c6091e59/a347c061-9164-4917-815c-9b489d0c27f0.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"3e529030-bf1f-4e91-a274-3398595838af","name":"卡西歐樂器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e529030-bf1f-4e91-a274-3398595838af/be20322a-efa7-428b-9ae9-c38442c73b6c.jpg","cat":"8d59d7ab-8fa9-4ee0-871d-f46962bf7456"},{"id":"6eb06bcf-add1-4d04-95b3-2fe8b2989db1","name":"原燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6eb06bcf-add1-4d04-95b3-2fe8b2989db1/882dc47e-ca36-43ca-a9d8-f8045f245e96.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"171fedc7-61aa-45f9-8505-3799c5e543f2","name":"口力口里","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/171fedc7-61aa-45f9-8505-3799c5e543f2/ad14b648-9420-465c-ab09-88ea0e4e80e3.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"be55930a-01ff-44dc-8cab-e7b27de84c7d","name":"古拉爵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/be55930a-01ff-44dc-8cab-e7b27de84c7d/e7f22830-cf5f-49b2-b0d6-f412b90093fe.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3b002889-cfc8-41b2-9df4-3c7ded51fdc6","name":"叭咘遊戲樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b002889-cfc8-41b2-9df4-3c7ded51fdc6/d496c058-445d-4389-bf0a-a7994754446e.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"2d72b272-77c9-46a7-aa06-71d1758d1541","name":"台灣大創百貨股份有限公司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2d72b272-77c9-46a7-aa06-71d1758d1541/81840717-e6f4-40ea-b11e-3abedfb59e91.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"382327f6-73e8-4ada-a926-9f8ee17b4d80","name":"台灣彩券","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/382327f6-73e8-4ada-a926-9f8ee17b4d80/363823de-a162-4da4-b43f-74742db12fb5.jpg","cat":"11ed25a1-d424-42d1-bfb6-4671f87bbf55"},{"id":"0f7b9822-ad6f-4b9c-ba50-79559461d4b2","name":"吉豚屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0f7b9822-ad6f-4b9c-ba50-79559461d4b2/ecb5fcf4-1cba-419d-b341-a5c38dc3f29d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f84e8bfe-4988-4705-9597-4e14ce29ca6e","name":"吉野家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f84e8bfe-4988-4705-9597-4e14ce29ca6e/b00e763e-9ae9-47fe-bb82-59adbd013fe3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8fc91ba7-d438-49ad-beec-75035a60a470","name":"吸霸","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"a4288f92-60de-4b2c-8dcf-79915d73b739","name":"吸霸","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a4288f92-60de-4b2c-8dcf-79915d73b739/2573ae46-6714-4c1e-addc-8b6bfe326761.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"45596f36-93ec-4009-afe4-daeed7813e79","name":"味滿食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/45596f36-93ec-4009-afe4-daeed7813e79/35549280-a0e2-4f8d-95b1-a23d0ae4a615.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"21973f1e-7996-4630-bdc8-69b4feb56ff6","name":"和漢鐵板燒Express","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/21973f1e-7996-4630-bdc8-69b4feb56ff6/eea2cfff-f78e-4ba7-8d06-3a47d933f9de.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f227db39-6e9b-4fec-9fec-437bd94cc905","name":"和美國際","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f227db39-6e9b-4fec-9fec-437bd94cc905/38678df3-d7f4-444c-b360-29dc50971227.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"cc99dca6-6749-4a73-b5d9-44bbaf1723d2","name":"咖啡先生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc99dca6-6749-4a73-b5d9-44bbaf1723d2/4561405d-762b-4122-ab60-99b0436c5e75.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"9cf4b456-c0e9-4bc9-8d50-0f7b2ef79d4b","name":"品川蘭","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9cf4b456-c0e9-4bc9-8d50-0f7b2ef79d4b/9868ff9f-9efb-423b-a3a9-0d71f295bf60.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a54bccdc-50b7-4c55-bd1d-f7c409b10834","name":"品田牧場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a54bccdc-50b7-4c55-bd1d-f7c409b10834/57a70a67-f821-4199-8c73-3cac23d4a04c.jpeg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7bdc6bf4-a7c8-41f0-be7b-29330974bc96","name":"品赫鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7bdc6bf4-a7c8-41f0-be7b-29330974bc96/441b78db-7efa-4efd-8630-ea99a917b064.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1044f851-2ab6-49d8-be6a-66451fad1a42","name":"哈克士戶外","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1044f851-2ab6-49d8-be6a-66451fad1a42/96db3d9c-b382-4474-82ad-99423719b455.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"2999fd26-deef-47c6-8c11-b849b5026daa","name":"哈根達斯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2999fd26-deef-47c6-8c11-b849b5026daa/71159304-96a0-46dc-8fee-918fa35b07dc.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"d506cc1f-b153-43c3-911c-78008b4e5725","name":"哈肉鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d506cc1f-b153-43c3-911c-78008b4e5725/53ec318b-dd9d-4043-9057-8a655d3fea40.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"25307012-f82c-4f0f-9319-c34bc3ddd941","name":"喜粵樓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/25307012-f82c-4f0f-9319-c34bc3ddd941/898c8df2-7d6e-4fc9-9296-ccef9c36bb91.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b4078d12-a020-4b29-88fd-6ab0a6334484","name":"喫茶趣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Tea_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"58927fab-2dbd-439e-bfe8-455905c89b6d","name":"喬治派克","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/58927fab-2dbd-439e-bfe8-455905c89b6d/77463e52-b9bd-4613-96b2-18c722bf1d3f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"4804a210-6fdb-4d61-8921-8280949c1dbd","name":"喬治皮鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4804a210-6fdb-4d61-8921-8280949c1dbd/4a991e3d-2948-473d-a4f8-f24e801d3de3.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"ff371136-288e-4dce-b683-17d357b22496","name":"嘉晉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ff371136-288e-4dce-b683-17d357b22496/3ae8af93-bebf-483f-9857-27919fb3286f.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"faa6b93f-cafc-4b9a-be25-e9b7686ceb39","name":"四作良食","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/faa6b93f-cafc-4b9a-be25-e9b7686ceb39/b5a1f161-fcb4-4a75-b0b6-ecb5e552f2aa.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bba359e7-2c77-4ba8-942c-b55bd350df2b","name":"圓圓圓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bba359e7-2c77-4ba8-942c-b55bd350df2b/3e178a92-4a7d-4700-984d-a05a21361ace.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cb380a5f-3474-4088-9e9b-4aa4a0366e4e","name":"均均紅豆餅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb380a5f-3474-4088-9e9b-4aa4a0366e4e/aee22aa9-3a33-4786-8d6b-ebaffdb4858f.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e7a69103-0740-4f3c-a4c4-06af4ca0c62c","name":"均岱鍋具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7a69103-0740-4f3c-a4c4-06af4ca0c62c/d710863b-7a07-48f0-a189-190343fd5835.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"684a88c3-eea1-459b-84d5-ad20429acfdd","name":"城市家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/684a88c3-eea1-459b-84d5-ad20429acfdd/109091b2-7b37-41b3-bd68-2c129a56d2de.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"97c4e862-b502-46b1-83f4-97a7cd016c48","name":"夢工場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97c4e862-b502-46b1-83f4-97a7cd016c48/b76413ea-367c-4e44-a066-fd6b5fe1e729.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"3bf28389-2ca6-4dc3-804c-6f134f7fa84d","name":"夢想銀行","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3bf28389-2ca6-4dc3-804c-6f134f7fa84d/9a27295f-dc2e-4688-93e6-b79b1466485b.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"eafa9174-154c-4521-9b1d-61bd771cad7f","name":"夢特嬌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/montagut_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"ac14bcf4-0346-4428-9ba0-17b879eb0d26","name":"夥伴生活","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ac14bcf4-0346-4428-9ba0-17b879eb0d26/e84f204a-ebf7-4bde-a6bd-089fa6a91ff9.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"9738d572-bba4-49d8-aacd-aa7c8124b186","name":"大喜鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9738d572-bba4-49d8-aacd-aa7c8124b186/a8f81f78-5aa3-4fcc-a77b-41f24bec7e55.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"014cd87a-988d-4786-9fbd-65ec0ed28464","name":"大心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/014cd87a-988d-4786-9fbd-65ec0ed28464/89c2ade9-082b-4d07-a8ae-df431efe3c2f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"68f75d02-892f-45ae-96a3-955eebba9a85","name":"大戶屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/68f75d02-892f-45ae-96a3-955eebba9a85/72249dc8-3dd0-4ff8-b5f9-fdf103565f04.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ed450dd8-0c10-49c4-8e6d-8ef3d8baf9cc","name":"大手前鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ed450dd8-0c10-49c4-8e6d-8ef3d8baf9cc/958ec79c-2033-49d7-8025-57e746a25f9c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e3e7864f-6efb-41eb-9f82-3a6f7b4b1bf7","name":"大河屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e3e7864f-6efb-41eb-9f82-3a6f7b4b1bf7/0439d413-417f-49b3-9dd8-9d0453ee3545.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bf1de11f-1bbe-4c12-a8f4-44976431f02c","name":"大目黑山寨飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf1de11f-1bbe-4c12-a8f4-44976431f02c/89513c53-d7ee-4e08-bcb7-6c6ea11f0b6b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7ac2e6d9-cd68-4e50-b939-ce5b0f3c2a15","name":"大紅袍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7ac2e6d9-cd68-4e50-b939-ce5b0f3c2a15/b6d68d4b-8a7d-41ba-b1cb-9707e359825b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0701501d-ac69-4d62-a729-2dbef6137652","name":"大象山","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Da_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2c852077-d9aa-49e6-af55-c213240fc220","name":"大阪王將","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2c852077-d9aa-49e6-af55-c213240fc220/9c84c44a-45e7-4efa-abe5-516cd636cc12.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dd1a326d-4563-4fe7-b65c-384dd58ed734","name":"天仁茗茶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd1a326d-4563-4fe7-b65c-384dd58ed734/7a4338bf-5e5d-4988-b6da-599f5527ade9.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"ef54c7d1-c875-40bc-90e6-8ad9126b162e","name":"太和工房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/TAHE_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"5ca5782e-0956-4f73-b3fb-33a7e1a682b9","name":"太子鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5ca5782e-0956-4f73-b3fb-33a7e1a682b9/af803768-dcfc-43e0-a139-e3772028a293.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"402f0b13-5ebf-4b2d-aa8e-831cea79c148","name":"奇威名品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/KeyWear_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"74154e47-c5d7-4564-b961-fa32e523d128","name":"奧特龍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/74154e47-c5d7-4564-b961-fa32e523d128/12329bdd-6e42-46a8-8848-f979068c8aef.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"e03c4d79-e1d0-49d5-b301-850bcfe77c52","name":"奧黛莉 Audrey","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Audrey_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"66ed5472-a2ad-4196-9338-a3a63ea55da7","name":"好事晴","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/66ed5472-a2ad-4196-9338-a3a63ea55da7/980b834f-694a-407d-ad25-8390b53f50b2.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"df19b2be-f64a-4c00-a807-dfc1f2e3d3c6","name":"娜娜廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/df19b2be-f64a-4c00-a807-dfc1f2e3d3c6/5f24c432-19e0-4dec-817d-0d3fd34cf6ea.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"3ea309de-599c-46bb-892e-2053964c7715","name":"季季樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3ea309de-599c-46bb-892e-2053964c7715/e47b75c6-b2b5-4133-bb4b-7997f4b87e89.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"4aed4907-54a4-4f7c-bb15-ec9817f9697c","name":"宅技研","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4aed4907-54a4-4f7c-bb15-ec9817f9697c/e82077e7-e785-49d8-b5ab-1ec8959f838b.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"77d2ec18-8d9f-4a9d-b27a-aa0077b24657","name":"定食8","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77d2ec18-8d9f-4a9d-b27a-aa0077b24657/0724b083-8390-4110-821f-121b2847bd7f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a6bc72af-06fd-4d4a-b076-8e80b5a3eb0b","name":"宜得利家居 NITORI","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a6bc72af-06fd-4d4a-b076-8e80b5a3eb0b/ac006af6-b3a2-4ed7-92d4-b42ea2b86a1c.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"0b320730-8eac-40e6-bbd6-a4bd8760a187","name":"家飾主義","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0b320730-8eac-40e6-bbd6-a4bd8760a187/102841b0-d805-45b4-a314-d0c78aa2a048.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"8888a8e7-f43a-458a-a87c-d93ceb4b3e83","name":"富士匠鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8888a8e7-f43a-458a-a87c-d93ceb4b3e83/76d9a92b-5212-4f7e-97e7-52645f653e9a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"83095780-dcce-4ba5-88d1-7a1594274f9c","name":"富發牌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83095780-dcce-4ba5-88d1-7a1594274f9c/7f9560e4-46c6-44c6-b780-dd11793393d5.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"a99c0f56-9a3d-4c38-9b33-6dd91f4c3e9d","name":"寵物公園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a99c0f56-9a3d-4c38-9b33-6dd91f4c3e9d/5a540b0e-4756-4881-b8d2-c666ab0b50a6.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"a1204f7f-a937-46c5-8d04-4724fed73fdd","name":"小蒙牛","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a1204f7f-a937-46c5-8d04-4724fed73fdd/ef4c2253-df5c-4c4c-8682-86d5acdba551.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5368a2f4-3655-47c1-aaba-2bb8d592e09f","name":"小鐵鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5368a2f4-3655-47c1-aaba-2bb8d592e09f/99cfcc6a-feaf-45f2-b28c-7a6d092f9f7b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a49aa441-0cde-40e3-81ff-c3e4bea1c7c4","name":"小陽鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a49aa441-0cde-40e3-81ff-c3e4bea1c7c4/de524ed4-009b-4f60-b61b-209ba0010913.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"030110bd-b95b-4e86-881a-e6069868e8ab","name":"小鱷魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Crocodile_300x300.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"2d98a747-a6dd-4ac9-bc20-4e79a5e61544","name":"屈臣氏","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Watsons_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"2481f7a3-f503-419f-9bfa-ea43b24cbaf0","name":"山水婆新加坡南洋料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2481f7a3-f503-419f-9bfa-ea43b24cbaf0/5114794a-1bc9-46b9-9539-36f344f5b00c.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"bf8bcbf0-f8f9-4ddb-9a80-0949f1cedf7d","name":"山羊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf8bcbf0-f8f9-4ddb-9a80-0949f1cedf7d/c3b617d8-a092-43fd-b9b1-9ce0e3d34625.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"98cb49d6-8c1f-434d-a165-7d2e4147544b","name":"山茶園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98cb49d6-8c1f-434d-a165-7d2e4147544b/de8f49c9-2d7e-41fb-a1c2-8278fef23fb3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e53f7925-771e-44ef-b4a2-1408fa18d763","name":"山頂鳥","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/HillTop_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"7646e04f-2daf-411a-b956-785913485523","name":"岩葉拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7646e04f-2daf-411a-b956-785913485523/e0f54bba-2615-4190-bfd6-381b6401ec9a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"98c5055f-b3f5-452e-adb2-dd4b3c8502b4","name":"幸福汽車","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98c5055f-b3f5-452e-adb2-dd4b3c8502b4/895bdcb1-3425-4835-a283-5c20daaabb97.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3d3a3480-a8a5-42e0-87e2-ad19dc1f8beb","name":"幾分甜","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/howsweet_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"652573a9-b0c4-4186-8419-2db6a0b0232e","name":"府城食府","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/652573a9-b0c4-4186-8419-2db6a0b0232e/acbe1578-ddfe-438a-b3d3-3b151ef5fc4f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"857e3e77-8e05-47a8-b623-e6423ba27a70","name":"康是美","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/COSMED_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"dbf18f7e-3a7c-4392-a8d6-b20b5570840f","name":"廣生堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dbf18f7e-3a7c-4392-a8d6-b20b5570840f/f68d77fc-ddc0-4415-b3b3-01100a025125.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"136c3078-a749-4776-a92c-9f16b545fc4b","name":"彩遊館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/saiyukan_300x300.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"c7c3090a-7ac1-4ceb-9b7b-88e869a2a1da","name":"御之饌","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/lohascoffee_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2b592671-748e-413e-ae74-d177a5b82759","name":"御膳屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b592671-748e-413e-ae74-d177a5b82759/1a431e47-60fb-4dde-addf-fa923ab4d985.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b217f65c-2e57-4085-803f-7e029fc4d593","name":"御鐵板","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b217f65c-2e57-4085-803f-7e029fc4d593/25947aa8-621d-460d-9bdb-9c07f0863292.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6933d8ad-6d9f-4d72-96e3-cc30bd02f5cd","name":"御閣日本料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6933d8ad-6d9f-4d72-96e3-cc30bd02f5cd/ad90cb12-019d-40a7-b35b-43a14f0d44cb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"af2895f0-62a1-4307-bcb2-b085e01c7bef","name":"德國海豚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/af2895f0-62a1-4307-bcb2-b085e01c7bef/bdb56a76-3d83-4188-92c9-a2d4eb2e44ce.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"2139d888-0756-443b-a00c-86e522ab50cc","name":"必勝客","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/pizzahut_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"2f42a4d1-f87d-45bc-bf6d-9b2515957bb3","name":"思夢樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2f42a4d1-f87d-45bc-bf6d-9b2515957bb3/f9f08324-becf-4704-a9db-9799ae2b3dc7.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"7343e395-aae6-46e0-b809-84b7ee2b6b7a","name":"思薇爾內衣 Swear","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/swear_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"3a628197-8287-4af1-bc6c-dfa8ca026383","name":"怡客咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3a628197-8287-4af1-bc6c-dfa8ca026383/b17a5386-da44-4b9c-a263-0c30bf011a8a.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"2b429ff8-d4d6-4d8d-b922-db4a3387dcd7","name":"愛車坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2b429ff8-d4d6-4d8d-b922-db4a3387dcd7/72878787-876f-45e5-925a-8477887caaca.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"965f6bbd-8779-4c2d-b9aa-5aa1816829a6","name":"慢享日初手作茶鋪","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/965f6bbd-8779-4c2d-b9aa-5aa1816829a6/90788213-97c7-4988-942f-e1f12bc0df65.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"49550ef3-6410-42b4-8f36-d67c31a4d877","name":"戀金店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/49550ef3-6410-42b4-8f36-d67c31a4d877/5bd78cb0-f5ad-4469-8e3d-9fa1fa9a33c8.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"dece8390-462b-4c13-9de4-e1f8cccbbbfe","name":"拿坡里披薩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/napoli_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3bc8077e-8671-42ef-b9ac-9938e7e76905","name":"挑戰者汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3bc8077e-8671-42ef-b9ac-9938e7e76905/7e0a6c7d-f841-4d05-934b-3ed64a987009.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3ba987c1-d8ad-4e13-b61d-48be8726bb34","name":"捷安特","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Giant_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"01d832f3-faa5-4e1a-88ce-dd28fb6ccf5b","name":"揚龍原木家具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/YangLong_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"ed566160-61ea-4ba7-99f5-f2d96ca48ae5","name":"摩斯漢堡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mose_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"cf2441a8-2a8b-4622-9b51-2d813c74f35d","name":"摩曼頓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Momentum_300x300.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"9d181505-7832-49c3-b761-8561f2a0cb22","name":"斐樂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9d181505-7832-49c3-b761-8561f2a0cb22/a630586f-33d0-4381-bbc3-14243c69606d.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"bf075240-8835-4006-84e5-417c53c21f51","name":"斑鳩的窩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf075240-8835-4006-84e5-417c53c21f51/4ac9b5e8-f5af-4f94-af7e-aaa01facf6b1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b330062a-6fad-404c-9d34-dc2cd26e7e71","name":"方塊7","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b330062a-6fad-404c-9d34-dc2cd26e7e71/2c42ec9a-a759-4f41-b817-94fe6d4cc91c.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0fc8434d-6d9d-4acf-9f28-4f551aa41c80","name":"旅狐-鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0fc8434d-6d9d-4acf-9f28-4f551aa41c80/20903498-e30b-45a4-9c9a-009cffa2cc4e.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"d1ec40d5-5813-4704-a346-bfb37f859f7a","name":"日出茶太","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d1ec40d5-5813-4704-a346-bfb37f859f7a/9a61655e-d3c2-4652-a229-06db9b46eb0c.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"fc8965b4-0105-41aa-8aaa-973d6e2fd8fb","name":"早點名露營生活館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fc8965b4-0105-41aa-8aaa-973d6e2fd8fb/05908683-9e01-4215-9459-4afb617b1365.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"2fa32631-3f13-44b1-b6cd-a99af0ebb1b4","name":"旭媄","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2fa32631-3f13-44b1-b6cd-a99af0ebb1b4/68b8a67a-6ec2-411c-9f62-3d0592ec7da7.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"6cbd3c78-afcb-44b1-916a-e560aa263ddd","name":"昂路名鞋館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/EnRo_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"2c94f91d-1515-4520-95b8-1f7567d66a73","name":"星巴克 Starbucks","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2c94f91d-1515-4520-95b8-1f7567d66a73/7a7268af-2ec6-4d4d-bc07-161f320c53ce.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"93abf2b2-7c90-4a73-9f0b-0172bfc44283","name":"春一籠港式茶樓","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/93abf2b2-7c90-4a73-9f0b-0172bfc44283/65728e5e-61b3-41d5-8fcd-fbe90be740ba.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5c9b9cda-20c8-4887-8f40-86c2ab70c2bd","name":"時壹越河粉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c9b9cda-20c8-4887-8f40-86c2ab70c2bd/c97b0ed2-db74-43ee-9513-9c24b58a4390.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"d5d3a111-3ccd-4099-abad-452139e9e89b","name":"時懿花雕雞米飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d5d3a111-3ccd-4099-abad-452139e9e89b/d9eb37de-1eec-4bcb-a1be-d373cd5db1b7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8701beba-ee56-4ee9-b550-2d9839bd026f","name":"晶璽健康體驗館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8701beba-ee56-4ee9-b550-2d9839bd026f/a344ed3e-9729-4484-a8de-97dcc0c21036.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"29dfc416-815f-4df8-8102-711f99e570ae","name":"晶碩光學","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Pega_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"e5806c6c-6e04-4833-b533-45272b3dd556","name":"曼黛瑪璉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Mode_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"5dcf7f6b-0577-4255-a3ab-4ff07f639401","name":"月星","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5dcf7f6b-0577-4255-a3ab-4ff07f639401/ff371bdb-a3f2-46a5-a0e7-96002a74c646.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"587766ff-3301-4cda-9821-e24ac24e6576","name":"木本鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/587766ff-3301-4cda-9821-e24ac24e6576/14836542-4398-4c66-8a25-9eaea67961c7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ef80e3ac-e9e7-46dc-9ac7-956dbd817fbb","name":"朱記餡餅粥","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ef80e3ac-e9e7-46dc-9ac7-956dbd817fbb/312ec540-1970-4b17-bfa9-14ff5e5a4466.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ea3fd150-f04d-401f-ae16-d2048646ae01","name":"杏一","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ea3fd150-f04d-401f-ae16-d2048646ae01/192ed5fe-1215-44f1-bb56-a3400931003e.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"88db8ea5-2997-4e03-82ac-6f085610d7b1","name":"村子口川菜料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/88db8ea5-2997-4e03-82ac-6f085610d7b1/ed9aad15-beb4-4075-a5d3-fc0cbe584fb2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"d68dab01-4706-4a80-9fbc-7adc0f36a1c6","name":"松下健康生活工房有限公司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d68dab01-4706-4a80-9fbc-7adc0f36a1c6/0498e3c4-a6a0-40ba-99b6-c4c786bfeab0.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"bc9ec8b9-6df0-4cfa-a880-2947580febcb","name":"柏蒂家居","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc9ec8b9-6df0-4cfa-a880-2947580febcb/4c77d013-5f06-4036-a1be-0186b5df3054.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"518b2435-a08d-4dcd-9d93-bd61938e578b","name":"桂林鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/518b2435-a08d-4dcd-9d93-bd61938e578b/04e719ed-2183-414b-85bf-274c639ecf09.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"3c487df1-02ec-464d-b032-1df6e588e1b4","name":"極限健身中心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3c487df1-02ec-464d-b032-1df6e588e1b4/07cf058c-4bac-48c6-9338-bff45fd50c5f.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"b5fd6b6b-8d5d-4a2f-8e54-e23bd858fda8","name":"樂樂屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b5fd6b6b-8d5d-4a2f-8e54-e23bd858fda8/f334157f-ce08-48de-bf3d-44abb4d86c55.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"87e53455-85c3-4a31-bc2e-d83aa2733408","name":"樂法Le Phare","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/87e53455-85c3-4a31-bc2e-d83aa2733408/11fb85f7-973e-40db-8f35-6e9f8c862147.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"85e47bd7-bc1b-4298-ba9f-a3a654891479","name":"樂津津","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/85e47bd7-bc1b-4298-ba9f-a3a654891479/dca65045-5722-4f62-a289-dab2b670214e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6961819d-010a-4e71-bd25-d7801fe8ac17","name":"樹太老日式定食專賣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6961819d-010a-4e71-bd25-d7801fe8ac17/07835a7f-11bc-4e12-ac68-5a3ab4c2136b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"35caef53-80a0-43bf-a47f-c72233cbf9e2","name":"橋屋拉麵食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/35caef53-80a0-43bf-a47f-c72233cbf9e2/95f13e0b-4035-4cfb-a698-73d2e888028d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"96cfef10-b795-416b-86d6-87cd43367ffe","name":"檸檬香茅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/96cfef10-b795-416b-86d6-87cd43367ffe/2ac4337a-275a-40ce-a291-be7295f0c881.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"74cfb16e-8383-4973-ab6c-c26f59534032","name":"檸檬香草","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/74cfb16e-8383-4973-ab6c-c26f59534032/0d775b08-9d06-4e62-8705-f5ee2bf5cc99.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6588f07b-5743-4bbd-a057-d25e8fa3075c","name":"歐日洗衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6588f07b-5743-4bbd-a057-d25e8fa3075c/fc5a6462-be9d-48cf-b753-830e9ab35e6f.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"5c0c980b-ef31-4c4f-8c02-f80e4f72e8c0","name":"歐羅巴遺風","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c0c980b-ef31-4c4f-8c02-f80e4f72e8c0/bb819ecc-e345-4ccc-be34-803bb9ad386b.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"97486024-11da-4fa7-b247-23bc34bbf7a1","name":"歡樂龍","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97486024-11da-4fa7-b247-23bc34bbf7a1/49d43b71-f1d6-43a5-a2f4-b9ad7dee8dba.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"3b18d88b-99e1-4f49-8900-803a4c2c5a1c","name":"正官庄","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/image00_300x300.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"9639e4a5-27e0-4473-be13-6112164e7c03","name":"水雲堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9639e4a5-27e0-4473-be13-6112164e7c03/c0159555-a296-4c25-8210-c6c95d23a972.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"d34749fc-188e-4598-9ec6-c721de91e17f","name":"江江順來","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d34749fc-188e-4598-9ec6-c721de91e17f/f01eb572-da57-492a-b4d7-c7bc1751289e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3cc7db36-f5e5-4e22-990b-7a5eb4673718","name":"汰汰熱情食堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3cc7db36-f5e5-4e22-990b-7a5eb4673718/9e14f45f-eb41-428e-a38f-568a4b80f220.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b6f98e35-7877-43b7-8fcf-ca597ad8eac4","name":"汽車家族國際美容中心","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b6f98e35-7877-43b7-8fcf-ca597ad8eac4/bf8d2ab8-3347-4e40-b2b6-41ffefa6a9fc.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"1a2a0887-d3a4-4449-97fa-dd0cee1a83e1","name":"油蔥黑鐵牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1a2a0887-d3a4-4449-97fa-dd0cee1a83e1/f349d19e-5cba-4a90-9df9-6e0d32735278.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e5ebef7a-33c3-40e8-905f-17e0deae60a9","name":"法爵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e5ebef7a-33c3-40e8-905f-17e0deae60a9/bfecc94f-b3c0-4d6b-b418-787fa97c48e4.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"726bcbb8-3869-4331-b346-2205882eab70","name":"法迪耐名店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/fadina_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"9e4e2d3d-fa90-49b9-9a9a-16a69ba861aa","name":"洋城義大利餐廳","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9e4e2d3d-fa90-49b9-9a9a-16a69ba861aa/2ce44100-fbab-46dc-91b3-f17c337182ee.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d8abe2f-b521-42dd-b3d7-01407a5cfb47","name":"洋朵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d8abe2f-b521-42dd-b3d7-01407a5cfb47/4faa4807-dd3b-4346-9a78-55298f3db9b3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e28f574e-d4c4-40ee-9b89-c8922722da72","name":"清田拉麵","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e28f574e-d4c4-40ee-9b89-c8922722da72/08429ab6-d064-472e-b416-efc9415fae5d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1932deb9-beeb-4874-8b52-9ee7776c5f81","name":"湯姆熊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1932deb9-beeb-4874-8b52-9ee7776c5f81/672b67c9-2e98-408d-9914-e33a2fa93d6c.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"4a1cf24a-8821-465c-bd3a-ea2c4928629b","name":"滷底撈","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4a1cf24a-8821-465c-bd3a-ea2c4928629b/14ad323e-2ea1-4913-8a8c-75e33cdc636c.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"54e2094e-d4e4-4f0c-ac04-a69ffcc739ee","name":"漢堡王","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BURGER_300x300.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"5c71f0dd-3655-4c72-9cda-3974d74afa2d","name":"灶紅了","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c71f0dd-3655-4c72-9cda-3974d74afa2d/e0f12fdd-c74e-48b7-8400-44e7bf9c9da1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cb610335-7ba2-49fa-b4e6-4007a0a0989e","name":"炙 鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cb610335-7ba2-49fa-b4e6-4007a0a0989e/66ce455d-cfce-472b-85fb-decf4c18b3ad.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0a710bf7-dd22-4ebd-9383-f6c9a780822a","name":"炸鷄大獅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0a710bf7-dd22-4ebd-9383-f6c9a780822a/6d5b099f-02af-48ab-8a80-e6fab249cb47.png","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"aadc9ca5-8383-4b04-bacf-ec593f983b47","name":"点爭鮮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aadc9ca5-8383-4b04-bacf-ec593f983b47/d8bf1078-62c9-44c0-80ff-09c6cf6168fb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1dc92840-a6bb-4725-9810-362040e00769","name":"燒丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1dc92840-a6bb-4725-9810-362040e00769/e04ba34d-6233-4d12-a56d-60f65be2e85e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"cc0bdf9d-ff5c-43d0-bbea-2317ce5b11b0","name":"爭鮮迴轉壽司","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cc0bdf9d-ff5c-43d0-bbea-2317ce5b11b0/6552a462-f437-4be6-bf5e-e289f55b6a65.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4496e68e-3a0d-4f60-99ab-4e8e699cd204","name":"牛仔部落","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4496e68e-3a0d-4f60-99ab-4e8e699cd204/de525a7b-c946-42e0-946e-57e2dbdaea50.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bc85774c-a73d-4e68-82a2-a2876e22a8e9","name":"牛大大pizza牛排屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc85774c-a73d-4e68-82a2-a2876e22a8e9/b1370489-5d72-4482-a333-18575499e114.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"fbfcfd40-6c71-48ac-99c5-53381a0824af","name":"牛車水","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fbfcfd40-6c71-48ac-99c5-53381a0824af/e15789e4-489a-4d55-98e4-e9c309129971.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8a12aa66-48ab-431a-ac49-d79fca81f75d","name":"牛頭牌運動鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8a12aa66-48ab-431a-ac49-d79fca81f75d/d29020f0-4906-4643-ae70-a185e4d9035a.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"95f04aeb-afc9-422a-b712-b57029bcf5e2","name":"玉紅泰式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/95f04aeb-afc9-422a-b712-b57029bcf5e2/7b6013e4-e3c6-498f-b121-e07d34d72445.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"102f038a-355e-4ba6-b719-c66595476eb8","name":"玉豆腐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/102f038a-355e-4ba6-b719-c66595476eb8/a2172c56-824b-4571-9e64-d69f50dfec55.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"f4bf6d30-1f18-4766-9f9a-16c951fb201c","name":"玩具反斗城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/toysrus_300x300.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"824f261f-58f4-490b-a080-850edfe24dc1","name":"玩具總動員","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/824f261f-58f4-490b-a080-850edfe24dc1/1a4e2d9d-62e4-4603-a515-4f8a69f95b95.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"1a0f8ecc-dd6e-414e-b308-2446f6a80ec4","name":"瑪荷尼傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/mahogany_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"936a4fdf-e11d-424a-ba51-f305f513bfa9","name":"瓦城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/936a4fdf-e11d-424a-ba51-f305f513bfa9/0a5be116-0a01-4ba9-b494-3bfb6a63f752.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5cd5b5ed-7c68-408b-891f-eafdff395aa1","name":"甘榜馳名海南雞飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5cd5b5ed-7c68-408b-891f-eafdff395aa1/5e318c7e-4313-45f7-aca9-f254b071bb73.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"702edd74-db8a-4ae5-855b-a30d58a6bd98","name":"生活工場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/WorkingH_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"c61e9d94-0f7e-4199-8b0c-5e69faf77d82","name":"異人館","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c61e9d94-0f7e-4199-8b0c-5e69faf77d82/263fa8d8-aebd-490c-b1bb-1d9ddc64c0bd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ee8eeb11-52d5-4763-80b3-1155f26fdedd","name":"瘋佬墨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ee8eeb11-52d5-4763-80b3-1155f26fdedd/eb0e626a-6c88-4c50-b580-7186b7db17cc.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"fab088f0-04d2-4e95-8698-a10b6ad6d847","name":"百享科技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/richman_300x300.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"e2f07c09-9458-4dd8-a495-a79b28af2e41","name":"百八魚場","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e2f07c09-9458-4dd8-a495-a79b28af2e41/a80a240c-5447-452d-b1bd-20818f05ba52.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ca63c81d-3d5b-44c7-8a62-ed70900ca9d9","name":"百悅板燒料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ca63c81d-3d5b-44c7-8a62-ed70900ca9d9/0fd5ca82-da9b-42a8-9617-eaa57092e26d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"a8edc331-b2f8-4492-95b8-ef781e97d3ec","name":"皇品鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/royal_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5a5e3add-e700-4117-8e13-18dd6c5b39c4","name":"皮爾卡登","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a5e3add-e700-4117-8e13-18dd6c5b39c4/9bceab82-7589-4e73-9a14-b81498d107c7.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5a49208d-39bc-4229-897d-544764ee5c4b","name":"眼窩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5a49208d-39bc-4229-897d-544764ee5c4b/8516e579-cd4e-4082-a499-9c3e9da1cbd5.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"d958b45d-a872-4931-8de5-871ea58a6e9f","name":"睿麗傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d958b45d-a872-4931-8de5-871ea58a6e9f/a8b881a1-840d-49d5-aec3-a9ddbdbd261a.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"83d80557-681b-4beb-ad4e-c10004d6e467","name":"石二鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83d80557-681b-4beb-ad4e-c10004d6e467/b43704a8-8272-4955-947b-a9074d56cf4b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"08df16da-00c9-48f6-a10a-6dc0b00fb9bf","name":"石板屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/08df16da-00c9-48f6-a10a-6dc0b00fb9bf/79b9ec2a-8d46-460f-b09a-4a5ef83949ba.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"2a786d7c-ff83-4ded-b2a1-c4196cfe1689","name":"磨豆咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/2a786d7c-ff83-4ded-b2a1-c4196cfe1689/df515c6d-c1c7-4789-9b27-4ba077894c1f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"b177b525-5089-49ac-a04d-10ef425641c1","name":"祥富水產","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b177b525-5089-49ac-a04d-10ef425641c1/1148e560-5313-487a-972a-bab05ad5ab8d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ce07e47c-0025-457a-ac7b-eb3ae355e65f","name":"福勝亭","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ce07e47c-0025-457a-ac7b-eb3ae355e65f/a5bf4077-af04-4b49-9cd7-535f4a4734c3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9ace505f-5e25-4303-a894-196688f6fd6c","name":"禾樂鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9ace505f-5e25-4303-a894-196688f6fd6c/ea0bbc37-b97e-4ed0-9bb2-279c6eb80f3f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7d407022-0837-4d44-b19f-5225b9ac68ad","name":"禾豐鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7d407022-0837-4d44-b19f-5225b9ac68ad/4c8ac47a-8abd-4f05-a7d4-8243276302f2.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7d7e8db5-2781-436b-a38a-f4cce91df4ec","name":"禾野鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7d7e8db5-2781-436b-a38a-f4cce91df4ec/05f67d4c-71ac-4b00-aaa7-7c939d786fcf.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b12dd63-688d-4387-bc99-96ca0d36cbe3","name":"秀泰影城","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b12dd63-688d-4387-bc99-96ca0d36cbe3/60f3e8e7-e7ae-4162-817b-86926bb1d4c6.jpg","cat":"1e041327-e707-495c-912a-4c939f6e8520"},{"id":"a600b803-a760-4d96-a20c-bda215a23a61","name":"私房小廚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/instant_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3e7fe1f5-025b-4d76-b556-78eb837e36ce","name":"私房小廚店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3e7fe1f5-025b-4d76-b556-78eb837e36ce/caceb09a-a3a8-4351-8e1a-b26b1a5787d1.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"18a13750-7d8a-4d78-8d1f-f34f5a7ccb76","name":"米塔義式廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/18a13750-7d8a-4d78-8d1f-f34f5a7ccb76/d05ba7ed-3984-4e42-8587-f1e6f562f5af.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"956ec994-8fc4-4c39-8d10-ed108fe85e94","name":"米塔黑糖飲品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/956ec994-8fc4-4c39-8d10-ed108fe85e94/8e37a170-ca93-40c1-a6ae-412699b97120.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"e84a04e3-8215-46e0-8d8b-5cdbefe4358b","name":"紅玉滿赤心雞蛋糕","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e84a04e3-8215-46e0-8d8b-5cdbefe4358b/673b07ee-a053-4137-b8c7-3b9af72188f3.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"83f60353-411f-444b-895a-1bbd073838d8","name":"紐西蘭牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/83f60353-411f-444b-895a-1bbd073838d8/7fbaf93e-aa6a-4337-8be6-8768007155fd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"00c729ee-6aa5-4dd6-a7e7-9422397e704e","name":"羅蘭索傢俱","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/lorenzo_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"66ff8428-90ad-44e2-a064-48a6dc2ebc93","name":"美威鮭魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/66ff8428-90ad-44e2-a064-48a6dc2ebc93/ac69e57a-078d-4193-95ec-245eb87a2dd8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0ca78690-f93a-440f-aed1-03a0c1289b9a","name":"美珍香","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/BEE_300x300.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"b78bb013-a9de-4818-a95d-68224e1bb907","name":"美蒂亞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b78bb013-a9de-4818-a95d-68224e1bb907/d7634648-4780-44b1-9cc4-dc73e0860725.jpg","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"75217a21-1cb8-4468-a17b-03dcaa5482e9","name":"美麗華高級汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/75217a21-1cb8-4468-a17b-03dcaa5482e9/1532b37b-9f63-4b38-b034-91fd04fb4d63.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"3fef6ce5-0a0a-4812-ad65-e81987f9f654","name":"羽衣精緻專業服務","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3fef6ce5-0a0a-4812-ad65-e81987f9f654/b19f3d27-2894-41a2-9fa1-0be1fb6e5a07.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"d7bb5da9-c3c2-458d-99d5-f765821b98c4","name":"翊新","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d7bb5da9-c3c2-458d-99d5-f765821b98c4/a5268e25-78a2-46a4-b4d2-ce912fce51b1.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"4142d10b-6f78-4745-be5f-c58988be7d28","name":"老船長","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4142d10b-6f78-4745-be5f-c58988be7d28/57228bca-060c-45cf-9b56-5e01906a1d3e.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"f2a914e7-3618-4ac4-98ab-fc6fc055870c","name":"老蔡水煎包","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f2a914e7-3618-4ac4-98ab-fc6fc055870c/aedc7ad2-d09b-44a0-a8a8-02b037ca6a47.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"79b74f42-a56b-4afd-978a-8057d9735463","name":"老饕牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/79b74f42-a56b-4afd-978a-8057d9735463/e4bd4b2d-8aac-4185-bf35-5004eb906c76.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"c7fbcb7c-9b57-47cf-8946-1205a73e42b3","name":"聊聊鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c7fbcb7c-9b57-47cf-8946-1205a73e42b3/0d2d1797-e236-4f6a-9e06-c07cdddaddc1.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8936096b-76ce-4b96-b214-da318d704b8b","name":"聖地亞精品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/sandia_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"daf28770-f0f3-40a6-87e0-7197af5c2eac","name":"聖荃童鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/daf28770-f0f3-40a6-87e0-7197af5c2eac/62176237-ecf4-4f5d-aec2-33e262057859.jpg","cat":"20b4ba22-57ac-45ab-a18a-0695f5464ebc"},{"id":"8c7e580b-54b9-4f00-a89d-997e6ed05b13","name":"聚-北海道昆布鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Gi_hot_pot.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"0776fc46-e260-4d5f-b110-f1beecf135f1","name":"肯德基","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0776fc46-e260-4d5f-b110-f1beecf135f1/43e3aaae-1903-4b08-8eb0-691fc0f4885a.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"d6d59e18-c728-45a9-a7d1-9b87d301cd79","name":"胡桃鉗生活傢飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d6d59e18-c728-45a9-a7d1-9b87d301cd79/6a5b63fe-730e-4486-a853-648c2fe96250.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1075e811-264b-45f6-8805-d982fdf099dd","name":"花月嵐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1075e811-264b-45f6-8805-d982fdf099dd/cfb91fc5-22d6-46d0-943b-a02610751090.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8cf4b69d-c032-44d8-976a-b25015782290","name":"花蓮扁食","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8cf4b69d-c032-44d8-976a-b25015782290/a547df52-8dcf-4f6e-92ca-57382b9aabde.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d57c195-9ddd-4bd9-93b4-d5b365ef5f18","name":"茶自點","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d57c195-9ddd-4bd9-93b4-d5b365ef5f18/c876db9f-b0ae-40a2-a227-c11a60c719cc.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"0816f19c-25f5-4136-8b8a-b64ff63725ce","name":"茶與波記","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/0816f19c-25f5-4136-8b8a-b64ff63725ce/fdf3a008-d9e0-4521-9415-746ac9909f03.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"52b71b16-d74e-4365-afd0-ba6ef60e9786","name":"菈菈派","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/52b71b16-d74e-4365-afd0-ba6ef60e9786/2b5fd611-d650-49d6-bc98-1a1e493a590f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e9f04fe3-16d9-4e61-b09c-b00cc4494ee5","name":"華歌爾內衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Wacoal_300x300.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"3b3f07b9-2740-48a1-9d2e-9542f8fc12c2","name":"菲凡創意剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3b3f07b9-2740-48a1-9d2e-9542f8fc12c2/310eced8-6088-48c7-a11b-9990e031b046.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"85f06a87-cbcf-40b1-bfb8-c02f18c07e15","name":"萬國通路","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/eminent_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"5ae415bc-f2c7-4a8e-b944-729389ab6f6c","name":"葛洛麗雅","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/gloria-logo_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"907755fb-edbd-4f63-9233-d270fe61d312","name":"葳達","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/907755fb-edbd-4f63-9233-d270fe61d312/ae97bbb1-8629-4142-a9d2-ec9edbd69d06.png","cat":"dc5932e8-f556-4c2d-9df2-c47fb6f352f9"},{"id":"f7ad7136-8b49-4c85-b4d0-84cdf2eb09b9","name":"蕾絲妮傢飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f7ad7136-8b49-4c85-b4d0-84cdf2eb09b9/7fdac87f-8108-4731-95d3-b36beb4aaa31.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"cf68a166-93c4-420c-afe7-652884ccc7e4","name":"薔薇派","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/cf68a166-93c4-420c-afe7-652884ccc7e4/a75f769b-405a-4fac-87f9-c4c097bd6dde.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"5d70e0e6-7e34-4b58-9309-aafdecbd1d61","name":"薩莉亞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5d70e0e6-7e34-4b58-9309-aafdecbd1d61/72516c0c-33de-46e2-9e9a-eb09e3e74f61.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6d1e7b0e-402b-42fa-98c3-7faad0efbff8","name":"虎爸廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6d1e7b0e-402b-42fa-98c3-7faad0efbff8/82d5a2bd-cc20-4ced-b995-2e684e3ee637.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"c487ac36-3637-4a27-9b1d-de650df60de5","name":"衣匠服飾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c487ac36-3637-4a27-9b1d-de650df60de5/f039bcff-8e9f-4b38-8284-3ea8222d7fdc.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"3d421283-1fae-4843-973d-4009b7211eab","name":"衣貝潔洗衣店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3d421283-1fae-4843-973d-4009b7211eab/bba5b430-3b39-46f1-a98d-a1fe045fb6d1.jpg","cat":"0768fbbf-4025-48d0-a4cc-b66235f79294"},{"id":"e3871517-09cb-4342-a059-078ef4d43ded","name":"裊裊鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e3871517-09cb-4342-a059-078ef4d43ded/c4988fb0-c28b-4135-9197-2c3dc2f739c7.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"3aef8279-63e3-48ea-bd7d-ef2754d3a875","name":"西堤牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/3aef8279-63e3-48ea-bd7d-ef2754d3a875/c0811f5a-428a-4203-b94e-96f483e900b0.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1ebc78b3-8cbc-4ede-bf64-75a79b23af43","name":"角子虎","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1ebc78b3-8cbc-4ede-bf64-75a79b23af43/5cf80651-0619-49b2-aa52-fdb909b09e25.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e10a8e62-d73a-4496-b97b-41fd2eb63145","name":"許留山","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e10a8e62-d73a-4496-b97b-41fd2eb63145/edeb3912-e9c3-426a-b5d7-067cc3a2f5d9.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"f22c504f-a4bd-4303-b224-beecd406f3e5","name":"請坐專業快速剪髮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f22c504f-a4bd-4303-b224-beecd406f3e5/2ed1c458-e4bb-476e-bbab-021f25bafd57.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"7740c753-823d-4cdb-8592-2e13ce5269cf","name":"豆咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7740c753-823d-4cdb-8592-2e13ce5269cf/daae6993-fdc1-465e-b15e-59ddb8a0102f.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"6ab341a2-55ed-4f3e-a267-068421a132f7","name":"貝兒絲樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6ab341a2-55ed-4f3e-a267-068421a132f7/b0335bb6-e881-4709-b261-214cd91a71a3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7a2dd721-65ba-430e-8a3a-23b3fd7dfb16","name":"貝妮嘉露","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7a2dd721-65ba-430e-8a3a-23b3fd7dfb16/1fe013aa-3744-4c9c-af98-6eb2823d6dca.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"52c233b3-f4ca-49da-9172-1296c8873521","name":"貢湯宴水產超市火鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/52c233b3-f4ca-49da-9172-1296c8873521/16cd06f4-9f5e-444b-accc-15b65706e70f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"8791adb1-88c3-4b2e-888d-594e49198d55","name":"貴妃廚具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8791adb1-88c3-4b2e-888d-594e49198d55/19de3d2f-2399-466c-bf01-7e0f70121ee1.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"8b0e91aa-5c47-4211-b553-d54f7bca0b56","name":"資生堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/shiseido_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"1444b8e8-c6f9-410f-8acb-b1eac26d53dc","name":"足適姿","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1444b8e8-c6f9-410f-8acb-b1eac26d53dc/a0e5f71b-3ae6-4c00-8246-af11b66bd265.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"419cff9a-5ba0-42a8-8cc9-eff1f9eb6a50","name":"路豹 Zobr","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/zobr_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"dc7c8aa5-5e1e-4ce5-a54e-0691dd18c9f1","name":"車之坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dc7c8aa5-5e1e-4ce5-a54e-0691dd18c9f1/61c36cd1-309b-4aea-9faa-3cfe18500a3d.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"11701c86-90a7-4241-ab01-579792858974","name":"車美樂汽車美容","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/11701c86-90a7-4241-ab01-579792858974/f7a28988-7108-4efb-87ba-969445b0d558.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"6a8ca671-9939-40e9-98ed-f45fec799694","name":"車藝鉉","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6a8ca671-9939-40e9-98ed-f45fec799694/8c7b1392-c600-4ace-8b0f-fe2d92f83143.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"7c34b00d-4033-49d8-aa5e-70f3ffc28401","name":"車鉅星","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7c34b00d-4033-49d8-aa5e-70f3ffc28401/1d81d567-f289-4b40-b53b-a09631c86cf4.jpg","cat":"bc2a4b33-a190-41d1-9a8a-4ad33bc0e409"},{"id":"4d9a9c4f-5dec-40f1-a409-dd1bf63cf3e6","name":"車麗屋汽車百貨","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d9a9c4f-5dec-40f1-a409-dd1bf63cf3e6/29d298de-ba09-4136-b444-a3d7a135333d.jpg","cat":"2503474f-8cd4-45cd-b91e-2d6e570f97eb"},{"id":"546b1510-90fd-46d1-a0e8-bd6cebac5a6a","name":"迪卡儂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/546b1510-90fd-46d1-a0e8-bd6cebac5a6a/a6901c36-2dd0-4f55-9541-fbd7589dccfe.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"035b252a-90f1-4214-ab99-bdf47cd062a3","name":"逗點咖啡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/035b252a-90f1-4214-ab99-bdf47cd062a3/77f95877-c8ff-4bf5-a1d1-962aa2a0d1d7.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"f3dbb797-7208-4062-aa82-1bf0c884991c","name":"這味泰泰","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f3dbb797-7208-4062-aa82-1bf0c884991c/f7929570-5c0f-4baf-a70f-1efac5fcbd98.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"ac19886a-50ec-45e1-a42a-59f271ff71d1","name":"遊戲愛樂園","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/ac19886a-50ec-45e1-a42a-59f271ff71d1/eedafaa3-ae69-41c6-a943-f8c84a860905.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"8b04c58f-bd54-4ec9-ae96-3e60c20fb651","name":"達芙妮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/DFN_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"7e2f094d-b6c7-48e6-92dc-c8d2fb7c4e64","name":"邦德蕾斯（蘿舒漫）","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/loosemag_300x300.jpg","cat":"4ff7a649-057d-451d-8bd1-7619750bf7cc"},{"id":"9241d77b-ea98-4772-a5c4-64668be93e29","name":"酷克牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9241d77b-ea98-4772-a5c4-64668be93e29/85ccc8df-4756-46e6-882b-83b6794f2e4e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"089cd74c-cb14-4c03-bb2e-9989debcad27","name":"酷聖石","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cold_stone_300x300.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"c54ae1a0-6544-4488-a5c5-059902d29bc4","name":"醇蛋糕","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/c54ae1a0-6544-4488-a5c5-059902d29bc4/3617cdeb-c714-4f38-a7f0-566fcd26938c.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"e04679e1-ba05-43cc-bd6c-295bb85e125d","name":"野宴二代王漾店","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e04679e1-ba05-43cc-bd6c-295bb85e125d/cc5ee7da-8c1d-48ed-83e6-0a39f5c1774b.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"d90ddf31-0659-4c5c-b771-e6bf7517dd7a","name":"金大鋤壽喜燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d90ddf31-0659-4c5c-b771-e6bf7517dd7a/42b39d56-7be4-4f91-b57d-b8a54f9d4f01.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5c41e371-a678-4b87-afcd-09dac7305600","name":"金安德森","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5c41e371-a678-4b87-afcd-09dac7305600/2a1801aa-ab37-438b-90da-2c639acd1580.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"537337af-117e-4f06-b99f-70575d98b4f8","name":"金安德森皮件","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/537337af-117e-4f06-b99f-70575d98b4f8/3965bd58-86a0-4faa-93e8-05ba6da5b63f.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"b6171f9f-e0c8-47e3-86a2-b63275580a31","name":"金宏鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/b6171f9f-e0c8-47e3-86a2-b63275580a31/360b489b-e3aa-4fde-aca6-9456f8975efb.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"9f1cc218-9f8c-4c37-aa07-bfdff6bd3e46","name":"金宗家韓式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9f1cc218-9f8c-4c37-aa07-bfdff6bd3e46/25ba1d30-765e-4e22-95c7-2b55837bfab8.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"579df2af-d724-49b7-b69b-3694ca8e8477","name":"金石堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Kingstone_300x300.jpg","cat":"0630e6fa-a5df-468b-bb9e-047669677603"},{"id":"311fcde0-ab49-40e4-9cd5-76b51b04657b","name":"金緻品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/justin_300x300.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"bab8a6b0-58da-4e23-a467-3dd43fc37bfc","name":"金豆腐","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bab8a6b0-58da-4e23-a467-3dd43fc37bfc/79dac46c-1f21-4839-9a01-c126838970c6.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"6adeb867-f8ce-4983-b7bd-872fb638cdac","name":"金首爾韓國料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/6adeb867-f8ce-4983-b7bd-872fb638cdac/b6a1c5f2-ee40-49ce-8f45-a23d32737114.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"77399192-6826-443e-be83-b3a49aea4fba","name":"銀座日式杏子豬排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77399192-6826-443e-be83-b3a49aea4fba/5b84c7fb-41ba-49fb-8c9b-22b64361388c.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"c2e02210-12b1-414f-b918-e92a68ad2b4b","name":"銀盾","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/Vital_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"a721344c-f3c6-49b4-8497-1519b51fb11f","name":"鍋裡鍋物","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a721344c-f3c6-49b4-8497-1519b51fb11f/d4f402be-1b1a-4082-bdae-c0dac8963a3a.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7a6f0886-a1e1-4fdb-991d-1c085d54ad67","name":"鍾愛一生","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/cherishdesign_300x300.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"1651382b-cf88-4f17-bbf8-0cd52db43033","name":"長壽石鍋拌飯","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1651382b-cf88-4f17-bbf8-0cd52db43033/d3e6a5a4-c1b2-4e02-955a-ad04538d943f.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"1c37d3da-83fc-4b00-b9d9-5f31724f2b8c","name":"長庚生技","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/1c37d3da-83fc-4b00-b9d9-5f31724f2b8c/8d61b04e-117e-4f77-86d7-133c0d323b52.jpg","cat":"81f730d5-239f-451b-947f-ff9996bf339c"},{"id":"bf5c5249-c206-4dad-bd7e-f7ecf2cebe42","name":"開心牛排","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bf5c5249-c206-4dad-bd7e-f7ecf2cebe42/b41b0749-3115-4533-8d69-e0a412fcc06c.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"97de8a85-1ac0-4bcc-918a-9b60711722f0","name":"開心魔法屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/97de8a85-1ac0-4bcc-918a-9b60711722f0/f13cc5c9-7e69-4922-8af3-58db9e2894eb.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"88877a18-dad9-4843-bc23-2a4138e26b77","name":"阿瘦皮鞋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/aso_300x300.jpg","cat":"9e0347bb-655d-4106-abab-e60e588eee4d"},{"id":"98710a1d-f5bc-4ecd-8633-6b293f69e60a","name":"陶板屋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98710a1d-f5bc-4ecd-8633-6b293f69e60a/9774be1a-19ba-40b9-9c22-f33b1f726fc3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4d387614-7a9a-4f99-aa2f-85e81e0c039a","name":"陸家班","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4d387614-7a9a-4f99-aa2f-85e81e0c039a/007271de-9e1e-41fe-99f3-f77d765df7cf.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"8d560b0c-5c77-435d-be20-cc817df20063","name":"雷根運動用品","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/8d560b0c-5c77-435d-be20-cc817df20063/2e4e475b-2a1e-4308-a331-1713508e2335.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"f403c3fe-3d81-4bf5-9129-20cf7a75b1cc","name":"靈光眼鏡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/f403c3fe-3d81-4bf5-9129-20cf7a75b1cc/7dd076f8-80a4-434f-aab7-258a94113ede.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"77d4b69e-1e29-432e-a778-afdf53ee5560","name":"非卡","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/77d4b69e-1e29-432e-a778-afdf53ee5560/59f00547-354c-4911-b004-fee0636bebc3.jpg","cat":"43b226c1-f691-46b9-918d-f7e8d5e0eb19"},{"id":"76491617-4538-443c-8e5f-6ce864d3d59f","name":"非常量販","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/very_300x300.jpg","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"5f5d130e-95c1-49b5-85f6-b6aaaa956993","name":"非越即泰","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5f5d130e-95c1-49b5-85f6-b6aaaa956993/5732b0c6-b899-4f21-a9fe-41ba753df0c0.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"adb080be-c3e3-4580-8bf0-ef44b63e3d53","name":"韓姜熙的小廚房","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/adb080be-c3e3-4580-8bf0-ef44b63e3d53/c26b3789-6cca-4c3f-8e88-3fd5b1e72646.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"96c3dca7-c914-435c-be94-2b090b7fbd8e","name":"韓州","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/96c3dca7-c914-435c-be94-2b090b7fbd8e/166e42c7-6dec-4687-b319-c1d2a268db60.png","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"50ca7868-7736-4940-b848-1dd87c3b199d","name":"韓本家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/50ca7868-7736-4940-b848-1dd87c3b199d/8291c27a-bb0a-4d90-959a-c964ae5e67d2.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"9f3dab01-2d15-4808-b57b-6d39bc8b93a9","name":"韓牛村","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9f3dab01-2d15-4808-b57b-6d39bc8b93a9/4669a508-c26f-4cd5-8303-b4042af8dd8a.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"29a66805-27d6-45f7-aba0-b0f84dacd02e","name":"韓金饌韓式料理","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/29a66805-27d6-45f7-aba0-b0f84dacd02e/80e4be87-2ba3-489c-bb9a-f4003840509d.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"7fe7c349-6e48-4263-8664-974669e483d4","name":"順發","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7fe7c349-6e48-4263-8664-974669e483d4/d738503a-8b4a-4519-8316-6f36926c1c4b.jpg","cat":"00fb7c8d-e18f-4615-b6dd-5ced270d9219"},{"id":"e7ce0b9b-5688-44f0-b6ab-e9a1156a2307","name":"風和家現烤烘焙","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e7ce0b9b-5688-44f0-b6ab-e9a1156a2307/3c649c9e-eb20-4873-887b-d186bdcb05b6.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"55cda70a-b7e8-428d-bd82-fd68bb73e6aa","name":"飛寶","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/55cda70a-b7e8-428d-bd82-fd68bb73e6aa/ffbdc889-cfb8-4c79-acba-8df0f8f9e947.jpg","cat":"360f4e91-51c3-4dcb-ac8d-3129d3a66739"},{"id":"fdd65a63-b447-4f2a-be29-17a47582cf80","name":"香草工坊","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/fdd65a63-b447-4f2a-be29-17a47582cf80/50164e72-b924-4e9f-9207-ac25ab54f96e.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"bfea58cd-29d5-4aac-a404-3ff8071d5a0a","name":"馫鱻鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bfea58cd-29d5-4aac-a404-3ff8071d5a0a/c0a9da3d-711e-40d8-b2c6-2265b261f460.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"75903fb7-4711-4e81-b9eb-a073e75f71ad","name":"馬祖新村","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/75903fb7-4711-4e81-b9eb-a073e75f71ad/8ca17856-7a8b-4b5e-95a8-8c7a9e0a1141.jpg","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"e9ea1c5a-0d6b-445f-ac77-12831651bf5f","name":"高島","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e9ea1c5a-0d6b-445f-ac77-12831651bf5f/b34fb688-d860-4caf-ac44-5b05179a8b35.jpg","cat":"979079bd-a456-43d7-8eeb-1a23cdb71351"},{"id":"d01f1b24-ce4e-407e-aae5-63ff57b874f9","name":"鬍鬚張","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/d01f1b24-ce4e-407e-aae5-63ff57b874f9/94e159c9-4d4a-43dd-af78-ea1e52399ad3.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"dd9b3b80-3d71-43e5-81a1-ec13bc3a3965","name":"鬼椒一番鍋","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/dd9b3b80-3d71-43e5-81a1-ec13bc3a3965/4254f92f-b406-48ee-b5de-ff19e3049967.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e248f947-570c-4c63-92ca-3add32484c1c","name":"魔法咖哩","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e248f947-570c-4c63-92ca-3add32484c1c/61e73b61-d4c8-46bc-8229-d3d6727db6fd.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"aacafd3c-9e81-4fa9-9a7e-af5b999ae1e2","name":"鮮五丼","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/aacafd3c-9e81-4fa9-9a7e-af5b999ae1e2/354e5863-71b1-45c9-8753-ee6c3b8ce2b6.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e008a8d8-05e3-438f-87f6-997344793d66","name":"鮮茶道","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e008a8d8-05e3-438f-87f6-997344793d66/905f6355-c664-48ac-8230-cd21d0885e15.png","cat":"9da69dbd-e5a4-4858-88ea-3523c5eb3023"},{"id":"9e250a2d-dd91-4a93-b87f-0ff126ecda05","name":"鯊魚","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9e250a2d-dd91-4a93-b87f-0ff126ecda05/b9aa3e2a-d89b-4b68-9ff7-37d948bdebb7.png","cat":"34359910-1c24-4d41-a888-cc4a479750ed"},{"id":"9c2137b7-d973-4c97-a0a8-a7474b45853f","name":"鯣口鮮","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/9c2137b7-d973-4c97-a0a8-a7474b45853f/17ac10fd-2da7-4794-917d-bae3e31edd28.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"da7a78dd-c7d3-4757-97b2-b8153e95f30b","name":"麗兒采家","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/da7a78dd-c7d3-4757-97b2-b8153e95f30b/91ca9fad-31f4-430e-a40c-3196f2cc22af.jpg","cat":"b6f55d05-6ff5-4c42-a3b3-c3553d301aa6"},{"id":"33259a42-e295-4663-b964-5d81d2c8ca4b","name":"麗嬰國際","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/FunBox_300x300.jpg","cat":"692e94cb-031f-4e9e-88bf-2c28915ed9cd"},{"id":"b366defc-fee9-4d13-bdc2-e331e48fd028","name":"麥當勞","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/McDonalds.jpg","cat":"cb3e9260-4f23-487f-b4c7-a422c220435e"},{"id":"98516093-278b-4da2-8f6d-7a3edd1dd1c0","name":"麥當勞點心吧","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/98516093-278b-4da2-8f6d-7a3edd1dd1c0/be9d3399-b134-409d-92b2-af4a3562fd72.jpg","cat":"1f763252-0594-45b0-85b6-1145efac27b6"},{"id":"bc2cc438-53f9-4d9f-909e-f2f3675e49af","name":"麥皇后寢具","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bc2cc438-53f9-4d9f-909e-f2f3675e49af/2cd6a7de-cc4f-425d-b031-23f8f8c4c6b2.jpg","cat":"fc1f7059-8065-4358-988c-e3d75cdb0b80"},{"id":"7195efb9-7ae6-4542-81c0-2a3ea31da53b","name":"麵屋虎徹-朱雀","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/7195efb9-7ae6-4542-81c0-2a3ea31da53b/f8111692-ec45-4a18-b5ef-3554cde77652.jpg","cat":"bb2b9a84-8eb6-48da-bc1c-979b0d98fd9f"},{"id":"bb212930-d568-44a4-8aa5-31a93b5b5ba3","name":"麻佬大","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/bb212930-d568-44a4-8aa5-31a93b5b5ba3/2b17d1c7-153f-4d03-b38a-b142be51ca33.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"5cfd7f83-3059-4405-909a-e61d9d4d5b42","name":"麻膳堂","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/5cfd7f83-3059-4405-909a-e61d9d4d5b42/57f3b36c-34d1-45b4-8d05-828e53128001.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"e224d996-00a3-4d95-8a24-b95286ccce65","name":"黃子庚天珠、玉器","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/default/HUANG_300x300.jpg","cat":"e4b68fde-1b5e-4fe6-95e7-f61768eefbaf"},{"id":"898aae6e-681a-4ff3-bf31-3f88806436f0","name":"黎陽","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/898aae6e-681a-4ff3-bf31-3f88806436f0/dddbc27e-e8af-4b93-92fe-1c61437bac12.jpg","cat":"21c2901d-e362-4020-9d6d-69b2a158c055"},{"id":"e4ce7863-4100-4ae4-a10a-bf7d9f4103bc","name":"黛安芬泳衣","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/e4ce7863-4100-4ae4-a10a-bf7d9f4103bc/46dd9a88-013e-40b8-9dfc-0b2f2a1b1ab2.jpg","cat":"2ff5fc5a-32ec-44a9-958c-68835d679e86"},{"id":"a8ff7b71-b3ac-44a6-b938-d4cd0a4dc7e4","name":"點心道","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/a8ff7b71-b3ac-44a6-b938-d4cd0a4dc7e4/e27f3f97-f1ad-4cf1-b820-1b1bc6eca0c4.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"},{"id":"4b768865-181d-4010-b991-46fb02338ede","name":"鼎晶鐵板燒","image":"https://www.uni-prosperity.com.tw/wp-content/uploads/2021/merge/ceccontext/storemall/4b768865-181d-4010-b991-46fb02338ede/9063898b-089e-4464-8f8f-618859115c83.jpg","cat":"39668741-4a18-436e-ae80-f132f84d4055"}]

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redo = exports.undo = exports.handleKeyCommand = exports.clear = exports.setMediaPosition = exports.removeMedia = exports.setMediaData = exports.insertMedias = exports.insertHorizontalLine = exports.insertAtomicBlock = exports.insertHTML = exports.insertText = exports.toggleSelectionLetterSpacing = exports.toggleSelectionFontFamily = exports.toggleSelectionLineHeight = exports.toggleSelectionFontSize = exports.toggleSelectionBackgroundColor = exports.toggleSelectionColor = exports.decreaseSelectionIndent = exports.increaseSelectionIndent = exports.toggleSelectionIndent = exports.toggleSelectionAlignment = exports.removeSelectionInlineStyles = exports.toggleSelectionInlineStyle = exports.selectionHasInlineStyle = exports.getSelectionInlineStyle = exports.toggleSelectionLink = exports.toggleSelectionEntity = exports.getSelectionEntityData = exports.getSelectionEntityType = exports.toggleSelectionBlockType = exports.getSelectionText = exports.getSelectionBlockType = exports.getSelectionBlockData = exports.setSelectionBlockData = exports.getSelectedBlocks = exports.updateEachCharacterOfSelection = exports.getSelectionBlock = exports.removeBlock = exports.selectNextBlock = exports.selectBlock = exports.selectionContainsStrictBlock = exports.selectionContainsBlockType = exports.isSelectionCollapsed = exports.createEditorState = exports.createEmptyEditorState = exports.isEditorState = exports.registerStrictBlockType = undefined;

var _draftJs = __webpack_require__(195);

var _draftjsUtils = __webpack_require__(835);

var _braftConvert = __webpack_require__(836);

var _immutable = __webpack_require__(32);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var strictBlockTypes = ['atomic'];

var registerStrictBlockType = exports.registerStrictBlockType = function registerStrictBlockType(blockType) {
  strictBlockTypes.indexOf(blockType) === -1 && strictBlockTypes.push(blockType);
};

var isEditorState = exports.isEditorState = function isEditorState(editorState) {
  return editorState instanceof _draftJs.EditorState;
};

var createEmptyEditorState = exports.createEmptyEditorState = function createEmptyEditorState(editorDecorators) {
  return _draftJs.EditorState.createEmpty(editorDecorators);
};

var createEditorState = exports.createEditorState = function createEditorState(contentState, editorDecorators) {
  return _draftJs.EditorState.createWithContent(contentState, editorDecorators);
};

var isSelectionCollapsed = exports.isSelectionCollapsed = function isSelectionCollapsed(editorState) {
  return editorState.getSelection().isCollapsed();
};

var selectionContainsBlockType = exports.selectionContainsBlockType = function selectionContainsBlockType(editorState, blockType) {
  return getSelectedBlocks(editorState).find(function (block) {
    return block.getType() === blockType;
  });
};

var selectionContainsStrictBlock = exports.selectionContainsStrictBlock = function selectionContainsStrictBlock(editorState) {
  return getSelectedBlocks(editorState).find(function (block) {
    return ~strictBlockTypes.indexOf(block.getType());
  });
};

var selectBlock = exports.selectBlock = function selectBlock(editorState, block) {

  var blockKey = block.getKey();

  return _draftJs.EditorState.forceSelection(editorState, new _draftJs.SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: block.getLength()
  }));
};

var selectNextBlock = exports.selectNextBlock = function selectNextBlock(editorState, block) {
  var nextBlock = editorState.getCurrentContent().getBlockAfter(block.getKey());
  return nextBlock ? selectBlock(editorState, nextBlock) : editorState;
};

var removeBlock = exports.removeBlock = function removeBlock(editorState, block) {
  var lastSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


  var nextContentState = void 0,
      nextEditorState = void 0;
  var blockKey = block.getKey();

  nextContentState = _draftJs.Modifier.removeRange(editorState.getCurrentContent(), new _draftJs.SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: block.getLength()
  }), 'backward');

  nextContentState = _draftJs.Modifier.setBlockType(nextContentState, nextContentState.getSelectionAfter(), 'unstyled');
  nextEditorState = _draftJs.EditorState.push(editorState, nextContentState, 'remove-range');
  return _draftJs.EditorState.forceSelection(nextEditorState, lastSelection || nextContentState.getSelectionAfter());
};

var getSelectionBlock = exports.getSelectionBlock = function getSelectionBlock(editorState) {
  return editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getAnchorKey());
};

var updateEachCharacterOfSelection = exports.updateEachCharacterOfSelection = function updateEachCharacterOfSelection(editorState, callback) {

  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var contentBlocks = contentState.getBlockMap();
  var selectedBlocks = getSelectedBlocks(editorState);

  if (selectedBlocks.length === 0) {
    return editorState;
  }

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var nextContentBlocks = contentBlocks.map(function (block) {

    if (selectedBlocks.indexOf(block) === -1) {
      return block;
    }

    var blockKey = block.getKey();
    var charactersList = block.getCharacterList();
    var nextCharactersList = null;

    if (blockKey === startKey && blockKey === endKey) {
      nextCharactersList = charactersList.map(function (character, index) {
        if (index >= startOffset && index < endOffset) {
          return callback(character);
        }
        return character;
      });
    } else if (blockKey === startKey) {
      nextCharactersList = charactersList.map(function (character, index) {
        if (index >= startOffset) {
          return callback(character);
        }
        return character;
      });
    } else if (blockKey === endKey) {
      nextCharactersList = charactersList.map(function (character, index) {
        if (index < endOffset) {
          return callback(character);
        }
        return character;
      });
    } else {
      nextCharactersList = charactersList.map(function (character) {
        return callback(character);
      });
    }

    return block.merge({
      'characterList': nextCharactersList
    });
  });

  return _draftJs.EditorState.push(editorState, contentState.merge({
    blockMap: nextContentBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  }), 'update-selection-character-list');
};

var getSelectedBlocks = exports.getSelectedBlocks = function getSelectedBlocks(editorState) {

  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();

  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var isSameBlock = startKey === endKey;
  var startingBlock = contentState.getBlockForKey(startKey);
  var selectedBlocks = [startingBlock];

  if (!isSameBlock) {
    var blockKey = startKey;

    while (blockKey !== endKey) {
      var nextBlock = contentState.getBlockAfter(blockKey);
      selectedBlocks.push(nextBlock);
      blockKey = nextBlock.getKey();
    }
  }

  return selectedBlocks;
};

var setSelectionBlockData = exports.setSelectionBlockData = function setSelectionBlockData(editorState, blockData, override) {

  var newBlockData = override ? blockData : Object.assign({}, getSelectionBlockData(editorState).toJS(), blockData);

  Object.keys(newBlockData).forEach(function (key) {
    if (newBlockData.hasOwnProperty(key) && newBlockData[key] === undefined) {
      delete newBlockData[key];
    }
  });

  return (0, _draftjsUtils.setBlockData)(editorState, newBlockData);
};

var getSelectionBlockData = exports.getSelectionBlockData = function getSelectionBlockData(editorState, name) {
  var blockData = getSelectionBlock(editorState).getData();
  return name ? blockData.get(name) : blockData;
};

var getSelectionBlockType = exports.getSelectionBlockType = function getSelectionBlockType(editorState) {
  return getSelectionBlock(editorState).getType();
};

var getSelectionText = exports.getSelectionText = function getSelectionText(editorState) {

  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();

  if (selectionState.isCollapsed() || getSelectionBlockType(editorState) === 'atomic') {
    return '';
  }

  var anchorKey = selectionState.getAnchorKey();
  var currentContentBlock = contentState.getBlockForKey(anchorKey);
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  return currentContentBlock.getText().slice(start, end);
};

var toggleSelectionBlockType = exports.toggleSelectionBlockType = function toggleSelectionBlockType(editorState, blockType) {

  if (selectionContainsStrictBlock(editorState)) {
    return editorState;
  }

  return _draftJs.RichUtils.toggleBlockType(editorState, blockType);
};

var getSelectionEntityType = exports.getSelectionEntityType = function getSelectionEntityType(editorState) {

  var entityKey = (0, _draftjsUtils.getSelectionEntity)(editorState);

  if (entityKey) {
    var entity = editorState.getCurrentContent().getEntity(entityKey);
    return entity ? entity.get('type') : null;
  }

  return null;
};

var getSelectionEntityData = exports.getSelectionEntityData = function getSelectionEntityData(editorState, type) {

  var entityKey = (0, _draftjsUtils.getSelectionEntity)(editorState);

  if (entityKey) {
    var entity = editorState.getCurrentContent().getEntity(entityKey);
    if (entity && entity.get('type') === type) {
      return entity.getData();
    } else {
      return {};
    }
  } else {
    return {};
  }
};

var toggleSelectionEntity = exports.toggleSelectionEntity = function toggleSelectionEntity(editorState, entity) {

  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed() || getSelectionBlockType(editorState) === 'atomic') {
    return editorState;
  }

  if (!entity || !entity.type || getSelectionEntityType(editorState) === entity.type) {
    return _draftJs.EditorState.push(editorState, _draftJs.Modifier.applyEntity(contentState, selectionState, null), 'apply-entity');
  }

  try {

    var nextContentState = contentState.createEntity(entity.type, entity.mutability, entity.data);
    var entityKey = nextContentState.getLastCreatedEntityKey();

    var nextEditorState = _draftJs.EditorState.set(editorState, {
      currentContent: nextContentState
    });

    return _draftJs.EditorState.push(nextEditorState, _draftJs.Modifier.applyEntity(nextContentState, selectionState, entityKey), 'apply-entity');
  } catch (error) {
    console.warn(error);
    return editorState;
  }
};

var toggleSelectionLink = exports.toggleSelectionLink = function toggleSelectionLink(editorState, href, target) {

  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();

  var entityData = { href: href, target: target };

  if (selectionState.isCollapsed() || getSelectionBlockType(editorState) === 'atomic') {
    return editorState;
  }

  if (href === false) {
    return _draftJs.RichUtils.toggleLink(editorState, selectionState, null);
  }

  if (href === null) {
    delete entityData.href;
  }

  try {

    var nextContentState = contentState.createEntity('LINK', 'MUTABLE', entityData);
    var entityKey = nextContentState.getLastCreatedEntityKey();

    var nextEditorState = _draftJs.EditorState.set(editorState, {
      currentContent: nextContentState
    });

    nextEditorState = _draftJs.RichUtils.toggleLink(nextEditorState, selectionState, entityKey);
    nextEditorState = _draftJs.EditorState.forceSelection(nextEditorState, selectionState.merge({
      anchorOffset: selectionState.getEndOffset(),
      focusOffset: selectionState.getEndOffset()
    }));

    nextEditorState = _draftJs.EditorState.push(nextEditorState, _draftJs.Modifier.insertText(nextEditorState.getCurrentContent(), nextEditorState.getSelection(), ''), 'insert-text');

    return nextEditorState;
  } catch (error) {
    console.warn(error);
    return editorState;
  }
};

var getSelectionInlineStyle = exports.getSelectionInlineStyle = function getSelectionInlineStyle(editorState) {
  return editorState.getCurrentInlineStyle();
};

var selectionHasInlineStyle = exports.selectionHasInlineStyle = function selectionHasInlineStyle(editorState, style) {
  return getSelectionInlineStyle(editorState).has(style.toUpperCase());
};

var toggleSelectionInlineStyle = exports.toggleSelectionInlineStyle = function toggleSelectionInlineStyle(editorState, style) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


  var nextEditorState = editorState;
  style = prefix + style.toUpperCase();

  if (prefix) {

    nextEditorState = updateEachCharacterOfSelection(nextEditorState, function (characterMetadata) {

      return characterMetadata.toJS().style.reduce(function (characterMetadata, characterStyle) {
        if (characterStyle.indexOf(prefix) === 0 && style !== characterStyle) {
          return _draftJs.CharacterMetadata.removeStyle(characterMetadata, characterStyle);
        } else {
          return characterMetadata;
        }
      }, characterMetadata);
    });
  }

  return _draftJs.RichUtils.toggleInlineStyle(nextEditorState, style);
};

var removeSelectionInlineStyles = exports.removeSelectionInlineStyles = function removeSelectionInlineStyles(editorState) {

  return updateEachCharacterOfSelection(editorState, function (characterMetadata) {
    return characterMetadata.merge({
      style: _immutable2.default.OrderedSet([])
    });
  });
};

var toggleSelectionAlignment = exports.toggleSelectionAlignment = function toggleSelectionAlignment(editorState, alignment) {
  return setSelectionBlockData(editorState, {
    textAlign: getSelectionBlockData(editorState, 'textAlign') !== alignment ? alignment : undefined
  });
};

var toggleSelectionIndent = exports.toggleSelectionIndent = function toggleSelectionIndent(editorState, textIndent) {
  var maxIndent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

  return textIndent < 0 || textIndent > maxIndent || isNaN(textIndent) ? editorState : setSelectionBlockData(editorState, {
    textIndent: textIndent || undefined
  });
};

var increaseSelectionIndent = exports.increaseSelectionIndent = function increaseSelectionIndent(editorState) {
  var maxIndent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

  var currentIndent = getSelectionBlockData(editorState, 'textIndent') || 0;
  return toggleSelectionIndent(editorState, currentIndent + 1, maxIndent);
};

var decreaseSelectionIndent = exports.decreaseSelectionIndent = function decreaseSelectionIndent(editorState) {
  var currentIndent = getSelectionBlockData(editorState, 'textIndent') || 0;
  return toggleSelectionIndent(editorState, currentIndent - 1);
};

var toggleSelectionColor = exports.toggleSelectionColor = function toggleSelectionColor(editorState, color) {
  return toggleSelectionInlineStyle(editorState, color.replace('#', ''), 'COLOR-');
};

var toggleSelectionBackgroundColor = exports.toggleSelectionBackgroundColor = function toggleSelectionBackgroundColor(editorState, color) {
  return toggleSelectionInlineStyle(editorState, color.replace('#', ''), 'BGCOLOR-');
};

var toggleSelectionFontSize = exports.toggleSelectionFontSize = function toggleSelectionFontSize(editorState, fontSize) {
  return toggleSelectionInlineStyle(editorState, fontSize, 'FONTSIZE-');
};

var toggleSelectionLineHeight = exports.toggleSelectionLineHeight = function toggleSelectionLineHeight(editorState, lineHeight) {
  return toggleSelectionInlineStyle(editorState, lineHeight, 'LINEHEIGHT-');
};

var toggleSelectionFontFamily = exports.toggleSelectionFontFamily = function toggleSelectionFontFamily(editorState, fontFamily) {
  return toggleSelectionInlineStyle(editorState, fontFamily, 'FONTFAMILY-');
};

var toggleSelectionLetterSpacing = exports.toggleSelectionLetterSpacing = function toggleSelectionLetterSpacing(editorState, letterSpacing) {
  return toggleSelectionInlineStyle(editorState, letterSpacing, 'LETTERSPACING-');
};

var insertText = exports.insertText = function insertText(editorState, text, inlineStyle, entity) {

  var selectionState = editorState.getSelection();
  var currentSelectedBlockType = getSelectionBlockType(editorState);

  if (currentSelectedBlockType === 'atomic') {
    return editorState;
  }

  var entityKey = void 0;
  var contentState = editorState.getCurrentContent();

  if (entity && entity.type) {
    contentState = contentState.createEntity(entity.type, entity.mutability || 'MUTABLE', entity.data || entityData);
    entityKey = contentState.getLastCreatedEntityKey();
  }

  if (!selectionState.isCollapsed()) {
    return _draftJs.EditorState.push(editorState, _draftJs.Modifier.replaceText(contentState, selectionState, text, inlineStyle, entityKey), 'replace-text');
  } else {
    return _draftJs.EditorState.push(editorState, _draftJs.Modifier.insertText(contentState, selectionState, text, inlineStyle, entityKey), 'insert-text');
  }
};

var insertHTML = exports.insertHTML = function insertHTML(editorState, htmlString, source) {

  if (!htmlString) {
    return editorState;
  }

  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var options = editorState.convertOptions || {};

  try {
    var _convertFromRaw = (0, _draftJs.convertFromRaw)((0, _braftConvert.convertHTMLToRaw)(htmlString, options, source)),
        blockMap = _convertFromRaw.blockMap;

    return _draftJs.EditorState.push(editorState, _draftJs.Modifier.replaceWithFragment(contentState, selectionState, blockMap), 'insert-fragment');
  } catch (error) {
    console.warn(error);
    return editorState;
  }
};

var insertAtomicBlock = exports.insertAtomicBlock = function insertAtomicBlock(editorState, type) {
  var immutable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};


  if (selectionContainsStrictBlock(editorState)) {
    return insertAtomicBlock(selectNextBlock(editorState, getSelectionBlock(editorState)), type, immutable, data);
  }

  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();

  if (!selectionState.isCollapsed() || getSelectionBlockType(editorState) === 'atomic') {
    return editorState;
  }

  var contentStateWithEntity = contentState.createEntity(type, immutable ? 'IMMUTABLE' : 'MUTABLE', data);
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var newEditorState = _draftJs.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');

  return newEditorState;
};

var insertHorizontalLine = exports.insertHorizontalLine = function insertHorizontalLine(editorState) {
  return insertAtomicBlock(editorState, 'HR');
};

var insertMedias = exports.insertMedias = function insertMedias(editorState) {
  var medias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];


  if (!medias.length) {
    return editorState;
  }

  return medias.reduce(function (editorState, media) {
    var url = media.url,
        link = media.link,
        link_target = media.link_target,
        name = media.name,
        type = media.type,
        width = media.width,
        height = media.height,
        meta = media.meta;

    return insertAtomicBlock(editorState, type, true, { url: url, link: link, link_target: link_target, name: name, type: type, width: width, height: height, meta: meta });
  }, editorState);
};

var setMediaData = exports.setMediaData = function setMediaData(editorState, entityKey, data) {
  return _draftJs.EditorState.push(editorState, editorState.getCurrentContent().mergeEntityData(entityKey, data), 'change-block-data');
};

var removeMedia = exports.removeMedia = function removeMedia(editorState, mediaBlock) {
  return removeBlock(editorState, mediaBlock);
};

var setMediaPosition = exports.setMediaPosition = function setMediaPosition(editorState, mediaBlock, position) {

  var newPosition = {};
  var float = position.float,
      alignment = position.alignment;


  if (typeof float !== 'undefined') {
    newPosition.float = mediaBlock.getData().get('float') === float ? null : float;
  }

  if (typeof alignment !== 'undefined') {
    newPosition.alignment = mediaBlock.getData().get('alignment') === alignment ? null : alignment;
  }

  return setSelectionBlockData(selectBlock(editorState, mediaBlock), newPosition);
};

var clear = exports.clear = function clear(editorState) {

  var contentState = editorState.getCurrentContent();

  var firstBlock = contentState.getFirstBlock();
  var lastBlock = contentState.getLastBlock();

  var allSelected = new _draftJs.SelectionState({
    anchorKey: firstBlock.getKey(),
    anchorOffset: 0,
    focusKey: lastBlock.getKey(),
    focusOffset: lastBlock.getLength(),
    hasFocus: true
  });

  return _draftJs.RichUtils.toggleBlockType(_draftJs.EditorState.push(editorState, _draftJs.Modifier.removeRange(contentState, allSelected, 'backward'), 'remove-range'), 'unstyled');
};

var handleKeyCommand = exports.handleKeyCommand = function handleKeyCommand(editorState, command) {
  return _draftJs.RichUtils.handleKeyCommand(editorState, command);
};

var undo = exports.undo = function undo(editorState) {
  return _draftJs.EditorState.undo(editorState);
};

var redo = exports.redo = function redo(editorState) {
  return _draftJs.EditorState.redo(editorState);
};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BlockMapBuilder = __webpack_require__(227);
var CharacterMetadata = __webpack_require__(83);
var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var DraftFeatureFlags = __webpack_require__(129);
var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var Immutable = __webpack_require__(32);
var SelectionState = __webpack_require__(196);

var generateRandomKey = __webpack_require__(121);
var moveBlockInContentState = __webpack_require__(1944);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _extends({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'move-block');
  }
};

module.exports = AtomicBlockUtils;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */



var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

module.exports = DraftFeatureFlags;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(83);

var _require = __webpack_require__(32),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(32);

var applyEntityToContentBlock = __webpack_require__(1933);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(83);

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @format
 * 
 */



var DraftEntitySegments = __webpack_require__(1935);

var getRangesForDraftEntity = __webpack_require__(1936);
var invariant = __webpack_require__(34);

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */



/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

module.exports = DraftEntitySegments;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @format
 * 
 */



var invariant = __webpack_require__(34);

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;

  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(227);
var ContentBlockNode = __webpack_require__(89);
var Immutable = __webpack_require__(32);

var insertIntoList = __webpack_require__(810);
var invariant = __webpack_require__(34);
var randomizeBlockMapKeys = __webpack_require__(808);

var List = Immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(32);

var insertIntoList = __webpack_require__(810);
var invariant = __webpack_require__(34);

var Repeat = Immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(32);

var Map = Immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(89);
var Immutable = __webpack_require__(32);

var getNextDelimiterBlockKey = __webpack_require__(811);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(89);
var Immutable = __webpack_require__(32);

var generateRandomKey = __webpack_require__(121);
var invariant = __webpack_require__(34);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update original next block
    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;

    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @format
 * 
 */



var Immutable = __webpack_require__(32);
var UnicodeBidiService = __webpack_require__(1943);

var nullthrows = __webpack_require__(105);

var OrderedMap = Immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

module.exports = EditorBidiService;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnicodeBidi = __webpack_require__(814);
var UnicodeBidiDirection = __webpack_require__(429);

var invariant = __webpack_require__(34);

var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(89);
var Immutable = __webpack_require__(32);

var getNextDelimiterBlockKey = __webpack_require__(811);
var invariant = __webpack_require__(34);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Immutable = __webpack_require__(32);

var List = Immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @format
 * 
 * @preventMunge
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(430);
var DefaultDraftInlineStyle = __webpack_require__(815);
var DraftEditorCompositionHandler = __webpack_require__(1947);
var DraftEditorContents = __webpack_require__(1948);
var DraftEditorDragHandler = __webpack_require__(1970);
var DraftEditorEditHandler = __webpack_require__(1973);
var DraftEditorPlaceholder = __webpack_require__(2006);
var EditorState = __webpack_require__(36);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(52);
var Scroll = __webpack_require__(820);
var Style = __webpack_require__(434);
var UserAgent = __webpack_require__(114);

var cx = __webpack_require__(197);
var emptyFunction = __webpack_require__(261);
var generateRandomKey = __webpack_require__(121);
var getDefaultKeyBinding = __webpack_require__(833);
var getScrollPosition = __webpack_require__(435);
var invariant = __webpack_require__(34);
var nullthrows = __webpack_require__(105);

var isIE = UserAgent.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck(this, DraftEditor);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React.createElement(
        'div',
        {
          className: cx('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React.createElement(DraftEditorContents, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: emptyFunction.thatReturnsNull,
  blockStyleFn: emptyFunction.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


module.exports = DraftEditor;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(129);
var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var Keys = __webpack_require__(431);

var getEntityKeyForSelection = __webpack_require__(432);
var isEventHandled = __webpack_require__(229);
var isSelectionAtLeafStart = __webpack_require__(816);

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */



var DraftEditorContents = __webpack_require__(1949);

module.exports = DraftEditorContents;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents-core.react
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(817);
var DraftOffsetKey = __webpack_require__(307);
var EditorState = __webpack_require__(36);
var React = __webpack_require__(0);

var cx = __webpack_require__(197);
var joinClasses = __webpack_require__(1969);
var nullthrows = __webpack_require__(105);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck(this, DraftEditorContents);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @format
 * 
 */



var _assign = __webpack_require__(64);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorTextNode = __webpack_require__(1951);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(52);

var invariant = __webpack_require__(34);
var setDraftEditorSelection = __webpack_require__(1957);

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck(this, DraftEditorLeaf);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = ReactDOM.findDOMNode(this);
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React.createElement(
        DraftEditorTextNode,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(52);
var UserAgent = __webpack_require__(114);

var invariant = __webpack_require__(34);

// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */



var UAParser = __webpack_require__(1953);

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new UAParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

module.exports = uaData;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.17',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
            ], [NAME, VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w+)*/i,                                                    // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w+)*/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w+)*/i                                                       // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w+)*/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i                                         // OnePlus
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android.+)[;\/].+build/i                                          // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i                                               // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                  // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i                                              // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(818)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var invariant = __webpack_require__(34);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

module.exports = VersionRange;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @format
 * 
 */



var DraftJsDebugLogging = __webpack_require__(1958);

var containsNode = __webpack_require__(433);
var getActiveElement = __webpack_require__(819);
var invariant = __webpack_require__(34);

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode(document.documentElement, node)) {
    return;
  }

  var selection = global.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  if (selection.extend && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

module.exports = setDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */



module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1960);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var camelize = __webpack_require__(1962);
var hyphenate = __webpack_require__(1963);

function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name)]);
  }
  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getElementRect = __webpack_require__(1965);

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var containsNode = __webpack_require__(433);

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @format
 * 
 */



var DataTransfer = __webpack_require__(821);
var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);

var findAncestorOffsetKey = __webpack_require__(436);
var getTextContentFromFiles = __webpack_require__(823);
var getUpdatedSelectionState = __webpack_require__(824);
var isEventHandled = __webpack_require__(229);
var nullthrows = __webpack_require__(105);

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));

  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(34);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * @format
 * 
 */



var onBeforeInput = __webpack_require__(1974);
var onBlur = __webpack_require__(1977);
var onCompositionStart = __webpack_require__(1978);
var onCopy = __webpack_require__(1979);
var onCut = __webpack_require__(1980);
var onDragOver = __webpack_require__(1981);
var onDragStart = __webpack_require__(1982);
var onFocus = __webpack_require__(1983);
var onInput = __webpack_require__(1984);
var onKeyDown = __webpack_require__(1985);
var onPaste = __webpack_require__(1999);
var onSelect = __webpack_require__(2004);

var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect
};

module.exports = DraftEditorEditHandler;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * @format
 * 
 */



var BlockTree = __webpack_require__(812);
var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var UserAgent = __webpack_require__(114);

var getEntityKeyForSelection = __webpack_require__(432);
var isEventHandled = __webpack_require__(229);
var isSelectionAtLeafStart = __webpack_require__(816);
var nullthrows = __webpack_require__(105);
var setImmediate = __webpack_require__(1975);

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = global.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(1976);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71), __webpack_require__(329)))

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

var containsNode = __webpack_require__(433);
var getActiveElement = __webpack_require__(819);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement() === document.body) {
    var _selection = global.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * @format
 * 
 */



var getFragmentFromSelection = __webpack_require__(825);

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var Style = __webpack_require__(434);

var getFragmentFromSelection = __webpack_require__(825);
var getScrollPosition = __webpack_require__(435);

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition(Style.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */



/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */



/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * @format
 * 
 */



var EditorState = __webpack_require__(36);
var UserAgent = __webpack_require__(114);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(129);
var DraftModifier = __webpack_require__(81);
var DraftOffsetKey = __webpack_require__(307);
var EditorState = __webpack_require__(36);
var UserAgent = __webpack_require__(114);

var findAncestorOffsetKey = __webpack_require__(436);
var nullthrows = __webpack_require__(105);

var isGecko = UserAgent.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = global.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);
var KeyBindingUtil = __webpack_require__(437);
var Keys = __webpack_require__(431);
var SecondaryClipboard = __webpack_require__(1986);
var UserAgent = __webpack_require__(114);

var isEventHandled = __webpack_require__(229);
var keyCommandBackspaceToStartOfLine = __webpack_require__(1987);
var keyCommandBackspaceWord = __webpack_require__(1989);
var keyCommandDeleteWord = __webpack_require__(1991);
var keyCommandInsertNewline = __webpack_require__(1992);
var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1993);
var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1994);
var keyCommandPlainBackspace = __webpack_require__(1995);
var keyCommandPlainDelete = __webpack_require__(1996);
var keyCommandTransposeCharacters = __webpack_require__(1997);
var keyCommandUndo = __webpack_require__(1998);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;

var isChrome = UserAgent.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete(editorState);
    case 'delete-word':
      return keyCommandDeleteWord(editorState);
    case 'backspace':
      return keyCommandPlainBackspace(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState);
    case 'split-block':
      return keyCommandInsertNewline(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);

var getContentStateFragment = __webpack_require__(305);
var nullthrows = __webpack_require__(105);

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange);
    clipboard = getContentStateFragment(content, targetRange);

    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};

module.exports = SecondaryClipboard;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

var expandRangeToStartOfLine = __webpack_require__(1988);
var getDraftEditorSelectionWithNodes = __webpack_require__(827);
var moveSelectionBackward = __webpack_require__(438);
var removeTextWithStrategy = __webpack_require__(230);

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var domSelection = global.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);

    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

var UnicodeUtils = __webpack_require__(155);

var getRangeClientRects = __webpack_require__(826);
var invariant = __webpack_require__(34);

/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(828);
var EditorState = __webpack_require__(36);

var moveSelectionBackward = __webpack_require__(438);
var removeTextWithStrategy = __webpack_require__(230);

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */



// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(828);
var EditorState = __webpack_require__(36);

var moveSelectionForward = __webpack_require__(829);
var removeTextWithStrategy = __webpack_require__(230);

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * @format
 * 
 */



var EditorState = __webpack_require__(36);
var UnicodeUtils = __webpack_require__(155);

var moveSelectionBackward = __webpack_require__(438);
var removeTextWithStrategy = __webpack_require__(230);

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * @format
 * 
 */



var EditorState = __webpack_require__(36);
var UnicodeUtils = __webpack_require__(155);

var moveSelectionForward = __webpack_require__(829);
var removeTextWithStrategy = __webpack_require__(230);

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * @format
 * 
 */



var DraftModifier = __webpack_require__(81);
var EditorState = __webpack_require__(36);

var getContentStateFragment = __webpack_require__(305);

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');

  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * @format
 * 
 */



var EditorState = __webpack_require__(36);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(227);
var CharacterMetadata = __webpack_require__(83);
var DataTransfer = __webpack_require__(821);
var DraftModifier = __webpack_require__(81);
var DraftPasteProcessor = __webpack_require__(2000);
var EditorState = __webpack_require__(36);
var RichTextEditorUtil = __webpack_require__(832);

var getEntityKeyForSelection = __webpack_require__(432);
var getTextContentFromFiles = __webpack_require__(823);
var isEventHandled = __webpack_require__(229);
var splitTextIntoTextBlocks = __webpack_require__(2003);

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);

        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CharacterMetadata = __webpack_require__(83);
var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var DraftFeatureFlags = __webpack_require__(129);
var Immutable = __webpack_require__(32);

var convertFromHTMLtoContentBlocks = __webpack_require__(830);
var generateRandomKey = __webpack_require__(121);
var getSafeBodyFromHTML = __webpack_require__(831);
var sanitizeDraftText = __webpack_require__(428);

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));

      return acc;
    }, []);
  }
};

module.exports = DraftPasteProcessor;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */



function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */



var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * @format
 * 
 */



var EditorState = __webpack_require__(36);
var ReactDOM = __webpack_require__(52);

var getDraftEditorSelection = __webpack_require__(2005);
var invariant = __webpack_require__(34);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @format
 * 
 */



var getDraftEditorSelectionWithNodes = __webpack_require__(827);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = global.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

module.exports = getDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(197);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        'div',
        {
          className: cx('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var DraftStringKey = __webpack_require__(834);

var encodeEntityRanges = __webpack_require__(2008);
var encodeInlineStyleRanges = __webpack_require__(2009);
var invariant = __webpack_require__(34);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @format
 * 
 */



var DraftStringKey = __webpack_require__(834);
var UnicodeUtils = __webpack_require__(155);

var strlen = UnicodeUtils.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(155);

var findRangesImmutable = __webpack_require__(228);

var areEqual = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable(filteredInlines, areEqual,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * @format
 * 
 */



var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(154);
var ContentBlockNode = __webpack_require__(89);
var ContentState = __webpack_require__(427);
var DraftEntity = __webpack_require__(306);
var DraftFeatureFlags = __webpack_require__(129);
var DraftTreeAdapter = __webpack_require__(2011);
var Immutable = __webpack_require__(32);
var SelectionState = __webpack_require__(196);

var createCharacterList = __webpack_require__(2012);
var decodeEntityRanges = __webpack_require__(2013);
var decodeInlineStyleRanges = __webpack_require__(2014);
var generateRandomKey = __webpack_require__(121);
var invariant = __webpack_require__(34);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends({}, block, {
    key: block.key || generateRandomKey()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());

  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(64);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var invariant = __webpack_require__(34);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

module.exports = DraftTreeAdapter;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(83);
var Immutable = __webpack_require__(32);

var List = Immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({ style: style, entity: entity });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(155);

var substr = UnicodeUtils.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @format
 * 
 */



var _require = __webpack_require__(32),
    OrderedSet = _require.OrderedSet;

var UnicodeUtils = __webpack_require__(155);

var substr = UnicodeUtils.substr;


var EMPTY_SET = OrderedSet();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @format
 * 
 */



var getRangeBoundingClientRect = __webpack_require__(2016);

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @format
 * 
 */



var getRangeClientRects = __webpack_require__(826);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__convertToHTML__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__convertFromHTML__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_parseHTML__ = __webpack_require__(842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "convertToHTML", function() { return __WEBPACK_IMPORTED_MODULE_0__convertToHTML__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "convertFromHTML", function() { return __WEBPACK_IMPORTED_MODULE_1__convertFromHTML__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseHTML", function() { return __WEBPACK_IMPORTED_MODULE_2__util_parseHTML__["a"]; });





/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__encodeBlock__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blockEntities__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blockInlineStyles__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_accumulateFunction__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_blockTypeObjectFunction__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_getBlockTags__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__default_defaultBlockHTML__ = __webpack_require__(2033);
// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars













var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
  return originalText;
};

var convertToHTML = function convertToHTML(_ref) {
  var _ref$styleToHTML = _ref.styleToHTML,
      styleToHTML = _ref$styleToHTML === void 0 ? {} : _ref$styleToHTML,
      _ref$blockToHTML = _ref.blockToHTML,
      blockToHTML = _ref$blockToHTML === void 0 ? {} : _ref$blockToHTML,
      _ref$entityToHTML = _ref.entityToHTML,
      entityToHTML = _ref$entityToHTML === void 0 ? defaultEntityToHTML : _ref$entityToHTML;
  return function (contentState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');
    var getBlockHTML;

    if (blockToHTML.__isMiddleware === true) {
      getBlockHTML = blockToHTML(Object(__WEBPACK_IMPORTED_MODULE_8__util_blockTypeObjectFunction__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__default_defaultBlockHTML__["a" /* default */]));
    } else {
      getBlockHTML = Object(__WEBPACK_IMPORTED_MODULE_7__util_accumulateFunction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__util_blockTypeObjectFunction__["a" /* default */])(blockToHTML), Object(__WEBPACK_IMPORTED_MODULE_8__util_blockTypeObjectFunction__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__default_defaultBlockHTML__["a" /* default */]));
    }

    var rawState = Object(__WEBPACK_IMPORTED_MODULE_3_draft_js__["convertToRaw"])(contentState);
    var listStack = [];
    var result = rawState.blocks.map(function (block) {
      var type = block.type,
          depth = block.depth;
      var closeNestTags = '';
      var openNestTags = '';
      var blockHTMLResult = getBlockHTML(block);

      if (!blockHTMLResult) {
        throw new Error("convertToHTML: missing HTML definition for block with type ".concat(block.type));
      }

      if (!blockHTMLResult.nest) {
        // this block can't be nested, so reset all nesting if necessary
        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
          return string + Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(nestedBlock), depth).nestEnd;
        }, '');
        listStack = [];
      } else {
        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
          if (depth + 1 === listStack.length) {
            // depth is right but doesn't match type
            var blockToClose = listStack[depth];
            closeNestTags += Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(blockToClose), depth).nestEnd;
            openNestTags += Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(block), depth).nestStart;
            listStack[depth] = block;
          } else if (depth + 1 < listStack.length) {
            var _blockToClose = listStack[listStack.length - 1];
            closeNestTags += Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(_blockToClose), depth).nestEnd;
            listStack = listStack.slice(0, -1);
          } else {
            openNestTags += Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(block), depth).nestStart;
            listStack.push(block);
          }
        }
      }

      var innerHTML = Object(__WEBPACK_IMPORTED_MODULE_6__blockInlineStyles__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__blockEntities__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__encodeBlock__["a" /* default */])(block), rawState.entityMap, entityToHTML), styleToHTML);
      var blockHTML = Object(__WEBPACK_IMPORTED_MODULE_9__util_getBlockTags__["a" /* default */])(getBlockHTML(block));
      var html;

      if (typeof blockHTML === 'string') {
        html = blockHTML;
      } else {
        html = blockHTML.start + innerHTML + blockHTML.end;
      }

      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(blockHTML.empty)) {
          html = __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default.a.renderToStaticMarkup(blockHTML.empty);
        } else {
          html = blockHTML.empty;
        }
      }

      return closeNestTags + openNestTags + html;
    }).join('');
    result = listStack.reduce(function (res, nestBlock) {
      return res + Object(__WEBPACK_IMPORTED_MODULE_10__util_getNestedBlockTags__["a" /* default */])(getBlockHTML(nestBlock), nestBlock.depth).nestEnd;
    }, result);
    return result;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
    // skip higher-order function and use defaults
    return convertToHTML({}).apply(void 0, args);
  }

  return convertToHTML.apply(void 0, args);
});

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(64),m=__webpack_require__(0);function r(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,v=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,x=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,A=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.fundamental"):60117;
function B(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case v:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case A:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case x:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return B(a.type);case ja:if(a=1===a._status?a._result:null)return B(a)}return null}var C=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});var la={};function D(a,b){for(var d=a._threadCount|0;d<=b;d++)a[d]=a._currentValue2,a._threadCount=d+1}
function ma(a,b,d,c){if(c&&(c=a.contextType,"object"===typeof c&&null!==c))return D(c,d),c[d];if(a=a.contextTypes){d={};for(var f in a)d[f]=b[f];b=d}else b=la;return b}for(var E=new Uint16Array(16),G=0;15>G;G++)E[G]=G+1;E[15]=0;
var na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,oa=Object.prototype.hasOwnProperty,pa={},qa={};
function ra(a){if(oa.call(qa,a))return!0;if(oa.call(pa,a))return!1;if(na.test(a))return qa[a]=!0;pa[a]=!0;return!1}function sa(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function ta(a,b,d,c){if(null===b||"undefined"===typeof b||sa(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,f,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=f;this.mustUseProperty=d;this.propertyName=a;this.type=b;this.sanitizeURL=e}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null,!1)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){J[a]=new I(a,1,!1,a.toLowerCase(),null,!1)});
J.xlinkHref=new I("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){J[a]=new I(a,1,!1,a.toLowerCase(),null,!0)});var ua=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ua.exec(a);if(b){var d="",c,f=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==c&&(d+=a.substring(f,c));f=c+1;d+=b}a=f!==c?d+a.substring(f,c):d}return a}
function va(a,b){var d=J.hasOwnProperty(a)?J[a]:null;var c;if(c="style"!==a)c=null!==d?0===d.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(c||ta(a,b,d,!1))return"";if(null!==d){a=d.attributeName;c=d.type;if(3===c||4===c&&!0===b)return a+'=""';d.sanitizeURL&&(b=""+b);return a+"="+('"'+M(b)+'"')}return ra(a)?a+"="+('"'+M(b)+'"'):""}var N=null,O=null,P=null,Q=!1,R=!1,T=null,U=0;function V(){if(null===N)throw r(Error(321));return N}
function wa(){if(0<U)throw r(Error(312));return{memoizedState:null,queue:null,next:null}}function W(){null===P?null===O?(Q=!1,O=P=wa()):(Q=!0,P=O):null===P.next?(Q=!1,P=P.next=wa()):(Q=!0,P=P.next);return P}function xa(a,b,d,c){for(;R;)R=!1,U+=1,P=null,d=a(b,c);O=N=null;U=0;P=T=null;return d}function ya(a,b){return"function"===typeof b?b(a):b}
function za(a,b,d){N=V();P=W();if(Q){var c=P.queue;b=c.dispatch;if(null!==T&&(d=T.get(c),void 0!==d)){T.delete(c);c=P.memoizedState;do c=a(c,d.action),d=d.next;while(null!==d);P.memoizedState=c;return[c,b]}return[P.memoizedState,b]}a=a===ya?"function"===typeof b?b():b:void 0!==d?d(b):b;P.memoizedState=a;a=P.queue={last:null,dispatch:null};a=a.dispatch=Aa.bind(null,N,a);return[P.memoizedState,a]}
function Aa(a,b,d){if(!(25>U))throw r(Error(301));if(a===N)if(R=!0,a={action:d,next:null},null===T&&(T=new Map),d=T.get(b),void 0===d)T.set(b,a);else{for(b=d;null!==b.next;)b=b.next;b.next=a}}function Ba(){}
var X=0,Ca={readContext:function(a){var b=X;D(a,b);return a[b]},useContext:function(a){V();var b=X;D(a,b);return a[b]},useMemo:function(a,b){N=V();P=W();b=void 0===b?null:b;if(null!==P){var d=P.memoizedState;if(null!==d&&null!==b){a:{var c=d[1];if(null===c)c=!1;else{for(var f=0;f<c.length&&f<b.length;f++){var e=b[f],h=c[f];if((e!==h||0===e&&1/e!==1/h)&&(e===e||h===h)){c=!1;break a}}c=!0}}if(c)return d[0]}}a=a();P.memoizedState=[a,b];return a},useReducer:za,useRef:function(a){N=V();P=W();var b=P.memoizedState;
return null===b?(a={current:a},P.memoizedState=a):b},useState:function(a){return za(ya,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ba,useEffect:Ba,useDebugValue:Ba,useResponder:function(a,b){return{props:b,responder:a}}},Da={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ea(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Fa={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ga=l({menuitem:!0},Fa),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ha=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ha.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Ia=/([A-Z])/g,Ja=/^ms-/,Z=m.Children.toArray,Ka=C.ReactCurrentDispatcher,La={listing:!0,pre:!0,textarea:!0},Ma=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Na={},Oa={};function Pa(a){if(void 0===a||null===a)return a;var b="";m.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Qa=Object.prototype.hasOwnProperty,Ra={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Sa(a,b){if(void 0===a)throw r(Error(152),B(b)||"Component");}
function Ta(a,b,d){function c(c,f){var e=f.prototype&&f.prototype.isReactComponent,g=ma(f,b,d,e),h=[],w=!1,p={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===h)return null},enqueueReplaceState:function(a,b){w=!0;h=[b]},enqueueSetState:function(a,b){if(null===h)return null;h.push(b)}},k=void 0;if(e)k=new f(c.props,g,p),"function"===typeof f.getDerivedStateFromProps&&(e=f.getDerivedStateFromProps.call(null,c.props,k.state),null!=e&&(k.state=l({},k.state,e)));else if(N={},k=f(c.props,
g,p),k=xa(f,c.props,k,g),null==k||null==k.render){a=k;Sa(a,f);return}k.props=c.props;k.context=g;k.updater=p;p=k.state;void 0===p&&(k.state=p=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),h.length){p=h;var q=
w;h=null;w=!1;if(q&&1===p.length)k.state=p[0];else{e=q?p[0]:k.state;var y=!0;for(q=q?1:0;q<p.length;q++){var u=p[q];u="function"===typeof u?u.call(k,e,c.props,g):u;null!=u&&(y?(y=!1,e=l({},e,u)):l(e,u))}k.state=e}}else h=null;a=k.render();Sa(a,f);c=void 0;if("function"===typeof k.getChildContext&&(g=f.childContextTypes,"object"===typeof g)){c=k.getChildContext();for(var S in c)if(!(S in g))throw r(Error(108),B(f)||"Unknown",S);}c&&(b=l({},b,c))}for(;m.isValidElement(a);){var f=a,e=f.type;if("function"!==
typeof e)break;c(f,e)}return{child:a,context:b}}
var Ua=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");m.isValidElement(b)?b.type!==v?b=[b]:(b=b.props.children,b=m.isValidElement(b)?[b]:Z(b)):b=Z(b);b={type:null,domNamespace:Da.html,children:b,childIndex:0,context:la,footer:""};var c=E[0];if(0===c){var f=E;c=f.length;var e=2*c;if(!(65536>=e))throw r(Error(304));var h=new Uint16Array(e);h.set(f);E=h;E[0]=c+1;for(f=c;f<e-1;f++)E[f]=f+1;E[e-1]=0}else E[0]=E[c];this.threadID=c;this.stack=
[b];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;E[a]=E[0];E[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,f=this.threadID;D(c,f);var e=c[f];this.contextStack[b]=c;this.contextValueStack[b]=e;c[f]=a.props.value};
a.prototype.popProvider=function(){var a=this.contextIndex,d=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;d[this.threadID]=c};a.prototype.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};a.prototype.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ka.current;Ka.current=Ca;try{for(var f=[""],e=!1;f[0].length<a;){if(0===
this.stack.length){this.exhausted=!0;var h=this.threadID;E[h]=E[0];E[0]=h;break}var g=this.stack[this.stack.length-1];if(e||g.childIndex>=g.children.length){var H=g.footer;""!==H&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===g.type)this.currentSelectValue=null;else if(null!=g.type&&null!=g.type.type&&g.type.type.$$typeof===x)this.popProvider(g.type);else if(g.type===A){this.suspenseDepth--;var F=f.pop();if(e){e=!1;var n=g.fallbackFrame;if(!n)throw r(Error(303));this.stack.push(n);
f[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else f[this.suspenseDepth]+=F}f[this.suspenseDepth]+=H}else{var w=g.children[g.childIndex++],p="";try{p+=this.render(w,g.context,g.domNamespace)}catch(k){throw k;}finally{}f.length<=this.suspenseDepth&&f.push("");f[this.suspenseDepth]+=p}}return f[0]}finally{Ka.current=c,X=b}};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+
M(c);this.previousWasTextNode=!0;return M(c)}d=Ta(a,d,this.threadID);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!m.isValidElement(a)){if(null!=a&&null!=a.$$typeof){c=a.$$typeof;if(c===aa)throw r(Error(257));throw r(Error(258),c.toString());}a=Z(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}var b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ba:case ea:case ca:case ha:case v:return a=Z(a.props.children),this.stack.push({type:null,
domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case A:throw r(Error(294));}if("object"===typeof b&&null!==b)switch(b.$$typeof){case fa:N={};var e=b.render(a.props,a.ref);e=xa(b.render,a.props,e,a.ref);e=Z(e);this.stack.push({type:null,domNamespace:c,children:e,childIndex:0,context:d,footer:""});return"";case ia:return a=[m.createElement(b.type,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case x:return b=Z(a.props.children),
c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case da:b=a.type;e=a.props;var h=this.threadID;D(b,h);b=Z(e.children(b[h]));this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""});return"";case ka:throw r(Error(338));case ja:throw r(Error(295));}throw r(Error(130),null==b?b:typeof b,"");};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===Da.html&&Ea(b);if(!Na.hasOwnProperty(b)){if(!Ma.test(b))throw r(Error(65),
b);Na[b]=!0}var e=a.props;if("input"===b)e=l({type:void 0},e,{defaultChecked:void 0,defaultValue:void 0,value:null!=e.value?e.value:e.defaultValue,checked:null!=e.checked?e.checked:e.defaultChecked});else if("textarea"===b){var h=e.value;if(null==h){h=e.defaultValue;var g=e.children;if(null!=g){if(null!=h)throw r(Error(92));if(Array.isArray(g)){if(!(1>=g.length))throw r(Error(93));g=g[0]}h=""+g}null==h&&(h="")}e=l({},e,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=
e.value?e.value:e.defaultValue,e=l({},e,{value:void 0});else if("option"===b){g=this.currentSelectValue;var H=Pa(e.children);if(null!=g){var F=null!=e.value?e.value+"":H;h=!1;if(Array.isArray(g))for(var n=0;n<g.length;n++){if(""+g[n]===F){h=!0;break}}else h=""+g===F;e=l({selected:void 0,children:void 0},e,{selected:h,children:H})}}if(h=e){if(Ga[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw r(Error(137),b,"");if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw r(Error(60));
if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw r(Error(61));}if(null!=h.style&&"object"!==typeof h.style)throw r(Error(62),"");}h=e;g=this.makeStaticMarkup;H=1===this.stack.length;F="<"+a.type;for(z in h)if(Qa.call(h,z)){var w=h[z];if(null!=w){if("style"===z){n=void 0;var p="",k="";for(n in w)if(w.hasOwnProperty(n)){var q=0===n.indexOf("--"),y=w[n];if(null!=y){if(q)var u=n;else if(u=n,Oa.hasOwnProperty(u))u=Oa[u];else{var S=u.replace(Ia,"-$1").toLowerCase().replace(Ja,
"-ms-");u=Oa[u]=S}p+=k+u+":";k=n;q=null==y||"boolean"===typeof y||""===y?"":q||"number"!==typeof y||0===y||Y.hasOwnProperty(k)&&Y[k]?(""+y).trim():y+"px";p+=q;k=";"}}w=p||null}n=null;b:if(q=b,y=h,-1===q.indexOf("-"))q="string"===typeof y.is;else switch(q){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":q=!1;break b;default:q=!0}q?Ra.hasOwnProperty(z)||(n=z,n=ra(n)&&null!=w?n+"="+
('"'+M(w)+'"'):""):n=va(z,w);n&&(F+=" "+n)}}g||H&&(F+=' data-reactroot=""');var z=F;h="";Fa.hasOwnProperty(b)?z+="/>":(z+=">",h="</"+a.type+">");a:{g=e.dangerouslySetInnerHTML;if(null!=g){if(null!=g.__html){g=g.__html;break a}}else if(g=e.children,"string"===typeof g||"number"===typeof g){g=M(g);break a}g=null}null!=g?(e=[],La[b]&&"\n"===g.charAt(0)&&(z+="\n"),z+=g):e=Z(e.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?Ea(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":
c;this.stack.push({domNamespace:c,type:b,children:e,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return z};return a}(),Va={renderToString:function(a){a=new Ua(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Ua(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw r(Error(207));},renderToStaticNodeStream:function(){throw r(Error(208));},version:"16.9.0"},Wa={default:Va},Xa=Wa&&Va||
Wa;module.exports=Xa.default||Xa;


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_updateMutation__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_rangeSort__ = __webpack_require__(309);



var ENTITY_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '\n': '<br/>'
};
/* harmony default export */ __webpack_exports__["a"] = (function (block) {
  var blockText = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(block.text);

  var entities = block.entityRanges.sort(__WEBPACK_IMPORTED_MODULE_2__util_rangeSort__["a" /* default */]);
  var styles = block.inlineStyleRanges.sort(__WEBPACK_IMPORTED_MODULE_2__util_rangeSort__["a" /* default */]);
  var resultText = '';

  var _loop = function _loop(index) {
    var _char = blockText[index];

    if (ENTITY_MAP[_char] !== undefined) {
      var encoded = ENTITY_MAP[_char];

      var resultIndex = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(resultText).length;

      resultText += encoded;

      var updateForChar = function updateForChar(mutation) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util_updateMutation__["a" /* default */])(mutation, resultIndex, _char.length, encoded.length, 0, 0);
      };

      entities = entities.map(updateForChar);
      styles = styles.map(updateForChar);
    } else {
      resultText += _char;
    }
  };

  for (var index = 0; index < blockText.length; index++) {
    _loop(index);
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities
  });
});

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(837);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(arr);
}

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(837);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
}

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_updateMutation__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_rangeSort__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_getElementHTML__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_getElementTagLength__ = __webpack_require__(2026);






var converter = function converter() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalText = arguments.length > 1 ? arguments[1] : undefined;
  return originalText;
};

/* harmony default export */ __webpack_exports__["a"] = (function (block, entityMap) {
  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;

  var resultText = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(block.text);

  var getEntityHTML = entityConverter;

  if (entityConverter.__isMiddleware) {
    getEntityHTML = entityConverter(converter);
  }

  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
    var entities = block.entityRanges.sort(__WEBPACK_IMPORTED_MODULE_2__util_rangeSort__["a" /* default */]);
    var styles = block.inlineStyleRanges;

    var _loop = function _loop(index) {
      var entityRange = entities[index];
      var entity = entityMap[entityRange.key];
      var originalText = resultText.slice(entityRange.offset, entityRange.offset + entityRange.length).join('');
      var entityHTML = getEntityHTML(entity, originalText);
      var elementHTML = Object(__WEBPACK_IMPORTED_MODULE_3__util_getElementHTML__["a" /* default */])(entityHTML, originalText);
      var converted = void 0;

      if (!!elementHTML || elementHTML === '') {
        converted = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(elementHTML);
      } else {
        converted = originalText;
      }

      var prefixLength = Object(__WEBPACK_IMPORTED_MODULE_4__util_getElementTagLength__["a" /* default */])(entityHTML, 'start');
      var suffixLength = Object(__WEBPACK_IMPORTED_MODULE_4__util_getElementTagLength__["a" /* default */])(entityHTML, 'end');

      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
        if (mutationIndex > index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__util_updateMutation__["a" /* default */])(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength, suffixLength);
        }

        return mutation;
      };

      var updateLaterMutations = function updateLaterMutations(mutationList) {
        return mutationList.reduce(function (acc, mutation, mutationIndex) {
          var updatedMutation = updateLaterMutation(mutation, mutationIndex);

          if (Array.isArray(updatedMutation)) {
            return acc.concat(updatedMutation);
          }

          return acc.concat([updatedMutation]);
        }, []);
      };

      entities = updateLaterMutations(entities);
      styles = updateLaterMutations(styles);
      resultText = [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(resultText.slice(0, entityRange.offset)), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(converted), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(resultText.slice(entityRange.offset + entityRange.length)));
    };

    for (var index = 0; index < entities.length; index++) {
      _loop(index);
    }

    return Object.assign({}, block, {
      text: resultText.join(''),
      inlineStyleRanges: styles,
      entityRanges: entities
    });
  }

  return block;
});

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__splitReactElement__ = __webpack_require__(310);




var getElementTagLength = function getElementTagLength(element) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) {
    var splitElement = Object(__WEBPACK_IMPORTED_MODULE_2__splitReactElement__["a" /* default */])(element);

    if (typeof splitElement === 'string') {
      return 0;
    }

    var length = splitElement[type].length;
    var child = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(element.props.children)[0];
    return length + (child && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child) ? getElementTagLength(child, type) : 0);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(element) === 'object') {
    return element[type] ? element[type].length : 0;
  }

  return 0;
};

/* harmony default export */ __webpack_exports__["a"] = (getElementTagLength);

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_styleObjectFunction__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_accumulateFunction__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_getElementHTML__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_rangeSort__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__default_defaultInlineHTML__ = __webpack_require__(2029);








var subtractStyles = function subtractStyles(original, toRemove) {
  return original.filter(function (el) {
    return !toRemove.some(function (elToRemove) {
      return elToRemove.style === el.style;
    });
  });
};

var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
  return endingStyles.reduceRight(function (stack, style) {
    var styleToRemove = stack[stack.length - 1];
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(styleToRemove.style === style.style, "Style ".concat(styleToRemove.style, " to be removed doesn't match expected ").concat(style.style));
    return stack.slice(0, -1);
  }, styleStack);
};

var characterStyles = function characterStyles(offset, ranges) {
  return ranges.filter(function (range) {
    return offset >= range.offset && offset < range.offset + range.length;
  });
};

var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
  // returns true if the second range is a subset of the first
  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;
  return secondStartWithinFirst && secondEndWithinFirst;
};

var latestStyleLast = function latestStyleLast(s1, s2) {
  // make sure longer-lasting styles are added first
  var s2endIndex = s2.offset + s2.length;
  var s1endIndex = s1.offset + s1.length;
  return s2endIndex - s1endIndex;
};

var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
  var i = 0;

  while (i < remainingStyles.length) {
    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
      i++;
    } else {
      return remainingStyles.slice(i);
    }
  }

  return [];
};

var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
  return string + Object(__WEBPACK_IMPORTED_MODULE_4__util_getElementHTML__["a" /* default */])(inlineHTML(styleRange.style)).start;
};

var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__util_getElementHTML__["a" /* default */])(inlineHTML(styleRange.style)).end + string;
};

var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
  return function (style) {
    return next(style);
  };
};

defaultCustomInlineHTML.__isMiddleware = true;
/* harmony default export */ __webpack_exports__["a"] = (function (rawBlock) {
  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;
  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');
  var inlineHTML;

  if (customInlineHTML.__isMiddleware === true) {
    inlineHTML = customInlineHTML(__WEBPACK_IMPORTED_MODULE_6__default_defaultInlineHTML__["a" /* default */]);
  } else {
    inlineHTML = Object(__WEBPACK_IMPORTED_MODULE_3__util_accumulateFunction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_styleObjectFunction__["a" /* default */])(customInlineHTML), Object(__WEBPACK_IMPORTED_MODULE_2__util_styleObjectFunction__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__default_defaultInlineHTML__["a" /* default */]));
  }

  var result = '';
  var styleStack = [];
  var sortedRanges = rawBlock.inlineStyleRanges.sort(__WEBPACK_IMPORTED_MODULE_5__util_rangeSort__["a" /* default */]);

  var originalTextArray = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(rawBlock.text);

  for (var i = 0; i < originalTextArray.length; i++) {
    var styles = characterStyles(i, sortedRanges);
    var endingStyles = subtractStyles(styleStack, styles);
    var newStyles = subtractStyles(styles, styleStack);
    var remainingStyles = subtractStyles(styleStack, endingStyles); // reset styles: look for any already existing styles that will need to
    // end before styles that are being added on this character. to solve this
    // close out those current tags and all nested children,
    // then open new ones nested within the new styles.

    var resetStyles = getStylesToReset(remainingStyles, newStyles);
    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);
    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');
    result += endingStyleTags + openingStyleTags + originalTextArray[i];
    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
    styleStack = styleStack.concat(openingStyles);
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(styleStack.length === styles.length, "Character ".concat(i, ": ").concat(styleStack.length - styles.length, " styles left on stack that should no longer be there"));
  }

  result = styleStack.reduceRight(function (res, openStyle) {
    return res + Object(__WEBPACK_IMPORTED_MODULE_4__util_getElementHTML__["a" /* default */])(inlineHTML(openStyle.style)).end;
  }, result);
  return result;
});

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
});

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultInlineHTML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function defaultInlineHTML(style) {
  switch (style) {
    case 'BOLD':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null);

    case 'ITALIC':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em", null);

    case 'UNDERLINE':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null);

    case 'CODE':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code", null);

    default:
      return {
        start: '',
        end: ''
      };
  }
}

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (typeObject) {
  return function (block) {
    if (typeof typeObject === 'function') {
      // handle case where typeObject is already a function
      return typeObject(block);
    }

    return typeObject[block.type];
  };
});

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBlockTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__splitReactElement__ = __webpack_require__(310);





function hasChildren(element) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(element.props.children) > 0;
}

function getBlockTags(blockHTML) {
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML === 'string') {
    return blockHTML;
  }

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(blockHTML)) {
    if (hasChildren(blockHTML)) {
      return __WEBPACK_IMPORTED_MODULE_2_react_dom_server___default.a.renderToStaticMarkup(blockHTML);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__splitReactElement__["a" /* default */])(blockHTML);
  }

  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(blockHTML.element)) {
    return Object.assign({}, blockHTML, Object(__WEBPACK_IMPORTED_MODULE_3__splitReactElement__["a" /* default */])(blockHTML.element));
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNestedBlockTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__splitReactElement__ = __webpack_require__(310);



function getNestedBlockTags(blockHTML, depth) {
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML.nest === 'function') {
    var _splitReactElement = Object(__WEBPACK_IMPORTED_MODULE_2__splitReactElement__["a" /* default */])(blockHTML.nest(depth)),
        start = _splitReactElement.start,
        end = _splitReactElement.end;

    return Object.assign({}, blockHTML, {
      nestStart: start,
      nestEnd: end
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(blockHTML.nest)) {
    var _splitReactElement2 = Object(__WEBPACK_IMPORTED_MODULE_2__splitReactElement__["a" /* default */])(blockHTML.nest),
        _start = _splitReactElement2.start,
        _end = _splitReactElement2.end;

    return Object.assign({}, blockHTML, {
      nestStart: _start,
      nestEnd: _end
    });
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // based on Draft.js' custom list depth styling

var ORDERED_LIST_TYPES = ['1', 'a', 'i'];
/* harmony default export */ __webpack_exports__["a"] = ({
  unstyled: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null),
  paragraph: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null),
  'header-one': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null),
  'header-two': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null),
  'header-three': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null),
  'header-four': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null),
  'header-five': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5", null),
  'header-six': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6", null),
  blockquote: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote", null),
  'unordered-list-item': {
    element: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null),
    nest: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null)
  },
  'ordered-list-item': {
    element: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null),
    nest: function nest(depth) {
      var type = ORDERED_LIST_TYPES[depth % 3];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
        type: type
      });
    }
  },
  media: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("figure", null),
  atomic: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("figure", null)
});

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_parseHTML__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_rangeSort__ = __webpack_require__(309);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the /src directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */




var NBSP = '&nbsp;';
var SPACE = ' '; // Arbitrary max indent

var MAX_DEPTH = 4; // used for replacing characters in HTML

/* eslint-disable no-control-regex */

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
/* eslint-enable no-control-regex */
// Block tag flow is different because LIs do not have
// a deterministic style ;_;

var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
    return maybeMiddleware(base);
  }

  return maybeMiddleware;
};

var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
  return undefined;
};

var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
  return currentStyle;
};

var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
  return undefined;
};

var defaultTextToEntity = function defaultTextToEntity(text) {
  return [];
};

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error('Got unexpected null or undefined');
};

var sanitizeDraftText = function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
};

function getEmptyChunk() {
  return {
    text: '',
    inlines: [],
    entities: [],
    blocks: []
  };
}

function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);

  if (inEntity) {
    entities[0] = inEntity;
  }

  return {
    text: SPACE,
    inlines: [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])()],
    entities: entities,
    blocks: []
  };
}

function getSoftNewlineChunk(block, depth) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();

  if (flat === true) {
    return {
      text: '\r',
      inlines: [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])()],
      entities: new Array(1),
      blocks: [{
        type: block,
        data: data,
        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
      }],
      isNewline: true
    };
  }

  return {
    text: '\n',
    inlines: [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])()],
    entities: new Array(1),
    blocks: []
  };
}

function getBlockDividerChunk(block, depth) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  return {
    text: '\r',
    inlines: [Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])()],
    entities: new Array(1),
    blocks: [{
      type: block,
      data: data,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    }]
  };
}

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case 'h1':
      return 'header-one';

    case 'h2':
      return 'header-two';

    case 'h3':
      return 'header-three';

    case 'h4':
      return 'header-four';

    case 'h5':
      return 'header-five';

    case 'h6':
      return 'header-six';

    case 'li':
      if (lastList === 'ol') {
        return 'ordered-list-item';
      }

      return 'unordered-list-item';

    case 'blockquote':
      return 'blockquote';

    case 'pre':
      return 'code-block';

    case 'div':
    case 'p':
      return 'unstyled';

    default:
      return null;
  }
}

function baseCheckBlockType(nodeName, node, lastList) {
  return getBlockTypeForTag(nodeName, lastList);
}

function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];

  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      if (htmlElement.style.fontWeight === 'bold') {
        style.add('BOLD');
      }

      if (htmlElement.style.fontStyle === 'italic') {
        style.add('ITALIC');
      }

      if (htmlElement.style.textDecoration === 'underline') {
        style.add('UNDERLINE');
      }

      if (htmlElement.style.textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }

  return currentStyle;
}

function baseProcessInlineTag(tag, node) {
  var inlineStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])();
  return processInlineTag(tag, node, inlineStyles);
}

function joinChunks(A, B) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var firstInB = B.text.slice(0, 1);
  var lastInA = A.text.slice(-1);
  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider

  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline

  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  } // Kill whitespace after blocks if flat mode is on


  if (A.text.slice(-1) === '\r' && flat === true) {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  var isNewline = A.text.length === 0 && B.isNewline;
  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks),
    isNewline: isNewline
  };
}
/*
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */


function containsSemanticBlockMarkup(html) {
  return blockTags.some(function (tag) {
    return html.indexOf("<".concat(tag)) !== -1;
  });
}

function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, inEntity) {
  var nodeName = node.nodeName.toLowerCase();
  var newBlock = false;
  var nextBlockType = 'unstyled'; // Base Case

  if (nodeName === '#text') {
    var text = node.textContent;

    if (text.trim() === '' && inBlock === null) {
      return getEmptyChunk();
    }

    if (text.trim() === '' && inBlock !== 'code-block') {
      return getWhitespaceChunk(inEntity);
    }

    if (inBlock !== 'code-block') {
      // Can't use empty string because MSWord
      text = text.replace(REGEX_LF, SPACE);
    }

    var entities = Array(text.length).fill(inEntity);
    var offsetChange = 0;
    var textEntities = checkEntityText(text, createEntity, getEntity, mergeEntityData, replaceEntityData).sort(__WEBPACK_IMPORTED_MODULE_3__util_rangeSort__["a" /* default */]);
    textEntities.forEach(function (_ref) {
      var entity = _ref.entity,
          offset = _ref.offset,
          length = _ref.length,
          result = _ref.result;
      var adjustedOffset = offset + offsetChange;

      if (result === null || result === undefined) {
        result = text.substr(adjustedOffset, length);
      }

      var textArray = text.split('');
      textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
      text = textArray.join('');
      entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
      offsetChange += result.length - length;
    });
    return {
      text: text,
      inlines: Array(text.length).fill(inlineStyle),
      entities: entities,
      blocks: []
    };
  } // BR tags


  if (nodeName === 'br') {
    var _blockType = inBlock;

    if (_blockType === null) {
      //  BR tag is at top level, treat it as an unstyled block
      return getSoftNewlineChunk('unstyled', depth, true);
    }

    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
  }

  var chunk = getEmptyChunk();
  var newChunk = null; // Inline tags

  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle); // Handle lists

  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }

    lastList = nodeName;
    inBlock = null;
  } // Block Tags


  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock);
  var blockType;
  var blockDataMap;

  if (blockInfo === false) {
    return getEmptyChunk();
  }

  blockInfo = blockInfo || {};

  if (typeof blockInfo === 'string') {
    blockType = blockInfo;
    blockDataMap = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  } else {
    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
    blockDataMap = blockInfo.data ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(blockInfo.data) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  }

  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
    newBlock = true;
  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
    chunk = getBlockDividerChunk(listItemBlockType, depth);
    inBlock = listItemBlockType;
    newBlock = true;
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
    inBlock = blockType;
    newBlock = true;
    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
    blockDataMap);
  } // Recurse through children


  var child = node.firstChild; // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
  // src="..." /></figure>). since metadata must be stored on an entity text
  // must exist for the entity to apply to. the way chunks are joined strips
  // whitespace at the end so it cannot be a space character.

  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
    child = document.createTextNode('a');
  }

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    entityId = checkEntityNode(nodeName, child, createEntity, getEntity, mergeEntityData, replaceEntityData);
    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, entityId || inEntity);
    chunk = joinChunks(chunk, newChunk, options.flat);
    var sibling = child.nextSibling; // Put in a newline to break up blocks inside blocks

    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock);
      var newBlockType = void 0;
      var newBlockData = void 0;

      if (newBlockInfo !== false) {
        newBlockInfo = newBlockInfo || {};

        if (typeof newBlockInfo === 'string') {
          newBlockType = newBlockInfo;
          newBlockData = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
        } else {
          newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
          newBlockData = newBlockInfo.data ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(newBlockInfo.data) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
        }

        chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
      }
    }

    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }

    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()), options.flat);
  }

  return chunk;
}

function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);
  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.


  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div']; // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to sta rt with.

  var chunk = genFragment(safeBody, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options); // join with previous block to prevent weirdness on paste

  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  } // Kill block delimiter at the end


  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  } // If we saw no block tags, put an unstyled one in


  if (chunk.blocks.length === 0) {
    chunk.blocks.push({
      type: 'unstyled',
      data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
      depth: 0
    });
  } // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content


  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({
      type: 'unstyled',
      data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
      depth: 0
    });
  }

  return chunk;
}

function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey) {
  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey);

  if (chunk == null) {
    return [];
  }

  var start = 0;
  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);
    var end = start + textBlock.length;
    var inlines = nullthrows(chunk).inlines.slice(start, end);
    var entities = nullthrows(chunk).entities.slice(start, end);
    var characterList = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(inlines.map(function (style, entityIndex) {
      var data = {
        style: style,
        entity: null
      };

      if (entities[entityIndex]) {
        data.entity = entities[entityIndex];
      }

      return __WEBPACK_IMPORTED_MODULE_1_draft_js__["CharacterMetadata"].create(data);
    }));
    start = end + 1;
    return new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
      key: generateKey(),
      type: nullthrows(chunk).blocks[blockIndex].type,
      data: nullthrows(chunk).blocks[blockIndex].data,
      depth: nullthrows(chunk).blocks[blockIndex].depth,
      text: textBlock,
      characterList: characterList
    });
  });
}

var convertFromHTML = function convertFromHTML(_ref2) {
  var _ref2$htmlToStyle = _ref2.htmlToStyle,
      htmlToStyle = _ref2$htmlToStyle === void 0 ? defaultHTMLToStyle : _ref2$htmlToStyle,
      _ref2$htmlToEntity = _ref2.htmlToEntity,
      htmlToEntity = _ref2$htmlToEntity === void 0 ? defaultHTMLToEntity : _ref2$htmlToEntity,
      _ref2$textToEntity = _ref2.textToEntity,
      textToEntity = _ref2$textToEntity === void 0 ? defaultTextToEntity : _ref2$textToEntity,
      _ref2$htmlToBlock = _ref2.htmlToBlock,
      htmlToBlock = _ref2$htmlToBlock === void 0 ? defaultHTMLToBlock : _ref2$htmlToBlock;
  return function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      flat: false
    };
    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__util_parseHTML__["a" /* default */];
    var generateKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1_draft_js__["genKey"];
    var contentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromText('');

    var createEntityWithContentState = function createEntityWithContentState() {
      if (contentState.createEntity) {
        var _contentState;

        contentState = (_contentState = contentState).createEntity.apply(_contentState, arguments);
        return contentState.getLastCreatedEntityKey();
      }

      return __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].create.apply(__WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"], arguments);
    };

    var getEntityWithContentState = function getEntityWithContentState() {
      if (contentState.getEntity) {
        var _contentState2;

        return (_contentState2 = contentState).getEntity.apply(_contentState2, arguments);
      }

      return __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].get.apply(__WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"], arguments);
    };

    var mergeEntityDataWithContentState = function mergeEntityDataWithContentState() {
      if (contentState.mergeEntityData) {
        var _contentState3;

        contentState = (_contentState3 = contentState).mergeEntityData.apply(_contentState3, arguments);
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].mergeData.apply(__WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"], arguments);
    };

    var replaceEntityDataWithContentState = function replaceEntityDataWithContentState() {
      if (contentState.replaceEntityData) {
        var _contentState4;

        contentState = (_contentState4 = contentState).replaceEntityData.apply(_contentState4, arguments);
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].replaceData.apply(__WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"], arguments);
    };

    var contentBlocks = convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), createEntityWithContentState, getEntityWithContentState, mergeEntityDataWithContentState, replaceEntityDataWithContentState, options, DOMBuilder, generateKey);
    var blockMap = __WEBPACK_IMPORTED_MODULE_1_draft_js__["BlockMapBuilder"].createFromArray(contentBlocks);
    var firstBlockKey = contentBlocks[0].getKey();
    return contentState.merge({
      blockMap: blockMap,
      selectionBefore: __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"].createEmpty(firstBlockKey),
      selectionAfter: __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"].createEmpty(firstBlockKey)
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
    return convertFromHTML({}).apply(void 0, arguments);
  }

  return convertFromHTML.apply(void 0, arguments);
});

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFromHTMLConfig = exports.getToHTMLConfig = exports.blocks = exports.getHexColor = exports.defaultFontFamilies = exports.namedColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var namedColors = exports.namedColors = {
  "aliceblue": "#f0f8ff",
  "antiquewhite": "#faebd7",
  "aqua": "#00ffff",
  "aquamarine": "#7fffd4",
  "azure": "#f0ffff",
  "beige": "#f5f5dc",
  "bisque": "#ffe4c4",
  "black": "#000000",
  "blanchedalmond": "#ffebcd",
  "blue": "#0000ff",
  "blueviolet": "#8a2be2",
  "brown": "#a52a2a",
  "burlywood": "#deb887",
  "cadetblue": "#5f9ea0",
  "chartreuse": "#7fff00",
  "chocolate": "#d2691e",
  "coral": "#ff7f50",
  "cornflowerblue": "#6495ed",
  "cornsilk": "#fff8dc",
  "crimson": "#dc143c",
  "cyan": "#00ffff",
  "darkblue": "#00008b",
  "darkcyan": "#008b8b",
  "darkgoldenrod": "#b8860b",
  "darkgray": "#a9a9a9",
  "darkgreen": "#006400",
  "darkkhaki": "#bdb76b",
  "darkmagenta": "#8b008b",
  "darkolivegreen": "#556b2f",
  "darkorange": "#ff8c00",
  "darkorchid": "#9932cc",
  "darkred": "#8b0000",
  "darksalmon": "#e9967a",
  "darkseagreen": "#8fbc8f",
  "darkslateblue": "#483d8b",
  "darkslategray": "#2f4f4f",
  "darkturquoise": "#00ced1",
  "darkviolet": "#9400d3",
  "deeppink": "#ff1493",
  "deepskyblue": "#00bfff",
  "dimgray": "#696969",
  "dodgerblue": "#1e90ff",
  "firebrick": "#b22222",
  "floralwhite": "#fffaf0",
  "forestgreen": "#228b22",
  "fuchsia": "#ff00ff",
  "gainsboro": "#dcdcdc",
  "ghostwhite": "#f8f8ff",
  "gold": "#ffd700",
  "goldenrod": "#daa520",
  "gray": "#808080",
  "green": "#008000",
  "greenyellow": "#adff2f",
  "honeydew": "#f0fff0",
  "hotpink": "#ff69b4",
  "indianred ": "#cd5c5c",
  "indigo": "#4b0082",
  "ivory": "#fffff0",
  "khaki": "#f0e68c",
  "lavender": "#e6e6fa",
  "lavenderblush": "#fff0f5",
  "lawngreen": "#7cfc00",
  "lemonchiffon": "#fffacd",
  "lightblue": "#add8e6",
  "lightcoral": "#f08080",
  "lightcyan": "#e0ffff",
  "lightgoldenrodyellow": "#fafad2",
  "lightgrey": "#d3d3d3",
  "lightgreen": "#90ee90",
  "lightpink": "#ffb6c1",
  "lightsalmon": "#ffa07a",
  "lightseagreen": "#20b2aa",
  "lightskyblue": "#87cefa",
  "lightslategray": "#778899",
  "lightsteelblue": "#b0c4de",
  "lightyellow": "#ffffe0",
  "lime": "#00ff00",
  "limegreen": "#32cd32",
  "linen": "#faf0e6",
  "magenta": "#ff00ff",
  "maroon": "#800000",
  "mediumaquamarine": "#66cdaa",
  "mediumblue": "#0000cd",
  "mediumorchid": "#ba55d3",
  "mediumpurple": "#9370d8",
  "mediumseagreen": "#3cb371",
  "mediumslateblue": "#7b68ee",
  "mediumspringgreen": "#00fa9a",
  "mediumturquoise": "#48d1cc",
  "mediumvioletred": "#c71585",
  "midnightblue": "#191970",
  "mintcream": "#f5fffa",
  "mistyrose": "#ffe4e1",
  "moccasin": "#ffe4b5",
  "navajowhite": "#ffdead",
  "navy": "#000080",
  "oldlace": "#fdf5e6",
  "olive": "#808000",
  "olivedrab": "#6b8e23",
  "orange": "#ffa500",
  "orangered": "#ff4500",
  "orchid": "#da70d6",
  "palegoldenrod": "#eee8aa",
  "palegreen": "#98fb98",
  "paleturquoise": "#afeeee",
  "palevioletred": "#d87093",
  "papayawhip": "#ffefd5",
  "peachpuff": "#ffdab9",
  "peru": "#cd853f",
  "pink": "#ffc0cb",
  "plum": "#dda0dd",
  "powderblue": "#b0e0e6",
  "purple": "#800080",
  "rebeccapurple": "#663399",
  "red": "#ff0000",
  "rosybrown": "#bc8f8f",
  "royalblue": "#4169e1",
  "saddlebrown": "#8b4513",
  "salmon": "#fa8072",
  "sandybrown": "#f4a460",
  "seagreen": "#2e8b57",
  "seashell": "#fff5ee",
  "sienna": "#a0522d",
  "silver": "#c0c0c0",
  "skyblue": "#87ceeb",
  "slateblue": "#6a5acd",
  "slategray": "#708090",
  "snow": "#fffafa",
  "springgreen": "#00ff7f",
  "steelblue": "#4682b4",
  "tan": "#d2b48c",
  "teal": "#008080",
  "thistle": "#d8bfd8",
  "tomato": "#ff6347",
  "turquoise": "#40e0d0",
  "violet": "#ee82ee",
  "wheat": "#f5deb3",
  "white": "#ffffff",
  "whitesmoke": "#f5f5f5",
  "yellow": "#ffff00",
  "yellowgreen": "#9acd32"
};

var getStyleValue = function getStyleValue(style) {
  return style.split('-')[1];
};
var defaultUnitExportFn = function defaultUnitExportFn(unit) {
  return unit + 'px';
};
var defaultUnitImportFn = function defaultUnitImportFn(unit) {
  return unit.replace('px', '');
};

var ignoredNodeAttributes = ['style'];
var ignoredEntityNodeAttributes = ['style', 'href', 'target', 'alt', 'title', 'id', 'controls', 'autoplay', 'loop', 'poster'];

var spreadNodeAttributes = function spreadNodeAttributes(attributesObject) {
  return Object.keys(attributesObject).reduce(function (attributeString, attributeName) {
    return attributeString + " " + attributeName + "=\"" + attributesObject[attributeName] + "\"";
  }, '').replace(/^\s$/, '');
};

var defaultFontFamilies = exports.defaultFontFamilies = [{
  name: 'Araial',
  family: 'Arial, Helvetica, sans-serif'
}, {
  name: 'Georgia',
  family: 'Georgia, serif'
}, {
  name: 'Impact',
  family: 'Impact, serif'
}, {
  name: 'Monospace',
  family: '"Courier New", Courier, monospace'
}, {
  name: 'Tahoma',
  family: "tahoma, arial, 'Hiragino Sans GB', 宋体, sans-serif"
}];

var getHexColor = exports.getHexColor = function getHexColor(color) {

  color = color.replace('color:', '').replace(';', '').replace(' ', '');

  if (/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(color)) {
    return color;
  } else if (namedColors[color]) {
    return namedColors[color];
  } else if (color.indexOf('rgb') === 0) {

    var rgbArray = color.split(',');
    var convertedColor = rgbArray.length < 3 ? null : '#' + [rgbArray[0], rgbArray[1], rgbArray[2]].map(function (x) {
      var hex = parseInt(x.replace(/\D/g, ''), 10).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');

    return (/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(convertedColor) ? convertedColor : null
    );
  } else {
    return null;
  }
};

var blocks = exports.blocks = {
  'header-one': 'h1',
  'header-two': 'h2',
  'header-three': 'h3',
  'header-four': 'h4',
  'header-five': 'h5',
  'header-six': 'h6',
  'unstyled': 'p',
  'blockquote': 'blockquote'
};

var blockTypes = Object.keys(blocks);
var blockNames = blockTypes.map(function (key) {
  return blocks[key];
});

var convertAtomicBlock = function convertAtomicBlock(block, contentState, blockNodeAttributes) {

  if (!block || !block.key) {
    return _react2.default.createElement("p", null);
  }

  var contentBlock = contentState.getBlockForKey(block.key);

  var className = blockNodeAttributes.class,
      nodeAttrAsProps = _objectWithoutProperties(blockNodeAttributes, ["class"]);

  nodeAttrAsProps.className = className;

  if (!contentBlock) {
    return _react2.default.createElement("p", null);
  }

  var entityKey = contentBlock.getEntityAt(0);

  if (!entityKey) {
    return _react2.default.createElement("p", null);
  }

  var entity = contentState.getEntity(entityKey);
  var mediaType = entity.getType().toLowerCase();

  var _block$data = block.data,
      float = _block$data.float,
      alignment = _block$data.alignment;

  var _entity$getData = entity.getData(),
      url = _entity$getData.url,
      link = _entity$getData.link,
      link_target = _entity$getData.link_target,
      width = _entity$getData.width,
      height = _entity$getData.height,
      meta = _entity$getData.meta;

  if (mediaType === 'image') {

    var imageWrapStyle = {};
    var styledClassName = '';

    if (float) {
      imageWrapStyle.float = float;
      styledClassName += ' float-' + float;
    } else if (alignment) {
      imageWrapStyle.textAlign = alignment;
      styledClassName += ' align-' + alignment;
    }

    if (link) {
      return _react2.default.createElement(
        "div",
        { className: "media-wrap image-wrap" + styledClassName, style: imageWrapStyle },
        _react2.default.createElement(
          "a",
          { style: { display: 'inline-block' }, href: link, target: link_target },
          _react2.default.createElement("img", _extends({}, nodeAttrAsProps, meta, { src: url, width: width, height: height, style: { width: width, height: height } }))
        )
      );
    } else {
      return _react2.default.createElement(
        "div",
        { className: "media-wrap image-wrap" + styledClassName, style: imageWrapStyle },
        _react2.default.createElement("img", _extends({}, nodeAttrAsProps, meta, { src: url, width: width, height: height, style: { width: width, height: height } }))
      );
    }
  } else if (mediaType === 'audio') {
    return _react2.default.createElement(
      "div",
      { className: "media-wrap audio-wrap" },
      _react2.default.createElement("audio", _extends({ controls: true }, nodeAttrAsProps, meta, { src: url }))
    );
  } else if (mediaType === 'video') {
    return _react2.default.createElement(
      "div",
      { className: "media-wrap video-wrap" },
      _react2.default.createElement("video", _extends({ controls: true }, nodeAttrAsProps, meta, { src: url, width: width, height: height }))
    );
  } else if (mediaType === 'embed') {
    return _react2.default.createElement(
      "div",
      { className: "media-wrap embed-wrap" },
      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: url } })
    );
  } else if (mediaType === 'hr') {
    return _react2.default.createElement("hr", null);
  } else {
    return _react2.default.createElement("p", null);
  }
};

var entityToHTML = function entityToHTML(options) {
  return function (entity, originalText) {
    var entityExportFn = options.entityExportFn;

    var entityType = entity.type.toLowerCase();

    if (entityExportFn) {
      var customOutput = entityExportFn(entity, originalText);
      if (customOutput) {
        return customOutput;
      }
    }

    if (entityType === 'link') {
      var _ref = entity.data.nodeAttributes || {},
          className = _ref.class,
          nodeAttrAsProps = _objectWithoutProperties(_ref, ["class"]);

      nodeAttrAsProps.className = className;
      return _react2.default.createElement("a", _extends({ href: entity.data.href, target: entity.data.target }, nodeAttrAsProps));
    }
  };
};

var styleToHTML = function styleToHTML(options) {
  return function (style) {

    var unitExportFn = options.unitExportFn || defaultUnitExportFn;

    if (options.styleExportFn) {
      var customOutput = options.styleExportFn(style, options);
      if (customOutput) {
        return customOutput;
      }
    }

    style = style.toLowerCase();

    if (style === 'strikethrough') {
      return _react2.default.createElement("span", { style: { textDecoration: 'line-through' } });
    } else if (style === 'superscript') {
      return _react2.default.createElement("sup", null);
    } else if (style === 'subscript') {
      return _react2.default.createElement("sub", null);
    } else if (style.indexOf('color-') === 0) {
      return _react2.default.createElement("span", { style: { color: '#' + getStyleValue(style) } });
    } else if (style.indexOf('bgcolor-') === 0) {
      return _react2.default.createElement("span", { style: { backgroundColor: '#' + getStyleValue(style) } });
    } else if (style.indexOf('fontsize-') === 0) {
      return _react2.default.createElement("span", { style: { fontSize: unitExportFn(getStyleValue(style), 'font-size', 'html') } });
    } else if (style.indexOf('lineheight-') === 0) {
      return _react2.default.createElement("span", { style: { lineHeight: unitExportFn(getStyleValue(style), 'line-height', 'html') } });
    } else if (style.indexOf('letterspacing-') === 0) {
      return _react2.default.createElement("span", { style: { letterSpacing: unitExportFn(getStyleValue(style), 'letter-spacing', 'html') } });
    } else if (style.indexOf('fontfamily-') === 0) {
      var fontFamily = options.fontFamilies.find(function (item) {
        return item.name.toLowerCase() === getStyleValue(style);
      });
      if (!fontFamily) return;
      return _react2.default.createElement("span", { style: { fontFamily: fontFamily.family } });
    }
  };
};

var blockToHTML = function blockToHTML(options) {
  return function (block) {
    var blockExportFn = options.blockExportFn,
        contentState = options.contentState;


    if (blockExportFn) {
      var customOutput = blockExportFn(contentState, block);
      if (customOutput) {
        return customOutput;
      }
    }

    var blockStyle = '';

    var blockType = block.type.toLowerCase();
    var _block$data2 = block.data,
        textAlign = _block$data2.textAlign,
        textIndent = _block$data2.textIndent,
        _block$data2$nodeAttr = _block$data2.nodeAttributes,
        nodeAttributes = _block$data2$nodeAttr === undefined ? {} : _block$data2$nodeAttr;

    var attributeString = spreadNodeAttributes(nodeAttributes);

    if (textAlign || textIndent) {

      blockStyle = ' style="';

      if (textAlign) {
        blockStyle += "text-align:" + textAlign + ";";
      }

      if (textIndent && !isNaN(textIndent) && textIndent > 0) {
        blockStyle += "text-indent:" + textIndent * 2 + "em;";
      }

      blockStyle += '"';
    }

    if (blockType === 'atomic') {
      return convertAtomicBlock(block, contentState, nodeAttributes);
    } else if (blockType === 'code-block') {

      var previousBlock = contentState.getBlockBefore(block.key);
      var nextBlock = contentState.getBlockAfter(block.key);
      var previousBlockType = previousBlock && previousBlock.getType();
      var nextBlockType = nextBlock && nextBlock.getType();

      var start = '';
      var end = '';

      if (previousBlockType !== 'code-block') {
        start = "<pre" + attributeString + "><code>";
      } else {
        start = '';
      }

      if (nextBlockType !== 'code-block') {
        end = '</code></pre>';
      } else {
        end = '<br/>';
      }

      return { start: start, end: end };
    } else if (blocks[blockType]) {
      return {
        start: "<" + blocks[blockType] + blockStyle + attributeString + ">",
        end: "</" + blocks[blockType] + ">"
      };
    } else if (blockType === 'unordered-list-item') {
      return {
        start: "<li" + blockStyle + attributeString + ">",
        end: '</li>',
        nest: _react2.default.createElement("ul", null)
      };
    } else if (blockType === 'ordered-list-item') {
      return {
        start: "<li" + blockStyle + attributeString + ">",
        end: '</li>',
        nest: _react2.default.createElement("ol", null)
      };
    }
  };
};

var htmlToStyle = function htmlToStyle(options, source) {
  return function (nodeName, node, currentStyle) {

    if (!node || !node.style) {
      return currentStyle;
    }

    var unitImportFn = options.unitImportFn || defaultUnitImportFn;
    var newStyle = currentStyle;

    [].forEach.call(node.style, function (style) {

      if (nodeName === 'span' && style === 'color') {
        var color = getHexColor(node.style.color);
        newStyle = color ? newStyle.add('COLOR-' + color.replace('#', '').toUpperCase()) : newStyle;
      } else if (nodeName === 'span' && style === 'background-color') {
        var _color = getHexColor(node.style.backgroundColor);
        newStyle = _color ? newStyle.add('BGCOLOR-' + _color.replace('#', '').toUpperCase()) : newStyle;
      } else if (nodeName === 'span' && style === 'font-size') {
        newStyle = newStyle.add('FONTSIZE-' + unitImportFn(node.style.fontSize, 'font-size', source));
      } else if (nodeName === 'span' && style === 'line-height' && !isNaN(parseFloat(node.style.lineHeight, 10))) {
        newStyle = newStyle.add('LINEHEIGHT-' + unitImportFn(node.style.lineHeight, 'line-height', source));
      } else if (nodeName === 'span' && style === 'letter-spacing' && !isNaN(parseFloat(node.style.letterSpacing, 10))) {
        newStyle = newStyle.add('LETTERSPACING-' + unitImportFn(node.style.letterSpacing, 'letter-spacing', source));
      } else if (nodeName === 'span' && style === 'text-decoration') {
        if (node.style.textDecoration === 'line-through') {
          newStyle = newStyle.add('STRIKETHROUGH');
        } else if (node.style.textDecoration === 'underline') {
          newStyle = newStyle.add('UNDERLINE');
        }
      } else if (nodeName === 'span' && style === 'font-family') {
        var fontFamily = options.fontFamilies.find(function (item) {
          return item.family.toLowerCase() === node.style.fontFamily.toLowerCase();
        });
        if (!fontFamily) return;
        newStyle = newStyle.add('FONTFAMILY-' + fontFamily.name.toUpperCase());
      }
    });

    if (nodeName === 'sup') {
      newStyle = newStyle.add('SUPERSCRIPT');
    } else if (nodeName === 'sub') {
      newStyle = newStyle.add('SUBSCRIPT');
    }

    options.styleImportFn && (newStyle = options.styleImportFn(nodeName, node, newStyle, source) || newStyle);
    return newStyle;
  };
};

var htmlToEntity = function htmlToEntity(options, source) {
  return function (nodeName, node, createEntity) {

    if (options && options.entityImportFn) {
      var customInput = options.entityImportFn(nodeName, node, createEntity, source);
      if (customInput) {
        return customInput;
      }
    }

    nodeName = nodeName.toLowerCase();

    var alt = node.alt,
        title = node.title,
        id = node.id,
        controls = node.controls,
        autoplay = node.autoplay,
        loop = node.loop,
        poster = node.poster;

    var meta = {};
    var nodeAttributes = {};

    id && (meta.id = id);
    alt && (meta.alt = alt);
    title && (meta.title = title);
    controls && (meta.controls = controls);
    autoplay && (meta.autoPlay = autoplay);
    loop && (meta.loop = loop);
    poster && (meta.poster = poster);

    node.attributes && Object.keys(node.attributes).forEach(function (key) {
      var attr = node.attributes[key];
      ignoredEntityNodeAttributes.indexOf(attr.name) === -1 && (nodeAttributes[attr.name] = attr.value);
    });

    if (nodeName === 'a' && !node.querySelectorAll('img').length) {
      var href = node.getAttribute('href');
      var _target = node.getAttribute('target');
      return createEntity('LINK', 'MUTABLE', { href: href, target: _target, nodeAttributes: nodeAttributes });
    } else if (nodeName === 'audio') {
      return createEntity('AUDIO', 'IMMUTABLE', { url: node.getAttribute('src'), meta: meta, nodeAttributes: nodeAttributes });
    } else if (nodeName === 'video') {
      return createEntity('VIDEO', 'IMMUTABLE', { url: node.getAttribute('src'), meta: meta, nodeAttributes: nodeAttributes });
    } else if (nodeName === 'img') {

      var parentNode = node.parentNode;
      var entityData = { meta: meta };
      var _node$style = node.style,
          width = _node$style.width,
          height = _node$style.height;


      entityData.url = node.getAttribute('src');
      width && (entityData.width = width);
      height && (entityData.height = height);

      if (parentNode.nodeName.toLowerCase() === 'a') {
        entityData.link = parentNode.getAttribute('href');
        entityData.link_target = parentNode.getAttribute('target');
      }

      return createEntity('IMAGE', 'IMMUTABLE', entityData);
    } else if (nodeName === 'hr') {
      return createEntity('HR', 'IMMUTABLE', {});
    } else if (node.parentNode && node.parentNode.classList.contains('embed-wrap')) {

      var embedContent = node.innerHTML || node.outerHTML;

      if (embedContent) {
        return createEntity('EMBED', 'IMMUTABLE', {
          url: embedContent
        });
      }
    }
  };
};

var htmlToBlock = function htmlToBlock(options, source) {
  return function (nodeName, node) {

    if (options && options.blockImportFn) {
      var customInput = options.blockImportFn(nodeName, node, source);
      if (customInput) {
        return customInput;
      }
    }

    var nodeAttributes = {};
    var nodeStyle = node.style || {};

    node.attributes && Object.keys(node.attributes).forEach(function (key) {
      var attr = node.attributes[key];
      ignoredNodeAttributes.indexOf(attr.name) === -1 && (nodeAttributes[attr.name] = attr.value);
    });

    if (node.classList && node.classList.contains('media-wrap')) {

      return {
        type: 'atomic',
        data: {
          nodeAttributes: nodeAttributes,
          float: nodeStyle.float,
          alignment: nodeStyle.textAlign
        }
      };
    } else if (nodeName === 'img') {

      return {
        type: 'atomic',
        data: {
          nodeAttributes: nodeAttributes,
          float: nodeStyle.float,
          alignment: nodeStyle.textAlign
        }
      };
    } else if (nodeName === 'hr') {

      return {
        type: 'atomic',
        data: { nodeAttributes: nodeAttributes }
      };
    } else if (nodeName === 'pre') {

      node.innerHTML = node.innerHTML.replace(/<code(.*?)>/g, '').replace(/<\/code>/g, '');

      return {
        type: 'code-block',
        data: { nodeAttributes: nodeAttributes }
      };
    } else if (blockNames.indexOf(nodeName) !== -1) {

      var blockData = { nodeAttributes: nodeAttributes };

      if (nodeStyle.textAlign) {
        blockData.textAlign = nodeStyle.textAlign;
      }

      if (nodeStyle.textIndent) {
        blockData.textIndent = /^\d+em$/.test(nodeStyle.textIndent) ? Math.ceil(parseInt(nodeStyle.textIndent, 10) / 2) : 1;
      }

      return {
        type: blockTypes[blockNames.indexOf(nodeName)],
        data: blockData
      };
    }
  };
};

var getToHTMLConfig = exports.getToHTMLConfig = function getToHTMLConfig(options) {

  return {
    styleToHTML: styleToHTML(options),
    entityToHTML: entityToHTML(options),
    blockToHTML: blockToHTML(options)
  };
};

var getFromHTMLConfig = exports.getFromHTMLConfig = function getFromHTMLConfig(options) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknow';


  return {
    htmlToStyle: htmlToStyle(options, source),
    htmlToEntity: htmlToEntity(options, source),
    htmlToBlock: htmlToBlock(options, source)
  };
};
//# sourceMappingURL=configs.js.map

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var braftUniqueIndex = 0;

var UniqueIndex = exports.UniqueIndex = function UniqueIndex() {
  return braftUniqueIndex += 1;
};

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _namedColors = {
  "aliceblue": "#f0f8ff",
  "antiquewhite": "#faebd7",
  "aqua": "#00ffff",
  "aquamarine": "#7fffd4",
  "azure": "#f0ffff",
  "beige": "#f5f5dc",
  "bisque": "#ffe4c4",
  "black": "#000000",
  "blanchedalmond": "#ffebcd",
  "blue": "#0000ff",
  "blueviolet": "#8a2be2",
  "brown": "#a52a2a",
  "burlywood": "#deb887",
  "cadetblue": "#5f9ea0",
  "chartreuse": "#7fff00",
  "chocolate": "#d2691e",
  "coral": "#ff7f50",
  "cornflowerblue": "#6495ed",
  "cornsilk": "#fff8dc",
  "crimson": "#dc143c",
  "cyan": "#00ffff",
  "darkblue": "#00008b",
  "darkcyan": "#008b8b",
  "darkgoldenrod": "#b8860b",
  "darkgray": "#a9a9a9",
  "darkgreen": "#006400",
  "darkkhaki": "#bdb76b",
  "darkmagenta": "#8b008b",
  "darkolivegreen": "#556b2f",
  "darkorange": "#ff8c00",
  "darkorchid": "#9932cc",
  "darkred": "#8b0000",
  "darksalmon": "#e9967a",
  "darkseagreen": "#8fbc8f",
  "darkslateblue": "#483d8b",
  "darkslategray": "#2f4f4f",
  "darkturquoise": "#00ced1",
  "darkviolet": "#9400d3",
  "deeppink": "#ff1493",
  "deepskyblue": "#00bfff",
  "dimgray": "#696969",
  "dodgerblue": "#1e90ff",
  "firebrick": "#b22222",
  "floralwhite": "#fffaf0",
  "forestgreen": "#228b22",
  "fuchsia": "#ff00ff",
  "gainsboro": "#dcdcdc",
  "ghostwhite": "#f8f8ff",
  "gold": "#ffd700",
  "goldenrod": "#daa520",
  "gray": "#808080",
  "green": "#008000",
  "greenyellow": "#adff2f",
  "honeydew": "#f0fff0",
  "hotpink": "#ff69b4",
  "indianred ": "#cd5c5c",
  "indigo": "#4b0082",
  "ivory": "#fffff0",
  "khaki": "#f0e68c",
  "lavender": "#e6e6fa",
  "lavenderblush": "#fff0f5",
  "lawngreen": "#7cfc00",
  "lemonchiffon": "#fffacd",
  "lightblue": "#add8e6",
  "lightcoral": "#f08080",
  "lightcyan": "#e0ffff",
  "lightgoldenrodyellow": "#fafad2",
  "lightgrey": "#d3d3d3",
  "lightgreen": "#90ee90",
  "lightpink": "#ffb6c1",
  "lightsalmon": "#ffa07a",
  "lightseagreen": "#20b2aa",
  "lightskyblue": "#87cefa",
  "lightslategray": "#778899",
  "lightsteelblue": "#b0c4de",
  "lightyellow": "#ffffe0",
  "lime": "#00ff00",
  "limegreen": "#32cd32",
  "linen": "#faf0e6",
  "magenta": "#ff00ff",
  "maroon": "#800000",
  "mediumaquamarine": "#66cdaa",
  "mediumblue": "#0000cd",
  "mediumorchid": "#ba55d3",
  "mediumpurple": "#9370d8",
  "mediumseagreen": "#3cb371",
  "mediumslateblue": "#7b68ee",
  "mediumspringgreen": "#00fa9a",
  "mediumturquoise": "#48d1cc",
  "mediumvioletred": "#c71585",
  "midnightblue": "#191970",
  "mintcream": "#f5fffa",
  "mistyrose": "#ffe4e1",
  "moccasin": "#ffe4b5",
  "navajowhite": "#ffdead",
  "navy": "#000080",
  "oldlace": "#fdf5e6",
  "olive": "#808000",
  "olivedrab": "#6b8e23",
  "orange": "#ffa500",
  "orangered": "#ff4500",
  "orchid": "#da70d6",
  "palegoldenrod": "#eee8aa",
  "palegreen": "#98fb98",
  "paleturquoise": "#afeeee",
  "palevioletred": "#d87093",
  "papayawhip": "#ffefd5",
  "peachpuff": "#ffdab9",
  "peru": "#cd853f",
  "pink": "#ffc0cb",
  "plum": "#dda0dd",
  "powderblue": "#b0e0e6",
  "purple": "#800080",
  "rebeccapurple": "#663399",
  "red": "#ff0000",
  "rosybrown": "#bc8f8f",
  "royalblue": "#4169e1",
  "saddlebrown": "#8b4513",
  "salmon": "#fa8072",
  "sandybrown": "#f4a460",
  "seagreen": "#2e8b57",
  "seashell": "#fff5ee",
  "sienna": "#a0522d",
  "silver": "#c0c0c0",
  "skyblue": "#87ceeb",
  "slateblue": "#6a5acd",
  "slategray": "#708090",
  "snow": "#fffafa",
  "springgreen": "#00ff7f",
  "steelblue": "#4682b4",
  "tan": "#d2b48c",
  "teal": "#008080",
  "thistle": "#d8bfd8",
  "tomato": "#ff6347",
  "turquoise": "#40e0d0",
  "violet": "#ee82ee",
  "wheat": "#f5deb3",
  "white": "#ffffff",
  "whitesmoke": "#f5f5f5",
  "yellow": "#ffff00",
  "yellowgreen": "#9acd32"
};

var _getHexColor = function _getHexColor(color) {

  color = color.replace('color:', '').replace(';', '').replace(' ', '');

  if (/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(color)) {
    return color;
  } else if (namedColors[color]) {
    return namedColors[color];
  } else if (color.indexOf('rgb') === 0) {

    var rgbArray = color.split(',');
    var convertedColor = rgbArray.length < 3 ? null : '#' + [rgbArray[0], rgbArray[1], rgbArray[2]].map(function (x) {
      var hex = parseInt(x.replace(/\D/g, ''), 10).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');

    return (/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(convertedColor) ? convertedColor : null
    );
  } else {
    return null;
  }
};

var namedColors = exports.namedColors = _namedColors;
var getHexColor = exports.getHexColor = _getHexColor;

var detectColorsFromHTMLString = exports.detectColorsFromHTMLString = function detectColorsFromHTMLString(html) {
  return typeof html !== 'string' ? [] : (html.match(/color:[^;]{3,24};/g) || []).map(getHexColor).filter(function (color) {
    return color;
  });
};

var detectColorsFromDraftState = exports.detectColorsFromDraftState = function detectColorsFromDraftState(draftState) {

  var result = [];

  if (!draftState || !draftState.blocks || !draftState.blocks.length) {
    return result;
  }

  draftState.blocks.forEach(function (block) {
    if (block && block.inlineStyleRanges && block.inlineStyleRanges.length) {
      block.inlineStyleRanges.forEach(function (inlineStyle) {
        if (inlineStyle.style && inlineStyle.style.indexOf('COLOR-') >= 0) {
          result.push('#' + inlineStyle.style.split('COLOR-')[1]);
        }
      });
    }
  });

  return result.filter(function (color) {
    return color;
  });
};

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var compressImage = exports.compressImage = function compressImage(url) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1280;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 800;


  return new Promise(function (resolve, reject) {

    var image = new Image();

    image.src = url;

    image.onerror = function (error) {
      reject(error);
    };

    image.onload = function () {

      try {

        var compressCanvas = document.createElement('canvas');
        var scale = this.width > width || this.height > height ? this.width > this.height ? width / this.width : height / this.height : 1;

        compressCanvas.width = this.width * scale;
        compressCanvas.height = this.height * scale;

        var canvasContext = compressCanvas.getContext('2d');
        canvasContext.drawImage(this, 0, 0, compressCanvas.width, compressCanvas.height);

        resolve({
          url: compressCanvas.toDataURL('image/png', 1),
          width: compressCanvas.width,
          height: compressCanvas.height
        });
      } catch (error) {
        reject(error);
      }
    };
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UniqueIndex = exports.UniqueIndex = function UniqueIndex() {

  if (isNaN(window.__BRAFT_MM_UNIQUE_INDEX__)) {
    window.__BRAFT_MM_UNIQUE_INDEX__ = 1;
  } else {
    window.__BRAFT_MM_UNIQUE_INDEX__ += 1;
  }

  return window.__BRAFT_MM_UNIQUE_INDEX__;
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: 'Kaldır',
  cancel: 'İptal',
  confirm: 'Onayla',
  insert: 'Seçilenleri ekle',
  width: 'Genişlik',
  height: 'Yükseklik',
  image: 'Resim',
  video: 'Görüntü',
  audio: 'Ses',
  embed: 'Nesne göm',
  caption: 'Kitaplık',
  dragTip: 'Tıkla ya da dosya sürükle',
  dropTip: 'Yüklemek için sürükleyin',
  selectAll: 'Tümünü seç',
  deselect: 'Seçimi kaldır',
  removeSelected: 'Seçilenleri kaldır',
  externalInputPlaceHolder: 'Kaynak adı|Kaynak bağlantısı',
  externalInputTip: 'Kaynak asını ve bağlantısını "|" ile ayırın ve Enter\' a basın.',
  addLocalFile: 'Yerel\' den ekle',
  addExternalSource: 'Harici kaynaktan ekle',
  unnamedItem: 'Adlandırılmamış giriş',
  confirmInsert: 'Seçilenleri ekle'
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: '削除する',
  cancel: 'キャンセル',
  confirm: '確認する',
  insert: '選択したアイテムを挿入',
  width: '幅',
  height: '身長',
  image: '絵',
  video: 'ビデオ',
  audio: '音声',
  embed: '埋め込みメディア',
  caption: 'メディアライブラリー',
  dragTip: 'ファイルをこの位置までクリックまたはドラッグします',
  dropTip: 'アップロードするマウスを放します',
  selectAll: 'すべて選択',
  deselect: '選択を解除',
  removeSelected: '選択したアイテムを削除',
  externalInputPlaceHolder: 'リソース名|リソースアドレス',
  externalInputTip: 'リソース名とリソースアドレスは "|"で区切ります。',
  addLocalFile: 'ローカルリソースを追加する',
  addExternalSource: 'ネットワークリソースを追加する',
  unnamedItem: '名前のないアイテム',
  confirmInsert: '選択したアイテムを挿入'
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: '삭제',
  cancel: '취소',
  confirm: '확인',
  insert: '선택한항목삽입',
  width: '너비',
  height: '높이',
  image: '그림',
  video: '비디오',
  audio: '오디오',
  embed: '임베디드미디어',
  caption: '미디어라이브러리',
  dragTip: '파일을 클릭하거나이 지점으로 드래그하십시오.',
  dropTip: '업로드하려면마우스를놓으십시오.',
  selectAll: '모두 선택',
  deselect: '선택 취소',
  removeSelected: '선택한 항목 삭제',
  externalInputPlaceHolder: '리소스 이름 | 리소스 주소',
  externalInputTip: '자원 이름과 자원 주소를 "|"',
  addLocalFile: '로컬 리소스 추가',
  addExternalSource: '네트워크 리소스 추가',
  unnamedItem: '이름없는 항목',
  confirmInsert: '선택한 항목 삽입'
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: 'Usuń',
  cancel: 'Anuluj',
  confirm: 'Potwierdź',
  insert: 'Wstaw wybrane elementy',
  width: 'Szerokość',
  height: 'Wysokość',
  image: 'Obraz',
  video: 'Wideo',
  audio: 'Dźwięk',
  embed: 'Obiekt',
  caption: 'Biblioteka mediów',
  dragTip: 'Kliknij lub przenieś tu pliki',
  dropTip: 'Upuść aby dodać plik',
  selectAll: 'Zaznacz wszystko',
  deselect: 'Odznacz',
  removeSelected: 'Usuń wybrane',
  externalInputPlaceHolder: 'Nazwa źródła|Adres URL',
  externalInputTip: 'Oddziel nazwę i adres URL źródła z pomocą "|", Potwierdź Enter-em',
  addLocalFile: 'Dodaj z komputera',
  addExternalSource: 'Dodaj z Internetu',
  unnamedItem: 'Bez nazwy',
  confirmInsert: 'Dodaj wybrane elementy'
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: '删除',
  cancel: '取消',
  confirm: '确认',
  insert: '插入所选项目',
  width: '宽度',
  height: '高度',
  image: '图片',
  video: '视频',
  audio: '音频',
  embed: '嵌入式媒体',
  caption: '媒体库',
  dragTip: '点击或拖动文件至此',
  dropTip: '放开鼠标以上传',
  selectAll: '选择全部',
  deselect: '取消选择',
  removeSelected: '删除选中项目',
  externalInputPlaceHolder: '资源名称|资源地址',
  externalInputTip: '使用“|”分隔资源名称和资源地址',
  addLocalFile: '添加本地资源',
  addExternalSource: '添加网络资源',
  unnamedItem: '未命名项目',
  confirmInsert: '插入选中项目'
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: '删除',
  cancel: '取消',
  confirm: '确认',
  insert: '插入所选项目',
  width: '宽度',
  height: '高度',
  image: '图片',
  video: '视频',
  audio: '音频',
  embed: '嵌入式媒体',
  caption: '媒体库',
  dragTip: '点击或拖动文件至此',
  dropTip: '放开鼠标以上传',
  selectAll: '选择全部',
  deselect: '取消选择',
  removeSelected: '删除选中项目',
  externalInputPlaceHolder: '资源名称|资源地址',
  externalInputTip: '使用“|”分隔资源名称和资源地址',
  addLocalFile: '添加本地资源',
  addExternalSource: '添加网络资源',
  unnamedItem: '未命名项目',
  confirmInsert: '插入选中项目'
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  remove: 'Remove',
  cancel: 'Cancel',
  confirm: 'Confirm',
  insert: 'Insert Selected Items',
  width: 'Width',
  height: 'Height',
  image: 'Image',
  video: 'Video',
  audio: 'Audio',
  embed: 'Embed',
  caption: 'Media Library',
  dragTip: 'Click Or Drag Files Here',
  dropTip: 'Drop To Upload',
  selectAll: 'Select All',
  deselect: 'Deselect',
  removeSelected: 'Remove Selected Items',
  externalInputPlaceHolder: 'Source Name|Source URL',
  externalInputTip: 'Split source name and source URL with "|", confirm by hit Enter.',
  addLocalFile: 'Add from local',
  addExternalSource: 'Add from Internet',
  unnamedItem: 'Unnamed Item',
  confirmInsert: 'Insert selected items'
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = __webpack_require__(9);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(8);

var _zh2 = _interopRequireDefault(_zh);

var _zhHant = __webpack_require__(7);

var _zhHant2 = _interopRequireDefault(_zhHant);

var _pl = __webpack_require__(6);

var _pl2 = _interopRequireDefault(_pl);

var _kr = __webpack_require__(5);

var _kr2 = _interopRequireDefault(_kr);

var _jpn = __webpack_require__(4);

var _jpn2 = _interopRequireDefault(_jpn);

var _tr = __webpack_require__(3);

var _tr2 = _interopRequireDefault(_tr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  "en": _en2.default,
  "zh": _zh2.default,
  "zh-hant": _zhHant2.default,
  "pl": _pl2.default,
  "kr": _kr2.default,
  "jpn": _jpn2.default,
  "tr": _tr2.default
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(11);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:font/ttf;base64,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"

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(15);
exports = module.exports = __webpack_require__(14)(false);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'bf-icons';\n  src: url(" + escape(__webpack_require__(13)) + ") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal; }\n\n.braft-finder [class^=\"braft-icon-\"], .braft-finder [class*=\" braft-icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'bf-icons' !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.braft-finder .braft-icon-code:before {\n  content: \"\\E903\"; }\n\n.braft-finder .braft-icon-pause:before {\n  content: \"\\E034\"; }\n\n.braft-finder .braft-icon-play_arrow:before {\n  content: \"\\E037\"; }\n\n.braft-finder .braft-icon-bin:before {\n  content: \"\\E9AC\"; }\n\n.braft-finder .braft-icon-replay:before {\n  content: \"\\E042\"; }\n\n.braft-finder .braft-icon-close:before {\n  content: \"\\E913\"; }\n\n.braft-finder .braft-icon-music:before {\n  content: \"\\E90E\"; }\n\n.braft-finder .braft-icon-camera:before {\n  content: \"\\E911\"; }\n\n.braft-finder .braft-icon-file-text:before {\n  content: \"\\E926\"; }\n\n.braft-finder .braft-icon-film:before {\n  content: \"\\E91C\"; }\n\n.braft-finder .braft-icon-paste:before {\n  content: \"\\E92D\"; }\n\n.braft-finder .braft-icon-spinner:before {\n  content: \"\\E980\"; }\n\n.braft-finder .braft-icon-media:before {\n  content: \"\\E90F\"; }\n\n.braft-finder .braft-icon-add:before {\n  content: \"\\E918\"; }\n\n.braft-finder .braft-icon-done:before {\n  content: \"\\E912\"; }\n\n.braft-finder .braft-icon-drop-down:before {\n  content: \"\\E906\"; }\n\n.braft-finder .braft-icon-drop-up:before {\n  content: \"\\E909\"; }\n\n.braft-finder .braft-icon-help:before {\n  content: \"\\E902\"; }\n\n.braft-finder .braft-icon-info:before {\n  content: \"\\E901\"; }\n\n.braft-finder .braft-icon-menu:before {\n  content: \"\\E908\"; }\n\n.pull-left {\n  float: left; }\n\n.pull-right {\n  float: right; }\n\n.braft-finder .bf-uploader {\n  position: relative;\n  height: 370px;\n  margin: 0; }\n  .braft-finder .bf-uploader.draging .bf-list-wrap,\n  .braft-finder .bf-uploader.draging .bf-add-external {\n    pointer-events: none; }\n  .braft-finder .bf-uploader input::-webkit-input-placeholder {\n    color: #ccc; }\n  .braft-finder .bf-uploader input::-moz-placeholder {\n    color: #ccc; }\n  .braft-finder .bf-uploader input::-ms-input-placeholder {\n    color: #ccc; }\n\n.braft-finder .bf-list-wrap {\n  position: relative;\n  height: 370px; }\n\n.braft-finder .bf-list-tools {\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 20px;\n  padding: 0 15px;\n  background-color: #fff; }\n  .braft-finder .bf-list-tools span {\n    height: 26px;\n    font-size: 12px;\n    line-height: 20px;\n    cursor: pointer;\n    user-select: none; }\n    .braft-finder .bf-list-tools span[disabled] {\n      opacity: .3;\n      pointer-events: none; }\n  .braft-finder .bf-list-tools .bf-select-all,\n  .braft-finder .bf-list-tools .bf-deselect-all {\n    float: left;\n    margin-right: 5px;\n    color: #bbb; }\n    .braft-finder .bf-list-tools .bf-select-all:hover,\n    .braft-finder .bf-list-tools .bf-deselect-all:hover {\n      color: #3498db; }\n  .braft-finder .bf-list-tools .bf-remove-selected {\n    float: right;\n    color: #e74c3c; }\n    .braft-finder .bf-list-tools .bf-remove-selected:hover {\n      color: #c92e1e; }\n\n.braft-finder .bf-list {\n  position: absolute;\n  z-index: 1;\n  top: 30px;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  margin: 0;\n  padding: 0 10px;\n  list-style: none;\n  overflow: auto; }\n  .braft-finder .bf-list::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    background-color: #fff; }\n  .braft-finder .bf-list::-webkit-scrollbar-track {\n    background-color: #fff; }\n  .braft-finder .bf-list::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.1); }\n\n.braft-finder .bf-item,\n.braft-finder .bf-add-item {\n  position: relative;\n  display: block;\n  float: left;\n  width: 113px;\n  height: 113px;\n  margin: 5px;\n  overflow: hidden;\n  border-radius: 3px; }\n\n.braft-finder .bf-item.uploading {\n  pointer-events: none; }\n\n.braft-finder .bf-item.error::before {\n  display: block;\n  content: \"\\E901\"; }\n\n.braft-finder .bf-item.error::after {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(231, 76, 60, 0.8);\n  content: ''; }\n\n.braft-finder .bf-item.error:hover::after {\n  background-color: rgba(231, 76, 60, 0.9); }\n\n.braft-finder .bf-item.error .bf-item-uploading {\n  display: none; }\n\n.braft-finder .bf-add-item {\n  background-color: #ecedef;\n  color: #999; }\n  .braft-finder .bf-add-item:hover {\n    background-color: #e1e2e3; }\n  .braft-finder .bf-add-item i {\n    display: block;\n    width: 113px;\n    height: 113px;\n    font-size: 48px;\n    line-height: 113px;\n    text-align: center; }\n  .braft-finder .bf-add-item input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer; }\n\n.braft-finder .bf-item::before {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 113px;\n  height: 113px;\n  color: #fff;\n  font-size: 48px;\n  font-family: 'bf-icons';\n  line-height: 113px;\n  text-align: center; }\n\n.braft-finder .bf-item::after {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(52, 152, 219, 0);\n  content: ''; }\n\n.braft-finder .bf-item:hover::after {\n  background-color: rgba(52, 152, 219, 0.3); }\n\n.braft-finder .bf-item:hover .bf-item-remove {\n  display: block; }\n\n.braft-finder .bf-item.active::before {\n  display: block;\n  content: \"\\E912\"; }\n\n.braft-finder .bf-item.active::after {\n  background-color: rgba(52, 152, 219, 0.6); }\n\n.braft-finder .bf-item.active:hover::after {\n  background-color: rgba(52, 152, 219, 0.8); }\n\n.braft-finder .bf-item.active:hover .bf-item-remove {\n  display: none; }\n\n.braft-finder .bf-item-uploading {\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 3;\n  top: 52px;\n  left: 10px;\n  width: 93px;\n  height: 10px;\n  overflow: hidden;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 5px;\n  box-shadow: 0 0 0 100px rgba(0, 0, 0, 0.5); }\n\n.braft-finder .bf-item-uploading-bar {\n  height: 10px;\n  background-color: #3498db;\n  border-radius: 0; }\n\n.braft-finder .bf-item-remove {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  width: 28px;\n  height: 28px;\n  color: #fff;\n  font-size: 18px;\n  line-height: 28px;\n  text-align: center;\n  cursor: pointer; }\n  .braft-finder .bf-item-remove:hover {\n    color: #e74c3c; }\n\n.braft-finder .bf-item-title {\n  display: none;\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  padding: 0 5px;\n  overflow: hidden;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), black);\n  color: #fff;\n  font-size: 12px;\n  line-height: 55px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.braft-finder .bf-image {\n  width: 100%;\n  height: 100%;\n  background-color: #eee;\n  user-select: none; }\n  .braft-finder .bf-image img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover; }\n\n.braft-finder .bf-video {\n  background-color: #8e44ad; }\n\n.braft-finder .bf-audio {\n  background-color: #f39c12; }\n\n.braft-finder .bf-embed {\n  background-color: #f1c40f; }\n\n.braft-finder .bf-icon {\n  display: block;\n  width: 113px;\n  height: 113px;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  text-decoration: none; }\n  .braft-finder .bf-icon i, .braft-finder .bf-icon span {\n    display: block; }\n  .braft-finder .bf-icon i {\n    margin-top: 35px;\n    font-size: 24px; }\n  .braft-finder .bf-icon span {\n    width: 103px;\n    margin: 10px auto;\n    overflow: hidden;\n    font-size: 12px;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n\n.braft-finder .bf-drag-uploader {\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 15px;\n  left: 15px;\n  height: 100%;\n  background-color: #fff;\n  border: dashed 1px #bbb;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none; }\n  .braft-finder .bf-drag-uploader:hover, .braft-finder .bf-drag-uploader.draging {\n    background-color: #f1f2f3; }\n  .braft-finder .bf-drag-uploader.active {\n    opacity: 1;\n    pointer-events: auto; }\n\n.braft-finder .bf-uploader-buttons {\n  height: 370px;\n  margin: auto;\n  text-align: center; }\n\n.braft-finder .bf-drag-tip {\n  display: inline-block;\n  margin-top: 150px;\n  color: #ccc;\n  text-align: center;\n  font-size: 28px;\n  font-weight: normal;\n  line-height: 40px; }\n  .braft-finder .bf-drag-tip input {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    color: #fff;\n    text-indent: -100px;\n    cursor: pointer; }\n\n.braft-finder .bf-manager-footer {\n  height: 36px;\n  margin: 10px 0;\n  padding: 0 15px; }\n  .braft-finder .bf-manager-footer .button {\n    float: right;\n    height: 36px;\n    margin-left: 5px;\n    padding: 0 35px;\n    font-size: 12px;\n    font-weight: 700;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer; }\n  .braft-finder .bf-manager-footer .button-insert {\n    color: #fff;\n    background-color: #3498db; }\n    .braft-finder .bf-manager-footer .button-insert:hover {\n      background-color: #2084c7; }\n    .braft-finder .bf-manager-footer .button-insert[disabled] {\n      opacity: .3;\n      pointer-events: none;\n      filter: grayscale(0.4); }\n  .braft-finder .bf-manager-footer .button-cancel {\n    color: #999;\n    background-color: #e8e8e9; }\n    .braft-finder .bf-manager-footer .button-cancel:hover {\n      background-color: #d8d8d9; }\n\n.braft-finder .bf-toggle-external-form {\n  color: #666;\n  font-size: 12px;\n  line-height: 36px; }\n  .braft-finder .bf-toggle-external-form span {\n    color: #bbb;\n    line-height: 16px;\n    cursor: pointer;\n    user-select: none; }\n    .braft-finder .bf-toggle-external-form span:hover {\n      color: #3498db; }\n    .braft-finder .bf-toggle-external-form span i {\n      position: relative;\n      top: 2px;\n      font-size: 16px; }\n\n.braft-finder .bf-add-external {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #fff; }\n  .braft-finder .bf-add-external input {\n    border: solid 1px rgba(0, 0, 0, 0.3);\n    border: solid 0.5px rgba(0, 0, 0, 0.3);\n    box-shadow: none; }\n    .braft-finder .bf-add-external input:focus {\n      border-color: #3498db;\n      box-shadow: none; }\n\n.braft-finder .bf-external-form {\n  width: 500px;\n  max-width: 90%;\n  margin: 91px auto 0 auto; }\n\n.braft-finder .bf-external-input {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  margin-bottom: 10px; }\n  .braft-finder .bf-external-input div {\n    position: absolute;\n    top: 0;\n    right: 85px;\n    left: 0;\n    height: 40px; }\n  .braft-finder .bf-external-input input,\n  .braft-finder .bf-external-input textarea {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    height: 40px;\n    padding: 0 10px;\n    border: none;\n    border-radius: 3px;\n    outline: none;\n    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.3);\n    color: #999;\n    font-size: 18px; }\n    .braft-finder .bf-external-input input:focus,\n    .braft-finder .bf-external-input textarea:focus {\n      box-shadow: inset 0 0 0 1px #3498db; }\n  .braft-finder .bf-external-input textarea {\n    height: 100px;\n    font-size: 14px; }\n  .braft-finder .bf-external-input button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 80px;\n    height: 40px;\n    background-color: #3498db;\n    border: none;\n    border-radius: 3px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: bold;\n    cursor: pointer; }\n    .braft-finder .bf-external-input button:disabled {\n      opacity: .3;\n      pointer-events: none;\n      filter: grayscale(0.4); }\n    .braft-finder .bf-external-input button:hover {\n      background-color: #2084c7; }\n\n.braft-finder .bf-switch-external-type {\n  overflow: hidden;\n  text-align: center; }\n  .braft-finder .bf-switch-external-type button {\n    width: auto;\n    height: 30px;\n    margin: 10px 5px;\n    padding: 0 10px;\n    background-color: #e8e9ea;\n    border: none;\n    border-radius: 3px;\n    color: #999;\n    font-size: 12px;\n    cursor: pointer; }\n    .braft-finder .bf-switch-external-type button:hover {\n      background-color: #d8d9da; }\n    .braft-finder .bf-switch-external-type button:only-child {\n      display: none; }\n  .braft-finder .bf-switch-external-type[data-type=\"IMAGE\"] [data-type=\"IMAGE\"],\n  .braft-finder .bf-switch-external-type[data-type=\"VIDEO\"] [data-type=\"VIDEO\"],\n  .braft-finder .bf-switch-external-type[data-type=\"AUDIO\"] [data-type=\"AUDIO\"],\n  .braft-finder .bf-switch-external-type[data-type=\"EMBED\"] [data-type=\"EMBED\"],\n  .braft-finder .bf-switch-external-type[data-type=\"FILE\"] [data-type=\"FILE\"] {\n    background-color: #3498db;\n    color: #fff; }\n\n.braft-finder .bf-external-tip {\n  display: block;\n  margin-top: 15px;\n  color: #ccc;\n  font-size: 12px;\n  text-align: center; }\n", ""]);

// exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(16);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(12)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(17);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _base = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultAccepts = {
  image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
  video: 'video/mp4',
  audio: 'audio/mp3'
};

var BraftFinderView = function (_React$Component) {
  _inherits(BraftFinderView, _React$Component);

  function BraftFinderView(props) {
    _classCallCheck(this, BraftFinderView);

    var _this = _possibleConstructorReturn(this, (BraftFinderView.__proto__ || Object.getPrototypeOf(BraftFinderView)).call(this, props));

    _this.toggleSelectItem = function (event) {

      var itemId = event.currentTarget.dataset.id;
      var item = _this.controller.getMediaItem(itemId);

      if (!item) {
        return false;
      }

      if (item.selected) {

        if (!_this.props.onBeforeDeselect || _this.props.onBeforeDeselect([item], _this.controller.getItems()) !== false) {
          _this.controller.deselectMediaItem(itemId);
          _this.props.onDeselect && _this.props.onDeselect([item], _this.controller.getItems());
        }
      } else {

        if (!_this.props.onBeforeSelect || _this.props.onBeforeSelect([item], _this.controller.getItems()) !== false) {
          _this.controller.selectMediaItem(itemId);
          _this.props.onSelect && _this.props.onSelect([item], _this.controller.getItems());
        }
      }
    };

    _this.removeItem = function (event) {

      var itemId = event.currentTarget.dataset.id;
      var item = _this.controller.getMediaItem(itemId);

      if (!item) {
        return false;
      }

      if (!_this.props.onBeforeRemove || _this.props.onBeforeRemove([item], _this.controller.getItems()) !== false) {
        _this.controller.removeMediaItem(itemId);
        _this.props.onRemove && _this.props.onRemove([item], _this.controller.getItems());
      }

      event.stopPropagation();
    };

    _this.selectAllItems = function () {

      var allItems = _this.controller.getItems();

      if (!_this.props.onBeforeSelect || _this.props.onBeforeSelect(allItems, allItems) !== false) {
        _this.controller.selectAllItems();
        _this.props.onSelect && _this.props.onSelect(allItems, allItems);
      }
    };

    _this.deselectAllItems = function () {

      var allItems = _this.controller.getItems();

      if (!_this.props.onBeforeDeselect || _this.props.onBeforeDeselect(allItems, allItems) !== false) {
        _this.controller.deselectAllItems();
        _this.props.onDeselect && _this.props.onDeselect(allItems, allItems);
      }
    };

    _this.removeSelectedItems = function () {

      var selectedItems = _this.controller.getSelectedItems();

      if (!_this.props.onBeforeRemove || _this.props.onBeforeRemove(selectedItems, _this.controller.getItems()) !== false) {
        _this.controller.removeSelectedItems();
        _this.props.onRemove && _this.props.onRemove(selectedItems, _this.controller.getItems());
      }
    };

    _this.handleDragLeave = function (event) {
      event.preventDefault();
      _this.dragCounter--;
      _this.dragCounter === 0 && _this.setState({
        draging: false
      });
    };

    _this.handleDragDrop = function (event) {
      event.preventDefault();
      _this.dragCounter = 0;
      _this.setState({ draging: false });
      _this.reslovePickedFiles(event);
    };

    _this.handleDragEnter = function (event) {
      event.preventDefault();
      _this.dragCounter++;
      _this.setState({ draging: true });
    };

    _this.reslovePickedFiles = function (event) {

      event.persist();

      var _ref = event.type === 'drop' ? event.dataTransfer : event.target,
          files = _ref.files;

      if (_this.props.onFileSelect) {
        var result = _this.props.onFileSelect(files);
        if (result === false) {
          return false;
        } else if (result instanceof FileList || result instanceof Array) {
          files = result;
        }
      }

      var accepts = _extends({}, defaultAccepts, _this.props.accepts);

      _this.controller.resolveFiles({
        files: files,
        onItemReady: function onItemReady(_ref2) {
          var id = _ref2.id;
          return _this.controller.selectMediaItem(id);
        },
        onAllReady: function onAllReady() {
          return event.target.value = null;
        }
      }, 0, accepts);
    };

    _this.inputExternal = function (event) {
      _this.setState({
        external: _extends({}, _this.state.external, {
          url: event.target.value
        })
      });
    };

    _this.switchExternalType = function (event) {
      _this.setState({
        external: _extends({}, _this.state.external, { type: event.target.dataset.type })
      });
    };

    _this.confirmAddExternal = function (event) {

      if (event.target.nodeName.toLowerCase() === 'button' || event.keyCode === 13) {
        var _this$state$external = _this.state.external,
            url = _this$state$external.url,
            type = _this$state$external.type;

        url = url.split('|');
        var name = url.length > 1 ? url[0] : _this.props.language.unnamedItem;
        url = url.length > 1 ? url[1] : url[0];
        var thumbnail = type === 'IMAGE' ? url : null;

        _this.controller.addItems([{
          thumbnail: thumbnail, url: url, name: name, type: type,
          id: new Date().getTime() + '_' + (0, _base.UniqueIndex)(),
          uploading: false,
          uploadProgress: 1,
          selected: true
        }]);

        _this.setState({
          showExternalForm: false,
          external: {
            url: '',
            type: 'IMAGE'
          }
        });
      }
    };

    _this.toggleExternalForm = function () {
      _this.setState({
        showExternalForm: !_this.state.showExternalForm
      });
    };

    _this.cancelInsert = function () {
      _this.props.onCancel && _this.props.onCancel();
    };

    _this.confirmInsert = function () {

      var selectedItems = _this.controller.getSelectedItems();

      if (_this.props.onBeforeInsert) {

        var filteredItems = _this.props.onBeforeInsert(selectedItems);

        if (filteredItems && filteredItems instanceof Array) {
          _this.controller.deselectAllItems();
          _this.props.onInsert && _this.props.onInsert(filteredItems);
        } else if (filteredItems !== false) {
          _this.controller.deselectAllItems();
          _this.props.onInsert && _this.props.onInsert(selectedItems);
        }
      } else {
        _this.controller.deselectAllItems();
        _this.props.onInsert && _this.props.onInsert(selectedItems);
      }
    };

    _this.dragCounter = 0;
    _this.controller = _this.props.controller;
    var initialItems = _this.controller.getItems();

    _this.state = {
      draging: false,
      error: false,
      confirmable: initialItems.find(function (_ref3) {
        var selected = _ref3.selected;
        return selected;
      }),
      external: {
        url: '',
        type: 'IMAGE'
      },
      fileAccept: '',
      showExternalForm: false,
      allowExternal: false,
      items: initialItems
    };

    _this.changeListenerId = _this.controller.onChange(function (items) {
      _this.setState({ items: items, confirmable: items.find(function (_ref4) {
          var selected = _ref4.selected;
          return selected;
        }) });
      _this.props.onChange && _this.props.onChange(items);
    });

    return _this;
  }

  _createClass(BraftFinderView, [{
    key: 'mapPropsToState',
    value: function mapPropsToState(props) {
      var accepts = props.accepts,
          externals = props.externals;


      accepts = _extends({}, defaultAccepts, accepts);

      var fileAccept = !accepts ? [defaultAccepts.image, defaultAccepts.video, defaultAccepts.audio].join(',') : [accepts.image, accepts.video, accepts.audio].filter(function (item) {
        return item;
      }).join(',');

      var external = {
        url: '',
        type: externals.image ? 'IMAGE' : externals.audio ? 'AUDIO' : externals.video ? 'VIDEO' : externals.embed ? 'EMBED' : ''
      };

      return {
        fileAccept: fileAccept,
        external: external,
        allowExternal: externals && (externals.image || externals.audio || externals.video || externals.embed)
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState(this.mapPropsToState(this.props));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.mapPropsToState(nextProps));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.controller.offChange(this.changeListenerId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          language = _props.language,
          externals = _props.externals;
      var _state = this.state,
          items = _state.items,
          draging = _state.draging,
          confirmable = _state.confirmable,
          fileAccept = _state.fileAccept,
          external = _state.external,
          showExternalForm = _state.showExternalForm,
          allowExternal = _state.allowExternal;


      return _react2.default.createElement(
        'div',
        { className: 'braft-finder' },
        _react2.default.createElement(
          'div',
          {
            onDragEnter: this.handleDragEnter,
            onDragOver: this.handleDragEnter,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDragDrop,
            className: 'bf-uploader'
          },
          _react2.default.createElement(
            'div',
            { className: "bf-drag-uploader " + (draging || !items.length ? 'active ' : ' ') + (draging ? 'draging' : '') },
            _react2.default.createElement(
              'span',
              { className: 'bf-drag-tip' },
              _react2.default.createElement('input', { accept: fileAccept, onChange: this.reslovePickedFiles, multiple: true, type: 'file' }),
              draging ? language.dropTip : language.dragTip
            )
          ),
          items.length ? _react2.default.createElement(
            'div',
            { className: 'bf-list-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'bf-list-tools' },
              _react2.default.createElement(
                'span',
                { onClick: this.selectAllItems, className: 'bf-select-all' },
                _react2.default.createElement('i', { className: 'braft-icon-done' }),
                ' ',
                language.selectAll
              ),
              _react2.default.createElement(
                'span',
                { onClick: this.deselectAllItems, disabled: !confirmable, className: 'bf-deselect-all' },
                _react2.default.createElement('i', { className: 'braft-icon-close' }),
                ' ',
                language.deselect
              ),
              _react2.default.createElement(
                'span',
                { onClick: this.removeSelectedItems, disabled: !confirmable, className: 'bf-remove-selected' },
                _react2.default.createElement('i', { className: 'braft-icon-bin' }),
                ' ',
                language.removeSelected
              )
            ),
            this.buildItemList()
          ) : null,
          showExternalForm && allowExternal ? _react2.default.createElement(
            'div',
            { className: 'bf-add-external' },
            _react2.default.createElement(
              'div',
              { className: 'bf-external-form' },
              _react2.default.createElement(
                'div',
                { className: 'bf-external-input' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('input', { onKeyDown: this.confirmAddExternal, value: external.url, onChange: this.inputExternal, placeholder: language.externalInputPlaceHolder })
                ),
                _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: this.confirmAddExternal, disabled: !external.url.trim().length },
                  language.confirm
                )
              ),
              _react2.default.createElement(
                'div',
                { 'data-type': external.type, className: 'bf-switch-external-type' },
                externals.image ? _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: this.switchExternalType, 'data-type': 'IMAGE' },
                  language.image
                ) : null,
                externals.audio ? _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: this.switchExternalType, 'data-type': 'AUDIO' },
                  language.audio
                ) : null,
                externals.video ? _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: this.switchExternalType, 'data-type': 'VIDEO' },
                  language.video
                ) : null,
                externals.embed ? _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: this.switchExternalType, 'data-type': 'EMBED' },
                  language.embed
                ) : null
              ),
              _react2.default.createElement(
                'span',
                { className: 'bf-external-tip' },
                language.externalInputTip
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'footer',
          { className: 'bf-manager-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pull-left' },
            allowExternal ? _react2.default.createElement(
              'span',
              {
                onClick: this.toggleExternalForm,
                className: 'bf-toggle-external-form'
              },
              showExternalForm ? _react2.default.createElement(
                'span',
                { className: 'bf-bottom-text' },
                _react2.default.createElement('i', { className: 'braft-icon-add' }),
                ' ',
                language.addLocalFile
              ) : _react2.default.createElement(
                'span',
                { className: 'bf-bottom-text' },
                _react2.default.createElement('i', { className: 'braft-icon-add' }),
                ' ',
                language.addExternalSource
              )
            ) : null
          ),
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              'button',
              { onClick: this.confirmInsert, className: 'button button-insert', disabled: !confirmable },
              language.insert
            ),
            _react2.default.createElement(
              'button',
              { onClick: this.cancelInsert, className: 'button button-cancel' },
              language.cancel
            )
          )
        )
      );
    }
  }, {
    key: 'buildItemList',
    value: function buildItemList() {
      var _this2 = this;

      return _react2.default.createElement(
        'ul',
        { className: 'bf-list' },
        _react2.default.createElement(
          'li',
          { className: 'bf-add-item' },
          _react2.default.createElement('i', { className: 'braft-icon-add' }),
          _react2.default.createElement('input', { accept: this.state.fileAccept, onChange: this.reslovePickedFiles, multiple: true, type: 'file' })
        ),
        this.state.items.map(function (item, index) {

          var previewerComponents = null;
          var progressMarker = item.uploading && !_this2.props.hideProgress ? _react2.default.createElement(
            'div',
            { className: 'bf-item-uploading' },
            _react2.default.createElement('div', { className: 'bf-item-uploading-bar', style: { width: item.uploadProgress / 1 + '%' } })
          ) : '';

          switch (item.type) {
            case 'IMAGE':
              previewerComponents = _react2.default.createElement(
                'div',
                { className: 'bf-image' },
                progressMarker,
                _react2.default.createElement('img', { src: item.thumbnail || item.url })
              );
              break;
            case 'VIDEO':
              previewerComponents = _react2.default.createElement(
                'div',
                { className: 'bf-icon bf-video', title: item.url },
                progressMarker,
                _react2.default.createElement('i', { className: 'braft-icon-film' }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.name || item.url
                )
              );
              break;
            case 'AUDIO':
              previewerComponents = _react2.default.createElement(
                'div',
                { className: 'bf-icon bf-audio', title: item.url },
                progressMarker,
                _react2.default.createElement('i', { className: 'braft-icon-music' }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.name || item.url
                )
              );
              break;
            case 'EMBED':
              previewerComponents = _react2.default.createElement(
                'div',
                { className: 'bf-icon bf-embed', title: item.url },
                progressMarker,
                _react2.default.createElement('i', { className: 'braft-icon-code' }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.name || _this2.props.language.embed
                )
              );
              break;
            default:
              previewerComponents = _react2.default.createElement(
                'a',
                { className: 'bf-icon bf-file', title: item.url, href: item.url },
                progressMarker,
                _react2.default.createElement('i', { className: 'braft-icon-file-text' }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.name || item.url
                )
              );
              break;
          }

          var className = ['bf-item'];
          item.selected && className.push('active');
          item.uploading && className.push('uploading');
          item.error && className.push('error');

          return _react2.default.createElement(
            'li',
            {
              key: index,
              title: item.name,
              'data-id': item.id,
              className: className.join(' '),
              onClick: _this2.toggleSelectItem
            },
            previewerComponents,
            _react2.default.createElement('span', { 'data-id': item.id, onClick: _this2.removeItem, className: 'bf-item-remove braft-icon-close' }),
            _react2.default.createElement(
              'span',
              { className: 'bf-item-title' },
              item.name
            )
          );
        })
      );
    }
  }]);

  return BraftFinderView;
}(_react2.default.Component);

BraftFinderView.defaultProps = {
  accepts: defaultAccepts,
  externals: {
    image: true,
    video: true,
    audio: true,
    embed: true
  }
};
exports.default = BraftFinderView;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _base = __webpack_require__(1);

var _image = __webpack_require__(0);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultValidator = function defaultValidator() {
  return true;
};

var BraftFinderController = function BraftFinderController() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, BraftFinderController);

  _initialiseProps.call(this);

  this.items = props.items || [];
  this.uploadFn = props.uploader;
  this.validateFn = props.validator || defaultValidator;

  this.changeListeners = [];
}

// resolvePastedFiles ({ clipboardData }, callback) {

//   if (clipboardData && clipboardData.items && clipboardData.items[0].type.indexOf('image') > -1) {
//     this.uploadImage(clipboardData.items[0].getAsFile(), callback)
//   }

// }

;

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.setProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    _this.items = props.items || _this.items || [];
    _this.uploadFn = props.uploader;
    _this.validateFn = props.validator || defaultValidator;
  };

  this.getMediaItem = function (id) {
    return _this.items.find(function (item) {
      return item.id === id;
    });
  };

  this.getSelectedItems = function () {
    return _this.items.filter(function (item) {
      return item.selected;
    });
  };

  this.getItems = function () {
    return _this.items;
  };

  this.setItems = function (items) {
    _this.items = items.map(function (item) {
      return _extends({}, item, { id: item.id.toString() });
    }) || [];
    _this.applyChange();
    _this.uploadItems();
  };

  this.addMediaItem = function (item) {
    _this.addItems([item]);
  };

  this.addItems = function (items) {
    _this.items = [].concat(_toConsumableArray(_this.items), _toConsumableArray(items.map(function (item) {
      return _extends({}, item, { id: item.id.toString() });
    })));
    _this.applyChange();
    _this.uploadItems();
  };

  this.selectMediaItem = function (id) {
    var item = _this.getMediaItem(id);
    if (item && (item.uploading || item.error)) {
      return false;
    }
    _this.setMediaItemState(id, {
      selected: true
    });
  };

  this.selectAllItems = function () {
    _this.items = _this.items.filter(function (item) {
      return !item.error && !item.uploading;
    }).map(function (item) {
      return _extends({}, item, { selected: true });
    });
    _this.applyChange();
  };

  this.deselectMediaItem = function (id) {
    _this.setMediaItemState(id, {
      selected: false
    });
  };

  this.deselectAllItems = function () {
    _this.items = _this.items.map(function (item) {
      return _extends({}, item, { selected: false });
    });
    _this.applyChange();
  };

  this.removeMediaItem = function (id) {
    _this.items = _this.items.filter(function (item) {
      return item.id !== id;
    });
    _this.applyChange();
  };

  this.removeItems = function () {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _this.items = _this.items.filter(function (item) {
      return !ids.includes(item.id);
    });
    _this.applyChange();
  };

  this.removeSelectedItems = function () {
    _this.items = _this.items.filter(function (item) {
      return !item.selected;
    });
    _this.applyChange();
  };

  this.removeErrorItems = function () {
    _this.items = _this.items.filter(function (item) {
      return !item.error;
    });
    _this.applyChange();
  };

  this.removeAllItems = function () {
    _this.items = [];
    _this.applyChange();
  };

  this.setMediaItemState = function (id, state) {
    _this.items = _this.items.map(function (item) {
      return item.id === id ? _extends({}, item, state) : item;
    });
    _this.applyChange();
  };

  this.reuploadErrorItems = function () {
    _this.uploadItems(true);
  };

  this.uploadItems = function () {
    var ignoreError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


    _this.items.forEach(function (item, index) {

      if (item.uploading || item.url) {
        return false;
      }

      if (!ignoreError && item.error) {
        return false;
      }

      if (item.type === 'IMAGE') {
        _this.createThumbnail(item);
        _this.uploadFn = _this.uploadFn || _this.createInlineImage;
      } else if (!_this.uploadFn) {
        _this.setMediaItemState(item.id, { error: 1 });
        return false;
      }

      _this.setMediaItemState(item.id, {
        uploading: true,
        uploadProgress: 0,
        error: 0
      });

      _this.uploadFn({
        id: item.id,
        file: item.file,
        success: function success(res) {
          _this.handleUploadSuccess(item.id, res);
        },
        progress: function progress(_progress) {
          _this.setMediaItemState(item.id, {
            uploading: true,
            uploadProgress: _progress
          });
        },
        error: function error(_error) {
          _this.setMediaItemState(item.id, {
            uploading: false,
            error: 2
          });
        }
      });
    });
  };

  this.createThumbnail = function (_ref) {
    var id = _ref.id,
        file = _ref.file;


    (0, _image.compressImage)(URL.createObjectURL(file), 226, 226).then(function (result) {
      _this.setMediaItemState(id, { thumbnail: result.url });
    });
  };

  this.createInlineImage = function (param) {

    (0, _image.compressImage)(URL.createObjectURL(param.file), 1280, 800).then(function (result) {
      param.success({ url: result.url });
    }).catch(function (error) {
      param.error(error);
    });
  };

  this.handleUploadSuccess = function (id, data) {

    _this.setMediaItemState(id, _extends({}, data, {
      file: null,
      uploadProgress: 1,
      uploading: false,
      selected: false
    }));

    var item = _this.getMediaItem(data.id || id);
    item.onReady && item.onReady(item);
  };

  this.applyChange = function () {
    _this.changeListeners.forEach(function (_ref2) {
      var callback = _ref2.callback;
      return callback(_this.items);
    });
  };

  this.uploadImage = function (file, callback) {

    var fileId = new Date().getTime() + '_' + (0, _base.UniqueIndex)();

    _this.addMediaItem({
      type: 'IMAGE',
      id: fileId,
      file: file,
      name: fileId,
      size: file.size,
      uploadProgress: 0,
      uploading: false,
      selected: false,
      error: 0,
      onReady: callback
    });
  };

  this.uploadImageRecursively = function (files, callback) {
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


    if (files[index] && files[index].type.indexOf('image') > -1) {
      _this.uploadImage(files[index], function (image) {
        callback && callback(image);
        index < files.length - 1 && _this.uploadImageRecursively(files, callback, index + 1);
      });
    } else {
      index < files.length - 1 && _this.uploadImageRecursively(files, callback, index + 1);
    }
  };

  this.addResolvedFiles = function (param, index, accepts) {

    var data = {
      id: new Date().getTime() + '_' + (0, _base.UniqueIndex)(),
      file: param.files[index],
      name: param.files[index].name,
      size: param.files[index].size,
      uploadProgress: 0,
      uploading: false,
      selected: false,
      error: 0,
      onReady: function onReady(item) {
        param.onItemReady && param.onItemReady(item);
      }
    };

    if (param.files[index].type.indexOf('image/') === 0 && accepts.image) {
      data.type = 'IMAGE';
      _this.addMediaItem(data);
    } else if (param.files[index].type.indexOf('video/') === 0 && accepts.video) {
      data.type = 'VIDEO';
      _this.addMediaItem(data);
    } else if (param.files[index].type.indexOf('audio/') === 0 && accepts.audio) {
      data.type = 'AUDIO';
      _this.addMediaItem(data);
    }

    setTimeout(function () {
      _this.resolveFiles(param, index + 1, accepts);
    }, 60);
  };

  this.resolveFiles = function (param, index, accepts) {

    if (index < param.files.length) {

      var validateResult = _this.validateFn(param.files[index]);

      if (validateResult instanceof Promise) {
        validateResult.then(function () {
          _this.addResolvedFiles(param, index, accepts);
        });
      } else if (validateResult) {
        _this.addResolvedFiles(param, index, accepts);
      }
    } else {
      param.onAllReady && param.onAllReady();
    }
  };

  this.onChange = function (callback) {

    var listenerId = (0, _base.UniqueIndex)();

    _this.changeListeners.push({
      id: listenerId,
      callback: callback
    });

    return listenerId;
  };

  this.offChange = function (listenerId) {
    _this.changeListeners = _this.changeListeners.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== listenerId;
    });
  };
};

exports.default = BraftFinderController;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUtils = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _controller = __webpack_require__(19);

var _controller2 = _interopRequireDefault(_controller);

var _view = __webpack_require__(18);

var _view2 = _interopRequireDefault(_view);

var _languages = __webpack_require__(10);

var _languages2 = _interopRequireDefault(_languages);

var _image = __webpack_require__(0);

var ImageUtils = _interopRequireWildcard(_image);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BraftFinder = function (_FinderController) {
  _inherits(BraftFinder, _FinderController);

  function BraftFinder(props) {
    _classCallCheck(this, BraftFinder);

    var _this = _possibleConstructorReturn(this, (BraftFinder.__proto__ || Object.getPrototypeOf(BraftFinder)).call(this, props));

    _initialiseProps.call(_this);

    _this.superProps = props;
    return _this;
  }

  return BraftFinder;
}(_controller2.default);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.ReactComponent = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    var componentProps = _extends({}, _this2.superProps, props);

    var language = (typeof componentProps.language === 'function' ? componentProps.language(_languages2.default, 'braft-finder') : _languages2.default[componentProps.language]) || _languages2.default['zh'];

    return _react2.default.createElement(_view2.default, _extends({}, componentProps, {
      language: language,
      controller: _this2
    }));
  };
};

exports.default = BraftFinder;
exports.ImageUtils = ImageUtils;

/***/ })
/******/ ]);
});

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BrandInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_module_scss__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_google_map_react__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_25_antd_lib_select___default.a.Option;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var BrandInfo=function(_Component){_inherits(BrandInfo,_Component);function BrandInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrandInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrandInfo.__proto__||Object.getPrototypeOf(BrandInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_26_react___default.a.createRef(),_this.state={brandInfo:{id:null,status:1,name:null,type:1},data:[],messages:{},isFetchData:false,isSubmitData:false,isImage:false},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.cloneDeep(devBrandInfo);if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isBoolean(data.status))data.status=data.status===1;_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_30__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/categories/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/category');return;}_this.fillData(data);});},_this.submitData=function(){var brandInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var current_user=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');brandInfo.user_id=current_user.ID;// 把Control元件轉換回上傳資料
var id=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(_this,'props.match.params.id','');_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_30__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/categories/'+id),brandInfo,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_21_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('建立成功');_this.setState({brandInfo:data});return _this.props.history.replace('/category/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_30__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_31__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/categories/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_21_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/category');});},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrandInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_32_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();this.fillData();}// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;var errors=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_36_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this,'props.app.options',{});var uploadList=this.formRef.current&&__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isArray(this.formRef.current.getFieldValue('uploadList'))?this.formRef.current.getFieldValue('uploadList'):[];return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_29__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */],{to:'/category'},'\u985E\u5225\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a.Item,null,'\u985E\u5225\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u985E\u5225\u8CC7\u8A0A',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);},onValuesChange:function onValuesChange(changedFields,allFields){return console.log('onValuesChange',changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','名稱'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('sort','排序'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('status','狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_35_libs_FormHelper__["a" /* genFormItemAtrribute */])('type','類別'),{rules:[{required:true,message:'請選擇類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a.Group,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a,{//grid={listGrid}
dataSource:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(options,'category_types',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_radio___default.a,{value:item.id},item.name));}}))))))));}}]);return BrandInfo;}(__WEBPACK_IMPORTED_MODULE_26_react__["Component"]);var devBrandInfo={name:'類別名稱',type:1,sort:null};

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CatalogueInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_EyeOutlined__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_EyeOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_EyeOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_icons_BookOutlined__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_icons_BookOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_icons_BookOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_radio_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_immutability_helper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__styles_module_scss__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CatalogueInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_39_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_40_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(CatalogueInfo,_Component);function CatalogueInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CatalogueInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CatalogueInfo.__proto__||Object.getPrototypeOf(CatalogueInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_37_react___default.a.createRef(),_this.state={catalogueInfo:{id:null,status:1,name:null,logo:null,type:1},data:[],messages:{},isFetchData:false,isSubmitData:false,isEDMType:false},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isString(data.cover)){data.cover=null;}else{data.cover={id:1,path:data.cover,url:data.cover_url};}data.show_range=[__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'show_at')?__WEBPACK_IMPORTED_MODULE_43_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'show_at')):null,__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'show_at')?__WEBPACK_IMPORTED_MODULE_43_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'hide_at')):null];data.promotion_date_range=[__WEBPACK_IMPORTED_MODULE_43_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'promotion_start_date')),__WEBPACK_IMPORTED_MODULE_43_moment___default()(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(data,'promotion_end_date'))];if(!__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isBoolean(data.status))data.status=data.status===1;_this.formRef.current.setFieldsValue(data);setTimeout(function(){_this.isEdmCategory();},500);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_46_libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_49_configs_env__["b" /* API_HOST */]+('/api/mgt/v1/catalogues/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/catalogues');return;}_this.fillData(data);});},_this.submitData=function(){var catalogueInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};window.cc=_this.formRef.current;// 把Control元件轉換回上傳資料
catalogueInfo.cover=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(catalogueInfo,'cover.path');catalogueInfo.show_at=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(catalogueInfo,'show_range.0').format('YYYY-MM-DD HH:mm:ss');catalogueInfo.hide_at=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(catalogueInfo,'show_range.1').format('YYYY-MM-DD HH:mm:ss');catalogueInfo.promotion_start_date=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(catalogueInfo,'promotion_date_range.0').format('YYYY-MM-DD');catalogueInfo.promotion_end_date=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(catalogueInfo,'promotion_date_range.1').format('YYYY-MM-DD');delete catalogueInfo.show_range;delete catalogueInfo.promotio_date_range;var current_user=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');catalogueInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id','');// 不是edm類別，清空iframe_url
if(!_this.state.isEDMType)catalogueInfo.iframe_url='';_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_46_libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_49_configs_env__["b" /* API_HOST */]+('/api/mgt/v1/catalogues/'+id),catalogueInfo,function(state,res){_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_34_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});var messages=data.messages;if(__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isObject(messages)){//處理錯誤訊息
__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.map(messages,function(errors,key){return{touched:true,validating:false,errors:[],name:[key],value:_this.getFieldValue(key)};});_this.forceUpdate();}return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.success('新增成功');_this.setState({catalogueInfo:data});return _this.props.history.replace('/catalogues/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_46_libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_49_configs_env__["b" /* API_HOST */]+('/api/mgt/v1/catalogues/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_36_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_34_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/catalogues');});},_this.getImages=function(){return _this.formRef.current&&__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.isArray(_this.formRef.current.getFieldValue('images'))?_this.formRef.current.getFieldValue('images'):[];},_this.moveRow=function(dragIndex,hoverIndex){var _this$state=_this.state,_this$state$table_dat=_this$state.table_data,table_data=_this$state$table_dat===undefined?{}:_this$state$table_dat,_this$state$table_dat2=_this$state.table_data;_this$state$table_dat2=_this$state$table_dat2===undefined?{}:_this$state$table_dat2;var _this$state$table_dat3=_this$state$table_dat2.rows,rows=_this$state$table_dat3===undefined?[]:_this$state$table_dat3;var images=_this.getImages();var dragRow=images[dragIndex];images=__WEBPACK_IMPORTED_MODULE_41_immutability_helper___default()(images,{$splice:[[dragIndex,1],[hoverIndex,0,dragRow]]});_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:['images'],value:images}]);},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_this.isEdmCategory=function(){if(!_this.formRef.current)return false;var options=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this,'props.app.options',{});var edmCate=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'catalogue_categories',[]).find(function(c){return c.name==='電子目錄';});// if edmCate not found return undefined, else return edmCate.id
var cateId=_this.formRef.current.getFieldValue('category_id')||'';_this.setState({isEDMType:edmCate?edmCate.id===cateId:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CatalogueInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_47_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();this.fillData();}},{key:'render',value:function render(){var _this2=this;var errors=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_44_validatorjs_src_errors___default.a());var options=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(this,'props.app.options',{});var id=this.getFieldValue('id');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_45__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react_router_dom__["b" /* Link */],{to:'/catalogues'},'\u4FC3\u92B7\u76EE\u9304\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_32_antd_lib_breadcrumb___default.a.Item,null,'\u4FC3\u92B7\u76EE\u9304\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u4FC3\u92B7\u76EE\u9304\u8CC7\u8A0A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_52_components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onKeyDown:function onKeyDown(e){return _this2.enterNotSubmit(e);}},!this.state.isEDMType&&wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,{style:{textAlign:'left'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/file/catalogues/promotion_sample-2.zip',target:'_blank'},' ',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,null,' ZIP\u7BC4\u4F8B ')),wp.element.createElement('a',{href:window.VC_CONFIG.INDEX_URL+'/wp-content/themes/cec/assets/file/catalogues/DM-sample.xlsx',target:'_blank'},' ',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,null,' Excel\u7BC4\u4F8B '))),wp.element.createElement('span',null,'PDF\b\b\u3001Excel\u9700\u4F7F\u7528FTP\u4E0A\u50B3\uFF0C\u5982\u9700\u8B8A\u66F4\u6A94\u6848',wp.element.createElement('br',null),'\u8ACB\u628APDF\u547D\u540D\u70BA\u300Cupdate_pdf_',id,'.pdf\u300D\uFF0C\u628AExcel\u547D\u540D\u70BA \u300Cupdate_excel_',id,'.xlsx\u300D')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','名稱'),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_name','英文名稱'),{rules:[{required:true,message:'請填寫英文名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('sort','排序'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_24_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('status','狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('show_range','系統上下架時間'),{extra:'\u7CFB\u7D71\u65BC\u8A72\u6642\u6BB5\u986F\u793A\u65BC\u5B98\u7DB2\uFF0C\u6CE8\u610F\u72C0\u614B\u9700\u70BA\u300C\u555F\u7528\u300D\u3002',rules:[{required:true,message:'請填寫系統上下架時間'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker___default.a.RangePicker,{showTime:{defaultValue:[__WEBPACK_IMPORTED_MODULE_43_moment___default()('09:00:00','HH:mm:ss'),__WEBPACK_IMPORTED_MODULE_43_moment___default()('23:59:59','HH:mm:ss')],format:'HH:mm'},format:'YYYY-MM-DD HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('promotion_date_range','促銷活動日期'),{rules:[{required:true,message:'請填寫促銷活動日期'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker___default.a.RangePicker,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_id','目錄類別'),{rules:[{required:true,message:'請選擇目錄類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a.Group,{onChange:this.isEdmCategory},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a,{grid:listGrid,dataSource:__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(options,'catalogue_categories',[]),renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_18_antd_lib_radio___default.a,{value:item.id},item.name));}}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('specialized','超市專屬','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_22_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'})),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc','促銷目錄說明'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a.TextArea,{rows:10})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('en_desc','英文促銷目錄說明'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a.TextArea,{rows:10}))),wp.element.createElement('div',{className:'flexBox'},this.state.isEDMType&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('iframe_url','電子目錄網址'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a,null))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_divider___default.a,null,'\u76EE\u9304\u6A94\u6848\u7BA1\u7406'),wp.element.createElement('span',null,'\u6B64\u5340\u584A\u64CD\u4F5C\u5F8C\u9084\u9700\u6309\u4E0B\u4E0A\u65B9\u7684\u300C\u5132\u5B58\u300D\u8CC7\u6599\u65B9\u5F97\u4FDD\u7559'),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,{label:'\u5C01\u9762',style:{minHeight:166}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.List,{name:'images'},function(){var url=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this2.getFieldValue('images'),'0.url');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_avatar___default.a,{shape:'square',size:128,style:{height:166},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_12__ant_design_icons_lib_icons_BookOutlined___default.a,null),src:url});})),!this.state.isEDMType&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,{label:'PDF\u6A94\u6848'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.List,{name:'pdfs'},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;if(fields.length===0)return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{type:'dashed',disabled:true},' ','\u6A94\u6848\u9700\u900F\u904EFTP\u4E0A\u50B3',' ');var url=__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.get(_this2.getFieldValue('pdfs'),'0.url');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(0);}},' ','\u522A\u9664',' '),wp.element.createElement('a',{href:url,target:'_blank'},' ',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,null,' PDF\u4E0B\u8F09 ')));}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])('images','圖片上傳 寬140x高210 (2:3)'),{valuePropName:'fileList',extra:'\u7B2C\u4E00\u5F35\u5716\u7247\u70BA\u5C01\u9762\uFF0C\u5EFA\u8B70\u5C3A\u5BF8: \u5BEC140x\u9AD8210 (2:3)'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_50_components_WUpload_WUpload__["b" /* default */],{multiple:true,showUploadList:false},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' \u4E0A\u50B3'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.List,{name:'images'},function(fields,_ref3){var add=_ref3.add,remove=_ref3.remove,move=_ref3.move;return wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:_this2.getFieldValue('images'),loading:_this2.state.isLoadingData,pagination:false,rowKey:'id',components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#'},{dataIndex:'url',title:'圖片',render:function render(url,asset//${url.replace(/\s/g, encodeURIComponent(' '))}
){return wp.element.createElement('div',{className:'tableImg',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_42_lodash___default.a.split(url,' ').join(encodeURIComponent(' '))+')'},alt:'avatar'});}},{dataIndex:'name',title:'名稱',render:function render(name,item){return _this2.getFieldValue('images').indexOf(item)===0?'[\u5C01\u9762] '+name:name;}},{title:'Action',dataIndex:'id',key:'tools',width:250,render:function render(id,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_51_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){var images=_this2.getFieldValue('images');remove(images.indexOf(record));}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_EyeOutlined___default.a,null),onClick:function onClick(){return _this2.setState({previewImage:{url:record.url}});}},'\u6AA2\u8996')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_list___default.a.Item,null,item);}});}}]}));})),!this.state.isEDMType&&wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14_antd_lib_divider___default.a,null,'\u76EE\u9304\u7D22\u5F15\u5340\u584A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.List,{name:'category_indexes'},function(fields,_ref4){var add=_ref4.add,remove=_ref4.remove,move=_ref4.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return idx+1;}},{dataIndex:'page',title:'頁數',render:function render(page,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'page']),{rules:[{required:true,message:'必填'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a,null));}},{dataIndex:'index_name',title:'索引名稱',render:function render(indexName,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_48_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'index_name']),{rules:[{required:true,message:'必填'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_antd_lib_input___default.a,null));}},{dataIndex:'action',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_28_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_30_antd_lib_button___default.a,{htmlType:'button',onClick:function onClick(){return add();}},'\u65B0\u589E')));})))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement('img',{alt:'Preview',style:{width:'100%'},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return CatalogueInfo;}(__WEBPACK_IMPORTED_MODULE_37_react__["Component"]))||_class);/* DnD */var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:'render',value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,['isOver','connectDragSource','connectDropTarget','moveRow']);var style=Object.assign({},restProps.style,{cursor:'move'});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=' drop-over-downward';}if(restProps.index<dragingIndex){className+=' drop-over-upward';}}return connectDragSource(connectDropTarget(wp.element.createElement('tr',_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_37_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_39_react_dnd__["DropTarget"])('row',rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_39_react_dnd__["DragSource"])('row',rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));/* DnD */

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var BookOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z" } }] }, "name": "book", "theme": "outlined" };
exports.default = BookOutlined;


/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RecipeInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_list_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_list__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_BookOutlined__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_BookOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_BookOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_icons_QuestionCircleOutlined__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_icons_QuestionCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_icons_QuestionCircleOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_number_style__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_input_number_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_input_number_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_date_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_switch_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_switch__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_immutability_helper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__styles_module_scss__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_braft_editor__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_braft_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_braft_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_react_device_detect__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_react_device_detect__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_37_antd_lib_select___default.a.Option;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var RecipeInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_40_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_41_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(RecipeInfo,_Component);function RecipeInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecipeInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipeInfo.__proto__||Object.getPrototypeOf(RecipeInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_38_react___default.a.createRef(),_this.state={tableData:{current:0,//目前頁數
page_size:10,//一頁幾筆
total:0,//以此query條件，總共幾筆資料
rows:[]},recipeInfo:{id:null,status:1,name:null,logo:null,type:1,ingredients:[{},{}]},data:[],messages:{},isFetchData:false,isSubmitData:false,isPreviewData:false,source:null,additional:null,searchTotal:0,searchOrder:0,value:null,searchTitle:''},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.cloneDeep(devRecipeInfo);if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.isString(data.cover)){data.cover=null;}else{data.cover={id:1,path:data.cover,url:data.cover_url};}data.show_range=[__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(data,'show_at')?__WEBPACK_IMPORTED_MODULE_54_moment___default()(__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(data,'show_at')):null,__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(data,'show_at')?__WEBPACK_IMPORTED_MODULE_54_moment___default()(__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(data,'hide_at')):null];// data.promotion_date_range = [moment(_.get(data, 'promotion_start_date')), moment(_.get(data, 'promotion_end_date'))]
if(!__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.isBoolean(data.status))data.status=data.status===1;__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.set(_this,'state.source',data.source);// _.set(this, 'state.additional',data.additional)
data.source=__WEBPACK_IMPORTED_MODULE_55_braft_editor___default.a.createEditorState(data.source);// data.additional=BraftEditor.createEditorState(data.additional)
_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true,isPreviewData:true});__WEBPACK_IMPORTED_MODULE_45__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_46__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/recipes/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/recipes');return;}_this.fillData(data);});},_this.submitData=function(){var recipeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};window.cc=_this.formRef.current;console.log('this.formRef.current',_this.formRef.current);// 把Control元件轉換回上傳資料
recipeInfo.cover=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(recipeInfo,'cover.path');recipeInfo.show_at=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(recipeInfo,'show_range.0')?__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(recipeInfo,'show_range.0').format('YYYY-MM-DD HH:mm:ss'):null;recipeInfo.hide_at=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(recipeInfo,'show_range.1')?__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(recipeInfo,'show_range.1').format('YYYY-MM-DD HH:mm:ss'):null;var source=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'state.source').toHTML();source=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'state.source').toHTML();// var additional = _.get(this,'state.additional').toHTML()
// additional     = _.get(this,'state.additional').toHTML()
recipeInfo.source=source;// recipeInfo.additional = additional
delete recipeInfo.show_range;recipeInfo.steps=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.map(recipeInfo.steps,function(step){return Object.assign({},step,{image:{uid:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.uid'),name:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.name'),path:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.path',__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.response.data.path')),url:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.url',__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(step,'image.response.data.url'))}});});console.log('submitData',recipeInfo);var current_user=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');recipeInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'props.match.params.id','');_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_45__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_46__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/recipes/'+id),recipeInfo,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});var messages=data.messages;if(__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.isObject(messages)){//處理錯誤訊息
__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.map(messages,function(errors,key){console.log('map',key,errors);return{touched:true,validating:false,errors:[],name:[key],value:_this.getFieldValue(key)};});_this.forceUpdate();console.log('this.formRef.current',_this.formRef.current);}return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.success('新增成功');_this.setState({recipeInfo:data});return _this.props.history.replace('/recipes/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_45__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_46__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/recipes/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_33_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/recipes');});},_this.getImages=function(){return _this.formRef.current&&__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.isArray(_this.formRef.current.getFieldValue('images'))?_this.formRef.current.getFieldValue('images'):[];},_this.moveRow=function(dragIndex,hoverIndex){var _this$state=_this.state,_this$state$table_dat=_this$state.table_data,table_data=_this$state$table_dat===undefined?{}:_this$state$table_dat,_this$state$table_dat2=_this$state.table_data;_this$state$table_dat2=_this$state$table_dat2===undefined?{}:_this$state$table_dat2;var _this$state$table_dat3=_this$state$table_dat2.rows,rows=_this$state$table_dat3===undefined?[]:_this$state$table_dat3;var images=_this.getImages();var dragRow=images[dragIndex];images=__WEBPACK_IMPORTED_MODULE_42_immutability_helper___default()(images,{$splice:[[dragIndex,1],[hoverIndex,0,dragRow]]});_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:['images'],value:images}]);},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.previewRecipe=function(){var recipe=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'props.match.params.name');var id=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;var INDEX_URL=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');if(recipe&&recipe>0){window.open(INDEX_URL+('/recipe-info-preview/?recipe='+id));return;}},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_this.sourceChange=function(editorState){_this.setState({source:editorState});},_this.productSearch=function(value,idx,title){console.log('搜尋: ',value,' idx: ',idx);_this.setState({searchOrder:idx});_this.setState({value:value});_this.setState({searchTitle:title});__WEBPACK_IMPORTED_MODULE_45__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_46__configs_env__["b" /* API_HOST */]+'/api/v1/products/',{keyword:value},function(state,res){_this.setState({isFetchData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_35_antd_lib_message___default.a.warning(reason);return;}console.log('fillData',data);_this.fillData(data);_this.setState({tableData:data});console.log('total: ',data.total);_this.setState({searchTotal:data.total});});},_this.loadData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var page=opt.page,page_size=opt.page_size;console.log('tableData: ',_this.state.tableData);_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_45__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_46__configs_env__["b" /* API_HOST */]+'/api/v1/products/',{page:page,page_size:page_size,keyword:_this.state.value},function(state,res){_this.setState({isLoadingData:false});var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?'發生錯誤':_res$reason5,_res$data6=res.data,data=_res$data6===undefined?{}:_res$data6;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({tableData:data});});},_this.selectProduct=function(item){var idx=_this.state.searchOrder;var title=_this.state.searchTitle;console.log('item: ',item);console.log('id: ',item.id);console.log('idx: ',idx);console.log('title: ',title);_this.formRef.current.setFields([{name:[title,idx,'id'],value:item.id,touched:true,validating:false,errors:[]}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipeInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_47_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();this.fillData();}// 抓取頁面資訊
//預覽食譜資訊
// additionalChange = (editorState) => {
//   this.setState({
//     additional: editorState
//   })
// }
// 拉Table資料
},{key:'render',value:function render(){var _this2=this;// 登入使用者的權限
var errors=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_52_validatorjs_src_errors___default.a());var editorPermissions=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(this,'props.app.options',{});var pdf=this.getFieldValue('pdf');var id=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(this,'props.match.params.id');var source=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(this,'state.source');// const additional = _.get(this, 'state.additional')
var controls=['font-size','line-height','text-color','bold','italic','underline','text-align','text-color','blockquote','separator','headings','undo','redo','separator','link','separator'];var _state=this.state,_state$tableQuery=_state.tableQuery,tableQuery=_state$tableQuery===undefined?{}:_state$tableQuery,_state$tableData=_state.tableData,tableData=_state$tableData===undefined?{}:_state$tableData;var searchTotal=this.state.searchTotal;var searchTitle=this.state.searchTitle;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_44__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_39_react_router_dom__["b" /* Link */],{to:'/recipes'},'\u98DF\u8B5C\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_antd_lib_breadcrumb___default.a.Item,null,'\u98DF\u8B5C\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u98DF\u8B5C\u8CC7\u8A0A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_53__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){return console.log('onValuesChange',changedFields);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'primary',style:{marginLeft:8},disabled:id==undefined,onClick:this.previewRecipe},'\u9810\u89BD')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','名稱'),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('status','狀態','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_23_antd_lib_switch___default.a,{checkedChildren:'\u555F\u7528',unCheckedChildren:'\u505C\u7528'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('show_range','系統上下架時間'),{extra:'\u7CFB\u7D71\u65BC\u8A72\u6642\u6BB5\u986F\u793A\u65BC\u5B98\u7DB2\uFF0C\u6CE8\u610F\u72C0\u614B\u9700\u70BA\u300C\u555F\u7528\u300D\u3002'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_date_picker___default.a.RangePicker,{showTime:{defaultValue:[__WEBPACK_IMPORTED_MODULE_54_moment___default()('09:00:00','HH:mm:ss'),__WEBPACK_IMPORTED_MODULE_54_moment___default()('23:59:59','HH:mm:ss')],format:'HH:mm'},format:'YYYY-MM-DD HH:mm'})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('sort','排序'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number___default.a,{style:{width:'100%'},min:0}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('level','難度'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_select___default.a,null,wp.element.createElement(Option,{value:0},'\u5165\u9580'),wp.element.createElement(Option,{value:1},'\u9032\u968E'),wp.element.createElement(Option,{value:2},'\u5927\u5E2B'),wp.element.createElement(Option,{value:3},'\u795E\u7D1A'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('portion','人份'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number___default.a,{style:{width:'100%'},min:1}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('category_id','食譜類別'),{rules:[{required:true,message:'請選擇目錄類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(options,'recipe_categories',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('desc','食譜說明'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a.TextArea,{rows:5}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('youtube','Youtube連結'),{rules:[{type:'url',message:'請填寫正確連結'}],extra:wp.element.createElement('a',{href:'https://support.google.com/youtube/answer/57741?hl=zh-Hant&co=GENIE.Platform=Desktop',target:'_blank',rel:'noopener noreferrer'},'\u8907\u88FDYoutube\u9023\u7D50 ',wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17__ant_design_icons_lib_icons_QuestionCircleOutlined___default.a,null))}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('prepare_time','準備時間（分鐘）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number___default.a,{style:{width:'100%'},min:0})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('cook_time','烹調時間（分鐘）'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_input_number___default.a,{style:{width:'100%'},min:0}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u7C21\u4ECB\u5716\u7247\u96C6'),wp.element.createElement('span',null,'\u6B64\u5340\u584A\u64CD\u4F5C\u5F8C\u9084\u9700\u6309\u4E0B\u4E0A\u65B9\u7684\u300C\u5132\u5B58\u300D\u8CC7\u6599\u65B9\u5F97\u4FDD\u7559'),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,{label:'\u5C01\u9762',style:{minHeight:166}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'images'},function(){var url=__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(_this2.getFieldValue('images'),'0.url');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_avatar___default.a,{shape:'square',size:128,style:{height:166},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_14__ant_design_icons_lib_icons_BookOutlined___default.a,null),src:url});}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('images','圖片上傳 寬800x高800'),{valuePropName:'fileList',extra:'\u5BEC800x\u9AD8800\uFF0C\u7B2C\u4E00\u5F35\u5716\u7247\u70BA\u5C01\u9762'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_49_components_WUpload_WUpload__["b" /* default */],{multiple:true,showUploadList:false},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11__ant_design_icons_lib_icons_UploadOutlined___default.a,null),' \u4E0A\u50B3'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'images'},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;return wp.element.createElement('div',null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:_this2.getFieldValue('images'),loading:_this2.state.isLoadingData,pagination:false,rowKey:'id',components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#'},{dataIndex:'url',title:'圖片',render:function render(url,asset){return wp.element.createElement('div',{className:'tableImg',style:{backgroundImage:'url('+url+')'},alt:'avatar'});}},{dataIndex:'name',title:'名稱',render:function render(name,item){return _this2.getFieldValue('images').indexOf(item)===0?'[\u5C01\u9762] '+name:name;}},{title:'Action',dataIndex:'id',key:'tools',width:250,render:function render(id,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_50_components_DeleteConfirmButton_DeleteConfirmButton__["a" /* default */],{loading:record.isDeleteData===true,size:'small',onConfirm:function onConfirm(){var images=_this2.getFieldValue('images');remove(images.indexOf(record));}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_10__ant_design_icons_lib_icons_EyeOutlined___default.a,null),onClick:function onClick(){return _this2.setState({previewImage:{url:record.url}});}},'\u6AA2\u8996')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u4E3B\u8981\u98DF\u6750'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'ingredients'},function(fields,_ref3){var add=_ref3.add,remove=_ref3.remove,move=_ref3.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'名稱',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'name']),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'portion',title:'數量',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'portion']),{rules:[{required:false,message:'請填寫數量'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'unit',title:'單位',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'unit']),{rules:[{required:false,message:'請填寫單位'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'id',title:'商品代號',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'id']),{rules:[{required:false,message:'請填寫商品代號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search___default.a,{placeholder:'\u8F38\u5165\u5546\u54C1\u4EE3\u865F\u6216\u662F\u95DC\u9375\u5B57',onSearch:function onSearch(value){return _this2.productSearch(value,idx,'ingredients');},enterButton:'\u641C\u5C0B'}));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'),searchTotal>0&&searchTitle=='ingredients'&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:tableData.rows,loading:_this2.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'name',title:'名稱'},{dataIndex:'price',title:'價格'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',onClick:function onClick(){return _this2.selectProduct(record);}},'\u9078\u64C7')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u914D\u83DC dishes'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'dishes'},function(fields,_ref4){var add=_ref4.add,remove=_ref4.remove,move=_ref4.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'名稱',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'name']),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'portion',title:'數量',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'portion']),{rules:[{required:false,message:'請填寫數量'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'unit',title:'單位',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'unit']),{rules:[{required:false,message:'請填寫單位'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'id',title:'商品代號',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'id']),{rules:[{required:false,message:'請填寫商品代號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search___default.a,{placeholder:'\u8F38\u5165\u5546\u54C1\u4EE3\u865F\u6216\u662F\u95DC\u9375\u5B57',onSearch:function onSearch(value){return _this2.productSearch(value,idx,'dishes');},enterButton:'\u641C\u5C0B'}));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'),searchTotal>0&&searchTitle=='dishes'&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:tableData.rows,loading:_this2.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'name',title:'名稱'},{dataIndex:'price',title:'價格'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',onClick:function onClick(){return _this2.selectProduct(record);}},'\u9078\u64C7')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u8ABF\u5473\u6599 condiments'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'condiments'},function(fields,_ref5){var add=_ref5.add,remove=_ref5.remove,move=_ref5.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'名稱',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'name']),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'portion',title:'數量',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'portion']),{rules:[{required:false,message:'請填寫數量'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'unit',title:'單位',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'unit']),{rules:[{required:false,message:'請填寫單位'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'id',title:'商品代號',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'id']),{rules:[{required:false,message:'請填寫商品代號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search___default.a,{placeholder:'\u8F38\u5165\u5546\u54C1\u4EE3\u865F\u6216\u662F\u95DC\u9375\u5B57',onSearch:function onSearch(value){return _this2.productSearch(value,idx,'condiments');},enterButton:'\u641C\u5C0B'}));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'),searchTotal>0&&searchTitle=='condiments'&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:tableData.rows,loading:_this2.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'name',title:'名稱'},{dataIndex:'price',title:'價格'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',onClick:function onClick(){return _this2.selectProduct(record);}},'\u9078\u64C7')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u9183\u6599'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'dips'},function(fields,_ref6){var add=_ref6.add,remove=_ref6.remove,move=_ref6.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'名稱',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'name']),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'portion',title:'數量',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'portion']),{rules:[{required:false,message:'請填寫數量'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'unit',title:'單位',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'unit']),{rules:[{required:false,message:'請填寫單位'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null));}},{dataIndex:'id',title:'商品代號',render:function render(unit,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'id']),{rules:[{required:false,message:'請填寫商品代號'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_56_antd_lib_input_Search___default.a,{placeholder:'\u8F38\u5165\u5546\u54C1\u4EE3\u865F\u6216\u662F\u95DC\u9375\u5B57',onSearch:function onSearch(value){return _this2.productSearch(value,idx,'dips');},enterButton:'\u641C\u5C0B'}));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'),searchTotal>0&&searchTitle=='dips'&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{dataSource:tableData.rows,loading:_this2.state.isLoadingData,pagination:{current:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'current',[]),total:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'total',0),pageSize:__WEBPACK_IMPORTED_MODULE_43_lodash___default.a.get(tableData,'page_size',0),onChange:function onChange(page,page_size){_this2.loadData({page:page,page_size:page_size});}},columns:[{dataIndex:'id',title:'ID'},{dataIndex:'name',title:'名稱'},{dataIndex:'price',title:'價格'},{title:'Action',key:'tools',width:250,render:function render(text,record){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a,{grid:{gutter:4,column:3},dataSource:[wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{type:'default',size:'small',onClick:function onClick(){return _this2.selectProduct(record);}},'\u9078\u64C7')],renderItem:function renderItem(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_list___default.a.Item,null,item);}});}}]}));}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u6B65\u9A5F steps'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.List,{name:'steps'},function(fields,_ref7){var add=_ref7.add,remove=_ref7.remove,move=_ref7.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'圖片',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'image'],'圖片 寬800x高800'),{style:{minHeight:166}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_49_components_WUpload_WUpload__["a" /* AvatarUpload */],null));}},{dataIndex:'portion',title:'說明',render:function render(portion,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38_react__["Fragment"],null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'desc'],'說明'),{rules:[{required:true,message:'請填寫說明'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])([idx,'tip'],'訣竅'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_input___default.a,null)));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'));}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_16_antd_lib_divider___default.a,null,'\u4E86\u89E3\u66F4\u591A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_51_libs_FormHelper__["a" /* genFormItemAtrribute */])('source',''),{validateTrigger:'onBlur'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_55_braft_editor___default.a,{style:{border:'1px solid'},className:'my-editor',controls:controls,placeholder:'\u8ACB\u8F38\u5165\u6587\u5B57',language:'zh-hant',defaultValue:source,contentStyle:{height:150,boxShadow:'inset 0 1px 3px rgba(0,0,0,.1)'},onChange:this.sourceChange})))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement('img',{alt:'Preview',style:{width:'100%'},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return RecipeInfo;}(__WEBPACK_IMPORTED_MODULE_38_react__["Component"]))||_class);var devRecipeInfo={name:'',type:1,desc:null,sort:null,logo:null,pdfs:[],images:[]};/* DnD */var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:'render',value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,['isOver','connectDragSource','connectDropTarget','moveRow']);var style=Object.assign({},restProps.style,{cursor:'move'});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=' drop-over-downward';}if(restProps.index<dragingIndex){className+=' drop-over-upward';}}return connectDragSource(connectDropTarget(wp.element.createElement('tr',_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_38_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_40_react_dnd__["DropTarget"])('row',rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_40_react_dnd__["DragSource"])('row',rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));/* DnD */

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="0.7.31",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY).replace(/\s\s*$/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/\bqbcore\/([\w\.]+)/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+ ([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!==UNDEF_TYPE&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser.major=majorize(_browser.version);return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(818)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VendorInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_immutability_helper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_module_scss__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_DeleteConfirmButton_DeleteConfirmButton__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_moment__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a.Option;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var VendorInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_22_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_23_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(VendorInfo,_Component);function VendorInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VendorInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VendorInfo.__proto__||Object.getPrototypeOf(VendorInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef(),_this.state={recipeInfo:{id:null,status:1,name:null,logo:null,type:1,ingredients:[{},{}]},data:[],messages:{},isFetchData:false,isSubmitData:false},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.cloneDeep(devVendorInfo);if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isString(data.image)){data.image=null;}else{data.image={id:1,path:data.image,url:data.image_url};}if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isBoolean(data.status))data.status=data.status===1;_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/vendors/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/vendors');return;}_this.fillData(data);});},_this.submitData=function(){var recipeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// 把Control元件轉換回上傳資料
recipeInfo.image=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(recipeInfo,'image.path');var current_user=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');recipeInfo.user_id=current_user.ID;var id=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this,'props.match.params.id','');_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/vendors/'+id),recipeInfo,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_15_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});var messages=data.messages;if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isObject(messages)){//處理錯誤訊息
__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.map(messages,function(errors,key){console.log('map',key,errors);return{touched:true,validating:false,errors:[],name:[key],value:_this.getFieldValue(key)};});_this.forceUpdate();console.log('this.formRef.current',_this.formRef.current);}return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('新增成功');_this.setState({recipeInfo:data});return _this.props.history.replace('/vendors/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.success('更新成功');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_27__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_28__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/vendors/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_17_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_15_antd_lib_notification___default.a['success']({message:'刪除成功'});return _this.props.history.replace('/vendors');});},_this.getImages=function(){return _this.formRef.current&&__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isArray(_this.formRef.current.getFieldValue('images'))?_this.formRef.current.getFieldValue('images'):[];},_this.moveRow=function(dragIndex,hoverIndex){var _this$state=_this.state,_this$state$table_dat=_this$state.table_data,table_data=_this$state$table_dat===undefined?{}:_this$state$table_dat,_this$state$table_dat2=_this$state.table_data;_this$state$table_dat2=_this$state$table_dat2===undefined?{}:_this$state$table_dat2;var _this$state$table_dat3=_this$state$table_dat2.rows,rows=_this$state$table_dat3===undefined?[]:_this$state$table_dat3;var images=_this.getImages();var dragRow=images[dragIndex];images=__WEBPACK_IMPORTED_MODULE_24_immutability_helper___default()(images,{$splice:[[dragIndex,1],[hoverIndex,0,dragRow]]});_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:['images'],value:images}]);},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+"";if(value.indexOf("TextArea")!==-1){console.log('TextArea');}else e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VendorInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_29_libs_AppHelper__["a" /* default */].updateConfig();this.fetchData();}// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;// 登入使用者的權限
var errors=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_34_validatorjs_src_errors___default.a());var editorPermissions=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this,'props.app.options',{});var pdf=this.getFieldValue('pdf');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_26__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_react_router_dom__["b" /* Link */],{to:'/vendors'},'\u7B2C\u4E09\u65B9\u5E73\u53F0\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_breadcrumb___default.a.Item,null,'\u7B2C\u4E09\u65B9\u5E73\u53F0\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u7B2C\u4E09\u65B9\u5E73\u53F0\u8CC7\u8A0A'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_35__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onValuesChange:function onValuesChange(changedFields,allFields){return console.log('onValuesChange',changedFields);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','名稱'),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_input___default.a,null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__["a" /* genFormItemAtrribute */])('type','平台類別'),{rules:[{required:true,message:'請選擇類別'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_select___default.a,{showSearch:true,filterOption:function filterOption(input,option){return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(options,'vendor_types',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.id},item.name);})))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_33_libs_FormHelper__["a" /* genFormItemAtrribute */])('image','圖片 寬1110x高370'),{style:{minHeight:166}}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_31_components_WUpload_WUpload__["a" /* AvatarUpload */],null)))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement('img',{alt:'Preview',style:{width:'100%'},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return VendorInfo;}(__WEBPACK_IMPORTED_MODULE_20_react__["Component"]))||_class);var devVendorInfo={name:'3皇3家',type:1,desc:null,sort:null,logo:null,pdfs:[],images:[]/* DnD */};var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:'render',value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,['isOver','connectDragSource','connectDropTarget','moveRow']);var style=Object.assign({},restProps.style,{cursor:'move'});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=' drop-over-downward';}if(restProps.index<dragingIndex){className+=' drop-over-upward';}}return connectDragSource(connectDropTarget(wp.element.createElement('tr',_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_22_react_dnd__["DropTarget"])('row',rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_22_react_dnd__["DragSource"])('row',rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));/* DnD */

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NewsInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_table_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_checkbox_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_dnd__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_dnd_html5_backend__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_immutability_helper__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_module_scss__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_25_antd_lib_select___default.a.Option;var devNewsInfo={user_id:'',privileges:{}};function ImageSize(category){//大Banner
if(category==50)return'建議尺寸: 1440 x 640';//中Banner
else if(category==53)return'建議尺寸: 1200 x 600';//美食購物, 品牌列表 Banner
else if(category==54||category==110)return'建議尺寸: 1080 x 400';//活動消息
else return'封面建議尺寸: 1200 x 600 (2:1) ; 內頁建議尺寸: 最小寬度1080以上即可';}var privilegeOptions=[{keyPath:'news',value:true,name:'最新消息'},// { keyPath: 'life', value: true, name: '生活專欄' },
{keyPath:'categories',value:true,name:'類別管理'},{keyPath:'catalogues',value:true,name:'促銷目錄管理'},{keyPath:'recipes',value:true,name:'食譜管理'},{keyPath:'deliveries',value:true,name:'第三方平台管理'},{keyPath:'cibc',value:true,name:'保經據點管理'},{keyPath:'privileges',value:true,name:'權限管理'},{keyPath:['brands','create'],value:true,name:'新增品牌'},{keyPath:['brands','modify'],value:true,name:'編輯品牌'},{keyPath:['stores','create'],value:true,name:'新增分店'},{keyPath:'static',value:true,name:'靜態頁面轉換'},{keyPath:'hotkeywords',value:true,name:'熱門關鍵字'}];var NewsInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_28_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_29_react_dnd_html5_backend___default.a),_dec(_class=function(_Component){_inherits(NewsInfo,_Component);function NewsInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsInfo.__proto__||Object.getPrototypeOf(NewsInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_26_react___default.a.createRef(),_this.state={storeOptions:[],privilegeInfo:{id:null,status:1,name:null,logo:null,type:1,action_type:0,category_id:null,is_middle_banner:0},data:[],messages:{},isFetchData:false,isSubmitData:false,cate:null,cateName:null},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.cloneDeep(devNewsInfo);console.log('fill',data);if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
// data.show_range = [_.get(data, 'show_at') ? moment(_.get(data, 'show_at')) : null, _.get(data, 'show_at') ? moment(_.get(data, 'hide_at')) : null]
// data.date_range = [moment(_.get(data, 'start_date')), moment(_.get(data, 'end_date'))]
// if (!_.isBoolean(data.status)) data.status = data.status === 1
// if (!_.isBoolean(data.is_middle_banner)) data.is_middle_banner = data.is_middle_banner === 1
// _.map(data.images,(item,idx)=>{
//   if(item.path==null||item.url==null){data.images.splice(idx, 1);}
// })
_this.formRef.current.setFieldsValue(data);},_this.loadStoresData=function(){var opt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1,page_size:10};var table_query=_this.state.table_query;var tableQuery=_this.formRef.current.getFieldValue();var page=opt.page,page_size=opt.page_size;_this.setState({isLoadingData:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+'/api/mgt/v1/stores',{page:page,page_size:'all',keyword:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(tableQuery,'keyword')// group: _.get(tableQuery, 'store_group_id'),
// area: _.get(tableQuery, 'store_area_id'),
// store_type: _.get(tableQuery, 'store_type_id'),
},function(state,res){_this.setState({isLoadingData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return _this.setState({message:'發生錯誤'});}if(code!==200){return _this.setState({message:reason});}_this.setState({storeOptions:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(data,'rows',[])});});},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id');console.log(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params'));if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/privileges/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/privileges');return;}_this.fillData(data);});},_this.submitData=function(){var privilegeInfo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// 把Control元件轉換回上傳資料
privilegeInfo.user_id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id');// privilegeInfo.cover = _.get(privilegeInfo,'cover.path')
// privilegeInfo.show_at    = _.get(privilegeInfo, 'show_range.0').format('YYYY-MM-DD HH:mm:ss')
// privilegeInfo.hide_at    = _.get(privilegeInfo, 'show_range.1').format('YYYY-MM-DD HH:mm:ss')
// privilegeInfo.start_date = _.get(privilegeInfo, 'date_range.0').format('YYYY-MM-DD')
// privilegeInfo.end_date   = _.get(privilegeInfo, 'date_range.1').format('YYYY-MM-DD')
// privilegeInfo.category_id = this.getFieldValue('category_id')
//privilegeInfo.is_middle_banner = this.getFieldValue('is_middle_banner')
// if(this.getFieldValue('category_id') == 53)
// {
//   privilegeInfo.is_middle_banner = 1;
// }
//delete privilegeInfo.show_range
//delete privilegeInfo.date_range
console.log('submitData',privilegeInfo);var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id','');_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/privileges/'+id),privilegeInfo,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_21_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});var messages=data.messages;if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isObject(messages)){//處理錯誤訊息
__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.map(messages,function(errors,key){console.log('map',key,errors);return{touched:true,validating:false,errors:[],name:[key],value:_this.getFieldValue(key)};});_this.forceUpdate();console.log('this.formRef.current',_this.formRef.current);}return _this.setState({messages:data.messages||{}});}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('更新成功');_this.fillData(data);});},_this.deleteData=function(item){if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isNil(item.id))return;item.isDeleteData=true;_this.setState({isDeleteData:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/privileges/'+item.id),{},function(state,res){item.isDeleteData=false;_this.setState({isDeleteData:false});var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?'發生錯誤':_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('刪除成功');_this.loadData();});},_this.cloneData=function(item){if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isNil(item.id))return;item.isCloneData=true;_this.setState({isCloneData:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/privileges/'+item.id+'/clone'),{},function(state,res){item.isCloneData=false;_this.setState({isCloneData:false});var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?'發生錯誤':_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_message___default.a.success('複製成功');if(!__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isNil(data.id))_this.props.history.push('/privileges/view/'+data.id);});},_this.getImages=function(){return _this.formRef.current&&__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isArray(_this.formRef.current.getFieldValue('images'))?_this.formRef.current.getFieldValue('images'):[];},_this.moveRow=function(dragIndex,hoverIndex){var _this$state=_this.state,_this$state$table_dat=_this$state.table_data,table_data=_this$state$table_dat===undefined?{}:_this$state$table_dat,_this$state$table_dat2=_this$state.table_data;_this$state$table_dat2=_this$state$table_dat2===undefined?{}:_this$state$table_dat2;var _this$state$table_dat3=_this$state$table_dat2.rows,rows=_this$state$table_dat3===undefined?[]:_this$state$table_dat3;var images=_this.getImages();var dragRow=images[dragIndex];images=__WEBPACK_IMPORTED_MODULE_30_immutability_helper___default()(images,{$splice:[[dragIndex,1],[hoverIndex,0,dragRow]]});_this.formRef.current.setFields([{touched:true,validating:false,errors:[],name:['images'],value:images}]);},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_35_libs_AppHelper__["a" /* default */].updateConfig();this.loadStoresData();this.fetchData();this.fillData();}// 拉Table資料
// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;// 登入使用者的權限
var errors=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_37_validatorjs_src_errors___default.a());var editorPermissions=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this.props,'auth.permissions',{});var options=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'props.app.options',{});var pdf=this.getFieldValue('pdf');var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'props.match.params.id');var category_id=this.getFieldValue('category_id');var storeOptions=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'state.storeOptions');window.getFieldValue=this.getFieldValue;//const privilegeInfo
return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_32__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_react_router_dom__["b" /* Link */],{to:'/privileges'},'\u6B0A\u9650\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_breadcrumb___default.a.Item,null,'\u6B0A\u9650')),wp.element.createElement('h2',null,'\u6B0A\u9650',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_38__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);},onFieldsChange:function onFieldsChange(changedFields,allFields){console.log('onFieldsChange',changedFields,allFields);},onValuesChange:function onValuesChange(changedFields,allFields){console.log('onValuesChange',_this2.getFieldValue('stores'),changedFields);}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_id','Username'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_input___default.a,{defaultValue:'Username',disabled:true}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u6B0A\u9650\u7BA1\u7406'),__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.map(privilegeOptions,function(item){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isString(item.keyPath)?['privileges',item.keyPath]:['privileges'].concat(_toConsumableArray(item.keyPath))),{valuePropName:'checked',noStyle:true}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9_antd_lib_checkbox___default.a,{value:item.value},item.name));}),wp.element.createElement('div',{className:'flexBox'}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u5206\u5E97\u7BA1\u7406'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.List,{name:['privileges','stores','modify']},function(fields,_ref2){var add=_ref2.add,remove=_ref2.remove,move=_ref2.move;return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null,fields.length>0&&wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_table___default.a,{pagination:false,rowKey:function rowKey(item,idx){return idx;},dataSource:fields,components:{body:{row:DragableBodyRow}},onRow:function onRow(record,index){return{index:index,moveRow:function moveRow(dragIndex,hoverIndex){return move(dragIndex,hoverIndex);}};},columns:[{dataIndex:'id',title:'#',render:function render(id,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,idx+1);}},{dataIndex:'name',title:'名稱',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_36_libs_FormHelper__["a" /* genFormItemAtrribute */])(idx),{rules:[{required:true,message:'請填寫名稱'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_25_antd_lib_select___default.a,{showSearch:true,style:{width:200},placeholder:'\u8F38\u5165\u5E97\u540D',optionFilterProp:'children'// onChange={onChange}
// onFocus={onFocus}
// onBlur={onBlur}
// onSearch={onSearch}
,filterOption:function filterOption(input,option){console.log('filterOption',input,option);return option.children.toLowerCase().indexOf(input.toLowerCase())>=0;}},wp.element.createElement(Option,{value:'all'},'\u5168\u90E8'),__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.map(storeOptions,function(store){return wp.element.createElement(Option,{value:store.id,data:store},store.name);})));}},{dataIndex:'name',title:'Action',render:function render(name,item,idx){return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{danger:true,onClick:function onClick(){return remove(idx);}},'\u522A\u9664'));}}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_button___default.a,{onClick:function onClick(){return add();}},'\u65B0\u589E'));}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_modal___default.a,{visible:this.state.previewImage,footer:null,onCancel:function onCancel(){return _this2.setState({previewImage:null});}},wp.element.createElement('img',{alt:'Preview',style:{width:'100%'},src:this.state.previewImage&&this.state.previewImage.url}))));}}]);return NewsInfo;}(__WEBPACK_IMPORTED_MODULE_26_react__["Component"]))||_class);/* DnD */var dragingIndex=-1;var BodyRow=function(_React$Component){_inherits(BodyRow,_React$Component);function BodyRow(){_classCallCheck(this,BodyRow);return _possibleConstructorReturn(this,(BodyRow.__proto__||Object.getPrototypeOf(BodyRow)).apply(this,arguments));}_createClass(BodyRow,[{key:'render',value:function render(){var _props=this.props,isOver=_props.isOver,connectDragSource=_props.connectDragSource,connectDropTarget=_props.connectDropTarget,moveRow=_props.moveRow,restProps=_objectWithoutProperties(_props,['isOver','connectDragSource','connectDropTarget','moveRow']);var style=Object.assign({},restProps.style,{cursor:'move'});var className=restProps.className;if(isOver){if(restProps.index>dragingIndex){className+=' drop-over-downward';}if(restProps.index<dragingIndex){className+=' drop-over-upward';}}return connectDragSource(connectDropTarget(wp.element.createElement('tr',_extends({},restProps,{className:className,style:style}))));}}]);return BodyRow;}(__WEBPACK_IMPORTED_MODULE_26_react___default.a.Component);var rowSource={beginDrag:function beginDrag(props){dragingIndex=props.index;return{index:props.index};}};var rowTarget={drop:function drop(props,monitor){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Time to actually perform the action
props.moveRow(dragIndex,hoverIndex);// Note: we're mutating the monitor item here!
// Generally it's better to avoid mutations,
// but it's good here for the sake of performance
// to avoid expensive index searches.
monitor.getItem().index=hoverIndex;}};var DragableBodyRow=Object(__WEBPACK_IMPORTED_MODULE_28_react_dnd__["DropTarget"])('row',rowTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(Object(__WEBPACK_IMPORTED_MODULE_28_react_dnd__["DragSource"])('row',rowSource,function(connect){return{connectDragSource:connect.dragSource()};})(BodyRow));/* DnD */

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CIBCInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_layout_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_skeleton_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_time_picker_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_avatar_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PictureOutlined__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PictureOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PictureOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_lib_divider_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_popconfirm_style__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_antd_lib_popconfirm_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_antd_lib_popconfirm_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_popconfirm__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_lib_popconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_lib_popconfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_button__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_antd_lib_breadcrumb_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_antd_lib_select_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_select__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_module_scss__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_CitySelect_CitySelect__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_WUpload_WUpload__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_validatorjs_src_errors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_validatorjs_src_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_validatorjs_src_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_ValidatorErrorAlert_ValidatorErrorAlert__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_google_map_react__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_google_map_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_google_map_react__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Option=__WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a.Option;var cardBodyStyle={padding:8,fontSize:8};var listGrid={gutter:16,xs:1,sm:2,md:4,lg:4,xl:4,xxl:4};var CIBCInfo=function(_Component){_inherits(CIBCInfo,_Component);function CIBCInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CIBCInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CIBCInfo.__proto__||Object.getPrototypeOf(CIBCInfo)).call.apply(_ref,[this].concat(args))),_this),_this.formRef=__WEBPACK_IMPORTED_MODULE_28_react___default.a.createRef(),_this.state={CIBCInfo:{id:null,name:'',iscibc:false,iscibc_name:'',address:'',users:[]},data:[],messages:{},isFetchData:false,isSubmitData:false,isImage:false,iscibc:false,pic:false},_this.fillData=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//console.log('CIBCInfo',data.iscibc)
_this.setState({CIBCInfo:data},function(){//console.log('CIBCInfo',data)
});if(!_this.formRef.current)return;// 處理資料，本地適合Form Control的資料
//if (!_.isBoolean(data.status)) data.status = data.status === 1
if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(data,'users.length')>0){var userInfo=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(data,'users')[0];//console.log('CIBCInfo-userInfo',userInfo,)
data.user_name=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'name');data.user_seniority=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'seniority');if(!__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isNil(userInfo.open_at)&&!__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.isNil(userInfo.close_at))data.user_service_time=[__WEBPACK_IMPORTED_MODULE_30_moment___default()(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'open_at'),'HH:mm'),__WEBPACK_IMPORTED_MODULE_30_moment___default()(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'close_at'),'HH:mm')];data.user_licenses=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'licenses');if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'image.length')>0){data.image=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(userInfo,'image');_this.setState({pic:true});}else _this.setState({pic:false});}data.user_location=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(data,'store_group_name');_this.setState({iscibc:data.iscibc});//console.log('CIBCInfo-data',data)
_this.formRef.current.setFieldsValue(data);},_this.fetchData=function(){var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isFetchData:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/cibcs/'+id),null,function(state,res){_this.setState({isFetchData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;console.log(code,reason,data,res);if(state===false||code!==200){__WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.warning(reason);_this.props.history.replace('/cibc');return;}_this.fillData(data);});},_this.submitData=function(){var Info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var user_id=null;if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_service_time.0'))var open_at=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_service_time.0').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_service_time.1'))var close_at=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_service_time.1').format('HH:mm');if(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'state.CIBCInfo.users.length')>0)user_id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'state.CIBCInfo.users')[0].id;//console.log('idididid',_.get(this, 'state.CIBCInfo.users')[0],user_id)
var user=[{id:user_id,name:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_name'),image:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'image'),licenses:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_licenses'),location:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_location'),seniority:__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(Info,'user_seniority'),open_at:open_at,close_at:close_at}];Info.users=user;Info.iscibc=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'state.iscibc');delete Info.user_name;delete Info.image;delete Info.user_licenses;delete Info.user_location;delete Info.user_seniority;delete Info.user_service_time;//console.log('submitData',Info)
var current_user=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(window,'VC_CONFIG.WP_CURRENT_USER','');Info.user_id=current_user.ID;// 把Control元件轉換回上傳資料
var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id','');_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/cibcs/'+id),Info,function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?'發生錯誤':_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){__WEBPACK_IMPORTED_MODULE_23_antd_lib_notification___default.a['error']({message:'更新失敗',description:reason});return _this.setState({messages:data.messages||{}});}var _res$data3=res.data;_res$data3=_res$data3===undefined?{}:_res$data3;var new_id=_res$data3.id;if(new_id!=id){__WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success('建立成功');_this.setState({Info:data});return _this.props.history.replace('/cibc/view/'+new_id);}__WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.success('更新成功');return _this.props.history.replace('/cibc');});},_this.deleteUser=function(e){var id=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this,'props.match.params.id');if(!id)return;_this.setState({isDeleteUser:true});__WEBPACK_IMPORTED_MODULE_33__libs_whttp__["a" /* default */].delete(__WEBPACK_IMPORTED_MODULE_34__configs_env__["b" /* API_HOST */]+('/api/mgt/v1/cibcs/'+id),{},function(state,res){_this.setState({isDeleteUser:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?'發生錯誤':_res$reason3,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){return __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){return __WEBPACK_IMPORTED_MODULE_25_antd_lib_message___default.a.error(reason);}__WEBPACK_IMPORTED_MODULE_23_antd_lib_notification___default.a['success']({message:'成功！已將此分店移除保經據點'});return _this.props.history.replace('/cibc');});},_this.getFieldValue=function(key){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;return _this.formRef.current?_this.formRef.current.getFieldValue(key):defaultValue;},_this.enterNotSubmit=function(e){if(e.key==='Enter'){var value=e.target+'';if(value.indexOf('TextArea')!==-1){console.log('TextArea');}else e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CIBCInfo,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_35_libs_AppHelper__["a" /* default */].updateConfig();//console.log('CIBCInfo',devCIBCInfo)
this.fetchData();this.fillData();//this.fillData(devCIBCInfo)
}// 抓取頁面資訊
},{key:'render',value:function render(){var _this2=this;var errors=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'state.validator.errors',new __WEBPACK_IMPORTED_MODULE_39_validatorjs_src_errors___default.a());//const categoryOptions = _.get(options, 'brand_categories', []).filter(categoryInfo => !_.isEmpty(categoryInfo.items) )
// 登入使用者的權限
var editorPermissions=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this.props,'auth.permissions',{});var fileList=[];var options=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'props.app.options',{});var CIBCInfo=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'state.CIBCInfo');//const uploadList = this.formRef.current && _.isArray(this.formRef.current.getFieldValue('uploadList')) ? this.formRef.current.getFieldValue('uploadList') : []
//console.log('uploadList', uploadList)
return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_layout___default.a,{className:__WEBPACK_IMPORTED_MODULE_32__styles_module_scss___default.a.container},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default.a,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_29_react_router_dom__["b" /* Link */],{to:'/category'},'\u4FDD\u7D93\u64DA\u9EDE\u7BA1\u7406')),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_21_antd_lib_breadcrumb___default.a.Item,null,'\u4FDD\u7D93\u64DA\u9EDE\u8CC7\u8A0A')),wp.element.createElement('h2',null,'\u4FDD\u7D93\u64DA\u9EDE\u8CC7\u8A0A',wp.element.createElement('span',null)),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_40__components_ValidatorErrorAlert_ValidatorErrorAlert__["a" /* default */],{errors:errors}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_skeleton___default.a,{loading:this.state.isFetchData},wp.element.createElement('div',{className:'block search'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a,{ref:this.formRef,name:'basic',className:'basicForm',layout:'vertical',onFinish:function onFinish(values){return _this2.submitData(values);},onKeyDown:function onKeyDown(e){_this2.enterNotSubmit(e);}// onValuesChange={(changedFields, allFields) => {
//   console.log('onValuesChange:', changedFields, allFields)
//   if (_.has(changedFields, 'latitude') || _.has(changedFields, 'longitude')) {
//     this.reloadMaps()
//   }
// }}
// onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
// onFieldsChange={(changedFields, allFields) => {
//     const storeInfo = _.reduce(allFields,(obj,item) => {
//         _.set(obj, item.name.join('.'), item.value)
//         return obj
//       }, {})
//       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
//       return true
//     }}
},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{style:{textAlign:'right'},taillayout:{wrapperCol:{offset:8,span:16}}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{type:'primary',htmlType:'submit',style:{marginLeft:8},disabled:!this.state.iscibc,loading:this.state.isSubmitData},'\u5132\u5B58')),wp.element.createElement('div',{className:'flexBox',style:{paddingBottom:'10px'}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('name','服務分店'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{disabled:true})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('store_group_name','區域'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{disabled:true})),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('iscibc','保經據點','checked'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_13_antd_lib_popconfirm___default.a,{title:this.state.iscibc?'請確認是否移除此保經據點分店？':'請確認是否要新增保經據點？',okText:'\u78BA\u8A8D',cancelText:'\u53D6\u6D88',onConfirm:function onConfirm(){if(_this2.state.iscibc)_this2.setState({pic:false,iscibc:false},function(){_this2.deleteUser();});else _this2.setState({iscibc:true});},onCancel:function onCancel(){if(_this2.state.iscibc)_this2.setState({iscibc:true});else _this2.setState({iscibc:false});}},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{danger:this.state.iscibc},this.state.iscibc?'刪除據點':'啟用')))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,{label:'\u5730\u5740',name:'address',rules:[{required:true,message:'Street is required'}]},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{style:{width:'70%'},placeholder:'\u8F38\u5165\u5730\u5740',disabled:!this.state.iscibc}))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_11_antd_lib_divider___default.a,null,'\u670D\u52D9\u4EBA\u54E1\u8CC7\u8A0A'),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('image',' '),{valuePropName:'fileList',rules:[{required:true,message:'請上傳服務人員照片'}]//style={{ textAlign: "center" }}
//extra="第一張圖片為封面"
}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_37_components_WUpload_WUpload__["b" /* default */],{multiple:false,listType:'picture',disabled:!this.state.iscibc,onChange:function onChange(fileList){if(fileList.length>=1){_this2.setState({pic:true});}else{_this2.setState({pic:false});}}},__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(this,'state.pic')?null:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_19_antd_lib_button___default.a,{disabled:!this.state.iscibc},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_9__ant_design_icons_lib_icons_UploadOutlined___default.a,null),'\u4E0A\u50B3\u7167\u7247'))),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,null,wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.List,{name:'image'},function(){var url=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(_this2.getFieldValue('image'),'0.url');return wp.element.createElement(__WEBPACK_IMPORTED_MODULE_7_antd_lib_avatar___default.a,{shape:'square',size:270,style:{height:350,lineHeight:270},icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_8__ant_design_icons_lib_icons_PictureOutlined___default.a,null),src:url});}))),wp.element.createElement('div',{style:{width:'70%'}},wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_name','姓名'),{rules:[{required:true,message:'請輸入服務人員姓名'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{disabled:!this.state.iscibc}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_seniority','服務年資'),{rules:[{required:true,message:'請輸入服務人員年資'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a,{disabled:!this.state.iscibc}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_location','服務據點'),{rules:[{required:true,message:'請選擇服務據點'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_27_antd_lib_select___default.a,{disabled:true},__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(options,'store_groups',[]),function(item){return wp.element.createElement(Option,{key:item.id,value:item.name},item.name);})))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,_extends({},Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_service_time','駐點時間'),{rules:[{required:true,message:'請輸入駐點時間'}]}),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_lib_time_picker___default.a.RangePicker,{disabled:!this.state.iscibc,format:'HH:mm'}))),wp.element.createElement('div',{className:'flexBox'},wp.element.createElement(__WEBPACK_IMPORTED_MODULE_17_antd_lib_form___default.a.Item,Object(__WEBPACK_IMPORTED_MODULE_38_libs_FormHelper__["a" /* genFormItemAtrribute */])('user_licenses','持有證照'),wp.element.createElement(__WEBPACK_IMPORTED_MODULE_15_antd_lib_input___default.a.TextArea,{disabled:!this.state.iscibc,rows:5}))))))));}}]);return CIBCInfo;}(__WEBPACK_IMPORTED_MODULE_28_react__["Component"]);var devCIBCInfo={id:81,name:'新仁店',iscibc:true,iscibc_name:'是',address:'717 台南市仁德區仁愛里大同路三段755號',users:[{id:1,name:'王曉明',image:[{// 有ID代表之前已經上傳過了
id:1,path:'uploads/6180ef9fd195448b2edcd3a18d840bd4.jpg',url:'https://testwww.uni-prosperity.com.tw/console/uploads/6180ef9fd195448b2edcd3a18d840bd4.jpg'}],location:'',seniority:10,open_at:'09:00',close_at:'18:00',licenses:'壽險,...'}],created_at:'2019-12-06 11:41:10',updated_at:'2020-05-15 16:47:02'};

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu_open":"menu_open___1K2pg"};

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_icons_ExclamationCircleOutlined__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_icons_ExclamationCircleOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_icons_ExclamationCircleOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification_style__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_notification_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_notification_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__web__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_history__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_NotificationCenter__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { hot } from 'react-hot-loader/root';
var VC_CONFIG=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'VC_CONFIG',{});var oca_login_url=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.props,'app.configs.oca_login_url');var isLogin=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.auth.isLogin');//const _ = __
var Login=function(_Component){_inherits(Login,_Component);function Login(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this),_this.state={LoginUrl:null},_this.GetCCUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__configs_env__["b" /* API_HOST */]+'/api/account/cc/login',{},function(state,res){console.log(state,res);var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){_this.setState({isSubmitData:false});return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);// 修改成直接過去CC
// this.GoCCLoginPage(data.uri)
_this.setState({isSubmitData:false});_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GoCCLoginPage=function(ccApiUrl){__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(ccApiUrl,{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code2=res.code,code=_res$code2===undefined?100:_res$code2,_res$reason2=res.reason,reason=_res$reason2===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason2,_res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;if(state===false){return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.GetOcaUri=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__configs_env__["b" /* API_HOST */]+'/api/account/oca/login',{},function(state,res){console.log(state,res);_this.setState({isSubmitData:false});var _res$code3=res.code,code=_res$code3===undefined?100:_res$code3,_res$reason3=res.reason,reason=_res$reason3===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason3,_res$data3=res.data,data=_res$data3===undefined?{}:_res$data3;if(state===false){return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});}if(code!==200){__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入頁面讀取失敗，請稍候再試。','cec-plugin-stores'),description:reason,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});return;}console.log(code,reason,data,res);_this.setState({LoginUrl:data.uri});window.location.href=data.uri;});},_this.CCLogout=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__configs_env__["b" /* API_HOST */]+'/api/account/cc/ccUri?type=logout',{},function(state,res){var _res$code4=res.code,code=_res$code4===undefined?100:_res$code4,_res$reason4=res.reason,reason=_res$reason4===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason4,_res$data4=res.data,data=_res$data4===undefined?{}:_res$data4;if(state===false){_this.setState({isSubmitData:false});return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!==200){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}console.log(data);_this.CCLogoutProcess(data.uri);});},_this.CCLogoutProcess=function(uri){// call cc logout api
__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(uri,{},function(state,res){_this.setState({isSubmitData:false});var _res$code5=res.code,code=_res$code5===undefined?100:_res$code5,_res$reason5=res.reason,reason=_res$reason5===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason5,_res$data5=res.data,data=_res$data5===undefined?{}:_res$data5;if(state===false){return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!=='200'){_this.setState({isSubmitData:false});__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}console.log(data);__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');_this.props.cleanUserInfo();_this.props.cleanAuthInfo();__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['warning']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('已成功登出','cec-plugin-stores'),duration:1,onClose:function onClose(){window.location.href=VC_CONFIG.INDEX_URL;}});});},_this.Logout=function(){_this.setState({isSubmitData:true});__WEBPACK_IMPORTED_MODULE_11__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__configs_env__["b" /* API_HOST */]+'/api/account/oca/ocaUri?type=logout',{},function(state,res){_this.setState({isSubmitData:false});var _res$code6=res.code,code=_res$code6===undefined?100:_res$code6,_res$reason6=res.reason,reason=_res$reason6===undefined?Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'):_res$reason6,_res$data6=res.data,data=_res$data6===undefined?{}:_res$data6;if(state===false){return __WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores')});}if(code!==200){__WEBPACK_IMPORTED_MODULE_4_antd_lib_notification___default.a['error']({message:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('發生錯誤','cec-plugin-stores'),description:reason});return;}console.log(data);//window.location.href = data.uri;
__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].removeLocalStorage('contact-data');__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');_this.props.cleanUserInfo();_this.props.cleanAuthInfo();// notification['warning']({message:__('已成功登出','cec-plugin-stores'), duration: 1, onClose:() => {
//   window.location.href = VC_CONFIG.INDEX_URL;
// }})
window.location.href=data.uri;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,auth=_props.auth,user=_props.user;if(auth&&auth.isLogin&&user==null){__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].updateUserInfo();}// auth異動
this.authDeniedToken=__WEBPACK_IMPORTED_MODULE_15__libs_NotificationCenter__["b" /* default */].default.addObserver(this,function(notif){_this2.props.cleanUserInfo&&_this2.props.cleanUserInfo();_this2.props.cleanAuthInfo&&_this2.props.cleanAuthInfo();__WEBPACK_IMPORTED_MODULE_13__libs_AppHelper__["a" /* default */].removeLocalStorage('to-href');// notification['warning']({message:'請重新登入', duration: 1, onClose:() => {
//   this.GetOcaUri();
//   if(this.state.LoginUrl) window.location.href = this.state.LoginUrl;
// }})
if(oca_login_url){__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal___default.a.confirm({title:'登入資訊過期，請重新登入',cancelText:'返回首頁',okText:'立即登入',onCancel:function onCancel(){window.location.replace(VC_CONFIG.INDEX_URL);},onOk:function onOk(){// ALVIN 2023/05/05 Remark OCA Login
// this.GetOcaUri();
// ALVIN 2023/05/17 Updated
_this2.GetCCUri();if(_this2.state.LoginUrl)window.location.replace(_this2.state.LoginUrl);}});}else if(!isLogin){// ALVIN 2023/05/05 Remark OCA Login
// this.GetOcaUri();
_this2.GetCCUri();if(_this2.state.LoginUrl)window.location.replace(_this2.state.LoginUrl);}else{__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal___default.a.error({title:'登入資訊過期，請重新登入',okText:'返回首頁',onOk:function onOk(){// this.GetOcaUri();
window.location.replace(VC_CONFIG.INDEX_URL);// if(this.state.LoginUrl) window.location.replace(VC_CONFIG.INDEX_URL);
}});}},__WEBPACK_IMPORTED_MODULE_15__libs_NotificationCenter__["a" /* NotificationName */].AuthDenied);// // auth異常
// this.authDeniedToken = NotificationCenter.default.addObserver(this, (notification) => {
//   console.log('PermissionsDidChanged', notification)
//   this.forceUpdate()
// }, NotificationName.PermissionsDidChanged)
}},{key:'componentWillUnmount',value:function componentWillUnmount(){}//NotificationCenter.default.removeObserver(this)
// ALVIN 2023/05/05 調整為CC登入
// 2023/05/05 取得並前往 CC Login Url
},{key:'render',value:function render(){var _this3=this;var auth=this.props.auth;var user=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.user');var roles=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this,'props.user.roles',[]);// 此處可簡單處理轉導功能
// if (user.isLogin === false && window.location.pathname !== '/')
//   history.replace('/')
//console.log(user);
var search=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(search);var slug=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(queryParams,'page');var Logoutconfirm=__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal___default.a.Logoutconfirm;// 此處不使用Route原本Path的功能
// 改看wp-admin/admin.php?page=stores
return wp.element.createElement('div',{'class':'loginButton'},auth&&auth.isLogin?wp.element.createElement('div',{'class':'d-flex'},wp.element.createElement('a',{'class':'text-primary',role:'button',href:VC_CONFIG.INDEX_URL+'/profile'},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('會員中心','cec-plugin-stores')),wp.element.createElement('a',{'class':'text-primary ml-3 pl-3 border-left border-gray',role:'button',href:'#',onClick:function onClick(){var confirm=__WEBPACK_IMPORTED_MODULE_2_antd_lib_modal___default.a.confirm;confirm({title:Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('是否要登出?','cec-plugin-stores'),icon:wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__ant_design_icons_lib_icons_ExclamationCircleOutlined___default.a,null),onOk:function onOk(){// 走CC Logout
// this.Logout()
_this3.CCLogout();},onCancel:function onCancel(){}});}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登出','cec-plugin-stores'))):wp.element.createElement('a',{'class':'btn btn-outline-primary rounded-pill',role:'button',href:'#',onClick:function onClick(){// ALVIN 2023/05/05 Remark OCA Login
// this.GetOcaUri();
_this3.GetCCUri();}},Object(__WEBPACK_IMPORTED_MODULE_17__wordpress_i18n__["__"])('登入/註冊','cec-plugin-stores')));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16__reducers__["b" /* wConnectRedux */])(Login));// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_modal_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_message_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__web__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_env__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_whttp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_AppHelper__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__libs_history__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_NotificationCenter__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__wordpress_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { hot } from 'react-hot-loader/root';
var PLUGIN_ASSETS_URL=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(window,'VC_CONFIG.PLUGIN_ASSETS_URL');var INDEX_URL=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(window,'VC_CONFIG.INDEX_URL');//const _ = __
var ECLogin=function(_Component){_inherits(ECLogin,_Component);function ECLogin(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ECLogin);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ECLogin.__proto__||Object.getPrototypeOf(ECLogin)).call.apply(_ref,[this].concat(args))),_this),_this.state={LoginUrl:null},_this.getProfile=function(){_this.setState({isSubmitData:true,messages:{}});__WEBPACK_IMPORTED_MODULE_10__libs_whttp__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__configs_env__["b" /* API_HOST */]+'/api/account/cc/getProfile',{},function(state,res){_this.setState({isSubmitData:false});var _res$code=res.code,code=_res$code===undefined?100:_res$code,_res$reason=res.reason,reason=_res$reason===undefined?'發生錯誤':_res$reason,_res$data=res.data,data=_res$data===undefined?{}:_res$data;if(state===false){return __WEBPACK_IMPORTED_MODULE_3_antd_lib_message___default.a.error('發生錯誤');}if(code!==200){// notification['error']({
//   message: '資料讀取失敗',
//   description: reason,
// });
return _this.setState({messages:data.messages||{}});}_this.setState({info:data});//console.log('getProfile',data)
});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ECLogin,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,auth=_props.auth,user=_props.user;if(auth&&auth.isLogin){this.getProfile();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){//NotificationCenter.default.removeObserver(this)
}},{key:'render',value:function render(){var auth=this.props.auth;var user=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this,'props.user');var roles=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this,'props.user.roles',[]);// 此處可簡單處理轉導功能
// if (user.isLogin === false && window.location.pathname !== '/')
//   history.replace('/')
//console.log(user);
var search=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(window,'location.search');var queryParams=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(search);var slug=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(queryParams,'page');var Logoutconfirm=__WEBPACK_IMPORTED_MODULE_1_antd_lib_modal___default.a.Logoutconfirm;var ProfileInfo=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this,'state.info');var src_token=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(ProfileInfo,'access_token');var src_client_id=__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(ProfileInfo,'client_id');// 此處不使用Route原本Path的功能
// 改看wp-admin/admin.php?page=stores
return wp.element.createElement('div',null,auth&&auth.isLogin&&src_token&&src_client_id?wp.element.createElement('a',{'class':'nav-link',role:'button'// href={`${LOGIN_ECLINK}?src_client_id=${src_client_id}&src_token=${src_token}`}
,href:'http://online.uni-prosperity.com.tw/zh/homepage/?utm_source=web&utm_medium=button',rel:'noopener noreferrer',target:'_blank'},wp.element.createElement('span',{'class':'iconBox'},wp.element.createElement('img',{src:PLUGIN_ASSETS_URL+'img/header/topbag.svg',alt:''})),Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('線上購物','cec-plugin-stores')):wp.element.createElement('a',{'class':'nav-link',role:'button',href:'http://online.uni-prosperity.com.tw/zh/homepage/?utm_source=web&utm_medium=button',rel:'noopener noreferrer',target:'_blank'},wp.element.createElement('span',{'class':'iconBox'},wp.element.createElement('img',{src:PLUGIN_ASSETS_URL+'img/header/topbag.svg',alt:''})),Object(__WEBPACK_IMPORTED_MODULE_16__wordpress_i18n__["__"])('線上購物','cec-plugin-stores')));}}]);return ECLogin;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15__reducers__["b" /* wConnectRedux */])(ECLogin));// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(63);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE = __webpack_require__(2052);

var _CODE2 = __webpack_require__(2053);

var _EAN_UPC = __webpack_require__(2059);

var _ITF = __webpack_require__(2065);

var _MSI = __webpack_require__(2068);

var _pharmacode = __webpack_require__(2073);

var _codabar = __webpack_require__(2074);

var _GenericBarcode = __webpack_require__(2075);

exports.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	GenericBarcode: _GenericBarcode.GenericBarcode
};

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CODE39 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

exports.CODE39 = CODE39;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE128C = exports.CODE128B = exports.CODE128A = exports.CODE128 = undefined;

var _CODE128_AUTO = __webpack_require__(2054);

var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);

var _CODE128A = __webpack_require__(2056);

var _CODE128A2 = _interopRequireDefault(_CODE128A);

var _CODE128B = __webpack_require__(2057);

var _CODE128B2 = _interopRequireDefault(_CODE128B);

var _CODE128C = __webpack_require__(2058);

var _CODE128C2 = _interopRequireDefault(_CODE128C);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CODE128 = _CODE128_AUTO2.default;
exports.CODE128A = _CODE128A2.default;
exports.CODE128B = _CODE128B2.default;
exports.CODE128C = _CODE128C2.default;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE2 = __webpack_require__(312);

var _CODE3 = _interopRequireDefault(_CODE2);

var _auto = __webpack_require__(2055);

var _auto2 = _interopRequireDefault(_auto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn(_this);
	}

	return CODE128AUTO;
}(_CODE3.default);

exports.default = CODE128AUTO;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__(231);

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

exports.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__(312);

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck(this, CODE128A);

		return _possibleConstructorReturn(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants.A_START_CHAR + string, options));
	}

	_createClass(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3.default);

exports.default = CODE128A;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__(312);

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck(this, CODE128B);

		return _possibleConstructorReturn(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants.B_START_CHAR + string, options));
	}

	_createClass(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3.default);

exports.default = CODE128B;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__(312);

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck(this, CODE128C);

		return _possibleConstructorReturn(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants.C_START_CHAR + string, options));
	}

	_createClass(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3.default);

exports.default = CODE128C;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPCE = exports.UPC = exports.EAN2 = exports.EAN5 = exports.EAN8 = exports.EAN13 = undefined;

var _EAN = __webpack_require__(2060);

var _EAN2 = _interopRequireDefault(_EAN);

var _EAN3 = __webpack_require__(2061);

var _EAN4 = _interopRequireDefault(_EAN3);

var _EAN5 = __webpack_require__(2062);

var _EAN6 = _interopRequireDefault(_EAN5);

var _EAN7 = __webpack_require__(2063);

var _EAN8 = _interopRequireDefault(_EAN7);

var _UPC = __webpack_require__(847);

var _UPC2 = _interopRequireDefault(_UPC);

var _UPCE = __webpack_require__(2064);

var _UPCE2 = _interopRequireDefault(_UPCE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EAN13 = _EAN2.default;
exports.EAN8 = _EAN4.default;
exports.EAN5 = _EAN6.default;
exports.EAN2 = _EAN8.default;
exports.UPC = _UPC2.default;
exports.UPCE = _UPCE2.default;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants = __webpack_require__(232);

var _EAN2 = __webpack_require__(846);

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants.EAN13_STRUCTURE[this.data[0]];
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3.default);

exports.default = EAN13;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2 = __webpack_require__(846);

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum(data);
		}

		return _possibleConstructorReturn(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3.default);

exports.default = EAN8;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(232);

var _encoder = __webpack_require__(233);

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck(this, EAN5);

		return _possibleConstructorReturn(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
			return {
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3.default);

exports.default = EAN5;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(232);

var _encoder = __webpack_require__(233);

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck(this, EAN2);

		return _possibleConstructorReturn(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3.default);

exports.default = EAN2;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = __webpack_require__(233);

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _UPC = __webpack_require__(847);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck(this, UPCE);

		var _this = _possibleConstructorReturn(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn(_this);
			}
		} else {
			return _possibleConstructorReturn(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC.checksum)(result);
}

exports.default = UPCE;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITF14 = exports.ITF = undefined;

var _ITF = __webpack_require__(848);

var _ITF2 = _interopRequireDefault(_ITF);

var _ITF3 = __webpack_require__(2067);

var _ITF4 = _interopRequireDefault(_ITF3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ITF = _ITF2.default;
exports.ITF14 = _ITF4.default;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var START_BIN = exports.START_BIN = '1010';
var END_BIN = exports.END_BIN = '11101';

var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2 = __webpack_require__(848);

var _ITF3 = _interopRequireDefault(_ITF2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3.default);

exports.default = ITF14;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MSI1110 = exports.MSI1010 = exports.MSI11 = exports.MSI10 = exports.MSI = undefined;

var _MSI = __webpack_require__(234);

var _MSI2 = _interopRequireDefault(_MSI);

var _MSI3 = __webpack_require__(2069);

var _MSI4 = _interopRequireDefault(_MSI3);

var _MSI5 = __webpack_require__(2070);

var _MSI6 = _interopRequireDefault(_MSI5);

var _MSI7 = __webpack_require__(2071);

var _MSI8 = _interopRequireDefault(_MSI7);

var _MSI9 = __webpack_require__(2072);

var _MSI10 = _interopRequireDefault(_MSI9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MSI = _MSI2.default;
exports.MSI10 = _MSI4.default;
exports.MSI11 = _MSI6.default;
exports.MSI1010 = _MSI8.default;
exports.MSI1110 = _MSI10.default;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__(234);

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck(this, MSI10);

		return _possibleConstructorReturn(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums.mod10)(data), options));
	}

	return MSI10;
}(_MSI3.default);

exports.default = MSI10;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__(234);

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck(this, MSI11);

		return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
	}

	return MSI11;
}(_MSI3.default);

exports.default = MSI11;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__(234);

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck(this, MSI1010);

		data += (0, _checksums.mod10)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3.default);

exports.default = MSI1010;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__(234);

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3.default);

exports.default = MSI1110;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pharmacode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck(this, pharmacode);

		var _this = _possibleConstructorReturn(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3.default);

exports.pharmacode = pharmacode;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.codabar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "101100110011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3.default);

exports.codabar = codabar;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GenericBarcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__(93);

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck(this, GenericBarcode);

		return _possibleConstructorReturn(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

exports.GenericBarcode = GenericBarcode;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = __webpack_require__(2079);

var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);

var _renderers = __webpack_require__(2080);

var _renderers2 = _interopRequireDefault(_renderers);

var _exceptions = __webpack_require__(852);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

exports.default = getRenderProperties;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _optionsFromStrings = __webpack_require__(849);

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _defaults = __webpack_require__(850);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2.default) {
		if (_defaults2.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2.default)(options);

	return options;
}

exports.default = getOptionsFromElement;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canvas = __webpack_require__(2081);

var _canvas2 = _interopRequireDefault(_canvas);

var _svg = __webpack_require__(2082);

var _svg2 = _interopRequireDefault(_svg);

var _object = __webpack_require__(2083);

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__(314);

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__(851);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__(314);

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__(851);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

exports.default = SVGRenderer;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

exports.default = ObjectRenderer;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

exports.default = ErrorHandler;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.GoogleLogin=t(require("react")):e.GoogleLogin=t(e.react)}("undefined"!=typeof self?self:this,(function(e){return o={},t.m=n=[function(t){t.exports=e},function(e,t,n){e.exports=n(2)()},function(e,t,n){"use strict";function o(){}function r(){}var i=n(3);r.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,r,a){if(a!==i){var c=Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(e){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function i(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return a(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function c(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return u(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?u(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function s(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return l(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?l(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function l(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function f(e,t,n,o,r){var i=e.getElementsByTagName(t)[0],a=i,c=i;(c=e.createElement(t)).id=n,c.src=o,a&&a.parentNode?a.parentNode.insertBefore(c,a):e.head.appendChild(c),c.onload=r}function d(e,t){var n=e.getElementById(t);n&&n.parentNode.removeChild(n)}function p(e){return b.a.createElement("span",{style:{paddingRight:10,fontWeight:500,paddingLeft:e.icon?0:10,paddingTop:10,paddingBottom:10}},e.children)}function g(e){return b.a.createElement("div",{style:{marginRight:10,background:e.active?"#eee":"#fff",padding:10,borderRadius:2}},b.a.createElement("svg",{width:"18",height:"18",xmlns:"http://www.w3.org/2000/svg"},b.a.createElement("g",{fill:"#000",fillRule:"evenodd"},b.a.createElement("path",{d:"M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z",fill:"#EA4335"}),b.a.createElement("path",{d:"M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",fill:"#4285F4"}),b.a.createElement("path",{d:"M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z",fill:"#FBBC05"}),b.a.createElement("path",{d:"M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z",fill:"#34A853"}),b.a.createElement("path",{fill:"none",d:"M0 0h18v18H0z"}))))}function y(e){var t=i(Object(m.useState)(!1),2),n=t[0],o=t[1],r=i(Object(m.useState)(!1),2),a=r[0],c=r[1],u=e.tag,s=e.type,l=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,v=e.render,S=e.theme,j=e.icon,O=e.disabled,x=h({onSuccess:e.onSuccess,onAutoLoadFinished:e.onAutoLoadFinished,onRequest:e.onRequest,onFailure:e.onFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,autoLoad:e.autoLoad,isSignedIn:e.isSignedIn,fetchBasicProfile:e.fetchBasicProfile,redirectUri:e.redirectUri,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,scope:e.scope,accessType:e.accessType,responseType:e.responseType,jsSrc:e.jsSrc,prompt:e.prompt}),I=x.signIn,w=O||!x.loaded;if(v)return v({onClick:I,disabled:w});var k={backgroundColor:"dark"===S?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===S?"#3367D6":"#eee",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):a?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(u,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),c(!1)},onMouseDown:function(){return c(!0)},onMouseUp:function(){return c(!1)},onClick:I,style:_,type:s,disabled:w,className:l},[j&&b.a.createElement(g,{key:1,active:a}),b.a.createElement(p,{icon:j,key:2},y||d)])}n.r(t),n.d(t,"default",(function(){return S})),n.d(t,"GoogleLogin",(function(){return S})),n.d(t,"GoogleLogout",(function(){return O})),n.d(t,"useGoogleLogin",(function(){return h})),n.d(t,"useGoogleLogout",(function(){return j}));var m=n(0),b=n.n(m),h=(n(1),function(e){function t(e){var t=e.getBasicProfile(),n=e.getAuthResponse();e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},i(e)}function n(e){if(e&&e.preventDefault(),P){var n=window.gapi.auth2.getAuthInstance(),o={prompt:T};p(),"code"===A?n.grantOfflineAccess(o).then((function(e){return i(e)}),(function(e){return s(e)})):n.signIn(o).then((function(e){return t(e)}),(function(e){return s(e)}))}}var r=e.onSuccess,i=void 0===r?function(){}:r,a=e.onAutoLoadFinished,c=void 0===a?function(){}:a,u=e.onFailure,s=void 0===u?function(){}:u,l=e.onRequest,p=void 0===l?function(){}:l,g=e.clientId,y=e.cookiePolicy,b=e.loginHint,h=e.hostedDomain,v=e.autoLoad,S=e.isSignedIn,j=e.fetchBasicProfile,O=e.redirectUri,x=e.discoveryDocs,I=e.uxMode,w=e.scope,k=e.accessType,A=e.responseType,_=e.jsSrc,E=void 0===_?"https://apis.google.com/js/api.js":_,T=e.prompt,M=o(Object(m.useState)(!1),2),P=M[0],L=M[1];return Object(m.useEffect)((function(){var e=!1;return f(document,"script","google-login",E,(function(){var n={client_id:g,cookie_policy:y,login_hint:b,hosted_domain:h,fetch_basic_profile:j,discoveryDocs:x,ux_mode:I,redirect_uri:O,scope:w,access_type:k};"code"===A&&(n.access_type="offline"),window.gapi.load("auth2",(function(){var o=window.gapi.auth2.getAuthInstance();o?S&&o.isSignedIn.get()?(L(!0),c(!0),t(o.currentUser.get())):e||(L(!0),c(!1)):window.gapi.auth2.init(n).then((function(n){if(!e){L(!0);var o=S&&n.isSignedIn.get();c(o),o&&t(n.currentUser.get())}}),(function(e){L(!0),c(!1),s(e)}))}))})),function(){e=!0,d(document,"google-login")}}),[]),Object(m.useEffect)((function(){v&&n()}),[P]),{signIn:n,loaded:P}});function v(e){var t=s(Object(m.useState)(!1),2),n=t[0],o=t[1],r=s(Object(m.useState)(!1),2),i=r[0],a=r[1],c=e.tag,u=e.type,l=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,h=e.render,v=e.theme,S=e.icon,O=e.disabled,x=j({jsSrc:e.jsSrc,onFailure:e.onFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,fetchBasicProfile:e.fetchBasicProfile,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,redirectUri:e.redirectUri,scope:e.scope,accessType:e.accessType,onLogoutSuccess:e.onLogoutSuccess}),I=x.signOut,w=O||!x.loaded;if(h)return h({onClick:I,disabled:w});var k={backgroundColor:"dark"===v?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===v?"#3367D6":"#eee",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):i?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(c,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),a(!1)},onMouseDown:function(){return a(!0)},onMouseUp:function(){return a(!1)},onClick:I,style:_,type:u,disabled:w,className:l},[S&&b.a.createElement(g,{key:1,active:i}),b.a.createElement(p,{icon:S,key:2},y||d)])}y.defaultProps={type:"button",tag:"button",buttonText:"Sign in with Google",scope:"profile email",accessType:"online",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},icon:!0,theme:"light",onRequest:function(){}};var S=y,j=function(e){var t=e.jsSrc,n=void 0===t?"https://apis.google.com/js/api.js":t,o=e.onFailure,r=e.clientId,i=e.cookiePolicy,a=e.loginHint,u=e.hostedDomain,s=e.fetchBasicProfile,l=e.discoveryDocs,p=e.uxMode,g=e.redirectUri,y=e.scope,b=e.accessType,h=e.onLogoutSuccess,v=c(Object(m.useState)(!1),2),S=v[0],j=v[1];return Object(m.useEffect)((function(){return f(document,"script","google-login",n,(function(){var e={client_id:r,cookie_policy:i,login_hint:a,hosted_domain:u,fetch_basic_profile:s,discoveryDocs:l,ux_mode:p,redirect_uri:g,scope:y,access_type:b};window.gapi.load("auth2",(function(){window.gapi.auth2.getAuthInstance()?j(!0):window.gapi.auth2.init(e).then((function(){return j(!0)}),(function(e){return o(e)}))}))})),function(){d(document,"google-login")}}),[]),{signOut:function(){if(window.gapi){var e=window.gapi.auth2.getAuthInstance();null!=e&&e.signOut().then(e.disconnect().then(h))}},loaded:S}};v.defaultProps={type:"button",tag:"button",buttonText:"Logout of Google",disabledStyle:{opacity:.6},icon:!0,theme:"light",jsSrc:"https://apis.google.com/js/api.js"};var O=v}],t.c=o,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:o})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(t.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)t.d(o,r,function(t){return e[t]}.bind(null,r));return o},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4);function t(e){if(o[e])return o[e].exports;var r=o[e]={i:e,l:!1,exports:{}};return n[e].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n,o}));

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2087);

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _debounce = _interopRequireDefault(__webpack_require__(596));

var _reactSlick = _interopRequireDefault(__webpack_require__(2089));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Carousel = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _classNames;

  var _a$dots = _a.dots,
      dots = _a$dots === void 0 ? true : _a$dots,
      _a$arrows = _a.arrows,
      arrows = _a$arrows === void 0 ? false : _a$arrows,
      _a$draggable = _a.draggable,
      draggable = _a$draggable === void 0 ? false : _a$draggable,
      _a$dotPosition = _a.dotPosition,
      dotPosition = _a$dotPosition === void 0 ? 'bottom' : _a$dotPosition,
      props = __rest(_a, ["dots", "arrows", "draggable", "dotPosition"]);

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var slickRef = React.useRef();

  var goTo = function goTo(slide) {
    var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    slickRef.current.slickGoTo(slide, dontAnimate);
  };

  React.useImperativeHandle(ref, function () {
    return {
      goTo: goTo,
      autoPlay: slickRef.current.innerSlider.autoPlay,
      innerSlider: slickRef.current.innerSlider,
      prev: slickRef.current.slickPrev,
      next: slickRef.current.slickNext
    };
  }, [slickRef.current]);
  React.useEffect(function () {
    var func = function func() {
      // Fix https://github.com/ant-design/ant-design/issues/2550
      var autoplay = props.autoplay;

      if (autoplay && slickRef.current && slickRef.current.innerSlider && slickRef.current.innerSlider.autoPlay) {
        slickRef.current.innerSlider.autoPlay();
      }
    };

    var onWindowResized = (0, _debounce["default"])(func, 500, {
      leading: false
    });

    if (props.autoplay) {
      window.addEventListener('resize', onWindowResized);
    }

    return function () {
      if (props.autoplay) {
        window.removeEventListener('resize', onWindowResized);
        onWindowResized.cancel();
      }
    };
  }, [slickRef.current, props.autoplay]);
  var prevCount = React.useRef(React.Children.count(props.children));
  React.useEffect(function () {
    if (prevCount.current !== React.Children.count(props.children)) {
      goTo(props.initialSlide || 0, false);
      prevCount.current = React.Children.count(props.children);
    }
  }, [props.children]);
  var newProps = (0, _extends2["default"])({}, props);

  if (newProps.effect === 'fade') {
    newProps.fade = true;
  }

  var prefixCls = getPrefixCls('carousel', newProps.prefixCls);
  var dotsClass = 'slick-dots';
  newProps.vertical = dotPosition === 'left' || dotPosition === 'right';
  var enableDots = !!dots;
  var dsClass = (0, _classnames["default"])(dotsClass, "".concat(dotsClass, "-").concat(dotPosition), typeof dots === 'boolean' ? false : dots === null || dots === void 0 ? void 0 : dots.className);
  var className = (0, _classnames["default"])(prefixCls, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-vertical"), newProps.vertical), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(_reactSlick["default"], (0, _extends2["default"])({
    ref: slickRef
  }, newProps, {
    dots: enableDots,
    dotsClass: dsClass,
    arrows: arrows,
    draggable: draggable
  })));
});
var _default = Carousel;
exports["default"] = _default;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(__webpack_require__(2090));

var _default = _slider["default"];
exports["default"] = _default;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(315));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(235));

var _createClass2 = _interopRequireDefault(__webpack_require__(236));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(318));

var _inherits2 = _interopRequireDefault(__webpack_require__(237));

var _createSuper2 = _interopRequireDefault(__webpack_require__(238));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(316));

var _react = _interopRequireDefault(__webpack_require__(0));

var _innerSlider = __webpack_require__(2096);

var _json2mq = _interopRequireDefault(__webpack_require__(2112));

var _defaultProps = _interopRequireDefault(__webpack_require__(2114));

var _innerSliderUtils = __webpack_require__(239);

var Slider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Slider, _React$Component);

  var _super = (0, _createSuper2["default"])(Slider);

  function Slider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });
    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      var mql = window.matchMedia(query);

      var listener = function listener(_ref) {
        var matches = _ref.matches;

        if (matches) {
          handler();
        }
      };

      mql.addListener(listener);
      listener(mql);

      this._responsiveMediaHandlers.push({
        mql: mql,
        query: query,
        listener: listener
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        obj.mql.removeListener(obj.listener);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, (0, _extends2["default"])({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);
  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(317)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(317)["default"];
var assertThisInitialized = __webpack_require__(318);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(317));

var _extends2 = _interopRequireDefault(__webpack_require__(315));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2097));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(235));

var _createClass2 = _interopRequireDefault(__webpack_require__(236));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(318));

var _inherits2 = _interopRequireDefault(__webpack_require__(237));

var _createSuper2 = _interopRequireDefault(__webpack_require__(238));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(316));

var _react = _interopRequireDefault(__webpack_require__(0));

var _initialState = _interopRequireDefault(__webpack_require__(2099));

var _debounce = _interopRequireDefault(__webpack_require__(2100));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(239);

var _track = __webpack_require__(2109);

var _dots = __webpack_require__(2110);

var _arrows = __webpack_require__(2111);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(269));

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(InnerSlider, _React$Component);

  var _super = (0, _createSuper2["default"])(InnerSlider);

  function InnerSlider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, InnerSlider);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = (0, _objectSpread2["default"])({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (prevProps.autoplay !== _this.props.autoplay || prevProps.autoplaySpeed !== _this.props.autoplaySpeed) {
          if (_this.props.autoplay) {
            _this.autoPlay("update");
          } else {
            _this.pause("paused");
          }
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _debounce["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;
      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkImagesLoad", function () {
      var images = _this.list.querySelectorAll(".slick-slide img");

      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];
      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = (0, _objectWithoutProperties2["default"])(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.props), _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, verticalHeightStyle), centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, (0, _extends2["default"])({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });
    _this.list = null;
    _this.track = null;
    _this.state = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _this.state), ssrState);
    return _this;
  }

  (0, _createClass2["default"])(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        // eslint-disable-next-line no-prototype-builtins
        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if ((0, _typeof2["default"])(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);
  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(2098);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(854),
    now = __webpack_require__(2101),
    toNumber = __webpack_require__(2103);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(855);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(854),
    isSymbol = __webpack_require__(2104);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2105),
    isObjectLike = __webpack_require__(2108);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(856),
    getRawTag = __webpack_require__(2106),
    objectToString = __webpack_require__(2107);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(856);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2107 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2108 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(315));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(235));

var _createClass2 = _interopRequireDefault(__webpack_require__(236));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(318));

var _inherits2 = _interopRequireDefault(__webpack_require__(237));

var _createSuper2 = _interopRequireDefault(__webpack_require__(238));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(316));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(239);

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key + "-" + fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Track, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Track);

  function Track() {
    var _this;

    (0, _classCallCheck2["default"])(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "node", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRef", function (ref) {
      _this.node = ref;
    });
    return _this;
  }

  (0, _createClass2["default"])(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);
  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(235));

var _createClass2 = _interopRequireDefault(__webpack_require__(236));

var _inherits2 = _interopRequireDefault(__webpack_require__(237));

var _createSuper2 = _interopRequireDefault(__webpack_require__(238));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(239);

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Dots, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Dots);

  function Dots() {
    (0, _classCallCheck2["default"])(this, Dots);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), (0, _objectSpread2["default"])({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);
  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(315));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(199));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(235));

var _createClass2 = _interopRequireDefault(__webpack_require__(236));

var _inherits2 = _interopRequireDefault(__webpack_require__(237));

var _createSuper2 = _interopRequireDefault(__webpack_require__(238));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _innerSliderUtils = __webpack_require__(239);

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(PrevArrow, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(PrevArrow);

  function PrevArrow() {
    (0, _classCallCheck2["default"])(this, PrevArrow);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);
  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  (0, _inherits2["default"])(NextArrow, _React$PureComponent2);

  var _super2 = (0, _createSuper2["default"])(NextArrow);

  function NextArrow() {
    (0, _classCallCheck2["default"])(this, NextArrow);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);
  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(2113);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(131);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {


      const createReactPlayer = __webpack_require__(2116).createReactPlayer
      const Player = __webpack_require__(2124).default
      module.exports = createReactPlayer([{
        key: 'youtube',
        canPlay: Player.canPlay,
        lazyPlayer: Player
      }])
    

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReactPlayer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _deepmerge = _interopRequireDefault(__webpack_require__(857));

var _memoizeOne = _interopRequireDefault(__webpack_require__(2117));

var _reactFastCompare = _interopRequireDefault(__webpack_require__(858));

var _props = __webpack_require__(859);

var _utils = __webpack_require__(460);

var _Player3 = _interopRequireDefault(__webpack_require__(2122));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Preview = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(__webpack_require__(2123));
  });
});
var IS_BROWSER = typeof window !== 'undefined' && window.document;
var IS_GLOBAL = typeof global !== 'undefined' && global.window && global.window.document;
var SUPPORTED_PROPS = Object.keys(_props.propTypes); // Return null when rendering on the server
// as Suspense is not supported yet

var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
  return null;
};
var customPlayers = [];

var createReactPlayer = function createReactPlayer(players, fallback) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(ReactPlayer, _Component);

    var _super = _createSuper(ReactPlayer);

    function ReactPlayer() {
      var _this;

      _classCallCheck(this, ReactPlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        showPreview: !!_this.props.light
      });

      _defineProperty(_assertThisInitialized(_this), "references", {
        wrapper: function wrapper(_wrapper) {
          _this.wrapper = _wrapper;
        },
        player: function player(_player) {
          _this.player = _player;
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function (e) {
        _this.setState({
          showPreview: false
        });

        _this.props.onClickPreview(e);
      });

      _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
        _this.setState({
          showPreview: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
        _this.props.onReady(_assertThisInitialized(_this));
      });

      _defineProperty(_assertThisInitialized(_this), "getActivePlayer", (0, _memoizeOne["default"])(function (url) {
        for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
          var player = _arr[_i];

          if (player.canPlay(url)) {
            return player;
          }
        }

        if (fallback) {
          return fallback;
        }

        return null;
      }));

      _defineProperty(_assertThisInitialized(_this), "getConfig", (0, _memoizeOne["default"])(function (url, key) {
        var config = _this.props.config;
        return _deepmerge["default"].all([_props.defaultProps.config, _props.defaultProps.config[key] || {}, config, config[key] || {}]);
      }));

      _defineProperty(_assertThisInitialized(_this), "getAttributes", (0, _memoizeOne["default"])(function (url) {
        return (0, _utils.omit)(_this.props, SUPPORTED_PROPS);
      }));

      _defineProperty(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
        if (!url) return null;

        var player = _this.getActivePlayer(url);

        if (!player) return null;

        var config = _this.getConfig(url, player.key);

        return /*#__PURE__*/_react["default"].createElement(_Player3["default"], _extends({}, _this.props, {
          key: player.key,
          ref: _this.references.player,
          config: config,
          activePlayer: player.lazyPlayer || player,
          onReady: _this.handleReady
        }));
      });

      return _this;
    }

    _createClass(ReactPlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _reactFastCompare["default"])(this.props, nextProps) || !(0, _reactFastCompare["default"])(this.state, nextState);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var light = this.props.light;

        if (!prevProps.light && light) {
          this.setState({
            showPreview: true
          });
        }

        if (prevProps.light && !light) {
          this.setState({
            showPreview: false
          });
        }
      }
    }, {
      key: "renderPreview",
      value: function renderPreview(url) {
        if (!url) return null;
        var _this$props = this.props,
            light = _this$props.light,
            playIcon = _this$props.playIcon,
            previewTabIndex = _this$props.previewTabIndex;
        return /*#__PURE__*/_react["default"].createElement(Preview, {
          url: url,
          light: light,
          playIcon: playIcon,
          previewTabIndex: previewTabIndex,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            url = _this$props2.url,
            style = _this$props2.style,
            width = _this$props2.width,
            height = _this$props2.height,
            fallback = _this$props2.fallback,
            Wrapper = _this$props2.wrapper;
        var showPreview = this.state.showPreview;
        var attributes = this.getAttributes(url);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          ref: this.references.wrapper,
          style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height
          })
        }, attributes), /*#__PURE__*/_react["default"].createElement(UniversalSuspense, {
          fallback: fallback
        }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
      }
    }]);

    return ReactPlayer;
  }(_react.Component), _defineProperty(_class, "displayName", 'ReactPlayer'), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "addCustomPlayer", function (player) {
    customPlayers.push(player);
  }), _defineProperty(_class, "removeCustomPlayers", function () {
    customPlayers.length = 0;
  }), _defineProperty(_class, "canPlay", function (url) {
    for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
      var _Player = _arr2[_i2];

      if (_Player.canPlay(url)) {
        return true;
      }
    }

    return false;
  }), _defineProperty(_class, "canEnablePIP", function (url) {
    for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
      var _Player2 = _arr3[_i3];

      if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
        return true;
      }
    }

    return false;
  }), _temp;
};

exports.createReactPlayer = createReactPlayer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2119)();
}


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2120);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2121 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactFastCompare = _interopRequireDefault(__webpack_require__(858));

var _props = __webpack_require__(859);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "handlePlayerMount", function (player) {
      _this.player = player;

      _this.player.load(_this.props.url);

      _this.progress();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady && this.props.stopOnUnmount) {
        this.player.stop();

        if (this.player.disablePIP) {
          this.player.disablePIP();
        }
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // If there isn’t a player available, don’t do anything
      if (!this.player) {
        return;
      } // Invoke player methods based on changed props


      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer;

      if (!(0, _reactFastCompare["default"])(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", _props.propTypes);

_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';
var cache = {};

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        _this.props.onClick();
      }
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      if (cache[url]) {
        this.setState({
          image: cache[url]
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });

          cache[url] = image;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon,
          previewTabIndex = _this$props2.previewTabIndex;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick,
        tabIndex: previewTabIndex,
        onKeyPress: this.handleKeyPress
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(460);

var _patterns = __webpack_require__(2125);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "parsePlaylist", function (url) {
      if (url instanceof Array) {
        return {
          listType: 'playlist',
          playlist: url.map(_this.getID).join(',')
        };
      }

      if (MATCH_PLAYLIST.test(url)) {
        var _url$match = url.match(MATCH_PLAYLIST),
            _url$match2 = _slicedToArray(_url$match, 2),
            playlistId = _url$match2[1];

        return {
          listType: 'playlist',
          list: playlistId.replace(/^UC/, 'UU')
        };
      }

      if (MATCH_USER_UPLOADS.test(url)) {
        var _url$match3 = url.match(MATCH_USER_UPLOADS),
            _url$match4 = _slicedToArray(_url$match3, 2),
            username = _url$match4[1];

        return {
          listType: 'user_uploads',
          list: username
        };
      }

      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
      var data = event.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop,
          _this$props$config = _this$props.config,
          playerVars = _this$props$config.playerVars,
          onUnstarted = _this$props$config.onUnstarted;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;
      if (data === UNSTARTED) onUnstarted();

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist'); // Only loop manually if not playing a playlist

        if (loop && !isPlaylist) {
          if (playerVars.start) {
            _this.seekTo(playerVars.start);
          } else {
            _this.play();
          }
        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount && this.props.onMount(this);
    }
  }, {
    key: "getID",
    value: function getID(url) {
      if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
        return null;
      }

      return url.match(_patterns.MATCH_URL_YOUTUBE)[1];
    }
  }, {
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var playerVars = config.playerVars,
          embedOptions = config.embedOptions;
      var id = this.getID(url);

      if (isReady) {
        if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
          this.player.loadPlaylist(this.parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread(_objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline ? 1 : 0
          }, _this2.parsePlaylist(url)), playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          },
          host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
        }, embedOptions));
      }, _onError);

      if (embedOptions.events) {
        console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause');
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports["default"] = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", _patterns.canPlay.youtube);

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;

var _utils = __webpack_require__(460);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
var MATCH_URL_VIMEO = /vimeo\.com\/.+/;
exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-]+)/;
exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_]+)$/;
exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

var canPlayFile = function canPlayFile(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlayFile(item)) {
          return true;
        }

        if (canPlayFile(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url) || (0, _utils.isBlobUrl)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};

var canPlay = {
  youtube: function youtube(url) {
    if (url instanceof Array) {
      return url.every(function (item) {
        return MATCH_URL_YOUTUBE.test(item);
      });
    }

    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: function soundcloud(url) {
    return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
  },
  vimeo: function vimeo(url) {
    return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
  },
  facebook: function facebook(url) {
    return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
  },
  streamable: function streamable(url) {
    return MATCH_URL_STREAMABLE.test(url);
  },
  wistia: function wistia(url) {
    return MATCH_URL_WISTIA.test(url);
  },
  twitch: function twitch(url) {
    return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
  },
  dailymotion: function dailymotion(url) {
    return MATCH_URL_DAILYMOTION.test(url);
  },
  mixcloud: function mixcloud(url) {
    return MATCH_URL_MIXCLOUD.test(url);
  },
  vidyard: function vidyard(url) {
    return MATCH_URL_VIDYARD.test(url);
  },
  kaltura: function kaltura(url) {
    return MATCH_URL_KALTURA.test(url);
  },
  file: canPlayFile
};
exports.canPlay = canPlay;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google_map.11db6c46.svg";

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brand-list.js.a8196cd1.bak";

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2129);

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(62));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(203));

var _inherits2 = _interopRequireDefault(__webpack_require__(66));

var _createSuper2 = _interopRequireDefault(__webpack_require__(67));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcDrawer = _interopRequireDefault(__webpack_require__(2131));

var _getScrollBarSize = _interopRequireDefault(__webpack_require__(367));

var _CloseOutlined = _interopRequireDefault(__webpack_require__(123));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _configProvider = __webpack_require__(8);

var _type = __webpack_require__(118);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var DrawerContext = /*#__PURE__*/React.createContext(null);
var PlacementTypes = (0, _type.tuple)('top', 'right', 'bottom', 'left');
var defaultPushState = {
  distance: 180
};

var Drawer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Drawer, _React$Component);

  var _super = (0, _createSuper2["default"])(Drawer);

  function Drawer() {
    var _this;

    (0, _classCallCheck2["default"])(this, Drawer);
    _this = _super.apply(this, arguments);
    _this.state = {
      push: false
    };

    _this.push = function () {
      if (_this.props.push) {
        _this.setState({
          push: true
        });
      }
    };

    _this.pull = function () {
      if (_this.props.push) {
        _this.setState({
          push: false
        });
      }
    };

    _this.onDestroyTransitionEnd = function () {
      var isDestroyOnClose = _this.getDestroyOnClose();

      if (!isDestroyOnClose) {
        return;
      }

      if (!_this.props.visible) {
        _this.destroyClose = true;

        _this.forceUpdate();
      }
    };

    _this.getDestroyOnClose = function () {
      return _this.props.destroyOnClose && !_this.props.visible;
    };

    _this.getPushDistance = function () {
      var push = _this.props.push;
      var distance;

      if (typeof push === 'boolean') {
        distance = push ? defaultPushState.distance : 0;
      } else {
        distance = push.distance;
      }

      return parseFloat(String(distance || 0));
    }; // get drawer push width or height


    _this.getPushTransform = function (placement) {
      var distance = _this.getPushDistance();

      if (placement === 'left' || placement === 'right') {
        return "translateX(".concat(placement === 'left' ? distance : -distance, "px)");
      }

      if (placement === 'top' || placement === 'bottom') {
        return "translateY(".concat(placement === 'top' ? distance : -distance, "px)");
      }
    };

    _this.getRcDrawerStyle = function () {
      var _this$props = _this.props,
          zIndex = _this$props.zIndex,
          placement = _this$props.placement,
          mask = _this$props.mask,
          style = _this$props.style;
      var push = _this.state.push; // 当无 mask 时，将 width 应用到外层容器上
      // 解决 https://github.com/ant-design/ant-design/issues/12401 的问题

      var offsetStyle = mask ? {} : _this.getOffsetStyle();
      return (0, _extends2["default"])((0, _extends2["default"])({
        zIndex: zIndex,
        transform: push ? _this.getPushTransform(placement) : undefined
      }, offsetStyle), style);
    }; // render drawer body dom


    _this.renderBody = function () {
      var _this$props2 = _this.props,
          bodyStyle = _this$props2.bodyStyle,
          drawerStyle = _this$props2.drawerStyle,
          prefixCls = _this$props2.prefixCls,
          visible = _this$props2.visible;

      if (_this.destroyClose && !visible) {
        return null;
      }

      _this.destroyClose = false;
      var containerStyle = {};

      var isDestroyOnClose = _this.getDestroyOnClose();

      if (isDestroyOnClose) {
        // Increase the opacity transition, delete children after closing.
        containerStyle.opacity = 0;
        containerStyle.transition = 'opacity .3s';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-wrapper-body"),
        style: (0, _extends2["default"])((0, _extends2["default"])({}, containerStyle), drawerStyle),
        onTransitionEnd: _this.onDestroyTransitionEnd
      }, _this.renderHeader(), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
      }, _this.props.children), _this.renderFooter());
    }; // render Provider for Multi-level drawer


    _this.renderProvider = function (value) {
      _this.parentDrawer = value;

      var _a = _this.props,
          prefixCls = _a.prefixCls,
          placement = _a.placement,
          className = _a.className,
          mask = _a.mask,
          direction = _a.direction,
          visible = _a.visible,
          rest = __rest(_a, ["prefixCls", "placement", "className", "mask", "direction", "visible"]);

      var drawerClassName = (0, _classnames["default"])((0, _defineProperty2["default"])({
        'no-mask': !mask
      }, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
      var offsetStyle = mask ? _this.getOffsetStyle() : {};
      return /*#__PURE__*/React.createElement(DrawerContext.Provider, {
        value: (0, _assertThisInitialized2["default"])(_this)
      }, /*#__PURE__*/React.createElement(_rcDrawer["default"], (0, _extends2["default"])({
        handler: false
      }, (0, _omit["default"])(rest, ['zIndex', 'closable', 'closeIcon', 'destroyOnClose', 'drawerStyle', 'headerStyle', 'bodyStyle', 'footerStyle', 'footer', 'title', 'push', 'visible', 'width', 'height']), offsetStyle, {
        prefixCls: prefixCls,
        open: visible,
        showMask: mask,
        placement: placement,
        style: _this.getRcDrawerStyle(),
        className: drawerClassName
      }), _this.renderBody()));
    };

    return _this;
  }

  (0, _createClass2["default"])(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // fix: delete drawer in child and re-render, no push started.
      // <Drawer>{show && <Drawer />}</Drawer>
      var visible = this.props.visible;

      if (visible && this.parentDrawer) {
        this.parentDrawer.push();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      var visible = this.props.visible;

      if (preProps.visible !== visible && this.parentDrawer) {
        if (visible) {
          this.parentDrawer.push();
        } else {
          this.parentDrawer.pull();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // unmount drawer in child, clear push.
      if (this.parentDrawer) {
        this.parentDrawer.pull();
        this.parentDrawer = null;
      }
    }
  }, {
    key: "getOffsetStyle",
    value: function getOffsetStyle() {
      var _this$props3 = this.props,
          placement = _this$props3.placement,
          width = _this$props3.width,
          height = _this$props3.height,
          visible = _this$props3.visible,
          mask = _this$props3.mask; // https://github.com/ant-design/ant-design/issues/24287

      if (!visible && !mask) {
        return {};
      }

      var offsetStyle = {};

      if (placement === 'left' || placement === 'right') {
        offsetStyle.width = width;
      } else {
        offsetStyle.height = height;
      }

      return offsetStyle;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          prefixCls = _this$props4.prefixCls,
          closable = _this$props4.closable,
          headerStyle = _this$props4.headerStyle;

      if (!title && !closable) {
        return null;
      }

      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
      return /*#__PURE__*/React.createElement("div", {
        className: headerClassName,
        style: headerStyle
      }, title && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-title")
      }, title), closable && this.renderCloseIcon());
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props5 = this.props,
          footer = _this$props5.footer,
          footerStyle = _this$props5.footerStyle,
          prefixCls = _this$props5.prefixCls;

      if (!footer) {
        return null;
      }

      var footerClassName = "".concat(prefixCls, "-footer");
      return /*#__PURE__*/React.createElement("div", {
        className: footerClassName,
        style: footerStyle
      }, footer);
    }
  }, {
    key: "renderCloseIcon",
    value: function renderCloseIcon() {
      var _this$props6 = this.props,
          closable = _this$props6.closable,
          _this$props6$closeIco = _this$props6.closeIcon,
          closeIcon = _this$props6$closeIco === void 0 ? /*#__PURE__*/React.createElement(_CloseOutlined["default"], null) : _this$props6$closeIco,
          prefixCls = _this$props6.prefixCls,
          onClose = _this$props6.onClose;
      return closable && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close"),
        style: {
          '--scroll-bar': "".concat((0, _getScrollBarSize["default"])(), "px")
        }
      }, closeIcon);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderProvider);
    }
  }]);
  return Drawer;
}(React.Component);

Drawer.defaultProps = {
  width: 256,
  height: 256,
  closable: true,
  placement: 'right',
  maskClosable: true,
  mask: true,
  level: null,
  keyboard: true,
  push: defaultPushState
};

var DrawerWrapper = function DrawerWrapper(props) {
  var customizePrefixCls = props.prefixCls,
      customizeGetContainer = props.getContainer;

  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPopupContainer = _React$useContext.getPopupContainer,
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var prefixCls = getPrefixCls('drawer', customizePrefixCls);
  var getContainer = // 有可能为 false，所以不能直接判断
  customizeGetContainer === undefined && getPopupContainer ? function () {
    return getPopupContainer(document.body);
  } : customizeGetContainer;
  return /*#__PURE__*/React.createElement(Drawer, (0, _extends2["default"])({}, props, {
    prefixCls: prefixCls,
    getContainer: getContainer,
    direction: direction
  }));
};

DrawerWrapper.displayName = 'DrawerWrapper';
var _default = DrawerWrapper;
exports["default"] = _default;

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DrawerWrapper__ = __webpack_require__(2132);
// export this package's api

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__DrawerWrapper__["a" /* default */]);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_PortalWrapper__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DrawerChild__ = __webpack_require__(2136);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var DrawerWrapper = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(DrawerWrapper, _React$Component);

  var _super = _createSuper(DrawerWrapper);

  function DrawerWrapper(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DrawerWrapper);

    _this = _super.call(this, props);

    _this.onHandleClick = function (e) {
      var _this$props = _this.props,
          onHandleClick = _this$props.onHandleClick,
          $open = _this$props.open;

      if (onHandleClick) {
        onHandleClick(e);
      }

      if (typeof $open === 'undefined') {
        var _open = _this.state.open;

        _this.setState({
          open: !_open
        });
      }
    };

    _this.onClose = function (e) {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          open = _this$props2.open;

      if (onClose) {
        onClose(e);
      }

      if (typeof open === 'undefined') {
        _this.setState({
          open: false
        });
      }
    };

    var open = typeof props.open !== 'undefined' ? props.open : !!props.defaultOpen;
    _this.state = {
      open: open
    };

    if ('onMaskClick' in props) {
      console.warn('`onMaskClick` are removed, please use `onClose` instead.');
    }

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(DrawerWrapper, [{
    key: "render",
    // tslint:disable-next-line:member-ordering
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          defaultOpen = _this$props3.defaultOpen,
          getContainer = _this$props3.getContainer,
          wrapperClassName = _this$props3.wrapperClassName,
          forceRender = _this$props3.forceRender,
          handler = _this$props3.handler,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props3, ["defaultOpen", "getContainer", "wrapperClassName", "forceRender", "handler"]);

      var open = this.state.open; // 渲染在当前 dom 里；

      if (!getContainer) {
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: wrapperClassName,
          ref: function ref(c) {
            _this2.dom = c;
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__DrawerChild__["a" /* default */], Object.assign({}, props, {
          open: open,
          handler: handler,
          getContainer: function getContainer() {
            return _this2.dom;
          },
          onClose: this.onClose,
          onHandleClick: this.onHandleClick
        })));
      } // 如果有 handler 为内置强制渲染；


      var $forceRender = !!handler || forceRender;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_rc_util_es_PortalWrapper__["a" /* default */], {
        visible: open,
        forceRender: $forceRender,
        getContainer: getContainer,
        wrapperClassName: wrapperClassName
      }, function (_ref) {
        var visible = _ref.visible,
            afterClose = _ref.afterClose,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["visible", "afterClose"]);

        return (// react 15，componentWillUnmount 时 Portal 返回 afterClose, visible.
          __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__DrawerChild__["a" /* default */], Object.assign({}, props, rest, {
            open: visible !== undefined ? visible : open,
            afterVisibleChange: afterClose !== undefined ? afterClose : props.afterVisibleChange,
            handler: handler,
            onClose: _this2.onClose,
            onHandleClick: _this2.onHandleClick
          }))
        );
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps;
      var newState = {
        prevProps: props
      };

      if (typeof prevProps !== 'undefined' && props.open !== prevProps.open) {
        newState.open = props.open;
      }

      return newState;
    }
  }]);

  return DrawerWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

DrawerWrapper.defaultProps = {
  prefixCls: 'drawer',
  placement: 'left',
  getContainer: 'body',
  defaultOpen: false,
  level: 'all',
  duration: '.3s',
  ease: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  onChange: function onChange() {},
  afterVisibleChange: function afterVisibleChange() {},
  handler: __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
    className: "drawer-handle"
  }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("i", {
    className: "drawer-handle-icon"
  })),
  showMask: true,
  maskClosable: true,
  maskStyle: {},
  wrapperClassName: '',
  className: '',
  keyboard: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (DrawerWrapper);

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(471);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_getScrollBarSize__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(2138);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var currentDrawer = {};

var DrawerChild = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(DrawerChild, _React$Component);

  var _super = _createSuper(DrawerChild);

  function DrawerChild(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DrawerChild);

    _this = _super.call(this, props);

    _this.domFocus = function () {
      if (_this.dom) {
        _this.dom.focus();
      }
    };

    _this.removeStartHandler = function (e) {
      if (e.touches.length > 1) {
        return;
      }

      _this.startPos = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
    };

    _this.removeMoveHandler = function (e) {
      if (e.changedTouches.length > 1) {
        return;
      }

      var currentTarget = e.currentTarget;
      var differX = e.changedTouches[0].clientX - _this.startPos.x;
      var differY = e.changedTouches[0].clientY - _this.startPos.y;

      if ((currentTarget === _this.maskDom || currentTarget === _this.handlerDom || currentTarget === _this.contentDom && Object(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* getTouchParentScroll */])(currentTarget, e.target, differX, differY)) && e.cancelable) {
        e.preventDefault();
      }
    };

    _this.transitionEnd = function (e) {
      var dom = e.target;
      Object(__WEBPACK_IMPORTED_MODULE_12__utils__["e" /* removeEventListener */])(dom, __WEBPACK_IMPORTED_MODULE_12__utils__["g" /* transitionEnd */], _this.transitionEnd);
      dom.style.transition = '';
    };

    _this.onKeyDown = function (e) {
      if (e.keyCode === __WEBPACK_IMPORTED_MODULE_10_rc_util_es_KeyCode__["a" /* default */].ESC) {
        var onClose = _this.props.onClose;
        e.stopPropagation();

        if (onClose) {
          onClose(e);
        }
      }
    };

    _this.onWrapperTransitionEnd = function (e) {
      var _this$props = _this.props,
          open = _this$props.open,
          afterVisibleChange = _this$props.afterVisibleChange;

      if (e.target === _this.contentWrapper && e.propertyName.match(/transform$/)) {
        _this.dom.style.transition = '';

        if (!open && _this.getCurrentDrawerSome()) {
          document.body.style.overflowX = '';

          if (_this.maskDom) {
            _this.maskDom.style.left = '';
            _this.maskDom.style.width = '';
          }
        }

        if (afterVisibleChange) {
          afterVisibleChange(!!open);
        }
      }
    };

    _this.openLevelTransition = function () {
      var _this$props2 = _this.props,
          open = _this$props2.open,
          width = _this$props2.width,
          height = _this$props2.height;

      var _this$getHorizontalBo = _this.getHorizontalBoolAndPlacementName(),
          isHorizontal = _this$getHorizontalBo.isHorizontal,
          placementName = _this$getHorizontalBo.placementName;

      var contentValue = _this.contentDom ? _this.contentDom.getBoundingClientRect()[isHorizontal ? 'width' : 'height'] : 0;
      var value = (isHorizontal ? width : height) || contentValue;

      _this.setLevelAndScrolling(open, placementName, value);
    };

    _this.setLevelTransform = function (open, placementName, value, right) {
      var _this$props3 = _this.props,
          placement = _this$props3.placement,
          levelMove = _this$props3.levelMove,
          duration = _this$props3.duration,
          ease = _this$props3.ease,
          showMask = _this$props3.showMask; // router 切换时可能会导至页面失去滚动条，所以需要时时获取。

      _this.levelDom.forEach(function (dom) {
        dom.style.transition = "transform ".concat(duration, " ").concat(ease);
        Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* addEventListener */])(dom, __WEBPACK_IMPORTED_MODULE_12__utils__["g" /* transitionEnd */], _this.transitionEnd);
        var levelValue = open ? value : 0;

        if (levelMove) {
          var $levelMove = Object(__WEBPACK_IMPORTED_MODULE_12__utils__["f" /* transformArguments */])(levelMove, {
            target: dom,
            open: open
          });
          levelValue = open ? $levelMove[0] : $levelMove[1] || 0;
        }

        var $value = typeof levelValue === 'number' ? "".concat(levelValue, "px") : levelValue;
        var placementPos = placement === 'left' || placement === 'top' ? $value : "-".concat($value);
        placementPos = showMask && placement === 'right' && right ? "calc(".concat(placementPos, " + ").concat(right, "px)") : placementPos;
        dom.style.transform = levelValue ? "".concat(placementName, "(").concat(placementPos, ")") : '';
      });
    };

    _this.setLevelAndScrolling = function (open, placementName, value) {
      var onChange = _this.props.onChange;

      if (!__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* windowIsUndefined */]) {
        var right = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth ? Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_getScrollBarSize__["a" /* default */])(true) : 0;

        _this.setLevelTransform(open, placementName, value, right);

        _this.toggleScrollingToDrawerAndBody(right);
      }

      if (onChange) {
        onChange(open);
      }
    };

    _this.toggleScrollingToDrawerAndBody = function (right) {
      var _this$props4 = _this.props,
          getOpenCount = _this$props4.getOpenCount,
          getContainer = _this$props4.getContainer,
          showMask = _this$props4.showMask,
          open = _this$props4.open;
      var container = getContainer && getContainer();
      var openCount = getOpenCount && getOpenCount(); // 处理 body 滚动

      if (container && container.parentNode === document.body && showMask) {
        var eventArray = ['touchstart'];
        var domArray = [document.body, _this.maskDom, _this.handlerDom, _this.contentDom];

        if (open && document.body.style.overflow !== 'hidden') {
          if (right) {
            _this.addScrollingEffect(right);
          }

          if (openCount === 1) {
            document.body.style.overflow = 'hidden';
          }

          document.body.style.touchAction = 'none'; // 手机禁滚

          domArray.forEach(function (item, i) {
            if (!item) {
              return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* addEventListener */])(item, eventArray[i] || 'touchmove', i ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
          });
        } else if (_this.getCurrentDrawerSome()) {
          // 没有弹框的状态下清除 overflow;
          if (!openCount) {
            document.body.style.overflow = '';
          }

          document.body.style.touchAction = '';

          if (right) {
            _this.remScrollingEffect(right);
          } // 恢复事件


          domArray.forEach(function (item, i) {
            if (!item) {
              return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_12__utils__["e" /* removeEventListener */])(item, eventArray[i] || 'touchmove', i ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
          });
        }
      }
    };

    _this.addScrollingEffect = function (right) {
      var _this$props5 = _this.props,
          placement = _this$props5.placement,
          duration = _this$props5.duration,
          ease = _this$props5.ease,
          getOpenCount = _this$props5.getOpenCount,
          switchScrollingEffect = _this$props5.switchScrollingEffect;
      var openCount = getOpenCount && getOpenCount();

      if (openCount === 1) {
        switchScrollingEffect();
      }

      var widthTransition = "width ".concat(duration, " ").concat(ease);
      var transformTransition = "transform ".concat(duration, " ").concat(ease);
      _this.dom.style.transition = 'none';

      switch (placement) {
        case 'right':
          _this.dom.style.transform = "translateX(-".concat(right, "px)");
          break;

        case 'top':
        case 'bottom':
          _this.dom.style.width = "calc(100% - ".concat(right, "px)");
          _this.dom.style.transform = 'translateZ(0)';
          break;

        default:
          break;
      }

      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function () {
        if (_this.dom) {
          _this.dom.style.transition = "".concat(transformTransition, ",").concat(widthTransition);
          _this.dom.style.width = '';
          _this.dom.style.transform = '';
        }
      });
    };

    _this.remScrollingEffect = function (right) {
      var _this$props6 = _this.props,
          placement = _this$props6.placement,
          duration = _this$props6.duration,
          ease = _this$props6.ease,
          getOpenCount = _this$props6.getOpenCount,
          switchScrollingEffect = _this$props6.switchScrollingEffect;
      var openCount = getOpenCount && getOpenCount();

      if (!openCount) {
        switchScrollingEffect(true);
      }

      if (__WEBPACK_IMPORTED_MODULE_12__utils__["h" /* transitionStr */]) {
        document.body.style.overflowX = 'hidden';
      }

      _this.dom.style.transition = 'none';
      var heightTransition;
      var widthTransition = "width ".concat(duration, " ").concat(ease);
      var transformTransition = "transform ".concat(duration, " ").concat(ease);

      switch (placement) {
        case 'left':
          {
            _this.dom.style.width = '100%';
            widthTransition = "width 0s ".concat(ease, " ").concat(duration);
            break;
          }

        case 'right':
          {
            _this.dom.style.transform = "translateX(".concat(right, "px)");
            _this.dom.style.width = '100%';
            widthTransition = "width 0s ".concat(ease, " ").concat(duration);

            if (_this.maskDom) {
              _this.maskDom.style.left = "-".concat(right, "px");
              _this.maskDom.style.width = "calc(100% + ".concat(right, "px)");
            }

            break;
          }

        case 'top':
        case 'bottom':
          {
            _this.dom.style.width = "calc(100% + ".concat(right, "px)");
            _this.dom.style.height = '100%';
            _this.dom.style.transform = 'translateZ(0)';
            heightTransition = "height 0s ".concat(ease, " ").concat(duration);
            break;
          }

        default:
          break;
      }

      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function () {
        if (_this.dom) {
          _this.dom.style.transition = "".concat(transformTransition, ",").concat(heightTransition ? "".concat(heightTransition, ",") : '').concat(widthTransition);
          _this.dom.style.transform = '';
          _this.dom.style.width = '';
          _this.dom.style.height = '';
        }
      });
    };

    _this.getCurrentDrawerSome = function () {
      return !Object.keys(currentDrawer).some(function (key) {
        return currentDrawer[key];
      });
    };

    _this.getLevelDom = function (_ref) {
      var level = _ref.level,
          getContainer = _ref.getContainer;

      if (__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* windowIsUndefined */]) {
        return;
      }

      var container = getContainer && getContainer();
      var parent = container ? container.parentNode : null;
      _this.levelDom = [];

      if (level === 'all') {
        var children = parent ? Array.prototype.slice.call(parent.children) : [];
        children.forEach(function (child) {
          if (child.nodeName !== 'SCRIPT' && child.nodeName !== 'STYLE' && child.nodeName !== 'LINK' && child !== container) {
            _this.levelDom.push(child);
          }
        });
      } else if (level) {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* dataToArray */])(level).forEach(function (key) {
          document.querySelectorAll(key).forEach(function (item) {
            _this.levelDom.push(item);
          });
        });
      }
    };

    _this.getHorizontalBoolAndPlacementName = function () {
      var placement = _this.props.placement;
      var isHorizontal = placement === 'left' || placement === 'right';
      var placementName = "translate".concat(isHorizontal ? 'X' : 'Y');
      return {
        isHorizontal: isHorizontal,
        placementName: placementName
      };
    };

    _this.state = {
      _self: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(DrawerChild, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* windowIsUndefined */]) {
        var passiveSupported = false;

        try {
          window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
            get: function get() {
              passiveSupported = true;
              return null;
            }
          }));
        } catch (err) {}

        this.passive = passiveSupported ? {
          passive: false
        } : false;
      }

      var _this$props7 = this.props,
          open = _this$props7.open,
          getContainer = _this$props7.getContainer;
      var container = getContainer && getContainer();
      this.drawerId = "drawer_id_".concat(Number((Date.now() + Math.random()).toString().replace('.', Math.round(Math.random() * 9).toString())).toString(16));
      this.getLevelDom(this.props);

      if (open) {
        if (container && container.parentNode === document.body) {
          currentDrawer[this.drawerId] = open;
        } // 默认打开状态时推出 level;


        this.openLevelTransition();
        this.forceUpdate(function () {
          _this2.domFocus();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props8 = this.props,
          open = _this$props8.open,
          getContainer = _this$props8.getContainer;
      var container = getContainer && getContainer();

      if (open !== prevProps.open) {
        if (open) {
          this.domFocus();
        }

        if (container && container.parentNode === document.body) {
          currentDrawer[this.drawerId] = !!open;
        }

        this.openLevelTransition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props9 = this.props,
          getOpenCount = _this$props9.getOpenCount,
          open = _this$props9.open,
          switchScrollingEffect = _this$props9.switchScrollingEffect;
      var openCount = typeof getOpenCount === 'function' && getOpenCount();
      delete currentDrawer[this.drawerId];

      if (open) {
        this.setLevelTransform(false);
        document.body.style.touchAction = '';
      }

      if (!openCount) {
        document.body.style.overflow = '';
        switchScrollingEffect(true);
      }
    } // tslint:disable-next-line:member-ordering

  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this3 = this;

      var _this$props10 = this.props,
          className = _this$props10.className,
          children = _this$props10.children,
          style = _this$props10.style,
          width = _this$props10.width,
          height = _this$props10.height,
          defaultOpen = _this$props10.defaultOpen,
          $open = _this$props10.open,
          prefixCls = _this$props10.prefixCls,
          placement = _this$props10.placement,
          level = _this$props10.level,
          levelMove = _this$props10.levelMove,
          ease = _this$props10.ease,
          duration = _this$props10.duration,
          getContainer = _this$props10.getContainer,
          handler = _this$props10.handler,
          onChange = _this$props10.onChange,
          afterVisibleChange = _this$props10.afterVisibleChange,
          showMask = _this$props10.showMask,
          maskClosable = _this$props10.maskClosable,
          maskStyle = _this$props10.maskStyle,
          onClose = _this$props10.onClose,
          onHandleClick = _this$props10.onHandleClick,
          keyboard = _this$props10.keyboard,
          getOpenCount = _this$props10.getOpenCount,
          switchScrollingEffect = _this$props10.switchScrollingEffect,
          props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props10, ["className", "children", "style", "width", "height", "defaultOpen", "open", "prefixCls", "placement", "level", "levelMove", "ease", "duration", "getContainer", "handler", "onChange", "afterVisibleChange", "showMask", "maskClosable", "maskStyle", "onClose", "onHandleClick", "keyboard", "getOpenCount", "switchScrollingEffect"]); // 首次渲染都将是关闭状态。


      var open = this.dom ? $open : false;
      var wrapperClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, (_classnames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classnames, "".concat(prefixCls, "-").concat(placement), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classnames, "".concat(prefixCls, "-open"), open), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classnames, className || '', !!className), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classnames, 'no-mask', !showMask), _classnames));

      var _this$getHorizontalBo2 = this.getHorizontalBoolAndPlacementName(),
          placementName = _this$getHorizontalBo2.placementName; // 百分比与像素动画不同步，第一次打用后全用像素动画。
      // const defaultValue = !this.contentDom || !level ? '100%' : `${value}px`;


      var placementPos = placement === 'left' || placement === 'top' ? '-100%' : '100%';
      var transform = open ? '' : "".concat(placementName, "(").concat(placementPos, ")");
      var handlerChildren = handler && __WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"](handler, {
        onClick: function onClick(e) {
          if (handler.props.onClick) {
            handler.props.onClick();
          }

          if (onHandleClick) {
            onHandleClick(e);
          }
        },
        ref: function ref(c) {
          _this3.handlerDom = c;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", Object.assign({}, props, {
        tabIndex: -1,
        className: wrapperClassName,
        style: style,
        ref: function ref(c) {
          _this3.dom = c;
        },
        onKeyDown: open && keyboard ? this.onKeyDown : undefined,
        onTransitionEnd: this.onWrapperTransitionEnd
      }), showMask && __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        className: "".concat(prefixCls, "-mask"),
        onClick: maskClosable ? onClose : undefined,
        style: maskStyle,
        ref: function ref(c) {
          _this3.maskDom = c;
        }
      }), __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        className: "".concat(prefixCls, "-content-wrapper"),
        style: {
          transform: transform,
          msTransform: transform,
          width: Object(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* isNumeric */])(width) ? "".concat(width, "px") : width,
          height: Object(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* isNumeric */])(height) ? "".concat(height, "px") : height
        },
        ref: function ref(c) {
          _this3.contentWrapper = c;
        }
      }, __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        className: "".concat(prefixCls, "-content"),
        ref: function ref(c) {
          _this3.contentDom = c;
        },
        onTouchStart: open && showMask ? this.removeStartHandler : undefined,
        onTouchMove: open && showMask ? this.removeMoveHandler : undefined
      }, children), handlerChildren));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevProps = _ref2.prevProps,
          _self = _ref2._self;
      var nextState = {
        prevProps: props
      };

      if (prevProps !== undefined) {
        var placement = props.placement,
            level = props.level;

        if (placement !== prevProps.placement) {
          // test 的 bug, 有动画过场，删除 dom
          _self.contentDom = null;
        }

        if (level !== prevProps.level) {
          _self.getLevelDom(props);
        }
      }

      return nextState;
    }
  }]);

  return DrawerChild;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

DrawerChild.defaultProps = {
  switchScrollingEffect: function switchScrollingEffect() {}
};
/* harmony default export */ __webpack_exports__["a"] = (DrawerChild);

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(870);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = dataToArray;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return transitionStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return transitionEnd; });
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeEventListener;
/* harmony export (immutable) */ __webpack_exports__["f"] = transformArguments;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNumeric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return windowIsUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTouchParentScroll; });
function dataToArray(vars) {
  if (Array.isArray(vars)) {
    return vars;
  }

  return [vars];
}
var transitionEndObject = {
  transition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'oTransitionEnd otransitionend'
};
var transitionStr = Object.keys(transitionEndObject).filter(function (key) {
  if (typeof document === 'undefined') {
    return false;
  }

  var html = document.getElementsByTagName('html')[0];
  return key in (html ? html.style : {});
})[0];
var transitionEnd = transitionEndObject[transitionStr];
function addEventListener(target, eventType, callback, options) {
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    // tslint:disable-line
    target.attachEvent("on".concat(eventType), callback); // tslint:disable-line
  }
}
function removeEventListener(target, eventType, callback, options) {
  if (target.removeEventListener) {
    target.removeEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    // tslint:disable-line
    target.detachEvent("on".concat(eventType), callback); // tslint:disable-line
  }
}
function transformArguments(arg, cb) {
  var result = typeof arg === 'function' ? arg(cb) : arg;

  if (Array.isArray(result)) {
    if (result.length === 2) {
      return result;
    }

    return [result[0], result[1]];
  }

  return [result];
}
var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
var getTouchParentScroll = function getTouchParentScroll(root, currentTarget, differX, differY) {
  if (!currentTarget || currentTarget === document || currentTarget instanceof Document) {
    return false;
  } // root 为 drawer-content 设定了 overflow, 判断为 root 的 parent 时结束滚动；


  if (currentTarget === root.parentNode) {
    return true;
  }

  var isY = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differY);
  var isX = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differX);
  var scrollY = currentTarget.scrollHeight - currentTarget.clientHeight;
  var scrollX = currentTarget.scrollWidth - currentTarget.clientWidth;
  var style = document.defaultView.getComputedStyle(currentTarget);
  var overflowY = style.overflowY === 'auto' || style.overflowY === 'scroll';
  var overflowX = style.overflowX === 'auto' || style.overflowX === 'scroll';
  var y = scrollY && overflowY;
  var x = scrollX && overflowX;

  if (isY && (!y || y && (currentTarget.scrollTop >= scrollY && differY < 0 || currentTarget.scrollTop <= 0 && differY > 0)) || isX && (!x || x && (currentTarget.scrollLeft >= scrollX && differX < 0 || currentTarget.scrollLeft <= 0 && differX > 0))) {
    return getTouchParentScroll(root, currentTarget.parentNode, differX, differY);
  }

  return false;
};

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttleByAnimationFrame = throttleByAnimationFrame;
exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(76));

var _raf = _interopRequireDefault(__webpack_require__(176));

function throttleByAnimationFrame(fn) {
  var requestId;

  var later = function later(args) {
    return function () {
      requestId = null;
      fn.apply(void 0, (0, _toConsumableArray2["default"])(args));
    };
  };

  var throttled = function throttled() {
    if (requestId == null) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      requestId = (0, _raf["default"])(later(args));
    }
  };

  throttled.cancel = function () {
    return _raf["default"].cancel(requestId);
  };

  return throttled;
}

function throttleByAnimationFrameDecorator() {
  return function throttle(target, key, descriptor) {
    var fn = descriptor.value;
    var definingProperty = false;
    return {
      configurable: true,
      get: function get() {
        // In IE11 calling Object.defineProperty has a side-effect of evaluating the
        // getter for the property which is being replaced. This causes infinite
        // recursion and an "Out of stack space" error.
        // eslint-disable-next-line no-prototype-builtins
        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
          /* istanbul ignore next */
          return fn;
        }

        var boundFn = throttleByAnimationFrame(fn.bind(this));
        definingProperty = true;
        Object.defineProperty(this, key, {
          value: boundFn,
          configurable: true,
          writable: true
        });
        definingProperty = false;
        return boundFn;
      }
    };
  };
}

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetRect = getTargetRect;
exports.getFixedTop = getFixedTop;
exports.getFixedBottom = getFixedBottom;
exports.getObserverEntities = getObserverEntities;
exports.addObserveTarget = addObserveTarget;
exports.removeObserveTarget = removeObserveTarget;

var _addEventListener = _interopRequireDefault(__webpack_require__(595));

function getTargetRect(target) {
  return target !== window ? target.getBoundingClientRect() : {
    top: 0,
    bottom: window.innerHeight
  };
}

function getFixedTop(placeholderReact, targetRect, offsetTop) {
  if (offsetTop !== undefined && targetRect.top > placeholderReact.top - offsetTop) {
    return offsetTop + targetRect.top;
  }

  return undefined;
}

function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
  if (offsetBottom !== undefined && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
    var targetBottomOffset = window.innerHeight - targetRect.bottom;
    return offsetBottom + targetBottomOffset;
  }

  return undefined;
} // ======================== Observer ========================


var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
var observerEntities = [];

function getObserverEntities() {
  // Only used in test env. Can be removed if refactor.
  return observerEntities;
}

function addObserveTarget(target, affix) {
  if (!target) return;
  var entity = observerEntities.find(function (item) {
    return item.target === target;
  });

  if (entity) {
    entity.affixList.push(affix);
  } else {
    entity = {
      target: target,
      affixList: [affix],
      eventHandlers: {}
    };
    observerEntities.push(entity); // Add listener

    TRIGGER_EVENTS.forEach(function (eventName) {
      entity.eventHandlers[eventName] = (0, _addEventListener["default"])(target, eventName, function () {
        entity.affixList.forEach(function (targetAffix) {
          targetAffix.lazyUpdatePosition();
        });
      });
    });
  }
}

function removeObserveTarget(affix) {
  var observerEntity = observerEntities.find(function (oriObserverEntity) {
    var hasAffix = oriObserverEntity.affixList.some(function (item) {
      return item === affix;
    });

    if (hasAffix) {
      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function (item) {
        return item !== affix;
      });
    }

    return hasAffix;
  });

  if (observerEntity && observerEntity.affixList.length === 0) {
    observerEntities = observerEntities.filter(function (item) {
      return item !== observerEntity;
    }); // Remove listener

    TRIGGER_EVENTS.forEach(function (eventName) {
      var handler = observerEntity.eventHandlers[eventName];

      if (handler && handler.remove) {
        handler.remove();
      }
    });
  }
}

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var ArrowLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };
exports.default = ArrowLeftOutlined;


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2144);

__webpack_require__(139);

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _rcSlider = _interopRequireWildcard(__webpack_require__(2146));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _SliderTooltip = _interopRequireDefault(__webpack_require__(2164));

var _configProvider = __webpack_require__(8);

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Slider = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(_configProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction,
      getPopupContainer = _React$useContext.getPopupContainer;

  var _React$useState = React.useState({}),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      visibles = _React$useState2[0],
      setVisibles = _React$useState2[1];

  var toggleTooltipVisible = function toggleTooltipVisible(index, visible) {
    setVisibles(function (prev) {
      return (0, _extends3["default"])((0, _extends3["default"])({}, prev), (0, _defineProperty2["default"])({}, index, visible));
    });
  };

  var getTooltipPlacement = function getTooltipPlacement(tooltipPlacement, vertical) {
    if (tooltipPlacement) {
      return tooltipPlacement;
    }

    if (!vertical) {
      return 'top';
    }

    return direction === 'rtl' ? 'left' : 'right';
  };

  var handleWithTooltip = function handleWithTooltip(_a) {
    var tooltipPrefixCls = _a.tooltipPrefixCls,
        prefixCls = _a.prefixCls,
        _b = _a.info,
        value = _b.value,
        dragging = _b.dragging,
        index = _b.index,
        restProps = __rest(_b, ["value", "dragging", "index"]);

    var tipFormatter = props.tipFormatter,
        tooltipVisible = props.tooltipVisible,
        tooltipPlacement = props.tooltipPlacement,
        getTooltipPopupContainer = props.getTooltipPopupContainer,
        vertical = props.vertical;
    var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
    var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
    return /*#__PURE__*/React.createElement(_SliderTooltip["default"], {
      prefixCls: tooltipPrefixCls,
      title: tipFormatter ? tipFormatter(value) : '',
      visible: visible,
      placement: getTooltipPlacement(tooltipPlacement, vertical),
      transitionName: "zoom-down",
      key: index,
      overlayClassName: "".concat(prefixCls, "-tooltip"),
      getPopupContainer: getTooltipPopupContainer || getPopupContainer || function () {
        return document.body;
      }
    }, /*#__PURE__*/React.createElement(_rcSlider.Handle, (0, _extends3["default"])({}, restProps, {
      value: value,
      onMouseEnter: function onMouseEnter() {
        return toggleTooltipVisible(index, true);
      },
      onMouseLeave: function onMouseLeave() {
        return toggleTooltipVisible(index, false);
      }
    })));
  };

  var customizePrefixCls = props.prefixCls,
      customizeTooltipPrefixCls = props.tooltipPrefixCls,
      range = props.range,
      className = props.className,
      restProps = __rest(props, ["prefixCls", "tooltipPrefixCls", "range", "className"]);

  var prefixCls = getPrefixCls('slider', customizePrefixCls);
  var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
  var cls = (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-rtl"), direction === 'rtl')); // make reverse default on rtl direction

  if (direction === 'rtl' && !restProps.vertical) {
    restProps.reverse = !restProps.reverse;
  } // extrack draggableTrack from range={{ ... }}


  var draggableTrack;

  if ((0, _typeof2["default"])(range) === 'object') {
    draggableTrack = range.draggableTrack;
  }

  if (range) {
    return /*#__PURE__*/React.createElement(_rcSlider.Range, (0, _extends3["default"])({}, restProps, {
      step: restProps.step,
      draggableTrack: draggableTrack,
      className: cls,
      ref: ref,
      handle: function handle(info) {
        return handleWithTooltip({
          tooltipPrefixCls: tooltipPrefixCls,
          prefixCls: prefixCls,
          info: info
        });
      },
      prefixCls: prefixCls
    }));
  }

  return /*#__PURE__*/React.createElement(_rcSlider["default"], (0, _extends3["default"])({}, restProps, {
    step: restProps.step,
    className: cls,
    ref: ref,
    handle: function handle(info) {
      return handleWithTooltip({
        tooltipPrefixCls: tooltipPrefixCls,
        prefixCls: prefixCls,
        info: info
      });
    },
    prefixCls: prefixCls
  }));
});
Slider.displayName = 'Slider';
Slider.defaultProps = {
  tipFormatter: function tipFormatter(value) {
    return typeof value === 'number' ? value.toString() : '';
  }
};
var _default = Slider;
exports["default"] = _default;

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_SliderTooltip__ = __webpack_require__(882);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return __WEBPACK_IMPORTED_MODULE_1__Range__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Handle", function() { return __WEBPACK_IMPORTED_MODULE_2__Handle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSliderWithTooltip", function() { return __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SliderTooltip", function() { return __WEBPACK_IMPORTED_MODULE_4__common_SliderTooltip__["a"]; });





var InternalSlider = __WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */];
InternalSlider.Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
InternalSlider.Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
InternalSlider.createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (InternalSlider);


/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Track__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_createSlider__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(476);











var Slider = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Slider, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Slider);

  /* eslint-enable */
  function Slider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Slider);

    _this = _super.call(this, props);

    _this.positionGetValue = function (position) {
      return [];
    };

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();

      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        dragging: false
      });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;
    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__["a" /* default */])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    Object(__WEBPACK_IMPORTED_MODULE_6_rc_util_es_warning__["a" /* default */])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Slider, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          onChange = _this$props.onChange;

      if (!('min' in this.props || 'max' in this.props)) {
        return;
      }

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);

      if (nextValue === prevState.value) {
        return;
      } // eslint-disable-next-line


      this.setState({
        value: nextValue
      });

      if (!(min === prevProps.min && max === prevProps.max) && __WEBPACK_IMPORTED_MODULE_9__utils__["i" /* isValueOutOfRange */](theValue, this.props)) {
        onChange(nextValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
        value: this.props.max
      }) : state;

      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      this.setState({
        dragging: true
      });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      if (value === prevValue) return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
      var oldValue = this.state.value;
      var value = this.calcValueByPos(position);
      if (value === oldValue) return;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;
        this.onChange({
          value: value
        });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      var minPoint = this.props.startPoint || this.props.min;
      return this.state.value > minPoint ? minPoint : this.state.value;
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      if (this.state.value < this.props.startPoint) {
        return this.props.startPoint;
      }

      return this.state.value;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.props), nextProps);

      var val = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          vertical = _this$props3.vertical,
          included = _this$props3.included,
          disabled = _this$props3.disabled,
          minimumTrackStyle = _this$props3.minimumTrackStyle,
          trackStyle = _this$props3.trackStyle,
          handleStyle = _this$props3.handleStyle,
          tabIndex = _this$props3.tabIndex,
          ariaLabelForHandle = _this$props3.ariaLabelForHandle,
          ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle,
          ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle,
          min = _this$props3.min,
          max = _this$props3.max,
          startPoint = _this$props3.startPoint,
          reverse = _this$props3.reverse,
          handleGenerator = _this$props3.handle;
      var _this$state = this.state,
          value = _this$state.value,
          dragging = _this$state.dragging;
      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: "".concat(prefixCls, "-handle"),
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });
      var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      var track = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Track__["a" /* default */], {
        className: "".concat(prefixCls, "-track"),
        vertical: vertical,
        included: included,
        offset: trackOffset,
        reverse: reverse,
        length: offset - trackOffset,
        style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, minimumTrackStyle), mergedTrackStyle)
      });
      return {
        tracks: track,
        handles: handle
      };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(324);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(2152);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(881);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(881);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__superPropBase_js__ = __webpack_require__(2159);

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = Object(__WEBPACK_IMPORTED_MODULE_0__superPropBase_js__["a" /* default */])(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _superPropBase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(472);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(object);
    if (object === null) break;
  }
  return object;
}

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_warning__ = __webpack_require__(55);






var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  Object(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_warning__["a" /* default */])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });

  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }

  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;
  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, dotStyle), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, reverse ? 'top' : 'bottom', offset)) : Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, dotStyle), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, reverse ? 'right' : 'left', offset));

    if (isActived) {
      style = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot"), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot-active"), isActived), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: pointClassName,
      style: style,
      key: point
    });
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, elements);
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;
  var marksKeys = Object.keys(marks);
  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(markPoint) === 'object' && ! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;

    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(className, "-text"), true), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(className, "-text-active"), isActive), _classNames));

    var bottomStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));

    var leftStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), markPoint.style) : style;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e) {
        return onClickLabel(e, point);
      },
      onTouchStart: function onTouchStart(e) {
        return onClickLabel(e, point);
      }
    }, markLabel);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: className
  }, elements);
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Track__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_createSlider__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(476);













var _trimAlignValue = function trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;
  var thershold = Number(pushable);
  var valInRange = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* ensureValueInRange */](value, props);
  var valNotConflict = valInRange;

  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }

    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* ensureValuePrecision */](valNotConflict, props);
};

var Range = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Range, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Range);

  function Range(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Range);

    _this = _super.call(this, props);

    _this.positionGetValue = function (position) {
      var bounds = _this.getValue();

      var value = _this.calcValueByPos(position);

      var closestBound = _this.getClosestBound(value);

      var index = _this.getBoundNeedMoving(value, closestBound);

      var prevValue = bounds[index];
      if (value === prevValue) return null;

      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(bounds);

      nextBounds[index] = value;
      return nextBounds;
    };

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (!handle) {
        _this.dragTrack = false;
      }

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;
    var initialValue = Array.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;
    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Range, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "getSliderLength",
    value: function getSliderLength() {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max;

      if (!('min' in this.props || 'max' in this.props)) {
        return;
      }

      if (min === prevProps.min && max === prevProps.max) {
        return;
      }

      var currentValue = value || prevState.bounds;

      if (currentValue.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_11__utils__["i" /* isValueOutOfRange */](v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* ensureValueInRange */](v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);

      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.state), state);

      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      var props = this.props,
          state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(state.bounds);

      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({
        bounds: nextBounds
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position, dragTrack, startBounds) {
      __WEBPACK_IMPORTED_MODULE_11__utils__["j" /* pauseEvent */](e);
      var state = this.state,
          props = this.props;
      var maxValue = props.max || 100;
      var minValue = props.min || 0;

      if (dragTrack) {
        var pos = props.vertical ? -position : position;
        pos = props.reverse ? -pos : pos;
        var max = maxValue - Math.max.apply(Math, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(startBounds));
        var min = minValue - Math.min.apply(Math, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(startBounds));
        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
        var nextBounds = startBounds.map(function (v) {
          return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
        });

        if (state.bounds.map(function (c, i) {
          return c === nextBounds[i];
        }).some(function (c) {
          return !c;
        })) {
          this.onChange({
            bounds: nextBounds
          });
        }

        return;
      }

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;
      this.moveTo(value);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = __WEBPACK_IMPORTED_MODULE_11__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_11__utils__["j" /* pauseEvent */](e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;
        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);

        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });

        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: "getClosestBound",
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;
      var closestBound = 0;

      for (var i = 1; i < bounds.length - 1; i += 1) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }

      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }

      return closestBound;
    }
  }, {
    key: "getBoundNeedMoving",
    value: function getBoundNeedMoving(value, closestBound) {
      var _this$state = this.state,
          bounds = _this$state.bounds,
          recent = _this$state.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }

      return boundNeedMoving;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      var bounds = this.state.bounds;
      return bounds[bounds.length - 1];
    }
    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: "getPoints",
    value: function getPoints() {
      var _this$props3 = this.props,
          marks = _this$props3.marks,
          step = _this$props3.step,
          min = _this$props3.min,
          max = _this$props3.max;
      var cache = this.internalPointsCache;

      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, marks);

        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }

        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this.internalPointsCache = {
          marks: marks,
          step: step,
          points: points
        };
      }

      return this.internalPointsCache.points;
    }
  }, {
    key: "moveTo",
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(state.bounds);

      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;

      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }

      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });

      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: "pushSurroundingHandles",
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var direction = 0;

      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }

      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        // eslint-disable-next-line no-param-reassign
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: "pushHandle",
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];

      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          // eslint-disable-next-line no-param-reassign
          bounds[handle] = originalValue;
          return false;
        }

        currentValue = bounds[handle];
      } // the handle was pushed enough to create the needed `amount` gap


      return true;
    }
  }, {
    key: "pushHandleOnePoint",
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;

      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }

      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction * (bounds[nextHandle] - nextValue);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      } // push the handle
      // eslint-disable-next-line no-param-reassign


      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(value) {
      var _this$state2 = this.state,
          handle = _this$state2.handle,
          bounds = _this$state2.bounds;
      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state3 = this.state,
          handle = _this$state3.handle,
          bounds = _this$state3.bounds;
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          vertical = _this$props4.vertical,
          included = _this$props4.included,
          disabled = _this$props4.disabled,
          min = _this$props4.min,
          max = _this$props4.max,
          reverse = _this$props4.reverse,
          handleGenerator = _this$props4.handle,
          trackStyle = _this$props4.trackStyle,
          handleStyle = _this$props4.handleStyle,
          tabIndex = _this$props4.tabIndex,
          ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles,
          ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles,
          ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });
      var handleClassName = "".concat(prefixCls, "-handle");
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var mergedTabIndex = tabIndex[i] || 0;

        if (disabled || tabIndex[i] === null) {
          mergedTabIndex = null;
        }

        var dragging = handle === i;
        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, handleClassName, true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          dragging: dragging,
          offset: offsets[i],
          value: v,
          index: i,
          tabIndex: mergedTabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          },
          ariaLabel: ariaLabelGroupForHandles[i],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
        });
      });
      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classNames2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-track"), true), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });
      return {
        tracks: tracks,
        handles: handles
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!('value' in props || 'min' in props || 'max' in props)) {
        return null;
      }

      var value = props.value || state.bounds;
      var nextBounds = value.map(function (v, i) {
        return _trimAlignValue({
          value: v,
          handle: i,
          bounds: state.bounds,
          props: props
        });
      });

      if (state.bounds.length === nextBounds.length) {
        if (nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
      } else {
        nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            props: props
          });
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, state), {}, {
        bounds: nextBounds
      });
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* eslint-enable */


Range.displayName = 'Range';
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  draggableTrack: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_SliderTooltip__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__(475);











function createSliderWithTooltip(Component) {
  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  return _a = /*#__PURE__*/function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(ComponentWrapper, _React$Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ComponentWrapper);

    function ComponentWrapper() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ComponentWrapper);

      _this = _super.apply(this, arguments);
      _this.state = {
        visibles: {}
      };

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, prevState.visibles), {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, index, visible))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["value", "dragging", "index", "disabled"]);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle,
            getTooltipContainer = _this$props.getTooltipContainer;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === void 0 ? false : _tipProps$visible,
            restTooltipProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(tipProps, ["prefixCls", "overlay", "placement", "visible"]);

        var handleStyleWithIndex;

        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_SliderTooltip__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, restTooltipProps, {
          getTooltipContainer: getTooltipContainer,
          prefixCls: prefixCls,
          overlay: overlay,
          placement: placement,
          visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
          key: index
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, restProps, {
          style: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, handleStyleWithIndex),
          value: value,
          onMouseEnter: function onMouseEnter() {
            return _this.handleTooltipVisibleChange(index, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleTooltipVisibleChange(index, false);
          }
        })));
      };

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ComponentWrapper, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _a.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },
    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node) {
      return node.parentNode;
    }
  }, _a;
}

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ref = __webpack_require__(117);

var _raf = _interopRequireDefault(__webpack_require__(176));

var _tooltip = _interopRequireDefault(__webpack_require__(119));

var SliderTooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var visible = props.visible;
  var innerRef = (0, React.useRef)(null);
  var rafRef = (0, React.useRef)(null);

  function cancelKeepAlign() {
    _raf["default"].cancel(rafRef.current);

    rafRef.current = null;
  }

  function keepAlign() {
    rafRef.current = (0, _raf["default"])(function () {
      innerRef.current.forcePopupAlign();
      rafRef.current = null;
      keepAlign();
    });
  }

  React.useEffect(function () {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }

    return cancelKeepAlign;
  }, [visible]);
  return /*#__PURE__*/React.createElement(_tooltip["default"], (0, _extends2["default"])({
    ref: (0, _ref.composeRef)(innerRef, ref)
  }, props));
});
var _default = SliderTooltip;
exports["default"] = _default;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(52)):"function"==typeof define&&define.amd?define(["react","react-dom"],e):"object"==typeof exports?exports.ReactDraggable=e(require("react"),require("react-dom")):t.ReactDraggable=e(t.React,t.ReactDOM)}(window,function(t,e){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=4)}([function(t,e,n){t.exports=n(5)()},function(e,n){e.exports=t},function(t,n){t.exports=e},function(t,e,n){var r;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/!function(){"use strict";var n={}.hasOwnProperty;function o(){for(var t=[],e=0;e<arguments.length;e++){var r=arguments[e];if(r){var a=typeof r;if("string"===a||"number"===a)t.push(r);else if(Array.isArray(r)&&r.length){var i=o.apply(null,r);i&&t.push(i)}else if("object"===a)for(var s in r)n.call(r,s)&&r[s]&&t.push(s)}}return t.join(" ")}t.exports?(o.default=o,t.exports=o):void 0===(r=function(){return o}.apply(e,[]))||(t.exports=r)}()},function(t,e,n){var r=n(7),o=r.default,a=r.DraggableCore;t.exports=o,t.exports.default=o,t.exports.DraggableCore=a},function(t,e,n){"use strict";var r=n(6);function o(){}function a(){}a.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,a,i){if(i!==r){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:a,resetWarningCache:o};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){"use strict";n.r(e);var r=n(1),o=n.n(r),a=n(0),i=n.n(a),s=n(2),u=n.n(s),c=n(3),l=n.n(c);function f(t,e){for(var n=0,r=t.length;n<r;n++)if(e.apply(e,[t[n],n,t]))return t[n]}function p(t){return"function"==typeof t||"[object Function]"===Object.prototype.toString.call(t)}function d(t){return"number"==typeof t&&!isNaN(t)}function g(t){return parseInt(t,10)}function y(t,e,n){if(t[e])return new Error("Invalid prop ".concat(e," passed to ").concat(n," - do not set this, set it on the child."))}var h=["Moz","Webkit","O","ms"];function b(t,e){return e?"".concat(e).concat(function(t){for(var e="",n=!0,r=0;r<t.length;r++)n?(e+=t[r].toUpperCase(),n=!1):"-"===t[r]?n=!0:e+=t[r];return e}(t)):t}var m=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"transform";if("undefined"==typeof window||void 0===window.document)return"";var e=window.document.documentElement.style;if(t in e)return"";for(var n=0;n<h.length;n++)if(b(t,h[n])in e)return h[n];return""}();function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,r)}return n}function w(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var O="";function S(t,e){return O||(O=f(["matches","webkitMatchesSelector","mozMatchesSelector","msMatchesSelector","oMatchesSelector"],function(e){return p(t[e])})),!!p(t[O])&&t[O](e)}function D(t,e,n){var r=t;do{if(S(r,e))return!0;if(r===n)return!1;r=r.parentNode}while(r);return!1}function x(t,e,n){t&&(t.attachEvent?t.attachEvent("on"+e,n):t.addEventListener?t.addEventListener(e,n,!0):t["on"+e]=n)}function P(t,e,n){t&&(t.detachEvent?t.detachEvent("on"+e,n):t.removeEventListener?t.removeEventListener(e,n,!0):t["on"+e]=null)}function j(t){var e=t.clientHeight,n=t.ownerDocument.defaultView.getComputedStyle(t);return e+=g(n.borderTopWidth),e+=g(n.borderBottomWidth)}function E(t){var e=t.clientWidth,n=t.ownerDocument.defaultView.getComputedStyle(t);return e+=g(n.borderLeftWidth),e+=g(n.borderRightWidth)}function T(t){var e=t.clientHeight,n=t.ownerDocument.defaultView.getComputedStyle(t);return e-=g(n.paddingTop),e-=g(n.paddingBottom)}function N(t){var e=t.clientWidth,n=t.ownerDocument.defaultView.getComputedStyle(t);return e-=g(n.paddingLeft),e-=g(n.paddingRight)}function C(t,e,n){var r=t.x,o=t.y,a="translate(".concat(r).concat(n,",").concat(o).concat(n,")");if(e){var i="".concat("string"==typeof e.x?e.x:e.x+n),s="".concat("string"==typeof e.y?e.y:e.y+n);a="translate(".concat(i,", ").concat(s,")")+a}return a}function M(t){if(t){var e,n,r=t.getElementById("react-draggable-style-el");r||((r=t.createElement("style")).type="text/css",r.id="react-draggable-style-el",r.innerHTML=".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n",r.innerHTML+=".react-draggable-transparent-selection *::selection {all: inherit;}\n",t.getElementsByTagName("head")[0].appendChild(r)),t.body&&(e=t.body,n="react-draggable-transparent-selection",e.classList?e.classList.add(n):e.className.match(new RegExp("(?:^|\\s)".concat(n,"(?!\\S)")))||(e.className+=" ".concat(n)))}}function k(t){try{t&&t.body&&(e=t.body,n="react-draggable-transparent-selection",e.classList?e.classList.remove(n):e.className=e.className.replace(new RegExp("(?:^|\\s)".concat(n,"(?!\\S)"),"g"),"")),t.selection?t.selection.empty():window.getSelection().removeAllRanges()}catch(t){}var e,n}function _(){return function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(n,!0).forEach(function(e){w(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(n).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}({touchAction:"none"},arguments.length>0&&void 0!==arguments[0]?arguments[0]:{})}function X(t){return"both"===t.props.axis||"x"===t.props.axis}function Y(t){return"both"===t.props.axis||"y"===t.props.axis}function L(t,e,n){var r="number"==typeof e?function(t,e){return t.targetTouches&&f(t.targetTouches,function(t){return e===t.identifier})||t.changedTouches&&f(t.changedTouches,function(t){return e===t.identifier})}(t,e):null;if("number"==typeof e&&!r)return null;var o=I(n);return function(t,e){var n=e===e.ownerDocument.body?{left:0,top:0}:e.getBoundingClientRect();return{x:t.clientX+e.scrollLeft-n.left,y:t.clientY+e.scrollTop-n.top}}(r||t,n.props.offsetParent||o.offsetParent||o.ownerDocument.body)}function R(t,e,n){var r=t.state,o=!d(r.lastX),a=I(t);return o?{node:a,deltaX:0,deltaY:0,lastX:e,lastY:n,x:e,y:n}:{node:a,deltaX:e-r.lastX,deltaY:n-r.lastY,lastX:r.lastX,lastY:r.lastY,x:e,y:n}}function A(t,e){var n=t.props.scale;return{node:e.node,x:t.state.x+e.deltaX/n,y:t.state.y+e.deltaY/n,deltaX:e.deltaX/n,deltaY:e.deltaY/n,lastX:t.state.x,lastY:t.state.y}}function I(t){var e=u.a.findDOMNode(t);if(!e)throw new Error("<DraggableCore>: Unmounted during event!");return e}function U(t){return(U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function V(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],r=!0,o=!1,a=void 0;try{for(var i,s=t[Symbol.iterator]();!(r=(i=s.next()).done)&&(n.push(i.value),!e||n.length!==e);r=!0);}catch(t){o=!0,a=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw a}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function W(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function B(t){return(B=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function H(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function q(t,e){return(q=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function G(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var z={touch:{start:"touchstart",move:"touchmove",stop:"touchend"},mouse:{start:"mousedown",move:"mousemove",stop:"mouseup"}},F=z.mouse,J=function(t){function e(){var t,n,r,o;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);for(var a=arguments.length,i=new Array(a),s=0;s<a;s++)i[s]=arguments[s];return r=this,o=(t=B(e)).call.apply(t,[this].concat(i)),n=!o||"object"!==U(o)&&"function"!=typeof o?H(r):o,G(H(n),"state",{dragging:!1,lastX:NaN,lastY:NaN,touchIdentifier:null}),G(H(n),"handleDragStart",function(t){if(n.props.onMouseDown(t),!n.props.allowAnyClick&&"number"==typeof t.button&&0!==t.button)return!1;var e=u.a.findDOMNode(H(n));if(!e||!e.ownerDocument||!e.ownerDocument.body)throw new Error("<DraggableCore> not mounted on DragStart!");var r=e.ownerDocument;if(!(n.props.disabled||!(t.target instanceof r.defaultView.Node)||n.props.handle&&!D(t.target,n.props.handle,e)||n.props.cancel&&D(t.target,n.props.cancel,e))){var o=function(t){return t.targetTouches&&t.targetTouches[0]?t.targetTouches[0].identifier:t.changedTouches&&t.changedTouches[0]?t.changedTouches[0].identifier:void 0}(t);n.setState({touchIdentifier:o});var a=L(t,o,H(n));if(null!=a){var i=a.x,s=a.y,c=R(H(n),i,s);n.props.onStart,!1!==n.props.onStart(t,c)&&(n.props.enableUserSelectHack&&M(r),n.setState({dragging:!0,lastX:i,lastY:s}),x(r,F.move,n.handleDrag),x(r,F.stop,n.handleDragStop))}}}),G(H(n),"handleDrag",function(t){"touchmove"===t.type&&t.preventDefault();var e=L(t,n.state.touchIdentifier,H(n));if(null!=e){var r,o,a,i=e.x,s=e.y;if(Array.isArray(n.props.grid)){var u=i-n.state.lastX,c=s-n.state.lastY,l=V((r=n.props.grid,o=u,a=c,[Math.round(o/r[0])*r[0],Math.round(a/r[1])*r[1]]),2);if(u=l[0],c=l[1],!u&&!c)return;i=n.state.lastX+u,s=n.state.lastY+c}var f=R(H(n),i,s);if(!1!==n.props.onDrag(t,f))n.setState({lastX:i,lastY:s});else try{n.handleDragStop(new MouseEvent("mouseup"))}catch(t){var p=document.createEvent("MouseEvents");p.initMouseEvent("mouseup",!0,!0,window,0,0,0,0,0,!1,!1,!1,!1,0,null),n.handleDragStop(p)}}}),G(H(n),"handleDragStop",function(t){if(n.state.dragging){var e=L(t,n.state.touchIdentifier,H(n));if(null!=e){var r=e.x,o=e.y,a=R(H(n),r,o),i=u.a.findDOMNode(H(n));i&&n.props.enableUserSelectHack&&k(i.ownerDocument),n.setState({dragging:!1,lastX:NaN,lastY:NaN}),n.props.onStop(t,a),i&&(P(i.ownerDocument,F.move,n.handleDrag),P(i.ownerDocument,F.stop,n.handleDragStop))}}}),G(H(n),"onMouseDown",function(t){return F=z.mouse,n.handleDragStart(t)}),G(H(n),"onMouseUp",function(t){return F=z.mouse,n.handleDragStop(t)}),G(H(n),"onTouchStart",function(t){return F=z.touch,n.handleDragStart(t)}),G(H(n),"onTouchEnd",function(t){return F=z.touch,n.handleDragStop(t)}),n}var n,r,a;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&q(t,e)}(e,o.a.Component),n=e,(r=[{key:"componentWillUnmount",value:function(){var t=u.a.findDOMNode(this);if(t){var e=t.ownerDocument;P(e,z.mouse.move,this.handleDrag),P(e,z.touch.move,this.handleDrag),P(e,z.mouse.stop,this.handleDragStop),P(e,z.touch.stop,this.handleDragStop),this.props.enableUserSelectHack&&k(e)}}},{key:"render",value:function(){return o.a.cloneElement(o.a.Children.only(this.props.children),{style:_(this.props.children.props.style),onMouseDown:this.onMouseDown,onTouchStart:this.onTouchStart,onMouseUp:this.onMouseUp,onTouchEnd:this.onTouchEnd})}}])&&W(n.prototype,r),a&&W(n,a),e}();function K(t){return(K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Q(){return(Q=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}function Z(t,e){if(null==t)return{};var n,r,o=function(t,e){if(null==t)return{};var n,r,o={},a=Object.keys(t);for(r=0;r<a.length;r++)n=a[r],e.indexOf(n)>=0||(o[n]=t[n]);return o}(t,e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);for(r=0;r<a.length;r++)n=a[r],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(o[n]=t[n])}return o}function $(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=[],r=!0,o=!1,a=void 0;try{for(var i,s=t[Symbol.iterator]();!(r=(i=s.next()).done)&&(n.push(i.value),!e||n.length!==e);r=!0);}catch(t){o=!0,a=t}finally{try{r||null==s.return||s.return()}finally{if(o)throw a}}return n}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function tt(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,r)}return n}function et(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?tt(n,!0).forEach(function(e){st(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):tt(n).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function rt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function ot(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function at(t,e,n){return e&&ot(t.prototype,e),n&&ot(t,n),t}function it(t,e){return(it=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function st(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}G(J,"displayName","DraggableCore"),G(J,"propTypes",{allowAnyClick:i.a.bool,disabled:i.a.bool,enableUserSelectHack:i.a.bool,offsetParent:function(t,e){if(t[e]&&1!==t[e].nodeType)throw new Error("Draggable's offsetParent must be a DOM Node.")},grid:i.a.arrayOf(i.a.number),handle:i.a.string,cancel:i.a.string,onStart:i.a.func,onDrag:i.a.func,onStop:i.a.func,onMouseDown:i.a.func,className:y,style:y,transform:y}),G(J,"defaultProps",{allowAnyClick:!1,cancel:null,disabled:!1,enableUserSelectHack:!0,offsetParent:null,handle:null,grid:null,transform:null,onStart:function(){},onDrag:function(){},onStop:function(){},onMouseDown:function(){}}),n.d(e,"default",function(){return ut}),n.d(e,"DraggableCore",function(){return J});var ut=function(t){function e(t){var n,r,o;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),r=this,o=nt(e).call(this,t),n=!o||"object"!==K(o)&&"function"!=typeof o?rt(r):o,st(rt(n),"onDragStart",function(t,e){if(!1===n.props.onStart(t,A(rt(n),e)))return!1;n.setState({dragging:!0,dragged:!0})}),st(rt(n),"onDrag",function(t,e){if(!n.state.dragging)return!1;var r=A(rt(n),e),o={x:r.x,y:r.y};if(n.props.bounds){var a=o.x,i=o.y;o.x+=n.state.slackX,o.y+=n.state.slackY;var s=$(function(t,e,n){if(!t.props.bounds)return[e,n];var r=t.props.bounds;r="string"==typeof r?r:function(t){return{left:t.left,top:t.top,right:t.right,bottom:t.bottom}}(r);var o=I(t);if("string"==typeof r){var a,i=o.ownerDocument,s=i.defaultView;if(!((a="parent"===r?o.parentNode:i.querySelector(r))instanceof s.HTMLElement))throw new Error('Bounds selector "'+r+'" could not find an element.');var u=s.getComputedStyle(o),c=s.getComputedStyle(a);r={left:-o.offsetLeft+g(c.paddingLeft)+g(u.marginLeft),top:-o.offsetTop+g(c.paddingTop)+g(u.marginTop),right:N(a)-E(o)-o.offsetLeft+g(c.paddingRight)-g(u.marginRight),bottom:T(a)-j(o)-o.offsetTop+g(c.paddingBottom)-g(u.marginBottom)}}return d(r.right)&&(e=Math.min(e,r.right)),d(r.bottom)&&(n=Math.min(n,r.bottom)),d(r.left)&&(e=Math.max(e,r.left)),d(r.top)&&(n=Math.max(n,r.top)),[e,n]}(rt(n),o.x,o.y),2),u=s[0],c=s[1];o.x=u,o.y=c,o.slackX=n.state.slackX+(a-o.x),o.slackY=n.state.slackY+(i-o.y),r.x=o.x,r.y=o.y,r.deltaX=o.x-n.state.x,r.deltaY=o.y-n.state.y}if(!1===n.props.onDrag(t,r))return!1;n.setState(o)}),st(rt(n),"onDragStop",function(t,e){if(!n.state.dragging)return!1;if(!1===n.props.onStop(t,A(rt(n),e)))return!1;var r={dragging:!1,slackX:0,slackY:0};if(Boolean(n.props.position)){var o=n.props.position,a=o.x,i=o.y;r.x=a,r.y=i}n.setState(r)}),n.state={dragging:!1,dragged:!1,x:t.position?t.position.x:t.defaultPosition.x,y:t.position?t.position.y:t.defaultPosition.y,prevPropsPosition:et({},t.position),slackX:0,slackY:0,isElementSVG:!1},!t.position||t.onDrag||t.onStop||console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."),n}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&it(t,e)}(e,o.a.Component),at(e,null,[{key:"getDerivedStateFromProps",value:function(t,e){var n=t.position,r=e.prevPropsPosition;return!n||r&&n.x===r.x&&n.y===r.y?null:{x:n.x,y:n.y,prevPropsPosition:et({},n)}}}]),at(e,[{key:"componentDidMount",value:function(){void 0!==window.SVGElement&&u.a.findDOMNode(this)instanceof window.SVGElement&&this.setState({isElementSVG:!0})}},{key:"componentWillUnmount",value:function(){this.setState({dragging:!1})}},{key:"render",value:function(){var t,e=this.props,n=(e.axis,e.bounds,e.children),r=e.defaultPosition,a=e.defaultClassName,i=e.defaultClassNameDragging,s=e.defaultClassNameDragged,u=e.position,c=e.positionOffset,f=(e.scale,Z(e,["axis","bounds","children","defaultPosition","defaultClassName","defaultClassNameDragging","defaultClassNameDragged","position","positionOffset","scale"])),p={},d=null,g=!Boolean(u)||this.state.dragging,y=u||r,h={x:X(this)&&g?this.state.x:y.x,y:Y(this)&&g?this.state.y:y.y};this.state.isElementSVG?d=function(t,e){return C(t,e,"")}(h,c):p=function(t,e){var n=C(t,e,"px");return w({},b("transform",m),n)}(h,c);var v=l()(n.props.className||"",a,(st(t={},i,this.state.dragging),st(t,s,this.state.dragged),t));return o.a.createElement(J,Q({},f,{onStart:this.onDragStart,onDrag:this.onDrag,onStop:this.onDragStop}),o.a.cloneElement(o.a.Children.only(n),{className:v,style:et({},n.props.style,{},p),transform:d}))}}]),e}();st(ut,"displayName","Draggable"),st(ut,"propTypes",et({},J.propTypes,{axis:i.a.oneOf(["both","x","y","none"]),bounds:i.a.oneOfType([i.a.shape({left:i.a.number,right:i.a.number,top:i.a.number,bottom:i.a.number}),i.a.string,i.a.oneOf([!1])]),defaultClassName:i.a.string,defaultClassNameDragging:i.a.string,defaultClassNameDragged:i.a.string,defaultPosition:i.a.shape({x:i.a.number,y:i.a.number}),positionOffset:i.a.shape({x:i.a.oneOfType([i.a.number,i.a.string]),y:i.a.oneOfType([i.a.number,i.a.string])}),position:i.a.shape({x:i.a.number,y:i.a.number}),className:y,style:y,transform:y})),st(ut,"defaultProps",et({},J.defaultProps,{axis:"both",bounds:!1,defaultClassName:"react-draggable",defaultClassNameDragging:"react-draggable-dragging",defaultClassNameDragged:"react-draggable-dragged",defaultPosition:{x:0,y:0},position:null,scale:1}))}])});
//# sourceMappingURL=react-draggable.min.js.map

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2167);

__webpack_require__(29);

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _typeof2 = _interopRequireDefault(__webpack_require__(40));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(22));

var React = _interopRequireWildcard(__webpack_require__(0));

var _toArray = _interopRequireDefault(__webpack_require__(145));

var _classnames = _interopRequireDefault(__webpack_require__(1));

var _omit = _interopRequireDefault(__webpack_require__(47));

var _select = _interopRequireDefault(__webpack_require__(28));

var _configProvider = __webpack_require__(8);

var _devWarning = _interopRequireDefault(__webpack_require__(41));

var _reactNode = __webpack_require__(57);

/**
 * TODO: 4.0
 *     - remove `dataSource`
 *     - `size` not work with customizeInput
 *     - customizeInput not feedback `ENTER` key since accessibility enhancement
 */
var Option = _select["default"].Option;

function isSelectOptionOrSelectOptGroup(child) {
  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}

var AutoComplete = function AutoComplete(props, ref) {
  var customizePrefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      dataSource = props.dataSource;
  var childNodes = (0, _toArray["default"])(children); // ============================= Input =============================

  var customizeInput;

  if (childNodes.length === 1 && (0, _reactNode.isValidElement)(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    var _childNodes = (0, _slicedToArray2["default"])(childNodes, 1);

    customizeInput = _childNodes[0];
  }

  var getInputElement = customizeInput ? function () {
    return customizeInput;
  } : undefined; // ============================ Options ============================

  var optionChildren; // [Legacy] convert `children` or `dataSource` into option children

  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(function (item) {
      if ((0, _reactNode.isValidElement)(item)) {
        return item;
      }

      switch ((0, _typeof2["default"])(item)) {
        case 'string':
          return /*#__PURE__*/React.createElement(Option, {
            key: item,
            value: item
          }, item);

        case 'object':
          {
            var optionValue = item.value;
            return /*#__PURE__*/React.createElement(Option, {
              key: optionValue,
              value: optionValue
            }, item.text);
          }

        default:
          throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
      }
    }) : [];
  } // ============================ Warning ============================


  React.useEffect(function () {
    (0, _devWarning["default"])(!('dataSource' in props), 'AutoComplete', '`dataSource` is deprecated, please use `options` instead.');
    (0, _devWarning["default"])(!customizeInput || !('size' in props), 'AutoComplete', 'You need to control style self instead of setting `size` when using customize input.');
  }, []);
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    return /*#__PURE__*/React.createElement(_select["default"], (0, _extends2["default"])({
      ref: ref
    }, (0, _omit["default"])(props, ['dataSource']), {
      prefixCls: prefixCls,
      className: (0, _classnames["default"])("".concat(prefixCls, "-auto-complete"), className),
      mode: _select["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE,
      getInputElement: getInputElement
    }), optionChildren);
  });
};

var RefAutoComplete = /*#__PURE__*/React.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
var _default = RefAutoComplete;
exports["default"] = _default;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1_person.039c648c.svg";

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2_info.9ab9297a.svg";

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3_message.01bf04bf.svg";

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4_place.3c555e74.svg";

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5_reply.f12e0125.svg";

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6_file.49cc4126.svg";

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(2177);

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Item;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var React = _interopRequireWildcard(__webpack_require__(0));

var _ = __webpack_require__(901);

function Item(_ref) {
  var className = _ref.className,
      direction = _ref.direction,
      index = _ref.index,
      marginDirection = _ref.marginDirection,
      children = _ref.children,
      split = _ref.split,
      wrap = _ref.wrap;

  var _React$useContext = React.useContext(_.SpaceContext),
      horizontalSize = _React$useContext.horizontalSize,
      verticalSize = _React$useContext.verticalSize,
      latestIndex = _React$useContext.latestIndex;

  var style = {};

  if (direction === 'vertical') {
    if (index < latestIndex) {
      style = {
        marginBottom: horizontalSize / (split ? 2 : 1)
      };
    }
  } else {
    style = (0, _extends2["default"])((0, _extends2["default"])({}, index < latestIndex && (0, _defineProperty2["default"])({}, marginDirection, horizontalSize / (split ? 2 : 1))), wrap && {
      paddingBottom: verticalSize
    });
  }

  if (children === null || children === undefined) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, children), index < latestIndex && split && /*#__PURE__*/React.createElement("span", {
    className: "".concat(className, "-split"),
    style: style
  }, split));
}

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var InstagramEmbed = /** @class */ (function (_super) {
    __extends(InstagramEmbed, _super);
    function InstagramEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.request = null;
        // Public
        _this.cancel = function () {
            if (_this.request) {
                _this.request.cancel();
            }
        };
        _this.handleFetchSuccess = function (response) {
            if (_this.props.onSuccess) {
                _this.props.onSuccess(response);
            }
            _this.setState({ html: response.html }, function () {
                window.instgrm.Embeds.process();
                if (_this.props.onAfterRender) {
                    _this.props.onAfterRender();
                }
            });
        };
        _this.handleFetchFailure = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(_this.timer);
            if (_this.props.onFailure) {
                _this.props.onFailure(args);
            }
        };
        _this.createRequestPromise = function (url) {
            var request = {};
            request.promise = new Promise(function (resolve, reject) {
                var promise = fetch(url)
                    .then(function (response) { return response.json(); })
                    .then(function (json) { return resolve(json); })
                    .catch(function (err) { return reject(err); });
                request.cancel = function () { return reject(new Error('Cancelled')); };
                return promise;
            });
            return request;
        };
        _this.state = { html: null };
        return _this;
    }
    InstagramEmbed.prototype.componentDidMount = function () {
        var _this = this;
        if (window.instgrm) {
            this.fetchEmbed(this.getQueryParams(this.props));
        }
        else {
            if (this.props.injectScript && !document.getElementById('react-instagram-embed-script')) {
                this.injectScript();
            }
            this.checkAPI().then(function () {
                _this.fetchEmbed(_this.getQueryParams(_this.props));
            });
        }
    };
    InstagramEmbed.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, url = _a.url, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth, containerTagName = _a.containerTagName;
        if (prevProps.url !== url ||
            prevProps.hideCaption !== hideCaption ||
            prevProps.maxWidth !== maxWidth ||
            prevProps.containerTagName !== containerTagName) {
            this.request.cancel();
            this.fetchEmbed(this.getQueryParams(this.props));
        }
    };
    InstagramEmbed.prototype.componentWillUnmount = function () {
        this.cancel();
    };
    InstagramEmbed.prototype.render = function () {
        var Tag = this.props.containerTagName;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tag, __assign({}, this.omitComponentProps(), { dangerouslySetInnerHTML: { __html: this.state.html || '' } }));
    };
    InstagramEmbed.prototype.fetchEmbed = function (queryParams) {
        this.request = this.createRequestPromise("https://api.instagram.com/oembed/?" + queryParams);
        if (this.props.onLoading) {
            this.props.onLoading();
        }
        this.request.promise.then(this.handleFetchSuccess).catch(this.handleFetchFailure);
    };
    InstagramEmbed.prototype.omitComponentProps = function () {
        var _a = this.props, url = _a.url, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth, containerTagName = _a.containerTagName, onLoading = _a.onLoading, onSuccess = _a.onSuccess, onAfterRender = _a.onAfterRender, onFailure = _a.onFailure, protocol = _a.protocol, injectScript = _a.injectScript, rest = __rest(_a, ["url", "hideCaption", "maxWidth", "containerTagName", "onLoading", "onSuccess", "onAfterRender", "onFailure", "protocol", "injectScript"]);
        return rest;
    };
    InstagramEmbed.prototype.injectScript = function () {
        var protocolToUse = window.location.protocol.indexOf('file') === 0 ? this.props.protocol : '';
        var s = document.createElement('script');
        s.async = s.defer = true;
        s.src = protocolToUse + "//platform.instagram.com/en_US/embeds.js";
        s.id = 'react-instagram-embed-script';
        var body = document.body;
        if (body) {
            body.appendChild(s);
        }
    };
    InstagramEmbed.prototype.checkAPI = function () {
        var _this = this;
        return new Promise(function (resolve) {
            (function checkAPI(self) {
                self.timer = window.setTimeout(function () {
                    if (window.instgrm) {
                        clearTimeout(self.timer);
                        resolve();
                    }
                    else {
                        checkAPI(self);
                    }
                }, 20);
            })(_this);
        });
    };
    InstagramEmbed.prototype.getQueryParams = function (_a) {
        var url = _a.url, hideCaption = _a.hideCaption, maxWidth = _a.maxWidth;
        return __WEBPACK_IMPORTED_MODULE_1_query_string__["stringify"]({
            url: url,
            hidecaption: hideCaption,
            maxwidth: typeof maxWidth === 'number' && maxWidth >= 320 ? maxWidth : undefined,
            omitscript: true
        });
    };
    InstagramEmbed.defaultProps = {
        hideCaption: false,
        containerTagName: 'div',
        protocol: 'https:',
        injectScript: true
    };
    return InstagramEmbed;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (InstagramEmbed);


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(723);
var objectAssign = __webpack_require__(64);
var decodeComponent = __webpack_require__(2182);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7504371c.js